/**
* plotly.js (basic - minified) v3.0.1
* Copyright 2012-2025, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/
(function (root, factory) {
  if (typeof module === "object" && module.exports) {
    module.exports = factory();
  } else {
    root.moduleName = factory();
  }
})(typeof self !== "undefined" ? self : this, () => {
  "use strict";

  var Plotly = (() => {
    var nb = Object.defineProperty;
    var jF = Object.getOwnPropertyDescriptor;
    var eI = Object.getOwnPropertyNames;
    var rI = Object.prototype.hasOwnProperty;
    var ib = (e, r) => () => (e && (r = e(e = 0)), r);
    var Z = (e, r) => () => (r || e((r = {
      exports: {}
    }).exports, r), r.exports);
    var tI = (e, r, t, a) => {
      if (r && typeof r == "object" || typeof r == "function") for (let n of eI(r)) !rI.call(e, n) && n !== t && nb(e, n, {
        get: () => r[n],
        enumerable: !(a = jF(r, n)) || a.enumerable
      });
      return e;
    };
    var aI = e => tI(nb({}, "__esModule", {
      value: !0
    }), e);
    var tv = Z(lb => {
      "use strict";

      lb.version = "3.0.1";
    });
    var sb = Z((ob, av) => {
      (function (r, t, a) {
        t[r] = t[r] || a(), typeof av != "undefined" && av.exports && (av.exports = t[r]);
      })("Promise", typeof window != "undefined" ? window : ob, function () {
        "use strict";

        var r,
          t,
          a,
          n = Object.prototype.toString,
          i = typeof setImmediate != "undefined" ? function (w) {
            return setImmediate(w);
          } : setTimeout;
        try {
          Object.defineProperty({}, "x", {}), r = function (w, T, b, A) {
            return Object.defineProperty(w, T, {
              value: b,
              writable: !0,
              configurable: A !== !1
            });
          };
        } catch (_) {
          r = function (T, b, A) {
            return T[b] = A, T;
          };
        }
        a = function () {
          var w, T, b;
          function A(S, k) {
            this.fn = S, this.self = k, this.next = void 0;
          }
          return {
            add: function (k, q) {
              b = new A(k, q), T ? T.next = b : w = b, T = b, b = void 0;
            },
            drain: function () {
              var k = w;
              for (w = T = t = void 0; k;) k.fn.call(k.self), k = k.next;
            }
          };
        }();
        function l(_, w) {
          a.add(_, w), t || (t = i(a.drain));
        }
        function o(_) {
          var w,
            T = typeof _;
          return _ != null && (T == "object" || T == "function") && (w = _.then), typeof w == "function" ? w : !1;
        }
        function s() {
          for (var _ = 0; _ < this.chain.length; _++) u(this, this.state === 1 ? this.chain[_].success : this.chain[_].failure, this.chain[_]);
          this.chain.length = 0;
        }
        function u(_, w, T) {
          var b, A;
          try {
            w === !1 ? T.reject(_.msg) : (w === !0 ? b = _.msg : b = w.call(void 0, _.msg), b === T.promise ? T.reject(TypeError("Promise-chain cycle")) : (A = o(b)) ? A.call(b, T.resolve, T.reject) : T.resolve(b));
          } catch (S) {
            T.reject(S);
          }
        }
        function f(_) {
          var w,
            T = this;
          if (!T.triggered) {
            T.triggered = !0, T.def && (T = T.def);
            try {
              (w = o(_)) ? l(function () {
                var b = new d(T);
                try {
                  w.call(_, function () {
                    f.apply(b, arguments);
                  }, function () {
                    v.apply(b, arguments);
                  });
                } catch (A) {
                  v.call(b, A);
                }
              }) : (T.msg = _, T.state = 1, T.chain.length > 0 && l(s, T));
            } catch (b) {
              v.call(new d(T), b);
            }
          }
        }
        function v(_) {
          var w = this;
          w.triggered || (w.triggered = !0, w.def && (w = w.def), w.msg = _, w.state = 2, w.chain.length > 0 && l(s, w));
        }
        function h(_, w, T, b) {
          for (var A = 0; A < w.length; A++) (function (k) {
            _.resolve(w[k]).then(function (D) {
              T(k, D);
            }, b);
          })(A);
        }
        function d(_) {
          this.def = _, this.triggered = !1;
        }
        function y(_) {
          this.promise = _, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
        }
        function g(_) {
          if (typeof _ != "function") throw TypeError("Not a function");
          if (this.__NPO__ !== 0) throw TypeError("Not a promise");
          this.__NPO__ = 1;
          var w = new y(this);
          this.then = function (b, A) {
            var S = {
              success: typeof b == "function" ? b : !0,
              failure: typeof A == "function" ? A : !1
            };
            return S.promise = new this.constructor(function (q, D) {
              if (typeof q != "function" || typeof D != "function") throw TypeError("Not a function");
              S.resolve = q, S.reject = D;
            }), w.chain.push(S), w.state !== 0 && l(s, w), S.promise;
          }, this.catch = function (b) {
            return this.then(void 0, b);
          };
          try {
            _.call(void 0, function (b) {
              f.call(w, b);
            }, function (b) {
              v.call(w, b);
            });
          } catch (T) {
            v.call(w, T);
          }
        }
        var m = r({}, "constructor", g, !1);
        return g.prototype = m, r(m, "__NPO__", 0, !1), r(g, "resolve", function (w) {
          var T = this;
          return w && typeof w == "object" && w.__NPO__ === 1 ? w : new T(function (A, S) {
            if (typeof A != "function" || typeof S != "function") throw TypeError("Not a function");
            A(w);
          });
        }), r(g, "reject", function (w) {
          return new this(function (b, A) {
            if (typeof b != "function" || typeof A != "function") throw TypeError("Not a function");
            A(w);
          });
        }), r(g, "all", function (w) {
          var T = this;
          return n.call(w) != "[object Array]" ? T.reject(TypeError("Not an array")) : w.length === 0 ? T.resolve([]) : new T(function (A, S) {
            if (typeof A != "function" || typeof S != "function") throw TypeError("Not a function");
            var k = w.length,
              q = Array(k),
              D = 0;
            h(T, w, function (z, N) {
              q[z] = N, ++D === k && A(q);
            }, S);
          });
        }), r(g, "race", function (w) {
          var T = this;
          return n.call(w) != "[object Array]" ? T.reject(TypeError("Not an array")) : new T(function (A, S) {
            if (typeof A != "function" || typeof S != "function") throw TypeError("Not a function");
            h(T, w, function (q, D) {
              A(D);
            }, S);
          });
        }), g;
      });
    });
    var Ir = Z((oie, nv) => {
      (function () {
        var e = {
            version: "3.8.2"
          },
          r = [].slice,
          t = function (c) {
            return r.call(c);
          },
          a = self.document;
        function n(c) {
          return c && (c.ownerDocument || c.document || c).documentElement;
        }
        function i(c) {
          return c && (c.ownerDocument && c.ownerDocument.defaultView || c.document && c || c.defaultView);
        }
        if (a) try {
          t(a.documentElement.childNodes)[0].nodeType;
        } catch (c) {
          t = function (p) {
            for (var x = p.length, M = new Array(x); x--;) M[x] = p[x];
            return M;
          };
        }
        if (Date.now || (Date.now = function () {
          return +new Date();
        }), a) try {
          a.createElement("DIV").style.setProperty("opacity", 0, "");
        } catch (c) {
          var l = this.Element.prototype,
            o = l.setAttribute,
            s = l.setAttributeNS,
            u = this.CSSStyleDeclaration.prototype,
            f = u.setProperty;
          l.setAttribute = function (p, x) {
            o.call(this, p, x + "");
          }, l.setAttributeNS = function (p, x, M) {
            s.call(this, p, x, M + "");
          }, u.setProperty = function (p, x, M) {
            f.call(this, p, x + "", M);
          };
        }
        e.ascending = v;
        function v(c, p) {
          return c < p ? -1 : c > p ? 1 : c >= p ? 0 : NaN;
        }
        e.descending = function (c, p) {
          return p < c ? -1 : p > c ? 1 : p >= c ? 0 : NaN;
        }, e.min = function (c, p) {
          var x = -1,
            M = c.length,
            C,
            L;
          if (arguments.length === 1) {
            for (; ++x < M;) if ((L = c[x]) != null && L >= L) {
              C = L;
              break;
            }
            for (; ++x < M;) (L = c[x]) != null && C > L && (C = L);
          } else {
            for (; ++x < M;) if ((L = p.call(c, c[x], x)) != null && L >= L) {
              C = L;
              break;
            }
            for (; ++x < M;) (L = p.call(c, c[x], x)) != null && C > L && (C = L);
          }
          return C;
        }, e.max = function (c, p) {
          var x = -1,
            M = c.length,
            C,
            L;
          if (arguments.length === 1) {
            for (; ++x < M;) if ((L = c[x]) != null && L >= L) {
              C = L;
              break;
            }
            for (; ++x < M;) (L = c[x]) != null && L > C && (C = L);
          } else {
            for (; ++x < M;) if ((L = p.call(c, c[x], x)) != null && L >= L) {
              C = L;
              break;
            }
            for (; ++x < M;) (L = p.call(c, c[x], x)) != null && L > C && (C = L);
          }
          return C;
        }, e.extent = function (c, p) {
          var x = -1,
            M = c.length,
            C,
            L,
            P;
          if (arguments.length === 1) {
            for (; ++x < M;) if ((L = c[x]) != null && L >= L) {
              C = P = L;
              break;
            }
            for (; ++x < M;) (L = c[x]) != null && (C > L && (C = L), P < L && (P = L));
          } else {
            for (; ++x < M;) if ((L = p.call(c, c[x], x)) != null && L >= L) {
              C = P = L;
              break;
            }
            for (; ++x < M;) (L = p.call(c, c[x], x)) != null && (C > L && (C = L), P < L && (P = L));
          }
          return [C, P];
        };
        function h(c) {
          return c === null ? NaN : +c;
        }
        function d(c) {
          return !isNaN(c);
        }
        e.sum = function (c, p) {
          var x = 0,
            M = c.length,
            C,
            L = -1;
          if (arguments.length === 1) for (; ++L < M;) d(C = +c[L]) && (x += C);else for (; ++L < M;) d(C = +p.call(c, c[L], L)) && (x += C);
          return x;
        }, e.mean = function (c, p) {
          var x = 0,
            M = c.length,
            C,
            L = -1,
            P = M;
          if (arguments.length === 1) for (; ++L < M;) d(C = h(c[L])) ? x += C : --P;else for (; ++L < M;) d(C = h(p.call(c, c[L], L))) ? x += C : --P;
          if (P) return x / P;
        }, e.quantile = function (c, p) {
          var x = (c.length - 1) * p + 1,
            M = Math.floor(x),
            C = +c[M - 1],
            L = x - M;
          return L ? C + L * (c[M] - C) : C;
        }, e.median = function (c, p) {
          var x = [],
            M = c.length,
            C,
            L = -1;
          if (arguments.length === 1) for (; ++L < M;) d(C = h(c[L])) && x.push(C);else for (; ++L < M;) d(C = h(p.call(c, c[L], L))) && x.push(C);
          if (x.length) return e.quantile(x.sort(v), .5);
        }, e.variance = function (c, p) {
          var x = c.length,
            M = 0,
            C,
            L,
            P = 0,
            E = -1,
            F = 0;
          if (arguments.length === 1) for (; ++E < x;) d(C = h(c[E])) && (L = C - M, M += L / ++F, P += L * (C - M));else for (; ++E < x;) d(C = h(p.call(c, c[E], E))) && (L = C - M, M += L / ++F, P += L * (C - M));
          if (F > 1) return P / (F - 1);
        }, e.deviation = function () {
          var c = e.variance.apply(this, arguments);
          return c && Math.sqrt(c);
        };
        function y(c) {
          return {
            left: function (p, x, M, C) {
              for (arguments.length < 3 && (M = 0), arguments.length < 4 && (C = p.length); M < C;) {
                var L = M + C >>> 1;
                c(p[L], x) < 0 ? M = L + 1 : C = L;
              }
              return M;
            },
            right: function (p, x, M, C) {
              for (arguments.length < 3 && (M = 0), arguments.length < 4 && (C = p.length); M < C;) {
                var L = M + C >>> 1;
                c(p[L], x) > 0 ? C = L : M = L + 1;
              }
              return M;
            }
          };
        }
        var g = y(v);
        e.bisectLeft = g.left, e.bisect = e.bisectRight = g.right, e.bisector = function (c) {
          return y(c.length === 1 ? function (p, x) {
            return v(c(p), x);
          } : c);
        }, e.shuffle = function (c, p, x) {
          (M = arguments.length) < 3 && (x = c.length, M < 2 && (p = 0));
          for (var M = x - p, C, L; M;) L = Math.random() * M-- | 0, C = c[M + p], c[M + p] = c[L + p], c[L + p] = C;
          return c;
        }, e.permute = function (c, p) {
          for (var x = p.length, M = new Array(x); x--;) M[x] = c[p[x]];
          return M;
        }, e.pairs = function (c) {
          for (var p = 0, x = c.length - 1, M, C = c[0], L = new Array(x < 0 ? 0 : x); p < x;) L[p] = [M = C, C = c[++p]];
          return L;
        }, e.transpose = function (c) {
          if (!(L = c.length)) return [];
          for (var p = -1, x = e.min(c, m), M = new Array(x); ++p < x;) for (var C = -1, L, P = M[p] = new Array(L); ++C < L;) P[C] = c[C][p];
          return M;
        };
        function m(c) {
          return c.length;
        }
        e.zip = function () {
          return e.transpose(arguments);
        }, e.keys = function (c) {
          var p = [];
          for (var x in c) p.push(x);
          return p;
        }, e.values = function (c) {
          var p = [];
          for (var x in c) p.push(c[x]);
          return p;
        }, e.entries = function (c) {
          var p = [];
          for (var x in c) p.push({
            key: x,
            value: c[x]
          });
          return p;
        }, e.merge = function (c) {
          for (var p = c.length, x, M = -1, C = 0, L, P; ++M < p;) C += c[M].length;
          for (L = new Array(C); --p >= 0;) for (P = c[p], x = P.length; --x >= 0;) L[--C] = P[x];
          return L;
        };
        var _ = Math.abs;
        e.range = function (c, p, x) {
          if (arguments.length < 3 && (x = 1, arguments.length < 2 && (p = c, c = 0)), (p - c) / x === 1 / 0) throw new Error("infinite range");
          var M = [],
            C = w(_(x)),
            L = -1,
            P;
          if (c *= C, p *= C, x *= C, x < 0) for (; (P = c + x * ++L) > p;) M.push(P / C);else for (; (P = c + x * ++L) < p;) M.push(P / C);
          return M;
        };
        function w(c) {
          for (var p = 1; c * p % 1;) p *= 10;
          return p;
        }
        function T(c, p) {
          for (var x in p) Object.defineProperty(c.prototype, x, {
            value: p[x],
            enumerable: !1
          });
        }
        e.map = function (c, p) {
          var x = new b();
          if (c instanceof b) c.forEach(function (E, F) {
            x.set(E, F);
          });else if (Array.isArray(c)) {
            var M = -1,
              C = c.length,
              L;
            if (arguments.length === 1) for (; ++M < C;) x.set(M, c[M]);else for (; ++M < C;) x.set(p.call(c, L = c[M], M), L);
          } else for (var P in c) x.set(P, c[P]);
          return x;
        };
        function b() {
          this._ = Object.create(null);
        }
        var A = "__proto__",
          S = "\0";
        T(b, {
          has: D,
          get: function (c) {
            return this._[k(c)];
          },
          set: function (c, p) {
            return this._[k(c)] = p;
          },
          remove: R,
          keys: z,
          values: function () {
            var c = [];
            for (var p in this._) c.push(this._[p]);
            return c;
          },
          entries: function () {
            var c = [];
            for (var p in this._) c.push({
              key: q(p),
              value: this._[p]
            });
            return c;
          },
          size: N,
          empty: H,
          forEach: function (c) {
            for (var p in this._) c.call(this, q(p), this._[p]);
          }
        });
        function k(c) {
          return (c += "") === A || c[0] === S ? S + c : c;
        }
        function q(c) {
          return (c += "")[0] === S ? c.slice(1) : c;
        }
        function D(c) {
          return k(c) in this._;
        }
        function R(c) {
          return (c = k(c)) in this._ && delete this._[c];
        }
        function z() {
          var c = [];
          for (var p in this._) c.push(q(p));
          return c;
        }
        function N() {
          var c = 0;
          for (var p in this._) ++c;
          return c;
        }
        function H() {
          for (var c in this._) return !1;
          return !0;
        }
        e.nest = function () {
          var c = {},
            p = [],
            x = [],
            M,
            C;
          function L(E, F, G) {
            if (G >= p.length) return C ? C.call(c, F) : M ? F.sort(M) : F;
            for (var W = -1, $ = F.length, ee = p[G++], he, we, te, le = new b(), ue; ++W < $;) (ue = le.get(he = ee(we = F[W]))) ? ue.push(we) : le.set(he, [we]);
            return E ? (we = E(), te = function (xe, Te) {
              we.set(xe, L(E, Te, G));
            }) : (we = {}, te = function (xe, Te) {
              we[xe] = L(E, Te, G);
            }), le.forEach(te), we;
          }
          function P(E, F) {
            if (F >= p.length) return E;
            var G = [],
              W = x[F++];
            return E.forEach(function ($, ee) {
              G.push({
                key: $,
                values: P(ee, F)
              });
            }), W ? G.sort(function ($, ee) {
              return W($.key, ee.key);
            }) : G;
          }
          return c.map = function (E, F) {
            return L(F, E, 0);
          }, c.entries = function (E) {
            return P(L(e.map, E, 0), 0);
          }, c.key = function (E) {
            return p.push(E), c;
          }, c.sortKeys = function (E) {
            return x[p.length - 1] = E, c;
          }, c.sortValues = function (E) {
            return M = E, c;
          }, c.rollup = function (E) {
            return C = E, c;
          }, c;
        }, e.set = function (c) {
          var p = new O();
          if (c) for (var x = 0, M = c.length; x < M; ++x) p.add(c[x]);
          return p;
        };
        function O() {
          this._ = Object.create(null);
        }
        T(O, {
          has: D,
          add: function (c) {
            return this._[k(c += "")] = !0, c;
          },
          remove: R,
          values: z,
          size: N,
          empty: H,
          forEach: function (c) {
            for (var p in this._) c.call(this, q(p));
          }
        }), e.behavior = {};
        function J(c) {
          return c;
        }
        e.rebind = function (c, p) {
          for (var x = 1, M = arguments.length, C; ++x < M;) c[C = arguments[x]] = X(c, p, p[C]);
          return c;
        };
        function X(c, p, x) {
          return function () {
            var M = x.apply(p, arguments);
            return M === p ? c : M;
          };
        }
        function B(c, p) {
          if (p in c) return p;
          p = p.charAt(0).toUpperCase() + p.slice(1);
          for (var x = 0, M = I.length; x < M; ++x) {
            var C = I[x] + p;
            if (C in c) return C;
          }
        }
        var I = ["webkit", "ms", "moz", "Moz", "o", "O"];
        function V() {}
        e.dispatch = function () {
          for (var c = new K(), p = -1, x = arguments.length; ++p < x;) c[arguments[p]] = Q(c);
          return c;
        };
        function K() {}
        K.prototype.on = function (c, p) {
          var x = c.indexOf("."),
            M = "";
          if (x >= 0 && (M = c.slice(x + 1), c = c.slice(0, x)), c) return arguments.length < 2 ? this[c].on(M) : this[c].on(M, p);
          if (arguments.length === 2) {
            if (p == null) for (c in this) this.hasOwnProperty(c) && this[c].on(M, null);
            return this;
          }
        };
        function Q(c) {
          var p = [],
            x = new b();
          function M() {
            for (var C = p, L = -1, P = C.length, E; ++L < P;) (E = C[L].on) && E.apply(this, arguments);
            return c;
          }
          return M.on = function (C, L) {
            var P = x.get(C),
              E;
            return arguments.length < 2 ? P && P.on : (P && (P.on = null, p = p.slice(0, E = p.indexOf(P)).concat(p.slice(E + 1)), x.remove(C)), L && p.push(x.set(C, {
              on: L
            })), c);
          }, M;
        }
        e.event = null;
        function ie() {
          e.event.preventDefault();
        }
        function me() {
          for (var c = e.event, p; p = c.sourceEvent;) c = p;
          return c;
        }
        function pe(c) {
          for (var p = new K(), x = 0, M = arguments.length; ++x < M;) p[arguments[x]] = Q(p);
          return p.of = function (C, L) {
            return function (P) {
              try {
                var E = P.sourceEvent = e.event;
                P.target = c, e.event = P, p[P.type].apply(C, L);
              } finally {
                e.event = E;
              }
            };
          }, p;
        }
        e.requote = function (c) {
          return c.replace(ge, "\\$&");
        };
        var ge = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g,
          j = {}.__proto__ ? function (c, p) {
            c.__proto__ = p;
          } : function (c, p) {
            for (var x in p) c[x] = p[x];
          };
        function _e(c) {
          return j(c, Ae), c;
        }
        var se = function (c, p) {
            return p.querySelector(c);
          },
          Se = function (c, p) {
            return p.querySelectorAll(c);
          },
          ve = function (c, p) {
            var x = c.matches || c[B(c, "matchesSelector")];
            return ve = function (M, C) {
              return x.call(M, C);
            }, ve(c, p);
          };
        typeof Sizzle == "function" && (se = function (c, p) {
          return Sizzle(c, p)[0] || null;
        }, Se = Sizzle, ve = Sizzle.matchesSelector), e.selection = function () {
          return e.select(a.documentElement);
        };
        var Ae = e.selection.prototype = [];
        Ae.select = function (c) {
          var p = [],
            x,
            M,
            C,
            L;
          c = Y(c);
          for (var P = -1, E = this.length; ++P < E;) {
            p.push(x = []), x.parentNode = (C = this[P]).parentNode;
            for (var F = -1, G = C.length; ++F < G;) (L = C[F]) ? (x.push(M = c.call(L, L.__data__, F, P)), M && "__data__" in L && (M.__data__ = L.__data__)) : x.push(null);
          }
          return _e(p);
        };
        function Y(c) {
          return typeof c == "function" ? c : function () {
            return se(c, this);
          };
        }
        Ae.selectAll = function (c) {
          var p = [],
            x,
            M;
          c = re(c);
          for (var C = -1, L = this.length; ++C < L;) for (var P = this[C], E = -1, F = P.length; ++E < F;) (M = P[E]) && (p.push(x = t(c.call(M, M.__data__, E, C))), x.parentNode = M);
          return _e(p);
        };
        function re(c) {
          return typeof c == "function" ? c : function () {
            return Se(c, this);
          };
        }
        var U = "http://www.w3.org/1999/xhtml",
          de = {
            svg: "http://www.w3.org/2000/svg",
            xhtml: U,
            xlink: "http://www.w3.org/1999/xlink",
            xml: "http://www.w3.org/XML/1998/namespace",
            xmlns: "http://www.w3.org/2000/xmlns/"
          };
        e.ns = {
          prefix: de,
          qualify: function (c) {
            var p = c.indexOf(":"),
              x = c;
            return p >= 0 && (x = c.slice(0, p)) !== "xmlns" && (c = c.slice(p + 1)), de.hasOwnProperty(x) ? {
              space: de[x],
              local: c
            } : c;
          }
        }, Ae.attr = function (c, p) {
          if (arguments.length < 2) {
            if (typeof c == "string") {
              var x = this.node();
              return c = e.ns.qualify(c), c.local ? x.getAttributeNS(c.space, c.local) : x.getAttribute(c);
            }
            for (p in c) this.each(be(p, c[p]));
            return this;
          }
          return this.each(be(c, p));
        };
        function be(c, p) {
          c = e.ns.qualify(c);
          function x() {
            this.removeAttribute(c);
          }
          function M() {
            this.removeAttributeNS(c.space, c.local);
          }
          function C() {
            this.setAttribute(c, p);
          }
          function L() {
            this.setAttributeNS(c.space, c.local, p);
          }
          function P() {
            var F = p.apply(this, arguments);
            F == null ? this.removeAttribute(c) : this.setAttribute(c, F);
          }
          function E() {
            var F = p.apply(this, arguments);
            F == null ? this.removeAttributeNS(c.space, c.local) : this.setAttributeNS(c.space, c.local, F);
          }
          return p == null ? c.local ? M : x : typeof p == "function" ? c.local ? E : P : c.local ? L : C;
        }
        function ye(c) {
          return c.trim().replace(/\s+/g, " ");
        }
        Ae.classed = function (c, p) {
          if (arguments.length < 2) {
            if (typeof c == "string") {
              var x = this.node(),
                M = (c = Re(c)).length,
                C = -1;
              if (p = x.classList) {
                for (; ++C < M;) if (!p.contains(c[C])) return !1;
              } else for (p = x.getAttribute("class"); ++C < M;) if (!Fe(c[C]).test(p)) return !1;
              return !0;
            }
            for (p in c) this.each(Pe(p, c[p]));
            return this;
          }
          return this.each(Pe(c, p));
        };
        function Fe(c) {
          return new RegExp("(?:^|\\s+)" + e.requote(c) + "(?:\\s+|$)", "g");
        }
        function Re(c) {
          return (c + "").trim().split(/^|\s+/);
        }
        function Pe(c, p) {
          c = Re(c).map(Ie);
          var x = c.length;
          function M() {
            for (var L = -1; ++L < x;) c[L](this, p);
          }
          function C() {
            for (var L = -1, P = p.apply(this, arguments); ++L < x;) c[L](this, P);
          }
          return typeof p == "function" ? C : M;
        }
        function Ie(c) {
          var p = Fe(c);
          return function (x, M) {
            if (C = x.classList) return M ? C.add(c) : C.remove(c);
            var C = x.getAttribute("class") || "";
            M ? (p.lastIndex = 0, p.test(C) || x.setAttribute("class", ye(C + " " + c))) : x.setAttribute("class", ye(C.replace(p, " ")));
          };
        }
        Ae.style = function (c, p, x) {
          var M = arguments.length;
          if (M < 3) {
            if (typeof c != "string") {
              M < 2 && (p = "");
              for (x in c) this.each(Be(x, c[x], p));
              return this;
            }
            if (M < 2) {
              var C = this.node();
              return i(C).getComputedStyle(C, null).getPropertyValue(c);
            }
            x = "";
          }
          return this.each(Be(c, p, x));
        };
        function Be(c, p, x) {
          function M() {
            this.style.removeProperty(c);
          }
          function C() {
            this.style.setProperty(c, p, x);
          }
          function L() {
            var P = p.apply(this, arguments);
            P == null ? this.style.removeProperty(c) : this.style.setProperty(c, P, x);
          }
          return p == null ? M : typeof p == "function" ? L : C;
        }
        Ae.property = function (c, p) {
          if (arguments.length < 2) {
            if (typeof c == "string") return this.node()[c];
            for (p in c) this.each(Ne(p, c[p]));
            return this;
          }
          return this.each(Ne(c, p));
        };
        function Ne(c, p) {
          function x() {
            delete this[c];
          }
          function M() {
            this[c] = p;
          }
          function C() {
            var L = p.apply(this, arguments);
            L == null ? delete this[c] : this[c] = L;
          }
          return p == null ? x : typeof p == "function" ? C : M;
        }
        Ae.text = function (c) {
          return arguments.length ? this.each(typeof c == "function" ? function () {
            var p = c.apply(this, arguments);
            this.textContent = p == null ? "" : p;
          } : c == null ? function () {
            this.textContent = "";
          } : function () {
            this.textContent = c;
          }) : this.node().textContent;
        }, Ae.html = function (c) {
          return arguments.length ? this.each(typeof c == "function" ? function () {
            var p = c.apply(this, arguments);
            this.innerHTML = p == null ? "" : p;
          } : c == null ? function () {
            this.innerHTML = "";
          } : function () {
            this.innerHTML = c;
          }) : this.node().innerHTML;
        }, Ae.append = function (c) {
          return c = Ee(c), this.select(function () {
            return this.appendChild(c.apply(this, arguments));
          });
        };
        function Ee(c) {
          function p() {
            var M = this.ownerDocument,
              C = this.namespaceURI;
            return C === U && M.documentElement.namespaceURI === U ? M.createElement(c) : M.createElementNS(C, c);
          }
          function x() {
            return this.ownerDocument.createElementNS(c.space, c.local);
          }
          return typeof c == "function" ? c : (c = e.ns.qualify(c)).local ? x : p;
        }
        Ae.insert = function (c, p) {
          return c = Ee(c), p = Y(p), this.select(function () {
            return this.insertBefore(c.apply(this, arguments), p.apply(this, arguments) || null);
          });
        }, Ae.remove = function () {
          return this.each(Je);
        };
        function Je() {
          var c = this.parentNode;
          c && c.removeChild(this);
        }
        Ae.data = function (c, p) {
          var x = -1,
            M = this.length,
            C,
            L;
          if (!arguments.length) {
            for (c = new Array(M = (C = this[0]).length); ++x < M;) (L = C[x]) && (c[x] = L.__data__);
            return c;
          }
          function P(W, $) {
            var ee,
              he = W.length,
              we = $.length,
              te = Math.min(he, we),
              le = new Array(we),
              ue = new Array(we),
              xe = new Array(he),
              Te,
              ce;
            if (p) {
              var Ge = new b(),
                rr = new Array(he),
                or;
              for (ee = -1; ++ee < he;) (Te = W[ee]) && (Ge.has(or = p.call(Te, Te.__data__, ee)) ? xe[ee] = Te : Ge.set(or, Te), rr[ee] = or);
              for (ee = -1; ++ee < we;) (Te = Ge.get(or = p.call($, ce = $[ee], ee))) ? Te !== !0 && (le[ee] = Te, Te.__data__ = ce) : ue[ee] = We(ce), Ge.set(or, !0);
              for (ee = -1; ++ee < he;) ee in rr && Ge.get(rr[ee]) !== !0 && (xe[ee] = W[ee]);
            } else {
              for (ee = -1; ++ee < te;) Te = W[ee], ce = $[ee], Te ? (Te.__data__ = ce, le[ee] = Te) : ue[ee] = We(ce);
              for (; ee < we; ++ee) ue[ee] = We($[ee]);
              for (; ee < he; ++ee) xe[ee] = W[ee];
            }
            ue.update = le, ue.parentNode = le.parentNode = xe.parentNode = W.parentNode, E.push(ue), F.push(le), G.push(xe);
          }
          var E = cr([]),
            F = _e([]),
            G = _e([]);
          if (typeof c == "function") for (; ++x < M;) P(C = this[x], c.call(C, C.parentNode.__data__, x));else for (; ++x < M;) P(C = this[x], c);
          return F.enter = function () {
            return E;
          }, F.exit = function () {
            return G;
          }, F;
        };
        function We(c) {
          return {
            __data__: c
          };
        }
        Ae.datum = function (c) {
          return arguments.length ? this.property("__data__", c) : this.property("__data__");
        }, Ae.filter = function (c) {
          var p = [],
            x,
            M,
            C;
          typeof c != "function" && (c = ne(c));
          for (var L = 0, P = this.length; L < P; L++) {
            p.push(x = []), x.parentNode = (M = this[L]).parentNode;
            for (var E = 0, F = M.length; E < F; E++) (C = M[E]) && c.call(C, C.__data__, E, L) && x.push(C);
          }
          return _e(p);
        };
        function ne(c) {
          return function () {
            return ve(this, c);
          };
        }
        Ae.order = function () {
          for (var c = -1, p = this.length; ++c < p;) for (var x = this[c], M = x.length - 1, C = x[M], L; --M >= 0;) (L = x[M]) && (C && C !== L.nextSibling && C.parentNode.insertBefore(L, C), C = L);
          return this;
        }, Ae.sort = function (c) {
          c = Me.apply(this, arguments);
          for (var p = -1, x = this.length; ++p < x;) this[p].sort(c);
          return this.order();
        };
        function Me(c) {
          return arguments.length || (c = v), function (p, x) {
            return p && x ? c(p.__data__, x.__data__) : !p - !x;
          };
        }
        Ae.each = function (c) {
          return Ce(this, function (p, x, M) {
            c.call(p, p.__data__, x, M);
          });
        };
        function Ce(c, p) {
          for (var x = 0, M = c.length; x < M; x++) for (var C = c[x], L = 0, P = C.length, E; L < P; L++) (E = C[L]) && p(E, L, x);
          return c;
        }
        Ae.call = function (c) {
          var p = t(arguments);
          return c.apply(p[0] = this, p), this;
        }, Ae.empty = function () {
          return !this.node();
        }, Ae.node = function () {
          for (var c = 0, p = this.length; c < p; c++) for (var x = this[c], M = 0, C = x.length; M < C; M++) {
            var L = x[M];
            if (L) return L;
          }
          return null;
        }, Ae.size = function () {
          var c = 0;
          return Ce(this, function () {
            ++c;
          }), c;
        };
        function cr(c) {
          return j(c, tr), c;
        }
        var tr = [];
        e.selection.enter = cr, e.selection.enter.prototype = tr, tr.append = Ae.append, tr.empty = Ae.empty, tr.node = Ae.node, tr.call = Ae.call, tr.size = Ae.size, tr.select = function (c) {
          for (var p = [], x, M, C, L, P, E = -1, F = this.length; ++E < F;) {
            C = (L = this[E]).update, p.push(x = []), x.parentNode = L.parentNode;
            for (var G = -1, W = L.length; ++G < W;) (P = L[G]) ? (x.push(C[G] = M = c.call(L.parentNode, P.__data__, G, E)), M.__data__ = P.__data__) : x.push(null);
          }
          return _e(p);
        }, tr.insert = function (c, p) {
          return arguments.length < 2 && (p = De(this)), Ae.insert.call(this, c, p);
        };
        function De(c) {
          var p, x;
          return function (M, C, L) {
            var P = c[L].update,
              E = P.length,
              F;
            for (L != x && (x = L, p = 0), C >= p && (p = C + 1); !(F = P[p]) && ++p < E;);
            return F;
          };
        }
        e.select = function (c) {
          var p;
          return typeof c == "string" ? (p = [se(c, a)], p.parentNode = a.documentElement) : (p = [c], p.parentNode = n(c)), _e([p]);
        }, e.selectAll = function (c) {
          var p;
          return typeof c == "string" ? (p = t(Se(c, a)), p.parentNode = a.documentElement) : (p = t(c), p.parentNode = null), _e([p]);
        }, Ae.on = function (c, p, x) {
          var M = arguments.length;
          if (M < 3) {
            if (typeof c != "string") {
              M < 2 && (p = !1);
              for (x in c) this.each(Le(x, c[x], p));
              return this;
            }
            if (M < 2) return (M = this.node()["__on" + c]) && M._;
            x = !1;
          }
          return this.each(Le(c, p, x));
        };
        function Le(c, p, x) {
          var M = "__on" + c,
            C = c.indexOf("."),
            L = Ze;
          C > 0 && (c = c.slice(0, C));
          var P = Ye.get(c);
          P && (c = P, L = Ue);
          function E() {
            var W = this[M];
            W && (this.removeEventListener(c, W, W.$), delete this[M]);
          }
          function F() {
            var W = L(p, t(arguments));
            E.call(this), this.addEventListener(c, this[M] = W, W.$ = x), W._ = p;
          }
          function G() {
            var W = new RegExp("^__on([^.]+)" + e.requote(c) + "$"),
              $;
            for (var ee in this) if ($ = ee.match(W)) {
              var he = this[ee];
              this.removeEventListener($[1], he, he.$), delete this[ee];
            }
          }
          return C ? p ? F : E : p ? V : G;
        }
        var Ye = e.map({
          mouseenter: "mouseover",
          mouseleave: "mouseout"
        });
        a && Ye.forEach(function (c) {
          "on" + c in a && Ye.remove(c);
        });
        function Ze(c, p) {
          return function (x) {
            var M = e.event;
            e.event = x, p[0] = this.__data__;
            try {
              c.apply(this, p);
            } finally {
              e.event = M;
            }
          };
        }
        function Ue(c, p) {
          var x = Ze(c, p);
          return function (M) {
            var C = this,
              L = M.relatedTarget;
            (!L || L !== C && !(L.compareDocumentPosition(C) & 8)) && x.call(C, M);
          };
        }
        var Oe,
          Ke = 0;
        function fr(c) {
          var p = ".dragsuppress-" + ++Ke,
            x = "click" + p,
            M = e.select(i(c)).on("touchmove" + p, ie).on("dragstart" + p, ie).on("selectstart" + p, ie);
          if (Oe == null && (Oe = "onselectstart" in c ? !1 : B(c.style, "userSelect")), Oe) {
            var C = n(c).style,
              L = C[Oe];
            C[Oe] = "none";
          }
          return function (P) {
            if (M.on(p, null), Oe && (C[Oe] = L), P) {
              var E = function () {
                M.on(x, null);
              };
              M.on(x, function () {
                ie(), E();
              }, !0), setTimeout(E, 0);
            }
          };
        }
        e.mouse = function (c) {
          return ze(c, me());
        };
        var lr = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
        function ze(c, p) {
          p.changedTouches && (p = p.changedTouches[0]);
          var x = c.ownerSVGElement || c;
          if (x.createSVGPoint) {
            var M = x.createSVGPoint();
            if (lr < 0) {
              var C = i(c);
              if (C.scrollX || C.scrollY) {
                x = e.select("body").append("svg").style({
                  position: "absolute",
                  top: 0,
                  left: 0,
                  margin: 0,
                  padding: 0,
                  border: "none"
                }, "important");
                var L = x[0][0].getScreenCTM();
                lr = !(L.f || L.e), x.remove();
              }
            }
            return lr ? (M.x = p.pageX, M.y = p.pageY) : (M.x = p.clientX, M.y = p.clientY), M = M.matrixTransform(c.getScreenCTM().inverse()), [M.x, M.y];
          }
          var P = c.getBoundingClientRect();
          return [p.clientX - P.left - c.clientLeft, p.clientY - P.top - c.clientTop];
        }
        e.touch = function (c, p, x) {
          if (arguments.length < 3 && (x = p, p = me().changedTouches), p) {
            for (var M = 0, C = p.length, L; M < C; ++M) if ((L = p[M]).identifier === x) return ze(c, L);
          }
        }, e.behavior.drag = function () {
          var c = pe(C, "drag", "dragstart", "dragend"),
            p = null,
            x = L(V, e.mouse, i, "mousemove", "mouseup"),
            M = L(ae, e.touch, J, "touchmove", "touchend");
          function C() {
            this.on("mousedown.drag", x).on("touchstart.drag", M);
          }
          function L(P, E, F, G, W) {
            return function () {
              var $ = this,
                ee = e.event.target.correspondingElement || e.event.target,
                he = $.parentNode,
                we = c.of($, arguments),
                te = 0,
                le = P(),
                ue = ".drag" + (le == null ? "" : "-" + le),
                xe,
                Te = e.select(F(ee)).on(G + ue, rr).on(W + ue, or),
                ce = fr(ee),
                Ge = E(he, le);
              p ? (xe = p.apply($, arguments), xe = [xe.x - Ge[0], xe.y - Ge[1]]) : xe = [0, 0], we({
                type: "dragstart"
              });
              function rr() {
                var ar = E(he, le),
                  hr,
                  dr;
                ar && (hr = ar[0] - Ge[0], dr = ar[1] - Ge[1], te |= hr | dr, Ge = ar, we({
                  type: "drag",
                  x: ar[0] + xe[0],
                  y: ar[1] + xe[1],
                  dx: hr,
                  dy: dr
                }));
              }
              function or() {
                E(he, le) && (Te.on(G + ue, null).on(W + ue, null), ce(te), we({
                  type: "dragend"
                }));
              }
            };
          }
          return C.origin = function (P) {
            return arguments.length ? (p = P, C) : p;
          }, e.rebind(C, c, "on");
        };
        function ae() {
          return e.event.changedTouches[0].identifier;
        }
        e.touches = function (c, p) {
          return arguments.length < 2 && (p = me().touches), p ? t(p).map(function (x) {
            var M = ze(c, x);
            return M.identifier = x.identifier, M;
          }) : [];
        };
        var oe = 1e-6,
          qe = oe * oe,
          ke = Math.PI,
          ir = 2 * ke,
          vr = ir - oe,
          sr = ke / 2,
          Mr = ke / 180,
          Ur = 180 / ke;
        function $r(c) {
          return c > 0 ? 1 : c < 0 ? -1 : 0;
        }
        function Vr(c, p, x) {
          return (p[0] - c[0]) * (x[1] - c[1]) - (p[1] - c[1]) * (x[0] - c[0]);
        }
        function St(c) {
          return c > 1 ? 0 : c < -1 ? ke : Math.acos(c);
        }
        function ea(c) {
          return c > 1 ? sr : c < -1 ? -sr : Math.asin(c);
        }
        function ka(c) {
          return ((c = Math.exp(c)) - 1 / c) / 2;
        }
        function ra(c) {
          return ((c = Math.exp(c)) + 1 / c) / 2;
        }
        function pn(c) {
          return ((c = Math.exp(2 * c)) - 1) / (c + 1);
        }
        function Ia(c) {
          return (c = Math.sin(c / 2)) * c;
        }
        var ta = Math.SQRT2,
          Ha = 2,
          yr = 4;
        e.interpolateZoom = function (c, p) {
          var x = c[0],
            M = c[1],
            C = c[2],
            L = p[0],
            P = p[1],
            E = p[2],
            F = L - x,
            G = P - M,
            W = F * F + G * G,
            $,
            ee;
          if (W < qe) ee = Math.log(E / C) / ta, $ = function (xe) {
            return [x + xe * F, M + xe * G, C * Math.exp(ta * xe * ee)];
          };else {
            var he = Math.sqrt(W),
              we = (E * E - C * C + yr * W) / (2 * C * Ha * he),
              te = (E * E - C * C - yr * W) / (2 * E * Ha * he),
              le = Math.log(Math.sqrt(we * we + 1) - we),
              ue = Math.log(Math.sqrt(te * te + 1) - te);
            ee = (ue - le) / ta, $ = function (xe) {
              var Te = xe * ee,
                ce = ra(le),
                Ge = C / (Ha * he) * (ce * pn(ta * Te + le) - ka(le));
              return [x + Ge * F, M + Ge * G, C * ce / ra(ta * Te + le)];
            };
          }
          return $.duration = ee * 1e3, $;
        }, e.behavior.zoom = function () {
          var c = {
              x: 0,
              y: 0,
              k: 1
            },
            p,
            x,
            M,
            C = [960, 500],
            L = lt,
            P = 250,
            E = 0,
            F = "mousedown.zoom",
            G = "mousemove.zoom",
            W = "mouseup.zoom",
            $,
            ee = "touchstart.zoom",
            he,
            we = pe(Te, "zoomstart", "zoom", "zoomend"),
            te,
            le,
            ue,
            xe;
          mt || (mt = "onwheel" in a ? (Wr = function () {
            return -e.event.deltaY * (e.event.deltaMode ? 120 : 1);
          }, "wheel") : "onmousewheel" in a ? (Wr = function () {
            return e.event.wheelDelta;
          }, "mousewheel") : (Wr = function () {
            return -e.event.detail;
          }, "MozMousePixelScroll"));
          function Te(er) {
            er.on(F, Tr).on(mt + ".zoom", Lt).on("dblclick.zoom", rt).on(ee, Jr);
          }
          Te.event = function (er) {
            er.each(function () {
              var Lr = we.of(this, arguments),
                qr = c;
              Xl ? e.select(this).transition().each("start.zoom", function () {
                c = this.__chart__ || {
                  x: 0,
                  y: 0,
                  k: 1
                }, dr(Lr);
              }).tween("zoom:zoom", function () {
                var Kr = C[0],
                  _t = C[1],
                  Ot = x ? x[0] : Kr / 2,
                  ca = x ? x[1] : _t / 2,
                  La = e.interpolateZoom([(Ot - c.x) / c.k, (ca - c.y) / c.k, Kr / c.k], [(Ot - qr.x) / qr.k, (ca - qr.y) / qr.k, Kr / qr.k]);
                return function (Oa) {
                  var qa = La(Oa),
                    Ga = Kr / qa[2];
                  this.__chart__ = c = {
                    x: Ot - qa[0] * Ga,
                    y: ca - qa[1] * Ga,
                    k: Ga
                  }, Sr(Lr);
                };
              }).each("interrupt.zoom", function () {
                pr(Lr);
              }).each("end.zoom", function () {
                pr(Lr);
              }) : (this.__chart__ = c, dr(Lr), Sr(Lr), pr(Lr));
            });
          }, Te.translate = function (er) {
            return arguments.length ? (c = {
              x: +er[0],
              y: +er[1],
              k: c.k
            }, hr(), Te) : [c.x, c.y];
          }, Te.scale = function (er) {
            return arguments.length ? (c = {
              x: c.x,
              y: c.y,
              k: null
            }, rr(+er), hr(), Te) : c.k;
          }, Te.scaleExtent = function (er) {
            return arguments.length ? (L = er == null ? lt : [+er[0], +er[1]], Te) : L;
          }, Te.center = function (er) {
            return arguments.length ? (M = er && [+er[0], +er[1]], Te) : M;
          }, Te.size = function (er) {
            return arguments.length ? (C = er && [+er[0], +er[1]], Te) : C;
          }, Te.duration = function (er) {
            return arguments.length ? (P = +er, Te) : P;
          }, Te.x = function (er) {
            return arguments.length ? (le = er, te = er.copy(), c = {
              x: 0,
              y: 0,
              k: 1
            }, Te) : le;
          }, Te.y = function (er) {
            return arguments.length ? (xe = er, ue = er.copy(), c = {
              x: 0,
              y: 0,
              k: 1
            }, Te) : xe;
          };
          function ce(er) {
            return [(er[0] - c.x) / c.k, (er[1] - c.y) / c.k];
          }
          function Ge(er) {
            return [er[0] * c.k + c.x, er[1] * c.k + c.y];
          }
          function rr(er) {
            c.k = Math.max(L[0], Math.min(L[1], er));
          }
          function or(er, Lr) {
            Lr = Ge(Lr), c.x += er[0] - Lr[0], c.y += er[1] - Lr[1];
          }
          function ar(er, Lr, qr, Kr) {
            er.__chart__ = {
              x: c.x,
              y: c.y,
              k: c.k
            }, rr(Math.pow(2, Kr)), or(x = Lr, qr), er = e.select(er), P > 0 && (er = er.transition().duration(P)), er.call(Te.event);
          }
          function hr() {
            le && le.domain(te.range().map(function (er) {
              return (er - c.x) / c.k;
            }).map(te.invert)), xe && xe.domain(ue.range().map(function (er) {
              return (er - c.y) / c.k;
            }).map(ue.invert));
          }
          function dr(er) {
            E++ || er({
              type: "zoomstart"
            });
          }
          function Sr(er) {
            hr(), er({
              type: "zoom",
              scale: c.k,
              translate: [c.x, c.y]
            });
          }
          function pr(er) {
            --E || (er({
              type: "zoomend"
            }), x = null);
          }
          function Tr() {
            var er = this,
              Lr = we.of(er, arguments),
              qr = 0,
              Kr = e.select(i(er)).on(G, ca).on(W, La),
              _t = ce(e.mouse(er)),
              Ot = fr(er);
            $c.call(er), dr(Lr);
            function ca() {
              qr = 1, or(e.mouse(er), _t), Sr(Lr);
            }
            function La() {
              Kr.on(G, null).on(W, null), Ot(qr), pr(Lr);
            }
          }
          function Jr() {
            var er = this,
              Lr = we.of(er, arguments),
              qr = {},
              Kr = 0,
              _t,
              Ot = ".zoom-" + e.event.changedTouches[0].identifier,
              ca = "touchmove" + Ot,
              La = "touchend" + Ot,
              Oa = [],
              qa = e.select(er),
              Ga = fr(er);
            Va(), dr(Lr), qa.on(F, null).on(ee, Va);
            function ba() {
              var Yn = e.touches(er);
              return _t = c.k, Yn.forEach(function (va) {
                va.identifier in qr && (qr[va.identifier] = ce(va));
              }), Yn;
            }
            function Va() {
              var Yn = e.event.target;
              e.select(Yn).on(ca, Jl).on(La, $F), Oa.push(Yn);
              for (var va = e.event.changedTouches, yn = 0, vi = va.length; yn < vi; ++yn) qr[va[yn].identifier] = null;
              var gn = ba(),
                ls = Date.now();
              if (gn.length === 1) {
                if (ls - he < 500) {
                  var Kl = gn[0];
                  ar(er, Kl, qr[Kl.identifier], Math.floor(Math.log(c.k) / Math.LN2) + 1), ie();
                }
                he = ls;
              } else if (gn.length > 1) {
                var Kl = gn[0],
                  al = gn[1],
                  rv = Kl[0] - al[0],
                  ab = Kl[1] - al[1];
                Kr = rv * rv + ab * ab;
              }
            }
            function Jl() {
              var Yn = e.touches(er),
                va,
                yn,
                vi,
                gn;
              $c.call(er);
              for (var ls = 0, Kl = Yn.length; ls < Kl; ++ls, gn = null) if (vi = Yn[ls], gn = qr[vi.identifier]) {
                if (yn) break;
                va = vi, yn = gn;
              }
              if (gn) {
                var al = (al = vi[0] - va[0]) * al + (al = vi[1] - va[1]) * al,
                  rv = Kr && Math.sqrt(al / Kr);
                va = [(va[0] + vi[0]) / 2, (va[1] + vi[1]) / 2], yn = [(yn[0] + gn[0]) / 2, (yn[1] + gn[1]) / 2], rr(rv * _t);
              }
              he = null, or(va, yn), Sr(Lr);
            }
            function $F() {
              if (e.event.touches.length) {
                for (var Yn = e.event.changedTouches, va = 0, yn = Yn.length; va < yn; ++va) delete qr[Yn[va].identifier];
                for (var vi in qr) return void ba();
              }
              e.selectAll(Oa).on(Ot, null), qa.on(F, Tr).on(ee, Jr), Ga(), pr(Lr);
            }
          }
          function Lt() {
            var er = we.of(this, arguments);
            $ ? clearTimeout($) : ($c.call(this), p = ce(x = M || e.mouse(this)), dr(er)), $ = setTimeout(function () {
              $ = null, pr(er);
            }, 50), ie(), rr(Math.pow(2, Wr() * .002) * c.k), or(x, p), Sr(er);
          }
          function rt() {
            var er = e.mouse(this),
              Lr = Math.log(c.k) / Math.LN2;
            ar(this, er, ce(er), e.event.shiftKey ? Math.ceil(Lr) - 1 : Math.floor(Lr) + 1);
          }
          return e.rebind(Te, we, "on");
        };
        var lt = [0, 1 / 0],
          Wr,
          mt;
        e.color = Tt;
        function Tt() {}
        Tt.prototype.toString = function () {
          return this.rgb() + "";
        }, e.hsl = ot;
        function ot(c, p, x) {
          return this instanceof ot ? (this.h = +c, this.s = +p, void (this.l = +x)) : arguments.length < 2 ? c instanceof ot ? new ot(c.h, c.s, c.l) : Zr("" + c, jr, ot) : new ot(c, p, x);
        }
        var yt = ot.prototype = new Tt();
        yt.brighter = function (c) {
          return c = Math.pow(.7, arguments.length ? c : 1), new ot(this.h, this.s, this.l / c);
        }, yt.darker = function (c) {
          return c = Math.pow(.7, arguments.length ? c : 1), new ot(this.h, this.s, c * this.l);
        }, yt.rgb = function () {
          return Ca(this.h, this.s, this.l);
        };
        function Ca(c, p, x) {
          var M, C;
          c = isNaN(c) ? 0 : (c %= 360) < 0 ? c + 360 : c, p = isNaN(p) || p < 0 ? 0 : p > 1 ? 1 : p, x = x < 0 ? 0 : x > 1 ? 1 : x, C = x <= .5 ? x * (1 + p) : x + p - x * p, M = 2 * x - C;
          function L(E) {
            return E > 360 ? E -= 360 : E < 0 && (E += 360), E < 60 ? M + (C - M) * E / 60 : E < 180 ? C : E < 240 ? M + (C - M) * (240 - E) / 60 : M;
          }
          function P(E) {
            return Math.round(L(E) * 255);
          }
          return new Sa(P(c + 120), P(c), P(c - 120));
        }
        e.hcl = aa;
        function aa(c, p, x) {
          return this instanceof aa ? (this.h = +c, this.c = +p, void (this.l = +x)) : arguments.length < 2 ? c instanceof aa ? new aa(c.h, c.c, c.l) : c instanceof Wt ? Dc(c.l, c.a, c.b) : Dc((c = nr((c = e.rgb(c)).r, c.g, c.b)).l, c.a, c.b) : new aa(c, p, x);
        }
        var In = aa.prototype = new Tt();
        In.brighter = function (c) {
          return new aa(this.h, this.c, Math.min(100, this.l + at * (arguments.length ? c : 1)));
        }, In.darker = function (c) {
          return new aa(this.h, this.c, Math.max(0, this.l - at * (arguments.length ? c : 1)));
        }, In.rgb = function () {
          return Hn(this.h, this.c, this.l).rgb();
        };
        function Hn(c, p, x) {
          return isNaN(c) && (c = 0), isNaN(p) && (p = 0), new Wt(x, Math.cos(c *= Mr) * p, Math.sin(c) * p);
        }
        e.lab = Wt;
        function Wt(c, p, x) {
          return this instanceof Wt ? (this.l = +c, this.a = +p, void (this.b = +x)) : arguments.length < 2 ? c instanceof Wt ? new Wt(c.l, c.a, c.b) : c instanceof aa ? Hn(c.h, c.c, c.l) : nr((c = Sa(c)).r, c.g, c.b) : new Wt(c, p, x);
        }
        var at = 18,
          sa = .95047,
          Ul = 1,
          Gl = 1.08883,
          rl = Wt.prototype = new Tt();
        rl.brighter = function (c) {
          return new Wt(Math.min(100, this.l + at * (arguments.length ? c : 1)), this.a, this.b);
        }, rl.darker = function (c) {
          return new Wt(Math.max(0, this.l - at * (arguments.length ? c : 1)), this.a, this.b);
        }, rl.rgb = function () {
          return qc(this.l, this.a, this.b);
        };
        function qc(c, p, x) {
          var M = (c + 16) / 116,
            C = M + p / 500,
            L = M - x / 200;
          return C = ku(C) * sa, M = ku(M) * Ul, L = ku(L) * Gl, new Sa(Su(3.2404542 * C - 1.5371385 * M - .4985314 * L), Su(-.969266 * C + 1.8760108 * M + .041556 * L), Su(.0556434 * C - .2040259 * M + 1.0572252 * L));
        }
        function Dc(c, p, x) {
          return c > 0 ? new aa(Math.atan2(x, p) * Ur, Math.sqrt(p * p + x * x), c) : new aa(NaN, NaN, c);
        }
        function ku(c) {
          return c > .206893034 ? c * c * c : (c - 4 / 29) / 7.787037;
        }
        function Cu(c) {
          return c > .008856 ? Math.pow(c, 1 / 3) : 7.787037 * c + 4 / 29;
        }
        function Su(c) {
          return Math.round(255 * (c <= .00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - .055));
        }
        e.rgb = Sa;
        function Sa(c, p, x) {
          return this instanceof Sa ? (this.r = ~~c, this.g = ~~p, void (this.b = ~~x)) : arguments.length < 2 ? c instanceof Sa ? new Sa(c.r, c.g, c.b) : Zr("" + c, Sa, Ca) : new Sa(c, p, x);
        }
        function Ec(c) {
          return new Sa(c >> 16, c >> 8 & 255, c & 255);
        }
        function $o(c) {
          return Ec(c) + "";
        }
        var jo = Sa.prototype = new Tt();
        jo.brighter = function (c) {
          c = Math.pow(.7, arguments.length ? c : 1);
          var p = this.r,
            x = this.g,
            M = this.b,
            C = 30;
          return !p && !x && !M ? new Sa(C, C, C) : (p && p < C && (p = C), x && x < C && (x = C), M && M < C && (M = C), new Sa(Math.min(255, p / c), Math.min(255, x / c), Math.min(255, M / c)));
        }, jo.darker = function (c) {
          return c = Math.pow(.7, arguments.length ? c : 1), new Sa(c * this.r, c * this.g, c * this.b);
        }, jo.hsl = function () {
          return jr(this.r, this.g, this.b);
        }, jo.toString = function () {
          return "#" + mr(this.r) + mr(this.g) + mr(this.b);
        };
        function mr(c) {
          return c < 16 ? "0" + Math.max(0, c).toString(16) : Math.min(255, c).toString(16);
        }
        function Zr(c, p, x) {
          var M = 0,
            C = 0,
            L = 0,
            P,
            E,
            F;
          if (P = /([a-z]+)\((.*)\)/.exec(c = c.toLowerCase()), P) switch (E = P[2].split(","), P[1]) {
            case "hsl":
              return x(parseFloat(E[0]), parseFloat(E[1]) / 100, parseFloat(E[2]) / 100);
            case "rgb":
              return p(st(E[0]), st(E[1]), st(E[2]));
          }
          return (F = fa.get(c)) ? p(F.r, F.g, F.b) : (c != null && c.charAt(0) === "#" && !isNaN(F = parseInt(c.slice(1), 16)) && (c.length === 4 ? (M = (F & 3840) >> 4, M = M >> 4 | M, C = F & 240, C = C >> 4 | C, L = F & 15, L = L << 4 | L) : c.length === 7 && (M = (F & 16711680) >> 16, C = (F & 65280) >> 8, L = F & 255)), p(M, C, L));
        }
        function jr(c, p, x) {
          var M = Math.min(c /= 255, p /= 255, x /= 255),
            C = Math.max(c, p, x),
            L = C - M,
            P,
            E,
            F = (C + M) / 2;
          return L ? (E = F < .5 ? L / (C + M) : L / (2 - C - M), c == C ? P = (p - x) / L + (p < x ? 6 : 0) : p == C ? P = (x - c) / L + 2 : P = (c - p) / L + 4, P *= 60) : (P = NaN, E = F > 0 && F < 1 ? 0 : P), new ot(P, E, F);
        }
        function nr(c, p, x) {
          c = ua(c), p = ua(p), x = ua(x);
          var M = Cu((.4124564 * c + .3575761 * p + .1804375 * x) / sa),
            C = Cu((.2126729 * c + .7151522 * p + .072175 * x) / Ul),
            L = Cu((.0193339 * c + .119192 * p + .9503041 * x) / Gl);
          return Wt(116 * C - 16, 500 * (M - C), 200 * (C - L));
        }
        function ua(c) {
          return (c /= 255) <= .04045 ? c / 12.92 : Math.pow((c + .055) / 1.055, 2.4);
        }
        function st(c) {
          var p = parseFloat(c);
          return c.charAt(c.length - 1) === "%" ? Math.round(p * 2.55) : p;
        }
        var fa = e.map({
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        });
        fa.forEach(function (c, p) {
          fa.set(c, Ec(p));
        });
        function Rr(c) {
          return typeof c == "function" ? c : function () {
            return c;
          };
        }
        e.functor = Rr, e.xhr = On(J);
        function On(c) {
          return function (p, x, M) {
            return arguments.length === 2 && typeof x == "function" && (M = x, x = null), Vl(p, x, c, M);
          };
        }
        function Vl(c, p, x, M) {
          var C = {},
            L = e.dispatch("beforesend", "progress", "load", "error"),
            P = {},
            E = new XMLHttpRequest(),
            F = null;
          self.XDomainRequest && !("withCredentials" in E) && /^(http(s)?:)?\/\//.test(c) && (E = new XDomainRequest()), "onload" in E ? E.onload = E.onerror = G : E.onreadystatechange = function () {
            E.readyState > 3 && G();
          };
          function G() {
            var W = E.status,
              $;
            if (!W && eN(E) || W >= 200 && W < 300 || W === 304) {
              try {
                $ = x.call(C, E);
              } catch (ee) {
                L.error.call(C, ee);
                return;
              }
              L.load.call(C, $);
            } else L.error.call(C, E);
          }
          return E.onprogress = function (W) {
            var $ = e.event;
            e.event = W;
            try {
              L.progress.call(C, E);
            } finally {
              e.event = $;
            }
          }, C.header = function (W, $) {
            return W = (W + "").toLowerCase(), arguments.length < 2 ? P[W] : ($ == null ? delete P[W] : P[W] = $ + "", C);
          }, C.mimeType = function (W) {
            return arguments.length ? (p = W == null ? null : W + "", C) : p;
          }, C.responseType = function (W) {
            return arguments.length ? (F = W, C) : F;
          }, C.response = function (W) {
            return x = W, C;
          }, ["get", "post"].forEach(function (W) {
            C[W] = function () {
              return C.send.apply(C, [W].concat(t(arguments)));
            };
          }), C.send = function (W, $, ee) {
            if (arguments.length === 2 && typeof $ == "function" && (ee = $, $ = null), E.open(W, c, !0), p != null && !("accept" in P) && (P.accept = p + ",*/*"), E.setRequestHeader) for (var he in P) E.setRequestHeader(he, P[he]);
            return p != null && E.overrideMimeType && E.overrideMimeType(p), F != null && (E.responseType = F), ee != null && C.on("error", ee).on("load", function (we) {
              ee(null, we);
            }), L.beforesend.call(C, E), E.send($ == null ? null : $), C;
          }, C.abort = function () {
            return E.abort(), C;
          }, e.rebind(C, L, "on"), M == null ? C : C.get(jz(M));
        }
        function jz(c) {
          return c.length === 1 ? function (p, x) {
            c(p == null ? x : null);
          } : c;
        }
        function eN(c) {
          var p = c.responseType;
          return p && p !== "text" ? c.response : c.responseText;
        }
        e.dsv = function (c, p) {
          var x = new RegExp('["' + c + `
]`),
            M = c.charCodeAt(0);
          function C(G, W, $) {
            arguments.length < 3 && ($ = W, W = null);
            var ee = Vl(G, p, W == null ? L : P(W), $);
            return ee.row = function (he) {
              return arguments.length ? ee.response((W = he) == null ? L : P(he)) : W;
            }, ee;
          }
          function L(G) {
            return C.parse(G.responseText);
          }
          function P(G) {
            return function (W) {
              return C.parse(W.responseText, G);
            };
          }
          C.parse = function (G, W) {
            var $;
            return C.parseRows(G, function (ee, he) {
              if ($) return $(ee, he - 1);
              var we = function (te) {
                for (var le = {}, ue = ee.length, xe = 0; xe < ue; ++xe) le[ee[xe]] = te[xe];
                return le;
              };
              $ = W ? function (te, le) {
                return W(we(te), le);
              } : we;
            });
          }, C.parseRows = function (G, W) {
            var $ = {},
              ee = {},
              he = [],
              we = G.length,
              te = 0,
              le = 0,
              ue,
              xe;
            function Te() {
              if (te >= we) return ee;
              if (xe) return xe = !1, $;
              var Ge = te;
              if (G.charCodeAt(Ge) === 34) {
                for (var rr = Ge; rr++ < we;) if (G.charCodeAt(rr) === 34) {
                  if (G.charCodeAt(rr + 1) !== 34) break;
                  ++rr;
                }
                te = rr + 2;
                var or = G.charCodeAt(rr + 1);
                return or === 13 ? (xe = !0, G.charCodeAt(rr + 2) === 10 && ++te) : or === 10 && (xe = !0), G.slice(Ge + 1, rr).replace(/""/g, '"');
              }
              for (; te < we;) {
                var or = G.charCodeAt(te++),
                  ar = 1;
                if (or === 10) xe = !0;else if (or === 13) xe = !0, G.charCodeAt(te) === 10 && (++te, ++ar);else if (or !== M) continue;
                return G.slice(Ge, te - ar);
              }
              return G.slice(Ge);
            }
            for (; (ue = Te()) !== ee;) {
              for (var ce = []; ue !== $ && ue !== ee;) ce.push(ue), ue = Te();
              W && (ce = W(ce, le++)) == null || he.push(ce);
            }
            return he;
          }, C.format = function (G) {
            if (Array.isArray(G[0])) return C.formatRows(G);
            var W = new O(),
              $ = [];
            return G.forEach(function (ee) {
              for (var he in ee) W.has(he) || $.push(W.add(he));
            }), [$.map(F).join(c)].concat(G.map(function (ee) {
              return $.map(function (he) {
                return F(ee[he]);
              }).join(c);
            })).join(`
`);
          }, C.formatRows = function (G) {
            return G.map(E).join(`
`);
          };
          function E(G) {
            return G.map(F).join(c);
          }
          function F(G) {
            return x.test(G) ? '"' + G.replace(/\"/g, '""') + '"' : G;
          }
          return C;
        }, e.csv = e.dsv(",", "text/csv"), e.tsv = e.dsv("	", "text/tab-separated-values");
        var Pc,
          Rc,
          zc,
          Nc,
          U3 = this[B(this, "requestAnimationFrame")] || function (c) {
            setTimeout(c, 17);
          };
        e.timer = function () {
          Fc.apply(this, arguments);
        };
        function Fc(c, p, x) {
          var M = arguments.length;
          M < 2 && (p = 0), M < 3 && (x = Date.now());
          var C = x + p,
            L = {
              c,
              t: C,
              n: null
            };
          return Rc ? Rc.n = L : Pc = L, Rc = L, zc || (Nc = clearTimeout(Nc), zc = 1, U3(c1)), L;
        }
        function c1() {
          var c = G3(),
            p = V3() - c;
          p > 24 ? (isFinite(p) && (clearTimeout(Nc), Nc = setTimeout(c1, p)), zc = 0) : (zc = 1, U3(c1));
        }
        e.timer.flush = function () {
          G3(), V3();
        };
        function G3() {
          for (var c = Date.now(), p = Pc; p;) c >= p.t && p.c(c - p.t) && (p.c = null), p = p.n;
          return c;
        }
        function V3() {
          for (var c, p = Pc, x = 1 / 0; p;) p.c ? (p.t < x && (x = p.t), p = (c = p).n) : p = c ? c.n = p.n : Pc = p.n;
          return Rc = c, x;
        }
        e.round = function (c, p) {
          return p ? Math.round(c * (p = Math.pow(10, p))) / p : Math.round(c);
        }, e.geom = {};
        function es(c) {
          return c[0];
        }
        function Lu(c) {
          return c[1];
        }
        e.geom.hull = function (c) {
          var p = es,
            x = Lu;
          if (arguments.length) return M(c);
          function M(C) {
            if (C.length < 3) return [];
            var L = Rr(p),
              P = Rr(x),
              E,
              F = C.length,
              G = [],
              W = [];
            for (E = 0; E < F; E++) G.push([+L.call(this, C[E], E), +P.call(this, C[E], E), E]);
            for (G.sort(rN), E = 0; E < F; E++) W.push([G[E][0], -G[E][1]]);
            var $ = W3(G),
              ee = W3(W),
              he = ee[0] === $[0],
              we = ee[ee.length - 1] === $[$.length - 1],
              te = [];
            for (E = $.length - 1; E >= 0; --E) te.push(C[G[$[E]][2]]);
            for (E = +he; E < ee.length - we; ++E) te.push(C[G[ee[E]][2]]);
            return te;
          }
          return M.x = function (C) {
            return arguments.length ? (p = C, M) : p;
          }, M.y = function (C) {
            return arguments.length ? (x = C, M) : x;
          }, M;
        };
        function W3(c) {
          for (var p = c.length, x = [0, 1], M = 2, C = 2; C < p; C++) {
            for (; M > 1 && Vr(c[x[M - 2]], c[x[M - 1]], c[C]) <= 0;) --M;
            x[M++] = C;
          }
          return x.slice(0, M);
        }
        function rN(c, p) {
          return c[0] - p[0] || c[1] - p[1];
        }
        e.geom.polygon = function (c) {
          return j(c, Ic), c;
        };
        var Ic = e.geom.polygon.prototype = [];
        Ic.area = function () {
          for (var c = -1, p = this.length, x, M = this[p - 1], C = 0; ++c < p;) x = M, M = this[c], C += x[1] * M[0] - x[0] * M[1];
          return C * .5;
        }, Ic.centroid = function (c) {
          var p = -1,
            x = this.length,
            M = 0,
            C = 0,
            L,
            P = this[x - 1],
            E;
          for (arguments.length || (c = -1 / (6 * this.area())); ++p < x;) L = P, P = this[p], E = L[0] * P[1] - P[0] * L[1], M += (L[0] + P[0]) * E, C += (L[1] + P[1]) * E;
          return [M * c, C * c];
        }, Ic.clip = function (c) {
          for (var p, x = Z3(c), M = -1, C = this.length - Z3(this), L, P, E = this[C - 1], F, G, W; ++M < C;) {
            for (p = c.slice(), c.length = 0, F = this[M], G = p[(P = p.length - x) - 1], L = -1; ++L < P;) W = p[L], v1(W, E, F) ? (v1(G, E, F) || c.push(h1(G, W, E, F)), c.push(W)) : v1(G, E, F) && c.push(h1(G, W, E, F)), G = W;
            x && c.push(c[0]), E = F;
          }
          return c;
        };
        function v1(c, p, x) {
          return (x[0] - p[0]) * (c[1] - p[1]) < (x[1] - p[1]) * (c[0] - p[0]);
        }
        function h1(c, p, x, M) {
          var C = c[0],
            L = x[0],
            P = p[0] - C,
            E = M[0] - L,
            F = c[1],
            G = x[1],
            W = p[1] - F,
            $ = M[1] - G,
            ee = (E * (F - G) - $ * (C - L)) / ($ * P - E * W);
          return [C + ee * P, F + ee * W];
        }
        function Z3(c) {
          var p = c[0],
            x = c[c.length - 1];
          return !(p[0] - x[0] || p[1] - x[1]);
        }
        var rs,
          Wl,
          ts,
          X3 = [],
          d1,
          qu,
          J3 = [];
        function tN() {
          Bc(this), this.edge = this.site = this.circle = null;
        }
        function K3(c) {
          var p = X3.pop() || new tN();
          return p.site = c, p;
        }
        function p1(c) {
          ns(c), ts.remove(c), X3.push(c), Bc(c);
        }
        function aN(c) {
          var p = c.circle,
            x = p.x,
            M = p.cy,
            C = {
              x,
              y: M
            },
            L = c.P,
            P = c.N,
            E = [c];
          p1(c);
          for (var F = L; F.circle && _(x - F.circle.x) < oe && _(M - F.circle.cy) < oe;) L = F.P, E.unshift(F), p1(F), F = L;
          E.unshift(F), ns(F);
          for (var G = P; G.circle && _(x - G.circle.x) < oe && _(M - G.circle.cy) < oe;) P = G.N, E.push(G), p1(G), G = P;
          E.push(G), ns(G);
          var W = E.length,
            $;
          for ($ = 1; $ < W; ++$) G = E[$], F = E[$ - 1], Hc(G.edge, F.site, G.site, C);
          F = E[0], G = E[W - 1], G.edge = Du(F.site, G.site, null, C), as(F), as(G);
        }
        function nN(c) {
          for (var p = c.x, x = c.y, M, C, L, P, E = ts._; E;) if (L = Q3(E, x) - p, L > oe) E = E.L;else if (P = p - iN(E, x), P > oe) {
            if (!E.R) {
              M = E;
              break;
            }
            E = E.R;
          } else {
            L > -oe ? (M = E.P, C = E) : P > -oe ? (M = E, C = E.N) : M = C = E;
            break;
          }
          var F = K3(c);
          if (ts.insert(M, F), !(!M && !C)) {
            if (M === C) {
              ns(M), C = K3(M.site), ts.insert(F, C), F.edge = C.edge = Du(M.site, F.site), as(M), as(C);
              return;
            }
            if (!C) {
              F.edge = Du(M.site, F.site);
              return;
            }
            ns(M), ns(C);
            var G = M.site,
              W = G.x,
              $ = G.y,
              ee = c.x - W,
              he = c.y - $,
              we = C.site,
              te = we.x - W,
              le = we.y - $,
              ue = 2 * (ee * le - he * te),
              xe = ee * ee + he * he,
              Te = te * te + le * le,
              ce = {
                x: (le * xe - he * Te) / ue + W,
                y: (ee * Te - te * xe) / ue + $
              };
            Hc(C.edge, G, we, ce), F.edge = Du(G, c, null, ce), C.edge = Du(c, we, null, ce), as(M), as(C);
          }
        }
        function Q3(c, p) {
          var x = c.site,
            M = x.x,
            C = x.y,
            L = C - p;
          if (!L) return M;
          var P = c.P;
          if (!P) return -1 / 0;
          x = P.site;
          var E = x.x,
            F = x.y,
            G = F - p;
          if (!G) return E;
          var W = E - M,
            $ = 1 / L - 1 / G,
            ee = W / G;
          return $ ? (-ee + Math.sqrt(ee * ee - 2 * $ * (W * W / (-2 * G) - F + G / 2 + C - L / 2))) / $ + M : (M + E) / 2;
        }
        function iN(c, p) {
          var x = c.N;
          if (x) return Q3(x, p);
          var M = c.site;
          return M.y === p ? M.x : 1 / 0;
        }
        function $3(c) {
          this.site = c, this.edges = [];
        }
        $3.prototype.prepare = function () {
          for (var c = this.edges, p = c.length, x; p--;) x = c[p].edge, (!x.b || !x.a) && c.splice(p, 1);
          return c.sort(j3), c.length;
        };
        function lN(c) {
          for (var p = c[0][0], x = c[1][0], M = c[0][1], C = c[1][1], L, P, E, F, G = Wl, W = G.length, $, ee, he, we, te, le; W--;) if ($ = G[W], !(!$ || !$.prepare())) for (he = $.edges, we = he.length, ee = 0; ee < we;) le = he[ee].end(), E = le.x, F = le.y, te = he[++ee % we].start(), L = te.x, P = te.y, (_(E - L) > oe || _(F - P) > oe) && (he.splice(ee, 0, new Oc(cN($.site, le, _(E - p) < oe && C - F > oe ? {
            x: p,
            y: _(L - p) < oe ? P : C
          } : _(F - C) < oe && x - E > oe ? {
            x: _(P - C) < oe ? L : x,
            y: C
          } : _(E - x) < oe && F - M > oe ? {
            x,
            y: _(L - x) < oe ? P : M
          } : _(F - M) < oe && E - p > oe ? {
            x: _(P - M) < oe ? L : p,
            y: M
          } : null), $.site, null)), ++we);
        }
        function j3(c, p) {
          return p.angle - c.angle;
        }
        function oN() {
          Bc(this), this.x = this.y = this.arc = this.site = this.cy = null;
        }
        function as(c) {
          var p = c.P,
            x = c.N;
          if (!(!p || !x)) {
            var M = p.site,
              C = c.site,
              L = x.site;
            if (M !== L) {
              var P = C.x,
                E = C.y,
                F = M.x - P,
                G = M.y - E,
                W = L.x - P,
                le = L.y - E,
                $ = 2 * (F * le - G * W);
              if (!($ >= -qe)) {
                var ee = F * F + G * G,
                  he = W * W + le * le,
                  we = (le * ee - G * he) / $,
                  te = (F * he - W * ee) / $,
                  le = te + E,
                  ue = J3.pop() || new oN();
                ue.arc = c, ue.site = C, ue.x = we + P, ue.y = le + Math.sqrt(we * we + te * te), ue.cy = le, c.circle = ue;
                for (var xe = null, Te = qu._; Te;) if (ue.y < Te.y || ue.y === Te.y && ue.x <= Te.x) {
                  if (Te.L) Te = Te.L;else {
                    xe = Te.P;
                    break;
                  }
                } else if (Te.R) Te = Te.R;else {
                  xe = Te;
                  break;
                }
                qu.insert(xe, ue), xe || (d1 = ue);
              }
            }
          }
        }
        function ns(c) {
          var p = c.circle;
          p && (p.P || (d1 = p.N), qu.remove(p), J3.push(p), Bc(p), c.circle = null);
        }
        function sN(c, p, x, M) {
          return function (C) {
            var L = C.a,
              P = C.b,
              E = L.x,
              F = L.y,
              G = P.x,
              W = P.y,
              $ = 0,
              ee = 1,
              he = G - E,
              we = W - F,
              te;
            if (te = c - E, !(!he && te > 0)) {
              if (te /= he, he < 0) {
                if (te < $) return;
                te < ee && (ee = te);
              } else if (he > 0) {
                if (te > ee) return;
                te > $ && ($ = te);
              }
              if (te = x - E, !(!he && te < 0)) {
                if (te /= he, he < 0) {
                  if (te > ee) return;
                  te > $ && ($ = te);
                } else if (he > 0) {
                  if (te < $) return;
                  te < ee && (ee = te);
                }
                if (te = p - F, !(!we && te > 0)) {
                  if (te /= we, we < 0) {
                    if (te < $) return;
                    te < ee && (ee = te);
                  } else if (we > 0) {
                    if (te > ee) return;
                    te > $ && ($ = te);
                  }
                  if (te = M - F, !(!we && te < 0)) {
                    if (te /= we, we < 0) {
                      if (te > ee) return;
                      te > $ && ($ = te);
                    } else if (we > 0) {
                      if (te < $) return;
                      te < ee && (ee = te);
                    }
                    return $ > 0 && (C.a = {
                      x: E + $ * he,
                      y: F + $ * we
                    }), ee < 1 && (C.b = {
                      x: E + ee * he,
                      y: F + ee * we
                    }), C;
                  }
                }
              }
            }
          };
        }
        function uN(c) {
          for (var p = rs, x = sN(c[0][0], c[0][1], c[1][0], c[1][1]), M = p.length, C; M--;) C = p[M], (!fN(C, c) || !x(C) || _(C.a.x - C.b.x) < oe && _(C.a.y - C.b.y) < oe) && (C.a = C.b = null, p.splice(M, 1));
        }
        function fN(c, p) {
          var x = c.b;
          if (x) return !0;
          var M = c.a,
            C = p[0][0],
            L = p[1][0],
            P = p[0][1],
            E = p[1][1],
            F = c.l,
            G = c.r,
            W = F.x,
            $ = F.y,
            ee = G.x,
            he = G.y,
            we = (W + ee) / 2,
            te = ($ + he) / 2,
            le,
            ue;
          if (he === $) {
            if (we < C || we >= L) return;
            if (W > ee) {
              if (!M) M = {
                x: we,
                y: P
              };else if (M.y >= E) return;
              x = {
                x: we,
                y: E
              };
            } else {
              if (!M) M = {
                x: we,
                y: E
              };else if (M.y < P) return;
              x = {
                x: we,
                y: P
              };
            }
          } else if (le = (W - ee) / (he - $), ue = te - le * we, le < -1 || le > 1) {
            if (W > ee) {
              if (!M) M = {
                x: (P - ue) / le,
                y: P
              };else if (M.y >= E) return;
              x = {
                x: (E - ue) / le,
                y: E
              };
            } else {
              if (!M) M = {
                x: (E - ue) / le,
                y: E
              };else if (M.y < P) return;
              x = {
                x: (P - ue) / le,
                y: P
              };
            }
          } else if ($ < he) {
            if (!M) M = {
              x: C,
              y: le * C + ue
            };else if (M.x >= L) return;
            x = {
              x: L,
              y: le * L + ue
            };
          } else {
            if (!M) M = {
              x: L,
              y: le * L + ue
            };else if (M.x < C) return;
            x = {
              x: C,
              y: le * C + ue
            };
          }
          return c.a = M, c.b = x, !0;
        }
        function e5(c, p) {
          this.l = c, this.r = p, this.a = this.b = null;
        }
        function Du(c, p, x, M) {
          var C = new e5(c, p);
          return rs.push(C), x && Hc(C, c, p, x), M && Hc(C, p, c, M), Wl[c.i].edges.push(new Oc(C, c, p)), Wl[p.i].edges.push(new Oc(C, p, c)), C;
        }
        function cN(c, p, x) {
          var M = new e5(c, null);
          return M.a = p, M.b = x, rs.push(M), M;
        }
        function Hc(c, p, x, M) {
          !c.a && !c.b ? (c.a = M, c.l = p, c.r = x) : c.l === x ? c.b = M : c.a = M;
        }
        function Oc(c, p, x) {
          var M = c.a,
            C = c.b;
          this.edge = c, this.site = p, this.angle = x ? Math.atan2(x.y - p.y, x.x - p.x) : c.l === p ? Math.atan2(C.x - M.x, M.y - C.y) : Math.atan2(M.x - C.x, C.y - M.y);
        }
        Oc.prototype = {
          start: function () {
            return this.edge.l === this.site ? this.edge.a : this.edge.b;
          },
          end: function () {
            return this.edge.l === this.site ? this.edge.b : this.edge.a;
          }
        };
        function m1() {
          this._ = null;
        }
        function Bc(c) {
          c.U = c.C = c.L = c.R = c.P = c.N = null;
        }
        m1.prototype = {
          insert: function (c, p) {
            var x, M, C;
            if (c) {
              if (p.P = c, p.N = c.N, c.N && (c.N.P = p), c.N = p, c.R) {
                for (c = c.R; c.L;) c = c.L;
                c.L = p;
              } else c.R = p;
              x = c;
            } else this._ ? (c = r5(this._), p.P = null, p.N = c, c.P = c.L = p, x = c) : (p.P = p.N = null, this._ = p, x = null);
            for (p.L = p.R = null, p.U = x, p.C = !0, c = p; x && x.C;) M = x.U, x === M.L ? (C = M.R, C && C.C ? (x.C = C.C = !1, M.C = !0, c = M) : (c === x.R && (Eu(this, x), c = x, x = c.U), x.C = !1, M.C = !0, Pu(this, M))) : (C = M.L, C && C.C ? (x.C = C.C = !1, M.C = !0, c = M) : (c === x.L && (Pu(this, x), c = x, x = c.U), x.C = !1, M.C = !0, Eu(this, M))), x = c.U;
            this._.C = !1;
          },
          remove: function (c) {
            c.N && (c.N.P = c.P), c.P && (c.P.N = c.N), c.N = c.P = null;
            var p = c.U,
              x,
              M = c.L,
              C = c.R,
              L,
              P;
            if (M ? C ? L = r5(C) : L = M : L = C, p ? p.L === c ? p.L = L : p.R = L : this._ = L, M && C ? (P = L.C, L.C = c.C, L.L = M, M.U = L, L !== C ? (p = L.U, L.U = c.U, c = L.R, p.L = c, L.R = C, C.U = L) : (L.U = p, p = L, c = L.R)) : (P = c.C, c = L), c && (c.U = p), !P) {
              if (c && c.C) {
                c.C = !1;
                return;
              }
              do {
                if (c === this._) break;
                if (c === p.L) {
                  if (x = p.R, x.C && (x.C = !1, p.C = !0, Eu(this, p), x = p.R), x.L && x.L.C || x.R && x.R.C) {
                    (!x.R || !x.R.C) && (x.L.C = !1, x.C = !0, Pu(this, x), x = p.R), x.C = p.C, p.C = x.R.C = !1, Eu(this, p), c = this._;
                    break;
                  }
                } else if (x = p.L, x.C && (x.C = !1, p.C = !0, Pu(this, p), x = p.L), x.L && x.L.C || x.R && x.R.C) {
                  (!x.L || !x.L.C) && (x.R.C = !1, x.C = !0, Eu(this, x), x = p.L), x.C = p.C, p.C = x.L.C = !1, Pu(this, p), c = this._;
                  break;
                }
                x.C = !0, c = p, p = p.U;
              } while (!c.C);
              c && (c.C = !1);
            }
          }
        };
        function Eu(c, p) {
          var x = p,
            M = p.R,
            C = x.U;
          C ? C.L === x ? C.L = M : C.R = M : c._ = M, M.U = C, x.U = M, x.R = M.L, x.R && (x.R.U = x), M.L = x;
        }
        function Pu(c, p) {
          var x = p,
            M = p.L,
            C = x.U;
          C ? C.L === x ? C.L = M : C.R = M : c._ = M, M.U = C, x.U = M, x.L = M.R, x.L && (x.L.U = x), M.R = x;
        }
        function r5(c) {
          for (; c.L;) c = c.L;
          return c;
        }
        function y1(c, p) {
          var x = c.sort(vN).pop(),
            M,
            C,
            L;
          for (rs = [], Wl = new Array(c.length), ts = new m1(), qu = new m1();;) if (L = d1, x && (!L || x.y < L.y || x.y === L.y && x.x < L.x)) (x.x !== M || x.y !== C) && (Wl[x.i] = new $3(x), nN(x), M = x.x, C = x.y), x = c.pop();else if (L) aN(L.arc);else break;
          p && (uN(p), lN(p));
          var P = {
            cells: Wl,
            edges: rs
          };
          return ts = qu = rs = Wl = null, P;
        }
        function vN(c, p) {
          return p.y - c.y || p.x - c.x;
        }
        e.geom.voronoi = function (c) {
          var p = es,
            x = Lu,
            M = p,
            C = x,
            L = Yc;
          if (c) return P(c);
          function P(F) {
            var G = new Array(F.length),
              W = L[0][0],
              $ = L[0][1],
              ee = L[1][0],
              he = L[1][1];
            return y1(E(F), L).cells.forEach(function (we, te) {
              var le = we.edges,
                ue = we.site,
                xe = G[te] = le.length ? le.map(function (Te) {
                  var ce = Te.start();
                  return [ce.x, ce.y];
                }) : ue.x >= W && ue.x <= ee && ue.y >= $ && ue.y <= he ? [[W, he], [ee, he], [ee, $], [W, $]] : [];
              xe.point = F[te];
            }), G;
          }
          function E(F) {
            return F.map(function (G, W) {
              return {
                x: Math.round(M(G, W) / oe) * oe,
                y: Math.round(C(G, W) / oe) * oe,
                i: W
              };
            });
          }
          return P.links = function (F) {
            return y1(E(F)).edges.filter(function (G) {
              return G.l && G.r;
            }).map(function (G) {
              return {
                source: F[G.l.i],
                target: F[G.r.i]
              };
            });
          }, P.triangles = function (F) {
            var G = [];
            return y1(E(F)).cells.forEach(function (W, $) {
              for (var ee = W.site, he = W.edges.sort(j3), we = -1, te = he.length, le, ue, xe = he[te - 1].edge, Te = xe.l === ee ? xe.r : xe.l; ++we < te;) le = xe, ue = Te, xe = he[we].edge, Te = xe.l === ee ? xe.r : xe.l, $ < ue.i && $ < Te.i && hN(ee, ue, Te) < 0 && G.push([F[$], F[ue.i], F[Te.i]]);
            }), G;
          }, P.x = function (F) {
            return arguments.length ? (M = Rr(p = F), P) : p;
          }, P.y = function (F) {
            return arguments.length ? (C = Rr(x = F), P) : x;
          }, P.clipExtent = function (F) {
            return arguments.length ? (L = F == null ? Yc : F, P) : L === Yc ? null : L;
          }, P.size = function (F) {
            return arguments.length ? P.clipExtent(F && [[0, 0], F]) : L === Yc ? null : L && L[1];
          }, P;
        };
        var Yc = [[-1e6, -1e6], [1e6, 1e6]];
        function hN(c, p, x) {
          return (c.x - x.x) * (p.y - c.y) - (c.x - p.x) * (x.y - c.y);
        }
        e.geom.delaunay = function (c) {
          return e.geom.voronoi().triangles(c);
        }, e.geom.quadtree = function (c, p, x, M, C) {
          var L = es,
            P = Lu,
            E;
          if (E = arguments.length) return L = dN, P = pN, E === 3 && (C = x, M = p, x = p = 0), F(c);
          function F(G) {
            var W,
              $ = Rr(L),
              ee = Rr(P),
              he,
              we,
              te,
              le,
              ue,
              xe,
              Te,
              ce;
            if (p != null) ue = p, xe = x, Te = M, ce = C;else if (Te = ce = -(ue = xe = 1 / 0), he = [], we = [], le = G.length, E) for (te = 0; te < le; ++te) W = G[te], W.x < ue && (ue = W.x), W.y < xe && (xe = W.y), W.x > Te && (Te = W.x), W.y > ce && (ce = W.y), he.push(W.x), we.push(W.y);else for (te = 0; te < le; ++te) {
              var Ge = +$(W = G[te], te),
                rr = +ee(W, te);
              Ge < ue && (ue = Ge), rr < xe && (xe = rr), Ge > Te && (Te = Ge), rr > ce && (ce = rr), he.push(Ge), we.push(rr);
            }
            var or = Te - ue,
              ar = ce - xe;
            or > ar ? ce = xe + or : Te = ue + ar;
            function hr(pr, Tr, Jr, Lt, rt, er, Lr, qr) {
              if (!(isNaN(Jr) || isNaN(Lt))) if (pr.leaf) {
                var Kr = pr.x,
                  _t = pr.y;
                if (Kr != null) {
                  if (_(Kr - Jr) + _(_t - Lt) < .01) dr(pr, Tr, Jr, Lt, rt, er, Lr, qr);else {
                    var Ot = pr.point;
                    pr.x = pr.y = pr.point = null, dr(pr, Ot, Kr, _t, rt, er, Lr, qr), dr(pr, Tr, Jr, Lt, rt, er, Lr, qr);
                  }
                } else pr.x = Jr, pr.y = Lt, pr.point = Tr;
              } else dr(pr, Tr, Jr, Lt, rt, er, Lr, qr);
            }
            function dr(pr, Tr, Jr, Lt, rt, er, Lr, qr) {
              var Kr = (rt + Lr) * .5,
                _t = (er + qr) * .5,
                Ot = Jr >= Kr,
                ca = Lt >= _t,
                La = ca << 1 | Ot;
              pr.leaf = !1, pr = pr.nodes[La] || (pr.nodes[La] = t5()), Ot ? rt = Kr : Lr = Kr, ca ? er = _t : qr = _t, hr(pr, Tr, Jr, Lt, rt, er, Lr, qr);
            }
            var Sr = t5();
            if (Sr.add = function (pr) {
              hr(Sr, pr, +$(pr, ++te), +ee(pr, te), ue, xe, Te, ce);
            }, Sr.visit = function (pr) {
              Ru(pr, Sr, ue, xe, Te, ce);
            }, Sr.find = function (pr) {
              return mN(Sr, pr[0], pr[1], ue, xe, Te, ce);
            }, te = -1, p == null) {
              for (; ++te < le;) hr(Sr, G[te], he[te], we[te], ue, xe, Te, ce);
              --te;
            } else G.forEach(Sr.add);
            return he = we = G = W = null, Sr;
          }
          return F.x = function (G) {
            return arguments.length ? (L = G, F) : L;
          }, F.y = function (G) {
            return arguments.length ? (P = G, F) : P;
          }, F.extent = function (G) {
            return arguments.length ? (G == null ? p = x = M = C = null : (p = +G[0][0], x = +G[0][1], M = +G[1][0], C = +G[1][1]), F) : p == null ? null : [[p, x], [M, C]];
          }, F.size = function (G) {
            return arguments.length ? (G == null ? p = x = M = C = null : (p = x = 0, M = +G[0], C = +G[1]), F) : p == null ? null : [M - p, C - x];
          }, F;
        };
        function dN(c) {
          return c.x;
        }
        function pN(c) {
          return c.y;
        }
        function t5() {
          return {
            leaf: !0,
            nodes: [],
            point: null,
            x: null,
            y: null
          };
        }
        function Ru(c, p, x, M, C, L) {
          if (!c(p, x, M, C, L)) {
            var P = (x + C) * .5,
              E = (M + L) * .5,
              F = p.nodes;
            F[0] && Ru(c, F[0], x, M, P, E), F[1] && Ru(c, F[1], P, M, C, E), F[2] && Ru(c, F[2], x, E, P, L), F[3] && Ru(c, F[3], P, E, C, L);
          }
        }
        function mN(c, p, x, M, C, L, P) {
          var E = 1 / 0,
            F;
          return function G(W, $, ee, he, we) {
            if (!($ > L || ee > P || he < M || we < C)) {
              if (te = W.point) {
                var te,
                  le = p - W.x,
                  ue = x - W.y,
                  xe = le * le + ue * ue;
                if (xe < E) {
                  var Te = Math.sqrt(E = xe);
                  M = p - Te, C = x - Te, L = p + Te, P = x + Te, F = te;
                }
              }
              for (var ce = W.nodes, Ge = ($ + he) * .5, rr = (ee + we) * .5, or = p >= Ge, ar = x >= rr, hr = ar << 1 | or, dr = hr + 4; hr < dr; ++hr) if (W = ce[hr & 3]) switch (hr & 3) {
                case 0:
                  G(W, $, ee, Ge, rr);
                  break;
                case 1:
                  G(W, Ge, ee, he, rr);
                  break;
                case 2:
                  G(W, $, rr, Ge, we);
                  break;
                case 3:
                  G(W, Ge, rr, he, we);
                  break;
              }
            }
          }(c, M, C, L, P), F;
        }
        e.interpolateRgb = g1;
        function g1(c, p) {
          c = e.rgb(c), p = e.rgb(p);
          var x = c.r,
            M = c.g,
            C = c.b,
            L = p.r - x,
            P = p.g - M,
            E = p.b - C;
          return function (F) {
            return "#" + mr(Math.round(x + L * F)) + mr(Math.round(M + P * F)) + mr(Math.round(C + E * F));
          };
        }
        e.interpolateObject = a5;
        function a5(c, p) {
          var x = {},
            M = {},
            C;
          for (C in c) C in p ? x[C] = Zl(c[C], p[C]) : M[C] = c[C];
          for (C in p) C in c || (M[C] = p[C]);
          return function (L) {
            for (C in x) M[C] = x[C](L);
            return M;
          };
        }
        e.interpolateNumber = Ri;
        function Ri(c, p) {
          return c = +c, p = +p, function (x) {
            return c * (1 - x) + p * x;
          };
        }
        e.interpolateString = n5;
        function n5(c, p) {
          var x = b1.lastIndex = x1.lastIndex = 0,
            M,
            C,
            L,
            P = -1,
            E = [],
            F = [];
          for (c = c + "", p = p + ""; (M = b1.exec(c)) && (C = x1.exec(p));) (L = C.index) > x && (L = p.slice(x, L), E[P] ? E[P] += L : E[++P] = L), (M = M[0]) === (C = C[0]) ? E[P] ? E[P] += C : E[++P] = C : (E[++P] = null, F.push({
            i: P,
            x: Ri(M, C)
          })), x = x1.lastIndex;
          return x < p.length && (L = p.slice(x), E[P] ? E[P] += L : E[++P] = L), E.length < 2 ? F[0] ? (p = F[0].x, function (G) {
            return p(G) + "";
          }) : function () {
            return p;
          } : (p = F.length, function (G) {
            for (var W = 0, $; W < p; ++W) E[($ = F[W]).i] = $.x(G);
            return E.join("");
          });
        }
        var b1 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
          x1 = new RegExp(b1.source, "g");
        e.interpolate = Zl;
        function Zl(c, p) {
          for (var x = e.interpolators.length, M; --x >= 0 && !(M = e.interpolators[x](c, p)););
          return M;
        }
        e.interpolators = [function (c, p) {
          var x = typeof p;
          return (x === "string" ? fa.has(p.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(p) ? g1 : n5 : p instanceof Tt ? g1 : Array.isArray(p) ? Uc : x === "object" && isNaN(p) ? a5 : Ri)(c, p);
        }], e.interpolateArray = Uc;
        function Uc(c, p) {
          var x = [],
            M = [],
            C = c.length,
            L = p.length,
            P = Math.min(c.length, p.length),
            E;
          for (E = 0; E < P; ++E) x.push(Zl(c[E], p[E]));
          for (; E < C; ++E) M[E] = c[E];
          for (; E < L; ++E) M[E] = p[E];
          return function (F) {
            for (E = 0; E < P; ++E) M[E] = x[E](F);
            return M;
          };
        }
        var i5 = function () {
            return J;
          },
          yN = e.map({
            linear: i5,
            poly: TN,
            quad: function () {
              return xN;
            },
            cubic: function () {
              return _N;
            },
            sin: function () {
              return MN;
            },
            exp: function () {
              return AN;
            },
            circle: function () {
              return kN;
            },
            elastic: CN,
            back: SN,
            bounce: function () {
              return LN;
            }
          }),
          gN = e.map({
            in: J,
            out: l5,
            "in-out": o5,
            "out-in": function (c) {
              return o5(l5(c));
            }
          });
        e.ease = function (c) {
          var p = c.indexOf("-"),
            x = p >= 0 ? c.slice(0, p) : c,
            M = p >= 0 ? c.slice(p + 1) : "in";
          return x = yN.get(x) || i5, M = gN.get(M) || J, bN(M(x.apply(null, r.call(arguments, 1))));
        };
        function bN(c) {
          return function (p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : c(p);
          };
        }
        function l5(c) {
          return function (p) {
            return 1 - c(1 - p);
          };
        }
        function o5(c) {
          return function (p) {
            return .5 * (p < .5 ? c(2 * p) : 2 - c(2 - 2 * p));
          };
        }
        function xN(c) {
          return c * c;
        }
        function _N(c) {
          return c * c * c;
        }
        function wN(c) {
          if (c <= 0) return 0;
          if (c >= 1) return 1;
          var p = c * c,
            x = p * c;
          return 4 * (c < .5 ? x : 3 * (c - p) + x - .75);
        }
        function TN(c) {
          return function (p) {
            return Math.pow(p, c);
          };
        }
        function MN(c) {
          return 1 - Math.cos(c * sr);
        }
        function AN(c) {
          return Math.pow(2, 10 * (c - 1));
        }
        function kN(c) {
          return 1 - Math.sqrt(1 - c * c);
        }
        function CN(c, p) {
          var x;
          return arguments.length < 2 && (p = .45), arguments.length ? x = p / ir * Math.asin(1 / c) : (c = 1, x = p / 4), function (M) {
            return 1 + c * Math.pow(2, -10 * M) * Math.sin((M - x) * ir / p);
          };
        }
        function SN(c) {
          return c || (c = 1.70158), function (p) {
            return p * p * ((c + 1) * p - c);
          };
        }
        function LN(c) {
          return c < 1 / 2.75 ? 7.5625 * c * c : c < 2 / 2.75 ? 7.5625 * (c -= 1.5 / 2.75) * c + .75 : c < 2.5 / 2.75 ? 7.5625 * (c -= 2.25 / 2.75) * c + .9375 : 7.5625 * (c -= 2.625 / 2.75) * c + .984375;
        }
        e.interpolateHcl = qN;
        function qN(c, p) {
          c = e.hcl(c), p = e.hcl(p);
          var x = c.h,
            M = c.c,
            C = c.l,
            L = p.h - x,
            P = p.c - M,
            E = p.l - C;
          return isNaN(P) && (P = 0, M = isNaN(M) ? p.c : M), isNaN(L) ? (L = 0, x = isNaN(x) ? p.h : x) : L > 180 ? L -= 360 : L < -180 && (L += 360), function (F) {
            return Hn(x + L * F, M + P * F, C + E * F) + "";
          };
        }
        e.interpolateHsl = DN;
        function DN(c, p) {
          c = e.hsl(c), p = e.hsl(p);
          var x = c.h,
            M = c.s,
            C = c.l,
            L = p.h - x,
            P = p.s - M,
            E = p.l - C;
          return isNaN(P) && (P = 0, M = isNaN(M) ? p.s : M), isNaN(L) ? (L = 0, x = isNaN(x) ? p.h : x) : L > 180 ? L -= 360 : L < -180 && (L += 360), function (F) {
            return Ca(x + L * F, M + P * F, C + E * F) + "";
          };
        }
        e.interpolateLab = EN;
        function EN(c, p) {
          c = e.lab(c), p = e.lab(p);
          var x = c.l,
            M = c.a,
            C = c.b,
            L = p.l - x,
            P = p.a - M,
            E = p.b - C;
          return function (F) {
            return qc(x + L * F, M + P * F, C + E * F) + "";
          };
        }
        e.interpolateRound = s5;
        function s5(c, p) {
          return p -= c, function (x) {
            return Math.round(c + p * x);
          };
        }
        e.transform = function (c) {
          var p = a.createElementNS(e.ns.prefix.svg, "g");
          return (e.transform = function (x) {
            if (x != null) {
              p.setAttribute("transform", x);
              var M = p.transform.baseVal.consolidate();
            }
            return new u5(M ? M.matrix : RN);
          })(c);
        };
        function u5(c) {
          var p = [c.a, c.b],
            x = [c.c, c.d],
            M = c5(p),
            C = f5(p, x),
            L = c5(PN(x, p, -C)) || 0;
          p[0] * x[1] < x[0] * p[1] && (p[0] *= -1, p[1] *= -1, M *= -1, C *= -1), this.rotate = (M ? Math.atan2(p[1], p[0]) : Math.atan2(-x[0], x[1])) * Ur, this.translate = [c.e, c.f], this.scale = [M, L], this.skew = L ? Math.atan2(C, L) * Ur : 0;
        }
        u5.prototype.toString = function () {
          return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
        };
        function f5(c, p) {
          return c[0] * p[0] + c[1] * p[1];
        }
        function c5(c) {
          var p = Math.sqrt(f5(c, c));
          return p && (c[0] /= p, c[1] /= p), p;
        }
        function PN(c, p, x) {
          return c[0] += x * p[0], c[1] += x * p[1], c;
        }
        var RN = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: 0,
          f: 0
        };
        e.interpolateTransform = v5;
        function is(c) {
          return c.length ? c.pop() + "," : "";
        }
        function zN(c, p, x, M) {
          if (c[0] !== p[0] || c[1] !== p[1]) {
            var C = x.push("translate(", null, ",", null, ")");
            M.push({
              i: C - 4,
              x: Ri(c[0], p[0])
            }, {
              i: C - 2,
              x: Ri(c[1], p[1])
            });
          } else (p[0] || p[1]) && x.push("translate(" + p + ")");
        }
        function NN(c, p, x, M) {
          c !== p ? (c - p > 180 ? p += 360 : p - c > 180 && (c += 360), M.push({
            i: x.push(is(x) + "rotate(", null, ")") - 2,
            x: Ri(c, p)
          })) : p && x.push(is(x) + "rotate(" + p + ")");
        }
        function FN(c, p, x, M) {
          c !== p ? M.push({
            i: x.push(is(x) + "skewX(", null, ")") - 2,
            x: Ri(c, p)
          }) : p && x.push(is(x) + "skewX(" + p + ")");
        }
        function IN(c, p, x, M) {
          if (c[0] !== p[0] || c[1] !== p[1]) {
            var C = x.push(is(x) + "scale(", null, ",", null, ")");
            M.push({
              i: C - 4,
              x: Ri(c[0], p[0])
            }, {
              i: C - 2,
              x: Ri(c[1], p[1])
            });
          } else (p[0] !== 1 || p[1] !== 1) && x.push(is(x) + "scale(" + p + ")");
        }
        function v5(c, p) {
          var x = [],
            M = [];
          return c = e.transform(c), p = e.transform(p), zN(c.translate, p.translate, x, M), NN(c.rotate, p.rotate, x, M), FN(c.skew, p.skew, x, M), IN(c.scale, p.scale, x, M), c = p = null, function (C) {
            for (var L = -1, P = M.length, E; ++L < P;) x[(E = M[L]).i] = E.x(C);
            return x.join("");
          };
        }
        function HN(c, p) {
          return p = (p -= c = +c) || 1 / p, function (x) {
            return (x - c) / p;
          };
        }
        function ON(c, p) {
          return p = (p -= c = +c) || 1 / p, function (x) {
            return Math.max(0, Math.min(1, (x - c) / p));
          };
        }
        e.layout = {}, e.layout.bundle = function () {
          return function (c) {
            for (var p = [], x = -1, M = c.length; ++x < M;) p.push(BN(c[x]));
            return p;
          };
        };
        function BN(c) {
          for (var p = c.source, x = c.target, M = YN(p, x), C = [p]; p !== M;) p = p.parent, C.push(p);
          for (var L = C.length; x !== M;) C.splice(L, 0, x), x = x.parent;
          return C;
        }
        function h5(c) {
          for (var p = [], x = c.parent; x != null;) p.push(c), c = x, x = x.parent;
          return p.push(c), p;
        }
        function YN(c, p) {
          if (c === p) return c;
          for (var x = h5(c), M = h5(p), C = x.pop(), L = M.pop(), P = null; C === L;) P = C, C = x.pop(), L = M.pop();
          return P;
        }
        e.layout.chord = function () {
          var c = {},
            p,
            x,
            M,
            C,
            L = 0,
            P,
            E,
            F;
          function G() {
            var $ = {},
              ee = [],
              he = e.range(C),
              we = [],
              te,
              le,
              ue,
              xe,
              Te;
            for (p = [], x = [], te = 0, xe = -1; ++xe < C;) {
              for (le = 0, Te = -1; ++Te < C;) le += M[xe][Te];
              ee.push(le), we.push(e.range(C)), te += le;
            }
            for (P && he.sort(function (Sr, pr) {
              return P(ee[Sr], ee[pr]);
            }), E && we.forEach(function (Sr, pr) {
              Sr.sort(function (Tr, Jr) {
                return E(M[pr][Tr], M[pr][Jr]);
              });
            }), te = (ir - L * C) / te, le = 0, xe = -1; ++xe < C;) {
              for (ue = le, Te = -1; ++Te < C;) {
                var ce = he[xe],
                  Ge = we[ce][Te],
                  rr = M[ce][Ge],
                  or = le,
                  ar = le += rr * te;
                $[ce + "-" + Ge] = {
                  index: ce,
                  subindex: Ge,
                  startAngle: or,
                  endAngle: ar,
                  value: rr
                };
              }
              x[ce] = {
                index: ce,
                startAngle: ue,
                endAngle: le,
                value: ee[ce]
              }, le += L;
            }
            for (xe = -1; ++xe < C;) for (Te = xe - 1; ++Te < C;) {
              var hr = $[xe + "-" + Te],
                dr = $[Te + "-" + xe];
              (hr.value || dr.value) && p.push(hr.value < dr.value ? {
                source: dr,
                target: hr
              } : {
                source: hr,
                target: dr
              });
            }
            F && W();
          }
          function W() {
            p.sort(function ($, ee) {
              return F(($.source.value + $.target.value) / 2, (ee.source.value + ee.target.value) / 2);
            });
          }
          return c.matrix = function ($) {
            return arguments.length ? (C = (M = $) && M.length, p = x = null, c) : M;
          }, c.padding = function ($) {
            return arguments.length ? (L = $, p = x = null, c) : L;
          }, c.sortGroups = function ($) {
            return arguments.length ? (P = $, p = x = null, c) : P;
          }, c.sortSubgroups = function ($) {
            return arguments.length ? (E = $, p = null, c) : E;
          }, c.sortChords = function ($) {
            return arguments.length ? (F = $, p && W(), c) : F;
          }, c.chords = function () {
            return p || G(), p;
          }, c.groups = function () {
            return x || G(), x;
          }, c;
        }, e.layout.force = function () {
          var c = {},
            p = e.dispatch("start", "tick", "end"),
            x,
            M = [1, 1],
            C,
            L,
            P = .9,
            E = ZN,
            F = XN,
            G = -30,
            W = JN,
            $ = .1,
            ee = .64,
            he = [],
            we = [],
            te,
            le,
            ue;
          function xe(ce) {
            return function (Ge, rr, or, ar) {
              if (Ge.point !== ce) {
                var hr = Ge.cx - ce.x,
                  dr = Ge.cy - ce.y,
                  Sr = ar - rr,
                  pr = hr * hr + dr * dr;
                if (Sr * Sr / ee < pr) {
                  if (pr < W) {
                    var Tr = Ge.charge / pr;
                    ce.px -= hr * Tr, ce.py -= dr * Tr;
                  }
                  return !0;
                }
                if (Ge.point && pr && pr < W) {
                  var Tr = Ge.pointCharge / pr;
                  ce.px -= hr * Tr, ce.py -= dr * Tr;
                }
              }
              return !Ge.charge;
            };
          }
          c.tick = function () {
            if ((L *= .99) < .005) return x = null, p.end({
              type: "end",
              alpha: L = 0
            }), !0;
            var ce = he.length,
              Ge = we.length,
              rr,
              or,
              ar,
              hr,
              dr,
              Sr,
              pr,
              Tr,
              Jr;
            for (or = 0; or < Ge; ++or) ar = we[or], hr = ar.source, dr = ar.target, Tr = dr.x - hr.x, Jr = dr.y - hr.y, (Sr = Tr * Tr + Jr * Jr) && (Sr = L * le[or] * ((Sr = Math.sqrt(Sr)) - te[or]) / Sr, Tr *= Sr, Jr *= Sr, dr.x -= Tr * (pr = hr.weight + dr.weight ? hr.weight / (hr.weight + dr.weight) : .5), dr.y -= Jr * pr, hr.x += Tr * (pr = 1 - pr), hr.y += Jr * pr);
            if ((pr = L * $) && (Tr = M[0] / 2, Jr = M[1] / 2, or = -1, pr)) for (; ++or < ce;) ar = he[or], ar.x += (Tr - ar.x) * pr, ar.y += (Jr - ar.y) * pr;
            if (G) for (d5(rr = e.geom.quadtree(he), L, ue), or = -1; ++or < ce;) (ar = he[or]).fixed || rr.visit(xe(ar));
            for (or = -1; ++or < ce;) ar = he[or], ar.fixed ? (ar.x = ar.px, ar.y = ar.py) : (ar.x -= (ar.px - (ar.px = ar.x)) * P, ar.y -= (ar.py - (ar.py = ar.y)) * P);
            p.tick({
              type: "tick",
              alpha: L
            });
          }, c.nodes = function (ce) {
            return arguments.length ? (he = ce, c) : he;
          }, c.links = function (ce) {
            return arguments.length ? (we = ce, c) : we;
          }, c.size = function (ce) {
            return arguments.length ? (M = ce, c) : M;
          }, c.linkDistance = function (ce) {
            return arguments.length ? (E = typeof ce == "function" ? ce : +ce, c) : E;
          }, c.distance = c.linkDistance, c.linkStrength = function (ce) {
            return arguments.length ? (F = typeof ce == "function" ? ce : +ce, c) : F;
          }, c.friction = function (ce) {
            return arguments.length ? (P = +ce, c) : P;
          }, c.charge = function (ce) {
            return arguments.length ? (G = typeof ce == "function" ? ce : +ce, c) : G;
          }, c.chargeDistance = function (ce) {
            return arguments.length ? (W = ce * ce, c) : Math.sqrt(W);
          }, c.gravity = function (ce) {
            return arguments.length ? ($ = +ce, c) : $;
          }, c.theta = function (ce) {
            return arguments.length ? (ee = ce * ce, c) : Math.sqrt(ee);
          }, c.alpha = function (ce) {
            return arguments.length ? (ce = +ce, L ? ce > 0 ? L = ce : (x.c = null, x.t = NaN, x = null, p.end({
              type: "end",
              alpha: L = 0
            })) : ce > 0 && (p.start({
              type: "start",
              alpha: L = ce
            }), x = Fc(c.tick)), c) : L;
          }, c.start = function () {
            var ce,
              Ge = he.length,
              rr = we.length,
              or = M[0],
              ar = M[1],
              hr,
              dr;
            for (ce = 0; ce < Ge; ++ce) (dr = he[ce]).index = ce, dr.weight = 0;
            for (ce = 0; ce < rr; ++ce) dr = we[ce], typeof dr.source == "number" && (dr.source = he[dr.source]), typeof dr.target == "number" && (dr.target = he[dr.target]), ++dr.source.weight, ++dr.target.weight;
            for (ce = 0; ce < Ge; ++ce) dr = he[ce], isNaN(dr.x) && (dr.x = Sr("x", or)), isNaN(dr.y) && (dr.y = Sr("y", ar)), isNaN(dr.px) && (dr.px = dr.x), isNaN(dr.py) && (dr.py = dr.y);
            if (te = [], typeof E == "function") for (ce = 0; ce < rr; ++ce) te[ce] = +E.call(this, we[ce], ce);else for (ce = 0; ce < rr; ++ce) te[ce] = E;
            if (le = [], typeof F == "function") for (ce = 0; ce < rr; ++ce) le[ce] = +F.call(this, we[ce], ce);else for (ce = 0; ce < rr; ++ce) le[ce] = F;
            if (ue = [], typeof G == "function") for (ce = 0; ce < Ge; ++ce) ue[ce] = +G.call(this, he[ce], ce);else for (ce = 0; ce < Ge; ++ce) ue[ce] = G;
            function Sr(pr, Tr) {
              if (!hr) {
                for (hr = new Array(Ge), rt = 0; rt < Ge; ++rt) hr[rt] = [];
                for (rt = 0; rt < rr; ++rt) {
                  var Jr = we[rt];
                  hr[Jr.source.index].push(Jr.target), hr[Jr.target.index].push(Jr.source);
                }
              }
              for (var Lt = hr[ce], rt = -1, er = Lt.length, Lr; ++rt < er;) if (!isNaN(Lr = Lt[rt][pr])) return Lr;
              return Math.random() * Tr;
            }
            return c.resume();
          }, c.resume = function () {
            return c.alpha(.1);
          }, c.stop = function () {
            return c.alpha(0);
          }, c.drag = function () {
            if (C || (C = e.behavior.drag().origin(J).on("dragstart.force", UN).on("drag.force", Te).on("dragend.force", GN)), !arguments.length) return C;
            this.on("mouseover.force", VN).on("mouseout.force", WN).call(C);
          };
          function Te(ce) {
            ce.px = e.event.x, ce.py = e.event.y, c.resume();
          }
          return e.rebind(c, p, "on");
        };
        function UN(c) {
          c.fixed |= 2;
        }
        function GN(c) {
          c.fixed &= -7;
        }
        function VN(c) {
          c.fixed |= 4, c.px = c.x, c.py = c.y;
        }
        function WN(c) {
          c.fixed &= -5;
        }
        function d5(c, p, x) {
          var M = 0,
            C = 0;
          if (c.charge = 0, !c.leaf) for (var L = c.nodes, P = L.length, E = -1, F; ++E < P;) F = L[E], F != null && (d5(F, p, x), c.charge += F.charge, M += F.charge * F.cx, C += F.charge * F.cy);
          if (c.point) {
            c.leaf || (c.point.x += Math.random() - .5, c.point.y += Math.random() - .5);
            var G = p * x[c.point.index];
            c.charge += c.pointCharge = G, M += G * c.point.x, C += G * c.point.y;
          }
          c.cx = M / c.charge, c.cy = C / c.charge;
        }
        var ZN = 20,
          XN = 1,
          JN = 1 / 0;
        e.layout.hierarchy = function () {
          var c = $N,
            p = KN,
            x = QN;
          function M(C) {
            var L = [C],
              P = [],
              E;
            for (C.depth = 0; (E = L.pop()) != null;) if (P.push(E), (G = p.call(M, E, E.depth)) && (F = G.length)) {
              for (var F, G, W; --F >= 0;) L.push(W = G[F]), W.parent = E, W.depth = E.depth + 1;
              x && (E.value = 0), E.children = G;
            } else x && (E.value = +x.call(M, E, E.depth) || 0), delete E.children;
            return ci(C, function ($) {
              var ee, he;
              c && (ee = $.children) && ee.sort(c), x && (he = $.parent) && (he.value += $.value);
            }), P;
          }
          return M.sort = function (C) {
            return arguments.length ? (c = C, M) : c;
          }, M.children = function (C) {
            return arguments.length ? (p = C, M) : p;
          }, M.value = function (C) {
            return arguments.length ? (x = C, M) : x;
          }, M.revalue = function (C) {
            return x && (Nu(C, function (L) {
              L.children && (L.value = 0);
            }), ci(C, function (L) {
              var P;
              L.children || (L.value = +x.call(M, L, L.depth) || 0), (P = L.parent) && (P.value += L.value);
            })), C;
          }, M;
        };
        function zu(c, p) {
          return e.rebind(c, p, "sort", "children", "value"), c.nodes = c, c.links = jN, c;
        }
        function Nu(c, p) {
          for (var x = [c]; (c = x.pop()) != null;) if (p(c), (C = c.children) && (M = C.length)) for (var M, C; --M >= 0;) x.push(C[M]);
        }
        function ci(c, p) {
          for (var x = [c], M = []; (c = x.pop()) != null;) if (M.push(c), (P = c.children) && (L = P.length)) for (var C = -1, L, P; ++C < L;) x.push(P[C]);
          for (; (c = M.pop()) != null;) p(c);
        }
        function KN(c) {
          return c.children;
        }
        function QN(c) {
          return c.value;
        }
        function $N(c, p) {
          return p.value - c.value;
        }
        function jN(c) {
          return e.merge(c.map(function (p) {
            return (p.children || []).map(function (x) {
              return {
                source: p,
                target: x
              };
            });
          }));
        }
        e.layout.partition = function () {
          var c = e.layout.hierarchy(),
            p = [1, 1];
          function x(L, P, E, F) {
            var G = L.children;
            if (L.x = P, L.y = L.depth * F, L.dx = E, L.dy = F, G && ($ = G.length)) {
              var W = -1,
                $,
                ee,
                he;
              for (E = L.value ? E / L.value : 0; ++W < $;) x(ee = G[W], P, he = ee.value * E, F), P += he;
            }
          }
          function M(L) {
            var P = L.children,
              E = 0;
            if (P && (G = P.length)) for (var F = -1, G; ++F < G;) E = Math.max(E, M(P[F]));
            return 1 + E;
          }
          function C(L, P) {
            var E = c.call(this, L, P);
            return x(E[0], 0, p[0], p[1] / M(E[0])), E;
          }
          return C.size = function (L) {
            return arguments.length ? (p = L, C) : p;
          }, zu(C, c);
        }, e.layout.pie = function () {
          var c = Number,
            p = p5,
            x = 0,
            M = ir,
            C = 0;
          function L(P) {
            var E = P.length,
              F = P.map(function (xe, Te) {
                return +c.call(L, xe, Te);
              }),
              G = +(typeof x == "function" ? x.apply(this, arguments) : x),
              W = (typeof M == "function" ? M.apply(this, arguments) : M) - G,
              $ = Math.min(Math.abs(W) / E, +(typeof C == "function" ? C.apply(this, arguments) : C)),
              ee = $ * (W < 0 ? -1 : 1),
              he = e.sum(F),
              we = he ? (W - E * ee) / he : 0,
              te = e.range(E),
              le = [],
              ue;
            return p != null && te.sort(p === p5 ? function (xe, Te) {
              return F[Te] - F[xe];
            } : function (xe, Te) {
              return p(P[xe], P[Te]);
            }), te.forEach(function (xe) {
              le[xe] = {
                data: P[xe],
                value: ue = F[xe],
                startAngle: G,
                endAngle: G += ue * we + ee,
                padAngle: $
              };
            }), le;
          }
          return L.value = function (P) {
            return arguments.length ? (c = P, L) : c;
          }, L.sort = function (P) {
            return arguments.length ? (p = P, L) : p;
          }, L.startAngle = function (P) {
            return arguments.length ? (x = P, L) : x;
          }, L.endAngle = function (P) {
            return arguments.length ? (M = P, L) : M;
          }, L.padAngle = function (P) {
            return arguments.length ? (C = P, L) : C;
          }, L;
        };
        var p5 = {};
        e.layout.stack = function () {
          var c = J,
            p = _1,
            x = w1,
            M = tF,
            C = eF,
            L = rF;
          function P(E, F) {
            if (!(we = E.length)) return E;
            var G = E.map(function (xe, Te) {
                return c.call(P, xe, Te);
              }),
              W = G.map(function (xe) {
                return xe.map(function (Te, ce) {
                  return [C.call(P, Te, ce), L.call(P, Te, ce)];
                });
              }),
              $ = p.call(P, W, F);
            G = e.permute(G, $), W = e.permute(W, $);
            var ee = x.call(P, W, F),
              he = G[0].length,
              we,
              te,
              le,
              ue;
            for (le = 0; le < he; ++le) for (M.call(P, G[0][le], ue = ee[le], W[0][le][1]), te = 1; te < we; ++te) M.call(P, G[te][le], ue += W[te - 1][le][1], W[te][le][1]);
            return E;
          }
          return P.values = function (E) {
            return arguments.length ? (c = E, P) : c;
          }, P.order = function (E) {
            return arguments.length ? (p = typeof E == "function" ? E : aF.get(E) || _1, P) : p;
          }, P.offset = function (E) {
            return arguments.length ? (x = typeof E == "function" ? E : nF.get(E) || w1, P) : x;
          }, P.x = function (E) {
            return arguments.length ? (C = E, P) : C;
          }, P.y = function (E) {
            return arguments.length ? (L = E, P) : L;
          }, P.out = function (E) {
            return arguments.length ? (M = E, P) : M;
          }, P;
        };
        function eF(c) {
          return c.x;
        }
        function rF(c) {
          return c.y;
        }
        function tF(c, p, x) {
          c.y0 = p, c.y = x;
        }
        var aF = e.map({
            "inside-out": function (c) {
              var p = c.length,
                x,
                M,
                C = c.map(iF),
                L = c.map(lF),
                P = e.range(p).sort(function ($, ee) {
                  return C[$] - C[ee];
                }),
                E = 0,
                F = 0,
                G = [],
                W = [];
              for (x = 0; x < p; ++x) M = P[x], E < F ? (E += L[M], G.push(M)) : (F += L[M], W.push(M));
              return W.reverse().concat(G);
            },
            reverse: function (c) {
              return e.range(c.length).reverse();
            },
            default: _1
          }),
          nF = e.map({
            silhouette: function (c) {
              var p = c.length,
                x = c[0].length,
                M = [],
                C = 0,
                L,
                P,
                E,
                F = [];
              for (P = 0; P < x; ++P) {
                for (L = 0, E = 0; L < p; L++) E += c[L][P][1];
                E > C && (C = E), M.push(E);
              }
              for (P = 0; P < x; ++P) F[P] = (C - M[P]) / 2;
              return F;
            },
            wiggle: function (c) {
              var p = c.length,
                x = c[0],
                M = x.length,
                C,
                L,
                P,
                E,
                F,
                G,
                W,
                $,
                ee,
                he = [];
              for (he[0] = $ = ee = 0, L = 1; L < M; ++L) {
                for (C = 0, E = 0; C < p; ++C) E += c[C][L][1];
                for (C = 0, F = 0, W = x[L][0] - x[L - 1][0]; C < p; ++C) {
                  for (P = 0, G = (c[C][L][1] - c[C][L - 1][1]) / (2 * W); P < C; ++P) G += (c[P][L][1] - c[P][L - 1][1]) / W;
                  F += G * c[C][L][1];
                }
                he[L] = $ -= E ? F / E * W : 0, $ < ee && (ee = $);
              }
              for (L = 0; L < M; ++L) he[L] -= ee;
              return he;
            },
            expand: function (c) {
              var p = c.length,
                x = c[0].length,
                M = 1 / p,
                C,
                L,
                P,
                E = [];
              for (L = 0; L < x; ++L) {
                for (C = 0, P = 0; C < p; C++) P += c[C][L][1];
                if (P) for (C = 0; C < p; C++) c[C][L][1] /= P;else for (C = 0; C < p; C++) c[C][L][1] = M;
              }
              for (L = 0; L < x; ++L) E[L] = 0;
              return E;
            },
            zero: w1
          });
        function _1(c) {
          return e.range(c.length);
        }
        function w1(c) {
          for (var p = -1, x = c[0].length, M = []; ++p < x;) M[p] = 0;
          return M;
        }
        function iF(c) {
          for (var p = 1, x = 0, M = c[0][1], C, L = c.length; p < L; ++p) (C = c[p][1]) > M && (x = p, M = C);
          return x;
        }
        function lF(c) {
          return c.reduce(oF, 0);
        }
        function oF(c, p) {
          return c + p[1];
        }
        e.layout.histogram = function () {
          var c = !0,
            p = Number,
            x = uF,
            M = sF;
          function C(L, ee) {
            for (var E = [], F = L.map(p, this), G = x.call(this, F, ee), W = M.call(this, G, F, ee), $, ee = -1, he = F.length, we = W.length - 1, te = c ? 1 : 1 / he, le; ++ee < we;) $ = E[ee] = [], $.dx = W[ee + 1] - ($.x = W[ee]), $.y = 0;
            if (we > 0) for (ee = -1; ++ee < he;) le = F[ee], le >= G[0] && le <= G[1] && ($ = E[e.bisect(W, le, 1, we) - 1], $.y += te, $.push(L[ee]));
            return E;
          }
          return C.value = function (L) {
            return arguments.length ? (p = L, C) : p;
          }, C.range = function (L) {
            return arguments.length ? (x = Rr(L), C) : x;
          }, C.bins = function (L) {
            return arguments.length ? (M = typeof L == "number" ? function (P) {
              return m5(P, L);
            } : Rr(L), C) : M;
          }, C.frequency = function (L) {
            return arguments.length ? (c = !!L, C) : c;
          }, C;
        };
        function sF(c, p) {
          return m5(c, Math.ceil(Math.log(p.length) / Math.LN2 + 1));
        }
        function m5(c, p) {
          for (var x = -1, M = +c[0], C = (c[1] - M) / p, L = []; ++x <= p;) L[x] = C * x + M;
          return L;
        }
        function uF(c) {
          return [e.min(c), e.max(c)];
        }
        e.layout.pack = function () {
          var c = e.layout.hierarchy().sort(fF),
            p = 0,
            x = [1, 1],
            M;
          function C(L, P) {
            var E = c.call(this, L, P),
              F = E[0],
              G = x[0],
              W = x[1],
              $ = M == null ? Math.sqrt : typeof M == "function" ? M : function () {
                return M;
              };
            if (F.x = F.y = 0, ci(F, function (he) {
              he.r = +$(he.value);
            }), ci(F, b5), p) {
              var ee = p * (M ? 1 : Math.max(2 * F.r / G, 2 * F.r / W)) / 2;
              ci(F, function (he) {
                he.r += ee;
              }), ci(F, b5), ci(F, function (he) {
                he.r -= ee;
              });
            }
            return x5(F, G / 2, W / 2, M ? 1 : 1 / Math.max(2 * F.r / G, 2 * F.r / W)), E;
          }
          return C.size = function (L) {
            return arguments.length ? (x = L, C) : x;
          }, C.radius = function (L) {
            return arguments.length ? (M = L == null || typeof L == "function" ? L : +L, C) : M;
          }, C.padding = function (L) {
            return arguments.length ? (p = +L, C) : p;
          }, zu(C, c);
        };
        function fF(c, p) {
          return c.value - p.value;
        }
        function T1(c, p) {
          var x = c._pack_next;
          c._pack_next = p, p._pack_prev = c, p._pack_next = x, x._pack_prev = p;
        }
        function y5(c, p) {
          c._pack_next = p, p._pack_prev = c;
        }
        function g5(c, p) {
          var x = p.x - c.x,
            M = p.y - c.y,
            C = c.r + p.r;
          return .999 * C * C > x * x + M * M;
        }
        function b5(c) {
          if (!(p = c.children) || !(ee = p.length)) return;
          var p,
            x = 1 / 0,
            M = -1 / 0,
            C = 1 / 0,
            L = -1 / 0,
            P,
            E,
            F,
            G,
            W,
            $,
            ee;
          function he(ce) {
            x = Math.min(ce.x - ce.r, x), M = Math.max(ce.x + ce.r, M), C = Math.min(ce.y - ce.r, C), L = Math.max(ce.y + ce.r, L);
          }
          if (p.forEach(cF), P = p[0], P.x = -P.r, P.y = 0, he(P), ee > 1 && (E = p[1], E.x = E.r, E.y = 0, he(E), ee > 2)) for (F = p[2], _5(P, E, F), he(F), T1(P, F), P._pack_prev = F, T1(F, E), E = P._pack_next, G = 3; G < ee; G++) {
            _5(P, E, F = p[G]);
            var we = 0,
              te = 1,
              le = 1;
            for (W = E._pack_next; W !== E; W = W._pack_next, te++) if (g5(W, F)) {
              we = 1;
              break;
            }
            if (we == 1) for ($ = P._pack_prev; $ !== W._pack_prev && !g5($, F); $ = $._pack_prev, le++);
            we ? (te < le || te == le && E.r < P.r ? y5(P, E = W) : y5(P = $, E), G--) : (T1(P, F), E = F, he(F));
          }
          var ue = (x + M) / 2,
            xe = (C + L) / 2,
            Te = 0;
          for (G = 0; G < ee; G++) F = p[G], F.x -= ue, F.y -= xe, Te = Math.max(Te, F.r + Math.sqrt(F.x * F.x + F.y * F.y));
          c.r = Te, p.forEach(vF);
        }
        function cF(c) {
          c._pack_next = c._pack_prev = c;
        }
        function vF(c) {
          delete c._pack_next, delete c._pack_prev;
        }
        function x5(c, p, x, M) {
          var C = c.children;
          if (c.x = p += M * c.x, c.y = x += M * c.y, c.r *= M, C) for (var L = -1, P = C.length; ++L < P;) x5(C[L], p, x, M);
        }
        function _5(c, p, x) {
          var M = c.r + x.r,
            C = p.x - c.x,
            L = p.y - c.y;
          if (M && (C || L)) {
            var P = p.r + x.r,
              E = C * C + L * L;
            P *= P, M *= M;
            var F = .5 + (M - P) / (2 * E),
              G = Math.sqrt(Math.max(0, 2 * P * (M + E) - (M -= E) * M - P * P)) / (2 * E);
            x.x = c.x + F * C + G * L, x.y = c.y + F * L - G * C;
          } else x.x = c.x + M, x.y = c.y;
        }
        e.layout.tree = function () {
          var c = e.layout.hierarchy().sort(null).value(null),
            p = w5,
            x = [1, 1],
            M = null;
          function C(W, $) {
            var ee = c.call(this, W, $),
              he = ee[0],
              we = L(he);
            if (ci(we, P), we.parent.m = -we.z, Nu(we, E), M) Nu(he, G);else {
              var te = he,
                le = he,
                ue = he;
              Nu(he, function (Ge) {
                Ge.x < te.x && (te = Ge), Ge.x > le.x && (le = Ge), Ge.depth > ue.depth && (ue = Ge);
              });
              var xe = p(te, le) / 2 - te.x,
                Te = x[0] / (le.x + p(le, te) / 2 + xe),
                ce = x[1] / (ue.depth || 1);
              Nu(he, function (Ge) {
                Ge.x = (Ge.x + xe) * Te, Ge.y = Ge.depth * ce;
              });
            }
            return ee;
          }
          function L(W) {
            for (var $ = {
                A: null,
                children: [W]
              }, ee = [$], he; (he = ee.pop()) != null;) for (var we = he.children, te, le = 0, ue = we.length; le < ue; ++le) ee.push((we[le] = te = {
              _: we[le],
              parent: he,
              children: (te = we[le].children) && te.slice() || [],
              A: null,
              a: null,
              z: 0,
              m: 0,
              c: 0,
              s: 0,
              t: null,
              i: le
            }).a = te);
            return $.children[0];
          }
          function P(W) {
            var $ = W.children,
              ee = W.parent.children,
              he = W.i ? ee[W.i - 1] : null;
            if ($.length) {
              dF(W);
              var we = ($[0].z + $[$.length - 1].z) / 2;
              he ? (W.z = he.z + p(W._, he._), W.m = W.z - we) : W.z = we;
            } else he && (W.z = he.z + p(W._, he._));
            W.parent.A = F(W, he, W.parent.A || ee[0]);
          }
          function E(W) {
            W._.x = W.z + W.parent.m, W.m += W.parent.m;
          }
          function F(W, $, ee) {
            if ($) {
              for (var he = W, we = W, te = $, le = he.parent.children[0], ue = he.m, xe = we.m, Te = te.m, ce = le.m, Ge; te = A1(te), he = M1(he), te && he;) le = M1(le), we = A1(we), we.a = W, Ge = te.z + Te - he.z - ue + p(te._, he._), Ge > 0 && (hF(pF(te, W, ee), W, Ge), ue += Ge, xe += Ge), Te += te.m, ue += he.m, ce += le.m, xe += we.m;
              te && !A1(we) && (we.t = te, we.m += Te - xe), he && !M1(le) && (le.t = he, le.m += ue - ce, ee = W);
            }
            return ee;
          }
          function G(W) {
            W.x *= x[0], W.y = W.depth * x[1];
          }
          return C.separation = function (W) {
            return arguments.length ? (p = W, C) : p;
          }, C.size = function (W) {
            return arguments.length ? (M = (x = W) == null ? G : null, C) : M ? null : x;
          }, C.nodeSize = function (W) {
            return arguments.length ? (M = (x = W) == null ? null : G, C) : M ? x : null;
          }, zu(C, c);
        };
        function w5(c, p) {
          return c.parent == p.parent ? 1 : 2;
        }
        function M1(c) {
          var p = c.children;
          return p.length ? p[0] : c.t;
        }
        function A1(c) {
          var p = c.children,
            x;
          return (x = p.length) ? p[x - 1] : c.t;
        }
        function hF(c, p, x) {
          var M = x / (p.i - c.i);
          p.c -= M, p.s += x, c.c += M, p.z += x, p.m += x;
        }
        function dF(c) {
          for (var p = 0, x = 0, M = c.children, C = M.length, L; --C >= 0;) L = M[C], L.z += p, L.m += p, p += L.s + (x += L.c);
        }
        function pF(c, p, x) {
          return c.a.parent === p.parent ? c.a : x;
        }
        e.layout.cluster = function () {
          var c = e.layout.hierarchy().sort(null).value(null),
            p = w5,
            x = [1, 1],
            M = !1;
          function C(L, P) {
            var E = c.call(this, L, P),
              F = E[0],
              G,
              W = 0;
            ci(F, function (te) {
              var le = te.children;
              le && le.length ? (te.x = yF(le), te.y = mF(le)) : (te.x = G ? W += p(te, G) : 0, te.y = 0, G = te);
            });
            var $ = T5(F),
              ee = M5(F),
              he = $.x - p($, ee) / 2,
              we = ee.x + p(ee, $) / 2;
            return ci(F, M ? function (te) {
              te.x = (te.x - F.x) * x[0], te.y = (F.y - te.y) * x[1];
            } : function (te) {
              te.x = (te.x - he) / (we - he) * x[0], te.y = (1 - (F.y ? te.y / F.y : 1)) * x[1];
            }), E;
          }
          return C.separation = function (L) {
            return arguments.length ? (p = L, C) : p;
          }, C.size = function (L) {
            return arguments.length ? (M = (x = L) == null, C) : M ? null : x;
          }, C.nodeSize = function (L) {
            return arguments.length ? (M = (x = L) != null, C) : M ? x : null;
          }, zu(C, c);
        };
        function mF(c) {
          return 1 + e.max(c, function (p) {
            return p.y;
          });
        }
        function yF(c) {
          return c.reduce(function (p, x) {
            return p + x.x;
          }, 0) / c.length;
        }
        function T5(c) {
          var p = c.children;
          return p && p.length ? T5(p[0]) : c;
        }
        function M5(c) {
          var p = c.children,
            x;
          return p && (x = p.length) ? M5(p[x - 1]) : c;
        }
        e.layout.treemap = function () {
          var c = e.layout.hierarchy(),
            p = Math.round,
            x = [1, 1],
            M = null,
            C = k1,
            L = !1,
            P,
            E = "squarify",
            F = .5 * (1 + Math.sqrt(5));
          function G(te, le) {
            for (var ue = -1, xe = te.length, Te, ce; ++ue < xe;) ce = (Te = te[ue]).value * (le < 0 ? 0 : le), Te.area = isNaN(ce) || ce <= 0 ? 0 : ce;
          }
          function W(te) {
            var le = te.children;
            if (le && le.length) {
              var ue = C(te),
                xe = [],
                Te = le.slice(),
                ce,
                Ge = 1 / 0,
                rr,
                or = E === "slice" ? ue.dx : E === "dice" ? ue.dy : E === "slice-dice" ? te.depth & 1 ? ue.dy : ue.dx : Math.min(ue.dx, ue.dy),
                ar;
              for (G(Te, ue.dx * ue.dy / te.value), xe.area = 0; (ar = Te.length) > 0;) xe.push(ce = Te[ar - 1]), xe.area += ce.area, E !== "squarify" || (rr = ee(xe, or)) <= Ge ? (Te.pop(), Ge = rr) : (xe.area -= xe.pop().area, he(xe, or, ue, !1), or = Math.min(ue.dx, ue.dy), xe.length = xe.area = 0, Ge = 1 / 0);
              xe.length && (he(xe, or, ue, !0), xe.length = xe.area = 0), le.forEach(W);
            }
          }
          function $(te) {
            var le = te.children;
            if (le && le.length) {
              var ue = C(te),
                xe = le.slice(),
                Te,
                ce = [];
              for (G(xe, ue.dx * ue.dy / te.value), ce.area = 0; Te = xe.pop();) ce.push(Te), ce.area += Te.area, Te.z != null && (he(ce, Te.z ? ue.dx : ue.dy, ue, !xe.length), ce.length = ce.area = 0);
              le.forEach($);
            }
          }
          function ee(te, le) {
            for (var ue = te.area, xe, Te = 0, ce = 1 / 0, Ge = -1, rr = te.length; ++Ge < rr;) (xe = te[Ge].area) && (xe < ce && (ce = xe), xe > Te && (Te = xe));
            return ue *= ue, le *= le, ue ? Math.max(le * Te * F / ue, ue / (le * ce * F)) : 1 / 0;
          }
          function he(te, le, ue, xe) {
            var Te = -1,
              ce = te.length,
              Ge = ue.x,
              rr = ue.y,
              or = le ? p(te.area / le) : 0,
              ar;
            if (le == ue.dx) {
              for ((xe || or > ue.dy) && (or = ue.dy); ++Te < ce;) ar = te[Te], ar.x = Ge, ar.y = rr, ar.dy = or, Ge += ar.dx = Math.min(ue.x + ue.dx - Ge, or ? p(ar.area / or) : 0);
              ar.z = !0, ar.dx += ue.x + ue.dx - Ge, ue.y += or, ue.dy -= or;
            } else {
              for ((xe || or > ue.dx) && (or = ue.dx); ++Te < ce;) ar = te[Te], ar.x = Ge, ar.y = rr, ar.dx = or, rr += ar.dy = Math.min(ue.y + ue.dy - rr, or ? p(ar.area / or) : 0);
              ar.z = !1, ar.dy += ue.y + ue.dy - rr, ue.x += or, ue.dx -= or;
            }
          }
          function we(te) {
            var le = P || c(te),
              ue = le[0];
            return ue.x = ue.y = 0, ue.value ? (ue.dx = x[0], ue.dy = x[1]) : ue.dx = ue.dy = 0, P && c.revalue(ue), G([ue], ue.dx * ue.dy / ue.value), (P ? $ : W)(ue), L && (P = le), le;
          }
          return we.size = function (te) {
            return arguments.length ? (x = te, we) : x;
          }, we.padding = function (te) {
            if (!arguments.length) return M;
            function le(Te) {
              var ce = te.call(we, Te, Te.depth);
              return ce == null ? k1(Te) : A5(Te, typeof ce == "number" ? [ce, ce, ce, ce] : ce);
            }
            function ue(Te) {
              return A5(Te, te);
            }
            var xe;
            return C = (M = te) == null ? k1 : (xe = typeof te) == "function" ? le : (xe === "number" && (te = [te, te, te, te]), ue), we;
          }, we.round = function (te) {
            return arguments.length ? (p = te ? Math.round : Number, we) : p != Number;
          }, we.sticky = function (te) {
            return arguments.length ? (L = te, P = null, we) : L;
          }, we.ratio = function (te) {
            return arguments.length ? (F = te, we) : F;
          }, we.mode = function (te) {
            return arguments.length ? (E = te + "", we) : E;
          }, zu(we, c);
        };
        function k1(c) {
          return {
            x: c.x,
            y: c.y,
            dx: c.dx,
            dy: c.dy
          };
        }
        function A5(c, p) {
          var x = c.x + p[3],
            M = c.y + p[0],
            C = c.dx - p[1] - p[3],
            L = c.dy - p[0] - p[2];
          return C < 0 && (x += C / 2, C = 0), L < 0 && (M += L / 2, L = 0), {
            x,
            y: M,
            dx: C,
            dy: L
          };
        }
        e.random = {
          normal: function (c, p) {
            var x = arguments.length;
            return x < 2 && (p = 1), x < 1 && (c = 0), function () {
              var M, C, L;
              do M = Math.random() * 2 - 1, C = Math.random() * 2 - 1, L = M * M + C * C; while (!L || L > 1);
              return c + p * M * Math.sqrt(-2 * Math.log(L) / L);
            };
          },
          logNormal: function () {
            var c = e.random.normal.apply(e, arguments);
            return function () {
              return Math.exp(c());
            };
          },
          bates: function (c) {
            var p = e.random.irwinHall(c);
            return function () {
              return p() / c;
            };
          },
          irwinHall: function (c) {
            return function () {
              for (var p = 0, x = 0; x < c; x++) p += Math.random();
              return p;
            };
          }
        }, e.scale = {};
        function Gc(c) {
          var p = c[0],
            x = c[c.length - 1];
          return p < x ? [p, x] : [x, p];
        }
        function Vc(c) {
          return c.rangeExtent ? c.rangeExtent() : Gc(c.range());
        }
        function gF(c, p, x, M) {
          var C = x(c[0], c[1]),
            L = M(p[0], p[1]);
          return function (P) {
            return L(C(P));
          };
        }
        function C1(c, p) {
          var x = 0,
            M = c.length - 1,
            C = c[x],
            L = c[M],
            P;
          return L < C && (P = x, x = M, M = P, P = C, C = L, L = P), c[x] = p.floor(C), c[M] = p.ceil(L), c;
        }
        function k5(c) {
          return c ? {
            floor: function (p) {
              return Math.floor(p / c) * c;
            },
            ceil: function (p) {
              return Math.ceil(p / c) * c;
            }
          } : bF;
        }
        var bF = {
          floor: J,
          ceil: J
        };
        function xF(c, p, x, M) {
          var C = [],
            L = [],
            P = 0,
            E = Math.min(c.length, p.length) - 1;
          for (c[E] < c[0] && (c = c.slice().reverse(), p = p.slice().reverse()); ++P <= E;) C.push(x(c[P - 1], c[P])), L.push(M(p[P - 1], p[P]));
          return function (F) {
            var G = e.bisect(c, F, 1, E) - 1;
            return L[G](C[G](F));
          };
        }
        e.scale.linear = function () {
          return C5([0, 1], [0, 1], Zl, !1);
        };
        function C5(c, p, x, M) {
          var C, L;
          function P() {
            var F = Math.min(c.length, p.length) > 2 ? xF : gF,
              G = M ? ON : HN;
            return C = F(c, p, G, x), L = F(p, c, G, Zl), E;
          }
          function E(F) {
            return C(F);
          }
          return E.invert = function (F) {
            return L(F);
          }, E.domain = function (F) {
            return arguments.length ? (c = F.map(Number), P()) : c;
          }, E.range = function (F) {
            return arguments.length ? (p = F, P()) : p;
          }, E.rangeRound = function (F) {
            return E.range(F).interpolate(s5);
          }, E.clamp = function (F) {
            return arguments.length ? (M = F, P()) : M;
          }, E.interpolate = function (F) {
            return arguments.length ? (x = F, P()) : x;
          }, E.ticks = function (F) {
            return L1(c, F);
          }, E.tickFormat = function (F, G) {
            return d3_scale_linearTickFormat(c, F, G);
          }, E.nice = function (F) {
            return L5(c, F), P();
          }, E.copy = function () {
            return C5(c, p, x, M);
          }, P();
        }
        function S5(c, p) {
          return e.rebind(c, p, "range", "rangeRound", "interpolate", "clamp");
        }
        function L5(c, p) {
          return C1(c, k5(S1(c, p)[2])), C1(c, k5(S1(c, p)[2])), c;
        }
        function S1(c, p) {
          p == null && (p = 10);
          var x = Gc(c),
            M = x[1] - x[0],
            C = Math.pow(10, Math.floor(Math.log(M / p) / Math.LN10)),
            L = p / M * C;
          return L <= .15 ? C *= 10 : L <= .35 ? C *= 5 : L <= .75 && (C *= 2), x[0] = Math.ceil(x[0] / C) * C, x[1] = Math.floor(x[1] / C) * C + C * .5, x[2] = C, x;
        }
        function L1(c, p) {
          return e.range.apply(e, S1(c, p));
        }
        var _F = {
          s: 1,
          g: 1,
          p: 1,
          r: 1,
          e: 1
        };
        function q5(c) {
          return -Math.floor(Math.log(c) / Math.LN10 + .01);
        }
        function nie(c, p) {
          var x = q5(p[2]);
          return c in _F ? Math.abs(x - q5(Math.max(_(p[0]), _(p[1])))) + +(c !== "e") : x - (c === "%") * 2;
        }
        e.scale.log = function () {
          return D5(e.scale.linear().domain([0, 1]), 10, !0, [1, 10]);
        };
        function D5(c, p, x, M) {
          function C(E) {
            return (x ? Math.log(E < 0 ? 0 : E) : -Math.log(E > 0 ? 0 : -E)) / Math.log(p);
          }
          function L(E) {
            return x ? Math.pow(p, E) : -Math.pow(p, -E);
          }
          function P(E) {
            return c(C(E));
          }
          return P.invert = function (E) {
            return L(c.invert(E));
          }, P.domain = function (E) {
            return arguments.length ? (x = E[0] >= 0, c.domain((M = E.map(Number)).map(C)), P) : M;
          }, P.base = function (E) {
            return arguments.length ? (p = +E, c.domain(M.map(C)), P) : p;
          }, P.nice = function () {
            var E = C1(M.map(C), x ? Math : wF);
            return c.domain(E), M = E.map(L), P;
          }, P.ticks = function () {
            var E = Gc(M),
              F = [],
              G = E[0],
              W = E[1],
              $ = Math.floor(C(G)),
              ee = Math.ceil(C(W)),
              he = p % 1 ? 2 : p;
            if (isFinite(ee - $)) {
              if (x) {
                for (; $ < ee; $++) for (var we = 1; we < he; we++) F.push(L($) * we);
                F.push(L($));
              } else for (F.push(L($)); $++ < ee;) for (var we = he - 1; we > 0; we--) F.push(L($) * we);
              for ($ = 0; F[$] < G; $++);
              for (ee = F.length; F[ee - 1] > W; ee--);
              F = F.slice($, ee);
            }
            return F;
          }, P.copy = function () {
            return D5(c.copy(), p, x, M);
          }, S5(P, c);
        }
        var wF = {
          floor: function (c) {
            return -Math.ceil(-c);
          },
          ceil: function (c) {
            return -Math.floor(-c);
          }
        };
        e.scale.pow = function () {
          return E5(e.scale.linear(), 1, [0, 1]);
        };
        function E5(c, p, x) {
          var M = Wc(p),
            C = Wc(1 / p);
          function L(P) {
            return c(M(P));
          }
          return L.invert = function (P) {
            return C(c.invert(P));
          }, L.domain = function (P) {
            return arguments.length ? (c.domain((x = P.map(Number)).map(M)), L) : x;
          }, L.ticks = function (P) {
            return L1(x, P);
          }, L.tickFormat = function (P, E) {
            return d3_scale_linearTickFormat(x, P, E);
          }, L.nice = function (P) {
            return L.domain(L5(x, P));
          }, L.exponent = function (P) {
            return arguments.length ? (M = Wc(p = P), C = Wc(1 / p), c.domain(x.map(M)), L) : p;
          }, L.copy = function () {
            return E5(c.copy(), p, x);
          }, S5(L, c);
        }
        function Wc(c) {
          return function (p) {
            return p < 0 ? -Math.pow(-p, c) : Math.pow(p, c);
          };
        }
        e.scale.sqrt = function () {
          return e.scale.pow().exponent(.5);
        }, e.scale.ordinal = function () {
          return P5([], {
            t: "range",
            a: [[]]
          });
        };
        function P5(c, p) {
          var x, M, C;
          function L(E) {
            return M[((x.get(E) || (p.t === "range" ? x.set(E, c.push(E)) : NaN)) - 1) % M.length];
          }
          function P(E, F) {
            return e.range(c.length).map(function (G) {
              return E + F * G;
            });
          }
          return L.domain = function (E) {
            if (!arguments.length) return c;
            c = [], x = new b();
            for (var F = -1, G = E.length, W; ++F < G;) x.has(W = E[F]) || x.set(W, c.push(W));
            return L[p.t].apply(L, p.a);
          }, L.range = function (E) {
            return arguments.length ? (M = E, C = 0, p = {
              t: "range",
              a: arguments
            }, L) : M;
          }, L.rangePoints = function (E, F) {
            arguments.length < 2 && (F = 0);
            var G = E[0],
              W = E[1],
              $ = c.length < 2 ? (G = (G + W) / 2, 0) : (W - G) / (c.length - 1 + F);
            return M = P(G + $ * F / 2, $), C = 0, p = {
              t: "rangePoints",
              a: arguments
            }, L;
          }, L.rangeRoundPoints = function (E, F) {
            arguments.length < 2 && (F = 0);
            var G = E[0],
              W = E[1],
              $ = c.length < 2 ? (G = W = Math.round((G + W) / 2), 0) : (W - G) / (c.length - 1 + F) | 0;
            return M = P(G + Math.round($ * F / 2 + (W - G - (c.length - 1 + F) * $) / 2), $), C = 0, p = {
              t: "rangeRoundPoints",
              a: arguments
            }, L;
          }, L.rangeBands = function (E, F, G) {
            arguments.length < 2 && (F = 0), arguments.length < 3 && (G = F);
            var W = E[1] < E[0],
              $ = E[W - 0],
              ee = E[1 - W],
              he = (ee - $) / (c.length - F + 2 * G);
            return M = P($ + he * G, he), W && M.reverse(), C = he * (1 - F), p = {
              t: "rangeBands",
              a: arguments
            }, L;
          }, L.rangeRoundBands = function (E, F, G) {
            arguments.length < 2 && (F = 0), arguments.length < 3 && (G = F);
            var W = E[1] < E[0],
              $ = E[W - 0],
              ee = E[1 - W],
              he = Math.floor((ee - $) / (c.length - F + 2 * G));
            return M = P($ + Math.round((ee - $ - (c.length - F) * he) / 2), he), W && M.reverse(), C = Math.round(he * (1 - F)), p = {
              t: "rangeRoundBands",
              a: arguments
            }, L;
          }, L.rangeBand = function () {
            return C;
          }, L.rangeExtent = function () {
            return Gc(p.a[0]);
          }, L.copy = function () {
            return P5(c, p);
          }, L.domain(c);
        }
        e.scale.category10 = function () {
          return e.scale.ordinal().range(TF);
        }, e.scale.category20 = function () {
          return e.scale.ordinal().range(MF);
        }, e.scale.category20b = function () {
          return e.scale.ordinal().range(AF);
        }, e.scale.category20c = function () {
          return e.scale.ordinal().range(kF);
        };
        var TF = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map($o),
          MF = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map($o),
          AF = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map($o),
          kF = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map($o);
        e.scale.quantile = function () {
          return R5([], []);
        };
        function R5(c, p) {
          var x;
          function M() {
            var L = 0,
              P = p.length;
            for (x = []; ++L < P;) x[L - 1] = e.quantile(c, L / P);
            return C;
          }
          function C(L) {
            if (!isNaN(L = +L)) return p[e.bisect(x, L)];
          }
          return C.domain = function (L) {
            return arguments.length ? (c = L.map(h).filter(d).sort(v), M()) : c;
          }, C.range = function (L) {
            return arguments.length ? (p = L, M()) : p;
          }, C.quantiles = function () {
            return x;
          }, C.invertExtent = function (L) {
            return L = p.indexOf(L), L < 0 ? [NaN, NaN] : [L > 0 ? x[L - 1] : c[0], L < x.length ? x[L] : c[c.length - 1]];
          }, C.copy = function () {
            return R5(c, p);
          }, M();
        }
        e.scale.quantize = function () {
          return z5(0, 1, [0, 1]);
        };
        function z5(c, p, x) {
          var M, C;
          function L(E) {
            return x[Math.max(0, Math.min(C, Math.floor(M * (E - c))))];
          }
          function P() {
            return M = x.length / (p - c), C = x.length - 1, L;
          }
          return L.domain = function (E) {
            return arguments.length ? (c = +E[0], p = +E[E.length - 1], P()) : [c, p];
          }, L.range = function (E) {
            return arguments.length ? (x = E, P()) : x;
          }, L.invertExtent = function (E) {
            return E = x.indexOf(E), E = E < 0 ? NaN : E / M + c, [E, E + 1 / M];
          }, L.copy = function () {
            return z5(c, p, x);
          }, P();
        }
        e.scale.threshold = function () {
          return N5([.5], [0, 1]);
        };
        function N5(c, p) {
          function x(M) {
            if (M <= M) return p[e.bisect(c, M)];
          }
          return x.domain = function (M) {
            return arguments.length ? (c = M, x) : c;
          }, x.range = function (M) {
            return arguments.length ? (p = M, x) : p;
          }, x.invertExtent = function (M) {
            return M = p.indexOf(M), [c[M - 1], c[M]];
          }, x.copy = function () {
            return N5(c, p);
          }, x;
        }
        e.scale.identity = function () {
          return F5([0, 1]);
        };
        function F5(c) {
          function p(x) {
            return +x;
          }
          return p.invert = p, p.domain = p.range = function (x) {
            return arguments.length ? (c = x.map(p), p) : c;
          }, p.ticks = function (x) {
            return L1(c, x);
          }, p.tickFormat = function (x, M) {
            return d3_scale_linearTickFormat(c, x, M);
          }, p.copy = function () {
            return F5(c);
          }, p;
        }
        e.svg = {};
        function CF() {
          return 0;
        }
        e.svg.arc = function () {
          var c = SF,
            p = LF,
            x = CF,
            M = Zc,
            C = I5,
            L = H5,
            P = qF;
          function E() {
            var G = Math.max(0, +c.apply(this, arguments)),
              W = Math.max(0, +p.apply(this, arguments)),
              $ = C.apply(this, arguments) - sr,
              ee = L.apply(this, arguments) - sr,
              he = Math.abs(ee - $),
              we = $ > ee ? 0 : 1;
            if (W < G && (te = W, W = G, G = te), he >= vr) return F(W, we) + (G ? F(G, 1 - we) : "") + "Z";
            var te,
              le,
              ue,
              xe,
              Te = 0,
              ce = 0,
              Ge,
              rr,
              or,
              ar,
              hr,
              dr,
              Sr,
              pr,
              Tr = [];
            if ((xe = (+P.apply(this, arguments) || 0) / 2) && (ue = M === Zc ? Math.sqrt(G * G + W * W) : +M.apply(this, arguments), we || (ce *= -1), W && (ce = ea(ue / W * Math.sin(xe))), G && (Te = ea(ue / G * Math.sin(xe)))), W) {
              Ge = W * Math.cos($ + ce), rr = W * Math.sin($ + ce), or = W * Math.cos(ee - ce), ar = W * Math.sin(ee - ce);
              var Jr = Math.abs(ee - $ - 2 * ce) <= ke ? 0 : 1;
              if (ce && Xc(Ge, rr, or, ar) === we ^ Jr) {
                var Lt = ($ + ee) / 2;
                Ge = W * Math.cos(Lt), rr = W * Math.sin(Lt), or = ar = null;
              }
            } else Ge = rr = 0;
            if (G) {
              hr = G * Math.cos(ee - Te), dr = G * Math.sin(ee - Te), Sr = G * Math.cos($ + Te), pr = G * Math.sin($ + Te);
              var rt = Math.abs($ - ee + 2 * Te) <= ke ? 0 : 1;
              if (Te && Xc(hr, dr, Sr, pr) === 1 - we ^ rt) {
                var er = ($ + ee) / 2;
                hr = G * Math.cos(er), dr = G * Math.sin(er), Sr = pr = null;
              }
            } else hr = dr = 0;
            if (he > oe && (te = Math.min(Math.abs(W - G) / 2, +x.apply(this, arguments))) > .001) {
              le = G < W ^ we ? 0 : 1;
              var Lr = te,
                qr = te;
              if (he < ke) {
                var Kr = Sr == null ? [hr, dr] : or == null ? [Ge, rr] : h1([Ge, rr], [Sr, pr], [or, ar], [hr, dr]),
                  _t = Ge - Kr[0],
                  Ot = rr - Kr[1],
                  ca = or - Kr[0],
                  La = ar - Kr[1],
                  Oa = 1 / Math.sin(Math.acos((_t * ca + Ot * La) / (Math.sqrt(_t * _t + Ot * Ot) * Math.sqrt(ca * ca + La * La))) / 2),
                  qa = Math.sqrt(Kr[0] * Kr[0] + Kr[1] * Kr[1]);
                qr = Math.min(te, (G - qa) / (Oa - 1)), Lr = Math.min(te, (W - qa) / (Oa + 1));
              }
              if (or != null) {
                var Ga = Jc(Sr == null ? [hr, dr] : [Sr, pr], [Ge, rr], W, Lr, we),
                  ba = Jc([or, ar], [hr, dr], W, Lr, we);
                te === Lr ? Tr.push("M", Ga[0], "A", Lr, ",", Lr, " 0 0,", le, " ", Ga[1], "A", W, ",", W, " 0 ", 1 - we ^ Xc(Ga[1][0], Ga[1][1], ba[1][0], ba[1][1]), ",", we, " ", ba[1], "A", Lr, ",", Lr, " 0 0,", le, " ", ba[0]) : Tr.push("M", Ga[0], "A", Lr, ",", Lr, " 0 1,", le, " ", ba[0]);
              } else Tr.push("M", Ge, ",", rr);
              if (Sr != null) {
                var Va = Jc([Ge, rr], [Sr, pr], G, -qr, we),
                  Jl = Jc([hr, dr], or == null ? [Ge, rr] : [or, ar], G, -qr, we);
                te === qr ? Tr.push("L", Jl[0], "A", qr, ",", qr, " 0 0,", le, " ", Jl[1], "A", G, ",", G, " 0 ", we ^ Xc(Jl[1][0], Jl[1][1], Va[1][0], Va[1][1]), ",", 1 - we, " ", Va[1], "A", qr, ",", qr, " 0 0,", le, " ", Va[0]) : Tr.push("L", Jl[0], "A", qr, ",", qr, " 0 0,", le, " ", Va[0]);
              } else Tr.push("L", hr, ",", dr);
            } else Tr.push("M", Ge, ",", rr), or != null && Tr.push("A", W, ",", W, " 0 ", Jr, ",", we, " ", or, ",", ar), Tr.push("L", hr, ",", dr), Sr != null && Tr.push("A", G, ",", G, " 0 ", rt, ",", 1 - we, " ", Sr, ",", pr);
            return Tr.push("Z"), Tr.join("");
          }
          function F(G, W) {
            return "M0," + G + "A" + G + "," + G + " 0 1," + W + " 0," + -G + "A" + G + "," + G + " 0 1," + W + " 0," + G;
          }
          return E.innerRadius = function (G) {
            return arguments.length ? (c = Rr(G), E) : c;
          }, E.outerRadius = function (G) {
            return arguments.length ? (p = Rr(G), E) : p;
          }, E.cornerRadius = function (G) {
            return arguments.length ? (x = Rr(G), E) : x;
          }, E.padRadius = function (G) {
            return arguments.length ? (M = G == Zc ? Zc : Rr(G), E) : M;
          }, E.startAngle = function (G) {
            return arguments.length ? (C = Rr(G), E) : C;
          }, E.endAngle = function (G) {
            return arguments.length ? (L = Rr(G), E) : L;
          }, E.padAngle = function (G) {
            return arguments.length ? (P = Rr(G), E) : P;
          }, E.centroid = function () {
            var G = (+c.apply(this, arguments) + +p.apply(this, arguments)) / 2,
              W = (+C.apply(this, arguments) + +L.apply(this, arguments)) / 2 - sr;
            return [Math.cos(W) * G, Math.sin(W) * G];
          }, E;
        };
        var Zc = "auto";
        function SF(c) {
          return c.innerRadius;
        }
        function LF(c) {
          return c.outerRadius;
        }
        function I5(c) {
          return c.startAngle;
        }
        function H5(c) {
          return c.endAngle;
        }
        function qF(c) {
          return c && c.padAngle;
        }
        function Xc(c, p, x, M) {
          return (c - x) * p - (p - M) * c > 0 ? 0 : 1;
        }
        function Jc(c, p, x, M, C) {
          var L = c[0] - p[0],
            P = c[1] - p[1],
            E = (C ? M : -M) / Math.sqrt(L * L + P * P),
            F = E * P,
            G = -E * L,
            W = c[0] + F,
            $ = c[1] + G,
            ee = p[0] + F,
            he = p[1] + G,
            we = (W + ee) / 2,
            te = ($ + he) / 2,
            le = ee - W,
            ue = he - $,
            xe = le * le + ue * ue,
            Te = x - M,
            ce = W * he - ee * $,
            Ge = (ue < 0 ? -1 : 1) * Math.sqrt(Math.max(0, Te * Te * xe - ce * ce)),
            rr = (ce * ue - le * Ge) / xe,
            or = (-ce * le - ue * Ge) / xe,
            ar = (ce * ue + le * Ge) / xe,
            hr = (-ce * le + ue * Ge) / xe,
            dr = rr - we,
            Sr = or - te,
            pr = ar - we,
            Tr = hr - te;
          return dr * dr + Sr * Sr > pr * pr + Tr * Tr && (rr = ar, or = hr), [[rr - F, or - G], [rr * x / Te, or * x / Te]];
        }
        function O5() {
          return !0;
        }
        function B5(c) {
          var p = es,
            x = Lu,
            M = O5,
            C = Bn,
            L = C.key,
            P = .7;
          function E(F) {
            var G = [],
              W = [],
              $ = -1,
              ee = F.length,
              he,
              we = Rr(p),
              te = Rr(x);
            function le() {
              G.push("M", C(c(W), P));
            }
            for (; ++$ < ee;) M.call(this, he = F[$], $) ? W.push([+we.call(this, he, $), +te.call(this, he, $)]) : W.length && (le(), W = []);
            return W.length && le(), G.length ? G.join("") : null;
          }
          return E.x = function (F) {
            return arguments.length ? (p = F, E) : p;
          }, E.y = function (F) {
            return arguments.length ? (x = F, E) : x;
          }, E.defined = function (F) {
            return arguments.length ? (M = F, E) : M;
          }, E.interpolate = function (F) {
            return arguments.length ? (typeof F == "function" ? L = C = F : L = (C = q1.get(F) || Bn).key, E) : L;
          }, E.tension = function (F) {
            return arguments.length ? (P = F, E) : P;
          }, E;
        }
        e.svg.line = function () {
          return B5(J);
        };
        var q1 = e.map({
          linear: Bn,
          "linear-closed": Y5,
          step: DF,
          "step-before": D1,
          "step-after": E1,
          basis: U5,
          "basis-open": zF,
          "basis-closed": NF,
          bundle: FF,
          cardinal: RF,
          "cardinal-open": EF,
          "cardinal-closed": PF,
          monotone: OF
        });
        q1.forEach(function (c, p) {
          p.key = c, p.closed = /-closed$/.test(c);
        });
        function Bn(c) {
          return c.length > 1 ? c.join("L") : c + "Z";
        }
        function Y5(c) {
          return c.join("L") + "Z";
        }
        function DF(c) {
          for (var p = 0, x = c.length, M = c[0], C = [M[0], ",", M[1]]; ++p < x;) C.push("H", (M[0] + (M = c[p])[0]) / 2, "V", M[1]);
          return x > 1 && C.push("H", M[0]), C.join("");
        }
        function D1(c) {
          for (var p = 0, x = c.length, M = c[0], C = [M[0], ",", M[1]]; ++p < x;) C.push("V", (M = c[p])[1], "H", M[0]);
          return C.join("");
        }
        function E1(c) {
          for (var p = 0, x = c.length, M = c[0], C = [M[0], ",", M[1]]; ++p < x;) C.push("H", (M = c[p])[0], "V", M[1]);
          return C.join("");
        }
        function EF(c, p) {
          return c.length < 4 ? Bn(c) : c[1] + Kc(c.slice(1, -1), P1(c, p));
        }
        function PF(c, p) {
          return c.length < 3 ? Y5(c) : c[0] + Kc((c.push(c[0]), c), P1([c[c.length - 2]].concat(c, [c[1]]), p));
        }
        function RF(c, p) {
          return c.length < 3 ? Bn(c) : c[0] + Kc(c, P1(c, p));
        }
        function Kc(c, p) {
          if (p.length < 1 || c.length != p.length && c.length != p.length + 2) return Bn(c);
          var x = c.length != p.length,
            M = "",
            C = c[0],
            L = c[1],
            P = p[0],
            E = P,
            F = 1;
          if (x && (M += "Q" + (L[0] - P[0] * 2 / 3) + "," + (L[1] - P[1] * 2 / 3) + "," + L[0] + "," + L[1], C = c[1], F = 2), p.length > 1) {
            E = p[1], L = c[F], F++, M += "C" + (C[0] + P[0]) + "," + (C[1] + P[1]) + "," + (L[0] - E[0]) + "," + (L[1] - E[1]) + "," + L[0] + "," + L[1];
            for (var G = 2; G < p.length; G++, F++) L = c[F], E = p[G], M += "S" + (L[0] - E[0]) + "," + (L[1] - E[1]) + "," + L[0] + "," + L[1];
          }
          if (x) {
            var W = c[F];
            M += "Q" + (L[0] + E[0] * 2 / 3) + "," + (L[1] + E[1] * 2 / 3) + "," + W[0] + "," + W[1];
          }
          return M;
        }
        function P1(c, p) {
          for (var x = [], M = (1 - p) / 2, C, L = c[0], P = c[1], E = 1, F = c.length; ++E < F;) C = L, L = P, P = c[E], x.push([M * (P[0] - C[0]), M * (P[1] - C[1])]);
          return x;
        }
        function U5(c) {
          if (c.length < 3) return Bn(c);
          var p = 1,
            x = c.length,
            M = c[0],
            C = M[0],
            L = M[1],
            P = [C, C, C, (M = c[1])[0]],
            E = [L, L, L, M[1]],
            F = [C, ",", L, "L", mn(tl, P), ",", mn(tl, E)];
          for (c.push(c[x - 1]); ++p <= x;) M = c[p], P.shift(), P.push(M[0]), E.shift(), E.push(M[1]), R1(F, P, E);
          return c.pop(), F.push("L", M), F.join("");
        }
        function zF(c) {
          if (c.length < 4) return Bn(c);
          for (var p = [], x = -1, M = c.length, C, L = [0], P = [0]; ++x < 3;) C = c[x], L.push(C[0]), P.push(C[1]);
          for (p.push(mn(tl, L) + "," + mn(tl, P)), --x; ++x < M;) C = c[x], L.shift(), L.push(C[0]), P.shift(), P.push(C[1]), R1(p, L, P);
          return p.join("");
        }
        function NF(c) {
          for (var p, x = -1, M = c.length, C = M + 4, L, P = [], E = []; ++x < 4;) L = c[x % M], P.push(L[0]), E.push(L[1]);
          for (p = [mn(tl, P), ",", mn(tl, E)], --x; ++x < C;) L = c[x % M], P.shift(), P.push(L[0]), E.shift(), E.push(L[1]), R1(p, P, E);
          return p.join("");
        }
        function FF(c, p) {
          var x = c.length - 1;
          if (x) for (var M = c[0][0], C = c[0][1], L = c[x][0] - M, P = c[x][1] - C, E = -1, F, G; ++E <= x;) F = c[E], G = E / x, F[0] = p * F[0] + (1 - p) * (M + G * L), F[1] = p * F[1] + (1 - p) * (C + G * P);
          return U5(c);
        }
        function mn(c, p) {
          return c[0] * p[0] + c[1] * p[1] + c[2] * p[2] + c[3] * p[3];
        }
        var G5 = [0, 2 / 3, 1 / 3, 0],
          V5 = [0, 1 / 3, 2 / 3, 0],
          tl = [0, 1 / 6, 2 / 3, 1 / 6];
        function R1(c, p, x) {
          c.push("C", mn(G5, p), ",", mn(G5, x), ",", mn(V5, p), ",", mn(V5, x), ",", mn(tl, p), ",", mn(tl, x));
        }
        function z1(c, p) {
          return (p[1] - c[1]) / (p[0] - c[0]);
        }
        function IF(c) {
          for (var p = 0, x = c.length - 1, M = [], C = c[0], L = c[1], P = M[0] = z1(C, L); ++p < x;) M[p] = (P + (P = z1(C = L, L = c[p + 1]))) / 2;
          return M[p] = P, M;
        }
        function HF(c) {
          for (var p = [], x, M, C, L, P = IF(c), E = -1, F = c.length - 1; ++E < F;) x = z1(c[E], c[E + 1]), _(x) < oe ? P[E] = P[E + 1] = 0 : (M = P[E] / x, C = P[E + 1] / x, L = M * M + C * C, L > 9 && (L = x * 3 / Math.sqrt(L), P[E] = L * M, P[E + 1] = L * C));
          for (E = -1; ++E <= F;) L = (c[Math.min(F, E + 1)][0] - c[Math.max(0, E - 1)][0]) / (6 * (1 + P[E] * P[E])), p.push([L || 0, P[E] * L || 0]);
          return p;
        }
        function OF(c) {
          return c.length < 3 ? Bn(c) : c[0] + Kc(c, HF(c));
        }
        e.svg.line.radial = function () {
          var c = B5(W5);
          return c.radius = c.x, delete c.x, c.angle = c.y, delete c.y, c;
        };
        function W5(c) {
          for (var p, x = -1, M = c.length, C, L; ++x < M;) p = c[x], C = p[0], L = p[1] - sr, p[0] = C * Math.cos(L), p[1] = C * Math.sin(L);
          return c;
        }
        function Z5(c) {
          var p = es,
            x = es,
            M = 0,
            C = Lu,
            L = O5,
            P = Bn,
            E = P.key,
            F = P,
            G = "L",
            W = .7;
          function $(ee) {
            var he = [],
              we = [],
              te = [],
              le = -1,
              ue = ee.length,
              xe,
              Te = Rr(p),
              ce = Rr(M),
              Ge = p === x ? function () {
                return or;
              } : Rr(x),
              rr = M === C ? function () {
                return ar;
              } : Rr(C),
              or,
              ar;
            function hr() {
              he.push("M", P(c(te), W), G, F(c(we.reverse()), W), "Z");
            }
            for (; ++le < ue;) L.call(this, xe = ee[le], le) ? (we.push([or = +Te.call(this, xe, le), ar = +ce.call(this, xe, le)]), te.push([+Ge.call(this, xe, le), +rr.call(this, xe, le)])) : we.length && (hr(), we = [], te = []);
            return we.length && hr(), he.length ? he.join("") : null;
          }
          return $.x = function (ee) {
            return arguments.length ? (p = x = ee, $) : x;
          }, $.x0 = function (ee) {
            return arguments.length ? (p = ee, $) : p;
          }, $.x1 = function (ee) {
            return arguments.length ? (x = ee, $) : x;
          }, $.y = function (ee) {
            return arguments.length ? (M = C = ee, $) : C;
          }, $.y0 = function (ee) {
            return arguments.length ? (M = ee, $) : M;
          }, $.y1 = function (ee) {
            return arguments.length ? (C = ee, $) : C;
          }, $.defined = function (ee) {
            return arguments.length ? (L = ee, $) : L;
          }, $.interpolate = function (ee) {
            return arguments.length ? (typeof ee == "function" ? E = P = ee : E = (P = q1.get(ee) || Bn).key, F = P.reverse || P, G = P.closed ? "M" : "L", $) : E;
          }, $.tension = function (ee) {
            return arguments.length ? (W = ee, $) : W;
          }, $;
        }
        D1.reverse = E1, E1.reverse = D1, e.svg.area = function () {
          return Z5(J);
        }, e.svg.area.radial = function () {
          var c = Z5(W5);
          return c.radius = c.x, delete c.x, c.innerRadius = c.x0, delete c.x0, c.outerRadius = c.x1, delete c.x1, c.angle = c.y, delete c.y, c.startAngle = c.y0, delete c.y0, c.endAngle = c.y1, delete c.y1, c;
        };
        function X5(c) {
          return c.source;
        }
        function J5(c) {
          return c.target;
        }
        e.svg.chord = function () {
          var c = X5,
            p = J5,
            x = BF,
            M = I5,
            C = H5;
          function L(W, $) {
            var ee = P(this, c, W, $),
              he = P(this, p, W, $);
            return "M" + ee.p0 + F(ee.r, ee.p1, ee.a1 - ee.a0) + (E(ee, he) ? G(ee.r, ee.p1, ee.r, ee.p0) : G(ee.r, ee.p1, he.r, he.p0) + F(he.r, he.p1, he.a1 - he.a0) + G(he.r, he.p1, ee.r, ee.p0)) + "Z";
          }
          function P(W, $, ee, he) {
            var we = $.call(W, ee, he),
              te = x.call(W, we, he),
              le = M.call(W, we, he) - sr,
              ue = C.call(W, we, he) - sr;
            return {
              r: te,
              a0: le,
              a1: ue,
              p0: [te * Math.cos(le), te * Math.sin(le)],
              p1: [te * Math.cos(ue), te * Math.sin(ue)]
            };
          }
          function E(W, $) {
            return W.a0 == $.a0 && W.a1 == $.a1;
          }
          function F(W, $, ee) {
            return "A" + W + "," + W + " 0 " + +(ee > ke) + ",1 " + $;
          }
          function G(W, $, ee, he) {
            return "Q 0,0 " + he;
          }
          return L.radius = function (W) {
            return arguments.length ? (x = Rr(W), L) : x;
          }, L.source = function (W) {
            return arguments.length ? (c = Rr(W), L) : c;
          }, L.target = function (W) {
            return arguments.length ? (p = Rr(W), L) : p;
          }, L.startAngle = function (W) {
            return arguments.length ? (M = Rr(W), L) : M;
          }, L.endAngle = function (W) {
            return arguments.length ? (C = Rr(W), L) : C;
          }, L;
        };
        function BF(c) {
          return c.radius;
        }
        e.svg.diagonal = function () {
          var c = X5,
            p = J5,
            x = K5;
          function M(C, L) {
            var P = c.call(this, C, L),
              E = p.call(this, C, L),
              F = (P.y + E.y) / 2,
              G = [P, {
                x: P.x,
                y: F
              }, {
                x: E.x,
                y: F
              }, E];
            return G = G.map(x), "M" + G[0] + "C" + G[1] + " " + G[2] + " " + G[3];
          }
          return M.source = function (C) {
            return arguments.length ? (c = Rr(C), M) : c;
          }, M.target = function (C) {
            return arguments.length ? (p = Rr(C), M) : p;
          }, M.projection = function (C) {
            return arguments.length ? (x = C, M) : x;
          }, M;
        };
        function K5(c) {
          return [c.x, c.y];
        }
        e.svg.diagonal.radial = function () {
          var c = e.svg.diagonal(),
            p = K5,
            x = c.projection;
          return c.projection = function (M) {
            return arguments.length ? x(YF(p = M)) : p;
          }, c;
        };
        function YF(c) {
          return function () {
            var p = c.apply(this, arguments),
              x = p[0],
              M = p[1] - sr;
            return [x * Math.cos(M), x * Math.sin(M)];
          };
        }
        e.svg.symbol = function () {
          var c = GF,
            p = UF;
          function x(M, C) {
            return ($5.get(c.call(this, M, C)) || Q5)(p.call(this, M, C));
          }
          return x.type = function (M) {
            return arguments.length ? (c = Rr(M), x) : c;
          }, x.size = function (M) {
            return arguments.length ? (p = Rr(M), x) : p;
          }, x;
        };
        function UF() {
          return 64;
        }
        function GF() {
          return "circle";
        }
        function Q5(c) {
          var p = Math.sqrt(c / ke);
          return "M0," + p + "A" + p + "," + p + " 0 1,1 0," + -p + "A" + p + "," + p + " 0 1,1 0," + p + "Z";
        }
        var $5 = e.map({
          circle: Q5,
          cross: function (c) {
            var p = Math.sqrt(c / 5) / 2;
            return "M" + -3 * p + "," + -p + "H" + -p + "V" + -3 * p + "H" + p + "V" + -p + "H" + 3 * p + "V" + p + "H" + p + "V" + 3 * p + "H" + -p + "V" + p + "H" + -3 * p + "Z";
          },
          diamond: function (c) {
            var p = Math.sqrt(c / (2 * j5)),
              x = p * j5;
            return "M0," + -p + "L" + x + ",0 0," + p + " " + -x + ",0Z";
          },
          square: function (c) {
            var p = Math.sqrt(c) / 2;
            return "M" + -p + "," + -p + "L" + p + "," + -p + " " + p + "," + p + " " + -p + "," + p + "Z";
          },
          "triangle-down": function (c) {
            var p = Math.sqrt(c / Qc),
              x = p * Qc / 2;
            return "M0," + x + "L" + p + "," + -x + " " + -p + "," + -x + "Z";
          },
          "triangle-up": function (c) {
            var p = Math.sqrt(c / Qc),
              x = p * Qc / 2;
            return "M0," + -x + "L" + p + "," + x + " " + -p + "," + x + "Z";
          }
        });
        e.svg.symbolTypes = $5.keys();
        var Qc = Math.sqrt(3),
          j5 = Math.tan(30 * Mr);
        Ae.transition = function (c) {
          for (var p = Xl || ++rb, x = F1(c), M = [], C, L, P = jc || {
              time: Date.now(),
              ease: wN,
              delay: 0,
              duration: 250
            }, E = -1, F = this.length; ++E < F;) {
            M.push(C = []);
            for (var G = this[E], W = -1, $ = G.length; ++W < $;) (L = G[W]) && ev(L, W, x, p, P), C.push(L);
          }
          return Fu(M, x, p);
        }, Ae.interrupt = function (c) {
          return this.each(c == null ? $c : eb(F1(c)));
        };
        var $c = eb(F1());
        function eb(c) {
          return function () {
            var p, x, M;
            (p = this[c]) && (M = p[x = p.active]) && (M.timer.c = null, M.timer.t = NaN, --p.count ? delete p[x] : delete this[c], p.active += .5, M.event && M.event.interrupt.call(this, this.__data__, M.index));
          };
        }
        function Fu(c, p, x) {
          return j(c, Ht), c.namespace = p, c.id = x, c;
        }
        var Ht = [],
          rb = 0,
          Xl,
          jc;
        Ht.call = Ae.call, Ht.empty = Ae.empty, Ht.node = Ae.node, Ht.size = Ae.size, e.transition = function (c, p) {
          return c && c.transition ? Xl ? c.transition(p) : c : e.selection().transition(c);
        }, e.transition.prototype = Ht, Ht.select = function (c) {
          var p = this.id,
            x = this.namespace,
            M = [],
            C,
            L,
            P;
          c = Y(c);
          for (var E = -1, F = this.length; ++E < F;) {
            M.push(C = []);
            for (var G = this[E], W = -1, $ = G.length; ++W < $;) (P = G[W]) && (L = c.call(P, P.__data__, W, E)) ? ("__data__" in P && (L.__data__ = P.__data__), ev(L, W, x, p, P[x][p]), C.push(L)) : C.push(null);
          }
          return Fu(M, x, p);
        }, Ht.selectAll = function (c) {
          var p = this.id,
            x = this.namespace,
            M = [],
            C,
            L,
            P,
            E,
            F;
          c = re(c);
          for (var G = -1, W = this.length; ++G < W;) for (var $ = this[G], ee = -1, he = $.length; ++ee < he;) if (P = $[ee]) {
            F = P[x][p], L = c.call(P, P.__data__, ee, G), M.push(C = []);
            for (var we = -1, te = L.length; ++we < te;) (E = L[we]) && ev(E, we, x, p, F), C.push(E);
          }
          return Fu(M, x, p);
        }, Ht.filter = function (c) {
          var p = [],
            x,
            M,
            C;
          typeof c != "function" && (c = ne(c));
          for (var L = 0, P = this.length; L < P; L++) {
            p.push(x = []);
            for (var M = this[L], E = 0, F = M.length; E < F; E++) (C = M[E]) && c.call(C, C.__data__, E, L) && x.push(C);
          }
          return Fu(p, this.namespace, this.id);
        }, Ht.tween = function (c, p) {
          var x = this.id,
            M = this.namespace;
          return arguments.length < 2 ? this.node()[M][x].tween.get(c) : Ce(this, p == null ? function (C) {
            C[M][x].tween.remove(c);
          } : function (C) {
            C[M][x].tween.set(c, p);
          });
        };
        function N1(c, p, x, M) {
          var C = c.id,
            L = c.namespace;
          return Ce(c, typeof x == "function" ? function (P, E, F) {
            P[L][C].tween.set(p, M(x.call(P, P.__data__, E, F)));
          } : (x = M(x), function (P) {
            P[L][C].tween.set(p, x);
          }));
        }
        Ht.attr = function (c, p) {
          if (arguments.length < 2) {
            for (p in c) this.attr(p, c[p]);
            return this;
          }
          var x = c == "transform" ? v5 : Zl,
            M = e.ns.qualify(c);
          function C() {
            this.removeAttribute(M);
          }
          function L() {
            this.removeAttributeNS(M.space, M.local);
          }
          function P(F) {
            return F == null ? C : (F += "", function () {
              var G = this.getAttribute(M),
                W;
              return G !== F && (W = x(G, F), function ($) {
                this.setAttribute(M, W($));
              });
            });
          }
          function E(F) {
            return F == null ? L : (F += "", function () {
              var G = this.getAttributeNS(M.space, M.local),
                W;
              return G !== F && (W = x(G, F), function ($) {
                this.setAttributeNS(M.space, M.local, W($));
              });
            });
          }
          return N1(this, "attr." + c, p, M.local ? E : P);
        }, Ht.attrTween = function (c, p) {
          var x = e.ns.qualify(c);
          function M(L, P) {
            var E = p.call(this, L, P, this.getAttribute(x));
            return E && function (F) {
              this.setAttribute(x, E(F));
            };
          }
          function C(L, P) {
            var E = p.call(this, L, P, this.getAttributeNS(x.space, x.local));
            return E && function (F) {
              this.setAttributeNS(x.space, x.local, E(F));
            };
          }
          return this.tween("attr." + c, x.local ? C : M);
        }, Ht.style = function (c, p, x) {
          var M = arguments.length;
          if (M < 3) {
            if (typeof c != "string") {
              M < 2 && (p = "");
              for (x in c) this.style(x, c[x], p);
              return this;
            }
            x = "";
          }
          function C() {
            this.style.removeProperty(c);
          }
          function L(P) {
            return P == null ? C : (P += "", function () {
              var E = i(this).getComputedStyle(this, null).getPropertyValue(c),
                F;
              return E !== P && (F = Zl(E, P), function (G) {
                this.style.setProperty(c, F(G), x);
              });
            });
          }
          return N1(this, "style." + c, p, L);
        }, Ht.styleTween = function (c, p, x) {
          arguments.length < 3 && (x = "");
          function M(C, L) {
            var P = p.call(this, C, L, i(this).getComputedStyle(this, null).getPropertyValue(c));
            return P && function (E) {
              this.style.setProperty(c, P(E), x);
            };
          }
          return this.tween("style." + c, M);
        }, Ht.text = function (c) {
          return N1(this, "text", c, VF);
        };
        function VF(c) {
          return c == null && (c = ""), function () {
            this.textContent = c;
          };
        }
        Ht.remove = function () {
          var c = this.namespace;
          return this.each("end.transition", function () {
            var p;
            this[c].count < 2 && (p = this.parentNode) && p.removeChild(this);
          });
        }, Ht.ease = function (c) {
          var p = this.id,
            x = this.namespace;
          return arguments.length < 1 ? this.node()[x][p].ease : (typeof c != "function" && (c = e.ease.apply(e, arguments)), Ce(this, function (M) {
            M[x][p].ease = c;
          }));
        }, Ht.delay = function (c) {
          var p = this.id,
            x = this.namespace;
          return arguments.length < 1 ? this.node()[x][p].delay : Ce(this, typeof c == "function" ? function (M, C, L) {
            M[x][p].delay = +c.call(M, M.__data__, C, L);
          } : (c = +c, function (M) {
            M[x][p].delay = c;
          }));
        }, Ht.duration = function (c) {
          var p = this.id,
            x = this.namespace;
          return arguments.length < 1 ? this.node()[x][p].duration : Ce(this, typeof c == "function" ? function (M, C, L) {
            M[x][p].duration = Math.max(1, c.call(M, M.__data__, C, L));
          } : (c = Math.max(1, c), function (M) {
            M[x][p].duration = c;
          }));
        }, Ht.each = function (c, p) {
          var x = this.id,
            M = this.namespace;
          if (arguments.length < 2) {
            var C = jc,
              L = Xl;
            try {
              Xl = x, Ce(this, function (P, E, F) {
                jc = P[M][x], c.call(P, P.__data__, E, F);
              });
            } finally {
              jc = C, Xl = L;
            }
          } else Ce(this, function (P) {
            var E = P[M][x];
            (E.event || (E.event = e.dispatch("start", "end", "interrupt"))).on(c, p);
          });
          return this;
        }, Ht.transition = function () {
          for (var c = this.id, p = ++rb, x = this.namespace, M = [], C, L, P, E, F = 0, G = this.length; F < G; F++) {
            M.push(C = []);
            for (var L = this[F], W = 0, $ = L.length; W < $; W++) (P = L[W]) && (E = P[x][c], ev(P, W, x, p, {
              time: E.time,
              ease: E.ease,
              delay: E.delay + E.duration,
              duration: E.duration
            })), C.push(P);
          }
          return Fu(M, x, p);
        };
        function F1(c) {
          return c == null ? "__transition__" : "__transition_" + c + "__";
        }
        function ev(c, p, x, M, C) {
          var L = c[x] || (c[x] = {
              active: 0,
              count: 0
            }),
            P = L[M],
            E,
            F,
            G,
            W,
            $;
          function ee(te) {
            var le = P.delay;
            if (F.t = le + E, le <= te) return he(te - le);
            F.c = he;
          }
          function he(te) {
            var le = L.active,
              ue = L[le];
            ue && (ue.timer.c = null, ue.timer.t = NaN, --L.count, delete L[le], ue.event && ue.event.interrupt.call(c, c.__data__, ue.index));
            for (var xe in L) if (+xe < M) {
              var Te = L[xe];
              Te.timer.c = null, Te.timer.t = NaN, --L.count, delete L[xe];
            }
            F.c = we, Fc(function () {
              return F.c && we(te || 1) && (F.c = null, F.t = NaN), 1;
            }, 0, E), L.active = M, P.event && P.event.start.call(c, c.__data__, p), $ = [], P.tween.forEach(function (ce, Ge) {
              (Ge = Ge.call(c, c.__data__, p)) && $.push(Ge);
            }), W = P.ease, G = P.duration;
          }
          function we(te) {
            for (var le = te / G, ue = W(le), xe = $.length; xe > 0;) $[--xe].call(c, ue);
            if (le >= 1) return P.event && P.event.end.call(c, c.__data__, p), --L.count ? delete L[M] : delete c[x], 1;
          }
          P || (E = C.time, F = Fc(ee, 0, E), P = L[M] = {
            tween: new b(),
            time: E,
            timer: F,
            delay: C.delay,
            duration: C.duration,
            ease: C.ease,
            index: p
          }, C = null, ++L.count);
        }
        e.svg.axis = function () {
          var c = e.scale.linear(),
            p = tb,
            x = 6,
            M = 6,
            C = 3,
            L = [10],
            P = null,
            E;
          function F(G) {
            G.each(function () {
              var W = e.select(this),
                $ = this.__chart__ || c,
                ee = this.__chart__ = c.copy(),
                he = P == null ? ee.ticks ? ee.ticks.apply(ee, L) : ee.domain() : P,
                we = E == null ? ee.tickFormat ? ee.tickFormat.apply(ee, L) : J : E,
                te = W.selectAll(".tick").data(he, ee),
                le = te.enter().insert("g", ".domain").attr("class", "tick").style("opacity", oe),
                ue = e.transition(te.exit()).style("opacity", oe).remove(),
                xe = e.transition(te.order()).style("opacity", 1),
                Te = Math.max(x, 0) + C,
                ce,
                Ge = Vc(ee),
                rr = W.selectAll(".domain").data([0]),
                or = (rr.enter().append("path").attr("class", "domain"), e.transition(rr));
              le.append("line"), le.append("text");
              var ar = le.select("line"),
                hr = xe.select("line"),
                dr = te.select("text").text(we),
                Sr = le.select("text"),
                pr = xe.select("text"),
                Tr = p === "top" || p === "left" ? -1 : 1,
                Jr,
                Lt,
                rt,
                er;
              if (p === "bottom" || p === "top" ? (ce = ZF, Jr = "x", rt = "y", Lt = "x2", er = "y2", dr.attr("dy", Tr < 0 ? "0em" : ".71em").style("text-anchor", "middle"), or.attr("d", "M" + Ge[0] + "," + Tr * M + "V0H" + Ge[1] + "V" + Tr * M)) : (ce = XF, Jr = "y", rt = "x", Lt = "y2", er = "x2", dr.attr("dy", ".32em").style("text-anchor", Tr < 0 ? "end" : "start"), or.attr("d", "M" + Tr * M + "," + Ge[0] + "H0V" + Ge[1] + "H" + Tr * M)), ar.attr(er, Tr * x), Sr.attr(rt, Tr * Te), hr.attr(Lt, 0).attr(er, Tr * x), pr.attr(Jr, 0).attr(rt, Tr * Te), ee.rangeBand) {
                var Lr = ee,
                  qr = Lr.rangeBand() / 2;
                $ = ee = function (Kr) {
                  return Lr(Kr) + qr;
                };
              } else $.rangeBand ? $ = ee : ue.call(ce, ee, $);
              le.call(ce, $, ee), xe.call(ce, ee, ee);
            });
          }
          return F.scale = function (G) {
            return arguments.length ? (c = G, F) : c;
          }, F.orient = function (G) {
            return arguments.length ? (p = G in WF ? G + "" : tb, F) : p;
          }, F.ticks = function () {
            return arguments.length ? (L = t(arguments), F) : L;
          }, F.tickValues = function (G) {
            return arguments.length ? (P = G, F) : P;
          }, F.tickFormat = function (G) {
            return arguments.length ? (E = G, F) : E;
          }, F.tickSize = function (G) {
            var W = arguments.length;
            return W ? (x = +G, M = +arguments[W - 1], F) : x;
          }, F.innerTickSize = function (G) {
            return arguments.length ? (x = +G, F) : x;
          }, F.outerTickSize = function (G) {
            return arguments.length ? (M = +G, F) : M;
          }, F.tickPadding = function (G) {
            return arguments.length ? (C = +G, F) : C;
          }, F.tickSubdivide = function () {
            return arguments.length && F;
          }, F;
        };
        var tb = "bottom",
          WF = {
            top: 1,
            right: 1,
            bottom: 1,
            left: 1
          };
        function ZF(c, p, x) {
          c.attr("transform", function (M) {
            var C = p(M);
            return "translate(" + (isFinite(C) ? C : x(M)) + ",0)";
          });
        }
        function XF(c, p, x) {
          c.attr("transform", function (M) {
            var C = p(M);
            return "translate(0," + (isFinite(C) ? C : x(M)) + ")";
          });
        }
        e.svg.brush = function () {
          var c = pe(W, "brushstart", "brush", "brushend"),
            p = null,
            x = null,
            M = [0, 0],
            C = [0, 0],
            L,
            P,
            E = !0,
            F = !0,
            G = I1[0];
          function W(te) {
            te.each(function () {
              var le = e.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", we).on("touchstart.brush", we),
                ue = le.selectAll(".background").data([0]);
              ue.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), le.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
              var xe = le.selectAll(".resize").data(G, J);
              xe.exit().remove(), xe.enter().append("g").attr("class", function (rr) {
                return "resize " + rr;
              }).style("cursor", function (rr) {
                return JF[rr];
              }).append("rect").attr("x", function (rr) {
                return /[ew]$/.test(rr) ? -3 : null;
              }).attr("y", function (rr) {
                return /^[ns]/.test(rr) ? -3 : null;
              }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), xe.style("display", W.empty() ? "none" : null);
              var Te = e.transition(le),
                ce = e.transition(ue),
                Ge;
              p && (Ge = Vc(p), ce.attr("x", Ge[0]).attr("width", Ge[1] - Ge[0]), ee(Te)), x && (Ge = Vc(x), ce.attr("y", Ge[0]).attr("height", Ge[1] - Ge[0]), he(Te)), $(Te);
            });
          }
          W.event = function (te) {
            te.each(function () {
              var le = c.of(this, arguments),
                ue = {
                  x: M,
                  y: C,
                  i: L,
                  j: P
                },
                xe = this.__chart__ || ue;
              this.__chart__ = ue, Xl ? e.select(this).transition().each("start.brush", function () {
                L = xe.i, P = xe.j, M = xe.x, C = xe.y, le({
                  type: "brushstart"
                });
              }).tween("brush:brush", function () {
                var Te = Uc(M, ue.x),
                  ce = Uc(C, ue.y);
                return L = P = null, function (Ge) {
                  M = ue.x = Te(Ge), C = ue.y = ce(Ge), le({
                    type: "brush",
                    mode: "resize"
                  });
                };
              }).each("end.brush", function () {
                L = ue.i, P = ue.j, le({
                  type: "brush",
                  mode: "resize"
                }), le({
                  type: "brushend"
                });
              }) : (le({
                type: "brushstart"
              }), le({
                type: "brush",
                mode: "resize"
              }), le({
                type: "brushend"
              }));
            });
          };
          function $(te) {
            te.selectAll(".resize").attr("transform", function (le) {
              return "translate(" + M[+/e$/.test(le)] + "," + C[+/^s/.test(le)] + ")";
            });
          }
          function ee(te) {
            te.select(".extent").attr("x", M[0]), te.selectAll(".extent,.n>rect,.s>rect").attr("width", M[1] - M[0]);
          }
          function he(te) {
            te.select(".extent").attr("y", C[0]), te.selectAll(".extent,.e>rect,.w>rect").attr("height", C[1] - C[0]);
          }
          function we() {
            var te = this,
              le = e.select(e.event.target),
              ue = c.of(te, arguments),
              xe = e.select(te),
              Te = le.datum(),
              ce = !/^(n|s)$/.test(Te) && p,
              Ge = !/^(e|w)$/.test(Te) && x,
              rr = le.classed("extent"),
              or = fr(te),
              ar,
              hr = e.mouse(te),
              dr,
              Sr = e.select(i(te)).on("keydown.brush", Jr).on("keyup.brush", Lt);
            if (e.event.changedTouches ? Sr.on("touchmove.brush", rt).on("touchend.brush", Lr) : Sr.on("mousemove.brush", rt).on("mouseup.brush", Lr), xe.interrupt().selectAll("*").interrupt(), rr) hr[0] = M[0] - hr[0], hr[1] = C[0] - hr[1];else if (Te) {
              var pr = +/w$/.test(Te),
                Tr = +/^n/.test(Te);
              dr = [M[1 - pr] - hr[0], C[1 - Tr] - hr[1]], hr[0] = M[pr], hr[1] = C[Tr];
            } else e.event.altKey && (ar = hr.slice());
            xe.style("pointer-events", "none").selectAll(".resize").style("display", null), e.select("body").style("cursor", le.style("cursor")), ue({
              type: "brushstart"
            }), rt();
            function Jr() {
              e.event.keyCode == 32 && (rr || (ar = null, hr[0] -= M[1], hr[1] -= C[1], rr = 2), ie());
            }
            function Lt() {
              e.event.keyCode == 32 && rr == 2 && (hr[0] += M[1], hr[1] += C[1], rr = 0, ie());
            }
            function rt() {
              var qr = e.mouse(te),
                Kr = !1;
              dr && (qr[0] += dr[0], qr[1] += dr[1]), rr || (e.event.altKey ? (ar || (ar = [(M[0] + M[1]) / 2, (C[0] + C[1]) / 2]), hr[0] = M[+(qr[0] < ar[0])], hr[1] = C[+(qr[1] < ar[1])]) : ar = null), ce && er(qr, p, 0) && (ee(xe), Kr = !0), Ge && er(qr, x, 1) && (he(xe), Kr = !0), Kr && ($(xe), ue({
                type: "brush",
                mode: rr ? "move" : "resize"
              }));
            }
            function er(qr, Kr, _t) {
              var Ot = Vc(Kr),
                ca = Ot[0],
                La = Ot[1],
                Oa = hr[_t],
                qa = _t ? C : M,
                Ga = qa[1] - qa[0],
                ba,
                Va;
              if (rr && (ca -= Oa, La -= Ga + Oa), ba = (_t ? F : E) ? Math.max(ca, Math.min(La, qr[_t])) : qr[_t], rr ? Va = (ba += Oa) + Ga : (ar && (Oa = Math.max(ca, Math.min(La, 2 * ar[_t] - ba))), Oa < ba ? (Va = ba, ba = Oa) : Va = Oa), qa[0] != ba || qa[1] != Va) return _t ? P = null : L = null, qa[0] = ba, qa[1] = Va, !0;
            }
            function Lr() {
              rt(), xe.style("pointer-events", "all").selectAll(".resize").style("display", W.empty() ? "none" : null), e.select("body").style("cursor", null), Sr.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), or(), ue({
                type: "brushend"
              });
            }
          }
          return W.x = function (te) {
            return arguments.length ? (p = te, G = I1[!p << 1 | !x], W) : p;
          }, W.y = function (te) {
            return arguments.length ? (x = te, G = I1[!p << 1 | !x], W) : x;
          }, W.clamp = function (te) {
            return arguments.length ? (p && x ? (E = !!te[0], F = !!te[1]) : p ? E = !!te : x && (F = !!te), W) : p && x ? [E, F] : p ? E : x ? F : null;
          }, W.extent = function (te) {
            var le, ue, xe, Te, ce;
            return arguments.length ? (p && (le = te[0], ue = te[1], x && (le = le[0], ue = ue[0]), L = [le, ue], p.invert && (le = p(le), ue = p(ue)), ue < le && (ce = le, le = ue, ue = ce), (le != M[0] || ue != M[1]) && (M = [le, ue])), x && (xe = te[0], Te = te[1], p && (xe = xe[1], Te = Te[1]), P = [xe, Te], x.invert && (xe = x(xe), Te = x(Te)), Te < xe && (ce = xe, xe = Te, Te = ce), (xe != C[0] || Te != C[1]) && (C = [xe, Te])), W) : (p && (L ? (le = L[0], ue = L[1]) : (le = M[0], ue = M[1], p.invert && (le = p.invert(le), ue = p.invert(ue)), ue < le && (ce = le, le = ue, ue = ce))), x && (P ? (xe = P[0], Te = P[1]) : (xe = C[0], Te = C[1], x.invert && (xe = x.invert(xe), Te = x.invert(Te)), Te < xe && (ce = xe, xe = Te, Te = ce))), p && x ? [[le, xe], [ue, Te]] : p ? [le, ue] : x && [xe, Te]);
          }, W.clear = function () {
            return W.empty() || (M = [0, 0], C = [0, 0], L = P = null), W;
          }, W.empty = function () {
            return !!p && M[0] == M[1] || !!x && C[0] == C[1];
          }, e.rebind(W, c, "on");
        };
        var JF = {
            n: "ns-resize",
            e: "ew-resize",
            s: "ns-resize",
            w: "ew-resize",
            nw: "nwse-resize",
            ne: "nesw-resize",
            se: "nwse-resize",
            sw: "nesw-resize"
          },
          I1 = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []];
        e.text = On(function (c) {
          return c.responseText;
        }), e.json = function (c, p) {
          return Vl(c, "application/json", KF, p);
        };
        function KF(c) {
          return JSON.parse(c.responseText);
        }
        e.html = function (c, p) {
          return Vl(c, "text/html", QF, p);
        };
        function QF(c) {
          var p = a.createRange();
          return p.selectNode(a.body), p.createContextualFragment(c.responseText);
        }
        e.xml = On(function (c) {
          return c.responseXML;
        }), typeof nv == "object" && nv.exports ? nv.exports = e : this.d3 = e;
      }).apply(self);
    });
    var H1 = Z((iv, ub) => {
      (function (e, r) {
        typeof iv == "object" && typeof ub != "undefined" ? r(iv) : (e = e || self, r(e.d3 = e.d3 || {}));
      })(iv, function (e) {
        "use strict";

        var r = new Date(),
          t = new Date();
        function a(ne, Me, Ce, cr) {
          function tr(De) {
            return ne(De = arguments.length === 0 ? new Date() : new Date(+De)), De;
          }
          return tr.floor = function (De) {
            return ne(De = new Date(+De)), De;
          }, tr.ceil = function (De) {
            return ne(De = new Date(De - 1)), Me(De, 1), ne(De), De;
          }, tr.round = function (De) {
            var Le = tr(De),
              Ye = tr.ceil(De);
            return De - Le < Ye - De ? Le : Ye;
          }, tr.offset = function (De, Le) {
            return Me(De = new Date(+De), Le == null ? 1 : Math.floor(Le)), De;
          }, tr.range = function (De, Le, Ye) {
            var Ze = [],
              Ue;
            if (De = tr.ceil(De), Ye = Ye == null ? 1 : Math.floor(Ye), !(De < Le) || !(Ye > 0)) return Ze;
            do Ze.push(Ue = new Date(+De)), Me(De, Ye), ne(De); while (Ue < De && De < Le);
            return Ze;
          }, tr.filter = function (De) {
            return a(function (Le) {
              if (Le >= Le) for (; ne(Le), !De(Le);) Le.setTime(Le - 1);
            }, function (Le, Ye) {
              if (Le >= Le) if (Ye < 0) for (; ++Ye <= 0;) for (; Me(Le, -1), !De(Le););else for (; --Ye >= 0;) for (; Me(Le, 1), !De(Le););
            });
          }, Ce && (tr.count = function (De, Le) {
            return r.setTime(+De), t.setTime(+Le), ne(r), ne(t), Math.floor(Ce(r, t));
          }, tr.every = function (De) {
            return De = Math.floor(De), !isFinite(De) || !(De > 0) ? null : De > 1 ? tr.filter(cr ? function (Le) {
              return cr(Le) % De === 0;
            } : function (Le) {
              return tr.count(0, Le) % De === 0;
            }) : tr;
          }), tr;
        }
        var n = a(function () {}, function (ne, Me) {
          ne.setTime(+ne + Me);
        }, function (ne, Me) {
          return Me - ne;
        });
        n.every = function (ne) {
          return ne = Math.floor(ne), !isFinite(ne) || !(ne > 0) ? null : ne > 1 ? a(function (Me) {
            Me.setTime(Math.floor(Me / ne) * ne);
          }, function (Me, Ce) {
            Me.setTime(+Me + Ce * ne);
          }, function (Me, Ce) {
            return (Ce - Me) / ne;
          }) : n;
        };
        var i = n.range,
          l = 1e3,
          o = 6e4,
          s = 36e5,
          u = 864e5,
          f = 6048e5,
          v = a(function (ne) {
            ne.setTime(ne - ne.getMilliseconds());
          }, function (ne, Me) {
            ne.setTime(+ne + Me * l);
          }, function (ne, Me) {
            return (Me - ne) / l;
          }, function (ne) {
            return ne.getUTCSeconds();
          }),
          h = v.range,
          d = a(function (ne) {
            ne.setTime(ne - ne.getMilliseconds() - ne.getSeconds() * l);
          }, function (ne, Me) {
            ne.setTime(+ne + Me * o);
          }, function (ne, Me) {
            return (Me - ne) / o;
          }, function (ne) {
            return ne.getMinutes();
          }),
          y = d.range,
          g = a(function (ne) {
            ne.setTime(ne - ne.getMilliseconds() - ne.getSeconds() * l - ne.getMinutes() * o);
          }, function (ne, Me) {
            ne.setTime(+ne + Me * s);
          }, function (ne, Me) {
            return (Me - ne) / s;
          }, function (ne) {
            return ne.getHours();
          }),
          m = g.range,
          _ = a(function (ne) {
            ne.setHours(0, 0, 0, 0);
          }, function (ne, Me) {
            ne.setDate(ne.getDate() + Me);
          }, function (ne, Me) {
            return (Me - ne - (Me.getTimezoneOffset() - ne.getTimezoneOffset()) * o) / u;
          }, function (ne) {
            return ne.getDate() - 1;
          }),
          w = _.range;
        function T(ne) {
          return a(function (Me) {
            Me.setDate(Me.getDate() - (Me.getDay() + 7 - ne) % 7), Me.setHours(0, 0, 0, 0);
          }, function (Me, Ce) {
            Me.setDate(Me.getDate() + Ce * 7);
          }, function (Me, Ce) {
            return (Ce - Me - (Ce.getTimezoneOffset() - Me.getTimezoneOffset()) * o) / f;
          });
        }
        var b = T(0),
          A = T(1),
          S = T(2),
          k = T(3),
          q = T(4),
          D = T(5),
          R = T(6),
          z = b.range,
          N = A.range,
          H = S.range,
          O = k.range,
          J = q.range,
          X = D.range,
          B = R.range,
          I = a(function (ne) {
            ne.setDate(1), ne.setHours(0, 0, 0, 0);
          }, function (ne, Me) {
            ne.setMonth(ne.getMonth() + Me);
          }, function (ne, Me) {
            return Me.getMonth() - ne.getMonth() + (Me.getFullYear() - ne.getFullYear()) * 12;
          }, function (ne) {
            return ne.getMonth();
          }),
          V = I.range,
          K = a(function (ne) {
            ne.setMonth(0, 1), ne.setHours(0, 0, 0, 0);
          }, function (ne, Me) {
            ne.setFullYear(ne.getFullYear() + Me);
          }, function (ne, Me) {
            return Me.getFullYear() - ne.getFullYear();
          }, function (ne) {
            return ne.getFullYear();
          });
        K.every = function (ne) {
          return !isFinite(ne = Math.floor(ne)) || !(ne > 0) ? null : a(function (Me) {
            Me.setFullYear(Math.floor(Me.getFullYear() / ne) * ne), Me.setMonth(0, 1), Me.setHours(0, 0, 0, 0);
          }, function (Me, Ce) {
            Me.setFullYear(Me.getFullYear() + Ce * ne);
          });
        };
        var Q = K.range,
          ie = a(function (ne) {
            ne.setUTCSeconds(0, 0);
          }, function (ne, Me) {
            ne.setTime(+ne + Me * o);
          }, function (ne, Me) {
            return (Me - ne) / o;
          }, function (ne) {
            return ne.getUTCMinutes();
          }),
          me = ie.range,
          pe = a(function (ne) {
            ne.setUTCMinutes(0, 0, 0);
          }, function (ne, Me) {
            ne.setTime(+ne + Me * s);
          }, function (ne, Me) {
            return (Me - ne) / s;
          }, function (ne) {
            return ne.getUTCHours();
          }),
          ge = pe.range,
          j = a(function (ne) {
            ne.setUTCHours(0, 0, 0, 0);
          }, function (ne, Me) {
            ne.setUTCDate(ne.getUTCDate() + Me);
          }, function (ne, Me) {
            return (Me - ne) / u;
          }, function (ne) {
            return ne.getUTCDate() - 1;
          }),
          _e = j.range;
        function se(ne) {
          return a(function (Me) {
            Me.setUTCDate(Me.getUTCDate() - (Me.getUTCDay() + 7 - ne) % 7), Me.setUTCHours(0, 0, 0, 0);
          }, function (Me, Ce) {
            Me.setUTCDate(Me.getUTCDate() + Ce * 7);
          }, function (Me, Ce) {
            return (Ce - Me) / f;
          });
        }
        var Se = se(0),
          ve = se(1),
          Ae = se(2),
          Y = se(3),
          re = se(4),
          U = se(5),
          de = se(6),
          be = Se.range,
          ye = ve.range,
          Fe = Ae.range,
          Re = Y.range,
          Pe = re.range,
          Ie = U.range,
          Be = de.range,
          Ne = a(function (ne) {
            ne.setUTCDate(1), ne.setUTCHours(0, 0, 0, 0);
          }, function (ne, Me) {
            ne.setUTCMonth(ne.getUTCMonth() + Me);
          }, function (ne, Me) {
            return Me.getUTCMonth() - ne.getUTCMonth() + (Me.getUTCFullYear() - ne.getUTCFullYear()) * 12;
          }, function (ne) {
            return ne.getUTCMonth();
          }),
          Ee = Ne.range,
          Je = a(function (ne) {
            ne.setUTCMonth(0, 1), ne.setUTCHours(0, 0, 0, 0);
          }, function (ne, Me) {
            ne.setUTCFullYear(ne.getUTCFullYear() + Me);
          }, function (ne, Me) {
            return Me.getUTCFullYear() - ne.getUTCFullYear();
          }, function (ne) {
            return ne.getUTCFullYear();
          });
        Je.every = function (ne) {
          return !isFinite(ne = Math.floor(ne)) || !(ne > 0) ? null : a(function (Me) {
            Me.setUTCFullYear(Math.floor(Me.getUTCFullYear() / ne) * ne), Me.setUTCMonth(0, 1), Me.setUTCHours(0, 0, 0, 0);
          }, function (Me, Ce) {
            Me.setUTCFullYear(Me.getUTCFullYear() + Ce * ne);
          });
        };
        var We = Je.range;
        e.timeDay = _, e.timeDays = w, e.timeFriday = D, e.timeFridays = X, e.timeHour = g, e.timeHours = m, e.timeInterval = a, e.timeMillisecond = n, e.timeMilliseconds = i, e.timeMinute = d, e.timeMinutes = y, e.timeMonday = A, e.timeMondays = N, e.timeMonth = I, e.timeMonths = V, e.timeSaturday = R, e.timeSaturdays = B, e.timeSecond = v, e.timeSeconds = h, e.timeSunday = b, e.timeSundays = z, e.timeThursday = q, e.timeThursdays = J, e.timeTuesday = S, e.timeTuesdays = H, e.timeWednesday = k, e.timeWednesdays = O, e.timeWeek = b, e.timeWeeks = z, e.timeYear = K, e.timeYears = Q, e.utcDay = j, e.utcDays = _e, e.utcFriday = U, e.utcFridays = Ie, e.utcHour = pe, e.utcHours = ge, e.utcMillisecond = n, e.utcMilliseconds = i, e.utcMinute = ie, e.utcMinutes = me, e.utcMonday = ve, e.utcMondays = ye, e.utcMonth = Ne, e.utcMonths = Ee, e.utcSaturday = de, e.utcSaturdays = Be, e.utcSecond = v, e.utcSeconds = h, e.utcSunday = Se, e.utcSundays = be, e.utcThursday = re, e.utcThursdays = Pe, e.utcTuesday = Ae, e.utcTuesdays = Fe, e.utcWednesday = Y, e.utcWednesdays = Re, e.utcWeek = Se, e.utcWeeks = be, e.utcYear = Je, e.utcYears = We, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      });
    });
    var os = Z((lv, fb) => {
      (function (e, r) {
        typeof lv == "object" && typeof fb != "undefined" ? r(lv, H1()) : (e = e || self, r(e.d3 = e.d3 || {}, e.d3));
      })(lv, function (e, r) {
        "use strict";

        function t(ae) {
          if (0 <= ae.y && ae.y < 100) {
            var oe = new Date(-1, ae.m, ae.d, ae.H, ae.M, ae.S, ae.L);
            return oe.setFullYear(ae.y), oe;
          }
          return new Date(ae.y, ae.m, ae.d, ae.H, ae.M, ae.S, ae.L);
        }
        function a(ae) {
          if (0 <= ae.y && ae.y < 100) {
            var oe = new Date(Date.UTC(-1, ae.m, ae.d, ae.H, ae.M, ae.S, ae.L));
            return oe.setUTCFullYear(ae.y), oe;
          }
          return new Date(Date.UTC(ae.y, ae.m, ae.d, ae.H, ae.M, ae.S, ae.L));
        }
        function n(ae, oe, qe) {
          return {
            y: ae,
            m: oe,
            d: qe,
            H: 0,
            M: 0,
            S: 0,
            L: 0
          };
        }
        function i(ae) {
          var oe = ae.dateTime,
            qe = ae.date,
            ke = ae.time,
            ir = ae.periods,
            vr = ae.days,
            sr = ae.shortDays,
            Mr = ae.months,
            Ur = ae.shortMonths,
            $r = h(ir),
            Vr = d(ir),
            St = h(vr),
            ea = d(vr),
            ka = h(sr),
            ra = d(sr),
            pn = h(Mr),
            Ia = d(Mr),
            ta = h(Ur),
            Ha = d(Ur),
            yr = {
              a: Ul,
              A: Gl,
              b: rl,
              B: qc,
              c: null,
              d: I,
              e: I,
              f: me,
              H: V,
              I: K,
              j: Q,
              L: ie,
              m: pe,
              M: ge,
              p: Dc,
              q: ku,
              Q: Le,
              s: Ye,
              S: j,
              u: _e,
              U: se,
              V: Se,
              w: ve,
              W: Ae,
              x: null,
              X: null,
              y: Y,
              Y: re,
              Z: U,
              "%": De
            },
            lt = {
              a: Cu,
              A: Su,
              b: Sa,
              B: Ec,
              c: null,
              d: de,
              e: de,
              f: Pe,
              H: be,
              I: ye,
              j: Fe,
              L: Re,
              m: Ie,
              M: Be,
              p: $o,
              q: jo,
              Q: Le,
              s: Ye,
              S: Ne,
              u: Ee,
              U: Je,
              V: We,
              w: ne,
              W: Me,
              x: null,
              X: null,
              y: Ce,
              Y: cr,
              Z: tr,
              "%": De
            },
            Wr = {
              a: Ca,
              A: aa,
              b: In,
              B: Hn,
              c: Wt,
              d: q,
              e: q,
              f: O,
              H: R,
              I: R,
              j: D,
              L: H,
              m: k,
              M: z,
              p: yt,
              q: S,
              Q: X,
              s: B,
              S: N,
              u: g,
              U: m,
              V: _,
              w: y,
              W: w,
              x: at,
              X: sa,
              y: b,
              Y: T,
              Z: A,
              "%": J
            };
          yr.x = mt(qe, yr), yr.X = mt(ke, yr), yr.c = mt(oe, yr), lt.x = mt(qe, lt), lt.X = mt(ke, lt), lt.c = mt(oe, lt);
          function mt(mr, Zr) {
            return function (jr) {
              var nr = [],
                ua = -1,
                st = 0,
                fa = mr.length,
                Rr,
                On,
                Vl;
              for (jr instanceof Date || (jr = new Date(+jr)); ++ua < fa;) mr.charCodeAt(ua) === 37 && (nr.push(mr.slice(st, ua)), (On = l[Rr = mr.charAt(++ua)]) != null ? Rr = mr.charAt(++ua) : On = Rr === "e" ? " " : "0", (Vl = Zr[Rr]) && (Rr = Vl(jr, On)), nr.push(Rr), st = ua + 1);
              return nr.push(mr.slice(st, ua)), nr.join("");
            };
          }
          function Tt(mr, Zr) {
            return function (jr) {
              var nr = n(1900, void 0, 1),
                ua = ot(nr, mr, jr += "", 0),
                st,
                fa;
              if (ua != jr.length) return null;
              if ("Q" in nr) return new Date(nr.Q);
              if ("s" in nr) return new Date(nr.s * 1e3 + ("L" in nr ? nr.L : 0));
              if (Zr && !("Z" in nr) && (nr.Z = 0), "p" in nr && (nr.H = nr.H % 12 + nr.p * 12), nr.m === void 0 && (nr.m = "q" in nr ? nr.q : 0), "V" in nr) {
                if (nr.V < 1 || nr.V > 53) return null;
                "w" in nr || (nr.w = 1), "Z" in nr ? (st = a(n(nr.y, 0, 1)), fa = st.getUTCDay(), st = fa > 4 || fa === 0 ? r.utcMonday.ceil(st) : r.utcMonday(st), st = r.utcDay.offset(st, (nr.V - 1) * 7), nr.y = st.getUTCFullYear(), nr.m = st.getUTCMonth(), nr.d = st.getUTCDate() + (nr.w + 6) % 7) : (st = t(n(nr.y, 0, 1)), fa = st.getDay(), st = fa > 4 || fa === 0 ? r.timeMonday.ceil(st) : r.timeMonday(st), st = r.timeDay.offset(st, (nr.V - 1) * 7), nr.y = st.getFullYear(), nr.m = st.getMonth(), nr.d = st.getDate() + (nr.w + 6) % 7);
              } else ("W" in nr || "U" in nr) && ("w" in nr || (nr.w = "u" in nr ? nr.u % 7 : "W" in nr ? 1 : 0), fa = "Z" in nr ? a(n(nr.y, 0, 1)).getUTCDay() : t(n(nr.y, 0, 1)).getDay(), nr.m = 0, nr.d = "W" in nr ? (nr.w + 6) % 7 + nr.W * 7 - (fa + 5) % 7 : nr.w + nr.U * 7 - (fa + 6) % 7);
              return "Z" in nr ? (nr.H += nr.Z / 100 | 0, nr.M += nr.Z % 100, a(nr)) : t(nr);
            };
          }
          function ot(mr, Zr, jr, nr) {
            for (var ua = 0, st = Zr.length, fa = jr.length, Rr, On; ua < st;) {
              if (nr >= fa) return -1;
              if (Rr = Zr.charCodeAt(ua++), Rr === 37) {
                if (Rr = Zr.charAt(ua++), On = Wr[Rr in l ? Zr.charAt(ua++) : Rr], !On || (nr = On(mr, jr, nr)) < 0) return -1;
              } else if (Rr != jr.charCodeAt(nr++)) return -1;
            }
            return nr;
          }
          function yt(mr, Zr, jr) {
            var nr = $r.exec(Zr.slice(jr));
            return nr ? (mr.p = Vr[nr[0].toLowerCase()], jr + nr[0].length) : -1;
          }
          function Ca(mr, Zr, jr) {
            var nr = ka.exec(Zr.slice(jr));
            return nr ? (mr.w = ra[nr[0].toLowerCase()], jr + nr[0].length) : -1;
          }
          function aa(mr, Zr, jr) {
            var nr = St.exec(Zr.slice(jr));
            return nr ? (mr.w = ea[nr[0].toLowerCase()], jr + nr[0].length) : -1;
          }
          function In(mr, Zr, jr) {
            var nr = ta.exec(Zr.slice(jr));
            return nr ? (mr.m = Ha[nr[0].toLowerCase()], jr + nr[0].length) : -1;
          }
          function Hn(mr, Zr, jr) {
            var nr = pn.exec(Zr.slice(jr));
            return nr ? (mr.m = Ia[nr[0].toLowerCase()], jr + nr[0].length) : -1;
          }
          function Wt(mr, Zr, jr) {
            return ot(mr, oe, Zr, jr);
          }
          function at(mr, Zr, jr) {
            return ot(mr, qe, Zr, jr);
          }
          function sa(mr, Zr, jr) {
            return ot(mr, ke, Zr, jr);
          }
          function Ul(mr) {
            return sr[mr.getDay()];
          }
          function Gl(mr) {
            return vr[mr.getDay()];
          }
          function rl(mr) {
            return Ur[mr.getMonth()];
          }
          function qc(mr) {
            return Mr[mr.getMonth()];
          }
          function Dc(mr) {
            return ir[+(mr.getHours() >= 12)];
          }
          function ku(mr) {
            return 1 + ~~(mr.getMonth() / 3);
          }
          function Cu(mr) {
            return sr[mr.getUTCDay()];
          }
          function Su(mr) {
            return vr[mr.getUTCDay()];
          }
          function Sa(mr) {
            return Ur[mr.getUTCMonth()];
          }
          function Ec(mr) {
            return Mr[mr.getUTCMonth()];
          }
          function $o(mr) {
            return ir[+(mr.getUTCHours() >= 12)];
          }
          function jo(mr) {
            return 1 + ~~(mr.getUTCMonth() / 3);
          }
          return {
            format: function (mr) {
              var Zr = mt(mr += "", yr);
              return Zr.toString = function () {
                return mr;
              }, Zr;
            },
            parse: function (mr) {
              var Zr = Tt(mr += "", !1);
              return Zr.toString = function () {
                return mr;
              }, Zr;
            },
            utcFormat: function (mr) {
              var Zr = mt(mr += "", lt);
              return Zr.toString = function () {
                return mr;
              }, Zr;
            },
            utcParse: function (mr) {
              var Zr = Tt(mr += "", !0);
              return Zr.toString = function () {
                return mr;
              }, Zr;
            }
          };
        }
        var l = {
            "-": "",
            _: " ",
            0: "0"
          },
          o = /^\s*\d+/,
          s = /^%/,
          u = /[\\^$*+?|[\]().{}]/g;
        function f(ae, oe, qe) {
          var ke = ae < 0 ? "-" : "",
            ir = (ke ? -ae : ae) + "",
            vr = ir.length;
          return ke + (vr < qe ? new Array(qe - vr + 1).join(oe) + ir : ir);
        }
        function v(ae) {
          return ae.replace(u, "\\$&");
        }
        function h(ae) {
          return new RegExp("^(?:" + ae.map(v).join("|") + ")", "i");
        }
        function d(ae) {
          for (var oe = {}, qe = -1, ke = ae.length; ++qe < ke;) oe[ae[qe].toLowerCase()] = qe;
          return oe;
        }
        function y(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 1));
          return ke ? (ae.w = +ke[0], qe + ke[0].length) : -1;
        }
        function g(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 1));
          return ke ? (ae.u = +ke[0], qe + ke[0].length) : -1;
        }
        function m(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 2));
          return ke ? (ae.U = +ke[0], qe + ke[0].length) : -1;
        }
        function _(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 2));
          return ke ? (ae.V = +ke[0], qe + ke[0].length) : -1;
        }
        function w(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 2));
          return ke ? (ae.W = +ke[0], qe + ke[0].length) : -1;
        }
        function T(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 4));
          return ke ? (ae.y = +ke[0], qe + ke[0].length) : -1;
        }
        function b(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 2));
          return ke ? (ae.y = +ke[0] + (+ke[0] > 68 ? 1900 : 2e3), qe + ke[0].length) : -1;
        }
        function A(ae, oe, qe) {
          var ke = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(oe.slice(qe, qe + 6));
          return ke ? (ae.Z = ke[1] ? 0 : -(ke[2] + (ke[3] || "00")), qe + ke[0].length) : -1;
        }
        function S(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 1));
          return ke ? (ae.q = ke[0] * 3 - 3, qe + ke[0].length) : -1;
        }
        function k(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 2));
          return ke ? (ae.m = ke[0] - 1, qe + ke[0].length) : -1;
        }
        function q(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 2));
          return ke ? (ae.d = +ke[0], qe + ke[0].length) : -1;
        }
        function D(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 3));
          return ke ? (ae.m = 0, ae.d = +ke[0], qe + ke[0].length) : -1;
        }
        function R(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 2));
          return ke ? (ae.H = +ke[0], qe + ke[0].length) : -1;
        }
        function z(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 2));
          return ke ? (ae.M = +ke[0], qe + ke[0].length) : -1;
        }
        function N(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 2));
          return ke ? (ae.S = +ke[0], qe + ke[0].length) : -1;
        }
        function H(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 3));
          return ke ? (ae.L = +ke[0], qe + ke[0].length) : -1;
        }
        function O(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe, qe + 6));
          return ke ? (ae.L = Math.floor(ke[0] / 1e3), qe + ke[0].length) : -1;
        }
        function J(ae, oe, qe) {
          var ke = s.exec(oe.slice(qe, qe + 1));
          return ke ? qe + ke[0].length : -1;
        }
        function X(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe));
          return ke ? (ae.Q = +ke[0], qe + ke[0].length) : -1;
        }
        function B(ae, oe, qe) {
          var ke = o.exec(oe.slice(qe));
          return ke ? (ae.s = +ke[0], qe + ke[0].length) : -1;
        }
        function I(ae, oe) {
          return f(ae.getDate(), oe, 2);
        }
        function V(ae, oe) {
          return f(ae.getHours(), oe, 2);
        }
        function K(ae, oe) {
          return f(ae.getHours() % 12 || 12, oe, 2);
        }
        function Q(ae, oe) {
          return f(1 + r.timeDay.count(r.timeYear(ae), ae), oe, 3);
        }
        function ie(ae, oe) {
          return f(ae.getMilliseconds(), oe, 3);
        }
        function me(ae, oe) {
          return ie(ae, oe) + "000";
        }
        function pe(ae, oe) {
          return f(ae.getMonth() + 1, oe, 2);
        }
        function ge(ae, oe) {
          return f(ae.getMinutes(), oe, 2);
        }
        function j(ae, oe) {
          return f(ae.getSeconds(), oe, 2);
        }
        function _e(ae) {
          var oe = ae.getDay();
          return oe === 0 ? 7 : oe;
        }
        function se(ae, oe) {
          return f(r.timeSunday.count(r.timeYear(ae) - 1, ae), oe, 2);
        }
        function Se(ae, oe) {
          var qe = ae.getDay();
          return ae = qe >= 4 || qe === 0 ? r.timeThursday(ae) : r.timeThursday.ceil(ae), f(r.timeThursday.count(r.timeYear(ae), ae) + (r.timeYear(ae).getDay() === 4), oe, 2);
        }
        function ve(ae) {
          return ae.getDay();
        }
        function Ae(ae, oe) {
          return f(r.timeMonday.count(r.timeYear(ae) - 1, ae), oe, 2);
        }
        function Y(ae, oe) {
          return f(ae.getFullYear() % 100, oe, 2);
        }
        function re(ae, oe) {
          return f(ae.getFullYear() % 1e4, oe, 4);
        }
        function U(ae) {
          var oe = ae.getTimezoneOffset();
          return (oe > 0 ? "-" : (oe *= -1, "+")) + f(oe / 60 | 0, "0", 2) + f(oe % 60, "0", 2);
        }
        function de(ae, oe) {
          return f(ae.getUTCDate(), oe, 2);
        }
        function be(ae, oe) {
          return f(ae.getUTCHours(), oe, 2);
        }
        function ye(ae, oe) {
          return f(ae.getUTCHours() % 12 || 12, oe, 2);
        }
        function Fe(ae, oe) {
          return f(1 + r.utcDay.count(r.utcYear(ae), ae), oe, 3);
        }
        function Re(ae, oe) {
          return f(ae.getUTCMilliseconds(), oe, 3);
        }
        function Pe(ae, oe) {
          return Re(ae, oe) + "000";
        }
        function Ie(ae, oe) {
          return f(ae.getUTCMonth() + 1, oe, 2);
        }
        function Be(ae, oe) {
          return f(ae.getUTCMinutes(), oe, 2);
        }
        function Ne(ae, oe) {
          return f(ae.getUTCSeconds(), oe, 2);
        }
        function Ee(ae) {
          var oe = ae.getUTCDay();
          return oe === 0 ? 7 : oe;
        }
        function Je(ae, oe) {
          return f(r.utcSunday.count(r.utcYear(ae) - 1, ae), oe, 2);
        }
        function We(ae, oe) {
          var qe = ae.getUTCDay();
          return ae = qe >= 4 || qe === 0 ? r.utcThursday(ae) : r.utcThursday.ceil(ae), f(r.utcThursday.count(r.utcYear(ae), ae) + (r.utcYear(ae).getUTCDay() === 4), oe, 2);
        }
        function ne(ae) {
          return ae.getUTCDay();
        }
        function Me(ae, oe) {
          return f(r.utcMonday.count(r.utcYear(ae) - 1, ae), oe, 2);
        }
        function Ce(ae, oe) {
          return f(ae.getUTCFullYear() % 100, oe, 2);
        }
        function cr(ae, oe) {
          return f(ae.getUTCFullYear() % 1e4, oe, 4);
        }
        function tr() {
          return "+0000";
        }
        function De() {
          return "%";
        }
        function Le(ae) {
          return +ae;
        }
        function Ye(ae) {
          return Math.floor(+ae / 1e3);
        }
        var Ze;
        Ue({
          dateTime: "%x, %X",
          date: "%-m/%-d/%Y",
          time: "%-I:%M:%S %p",
          periods: ["AM", "PM"],
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        });
        function Ue(ae) {
          return Ze = i(ae), e.timeFormat = Ze.format, e.timeParse = Ze.parse, e.utcFormat = Ze.utcFormat, e.utcParse = Ze.utcParse, Ze;
        }
        var Oe = "%Y-%m-%dT%H:%M:%S.%LZ";
        function Ke(ae) {
          return ae.toISOString();
        }
        var fr = Date.prototype.toISOString ? Ke : e.utcFormat(Oe);
        function lr(ae) {
          var oe = new Date(ae);
          return isNaN(oe) ? null : oe;
        }
        var ze = +new Date("2000-01-01T00:00:00.000Z") ? lr : e.utcParse(Oe);
        e.isoFormat = fr, e.isoParse = ze, e.timeFormatDefaultLocale = Ue, e.timeFormatLocale = i, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      });
    });
    var O1 = Z((ov, cb) => {
      (function (e, r) {
        typeof ov == "object" && typeof cb != "undefined" ? r(ov) : (e = typeof globalThis != "undefined" ? globalThis : e || self, r(e.d3 = e.d3 || {}));
      })(ov, function (e) {
        "use strict";

        function r(k) {
          return Math.abs(k = Math.round(k)) >= 1e21 ? k.toLocaleString("en").replace(/,/g, "") : k.toString(10);
        }
        function t(k, q) {
          if ((D = (k = q ? k.toExponential(q - 1) : k.toExponential()).indexOf("e")) < 0) return null;
          var D,
            R = k.slice(0, D);
          return [R.length > 1 ? R[0] + R.slice(2) : R, +k.slice(D + 1)];
        }
        function a(k) {
          return k = t(Math.abs(k)), k ? k[1] : NaN;
        }
        function n(k, q) {
          return function (D, R) {
            for (var z = D.length, N = [], H = 0, O = k[0], J = 0; z > 0 && O > 0 && (J + O + 1 > R && (O = Math.max(1, R - J)), N.push(D.substring(z -= O, z + O)), !((J += O + 1) > R));) O = k[H = (H + 1) % k.length];
            return N.reverse().join(q);
          };
        }
        function i(k) {
          return function (q) {
            return q.replace(/[0-9]/g, function (D) {
              return k[+D];
            });
          };
        }
        var l = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
        function o(k) {
          if (!(q = l.exec(k))) throw new Error("invalid format: " + k);
          var q;
          return new s({
            fill: q[1],
            align: q[2],
            sign: q[3],
            symbol: q[4],
            zero: q[5],
            width: q[6],
            comma: q[7],
            precision: q[8] && q[8].slice(1),
            trim: q[9],
            type: q[10]
          });
        }
        o.prototype = s.prototype;
        function s(k) {
          this.fill = k.fill === void 0 ? " " : k.fill + "", this.align = k.align === void 0 ? ">" : k.align + "", this.sign = k.sign === void 0 ? "-" : k.sign + "", this.symbol = k.symbol === void 0 ? "" : k.symbol + "", this.zero = !!k.zero, this.width = k.width === void 0 ? void 0 : +k.width, this.comma = !!k.comma, this.precision = k.precision === void 0 ? void 0 : +k.precision, this.trim = !!k.trim, this.type = k.type === void 0 ? "" : k.type + "";
        }
        s.prototype.toString = function () {
          return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
        };
        function u(k) {
          e: for (var q = k.length, D = 1, R = -1, z; D < q; ++D) switch (k[D]) {
            case ".":
              R = z = D;
              break;
            case "0":
              R === 0 && (R = D), z = D;
              break;
            default:
              if (!+k[D]) break e;
              R > 0 && (R = 0);
              break;
          }
          return R > 0 ? k.slice(0, R) + k.slice(z + 1) : k;
        }
        var f;
        function v(k, q) {
          var D = t(k, q);
          if (!D) return k + "";
          var R = D[0],
            z = D[1],
            N = z - (f = Math.max(-8, Math.min(8, Math.floor(z / 3))) * 3) + 1,
            H = R.length;
          return N === H ? R : N > H ? R + new Array(N - H + 1).join("0") : N > 0 ? R.slice(0, N) + "." + R.slice(N) : "0." + new Array(1 - N).join("0") + t(k, Math.max(0, q + N - 1))[0];
        }
        function h(k, q) {
          var D = t(k, q);
          if (!D) return k + "";
          var R = D[0],
            z = D[1];
          return z < 0 ? "0." + new Array(-z).join("0") + R : R.length > z + 1 ? R.slice(0, z + 1) + "." + R.slice(z + 1) : R + new Array(z - R.length + 2).join("0");
        }
        var d = {
          "%": function (k, q) {
            return (k * 100).toFixed(q);
          },
          b: function (k) {
            return Math.round(k).toString(2);
          },
          c: function (k) {
            return k + "";
          },
          d: r,
          e: function (k, q) {
            return k.toExponential(q);
          },
          f: function (k, q) {
            return k.toFixed(q);
          },
          g: function (k, q) {
            return k.toPrecision(q);
          },
          o: function (k) {
            return Math.round(k).toString(8);
          },
          p: function (k, q) {
            return h(k * 100, q);
          },
          r: h,
          s: v,
          X: function (k) {
            return Math.round(k).toString(16).toUpperCase();
          },
          x: function (k) {
            return Math.round(k).toString(16);
          }
        };
        function y(k) {
          return k;
        }
        var g = Array.prototype.map,
          m = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
        function _(k) {
          var q = k.grouping === void 0 || k.thousands === void 0 ? y : n(g.call(k.grouping, Number), k.thousands + ""),
            D = k.currency === void 0 ? "" : k.currency[0] + "",
            R = k.currency === void 0 ? "" : k.currency[1] + "",
            z = k.decimal === void 0 ? "." : k.decimal + "",
            N = k.numerals === void 0 ? y : i(g.call(k.numerals, String)),
            H = k.percent === void 0 ? "%" : k.percent + "",
            O = k.minus === void 0 ? "-" : k.minus + "",
            J = k.nan === void 0 ? "NaN" : k.nan + "";
          function X(I) {
            I = o(I);
            var V = I.fill,
              K = I.align,
              Q = I.sign,
              ie = I.symbol,
              me = I.zero,
              pe = I.width,
              ge = I.comma,
              j = I.precision,
              _e = I.trim,
              se = I.type;
            se === "n" ? (ge = !0, se = "g") : d[se] || (j === void 0 && (j = 12), _e = !0, se = "g"), (me || V === "0" && K === "=") && (me = !0, V = "0", K = "=");
            var Se = ie === "$" ? D : ie === "#" && /[boxX]/.test(se) ? "0" + se.toLowerCase() : "",
              ve = ie === "$" ? R : /[%p]/.test(se) ? H : "",
              Ae = d[se],
              Y = /[defgprs%]/.test(se);
            j = j === void 0 ? 6 : /[gprs]/.test(se) ? Math.max(1, Math.min(21, j)) : Math.max(0, Math.min(20, j));
            function re(U) {
              var de = Se,
                be = ve,
                ye,
                Fe,
                Re;
              if (se === "c") be = Ae(U) + be, U = "";else {
                U = +U;
                var Pe = U < 0 || 1 / U < 0;
                if (U = isNaN(U) ? J : Ae(Math.abs(U), j), _e && (U = u(U)), Pe && +U == 0 && Q !== "+" && (Pe = !1), de = (Pe ? Q === "(" ? Q : O : Q === "-" || Q === "(" ? "" : Q) + de, be = (se === "s" ? m[8 + f / 3] : "") + be + (Pe && Q === "(" ? ")" : ""), Y) {
                  for (ye = -1, Fe = U.length; ++ye < Fe;) if (Re = U.charCodeAt(ye), 48 > Re || Re > 57) {
                    be = (Re === 46 ? z + U.slice(ye + 1) : U.slice(ye)) + be, U = U.slice(0, ye);
                    break;
                  }
                }
              }
              ge && !me && (U = q(U, 1 / 0));
              var Ie = de.length + U.length + be.length,
                Be = Ie < pe ? new Array(pe - Ie + 1).join(V) : "";
              switch (ge && me && (U = q(Be + U, Be.length ? pe - be.length : 1 / 0), Be = ""), K) {
                case "<":
                  U = de + U + be + Be;
                  break;
                case "=":
                  U = de + Be + U + be;
                  break;
                case "^":
                  U = Be.slice(0, Ie = Be.length >> 1) + de + U + be + Be.slice(Ie);
                  break;
                default:
                  U = Be + de + U + be;
                  break;
              }
              return N(U);
            }
            return re.toString = function () {
              return I + "";
            }, re;
          }
          function B(I, V) {
            var K = X((I = o(I), I.type = "f", I)),
              Q = Math.max(-8, Math.min(8, Math.floor(a(V) / 3))) * 3,
              ie = Math.pow(10, -Q),
              me = m[8 + Q / 3];
            return function (pe) {
              return K(ie * pe) + me;
            };
          }
          return {
            format: X,
            formatPrefix: B
          };
        }
        var w;
        T({
          decimal: ".",
          thousands: ",",
          grouping: [3],
          currency: ["$", ""],
          minus: "-"
        });
        function T(k) {
          return w = _(k), e.format = w.format, e.formatPrefix = w.formatPrefix, w;
        }
        function b(k) {
          return Math.max(0, -a(Math.abs(k)));
        }
        function A(k, q) {
          return Math.max(0, Math.max(-8, Math.min(8, Math.floor(a(q) / 3))) * 3 - a(Math.abs(k)));
        }
        function S(k, q) {
          return k = Math.abs(k), q = Math.abs(q) - k, Math.max(0, a(q) - a(k)) + 1;
        }
        e.FormatSpecifier = s, e.formatDefaultLocale = T, e.formatLocale = _, e.formatSpecifier = o, e.precisionFixed = b, e.precisionPrefix = A, e.precisionRound = S, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      });
    });
    var hb = Z((sie, vb) => {
      "use strict";

      vb.exports = function (e) {
        for (var r = e.length, t, a = 0; a < r; a++) if (t = e.charCodeAt(a), (t < 9 || t > 13) && t !== 32 && t !== 133 && t !== 160 && t !== 5760 && t !== 6158 && (t < 8192 || t > 8205) && t !== 8232 && t !== 8233 && t !== 8239 && t !== 8287 && t !== 8288 && t !== 12288 && t !== 65279) return !1;
        return !0;
      };
    });
    var Hr = Z((uie, db) => {
      "use strict";

      var nI = hb();
      db.exports = function (e) {
        var r = typeof e;
        if (r === "string") {
          var t = e;
          if (e = +e, e === 0 && nI(t)) return !1;
        } else if (r !== "number") return !1;
        return e - e < 1;
      };
    });
    var Bt = Z((fie, pb) => {
      "use strict";

      pb.exports = {
        BADNUM: void 0,
        FP_SAFE: Number.MAX_VALUE * 1e-4,
        ONEMAXYEAR: 316224e5,
        ONEAVGYEAR: 315576e5,
        ONEMINYEAR: 31536e6,
        ONEMAXQUARTER: 79488e5,
        ONEAVGQUARTER: 78894e5,
        ONEMINQUARTER: 76896e5,
        ONEMAXMONTH: 26784e5,
        ONEAVGMONTH: 26298e5,
        ONEMINMONTH: 24192e5,
        ONEWEEK: 6048e5,
        ONEDAY: 864e5,
        ONEHOUR: 36e5,
        ONEMIN: 6e4,
        ONESEC: 1e3,
        ONEMILLI: 1,
        ONEMICROSEC: .001,
        EPOCHJD: 24405875e-1,
        ALMOST_EQUAL: 1 - 1e-6,
        LOG_CLIP: 10,
        MINUS_SIGN: "\u2212"
      };
    });
    var B1 = Z((sv, mb) => {
      (function (e, r) {
        typeof sv == "object" && typeof mb != "undefined" ? r(sv) : (e = typeof globalThis != "undefined" ? globalThis : e || self, r(e["base64-arraybuffer"] = {}));
      })(sv, function (e) {
        "use strict";

        for (var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256), a = 0; a < r.length; a++) t[r.charCodeAt(a)] = a;
        var n = function (l) {
            var o = new Uint8Array(l),
              s,
              u = o.length,
              f = "";
            for (s = 0; s < u; s += 3) f += r[o[s] >> 2], f += r[(o[s] & 3) << 4 | o[s + 1] >> 4], f += r[(o[s + 1] & 15) << 2 | o[s + 2] >> 6], f += r[o[s + 2] & 63];
            return u % 3 === 2 ? f = f.substring(0, f.length - 1) + "=" : u % 3 === 1 && (f = f.substring(0, f.length - 2) + "=="), f;
          },
          i = function (l) {
            var o = l.length * .75,
              s = l.length,
              u,
              f = 0,
              v,
              h,
              d,
              y;
            l[l.length - 1] === "=" && (o--, l[l.length - 2] === "=" && o--);
            var g = new ArrayBuffer(o),
              m = new Uint8Array(g);
            for (u = 0; u < s; u += 4) v = t[l.charCodeAt(u)], h = t[l.charCodeAt(u + 1)], d = t[l.charCodeAt(u + 2)], y = t[l.charCodeAt(u + 3)], m[f++] = v << 2 | h >> 4, m[f++] = (h & 15) << 4 | d >> 2, m[f++] = (d & 3) << 6 | y & 63;
            return g;
          };
        e.decode = i, e.encode = n, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      });
    });
    var nl = Z((cie, yb) => {
      "use strict";

      yb.exports = function (r) {
        return window && window.process && window.process.versions ? Object.prototype.toString.call(r) === "[object Object]" : Object.prototype.toString.call(r) === "[object Object]" && Object.getPrototypeOf(r).hasOwnProperty("hasOwnProperty");
      };
    });
    var nn = Z(Un => {
      "use strict";

      var iI = B1().decode,
        lI = nl(),
        Y1 = Array.isArray,
        oI = ArrayBuffer,
        sI = DataView;
      function gb(e) {
        return oI.isView(e) && !(e instanceof sI);
      }
      Un.isTypedArray = gb;
      function uv(e) {
        return Y1(e) || gb(e);
      }
      Un.isArrayOrTypedArray = uv;
      function uI(e) {
        return !uv(e[0]);
      }
      Un.isArray1D = uI;
      Un.ensureArray = function (e, r) {
        return Y1(e) || (e = []), e.length = r, e;
      };
      var na = {
        u1c: typeof Uint8ClampedArray == "undefined" ? void 0 : Uint8ClampedArray,
        i1: typeof Int8Array == "undefined" ? void 0 : Int8Array,
        u1: typeof Uint8Array == "undefined" ? void 0 : Uint8Array,
        i2: typeof Int16Array == "undefined" ? void 0 : Int16Array,
        u2: typeof Uint16Array == "undefined" ? void 0 : Uint16Array,
        i4: typeof Int32Array == "undefined" ? void 0 : Int32Array,
        u4: typeof Uint32Array == "undefined" ? void 0 : Uint32Array,
        f4: typeof Float32Array == "undefined" ? void 0 : Float32Array,
        f8: typeof Float64Array == "undefined" ? void 0 : Float64Array
      };
      na.uint8c = na.u1c;
      na.uint8 = na.u1;
      na.int8 = na.i1;
      na.uint16 = na.u2;
      na.int16 = na.i2;
      na.uint32 = na.u4;
      na.int32 = na.i4;
      na.float32 = na.f4;
      na.float64 = na.f8;
      function U1(e) {
        return e.constructor === ArrayBuffer;
      }
      Un.isArrayBuffer = U1;
      Un.decodeTypedArraySpec = function (e) {
        var r = [],
          t = fI(e),
          a = t.dtype,
          n = na[a];
        if (!n) throw new Error('Error in dtype: "' + a + '"');
        var i = n.BYTES_PER_ELEMENT,
          l = t.bdata;
        U1(l) || (l = iI(l));
        var o = t.shape === void 0 ? [l.byteLength / i] : ("" + t.shape).split(",");
        o.reverse();
        var s = o.length,
          u,
          f,
          v = +o[0],
          h = i * v,
          d = 0;
        if (s === 1) r = new n(l);else if (s === 2) for (u = +o[1], f = 0; f < u; f++) r[f] = new n(l, d, v), d += h;else if (s === 3) {
          u = +o[1];
          for (var y = +o[2], g = 0; g < y; g++) for (r[g] = [], f = 0; f < u; f++) r[g][f] = new n(l, d, v), d += h;
        } else throw new Error("ndim: " + s + 'is not supported with the shape:"' + t.shape + '"');
        return r.bdata = t.bdata, r.dtype = t.dtype, r.shape = o.reverse().join(","), e._inputArray = r, r;
      };
      Un.isTypedArraySpec = function (e) {
        return lI(e) && e.hasOwnProperty("dtype") && typeof e.dtype == "string" && e.hasOwnProperty("bdata") && (typeof e.bdata == "string" || U1(e.bdata)) && (e.shape === void 0 || e.hasOwnProperty("shape") && (typeof e.shape == "string" || typeof e.shape == "number"));
      };
      function fI(e) {
        return {
          bdata: e.bdata,
          dtype: e.dtype,
          shape: e.shape
        };
      }
      Un.concat = function () {
        var e = [],
          r = !0,
          t = 0,
          a,
          n,
          i,
          l,
          o,
          s,
          u,
          f;
        for (i = 0; i < arguments.length; i++) l = arguments[i], s = l.length, s && (n ? e.push(l) : (n = l, o = s), Y1(l) ? a = !1 : (r = !1, t ? a !== l.constructor && (a = !1) : a = l.constructor), t += s);
        if (!t) return [];
        if (!e.length) return n;
        if (r) return n.concat.apply(n, e);
        if (a) {
          for (u = new a(t), u.set(n), i = 0; i < e.length; i++) l = e[i], u.set(l, o), o += l.length;
          return u;
        }
        for (u = new Array(t), f = 0; f < n.length; f++) u[f] = n[f];
        for (i = 0; i < e.length; i++) {
          for (l = e[i], f = 0; f < l.length; f++) u[o + f] = l[f];
          o += f;
        }
        return u;
      };
      Un.maxRowLength = function (e) {
        return bb(e, Math.max, 0);
      };
      Un.minRowLength = function (e) {
        return bb(e, Math.min, 1 / 0);
      };
      function bb(e, r, t) {
        if (uv(e)) if (uv(e[0])) {
          for (var a = t, n = 0; n < e.length; n++) a = r(a, e[n].length);
          return a;
        } else return e.length;
        return 0;
      }
    });
    var fv = Z((hie, Mb) => {
      "use strict";

      var xb = Hr(),
        V1 = nn().isArrayOrTypedArray;
      Mb.exports = function (r, t) {
        if (xb(t)) t = String(t);else if (typeof t != "string" || t.substr(t.length - 4) === "[-1]") throw "bad property string";
        var a = t.split("."),
          n,
          i,
          l,
          o;
        for (o = 0; o < a.length; o++) if (String(a[o]).slice(0, 2) === "__") throw "bad property string";
        for (o = 0; o < a.length;) {
          if (n = String(a[o]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/), n) {
            if (n[1]) a[o] = n[1];else if (o === 0) a.splice(0, 1);else throw "bad property string";
            for (i = n[2].substr(1, n[2].length - 2).split("]["), l = 0; l < i.length; l++) o++, a.splice(o, 0, Number(i[l]));
          }
          o++;
        }
        return typeof r != "object" ? dI(r, t, a) : {
          set: wb(r, a, t),
          get: _b(r, a),
          astr: t,
          parts: a,
          obj: r
        };
      };
      function _b(e, r) {
        return function (t) {
          var a = e,
            n,
            i,
            l,
            o,
            s;
          for (o = 0; o < r.length - 1; o++) {
            if (n = r[o], n === -1) {
              for (i = !0, l = [], s = 0; s < a.length; s++) l[s] = _b(a[s], r.slice(o + 1))(t), l[s] !== l[0] && (i = !1);
              return i ? l[0] : l;
            }
            if (typeof n == "number" && !V1(a) || (a = a[n], typeof a != "object" || a === null)) return;
          }
          if (!(typeof a != "object" || a === null) && (l = a[r[o]], !(!t && l === null))) return l;
        };
      }
      var cI = /(^|\.)args\[/;
      function G1(e, r) {
        return e === void 0 || e === null && !r.match(cI);
      }
      function wb(e, r, t) {
        return function (a) {
          var n = e,
            i = "",
            l = [[e, i]],
            o = G1(a, t),
            s,
            u;
          for (u = 0; u < r.length - 1; u++) {
            if (s = r[u], typeof s == "number" && !V1(n)) throw "array index but container is not an array";
            if (s === -1) {
              if (o = !hI(n, r.slice(u + 1), a, t), o) break;
              return;
            }
            if (!Tb(n, s, r[u + 1], o)) break;
            if (n = n[s], typeof n != "object" || n === null) throw "container is not an object";
            i = vI(i, s), l.push([n, i]);
          }
          if (o) {
            if (u === r.length - 1 && (delete n[r[u]], Array.isArray(n) && +r[u] === n.length - 1)) for (; n.length && n[n.length - 1] === void 0;) n.pop();
          } else n[r[u]] = a;
        };
      }
      function vI(e, r) {
        var t = r;
        return xb(r) ? t = "[" + r + "]" : e && (t = "." + r), e + t;
      }
      function hI(e, r, t, a) {
        var n = V1(t),
          i = !0,
          l = t,
          o = a.replace("-1", 0),
          s = n ? !1 : G1(t, o),
          u = r[0],
          f;
        for (f = 0; f < e.length; f++) o = a.replace("-1", f), n && (l = t[f % t.length], s = G1(l, o)), s && (i = !1), Tb(e, f, u, s) && wb(e[f], r, a.replace("-1", f))(l);
        return i;
      }
      function Tb(e, r, t, a) {
        if (e[r] === void 0) {
          if (a) return !1;
          typeof t == "number" ? e[r] = [] : e[r] = {};
        }
        return !0;
      }
      function dI(e, r, t) {
        return {
          set: function () {
            throw "bad container";
          },
          get: function () {},
          astr: r,
          parts: t,
          obj: e
        };
      }
    });
    var Sb = Z((die, Cb) => {
      "use strict";

      var ss = fv(),
        pI = /^\w*$/,
        mI = 0,
        Ab = 1,
        cv = 2,
        kb = 3,
        Ql = 4;
      Cb.exports = function (r, t, a, n) {
        a = a || "name", n = n || "value";
        var i,
          l,
          o,
          s = {};
        t && t.length ? (o = ss(r, t), l = o.get()) : l = r, t = t || "";
        var u = {};
        if (l) for (i = 0; i < l.length; i++) u[l[i][a]] = i;
        var f = pI.test(n),
          v = {
            set: function (h, d) {
              var y = d === null ? Ql : mI;
              if (!l) {
                if (!o || y === Ql) return;
                l = [], o.set(l);
              }
              var g = u[h];
              if (g === void 0) {
                if (y === Ql) return;
                y = y | kb, g = l.length, u[h] = g;
              } else d !== (f ? l[g][n] : ss(l[g], n).get()) && (y = y | cv);
              var m = l[g] = l[g] || {};
              return m[a] = h, f ? m[n] = d : ss(m, n).set(d), d !== null && (y = y & ~Ql), s[g] = s[g] | y, v;
            },
            get: function (h) {
              if (l) {
                var d = u[h];
                if (d !== void 0) return f ? l[d][n] : ss(l[d], n).get();
              }
            },
            rename: function (h, d) {
              var y = u[h];
              return y === void 0 || (s[y] = s[y] | Ab, u[d] = y, delete u[h], l[y][a] = d), v;
            },
            remove: function (h) {
              var d = u[h];
              if (d === void 0) return v;
              var y = l[d];
              if (Object.keys(y).length > 2) return s[d] = s[d] | cv, v.set(h, null);
              if (f) {
                for (i = d; i < l.length; i++) s[i] = s[i] | kb;
                for (i = d; i < l.length; i++) u[l[i][a]]--;
                l.splice(d, 1), delete u[h];
              } else ss(y, n).set(null), s[d] = s[d] | cv | Ql;
              return v;
            },
            constructUpdate: function () {
              for (var h, d, y = {}, g = Object.keys(s), m = 0; m < g.length; m++) d = g[m], h = t + "[" + d + "]", l[d] ? (s[d] & Ab && (y[h + "." + a] = l[d][a]), s[d] & cv && (f ? y[h + "." + n] = s[d] & Ql ? null : l[d][n] : y[h + "." + n] = s[d] & Ql ? null : ss(l[d], n).get())) : y[h] = null;
              return y;
            }
          };
        return v;
      };
    });
    var qb = Z((pie, Lb) => {
      "use strict";

      var yI = /^(.*)(\.[^\.\[\]]+|\[\d\])$/,
        gI = /^[^\.\[\]]+$/;
      Lb.exports = function (e, r) {
        for (; r;) {
          var t = e.match(yI);
          if (t) e = t[1];else if (e.match(gI)) e = "";else throw new Error("bad relativeAttr call:" + [e, r]);
          if (r.charAt(0) === "^") r = r.slice(1);else break;
        }
        return e && r.charAt(0) !== "[" ? e + "." + r : e + r;
      };
    });
    var vv = Z((mie, Db) => {
      "use strict";

      var bI = Hr();
      Db.exports = function (r, t) {
        if (r > 0) return Math.log(r) / Math.LN10;
        var a = Math.log(Math.min(t[0], t[1])) / Math.LN10;
        return bI(a) || (a = Math.log(Math.max(t[0], t[1])) / Math.LN10 - 6), a;
      };
    });
    var Rb = Z((yie, Pb) => {
      "use strict";

      var Eb = nn().isArrayOrTypedArray,
        Iu = nl();
      Pb.exports = function e(r, t) {
        for (var a in t) {
          var n = t[a],
            i = r[a];
          if (i !== n) if (a.charAt(0) === "_" || typeof n == "function") {
            if (a in r) continue;
            r[a] = n;
          } else if (Eb(n) && Eb(i) && Iu(n[0])) {
            if (a === "customdata" || a === "ids") continue;
            for (var l = Math.min(n.length, i.length), o = 0; o < l; o++) i[o] !== n[o] && Iu(n[o]) && Iu(i[o]) && e(i[o], n[o]);
          } else Iu(n) && Iu(i) && (e(i, n), Object.keys(i).length || delete r[a]);
        }
      };
    });
    var us = Z((gie, zb) => {
      "use strict";

      function xI(e, r) {
        var t = e % r;
        return t < 0 ? t + r : t;
      }
      function _I(e, r) {
        return Math.abs(e) > r / 2 ? e - Math.round(e / r) * r : e;
      }
      zb.exports = {
        mod: xI,
        modHalf: _I
      };
    });
    var bn = Z((bie, hv) => {
      (function (e) {
        var r = /^\s+/,
          t = /\s+$/,
          a = 0,
          n = e.round,
          i = e.min,
          l = e.max,
          o = e.random;
        function s(Y, re) {
          if (Y = Y || "", re = re || {}, Y instanceof s) return Y;
          if (!(this instanceof s)) return new s(Y, re);
          var U = u(Y);
          this._originalInput = Y, this._r = U.r, this._g = U.g, this._b = U.b, this._a = U.a, this._roundA = n(100 * this._a) / 100, this._format = re.format || U.format, this._gradientType = re.gradientType, this._r < 1 && (this._r = n(this._r)), this._g < 1 && (this._g = n(this._g)), this._b < 1 && (this._b = n(this._b)), this._ok = U.ok, this._tc_id = a++;
        }
        s.prototype = {
          isDark: function () {
            return this.getBrightness() < 128;
          },
          isLight: function () {
            return !this.isDark();
          },
          isValid: function () {
            return this._ok;
          },
          getOriginalInput: function () {
            return this._originalInput;
          },
          getFormat: function () {
            return this._format;
          },
          getAlpha: function () {
            return this._a;
          },
          getBrightness: function () {
            var Y = this.toRgb();
            return (Y.r * 299 + Y.g * 587 + Y.b * 114) / 1e3;
          },
          getLuminance: function () {
            var Y = this.toRgb(),
              re,
              U,
              de,
              be,
              ye,
              Fe;
            return re = Y.r / 255, U = Y.g / 255, de = Y.b / 255, re <= .03928 ? be = re / 12.92 : be = e.pow((re + .055) / 1.055, 2.4), U <= .03928 ? ye = U / 12.92 : ye = e.pow((U + .055) / 1.055, 2.4), de <= .03928 ? Fe = de / 12.92 : Fe = e.pow((de + .055) / 1.055, 2.4), .2126 * be + .7152 * ye + .0722 * Fe;
          },
          setAlpha: function (Y) {
            return this._a = I(Y), this._roundA = n(100 * this._a) / 100, this;
          },
          toHsv: function () {
            var Y = d(this._r, this._g, this._b);
            return {
              h: Y.h * 360,
              s: Y.s,
              v: Y.v,
              a: this._a
            };
          },
          toHsvString: function () {
            var Y = d(this._r, this._g, this._b),
              re = n(Y.h * 360),
              U = n(Y.s * 100),
              de = n(Y.v * 100);
            return this._a == 1 ? "hsv(" + re + ", " + U + "%, " + de + "%)" : "hsva(" + re + ", " + U + "%, " + de + "%, " + this._roundA + ")";
          },
          toHsl: function () {
            var Y = v(this._r, this._g, this._b);
            return {
              h: Y.h * 360,
              s: Y.s,
              l: Y.l,
              a: this._a
            };
          },
          toHslString: function () {
            var Y = v(this._r, this._g, this._b),
              re = n(Y.h * 360),
              U = n(Y.s * 100),
              de = n(Y.l * 100);
            return this._a == 1 ? "hsl(" + re + ", " + U + "%, " + de + "%)" : "hsla(" + re + ", " + U + "%, " + de + "%, " + this._roundA + ")";
          },
          toHex: function (Y) {
            return g(this._r, this._g, this._b, Y);
          },
          toHexString: function (Y) {
            return "#" + this.toHex(Y);
          },
          toHex8: function (Y) {
            return m(this._r, this._g, this._b, this._a, Y);
          },
          toHex8String: function (Y) {
            return "#" + this.toHex8(Y);
          },
          toRgb: function () {
            return {
              r: n(this._r),
              g: n(this._g),
              b: n(this._b),
              a: this._a
            };
          },
          toRgbString: function () {
            return this._a == 1 ? "rgb(" + n(this._r) + ", " + n(this._g) + ", " + n(this._b) + ")" : "rgba(" + n(this._r) + ", " + n(this._g) + ", " + n(this._b) + ", " + this._roundA + ")";
          },
          toPercentageRgb: function () {
            return {
              r: n(V(this._r, 255) * 100) + "%",
              g: n(V(this._g, 255) * 100) + "%",
              b: n(V(this._b, 255) * 100) + "%",
              a: this._a
            };
          },
          toPercentageRgbString: function () {
            return this._a == 1 ? "rgb(" + n(V(this._r, 255) * 100) + "%, " + n(V(this._g, 255) * 100) + "%, " + n(V(this._b, 255) * 100) + "%)" : "rgba(" + n(V(this._r, 255) * 100) + "%, " + n(V(this._g, 255) * 100) + "%, " + n(V(this._b, 255) * 100) + "%, " + this._roundA + ")";
          },
          toName: function () {
            return this._a === 0 ? "transparent" : this._a < 1 ? !1 : X[g(this._r, this._g, this._b, !0)] || !1;
          },
          toFilter: function (Y) {
            var re = "#" + _(this._r, this._g, this._b, this._a),
              U = re,
              de = this._gradientType ? "GradientType = 1, " : "";
            if (Y) {
              var be = s(Y);
              U = "#" + _(be._r, be._g, be._b, be._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + de + "startColorstr=" + re + ",endColorstr=" + U + ")";
          },
          toString: function (Y) {
            var re = !!Y;
            Y = Y || this._format;
            var U = !1,
              de = this._a < 1 && this._a >= 0,
              be = !re && de && (Y === "hex" || Y === "hex6" || Y === "hex3" || Y === "hex4" || Y === "hex8" || Y === "name");
            return be ? Y === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (Y === "rgb" && (U = this.toRgbString()), Y === "prgb" && (U = this.toPercentageRgbString()), (Y === "hex" || Y === "hex6") && (U = this.toHexString()), Y === "hex3" && (U = this.toHexString(!0)), Y === "hex4" && (U = this.toHex8String(!0)), Y === "hex8" && (U = this.toHex8String()), Y === "name" && (U = this.toName()), Y === "hsl" && (U = this.toHslString()), Y === "hsv" && (U = this.toHsvString()), U || this.toHexString());
          },
          clone: function () {
            return s(this.toString());
          },
          _applyModification: function (Y, re) {
            var U = Y.apply(null, [this].concat([].slice.call(re)));
            return this._r = U._r, this._g = U._g, this._b = U._b, this.setAlpha(U._a), this;
          },
          lighten: function () {
            return this._applyModification(A, arguments);
          },
          brighten: function () {
            return this._applyModification(S, arguments);
          },
          darken: function () {
            return this._applyModification(k, arguments);
          },
          desaturate: function () {
            return this._applyModification(w, arguments);
          },
          saturate: function () {
            return this._applyModification(T, arguments);
          },
          greyscale: function () {
            return this._applyModification(b, arguments);
          },
          spin: function () {
            return this._applyModification(q, arguments);
          },
          _applyCombination: function (Y, re) {
            return Y.apply(null, [this].concat([].slice.call(re)));
          },
          analogous: function () {
            return this._applyCombination(H, arguments);
          },
          complement: function () {
            return this._applyCombination(D, arguments);
          },
          monochromatic: function () {
            return this._applyCombination(O, arguments);
          },
          splitcomplement: function () {
            return this._applyCombination(N, arguments);
          },
          triad: function () {
            return this._applyCombination(R, arguments);
          },
          tetrad: function () {
            return this._applyCombination(z, arguments);
          }
        }, s.fromRatio = function (Y, re) {
          if (typeof Y == "object") {
            var U = {};
            for (var de in Y) Y.hasOwnProperty(de) && (de === "a" ? U[de] = Y[de] : U[de] = ge(Y[de]));
            Y = U;
          }
          return s(Y, re);
        };
        function u(Y) {
          var re = {
              r: 0,
              g: 0,
              b: 0
            },
            U = 1,
            de = null,
            be = null,
            ye = null,
            Fe = !1,
            Re = !1;
          return typeof Y == "string" && (Y = ve(Y)), typeof Y == "object" && (Se(Y.r) && Se(Y.g) && Se(Y.b) ? (re = f(Y.r, Y.g, Y.b), Fe = !0, Re = String(Y.r).substr(-1) === "%" ? "prgb" : "rgb") : Se(Y.h) && Se(Y.s) && Se(Y.v) ? (de = ge(Y.s), be = ge(Y.v), re = y(Y.h, de, be), Fe = !0, Re = "hsv") : Se(Y.h) && Se(Y.s) && Se(Y.l) && (de = ge(Y.s), ye = ge(Y.l), re = h(Y.h, de, ye), Fe = !0, Re = "hsl"), Y.hasOwnProperty("a") && (U = Y.a)), U = I(U), {
            ok: Fe,
            format: Y.format || Re,
            r: i(255, l(re.r, 0)),
            g: i(255, l(re.g, 0)),
            b: i(255, l(re.b, 0)),
            a: U
          };
        }
        function f(Y, re, U) {
          return {
            r: V(Y, 255) * 255,
            g: V(re, 255) * 255,
            b: V(U, 255) * 255
          };
        }
        function v(Y, re, U) {
          Y = V(Y, 255), re = V(re, 255), U = V(U, 255);
          var de = l(Y, re, U),
            be = i(Y, re, U),
            ye,
            Fe,
            Re = (de + be) / 2;
          if (de == be) ye = Fe = 0;else {
            var Pe = de - be;
            switch (Fe = Re > .5 ? Pe / (2 - de - be) : Pe / (de + be), de) {
              case Y:
                ye = (re - U) / Pe + (re < U ? 6 : 0);
                break;
              case re:
                ye = (U - Y) / Pe + 2;
                break;
              case U:
                ye = (Y - re) / Pe + 4;
                break;
            }
            ye /= 6;
          }
          return {
            h: ye,
            s: Fe,
            l: Re
          };
        }
        function h(Y, re, U) {
          var de, be, ye;
          Y = V(Y, 360), re = V(re, 100), U = V(U, 100);
          function Fe(Ie, Be, Ne) {
            return Ne < 0 && (Ne += 1), Ne > 1 && (Ne -= 1), Ne < 1 / 6 ? Ie + (Be - Ie) * 6 * Ne : Ne < 1 / 2 ? Be : Ne < 2 / 3 ? Ie + (Be - Ie) * (2 / 3 - Ne) * 6 : Ie;
          }
          if (re === 0) de = be = ye = U;else {
            var Re = U < .5 ? U * (1 + re) : U + re - U * re,
              Pe = 2 * U - Re;
            de = Fe(Pe, Re, Y + 1 / 3), be = Fe(Pe, Re, Y), ye = Fe(Pe, Re, Y - 1 / 3);
          }
          return {
            r: de * 255,
            g: be * 255,
            b: ye * 255
          };
        }
        function d(Y, re, U) {
          Y = V(Y, 255), re = V(re, 255), U = V(U, 255);
          var de = l(Y, re, U),
            be = i(Y, re, U),
            ye,
            Fe,
            Re = de,
            Pe = de - be;
          if (Fe = de === 0 ? 0 : Pe / de, de == be) ye = 0;else {
            switch (de) {
              case Y:
                ye = (re - U) / Pe + (re < U ? 6 : 0);
                break;
              case re:
                ye = (U - Y) / Pe + 2;
                break;
              case U:
                ye = (Y - re) / Pe + 4;
                break;
            }
            ye /= 6;
          }
          return {
            h: ye,
            s: Fe,
            v: Re
          };
        }
        function y(Y, re, U) {
          Y = V(Y, 360) * 6, re = V(re, 100), U = V(U, 100);
          var de = e.floor(Y),
            be = Y - de,
            ye = U * (1 - re),
            Fe = U * (1 - be * re),
            Re = U * (1 - (1 - be) * re),
            Pe = de % 6,
            Ie = [U, Fe, ye, ye, Re, U][Pe],
            Be = [Re, U, U, Fe, ye, ye][Pe],
            Ne = [ye, ye, Re, U, U, Fe][Pe];
          return {
            r: Ie * 255,
            g: Be * 255,
            b: Ne * 255
          };
        }
        function g(Y, re, U, de) {
          var be = [pe(n(Y).toString(16)), pe(n(re).toString(16)), pe(n(U).toString(16))];
          return de && be[0].charAt(0) == be[0].charAt(1) && be[1].charAt(0) == be[1].charAt(1) && be[2].charAt(0) == be[2].charAt(1) ? be[0].charAt(0) + be[1].charAt(0) + be[2].charAt(0) : be.join("");
        }
        function m(Y, re, U, de, be) {
          var ye = [pe(n(Y).toString(16)), pe(n(re).toString(16)), pe(n(U).toString(16)), pe(j(de))];
          return be && ye[0].charAt(0) == ye[0].charAt(1) && ye[1].charAt(0) == ye[1].charAt(1) && ye[2].charAt(0) == ye[2].charAt(1) && ye[3].charAt(0) == ye[3].charAt(1) ? ye[0].charAt(0) + ye[1].charAt(0) + ye[2].charAt(0) + ye[3].charAt(0) : ye.join("");
        }
        function _(Y, re, U, de) {
          var be = [pe(j(de)), pe(n(Y).toString(16)), pe(n(re).toString(16)), pe(n(U).toString(16))];
          return be.join("");
        }
        s.equals = function (Y, re) {
          return !Y || !re ? !1 : s(Y).toRgbString() == s(re).toRgbString();
        }, s.random = function () {
          return s.fromRatio({
            r: o(),
            g: o(),
            b: o()
          });
        };
        function w(Y, re) {
          re = re === 0 ? 0 : re || 10;
          var U = s(Y).toHsl();
          return U.s -= re / 100, U.s = K(U.s), s(U);
        }
        function T(Y, re) {
          re = re === 0 ? 0 : re || 10;
          var U = s(Y).toHsl();
          return U.s += re / 100, U.s = K(U.s), s(U);
        }
        function b(Y) {
          return s(Y).desaturate(100);
        }
        function A(Y, re) {
          re = re === 0 ? 0 : re || 10;
          var U = s(Y).toHsl();
          return U.l += re / 100, U.l = K(U.l), s(U);
        }
        function S(Y, re) {
          re = re === 0 ? 0 : re || 10;
          var U = s(Y).toRgb();
          return U.r = l(0, i(255, U.r - n(255 * -(re / 100)))), U.g = l(0, i(255, U.g - n(255 * -(re / 100)))), U.b = l(0, i(255, U.b - n(255 * -(re / 100)))), s(U);
        }
        function k(Y, re) {
          re = re === 0 ? 0 : re || 10;
          var U = s(Y).toHsl();
          return U.l -= re / 100, U.l = K(U.l), s(U);
        }
        function q(Y, re) {
          var U = s(Y).toHsl(),
            de = (U.h + re) % 360;
          return U.h = de < 0 ? 360 + de : de, s(U);
        }
        function D(Y) {
          var re = s(Y).toHsl();
          return re.h = (re.h + 180) % 360, s(re);
        }
        function R(Y) {
          var re = s(Y).toHsl(),
            U = re.h;
          return [s(Y), s({
            h: (U + 120) % 360,
            s: re.s,
            l: re.l
          }), s({
            h: (U + 240) % 360,
            s: re.s,
            l: re.l
          })];
        }
        function z(Y) {
          var re = s(Y).toHsl(),
            U = re.h;
          return [s(Y), s({
            h: (U + 90) % 360,
            s: re.s,
            l: re.l
          }), s({
            h: (U + 180) % 360,
            s: re.s,
            l: re.l
          }), s({
            h: (U + 270) % 360,
            s: re.s,
            l: re.l
          })];
        }
        function N(Y) {
          var re = s(Y).toHsl(),
            U = re.h;
          return [s(Y), s({
            h: (U + 72) % 360,
            s: re.s,
            l: re.l
          }), s({
            h: (U + 216) % 360,
            s: re.s,
            l: re.l
          })];
        }
        function H(Y, re, U) {
          re = re || 6, U = U || 30;
          var de = s(Y).toHsl(),
            be = 360 / U,
            ye = [s(Y)];
          for (de.h = (de.h - (be * re >> 1) + 720) % 360; --re;) de.h = (de.h + be) % 360, ye.push(s(de));
          return ye;
        }
        function O(Y, re) {
          re = re || 6;
          for (var U = s(Y).toHsv(), de = U.h, be = U.s, ye = U.v, Fe = [], Re = 1 / re; re--;) Fe.push(s({
            h: de,
            s: be,
            v: ye
          })), ye = (ye + Re) % 1;
          return Fe;
        }
        s.mix = function (Y, re, U) {
          U = U === 0 ? 0 : U || 50;
          var de = s(Y).toRgb(),
            be = s(re).toRgb(),
            ye = U / 100,
            Fe = {
              r: (be.r - de.r) * ye + de.r,
              g: (be.g - de.g) * ye + de.g,
              b: (be.b - de.b) * ye + de.b,
              a: (be.a - de.a) * ye + de.a
            };
          return s(Fe);
        }, s.readability = function (Y, re) {
          var U = s(Y),
            de = s(re);
          return (e.max(U.getLuminance(), de.getLuminance()) + .05) / (e.min(U.getLuminance(), de.getLuminance()) + .05);
        }, s.isReadable = function (Y, re, U) {
          var de = s.readability(Y, re),
            be,
            ye;
          switch (ye = !1, be = Ae(U), be.level + be.size) {
            case "AAsmall":
            case "AAAlarge":
              ye = de >= 4.5;
              break;
            case "AAlarge":
              ye = de >= 3;
              break;
            case "AAAsmall":
              ye = de >= 7;
              break;
          }
          return ye;
        }, s.mostReadable = function (Y, re, U) {
          var de = null,
            be = 0,
            ye,
            Fe,
            Re,
            Pe;
          U = U || {}, Fe = U.includeFallbackColors, Re = U.level, Pe = U.size;
          for (var Ie = 0; Ie < re.length; Ie++) ye = s.readability(Y, re[Ie]), ye > be && (be = ye, de = s(re[Ie]));
          return s.isReadable(Y, de, {
            level: Re,
            size: Pe
          }) || !Fe ? de : (U.includeFallbackColors = !1, s.mostReadable(Y, ["#fff", "#000"], U));
        };
        var J = s.names = {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "0ff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000",
            blanchedalmond: "ffebcd",
            blue: "00f",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            burntsienna: "ea7e5d",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "0ff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgreen: "006400",
            darkgrey: "a9a9a9",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkslategrey: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dimgrey: "696969",
            dodgerblue: "1e90ff",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "f0f",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            green: "008000",
            greenyellow: "adff2f",
            grey: "808080",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgray: "d3d3d3",
            lightgreen: "90ee90",
            lightgrey: "d3d3d3",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslategray: "789",
            lightslategrey: "789",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "0f0",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "f0f",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370db",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "db7093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            rebeccapurple: "663399",
            red: "f00",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            slategrey: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            wheat: "f5deb3",
            white: "fff",
            whitesmoke: "f5f5f5",
            yellow: "ff0",
            yellowgreen: "9acd32"
          },
          X = s.hexNames = B(J);
        function B(Y) {
          var re = {};
          for (var U in Y) Y.hasOwnProperty(U) && (re[Y[U]] = U);
          return re;
        }
        function I(Y) {
          return Y = parseFloat(Y), (isNaN(Y) || Y < 0 || Y > 1) && (Y = 1), Y;
        }
        function V(Y, re) {
          ie(Y) && (Y = "100%");
          var U = me(Y);
          return Y = i(re, l(0, parseFloat(Y))), U && (Y = parseInt(Y * re, 10) / 100), e.abs(Y - re) < 1e-6 ? 1 : Y % re / parseFloat(re);
        }
        function K(Y) {
          return i(1, l(0, Y));
        }
        function Q(Y) {
          return parseInt(Y, 16);
        }
        function ie(Y) {
          return typeof Y == "string" && Y.indexOf(".") != -1 && parseFloat(Y) === 1;
        }
        function me(Y) {
          return typeof Y == "string" && Y.indexOf("%") != -1;
        }
        function pe(Y) {
          return Y.length == 1 ? "0" + Y : "" + Y;
        }
        function ge(Y) {
          return Y <= 1 && (Y = Y * 100 + "%"), Y;
        }
        function j(Y) {
          return e.round(parseFloat(Y) * 255).toString(16);
        }
        function _e(Y) {
          return Q(Y) / 255;
        }
        var se = function () {
          var Y = "[-\\+]?\\d+%?",
            re = "[-\\+]?\\d*\\.\\d+%?",
            U = "(?:" + re + ")|(?:" + Y + ")",
            de = "[\\s|\\(]+(" + U + ")[,|\\s]+(" + U + ")[,|\\s]+(" + U + ")\\s*\\)?",
            be = "[\\s|\\(]+(" + U + ")[,|\\s]+(" + U + ")[,|\\s]+(" + U + ")[,|\\s]+(" + U + ")\\s*\\)?";
          return {
            CSS_UNIT: new RegExp(U),
            rgb: new RegExp("rgb" + de),
            rgba: new RegExp("rgba" + be),
            hsl: new RegExp("hsl" + de),
            hsla: new RegExp("hsla" + be),
            hsv: new RegExp("hsv" + de),
            hsva: new RegExp("hsva" + be),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
          };
        }();
        function Se(Y) {
          return !!se.CSS_UNIT.exec(Y);
        }
        function ve(Y) {
          Y = Y.replace(r, "").replace(t, "").toLowerCase();
          var re = !1;
          if (J[Y]) Y = J[Y], re = !0;else if (Y == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
          };
          var U;
          return (U = se.rgb.exec(Y)) ? {
            r: U[1],
            g: U[2],
            b: U[3]
          } : (U = se.rgba.exec(Y)) ? {
            r: U[1],
            g: U[2],
            b: U[3],
            a: U[4]
          } : (U = se.hsl.exec(Y)) ? {
            h: U[1],
            s: U[2],
            l: U[3]
          } : (U = se.hsla.exec(Y)) ? {
            h: U[1],
            s: U[2],
            l: U[3],
            a: U[4]
          } : (U = se.hsv.exec(Y)) ? {
            h: U[1],
            s: U[2],
            v: U[3]
          } : (U = se.hsva.exec(Y)) ? {
            h: U[1],
            s: U[2],
            v: U[3],
            a: U[4]
          } : (U = se.hex8.exec(Y)) ? {
            r: Q(U[1]),
            g: Q(U[2]),
            b: Q(U[3]),
            a: _e(U[4]),
            format: re ? "name" : "hex8"
          } : (U = se.hex6.exec(Y)) ? {
            r: Q(U[1]),
            g: Q(U[2]),
            b: Q(U[3]),
            format: re ? "name" : "hex"
          } : (U = se.hex4.exec(Y)) ? {
            r: Q(U[1] + "" + U[1]),
            g: Q(U[2] + "" + U[2]),
            b: Q(U[3] + "" + U[3]),
            a: _e(U[4] + "" + U[4]),
            format: re ? "name" : "hex8"
          } : (U = se.hex3.exec(Y)) ? {
            r: Q(U[1] + "" + U[1]),
            g: Q(U[2] + "" + U[2]),
            b: Q(U[3] + "" + U[3]),
            format: re ? "name" : "hex"
          } : !1;
        }
        function Ae(Y) {
          var re, U;
          return Y = Y || {
            level: "AA",
            size: "small"
          }, re = (Y.level || "AA").toUpperCase(), U = (Y.size || "small").toLowerCase(), re !== "AA" && re !== "AAA" && (re = "AA"), U !== "small" && U !== "large" && (U = "small"), {
            level: re,
            size: U
          };
        }
        typeof hv != "undefined" && hv.exports ? hv.exports = s : window.tinycolor = s;
      })(Math);
    });
    var Yt = Z(Bu => {
      "use strict";

      var Nb = nl(),
        Hu = Array.isArray;
      function wI(e, r) {
        var t, a;
        for (t = 0; t < e.length; t++) {
          if (a = e[t], a !== null && typeof a == "object") return !1;
          a !== void 0 && (r[t] = a);
        }
        return !0;
      }
      Bu.extendFlat = function () {
        return Ou(arguments, !1, !1, !1);
      };
      Bu.extendDeep = function () {
        return Ou(arguments, !0, !1, !1);
      };
      Bu.extendDeepAll = function () {
        return Ou(arguments, !0, !0, !1);
      };
      Bu.extendDeepNoArrays = function () {
        return Ou(arguments, !0, !1, !0);
      };
      function Ou(e, r, t, a) {
        var n = e[0],
          i = e.length,
          l,
          o,
          s,
          u,
          f,
          v,
          h;
        if (i === 2 && Hu(n) && Hu(e[1]) && n.length === 0) {
          if (h = wI(e[1], n), h) return n;
          n.splice(0, n.length);
        }
        for (var d = 1; d < i; d++) {
          l = e[d];
          for (o in l) s = n[o], u = l[o], a && Hu(u) ? n[o] = u : r && u && (Nb(u) || (f = Hu(u))) ? (f ? (f = !1, v = s && Hu(s) ? s : []) : v = s && Nb(s) ? s : {}, n[o] = Ou([v, u], r, t, a)) : (typeof u != "undefined" || t) && (n[o] = u);
        }
        return n;
      }
    });
    var ha = Z((_ie, Fb) => {
      "use strict";

      Fb.exports = function (e) {
        var r = e.variantValues,
          t = e.editType,
          a = e.colorEditType;
        a === void 0 && (a = t);
        var n = {
          editType: t,
          valType: "integer",
          min: 1,
          max: 1e3,
          extras: ["normal", "bold"],
          dflt: "normal"
        };
        e.noNumericWeightValues && (n.valType = "enumerated", n.values = n.extras, n.extras = void 0, n.min = void 0, n.max = void 0);
        var i = {
          family: {
            valType: "string",
            noBlank: !0,
            strict: !0,
            editType: t
          },
          size: {
            valType: "number",
            min: 1,
            editType: t
          },
          color: {
            valType: "color",
            editType: a
          },
          weight: n,
          style: {
            editType: t,
            valType: "enumerated",
            values: ["normal", "italic"],
            dflt: "normal"
          },
          variant: e.noFontVariant ? void 0 : {
            editType: t,
            valType: "enumerated",
            values: r || ["normal", "small-caps", "all-small-caps", "all-petite-caps", "petite-caps", "unicase"],
            dflt: "normal"
          },
          textcase: e.noFontTextcase ? void 0 : {
            editType: t,
            valType: "enumerated",
            values: ["normal", "word caps", "upper", "lower"],
            dflt: "normal"
          },
          lineposition: e.noFontLineposition ? void 0 : {
            editType: t,
            valType: "flaglist",
            flags: ["under", "over", "through"],
            extras: ["none"],
            dflt: "none"
          },
          shadow: e.noFontShadow ? void 0 : {
            editType: t,
            valType: "string",
            dflt: e.autoShadowDflt ? "auto" : "none"
          },
          editType: t
        };
        return e.autoSize && (i.size.dflt = "auto"), e.autoColor && (i.color.dflt = "auto"), e.arrayOk && (i.family.arrayOk = !0, i.weight.arrayOk = !0, i.style.arrayOk = !0, e.noFontVariant || (i.variant.arrayOk = !0), e.noFontTextcase || (i.textcase.arrayOk = !0), e.noFontLineposition || (i.lineposition.arrayOk = !0), e.noFontShadow || (i.shadow.arrayOk = !0), i.size.arrayOk = !0, i.color.arrayOk = !0), i;
      };
    });
    var Yu = Z((wie, Ib) => {
      "use strict";

      Ib.exports = {
        YANGLE: 60,
        HOVERARROWSIZE: 6,
        HOVERTEXTPAD: 3,
        HOVERFONTSIZE: 13,
        HOVERFONT: "Arial, sans-serif",
        HOVERMINTIME: 50,
        HOVERID: "-hover"
      };
    });
    var fs = Z((Tie, Bb) => {
      "use strict";

      var Hb = Yu(),
        Ob = ha(),
        W1 = Ob({
          editType: "none"
        });
      W1.family.dflt = Hb.HOVERFONT;
      W1.size.dflt = Hb.HOVERFONTSIZE;
      Bb.exports = {
        clickmode: {
          valType: "flaglist",
          flags: ["event", "select"],
          dflt: "event",
          editType: "plot",
          extras: ["none"]
        },
        dragmode: {
          valType: "enumerated",
          values: ["zoom", "pan", "select", "lasso", "drawclosedpath", "drawopenpath", "drawline", "drawrect", "drawcircle", "orbit", "turntable", !1],
          dflt: "zoom",
          editType: "modebar"
        },
        hovermode: {
          valType: "enumerated",
          values: ["x", "y", "closest", !1, "x unified", "y unified"],
          dflt: "closest",
          editType: "modebar"
        },
        hoversubplots: {
          valType: "enumerated",
          values: ["single", "overlaying", "axis"],
          dflt: "overlaying",
          editType: "none"
        },
        hoverdistance: {
          valType: "integer",
          min: -1,
          dflt: 20,
          editType: "none"
        },
        spikedistance: {
          valType: "integer",
          min: -1,
          dflt: -1,
          editType: "none"
        },
        hoverlabel: {
          bgcolor: {
            valType: "color",
            editType: "none"
          },
          bordercolor: {
            valType: "color",
            editType: "none"
          },
          font: W1,
          grouptitlefont: Ob({
            editType: "none"
          }),
          align: {
            valType: "enumerated",
            values: ["left", "right", "auto"],
            dflt: "auto",
            editType: "none"
          },
          namelength: {
            valType: "integer",
            min: -1,
            dflt: 15,
            editType: "none"
          },
          editType: "none"
        },
        selectdirection: {
          valType: "enumerated",
          values: ["h", "v", "d", "any"],
          dflt: "any",
          editType: "none"
        }
      };
    });
    var mv = Z((Mie, Yb) => {
      "use strict";

      var TI = ha(),
        dv = fs().hoverlabel,
        pv = Yt().extendFlat;
      Yb.exports = {
        hoverlabel: {
          bgcolor: pv({}, dv.bgcolor, {
            arrayOk: !0
          }),
          bordercolor: pv({}, dv.bordercolor, {
            arrayOk: !0
          }),
          font: TI({
            arrayOk: !0,
            editType: "none"
          }),
          align: pv({}, dv.align, {
            arrayOk: !0
          }),
          namelength: pv({}, dv.namelength, {
            arrayOk: !0
          }),
          editType: "none"
        }
      };
    });
    var Gn = Z((Aie, Ub) => {
      "use strict";

      var MI = ha(),
        AI = mv();
      Ub.exports = {
        type: {
          valType: "enumerated",
          values: [],
          dflt: "scatter",
          editType: "calc+clearAxisTypes",
          _noTemplating: !0
        },
        visible: {
          valType: "enumerated",
          values: [!0, !1, "legendonly"],
          dflt: !0,
          editType: "calc"
        },
        showlegend: {
          valType: "boolean",
          dflt: !0,
          editType: "style"
        },
        legend: {
          valType: "subplotid",
          dflt: "legend",
          editType: "style"
        },
        legendgroup: {
          valType: "string",
          dflt: "",
          editType: "style"
        },
        legendgrouptitle: {
          text: {
            valType: "string",
            dflt: "",
            editType: "style"
          },
          font: MI({
            editType: "style"
          }),
          editType: "style"
        },
        legendrank: {
          valType: "number",
          dflt: 1e3,
          editType: "style"
        },
        legendwidth: {
          valType: "number",
          min: 0,
          editType: "style"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "style"
        },
        name: {
          valType: "string",
          editType: "style"
        },
        uid: {
          valType: "string",
          editType: "plot",
          anim: !0
        },
        ids: {
          valType: "data_array",
          editType: "calc",
          anim: !0
        },
        customdata: {
          valType: "data_array",
          editType: "calc"
        },
        meta: {
          valType: "any",
          arrayOk: !0,
          editType: "plot"
        },
        selectedpoints: {
          valType: "any",
          editType: "calc"
        },
        hoverinfo: {
          valType: "flaglist",
          flags: ["x", "y", "z", "text", "name"],
          extras: ["all", "none", "skip"],
          arrayOk: !0,
          dflt: "all",
          editType: "none"
        },
        hoverlabel: AI.hoverlabel,
        stream: {
          token: {
            valType: "string",
            noBlank: !0,
            strict: !0,
            editType: "calc"
          },
          maxpoints: {
            valType: "number",
            min: 0,
            max: 1e4,
            dflt: 500,
            editType: "calc"
          },
          editType: "calc"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        }
      };
    });
    var $l = Z((kie, Wb) => {
      "use strict";

      var kI = bn(),
        yv = {
          Greys: [[0, "rgb(0,0,0)"], [1, "rgb(255,255,255)"]],
          YlGnBu: [[0, "rgb(8,29,88)"], [.125, "rgb(37,52,148)"], [.25, "rgb(34,94,168)"], [.375, "rgb(29,145,192)"], [.5, "rgb(65,182,196)"], [.625, "rgb(127,205,187)"], [.75, "rgb(199,233,180)"], [.875, "rgb(237,248,217)"], [1, "rgb(255,255,217)"]],
          Greens: [[0, "rgb(0,68,27)"], [.125, "rgb(0,109,44)"], [.25, "rgb(35,139,69)"], [.375, "rgb(65,171,93)"], [.5, "rgb(116,196,118)"], [.625, "rgb(161,217,155)"], [.75, "rgb(199,233,192)"], [.875, "rgb(229,245,224)"], [1, "rgb(247,252,245)"]],
          YlOrRd: [[0, "rgb(128,0,38)"], [.125, "rgb(189,0,38)"], [.25, "rgb(227,26,28)"], [.375, "rgb(252,78,42)"], [.5, "rgb(253,141,60)"], [.625, "rgb(254,178,76)"], [.75, "rgb(254,217,118)"], [.875, "rgb(255,237,160)"], [1, "rgb(255,255,204)"]],
          Bluered: [[0, "rgb(0,0,255)"], [1, "rgb(255,0,0)"]],
          RdBu: [[0, "rgb(5,10,172)"], [.35, "rgb(106,137,247)"], [.5, "rgb(190,190,190)"], [.6, "rgb(220,170,132)"], [.7, "rgb(230,145,90)"], [1, "rgb(178,10,28)"]],
          Reds: [[0, "rgb(220,220,220)"], [.2, "rgb(245,195,157)"], [.4, "rgb(245,160,105)"], [1, "rgb(178,10,28)"]],
          Blues: [[0, "rgb(5,10,172)"], [.35, "rgb(40,60,190)"], [.5, "rgb(70,100,245)"], [.6, "rgb(90,120,245)"], [.7, "rgb(106,137,247)"], [1, "rgb(220,220,220)"]],
          Picnic: [[0, "rgb(0,0,255)"], [.1, "rgb(51,153,255)"], [.2, "rgb(102,204,255)"], [.3, "rgb(153,204,255)"], [.4, "rgb(204,204,255)"], [.5, "rgb(255,255,255)"], [.6, "rgb(255,204,255)"], [.7, "rgb(255,153,255)"], [.8, "rgb(255,102,204)"], [.9, "rgb(255,102,102)"], [1, "rgb(255,0,0)"]],
          Rainbow: [[0, "rgb(150,0,90)"], [.125, "rgb(0,0,200)"], [.25, "rgb(0,25,255)"], [.375, "rgb(0,152,255)"], [.5, "rgb(44,255,150)"], [.625, "rgb(151,255,0)"], [.75, "rgb(255,234,0)"], [.875, "rgb(255,111,0)"], [1, "rgb(255,0,0)"]],
          Portland: [[0, "rgb(12,51,131)"], [.25, "rgb(10,136,186)"], [.5, "rgb(242,211,56)"], [.75, "rgb(242,143,56)"], [1, "rgb(217,30,30)"]],
          Jet: [[0, "rgb(0,0,131)"], [.125, "rgb(0,60,170)"], [.375, "rgb(5,255,255)"], [.625, "rgb(255,255,0)"], [.875, "rgb(250,0,0)"], [1, "rgb(128,0,0)"]],
          Hot: [[0, "rgb(0,0,0)"], [.3, "rgb(230,0,0)"], [.6, "rgb(255,210,0)"], [1, "rgb(255,255,255)"]],
          Blackbody: [[0, "rgb(0,0,0)"], [.2, "rgb(230,0,0)"], [.4, "rgb(230,210,0)"], [.7, "rgb(255,255,255)"], [1, "rgb(160,200,255)"]],
          Earth: [[0, "rgb(0,0,130)"], [.1, "rgb(0,180,180)"], [.2, "rgb(40,210,40)"], [.4, "rgb(230,230,50)"], [.6, "rgb(120,70,20)"], [1, "rgb(255,255,255)"]],
          Electric: [[0, "rgb(0,0,0)"], [.15, "rgb(30,0,100)"], [.4, "rgb(120,0,100)"], [.6, "rgb(160,90,0)"], [.8, "rgb(230,200,0)"], [1, "rgb(255,250,220)"]],
          Viridis: [[0, "#440154"], [.06274509803921569, "#48186a"], [.12549019607843137, "#472d7b"], [.18823529411764706, "#424086"], [.25098039215686274, "#3b528b"], [.3137254901960784, "#33638d"], [.3764705882352941, "#2c728e"], [.4392156862745098, "#26828e"], [.5019607843137255, "#21918c"], [.5647058823529412, "#1fa088"], [.6274509803921569, "#28ae80"], [.6901960784313725, "#3fbc73"], [.7529411764705882, "#5ec962"], [.8156862745098039, "#84d44b"], [.8784313725490196, "#addc30"], [.9411764705882353, "#d8e219"], [1, "#fde725"]],
          Cividis: [[0, "rgb(0,32,76)"], [.058824, "rgb(0,42,102)"], [.117647, "rgb(0,52,110)"], [.176471, "rgb(39,63,108)"], [.235294, "rgb(60,74,107)"], [.294118, "rgb(76,85,107)"], [.352941, "rgb(91,95,109)"], [.411765, "rgb(104,106,112)"], [.470588, "rgb(117,117,117)"], [.529412, "rgb(131,129,120)"], [.588235, "rgb(146,140,120)"], [.647059, "rgb(161,152,118)"], [.705882, "rgb(176,165,114)"], [.764706, "rgb(192,177,109)"], [.823529, "rgb(209,191,102)"], [.882353, "rgb(225,204,92)"], [.941176, "rgb(243,219,79)"], [1, "rgb(255,233,69)"]]
        },
        Gb = yv.RdBu;
      function CI(e, r) {
        if (r || (r = Gb), !e) return r;
        function t() {
          try {
            e = yv[e] || JSON.parse(e);
          } catch (a) {
            e = r;
          }
        }
        return typeof e == "string" && (t(), typeof e == "string" && t()), Vb(e) ? e : r;
      }
      function Vb(e) {
        var r = 0;
        if (!Array.isArray(e) || e.length < 2 || !e[0] || !e[e.length - 1] || +e[0][0] != 0 || +e[e.length - 1][0] != 1) return !1;
        for (var t = 0; t < e.length; t++) {
          var a = e[t];
          if (a.length !== 2 || +a[0] < r || !kI(a[1]).isValid()) return !1;
          r = +a[0];
        }
        return !0;
      }
      function SI(e) {
        return yv[e] !== void 0 ? !0 : Vb(e);
      }
      Wb.exports = {
        scales: yv,
        defaultScale: Gb,
        get: CI,
        isValid: SI
      };
    });
    var hi = Z(jl => {
      "use strict";

      jl.defaults = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"];
      jl.defaultLine = "#444";
      jl.lightLine = "#eee";
      jl.background = "#fff";
      jl.borderLine = "#BEC8D9";
      jl.lightFraction = 100 * 10 / 11;
    });
    var Er = Z((Sie, Zb) => {
      "use strict";

      var Wa = bn(),
        LI = Hr(),
        qI = nn().isTypedArray,
        Zt = Zb.exports = {},
        gv = hi();
      Zt.defaults = gv.defaults;
      var DI = Zt.defaultLine = gv.defaultLine;
      Zt.lightLine = gv.lightLine;
      var X1 = Zt.background = gv.background;
      Zt.tinyRGB = function (e) {
        var r = e.toRgb();
        return "rgb(" + Math.round(r.r) + ", " + Math.round(r.g) + ", " + Math.round(r.b) + ")";
      };
      Zt.rgb = function (e) {
        return Zt.tinyRGB(Wa(e));
      };
      Zt.opacity = function (e) {
        return e ? Wa(e).getAlpha() : 0;
      };
      Zt.addOpacity = function (e, r) {
        var t = Wa(e).toRgb();
        return "rgba(" + Math.round(t.r) + ", " + Math.round(t.g) + ", " + Math.round(t.b) + ", " + r + ")";
      };
      Zt.combine = function (e, r) {
        var t = Wa(e).toRgb();
        if (t.a === 1) return Wa(e).toRgbString();
        var a = Wa(r || X1).toRgb(),
          n = a.a === 1 ? a : {
            r: 255 * (1 - a.a) + a.r * a.a,
            g: 255 * (1 - a.a) + a.g * a.a,
            b: 255 * (1 - a.a) + a.b * a.a
          },
          i = {
            r: n.r * (1 - t.a) + t.r * t.a,
            g: n.g * (1 - t.a) + t.g * t.a,
            b: n.b * (1 - t.a) + t.b * t.a
          };
        return Wa(i).toRgbString();
      };
      Zt.interpolate = function (e, r, t) {
        var a = Wa(e).toRgb(),
          n = Wa(r).toRgb(),
          i = {
            r: t * a.r + (1 - t) * n.r,
            g: t * a.g + (1 - t) * n.g,
            b: t * a.b + (1 - t) * n.b
          };
        return Wa(i).toRgbString();
      };
      Zt.contrast = function (e, r, t) {
        var a = Wa(e);
        a.getAlpha() !== 1 && (a = Wa(Zt.combine(e, X1)));
        var n = a.isDark() ? r ? a.lighten(r) : X1 : t ? a.darken(t) : DI;
        return n.toString();
      };
      Zt.stroke = function (e, r) {
        var t = Wa(r);
        e.style({
          stroke: Zt.tinyRGB(t),
          "stroke-opacity": t.getAlpha()
        });
      };
      Zt.fill = function (e, r) {
        var t = Wa(r);
        e.style({
          fill: Zt.tinyRGB(t),
          "fill-opacity": t.getAlpha()
        });
      };
      Zt.clean = function (e) {
        if (!(!e || typeof e != "object")) {
          var r = Object.keys(e),
            t,
            a,
            n,
            i;
          for (t = 0; t < r.length; t++) if (n = r[t], i = e[n], n.substr(n.length - 5) === "color") {
            if (Array.isArray(i)) for (a = 0; a < i.length; a++) i[a] = Z1(i[a]);else e[n] = Z1(i);
          } else if (n.substr(n.length - 10) === "colorscale" && Array.isArray(i)) for (a = 0; a < i.length; a++) Array.isArray(i[a]) && (i[a][1] = Z1(i[a][1]));else if (Array.isArray(i)) {
            var l = i[0];
            if (!Array.isArray(l) && l && typeof l == "object") for (a = 0; a < i.length; a++) Zt.clean(i[a]);
          } else i && typeof i == "object" && !qI(i) && Zt.clean(i);
        }
      };
      function Z1(e) {
        if (LI(e) || typeof e != "string") return e;
        var r = e.trim();
        if (r.substr(0, 3) !== "rgb") return e;
        var t = r.match(/^rgba?\s*\(([^()]*)\)$/);
        if (!t) return e;
        var a = t[1].trim().split(/\s*[\s,]\s*/),
          n = r.charAt(3) === "a" && a.length === 4;
        if (!n && a.length !== 3) return e;
        for (var i = 0; i < a.length; i++) {
          if (!a[i].length || (a[i] = Number(a[i]), !(a[i] >= 0))) return e;
          if (i === 3) a[i] > 1 && (a[i] = 1);else if (a[i] >= 1) return e;
        }
        var l = Math.round(a[0] * 255) + ", " + Math.round(a[1] * 255) + ", " + Math.round(a[2] * 255);
        return n ? "rgba(" + l + ", " + a[3] + ")" : "rgb(" + l + ")";
      }
    });
    var bv = Z((Lie, Xb) => {
      "use strict";

      Xb.exports = {
        SHOW_PLACEHOLDER: 100,
        HIDE_PLACEHOLDER: 1e3,
        DESELECTDIM: .2
      };
    });
    var cs = Z(Jb => {
      "use strict";

      Jb.counter = function (e, r, t, a) {
        var n = (r || "") + (t ? "" : "$"),
          i = a === !1 ? "" : "^";
        return e === "xy" ? new RegExp(i + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + n) : new RegExp(i + e + "([2-9]|[1-9][0-9]+)?" + n);
      };
    });
    var jb = Z(Za => {
      "use strict";

      var J1 = Hr(),
        Kb = bn(),
        Qb = Yt().extendFlat,
        EI = Gn(),
        PI = $l(),
        RI = Er(),
        zI = bv().DESELECTDIM,
        vs = fv(),
        $b = cs().counter,
        NI = us().modHalf,
        di = nn().isArrayOrTypedArray,
        il = nn().isTypedArraySpec,
        ll = nn().decodeTypedArraySpec;
      Za.valObjectMeta = {
        data_array: {
          coerceFunction: function (e, r, t) {
            r.set(di(e) ? e : il(e) ? ll(e) : t);
          }
        },
        enumerated: {
          coerceFunction: function (e, r, t, a) {
            a.coerceNumber && (e = +e), a.values.indexOf(e) === -1 ? r.set(t) : r.set(e);
          },
          validateFunction: function (e, r) {
            r.coerceNumber && (e = +e);
            for (var t = r.values, a = 0; a < t.length; a++) {
              var n = String(t[a]);
              if (n.charAt(0) === "/" && n.charAt(n.length - 1) === "/") {
                var i = new RegExp(n.substr(1, n.length - 2));
                if (i.test(e)) return !0;
              } else if (e === t[a]) return !0;
            }
            return !1;
          }
        },
        boolean: {
          coerceFunction: function (e, r, t) {
            e === !0 || e === !1 ? r.set(e) : r.set(t);
          }
        },
        number: {
          coerceFunction: function (e, r, t, a) {
            il(e) && (e = ll(e)), !J1(e) || a.min !== void 0 && e < a.min || a.max !== void 0 && e > a.max ? r.set(t) : r.set(+e);
          }
        },
        integer: {
          coerceFunction: function (e, r, t, a) {
            if ((a.extras || []).indexOf(e) !== -1) {
              r.set(e);
              return;
            }
            il(e) && (e = ll(e)), e % 1 || !J1(e) || a.min !== void 0 && e < a.min || a.max !== void 0 && e > a.max ? r.set(t) : r.set(+e);
          }
        },
        string: {
          coerceFunction: function (e, r, t, a) {
            if (typeof e != "string") {
              var n = typeof e == "number";
              a.strict === !0 || !n ? r.set(t) : r.set(String(e));
            } else a.noBlank && !e ? r.set(t) : r.set(e);
          }
        },
        color: {
          coerceFunction: function (e, r, t) {
            il(e) && (e = ll(e)), Kb(e).isValid() ? r.set(e) : r.set(t);
          }
        },
        colorlist: {
          coerceFunction: function (e, r, t) {
            function a(n) {
              return Kb(n).isValid();
            }
            !Array.isArray(e) || !e.length ? r.set(t) : e.every(a) ? r.set(e) : r.set(t);
          }
        },
        colorscale: {
          coerceFunction: function (e, r, t) {
            r.set(PI.get(e, t));
          }
        },
        angle: {
          coerceFunction: function (e, r, t) {
            il(e) && (e = ll(e)), e === "auto" ? r.set("auto") : J1(e) ? r.set(NI(+e, 360)) : r.set(t);
          }
        },
        subplotid: {
          coerceFunction: function (e, r, t, a) {
            var n = a.regex || $b(t);
            if (typeof e == "string" && n.test(e)) {
              r.set(e);
              return;
            }
            r.set(t);
          },
          validateFunction: function (e, r) {
            var t = r.dflt;
            return e === t ? !0 : typeof e != "string" ? !1 : !!$b(t).test(e);
          }
        },
        flaglist: {
          coerceFunction: function (e, r, t, a) {
            if ((a.extras || []).indexOf(e) !== -1) {
              r.set(e);
              return;
            }
            if (typeof e != "string") {
              r.set(t);
              return;
            }
            for (var n = e.split("+"), i = 0; i < n.length;) {
              var l = n[i];
              a.flags.indexOf(l) === -1 || n.indexOf(l) < i ? n.splice(i, 1) : i++;
            }
            n.length ? r.set(n.join("+")) : r.set(t);
          }
        },
        any: {
          coerceFunction: function (e, r, t) {
            e === void 0 ? r.set(t) : r.set(il(e) ? ll(e) : e);
          }
        },
        info_array: {
          coerceFunction: function (e, r, t, a) {
            function n(w, T, b) {
              var A,
                S = {
                  set: function (k) {
                    A = k;
                  }
                };
              return b === void 0 && (b = T.dflt), Za.valObjectMeta[T.valType].coerceFunction(w, S, b, T), A;
            }
            if (il(e) && (e = ll(e)), !di(e)) {
              r.set(t);
              return;
            }
            var i = a.dimensions === 2 || a.dimensions === "1-2" && Array.isArray(e) && di(e[0]),
              l = a.items,
              o = [],
              s = Array.isArray(l),
              u = s && i && di(l[0]),
              f = i && s && !u,
              v = s && !f ? l.length : e.length,
              h,
              d,
              y,
              g,
              m,
              _;
            if (t = Array.isArray(t) ? t : [], i) for (h = 0; h < v; h++) for (o[h] = [], y = di(e[h]) ? e[h] : [], f ? m = l.length : s ? m = l[h].length : m = y.length, d = 0; d < m; d++) f ? g = l[d] : s ? g = l[h][d] : g = l, _ = n(y[d], g, (t[h] || [])[d]), _ !== void 0 && (o[h][d] = _);else for (h = 0; h < v; h++) _ = n(e[h], s ? l[h] : l, t[h]), _ !== void 0 && (o[h] = _);
            r.set(o);
          },
          validateFunction: function (e, r) {
            if (!di(e)) return !1;
            var t = r.items,
              a = Array.isArray(t),
              n = r.dimensions === 2;
            if (!r.freeLength && e.length !== t.length) return !1;
            for (var i = 0; i < e.length; i++) if (n) {
              if (!di(e[i]) || !r.freeLength && e[i].length !== t[i].length) return !1;
              for (var l = 0; l < e[i].length; l++) if (!xv(e[i][l], a ? t[i][l] : t)) return !1;
            } else if (!xv(e[i], a ? t[i] : t)) return !1;
            return !0;
          }
        }
      };
      Za.coerce = function (e, r, t, a, n) {
        var i = vs(t, a).get(),
          l = vs(e, a),
          o = vs(r, a),
          s = l.get(),
          u = r._template;
        if (s === void 0 && u && (s = vs(u, a).get(), u = 0), n === void 0 && (n = i.dflt), i.arrayOk) {
          if (di(s)) return o.set(s), s;
          if (il(s)) return s = ll(s), o.set(s), s;
        }
        var f = Za.valObjectMeta[i.valType].coerceFunction;
        f(s, o, n, i);
        var v = o.get();
        return u && v === n && !xv(s, i) && (s = vs(u, a).get(), f(s, o, n, i), v = o.get()), v;
      };
      Za.coerce2 = function (e, r, t, a, n) {
        var i = vs(e, a),
          l = Za.coerce(e, r, t, a, n),
          o = i.get();
        return o != null ? l : !1;
      };
      Za.coerceFont = function (e, r, t, a) {
        a || (a = {}), t = Qb({}, t), t = Qb(t, a.overrideDflt || {});
        var n = {
          family: e(r + ".family", t.family),
          size: e(r + ".size", t.size),
          color: e(r + ".color", t.color),
          weight: e(r + ".weight", t.weight),
          style: e(r + ".style", t.style)
        };
        if (a.noFontVariant || (n.variant = e(r + ".variant", t.variant)), a.noFontLineposition || (n.lineposition = e(r + ".lineposition", t.lineposition)), a.noFontTextcase || (n.textcase = e(r + ".textcase", t.textcase)), !a.noFontShadow) {
          var i = t.shadow;
          i === "none" && a.autoShadowDflt && (i = "auto"), n.shadow = e(r + ".shadow", i);
        }
        return n;
      };
      Za.coercePattern = function (e, r, t, a) {
        var n = e(r + ".shape");
        if (n) {
          e(r + ".solidity"), e(r + ".size");
          var i = e(r + ".fillmode"),
            l = i === "overlay";
          if (!a) {
            var o = e(r + ".bgcolor", l ? t : void 0);
            e(r + ".fgcolor", l ? RI.contrast(o) : t);
          }
          e(r + ".fgopacity", l ? .5 : 1);
        }
      };
      Za.coerceHoverinfo = function (e, r, t) {
        var a = r._module.attributes,
          n = a.hoverinfo ? a : EI,
          i = n.hoverinfo,
          l;
        if (t._dataLength === 1) {
          var o = i.dflt === "all" ? i.flags.slice() : i.dflt.split("+");
          o.splice(o.indexOf("name"), 1), l = o.join("+");
        }
        return Za.coerce(e, r, n, "hoverinfo", l);
      };
      Za.coerceSelectionMarkerOpacity = function (e, r) {
        if (e.marker) {
          var t = e.marker.opacity;
          if (t !== void 0) {
            var a, n;
            !di(t) && !e.selected && !e.unselected && (a = t, n = zI * t), r("selected.marker.opacity", a), r("unselected.marker.opacity", n);
          }
        }
      };
      function xv(e, r) {
        var t = Za.valObjectMeta[r.valType];
        if (r.arrayOk && di(e)) return !0;
        if (t.validateFunction) return t.validateFunction(e, r);
        var a = {},
          n = a,
          i = {
            set: function (l) {
              n = l;
            }
          };
        return t.coerceFunction(e, i, a, r), n !== a;
      }
      Za.validate = xv;
    });
    var eo = Z((Eie, ax) => {
      "use strict";

      var ex = {
          staticPlot: {
            valType: "boolean",
            dflt: !1
          },
          typesetMath: {
            valType: "boolean",
            dflt: !0
          },
          plotlyServerURL: {
            valType: "string",
            dflt: ""
          },
          editable: {
            valType: "boolean",
            dflt: !1
          },
          edits: {
            annotationPosition: {
              valType: "boolean",
              dflt: !1
            },
            annotationTail: {
              valType: "boolean",
              dflt: !1
            },
            annotationText: {
              valType: "boolean",
              dflt: !1
            },
            axisTitleText: {
              valType: "boolean",
              dflt: !1
            },
            colorbarPosition: {
              valType: "boolean",
              dflt: !1
            },
            colorbarTitleText: {
              valType: "boolean",
              dflt: !1
            },
            legendPosition: {
              valType: "boolean",
              dflt: !1
            },
            legendText: {
              valType: "boolean",
              dflt: !1
            },
            shapePosition: {
              valType: "boolean",
              dflt: !1
            },
            titleText: {
              valType: "boolean",
              dflt: !1
            }
          },
          editSelection: {
            valType: "boolean",
            dflt: !0
          },
          autosizable: {
            valType: "boolean",
            dflt: !1
          },
          responsive: {
            valType: "boolean",
            dflt: !1
          },
          fillFrame: {
            valType: "boolean",
            dflt: !1
          },
          frameMargins: {
            valType: "number",
            dflt: 0,
            min: 0,
            max: .5
          },
          scrollZoom: {
            valType: "flaglist",
            flags: ["cartesian", "gl3d", "geo", "mapbox", "map"],
            extras: [!0, !1],
            dflt: "gl3d+geo+map"
          },
          doubleClick: {
            valType: "enumerated",
            values: [!1, "reset", "autosize", "reset+autosize"],
            dflt: "reset+autosize"
          },
          doubleClickDelay: {
            valType: "number",
            dflt: 300,
            min: 0
          },
          showAxisDragHandles: {
            valType: "boolean",
            dflt: !0
          },
          showAxisRangeEntryBoxes: {
            valType: "boolean",
            dflt: !0
          },
          showTips: {
            valType: "boolean",
            dflt: !0
          },
          showLink: {
            valType: "boolean",
            dflt: !1
          },
          linkText: {
            valType: "string",
            dflt: "Edit chart",
            noBlank: !0
          },
          sendData: {
            valType: "boolean",
            dflt: !0
          },
          showSources: {
            valType: "any",
            dflt: !1
          },
          displayModeBar: {
            valType: "enumerated",
            values: ["hover", !0, !1],
            dflt: "hover"
          },
          showSendToCloud: {
            valType: "boolean",
            dflt: !1
          },
          showEditInChartStudio: {
            valType: "boolean",
            dflt: !1
          },
          modeBarButtonsToRemove: {
            valType: "any",
            dflt: []
          },
          modeBarButtonsToAdd: {
            valType: "any",
            dflt: []
          },
          modeBarButtons: {
            valType: "any",
            dflt: !1
          },
          toImageButtonOptions: {
            valType: "any",
            dflt: {}
          },
          displaylogo: {
            valType: "boolean",
            dflt: !0
          },
          watermark: {
            valType: "boolean",
            dflt: !1
          },
          plotGlPixelRatio: {
            valType: "number",
            dflt: 2,
            min: 1,
            max: 4
          },
          setBackground: {
            valType: "any",
            dflt: "transparent"
          },
          topojsonURL: {
            valType: "string",
            noBlank: !0,
            dflt: "https://cdn.plot.ly/"
          },
          mapboxAccessToken: {
            valType: "string",
            dflt: null
          },
          logging: {
            valType: "integer",
            min: 0,
            max: 2,
            dflt: 1
          },
          notifyOnLogging: {
            valType: "integer",
            min: 0,
            max: 2,
            dflt: 0
          },
          queueLength: {
            valType: "integer",
            min: 0,
            dflt: 0
          },
          locale: {
            valType: "string",
            dflt: "en-US"
          },
          locales: {
            valType: "any",
            dflt: {}
          }
        },
        rx = {};
      function tx(e, r) {
        for (var t in e) {
          var a = e[t];
          a.valType ? r[t] = a.dflt : (r[t] || (r[t] = {}), tx(a, r[t]));
        }
      }
      tx(ex, rx);
      ax.exports = {
        configAttributes: ex,
        dfltConfig: rx
      };
    });
    var Q1 = Z((Pie, nx) => {
      "use strict";

      var K1 = Ir(),
        FI = Hr(),
        Uu = [];
      nx.exports = function (e, r) {
        if (Uu.indexOf(e) !== -1) return;
        Uu.push(e);
        var t = 1e3;
        FI(r) ? t = r : r === "long" && (t = 3e3);
        var a = K1.select("body").selectAll(".plotly-notifier").data([0]);
        a.enter().append("div").classed("plotly-notifier", !0);
        var n = a.selectAll(".notifier-note").data(Uu);
        function i(l) {
          l.duration(700).style("opacity", 0).each("end", function (o) {
            var s = Uu.indexOf(o);
            s !== -1 && Uu.splice(s, 1), K1.select(this).remove();
          });
        }
        n.enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function (l) {
          var o = K1.select(this);
          o.append("button").classed("notifier-close", !0).html("&times;").on("click", function () {
            o.transition().call(i);
          });
          for (var s = o.append("p"), u = l.split(/<br\s*\/?>/g), f = 0; f < u.length; f++) f && s.append("br"), s.append("span").text(u[f]);
          r === "stick" ? o.transition().duration(350).style("opacity", 1) : o.transition().duration(700).style("opacity", 1).transition().delay(t).call(i);
        });
      };
    });
    var ro = Z((Rie, ix) => {
      "use strict";

      var hs = eo().dfltConfig,
        $1 = Q1(),
        j1 = ix.exports = {};
      j1.log = function () {
        var e;
        if (hs.logging > 1) {
          var r = ["LOG:"];
          for (e = 0; e < arguments.length; e++) r.push(arguments[e]);
          console.trace.apply(console, r);
        }
        if (hs.notifyOnLogging > 1) {
          var t = [];
          for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
          $1(t.join("<br>"), "long");
        }
      };
      j1.warn = function () {
        var e;
        if (hs.logging > 0) {
          var r = ["WARN:"];
          for (e = 0; e < arguments.length; e++) r.push(arguments[e]);
          console.trace.apply(console, r);
        }
        if (hs.notifyOnLogging > 0) {
          var t = [];
          for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
          $1(t.join("<br>"), "stick");
        }
      };
      j1.error = function () {
        var e;
        if (hs.logging > 0) {
          var r = ["ERROR:"];
          for (e = 0; e < arguments.length; e++) r.push(arguments[e]);
          console.error.apply(console, r);
        }
        if (hs.notifyOnLogging > 0) {
          var t = [];
          for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
          $1(t.join("<br>"), "stick");
        }
      };
    });
    var _v = Z((zie, lx) => {
      "use strict";

      lx.exports = function () {};
    });
    var ep = Z((Nie, ox) => {
      "use strict";

      ox.exports = function (r, t) {
        if (t instanceof RegExp) {
          for (var a = t.toString(), n = 0; n < r.length; n++) if (r[n] instanceof RegExp && r[n].toString() === a) return r;
          r.push(t);
        } else (t || t === 0) && r.indexOf(t) === -1 && r.push(t);
        return r;
      };
    });
    var ux = Z((Fie, sx) => {
      sx.exports = II;
      function II() {
        var e = new Float32Array(16);
        return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      }
    });
    var cx = Z((Iie, fx) => {
      fx.exports = HI;
      function HI(e) {
        var r = new Float32Array(16);
        return r[0] = e[0], r[1] = e[1], r[2] = e[2], r[3] = e[3], r[4] = e[4], r[5] = e[5], r[6] = e[6], r[7] = e[7], r[8] = e[8], r[9] = e[9], r[10] = e[10], r[11] = e[11], r[12] = e[12], r[13] = e[13], r[14] = e[14], r[15] = e[15], r;
      }
    });
    var hx = Z((Hie, vx) => {
      vx.exports = OI;
      function OI(e, r) {
        return e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[8] = r[8], e[9] = r[9], e[10] = r[10], e[11] = r[11], e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15], e;
      }
    });
    var rp = Z((Oie, dx) => {
      dx.exports = BI;
      function BI(e) {
        return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      }
    });
    var mx = Z((Bie, px) => {
      px.exports = YI;
      function YI(e, r) {
        if (e === r) {
          var t = r[1],
            a = r[2],
            n = r[3],
            i = r[6],
            l = r[7],
            o = r[11];
          e[1] = r[4], e[2] = r[8], e[3] = r[12], e[4] = t, e[6] = r[9], e[7] = r[13], e[8] = a, e[9] = i, e[11] = r[14], e[12] = n, e[13] = l, e[14] = o;
        } else e[0] = r[0], e[1] = r[4], e[2] = r[8], e[3] = r[12], e[4] = r[1], e[5] = r[5], e[6] = r[9], e[7] = r[13], e[8] = r[2], e[9] = r[6], e[10] = r[10], e[11] = r[14], e[12] = r[3], e[13] = r[7], e[14] = r[11], e[15] = r[15];
        return e;
      }
    });
    var gx = Z((Yie, yx) => {
      yx.exports = UI;
      function UI(e, r) {
        var t = r[0],
          a = r[1],
          n = r[2],
          i = r[3],
          l = r[4],
          o = r[5],
          s = r[6],
          u = r[7],
          f = r[8],
          v = r[9],
          h = r[10],
          d = r[11],
          y = r[12],
          g = r[13],
          m = r[14],
          _ = r[15],
          w = t * o - a * l,
          T = t * s - n * l,
          b = t * u - i * l,
          A = a * s - n * o,
          S = a * u - i * o,
          k = n * u - i * s,
          q = f * g - v * y,
          D = f * m - h * y,
          R = f * _ - d * y,
          z = v * m - h * g,
          N = v * _ - d * g,
          H = h * _ - d * m,
          O = w * H - T * N + b * z + A * R - S * D + k * q;
        return O ? (O = 1 / O, e[0] = (o * H - s * N + u * z) * O, e[1] = (n * N - a * H - i * z) * O, e[2] = (g * k - m * S + _ * A) * O, e[3] = (h * S - v * k - d * A) * O, e[4] = (s * R - l * H - u * D) * O, e[5] = (t * H - n * R + i * D) * O, e[6] = (m * b - y * k - _ * T) * O, e[7] = (f * k - h * b + d * T) * O, e[8] = (l * N - o * R + u * q) * O, e[9] = (a * R - t * N - i * q) * O, e[10] = (y * S - g * b + _ * w) * O, e[11] = (v * b - f * S - d * w) * O, e[12] = (o * D - l * z - s * q) * O, e[13] = (t * z - a * D + n * q) * O, e[14] = (g * T - y * A - m * w) * O, e[15] = (f * A - v * T + h * w) * O, e) : null;
      }
    });
    var xx = Z((Uie, bx) => {
      bx.exports = GI;
      function GI(e, r) {
        var t = r[0],
          a = r[1],
          n = r[2],
          i = r[3],
          l = r[4],
          o = r[5],
          s = r[6],
          u = r[7],
          f = r[8],
          v = r[9],
          h = r[10],
          d = r[11],
          y = r[12],
          g = r[13],
          m = r[14],
          _ = r[15];
        return e[0] = o * (h * _ - d * m) - v * (s * _ - u * m) + g * (s * d - u * h), e[1] = -(a * (h * _ - d * m) - v * (n * _ - i * m) + g * (n * d - i * h)), e[2] = a * (s * _ - u * m) - o * (n * _ - i * m) + g * (n * u - i * s), e[3] = -(a * (s * d - u * h) - o * (n * d - i * h) + v * (n * u - i * s)), e[4] = -(l * (h * _ - d * m) - f * (s * _ - u * m) + y * (s * d - u * h)), e[5] = t * (h * _ - d * m) - f * (n * _ - i * m) + y * (n * d - i * h), e[6] = -(t * (s * _ - u * m) - l * (n * _ - i * m) + y * (n * u - i * s)), e[7] = t * (s * d - u * h) - l * (n * d - i * h) + f * (n * u - i * s), e[8] = l * (v * _ - d * g) - f * (o * _ - u * g) + y * (o * d - u * v), e[9] = -(t * (v * _ - d * g) - f * (a * _ - i * g) + y * (a * d - i * v)), e[10] = t * (o * _ - u * g) - l * (a * _ - i * g) + y * (a * u - i * o), e[11] = -(t * (o * d - u * v) - l * (a * d - i * v) + f * (a * u - i * o)), e[12] = -(l * (v * m - h * g) - f * (o * m - s * g) + y * (o * h - s * v)), e[13] = t * (v * m - h * g) - f * (a * m - n * g) + y * (a * h - n * v), e[14] = -(t * (o * m - s * g) - l * (a * m - n * g) + y * (a * s - n * o)), e[15] = t * (o * h - s * v) - l * (a * h - n * v) + f * (a * s - n * o), e;
      }
    });
    var wx = Z((Gie, _x) => {
      _x.exports = VI;
      function VI(e) {
        var r = e[0],
          t = e[1],
          a = e[2],
          n = e[3],
          i = e[4],
          l = e[5],
          o = e[6],
          s = e[7],
          u = e[8],
          f = e[9],
          v = e[10],
          h = e[11],
          d = e[12],
          y = e[13],
          g = e[14],
          m = e[15],
          _ = r * l - t * i,
          w = r * o - a * i,
          T = r * s - n * i,
          b = t * o - a * l,
          A = t * s - n * l,
          S = a * s - n * o,
          k = u * y - f * d,
          q = u * g - v * d,
          D = u * m - h * d,
          R = f * g - v * y,
          z = f * m - h * y,
          N = v * m - h * g;
        return _ * N - w * z + T * R + b * D - A * q + S * k;
      }
    });
    var Mx = Z((Vie, Tx) => {
      Tx.exports = WI;
      function WI(e, r, t) {
        var a = r[0],
          n = r[1],
          i = r[2],
          l = r[3],
          o = r[4],
          s = r[5],
          u = r[6],
          f = r[7],
          v = r[8],
          h = r[9],
          d = r[10],
          y = r[11],
          g = r[12],
          m = r[13],
          _ = r[14],
          w = r[15],
          T = t[0],
          b = t[1],
          A = t[2],
          S = t[3];
        return e[0] = T * a + b * o + A * v + S * g, e[1] = T * n + b * s + A * h + S * m, e[2] = T * i + b * u + A * d + S * _, e[3] = T * l + b * f + A * y + S * w, T = t[4], b = t[5], A = t[6], S = t[7], e[4] = T * a + b * o + A * v + S * g, e[5] = T * n + b * s + A * h + S * m, e[6] = T * i + b * u + A * d + S * _, e[7] = T * l + b * f + A * y + S * w, T = t[8], b = t[9], A = t[10], S = t[11], e[8] = T * a + b * o + A * v + S * g, e[9] = T * n + b * s + A * h + S * m, e[10] = T * i + b * u + A * d + S * _, e[11] = T * l + b * f + A * y + S * w, T = t[12], b = t[13], A = t[14], S = t[15], e[12] = T * a + b * o + A * v + S * g, e[13] = T * n + b * s + A * h + S * m, e[14] = T * i + b * u + A * d + S * _, e[15] = T * l + b * f + A * y + S * w, e;
      }
    });
    var kx = Z((Wie, Ax) => {
      Ax.exports = ZI;
      function ZI(e, r, t) {
        var a = t[0],
          n = t[1],
          i = t[2],
          l,
          o,
          s,
          u,
          f,
          v,
          h,
          d,
          y,
          g,
          m,
          _;
        return r === e ? (e[12] = r[0] * a + r[4] * n + r[8] * i + r[12], e[13] = r[1] * a + r[5] * n + r[9] * i + r[13], e[14] = r[2] * a + r[6] * n + r[10] * i + r[14], e[15] = r[3] * a + r[7] * n + r[11] * i + r[15]) : (l = r[0], o = r[1], s = r[2], u = r[3], f = r[4], v = r[5], h = r[6], d = r[7], y = r[8], g = r[9], m = r[10], _ = r[11], e[0] = l, e[1] = o, e[2] = s, e[3] = u, e[4] = f, e[5] = v, e[6] = h, e[7] = d, e[8] = y, e[9] = g, e[10] = m, e[11] = _, e[12] = l * a + f * n + y * i + r[12], e[13] = o * a + v * n + g * i + r[13], e[14] = s * a + h * n + m * i + r[14], e[15] = u * a + d * n + _ * i + r[15]), e;
      }
    });
    var Sx = Z((Zie, Cx) => {
      Cx.exports = XI;
      function XI(e, r, t) {
        var a = t[0],
          n = t[1],
          i = t[2];
        return e[0] = r[0] * a, e[1] = r[1] * a, e[2] = r[2] * a, e[3] = r[3] * a, e[4] = r[4] * n, e[5] = r[5] * n, e[6] = r[6] * n, e[7] = r[7] * n, e[8] = r[8] * i, e[9] = r[9] * i, e[10] = r[10] * i, e[11] = r[11] * i, e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15], e;
      }
    });
    var qx = Z((Xie, Lx) => {
      Lx.exports = JI;
      function JI(e, r, t, a) {
        var n = a[0],
          i = a[1],
          l = a[2],
          o = Math.sqrt(n * n + i * i + l * l),
          s,
          u,
          f,
          v,
          h,
          d,
          y,
          g,
          m,
          _,
          w,
          T,
          b,
          A,
          S,
          k,
          q,
          D,
          R,
          z,
          N,
          H,
          O,
          J;
        return Math.abs(o) < 1e-6 ? null : (o = 1 / o, n *= o, i *= o, l *= o, s = Math.sin(t), u = Math.cos(t), f = 1 - u, v = r[0], h = r[1], d = r[2], y = r[3], g = r[4], m = r[5], _ = r[6], w = r[7], T = r[8], b = r[9], A = r[10], S = r[11], k = n * n * f + u, q = i * n * f + l * s, D = l * n * f - i * s, R = n * i * f - l * s, z = i * i * f + u, N = l * i * f + n * s, H = n * l * f + i * s, O = i * l * f - n * s, J = l * l * f + u, e[0] = v * k + g * q + T * D, e[1] = h * k + m * q + b * D, e[2] = d * k + _ * q + A * D, e[3] = y * k + w * q + S * D, e[4] = v * R + g * z + T * N, e[5] = h * R + m * z + b * N, e[6] = d * R + _ * z + A * N, e[7] = y * R + w * z + S * N, e[8] = v * H + g * O + T * J, e[9] = h * H + m * O + b * J, e[10] = d * H + _ * O + A * J, e[11] = y * H + w * O + S * J, r !== e && (e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15]), e);
      }
    });
    var Ex = Z((Jie, Dx) => {
      Dx.exports = KI;
      function KI(e, r, t) {
        var a = Math.sin(t),
          n = Math.cos(t),
          i = r[4],
          l = r[5],
          o = r[6],
          s = r[7],
          u = r[8],
          f = r[9],
          v = r[10],
          h = r[11];
        return r !== e && (e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15]), e[4] = i * n + u * a, e[5] = l * n + f * a, e[6] = o * n + v * a, e[7] = s * n + h * a, e[8] = u * n - i * a, e[9] = f * n - l * a, e[10] = v * n - o * a, e[11] = h * n - s * a, e;
      }
    });
    var Rx = Z((Kie, Px) => {
      Px.exports = QI;
      function QI(e, r, t) {
        var a = Math.sin(t),
          n = Math.cos(t),
          i = r[0],
          l = r[1],
          o = r[2],
          s = r[3],
          u = r[8],
          f = r[9],
          v = r[10],
          h = r[11];
        return r !== e && (e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15]), e[0] = i * n - u * a, e[1] = l * n - f * a, e[2] = o * n - v * a, e[3] = s * n - h * a, e[8] = i * a + u * n, e[9] = l * a + f * n, e[10] = o * a + v * n, e[11] = s * a + h * n, e;
      }
    });
    var Nx = Z((Qie, zx) => {
      zx.exports = $I;
      function $I(e, r, t) {
        var a = Math.sin(t),
          n = Math.cos(t),
          i = r[0],
          l = r[1],
          o = r[2],
          s = r[3],
          u = r[4],
          f = r[5],
          v = r[6],
          h = r[7];
        return r !== e && (e[8] = r[8], e[9] = r[9], e[10] = r[10], e[11] = r[11], e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15]), e[0] = i * n + u * a, e[1] = l * n + f * a, e[2] = o * n + v * a, e[3] = s * n + h * a, e[4] = u * n - i * a, e[5] = f * n - l * a, e[6] = v * n - o * a, e[7] = h * n - s * a, e;
      }
    });
    var Ix = Z(($ie, Fx) => {
      Fx.exports = jI;
      function jI(e, r, t) {
        var a,
          n,
          i,
          l = t[0],
          o = t[1],
          s = t[2],
          u = Math.sqrt(l * l + o * o + s * s);
        return Math.abs(u) < 1e-6 ? null : (u = 1 / u, l *= u, o *= u, s *= u, a = Math.sin(r), n = Math.cos(r), i = 1 - n, e[0] = l * l * i + n, e[1] = o * l * i + s * a, e[2] = s * l * i - o * a, e[3] = 0, e[4] = l * o * i - s * a, e[5] = o * o * i + n, e[6] = s * o * i + l * a, e[7] = 0, e[8] = l * s * i + o * a, e[9] = o * s * i - l * a, e[10] = s * s * i + n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e);
      }
    });
    var Ox = Z((jie, Hx) => {
      Hx.exports = eH;
      function eH(e, r, t) {
        var a = r[0],
          n = r[1],
          i = r[2],
          l = r[3],
          o = a + a,
          s = n + n,
          u = i + i,
          f = a * o,
          v = a * s,
          h = a * u,
          d = n * s,
          y = n * u,
          g = i * u,
          m = l * o,
          _ = l * s,
          w = l * u;
        return e[0] = 1 - (d + g), e[1] = v + w, e[2] = h - _, e[3] = 0, e[4] = v - w, e[5] = 1 - (f + g), e[6] = y + m, e[7] = 0, e[8] = h + _, e[9] = y - m, e[10] = 1 - (f + d), e[11] = 0, e[12] = t[0], e[13] = t[1], e[14] = t[2], e[15] = 1, e;
      }
    });
    var Yx = Z((ele, Bx) => {
      Bx.exports = rH;
      function rH(e, r) {
        return e[0] = r[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = r[1], e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = r[2], e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      }
    });
    var Gx = Z((rle, Ux) => {
      Ux.exports = tH;
      function tH(e, r) {
        return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = r[0], e[13] = r[1], e[14] = r[2], e[15] = 1, e;
      }
    });
    var Wx = Z((tle, Vx) => {
      Vx.exports = aH;
      function aH(e, r) {
        var t = Math.sin(r),
          a = Math.cos(r);
        return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a, e[6] = t, e[7] = 0, e[8] = 0, e[9] = -t, e[10] = a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      }
    });
    var Xx = Z((ale, Zx) => {
      Zx.exports = nH;
      function nH(e, r) {
        var t = Math.sin(r),
          a = Math.cos(r);
        return e[0] = a, e[1] = 0, e[2] = -t, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = t, e[9] = 0, e[10] = a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      }
    });
    var Kx = Z((nle, Jx) => {
      Jx.exports = iH;
      function iH(e, r) {
        var t = Math.sin(r),
          a = Math.cos(r);
        return e[0] = a, e[1] = t, e[2] = 0, e[3] = 0, e[4] = -t, e[5] = a, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      }
    });
    var tp = Z((ile, Qx) => {
      Qx.exports = lH;
      function lH(e, r) {
        var t = r[0],
          a = r[1],
          n = r[2],
          i = r[3],
          l = t + t,
          o = a + a,
          s = n + n,
          u = t * l,
          f = a * l,
          v = a * o,
          h = n * l,
          d = n * o,
          y = n * s,
          g = i * l,
          m = i * o,
          _ = i * s;
        return e[0] = 1 - v - y, e[1] = f + _, e[2] = h - m, e[3] = 0, e[4] = f - _, e[5] = 1 - u - y, e[6] = d + g, e[7] = 0, e[8] = h + m, e[9] = d - g, e[10] = 1 - u - v, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      }
    });
    var jx = Z((lle, $x) => {
      $x.exports = oH;
      function oH(e, r, t, a, n, i, l) {
        var o = 1 / (t - r),
          s = 1 / (n - a),
          u = 1 / (i - l);
        return e[0] = i * 2 * o, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = i * 2 * s, e[6] = 0, e[7] = 0, e[8] = (t + r) * o, e[9] = (n + a) * s, e[10] = (l + i) * u, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = l * i * 2 * u, e[15] = 0, e;
      }
    });
    var r_ = Z((ole, e_) => {
      e_.exports = sH;
      function sH(e, r, t, a, n) {
        var i = 1 / Math.tan(r / 2),
          l = 1 / (a - n);
        return e[0] = i / t, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = i, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = (n + a) * l, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = 2 * n * a * l, e[15] = 0, e;
      }
    });
    var a_ = Z((sle, t_) => {
      t_.exports = uH;
      function uH(e, r, t, a) {
        var n = Math.tan(r.upDegrees * Math.PI / 180),
          i = Math.tan(r.downDegrees * Math.PI / 180),
          l = Math.tan(r.leftDegrees * Math.PI / 180),
          o = Math.tan(r.rightDegrees * Math.PI / 180),
          s = 2 / (l + o),
          u = 2 / (n + i);
        return e[0] = s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = u, e[6] = 0, e[7] = 0, e[8] = -((l - o) * s * .5), e[9] = (n - i) * u * .5, e[10] = a / (t - a), e[11] = -1, e[12] = 0, e[13] = 0, e[14] = a * t / (t - a), e[15] = 0, e;
      }
    });
    var i_ = Z((ule, n_) => {
      n_.exports = fH;
      function fH(e, r, t, a, n, i, l) {
        var o = 1 / (r - t),
          s = 1 / (a - n),
          u = 1 / (i - l);
        return e[0] = -2 * o, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * s, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * u, e[11] = 0, e[12] = (r + t) * o, e[13] = (n + a) * s, e[14] = (l + i) * u, e[15] = 1, e;
      }
    });
    var o_ = Z((fle, l_) => {
      var cH = rp();
      l_.exports = vH;
      function vH(e, r, t, a) {
        var n,
          i,
          l,
          o,
          s,
          u,
          f,
          v,
          h,
          d,
          y = r[0],
          g = r[1],
          m = r[2],
          _ = a[0],
          w = a[1],
          T = a[2],
          b = t[0],
          A = t[1],
          S = t[2];
        return Math.abs(y - b) < 1e-6 && Math.abs(g - A) < 1e-6 && Math.abs(m - S) < 1e-6 ? cH(e) : (f = y - b, v = g - A, h = m - S, d = 1 / Math.sqrt(f * f + v * v + h * h), f *= d, v *= d, h *= d, n = w * h - T * v, i = T * f - _ * h, l = _ * v - w * f, d = Math.sqrt(n * n + i * i + l * l), d ? (d = 1 / d, n *= d, i *= d, l *= d) : (n = 0, i = 0, l = 0), o = v * l - h * i, s = h * n - f * l, u = f * i - v * n, d = Math.sqrt(o * o + s * s + u * u), d ? (d = 1 / d, o *= d, s *= d, u *= d) : (o = 0, s = 0, u = 0), e[0] = n, e[1] = o, e[2] = f, e[3] = 0, e[4] = i, e[5] = s, e[6] = v, e[7] = 0, e[8] = l, e[9] = u, e[10] = h, e[11] = 0, e[12] = -(n * y + i * g + l * m), e[13] = -(o * y + s * g + u * m), e[14] = -(f * y + v * g + h * m), e[15] = 1, e);
      }
    });
    var u_ = Z((cle, s_) => {
      s_.exports = hH;
      function hH(e) {
        return "mat4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ", " + e[9] + ", " + e[10] + ", " + e[11] + ", " + e[12] + ", " + e[13] + ", " + e[14] + ", " + e[15] + ")";
      }
    });
    var ap = Z((vle, f_) => {
      f_.exports = {
        create: ux(),
        clone: cx(),
        copy: hx(),
        identity: rp(),
        transpose: mx(),
        invert: gx(),
        adjoint: xx(),
        determinant: wx(),
        multiply: Mx(),
        translate: kx(),
        scale: Sx(),
        rotate: qx(),
        rotateX: Ex(),
        rotateY: Rx(),
        rotateZ: Nx(),
        fromRotation: Ix(),
        fromRotationTranslation: Ox(),
        fromScaling: Yx(),
        fromTranslation: Gx(),
        fromXRotation: Wx(),
        fromYRotation: Xx(),
        fromZRotation: Kx(),
        fromQuat: tp(),
        frustum: jx(),
        perspective: r_(),
        perspectiveFromFieldOfView: a_(),
        ortho: i_(),
        lookAt: o_(),
        str: u_()
      };
    });
    var wv = Z(qt => {
      "use strict";

      var dH = ap();
      qt.init2dArray = function (e, r) {
        for (var t = new Array(e), a = 0; a < e; a++) t[a] = new Array(r);
        return t;
      };
      qt.transposeRagged = function (e) {
        var r = 0,
          t = e.length,
          a,
          n;
        for (a = 0; a < t; a++) r = Math.max(r, e[a].length);
        var i = new Array(r);
        for (a = 0; a < r; a++) for (i[a] = new Array(t), n = 0; n < t; n++) i[a][n] = e[n][a];
        return i;
      };
      qt.dot = function (e, r) {
        if (!(e.length && r.length) || e.length !== r.length) return null;
        var t = e.length,
          a,
          n;
        if (e[0].length) for (a = new Array(t), n = 0; n < t; n++) a[n] = qt.dot(e[n], r);else if (r[0].length) {
          var i = qt.transposeRagged(r);
          for (a = new Array(i.length), n = 0; n < i.length; n++) a[n] = qt.dot(e, i[n]);
        } else for (a = 0, n = 0; n < t; n++) a += e[n] * r[n];
        return a;
      };
      qt.translationMatrix = function (e, r) {
        return [[1, 0, e], [0, 1, r], [0, 0, 1]];
      };
      qt.rotationMatrix = function (e) {
        var r = e * Math.PI / 180;
        return [[Math.cos(r), -Math.sin(r), 0], [Math.sin(r), Math.cos(r), 0], [0, 0, 1]];
      };
      qt.rotationXYMatrix = function (e, r, t) {
        return qt.dot(qt.dot(qt.translationMatrix(r, t), qt.rotationMatrix(e)), qt.translationMatrix(-r, -t));
      };
      qt.apply3DTransform = function (e) {
        return function () {
          var r = arguments,
            t = arguments.length === 1 ? r[0] : [r[0], r[1], r[2] || 0];
          return qt.dot(e, [t[0], t[1], t[2], 1]).slice(0, 3);
        };
      };
      qt.apply2DTransform = function (e) {
        return function () {
          var r = arguments;
          r.length === 3 && (r = r[0]);
          var t = arguments.length === 1 ? r[0] : [r[0], r[1]];
          return qt.dot(e, [t[0], t[1], 1]).slice(0, 2);
        };
      };
      qt.apply2DTransform2 = function (e) {
        var r = qt.apply2DTransform(e);
        return function (t) {
          return r(t.slice(0, 2)).concat(r(t.slice(2, 4)));
        };
      };
      qt.convertCssMatrix = function (e) {
        if (e) {
          var r = e.length;
          if (r === 16) return e;
          if (r === 6) return [e[0], e[1], 0, 0, e[2], e[3], 0, 0, 0, 0, 1, 0, e[4], e[5], 0, 1];
        }
        return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
      };
      qt.inverseTransformMatrix = function (e) {
        var r = [];
        return dH.invert(r, e), [[r[0], r[1], r[2], r[3]], [r[4], r[5], r[6], r[7]], [r[8], r[9], r[10], r[11]], [r[12], r[13], r[14], r[15]]];
      };
    });
    var Gu = Z((dle, m_) => {
      "use strict";

      var pH = Ir(),
        c_ = ro(),
        mH = wv(),
        yH = ap();
      function gH(e) {
        var r;
        if (typeof e == "string") {
          if (r = document.getElementById(e), r === null) throw new Error("No DOM element with id '" + e + "' exists on the page.");
          return r;
        } else if (e == null) throw new Error("DOM element provided is null or undefined");
        return e;
      }
      function bH(e) {
        var r = pH.select(e);
        return r.node() instanceof HTMLElement && r.size() && r.classed("js-plotly-plot");
      }
      function v_(e) {
        var r = e && e.parentNode;
        r && r.removeChild(e);
      }
      function xH(e, r) {
        h_("global", e, r);
      }
      function h_(e, r, t) {
        var a = "plotly.js-style-" + e,
          n = document.getElementById(a);
        if (!(n && n.matches(".no-inline-styles"))) {
          n || (n = document.createElement("style"), n.setAttribute("id", a), n.appendChild(document.createTextNode("")), document.head.appendChild(n));
          var i = n.sheet;
          i ? i.insertRule ? i.insertRule(r + "{" + t + "}", 0) : i.addRule ? i.addRule(r, t, 0) : c_.warn("addStyleRule failed") : c_.warn("Cannot addRelatedStyleRule, probably due to strict CSP...");
        }
      }
      function _H(e) {
        var r = "plotly.js-style-" + e,
          t = document.getElementById(r);
        t && v_(t);
      }
      function wH(e, r, t, a, n, i) {
        var l = a.split(":"),
          o = n.split(":"),
          s = "data-btn-style-event-added";
        i || (i = document), i.querySelectorAll(e).forEach(function (u) {
          u.getAttribute(s) || (u.addEventListener("mouseenter", function () {
            var f = this.querySelector(t);
            f && (f.style[l[0]] = l[1]);
          }), u.addEventListener("mouseleave", function () {
            var f = this.querySelector(t);
            f && (r && this.matches(r) ? f.style[l[0]] = l[1] : f.style[o[0]] = o[1]);
          }), u.setAttribute(s, !0));
        });
      }
      function TH(e) {
        var r = p_(e),
          t = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
        return r.forEach(function (a) {
          var n = d_(a);
          if (n) {
            var i = mH.convertCssMatrix(n);
            t = yH.multiply(t, t, i);
          }
        }), t;
      }
      function d_(e) {
        var r = window.getComputedStyle(e, null),
          t = r.getPropertyValue("-webkit-transform") || r.getPropertyValue("-moz-transform") || r.getPropertyValue("-ms-transform") || r.getPropertyValue("-o-transform") || r.getPropertyValue("transform");
        return t === "none" ? null : t.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function (a) {
          return +a;
        });
      }
      function p_(e) {
        for (var r = []; MH(e);) r.push(e), e = e.parentNode, typeof ShadowRoot == "function" && e instanceof ShadowRoot && (e = e.host);
        return r;
      }
      function MH(e) {
        return e && (e instanceof Element || e instanceof HTMLElement);
      }
      function AH(e, r) {
        return e && r && e.top === r.top && e.left === r.left && e.right === r.right && e.bottom === r.bottom;
      }
      m_.exports = {
        getGraphDiv: gH,
        isPlotDiv: bH,
        removeElement: v_,
        addStyleRule: xH,
        addRelatedStyleRule: h_,
        deleteRelatedStyleRule: _H,
        setStyleOnHover: wH,
        getFullTransformMatrix: TH,
        getElementTransformMatrix: d_,
        getElementAndAncestors: p_,
        equalDomRects: AH
      };
    });
    var Vu = Z((ple, y_) => {
      "use strict";

      y_.exports = {
        mode: {
          valType: "enumerated",
          dflt: "afterall",
          values: ["immediate", "next", "afterall"]
        },
        direction: {
          valType: "enumerated",
          values: ["forward", "reverse"],
          dflt: "forward"
        },
        fromcurrent: {
          valType: "boolean",
          dflt: !1
        },
        frame: {
          duration: {
            valType: "number",
            min: 0,
            dflt: 500
          },
          redraw: {
            valType: "boolean",
            dflt: !0
          }
        },
        transition: {
          duration: {
            valType: "number",
            min: 0,
            dflt: 500,
            editType: "none"
          },
          easing: {
            valType: "enumerated",
            dflt: "cubic-in-out",
            values: ["linear", "quad", "cubic", "sin", "exp", "circle", "elastic", "back", "bounce", "linear-in", "quad-in", "cubic-in", "sin-in", "exp-in", "circle-in", "elastic-in", "back-in", "bounce-in", "linear-out", "quad-out", "cubic-out", "sin-out", "exp-out", "circle-out", "elastic-out", "back-out", "bounce-out", "linear-in-out", "quad-in-out", "cubic-in-out", "sin-in-out", "exp-in-out", "circle-in-out", "elastic-in-out", "back-in-out", "bounce-in-out"],
            editType: "none"
          },
          ordering: {
            valType: "enumerated",
            values: ["layout first", "traces first"],
            dflt: "layout first",
            editType: "none"
          }
        }
      };
    });
    var pi = Z((mle, M_) => {
      "use strict";

      var b_ = Yt().extendFlat,
        kH = nl(),
        x_ = {
          valType: "flaglist",
          extras: ["none"],
          flags: ["calc", "clearAxisTypes", "plot", "style", "markerSize", "colorbars"]
        },
        __ = {
          valType: "flaglist",
          extras: ["none"],
          flags: ["calc", "plot", "legend", "ticks", "axrange", "layoutstyle", "modebar", "camera", "arraydraw", "colorbars"]
        },
        CH = x_.flags.slice().concat(["fullReplot"]),
        SH = __.flags.slice().concat("layoutReplot");
      M_.exports = {
        traces: x_,
        layout: __,
        traceFlags: function () {
          return g_(CH);
        },
        layoutFlags: function () {
          return g_(SH);
        },
        update: function (e, r) {
          var t = r.editType;
          if (t && t !== "none") for (var a = t.split("+"), n = 0; n < a.length; n++) e[a[n]] = !0;
        },
        overrideAll: w_
      };
      function g_(e) {
        for (var r = {}, t = 0; t < e.length; t++) r[e[t]] = !1;
        return r;
      }
      function w_(e, r, t) {
        var a = b_({}, e);
        for (var n in a) {
          var i = a[n];
          kH(i) && (a[n] = T_(i, r, t, n));
        }
        return t === "from-root" && (a.editType = r), a;
      }
      function T_(e, r, t, a) {
        if (e.valType) {
          var n = b_({}, e);
          if (n.editType = r, Array.isArray(e.items)) {
            n.items = new Array(e.items.length);
            for (var i = 0; i < e.items.length; i++) n.items[i] = T_(e.items[i], r, "from-root");
          }
          return n;
        } else return w_(e, r, a.charAt(0) === "_" ? "nested" : "from-root");
      }
    });
    var mi = Z(np => {
      "use strict";

      np.dash = {
        valType: "string",
        values: ["solid", "dot", "dash", "longdash", "dashdot", "longdashdot"],
        dflt: "solid",
        editType: "style"
      };
      np.pattern = {
        shape: {
          valType: "enumerated",
          values: ["", "/", "\\", "x", "-", "|", "+", "."],
          dflt: "",
          arrayOk: !0,
          editType: "style"
        },
        fillmode: {
          valType: "enumerated",
          values: ["replace", "overlay"],
          dflt: "replace",
          editType: "style"
        },
        bgcolor: {
          valType: "color",
          arrayOk: !0,
          editType: "style"
        },
        fgcolor: {
          valType: "color",
          arrayOk: !0,
          editType: "style"
        },
        fgopacity: {
          valType: "number",
          editType: "style",
          min: 0,
          max: 1
        },
        size: {
          valType: "number",
          min: 0,
          dflt: 8,
          arrayOk: !0,
          editType: "style"
        },
        solidity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: .3,
          arrayOk: !0,
          editType: "style"
        },
        editType: "style"
      };
    });
    var ip = Z((gle, A_) => {
      "use strict";

      A_.exports = {
        FORMAT_LINK: "https://github.com/d3/d3-format/tree/v1.4.5#d3-format",
        DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format"
      };
    });
    var zi = Z(Tv => {
      "use strict";

      var k_ = ip(),
        ble = k_.FORMAT_LINK,
        xle = k_.DATE_FORMAT_LINK;
      function lp(e) {
        var r = e.description ? " " + e.description : "",
          t = e.keys || [];
        if (t.length > 0) {
          for (var a = [], n = 0; n < t.length; n++) a[n] = "`" + t[n] + "`";
          r = r + "Finally, the template string has access to ", t.length === 1 ? r = r + "variable " + a[0] : r = r + "variables " + a.slice(0, -1).join(", ") + " and " + a.slice(-1) + ".";
        }
        return r;
      }
      Tv.hovertemplateAttrs = function (e, r) {
        e = e || {}, r = r || {};
        var t = lp(r),
          a = {
            valType: "string",
            dflt: "",
            editType: e.editType || "none"
          };
        return e.arrayOk !== !1 && (a.arrayOk = !0), a;
      };
      Tv.texttemplateAttrs = function (e, r) {
        e = e || {}, r = r || {};
        var t = lp(r),
          a = {
            valType: "string",
            dflt: "",
            editType: e.editType || "calc"
          };
        return e.arrayOk !== !1 && (a.arrayOk = !0), a;
      };
      Tv.shapeTexttemplateAttrs = function (e, r) {
        e = e || {}, r = r || {};
        var t = e.newshape ? "new " : "",
          a = lp(r),
          n = {
            valType: "string",
            dflt: "",
            editType: e.editType || "arraydraw"
          };
        return n;
      };
    });
    var kv = Z((wle, E_) => {
      "use strict";

      function ol(e, r) {
        return r ? r.d2l(e) : e;
      }
      function C_(e, r) {
        return r ? r.l2d(e) : e;
      }
      function LH(e) {
        return e.x0;
      }
      function qH(e) {
        return e.x1;
      }
      function DH(e) {
        return e.y0;
      }
      function EH(e) {
        return e.y1;
      }
      function S_(e) {
        return e.x0shift || 0;
      }
      function L_(e) {
        return e.x1shift || 0;
      }
      function q_(e) {
        return e.y0shift || 0;
      }
      function D_(e) {
        return e.y1shift || 0;
      }
      function Mv(e, r) {
        return ol(e.x1, r) + L_(e) - ol(e.x0, r) - S_(e);
      }
      function Av(e, r, t) {
        return ol(e.y1, t) + D_(e) - ol(e.y0, t) - q_(e);
      }
      function PH(e, r) {
        return Math.abs(Mv(e, r));
      }
      function RH(e, r, t) {
        return Math.abs(Av(e, r, t));
      }
      function zH(e, r, t) {
        return e.type !== "line" ? void 0 : Math.sqrt(Math.pow(Mv(e, r), 2) + Math.pow(Av(e, r, t), 2));
      }
      function NH(e, r) {
        return C_((ol(e.x1, r) + L_(e) + ol(e.x0, r) + S_(e)) / 2, r);
      }
      function FH(e, r, t) {
        return C_((ol(e.y1, t) + D_(e) + ol(e.y0, t) + q_(e)) / 2, t);
      }
      function IH(e, r, t) {
        return e.type !== "line" ? void 0 : Av(e, r, t) / Mv(e, r);
      }
      E_.exports = {
        x0: LH,
        x1: qH,
        y0: DH,
        y1: EH,
        slope: IH,
        dx: Mv,
        dy: Av,
        width: PH,
        height: RH,
        length: zH,
        xcenter: NH,
        ycenter: FH
      };
    });
    var z_ = Z((Tle, R_) => {
      "use strict";

      var HH = pi().overrideAll,
        to = Gn(),
        P_ = ha(),
        OH = mi().dash,
        sl = Yt().extendFlat,
        BH = zi().shapeTexttemplateAttrs,
        YH = kv();
      R_.exports = HH({
        newshape: {
          visible: sl({}, to.visible, {}),
          showlegend: {
            valType: "boolean",
            dflt: !1
          },
          legend: sl({}, to.legend, {}),
          legendgroup: sl({}, to.legendgroup, {}),
          legendgrouptitle: {
            text: sl({}, to.legendgrouptitle.text, {}),
            font: P_({})
          },
          legendrank: sl({}, to.legendrank, {}),
          legendwidth: sl({}, to.legendwidth, {}),
          line: {
            color: {
              valType: "color"
            },
            width: {
              valType: "number",
              min: 0,
              dflt: 4
            },
            dash: sl({}, OH, {
              dflt: "solid"
            })
          },
          fillcolor: {
            valType: "color",
            dflt: "rgba(0,0,0,0)"
          },
          fillrule: {
            valType: "enumerated",
            values: ["evenodd", "nonzero"],
            dflt: "evenodd"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: 1
          },
          layer: {
            valType: "enumerated",
            values: ["below", "above", "between"],
            dflt: "above"
          },
          drawdirection: {
            valType: "enumerated",
            values: ["ortho", "horizontal", "vertical", "diagonal"],
            dflt: "diagonal"
          },
          name: sl({}, to.name, {}),
          label: {
            text: {
              valType: "string",
              dflt: ""
            },
            texttemplate: BH({
              newshape: !0
            }, {
              keys: Object.keys(YH)
            }),
            font: P_({}),
            textposition: {
              valType: "enumerated",
              values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right", "start", "middle", "end"]
            },
            textangle: {
              valType: "angle",
              dflt: "auto"
            },
            xanchor: {
              valType: "enumerated",
              values: ["auto", "left", "center", "right"],
              dflt: "auto"
            },
            yanchor: {
              valType: "enumerated",
              values: ["top", "middle", "bottom"]
            },
            padding: {
              valType: "number",
              dflt: 3,
              min: 0
            }
          }
        },
        activeshape: {
          fillcolor: {
            valType: "color",
            dflt: "rgb(255,0,255)"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .5
          }
        }
      }, "none", "from-root");
    });
    var F_ = Z((Mle, N_) => {
      "use strict";

      var UH = mi().dash,
        GH = Yt().extendFlat;
      N_.exports = {
        newselection: {
          mode: {
            valType: "enumerated",
            values: ["immediate", "gradual"],
            dflt: "immediate",
            editType: "none"
          },
          line: {
            color: {
              valType: "color",
              editType: "none"
            },
            width: {
              valType: "number",
              min: 1,
              dflt: 1,
              editType: "none"
            },
            dash: GH({}, UH, {
              dflt: "dot",
              editType: "none"
            }),
            editType: "none"
          },
          editType: "none"
        },
        activeselection: {
          fillcolor: {
            valType: "color",
            dflt: "rgba(0,0,0,0)",
            editType: "none"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .5,
            editType: "none"
          },
          editType: "none"
        }
      };
    });
    var Cv = Z((Ale, I_) => {
      "use strict";

      I_.exports = function (e) {
        var r = e.editType;
        return {
          t: {
            valType: "number",
            dflt: 0,
            editType: r
          },
          r: {
            valType: "number",
            dflt: 0,
            editType: r
          },
          b: {
            valType: "number",
            dflt: 0,
            editType: r
          },
          l: {
            valType: "number",
            dflt: 0,
            editType: r
          },
          editType: r
        };
      };
    });
    var ds = Z((kle, Y_) => {
      "use strict";

      var op = ha(),
        VH = Vu(),
        Sv = hi(),
        H_ = z_(),
        O_ = F_(),
        WH = Cv(),
        B_ = Yt().extendFlat,
        Lv = op({
          editType: "calc"
        });
      Lv.family.dflt = '"Open Sans", verdana, arial, sans-serif';
      Lv.size.dflt = 12;
      Lv.color.dflt = Sv.defaultLine;
      Y_.exports = {
        font: Lv,
        title: {
          text: {
            valType: "string",
            editType: "layoutstyle"
          },
          font: op({
            editType: "layoutstyle"
          }),
          subtitle: {
            text: {
              valType: "string",
              editType: "layoutstyle"
            },
            font: op({
              editType: "layoutstyle"
            }),
            editType: "layoutstyle"
          },
          xref: {
            valType: "enumerated",
            dflt: "container",
            values: ["container", "paper"],
            editType: "layoutstyle"
          },
          yref: {
            valType: "enumerated",
            dflt: "container",
            values: ["container", "paper"],
            editType: "layoutstyle"
          },
          x: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .5,
            editType: "layoutstyle"
          },
          y: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: "auto",
            editType: "layoutstyle"
          },
          xanchor: {
            valType: "enumerated",
            dflt: "auto",
            values: ["auto", "left", "center", "right"],
            editType: "layoutstyle"
          },
          yanchor: {
            valType: "enumerated",
            dflt: "auto",
            values: ["auto", "top", "middle", "bottom"],
            editType: "layoutstyle"
          },
          pad: B_(WH({
            editType: "layoutstyle"
          }), {}),
          automargin: {
            valType: "boolean",
            dflt: !1,
            editType: "plot"
          },
          editType: "layoutstyle"
        },
        uniformtext: {
          mode: {
            valType: "enumerated",
            values: [!1, "hide", "show"],
            dflt: !1,
            editType: "plot"
          },
          minsize: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          editType: "plot"
        },
        autosize: {
          valType: "boolean",
          dflt: !1,
          editType: "none"
        },
        width: {
          valType: "number",
          min: 10,
          dflt: 700,
          editType: "plot"
        },
        height: {
          valType: "number",
          min: 10,
          dflt: 450,
          editType: "plot"
        },
        minreducedwidth: {
          valType: "number",
          min: 2,
          dflt: 64,
          editType: "plot"
        },
        minreducedheight: {
          valType: "number",
          min: 2,
          dflt: 64,
          editType: "plot"
        },
        margin: {
          l: {
            valType: "number",
            min: 0,
            dflt: 80,
            editType: "plot"
          },
          r: {
            valType: "number",
            min: 0,
            dflt: 80,
            editType: "plot"
          },
          t: {
            valType: "number",
            min: 0,
            dflt: 100,
            editType: "plot"
          },
          b: {
            valType: "number",
            min: 0,
            dflt: 80,
            editType: "plot"
          },
          pad: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          autoexpand: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          editType: "plot"
        },
        computed: {
          valType: "any",
          editType: "none"
        },
        paper_bgcolor: {
          valType: "color",
          dflt: Sv.background,
          editType: "plot"
        },
        plot_bgcolor: {
          valType: "color",
          dflt: Sv.background,
          editType: "layoutstyle"
        },
        autotypenumbers: {
          valType: "enumerated",
          values: ["convert types", "strict"],
          dflt: "convert types",
          editType: "calc"
        },
        separators: {
          valType: "string",
          editType: "plot"
        },
        hidesources: {
          valType: "boolean",
          dflt: !1,
          editType: "plot"
        },
        showlegend: {
          valType: "boolean",
          editType: "legend"
        },
        colorway: {
          valType: "colorlist",
          dflt: Sv.defaults,
          editType: "calc"
        },
        datarevision: {
          valType: "any",
          editType: "calc"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editrevision: {
          valType: "any",
          editType: "none"
        },
        selectionrevision: {
          valType: "any",
          editType: "none"
        },
        template: {
          valType: "any",
          editType: "calc"
        },
        newshape: H_.newshape,
        activeshape: H_.activeshape,
        newselection: O_.newselection,
        activeselection: O_.activeselection,
        meta: {
          valType: "any",
          arrayOk: !0,
          editType: "plot"
        },
        transition: B_({}, VH.transition, {
          editType: "none"
        })
      };
    });
    var U_ = ib(() => {});
    var ZH = {};
    var G_ = ib(() => {
      U_();
    });
    var gr = Z(zr => {
      "use strict";

      var ps = ro(),
        V_ = _v(),
        W_ = ep(),
        XH = nl(),
        JH = Gu().addStyleRule,
        Z_ = Yt(),
        KH = Gn(),
        QH = ds(),
        $H = Z_.extendFlat,
        sp = Z_.extendDeepAll;
      zr.modules = {};
      zr.allCategories = {};
      zr.allTypes = [];
      zr.subplotsRegistry = {};
      zr.componentsRegistry = {};
      zr.layoutArrayContainers = [];
      zr.layoutArrayRegexes = [];
      zr.traceLayoutAttributes = {};
      zr.localeRegistry = {};
      zr.apiMethodRegistry = {};
      zr.collectableSubplotTypes = null;
      zr.register = function (r) {
        if (zr.collectableSubplotTypes = null, r) r && !Array.isArray(r) && (r = [r]);else throw new Error("No argument passed to Plotly.register.");
        for (var t = 0; t < r.length; t++) {
          var a = r[t];
          if (!a) throw new Error("Invalid module was attempted to be registered!");
          switch (a.moduleType) {
            case "trace":
              jH(a);
              break;
            case "transform":
              tO(a);
              break;
            case "component":
              rO(a);
              break;
            case "locale":
              aO(a);
              break;
            case "apiMethod":
              var n = a.name;
              zr.apiMethodRegistry[n] = a.fn;
              break;
            default:
              throw new Error("Invalid module was attempted to be registered!");
          }
        }
      };
      zr.getModule = function (e) {
        var r = zr.modules[Q_(e)];
        return r ? r._module : !1;
      };
      zr.traceIs = function (e, r) {
        if (e = Q_(e), e === "various") return !1;
        var t = zr.modules[e];
        return t || (e && ps.log("Unrecognized trace type " + e + "."), t = zr.modules[KH.type.dflt]), !!t.categories[r];
      };
      zr.getComponentMethod = function (e, r) {
        var t = zr.componentsRegistry[e];
        return t && t[r] || V_;
      };
      zr.call = function () {
        var e = arguments[0],
          r = [].slice.call(arguments, 1);
        return zr.apiMethodRegistry[e].apply(null, r);
      };
      function jH(e) {
        var r = e.name,
          t = e.categories,
          a = e.meta;
        if (zr.modules[r]) {
          ps.log("Type " + r + " already registered");
          return;
        }
        zr.subplotsRegistry[e.basePlotModule.name] || eO(e.basePlotModule);
        for (var n = {}, i = 0; i < t.length; i++) n[t[i]] = !0, zr.allCategories[t[i]] = !0;
        zr.modules[r] = {
          _module: e,
          categories: n
        }, a && Object.keys(a).length && (zr.modules[r].meta = a), zr.allTypes.push(r);
        for (var l in zr.componentsRegistry) J_(l, r);
        e.layoutAttributes && $H(zr.traceLayoutAttributes, e.layoutAttributes);
        var o = e.basePlotModule,
          s = o.name;
        if (s === "mapbox") {
          var u = o.constants.styleRules;
          for (var f in u) JH(".js-plotly-plot .plotly .mapboxgl-" + f, u[f]);
        }
        s === "map" && (G_(), aI(ZH)), (s === "geo" || s === "mapbox" || s === "map") && window.PlotlyGeoAssets === void 0 && (window.PlotlyGeoAssets = {
          topojson: {}
        });
      }
      function eO(e) {
        var r = e.name;
        if (zr.subplotsRegistry[r]) {
          ps.log("Plot type " + r + " already registered.");
          return;
        }
        X_(e), zr.subplotsRegistry[r] = e;
        for (var t in zr.componentsRegistry) K_(t, e.name);
      }
      function rO(e) {
        if (typeof e.name != "string") throw new Error("Component module *name* must be a string.");
        var r = e.name;
        zr.componentsRegistry[r] = e, e.layoutAttributes && (e.layoutAttributes._isLinkedToArray && W_(zr.layoutArrayContainers, r), X_(e));
        for (var t in zr.modules) J_(r, t);
        for (var a in zr.subplotsRegistry) K_(r, a);
        e.schema && e.schema.layout && sp(QH, e.schema.layout);
      }
      function tO(e) {
        if (typeof e.name != "string") throw new Error("Transform module *name* must be a string.");
        var r = "Transform module " + e.name,
          t = typeof e.transform == "function",
          a = typeof e.calcTransform == "function";
        if (!t && !a) throw new Error(r + " is missing a *transform* or *calcTransform* method.");
        t && a && ps.log([r + " has both a *transform* and *calcTransform* methods.", "Please note that all *transform* methods are executed", "before all *calcTransform* methods."].join(" ")), XH(e.attributes) || ps.log(r + " registered without an *attributes* object."), typeof e.supplyDefaults != "function" && ps.log(r + " registered without a *supplyDefaults* method.");
      }
      function aO(e) {
        var r = e.name,
          t = r.split("-")[0],
          a = e.dictionary,
          n = e.format,
          i = a && Object.keys(a).length,
          l = n && Object.keys(n).length,
          o = zr.localeRegistry,
          s = o[r];
        if (s || (o[r] = s = {}), t !== r) {
          var u = o[t];
          u || (o[t] = u = {}), i && u.dictionary === s.dictionary && (u.dictionary = a), l && u.format === s.format && (u.format = n);
        }
        i && (s.dictionary = a), l && (s.format = n);
      }
      function X_(e) {
        if (e.layoutAttributes) {
          var r = e.layoutAttributes._arrayAttrRegexps;
          if (r) for (var t = 0; t < r.length; t++) W_(zr.layoutArrayRegexes, r[t]);
        }
      }
      function J_(e, r) {
        var t = zr.componentsRegistry[e].schema;
        if (!(!t || !t.traces)) {
          var a = t.traces[r];
          a && sp(zr.modules[r]._module.attributes, a);
        }
      }
      function K_(e, r) {
        var t = zr.componentsRegistry[e].schema;
        if (!(!t || !t.subplots)) {
          var a = zr.subplotsRegistry[r],
            n = a.layoutAttributes,
            i = a.attr === "subplot" ? a.name : a.attr;
          Array.isArray(i) && (i = i[0]);
          var l = t.subplots[i];
          n && l && sp(n, l);
        }
      }
      function Q_(e) {
        return typeof e == "object" && (e = e.type), e;
      }
    });
    var l4 = Z(Dt => {
      "use strict";

      var nO = os().timeFormat,
        n4 = Hr(),
        up = ro(),
        fl = us().mod,
        gs = Bt(),
        xn = gs.BADNUM,
        Xa = gs.ONEDAY,
        Wu = gs.ONEHOUR,
        ul = gs.ONEMIN,
        ys = gs.ONESEC,
        Zu = gs.EPOCHJD,
        Ni = gr(),
        $_ = os().utcFormat,
        iO = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m,
        lO = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m,
        j_ = new Date().getFullYear() - 70;
      function Fi(e) {
        return e && Ni.componentsRegistry.calendars && typeof e == "string" && e !== "gregorian";
      }
      Dt.dateTick0 = function (e, r) {
        var t = oO(e, !!r);
        if (r < 2) return t;
        var a = Dt.dateTime2ms(t, e);
        return a += Xa * (r - 1), Dt.ms2DateTime(a, 0, e);
      };
      function oO(e, r) {
        return Fi(e) ? r ? Ni.getComponentMethod("calendars", "CANONICAL_SUNDAY")[e] : Ni.getComponentMethod("calendars", "CANONICAL_TICK")[e] : r ? "2000-01-02" : "2000-01-01";
      }
      Dt.dfltRange = function (e) {
        return Fi(e) ? Ni.getComponentMethod("calendars", "DFLTRANGE")[e] : ["2000-01-01", "2001-01-01"];
      };
      Dt.isJSDate = function (e) {
        return typeof e == "object" && e !== null && typeof e.getTime == "function";
      };
      var Dv, Ev;
      Dt.dateTime2ms = function (e, r) {
        if (Dt.isJSDate(e)) {
          var t = e.getTimezoneOffset() * ul,
            a = (e.getUTCMinutes() - e.getMinutes()) * ul + (e.getUTCSeconds() - e.getSeconds()) * ys + (e.getUTCMilliseconds() - e.getMilliseconds());
          if (a) {
            var n = 3 * ul;
            t = t - n / 2 + fl(a - t + n / 2, n);
          }
          return e = Number(e) - t, e >= Dv && e <= Ev ? e : xn;
        }
        if (typeof e != "string" && typeof e != "number") return xn;
        e = String(e);
        var i = Fi(r),
          l = e.charAt(0);
        i && (l === "G" || l === "g") && (e = e.substr(1), r = "");
        var o = i && r.substr(0, 7) === "chinese",
          s = e.match(o ? lO : iO);
        if (!s) return xn;
        var u = s[1],
          f = s[3] || "1",
          v = Number(s[5] || 1),
          h = Number(s[7] || 0),
          d = Number(s[9] || 0),
          y = Number(s[11] || 0);
        if (i) {
          if (u.length === 2) return xn;
          u = Number(u);
          var g;
          try {
            var m = Ni.getComponentMethod("calendars", "getCal")(r);
            if (o) {
              var _ = f.charAt(f.length - 1) === "i";
              f = parseInt(f, 10), g = m.newDate(u, m.toMonthIndex(u, f, _), v);
            } else g = m.newDate(u, Number(f), v);
          } catch (T) {
            return xn;
          }
          return g ? (g.toJD() - Zu) * Xa + h * Wu + d * ul + y * ys : xn;
        }
        u.length === 2 ? u = (Number(u) + 2e3 - j_) % 100 + j_ : u = Number(u), f -= 1;
        var w = new Date(Date.UTC(2e3, f, v, h, d));
        return w.setUTCFullYear(u), w.getUTCMonth() !== f || w.getUTCDate() !== v ? xn : w.getTime() + y * ys;
      };
      Dv = Dt.MIN_MS = Dt.dateTime2ms("-9999");
      Ev = Dt.MAX_MS = Dt.dateTime2ms("9999-12-31 23:59:59.9999");
      Dt.isDateTime = function (e, r) {
        return Dt.dateTime2ms(e, r) !== xn;
      };
      function ms(e, r) {
        return String(e + Math.pow(10, r)).substr(1);
      }
      var qv = 90 * Xa,
        e4 = 3 * Wu,
        r4 = 5 * ul;
      Dt.ms2DateTime = function (e, r, t) {
        if (typeof e != "number" || !(e >= Dv && e <= Ev)) return xn;
        r || (r = 0);
        var a = Math.floor(fl(e + .05, 1) * 10),
          n = Math.round(e - a / 10),
          i,
          l,
          o,
          s,
          u,
          f;
        if (Fi(t)) {
          var v = Math.floor(n / Xa) + Zu,
            h = Math.floor(fl(e, Xa));
          try {
            i = Ni.getComponentMethod("calendars", "getCal")(t).fromJD(v).formatDate("yyyy-mm-dd");
          } catch (d) {
            i = $_("G%Y-%m-%d")(new Date(n));
          }
          if (i.charAt(0) === "-") for (; i.length < 11;) i = "-0" + i.substr(1);else for (; i.length < 10;) i = "0" + i;
          l = r < qv ? Math.floor(h / Wu) : 0, o = r < qv ? Math.floor(h % Wu / ul) : 0, s = r < e4 ? Math.floor(h % ul / ys) : 0, u = r < r4 ? h % ys * 10 + a : 0;
        } else f = new Date(n), i = $_("%Y-%m-%d")(f), l = r < qv ? f.getUTCHours() : 0, o = r < qv ? f.getUTCMinutes() : 0, s = r < e4 ? f.getUTCSeconds() : 0, u = r < r4 ? f.getUTCMilliseconds() * 10 + a : 0;
        return i4(i, l, o, s, u);
      };
      Dt.ms2DateTimeLocal = function (e) {
        if (!(e >= Dv + Xa && e <= Ev - Xa)) return xn;
        var r = Math.floor(fl(e + .05, 1) * 10),
          t = new Date(Math.round(e - r / 10)),
          a = nO("%Y-%m-%d")(t),
          n = t.getHours(),
          i = t.getMinutes(),
          l = t.getSeconds(),
          o = t.getUTCMilliseconds() * 10 + r;
        return i4(a, n, i, l, o);
      };
      function i4(e, r, t, a, n) {
        if ((r || t || a || n) && (e += " " + ms(r, 2) + ":" + ms(t, 2), (a || n) && (e += ":" + ms(a, 2), n))) {
          for (var i = 4; n % 10 === 0;) i -= 1, n /= 10;
          e += "." + ms(n, i);
        }
        return e;
      }
      Dt.cleanDate = function (e, r, t) {
        if (e === xn) return r;
        if (Dt.isJSDate(e) || typeof e == "number" && isFinite(e)) {
          if (Fi(t)) return up.error("JS Dates and milliseconds are incompatible with world calendars", e), r;
          if (e = Dt.ms2DateTimeLocal(+e), !e && r !== void 0) return r;
        } else if (!Dt.isDateTime(e, t)) return up.error("unrecognized date", e), r;
        return e;
      };
      var sO = /%\d?f/g,
        uO = /%h/g,
        fO = {
          1: "1",
          2: "1",
          3: "2",
          4: "2"
        };
      function t4(e, r, t, a) {
        e = e.replace(sO, function (i) {
          var l = Math.min(+i.charAt(1) || 6, 6),
            o = (r / 1e3 % 1 + 2).toFixed(l).substr(2).replace(/0+$/, "") || "0";
          return o;
        });
        var n = new Date(Math.floor(r + .05));
        if (e = e.replace(uO, function () {
          return fO[t("%q")(n)];
        }), Fi(a)) try {
          e = Ni.getComponentMethod("calendars", "worldCalFmt")(e, r, a);
        } catch (i) {
          return "Invalid";
        }
        return t(e)(n);
      }
      var cO = [59, 59.9, 59.99, 59.999, 59.9999];
      function vO(e, r) {
        var t = fl(e + .05, Xa),
          a = ms(Math.floor(t / Wu), 2) + ":" + ms(fl(Math.floor(t / ul), 60), 2);
        if (r !== "M") {
          n4(r) || (r = 0);
          var n = Math.min(fl(e / ys, 60), cO[r]),
            i = (100 + n).toFixed(r).substr(1);
          r > 0 && (i = i.replace(/0+$/, "").replace(/[\.]$/, "")), a += ":" + i;
        }
        return a;
      }
      Dt.formatDate = function (e, r, t, a, n, i) {
        if (n = Fi(n) && n, !r) if (t === "y") r = i.year;else if (t === "m") r = i.month;else if (t === "d") r = i.dayMonth + `
` + i.year;else return vO(e, t) + `
` + t4(i.dayMonthYear, e, a, n);
        return t4(r, e, a, n);
      };
      var a4 = 3 * Xa;
      Dt.incrementMonth = function (e, r, t) {
        t = Fi(t) && t;
        var a = fl(e, Xa);
        if (e = Math.round(e - a), t) try {
          var n = Math.round(e / Xa) + Zu,
            i = Ni.getComponentMethod("calendars", "getCal")(t),
            l = i.fromJD(n);
          return r % 12 ? i.add(l, r, "m") : i.add(l, r / 12, "y"), (l.toJD() - Zu) * Xa + a;
        } catch (s) {
          up.error("invalid ms " + e + " in calendar " + t);
        }
        var o = new Date(e + a4);
        return o.setUTCMonth(o.getUTCMonth() + r) + a - a4;
      };
      Dt.findExactDates = function (e, r) {
        for (var t = 0, a = 0, n = 0, i = 0, l, o, s = Fi(r) && Ni.getComponentMethod("calendars", "getCal")(r), u = 0; u < e.length; u++) {
          if (o = e[u], !n4(o)) {
            i++;
            continue;
          }
          if (!(o % Xa)) if (s) try {
            l = s.fromJD(o / Xa + Zu), l.day() === 1 ? l.month() === 1 ? t++ : a++ : n++;
          } catch (v) {} else l = new Date(o), l.getUTCDate() === 1 ? l.getUTCMonth() === 0 ? t++ : a++ : n++;
        }
        a += t, n += a;
        var f = e.length - i;
        return {
          exactYears: t / f,
          exactMonths: a / f,
          exactDays: n / f
        };
      };
    });
    var fp = Z((Ele, o4) => {
      "use strict";

      o4.exports = function (r) {
        return r;
      };
    });
    var vp = Z(Ii => {
      "use strict";

      var hO = Hr(),
        dO = ro(),
        pO = fp(),
        mO = Bt().BADNUM,
        cp = 1e-9;
      Ii.findBin = function (e, r, t) {
        if (hO(r.start)) return t ? Math.ceil((e - r.start) / r.size - cp) - 1 : Math.floor((e - r.start) / r.size + cp);
        var a = 0,
          n = r.length,
          i = 0,
          l = n > 1 ? (r[n - 1] - r[0]) / (n - 1) : 1,
          o,
          s;
        for (l >= 0 ? s = t ? yO : gO : s = t ? xO : bO, e += l * cp * (t ? -1 : 1) * (l >= 0 ? 1 : -1); a < n && i++ < 100;) o = Math.floor((a + n) / 2), s(r[o], e) ? a = o + 1 : n = o;
        return i > 90 && dO.log("Long binary search..."), a - 1;
      };
      function yO(e, r) {
        return e < r;
      }
      function gO(e, r) {
        return e <= r;
      }
      function bO(e, r) {
        return e > r;
      }
      function xO(e, r) {
        return e >= r;
      }
      Ii.sorterAsc = function (e, r) {
        return e - r;
      };
      Ii.sorterDes = function (e, r) {
        return r - e;
      };
      Ii.distinctVals = function (e) {
        var r = e.slice();
        r.sort(Ii.sorterAsc);
        var t;
        for (t = r.length - 1; t > -1 && r[t] === mO; t--);
        for (var a = r[t] - r[0] || 1, n = a / (t || 1) / 1e4, i = [], l, o = 0; o <= t; o++) {
          var s = r[o],
            u = s - l;
          l === void 0 ? (i.push(s), l = s) : u > n && (a = Math.min(a, u), i.push(s), l = s);
        }
        return {
          vals: i,
          minDiff: a
        };
      };
      Ii.roundUp = function (e, r, t) {
        for (var a = 0, n = r.length - 1, i, l = 0, o = t ? 0 : 1, s = t ? 1 : 0, u = t ? Math.ceil : Math.floor; a < n && l++ < 100;) i = u((a + n) / 2), r[i] <= e ? a = i + o : n = i - s;
        return r[a];
      };
      Ii.sort = function (e, r) {
        for (var t = 0, a = 0, n = 1; n < e.length; n++) {
          var i = r(e[n], e[n - 1]);
          if (i < 0 ? t = 1 : i > 0 && (a = 1), t && a) return e.sort(r);
        }
        return a ? e : e.reverse();
      };
      Ii.findIndexOfMin = function (e, r) {
        r = r || pO;
        for (var t = 1 / 0, a, n = 0; n < e.length; n++) {
          var i = r(e[n]);
          i < t && (t = i, a = n);
        }
        return a;
      };
    });
    var hp = Z((Rle, s4) => {
      "use strict";

      s4.exports = function (r) {
        return Object.keys(r).sort();
      };
    });
    var u4 = Z(Et => {
      "use strict";

      var Xu = Hr(),
        _O = nn().isArrayOrTypedArray;
      Et.aggNums = function (e, r, t, a) {
        var n, i;
        if ((!a || a > t.length) && (a = t.length), Xu(r) || (r = !1), _O(t[0])) {
          for (i = new Array(a), n = 0; n < a; n++) i[n] = Et.aggNums(e, r, t[n]);
          t = i;
        }
        for (n = 0; n < a; n++) Xu(r) ? Xu(t[n]) && (r = e(+r, +t[n])) : r = t[n];
        return r;
      };
      Et.len = function (e) {
        return Et.aggNums(function (r) {
          return r + 1;
        }, 0, e);
      };
      Et.mean = function (e, r) {
        return r || (r = Et.len(e)), Et.aggNums(function (t, a) {
          return t + a;
        }, 0, e) / r;
      };
      Et.geometricMean = function (e, r) {
        return r || (r = Et.len(e)), Math.pow(Et.aggNums(function (t, a) {
          return t * a;
        }, 1, e), 1 / r);
      };
      Et.midRange = function (e) {
        if (!(e === void 0 || e.length === 0)) return (Et.aggNums(Math.max, null, e) + Et.aggNums(Math.min, null, e)) / 2;
      };
      Et.variance = function (e, r, t) {
        return r || (r = Et.len(e)), Xu(t) || (t = Et.mean(e, r)), Et.aggNums(function (a, n) {
          return a + Math.pow(n - t, 2);
        }, 0, e) / r;
      };
      Et.stdev = function (e, r, t) {
        return Math.sqrt(Et.variance(e, r, t));
      };
      Et.median = function (e) {
        var r = e.slice().sort();
        return Et.interp(r, .5);
      };
      Et.interp = function (e, r) {
        if (!Xu(r)) throw "n should be a finite number";
        if (r = r * e.length - .5, r < 0) return e[0];
        if (r > e.length - 1) return e[e.length - 1];
        var t = r % 1;
        return t * e[Math.ceil(r)] + (1 - t) * e[Math.floor(r)];
      };
    });
    var d4 = Z((Nle, h4) => {
      "use strict";

      var f4 = us(),
        dp = f4.mod,
        wO = f4.modHalf,
        Ju = Math.PI,
        cl = 2 * Ju;
      function TO(e) {
        return e / 180 * Ju;
      }
      function MO(e) {
        return e / Ju * 180;
      }
      function pp(e) {
        return Math.abs(e[1] - e[0]) > cl - 1e-14;
      }
      function c4(e, r) {
        return wO(r - e, cl);
      }
      function AO(e, r) {
        return Math.abs(c4(e, r));
      }
      function v4(e, r) {
        if (pp(r)) return !0;
        var t, a;
        r[0] < r[1] ? (t = r[0], a = r[1]) : (t = r[1], a = r[0]), t = dp(t, cl), a = dp(a, cl), t > a && (a += cl);
        var n = dp(e, cl),
          i = n + cl;
        return n >= t && n <= a || i >= t && i <= a;
      }
      function kO(e, r, t, a) {
        if (!v4(r, a)) return !1;
        var n, i;
        return t[0] < t[1] ? (n = t[0], i = t[1]) : (n = t[1], i = t[0]), e >= n && e <= i;
      }
      function mp(e, r, t, a, n, i, l) {
        n = n || 0, i = i || 0;
        var o = pp([t, a]),
          s,
          u,
          f,
          v,
          h;
        o ? (s = 0, u = Ju, f = cl) : t < a ? (s = t, f = a) : (s = a, f = t), e < r ? (v = e, h = r) : (v = r, h = e);
        function d(_, w) {
          return [_ * Math.cos(w) + n, i - _ * Math.sin(w)];
        }
        var y = Math.abs(f - s) <= Ju ? 0 : 1;
        function g(_, w, T) {
          return "A" + [_, _] + " " + [0, y, T] + " " + d(_, w);
        }
        var m;
        return o ? v === null ? m = "M" + d(h, s) + g(h, u, 0) + g(h, f, 0) + "Z" : m = "M" + d(v, s) + g(v, u, 0) + g(v, f, 0) + "ZM" + d(h, s) + g(h, u, 1) + g(h, f, 1) + "Z" : v === null ? (m = "M" + d(h, s) + g(h, f, 0), l && (m += "L0,0Z")) : m = "M" + d(v, s) + "L" + d(h, s) + g(h, f, 0) + "L" + d(v, f) + g(v, s, 1) + "Z", m;
      }
      function CO(e, r, t, a, n) {
        return mp(null, e, r, t, a, n, 0);
      }
      function SO(e, r, t, a, n) {
        return mp(null, e, r, t, a, n, 1);
      }
      function LO(e, r, t, a, n, i) {
        return mp(e, r, t, a, n, i, 1);
      }
      h4.exports = {
        deg2rad: TO,
        rad2deg: MO,
        angleDelta: c4,
        angleDist: AO,
        isFullCircle: pp,
        isAngleInsideSector: v4,
        isPtInsideSector: kO,
        pathArc: CO,
        pathSector: SO,
        pathAnnulus: LO
      };
    });
    var p4 = Z(ao => {
      "use strict";

      ao.isLeftAnchor = function (r) {
        return r.xanchor === "left" || r.xanchor === "auto" && r.x <= 1 / 3;
      };
      ao.isCenterAnchor = function (r) {
        return r.xanchor === "center" || r.xanchor === "auto" && r.x > 1 / 3 && r.x < 2 / 3;
      };
      ao.isRightAnchor = function (r) {
        return r.xanchor === "right" || r.xanchor === "auto" && r.x >= 2 / 3;
      };
      ao.isTopAnchor = function (r) {
        return r.yanchor === "top" || r.yanchor === "auto" && r.y >= 2 / 3;
      };
      ao.isMiddleAnchor = function (r) {
        return r.yanchor === "middle" || r.yanchor === "auto" && r.y > 1 / 3 && r.y < 2 / 3;
      };
      ao.isBottomAnchor = function (r) {
        return r.yanchor === "bottom" || r.yanchor === "auto" && r.y <= 1 / 3;
      };
    });
    var g4 = Z(no => {
      "use strict";

      var yp = us().mod;
      no.segmentsIntersect = y4;
      function y4(e, r, t, a, n, i, l, o) {
        var s = t - e,
          u = n - e,
          f = l - n,
          v = a - r,
          h = i - r,
          d = o - i,
          y = s * d - f * v;
        if (y === 0) return null;
        var g = (u * d - f * h) / y,
          m = (u * v - s * h) / y;
        return m < 0 || m > 1 || g < 0 || g > 1 ? null : {
          x: e + s * g,
          y: r + v * g
        };
      }
      no.segmentDistance = function (r, t, a, n, i, l, o, s) {
        if (y4(r, t, a, n, i, l, o, s)) return 0;
        var u = a - r,
          f = n - t,
          v = o - i,
          h = s - l,
          d = u * u + f * f,
          y = v * v + h * h,
          g = Math.min(Pv(u, f, d, i - r, l - t), Pv(u, f, d, o - r, s - t), Pv(v, h, y, r - i, t - l), Pv(v, h, y, a - i, n - l));
        return Math.sqrt(g);
      };
      function Pv(e, r, t, a, n) {
        var i = a * e + n * r;
        if (i < 0) return a * a + n * n;
        if (i > t) {
          var l = a - e,
            o = n - r;
          return l * l + o * o;
        } else {
          var s = a * r - n * e;
          return s * s / t;
        }
      }
      var Rv, gp, m4;
      no.getTextLocation = function (r, t, a, n) {
        if ((r !== gp || n !== m4) && (Rv = {}, gp = r, m4 = n), Rv[a]) return Rv[a];
        var i = r.getPointAtLength(yp(a - n / 2, t)),
          l = r.getPointAtLength(yp(a + n / 2, t)),
          o = Math.atan((l.y - i.y) / (l.x - i.x)),
          s = r.getPointAtLength(yp(a, t)),
          u = (s.x * 4 + i.x + l.x) / 6,
          f = (s.y * 4 + i.y + l.y) / 6,
          v = {
            x: u,
            y: f,
            theta: o
          };
        return Rv[a] = v, v;
      };
      no.clearLocationCache = function () {
        gp = null;
      };
      no.getVisibleSegment = function (r, t, a) {
        var n = t.left,
          i = t.right,
          l = t.top,
          o = t.bottom,
          s = 0,
          u = r.getTotalLength(),
          f = u,
          v,
          h;
        function d(g) {
          var m = r.getPointAtLength(g);
          g === 0 ? v = m : g === u && (h = m);
          var _ = m.x < n ? n - m.x : m.x > i ? m.x - i : 0,
            w = m.y < l ? l - m.y : m.y > o ? m.y - o : 0;
          return Math.sqrt(_ * _ + w * w);
        }
        for (var y = d(s); y;) {
          if (s += y + a, s > f) return;
          y = d(s);
        }
        for (y = d(f); y;) {
          if (f -= y + a, s > f) return;
          y = d(f);
        }
        return {
          min: s,
          max: f,
          len: f - s,
          total: u,
          isClosed: s === 0 && f === u && Math.abs(v.x - h.x) < .1 && Math.abs(v.y - h.y) < .1
        };
      };
      no.findPointOnPath = function (r, t, a, n) {
        n = n || {};
        for (var i = n.pathLength || r.getTotalLength(), l = n.tolerance || .001, o = n.iterationLimit || 30, s = r.getPointAtLength(0)[a] > r.getPointAtLength(i)[a] ? -1 : 1, u = 0, f = 0, v = i, h, d, y; u < o;) {
          if (h = (f + v) / 2, d = r.getPointAtLength(h), y = d[a] - t, Math.abs(y) < l) return d;
          s * y > 0 ? v = h : f = h, u++;
        }
        return d;
      };
    });
    var zv = Z(Ku => {
      "use strict";

      var Hi = {};
      Ku.throttle = function (r, t, a) {
        var n = Hi[r],
          i = Date.now();
        if (!n) {
          for (var l in Hi) Hi[l].ts < i - 6e4 && delete Hi[l];
          n = Hi[r] = {
            ts: 0,
            timer: null
          };
        }
        b4(n);
        function o() {
          a(), n.ts = Date.now(), n.onDone && (n.onDone(), n.onDone = null);
        }
        if (i > n.ts + t) {
          o();
          return;
        }
        n.timer = setTimeout(function () {
          o(), n.timer = null;
        }, t);
      };
      Ku.done = function (e) {
        var r = Hi[e];
        return !r || !r.timer ? Promise.resolve() : new Promise(function (t) {
          var a = r.onDone;
          r.onDone = function () {
            a && a(), t(), r.onDone = null;
          };
        });
      };
      Ku.clear = function (e) {
        if (e) b4(Hi[e]), delete Hi[e];else for (var r in Hi) Ku.clear(r);
      };
      function b4(e) {
        e && e.timer !== null && (clearTimeout(e.timer), e.timer = null);
      }
    });
    var _4 = Z((Ole, x4) => {
      "use strict";

      x4.exports = function (r) {
        r._responsiveChartHandler && (window.removeEventListener("resize", r._responsiveChartHandler), delete r._responsiveChartHandler);
      };
    });
    var w4 = Z((Ble, Nv) => {
      "use strict";

      Nv.exports = bp;
      Nv.exports.isMobile = bp;
      Nv.exports.default = bp;
      var qO = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
        DO = /CrOS/,
        EO = /android|ipad|playbook|silk/i;
      function bp(e) {
        e || (e = {});
        let r = e.ua;
        if (!r && typeof navigator != "undefined" && (r = navigator.userAgent), r && r.headers && typeof r.headers["user-agent"] == "string" && (r = r.headers["user-agent"]), typeof r != "string") return !1;
        let t = qO.test(r) && !DO.test(r) || !!e.tablet && EO.test(r);
        return !t && e.tablet && e.featureDetect && navigator && navigator.maxTouchPoints > 1 && r.indexOf("Macintosh") !== -1 && r.indexOf("Safari") !== -1 && (t = !0), t;
      }
    });
    var M4 = Z((Yle, T4) => {
      "use strict";

      var PO = Hr(),
        RO = w4();
      T4.exports = function (r) {
        var t;
        if (r && r.hasOwnProperty("userAgent") ? t = r.userAgent : t = zO(), typeof t != "string") return !0;
        var a = RO({
          ua: {
            headers: {
              "user-agent": t
            }
          },
          tablet: !0,
          featureDetect: !1
        });
        if (!a) for (var n = t.split(" "), i = 1; i < n.length; i++) {
          var l = n[i];
          if (l.indexOf("Safari") !== -1) for (var o = i - 1; o > -1; o--) {
            var s = n[o];
            if (s.substr(0, 8) === "Version/") {
              var u = s.substr(8).split(".")[0];
              if (PO(u) && (u = +u), u >= 13) return !0;
            }
          }
        }
        return a;
      };
      function zO() {
        var e;
        return typeof navigator != "undefined" && (e = navigator.userAgent), e && e.headers && typeof e.headers["user-agent"] == "string" && (e = e.headers["user-agent"]), e;
      }
    });
    var k4 = Z((Ule, A4) => {
      "use strict";

      var NO = Ir();
      A4.exports = function (r, t, a) {
        var n = r.selectAll("g." + a.replace(/\s/g, ".")).data(t, function (l) {
          return l[0].trace.uid;
        });
        n.exit().remove(), n.enter().append("g").attr("class", a), n.order();
        var i = r.classed("rangeplot") ? "nodeRangePlot3" : "node3";
        return n.each(function (l) {
          l[0][i] = NO.select(this);
        }), n;
      };
    });
    var S4 = Z((Gle, C4) => {
      "use strict";

      var FO = gr();
      C4.exports = function (r, t) {
        for (var a = r._context.locale, n = 0; n < 2; n++) {
          for (var i = r._context.locales, l = 0; l < 2; l++) {
            var o = (i[a] || {}).dictionary;
            if (o) {
              var s = o[t];
              if (s) return s;
            }
            i = FO.localeRegistry;
          }
          var u = a.split("-")[0];
          if (u === a) break;
          a = u;
        }
        return t;
      };
    });
    var q4 = Z((Vle, L4) => {
      "use strict";

      L4.exports = function (r) {
        for (var t = {}, a = [], n = 0, i = 0; i < r.length; i++) {
          var l = r[i];
          t[l] !== 1 && (t[l] = 1, a[n++] = l);
        }
        return a;
      };
    });
    var E4 = Z((Wle, D4) => {
      "use strict";

      D4.exports = function (r) {
        for (var t = OO(r) ? HO : IO, a = [], n = 0; n < r.length; n++) {
          var i = r[n];
          t(i) && a.push(i);
        }
        return a;
      };
      function IO(e) {
        return e.visible === !0;
      }
      function HO(e) {
        var r = e[0].trace;
        return r.visible === !0 && r._length !== 0;
      }
      function OO(e) {
        return Array.isArray(e) && Array.isArray(e[0]) && e[0][0] && e[0][0].trace;
      }
    });
    var R4 = Z((Zle, P4) => {
      "use strict";

      P4.exports = function (r, t) {
        if (!t) return r;
        var a = 1 / Math.abs(t),
          n = a > 1 ? (a * r + a * t) / a : r + t,
          i = String(n).length;
        if (i > 16) {
          var l = String(t).length,
            o = String(r).length;
          if (i >= o + l) {
            var s = parseFloat(n).toPrecision(12);
            s.indexOf("e+") === -1 && (n = +s);
          }
        }
        return n;
      };
    });
    var N4 = Z((Xle, z4) => {
      "use strict";

      var BO = Hr(),
        YO = Bt().BADNUM,
        UO = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
      z4.exports = function (r) {
        return typeof r == "string" && (r = r.replace(UO, "")), BO(r) ? Number(r) : YO;
      };
    });
    var He = Z((Jle, J4) => {
      "use strict";

      var Qu = Ir(),
        GO = os().utcFormat,
        VO = O1().format,
        Y4 = Hr(),
        U4 = Bt(),
        G4 = U4.FP_SAFE,
        WO = -G4,
        F4 = U4.BADNUM,
        fe = J4.exports = {};
      fe.adjustFormat = function (r) {
        return !r || /^\d[.]\df/.test(r) || /[.]\d%/.test(r) ? r : r === "0.f" ? "~f" : /^\d%/.test(r) ? "~%" : /^\ds/.test(r) ? "~s" : !/^[~,.0$]/.test(r) && /[&fps]/.test(r) ? "~" + r : r;
      };
      var I4 = {};
      fe.warnBadFormat = function (e) {
        var r = String(e);
        I4[r] || (I4[r] = 1, fe.warn('encountered bad format: "' + r + '"'));
      };
      fe.noFormat = function (e) {
        return String(e);
      };
      fe.numberFormat = function (e) {
        var r;
        try {
          r = VO(fe.adjustFormat(e));
        } catch (t) {
          return fe.warnBadFormat(e), fe.noFormat;
        }
        return r;
      };
      fe.nestedProperty = fv();
      fe.keyedContainer = Sb();
      fe.relativeAttr = qb();
      fe.isPlainObject = nl();
      fe.toLogRange = vv();
      fe.relinkPrivateKeys = Rb();
      var vl = nn();
      fe.isArrayBuffer = vl.isArrayBuffer;
      fe.isTypedArray = vl.isTypedArray;
      fe.isArrayOrTypedArray = vl.isArrayOrTypedArray;
      fe.isArray1D = vl.isArray1D;
      fe.ensureArray = vl.ensureArray;
      fe.concat = vl.concat;
      fe.maxRowLength = vl.maxRowLength;
      fe.minRowLength = vl.minRowLength;
      var V4 = us();
      fe.mod = V4.mod;
      fe.modHalf = V4.modHalf;
      var hl = jb();
      fe.valObjectMeta = hl.valObjectMeta;
      fe.coerce = hl.coerce;
      fe.coerce2 = hl.coerce2;
      fe.coerceFont = hl.coerceFont;
      fe.coercePattern = hl.coercePattern;
      fe.coerceHoverinfo = hl.coerceHoverinfo;
      fe.coerceSelectionMarkerOpacity = hl.coerceSelectionMarkerOpacity;
      fe.validate = hl.validate;
      var ln = l4();
      fe.dateTime2ms = ln.dateTime2ms;
      fe.isDateTime = ln.isDateTime;
      fe.ms2DateTime = ln.ms2DateTime;
      fe.ms2DateTimeLocal = ln.ms2DateTimeLocal;
      fe.cleanDate = ln.cleanDate;
      fe.isJSDate = ln.isJSDate;
      fe.formatDate = ln.formatDate;
      fe.incrementMonth = ln.incrementMonth;
      fe.dateTick0 = ln.dateTick0;
      fe.dfltRange = ln.dfltRange;
      fe.findExactDates = ln.findExactDates;
      fe.MIN_MS = ln.MIN_MS;
      fe.MAX_MS = ln.MAX_MS;
      var io = vp();
      fe.findBin = io.findBin;
      fe.sorterAsc = io.sorterAsc;
      fe.sorterDes = io.sorterDes;
      fe.distinctVals = io.distinctVals;
      fe.roundUp = io.roundUp;
      fe.sort = io.sort;
      fe.findIndexOfMin = io.findIndexOfMin;
      fe.sortObjectKeys = hp();
      var Oi = u4();
      fe.aggNums = Oi.aggNums;
      fe.len = Oi.len;
      fe.mean = Oi.mean;
      fe.geometricMean = Oi.geometricMean;
      fe.median = Oi.median;
      fe.midRange = Oi.midRange;
      fe.variance = Oi.variance;
      fe.stdev = Oi.stdev;
      fe.interp = Oi.interp;
      var Vn = wv();
      fe.init2dArray = Vn.init2dArray;
      fe.transposeRagged = Vn.transposeRagged;
      fe.dot = Vn.dot;
      fe.translationMatrix = Vn.translationMatrix;
      fe.rotationMatrix = Vn.rotationMatrix;
      fe.rotationXYMatrix = Vn.rotationXYMatrix;
      fe.apply3DTransform = Vn.apply3DTransform;
      fe.apply2DTransform = Vn.apply2DTransform;
      fe.apply2DTransform2 = Vn.apply2DTransform2;
      fe.convertCssMatrix = Vn.convertCssMatrix;
      fe.inverseTransformMatrix = Vn.inverseTransformMatrix;
      var yi = d4();
      fe.deg2rad = yi.deg2rad;
      fe.rad2deg = yi.rad2deg;
      fe.angleDelta = yi.angleDelta;
      fe.angleDist = yi.angleDist;
      fe.isFullCircle = yi.isFullCircle;
      fe.isAngleInsideSector = yi.isAngleInsideSector;
      fe.isPtInsideSector = yi.isPtInsideSector;
      fe.pathArc = yi.pathArc;
      fe.pathSector = yi.pathSector;
      fe.pathAnnulus = yi.pathAnnulus;
      var xs = p4();
      fe.isLeftAnchor = xs.isLeftAnchor;
      fe.isCenterAnchor = xs.isCenterAnchor;
      fe.isRightAnchor = xs.isRightAnchor;
      fe.isTopAnchor = xs.isTopAnchor;
      fe.isMiddleAnchor = xs.isMiddleAnchor;
      fe.isBottomAnchor = xs.isBottomAnchor;
      var _s = g4();
      fe.segmentsIntersect = _s.segmentsIntersect;
      fe.segmentDistance = _s.segmentDistance;
      fe.getTextLocation = _s.getTextLocation;
      fe.clearLocationCache = _s.clearLocationCache;
      fe.getVisibleSegment = _s.getVisibleSegment;
      fe.findPointOnPath = _s.findPointOnPath;
      var Hv = Yt();
      fe.extendFlat = Hv.extendFlat;
      fe.extendDeep = Hv.extendDeep;
      fe.extendDeepAll = Hv.extendDeepAll;
      fe.extendDeepNoArrays = Hv.extendDeepNoArrays;
      var xp = ro();
      fe.log = xp.log;
      fe.warn = xp.warn;
      fe.error = xp.error;
      var ZO = cs();
      fe.counterRegex = ZO.counter;
      var _p = zv();
      fe.throttle = _p.throttle;
      fe.throttleDone = _p.done;
      fe.clearThrottle = _p.clear;
      var Wn = Gu();
      fe.getGraphDiv = Wn.getGraphDiv;
      fe.isPlotDiv = Wn.isPlotDiv;
      fe.removeElement = Wn.removeElement;
      fe.addStyleRule = Wn.addStyleRule;
      fe.addRelatedStyleRule = Wn.addRelatedStyleRule;
      fe.deleteRelatedStyleRule = Wn.deleteRelatedStyleRule;
      fe.setStyleOnHover = Wn.setStyleOnHover;
      fe.getFullTransformMatrix = Wn.getFullTransformMatrix;
      fe.getElementTransformMatrix = Wn.getElementTransformMatrix;
      fe.getElementAndAncestors = Wn.getElementAndAncestors;
      fe.equalDomRects = Wn.equalDomRects;
      fe.clearResponsive = _4();
      fe.preserveDrawingBuffer = M4();
      fe.makeTraceGroups = k4();
      fe._ = S4();
      fe.notifier = Q1();
      fe.filterUnique = q4();
      fe.filterVisible = E4();
      fe.pushUnique = ep();
      fe.increment = R4();
      fe.cleanNumber = N4();
      fe.ensureNumber = function (r) {
        return Y4(r) ? (r = Number(r), r > G4 || r < WO ? F4 : r) : F4;
      };
      fe.isIndex = function (e, r) {
        return r !== void 0 && e >= r ? !1 : Y4(e) && e >= 0 && e % 1 === 0;
      };
      fe.noop = _v();
      fe.identity = fp();
      fe.repeat = function (e, r) {
        for (var t = new Array(r), a = 0; a < r; a++) t[a] = e;
        return t;
      };
      fe.swapAttrs = function (e, r, t, a) {
        t || (t = "x"), a || (a = "y");
        for (var n = 0; n < r.length; n++) {
          var i = r[n],
            l = fe.nestedProperty(e, i.replace("?", t)),
            o = fe.nestedProperty(e, i.replace("?", a)),
            s = l.get();
          l.set(o.get()), o.set(s);
        }
      };
      fe.raiseToTop = function (r) {
        r.parentNode.appendChild(r);
      };
      fe.cancelTransition = function (e) {
        return e.transition().duration(0);
      };
      fe.constrain = function (e, r, t) {
        return r > t ? Math.max(t, Math.min(r, e)) : Math.max(r, Math.min(t, e));
      };
      fe.bBoxIntersect = function (e, r, t) {
        return t = t || 0, e.left <= r.right + t && r.left <= e.right + t && e.top <= r.bottom + t && r.top <= e.bottom + t;
      };
      fe.simpleMap = function (e, r, t, a, n) {
        for (var i = e.length, l = new Array(i), o = 0; o < i; o++) l[o] = r(e[o], t, a, n);
        return l;
      };
      fe.randstr = function e(r, t, a, n) {
        if (a || (a = 16), t === void 0 && (t = 24), t <= 0) return "0";
        var i = Math.log(Math.pow(2, t)) / Math.log(a),
          l = "",
          o,
          s,
          u;
        for (o = 2; i === 1 / 0; o *= 2) i = Math.log(Math.pow(2, t / o)) / Math.log(a) * o;
        var f = i - Math.floor(i);
        for (o = 0; o < Math.floor(i); o++) u = Math.floor(Math.random() * a).toString(a), l = u + l;
        f && (s = Math.pow(a, f), u = Math.floor(Math.random() * s).toString(a), l = u + l);
        var v = parseInt(l, a);
        return r && r[l] || v !== 1 / 0 && v >= Math.pow(2, t) ? n > 10 ? (fe.warn("randstr failed uniqueness"), l) : e(r, t, a, (n || 0) + 1) : l;
      };
      fe.OptionControl = function (e, r) {
        e || (e = {}), r || (r = "opt");
        var t = {};
        return t.optionList = [], t._newoption = function (a) {
          a[r] = e, t[a.name] = a, t.optionList.push(a);
        }, t["_" + r] = e, t;
      };
      fe.smooth = function (e, r) {
        if (r = Math.round(r) || 0, r < 2) return e;
        var t = e.length,
          a = 2 * t,
          n = 2 * r - 1,
          i = new Array(n),
          l = new Array(t),
          o,
          s,
          u,
          f;
        for (o = 0; o < n; o++) i[o] = (1 - Math.cos(Math.PI * (o + 1) / r)) / (2 * r);
        for (o = 0; o < t; o++) {
          for (f = 0, s = 0; s < n; s++) u = o + s + 1 - r, u < -t ? u -= a * Math.round(u / a) : u >= a && (u -= a * Math.floor(u / a)), u < 0 ? u = -1 - u : u >= t && (u = a - 1 - u), f += e[u] * i[s];
          l[o] = f;
        }
        return l;
      };
      fe.syncOrAsync = function (e, r, t) {
        var a, n;
        function i() {
          return fe.syncOrAsync(e, r, t);
        }
        for (; e.length;) if (n = e.splice(0, 1)[0], a = n(r), a && a.then) return a.then(i);
        return t && t(r);
      };
      fe.stripTrailingSlash = function (e) {
        return e.substr(-1) === "/" ? e.substr(0, e.length - 1) : e;
      };
      fe.noneOrAll = function (e, r, t) {
        if (e) {
          var a = !1,
            n = !0,
            i,
            l;
          for (i = 0; i < t.length; i++) l = e[t[i]], l != null ? a = !0 : n = !1;
          if (a && !n) for (i = 0; i < t.length; i++) e[t[i]] = r[t[i]];
        }
      };
      fe.mergeArray = function (e, r, t, a) {
        var n = typeof a == "function";
        if (fe.isArrayOrTypedArray(e)) for (var i = Math.min(e.length, r.length), l = 0; l < i; l++) {
          var o = e[l];
          r[l][t] = n ? a(o) : o;
        }
      };
      fe.mergeArrayCastPositive = function (e, r, t) {
        return fe.mergeArray(e, r, t, function (a) {
          var n = +a;
          return isFinite(n) && n > 0 ? n : 0;
        });
      };
      fe.fillArray = function (e, r, t, a) {
        if (a = a || fe.identity, fe.isArrayOrTypedArray(e)) for (var n = 0; n < r.length; n++) r[n][t] = a(e[n]);
      };
      fe.castOption = function (e, r, t, a) {
        a = a || fe.identity;
        var n = fe.nestedProperty(e, t).get();
        return fe.isArrayOrTypedArray(n) ? Array.isArray(r) && fe.isArrayOrTypedArray(n[r[0]]) ? a(n[r[0]][r[1]]) : a(n[r]) : n;
      };
      fe.extractOption = function (e, r, t, a) {
        if (t in e) return e[t];
        var n = fe.nestedProperty(r, a).get();
        if (!Array.isArray(n)) return n;
      };
      function W4(e) {
        var r = {};
        for (var t in e) for (var a = e[t], n = 0; n < a.length; n++) r[a[n]] = +t;
        return r;
      }
      fe.tagSelected = function (e, r, t) {
        var a = r.selectedpoints,
          n = r._indexToPoints,
          i;
        n && (i = W4(n));
        function l(v) {
          return v !== void 0 && v < e.length;
        }
        for (var o = 0; o < a.length; o++) {
          var s = a[o];
          if (fe.isIndex(s) || fe.isArrayOrTypedArray(s) && fe.isIndex(s[0]) && fe.isIndex(s[1])) {
            var u = i ? i[s] : s,
              f = t ? t[u] : u;
            l(f) && (e[f].selected = 1);
          }
        }
      };
      fe.selIndices2selPoints = function (e) {
        var r = e.selectedpoints,
          t = e._indexToPoints;
        if (t) {
          for (var a = W4(t), n = [], i = 0; i < r.length; i++) {
            var l = r[i];
            if (fe.isIndex(l)) {
              var o = a[l];
              fe.isIndex(o) && n.push(o);
            }
          }
          return n;
        } else return r;
      };
      fe.getTargetArray = function (e, r) {
        var t = r.target;
        if (typeof t == "string" && t) {
          var a = fe.nestedProperty(e, t).get();
          return fe.isArrayOrTypedArray(a) ? a : !1;
        } else if (fe.isArrayOrTypedArray(t)) return t;
        return !1;
      };
      function Z4(e, r, t) {
        var a = {};
        typeof r != "object" && (r = {});
        var n = t === "pieLike" ? -1 : 3,
          i = Object.keys(e),
          l,
          o,
          s;
        for (l = 0; l < i.length; l++) o = i[l], s = e[o], !(o.charAt(0) === "_" || typeof s == "function") && (o === "module" ? a[o] = s : Array.isArray(s) ? o === "colorscale" || n === -1 ? a[o] = s.slice() : a[o] = s.slice(0, n) : fe.isTypedArray(s) ? n === -1 ? a[o] = s.subarray() : a[o] = s.subarray(0, n) : s && typeof s == "object" ? a[o] = Z4(e[o], r[o], t) : a[o] = s);
        for (i = Object.keys(r), l = 0; l < i.length; l++) o = i[l], s = r[o], (typeof s != "object" || !(o in a) || typeof a[o] != "object") && (a[o] = s);
        return a;
      }
      fe.minExtend = Z4;
      fe.titleCase = function (e) {
        return e.charAt(0).toUpperCase() + e.substr(1);
      };
      fe.containsAny = function (e, r) {
        for (var t = 0; t < r.length; t++) if (e.indexOf(r[t]) !== -1) return !0;
        return !1;
      };
      var XO = /Version\/[\d\.]+.*Safari/;
      fe.isSafari = function () {
        return XO.test(window.navigator.userAgent);
      };
      var JO = /iPad|iPhone|iPod/;
      fe.isIOS = function () {
        return JO.test(window.navigator.userAgent);
      };
      var KO = /Firefox\/(\d+)\.\d+/;
      fe.getFirefoxVersion = function () {
        var e = KO.exec(window.navigator.userAgent);
        if (e && e.length === 2) {
          var r = parseInt(e[1]);
          if (!isNaN(r)) return r;
        }
        return null;
      };
      fe.isD3Selection = function (e) {
        return e instanceof Qu.selection;
      };
      fe.ensureSingle = function (e, r, t, a) {
        var n = e.select(r + (t ? "." + t : ""));
        if (n.size()) return n;
        var i = e.append(r);
        return t && i.classed(t, !0), a && i.call(a), i;
      };
      fe.ensureSingleById = function (e, r, t, a) {
        var n = e.select(r + "#" + t);
        if (n.size()) return n;
        var i = e.append(r).attr("id", t);
        return a && i.call(a), i;
      };
      fe.objectFromPath = function (e, r) {
        for (var t = e.split("."), a, n = a = {}, i = 0; i < t.length; i++) {
          var l = t[i],
            o = null,
            s = t[i].match(/(.*)\[([0-9]+)\]/);
          s ? (l = s[1], o = s[2], a = a[l] = [], i === t.length - 1 ? a[o] = r : a[o] = {}, a = a[o]) : (i === t.length - 1 ? a[l] = r : a[l] = {}, a = a[l]);
        }
        return n;
      };
      var QO = /^([^\[\.]+)\.(.+)?/,
        $O = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
      function Fv(e) {
        return e.slice(0, 2) === "__";
      }
      fe.expandObjectPaths = function (e) {
        var r, t, a, n, i, l, o;
        if (typeof e == "object" && !Array.isArray(e)) {
          for (t in e) if (e.hasOwnProperty(t)) if (r = t.match(QO)) {
            if (n = e[t], a = r[1], Fv(a)) continue;
            delete e[t], e[a] = fe.extendDeepNoArrays(e[a] || {}, fe.objectFromPath(t, fe.expandObjectPaths(n))[a]);
          } else if (r = t.match($O)) {
            if (n = e[t], a = r[1], Fv(a)) continue;
            if (i = parseInt(r[2]), delete e[t], e[a] = e[a] || [], r[3] === ".") o = r[4], l = e[a][i] = e[a][i] || {}, fe.extendDeepNoArrays(l, fe.objectFromPath(o, fe.expandObjectPaths(n)));else {
              if (Fv(a)) continue;
              e[a][i] = fe.expandObjectPaths(n);
            }
          } else {
            if (Fv(t)) continue;
            e[t] = fe.expandObjectPaths(e[t]);
          }
        }
        return e;
      };
      fe.numSeparate = function (e, r, t) {
        if (t || (t = !1), typeof r != "string" || r.length === 0) throw new Error("Separator string required for formatting!");
        typeof e == "number" && (e = String(e));
        var a = /(\d+)(\d{3})/,
          n = r.charAt(0),
          i = r.charAt(1),
          l = e.split("."),
          o = l[0],
          s = l.length > 1 ? n + l[1] : "";
        if (i && (l.length > 1 || o.length > 4 || t)) for (; a.test(o);) o = o.replace(a, "$1" + i + "$2");
        return o + s;
      };
      fe.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
      var X4 = /^\w*$/;
      fe.templateString = function (e, r) {
        var t = {};
        return e.replace(fe.TEMPLATE_STRING_REGEX, function (a, n) {
          var i;
          return X4.test(n) ? i = r[n] : (t[n] = t[n] || fe.nestedProperty(r, n).get, i = t[n](!0)), i !== void 0 ? i : "";
        });
      };
      var jO = {
        max: 10,
        count: 0,
        name: "hovertemplate"
      };
      fe.hovertemplateString = function () {
        return wp.apply(jO, arguments);
      };
      var eB = {
        max: 10,
        count: 0,
        name: "texttemplate"
      };
      fe.texttemplateString = function () {
        return wp.apply(eB, arguments);
      };
      var rB = /^(\S+)([\*\/])(-?\d+(\.\d+)?)$/;
      function tB(e) {
        var r = e.match(rB);
        return r ? {
          key: r[1],
          op: r[2],
          number: Number(r[3])
        } : {
          key: e,
          op: null,
          number: null
        };
      }
      var aB = {
        max: 10,
        count: 0,
        name: "texttemplate",
        parseMultDiv: !0
      };
      fe.texttemplateStringForShapes = function () {
        return wp.apply(aB, arguments);
      };
      var H4 = /^[:|\|]/;
      function wp(e, r, t) {
        var a = this,
          n = arguments;
        return r || (r = {}), e.replace(fe.TEMPLATE_STRING_REGEX, function (i, l, o) {
          var s = l === "xother" || l === "yother",
            u = l === "_xother" || l === "_yother",
            f = l === "_xother_" || l === "_yother_",
            v = l === "xother_" || l === "yother_",
            h = s || u || v || f,
            d = l;
          (u || f) && (d = d.substring(1)), (v || f) && (d = d.substring(0, d.length - 1));
          var y = null,
            g = null;
          if (a.parseMultDiv) {
            var m = tB(d);
            d = m.key, y = m.op, g = m.number;
          }
          var _;
          if (h) {
            if (_ = r[d], _ === void 0) return "";
          } else {
            var w, T;
            for (T = 3; T < n.length; T++) if (w = n[T], !!w) {
              if (w.hasOwnProperty(d)) {
                _ = w[d];
                break;
              }
              if (X4.test(d) || (_ = fe.nestedProperty(w, d).get(!0)), _ !== void 0) break;
            }
          }
          if (_ !== void 0 && (y === "*" && (_ *= g), y === "/" && (_ /= g)), _ === void 0 && a) return a.count < a.max && (fe.warn("Variable '" + d + "' in " + a.name + " could not be found!"), _ = i), a.count === a.max && fe.warn("Too many " + a.name + " warnings - additional warnings will be suppressed"), a.count++, i;
          if (o) {
            var b;
            if (o[0] === ":" && (b = t ? t.numberFormat : fe.numberFormat, _ !== "" && (_ = b(o.replace(H4, ""))(_))), o[0] === "|") {
              b = t ? t.timeFormat : GO;
              var A = fe.dateTime2ms(_);
              _ = fe.formatDate(A, o.replace(H4, ""), !1, b);
            }
          } else {
            var S = d + "Label";
            r.hasOwnProperty(S) && (_ = r[S]);
          }
          return h && (_ = "(" + _ + ")", (u || f) && (_ = " " + _), (v || f) && (_ = _ + " ")), _;
        });
      }
      var Iv = 48,
        O4 = 57;
      fe.subplotSort = function (e, r) {
        for (var t = Math.min(e.length, r.length) + 1, a = 0, n = 0, i = 0; i < t; i++) {
          var l = e.charCodeAt(i) || 0,
            o = r.charCodeAt(i) || 0,
            s = l >= Iv && l <= O4,
            u = o >= Iv && o <= O4;
          if (s && (a = 10 * a + l - Iv), u && (n = 10 * n + o - Iv), !s || !u) {
            if (a !== n) return a - n;
            if (l !== o) return l - o;
          }
        }
        return n - a;
      };
      var bs = 2e9;
      fe.seedPseudoRandom = function () {
        bs = 2e9;
      };
      fe.pseudoRandom = function () {
        var e = bs;
        return bs = (69069 * bs + 1) % 4294967296, Math.abs(bs - e) < 429496729 ? fe.pseudoRandom() : bs / 4294967296;
      };
      fe.fillText = function (e, r, t) {
        var a = Array.isArray(t) ? function (l) {
            t.push(l);
          } : function (l) {
            t.text = l;
          },
          n = fe.extractOption(e, r, "htx", "hovertext");
        if (fe.isValidTextValue(n)) return a(n);
        var i = fe.extractOption(e, r, "tx", "text");
        if (fe.isValidTextValue(i)) return a(i);
      };
      fe.isValidTextValue = function (e) {
        return e || e === 0;
      };
      fe.formatPercent = function (e, r) {
        r = r || 0;
        for (var t = (Math.round(100 * e * Math.pow(10, r)) * Math.pow(.1, r)).toFixed(r) + "%", a = 0; a < r; a++) t.indexOf(".") !== -1 && (t = t.replace("0%", "%"), t = t.replace(".%", "%"));
        return t;
      };
      fe.isHidden = function (e) {
        var r = window.getComputedStyle(e).display;
        return !r || r === "none";
      };
      fe.strTranslate = function (e, r) {
        return e || r ? "translate(" + e + "," + r + ")" : "";
      };
      fe.strRotate = function (e) {
        return e ? "rotate(" + e + ")" : "";
      };
      fe.strScale = function (e) {
        return e !== 1 ? "scale(" + e + ")" : "";
      };
      fe.getTextTransform = function (e) {
        var r = e.noCenter,
          t = e.textX,
          a = e.textY,
          n = e.targetX,
          i = e.targetY,
          l = e.anchorX || 0,
          o = e.anchorY || 0,
          s = e.rotate,
          u = e.scale;
        return u ? u > 1 && (u = 1) : u = 0, fe.strTranslate(n - u * (t + l), i - u * (a + o)) + fe.strScale(u) + (s ? "rotate(" + s + (r ? "" : " " + t + " " + a) + ")" : "");
      };
      fe.setTransormAndDisplay = function (e, r) {
        e.attr("transform", fe.getTextTransform(r)), e.style("display", r.scale ? null : "none");
      };
      fe.ensureUniformFontSize = function (e, r) {
        var t = fe.extendFlat({}, r);
        return t.size = Math.max(r.size, e._fullLayout.uniformtext.minsize || 0), t;
      };
      fe.join2 = function (e, r, t) {
        var a = e.length;
        return a > 1 ? e.slice(0, -1).join(r) + t + e[a - 1] : e.join(r);
      };
      fe.bigFont = function (e) {
        return Math.round(1.2 * e);
      };
      var B4 = fe.getFirefoxVersion(),
        nB = B4 !== null && B4 < 86;
      fe.getPositionFromD3Event = function () {
        return nB ? [Qu.event.layerX, Qu.event.layerY] : [Qu.event.offsetX, Qu.event.offsetY];
      };
    });
    var $4 = Z(() => {
      "use strict";

      var iB = He(),
        K4 = {
          "X,X div": 'direction:ltr;font-family:"Open Sans",verdana,arial,sans-serif;margin:0;padding:0;',
          "X input,X button": 'font-family:"Open Sans",verdana,arial,sans-serif;',
          "X input:focus,X button:focus": "outline:none;",
          "X a": "text-decoration:none;",
          "X a:hover": "text-decoration:none;",
          "X .crisp": "shape-rendering:crispEdges;",
          "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
          "X svg a": "fill:#447adb;",
          "X svg a:hover": "fill:#3c6dc5;",
          "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
          "X .main-svg .draglayer": "pointer-events:all;",
          "X .cursor-default": "cursor:default;",
          "X .cursor-pointer": "cursor:pointer;",
          "X .cursor-crosshair": "cursor:crosshair;",
          "X .cursor-move": "cursor:move;",
          "X .cursor-col-resize": "cursor:col-resize;",
          "X .cursor-row-resize": "cursor:row-resize;",
          "X .cursor-ns-resize": "cursor:ns-resize;",
          "X .cursor-ew-resize": "cursor:ew-resize;",
          "X .cursor-sw-resize": "cursor:sw-resize;",
          "X .cursor-s-resize": "cursor:s-resize;",
          "X .cursor-se-resize": "cursor:se-resize;",
          "X .cursor-w-resize": "cursor:w-resize;",
          "X .cursor-e-resize": "cursor:e-resize;",
          "X .cursor-nw-resize": "cursor:nw-resize;",
          "X .cursor-n-resize": "cursor:n-resize;",
          "X .cursor-ne-resize": "cursor:ne-resize;",
          "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
          "X .modebar": "position:absolute;top:2px;right:2px;",
          "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;",
          "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;",
          "X:hover .modebar--hover .modebar-group": "opacity:1;",
          "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
          "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
          "X .modebar-btn svg": "position:relative;top:2px;",
          "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
          "X .modebar.vertical svg": "top:-1px;",
          "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
          "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
          "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
          "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
          "X [data-title]:before": 'content:"";position:absolute;background:rgba(0,0,0,0);border:6px solid rgba(0,0,0,0);z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;',
          "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
          "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
          "X .vertical [data-title]:before": "border:6px solid rgba(0,0,0,0);border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
          Y: 'font-family:"Open Sans",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;',
          "Y p": "margin:0;",
          "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
          "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
          "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
        };
      for (Tp in K4) Q4 = Tp.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier"), iB.addStyleRule(Q4, K4[Tp]);
      var Q4, Tp;
    });
    var Mp = Z(($le, j4) => {
      j4.exports = !0;
    });
    var kp = Z((jle, e6) => {
      "use strict";

      var lB = Mp(),
        Ap;
      typeof window.matchMedia == "function" ? Ap = !window.matchMedia("(hover: none)").matches : Ap = lB;
      e6.exports = Ap;
    });
    var Yv = Z((eoe, Cp) => {
      "use strict";

      var ws = typeof Reflect == "object" ? Reflect : null,
        r6 = ws && typeof ws.apply == "function" ? ws.apply : function (r, t, a) {
          return Function.prototype.apply.call(r, t, a);
        },
        Ov;
      ws && typeof ws.ownKeys == "function" ? Ov = ws.ownKeys : Object.getOwnPropertySymbols ? Ov = function (r) {
        return Object.getOwnPropertyNames(r).concat(Object.getOwnPropertySymbols(r));
      } : Ov = function (r) {
        return Object.getOwnPropertyNames(r);
      };
      function oB(e) {
        console && console.warn && console.warn(e);
      }
      var a6 = Number.isNaN || function (r) {
        return r !== r;
      };
      function vt() {
        vt.init.call(this);
      }
      Cp.exports = vt;
      Cp.exports.once = cB;
      vt.EventEmitter = vt;
      vt.prototype._events = void 0;
      vt.prototype._eventsCount = 0;
      vt.prototype._maxListeners = void 0;
      var t6 = 10;
      function Bv(e) {
        if (typeof e != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      }
      Object.defineProperty(vt, "defaultMaxListeners", {
        enumerable: !0,
        get: function () {
          return t6;
        },
        set: function (e) {
          if (typeof e != "number" || e < 0 || a6(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
          t6 = e;
        }
      });
      vt.init = function () {
        (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      };
      vt.prototype.setMaxListeners = function (r) {
        if (typeof r != "number" || r < 0 || a6(r)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + r + ".");
        return this._maxListeners = r, this;
      };
      function n6(e) {
        return e._maxListeners === void 0 ? vt.defaultMaxListeners : e._maxListeners;
      }
      vt.prototype.getMaxListeners = function () {
        return n6(this);
      };
      vt.prototype.emit = function (r) {
        for (var t = [], a = 1; a < arguments.length; a++) t.push(arguments[a]);
        var n = r === "error",
          i = this._events;
        if (i !== void 0) n = n && i.error === void 0;else if (!n) return !1;
        if (n) {
          var l;
          if (t.length > 0 && (l = t[0]), l instanceof Error) throw l;
          var o = new Error("Unhandled error." + (l ? " (" + l.message + ")" : ""));
          throw o.context = l, o;
        }
        var s = i[r];
        if (s === void 0) return !1;
        if (typeof s == "function") r6(s, this, t);else for (var u = s.length, f = u6(s, u), a = 0; a < u; ++a) r6(f[a], this, t);
        return !0;
      };
      function i6(e, r, t, a) {
        var n, i, l;
        if (Bv(t), i = e._events, i === void 0 ? (i = e._events = Object.create(null), e._eventsCount = 0) : (i.newListener !== void 0 && (e.emit("newListener", r, t.listener ? t.listener : t), i = e._events), l = i[r]), l === void 0) l = i[r] = t, ++e._eventsCount;else if (typeof l == "function" ? l = i[r] = a ? [t, l] : [l, t] : a ? l.unshift(t) : l.push(t), n = n6(e), n > 0 && l.length > n && !l.warned) {
          l.warned = !0;
          var o = new Error("Possible EventEmitter memory leak detected. " + l.length + " " + String(r) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          o.name = "MaxListenersExceededWarning", o.emitter = e, o.type = r, o.count = l.length, oB(o);
        }
        return e;
      }
      vt.prototype.addListener = function (r, t) {
        return i6(this, r, t, !1);
      };
      vt.prototype.on = vt.prototype.addListener;
      vt.prototype.prependListener = function (r, t) {
        return i6(this, r, t, !0);
      };
      function sB() {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
      }
      function l6(e, r, t) {
        var a = {
            fired: !1,
            wrapFn: void 0,
            target: e,
            type: r,
            listener: t
          },
          n = sB.bind(a);
        return n.listener = t, a.wrapFn = n, n;
      }
      vt.prototype.once = function (r, t) {
        return Bv(t), this.on(r, l6(this, r, t)), this;
      };
      vt.prototype.prependOnceListener = function (r, t) {
        return Bv(t), this.prependListener(r, l6(this, r, t)), this;
      };
      vt.prototype.removeListener = function (r, t) {
        var a, n, i, l, o;
        if (Bv(t), n = this._events, n === void 0) return this;
        if (a = n[r], a === void 0) return this;
        if (a === t || a.listener === t) --this._eventsCount === 0 ? this._events = Object.create(null) : (delete n[r], n.removeListener && this.emit("removeListener", r, a.listener || t));else if (typeof a != "function") {
          for (i = -1, l = a.length - 1; l >= 0; l--) if (a[l] === t || a[l].listener === t) {
            o = a[l].listener, i = l;
            break;
          }
          if (i < 0) return this;
          i === 0 ? a.shift() : uB(a, i), a.length === 1 && (n[r] = a[0]), n.removeListener !== void 0 && this.emit("removeListener", r, o || t);
        }
        return this;
      };
      vt.prototype.off = vt.prototype.removeListener;
      vt.prototype.removeAllListeners = function (r) {
        var t, a, n;
        if (a = this._events, a === void 0) return this;
        if (a.removeListener === void 0) return arguments.length === 0 ? (this._events = Object.create(null), this._eventsCount = 0) : a[r] !== void 0 && (--this._eventsCount === 0 ? this._events = Object.create(null) : delete a[r]), this;
        if (arguments.length === 0) {
          var i = Object.keys(a),
            l;
          for (n = 0; n < i.length; ++n) l = i[n], l !== "removeListener" && this.removeAllListeners(l);
          return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
        }
        if (t = a[r], typeof t == "function") this.removeListener(r, t);else if (t !== void 0) for (n = t.length - 1; n >= 0; n--) this.removeListener(r, t[n]);
        return this;
      };
      function o6(e, r, t) {
        var a = e._events;
        if (a === void 0) return [];
        var n = a[r];
        return n === void 0 ? [] : typeof n == "function" ? t ? [n.listener || n] : [n] : t ? fB(n) : u6(n, n.length);
      }
      vt.prototype.listeners = function (r) {
        return o6(this, r, !0);
      };
      vt.prototype.rawListeners = function (r) {
        return o6(this, r, !1);
      };
      vt.listenerCount = function (e, r) {
        return typeof e.listenerCount == "function" ? e.listenerCount(r) : s6.call(e, r);
      };
      vt.prototype.listenerCount = s6;
      function s6(e) {
        var r = this._events;
        if (r !== void 0) {
          var t = r[e];
          if (typeof t == "function") return 1;
          if (t !== void 0) return t.length;
        }
        return 0;
      }
      vt.prototype.eventNames = function () {
        return this._eventsCount > 0 ? Ov(this._events) : [];
      };
      function u6(e, r) {
        for (var t = new Array(r), a = 0; a < r; ++a) t[a] = e[a];
        return t;
      }
      function uB(e, r) {
        for (; r + 1 < e.length; r++) e[r] = e[r + 1];
        e.pop();
      }
      function fB(e) {
        for (var r = new Array(e.length), t = 0; t < r.length; ++t) r[t] = e[t].listener || e[t];
        return r;
      }
      function cB(e, r) {
        return new Promise(function (t, a) {
          function n(l) {
            e.removeListener(r, i), a(l);
          }
          function i() {
            typeof e.removeListener == "function" && e.removeListener("error", n), t([].slice.call(arguments));
          }
          f6(e, r, i, {
            once: !0
          }), r !== "error" && vB(e, n, {
            once: !0
          });
        });
      }
      function vB(e, r, t) {
        typeof e.on == "function" && f6(e, "error", r, t);
      }
      function f6(e, r, t, a) {
        if (typeof e.on == "function") a.once ? e.once(r, t) : e.on(r, t);else if (typeof e.addEventListener == "function") e.addEventListener(r, function n(i) {
          a.once && e.removeEventListener(r, n), t(i);
        });else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
      }
    });
    var $u = Z((roe, c6) => {
      "use strict";

      var Sp = Yv().EventEmitter,
        hB = {
          init: function (e) {
            if (e._ev instanceof Sp) return e;
            var r = new Sp(),
              t = new Sp();
            return e._ev = r, e._internalEv = t, e.on = r.on.bind(r), e.once = r.once.bind(r), e.removeListener = r.removeListener.bind(r), e.removeAllListeners = r.removeAllListeners.bind(r), e._internalOn = t.on.bind(t), e._internalOnce = t.once.bind(t), e._removeInternalListener = t.removeListener.bind(t), e._removeAllInternalListeners = t.removeAllListeners.bind(t), e.emit = function (a, n) {
              r.emit(a, n), t.emit(a, n);
            }, e;
          },
          triggerHandler: function (e, r, t) {
            var a,
              n = e._ev;
            if (!n) return;
            var i = n._events[r];
            if (!i) return;
            function l(s) {
              if (s.listener) {
                if (n.removeListener(r, s.listener), !s.fired) return s.fired = !0, s.listener.apply(n, [t]);
              } else return s.apply(n, [t]);
            }
            i = Array.isArray(i) ? i : [i];
            var o;
            for (o = 0; o < i.length - 1; o++) l(i[o]);
            return a = l(i[o]), a;
          },
          purge: function (e) {
            return delete e._ev, delete e.on, delete e.once, delete e.removeListener, delete e.removeAllListeners, delete e.emit, delete e._ev, delete e._internalEv, delete e._internalOn, delete e._internalOnce, delete e._removeInternalListener, delete e._removeAllInternalListeners, e;
          }
        };
      c6.exports = hB;
    });
    var d6 = Z((toe, h6) => {
      "use strict";

      var v6 = He(),
        dB = eo().dfltConfig;
      function pB(e, r) {
        for (var t = [], a, n = 0; n < r.length; n++) a = r[n], a === e ? t[n] = a : typeof a == "object" ? t[n] = Array.isArray(a) ? v6.extendDeep([], a) : v6.extendDeepAll({}, a) : t[n] = a;
        return t;
      }
      var Bi = {};
      Bi.add = function (e, r, t, a, n) {
        var i, l;
        if (e.undoQueue = e.undoQueue || {
          index: 0,
          queue: [],
          sequence: !1
        }, l = e.undoQueue.index, e.autoplay) {
          e.undoQueue.inSequence || (e.autoplay = !1);
          return;
        }
        !e.undoQueue.sequence || e.undoQueue.beginSequence ? (i = {
          undo: {
            calls: [],
            args: []
          },
          redo: {
            calls: [],
            args: []
          }
        }, e.undoQueue.queue.splice(l, e.undoQueue.queue.length - l, i), e.undoQueue.index += 1) : i = e.undoQueue.queue[l - 1], e.undoQueue.beginSequence = !1, i && (i.undo.calls.unshift(r), i.undo.args.unshift(t), i.redo.calls.push(a), i.redo.args.push(n)), e.undoQueue.queue.length > dB.queueLength && (e.undoQueue.queue.shift(), e.undoQueue.index--);
      };
      Bi.startSequence = function (e) {
        e.undoQueue = e.undoQueue || {
          index: 0,
          queue: [],
          sequence: !1
        }, e.undoQueue.sequence = !0, e.undoQueue.beginSequence = !0;
      };
      Bi.stopSequence = function (e) {
        e.undoQueue = e.undoQueue || {
          index: 0,
          queue: [],
          sequence: !1
        }, e.undoQueue.sequence = !1, e.undoQueue.beginSequence = !1;
      };
      Bi.undo = function (r) {
        var t, a;
        if (!(r.undoQueue === void 0 || isNaN(r.undoQueue.index) || r.undoQueue.index <= 0)) {
          for (r.undoQueue.index--, t = r.undoQueue.queue[r.undoQueue.index], r.undoQueue.inSequence = !0, a = 0; a < t.undo.calls.length; a++) Bi.plotDo(r, t.undo.calls[a], t.undo.args[a]);
          r.undoQueue.inSequence = !1, r.autoplay = !1;
        }
      };
      Bi.redo = function (r) {
        var t, a;
        if (!(r.undoQueue === void 0 || isNaN(r.undoQueue.index) || r.undoQueue.index >= r.undoQueue.queue.length)) {
          for (t = r.undoQueue.queue[r.undoQueue.index], r.undoQueue.inSequence = !0, a = 0; a < t.redo.calls.length; a++) Bi.plotDo(r, t.redo.calls[a], t.redo.args[a]);
          r.undoQueue.inSequence = !1, r.autoplay = !1, r.undoQueue.index++;
        }
      };
      Bi.plotDo = function (e, r, t) {
        e.autoplay = !0, t = pB(e, t), r.apply(null, t);
      };
      h6.exports = Bi;
    });
    var Lp = Z((aoe, p6) => {
      "use strict";

      p6.exports = {
        _isLinkedToArray: "frames_entry",
        group: {
          valType: "string"
        },
        name: {
          valType: "string"
        },
        traces: {
          valType: "any"
        },
        baseframe: {
          valType: "string"
        },
        data: {
          valType: "any"
        },
        layout: {
          valType: "any"
        }
      };
    });
    var As = Z(Ut => {
      "use strict";

      var _n = gr(),
        ju = He(),
        Gv = Gn(),
        qp = ds(),
        mB = Lp(),
        yB = Vu(),
        gB = eo().configAttributes,
        m6 = pi(),
        Zn = ju.extendDeepAll,
        Ts = ju.isPlainObject,
        bB = ju.isArrayOrTypedArray,
        Vv = ju.nestedProperty,
        xB = ju.valObjectMeta,
        Dp = "_isSubplotObj",
        Wv = "_isLinkedToArray",
        _B = "_arrayAttrRegexps",
        g6 = "_deprecated",
        Ep = [Dp, Wv, _B, g6];
      Ut.IS_SUBPLOT_OBJ = Dp;
      Ut.IS_LINKED_TO_ARRAY = Wv;
      Ut.DEPRECATED = g6;
      Ut.UNDERSCORE_ATTRS = Ep;
      Ut.get = function () {
        var e = {};
        return _n.allTypes.forEach(function (r) {
          e[r] = TB(r);
        }), {
          defs: {
            valObjects: xB,
            metaKeys: Ep.concat(["description", "role", "editType", "impliedEdits"]),
            editType: {
              traces: m6.traces,
              layout: m6.layout
            },
            impliedEdits: {}
          },
          traces: e,
          layout: MB(),
          frames: AB(),
          animation: Ms(yB),
          config: Ms(gB)
        };
      };
      Ut.crawl = function (e, r, t, a) {
        var n = t || 0;
        a = a || "", Object.keys(e).forEach(function (i) {
          var l = e[i];
          if (Ep.indexOf(i) === -1) {
            var o = (a ? a + "." : "") + i;
            r(l, i, e, n, o), !Ut.isValObject(l) && Ts(l) && i !== "impliedEdits" && Ut.crawl(l, r, n + 1, o);
          }
        });
      };
      Ut.isValObject = function (e) {
        return e && e.valType !== void 0;
      };
      Ut.findArrayAttributes = function (e) {
        var r = [],
          t = [],
          a = [],
          n,
          i;
        function l(s, u, f, v) {
          t = t.slice(0, v).concat([u]), a = a.slice(0, v).concat([s && s._isLinkedToArray]);
          var h = s && (s.valType === "data_array" || s.arrayOk === !0) && !(t[v - 1] === "colorbar" && (u === "ticktext" || u === "tickvals"));
          h && o(n, 0, "");
        }
        function o(s, u, f) {
          var v = s[t[u]],
            h = f + t[u];
          if (u === t.length - 1) bB(v) && r.push(i + h);else if (a[u]) {
            if (Array.isArray(v)) for (var d = 0; d < v.length; d++) Ts(v[d]) && o(v[d], u + 1, h + "[" + d + "].");
          } else Ts(v) && o(v, u + 1, h + ".");
        }
        return n = e, i = "", Ut.crawl(Gv, l), e._module && e._module.attributes && Ut.crawl(e._module.attributes, l), r;
      };
      Ut.getTraceValObject = function (e, r) {
        var t = r[0],
          a = 1,
          n,
          i,
          l = e._module;
        if (l || (l = (_n.modules[e.type || Gv.type.dflt] || {})._module), !l) return !1;
        if (n = l.attributes, i = n && n[t], !i) {
          var o = l.basePlotModule;
          o && o.attributes && (i = o.attributes[t]);
        }
        return i || (i = Gv[t]), b6(i, r, a);
      };
      Ut.getLayoutValObject = function (e, r) {
        var t = wB(e, r[0]);
        return b6(t, r, 1);
      };
      function wB(e, r) {
        var t,
          a,
          n,
          i,
          l = e._basePlotModules;
        if (l) {
          var o;
          for (t = 0; t < l.length; t++) {
            if (n = l[t], n.attrRegex && n.attrRegex.test(r)) {
              if (n.layoutAttrOverrides) return n.layoutAttrOverrides;
              !o && n.layoutAttributes && (o = n.layoutAttributes);
            }
            var s = n.baseLayoutAttrOverrides;
            if (s && r in s) return s[r];
          }
          if (o) return o;
        }
        var u = e._modules;
        if (u) {
          for (t = 0; t < u.length; t++) if (i = u[t].layoutAttributes, i && r in i) return i[r];
        }
        for (a in _n.componentsRegistry) {
          if (n = _n.componentsRegistry[a], n.name === "colorscale" && r.indexOf("coloraxis") === 0) return n.layoutAttributes[r];
          if (!n.schema && r === n.name) return n.layoutAttributes;
        }
        return r in qp ? qp[r] : !1;
      }
      function b6(e, r, t) {
        if (!e) return !1;
        if (e._isLinkedToArray) {
          if (Uv(r[t])) t++;else if (t < r.length) return !1;
        }
        for (; t < r.length; t++) {
          var a = e[r[t]];
          if (Ts(a)) e = a;else break;
          if (t === r.length - 1) break;
          if (e._isLinkedToArray) {
            if (t++, !Uv(r[t])) return !1;
          } else if (e.valType === "info_array") {
            t++;
            var n = r[t];
            if (!Uv(n)) return !1;
            var i = e.items;
            if (Array.isArray(i)) {
              if (n >= i.length) return !1;
              if (e.dimensions === 2) {
                if (t++, r.length === t) return e;
                var l = r[t];
                if (!Uv(l)) return !1;
                e = i[n][l];
              } else e = i[n];
            } else e = i;
          }
        }
        return e;
      }
      function Uv(e) {
        return e === Math.round(e) && e >= 0;
      }
      function TB(e) {
        var r, t;
        r = _n.modules[e]._module, t = r.basePlotModule;
        var a = {};
        a.type = null;
        var n = Zn({}, Gv),
          i = Zn({}, r.attributes);
        Ut.crawl(i, function (s, u, f, v, h) {
          Vv(n, h).set(void 0), s === void 0 && Vv(i, h).set(void 0);
        }), Zn(a, n), _n.traceIs(e, "noOpacity") && delete a.opacity, _n.traceIs(e, "showLegend") || (delete a.showlegend, delete a.legendgroup), _n.traceIs(e, "noHover") && (delete a.hoverinfo, delete a.hoverlabel), r.selectPoints || delete a.selectedpoints, Zn(a, i), t.attributes && Zn(a, t.attributes), a.type = e;
        var l = {
          meta: r.meta || {},
          categories: r.categories || {},
          animatable: !!r.animatable,
          type: e,
          attributes: Ms(a)
        };
        if (r.layoutAttributes) {
          var o = {};
          Zn(o, r.layoutAttributes), l.layoutAttributes = Ms(o);
        }
        return r.animatable || Ut.crawl(l, function (s) {
          Ut.isValObject(s) && "anim" in s && delete s.anim;
        }), l;
      }
      function MB() {
        var e = {},
          r,
          t;
        Zn(e, qp);
        for (r in _n.subplotsRegistry) if (t = _n.subplotsRegistry[r], !!t.layoutAttributes) if (Array.isArray(t.attr)) for (var a = 0; a < t.attr.length; a++) y6(e, t, t.attr[a]);else {
          var n = t.attr === "subplot" ? t.name : t.attr;
          y6(e, t, n);
        }
        for (r in _n.componentsRegistry) {
          t = _n.componentsRegistry[r];
          var i = t.schema;
          if (i && (i.subplots || i.layout)) {
            var l = i.subplots;
            if (l && l.xaxis && !l.yaxis) for (var o in l.xaxis) delete e.yaxis[o];
            delete e.xaxis.shift, delete e.xaxis.autoshift;
          } else t.name === "colorscale" ? Zn(e, t.layoutAttributes) : t.layoutAttributes && LB(e, t.layoutAttributes, t.name);
        }
        return {
          layoutAttributes: Ms(e)
        };
      }
      function AB() {
        var e = {
          frames: Zn({}, mB)
        };
        return Ms(e), e.frames;
      }
      function Ms(e) {
        return kB(e), CB(e), SB(e), e;
      }
      function kB(e) {
        function r(a) {
          return {
            valType: "string",
            editType: "none"
          };
        }
        function t(a, n, i) {
          Ut.isValObject(a) ? (a.arrayOk === !0 || a.valType === "data_array") && (i[n + "src"] = r(n)) : Ts(a) && (a.role = "object");
        }
        Ut.crawl(e, t);
      }
      function CB(e) {
        function r(t, a, n) {
          if (t) {
            var i = t[Wv];
            i && (delete t[Wv], n[a] = {
              items: {}
            }, n[a].items[i] = t, n[a].role = "object");
          }
        }
        Ut.crawl(e, r);
      }
      function SB(e) {
        function r(t) {
          for (var a in t) if (Ts(t[a])) r(t[a]);else if (Array.isArray(t[a])) for (var n = 0; n < t[a].length; n++) r(t[a][n]);else t[a] instanceof RegExp && (t[a] = t[a].toString());
        }
        r(e);
      }
      function y6(e, r, t) {
        var a = Vv(e, t),
          n = Zn({}, r.layoutAttributes);
        n[Dp] = !0, a.set(n);
      }
      function LB(e, r, t) {
        var a = Vv(e, t);
        a.set(Zn(a.get() || {}, r));
      }
    });
    var ct = Z(lo => {
      "use strict";

      var ks = He(),
        qB = Gn(),
        dl = "templateitemname",
        Pp = {
          name: {
            valType: "string",
            editType: "none"
          }
        };
      Pp[dl] = {
        valType: "string",
        editType: "calc"
      };
      lo.templatedArray = function (e, r) {
        return r._isLinkedToArray = e, r.name = Pp.name, r[dl] = Pp[dl], r;
      };
      lo.traceTemplater = function (e) {
        var r = {},
          t,
          a;
        for (t in e) a = e[t], Array.isArray(a) && a.length && (r[t] = 0);
        function n(i) {
          t = ks.coerce(i, {}, qB, "type");
          var l = {
            type: t,
            _template: null
          };
          if (t in r) {
            a = e[t];
            var o = r[t] % a.length;
            r[t]++, l._template = a[o];
          }
          return l;
        }
        return {
          newTrace: n
        };
      };
      lo.newContainer = function (e, r, t) {
        var a = e._template,
          n = a && (a[r] || t && a[t]);
        ks.isPlainObject(n) || (n = null);
        var i = e[r] = {
          _template: n
        };
        return i;
      };
      lo.arrayTemplater = function (e, r, t) {
        var a = e._template,
          n = a && a[_6(r)],
          i = a && a[r];
        (!Array.isArray(i) || !i.length) && (i = []);
        var l = {};
        function o(u) {
          var f = {
              name: u.name,
              _input: u
            },
            v = f[dl] = u[dl];
          if (!x6(v)) return f._template = n, f;
          for (var h = 0; h < i.length; h++) {
            var d = i[h];
            if (d.name === v) return l[v] = 1, f._template = d, f;
          }
          return f[t] = u[t] || !1, f._template = !1, f;
        }
        function s() {
          for (var u = [], f = 0; f < i.length; f++) {
            var v = i[f],
              h = v.name;
            if (x6(h) && !l[h]) {
              var d = {
                _template: v,
                name: h,
                _input: {
                  _templateitemname: h
                }
              };
              d[dl] = v[dl], u.push(d), l[h] = 1;
            }
          }
          return u;
        }
        return {
          newItem: o,
          defaultItems: s
        };
      };
      function x6(e) {
        return e && typeof e == "string";
      }
      function _6(e) {
        var r = e.length - 1;
        return e.charAt(r) !== "s" && ks.warn("bad argument to arrayDefaultKey: " + e), e.substr(0, e.length - 1) + "defaults";
      }
      lo.arrayDefaultKey = _6;
      lo.arrayEditor = function (e, r, t) {
        var a = (ks.nestedProperty(e, r).get() || []).length,
          n = t._index,
          i = n >= a && (t._input || {})._templateitemname;
        i && (n = a);
        var l = r + "[" + n + "]",
          o;
        function s() {
          o = {}, i && (o[l] = {}, o[l][dl] = i);
        }
        s();
        function u(d, y) {
          o[d] = y;
        }
        function f(d, y) {
          i ? ks.nestedProperty(o[l], d).set(y) : o[l + "." + d] = y;
        }
        function v() {
          var d = o;
          return s(), d;
        }
        function h(d, y) {
          d && f(d, y);
          var g = v();
          for (var m in g) ks.nestedProperty(e, m).set(g[m]);
        }
        return {
          modifyBase: u,
          modifyItem: f,
          getUpdateObj: v,
          applyUpdate: h
        };
      };
    });
    var da = Z((loe, w6) => {
      "use strict";

      var ef = cs().counter;
      w6.exports = {
        idRegex: {
          x: ef("x", "( domain)?"),
          y: ef("y", "( domain)?")
        },
        attrRegex: ef("[xy]axis"),
        xAxisMatch: ef("xaxis"),
        yAxisMatch: ef("yaxis"),
        AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
        AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
        SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
        HOUR_PATTERN: "hour",
        WEEKDAY_PATTERN: "day of week",
        MINDRAG: 8,
        MINZOOM: 20,
        DRAGGERSIZE: 20,
        REDRAWDELAY: 50,
        DFLTRANGEX: [-1, 6],
        DFLTRANGEY: [-1, 4],
        traceLayerClasses: ["imagelayer", "heatmaplayer", "contourcarpetlayer", "contourlayer", "funnellayer", "waterfalllayer", "barlayer", "carpetlayer", "violinlayer", "boxlayer", "ohlclayer", "scattercarpetlayer", "scatterlayer"],
        clipOnAxisFalseQuery: [".scatterlayer", ".barlayer", ".funnellayer", ".waterfalllayer"],
        layerValue2layerClass: {
          "above traces": "above",
          "below traces": "below"
        },
        zindexSeparator: "z"
      };
    });
    var Xt = Z(Ja => {
      "use strict";

      var DB = gr(),
        Rp = da();
      Ja.id2name = function (r) {
        if (!(typeof r != "string" || !r.match(Rp.AX_ID_PATTERN))) {
          var t = r.split(" ")[0].substr(1);
          return t === "1" && (t = ""), r.charAt(0) + "axis" + t;
        }
      };
      Ja.name2id = function (r) {
        if (r.match(Rp.AX_NAME_PATTERN)) {
          var t = r.substr(5);
          return t === "1" && (t = ""), r.charAt(0) + t;
        }
      };
      Ja.cleanId = function (r, t, a) {
        var n = /( domain)$/.test(r);
        if (!(typeof r != "string" || !r.match(Rp.AX_ID_PATTERN)) && !(t && r.charAt(0) !== t) && !(n && !a)) {
          var i = r.split(" ")[0].substr(1).replace(/^0+/, "");
          return i === "1" && (i = ""), r.charAt(0) + i + (n && a ? " domain" : "");
        }
      };
      Ja.list = function (e, r, t) {
        var a = e._fullLayout;
        if (!a) return [];
        var n = Ja.listIds(e, r),
          i = new Array(n.length),
          l;
        for (l = 0; l < n.length; l++) {
          var o = n[l];
          i[l] = a[o.charAt(0) + "axis" + o.substr(1)];
        }
        if (!t) {
          var s = a._subplots.gl3d || [];
          for (l = 0; l < s.length; l++) {
            var u = a[s[l]];
            r ? i.push(u[r + "axis"]) : i.push(u.xaxis, u.yaxis, u.zaxis);
          }
        }
        return i;
      };
      Ja.listIds = function (e, r) {
        var t = e._fullLayout;
        if (!t) return [];
        var a = t._subplots;
        return r ? a[r + "axis"] : a.xaxis.concat(a.yaxis);
      };
      Ja.getFromId = function (e, r, t) {
        var a = e._fullLayout;
        return r = r === void 0 || typeof r != "string" ? r : r.replace(" domain", ""), t === "x" ? r = r.replace(/y[0-9]*/, "") : t === "y" && (r = r.replace(/x[0-9]*/, "")), a[Ja.id2name(r)];
      };
      Ja.getFromTrace = function (e, r, t) {
        var a = e._fullLayout,
          n = null;
        if (DB.traceIs(r, "gl3d")) {
          var i = r.scene;
          i.substr(0, 5) === "scene" && (n = a[i][t + "axis"]);
        } else n = Ja.getFromId(e, r[t + "axis"] || t);
        return n;
      };
      Ja.idSort = function (e, r) {
        var t = e.charAt(0),
          a = r.charAt(0);
        return t !== a ? t > a ? 1 : -1 : +(e.substr(1) || 1) - +(r.substr(1) || 1);
      };
      Ja.ref2id = function (e) {
        return /^[xyz]/.test(e) ? e.split(" ")[0] : !1;
      };
      function T6(e, r) {
        if (r && r.length) {
          for (var t = 0; t < r.length; t++) if (r[t][e]) return !0;
        }
        return !1;
      }
      Ja.isLinked = function (e, r) {
        return T6(r, e._axisMatchGroups) || T6(r, e._axisConstraintGroups);
      };
    });
    var pl = Z((soe, M6) => {
      "use strict";

      function EB(e) {
        var r = e._fullLayout._zoomlayer;
        r && r.selectAll(".outline-controllers").remove();
      }
      function PB(e) {
        var r = e._fullLayout._zoomlayer;
        r && r.selectAll(".select-outline").remove(), e._fullLayout._outlining = !1;
      }
      M6.exports = {
        clearOutlineControllers: EB,
        clearOutline: PB
      };
    });
    var Zv = Z((uoe, A6) => {
      "use strict";

      A6.exports = {
        scattermode: {
          valType: "enumerated",
          values: ["group", "overlay"],
          dflt: "overlay",
          editType: "calc"
        },
        scattergap: {
          valType: "number",
          min: 0,
          max: 1,
          editType: "calc"
        }
      };
    });
    var zp = Z(Jv => {
      "use strict";

      var Xv = gr(),
        foe = da().SUBPLOT_PATTERN;
      Jv.getSubplotCalcData = function (e, r, t) {
        var a = Xv.subplotsRegistry[r];
        if (!a) return [];
        for (var n = a.attr, i = [], l = 0; l < e.length; l++) {
          var o = e[l],
            s = o[0].trace;
          s[n] === t && i.push(o);
        }
        return i;
      };
      Jv.getModuleCalcData = function (e, r, t) {
        var a = [],
          n = [],
          i;
        if (typeof r == "string" ? i = Xv.getModule(r).plot : typeof r == "function" ? i = r : i = r.plot, !i) return [a, e];
        for (var l = t, o = 0; o < e.length; o++) {
          var s = e[o],
            u = s[0].trace,
            f = u.zorder !== void 0;
          u.visible !== !0 || u._length === 0 || (u._module && u._module.plot === i && (!f || u.zorder === l) ? a.push(s) : n.push(s));
        }
        return [a, n];
      };
      Jv.getSubplotData = function (r, t, a) {
        if (!Xv.subplotsRegistry[t]) return [];
        for (var n = Xv.subplotsRegistry[t].attr, i = [], l, o, s, u = 0; u < r.length; u++) l = r[u], l[n] === a && i.push(l);
        return i;
      };
    });
    var L6 = Z(oo => {
      "use strict";

      var RB = gr(),
        Cs = He();
      oo.manageCommandObserver = function (e, r, t, a) {
        var n = {},
          i = !0;
        r && r._commandObserver && (n = r._commandObserver), n.cache || (n.cache = {}), n.lookupTable = {};
        var l = oo.hasSimpleAPICommandBindings(e, t, n.lookupTable);
        if (r && r._commandObserver) {
          if (l) return n;
          if (r._commandObserver.remove) return r._commandObserver.remove(), r._commandObserver = null, n;
        }
        if (l) {
          k6(e, l, n.cache), n.check = function () {
            if (i) {
              var f = k6(e, l, n.cache);
              return f.changed && a && n.lookupTable[f.value] !== void 0 && (n.disable(), Promise.resolve(a({
                value: f.value,
                type: l.type,
                prop: l.prop,
                traces: l.traces,
                index: n.lookupTable[f.value]
              })).then(n.enable, n.enable)), f.changed;
            }
          };
          for (var o = ["plotly_relayout", "plotly_redraw", "plotly_restyle", "plotly_update", "plotly_animatingframe", "plotly_afterplot"], s = 0; s < o.length; s++) e._internalOn(o[s], n.check);
          n.remove = function () {
            for (var u = 0; u < o.length; u++) e._removeInternalListener(o[u], n.check);
          };
        } else Cs.log("Unable to automatically bind plot updates to API command"), n.lookupTable = {}, n.remove = function () {};
        return n.disable = function () {
          i = !1;
        }, n.enable = function () {
          i = !0;
        }, r && (r._commandObserver = n), n;
      };
      oo.hasSimpleAPICommandBindings = function (e, r, t) {
        var a,
          n = r.length,
          i;
        for (a = 0; a < n; a++) {
          var l,
            o = r[a],
            s = o.method,
            u = o.args;
          if (Array.isArray(u) || (u = []), !s) return !1;
          var f = oo.computeAPICommandBindings(e, s, u);
          if (f.length !== 1) return !1;
          if (!i) i = f[0], Array.isArray(i.traces) && i.traces.sort();else {
            if (l = f[0], l.type !== i.type || l.prop !== i.prop) return !1;
            if (Array.isArray(i.traces)) {
              if (Array.isArray(l.traces)) {
                l.traces.sort();
                for (var v = 0; v < i.traces.length; v++) if (i.traces[v] !== l.traces[v]) return !1;
              } else return !1;
            } else if (l.prop !== i.prop) return !1;
          }
          l = f[0];
          var h = l.value;
          if (Array.isArray(h)) if (h.length === 1) h = h[0];else return !1;
          t && (t[h] = a);
        }
        return i;
      };
      function k6(e, r, t) {
        var a,
          n,
          i,
          l = !1;
        if (r.type === "data") a = e._fullData[r.traces !== null ? r.traces[0] : 0];else if (r.type === "layout") a = e._fullLayout;else return !1;
        return n = Cs.nestedProperty(a, r.prop).get(), i = t[r.type] = t[r.type] || {}, i.hasOwnProperty(r.prop) && i[r.prop] !== n && (l = !0), i[r.prop] = n, {
          changed: l,
          value: n
        };
      }
      oo.executeAPICommand = function (e, r, t) {
        if (r === "skip") return Promise.resolve();
        var a = RB.apiMethodRegistry[r],
          n = [e];
        Array.isArray(t) || (t = []);
        for (var i = 0; i < t.length; i++) n.push(t[i]);
        return a.apply(null, n).catch(function (l) {
          return Cs.warn("API call to Plotly." + r + " rejected.", l), Promise.reject(l);
        });
      };
      oo.computeAPICommandBindings = function (e, r, t) {
        var a;
        switch (Array.isArray(t) || (t = []), r) {
          case "restyle":
            a = S6(e, t);
            break;
          case "relayout":
            a = C6(e, t);
            break;
          case "update":
            a = S6(e, [t[0], t[2]]).concat(C6(e, [t[1]]));
            break;
          case "animate":
            a = zB(e, t);
            break;
          default:
            a = [];
        }
        return a;
      };
      function zB(e, r) {
        return Array.isArray(r[0]) && r[0].length === 1 && ["string", "number"].indexOf(typeof r[0][0]) !== -1 ? [{
          type: "layout",
          prop: "_currentFrame",
          value: r[0][0].toString()
        }] : [];
      }
      function C6(e, r) {
        var t = [],
          a = r[0],
          n = {};
        if (typeof a == "string") n[a] = r[1];else if (Cs.isPlainObject(a)) n = a;else return t;
        return Np(n, function (i, l, o) {
          t.push({
            type: "layout",
            prop: i,
            value: o
          });
        }, "", 0), t;
      }
      function S6(e, r) {
        var t,
          a,
          n,
          i,
          l = [];
        if (a = r[0], n = r[1], t = r[2], i = {}, typeof a == "string") i[a] = n;else if (Cs.isPlainObject(a)) i = a, t === void 0 && (t = n);else return l;
        return t === void 0 && (t = null), Np(i, function (o, s, u) {
          var f, v;
          if (Array.isArray(u)) {
            v = u.slice();
            var h = Math.min(v.length, e.data.length);
            t && (h = Math.min(h, t.length)), f = [];
            for (var d = 0; d < h; d++) f[d] = t ? t[d] : d;
          } else v = u, f = t ? t.slice() : null;
          if (f === null) Array.isArray(v) && (v = v[0]);else if (Array.isArray(f)) {
            if (!Array.isArray(v)) {
              var y = v;
              v = [];
              for (var g = 0; g < f.length; g++) v[g] = y;
            }
            v.length = Math.min(f.length, v.length);
          }
          l.push({
            type: "data",
            prop: o,
            traces: f,
            value: v
          });
        }, "", 0), l;
      }
      function Np(e, r, t, a) {
        Object.keys(e).forEach(function (n) {
          var i = e[n];
          if (n[0] !== "_") {
            var l = t + (a > 0 ? "." : "") + n;
            Cs.isPlainObject(i) ? Np(i, r, l, a + 1) : r(l, n, i);
          }
        });
      }
    });
    var Pt = Z((hoe, U6) => {
      "use strict";

      var N6 = Ir(),
        NB = os().timeFormatLocale,
        FB = O1().formatLocale,
        rf = Hr(),
        IB = B1(),
        Xr = gr(),
        F6 = As(),
        HB = ct(),
        ur = He(),
        I6 = Er(),
        q6 = Bt().BADNUM,
        Ka = Xt(),
        OB = pl().clearOutline,
        BB = Zv(),
        Fp = Vu(),
        YB = Lp(),
        UB = zp().getModuleCalcData,
        D6 = ur.relinkPrivateKeys,
        so = ur._,
        je = U6.exports = {};
      ur.extendFlat(je, Xr);
      je.attributes = Gn();
      je.attributes.type.values = je.allTypes;
      je.fontAttrs = ha();
      je.layoutAttributes = ds();
      var Qv = L6();
      je.executeAPICommand = Qv.executeAPICommand;
      je.computeAPICommandBindings = Qv.computeAPICommandBindings;
      je.manageCommandObserver = Qv.manageCommandObserver;
      je.hasSimpleAPICommandBindings = Qv.hasSimpleAPICommandBindings;
      je.redrawText = function (e) {
        return e = ur.getGraphDiv(e), new Promise(function (r) {
          setTimeout(function () {
            e._fullLayout && (Xr.getComponentMethod("annotations", "draw")(e), Xr.getComponentMethod("legend", "draw")(e), Xr.getComponentMethod("colorbar", "draw")(e), r(je.previousPromises(e)));
          }, 300);
        });
      };
      je.resize = function (e) {
        e = ur.getGraphDiv(e);
        var r,
          t = new Promise(function (a, n) {
            (!e || ur.isHidden(e)) && n(new Error("Resize must be passed a displayed plot div element.")), e._redrawTimer && clearTimeout(e._redrawTimer), e._resolveResize && (r = e._resolveResize), e._resolveResize = a, e._redrawTimer = setTimeout(function () {
              if (!e.layout || e.layout.width && e.layout.height || ur.isHidden(e)) {
                a(e);
                return;
              }
              delete e.layout.width, delete e.layout.height;
              var i = e.changed;
              e.autoplay = !0, Xr.call("relayout", e, {
                autosize: !0
              }).then(function () {
                e.changed = i, e._resolveResize === a && (delete e._resolveResize, a(e));
              });
            }, 100);
          });
        return r && r(t), t;
      };
      je.previousPromises = function (e) {
        if ((e._promises || []).length) return Promise.all(e._promises).then(function () {
          e._promises = [];
        });
      };
      je.addLinks = function (e) {
        if (!(!e._context.showLink && !e._context.showSources)) {
          var r = e._fullLayout,
            t = ur.ensureSingle(r._paper, "text", "js-plot-link-container", function (s) {
              s.style({
                "font-family": '"Open Sans", Arial, sans-serif',
                "font-size": "12px",
                fill: I6.defaultLine,
                "pointer-events": "all"
              }).each(function () {
                var u = N6.select(this);
                u.append("tspan").classed("js-link-to-tool", !0), u.append("tspan").classed("js-link-spacer", !0), u.append("tspan").classed("js-sourcelinks", !0);
              });
            }),
            a = t.node(),
            n = {
              y: r._paper.attr("height") - 9
            };
          document.body.contains(a) && a.getComputedTextLength() >= r.width - 20 ? (n["text-anchor"] = "start", n.x = 5) : (n["text-anchor"] = "end", n.x = r._paper.attr("width") - 7), t.attr(n);
          var i = t.select(".js-link-to-tool"),
            l = t.select(".js-link-spacer"),
            o = t.select(".js-sourcelinks");
          e._context.showSources && e._context.showSources(e), e._context.showLink && GB(e, i), l.text(i.text() && o.text() ? " - " : "");
        }
      };
      function GB(e, r) {
        r.text("");
        var t = r.append("a").attr({
          "xlink:xlink:href": "#",
          class: "link--impt link--embedview",
          "font-weight": "bold"
        }).text(e._context.linkText + " \xBB");
        if (e._context.sendData) t.on("click", function () {
          je.sendDataToCloud(e);
        });else {
          var a = window.location.pathname.split("/"),
            n = window.location.search;
          t.attr({
            "xlink:xlink:show": "new",
            "xlink:xlink:href": "/" + a[2].split(".")[0] + "/" + a[1] + n
          });
        }
      }
      je.sendDataToCloud = function (e) {
        var r = (window.PLOTLYENV || {}).BASE_URL || e._context.plotlyServerURL;
        if (r) {
          e.emit("plotly_beforeexport");
          var t = N6.select(e).append("div").attr("id", "hiddenform").style("display", "none"),
            a = t.append("form").attr({
              action: r + "/external",
              method: "post",
              target: "_blank"
            }),
            n = a.append("input").attr({
              type: "text",
              name: "data"
            });
          return n.node().value = je.graphJson(e, !1, "keepdata"), a.node().submit(), t.remove(), e.emit("plotly_afterexport"), !1;
        }
      };
      var VB = ["days", "shortDays", "months", "shortMonths", "periods", "dateTime", "date", "time", "decimal", "thousands", "grouping", "currency"],
        WB = ["year", "month", "dayMonth", "dayMonthYear"];
      je.supplyDefaults = function (e, r) {
        var t = r && r.skipUpdateCalc,
          a = e._fullLayout || {};
        if (a._skipDefaults) {
          delete a._skipDefaults;
          return;
        }
        var n = e._fullLayout = {},
          i = e.layout || {},
          l = e._fullData || [],
          o = e._fullData = [],
          s = e.data || [],
          u = e.calcdata || [],
          f = e._context || {},
          v;
        e._transitionData || je.createTransitionData(e), n._dfltTitle = {
          plot: so(e, "Click to enter Plot title"),
          subtitle: so(e, "Click to enter Plot subtitle"),
          x: so(e, "Click to enter X axis title"),
          y: so(e, "Click to enter Y axis title"),
          colorbar: so(e, "Click to enter Colorscale title"),
          annotation: so(e, "new text")
        }, n._traceWord = so(e, "trace");
        var h = E6(e, VB);
        if (n._mapboxAccessToken = f.mapboxAccessToken, a._initialAutoSizeIsDone) {
          var d = a.width,
            y = a.height;
          je.supplyLayoutGlobalDefaults(i, n, h), i.width || (n.width = d), i.height || (n.height = y), je.sanitizeMargins(n);
        } else {
          je.supplyLayoutGlobalDefaults(i, n, h);
          var g = !i.width || !i.height,
            m = n.autosize,
            _ = f.autosizable,
            w = g && (m || _);
          w ? je.plotAutoSize(e, i, n) : g && je.sanitizeMargins(n), !m && g && (i.width = n.width, i.height = n.height);
        }
        n._d3locale = JB(h, n.separators), n._extraFormat = E6(e, WB), n._initialAutoSizeIsDone = !0, n._dataLength = s.length, n._modules = [], n._visibleModules = [], n._basePlotModules = [];
        var T = n._subplots = XB(),
          b = n._splomAxes = {
            x: {},
            y: {}
          },
          A = n._splomSubplots = {};
        n._splomGridDflt = {}, n._scatterStackOpts = {}, n._firstScatter = {}, n._alignmentOpts = {}, n._colorAxes = {}, n._requestRangeslider = {}, n._traceUids = ZB(l, s), je.supplyDataDefaults(s, o, i, n);
        var S = Object.keys(b.x),
          k = Object.keys(b.y);
        if (S.length > 1 && k.length > 1) {
          for (Xr.getComponentMethod("grid", "sizeDefaults")(i, n), v = 0; v < S.length; v++) ur.pushUnique(T.xaxis, S[v]);
          for (v = 0; v < k.length; v++) ur.pushUnique(T.yaxis, k[v]);
          for (var q in A) ur.pushUnique(T.cartesian, q);
        }
        if (n._has = je._hasPlotType.bind(n), l.length === o.length) for (v = 0; v < o.length; v++) D6(o[v], l[v]);
        je.supplyLayoutModuleDefaults(i, n, o, e._transitionData);
        var D = n._visibleModules,
          R = [];
        for (v = 0; v < D.length; v++) {
          var z = D[v].crossTraceDefaults;
          z && ur.pushUnique(R, z);
        }
        for (v = 0; v < R.length; v++) R[v](o, n);
        n._hasOnlyLargeSploms = n._basePlotModules.length === 1 && n._basePlotModules[0].name === "splom" && S.length > 15 && k.length > 15 && n.shapes.length === 0 && n.images.length === 0, je.linkSubplots(o, n, l, a), je.cleanPlot(o, n, l, a);
        var N = !!(a._has && a._has("cartesian")),
          H = !!(n._has && n._has("cartesian")),
          O = N,
          J = H;
        O && !J ? a._bgLayer.remove() : J && !O && (n._shouldCreateBgLayer = !0), a._zoomlayer && !e._dragging && OB({
          _fullLayout: a
        }), KB(o, n), D6(n, a), Xr.getComponentMethod("colorscale", "crossTraceDefaults")(o, n), n._preGUI || (n._preGUI = {}), n._tracePreGUI || (n._tracePreGUI = {});
        var X = n._tracePreGUI,
          B = {},
          I;
        for (I in X) B[I] = "old";
        for (v = 0; v < o.length; v++) I = o[v]._fullInput.uid, B[I] || (X[I] = {}), B[I] = "new";
        for (I in B) B[I] === "old" && delete X[I];
        H6(n), Xr.getComponentMethod("rangeslider", "makeData")(n), !t && u.length === o.length && je.supplyDefaultsUpdateCalc(u, o);
      };
      je.supplyDefaultsUpdateCalc = function (e, r) {
        for (var t = 0; t < r.length; t++) {
          var a = r[t],
            n = (e[t] || [])[0];
          if (n && n.trace) {
            var i = n.trace;
            if (i._hasCalcTransform) {
              var l = i._arrayAttrs,
                o,
                s,
                u;
              for (o = 0; o < l.length; o++) s = l[o], u = ur.nestedProperty(i, s).get().slice(), ur.nestedProperty(a, s).set(u);
            }
            n.trace = a;
          }
        }
      };
      function ZB(e, r) {
        var t = r.length,
          a = [],
          n,
          i;
        for (n = 0; n < e.length; n++) {
          var l = e[n]._fullInput;
          l !== i && a.push(l), i = l;
        }
        var o = a.length,
          s = new Array(t),
          u = {};
        function f(d, y) {
          s[y] = d, u[d] = 1;
        }
        function v(d, y) {
          if (d && typeof d == "string" && !u[d]) return f(d, y), !0;
        }
        for (n = 0; n < t; n++) {
          var h = r[n].uid;
          typeof h == "number" && (h = String(h)), !v(h, n) && (n < o && v(a[n].uid, n) || f(ur.randstr(u), n));
        }
        return s;
      }
      function XB() {
        var e = Xr.collectableSubplotTypes,
          r = {},
          t,
          a;
        if (!e) {
          e = [];
          var n = Xr.subplotsRegistry;
          for (var i in n) {
            var l = n[i],
              o = l.attr;
            if (o && (e.push(i), Array.isArray(o))) for (a = 0; a < o.length; a++) ur.pushUnique(e, o[a]);
          }
        }
        for (t = 0; t < e.length; t++) r[e[t]] = [];
        return r;
      }
      function E6(e, r) {
        var t = e._context.locale;
        t || (t = "en-US");
        var a = !1,
          n = {};
        function i(v) {
          for (var h = !0, d = 0; d < r.length; d++) {
            var y = r[d];
            n[y] || (v[y] ? n[y] = v[y] : h = !1);
          }
          h && (a = !0);
        }
        for (var l = 0; l < 2; l++) {
          for (var o = e._context.locales, s = 0; s < 2; s++) {
            var u = (o[t] || {}).format;
            if (u && (i(u), a)) break;
            o = Xr.localeRegistry;
          }
          var f = t.split("-")[0];
          if (a || f === t) break;
          t = f;
        }
        return a || i(Xr.localeRegistry.en.format), n;
      }
      function JB(e, r) {
        return e.decimal = r.charAt(0), e.thousands = r.charAt(1), {
          numberFormat: function (t) {
            try {
              t = FB(e).format(ur.adjustFormat(t));
            } catch (a) {
              return ur.warnBadFormat(t), ur.noFormat;
            }
            return t;
          },
          timeFormat: NB(e).utcFormat
        };
      }
      function KB(e, r) {
        var t,
          a = [];
        r.meta && (t = r._meta = {
          meta: r.meta,
          layout: {
            meta: r.meta
          }
        });
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          i.meta ? a[i.index] = i._meta = {
            meta: i.meta
          } : r.meta && (i._meta = {
            meta: r.meta
          }), r.meta && (i._meta.layout = {
            meta: r.meta
          });
        }
        a.length && (t || (t = r._meta = {}), t.data = a);
      }
      je.createTransitionData = function (e) {
        e._transitionData || (e._transitionData = {}), e._transitionData._frames || (e._transitionData._frames = []), e._transitionData._frameHash || (e._transitionData._frameHash = {}), e._transitionData._counter || (e._transitionData._counter = 0), e._transitionData._interruptCallbacks || (e._transitionData._interruptCallbacks = []);
      };
      je._hasPlotType = function (e) {
        var r,
          t = this._basePlotModules || [];
        for (r = 0; r < t.length; r++) if (t[r].name === e) return !0;
        var a = this._modules || [];
        for (r = 0; r < a.length; r++) {
          var n = a[r].name;
          if (n === e) return !0;
          var i = Xr.modules[n];
          if (i && i.categories[e]) return !0;
        }
        return !1;
      };
      je.cleanPlot = function (e, r, t, a) {
        var n,
          i,
          l = a._basePlotModules || [];
        for (n = 0; n < l.length; n++) {
          var o = l[n];
          o.clean && o.clean(e, r, t, a);
        }
        var s = a._has && a._has("gl"),
          u = r._has && r._has("gl");
        s && !u && a._glcontainer !== void 0 && (a._glcontainer.selectAll(".gl-canvas").remove(), a._glcontainer.selectAll(".no-webgl").remove(), a._glcanvas = null);
        var f = !!a._infolayer;
        e: for (n = 0; n < t.length; n++) {
          var v = t[n],
            h = v.uid;
          for (i = 0; i < e.length; i++) {
            var d = e[i];
            if (h === d.uid) continue e;
          }
          f && a._infolayer.select(".cb" + h).remove();
        }
      };
      je.linkSubplots = function (e, r, t, a) {
        var n,
          i,
          l = a._plots || {},
          o = r._plots = {},
          s = r._subplots,
          u = {
            _fullData: e,
            _fullLayout: r
          },
          f = s.cartesian || [];
        for (n = 0; n < f.length; n++) {
          var v = f[n],
            h = l[v],
            d = Ka.getFromId(u, v, "x"),
            y = Ka.getFromId(u, v, "y"),
            g;
          for (h ? g = o[v] = h : (g = o[v] = {}, g.id = v), d._counterAxes.push(y._id), y._counterAxes.push(d._id), d._subplotsWith.push(v), y._subplotsWith.push(v), g.xaxis = d, g.yaxis = y, g._hasClipOnAxisFalse = !1, i = 0; i < e.length; i++) {
            var m = e[i];
            if (m.xaxis === g.xaxis._id && m.yaxis === g.yaxis._id && m.cliponaxis === !1) {
              g._hasClipOnAxisFalse = !0;
              break;
            }
          }
        }
        var _ = Ka.list(u, null, !0),
          w;
        for (n = 0; n < _.length; n++) {
          w = _[n];
          var T = null;
          w.overlaying && (T = Ka.getFromId(u, w.overlaying), T && T.overlaying && (w.overlaying = !1, T = null)), w._mainAxis = T || w, T && (w.domain = T.domain.slice()), w._anchorAxis = w.anchor === "free" ? null : Ka.getFromId(u, w.anchor);
        }
        for (n = 0; n < _.length; n++) if (w = _[n], w._counterAxes.sort(Ka.idSort), w._subplotsWith.sort(ur.subplotSort), w._mainSubplot = QB(w, r), w._counterAxes.length && (w.spikemode && w.spikemode.indexOf("across") !== -1 || w.automargin && w.mirror && w.anchor !== "free" || Xr.getComponentMethod("rangeslider", "isVisible")(w))) {
          var b = 1,
            A = 0;
          for (i = 0; i < w._counterAxes.length; i++) {
            var S = Ka.getFromId(u, w._counterAxes[i]);
            b = Math.min(b, S.domain[0]), A = Math.max(A, S.domain[1]);
          }
          b < A && (w._counterDomainMin = b, w._counterDomainMax = A);
        }
      };
      function QB(e, r) {
        var t = {
            _fullLayout: r
          },
          a = e._id.charAt(0) === "x",
          n = e._mainAxis._anchorAxis,
          i = "",
          l = "",
          o = "";
        if (n && (o = n._mainAxis._id, i = a ? e._id + o : o + e._id), !i || !r._plots[i]) {
          i = "";
          for (var s = e._counterAxes, u = 0; u < s.length; u++) {
            var f = s[u],
              v = a ? e._id + f : f + e._id;
            l || (l = v);
            var h = Ka.getFromId(t, f);
            if (o && h.overlaying === o) {
              i = v;
              break;
            }
          }
        }
        return i || l;
      }
      je.clearExpandedTraceDefaultColors = function (e) {
        var r, t, a;
        function n(l, o, s, u) {
          t[u] = o, t.length = u + 1, l.valType === "color" && l.dflt === void 0 && r.push(t.join("."));
        }
        for (t = [], r = e._module._colorAttrs, r || (e._module._colorAttrs = r = [], F6.crawl(e._module.attributes, n)), a = 0; a < r.length; a++) {
          var i = ur.nestedProperty(e, "_input." + r[a]);
          i.get() || ur.nestedProperty(e, r[a]).set(null);
        }
      };
      je.supplyDataDefaults = function (e, r, t, a) {
        var n = a._modules,
          i = a._visibleModules,
          l = a._basePlotModules,
          o = 0,
          s = 0,
          u,
          f,
          v;
        a._transformModules = [];
        function h(w) {
          r.push(w);
          var T = w._module;
          T && (ur.pushUnique(n, T), w.visible === !0 && ur.pushUnique(i, T), ur.pushUnique(l, w._module.basePlotModule), o++, w._input.visible !== !1 && s++);
        }
        var d = {},
          y = [],
          g = (t.template || {}).data || {},
          m = HB.traceTemplater(g);
        for (u = 0; u < e.length; u++) v = e[u], f = m.newTrace(v), f.uid = a._traceUids[u], je.supplyTraceDefaults(v, f, s, a, u), f.index = u, f._input = v, f._fullInput = f, h(f), Xr.traceIs(f, "carpetAxis") && (d[f.carpet] = f), Xr.traceIs(f, "carpetDependent") && y.push(u);
        for (u = 0; u < y.length; u++) if (f = r[y[u]], !!f.visible) {
          var _ = d[f.carpet];
          if (f._carpet = _, !_ || !_.visible) {
            f.visible = !1;
            continue;
          }
          f.xaxis = _.xaxis, f.yaxis = _.yaxis;
        }
      };
      je.supplyAnimationDefaults = function (e) {
        e = e || {};
        var r,
          t = {};
        function a(n, i) {
          return ur.coerce(e || {}, t, Fp, n, i);
        }
        if (a("mode"), a("direction"), a("fromcurrent"), Array.isArray(e.frame)) for (t.frame = [], r = 0; r < e.frame.length; r++) t.frame[r] = je.supplyAnimationFrameDefaults(e.frame[r] || {});else t.frame = je.supplyAnimationFrameDefaults(e.frame || {});
        if (Array.isArray(e.transition)) for (t.transition = [], r = 0; r < e.transition.length; r++) t.transition[r] = je.supplyAnimationTransitionDefaults(e.transition[r] || {});else t.transition = je.supplyAnimationTransitionDefaults(e.transition || {});
        return t;
      };
      je.supplyAnimationFrameDefaults = function (e) {
        var r = {};
        function t(a, n) {
          return ur.coerce(e || {}, r, Fp.frame, a, n);
        }
        return t("duration"), t("redraw"), r;
      };
      je.supplyAnimationTransitionDefaults = function (e) {
        var r = {};
        function t(a, n) {
          return ur.coerce(e || {}, r, Fp.transition, a, n);
        }
        return t("duration"), t("easing"), r;
      };
      je.supplyFrameDefaults = function (e) {
        var r = {};
        function t(a, n) {
          return ur.coerce(e, r, YB, a, n);
        }
        return t("group"), t("name"), t("traces"), t("baseframe"), t("data"), t("layout"), r;
      };
      je.supplyTraceDefaults = function (e, r, t, a, n) {
        var i = a.colorway || I6.defaults,
          l = i[t % i.length],
          o;
        function s(T, b) {
          return ur.coerce(e, r, je.attributes, T, b);
        }
        var u = s("visible");
        s("type"), s("name", a._traceWord + " " + n), s("uirevision", a.uirevision);
        var f = je.getModule(r);
        if (r._module = f, f) {
          var v = f.basePlotModule,
            h = v.attr,
            d = v.attributes;
          if (h && d) {
            var y = a._subplots,
              g = "";
            if (Array.isArray(h)) for (o = 0; o < h.length; o++) {
              var m = h[o],
                _ = ur.coerce(e, r, d, m);
              y[m] && ur.pushUnique(y[m], _), g += _;
            } else g = ur.coerce(e, r, d, h);
            y[v.name] && ur.pushUnique(y[v.name], g);
          }
        }
        if (u && (s("customdata"), s("ids"), s("meta"), Xr.traceIs(r, "showLegend") ? (ur.coerce(e, r, f.attributes.showlegend ? f.attributes : je.attributes, "showlegend"), s("legend"), s("legendwidth"), s("legendgroup"), s("legendgrouptitle.text"), s("legendrank"), r._dfltShowLegend = !0) : r._dfltShowLegend = !1, f && f.supplyDefaults(e, r, l, a), Xr.traceIs(r, "noOpacity") || s("opacity"), Xr.traceIs(r, "notLegendIsolatable") && (r.visible = !!r.visible), Xr.traceIs(r, "noHover") || (r.hovertemplate || ur.coerceHoverinfo(e, r, a), r.type !== "parcats" && Xr.getComponentMethod("fx", "supplyDefaults")(e, r, l, a)), f && f.selectPoints)) {
          var w = s("selectedpoints");
          ur.isTypedArray(w) && (r.selectedpoints = Array.from(w));
        }
        return r;
      };
      je.supplyLayoutGlobalDefaults = function (e, r, t) {
        function a(v, h) {
          return ur.coerce(e, r, je.layoutAttributes, v, h);
        }
        var n = e.template;
        ur.isPlainObject(n) && (r.template = n, r._template = n.layout, r._dataTemplate = n.data), a("autotypenumbers");
        var i = ur.coerceFont(a, "font"),
          l = i.size;
        ur.coerceFont(a, "title.font", i, {
          overrideDflt: {
            size: Math.round(l * 1.4)
          }
        }), a("title.text", r._dfltTitle.plot), a("title.xref");
        var o = a("title.yref");
        a("title.pad.t"), a("title.pad.r"), a("title.pad.b"), a("title.pad.l");
        var s = a("title.automargin");
        a("title.x"), a("title.xanchor"), a("title.y"), a("title.yanchor"), a("title.subtitle.text", r._dfltTitle.subtitle), ur.coerceFont(a, "title.subtitle.font", i, {
          overrideDflt: {
            size: Math.round(r.title.font.size * .7)
          }
        }), s && (o === "paper" && (r.title.y !== 0 && (r.title.y = 1), r.title.yanchor === "auto" && (r.title.yanchor = r.title.y === 0 ? "top" : "bottom")), o === "container" && (r.title.y === "auto" && (r.title.y = 1), r.title.yanchor === "auto" && (r.title.yanchor = r.title.y < .5 ? "bottom" : "top")));
        var u = a("uniformtext.mode");
        u && a("uniformtext.minsize"), a("autosize", !(e.width && e.height)), a("width"), a("height"), a("minreducedwidth"), a("minreducedheight"), a("margin.l"), a("margin.r"), a("margin.t"), a("margin.b"), a("margin.pad"), a("margin.autoexpand"), e.width && e.height && je.sanitizeMargins(r), Xr.getComponentMethod("grid", "sizeDefaults")(e, r), a("paper_bgcolor"), a("separators", t.decimal + t.thousands), a("hidesources"), a("colorway"), a("datarevision");
        var f = a("uirevision");
        a("editrevision", f), a("selectionrevision", f), Xr.getComponentMethod("modebar", "supplyLayoutDefaults")(e, r), Xr.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(e, r, a), Xr.getComponentMethod("selections", "supplyDrawNewSelectionDefaults")(e, r, a), a("meta"), ur.isPlainObject(e.transition) && (a("transition.duration"), a("transition.easing"), a("transition.ordering")), Xr.getComponentMethod("calendars", "handleDefaults")(e, r, "calendar"), Xr.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(e, r, a), ur.coerce(e, r, BB, "scattermode");
      };
      function Kv(e) {
        return typeof e == "string" && e.substr(e.length - 2) === "px" && parseFloat(e);
      }
      je.plotAutoSize = function (r, t, a) {
        var n = r._context || {},
          i = n.frameMargins,
          l,
          o,
          s = ur.isPlotDiv(r);
        if (s && r.emit("plotly_autosize"), n.fillFrame) l = window.innerWidth, o = window.innerHeight, document.body.style.overflow = "hidden";else {
          var u = s ? window.getComputedStyle(r) : {};
          if (l = Kv(u.width) || Kv(u.maxWidth) || a.width, o = Kv(u.height) || Kv(u.maxHeight) || a.height, rf(i) && i > 0) {
            var f = 1 - 2 * i;
            l = Math.round(f * l), o = Math.round(f * o);
          }
        }
        var v = je.layoutAttributes.width.min,
          h = je.layoutAttributes.height.min;
        l < v && (l = v), o < h && (o = h);
        var d = !t.width && Math.abs(a.width - l) > 1,
          y = !t.height && Math.abs(a.height - o) > 1;
        (y || d) && (d && (a.width = l), y && (a.height = o)), r._initialAutoSize || (r._initialAutoSize = {
          width: l,
          height: o
        }), je.sanitizeMargins(a);
      };
      je.supplyLayoutModuleDefaults = function (e, r, t, a) {
        var n = Xr.componentsRegistry,
          i = r._basePlotModules,
          l,
          o,
          s,
          u = Xr.subplotsRegistry.cartesian;
        for (l in n) s = n[l], s.includeBasePlot && s.includeBasePlot(e, r);
        i.length || i.push(u), r._has("cartesian") && (Xr.getComponentMethod("grid", "contentDefaults")(e, r), u.finalizeSubplots(e, r));
        for (var f in r._subplots) r._subplots[f].sort(ur.subplotSort);
        for (o = 0; o < i.length; o++) s = i[o], s.supplyLayoutDefaults && s.supplyLayoutDefaults(e, r, t);
        var v = r._modules;
        for (o = 0; o < v.length; o++) s = v[o], s.supplyLayoutDefaults && s.supplyLayoutDefaults(e, r, t);
        var h = r._transformModules;
        for (o = 0; o < h.length; o++) s = h[o], s.supplyLayoutDefaults && s.supplyLayoutDefaults(e, r, t, a);
        for (l in n) s = n[l], s.supplyLayoutDefaults && s.supplyLayoutDefaults(e, r, t);
      };
      je.purge = function (e) {
        var r = e._fullLayout || {};
        r._glcontainer !== void 0 && (r._glcontainer.selectAll(".gl-canvas").remove(), r._glcontainer.remove(), r._glcanvas = null), r._modeBar && r._modeBar.destroy(), e._transitionData && (e._transitionData._interruptCallbacks && (e._transitionData._interruptCallbacks.length = 0), e._transitionData._animationRaf && window.cancelAnimationFrame(e._transitionData._animationRaf)), ur.clearThrottle(), ur.clearResponsive(e), delete e.data, delete e.layout, delete e._fullData, delete e._fullLayout, delete e.calcdata, delete e.empty, delete e.fid, delete e.undoqueue, delete e.undonum, delete e.autoplay, delete e.changed, delete e._promises, delete e._redrawTimer, delete e._hmlumcount, delete e._hmpixcount, delete e._transitionData, delete e._transitioning, delete e._initialAutoSize, delete e._transitioningWithDuration, delete e._dragging, delete e._dragged, delete e._dragdata, delete e._hoverdata, delete e._snapshotInProgress, delete e._editing, delete e._mouseDownTime, delete e._legendMouseDownTime, e.removeAllListeners && e.removeAllListeners();
      };
      je.style = function (e) {
        var r = e._fullLayout._visibleModules,
          t = [],
          a;
        for (a = 0; a < r.length; a++) {
          var n = r[a];
          n.style && ur.pushUnique(t, n.style);
        }
        for (a = 0; a < t.length; a++) t[a](e);
      };
      je.sanitizeMargins = function (e) {
        if (!(!e || !e.margin)) {
          var r = e.width,
            t = e.height,
            a = e.margin,
            n = r - (a.l + a.r),
            i = t - (a.t + a.b),
            l;
          n < 0 && (l = (r - 1) / (a.l + a.r), a.l = Math.floor(l * a.l), a.r = Math.floor(l * a.r)), i < 0 && (l = (t - 1) / (a.t + a.b), a.t = Math.floor(l * a.t), a.b = Math.floor(l * a.b));
        }
      };
      je.clearAutoMarginIds = function (e) {
        e._fullLayout._pushmarginIds = {};
      };
      je.allowAutoMargin = function (e, r) {
        e._fullLayout._pushmarginIds[r] = 1;
      };
      function H6(e) {
        var r = e.margin;
        if (!e._size) {
          var t = e._size = {
            l: Math.round(r.l),
            r: Math.round(r.r),
            t: Math.round(r.t),
            b: Math.round(r.b),
            p: Math.round(r.pad)
          };
          t.w = Math.round(e.width) - t.l - t.r, t.h = Math.round(e.height) - t.t - t.b;
        }
        e._pushmargin || (e._pushmargin = {}), e._pushmarginIds || (e._pushmarginIds = {}), e._reservedMargin || (e._reservedMargin = {});
      }
      var O6 = 2,
        B6 = 2;
      je.autoMargin = function (e, r, t) {
        var a = e._fullLayout,
          n = a.width,
          i = a.height,
          l = a.margin,
          o = a.minreducedwidth,
          s = a.minreducedheight,
          u = ur.constrain(n - l.l - l.r, O6, o),
          f = ur.constrain(i - l.t - l.b, B6, s),
          v = Math.max(0, n - u),
          h = Math.max(0, i - f),
          d = a._pushmargin,
          y = a._pushmarginIds;
        if (l.autoexpand !== !1) {
          if (!t) delete d[r], delete y[r];else {
            var g = t.pad;
            if (g === void 0 && (g = Math.min(12, l.l, l.r, l.t, l.b)), v) {
              var m = (t.l + t.r) / v;
              m > 1 && (t.l /= m, t.r /= m);
            }
            if (h) {
              var _ = (t.t + t.b) / h;
              _ > 1 && (t.t /= _, t.b /= _);
            }
            var w = t.xl !== void 0 ? t.xl : t.x,
              T = t.xr !== void 0 ? t.xr : t.x,
              b = t.yt !== void 0 ? t.yt : t.y,
              A = t.yb !== void 0 ? t.yb : t.y;
            d[r] = {
              l: {
                val: w,
                size: t.l + g
              },
              r: {
                val: T,
                size: t.r + g
              },
              b: {
                val: A,
                size: t.b + g
              },
              t: {
                val: b,
                size: t.t + g
              }
            }, y[r] = 1;
          }
          if (!a._replotting) return je.doAutoMargin(e);
        }
      };
      function $B(e) {
        if ("_redrawFromAutoMarginCount" in e._fullLayout) return !1;
        var r = Ka.list(e, "", !0);
        for (var t in r) if (r[t].autoshift || r[t].shift) return !0;
        return !1;
      }
      je.doAutoMargin = function (e) {
        var r = e._fullLayout,
          t = r.width,
          a = r.height;
        r._size || (r._size = {}), H6(r);
        var n = r._size,
          i = r.margin,
          l = {
            t: 0,
            b: 0,
            l: 0,
            r: 0
          },
          o = ur.extendFlat({}, n),
          s = i.l,
          u = i.r,
          f = i.t,
          v = i.b,
          h = r._pushmargin,
          d = r._pushmarginIds,
          y = r.minreducedwidth,
          g = r.minreducedheight;
        if (i.autoexpand !== !1) {
          for (var m in h) d[m] || delete h[m];
          var _ = e._fullLayout._reservedMargin;
          for (var w in _) for (var T in _[w]) {
            var b = _[w][T];
            l[T] = Math.max(l[T], b);
          }
          h.base = {
            l: {
              val: 0,
              size: s
            },
            r: {
              val: 1,
              size: u
            },
            t: {
              val: 1,
              size: f
            },
            b: {
              val: 0,
              size: v
            }
          };
          for (var A in l) {
            var S = 0;
            for (var k in h) k !== "base" && rf(h[k][A].size) && (S = h[k][A].size > S ? h[k][A].size : S);
            var q = Math.max(0, i[A] - S);
            l[A] = Math.max(0, l[A] - q);
          }
          for (var D in h) {
            var R = h[D].l || {},
              z = h[D].b || {},
              N = R.val,
              H = R.size,
              O = z.val,
              J = z.size,
              X = t - l.r - l.l,
              B = a - l.t - l.b;
            for (var I in h) {
              if (rf(H) && h[I].r) {
                var V = h[I].r.val,
                  K = h[I].r.size;
                if (V > N) {
                  var Q = (H * V + (K - X) * N) / (V - N),
                    ie = (K * (1 - N) + (H - X) * (1 - V)) / (V - N);
                  Q + ie > s + u && (s = Q, u = ie);
                }
              }
              if (rf(J) && h[I].t) {
                var me = h[I].t.val,
                  pe = h[I].t.size;
                if (me > O) {
                  var ge = (J * me + (pe - B) * O) / (me - O),
                    j = (pe * (1 - O) + (J - B) * (1 - me)) / (me - O);
                  ge + j > v + f && (v = ge, f = j);
                }
              }
            }
          }
        }
        var _e = ur.constrain(t - i.l - i.r, O6, y),
          se = ur.constrain(a - i.t - i.b, B6, g),
          Se = Math.max(0, t - _e),
          ve = Math.max(0, a - se);
        if (Se) {
          var Ae = (s + u) / Se;
          Ae > 1 && (s /= Ae, u /= Ae);
        }
        if (ve) {
          var Y = (v + f) / ve;
          Y > 1 && (v /= Y, f /= Y);
        }
        if (n.l = Math.round(s) + l.l, n.r = Math.round(u) + l.r, n.t = Math.round(f) + l.t, n.b = Math.round(v) + l.b, n.p = Math.round(i.pad), n.w = Math.round(t) - n.l - n.r, n.h = Math.round(a) - n.t - n.b, !r._replotting && (je.didMarginChange(o, n) || $B(e))) {
          "_redrawFromAutoMarginCount" in r ? r._redrawFromAutoMarginCount++ : r._redrawFromAutoMarginCount = 1;
          var re = 3 * (1 + Object.keys(d).length);
          if (r._redrawFromAutoMarginCount < re) return Xr.call("_doPlot", e);
          r._size = o, ur.warn("Too many auto-margin redraws.");
        }
        jB(e);
      };
      function jB(e) {
        var r = Ka.list(e, "", !0);
        ["_adjustTickLabelsOverflow", "_hideCounterAxisInsideTickLabels"].forEach(function (t) {
          for (var a = 0; a < r.length; a++) {
            var n = r[a][t];
            n && n();
          }
        });
      }
      var P6 = ["l", "r", "t", "b", "p", "w", "h"];
      je.didMarginChange = function (e, r) {
        for (var t = 0; t < P6.length; t++) {
          var a = P6[t],
            n = e[a],
            i = r[a];
          if (!rf(n) || Math.abs(i - n) > 1) return !0;
        }
        return !1;
      };
      je.graphJson = function (e, r, t, a, n, i) {
        (n && r && !e._fullData || n && !r && !e._fullLayout) && je.supplyDefaults(e);
        var l = n ? e._fullData : e.data,
          o = n ? e._fullLayout : e.layout,
          s = (e._transitionData || {})._frames;
        function u(h, d) {
          if (typeof h == "function") return d ? "_function_" : null;
          if (ur.isPlainObject(h)) {
            var y = {},
              g;
            return Object.keys(h).sort().forEach(function (T) {
              if (["_", "["].indexOf(T.charAt(0)) === -1) {
                if (typeof h[T] == "function") {
                  d && (y[T] = "_function");
                  return;
                }
                if (t === "keepdata") {
                  if (T.substr(T.length - 3) === "src") return;
                } else if (t === "keepstream") {
                  if (g = h[T + "src"], typeof g == "string" && g.indexOf(":") > 0 && !ur.isPlainObject(h.stream)) return;
                } else if (t !== "keepall" && (g = h[T + "src"], typeof g == "string" && g.indexOf(":") > 0)) return;
                y[T] = u(h[T], d);
              }
            }), y;
          }
          var m = Array.isArray(h),
            _ = ur.isTypedArray(h);
          if ((m || _) && h.dtype && h.shape) {
            var w = h.bdata;
            return u({
              dtype: h.dtype,
              shape: h.shape,
              bdata: ur.isArrayBuffer(w) ? IB.encode(w) : w
            }, d);
          }
          return m ? h.map(function (T) {
            return u(T, d);
          }) : _ ? ur.simpleMap(h, ur.identity) : ur.isJSDate(h) ? ur.ms2DateTimeLocal(+h) : h;
        }
        var f = {
          data: (l || []).map(function (h) {
            var d = u(h);
            return r && delete d.fit, d;
          })
        };
        if (!r && (f.layout = u(o), n)) {
          var v = o._size;
          f.layout.computed = {
            margin: {
              b: v.b,
              l: v.l,
              r: v.r,
              t: v.t
            }
          };
        }
        return s && (f.frames = u(s)), i && (f.config = u(e._context, !0)), a === "object" ? f : JSON.stringify(f);
      };
      je.modifyFrames = function (e, r) {
        var t,
          a,
          n,
          i = e._transitionData._frames,
          l = e._transitionData._frameHash;
        for (t = 0; t < r.length; t++) switch (a = r[t], a.type) {
          case "replace":
            n = a.value;
            var o = (i[a.index] || {}).name,
              s = n.name;
            i[a.index] = l[s] = n, s !== o && (delete l[o], l[s] = n);
            break;
          case "insert":
            n = a.value, l[n.name] = n, i.splice(a.index, 0, n);
            break;
          case "delete":
            n = i[a.index], delete l[n.name], i.splice(a.index, 1);
            break;
        }
        return Promise.resolve();
      };
      je.computeFrame = function (e, r) {
        var t = e._transitionData._frameHash,
          a,
          n,
          i,
          l;
        if (!r) throw new Error("computeFrame must be given a string frame name");
        var o = t[r.toString()];
        if (!o) return !1;
        for (var s = [o], u = [o.name]; o.baseframe && (o = t[o.baseframe.toString()]) && u.indexOf(o.name) === -1;) s.push(o), u.push(o.name);
        for (var f = {}; o = s.pop();) if (o.layout && (f.layout = je.extendLayout(f.layout, o.layout)), o.data) {
          if (f.data || (f.data = []), n = o.traces, !n) for (n = [], a = 0; a < o.data.length; a++) n[a] = a;
          for (f.traces || (f.traces = []), a = 0; a < o.data.length; a++) i = n[a], i != null && (l = f.traces.indexOf(i), l === -1 && (l = f.data.length, f.traces[l] = i), f.data[l] = je.extendTrace(f.data[l], o.data[a]));
        }
        return f;
      };
      je.recomputeFrameHash = function (e) {
        for (var r = e._transitionData._frameHash = {}, t = e._transitionData._frames, a = 0; a < t.length; a++) {
          var n = t[a];
          n && n.name && (r[n.name] = n);
        }
      };
      je.extendObjectWithContainers = function (e, r, t) {
        var a,
          n,
          i,
          l,
          o,
          s,
          u,
          f,
          v = ur.extendDeepNoArrays({}, r || {}),
          h = ur.expandObjectPaths(v),
          d = {};
        if (t && t.length) for (i = 0; i < t.length; i++) a = ur.nestedProperty(h, t[i]), n = a.get(), n === void 0 ? ur.nestedProperty(d, t[i]).set(null) : (a.set(null), ur.nestedProperty(d, t[i]).set(n));
        if (e = ur.extendDeepNoArrays(e || {}, h), t && t.length) {
          for (i = 0; i < t.length; i++) if (o = ur.nestedProperty(d, t[i]), u = o.get(), !!u) {
            for (s = ur.nestedProperty(e, t[i]), f = s.get(), Array.isArray(f) || (f = [], s.set(f)), l = 0; l < u.length; l++) {
              var y = u[l];
              y === null ? f[l] = null : f[l] = je.extendObjectWithContainers(f[l], y);
            }
            s.set(f);
          }
        }
        return e;
      };
      je.dataArrayContainers = ["transforms", "dimensions"];
      je.layoutArrayContainers = Xr.layoutArrayContainers;
      je.extendTrace = function (e, r) {
        return je.extendObjectWithContainers(e, r, je.dataArrayContainers);
      };
      je.extendLayout = function (e, r) {
        return je.extendObjectWithContainers(e, r, je.layoutArrayContainers);
      };
      je.transition = function (e, r, t, a, n, i) {
        var l = {
            redraw: n.redraw
          },
          o = {},
          s = [];
        return l.prepareFn = function () {
          for (var u = Array.isArray(r) ? r.length : 0, f = a.slice(0, u), v = 0; v < f.length; v++) {
            var h = f[v],
              d = e._fullData[h],
              y = d._module;
            if (y) {
              if (y.animatable) {
                var g = y.basePlotModule.name;
                o[g] || (o[g] = []), o[g].push(h);
              }
              e.data[f[v]] = je.extendTrace(e.data[f[v]], r[v]);
            }
          }
          var m = ur.expandObjectPaths(ur.extendDeepNoArrays({}, t)),
            _ = /^[xy]axis[0-9]*$/;
          for (var w in m) _.test(w) && delete m[w].range;
          je.extendLayout(e.layout, m), delete e.calcdata, je.supplyDefaults(e), je.doCalcdata(e);
          var T = ur.expandObjectPaths(t);
          if (T) {
            var b = e._fullLayout._plots;
            for (var A in b) {
              var S = b[A],
                k = S.xaxis,
                q = S.yaxis,
                D = k.range.slice(),
                R = q.range.slice(),
                z = null,
                N = null,
                H = null,
                O = null;
              Array.isArray(T[k._name + ".range"]) ? z = T[k._name + ".range"].slice() : Array.isArray((T[k._name] || {}).range) && (z = T[k._name].range.slice()), Array.isArray(T[q._name + ".range"]) ? N = T[q._name + ".range"].slice() : Array.isArray((T[q._name] || {}).range) && (N = T[q._name].range.slice()), D && z && (k.r2l(D[0]) !== k.r2l(z[0]) || k.r2l(D[1]) !== k.r2l(z[1])) && (H = {
                xr0: D,
                xr1: z
              }), R && N && (q.r2l(R[0]) !== q.r2l(N[0]) || q.r2l(R[1]) !== q.r2l(N[1])) && (O = {
                yr0: R,
                yr1: N
              }), (H || O) && s.push(ur.extendFlat({
                plotinfo: S
              }, H, O));
            }
          }
          return Promise.resolve();
        }, l.runFn = function (u) {
          var f,
            v = e._fullLayout._basePlotModules,
            h = s.length,
            d;
          if (t) for (d = 0; d < v.length; d++) v[d].transitionAxes && v[d].transitionAxes(e, s, i, u);
          h ? (f = ur.extendFlat({}, i), f.duration = 0, delete o.cartesian) : f = i;
          for (var y in o) {
            var g = o[y],
              m = e._fullData[g[0]]._module;
            m.basePlotModule.plot(e, g, f, u);
          }
        }, Y6(e, i, l);
      };
      je.transitionFromReact = function (e, r, t, a) {
        var n = e._fullLayout,
          i = n.transition,
          l = {},
          o = [];
        return l.prepareFn = function () {
          var s = n._plots;
          l.redraw = !1, r.anim === "some" && (l.redraw = !0), t.anim === "some" && (l.redraw = !0);
          for (var u in s) {
            var f = s[u],
              v = f.xaxis,
              h = f.yaxis,
              d = a[v._name].range.slice(),
              y = a[h._name].range.slice(),
              g = v.range.slice(),
              m = h.range.slice();
            v.setScale(), h.setScale();
            var _ = null,
              w = null;
            (v.r2l(d[0]) !== v.r2l(g[0]) || v.r2l(d[1]) !== v.r2l(g[1])) && (_ = {
              xr0: d,
              xr1: g
            }), (h.r2l(y[0]) !== h.r2l(m[0]) || h.r2l(y[1]) !== h.r2l(m[1])) && (w = {
              yr0: y,
              yr1: m
            }), (_ || w) && o.push(ur.extendFlat({
              plotinfo: f
            }, _, w));
          }
          return Promise.resolve();
        }, l.runFn = function (s) {
          for (var u = e._fullData, f = e._fullLayout, v = f._basePlotModules, h, d, y, g = [], m = 0; m < u.length; m++) g.push(m);
          function _() {
            if (e._fullLayout) for (var T = 0; T < v.length; T++) v[T].transitionAxes && v[T].transitionAxes(e, o, h, s);
          }
          function w() {
            if (e._fullLayout) for (var T = 0; T < v.length; T++) v[T].plot(e, y, d, s);
          }
          o.length && r.anim ? i.ordering === "traces first" ? (h = ur.extendFlat({}, i, {
            duration: 0
          }), y = g, d = i, setTimeout(_, i.duration), w()) : (h = i, y = null, d = ur.extendFlat({}, i, {
            duration: 0
          }), setTimeout(w, h.duration), _()) : o.length ? (h = i, _()) : r.anim && (y = g, d = i, w());
        }, Y6(e, i, l);
      };
      function Y6(e, r, t) {
        var a = !1;
        function n(v) {
          var h = Promise.resolve();
          if (!v) return h;
          for (; v.length;) h = h.then(v.shift());
          return h;
        }
        function i(v) {
          if (v) for (; v.length;) v.shift();
        }
        function l() {
          return e.emit("plotly_transitioning", []), new Promise(function (v) {
            e._transitioning = !0, r.duration > 0 && (e._transitioningWithDuration = !0), e._transitionData._interruptCallbacks.push(function () {
              a = !0;
            }), t.redraw && e._transitionData._interruptCallbacks.push(function () {
              return Xr.call("redraw", e);
            }), e._transitionData._interruptCallbacks.push(function () {
              e.emit("plotly_transitioninterrupted", []);
            });
            var h = 0,
              d = 0;
            function y() {
              return h++, function () {
                d++, !a && d === h && o(v);
              };
            }
            t.runFn(y), setTimeout(y());
          });
        }
        function o(v) {
          if (e._transitionData) return i(e._transitionData._interruptCallbacks), Promise.resolve().then(function () {
            if (t.redraw) return Xr.call("redraw", e);
          }).then(function () {
            e._transitioning = !1, e._transitioningWithDuration = !1, e.emit("plotly_transitioned", []);
          }).then(v);
        }
        function s() {
          if (e._transitionData) return e._transitioning = !1, n(e._transitionData._interruptCallbacks);
        }
        var u = [je.previousPromises, s, t.prepareFn, je.rehover, je.reselect, l],
          f = ur.syncOrAsync(u, e);
        return (!f || !f.then) && (f = Promise.resolve()), f.then(function () {
          return e;
        });
      }
      je.doCalcdata = function (e, r) {
        var t = Ka.list(e),
          a = e._fullData,
          n = e._fullLayout,
          i,
          l,
          o,
          s,
          u = new Array(a.length),
          f = (e.calcdata || []).slice();
        for (e.calcdata = u, n._numBoxes = 0, n._numViolins = 0, n._violinScaleGroupStats = {}, e._hmpixcount = 0, e._hmlumcount = 0, n._piecolormap = {}, n._sunburstcolormap = {}, n._treemapcolormap = {}, n._iciclecolormap = {}, n._funnelareacolormap = {}, o = 0; o < a.length; o++) if (Array.isArray(r) && r.indexOf(o) === -1) {
          u[o] = f[o];
          continue;
        }
        for (o = 0; o < a.length; o++) i = a[o], i._arrayAttrs = F6.findArrayAttributes(i), i._extremes = {};
        var v = n._subplots.polar || [];
        for (o = 0; o < v.length; o++) t.push(n[v[o]].radialaxis, n[v[o]].angularaxis);
        for (var h in n._colorAxes) {
          var d = n[h];
          d.cauto !== !1 && (delete d.cmin, delete d.cmax);
        }
        var y = !1;
        function g(w) {
          if (i = a[w], l = i._module, i.visible === !0 && i.transforms) {
            if (l && l.calc) {
              var T = l.calc(e, i);
              T[0] && T[0].t && T[0].t._scene && delete T[0].t._scene.dirty;
            }
            for (s = 0; s < i.transforms.length; s++) {
              var b = i.transforms[s];
              l = transformsRegistry[b.type], l && l.calcTransform && (i._hasCalcTransform = !0, y = !0, l.calcTransform(e, i, b));
            }
          }
        }
        function m(w, T) {
          if (i = a[w], l = i._module, !!l.isContainer === T) {
            var b = [];
            if (i.visible === !0 && i._length !== 0) {
              delete i._indexToPoints;
              var A = i.transforms || [];
              for (s = A.length - 1; s >= 0; s--) if (A[s].enabled) {
                i._indexToPoints = A[s]._indexToPoints;
                break;
              }
              l && l.calc && (b = l.calc(e, i));
            }
            (!Array.isArray(b) || !b[0]) && (b = [{
              x: q6,
              y: q6
            }]), b[0].t || (b[0].t = {}), b[0].trace = i, u[w] = b;
          }
        }
        for (R6(t, a, n), o = 0; o < a.length; o++) m(o, !0);
        for (o = 0; o < a.length; o++) g(o);
        for (y && R6(t, a, n), o = 0; o < a.length; o++) m(o, !0);
        for (o = 0; o < a.length; o++) m(o, !1);
        z6(e);
        var _ = rY(t, e);
        if (_.length) {
          for (n._numBoxes = 0, n._numViolins = 0, o = 0; o < _.length; o++) m(_[o], !0);
          for (o = 0; o < _.length; o++) m(_[o], !1);
          z6(e);
        }
        Xr.getComponentMethod("fx", "calc")(e), Xr.getComponentMethod("errorbars", "calc")(e);
      };
      var eY = /(total|sum|min|max|mean|geometric mean|median) (ascending|descending)/;
      function rY(e, r) {
        var t = [],
          a,
          n,
          i,
          l,
          o;
        function s(I, V, K) {
          var Q = V._id.charAt(0);
          if (I === "histogram2dcontour") {
            var ie = V._counterAxes[0],
              me = Ka.getFromId(r, ie),
              pe = Q === "x" || ie === "x" && me.type === "category",
              ge = Q === "y" || ie === "y" && me.type === "category";
            return function (j, _e) {
              return j === 0 || _e === 0 || pe && j === K[_e].length - 1 || ge && _e === K.length - 1 ? -1 : (Q === "y" ? _e : j) - 1;
            };
          } else return function (j, _e) {
            return Q === "y" ? _e : j;
          };
        }
        var u = {
          min: function (I) {
            return ur.aggNums(Math.min, null, I);
          },
          max: function (I) {
            return ur.aggNums(Math.max, null, I);
          },
          sum: function (I) {
            return ur.aggNums(function (V, K) {
              return V + K;
            }, null, I);
          },
          total: function (I) {
            return ur.aggNums(function (V, K) {
              return V + K;
            }, null, I);
          },
          mean: function (I) {
            return ur.mean(I);
          },
          "geometric mean": function (I) {
            return ur.geometricMean(I);
          },
          median: function (I) {
            return ur.median(I);
          }
        };
        function f(I, V) {
          return I[1] - V[1];
        }
        function v(I, V) {
          return V[1] - I[1];
        }
        for (a = 0; a < e.length; a++) {
          var h = e[a];
          if (h.type === "category") {
            var d = h.categoryorder.match(eY);
            if (d) {
              var y = d[1],
                g = d[2],
                m = h._id.charAt(0),
                _ = m === "x",
                w = [];
              for (n = 0; n < h._categories.length; n++) w.push([h._categories[n], []]);
              for (n = 0; n < h._traceIndices.length; n++) {
                var T = h._traceIndices[n],
                  b = r._fullData[T];
                if (b.visible === !0) {
                  var A = b.type;
                  Xr.traceIs(b, "histogram") && (delete b._xautoBinFinished, delete b._yautoBinFinished);
                  var S = A === "splom",
                    k = A === "scattergl",
                    q = r.calcdata[T];
                  for (i = 0; i < q.length; i++) {
                    var D = q[i],
                      R,
                      z;
                    if (S) {
                      var N = b._axesDim[h._id];
                      if (!_) {
                        var H = b._diag[N][0];
                        H && (h = r._fullLayout[Ka.id2name(H)]);
                      }
                      var O = D.trace.dimensions[N].values;
                      for (l = 0; l < O.length; l++) for (R = h._categoriesMap[O[l]], o = 0; o < D.trace.dimensions.length; o++) if (o !== N) {
                        var J = D.trace.dimensions[o];
                        w[R][1].push(J.values[l]);
                      }
                    } else if (k) {
                      for (l = 0; l < D.t.x.length; l++) _ ? (R = D.t.x[l], z = D.t.y[l]) : (R = D.t.y[l], z = D.t.x[l]), w[R][1].push(z);
                      D.t && D.t._scene && delete D.t._scene.dirty;
                    } else if (D.hasOwnProperty("z")) {
                      z = D.z;
                      var X = s(b.type, h, z);
                      for (l = 0; l < z.length; l++) for (o = 0; o < z[l].length; o++) R = X(o, l), R + 1 && w[R][1].push(z[l][o]);
                    } else for (R = D.p, R === void 0 && (R = D[m]), z = D.s, z === void 0 && (z = D.v), z === void 0 && (z = _ ? D.y : D.x), Array.isArray(z) || (z === void 0 ? z = [] : z = [z]), l = 0; l < z.length; l++) w[R][1].push(z[l]);
                  }
                }
              }
              h._categoriesValue = w;
              var B = [];
              for (n = 0; n < w.length; n++) B.push([w[n][0], u[y](w[n][1])]);
              B.sort(g === "descending" ? v : f), h._categoriesAggregatedValue = B, h._initialCategories = B.map(function (I) {
                return I[0];
              }), t = t.concat(h.sortByInitialCategories());
            }
          }
        }
        return t;
      }
      function R6(e, r, t) {
        var a = {};
        function n(s) {
          s.clearCalc(), s.type === "multicategory" && s.setupMultiCategory(r), a[s._id] = 1;
        }
        ur.simpleMap(e, n);
        for (var i = t._axisMatchGroups || [], l = 0; l < i.length; l++) for (var o in i[l]) a[o] || n(t[Ka.id2name(o)]);
      }
      function z6(e) {
        var r = e._fullLayout,
          t = r._visibleModules,
          a = {},
          n,
          i,
          l;
        for (i = 0; i < t.length; i++) {
          var o = t[i],
            s = o.crossTraceCalc;
          if (s) {
            var u = o.basePlotModule.name;
            a[u] ? ur.pushUnique(a[u], s) : a[u] = [s];
          }
        }
        for (l in a) {
          var f = a[l],
            v = r._subplots[l];
          if (Array.isArray(v)) for (n = 0; n < v.length; n++) {
            var h = v[n],
              d = l === "cartesian" ? r._plots[h] : r[h];
            for (i = 0; i < f.length; i++) f[i](e, d, h);
          } else for (i = 0; i < f.length; i++) f[i](e);
        }
      }
      je.rehover = function (e) {
        e._fullLayout._rehover && e._fullLayout._rehover();
      };
      je.redrag = function (e) {
        e._fullLayout._redrag && e._fullLayout._redrag();
      };
      je.reselect = function (e) {
        var r = e._fullLayout,
          t = (e.layout || {}).selections,
          a = r._previousSelections;
        r._previousSelections = t;
        var n = r._reselect || JSON.stringify(t) !== JSON.stringify(a);
        Xr.getComponentMethod("selections", "reselect")(e, n);
      };
      je.generalUpdatePerTraceModule = function (e, r, t, a) {
        var n = r.traceHash,
          i = {},
          l;
        for (l = 0; l < t.length; l++) {
          var o = t[l],
            s = o[0].trace;
          s.visible && (i[s.type] = i[s.type] || [], i[s.type].push(o));
        }
        for (var u in n) if (!i[u]) {
          var f = n[u][0],
            v = f[0].trace;
          v.visible = !1, i[u] = [f];
        }
        for (var h in i) {
          var d = i[h],
            y = d[0][0].trace._module;
          y.plot(e, r, ur.filterVisible(d), a);
        }
        r.traceHash = i;
      };
      je.plotBasePlot = function (e, r, t, a, n) {
        var i = Xr.getModule(e),
          l = UB(r.calcdata, i)[0];
        i.plot(r, l, a, n);
      };
      je.cleanBasePlot = function (e, r, t, a, n) {
        var i = n._has && n._has(e),
          l = t._has && t._has(e);
        i && !l && n["_" + e + "layer"].selectAll("g.trace").remove();
      };
    });
    var fo = Z(uo => {
      "use strict";

      uo.xmlns = "http://www.w3.org/2000/xmlns/";
      uo.svg = "http://www.w3.org/2000/svg";
      uo.xlink = "http://www.w3.org/1999/xlink";
      uo.svgAttrs = {
        xmlns: uo.svg,
        "xmlns:xlink": uo.xlink
      };
    });
    var Da = Z((poe, G6) => {
      "use strict";

      G6.exports = {
        FROM_BL: {
          left: 0,
          center: .5,
          right: 1,
          bottom: 0,
          middle: .5,
          top: 1
        },
        FROM_TL: {
          left: 0,
          center: .5,
          right: 1,
          bottom: 1,
          middle: .5,
          top: 0
        },
        FROM_BR: {
          left: 1,
          center: .5,
          right: 0,
          bottom: 0,
          middle: .5,
          top: 1
        },
        LINE_SPACING: 1.3,
        CAP_SHIFT: .7,
        MID_SHIFT: .35,
        OPPOSITE_SIDE: {
          left: "right",
          right: "left",
          top: "bottom",
          bottom: "top"
        }
      };
    });
    var xa = Z(wn => {
      "use strict";

      var Rt = Ir(),
        Yi = He(),
        tY = Yi.strTranslate,
        Ip = fo(),
        aY = Da().LINE_SPACING,
        nY = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
      wn.convertToTspans = function (e, r, t) {
        var a = e.text(),
          n = !e.attr("data-notex") && r && r._context.typesetMath && typeof MathJax != "undefined" && a.match(nY),
          i = Rt.select(e.node().parentNode);
        if (i.empty()) return;
        var l = e.attr("class") ? e.attr("class").split(" ")[0] : "text";
        l += "-math", i.selectAll("svg." + l).remove(), i.selectAll("g." + l + "-group").remove(), e.style("display", null).attr({
          "data-unformatted": a,
          "data-math": "N"
        });
        function o() {
          i.empty() || (l = e.attr("class") + "-math", i.select("svg." + l).remove()), e.text("").style("white-space", "pre");
          var s = yY(e.node(), a);
          s && e.style("pointer-events", "all"), wn.positionText(e), t && t.call(e);
        }
        return n ? (r && r._promises || []).push(new Promise(function (s) {
          e.style("display", "none");
          var u = parseInt(e.node().style.fontSize, 10),
            f = {
              fontSize: u
            };
          sY(n[2], f, function (v, h, d) {
            i.selectAll("svg." + l).remove(), i.selectAll("g." + l + "-group").remove();
            var y = v && v.select("svg");
            if (!y || !y.node()) {
              o(), s();
              return;
            }
            var g = i.append("g").classed(l + "-group", !0).attr({
              "pointer-events": "none",
              "data-unformatted": a,
              "data-math": "Y"
            });
            g.node().appendChild(y.node()), h && h.node() && y.node().insertBefore(h.node().cloneNode(!0), y.node().firstChild);
            var m = d.width,
              _ = d.height;
            y.attr({
              class: l,
              height: _,
              preserveAspectRatio: "xMinYMin meet"
            }).style({
              overflow: "visible",
              "pointer-events": "none"
            });
            var w = e.node().style.fill || "black",
              T = y.select("g");
            T.attr({
              fill: w,
              stroke: w
            });
            var b = T.node().getBoundingClientRect(),
              A = b.width,
              S = b.height;
            (A > m || S > _) && (y.style("overflow", "hidden"), b = y.node().getBoundingClientRect(), A = b.width, S = b.height);
            var k = +e.attr("x"),
              q = +e.attr("y"),
              D = u || e.node().getBoundingClientRect().height,
              R = -D / 4;
            if (l[0] === "y") g.attr({
              transform: "rotate(" + [-90, k, q] + ")" + tY(-A / 2, R - S / 2)
            });else if (l[0] === "l") q = R - S / 2;else if (l[0] === "a" && l.indexOf("atitle") !== 0) k = 0, q = R;else {
              var z = e.attr("text-anchor");
              k = k - A * (z === "middle" ? .5 : z === "end" ? 1 : 0), q = q + R - S / 2;
            }
            y.attr({
              x: k,
              y: q
            }), t && t.call(e, g), s(g);
          });
        })) : o(), e;
      };
      var iY = /(<|&lt;|&#60;)/g,
        lY = /(>|&gt;|&#62;)/g;
      function oY(e) {
        return e.replace(iY, "\\lt ").replace(lY, "\\gt ");
      }
      var V6 = [["$", "$"], ["\\(", "\\)"]];
      function sY(e, r, t) {
        var a = parseInt((MathJax.version || "").split(".")[0]);
        if (a !== 2 && a !== 3) {
          Yi.warn("No MathJax version:", MathJax.version);
          return;
        }
        var n,
          i,
          l,
          o,
          s = function () {
            return i = Yi.extendDeepAll({}, MathJax.Hub.config), l = MathJax.Hub.processSectionDelay, MathJax.Hub.processSectionDelay !== void 0 && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({
              messageStyle: "none",
              tex2jax: {
                inlineMath: V6
              },
              displayAlign: "left"
            });
          },
          u = function () {
            i = Yi.extendDeepAll({}, MathJax.config), MathJax.config.tex || (MathJax.config.tex = {}), MathJax.config.tex.inlineMath = V6;
          },
          f = function () {
            if (n = MathJax.Hub.config.menuSettings.renderer, n !== "SVG") return MathJax.Hub.setRenderer("SVG");
          },
          v = function () {
            n = MathJax.config.startup.output, n !== "svg" && (MathJax.config.startup.output = "svg");
          },
          h = function () {
            var w = "math-output-" + Yi.randstr({}, 64);
            o = Rt.select("body").append("div").attr({
              id: w
            }).style({
              visibility: "hidden",
              position: "absolute",
              "font-size": r.fontSize + "px"
            }).text(oY(e));
            var T = o.node();
            return a === 2 ? MathJax.Hub.Typeset(T) : MathJax.typeset([T]);
          },
          d = function () {
            var w = o.select(a === 2 ? ".MathJax_SVG" : ".MathJax"),
              T = !w.empty() && o.select("svg").node();
            if (!T) Yi.log("There was an error in the tex syntax.", e), t();else {
              var b = T.getBoundingClientRect(),
                A;
              a === 2 ? A = Rt.select("body").select("#MathJax_SVG_glyphs") : A = w.select("defs"), t(w, A, b);
            }
            o.remove();
          },
          y = function () {
            if (n !== "SVG") return MathJax.Hub.setRenderer(n);
          },
          g = function () {
            n !== "svg" && (MathJax.config.startup.output = n);
          },
          m = function () {
            return l !== void 0 && (MathJax.Hub.processSectionDelay = l), MathJax.Hub.Config(i);
          },
          _ = function () {
            MathJax.config = i;
          };
        a === 2 ? MathJax.Hub.Queue(s, f, h, d, y, m) : a === 3 && (u(), v(), MathJax.startup.defaultReady(), MathJax.startup.promise.then(function () {
          h(), d(), g(), _();
        }));
      }
      var J6 = {
          sup: "font-size:70%",
          sub: "font-size:70%",
          s: "text-decoration:line-through",
          u: "text-decoration:underline",
          b: "font-weight:bold",
          i: "font-style:italic",
          a: "cursor:pointer",
          span: "",
          em: "font-style:italic;font-weight:bold"
        },
        uY = {
          sub: "0.3em",
          sup: "-0.6em"
        },
        fY = {
          sub: "-0.21em",
          sup: "0.42em"
        },
        W6 = "\u200B",
        Z6 = ["http:", "https:", "mailto:", "", void 0, ":"],
        K6 = wn.NEWLINES = /(\r\n?|\n)/g,
        Op = /(<[^<>]*>)/,
        Bp = /<(\/?)([^ >]*)(\s+(.*))?>/i,
        cY = /<br(\s+.*)?>/i;
      wn.BR_TAG_ALL = /<br(\s+.*)?>/gi;
      var Q6 = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i,
        $6 = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i,
        j6 = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i,
        vY = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
      function co(e, r) {
        if (!e) return null;
        var t = e.match(r),
          a = t && (t[3] || t[4]);
        return a && $v(a);
      }
      var hY = /(^|;)\s*color:/;
      wn.plainText = function (e, r) {
        r = r || {};
        for (var t = r.len !== void 0 && r.len !== -1 ? r.len : 1 / 0, a = r.allowedTags !== void 0 ? r.allowedTags : ["br"], n = "...", i = n.length, l = e.split(Op), o = [], s = "", u = 0, f = 0; f < l.length; f++) {
          var v = l[f],
            h = v.match(Bp),
            d = h && h[2].toLowerCase();
          if (d) a.indexOf(d) !== -1 && (o.push(v), s = d);else {
            var y = v.length;
            if (u + y < t) o.push(v), u += y;else if (u < t) {
              var g = t - u;
              s && (s !== "br" || g <= i || y <= i) && o.pop(), t > i ? o.push(v.substr(0, g - i) + n) : o.push(v.substr(0, g));
              break;
            }
            s = "";
          }
        }
        return o.join("");
      };
      var dY = {
          mu: "\u03BC",
          amp: "&",
          lt: "<",
          gt: ">",
          nbsp: "\xA0",
          times: "\xD7",
          plusmn: "\xB1",
          deg: "\xB0"
        },
        pY = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
      function $v(e) {
        return e.replace(pY, function (r, t) {
          var a;
          return t.charAt(0) === "#" ? a = mY(t.charAt(1) === "x" ? parseInt(t.substr(2), 16) : parseInt(t.substr(1), 10)) : a = dY[t], a || r;
        });
      }
      wn.convertEntities = $v;
      function mY(e) {
        if (!(e > 1114111)) {
          var r = String.fromCodePoint;
          if (r) return r(e);
          var t = String.fromCharCode;
          return e <= 65535 ? t(e) : t((e >> 10) + 55232, e % 1024 + 56320);
        }
      }
      function yY(e, r) {
        r = r.replace(K6, " ");
        var t = !1,
          a = [],
          n,
          i = -1;
        function l() {
          i++;
          var S = document.createElementNS(Ip.svg, "tspan");
          Rt.select(S).attr({
            class: "line",
            dy: i * aY + "em"
          }), e.appendChild(S), n = S;
          var k = a;
          if (a = [{
            node: S
          }], k.length > 1) for (var q = 1; q < k.length; q++) o(k[q]);
        }
        function o(S) {
          var k = S.type,
            q = {},
            D;
          if (k === "a") {
            D = "a";
            var R = S.target,
              z = S.href,
              N = S.popup;
            z && (q = {
              "xlink:xlink:show": R === "_blank" || R.charAt(0) !== "_" ? "new" : "replace",
              target: R,
              "xlink:xlink:href": z
            }, N && (q.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + N + '");return false;'));
          } else D = "tspan";
          S.style && (q.style = S.style);
          var H = document.createElementNS(Ip.svg, D);
          if (k === "sup" || k === "sub") {
            s(n, W6), n.appendChild(H);
            var O = document.createElementNS(Ip.svg, "tspan");
            s(O, W6), Rt.select(O).attr("dy", fY[k]), q.dy = uY[k], n.appendChild(H), n.appendChild(O);
          } else n.appendChild(H);
          Rt.select(H).attr(q), n = S.node = H, a.push(S);
        }
        function s(S, k) {
          S.appendChild(document.createTextNode(k));
        }
        function u(S) {
          if (a.length === 1) {
            Yi.log("Ignoring unexpected end tag </" + S + ">.", r);
            return;
          }
          var k = a.pop();
          S !== k.type && Yi.log("Start tag <" + k.type + "> doesnt match end tag <" + S + ">. Pretending it did match.", r), n = a[a.length - 1].node;
        }
        var f = cY.test(r);
        f ? l() : (n = e, a = [{
          node: e
        }]);
        for (var v = r.split(Op), h = 0; h < v.length; h++) {
          var d = v[h],
            y = d.match(Bp),
            g = y && y[2].toLowerCase(),
            m = J6[g];
          if (g === "br") l();else if (m === void 0) s(n, $v(d));else if (y[1]) u(g);else {
            var _ = y[4],
              w = {
                type: g
              },
              T = co(_, Q6);
            if (T ? (T = T.replace(hY, "$1 fill:"), m && (T += ";" + m)) : m && (T = m), T && (w.style = T), g === "a") {
              t = !0;
              var b = co(_, $6);
              if (b) {
                var A = e7(b);
                A && (w.href = A, w.target = co(_, j6) || "_blank", w.popup = co(_, vY));
              }
            }
            o(w);
          }
        }
        return t;
      }
      function e7(e) {
        var r = encodeURI(decodeURI(e)),
          t = document.createElement("a"),
          a = document.createElement("a");
        t.href = e, a.href = r;
        var n = t.protocol,
          i = a.protocol;
        return Z6.indexOf(n) !== -1 && Z6.indexOf(i) !== -1 ? r : "";
      }
      wn.sanitizeHTML = function (r) {
        r = r.replace(K6, " ");
        for (var t = document.createElement("p"), a = t, n = [], i = r.split(Op), l = 0; l < i.length; l++) {
          var o = i[l],
            s = o.match(Bp),
            u = s && s[2].toLowerCase();
          if (u in J6) {
            if (s[1]) n.length && (a = n.pop());else {
              var f = s[4],
                v = co(f, Q6),
                h = v ? {
                  style: v
                } : {};
              if (u === "a") {
                var d = co(f, $6);
                if (d) {
                  var y = e7(d);
                  if (y) {
                    h.href = y;
                    var g = co(f, j6);
                    g && (h.target = g);
                  }
                }
              }
              var m = document.createElement(u);
              a.appendChild(m), Rt.select(m).attr(h), a = m, n.push(m);
            }
          } else a.appendChild(document.createTextNode($v(o)));
        }
        var _ = "innerHTML";
        return t[_];
      };
      wn.lineCount = function (r) {
        return r.selectAll("tspan.line").size() || 1;
      };
      wn.positionText = function (r, t, a) {
        return r.each(function () {
          var n = Rt.select(this);
          function i(s, u) {
            return u === void 0 ? (u = n.attr(s), u === null && (n.attr(s, 0), u = 0)) : n.attr(s, u), u;
          }
          var l = i("x", t),
            o = i("y", a);
          this.nodeName === "text" && n.selectAll("tspan.line").attr({
            x: l,
            y: o
          });
        });
      };
      function X6(e, r, t) {
        var a = t.horizontalAlign,
          n = t.verticalAlign || "top",
          i = e.node().getBoundingClientRect(),
          l = r.node().getBoundingClientRect(),
          o,
          s,
          u;
        return n === "bottom" ? s = function () {
          return i.bottom - o.height;
        } : n === "middle" ? s = function () {
          return i.top + (i.height - o.height) / 2;
        } : s = function () {
          return i.top;
        }, a === "right" ? u = function () {
          return i.right - o.width;
        } : a === "center" ? u = function () {
          return i.left + (i.width - o.width) / 2;
        } : u = function () {
          return i.left;
        }, function () {
          o = this.node().getBoundingClientRect();
          var f = u() - l.left,
            v = s() - l.top,
            h = t.gd || {};
          if (t.gd) {
            h._fullLayout._calcInverseTransform(h);
            var d = Yi.apply3DTransform(h._fullLayout._invTransform)(f, v);
            f = d[0], v = d[1];
          }
          return this.style({
            top: v + "px",
            left: f + "px",
            "z-index": 1e3
          }), this;
        };
      }
      var Hp = "1px ";
      wn.makeTextShadow = function (e) {
        var r = Hp,
          t = Hp,
          a = Hp;
        return r + t + a + e + ", -" + r + "-" + t + a + e + ", " + r + "-" + t + a + e + ", -" + r + t + a + e;
      };
      wn.makeEditable = function (e, r) {
        var t = r.gd,
          a = r.delegate,
          n = Rt.dispatch("edit", "input", "cancel"),
          i = a || e;
        if (e.style({
          "pointer-events": a ? "none" : "all"
        }), e.size() !== 1) throw new Error("boo");
        function l() {
          s(), e.style({
            opacity: 0
          });
          var u = i.attr("class"),
            f;
          u ? f = "." + u.split(" ")[0] + "-math-group" : f = "[class*=-math-group]", f && Rt.select(e.node().parentNode).select(f).style({
            opacity: 0
          });
        }
        function o(u) {
          var f = u.node(),
            v = document.createRange();
          v.selectNodeContents(f);
          var h = window.getSelection();
          h.removeAllRanges(), h.addRange(v), f.focus();
        }
        function s() {
          var u = Rt.select(t),
            f = u.select(".svg-container"),
            v = f.append("div"),
            h = e.node().style,
            d = parseFloat(h.fontSize || 12),
            y = r.text;
          y === void 0 && (y = e.attr("data-unformatted")), v.classed("plugin-editable editable", !0).style({
            position: "absolute",
            "font-family": h.fontFamily || "Arial",
            "font-size": d,
            color: r.fill || h.fill || "black",
            opacity: 1,
            "background-color": r.background || "transparent",
            outline: "#ffffff33 1px solid",
            margin: [-d / 8 + 1, 0, 0, -1].join("px ") + "px",
            padding: "0",
            "box-sizing": "border-box"
          }).attr({
            contenteditable: !0
          }).text(y).call(X6(e, f, r)).on("blur", function () {
            t._editing = !1, e.text(this.textContent).style({
              opacity: 1
            });
            var g = Rt.select(this).attr("class"),
              m;
            g ? m = "." + g.split(" ")[0] + "-math-group" : m = "[class*=-math-group]", m && Rt.select(e.node().parentNode).select(m).style({
              opacity: 0
            });
            var _ = this.textContent;
            Rt.select(this).transition().duration(0).remove(), Rt.select(document).on("mouseup", null), n.edit.call(e, _);
          }).on("focus", function () {
            var g = this;
            t._editing = !0, Rt.select(document).on("mouseup", function () {
              if (Rt.event.target === g) return !1;
              document.activeElement === v.node() && v.node().blur();
            });
          }).on("keyup", function () {
            Rt.event.which === 27 ? (t._editing = !1, e.style({
              opacity: 1
            }), Rt.select(this).style({
              opacity: 0
            }).on("blur", function () {
              return !1;
            }).transition().remove(), n.cancel.call(e, this.textContent)) : (n.input.call(e, this.textContent), Rt.select(this).call(X6(e, f, r)));
          }).on("keydown", function () {
            Rt.event.which === 13 && this.blur();
          }).call(o);
        }
        return r.immediate ? l() : i.on("click", l), Rt.rebind(e, n, "on");
      };
    });
    var Tn = Z((yoe, s7) => {
      "use strict";

      var gY = Ir(),
        e0 = bn(),
        af = Hr(),
        jv = He(),
        r7 = Er(),
        bY = $l().isValid;
      function xY(e, r, t) {
        var a = r ? jv.nestedProperty(e, r).get() || {} : e,
          n = a[t || "color"];
        n && n._inputArray && (n = n._inputArray);
        var i = !1;
        if (jv.isArrayOrTypedArray(n)) {
          for (var l = 0; l < n.length; l++) if (af(n[l])) {
            i = !0;
            break;
          }
        }
        return jv.isPlainObject(a) && (i || a.showscale === !0 || af(a.cmin) && af(a.cmax) || bY(a.colorscale) || jv.isPlainObject(a.colorbar));
      }
      var t7 = ["showscale", "autocolorscale", "colorscale", "reversescale", "colorbar"],
        tf = ["min", "max", "mid", "auto"];
      function n7(e) {
        var r = e._colorAx,
          t = r || e,
          a = {},
          n,
          i,
          l;
        for (i = 0; i < t7.length; i++) l = t7[i], a[l] = t[l];
        if (r) for (n = "c", i = 0; i < tf.length; i++) l = tf[i], a[l] = t["c" + l];else {
          var o;
          for (i = 0; i < tf.length; i++) {
            if (l = tf[i], o = "c" + l, o in t) {
              a[l] = t[o];
              continue;
            }
            o = "z" + l, o in t && (a[l] = t[o]);
          }
          n = o.charAt(0);
        }
        return a._sync = function (s, u) {
          var f = tf.indexOf(s) !== -1 ? n + s : s;
          t[f] = t["_" + f] = u;
        }, a;
      }
      function i7(e) {
        for (var r = n7(e), t = r.min, a = r.max, n = r.reversescale ? l7(r.colorscale) : r.colorscale, i = n.length, l = new Array(i), o = new Array(i), s = 0; s < i; s++) {
          var u = n[s];
          l[s] = t + u[0] * (a - t), o[s] = u[1];
        }
        return {
          domain: l,
          range: o
        };
      }
      function l7(e) {
        for (var r = e.length, t = new Array(r), a = r - 1, n = 0; a >= 0; a--, n++) {
          var i = e[a];
          t[n] = [1 - i[0], i[1]];
        }
        return t;
      }
      function o7(e, r) {
        r = r || {};
        for (var t = e.domain, a = e.range, n = a.length, i = new Array(n), l = 0; l < n; l++) {
          var o = e0(a[l]).toRgb();
          i[l] = [o.r, o.g, o.b, o.a];
        }
        var s = gY.scale.linear().domain(t).range(i).clamp(!0),
          u = r.noNumericCheck,
          f = r.returnArray,
          v;
        return u && f ? v = s : u ? v = function (h) {
          return a7(s(h));
        } : f ? v = function (h) {
          return af(h) ? s(h) : e0(h).isValid() ? h : r7.defaultLine;
        } : v = function (h) {
          return af(h) ? a7(s(h)) : e0(h).isValid() ? h : r7.defaultLine;
        }, v.domain = s.domain, v.range = function () {
          return a;
        }, v;
      }
      function _Y(e, r) {
        return o7(i7(e), r);
      }
      function a7(e) {
        var r = {
          r: e[0],
          g: e[1],
          b: e[2],
          a: e[3]
        };
        return e0(r).toRgbString();
      }
      s7.exports = {
        hasColorscale: xY,
        extractOpts: n7,
        extractScale: i7,
        flipScale: l7,
        makeColorScaleFunc: o7,
        makeColorScaleFuncFromTrace: _Y
      };
    });
    var r0 = Z((goe, c7) => {
      "use strict";

      var u7 = ip(),
        wY = u7.FORMAT_LINK,
        TY = u7.DATE_FORMAT_LINK;
      function MY(e, r) {
        return {
          valType: "string",
          dflt: "",
          editType: "none",
          description: (r ? Yp : f7)("hover text", e) + ["By default the values are formatted using " + (r ? "generic number format" : "`" + e + "axis.hoverformat`") + "."].join(" ")
        };
      }
      function Yp(e, r) {
        return ["Sets the " + e + " formatting rule" + (r ? "for `" + r + "` " : ""), "using d3 formatting mini-languages", "which are very similar to those in Python. For numbers, see: " + wY + "."].join(" ");
      }
      function f7(e, r) {
        return Yp(e, r) + [" And for dates see: " + TY + ".", "We add two items to d3's date formatter:", "*%h* for half of the year as a decimal number as well as", "*%{n}f* for fractional seconds", "with n digits. For example, *2016-10-13 09:15:23.456* with tickformat", "*%H~%M~%S.%2f* would display *09~15~23.46*"].join(" ");
      }
      c7.exports = {
        axisHoverFormat: MY,
        descriptionOnlyNumbers: Yp,
        descriptionWithDates: f7
      };
    });
    var Xn = Z((boe, S7) => {
      "use strict";

      var v7 = ha(),
        Ss = hi(),
        C7 = mi().dash,
        Gp = Yt().extendFlat,
        h7 = ct().templatedArray,
        d7 = r0().descriptionWithDates,
        AY = Bt().ONEDAY,
        gi = da(),
        kY = gi.HOUR_PATTERN,
        CY = gi.WEEKDAY_PATTERN,
        Up = {
          valType: "enumerated",
          values: ["auto", "linear", "array"],
          editType: "ticks",
          impliedEdits: {
            tick0: void 0,
            dtick: void 0
          }
        },
        SY = Gp({}, Up, {
          values: Up.values.slice().concat(["sync"])
        });
      function p7(e) {
        return {
          valType: "integer",
          min: 0,
          dflt: e ? 5 : 0,
          editType: "ticks"
        };
      }
      var m7 = {
          valType: "any",
          editType: "ticks",
          impliedEdits: {
            tickmode: "linear"
          }
        },
        y7 = {
          valType: "any",
          editType: "ticks",
          impliedEdits: {
            tickmode: "linear"
          }
        },
        g7 = {
          valType: "data_array",
          editType: "ticks"
        },
        b7 = {
          valType: "enumerated",
          values: ["outside", "inside", ""],
          editType: "ticks"
        };
      function x7(e) {
        var r = {
          valType: "number",
          min: 0,
          editType: "ticks"
        };
        return e || (r.dflt = 5), r;
      }
      function _7(e) {
        var r = {
          valType: "number",
          min: 0,
          editType: "ticks"
        };
        return e || (r.dflt = 1), r;
      }
      var w7 = {
          valType: "color",
          dflt: Ss.defaultLine,
          editType: "ticks"
        },
        T7 = {
          valType: "color",
          dflt: Ss.lightLine,
          editType: "ticks"
        };
      function M7(e) {
        var r = {
          valType: "number",
          min: 0,
          editType: "ticks"
        };
        return e || (r.dflt = 1), r;
      }
      var A7 = Gp({}, C7, {
          editType: "ticks"
        }),
        k7 = {
          valType: "boolean",
          editType: "ticks"
        };
      S7.exports = {
        visible: {
          valType: "boolean",
          editType: "plot"
        },
        color: {
          valType: "color",
          dflt: Ss.defaultLine,
          editType: "ticks"
        },
        title: {
          text: {
            valType: "string",
            editType: "ticks"
          },
          font: v7({
            editType: "ticks"
          }),
          standoff: {
            valType: "number",
            min: 0,
            editType: "ticks"
          },
          editType: "ticks"
        },
        type: {
          valType: "enumerated",
          values: ["-", "linear", "log", "date", "category", "multicategory"],
          dflt: "-",
          editType: "calc",
          _noTemplating: !0
        },
        autotypenumbers: {
          valType: "enumerated",
          values: ["convert types", "strict"],
          dflt: "convert types",
          editType: "calc"
        },
        autorange: {
          valType: "enumerated",
          values: [!0, !1, "reversed", "min reversed", "max reversed", "min", "max"],
          dflt: !0,
          editType: "axrange",
          impliedEdits: {
            "range[0]": void 0,
            "range[1]": void 0
          }
        },
        autorangeoptions: {
          minallowed: {
            valType: "any",
            editType: "plot",
            impliedEdits: {
              "range[0]": void 0,
              "range[1]": void 0
            }
          },
          maxallowed: {
            valType: "any",
            editType: "plot",
            impliedEdits: {
              "range[0]": void 0,
              "range[1]": void 0
            }
          },
          clipmin: {
            valType: "any",
            editType: "plot",
            impliedEdits: {
              "range[0]": void 0,
              "range[1]": void 0
            }
          },
          clipmax: {
            valType: "any",
            editType: "plot",
            impliedEdits: {
              "range[0]": void 0,
              "range[1]": void 0
            }
          },
          include: {
            valType: "any",
            arrayOk: !0,
            editType: "plot",
            impliedEdits: {
              "range[0]": void 0,
              "range[1]": void 0
            }
          },
          editType: "plot"
        },
        rangemode: {
          valType: "enumerated",
          values: ["normal", "tozero", "nonnegative"],
          dflt: "normal",
          editType: "plot"
        },
        range: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "axrange",
            impliedEdits: {
              "^autorange": !1
            },
            anim: !0
          }, {
            valType: "any",
            editType: "axrange",
            impliedEdits: {
              "^autorange": !1
            },
            anim: !0
          }],
          editType: "axrange",
          impliedEdits: {
            autorange: !1
          },
          anim: !0
        },
        minallowed: {
          valType: "any",
          editType: "plot",
          impliedEdits: {
            "^autorange": !1
          }
        },
        maxallowed: {
          valType: "any",
          editType: "plot",
          impliedEdits: {
            "^autorange": !1
          }
        },
        fixedrange: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        insiderange: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "plot"
          }, {
            valType: "any",
            editType: "plot"
          }],
          editType: "plot"
        },
        scaleanchor: {
          valType: "enumerated",
          values: [gi.idRegex.x.toString(), gi.idRegex.y.toString(), !1],
          editType: "plot"
        },
        scaleratio: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "plot"
        },
        constrain: {
          valType: "enumerated",
          values: ["range", "domain"],
          editType: "plot"
        },
        constraintoward: {
          valType: "enumerated",
          values: ["left", "center", "right", "top", "middle", "bottom"],
          editType: "plot"
        },
        matches: {
          valType: "enumerated",
          values: [gi.idRegex.x.toString(), gi.idRegex.y.toString()],
          editType: "calc"
        },
        rangebreaks: h7("rangebreak", {
          enabled: {
            valType: "boolean",
            dflt: !0,
            editType: "calc"
          },
          bounds: {
            valType: "info_array",
            items: [{
              valType: "any",
              editType: "calc"
            }, {
              valType: "any",
              editType: "calc"
            }],
            editType: "calc"
          },
          pattern: {
            valType: "enumerated",
            values: [CY, kY, ""],
            editType: "calc"
          },
          values: {
            valType: "info_array",
            freeLength: !0,
            editType: "calc",
            items: {
              valType: "any",
              editType: "calc"
            }
          },
          dvalue: {
            valType: "number",
            editType: "calc",
            min: 0,
            dflt: AY
          },
          editType: "calc"
        }),
        tickmode: SY,
        nticks: p7(),
        tick0: m7,
        dtick: y7,
        ticklabelstep: {
          valType: "integer",
          min: 1,
          dflt: 1,
          editType: "ticks"
        },
        tickvals: g7,
        ticktext: {
          valType: "data_array",
          editType: "ticks"
        },
        ticks: b7,
        tickson: {
          valType: "enumerated",
          values: ["labels", "boundaries"],
          dflt: "labels",
          editType: "ticks"
        },
        ticklabelmode: {
          valType: "enumerated",
          values: ["instant", "period"],
          dflt: "instant",
          editType: "ticks"
        },
        ticklabelposition: {
          valType: "enumerated",
          values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"],
          dflt: "outside",
          editType: "calc"
        },
        ticklabeloverflow: {
          valType: "enumerated",
          values: ["allow", "hide past div", "hide past domain"],
          editType: "calc"
        },
        ticklabelshift: {
          valType: "integer",
          dflt: 0,
          editType: "ticks"
        },
        ticklabelstandoff: {
          valType: "integer",
          dflt: 0,
          editType: "ticks"
        },
        ticklabelindex: {
          valType: "integer",
          arrayOk: !0,
          editType: "calc"
        },
        mirror: {
          valType: "enumerated",
          values: [!0, "ticks", !1, "all", "allticks"],
          dflt: !1,
          editType: "ticks+layoutstyle"
        },
        ticklen: x7(),
        tickwidth: _7(),
        tickcolor: w7,
        showticklabels: {
          valType: "boolean",
          dflt: !0,
          editType: "ticks"
        },
        labelalias: {
          valType: "any",
          dflt: !1,
          editType: "ticks"
        },
        automargin: {
          valType: "flaglist",
          flags: ["height", "width", "left", "right", "top", "bottom"],
          extras: [!0, !1],
          dflt: !1,
          editType: "ticks"
        },
        showspikes: {
          valType: "boolean",
          dflt: !1,
          editType: "modebar"
        },
        spikecolor: {
          valType: "color",
          dflt: null,
          editType: "none"
        },
        spikethickness: {
          valType: "number",
          dflt: 3,
          editType: "none"
        },
        spikedash: Gp({}, C7, {
          dflt: "dash",
          editType: "none"
        }),
        spikemode: {
          valType: "flaglist",
          flags: ["toaxis", "across", "marker"],
          dflt: "toaxis",
          editType: "none"
        },
        spikesnap: {
          valType: "enumerated",
          values: ["data", "cursor", "hovered data"],
          dflt: "hovered data",
          editType: "none"
        },
        tickfont: v7({
          editType: "ticks"
        }),
        tickangle: {
          valType: "angle",
          dflt: "auto",
          editType: "ticks"
        },
        autotickangles: {
          valType: "info_array",
          freeLength: !0,
          items: {
            valType: "angle"
          },
          dflt: [0, 30, 90],
          editType: "ticks"
        },
        tickprefix: {
          valType: "string",
          dflt: "",
          editType: "ticks"
        },
        showtickprefix: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "ticks"
        },
        ticksuffix: {
          valType: "string",
          dflt: "",
          editType: "ticks"
        },
        showticksuffix: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "ticks"
        },
        showexponent: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "ticks"
        },
        exponentformat: {
          valType: "enumerated",
          values: ["none", "e", "E", "power", "SI", "B"],
          dflt: "B",
          editType: "ticks"
        },
        minexponent: {
          valType: "number",
          dflt: 3,
          min: 0,
          editType: "ticks"
        },
        separatethousands: {
          valType: "boolean",
          dflt: !1,
          editType: "ticks"
        },
        tickformat: {
          valType: "string",
          dflt: "",
          editType: "ticks",
          description: d7("tick label")
        },
        tickformatstops: h7("tickformatstop", {
          enabled: {
            valType: "boolean",
            dflt: !0,
            editType: "ticks"
          },
          dtickrange: {
            valType: "info_array",
            items: [{
              valType: "any",
              editType: "ticks"
            }, {
              valType: "any",
              editType: "ticks"
            }],
            editType: "ticks"
          },
          value: {
            valType: "string",
            dflt: "",
            editType: "ticks"
          },
          editType: "ticks"
        }),
        hoverformat: {
          valType: "string",
          dflt: "",
          editType: "none",
          description: d7("hover text")
        },
        showline: {
          valType: "boolean",
          dflt: !1,
          editType: "ticks+layoutstyle"
        },
        linecolor: {
          valType: "color",
          dflt: Ss.defaultLine,
          editType: "layoutstyle"
        },
        linewidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "ticks+layoutstyle"
        },
        showgrid: k7,
        gridcolor: T7,
        gridwidth: M7(),
        griddash: A7,
        zeroline: {
          valType: "boolean",
          editType: "ticks"
        },
        zerolinecolor: {
          valType: "color",
          dflt: Ss.defaultLine,
          editType: "ticks"
        },
        zerolinewidth: {
          valType: "number",
          dflt: 1,
          editType: "ticks"
        },
        showdividers: {
          valType: "boolean",
          dflt: !0,
          editType: "ticks"
        },
        dividercolor: {
          valType: "color",
          dflt: Ss.defaultLine,
          editType: "ticks"
        },
        dividerwidth: {
          valType: "number",
          dflt: 1,
          editType: "ticks"
        },
        anchor: {
          valType: "enumerated",
          values: ["free", gi.idRegex.x.toString(), gi.idRegex.y.toString()],
          editType: "plot"
        },
        side: {
          valType: "enumerated",
          values: ["top", "bottom", "left", "right"],
          editType: "plot"
        },
        overlaying: {
          valType: "enumerated",
          values: ["free", gi.idRegex.x.toString(), gi.idRegex.y.toString()],
          editType: "plot"
        },
        minor: {
          tickmode: Up,
          nticks: p7("minor"),
          tick0: m7,
          dtick: y7,
          tickvals: g7,
          ticks: b7,
          ticklen: x7("minor"),
          tickwidth: _7("minor"),
          tickcolor: w7,
          gridcolor: T7,
          gridwidth: M7("minor"),
          griddash: A7,
          showgrid: k7,
          editType: "ticks"
        },
        layer: {
          valType: "enumerated",
          values: ["above traces", "below traces"],
          dflt: "above traces",
          editType: "plot"
        },
        domain: {
          valType: "info_array",
          items: [{
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          }, {
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          }],
          dflt: [0, 1],
          editType: "plot"
        },
        position: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "plot"
        },
        autoshift: {
          valType: "boolean",
          dflt: !1,
          editType: "plot"
        },
        shift: {
          valType: "number",
          editType: "plot"
        },
        categoryorder: {
          valType: "enumerated",
          values: ["trace", "category ascending", "category descending", "array", "total ascending", "total descending", "min ascending", "min descending", "max ascending", "max descending", "sum ascending", "sum descending", "mean ascending", "mean descending", "geometric mean ascending", "geometric mean descending", "median ascending", "median descending"],
          dflt: "trace",
          editType: "calc"
        },
        categoryarray: {
          valType: "data_array",
          editType: "calc"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editType: "calc"
      };
    });
    var t0 = Z((xoe, D7) => {
      "use strict";

      var ht = Xn(),
        L7 = ha(),
        q7 = Yt().extendFlat,
        LY = pi().overrideAll;
      D7.exports = LY({
        orientation: {
          valType: "enumerated",
          values: ["h", "v"],
          dflt: "v"
        },
        thicknessmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "pixels"
        },
        thickness: {
          valType: "number",
          min: 0,
          dflt: 30
        },
        lenmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "fraction"
        },
        len: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        x: {
          valType: "number"
        },
        xref: {
          valType: "enumerated",
          dflt: "paper",
          values: ["container", "paper"],
          editType: "layoutstyle"
        },
        xanchor: {
          valType: "enumerated",
          values: ["left", "center", "right"]
        },
        xpad: {
          valType: "number",
          min: 0,
          dflt: 10
        },
        y: {
          valType: "number"
        },
        yref: {
          valType: "enumerated",
          dflt: "paper",
          values: ["container", "paper"],
          editType: "layoutstyle"
        },
        yanchor: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"]
        },
        ypad: {
          valType: "number",
          min: 0,
          dflt: 10
        },
        outlinecolor: ht.linecolor,
        outlinewidth: ht.linewidth,
        bordercolor: ht.linecolor,
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 0
        },
        bgcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)"
        },
        tickmode: ht.minor.tickmode,
        nticks: ht.nticks,
        tick0: ht.tick0,
        dtick: ht.dtick,
        tickvals: ht.tickvals,
        ticktext: ht.ticktext,
        ticks: q7({}, ht.ticks, {
          dflt: ""
        }),
        ticklabeloverflow: q7({}, ht.ticklabeloverflow, {}),
        ticklabelposition: {
          valType: "enumerated",
          values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"],
          dflt: "outside"
        },
        ticklen: ht.ticklen,
        tickwidth: ht.tickwidth,
        tickcolor: ht.tickcolor,
        ticklabelstep: ht.ticklabelstep,
        showticklabels: ht.showticklabels,
        labelalias: ht.labelalias,
        tickfont: L7({}),
        tickangle: ht.tickangle,
        tickformat: ht.tickformat,
        tickformatstops: ht.tickformatstops,
        tickprefix: ht.tickprefix,
        showtickprefix: ht.showtickprefix,
        ticksuffix: ht.ticksuffix,
        showticksuffix: ht.showticksuffix,
        separatethousands: ht.separatethousands,
        exponentformat: ht.exponentformat,
        minexponent: ht.minexponent,
        showexponent: ht.showexponent,
        title: {
          text: {
            valType: "string"
          },
          font: L7({}),
          side: {
            valType: "enumerated",
            values: ["right", "top", "bottom"]
          }
        }
      }, "colorbars", "from-root");
    });
    var nf = Z((woe, P7) => {
      "use strict";

      var qY = t0(),
        DY = cs().counter,
        EY = hp(),
        E7 = $l().scales,
        _oe = EY(E7);
      function a0(e) {
        return "`" + e + "`";
      }
      P7.exports = function (r, t) {
        r = r || "", t = t || {};
        var a = t.cLetter || "c",
          n = "onlyIfNumerical" in t ? t.onlyIfNumerical : !!r,
          i = "noScale" in t ? t.noScale : r === "marker.line",
          l = "showScaleDflt" in t ? t.showScaleDflt : a === "z",
          o = typeof t.colorscaleDflt == "string" ? E7[t.colorscaleDflt] : null,
          s = t.editTypeOverride || "",
          u = r ? r + "." : "",
          f,
          v;
        "colorAttr" in t ? (f = t.colorAttr, v = t.colorAttr) : (f = {
          z: "z",
          c: "color"
        }[a], v = "in " + a0(u + f));
        var h = n ? " Has an effect only if " + v + " is set to a numerical array." : "",
          d = a + "auto",
          y = a + "min",
          g = a + "max",
          m = a + "mid",
          _ = a0(u + d),
          w = a0(u + y),
          T = a0(u + g),
          b = w + " and " + T,
          A = {};
        A[y] = A[g] = void 0;
        var S = {};
        S[d] = !1;
        var k = {};
        return f === "color" && (k.color = {
          valType: "color",
          arrayOk: !0,
          editType: s || "style"
        }, t.anim && (k.color.anim = !0)), k[d] = {
          valType: "boolean",
          dflt: !0,
          editType: "calc",
          impliedEdits: A
        }, k[y] = {
          valType: "number",
          dflt: null,
          editType: s || "plot",
          impliedEdits: S
        }, k[g] = {
          valType: "number",
          dflt: null,
          editType: s || "plot",
          impliedEdits: S
        }, k[m] = {
          valType: "number",
          dflt: null,
          editType: "calc",
          impliedEdits: A
        }, k.colorscale = {
          valType: "colorscale",
          editType: "calc",
          dflt: o,
          impliedEdits: {
            autocolorscale: !1
          }
        }, k.autocolorscale = {
          valType: "boolean",
          dflt: t.autoColorDflt !== !1,
          editType: "calc",
          impliedEdits: {
            colorscale: void 0
          }
        }, k.reversescale = {
          valType: "boolean",
          dflt: !1,
          editType: "plot"
        }, i || (k.showscale = {
          valType: "boolean",
          dflt: l,
          editType: "calc"
        }, k.colorbar = qY), t.noColorAxis || (k.coloraxis = {
          valType: "subplotid",
          regex: DY("coloraxis"),
          dflt: null,
          editType: "calc"
        }), k;
      };
    });
    var Wp = Z((Toe, R7) => {
      "use strict";

      var PY = Yt().extendFlat,
        RY = nf(),
        Vp = $l().scales;
      R7.exports = {
        editType: "calc",
        colorscale: {
          editType: "calc",
          sequential: {
            valType: "colorscale",
            dflt: Vp.Reds,
            editType: "calc"
          },
          sequentialminus: {
            valType: "colorscale",
            dflt: Vp.Blues,
            editType: "calc"
          },
          diverging: {
            valType: "colorscale",
            dflt: Vp.RdBu,
            editType: "calc"
          }
        },
        coloraxis: PY({
          _isSubplotObj: !0,
          editType: "calc"
        }, RY("", {
          colorAttr: "corresponding trace color array(s)",
          noColorAxis: !0,
          showScaleDflt: !0
        }))
      };
    });
    var Zp = Z((Moe, z7) => {
      "use strict";

      var zY = He();
      z7.exports = function (r) {
        return zY.isPlainObject(r.colorbar);
      };
    });
    var Kp = Z(Jp => {
      "use strict";

      var Xp = Hr(),
        N7 = He(),
        F7 = Bt(),
        NY = F7.ONEDAY,
        FY = F7.ONEWEEK;
      Jp.dtick = function (e, r) {
        var t = r === "log",
          a = r === "date",
          n = r === "category",
          i = a ? NY : 1;
        if (!e) return i;
        if (Xp(e)) return e = Number(e), e <= 0 ? i : n ? Math.max(1, Math.round(e)) : a ? Math.max(.1, e) : e;
        if (typeof e != "string" || !(a || t)) return i;
        var l = e.charAt(0),
          o = e.substr(1);
        return o = Xp(o) ? Number(o) : 0, o <= 0 || !(a && l === "M" && o === Math.round(o) || t && l === "L" || t && l === "D" && (o === 1 || o === 2)) ? i : e;
      };
      Jp.tick0 = function (e, r, t, a) {
        if (r === "date") return N7.cleanDate(e, N7.dateTick0(t, a % FY === 0 ? 1 : 0));
        if (!(a === "D1" || a === "D2")) return Xp(e) ? Number(e) : 0;
      };
    });
    var Qp = Z((koe, H7) => {
      "use strict";

      var I7 = Kp(),
        IY = He().isArrayOrTypedArray,
        HY = nn().isTypedArraySpec,
        OY = nn().decodeTypedArraySpec;
      H7.exports = function (r, t, a, n, i) {
        i || (i = {});
        var l = i.isMinor,
          o = l ? r.minor || {} : r,
          s = l ? t.minor : t,
          u = l ? "minor." : "";
        function f(w) {
          var T = o[w];
          return HY(T) && (T = OY(T)), T !== void 0 ? T : (s._template || {})[w];
        }
        var v = f("tick0"),
          h = f("dtick"),
          d = f("tickvals"),
          y = IY(d) ? "array" : h ? "linear" : "auto",
          g = a(u + "tickmode", y);
        if (g === "auto" || g === "sync") a(u + "nticks");else if (g === "linear") {
          var m = s.dtick = I7.dtick(h, n);
          s.tick0 = I7.tick0(v, n, t.calendar, m);
        } else if (n !== "multicategory") {
          var _ = a(u + "tickvals");
          _ === void 0 ? s.tickmode = "auto" : l || a("ticktext");
        }
      };
    });
    var jp = Z((Coe, B7) => {
      "use strict";

      var $p = He(),
        O7 = Xn();
      B7.exports = function (r, t, a, n) {
        var i = n.isMinor,
          l = i ? r.minor || {} : r,
          o = i ? t.minor : t,
          s = i ? O7.minor : O7,
          u = i ? "minor." : "",
          f = $p.coerce2(l, o, s, "ticklen", i ? (t.ticklen || 5) * .6 : void 0),
          v = $p.coerce2(l, o, s, "tickwidth", i ? t.tickwidth || 1 : void 0),
          h = $p.coerce2(l, o, s, "tickcolor", (i ? t.tickcolor : void 0) || o.color),
          d = a(u + "ticks", !i && n.outerTicks || f || v || h ? "outside" : "");
        d || (delete o.ticklen, delete o.tickwidth, delete o.tickcolor);
      };
    });
    var em = Z((Soe, Y7) => {
      "use strict";

      Y7.exports = function (r) {
        var t = ["showexponent", "showtickprefix", "showticksuffix"],
          a = t.filter(function (i) {
            return r[i] !== void 0;
          }),
          n = function (i) {
            return r[i] === r[a[0]];
          };
        if (a.every(n) || a.length === 1) return r[a[0]];
      };
    });
    var Jn = Z((Loe, U7) => {
      "use strict";

      var n0 = He(),
        BY = ct();
      U7.exports = function (r, t, a) {
        var n = a.name,
          i = a.inclusionAttr || "visible",
          l = t[n],
          o = n0.isArrayOrTypedArray(r[n]) ? r[n] : [],
          s = t[n] = [],
          u = BY.arrayTemplater(t, n, i),
          f,
          v;
        for (f = 0; f < o.length; f++) {
          var h = o[f];
          n0.isPlainObject(h) ? v = u.newItem(h) : (v = u.newItem({}), v[i] = !1), v._index = f, v[i] !== !1 && a.handleItemDefaults(h, v, t, a), s.push(v);
        }
        var d = u.defaultItems();
        for (f = 0; f < d.length; f++) v = d[f], v._index = s.length, a.handleItemDefaults({}, v, t, a, {}), s.push(v);
        if (n0.isArrayOrTypedArray(l)) {
          var y = Math.min(l.length, s.length);
          for (f = 0; f < y; f++) n0.relinkPrivateKeys(s[f], l[f]);
        }
        return s;
      };
    });
    var tm = Z((qoe, V7) => {
      "use strict";

      var rm = He(),
        YY = Er().contrast,
        G7 = Xn(),
        UY = em(),
        GY = Jn();
      V7.exports = function (r, t, a, n, i) {
        i || (i = {});
        var l = a("labelalias");
        rm.isPlainObject(l) || delete t.labelalias;
        var o = UY(r),
          s = a("showticklabels");
        if (s) {
          i.noTicklabelshift || a("ticklabelshift"), i.noTicklabelstandoff || a("ticklabelstandoff");
          var u = i.font || {},
            f = t.color,
            v = t.ticklabelposition || "",
            h = v.indexOf("inside") !== -1 ? YY(i.bgColor) : f && f !== G7.color.dflt ? f : u.color;
          if (rm.coerceFont(a, "tickfont", u, {
            overrideDflt: {
              color: h
            }
          }), !i.noTicklabelstep && n !== "multicategory" && n !== "log" && a("ticklabelstep"), !i.noAng) {
            var d = a("tickangle");
            !i.noAutotickangles && d === "auto" && a("autotickangles");
          }
          if (n !== "category") {
            var y = a("tickformat");
            GY(r, t, {
              name: "tickformatstops",
              inclusionAttr: "enabled",
              handleItemDefaults: VY
            }), t.tickformatstops.length || delete t.tickformatstops, !i.noExp && !y && n !== "date" && (a("showexponent", o), a("exponentformat"), a("minexponent"), a("separatethousands"));
          }
        }
      };
      function VY(e, r) {
        function t(n, i) {
          return rm.coerce(e, r, G7.tickformatstops, n, i);
        }
        var a = t("enabled");
        a && (t("dtickrange"), t("value"));
      }
    });
    var am = Z((Doe, W7) => {
      "use strict";

      var WY = em();
      W7.exports = function (r, t, a, n, i) {
        i || (i = {});
        var l = i.tickSuffixDflt,
          o = WY(r),
          s = a("tickprefix");
        s && a("showtickprefix", o);
        var u = a("ticksuffix", l);
        u && a("showticksuffix", o);
      };
    });
    var nm = Z((Eoe, Z7) => {
      "use strict";

      var ml = He(),
        ZY = ct(),
        XY = Qp(),
        JY = jp(),
        KY = tm(),
        QY = am(),
        $Y = t0();
      Z7.exports = function (r, t, a) {
        var n = ZY.newContainer(t, "colorbar"),
          i = r.colorbar || {};
        function l(z, N) {
          return ml.coerce(i, n, $Y, z, N);
        }
        var o = a.margin || {
            t: 0,
            b: 0,
            l: 0,
            r: 0
          },
          s = a.width - o.l - o.r,
          u = a.height - o.t - o.b,
          f = l("orientation"),
          v = f === "v",
          h = l("thicknessmode");
        l("thickness", h === "fraction" ? 30 / (v ? s : u) : 30);
        var d = l("lenmode");
        l("len", d === "fraction" ? 1 : v ? u : s);
        var y = l("yref"),
          g = l("xref"),
          m = y === "paper",
          _ = g === "paper",
          w,
          T,
          b,
          A = "left";
        v ? (b = "middle", A = _ ? "left" : "right", w = _ ? 1.02 : 1, T = .5) : (b = m ? "bottom" : "top", A = "center", w = .5, T = m ? 1.02 : 1), ml.coerce(i, n, {
          x: {
            valType: "number",
            min: _ ? -2 : 0,
            max: _ ? 3 : 1,
            dflt: w
          }
        }, "x"), ml.coerce(i, n, {
          y: {
            valType: "number",
            min: m ? -2 : 0,
            max: m ? 3 : 1,
            dflt: T
          }
        }, "y"), l("xanchor", A), l("xpad"), l("yanchor", b), l("ypad"), ml.noneOrAll(i, n, ["x", "y"]), l("outlinecolor"), l("outlinewidth"), l("bordercolor"), l("borderwidth"), l("bgcolor");
        var S = ml.coerce(i, n, {
          ticklabelposition: {
            valType: "enumerated",
            dflt: "outside",
            values: v ? ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"] : ["outside", "inside", "outside left", "inside left", "outside right", "inside right"]
          }
        }, "ticklabelposition");
        l("ticklabeloverflow", S.indexOf("inside") !== -1 ? "hide past domain" : "hide past div"), XY(i, n, l, "linear");
        var k = a.font,
          q = {
            noAutotickangles: !0,
            noTicklabelshift: !0,
            noTicklabelstandoff: !0,
            outerTicks: !1,
            font: k
          };
        S.indexOf("inside") !== -1 && (q.bgColor = "black"), QY(i, n, l, "linear", q), KY(i, n, l, "linear", q), JY(i, n, l, "linear", q), l("title.text", a._dfltTitle.colorbar);
        var D = n.showticklabels ? n.tickfont : k,
          R = ml.extendFlat({}, k, {
            family: D.family,
            size: ml.bigFont(D.size)
          });
        ml.coerceFont(l, "title.font", R), l("title.side", v ? "top" : "right");
      };
    });
    var Ls = Z((Poe, K7) => {
      "use strict";

      var X7 = Hr(),
        lm = He(),
        jY = Zp(),
        eU = nm(),
        J7 = $l().isValid,
        rU = gr().traceIs;
      function im(e, r) {
        var t = r.slice(0, r.length - 1);
        return r ? lm.nestedProperty(e, t).get() || {} : e;
      }
      K7.exports = function e(r, t, a, n, i) {
        var l = i.prefix,
          o = i.cLetter,
          s = "_module" in t,
          u = im(r, l),
          f = im(t, l),
          v = im(t._template || {}, l) || {},
          h = function () {
            return delete r.coloraxis, delete t.coloraxis, e(r, t, a, n, i);
          };
        if (s) {
          var d = a._colorAxes || {},
            y = n(l + "coloraxis");
          if (y) {
            var g = rU(t, "contour") && lm.nestedProperty(t, "contours.coloring").get() || "heatmap",
              m = d[y];
            m ? (m[2].push(h), m[0] !== g && (m[0] = !1, lm.warn(["Ignoring coloraxis:", y, "setting", "as it is linked to incompatible colorscales."].join(" ")))) : d[y] = [g, t, [h]];
            return;
          }
        }
        var _ = u[o + "min"],
          w = u[o + "max"],
          T = X7(_) && X7(w) && _ < w,
          b = n(l + o + "auto", !T);
        b ? n(l + o + "mid") : (n(l + o + "min"), n(l + o + "max"));
        var A = u.colorscale,
          S = v.colorscale,
          k;
        if (A !== void 0 && (k = !J7(A)), S !== void 0 && (k = !J7(S)), n(l + "autocolorscale", k), n(l + "colorscale"), n(l + "reversescale"), l !== "marker.line.") {
          var q;
          l && s && (q = jY(u));
          var D = n(l + "showscale", q);
          D && (l && v && (f._template = v), eU(u, f, a));
        }
      };
    });
    var e9 = Z((Roe, j7) => {
      "use strict";

      var Q7 = He(),
        tU = ct(),
        $7 = Wp(),
        aU = Ls();
      j7.exports = function (r, t) {
        function a(v, h) {
          return Q7.coerce(r, t, $7, v, h);
        }
        a("colorscale.sequential"), a("colorscale.sequentialminus"), a("colorscale.diverging");
        var n = t._colorAxes,
          i,
          l;
        function o(v, h) {
          return Q7.coerce(i, l, $7.coloraxis, v, h);
        }
        for (var s in n) {
          var u = n[s];
          if (u[0]) i = r[s] || {}, l = tU.newContainer(t, s, "coloraxis"), l._name = s, aU(i, l, t, o, {
            prefix: "",
            cLetter: "c"
          });else {
            for (var f = 0; f < u[2].length; f++) u[2][f]();
            delete t._colorAxes[s];
          }
        }
      };
    });
    var t9 = Z((zoe, r9) => {
      "use strict";

      var nU = He(),
        iU = Tn().hasColorscale,
        lU = Tn().extractOpts;
      r9.exports = function (r, t) {
        function a(f, v) {
          var h = f["_" + v];
          h !== void 0 && (f[v] = h);
        }
        function n(f, v) {
          var h = v.container ? nU.nestedProperty(f, v.container).get() : f;
          if (h) if (h.coloraxis) h._colorAx = t[h.coloraxis];else {
            var d = lU(h),
              y = d.auto;
            (y || d.min === void 0) && a(h, v.min), (y || d.max === void 0) && a(h, v.max), d.autocolorscale && a(h, "colorscale");
          }
        }
        for (var i = 0; i < r.length; i++) {
          var l = r[i],
            o = l._module.colorbar;
          if (o) if (Array.isArray(o)) for (var s = 0; s < o.length; s++) n(l, o[s]);else n(l, o);
          iU(l, "marker.line") && n(l, {
            container: "marker.line",
            min: "cmin",
            max: "cmax"
          });
        }
        for (var u in t._colorAxes) n(t[u], {
          min: "cmin",
          max: "cmax"
        });
      };
    });
    var i0 = Z((Noe, n9) => {
      "use strict";

      var a9 = Hr(),
        om = He(),
        oU = Tn().extractOpts;
      n9.exports = function (r, t, a) {
        var n = r._fullLayout,
          i = a.vals,
          l = a.containerStr,
          o = l ? om.nestedProperty(t, l).get() : t,
          s = oU(o),
          u = s.auto !== !1,
          f = s.min,
          v = s.max,
          h = s.mid,
          d = function () {
            return om.aggNums(Math.min, null, i);
          },
          y = function () {
            return om.aggNums(Math.max, null, i);
          };
        if (f === void 0 ? f = d() : u && (o._colorAx && a9(f) ? f = Math.min(f, d()) : f = d()), v === void 0 ? v = y() : u && (o._colorAx && a9(v) ? v = Math.max(v, y()) : v = y()), u && h !== void 0 && (v - h > h - f ? f = h - (v - h) : v - h < h - f && (v = h + (h - f))), f === v && (f -= .5, v += .5), s._sync("min", f), s._sync("max", v), s.autocolorscale) {
          var g;
          f * v < 0 ? g = n.colorscale.diverging : f >= 0 ? g = n.colorscale.sequential : g = n.colorscale.sequentialminus, s._sync("colorscale", g);
        }
      };
    });
    var sm = Z((Foe, i9) => {
      "use strict";

      var l0 = $l(),
        qs = Tn();
      i9.exports = {
        moduleType: "component",
        name: "colorscale",
        attributes: nf(),
        layoutAttributes: Wp(),
        supplyLayoutDefaults: e9(),
        handleDefaults: Ls(),
        crossTraceDefaults: t9(),
        calc: i0(),
        scales: l0.scales,
        defaultScale: l0.defaultScale,
        getScale: l0.get,
        isValidScale: l0.isValid,
        hasColorscale: qs.hasColorscale,
        extractOpts: qs.extractOpts,
        extractScale: qs.extractScale,
        flipScale: qs.flipScale,
        makeColorScaleFunc: qs.makeColorScaleFunc,
        makeColorScaleFuncFromTrace: qs.makeColorScaleFuncFromTrace
      };
    });
    var on = Z((Ioe, o9) => {
      "use strict";

      var l9 = He(),
        sU = nn().isTypedArraySpec;
      o9.exports = {
        hasLines: function (e) {
          return e.visible && e.mode && e.mode.indexOf("lines") !== -1;
        },
        hasMarkers: function (e) {
          return e.visible && (e.mode && e.mode.indexOf("markers") !== -1 || e.type === "splom");
        },
        hasText: function (e) {
          return e.visible && e.mode && e.mode.indexOf("text") !== -1;
        },
        isBubble: function (e) {
          var r = e.marker;
          return l9.isPlainObject(r) && (l9.isArrayOrTypedArray(r.size) || sU(r.size));
        }
      };
    });
    var u9 = Z((Hoe, s9) => {
      "use strict";

      var uU = Hr();
      s9.exports = function (r, t) {
        t || (t = 2);
        var a = r.marker,
          n = a.sizeref || 1,
          i = a.sizemin || 0,
          l = a.sizemode === "area" ? function (o) {
            return Math.sqrt(o / n);
          } : function (o) {
            return o / n;
          };
        return function (o) {
          var s = l(o / t);
          return uU(s) && s > 0 ? Math.max(s, i) : 0;
        };
      };
    });
    var bi = Z(_a => {
      "use strict";

      var f9 = He();
      _a.getSubplot = function (e) {
        return e.subplot || e.xaxis + e.yaxis || e.geo;
      };
      _a.isTraceInSubplots = function (e, r) {
        if (e.type === "splom") {
          for (var t = e.xaxes || [], a = e.yaxes || [], n = 0; n < t.length; n++) for (var i = 0; i < a.length; i++) if (r.indexOf(t[n] + a[i]) !== -1) return !0;
          return !1;
        }
        return r.indexOf(_a.getSubplot(e)) !== -1;
      };
      _a.flat = function (e, r) {
        for (var t = new Array(e.length), a = 0; a < e.length; a++) t[a] = r;
        return t;
      };
      _a.p2c = function (e, r) {
        for (var t = new Array(e.length), a = 0; a < e.length; a++) t[a] = e[a].p2c(r);
        return t;
      };
      _a.getDistanceFunction = function (e, r, t, a) {
        return e === "closest" ? a || _a.quadrature(r, t) : e.charAt(0) === "x" ? r : t;
      };
      _a.getClosest = function (e, r, t) {
        if (t.index !== !1) t.index >= 0 && t.index < e.length ? t.distance = 0 : t.index = !1;else for (var a = 1 / 0, n = e.length, i = 0; i < n; i++) a = r(e[i]), a <= t.distance && (t.index = i, t.distance = a);
        return t;
      };
      _a.inbox = function (e, r, t) {
        return e * r < 0 || e === 0 ? t : 1 / 0;
      };
      _a.quadrature = function (e, r) {
        return function (t) {
          var a = e(t),
            n = r(t);
          return Math.sqrt(a * a + n * n);
        };
      };
      _a.makeEventData = function (e, r, t) {
        var a = "index" in e ? e.index : e.pointNumber,
          n = {
            data: r._input,
            fullData: r,
            curveNumber: r.index,
            pointNumber: a
          };
        if (r._indexToPoints) {
          var i = r._indexToPoints[a];
          i.length === 1 ? n.pointIndex = i[0] : n.pointIndices = i;
        } else n.pointIndex = a;
        return r._module.eventData ? n = r._module.eventData(n, e, r, t, a) : ("xVal" in e ? n.x = e.xVal : "x" in e && (n.x = e.x), "yVal" in e ? n.y = e.yVal : "y" in e && (n.y = e.y), e.xa && (n.xaxis = e.xa), e.ya && (n.yaxis = e.ya), e.zLabelVal !== void 0 && (n.z = e.zLabelVal)), _a.appendArrayPointValue(n, r, a), n;
      };
      _a.appendArrayPointValue = function (e, r, t) {
        var a = r._arrayAttrs;
        if (a) for (var n = 0; n < a.length; n++) {
          var i = a[n],
            l = c9(i);
          if (e[l] === void 0) {
            var o = f9.nestedProperty(r, i).get(),
              s = v9(o, t);
            s !== void 0 && (e[l] = s);
          }
        }
      };
      _a.appendArrayMultiPointValues = function (e, r, t) {
        var a = r._arrayAttrs;
        if (a) for (var n = 0; n < a.length; n++) {
          var i = a[n],
            l = c9(i);
          if (e[l] === void 0) {
            for (var o = f9.nestedProperty(r, i).get(), s = new Array(t.length), u = 0; u < t.length; u++) s[u] = v9(o, t[u]);
            e[l] = s;
          }
        }
      };
      var fU = {
        ids: "id",
        locations: "location",
        labels: "label",
        values: "value",
        "marker.colors": "color",
        parents: "parent"
      };
      function c9(e) {
        return fU[e] || e;
      }
      function v9(e, r) {
        if (Array.isArray(r)) {
          if (Array.isArray(e) && Array.isArray(e[r[0]])) return e[r[0]][r[1]];
        } else return e[r];
      }
      var cU = {
          x: !0,
          y: !0
        },
        vU = {
          "x unified": !0,
          "y unified": !0
        };
      _a.isUnifiedHover = function (e) {
        return typeof e != "string" ? !1 : !!vU[e];
      };
      _a.isXYhover = function (e) {
        return typeof e != "string" ? !1 : !!cU[e];
      };
    });
    var fm = Z((Boe, h9) => {
      h9.exports = dU;
      var um = {
          a: 7,
          c: 6,
          h: 1,
          l: 2,
          m: 2,
          q: 4,
          s: 4,
          t: 2,
          v: 1,
          z: 0
        },
        hU = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
      function dU(e) {
        var r = [];
        return e.replace(hU, function (t, a, n) {
          var i = a.toLowerCase();
          for (n = mU(n), i == "m" && n.length > 2 && (r.push([a].concat(n.splice(0, 2))), i = "l", a = a == "m" ? "l" : "L");;) {
            if (n.length == um[i]) return n.unshift(a), r.push(n);
            if (n.length < um[i]) throw new Error("malformed path data");
            r.push([a].concat(n.splice(0, um[i])));
          }
        }), r;
      }
      var pU = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
      function mU(e) {
        var r = e.match(pU);
        return r ? r.map(Number) : [];
      }
    });
    var x9 = Z((Yoe, b9) => {
      "use strict";

      var yU = fm(),
        Xe = function (e, r) {
          return r ? Math.round(e * (r = Math.pow(10, r))) / r : Math.round(e);
        },
        Ar = "M0,0Z",
        d9 = Math.sqrt(2),
        yl = Math.sqrt(3),
        cm = Math.PI,
        vm = Math.cos,
        hm = Math.sin;
      b9.exports = {
        circle: {
          n: 0,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2),
              n = "M" + a + ",0A" + a + "," + a + " 0 1,1 0,-" + a + "A" + a + "," + a + " 0 0,1 " + a + ",0Z";
            return t ? Cr(r, t, n) : n;
          }
        },
        square: {
          n: 1,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2);
            return Cr(r, t, "M" + a + "," + a + "H-" + a + "V-" + a + "H" + a + "Z");
          }
        },
        diamond: {
          n: 2,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.3, 2);
            return Cr(r, t, "M" + a + ",0L0," + a + "L-" + a + ",0L0,-" + a + "Z");
          }
        },
        cross: {
          n: 3,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .4, 2),
              n = Xe(e * 1.2, 2);
            return Cr(r, t, "M" + n + "," + a + "H" + a + "V" + n + "H-" + a + "V" + a + "H-" + n + "V-" + a + "H-" + a + "V-" + n + "H" + a + "V-" + a + "H" + n + "Z");
          }
        },
        x: {
          n: 4,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .8 / d9, 2),
              n = "l" + a + "," + a,
              i = "l" + a + ",-" + a,
              l = "l-" + a + ",-" + a,
              o = "l-" + a + "," + a;
            return Cr(r, t, "M0," + a + n + i + l + i + l + o + l + o + n + o + n + "Z");
          }
        },
        "triangle-up": {
          n: 5,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 2 / yl, 2),
              n = Xe(e / 2, 2),
              i = Xe(e, 2);
            return Cr(r, t, "M-" + a + "," + n + "H" + a + "L0,-" + i + "Z");
          }
        },
        "triangle-down": {
          n: 6,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 2 / yl, 2),
              n = Xe(e / 2, 2),
              i = Xe(e, 2);
            return Cr(r, t, "M-" + a + ",-" + n + "H" + a + "L0," + i + "Z");
          }
        },
        "triangle-left": {
          n: 7,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 2 / yl, 2),
              n = Xe(e / 2, 2),
              i = Xe(e, 2);
            return Cr(r, t, "M" + n + ",-" + a + "V" + a + "L-" + i + ",0Z");
          }
        },
        "triangle-right": {
          n: 8,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 2 / yl, 2),
              n = Xe(e / 2, 2),
              i = Xe(e, 2);
            return Cr(r, t, "M-" + n + ",-" + a + "V" + a + "L" + i + ",0Z");
          }
        },
        "triangle-ne": {
          n: 9,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .6, 2),
              n = Xe(e * 1.2, 2);
            return Cr(r, t, "M-" + n + ",-" + a + "H" + a + "V" + n + "Z");
          }
        },
        "triangle-se": {
          n: 10,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .6, 2),
              n = Xe(e * 1.2, 2);
            return Cr(r, t, "M" + a + ",-" + n + "V" + a + "H-" + n + "Z");
          }
        },
        "triangle-sw": {
          n: 11,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .6, 2),
              n = Xe(e * 1.2, 2);
            return Cr(r, t, "M" + n + "," + a + "H-" + a + "V-" + n + "Z");
          }
        },
        "triangle-nw": {
          n: 12,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .6, 2),
              n = Xe(e * 1.2, 2);
            return Cr(r, t, "M-" + a + "," + n + "V-" + a + "H" + n + "Z");
          }
        },
        pentagon: {
          n: 13,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .951, 2),
              n = Xe(e * .588, 2),
              i = Xe(-e, 2),
              l = Xe(e * -.309, 2),
              o = Xe(e * .809, 2);
            return Cr(r, t, "M" + a + "," + l + "L" + n + "," + o + "H-" + n + "L-" + a + "," + l + "L0," + i + "Z");
          }
        },
        hexagon: {
          n: 14,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2),
              n = Xe(e / 2, 2),
              i = Xe(e * yl / 2, 2);
            return Cr(r, t, "M" + i + ",-" + n + "V" + n + "L0," + a + "L-" + i + "," + n + "V-" + n + "L0,-" + a + "Z");
          }
        },
        hexagon2: {
          n: 15,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2),
              n = Xe(e / 2, 2),
              i = Xe(e * yl / 2, 2);
            return Cr(r, t, "M-" + n + "," + i + "H" + n + "L" + a + ",0L" + n + ",-" + i + "H-" + n + "L-" + a + ",0Z");
          }
        },
        octagon: {
          n: 16,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .924, 2),
              n = Xe(e * .383, 2);
            return Cr(r, t, "M-" + n + ",-" + a + "H" + n + "L" + a + ",-" + n + "V" + n + "L" + n + "," + a + "H-" + n + "L-" + a + "," + n + "V-" + n + "Z");
          }
        },
        star: {
          n: 17,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = e * 1.4,
              n = Xe(a * .225, 2),
              i = Xe(a * .951, 2),
              l = Xe(a * .363, 2),
              o = Xe(a * .588, 2),
              s = Xe(-a, 2),
              u = Xe(a * -.309, 2),
              f = Xe(a * .118, 2),
              v = Xe(a * .809, 2),
              h = Xe(a * .382, 2);
            return Cr(r, t, "M" + n + "," + u + "H" + i + "L" + l + "," + f + "L" + o + "," + v + "L0," + h + "L-" + o + "," + v + "L-" + l + "," + f + "L-" + i + "," + u + "H-" + n + "L0," + s + "Z");
          }
        },
        hexagram: {
          n: 18,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .66, 2),
              n = Xe(e * .38, 2),
              i = Xe(e * .76, 2);
            return Cr(r, t, "M-" + i + ",0l-" + n + ",-" + a + "h" + i + "l" + n + ",-" + a + "l" + n + "," + a + "h" + i + "l-" + n + "," + a + "l" + n + "," + a + "h-" + i + "l-" + n + "," + a + "l-" + n + ",-" + a + "h-" + i + "Z");
          }
        },
        "star-triangle-up": {
          n: 19,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * yl * .8, 2),
              n = Xe(e * .8, 2),
              i = Xe(e * 1.6, 2),
              l = Xe(e * 4, 2),
              o = "A " + l + "," + l + " 0 0 1 ";
            return Cr(r, t, "M-" + a + "," + n + o + a + "," + n + o + "0,-" + i + o + "-" + a + "," + n + "Z");
          }
        },
        "star-triangle-down": {
          n: 20,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * yl * .8, 2),
              n = Xe(e * .8, 2),
              i = Xe(e * 1.6, 2),
              l = Xe(e * 4, 2),
              o = "A " + l + "," + l + " 0 0 1 ";
            return Cr(r, t, "M" + a + ",-" + n + o + "-" + a + ",-" + n + o + "0," + i + o + a + ",-" + n + "Z");
          }
        },
        "star-square": {
          n: 21,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.1, 2),
              n = Xe(e * 2, 2),
              i = "A " + n + "," + n + " 0 0 1 ";
            return Cr(r, t, "M-" + a + ",-" + a + i + "-" + a + "," + a + i + a + "," + a + i + a + ",-" + a + i + "-" + a + ",-" + a + "Z");
          }
        },
        "star-diamond": {
          n: 22,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.4, 2),
              n = Xe(e * 1.9, 2),
              i = "A " + n + "," + n + " 0 0 1 ";
            return Cr(r, t, "M-" + a + ",0" + i + "0," + a + i + a + ",0" + i + "0,-" + a + i + "-" + a + ",0Z");
          }
        },
        "diamond-tall": {
          n: 23,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * .7, 2),
              n = Xe(e * 1.4, 2);
            return Cr(r, t, "M0," + n + "L" + a + ",0L0,-" + n + "L-" + a + ",0Z");
          }
        },
        "diamond-wide": {
          n: 24,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.4, 2),
              n = Xe(e * .7, 2);
            return Cr(r, t, "M0," + n + "L" + a + ",0L0,-" + n + "L-" + a + ",0Z");
          }
        },
        hourglass: {
          n: 25,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2);
            return Cr(r, t, "M" + a + "," + a + "H-" + a + "L" + a + ",-" + a + "H-" + a + "Z");
          },
          noDot: !0
        },
        bowtie: {
          n: 26,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2);
            return Cr(r, t, "M" + a + "," + a + "V-" + a + "L-" + a + "," + a + "V-" + a + "Z");
          },
          noDot: !0
        },
        "circle-cross": {
          n: 27,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2);
            return Cr(r, t, "M0," + a + "V-" + a + "M" + a + ",0H-" + a + "M" + a + ",0A" + a + "," + a + " 0 1,1 0,-" + a + "A" + a + "," + a + " 0 0,1 " + a + ",0Z");
          },
          needLine: !0,
          noDot: !0
        },
        "circle-x": {
          n: 28,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2),
              n = Xe(e / d9, 2);
            return Cr(r, t, "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n + "M" + a + ",0A" + a + "," + a + " 0 1,1 0,-" + a + "A" + a + "," + a + " 0 0,1 " + a + ",0Z");
          },
          needLine: !0,
          noDot: !0
        },
        "square-cross": {
          n: 29,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2);
            return Cr(r, t, "M0," + a + "V-" + a + "M" + a + ",0H-" + a + "M" + a + "," + a + "H-" + a + "V-" + a + "H" + a + "Z");
          },
          needLine: !0,
          noDot: !0
        },
        "square-x": {
          n: 30,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2);
            return Cr(r, t, "M" + a + "," + a + "L-" + a + ",-" + a + "M" + a + ",-" + a + "L-" + a + "," + a + "M" + a + "," + a + "H-" + a + "V-" + a + "H" + a + "Z");
          },
          needLine: !0,
          noDot: !0
        },
        "diamond-cross": {
          n: 31,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.3, 2);
            return Cr(r, t, "M" + a + ",0L0," + a + "L-" + a + ",0L0,-" + a + "ZM0,-" + a + "V" + a + "M-" + a + ",0H" + a);
          },
          needLine: !0,
          noDot: !0
        },
        "diamond-x": {
          n: 32,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.3, 2),
              n = Xe(e * .65, 2);
            return Cr(r, t, "M" + a + ",0L0," + a + "L-" + a + ",0L0,-" + a + "ZM-" + n + ",-" + n + "L" + n + "," + n + "M-" + n + "," + n + "L" + n + ",-" + n);
          },
          needLine: !0,
          noDot: !0
        },
        "cross-thin": {
          n: 33,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.4, 2);
            return Cr(r, t, "M0," + a + "V-" + a + "M" + a + ",0H-" + a);
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "x-thin": {
          n: 34,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2);
            return Cr(r, t, "M" + a + "," + a + "L-" + a + ",-" + a + "M" + a + ",-" + a + "L-" + a + "," + a);
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        asterisk: {
          n: 35,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.2, 2),
              n = Xe(e * .85, 2);
            return Cr(r, t, "M0," + a + "V-" + a + "M" + a + ",0H-" + a + "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n);
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        hash: {
          n: 36,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e / 2, 2),
              n = Xe(e, 2);
            return Cr(r, t, "M" + a + "," + n + "V-" + n + "M" + (a - n) + ",-" + n + "V" + n + "M" + n + "," + a + "H-" + n + "M-" + n + "," + (a - n) + "H" + n);
          },
          needLine: !0,
          noFill: !0
        },
        "y-up": {
          n: 37,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.2, 2),
              n = Xe(e * 1.6, 2),
              i = Xe(e * .8, 2);
            return Cr(r, t, "M-" + a + "," + i + "L0,0M" + a + "," + i + "L0,0M0,-" + n + "L0,0");
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "y-down": {
          n: 38,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.2, 2),
              n = Xe(e * 1.6, 2),
              i = Xe(e * .8, 2);
            return Cr(r, t, "M-" + a + ",-" + i + "L0,0M" + a + ",-" + i + "L0,0M0," + n + "L0,0");
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "y-left": {
          n: 39,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.2, 2),
              n = Xe(e * 1.6, 2),
              i = Xe(e * .8, 2);
            return Cr(r, t, "M" + i + "," + a + "L0,0M" + i + ",-" + a + "L0,0M-" + n + ",0L0,0");
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "y-right": {
          n: 40,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.2, 2),
              n = Xe(e * 1.6, 2),
              i = Xe(e * .8, 2);
            return Cr(r, t, "M-" + i + "," + a + "L0,0M-" + i + ",-" + a + "L0,0M" + n + ",0L0,0");
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-ew": {
          n: 41,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.4, 2);
            return Cr(r, t, "M" + a + ",0H-" + a);
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-ns": {
          n: 42,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 1.4, 2);
            return Cr(r, t, "M0," + a + "V-" + a);
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-ne": {
          n: 43,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2);
            return Cr(r, t, "M" + a + ",-" + a + "L-" + a + "," + a);
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-nw": {
          n: 44,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2);
            return Cr(r, t, "M" + a + "," + a + "L-" + a + ",-" + a);
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "arrow-up": {
          n: 45,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2),
              n = Xe(e * 2, 2);
            return Cr(r, t, "M0,0L-" + a + "," + n + "H" + a + "Z");
          },
          backoff: 1,
          noDot: !0
        },
        "arrow-down": {
          n: 46,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2),
              n = Xe(e * 2, 2);
            return Cr(r, t, "M0,0L-" + a + ",-" + n + "H" + a + "Z");
          },
          noDot: !0
        },
        "arrow-left": {
          n: 47,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 2, 2),
              n = Xe(e, 2);
            return Cr(r, t, "M0,0L" + a + ",-" + n + "V" + n + "Z");
          },
          noDot: !0
        },
        "arrow-right": {
          n: 48,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 2, 2),
              n = Xe(e, 2);
            return Cr(r, t, "M0,0L-" + a + ",-" + n + "V" + n + "Z");
          },
          noDot: !0
        },
        "arrow-bar-up": {
          n: 49,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2),
              n = Xe(e * 2, 2);
            return Cr(r, t, "M-" + a + ",0H" + a + "M0,0L-" + a + "," + n + "H" + a + "Z");
          },
          backoff: 1,
          needLine: !0,
          noDot: !0
        },
        "arrow-bar-down": {
          n: 50,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e, 2),
              n = Xe(e * 2, 2);
            return Cr(r, t, "M-" + a + ",0H" + a + "M0,0L-" + a + ",-" + n + "H" + a + "Z");
          },
          needLine: !0,
          noDot: !0
        },
        "arrow-bar-left": {
          n: 51,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 2, 2),
              n = Xe(e, 2);
            return Cr(r, t, "M0,-" + n + "V" + n + "M0,0L" + a + ",-" + n + "V" + n + "Z");
          },
          needLine: !0,
          noDot: !0
        },
        "arrow-bar-right": {
          n: 52,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = Xe(e * 2, 2),
              n = Xe(e, 2);
            return Cr(r, t, "M0,-" + n + "V" + n + "M0,0L-" + a + ",-" + n + "V" + n + "Z");
          },
          needLine: !0,
          noDot: !0
        },
        arrow: {
          n: 53,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = cm / 2.5,
              n = 2 * e * vm(a),
              i = 2 * e * hm(a);
            return Cr(r, t, "M0,0L" + -n + "," + i + "L" + n + "," + i + "Z");
          },
          backoff: .9,
          noDot: !0
        },
        "arrow-wide": {
          n: 54,
          f: function (e, r, t) {
            if (kr(r)) return Ar;
            var a = cm / 4,
              n = 2 * e * vm(a),
              i = 2 * e * hm(a);
            return Cr(r, t, "M0,0L" + -n + "," + i + "A " + 2 * e + "," + 2 * e + " 0 0 1 " + n + "," + i + "Z");
          },
          backoff: .4,
          noDot: !0
        }
      };
      function kr(e) {
        return e === null;
      }
      var p9, m9, y9, g9;
      function Cr(e, r, t) {
        if ((!e || e % 360 === 0) && !r) return t;
        if (y9 === e && g9 === r && p9 === t) return m9;
        y9 = e, g9 = r, p9 = t;
        function a(m, _) {
          var w = vm(m),
            T = hm(m),
            b = _[0],
            A = _[1] + (r || 0);
          return [b * w - A * T, b * T + A * w];
        }
        for (var n = e / 180 * cm, i = 0, l = 0, o = yU(t), s = "", u = 0; u < o.length; u++) {
          var f = o[u],
            v = f[0],
            h = i,
            d = l;
          if (v === "M" || v === "L") i = +f[1], l = +f[2];else if (v === "m" || v === "l") i += +f[1], l += +f[2];else if (v === "H") i = +f[1];else if (v === "h") i += +f[1];else if (v === "V") l = +f[1];else if (v === "v") l += +f[1];else if (v === "A") {
            i = +f[1], l = +f[2];
            var y = a(n, [+f[6], +f[7]]);
            f[6] = y[0], f[7] = y[1], f[3] = +f[3] + e;
          }
          (v === "H" || v === "V") && (v = "L"), (v === "h" || v === "v") && (v = "l"), (v === "m" || v === "l") && (i -= h, l -= d);
          var g = a(n, [i, l]);
          (v === "H" || v === "V") && (v = "L"), (v === "M" || v === "L" || v === "m" || v === "l") && (f[1] = g[0], f[2] = g[1]), f[0] = v, s += f[0] + f.slice(1).join(",");
        }
        return m9 = s, s;
      }
    });
    var tt = Z((Uoe, O9) => {
      "use strict";

      var Jt = Ir(),
        nt = He(),
        gU = nt.numberFormat,
        mo = Hr(),
        bm = bn(),
        s0 = gr(),
        pa = Er(),
        bU = sm(),
        of = nt.strTranslate,
        u0 = xa(),
        xU = fo(),
        _U = Da(),
        wU = _U.LINE_SPACING,
        q9 = bv().DESELECTDIM,
        TU = on(),
        MU = u9(),
        AU = bi().appendArrayPointValue,
        Qe = O9.exports = {};
      Qe.font = function (e, r) {
        var t = r.variant,
          a = r.style,
          n = r.weight,
          i = r.color,
          l = r.size,
          o = r.family,
          s = r.shadow,
          u = r.lineposition,
          f = r.textcase;
        o && e.style("font-family", o), l + 1 && e.style("font-size", l + "px"), i && e.call(pa.fill, i), n && e.style("font-weight", n), a && e.style("font-style", a), t && e.style("font-variant", t), f && e.style("text-transform", dm(CU(f))), s && e.style("text-shadow", s === "auto" ? u0.makeTextShadow(pa.contrast(i)) : dm(s)), u && e.style("text-decoration-line", dm(SU(u)));
      };
      function dm(e) {
        return e === "none" ? void 0 : e;
      }
      var kU = {
        normal: "none",
        lower: "lowercase",
        upper: "uppercase",
        "word caps": "capitalize"
      };
      function CU(e) {
        return kU[e];
      }
      function SU(e) {
        return e.replace("under", "underline").replace("over", "overline").replace("through", "line-through").split("+").join(" ");
      }
      Qe.setPosition = function (e, r, t) {
        e.attr("x", r).attr("y", t);
      };
      Qe.setSize = function (e, r, t) {
        e.attr("width", r).attr("height", t);
      };
      Qe.setRect = function (e, r, t, a, n) {
        e.call(Qe.setPosition, r, t).call(Qe.setSize, a, n);
      };
      Qe.translatePoint = function (e, r, t, a) {
        var n = t.c2p(e.x),
          i = a.c2p(e.y);
        if (mo(n) && mo(i) && r.node()) r.node().nodeName === "text" ? r.attr("x", n).attr("y", i) : r.attr("transform", of(n, i));else return !1;
        return !0;
      };
      Qe.translatePoints = function (e, r, t) {
        e.each(function (a) {
          var n = Jt.select(this);
          Qe.translatePoint(a, n, r, t);
        });
      };
      Qe.hideOutsideRangePoint = function (e, r, t, a, n, i) {
        r.attr("display", t.isPtWithinRange(e, n) && a.isPtWithinRange(e, i) ? null : "none");
      };
      Qe.hideOutsideRangePoints = function (e, r) {
        if (r._hasClipOnAxisFalse) {
          var t = r.xaxis,
            a = r.yaxis;
          e.each(function (n) {
            var i = n[0].trace,
              l = i.xcalendar,
              o = i.ycalendar,
              s = s0.traceIs(i, "bar-like") ? ".bartext" : ".point,.textpoint";
            e.selectAll(s).each(function (u) {
              Qe.hideOutsideRangePoint(u, Jt.select(this), t, a, l, o);
            });
          });
        }
      };
      Qe.crispRound = function (e, r, t) {
        return !r || !mo(r) ? t || 0 : e._context.staticPlot ? r : r < 1 ? 1 : Math.round(r);
      };
      Qe.singleLineStyle = function (e, r, t, a, n) {
        r.style("fill", "none");
        var i = (((e || [])[0] || {}).trace || {}).line || {},
          l = t || i.width || 0,
          o = n || i.dash || "";
        pa.stroke(r, a || i.color), Qe.dashLine(r, o, l);
      };
      Qe.lineGroupStyle = function (e, r, t, a) {
        e.style("fill", "none").each(function (n) {
          var i = (((n || [])[0] || {}).trace || {}).line || {},
            l = r || i.width || 0,
            o = a || i.dash || "";
          Jt.select(this).call(pa.stroke, t || i.color).call(Qe.dashLine, o, l);
        });
      };
      Qe.dashLine = function (e, r, t) {
        t = +t || 0, r = Qe.dashStyle(r, t), e.style({
          "stroke-dasharray": r,
          "stroke-width": t + "px"
        });
      };
      Qe.dashStyle = function (e, r) {
        r = +r || 1;
        var t = Math.max(r, 3);
        return e === "solid" ? e = "" : e === "dot" ? e = t + "px," + t + "px" : e === "dash" ? e = 3 * t + "px," + 3 * t + "px" : e === "longdash" ? e = 5 * t + "px," + 5 * t + "px" : e === "dashdot" ? e = 3 * t + "px," + t + "px," + t + "px," + t + "px" : e === "longdashdot" && (e = 5 * t + "px," + 2 * t + "px," + t + "px," + 2 * t + "px"), e;
      };
      function D9(e, r, t, a) {
        var n = r.fillpattern,
          i = r.fillgradient,
          l = n && Qe.getPatternAttr(n.shape, 0, "");
        if (l) {
          var o = Qe.getPatternAttr(n.bgcolor, 0, null),
            s = Qe.getPatternAttr(n.fgcolor, 0, null),
            u = n.fgopacity,
            f = Qe.getPatternAttr(n.size, 0, 8),
            v = Qe.getPatternAttr(n.solidity, 0, .3),
            h = r.uid;
          Qe.pattern(e, "point", t, h, l, f, v, void 0, n.fillmode, o, s, u);
        } else if (i && i.type !== "none") {
          var d = i.type,
            y = "scatterfill-" + r.uid;
          if (a && (y = "legendfill-" + r.uid), !a && (i.start !== void 0 || i.stop !== void 0)) {
            var g, m;
            d === "horizontal" ? (g = {
              x: i.start,
              y: 0
            }, m = {
              x: i.stop,
              y: 0
            }) : d === "vertical" && (g = {
              x: 0,
              y: i.start
            }, m = {
              x: 0,
              y: i.stop
            }), g.x = r._xA.c2p(g.x === void 0 ? r._extremes.x.min[0].val : g.x, !0), g.y = r._yA.c2p(g.y === void 0 ? r._extremes.y.min[0].val : g.y, !0), m.x = r._xA.c2p(m.x === void 0 ? r._extremes.x.max[0].val : m.x, !0), m.y = r._yA.c2p(m.y === void 0 ? r._extremes.y.max[0].val : m.y, !0), e.call(R9, t, y, "linear", i.colorscale, "fill", g, m, !0, !1);
          } else d === "horizontal" && (d = d + "reversed"), e.call(Qe.gradient, t, y, d, i.colorscale, "fill");
        } else r.fillcolor && e.call(pa.fill, r.fillcolor);
      }
      Qe.singleFillStyle = function (e, r) {
        var t = Jt.select(e.node()),
          a = t.data(),
          n = ((a[0] || [])[0] || {}).trace || {};
        D9(e, n, r, !1);
      };
      Qe.fillGroupStyle = function (e, r, t) {
        e.style("stroke-width", 0).each(function (a) {
          var n = Jt.select(this);
          a[0].trace && D9(n, a[0].trace, r, t);
        });
      };
      var _9 = x9();
      Qe.symbolNames = [];
      Qe.symbolFuncs = [];
      Qe.symbolBackOffs = [];
      Qe.symbolNeedLines = {};
      Qe.symbolNoDot = {};
      Qe.symbolNoFill = {};
      Qe.symbolList = [];
      Object.keys(_9).forEach(function (e) {
        var r = _9[e],
          t = r.n;
        Qe.symbolList.push(t, String(t), e, t + 100, String(t + 100), e + "-open"), Qe.symbolNames[t] = e, Qe.symbolFuncs[t] = r.f, Qe.symbolBackOffs[t] = r.backoff || 0, r.needLine && (Qe.symbolNeedLines[t] = !0), r.noDot ? Qe.symbolNoDot[t] = !0 : Qe.symbolList.push(t + 200, String(t + 200), e + "-dot", t + 300, String(t + 300), e + "-open-dot"), r.noFill && (Qe.symbolNoFill[t] = !0);
      });
      var LU = Qe.symbolNames.length,
        qU = "M0,0.5L0.5,0L0,-0.5L-0.5,0Z";
      Qe.symbolNumber = function (e) {
        if (mo(e)) e = +e;else if (typeof e == "string") {
          var r = 0;
          e.indexOf("-open") > 0 && (r = 100, e = e.replace("-open", "")), e.indexOf("-dot") > 0 && (r += 200, e = e.replace("-dot", "")), e = Qe.symbolNames.indexOf(e), e >= 0 && (e += r);
        }
        return e % 100 >= LU || e >= 400 ? 0 : Math.floor(Math.max(e, 0));
      };
      function E9(e, r, t, a) {
        var n = e % 100;
        return Qe.symbolFuncs[n](r, t, a) + (e >= 200 ? qU : "");
      }
      var w9 = gU("~f"),
        P9 = {
          radial: {
            type: "radial"
          },
          radialreversed: {
            type: "radial",
            reversed: !0
          },
          horizontal: {
            type: "linear",
            start: {
              x: 1,
              y: 0
            },
            stop: {
              x: 0,
              y: 0
            }
          },
          horizontalreversed: {
            type: "linear",
            start: {
              x: 1,
              y: 0
            },
            stop: {
              x: 0,
              y: 0
            },
            reversed: !0
          },
          vertical: {
            type: "linear",
            start: {
              x: 0,
              y: 1
            },
            stop: {
              x: 0,
              y: 0
            }
          },
          verticalreversed: {
            type: "linear",
            start: {
              x: 0,
              y: 1
            },
            stop: {
              x: 0,
              y: 0
            },
            reversed: !0
          }
        };
      Qe.gradient = function (e, r, t, a, n, i) {
        var l = P9[a];
        return R9(e, r, t, l.type, n, i, l.start, l.stop, !1, l.reversed);
      };
      function R9(e, r, t, a, n, i, l, o, s, u) {
        var f = n.length,
          v;
        a === "linear" ? v = {
          node: "linearGradient",
          attrs: {
            x1: l.x,
            y1: l.y,
            x2: o.x,
            y2: o.y,
            gradientUnits: s ? "userSpaceOnUse" : "objectBoundingBox"
          },
          reversed: u
        } : a === "radial" && (v = {
          node: "radialGradient",
          reversed: u
        });
        for (var h = new Array(f), d = 0; d < f; d++) v.reversed ? h[f - 1 - d] = [w9((1 - n[d][0]) * 100), n[d][1]] : h[d] = [w9(n[d][0] * 100), n[d][1]];
        var y = r._fullLayout,
          g = "g" + y._uid + "-" + t,
          m = y._defs.select(".gradients").selectAll("#" + g).data([a + h.join(";")], nt.identity);
        m.exit().remove(), m.enter().append(v.node).each(function () {
          var _ = Jt.select(this);
          v.attrs && _.attr(v.attrs), _.attr("id", g);
          var w = _.selectAll("stop").data(h);
          w.exit().remove(), w.enter().append("stop"), w.each(function (T) {
            var b = bm(T[1]);
            Jt.select(this).attr({
              offset: T[0] + "%",
              "stop-color": pa.tinyRGB(b),
              "stop-opacity": b.getAlpha()
            });
          });
        }), e.style(i, xm(g, r)).style(i + "-opacity", null), e.classed("gradient_filled", !0);
      }
      Qe.pattern = function (e, r, t, a, n, i, l, o, s, u, f, v) {
        var h = r === "legend";
        o && (s === "overlay" ? (u = o, f = pa.contrast(u)) : (u = void 0, f = o));
        var d = t._fullLayout,
          y = "p" + d._uid + "-" + a,
          g,
          m,
          _ = function (H, O, J, X, B) {
            return X + (B - X) * (H - O) / (J - O);
          },
          w,
          T,
          b,
          A,
          S = {},
          k = bm(f),
          q = pa.tinyRGB(k),
          D = k.getAlpha(),
          R = v * D;
        switch (n) {
          case "/":
            g = i * Math.sqrt(2), m = i * Math.sqrt(2), w = "M-" + g / 4 + "," + m / 4 + "l" + g / 2 + ",-" + m / 2 + "M0," + m + "L" + g + ",0M" + g / 4 * 3 + "," + m / 4 * 5 + "l" + g / 2 + ",-" + m / 2, T = l * i, A = "path", S = {
              d: w,
              opacity: R,
              stroke: q,
              "stroke-width": T + "px"
            };
            break;
          case "\\":
            g = i * Math.sqrt(2), m = i * Math.sqrt(2), w = "M" + g / 4 * 3 + ",-" + m / 4 + "l" + g / 2 + "," + m / 2 + "M0,0L" + g + "," + m + "M-" + g / 4 + "," + m / 4 * 3 + "l" + g / 2 + "," + m / 2, T = l * i, A = "path", S = {
              d: w,
              opacity: R,
              stroke: q,
              "stroke-width": T + "px"
            };
            break;
          case "x":
            g = i * Math.sqrt(2), m = i * Math.sqrt(2), w = "M-" + g / 4 + "," + m / 4 + "l" + g / 2 + ",-" + m / 2 + "M0," + m + "L" + g + ",0M" + g / 4 * 3 + "," + m / 4 * 5 + "l" + g / 2 + ",-" + m / 2 + "M" + g / 4 * 3 + ",-" + m / 4 + "l" + g / 2 + "," + m / 2 + "M0,0L" + g + "," + m + "M-" + g / 4 + "," + m / 4 * 3 + "l" + g / 2 + "," + m / 2, T = i - i * Math.sqrt(1 - l), A = "path", S = {
              d: w,
              opacity: R,
              stroke: q,
              "stroke-width": T + "px"
            };
            break;
          case "|":
            g = i, m = i, A = "path", w = "M" + g / 2 + ",0L" + g / 2 + "," + m, T = l * i, A = "path", S = {
              d: w,
              opacity: R,
              stroke: q,
              "stroke-width": T + "px"
            };
            break;
          case "-":
            g = i, m = i, A = "path", w = "M0," + m / 2 + "L" + g + "," + m / 2, T = l * i, A = "path", S = {
              d: w,
              opacity: R,
              stroke: q,
              "stroke-width": T + "px"
            };
            break;
          case "+":
            g = i, m = i, A = "path", w = "M" + g / 2 + ",0L" + g / 2 + "," + m + "M0," + m / 2 + "L" + g + "," + m / 2, T = i - i * Math.sqrt(1 - l), A = "path", S = {
              d: w,
              opacity: R,
              stroke: q,
              "stroke-width": T + "px"
            };
            break;
          case ".":
            g = i, m = i, l < Math.PI / 4 ? b = Math.sqrt(l * i * i / Math.PI) : b = _(l, Math.PI / 4, 1, i / 2, i / Math.sqrt(2)), A = "circle", S = {
              cx: g / 2,
              cy: m / 2,
              r: b,
              opacity: R,
              fill: q
            };
            break;
        }
        var z = [n || "noSh", u || "noBg", f || "noFg", i, l].join(";"),
          N = d._defs.select(".patterns").selectAll("#" + y).data([z], nt.identity);
        N.exit().remove(), N.enter().append("pattern").each(function () {
          var H = Jt.select(this);
          if (H.attr({
            id: y,
            width: g + "px",
            height: m + "px",
            patternUnits: "userSpaceOnUse",
            patternTransform: h ? "scale(0.8)" : ""
          }), u) {
            var O = bm(u),
              J = pa.tinyRGB(O),
              X = O.getAlpha(),
              B = H.selectAll("rect").data([0]);
            B.exit().remove(), B.enter().append("rect").attr({
              width: g + "px",
              height: m + "px",
              fill: J,
              "fill-opacity": X
            });
          }
          var I = H.selectAll(A).data([0]);
          I.exit().remove(), I.enter().append(A).attr(S);
        }), e.style("fill", xm(y, t)).style("fill-opacity", null), e.classed("pattern_filled", !0);
      };
      Qe.initGradients = function (e) {
        var r = e._fullLayout,
          t = nt.ensureSingle(r._defs, "g", "gradients");
        t.selectAll("linearGradient,radialGradient").remove(), Jt.select(e).selectAll(".gradient_filled").classed("gradient_filled", !1);
      };
      Qe.initPatterns = function (e) {
        var r = e._fullLayout,
          t = nt.ensureSingle(r._defs, "g", "patterns");
        t.selectAll("pattern").remove(), Jt.select(e).selectAll(".pattern_filled").classed("pattern_filled", !1);
      };
      Qe.getPatternAttr = function (e, r, t) {
        return e && nt.isArrayOrTypedArray(e) ? r < e.length ? e[r] : t : e;
      };
      Qe.pointStyle = function (e, r, t, a) {
        if (e.size()) {
          var n = Qe.makePointStyleFns(r);
          e.each(function (i) {
            Qe.singlePointStyle(i, Jt.select(this), r, n, t, a);
          });
        }
      };
      Qe.singlePointStyle = function (e, r, t, a, n, i) {
        var l = t.marker,
          o = l.line;
        if (i && i.i >= 0 && e.i === void 0 && (e.i = i.i), r.style("opacity", a.selectedOpacityFn ? a.selectedOpacityFn(e) : e.mo === void 0 ? l.opacity : e.mo), a.ms2mrc) {
          var s;
          e.ms === "various" || l.size === "various" ? s = 3 : s = a.ms2mrc(e.ms), e.mrc = s, a.selectedSizeFn && (s = e.mrc = a.selectedSizeFn(e));
          var u = Qe.symbolNumber(e.mx || l.symbol) || 0;
          e.om = u % 200 >= 100;
          var f = wm(e, t),
            v = _m(e, t);
          r.attr("d", E9(u, s, f, v));
        }
        var h = !1,
          d,
          y,
          g;
        if (e.so) g = o.outlierwidth, y = o.outliercolor, d = l.outliercolor;else {
          var m = (o || {}).width;
          g = (e.mlw + 1 || m + 1 || (e.trace ? (e.trace.marker.line || {}).width : 0) + 1) - 1 || 0, "mlc" in e ? y = e.mlcc = a.lineScale(e.mlc) : nt.isArrayOrTypedArray(o.color) ? y = pa.defaultLine : y = o.color, nt.isArrayOrTypedArray(l.color) && (d = pa.defaultLine, h = !0), "mc" in e ? d = e.mcc = a.markerScale(e.mc) : d = l.color || l.colors || "rgba(0,0,0,0)", a.selectedColorFn && (d = a.selectedColorFn(e));
        }
        if (e.om) r.call(pa.stroke, d).style({
          "stroke-width": (g || 1) + "px",
          fill: "none"
        });else {
          r.style("stroke-width", (e.isBlank ? 0 : g) + "px");
          var _ = l.gradient,
            w = e.mgt;
          w ? h = !0 : w = _ && _.type, nt.isArrayOrTypedArray(w) && (w = w[0], P9[w] || (w = 0));
          var T = l.pattern,
            b = T && Qe.getPatternAttr(T.shape, e.i, "");
          if (w && w !== "none") {
            var A = e.mgc;
            A ? h = !0 : A = _.color;
            var S = t.uid;
            h && (S += "-" + e.i), Qe.gradient(r, n, S, w, [[0, A], [1, d]], "fill");
          } else if (b) {
            var k = !1,
              q = T.fgcolor;
            !q && i && i.color && (q = i.color, k = !0);
            var D = Qe.getPatternAttr(q, e.i, i && i.color || null),
              R = Qe.getPatternAttr(T.bgcolor, e.i, null),
              z = T.fgopacity,
              N = Qe.getPatternAttr(T.size, e.i, 8),
              H = Qe.getPatternAttr(T.solidity, e.i, .3);
            k = k || e.mcc || nt.isArrayOrTypedArray(T.shape) || nt.isArrayOrTypedArray(T.bgcolor) || nt.isArrayOrTypedArray(T.fgcolor) || nt.isArrayOrTypedArray(T.size) || nt.isArrayOrTypedArray(T.solidity);
            var O = t.uid;
            k && (O += "-" + e.i), Qe.pattern(r, "point", n, O, b, N, H, e.mcc, T.fillmode, R, D, z);
          } else nt.isArrayOrTypedArray(d) ? pa.fill(r, d[e.i]) : pa.fill(r, d);
          g && pa.stroke(r, y);
        }
      };
      Qe.makePointStyleFns = function (e) {
        var r = {},
          t = e.marker;
        return r.markerScale = Qe.tryColorscale(t, ""), r.lineScale = Qe.tryColorscale(t, "line"), s0.traceIs(e, "symbols") && (r.ms2mrc = TU.isBubble(e) ? MU(e) : function () {
          return (t.size || 6) / 2;
        }), e.selectedpoints && nt.extendFlat(r, Qe.makeSelectedPointStyleFns(e)), r;
      };
      Qe.makeSelectedPointStyleFns = function (e) {
        var r = {},
          t = e.selected || {},
          a = e.unselected || {},
          n = e.marker || {},
          i = t.marker || {},
          l = a.marker || {},
          o = n.opacity,
          s = i.opacity,
          u = l.opacity,
          f = s !== void 0,
          v = u !== void 0;
        (nt.isArrayOrTypedArray(o) || f || v) && (r.selectedOpacityFn = function (b) {
          var A = b.mo === void 0 ? n.opacity : b.mo;
          return b.selected ? f ? s : A : v ? u : q9 * A;
        });
        var h = n.color,
          d = i.color,
          y = l.color;
        (d || y) && (r.selectedColorFn = function (b) {
          var A = b.mcc || h;
          return b.selected ? d || A : y || A;
        });
        var g = n.size,
          m = i.size,
          _ = l.size,
          w = m !== void 0,
          T = _ !== void 0;
        return s0.traceIs(e, "symbols") && (w || T) && (r.selectedSizeFn = function (b) {
          var A = b.mrc || g / 2;
          return b.selected ? w ? m / 2 : A : T ? _ / 2 : A;
        }), r;
      };
      Qe.makeSelectedTextStyleFns = function (e) {
        var r = {},
          t = e.selected || {},
          a = e.unselected || {},
          n = e.textfont || {},
          i = t.textfont || {},
          l = a.textfont || {},
          o = n.color,
          s = i.color,
          u = l.color;
        return r.selectedTextColorFn = function (f) {
          var v = f.tc || o;
          return f.selected ? s || v : u || (s ? v : pa.addOpacity(v, q9));
        }, r;
      };
      Qe.selectedPointStyle = function (e, r) {
        if (!(!e.size() || !r.selectedpoints)) {
          var t = Qe.makeSelectedPointStyleFns(r),
            a = r.marker || {},
            n = [];
          t.selectedOpacityFn && n.push(function (i, l) {
            i.style("opacity", t.selectedOpacityFn(l));
          }), t.selectedColorFn && n.push(function (i, l) {
            pa.fill(i, t.selectedColorFn(l));
          }), t.selectedSizeFn && n.push(function (i, l) {
            var o = l.mx || a.symbol || 0,
              s = t.selectedSizeFn(l);
            i.attr("d", E9(Qe.symbolNumber(o), s, wm(l, r), _m(l, r))), l.mrc2 = s;
          }), n.length && e.each(function (i) {
            for (var l = Jt.select(this), o = 0; o < n.length; o++) n[o](l, i);
          });
        }
      };
      Qe.tryColorscale = function (e, r) {
        var t = r ? nt.nestedProperty(e, r).get() : e;
        if (t) {
          var a = t.color;
          if ((t.colorscale || t._colorAx) && nt.isArrayOrTypedArray(a)) return bU.makeColorScaleFuncFromTrace(t);
        }
        return nt.identity;
      };
      var pm = {
        start: 1,
        end: -1,
        middle: 0,
        bottom: 1,
        top: -1
      };
      function z9(e, r, t, a, n) {
        var i = Jt.select(e.node().parentNode),
          l = r.indexOf("top") !== -1 ? "top" : r.indexOf("bottom") !== -1 ? "bottom" : "middle",
          o = r.indexOf("left") !== -1 ? "end" : r.indexOf("right") !== -1 ? "start" : "middle",
          s = a ? a / .8 + 1 : 0,
          u = (u0.lineCount(e) - 1) * wU + 1,
          f = pm[o] * s,
          v = t * .75 + pm[l] * s + (pm[l] - 1) * u * t / 2;
        e.attr("text-anchor", o), n || i.attr("transform", of(f, v));
      }
      function N9(e, r) {
        var t = e.ts || r.textfont.size;
        return mo(t) && t > 0 ? t : 0;
      }
      Qe.textPointStyle = function (e, r, t) {
        if (e.size()) {
          var a;
          if (r.selectedpoints) {
            var n = Qe.makeSelectedTextStyleFns(r);
            a = n.selectedTextColorFn;
          }
          var i = r.texttemplate,
            l = t._fullLayout;
          e.each(function (o) {
            var s = Jt.select(this),
              u = i ? nt.extractOption(o, r, "txt", "texttemplate") : nt.extractOption(o, r, "tx", "text");
            if (!u && u !== 0) {
              s.remove();
              return;
            }
            if (i) {
              var f = r._module.formatLabels,
                v = f ? f(o, r, l) : {},
                h = {};
              AU(h, r, o.i);
              var d = r._meta || {};
              u = nt.texttemplateString(u, v, l._d3locale, h, o, d);
            }
            var y = o.tp || r.textposition,
              g = N9(o, r),
              m = a ? a(o) : o.tc || r.textfont.color;
            s.call(Qe.font, {
              family: o.tf || r.textfont.family,
              weight: o.tw || r.textfont.weight,
              style: o.ty || r.textfont.style,
              variant: o.tv || r.textfont.variant,
              textcase: o.tC || r.textfont.textcase,
              lineposition: o.tE || r.textfont.lineposition,
              shadow: o.tS || r.textfont.shadow,
              size: g,
              color: m
            }).text(u).call(u0.convertToTspans, t).call(z9, y, g, o.mrc);
          });
        }
      };
      Qe.selectedTextStyle = function (e, r) {
        if (!(!e.size() || !r.selectedpoints)) {
          var t = Qe.makeSelectedTextStyleFns(r);
          e.each(function (a) {
            var n = Jt.select(this),
              i = t.selectedTextColorFn(a),
              l = a.tp || r.textposition,
              o = N9(a, r);
            pa.fill(n, i);
            var s = s0.traceIs(r, "bar-like");
            z9(n, l, o, a.mrc2 || a.mrc, s);
          });
        }
      };
      var T9 = .5;
      Qe.smoothopen = function (e, r) {
        if (e.length < 3) return "M" + e.join("L");
        var t = "M" + e[0],
          a = [],
          n;
        for (n = 1; n < e.length - 1; n++) a.push(o0(e[n - 1], e[n], e[n + 1], r));
        for (t += "Q" + a[0][0] + " " + e[1], n = 2; n < e.length - 1; n++) t += "C" + a[n - 2][1] + " " + a[n - 1][0] + " " + e[n];
        return t += "Q" + a[e.length - 3][1] + " " + e[e.length - 1], t;
      };
      Qe.smoothclosed = function (e, r) {
        if (e.length < 3) return "M" + e.join("L") + "Z";
        var t = "M" + e[0],
          a = e.length - 1,
          n = [o0(e[a], e[0], e[1], r)],
          i;
        for (i = 1; i < a; i++) n.push(o0(e[i - 1], e[i], e[i + 1], r));
        for (n.push(o0(e[a - 1], e[a], e[0], r)), i = 1; i <= a; i++) t += "C" + n[i - 1][1] + " " + n[i][0] + " " + e[i];
        return t += "C" + n[a][1] + " " + n[0][0] + " " + e[0] + "Z", t;
      };
      var F9, I9;
      function Ds(e, r, t) {
        return t && (e = H9(e)), r ? po(e[1]) : ho(e[0]);
      }
      function ho(e) {
        var r = Jt.round(e, 2);
        return F9 = r, r;
      }
      function po(e) {
        var r = Jt.round(e, 2);
        return I9 = r, r;
      }
      function o0(e, r, t, a) {
        var n = e[0] - r[0],
          i = e[1] - r[1],
          l = t[0] - r[0],
          o = t[1] - r[1],
          s = Math.pow(n * n + i * i, T9 / 2),
          u = Math.pow(l * l + o * o, T9 / 2),
          f = (u * u * n - s * s * l) * a,
          v = (u * u * i - s * s * o) * a,
          h = 3 * u * (s + u),
          d = 3 * s * (s + u);
        return [[ho(r[0] + (h && f / h)), po(r[1] + (h && v / h))], [ho(r[0] - (d && f / d)), po(r[1] - (d && v / d))]];
      }
      var DU = {
          hv: function (e, r, t) {
            return "H" + ho(r[0]) + "V" + Ds(r, 1, t);
          },
          vh: function (e, r, t) {
            return "V" + po(r[1]) + "H" + Ds(r, 0, t);
          },
          hvh: function (e, r, t) {
            return "H" + ho((e[0] + r[0]) / 2) + "V" + po(r[1]) + "H" + Ds(r, 0, t);
          },
          vhv: function (e, r, t) {
            return "V" + po((e[1] + r[1]) / 2) + "H" + ho(r[0]) + "V" + Ds(r, 1, t);
          }
        },
        EU = function (e, r, t) {
          return "L" + Ds(r, 0, t) + "," + Ds(r, 1, t);
        };
      Qe.steps = function (e) {
        var r = DU[e] || EU;
        return function (t) {
          for (var a = "M" + ho(t[0][0]) + "," + po(t[0][1]), n = t.length, i = 1; i < n; i++) a += r(t[i - 1], t[i], i === n - 1);
          return a;
        };
      };
      function H9(e, r) {
        var t = e.backoff,
          a = e.trace,
          n = e.d,
          i = e.i;
        if (t && a && a.marker && a.marker.angle % 360 === 0 && a.line && a.line.shape !== "spline") {
          var l = nt.isArrayOrTypedArray(t),
            o = e,
            s = r ? r[0] : F9 || 0,
            u = r ? r[1] : I9 || 0,
            f = o[0],
            v = o[1],
            h = f - s,
            d = v - u,
            y = Math.atan2(d, h),
            g = l ? t[i] : t;
          if (g === "auto") {
            var m = o.i;
            a.type === "scatter" && m--;
            var _ = o.marker,
              w = _.symbol;
            nt.isArrayOrTypedArray(w) && (w = w[m]);
            var T = _.size;
            nt.isArrayOrTypedArray(T) && (T = T[m]), g = _ ? Qe.symbolBackOffs[Qe.symbolNumber(w)] * T : 0, g += Qe.getMarkerStandoff(n[m], a) || 0;
          }
          var b = f - g * Math.cos(y),
            A = v - g * Math.sin(y);
          (b <= f && b >= s || b >= f && b <= s) && (A <= v && A >= u || A >= v && A <= u) && (e = [b, A]);
        }
        return e;
      }
      Qe.applyBackoff = H9;
      Qe.makeTester = function () {
        var e = nt.ensureSingleById(Jt.select("body"), "svg", "js-plotly-tester", function (t) {
            t.attr(xU.svgAttrs).style({
              position: "absolute",
              left: "-10000px",
              top: "-10000px",
              width: "9000px",
              height: "9000px",
              "z-index": "1"
            });
          }),
          r = nt.ensureSingle(e, "path", "js-reference-point", function (t) {
            t.attr("d", "M0,0H1V1H0Z").style({
              "stroke-width": 0,
              fill: "black"
            });
          });
        Qe.tester = e, Qe.testref = r;
      };
      Qe.savedBBoxes = {};
      var mm = 0,
        PU = 1e4;
      Qe.bBox = function (e, r, t) {
        t || (t = M9(e));
        var a;
        if (t) {
          if (a = Qe.savedBBoxes[t], a) return nt.extendFlat({}, a);
        } else if (e.childNodes.length === 1) {
          var n = e.childNodes[0];
          if (t = M9(n), t) {
            var i = +n.getAttribute("x") || 0,
              l = +n.getAttribute("y") || 0,
              o = n.getAttribute("transform");
            if (!o) {
              var s = Qe.bBox(n, !1, t);
              return i && (s.left += i, s.right += i), l && (s.top += l, s.bottom += l), s;
            }
            if (t += "~" + i + "~" + l + "~" + o, a = Qe.savedBBoxes[t], a) return nt.extendFlat({}, a);
          }
        }
        var u, f;
        r ? u = e : (f = Qe.tester.node(), u = e.cloneNode(!0), f.appendChild(u)), Jt.select(u).attr("transform", null).call(u0.positionText, 0, 0);
        var v = u.getBoundingClientRect(),
          h = Qe.testref.node().getBoundingClientRect();
        r || f.removeChild(u);
        var d = {
          height: v.height,
          width: v.width,
          left: v.left - h.left,
          top: v.top - h.top,
          right: v.right - h.left,
          bottom: v.bottom - h.top
        };
        return mm >= PU && (Qe.savedBBoxes = {}, mm = 0), t && (Qe.savedBBoxes[t] = d), mm++, nt.extendFlat({}, d);
      };
      function M9(e) {
        var r = e.getAttribute("data-unformatted");
        if (r !== null) return r + e.getAttribute("data-math") + e.getAttribute("text-anchor") + e.getAttribute("style");
      }
      Qe.setClipUrl = function (e, r, t) {
        e.attr("clip-path", xm(r, t));
      };
      function xm(e, r) {
        if (!e) return null;
        var t = r._context,
          a = t._exportedPlot ? "" : t._baseUrl || "";
        return a ? "url('" + a + "#" + e + "')" : "url(#" + e + ")";
      }
      Qe.getTranslate = function (e) {
        var r = /.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/,
          t = e.attr ? "attr" : "getAttribute",
          a = e[t]("transform") || "",
          n = a.replace(r, function (i, l, o) {
            return [l, o].join(" ");
          }).split(" ");
        return {
          x: +n[0] || 0,
          y: +n[1] || 0
        };
      };
      Qe.setTranslate = function (e, r, t) {
        var a = /(\btranslate\(.*?\);?)/,
          n = e.attr ? "attr" : "getAttribute",
          i = e.attr ? "attr" : "setAttribute",
          l = e[n]("transform") || "";
        return r = r || 0, t = t || 0, l = l.replace(a, "").trim(), l += of(r, t), l = l.trim(), e[i]("transform", l), l;
      };
      Qe.getScale = function (e) {
        var r = /.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/,
          t = e.attr ? "attr" : "getAttribute",
          a = e[t]("transform") || "",
          n = a.replace(r, function (i, l, o) {
            return [l, o].join(" ");
          }).split(" ");
        return {
          x: +n[0] || 1,
          y: +n[1] || 1
        };
      };
      Qe.setScale = function (e, r, t) {
        var a = /(\bscale\(.*?\);?)/,
          n = e.attr ? "attr" : "getAttribute",
          i = e.attr ? "attr" : "setAttribute",
          l = e[n]("transform") || "";
        return r = r || 1, t = t || 1, l = l.replace(a, "").trim(), l += "scale(" + r + "," + t + ")", l = l.trim(), e[i]("transform", l), l;
      };
      var RU = /\s*sc.*/;
      Qe.setPointGroupScale = function (e, r, t) {
        if (r = r || 1, t = t || 1, !!e) {
          var a = r === 1 && t === 1 ? "" : "scale(" + r + "," + t + ")";
          e.each(function () {
            var n = (this.getAttribute("transform") || "").replace(RU, "");
            n += a, n = n.trim(), this.setAttribute("transform", n);
          });
        }
      };
      var zU = /translate\([^)]*\)\s*$/;
      Qe.setTextPointsScale = function (e, r, t) {
        e && e.each(function () {
          var a,
            n = Jt.select(this),
            i = n.select("text");
          if (i.node()) {
            var l = parseFloat(i.attr("x") || 0),
              o = parseFloat(i.attr("y") || 0),
              s = (n.attr("transform") || "").match(zU);
            r === 1 && t === 1 ? a = [] : a = [of(l, o), "scale(" + r + "," + t + ")", of(-l, -o)], s && a.push(s), n.attr("transform", a.join(""));
          }
        });
      };
      function _m(e, r) {
        var t;
        return e && (t = e.mf), t === void 0 && (t = r.marker && r.marker.standoff || 0), !r._geo && !r._xA ? -t : t;
      }
      Qe.getMarkerStandoff = _m;
      var lf = Math.atan2,
        vo = Math.cos,
        Es = Math.sin;
      function A9(e, r) {
        var t = r[0],
          a = r[1];
        return [t * vo(e) - a * Es(e), t * Es(e) + a * vo(e)];
      }
      var k9, C9, S9, L9, ym, gm;
      function wm(e, r) {
        var t = e.ma;
        t === void 0 && (t = r.marker.angle, (!t || nt.isArrayOrTypedArray(t)) && (t = 0));
        var a,
          n,
          i = r.marker.angleref;
        if (i === "previous" || i === "north") {
          if (r._geo) {
            var l = r._geo.project(e.lonlat);
            a = l[0], n = l[1];
          } else {
            var o = r._xA,
              s = r._yA;
            if (o && s) a = o.c2p(e.x), n = s.c2p(e.y);else return 90;
          }
          if (r._geo) {
            var u = e.lonlat[0],
              f = e.lonlat[1],
              v = r._geo.project([u, f + 1e-5]),
              h = r._geo.project([u + 1e-5, f]),
              d = lf(h[1] - n, h[0] - a),
              y = lf(v[1] - n, v[0] - a),
              g;
            if (i === "north") g = t / 180 * Math.PI;else if (i === "previous") {
              var m = u / 180 * Math.PI,
                _ = f / 180 * Math.PI,
                w = k9 / 180 * Math.PI,
                T = C9 / 180 * Math.PI,
                b = w - m,
                A = vo(T) * Es(b),
                S = Es(T) * vo(_) - vo(T) * Es(_) * vo(b);
              g = -lf(A, S) - Math.PI, k9 = u, C9 = f;
            }
            var k = A9(d, [vo(g), 0]),
              q = A9(y, [Es(g), 0]);
            t = lf(k[1] + q[1], k[0] + q[0]) / Math.PI * 180, i === "previous" && !(gm === r.uid && e.i === ym + 1) && (t = null);
          }
          if (i === "previous" && !r._geo) if (gm === r.uid && e.i === ym + 1 && mo(a) && mo(n)) {
            var D = a - S9,
              R = n - L9,
              z = r.line && r.line.shape || "",
              N = z.slice(z.length - 1);
            N === "h" && (R = 0), N === "v" && (D = 0), t += lf(R, D) / Math.PI * 180 + 90;
          } else t = null;
        }
        return S9 = a, L9 = n, ym = e.i, gm = r.uid, t;
      }
      Qe.getMarkerAngle = wm;
    });
    var sf = Z((Goe, G9) => {
      "use strict";

      var Ps = Ir(),
        NU = Hr(),
        FU = Pt(),
        Tm = gr(),
        yo = He(),
        B9 = yo.strTranslate,
        f0 = tt(),
        c0 = Er(),
        Rs = xa(),
        Y9 = bv(),
        IU = Da().OPPOSITE_SIDE,
        U9 = / [XY][0-9]* /,
        Mm = 1.6,
        Am = 1.6;
      function HU(e, r, t) {
        var a = e._fullLayout,
          n = t.propContainer,
          i = t.propName,
          l = t.placeholder,
          o = t.traceIndex,
          s = t.avoid || {},
          u = t.attributes,
          f = t.transform,
          v = t.containerGroup,
          h = 1,
          d = n.title,
          y = (d && d.text ? d.text : "").trim(),
          g = !1,
          m = d && d.font ? d.font : {},
          _ = m.family,
          w = m.size,
          T = m.color,
          b = m.weight,
          A = m.style,
          S = m.variant,
          k = m.textcase,
          q = m.lineposition,
          D = m.shadow,
          R = t.subtitlePropName,
          z = !!R,
          N = t.subtitlePlaceholder,
          H = (n.title || {}).subtitle || {
            text: "",
            font: {}
          },
          O = H.text.trim(),
          J = !1,
          X = 1,
          B = H.font,
          I = B.family,
          V = B.size,
          K = B.color,
          Q = B.weight,
          ie = B.style,
          me = B.variant,
          pe = B.textcase,
          ge = B.lineposition,
          j = B.shadow,
          _e;
        i === "title.text" ? _e = "titleText" : i.indexOf("axis") !== -1 ? _e = "axisTitleText" : i.indexOf("colorbar" !== -1) && (_e = "colorbarTitleText");
        var se = e._context.edits[_e];
        function Se(Be, Ne) {
          return Be === void 0 || Ne === void 0 ? !1 : Be.replace(U9, " % ") === Ne.replace(U9, " % ");
        }
        y === "" ? h = 0 : Se(y, l) && (se || (y = ""), h = .2, g = !0), z && (O === "" ? X = 0 : Se(O, N) && (se || (O = ""), X = .2, J = !0)), t._meta ? y = yo.templateString(y, t._meta) : a._meta && (y = yo.templateString(y, a._meta));
        var ve = y || O || se,
          Ae;
        v || (v = yo.ensureSingle(a._infolayer, "g", "g-" + r), Ae = a._hColorbarMoveTitle);
        var Y = v.selectAll("text." + r).data(ve ? [0] : []);
        Y.enter().append("text"), Y.text(y).attr("class", r), Y.exit().remove();
        var re = null,
          U = r + "-subtitle",
          de = O || se;
        if (z && de && (re = v.selectAll("text." + U).data(de ? [0] : []), re.enter().append("text"), re.text(O).attr("class", U), re.exit().remove()), !ve) return v;
        function be(Be, Ne) {
          yo.syncOrAsync([ye, Fe], {
            title: Be,
            subtitle: Ne
          });
        }
        function ye(Be) {
          var Ne = Be.title,
            Ee = Be.subtitle,
            Je;
          !f && Ae && (f = {}), f ? (Je = "", f.rotate && (Je += "rotate(" + [f.rotate, u.x, u.y] + ")"), (f.offset || Ae) && (Je += B9(0, (f.offset || 0) - (Ae || 0)))) : Je = null, Ne.attr("transform", Je);
          function We(De) {
            if (De) {
              var Le = Ps.select(De.node().parentNode).select("." + U);
              if (!Le.empty()) {
                var Ye = De.node().getBBox();
                if (Ye.height) {
                  var Ze = Ye.y + Ye.height + Mm * V;
                  Le.attr("y", Ze);
                }
              }
            }
          }
          if (Ne.style("opacity", h * c0.opacity(T)).call(f0.font, {
            color: c0.rgb(T),
            size: Ps.round(w, 2),
            family: _,
            weight: b,
            style: A,
            variant: S,
            textcase: k,
            shadow: D,
            lineposition: q
          }).attr(u).call(Rs.convertToTspans, e, We), Ee) {
            var ne = v.select("." + r + "-math-group"),
              Me = Ne.node().getBBox(),
              Ce = ne.node() ? ne.node().getBBox() : void 0,
              cr = Ce ? Ce.y + Ce.height + Mm * V : Me.y + Me.height + Am * V,
              tr = yo.extendFlat({}, u, {
                y: cr
              });
            Ee.attr("transform", Je), Ee.style("opacity", X * c0.opacity(K)).call(f0.font, {
              color: c0.rgb(K),
              size: Ps.round(V, 2),
              family: I,
              weight: Q,
              style: ie,
              variant: me,
              textcase: pe,
              shadow: j,
              lineposition: ge
            }).attr(tr).call(Rs.convertToTspans, e);
          }
          return FU.previousPromises(e);
        }
        function Fe(Be) {
          var Ne = Be.title,
            Ee = Ps.select(Ne.node().parentNode);
          if (s && s.selection && s.side && y) {
            Ee.attr("transform", null);
            var Je = IU[s.side],
              We = s.side === "left" || s.side === "top" ? -1 : 1,
              ne = NU(s.pad) ? s.pad : 2,
              Me = f0.bBox(Ee.node()),
              Ce = {
                t: 0,
                b: 0,
                l: 0,
                r: 0
              },
              cr = e._fullLayout._reservedMargin;
            for (var tr in cr) for (var De in cr[tr]) {
              var Le = cr[tr][De];
              Ce[De] = Math.max(Ce[De], Le);
            }
            var Ye = {
                left: Ce.l,
                top: Ce.t,
                right: a.width - Ce.r,
                bottom: a.height - Ce.b
              },
              Ze = s.maxShift || We * (Ye[s.side] - Me[s.side]),
              Ue = 0;
            if (Ze < 0) Ue = Ze;else {
              var Oe = s.offsetLeft || 0,
                Ke = s.offsetTop || 0;
              Me.left -= Oe, Me.right -= Oe, Me.top -= Ke, Me.bottom -= Ke, s.selection.each(function () {
                var lr = f0.bBox(this);
                yo.bBoxIntersect(Me, lr, ne) && (Ue = Math.max(Ue, We * (lr[s.side] - Me[Je]) + ne));
              }), Ue = Math.min(Ze, Ue), n._titleScoot = Math.abs(Ue);
            }
            if (Ue > 0 || Ze < 0) {
              var fr = {
                left: [-Ue, 0],
                right: [Ue, 0],
                top: [0, -Ue],
                bottom: [0, Ue]
              }[s.side];
              Ee.attr("transform", B9(fr[0], fr[1]));
            }
          }
        }
        Y.call(be, re);
        function Re(Be, Ne) {
          Be.text(Ne).on("mouseover.opacity", function () {
            Ps.select(this).transition().duration(Y9.SHOW_PLACEHOLDER).style("opacity", 1);
          }).on("mouseout.opacity", function () {
            Ps.select(this).transition().duration(Y9.HIDE_PLACEHOLDER).style("opacity", 0);
          });
        }
        if (se && (y ? Y.on(".opacity", null) : (Re(Y, l), g = !0), Y.call(Rs.makeEditable, {
          gd: e
        }).on("edit", function (Be) {
          o !== void 0 ? Tm.call("_guiRestyle", e, i, Be, o) : Tm.call("_guiRelayout", e, i, Be);
        }).on("cancel", function () {
          this.text(this.attr("data-unformatted")).call(be);
        }).on("input", function (Be) {
          this.text(Be || " ").call(Rs.positionText, u.x, u.y);
        }), z)) {
          if (z && !y) {
            var Pe = Y.node().getBBox(),
              Ie = Pe.y + Pe.height + Am * V;
            re.attr("y", Ie);
          }
          O ? re.on(".opacity", null) : (Re(re, N), J = !0), re.call(Rs.makeEditable, {
            gd: e
          }).on("edit", function (Be) {
            Tm.call("_guiRelayout", e, "title.subtitle.text", Be);
          }).on("cancel", function () {
            this.text(this.attr("data-unformatted")).call(be);
          }).on("input", function (Be) {
            this.text(Be || " ").call(Rs.positionText, re.attr("x"), re.attr("y"));
          });
        }
        return Y.classed("js-placeholder", g), re && re.classed("js-placeholder", J), v;
      }
      G9.exports = {
        draw: HU,
        SUBTITLE_PADDING_EM: Am,
        SUBTITLE_PADDING_MATHJAX_EM: Mm
      };
    });
    var b0 = Z((Voe, J9) => {
      "use strict";

      var OU = Ir(),
        BU = os().utcFormat,
        it = He(),
        YU = it.numberFormat,
        xi = Hr(),
        gl = it.cleanNumber,
        UU = it.ms2DateTime,
        V9 = it.dateTime2ms,
        _i = it.ensureNumber,
        W9 = it.isArrayOrTypedArray,
        bl = Bt(),
        v0 = bl.FP_SAFE,
        Kn = bl.BADNUM,
        GU = bl.LOG_CLIP,
        VU = bl.ONEWEEK,
        h0 = bl.ONEDAY,
        d0 = bl.ONEHOUR,
        Z9 = bl.ONEMIN,
        X9 = bl.ONESEC,
        p0 = Xt(),
        g0 = da(),
        m0 = g0.HOUR_PATTERN,
        y0 = g0.WEEKDAY_PATTERN;
      function uf(e) {
        return Math.pow(10, e);
      }
      function km(e) {
        return e != null;
      }
      J9.exports = function (r, t) {
        t = t || {};
        var a = r._id || "x",
          n = a.charAt(0);
        function i(b, A) {
          if (b > 0) return Math.log(b) / Math.LN10;
          if (b <= 0 && A && r.range && r.range.length === 2) {
            var S = r.range[0],
              k = r.range[1];
            return .5 * (S + k - 2 * GU * Math.abs(S - k));
          } else return Kn;
        }
        function l(b, A, S, k) {
          if ((k || {}).msUTC && xi(b)) return +b;
          var q = V9(b, S || r.calendar);
          if (q === Kn) if (xi(b)) {
            b = +b;
            var D = Math.floor(it.mod(b + .05, 1) * 10),
              R = Math.round(b - D / 10);
            q = V9(new Date(R)) + D / 10;
          } else return Kn;
          return q;
        }
        function o(b, A, S) {
          return UU(b, A, S || r.calendar);
        }
        function s(b) {
          return r._categories[Math.round(b)];
        }
        function u(b) {
          if (km(b)) {
            if (r._categoriesMap === void 0 && (r._categoriesMap = {}), r._categoriesMap[b] !== void 0) return r._categoriesMap[b];
            r._categories.push(typeof b == "number" ? String(b) : b);
            var A = r._categories.length - 1;
            return r._categoriesMap[b] = A, A;
          }
          return Kn;
        }
        function f(b, A) {
          for (var S = new Array(A), k = 0; k < A; k++) {
            var q = (b[0] || [])[k],
              D = (b[1] || [])[k];
            S[k] = v([q, D]);
          }
          return S;
        }
        function v(b) {
          if (r._categoriesMap) return r._categoriesMap[b];
        }
        function h(b) {
          var A = v(b);
          if (A !== void 0) return A;
          if (xi(b)) return +b;
        }
        function d(b) {
          return xi(b) ? +b : v(b);
        }
        function y(b, A, S) {
          return OU.round(S + A * b, 2);
        }
        function g(b, A, S) {
          return (b - S) / A;
        }
        var m = function (A) {
            return xi(A) ? y(A, r._m, r._b) : Kn;
          },
          _ = function (b) {
            return g(b, r._m, r._b);
          };
        if (r.rangebreaks) {
          var w = n === "y";
          m = function (b) {
            if (!xi(b)) return Kn;
            var A = r._rangebreaks.length;
            if (!A) return y(b, r._m, r._b);
            var S = w;
            r.range[0] > r.range[1] && (S = !S);
            for (var k = S ? -1 : 1, q = k * b, D = 0, R = 0; R < A; R++) {
              var z = k * r._rangebreaks[R].min,
                N = k * r._rangebreaks[R].max;
              if (q < z) break;
              if (q > N) D = R + 1;else {
                D = q < (z + N) / 2 ? R : R + 1;
                break;
              }
            }
            var H = r._B[D] || 0;
            return isFinite(H) ? y(b, r._m2, H) : 0;
          }, _ = function (b) {
            var A = r._rangebreaks.length;
            if (!A) return g(b, r._m, r._b);
            for (var S = 0, k = 0; k < A && !(b < r._rangebreaks[k].pmin); k++) b > r._rangebreaks[k].pmax && (S = k + 1);
            return g(b, r._m2, r._B[S]);
          };
        }
        r.c2l = r.type === "log" ? i : _i, r.l2c = r.type === "log" ? uf : _i, r.l2p = m, r.p2l = _, r.c2p = r.type === "log" ? function (b, A) {
          return m(i(b, A));
        } : m, r.p2c = r.type === "log" ? function (b) {
          return uf(_(b));
        } : _, ["linear", "-"].indexOf(r.type) !== -1 ? (r.d2r = r.r2d = r.d2c = r.r2c = r.d2l = r.r2l = gl, r.c2d = r.c2r = r.l2d = r.l2r = _i, r.d2p = r.r2p = function (b) {
          return r.l2p(gl(b));
        }, r.p2d = r.p2r = _, r.cleanPos = _i) : r.type === "log" ? (r.d2r = r.d2l = function (b, A) {
          return i(gl(b), A);
        }, r.r2d = r.r2c = function (b) {
          return uf(gl(b));
        }, r.d2c = r.r2l = gl, r.c2d = r.l2r = _i, r.c2r = i, r.l2d = uf, r.d2p = function (b, A) {
          return r.l2p(r.d2r(b, A));
        }, r.p2d = function (b) {
          return uf(_(b));
        }, r.r2p = function (b) {
          return r.l2p(gl(b));
        }, r.p2r = _, r.cleanPos = _i) : r.type === "date" ? (r.d2r = r.r2d = it.identity, r.d2c = r.r2c = r.d2l = r.r2l = l, r.c2d = r.c2r = r.l2d = r.l2r = o, r.d2p = r.r2p = function (b, A, S) {
          return r.l2p(l(b, 0, S));
        }, r.p2d = r.p2r = function (b, A, S) {
          return o(_(b), A, S);
        }, r.cleanPos = function (b) {
          return it.cleanDate(b, Kn, r.calendar);
        }) : r.type === "category" ? (r.d2c = r.d2l = u, r.r2d = r.c2d = r.l2d = s, r.d2r = r.d2l_noadd = h, r.r2c = function (b) {
          var A = d(b);
          return A !== void 0 ? A : r.fraction2r(.5);
        }, r.l2r = r.c2r = _i, r.r2l = d, r.d2p = function (b) {
          return r.l2p(r.r2c(b));
        }, r.p2d = function (b) {
          return s(_(b));
        }, r.r2p = r.d2p, r.p2r = _, r.cleanPos = function (b) {
          return typeof b == "string" && b !== "" ? b : _i(b);
        }) : r.type === "multicategory" && (r.r2d = r.c2d = r.l2d = s, r.d2r = r.d2l_noadd = h, r.r2c = function (b) {
          var A = h(b);
          return A !== void 0 ? A : r.fraction2r(.5);
        }, r.r2c_just_indices = v, r.l2r = r.c2r = _i, r.r2l = h, r.d2p = function (b) {
          return r.l2p(r.r2c(b));
        }, r.p2d = function (b) {
          return s(_(b));
        }, r.r2p = r.d2p, r.p2r = _, r.cleanPos = function (b) {
          return Array.isArray(b) || typeof b == "string" && b !== "" ? b : _i(b);
        }, r.setupMultiCategory = function (b) {
          var A = r._traceIndices,
            S,
            k,
            q = r._matchGroup;
          if (q && r._categories.length === 0) {
            for (var D in q) if (D !== a) {
              var R = t[p0.id2name(D)];
              A = A.concat(R._traceIndices);
            }
          }
          var z = [[0, {}], [0, {}]],
            N = [];
          for (S = 0; S < A.length; S++) {
            var H = b[A[S]];
            if (n in H) {
              var O = H[n],
                J = H._length || it.minRowLength(O);
              if (W9(O[0]) && W9(O[1])) for (k = 0; k < J; k++) {
                var X = O[0][k],
                  B = O[1][k];
                km(X) && km(B) && (N.push([X, B]), X in z[0][1] || (z[0][1][X] = z[0][0]++), B in z[1][1] || (z[1][1][B] = z[1][0]++));
              }
            }
          }
          for (N.sort(function (I, V) {
            var K = z[0][1],
              Q = K[I[0]] - K[V[0]];
            if (Q) return Q;
            var ie = z[1][1];
            return ie[I[1]] - ie[V[1]];
          }), S = 0; S < N.length; S++) u(N[S]);
        }), r.fraction2r = function (b) {
          var A = r.r2l(r.range[0]),
            S = r.r2l(r.range[1]);
          return r.l2r(A + b * (S - A));
        }, r.r2fraction = function (b) {
          var A = r.r2l(r.range[0]),
            S = r.r2l(r.range[1]);
          return (r.r2l(b) - A) / (S - A);
        }, r.limitRange = function (b) {
          var A = r.minallowed,
            S = r.maxallowed;
          if (!(A === void 0 && S === void 0)) {
            b || (b = "range");
            var k = it.nestedProperty(r, b).get(),
              q = it.simpleMap(k, r.r2l),
              D = q[1] < q[0];
            D && q.reverse();
            var R = it.simpleMap([A, S], r.r2l);
            if (A !== void 0 && q[0] < R[0] && (k[D ? 1 : 0] = A), S !== void 0 && q[1] > R[1] && (k[D ? 0 : 1] = S), k[0] === k[1]) {
              var z = r.l2r(A),
                N = r.l2r(S);
              if (A !== void 0) {
                var H = z + 1;
                S !== void 0 && (H = Math.min(H, N)), k[D ? 1 : 0] = H;
              }
              if (S !== void 0) {
                var O = N + 1;
                A !== void 0 && (O = Math.max(O, z)), k[D ? 0 : 1] = O;
              }
            }
          }
        }, r.cleanRange = function (b, A) {
          r._cleanRange(b, A), r.limitRange(b);
        }, r._cleanRange = function (b, A) {
          A || (A = {}), b || (b = "range");
          var S = it.nestedProperty(r, b).get(),
            k,
            q;
          if (r.type === "date" ? q = it.dfltRange(r.calendar) : n === "y" ? q = g0.DFLTRANGEY : r._name === "realaxis" ? q = [0, 1] : q = A.dfltRange || g0.DFLTRANGEX, q = q.slice(), (r.rangemode === "tozero" || r.rangemode === "nonnegative") && (q[0] = 0), !S || S.length !== 2) {
            it.nestedProperty(r, b).set(q);
            return;
          }
          var D = S[0] === null,
            R = S[1] === null;
          for (r.type === "date" && !r.autorange && (S[0] = it.cleanDate(S[0], Kn, r.calendar), S[1] = it.cleanDate(S[1], Kn, r.calendar)), k = 0; k < 2; k++) if (r.type === "date") {
            if (!it.isDateTime(S[k], r.calendar)) {
              r[b] = q;
              break;
            }
            if (r.r2l(S[0]) === r.r2l(S[1])) {
              var z = it.constrain(r.r2l(S[0]), it.MIN_MS + 1e3, it.MAX_MS - 1e3);
              S[0] = r.l2r(z - 1e3), S[1] = r.l2r(z + 1e3);
              break;
            }
          } else {
            if (!xi(S[k])) if (!(D || R) && xi(S[1 - k])) S[k] = S[1 - k] * (k ? 10 : .1);else {
              r[b] = q;
              break;
            }
            if (S[k] < -v0 ? S[k] = -v0 : S[k] > v0 && (S[k] = v0), S[0] === S[1]) {
              var N = Math.max(1, Math.abs(S[0] * 1e-6));
              S[0] -= N, S[1] += N;
            }
          }
        }, r.setScale = function (b) {
          var A = t._size;
          if (r.overlaying) {
            var S = p0.getFromId({
              _fullLayout: t
            }, r.overlaying);
            r.domain = S.domain;
          }
          var k = b && r._r ? "_r" : "range",
            q = r.calendar;
          r.cleanRange(k);
          var D = r.r2l(r[k][0], q),
            R = r.r2l(r[k][1], q),
            z = n === "y";
          if (z ? (r._offset = A.t + (1 - r.domain[1]) * A.h, r._length = A.h * (r.domain[1] - r.domain[0]), r._m = r._length / (D - R), r._b = -r._m * R) : (r._offset = A.l + r.domain[0] * A.w, r._length = A.w * (r.domain[1] - r.domain[0]), r._m = r._length / (R - D), r._b = -r._m * D), r._rangebreaks = [], r._lBreaks = 0, r._m2 = 0, r._B = [], r.rangebreaks) {
            var N, H;
            if (r._rangebreaks = r.locateBreaks(Math.min(D, R), Math.max(D, R)), r._rangebreaks.length) {
              for (N = 0; N < r._rangebreaks.length; N++) H = r._rangebreaks[N], r._lBreaks += Math.abs(H.max - H.min);
              var O = z;
              D > R && (O = !O), O && r._rangebreaks.reverse();
              var J = O ? -1 : 1;
              for (r._m2 = J * r._length / (Math.abs(R - D) - r._lBreaks), r._B.push(-r._m2 * (z ? R : D)), N = 0; N < r._rangebreaks.length; N++) H = r._rangebreaks[N], r._B.push(r._B[r._B.length - 1] - J * r._m2 * (H.max - H.min));
              for (N = 0; N < r._rangebreaks.length; N++) H = r._rangebreaks[N], H.pmin = m(H.min), H.pmax = m(H.max);
            }
          }
          if (!isFinite(r._m) || !isFinite(r._b) || r._length < 0) throw t._replotting = !1, new Error("Something went wrong with axis scaling");
        }, r.maskBreaks = function (b) {
          var A = r.rangebreaks || [],
            S,
            k,
            q,
            D,
            R;
          A._cachedPatterns || (A._cachedPatterns = A.map(function (K) {
            return K.enabled && K.bounds ? it.simpleMap(K.bounds, K.pattern ? gl : r.d2c) : null;
          })), A._cachedValues || (A._cachedValues = A.map(function (K) {
            return K.enabled && K.values ? it.simpleMap(K.values, r.d2c).sort(it.sorterAsc) : null;
          }));
          for (var z = 0; z < A.length; z++) {
            var N = A[z];
            if (N.enabled) {
              if (N.bounds) {
                var H = N.pattern;
                switch (S = A._cachedPatterns[z], k = S[0], q = S[1], H) {
                  case y0:
                    R = new Date(b), D = R.getUTCDay(), k > q && (q += 7, D < k && (D += 7));
                    break;
                  case m0:
                    R = new Date(b);
                    var O = R.getUTCHours(),
                      J = R.getUTCMinutes(),
                      X = R.getUTCSeconds(),
                      B = R.getUTCMilliseconds();
                    D = O + (J / 60 + X / 3600 + B / 36e5), k > q && (q += 24, D < k && (D += 24));
                    break;
                  case "":
                    D = b;
                    break;
                }
                if (D >= k && D < q) return Kn;
              } else for (var I = A._cachedValues[z], V = 0; V < I.length; V++) if (k = I[V], q = k + N.dvalue, b >= k && b < q) return Kn;
            }
          }
          return b;
        }, r.locateBreaks = function (b, A) {
          var S,
            k,
            q,
            D,
            R = [];
          if (!r.rangebreaks) return R;
          var z = r.rangebreaks.slice().sort(function (ie, me) {
              return ie.pattern === y0 && me.pattern === m0 ? -1 : me.pattern === y0 && ie.pattern === m0 ? 1 : 0;
            }),
            N = function (ie, me) {
              if (ie = it.constrain(ie, b, A), me = it.constrain(me, b, A), ie !== me) {
                for (var pe = !0, ge = 0; ge < R.length; ge++) {
                  var j = R[ge];
                  ie < j.max && me >= j.min && (ie < j.min && (j.min = ie), me > j.max && (j.max = me), pe = !1);
                }
                pe && R.push({
                  min: ie,
                  max: me
                });
              }
            };
          for (S = 0; S < z.length; S++) {
            var H = z[S];
            if (H.enabled) if (H.bounds) {
              var O = b,
                J = A;
              H.pattern && (O = Math.floor(O)), k = it.simpleMap(H.bounds, H.pattern ? gl : r.r2l), q = k[0], D = k[1];
              var X = new Date(O),
                B,
                I;
              switch (H.pattern) {
                case y0:
                  I = VU, B = ((D < q ? 7 : 0) + (D - q)) * h0, O += q * h0 - (X.getUTCDay() * h0 + X.getUTCHours() * d0 + X.getUTCMinutes() * Z9 + X.getUTCSeconds() * X9 + X.getUTCMilliseconds());
                  break;
                case m0:
                  I = h0, B = ((D < q ? 24 : 0) + (D - q)) * d0, O += q * d0 - (X.getUTCHours() * d0 + X.getUTCMinutes() * Z9 + X.getUTCSeconds() * X9 + X.getUTCMilliseconds());
                  break;
                default:
                  O = Math.min(k[0], k[1]), J = Math.max(k[0], k[1]), I = J - O, B = I;
              }
              for (var V = O; V < J; V += I) N(V, V + B);
            } else for (var K = it.simpleMap(H.values, r.d2c), Q = 0; Q < K.length; Q++) q = K[Q], D = q + H.dvalue, N(q, D);
          }
          return R.sort(function (ie, me) {
            return ie.min - me.min;
          }), R;
        }, r.makeCalcdata = function (b, A, S) {
          var k,
            q,
            D,
            R,
            z = r.type,
            N = z === "date" && b[A + "calendar"];
          if (A in b) {
            if (k = b[A], R = b._length || it.minRowLength(k), it.isTypedArray(k) && (z === "linear" || z === "log")) {
              if (R === k.length) return k;
              if (k.subarray) return k.subarray(0, R);
            }
            if (z === "multicategory") return f(k, R);
            for (q = new Array(R), D = 0; D < R; D++) q[D] = r.d2c(k[D], 0, N, S);
          } else {
            var H = A + "0" in b ? r.d2c(b[A + "0"], 0, N) : 0,
              O = b["d" + A] ? Number(b["d" + A]) : 1;
            for (k = b[{
              x: "y",
              y: "x"
            }[A]], R = b._length || k.length, q = new Array(R), D = 0; D < R; D++) q[D] = H + D * O;
          }
          if (r.rangebreaks) for (D = 0; D < R; D++) q[D] = r.maskBreaks(q[D]);
          return q;
        }, r.isValidRange = function (b, A) {
          return Array.isArray(b) && b.length === 2 && (A && b[0] === null || xi(r.r2l(b[0]))) && (A && b[1] === null || xi(r.r2l(b[1])));
        }, r.getAutorangeDflt = function (b, A) {
          var S = !r.isValidRange(b, "nullOk");
          return S && A && A.reverseDflt ? S = "reversed" : b && (b[0] === null && b[1] === null ? S = !0 : b[0] === null && b[1] !== null ? S = "min" : b[0] !== null && b[1] === null && (S = "max")), S;
        }, r.isReversed = function () {
          var b = r.autorange;
          return b === "reversed" || b === "min reversed" || b === "max reversed";
        }, r.isPtWithinRange = function (b, A) {
          var S = r.c2l(b[n], null, A),
            k = r.r2l(r.range[0]),
            q = r.r2l(r.range[1]);
          return k < q ? k <= S && S <= q : q <= S && S <= k;
        }, r._emptyCategories = function () {
          r._categories = [], r._categoriesMap = {};
        }, r.clearCalc = function () {
          var b = r._matchGroup;
          if (b) {
            var A = null,
              S = null;
            for (var k in b) {
              var q = t[p0.id2name(k)];
              if (q._categories) {
                A = q._categories, S = q._categoriesMap;
                break;
              }
            }
            A && S ? (r._categories = A, r._categoriesMap = S) : r._emptyCategories();
          } else r._emptyCategories();
          if (r._initialCategories) for (var D = 0; D < r._initialCategories.length; D++) u(r._initialCategories[D]);
        }, r.sortByInitialCategories = function () {
          var b = [];
          if (r._emptyCategories(), r._initialCategories) for (var A = 0; A < r._initialCategories.length; A++) u(r._initialCategories[A]);
          b = b.concat(r._traceIndices);
          var S = r._matchGroup;
          for (var k in S) if (a !== k) {
            var q = t[p0.id2name(k)];
            q._categories = r._categories, q._categoriesMap = r._categoriesMap, b = b.concat(q._traceIndices);
          }
          return b;
        };
        var T = t._d3locale;
        r.type === "date" && (r._dateFormat = T ? T.timeFormat : BU, r._extraFormat = t._extraFormat), r._separators = t.separators, r._numFormat = T ? T.numberFormat : YU, delete r._minDtick, delete r._forceTick0;
      };
    });
    var Sm = Z((Woe, j9) => {
      "use strict";

      var K9 = Hr(),
        Cm = He(),
        WU = Bt().BADNUM,
        x0 = Cm.isArrayOrTypedArray,
        ZU = Cm.isDateTime,
        XU = Cm.cleanNumber,
        Q9 = Math.round;
      j9.exports = function (r, t, a) {
        var n = r,
          i = a.noMultiCategory;
        if (x0(n) && !n.length) return "-";
        if (!i && jU(n)) return "multicategory";
        if (i && Array.isArray(n[0])) {
          for (var l = [], o = 0; o < n.length; o++) if (x0(n[o])) for (var s = 0; s < n[o].length; s++) l.push(n[o][s]);
          n = l;
        }
        if (QU(n, t)) return "date";
        var u = a.autotypenumbers !== "strict";
        return $U(n, u) ? "category" : KU(n, u) ? "linear" : "-";
      };
      function JU(e, r) {
        return r ? K9(e) : typeof e == "number";
      }
      function KU(e, r) {
        for (var t = e.length, a = 0; a < t; a++) if (JU(e[a], r)) return !0;
        return !1;
      }
      function QU(e, r) {
        for (var t = e.length, a = $9(t), n = 0, i = 0, l = {}, o = 0; o < t; o += a) {
          var s = Q9(o),
            u = e[s],
            f = String(u);
          l[f] || (l[f] = 1, ZU(u, r) && n++, K9(u) && i++);
        }
        return n > i * 2;
      }
      function $9(e) {
        return Math.max(1, (e - 1) / 1e3);
      }
      function $U(e, r) {
        for (var t = e.length, a = $9(t), n = 0, i = 0, l = {}, o = 0; o < t; o += a) {
          var s = Q9(o),
            u = e[s],
            f = String(u);
          if (!l[f]) {
            l[f] = 1;
            var v = typeof u;
            v === "boolean" ? i++ : (r ? XU(u) !== WU : v === "number") ? n++ : v === "string" && i++;
          }
        }
        return i > n * 2;
      }
      function jU(e) {
        return x0(e[0]) && x0(e[1]);
      }
    });
    var ff = Z((Zoe, o8) => {
      "use strict";

      var eG = Ir(),
        a8 = Hr(),
        xl = He(),
        _0 = Bt().FP_SAFE,
        rG = gr(),
        tG = tt(),
        n8 = Xt(),
        aG = n8.getFromId,
        nG = n8.isLinked;
      o8.exports = {
        applyAutorangeOptions: l8,
        getAutoRange: Lm,
        makePadFn: qm,
        doAutoRange: lG,
        findExtremes: oG,
        concatExtremes: Pm
      };
      function Lm(e, r) {
        var t,
          a,
          n = [],
          i = e._fullLayout,
          l = qm(i, r, 0),
          o = qm(i, r, 1),
          s = Pm(e, r),
          u = s.min,
          f = s.max;
        if (u.length === 0 || f.length === 0) return xl.simpleMap(r.range, r.r2l);
        var v = u[0].val,
          h = f[0].val;
        for (t = 1; t < u.length && v === h; t++) v = Math.min(v, u[t].val);
        for (t = 1; t < f.length && v === h; t++) h = Math.max(h, f[t].val);
        var d = r.autorange,
          y = d === "reversed" || d === "min reversed" || d === "max reversed";
        if (!y && r.range) {
          var g = xl.simpleMap(r.range, r.r2l);
          y = g[1] < g[0];
        }
        r.autorange === "reversed" && (r.autorange = !0);
        var m = r.rangemode,
          _ = m === "tozero",
          w = m === "nonnegative",
          T = r._length,
          b = T / 10,
          A = 0,
          S,
          k,
          q,
          D,
          R,
          z;
        for (t = 0; t < u.length; t++) for (S = u[t], a = 0; a < f.length; a++) k = f[a], z = k.val - S.val - e8(r, S.val, k.val), z > 0 && (R = T - l(S) - o(k), R > b ? z / R > A && (q = S, D = k, A = z / R) : z / T > A && (q = {
          val: S.val,
          nopad: 1
        }, D = {
          val: k.val,
          nopad: 1
        }, A = z / T));
        function N(B, I) {
          return Math.max(B, o(I));
        }
        if (v === h) {
          var H = v - 1,
            O = v + 1;
          if (_) {
            if (v === 0) n = [0, 1];else {
              var J = (v > 0 ? f : u).reduce(N, 0),
                X = v / (1 - Math.min(.5, J / T));
              n = v > 0 ? [0, X] : [X, 0];
            }
          } else w ? n = [Math.max(0, H), Math.max(1, O)] : n = [H, O];
        } else _ ? (q.val >= 0 && (q = {
          val: 0,
          nopad: 1
        }), D.val <= 0 && (D = {
          val: 0,
          nopad: 1
        })) : w && (q.val - A * l(q) < 0 && (q = {
          val: 0,
          nopad: 1
        }), D.val <= 0 && (D = {
          val: 1,
          nopad: 1
        })), A = (D.val - q.val - e8(r, S.val, k.val)) / (T - l(q) - o(D)), n = [q.val - A * l(q), D.val + A * o(D)];
        return n = l8(n, r), r.limitRange && r.limitRange(), y && n.reverse(), xl.simpleMap(n, r.l2r || Number);
      }
      function e8(e, r, t) {
        var a = 0;
        if (e.rangebreaks) for (var n = e.locateBreaks(r, t), i = 0; i < n.length; i++) {
          var l = n[i];
          a += l.max - l.min;
        }
        return a;
      }
      function qm(e, r, t) {
        var a = .05 * r._length,
          n = r._anchorAxis || {};
        if ((r.ticklabelposition || "").indexOf("inside") !== -1 || (n.ticklabelposition || "").indexOf("inside") !== -1) {
          var i = r.isReversed();
          if (!i) {
            var l = xl.simpleMap(r.range, r.r2l);
            i = l[1] < l[0];
          }
          i && (t = !t);
        }
        var o = 0;
        return nG(e, r._id) || (o = iG(e, r, t)), a = Math.max(o, a), r.constrain === "domain" && r._inputDomain && (a *= (r._inputDomain[1] - r._inputDomain[0]) / (r.domain[1] - r.domain[0])), function (u) {
          return u.nopad ? 0 : u.pad + (u.extrapad ? a : o);
        };
      }
      var r8 = 3;
      function iG(e, r, t) {
        var a = 0,
          n = r._id.charAt(0) === "x";
        for (var i in e._plots) {
          var l = e._plots[i];
          if (!(r._id !== l.xaxis._id && r._id !== l.yaxis._id)) {
            var o = (n ? l.yaxis : l.xaxis) || {};
            if ((o.ticklabelposition || "").indexOf("inside") !== -1 && (!t && (o.side === "left" || o.side === "bottom") || t && (o.side === "top" || o.side === "right"))) {
              if (o._vals) {
                var s = xl.deg2rad(o._tickAngles[o._id + "tick"] || 0),
                  u = Math.abs(Math.cos(s)),
                  f = Math.abs(Math.sin(s));
                if (!o._vals[0].bb) {
                  var v = o._id + "tick",
                    h = o._selections[v];
                  h.each(function (w) {
                    var T = eG.select(this),
                      b = T.select(".text-math-group");
                    b.empty() && (w.bb = tG.bBox(T.node()));
                  });
                }
                for (var d = 0; d < o._vals.length; d++) {
                  var y = o._vals[d],
                    g = y.bb;
                  if (g) {
                    var m = 2 * r8 + g.width,
                      _ = 2 * r8 + g.height;
                    a = Math.max(a, n ? Math.max(m * u, _ * f) : Math.max(_ * u, m * f));
                  }
                }
              }
              o.ticks === "inside" && o.ticklabelposition === "inside" && (a += o.ticklen || 0);
            }
          }
        }
        return a;
      }
      function Pm(e, r, t) {
        var a = r._id,
          n = e._fullData,
          i = e._fullLayout,
          l = [],
          o = [],
          s,
          u,
          f;
        function v(m, _) {
          for (s = 0; s < _.length; s++) {
            var w = m[_[s]],
              T = (w._extremes || {})[a];
            if (w.visible === !0 && T) {
              for (u = 0; u < T.min.length; u++) f = T.min[u], Dm(l, f.val, f.pad, {
                extrapad: f.extrapad
              });
              for (u = 0; u < T.max.length; u++) f = T.max[u], Em(o, f.val, f.pad, {
                extrapad: f.extrapad
              });
            }
          }
        }
        if (v(n, r._traceIndices), v(i.annotations || [], r._annIndices || []), v(i.shapes || [], r._shapeIndices || []), r._matchGroup && !t) {
          for (var h in r._matchGroup) if (h !== r._id) {
            var d = aG(e, h),
              y = Pm(e, d, !0),
              g = r._length / d._length;
            for (u = 0; u < y.min.length; u++) f = y.min[u], Dm(l, f.val, f.pad * g, {
              extrapad: f.extrapad
            });
            for (u = 0; u < y.max.length; u++) f = y.max[u], Em(o, f.val, f.pad * g, {
              extrapad: f.extrapad
            });
          }
        }
        return {
          min: l,
          max: o
        };
      }
      function lG(e, r, t) {
        if (r.setScale(), r.autorange) {
          r.range = t ? t.slice() : Lm(e, r), r._r = r.range.slice(), r._rl = xl.simpleMap(r._r, r.r2l);
          var a = r._input,
            n = {};
          n[r._attr + ".range"] = r.range, n[r._attr + ".autorange"] = r.autorange, rG.call("_storeDirectGUIEdit", e.layout, e._fullLayout._preGUI, n), a.range = r.range.slice(), a.autorange = r.autorange;
        }
        var i = r._anchorAxis;
        if (i && i.rangeslider) {
          var l = i.rangeslider[r._name];
          l && l.rangemode === "auto" && (l.range = Lm(e, r)), i._input.rangeslider[r._name] = xl.extendFlat({}, l);
        }
      }
      function oG(e, r, t) {
        t || (t = {}), e._m || e.setScale();
        var a = [],
          n = [],
          i = r.length,
          l = t.padded || !1,
          o = t.tozero && (e.type === "linear" || e.type === "-"),
          s = e.type === "log",
          u = !1,
          f = t.vpadLinearized || !1,
          v,
          h,
          d,
          y,
          g,
          m,
          _,
          w,
          T;
        function b(N) {
          if (Array.isArray(N)) return u = !0, function (O) {
            return Math.max(Number(N[O] || 0), 0);
          };
          var H = Math.max(Number(N || 0), 0);
          return function () {
            return H;
          };
        }
        var A = b((e._m > 0 ? t.ppadplus : t.ppadminus) || t.ppad || 0),
          S = b((e._m > 0 ? t.ppadminus : t.ppadplus) || t.ppad || 0),
          k = b(t.vpadplus || t.vpad),
          q = b(t.vpadminus || t.vpad);
        if (!u) {
          if (w = 1 / 0, T = -1 / 0, s) for (v = 0; v < i; v++) h = r[v], h < w && h > 0 && (w = h), h > T && h < _0 && (T = h);else for (v = 0; v < i; v++) h = r[v], h < w && h > -_0 && (w = h), h > T && h < _0 && (T = h);
          r = [w, T], i = 2;
        }
        var D = {
          tozero: o,
          extrapad: l
        };
        function R(N) {
          d = r[N], a8(d) && (m = A(N), _ = S(N), f ? (y = e.c2l(d) - q(N), g = e.c2l(d) + k(N)) : (w = d - q(N), T = d + k(N), s && w < T / 10 && (w = T / 10), y = e.c2l(w), g = e.c2l(T)), o && (y = Math.min(0, y), g = Math.max(0, g)), t8(y) && Dm(a, y, _, D), t8(g) && Em(n, g, m, D));
        }
        var z = Math.min(6, i);
        for (v = 0; v < z; v++) R(v);
        for (v = i - 1; v >= z; v--) R(v);
        return {
          min: a,
          max: n,
          opts: t
        };
      }
      function Dm(e, r, t, a) {
        i8(e, r, t, a, sG);
      }
      function Em(e, r, t, a) {
        i8(e, r, t, a, uG);
      }
      function i8(e, r, t, a, n) {
        for (var i = a.tozero, l = a.extrapad, o = !0, s = 0; s < e.length && o; s++) {
          var u = e[s];
          if (n(u.val, r) && u.pad >= t && (u.extrapad || !l)) {
            o = !1;
            break;
          } else n(r, u.val) && u.pad <= t && (l || !u.extrapad) && (e.splice(s, 1), s--);
        }
        if (o) {
          var f = i && r === 0;
          e.push({
            val: r,
            pad: f ? 0 : t,
            extrapad: f ? !1 : l
          });
        }
      }
      function t8(e) {
        return a8(e) && Math.abs(e) < _0;
      }
      function sG(e, r) {
        return e <= r;
      }
      function uG(e, r) {
        return e >= r;
      }
      function fG(e, r) {
        var t = r.autorangeoptions;
        return t && t.minallowed !== void 0 && w0(r, t.minallowed, t.maxallowed) ? t.minallowed : t && t.clipmin !== void 0 && w0(r, t.clipmin, t.clipmax) ? Math.max(e, r.d2l(t.clipmin)) : e;
      }
      function cG(e, r) {
        var t = r.autorangeoptions;
        return t && t.maxallowed !== void 0 && w0(r, t.minallowed, t.maxallowed) ? t.maxallowed : t && t.clipmax !== void 0 && w0(r, t.clipmin, t.clipmax) ? Math.min(e, r.d2l(t.clipmax)) : e;
      }
      function w0(e, r, t) {
        return r !== void 0 && t !== void 0 ? (r = e.d2l(r), t = e.d2l(t), r < t) : !0;
      }
      function l8(e, r) {
        if (!r || !r.autorangeoptions) return e;
        var t = e[0],
          a = e[1],
          n = r.autorangeoptions.include;
        if (n !== void 0) {
          var i = r.d2l(t),
            l = r.d2l(a);
          xl.isArrayOrTypedArray(n) || (n = [n]);
          for (var o = 0; o < n.length; o++) {
            var s = r.d2l(n[o]);
            i >= s && (i = s, t = s), l <= s && (l = s, a = s);
          }
        }
        return t = fG(t, r), a = cG(a, r), [t, a];
      }
    });
    var dt = Z((Xoe, L8) => {
      "use strict";

      var Mn = Ir(),
        zt = Hr(),
        zs = Pt(),
        vf = gr(),
        br = He(),
        Ns = br.strTranslate,
        go = xa(),
        vG = sf(),
        hf = Er(),
        sn = tt(),
        hG = Xn(),
        s8 = Kp(),
        ma = Bt(),
        dG = ma.ONEMAXYEAR,
        A0 = ma.ONEAVGYEAR,
        k0 = ma.ONEMINYEAR,
        pG = ma.ONEMAXQUARTER,
        Fm = ma.ONEAVGQUARTER,
        C0 = ma.ONEMINQUARTER,
        mG = ma.ONEMAXMONTH,
        Fs = ma.ONEAVGMONTH,
        S0 = ma.ONEMINMONTH,
        un = ma.ONEWEEK,
        Ea = ma.ONEDAY,
        _l = Ea / 2,
        Ti = ma.ONEHOUR,
        df = ma.ONEMIN,
        L0 = ma.ONESEC,
        yG = ma.ONEMILLI,
        gG = ma.ONEMICROSEC,
        bo = ma.MINUS_SIGN,
        E0 = ma.BADNUM,
        Im = {
          K: "zeroline"
        },
        Hm = {
          K: "gridline",
          L: "path"
        },
        Om = {
          K: "minor-gridline",
          L: "path"
        },
        b8 = {
          K: "tick",
          L: "path"
        },
        u8 = {
          K: "tick",
          L: "text"
        },
        f8 = {
          width: ["x", "r", "l", "xl", "xr"],
          height: ["y", "t", "b", "yt", "yb"],
          right: ["r", "xr"],
          left: ["l", "xl"],
          top: ["t", "yt"],
          bottom: ["b", "yb"]
        },
        P0 = Da(),
        cf = P0.MID_SHIFT,
        xo = P0.CAP_SHIFT,
        pf = P0.LINE_SPACING,
        bG = P0.OPPOSITE_SIDE,
        q0 = 3,
        Ve = L8.exports = {};
      Ve.setConvert = b0();
      var xG = Sm(),
        Ui = Xt(),
        _G = Ui.idSort,
        wG = Ui.isLinked;
      Ve.id2name = Ui.id2name;
      Ve.name2id = Ui.name2id;
      Ve.cleanId = Ui.cleanId;
      Ve.list = Ui.list;
      Ve.listIds = Ui.listIds;
      Ve.getFromId = Ui.getFromId;
      Ve.getFromTrace = Ui.getFromTrace;
      var x8 = ff();
      Ve.getAutoRange = x8.getAutoRange;
      Ve.findExtremes = x8.findExtremes;
      var TG = 1e-4;
      function Gm(e) {
        var r = (e[1] - e[0]) * TG;
        return [e[0] - r, e[1] + r];
      }
      Ve.coerceRef = function (e, r, t, a, n, i) {
        var l = a.charAt(a.length - 1),
          o = t._fullLayout._subplots[l + "axis"],
          s = a + "ref",
          u = {};
        return n || (n = o[0] || (typeof i == "string" ? i : i[0])), i || (i = n), o = o.concat(o.map(function (f) {
          return f + " domain";
        })), u[s] = {
          valType: "enumerated",
          values: o.concat(i ? typeof i == "string" ? [i] : i : []),
          dflt: n
        }, br.coerce(e, r, u, s);
      };
      Ve.getRefType = function (e) {
        return e === void 0 ? e : e === "paper" ? "paper" : e === "pixel" ? "pixel" : /( domain)$/.test(e) ? "domain" : "range";
      };
      Ve.coercePosition = function (e, r, t, a, n, i) {
        var l,
          o,
          s = Ve.getRefType(a);
        if (s !== "range") l = br.ensureNumber, o = t(n, i);else {
          var u = Ve.getFromId(r, a);
          i = u.fraction2r(i), o = t(n, i), l = u.cleanPos;
        }
        e[n] = l(o);
      };
      Ve.cleanPosition = function (e, r, t) {
        var a = t === "paper" || t === "pixel" ? br.ensureNumber : Ve.getFromId(r, t).cleanPos;
        return a(e);
      };
      Ve.redrawComponents = function (e, r) {
        r = r || Ve.listIds(e);
        var t = e._fullLayout;
        function a(n, i, l, o) {
          for (var s = vf.getComponentMethod(n, i), u = {}, f = 0; f < r.length; f++) for (var v = t[Ve.id2name(r[f])], h = v[l], d = 0; d < h.length; d++) {
            var y = h[d];
            if (!u[y] && (s(e, y), u[y] = 1, o)) return;
          }
        }
        a("annotations", "drawOne", "_annIndices"), a("shapes", "drawOne", "_shapeIndices"), a("images", "draw", "_imgIndices", !0), a("selections", "drawOne", "_selectionIndices");
      };
      var MG = Ve.getDataConversions = function (e, r, t, a) {
        var n,
          i = t === "x" || t === "y" || t === "z" ? t : a;
        if (br.isArrayOrTypedArray(i)) {
          if (n = {
            type: xG(a, void 0, {
              autotypenumbers: e._fullLayout.autotypenumbers
            }),
            _categories: []
          }, Ve.setConvert(n), n.type === "category") for (var l = 0; l < a.length; l++) n.d2c(a[l]);
        } else n = Ve.getFromTrace(e, r, i);
        return n ? {
          d2c: n.d2c,
          c2d: n.c2d
        } : i === "ids" ? {
          d2c: v8,
          c2d: v8
        } : {
          d2c: c8,
          c2d: c8
        };
      };
      function c8(e) {
        return +e;
      }
      function v8(e) {
        return String(e);
      }
      Ve.getDataToCoordFunc = function (e, r, t, a) {
        return MG(e, r, t, a).d2c;
      };
      Ve.counterLetter = function (e) {
        var r = e.charAt(0);
        if (r === "x") return "y";
        if (r === "y") return "x";
      };
      Ve.minDtick = function (e, r, t, a) {
        ["log", "category", "multicategory"].indexOf(e.type) !== -1 || !a ? e._minDtick = 0 : e._minDtick === void 0 ? (e._minDtick = r, e._forceTick0 = t) : e._minDtick && ((e._minDtick / r + 1e-6) % 1 < 2e-6 && ((t - e._forceTick0) / r % 1 + 1.000001) % 1 < 2e-6 ? (e._minDtick = r, e._forceTick0 = t) : ((r / e._minDtick + 1e-6) % 1 > 2e-6 || ((t - e._forceTick0) / e._minDtick % 1 + 1.000001) % 1 > 2e-6) && (e._minDtick = 0));
      };
      Ve.saveRangeInitial = function (e, r) {
        for (var t = Ve.list(e, "", !0), a = !1, n = 0; n < t.length; n++) {
          var i = t[n],
            l = i._rangeInitial0 === void 0 && i._rangeInitial1 === void 0,
            o = l || i.range[0] !== i._rangeInitial0 || i.range[1] !== i._rangeInitial1,
            s = i.autorange;
          (l && s !== !0 || r && o) && (i._rangeInitial0 = s === "min" || s === "max reversed" ? void 0 : i.range[0], i._rangeInitial1 = s === "max" || s === "min reversed" ? void 0 : i.range[1], i._autorangeInitial = s, a = !0);
        }
        return a;
      };
      Ve.saveShowSpikeInitial = function (e, r) {
        for (var t = Ve.list(e, "", !0), a = !1, n = "on", i = 0; i < t.length; i++) {
          var l = t[i],
            o = l._showSpikeInitial === void 0,
            s = o || l.showspikes !== l._showspikes;
          (o || r && s) && (l._showSpikeInitial = l.showspikes, a = !0), n === "on" && !l.showspikes && (n = "off");
        }
        return e._fullLayout._cartesianSpikesEnabled = n, a;
      };
      Ve.autoBin = function (e, r, t, a, n, i) {
        var l = br.aggNums(Math.min, null, e),
          o = br.aggNums(Math.max, null, e);
        if (r.type === "category" || r.type === "multicategory") return {
          start: l - .5,
          end: o + .5,
          size: Math.max(1, Math.round(i) || 1),
          _dataSpan: o - l
        };
        n || (n = r.calendar);
        var s;
        if (r.type === "log" ? s = {
          type: "linear",
          range: [l, o]
        } : s = {
          type: r.type,
          range: br.simpleMap([l, o], r.c2r, 0, n),
          calendar: n
        }, Ve.setConvert(s), i = i && s8.dtick(i, s.type), i) s.dtick = i, s.tick0 = s8.tick0(void 0, s.type, n);else {
          var u;
          if (t) u = (o - l) / t;else {
            var f = br.distinctVals(e),
              v = Math.pow(10, Math.floor(Math.log(f.minDiff) / Math.LN10)),
              h = v * br.roundUp(f.minDiff / v, [.9, 1.9, 4.9, 9.9], !0);
            u = Math.max(h, 2 * br.stdev(e) / Math.pow(e.length, a ? .25 : .4)), zt(u) || (u = 1);
          }
          Ve.autoTicks(s, u);
        }
        var d = s.dtick,
          y = Ve.tickIncrement(Ve.tickFirst(s), d, "reverse", n),
          g,
          m;
        if (typeof d == "number") y = AG(y, e, s, l, o), m = 1 + Math.floor((o - y) / d), g = y + m * d;else for (s.dtick.charAt(0) === "M" && (y = kG(y, e, d, l, n)), g = y, m = 0; g <= o;) g = Ve.tickIncrement(g, d, !1, n), m++;
        return {
          start: r.c2r(y, 0, n),
          end: r.c2r(g, 0, n),
          size: d,
          _dataSpan: o - l
        };
      };
      function AG(e, r, t, a, n) {
        var i = 0,
          l = 0,
          o = 0,
          s = 0;
        function u(d) {
          return (1 + (d - e) * 100 / t.dtick) % 100 < 2;
        }
        for (var f = 0; f < r.length; f++) r[f] % 1 === 0 ? o++ : zt(r[f]) || s++, u(r[f]) && i++, u(r[f] + t.dtick / 2) && l++;
        var v = r.length - s;
        if (o === v && t.type !== "date") t.dtick < 1 ? e = a - .5 * t.dtick : (e -= .5, e + t.dtick < a && (e += t.dtick));else if (l < v * .1 && (i > v * .3 || u(a) || u(n))) {
          var h = t.dtick / 2;
          e += e + h < a ? h : -h;
        }
        return e;
      }
      function kG(e, r, t, a, n) {
        var i = br.findExactDates(r, n),
          l = .8;
        if (i.exactDays > l) {
          var o = Number(t.substr(1));
          i.exactYears > l && o % 12 === 0 ? e = Ve.tickIncrement(e, "M6", "reverse") + Ea * 1.5 : i.exactMonths > l ? e = Ve.tickIncrement(e, "M1", "reverse") + Ea * 15.5 : e -= _l;
          var s = Ve.tickIncrement(e, t);
          if (s <= a) return s;
        }
        return e;
      }
      Ve.prepMinorTicks = function (e, r, t) {
        if (!r.minor.dtick) {
          delete e.dtick;
          var a = r.dtick && zt(r._tmin),
            n;
          if (a) {
            var i = Ve.tickIncrement(r._tmin, r.dtick, !0);
            n = [r._tmin, i * .99 + r._tmin * .01];
          } else {
            var l = br.simpleMap(r.range, r.r2l);
            n = [l[0], .8 * l[0] + .2 * l[1]];
          }
          if (e.range = br.simpleMap(n, r.l2r), e._isMinor = !0, Ve.prepTicks(e, t), a) {
            var o = zt(r.dtick),
              s = zt(e.dtick),
              u = o ? r.dtick : +r.dtick.substring(1),
              f = s ? e.dtick : +e.dtick.substring(1);
            o && s ? Rm(u, f) ? u === 2 * un && f === 2 * Ea && (e.dtick = un) : u === 2 * un && f === 3 * Ea ? e.dtick = un : u === un && !(r._input.minor || {}).nticks ? e.dtick = Ea : h8(u / f, 2.5) ? e.dtick = u / 2 : e.dtick = u : String(r.dtick).charAt(0) === "M" ? s ? e.dtick = "M1" : Rm(u, f) ? u >= 12 && f === 2 && (e.dtick = "M3") : e.dtick = r.dtick : String(e.dtick).charAt(0) === "L" ? String(r.dtick).charAt(0) === "L" ? Rm(u, f) || (e.dtick = h8(u / f, 2.5) ? r.dtick / 2 : r.dtick) : e.dtick = "D1" : e.dtick === "D2" && +r.dtick > 1 && (e.dtick = 1);
          }
          e.range = r.range;
        }
        r.minor._tick0Init === void 0 && (e.tick0 = r.tick0);
      };
      function Rm(e, r) {
        return Math.abs((e / r + .5) % 1 - .5) < .001;
      }
      function h8(e, r) {
        return Math.abs(e / r - 1) < .001;
      }
      Ve.prepTicks = function (e, r) {
        var t = br.simpleMap(e.range, e.r2l, void 0, void 0, r);
        if (e.tickmode === "auto" || !e.dtick) {
          var a = e.nticks,
            n;
          a || (e.type === "category" || e.type === "multicategory" ? (n = e.tickfont ? br.bigFont(e.tickfont.size || 12) : 15, a = e._length / n) : (n = e._id.charAt(0) === "y" ? 40 : 80, a = br.constrain(e._length / n, 4, 9) + 1), e._name === "radialaxis" && (a *= 2)), e.minor && e.minor.tickmode !== "array" || e.tickmode === "array" && (a *= 100), e._roughDTick = Math.abs(t[1] - t[0]) / a, Ve.autoTicks(e, e._roughDTick), e._minDtick > 0 && e.dtick < e._minDtick * 2 && (e.dtick = e._minDtick, e.tick0 = e.l2r(e._forceTick0));
        }
        e.ticklabelmode === "period" && CG(e), e.tick0 || (e.tick0 = e.type === "date" ? "2000-01-01" : 0), e.type === "date" && e.dtick < .1 && (e.dtick = .1), M8(e);
      };
      function zm(e) {
        return +e.substring(1);
      }
      function CG(e) {
        var r;
        function t() {
          return !(zt(e.dtick) || e.dtick.charAt(0) !== "M");
        }
        var a = t(),
          n = Ve.getTickFormat(e);
        if (n) {
          var i = e._dtickInit !== e.dtick;
          /%[fLQsSMX]/.test(n) || (/%[HI]/.test(n) ? (r = Ti, i && !a && e.dtick < Ti && (e.dtick = Ti)) : /%p/.test(n) ? (r = _l, i && !a && e.dtick < _l && (e.dtick = _l)) : /%[Aadejuwx]/.test(n) ? (r = Ea, i && !a && e.dtick < Ea && (e.dtick = Ea)) : /%[UVW]/.test(n) ? (r = un, i && !a && e.dtick < un && (e.dtick = un)) : /%[Bbm]/.test(n) ? (r = Fs, i && (a ? zm(e.dtick) < 1 : e.dtick < S0) && (e.dtick = "M1")) : /%[q]/.test(n) ? (r = Fm, i && (a ? zm(e.dtick) < 3 : e.dtick < C0) && (e.dtick = "M3")) : /%[Yy]/.test(n) && (r = A0, i && (a ? zm(e.dtick) < 12 : e.dtick < k0) && (e.dtick = "M12")));
        }
        a = t(), a && e.tick0 === e._dowTick0 && (e.tick0 = e._rawTick0), e._definedDelta = r;
      }
      function SG(e, r, t) {
        for (var a = 0; a < e.length; a++) {
          var n = e[a].value,
            i = a,
            l = a + 1;
          a < e.length - 1 ? (i = a, l = a + 1) : a > 0 ? (i = a - 1, l = a) : (i = a, l = a);
          var o = e[i].value,
            s = e[l].value,
            u = Math.abs(s - o),
            f = t || u,
            v = 0;
          f >= k0 ? u >= k0 && u <= dG ? v = u : v = A0 : t === Fm && f >= C0 ? u >= C0 && u <= pG ? v = u : v = Fm : f >= S0 ? u >= S0 && u <= mG ? v = u : v = Fs : t === un && f >= un ? v = un : f >= Ea ? v = Ea : t === _l && f >= _l ? v = _l : t === Ti && f >= Ti && (v = Ti);
          var h;
          v >= u && (v = u, h = !0);
          var d = n + v;
          if (r.rangebreaks && v > 0) {
            for (var y = 84, g = 0, m = 0; m < y; m++) {
              var _ = (m + .5) / y;
              r.maskBreaks(n * (1 - _) + _ * d) !== E0 && g++;
            }
            v *= g / y, v || (e[a].drop = !0), h && u > un && (v = u);
          }
          (v > 0 || a === 0) && (e[a].periodX = n + v / 2);
        }
      }
      Ve.calcTicks = function (r, t) {
        for (var a = r.type, n = r.calendar, i = r.ticklabelstep, l = r.ticklabelmode === "period", o = r.range[0] > r.range[1], s = !r.ticklabelindex || br.isArrayOrTypedArray(r.ticklabelindex) ? r.ticklabelindex : [r.ticklabelindex], u = br.simpleMap(r.range, r.r2l, void 0, void 0, t), f = u[1] < u[0], v = Math.min(u[0], u[1]), h = Math.max(u[0], u[1]), d = Math.max(1e3, r._length || 0), y = [], g = [], m = [], _ = [], w = [], T = r.minor && (r.minor.ticks || r.minor.showgrid), b = 1; b >= (T ? 0 : 1); b--) {
          var A = !b;
          b ? (r._dtickInit = r.dtick, r._tick0Init = r.tick0) : (r.minor._dtickInit = r.minor.dtick, r.minor._tick0Init = r.minor.tick0);
          var S = b ? r : br.extendFlat({}, r, r.minor);
          if (A ? Ve.prepMinorTicks(S, r, t) : Ve.prepTicks(S, t), S.tickmode === "array") {
            b ? (m = [], y = d8(r, !A)) : (_ = [], g = d8(r, !A));
            continue;
          }
          if (S.tickmode === "sync") {
            m = [], y = LG(r);
            continue;
          }
          var k = Gm(u),
            q = k[0],
            D = k[1],
            R = zt(S.dtick),
            z = a === "log" && !(R || S.dtick.charAt(0) === "L"),
            N = Ve.tickFirst(S, t);
          if (b) {
            if (r._tmin = N, N < q !== f) break;
            (a === "category" || a === "multicategory") && (D = f ? Math.max(-.5, D) : Math.min(r._categories.length - .5, D));
          }
          var H = null,
            O = N,
            J;
          if (b) {
            var X;
            R ? X = r.dtick : a === "date" ? typeof r.dtick == "string" && r.dtick.charAt(0) === "M" && (X = Fs * r.dtick.substring(1)) : X = r._roughDTick, J = Math.round((r.r2l(O) - r.r2l(r.tick0)) / X) - 1;
          }
          var B = S.dtick;
          for (S.rangebreaks && S._tick0Init !== S.tick0 && (O = Nm(O, r), f || (O = Ve.tickIncrement(O, B, !f, n))), b && l && (O = Ve.tickIncrement(O, B, !f, n), J--); f ? O >= D : O <= D; O = Ve.tickIncrement(O, B, f, n)) {
            if (b && J++, S.rangebreaks && !f) {
              if (O < q) continue;
              if (S.maskBreaks(O) === E0 && Nm(O, S) >= h) break;
            }
            if (m.length > d || O === H) break;
            H = O;
            var I = {
              value: O
            };
            b ? (z && O !== (O | 0) && (I.simpleLabel = !0), i > 1 && J % i && (I.skipLabel = !0), m.push(I)) : (I.minor = !0, _.push(I));
          }
        }
        if (!_ || _.length < 2) s = !1;else {
          var V = (_[1].value - _[0].value) * (o ? -1 : 1);
          jG(V, r.tickformat) || (s = !1);
        }
        if (!s) w = m;else {
          var K = m.concat(_);
          l && m.length && (K = K.slice(1)), K = K.sort(function (Ie, Be) {
            return Ie.value - Be.value;
          }).filter(function (Ie, Be, Ne) {
            return Be === 0 || Ie.value !== Ne[Be - 1].value;
          });
          var Q = K.map(function (Ie, Be) {
            return Ie.minor === void 0 && !Ie.skipLabel ? Be : null;
          }).filter(function (Ie) {
            return Ie !== null;
          });
          Q.forEach(function (Ie) {
            s.map(function (Be) {
              var Ne = Ie + Be;
              Ne >= 0 && Ne < K.length && br.pushUnique(w, K[Ne]);
            });
          });
        }
        if (T) {
          var ie = r.minor.ticks === "inside" && r.ticks === "outside" || r.minor.ticks === "outside" && r.ticks === "inside";
          if (!ie) {
            for (var me = m.map(function (Ie) {
                return Ie.value;
              }), pe = [], ge = 0; ge < _.length; ge++) {
              var j = _[ge],
                _e = j.value;
              if (me.indexOf(_e) === -1) {
                for (var se = !1, Se = 0; !se && Se < m.length; Se++) 1e7 + m[Se].value === 1e7 + _e && (se = !0);
                se || pe.push(j);
              }
            }
            _ = pe;
          }
        }
        l && SG(w, r, r._definedDelta);
        var ve;
        if (r.rangebreaks) {
          var Ae = r._id.charAt(0) === "y",
            Y = 1;
          r.tickmode === "auto" && (Y = r.tickfont ? r.tickfont.size : 12);
          var re = NaN;
          for (ve = m.length - 1; ve > -1; ve--) {
            if (m[ve].drop) {
              m.splice(ve, 1);
              continue;
            }
            m[ve].value = Nm(m[ve].value, r);
            var U = r.c2p(m[ve].value);
            (Ae ? re > U - Y : re < U + Y) ? m.splice(f ? ve + 1 : ve, 1) : re = U;
          }
        }
        Zm(r) && Math.abs(u[1] - u[0]) === 360 && m.pop(), r._tmax = (m[m.length - 1] || {}).value, r._prevDateHead = "", r._inCalcTicks = !0;
        var de,
          be = function (Ie) {
            Ie.text = "", r._prevDateHead = de;
          };
        m = m.concat(_);
        function ye(Ie, Be) {
          var Ne = Ve.tickText(Ie, Be.value, !1, Be.simpleLabel),
            Ee = Be.periodX;
          return Ee !== void 0 && (Ne.periodX = Ee, (Ee > h || Ee < v) && (Ee > h && (Ne.periodX = h), Ee < v && (Ne.periodX = v), be(Ne))), Ne;
        }
        var Fe;
        for (ve = 0; ve < m.length; ve++) {
          var Re = m[ve].minor,
            Pe = m[ve].value;
          Re ? (s && w.indexOf(m[ve]) !== -1 ? Fe = ye(r, m[ve]) : Fe = {
            x: Pe
          }, Fe.minor = !0, g.push(Fe)) : (de = r._prevDateHead, Fe = ye(r, m[ve]), (m[ve].skipLabel || s && w.indexOf(m[ve]) === -1) && be(Fe), y.push(Fe));
        }
        return y = y.concat(g), r._inCalcTicks = !1, l && y.length && (y[0].noTick = !0), y;
      };
      function _8(e, r) {
        return e.rangebreaks && (r = r.filter(function (t) {
          return e.maskBreaks(t.x) !== E0;
        })), r;
      }
      function LG(e) {
        var r = e._mainAxis,
          t = [];
        if (r._vals) {
          for (var a = 0; a < r._vals.length; a++) if (!r._vals[a].noTick) {
            var n = r.l2p(r._vals[a].x),
              i = e.p2l(n),
              l = Ve.tickText(e, i);
            r._vals[a].minor && (l.minor = !0, l.text = ""), t.push(l);
          }
        }
        return t = _8(e, t), t;
      }
      function d8(e, r) {
        var t = br.simpleMap(e.range, e.r2l),
          a = Gm(t),
          n = Math.min(a[0], a[1]),
          i = Math.max(a[0], a[1]),
          l = e.type === "category" ? e.d2l_noadd : e.d2l;
        e.type === "log" && String(e.dtick).charAt(0) !== "L" && (e.dtick = "L" + Math.pow(10, Math.floor(Math.min(e.range[0], e.range[1])) - 1));
        for (var o = [], s = 0; s <= 1; s++) if (!(r !== void 0 && (r && s || r === !1 && !s)) && !(s && !e.minor)) {
          var u = s ? e.minor.tickvals : e.tickvals,
            f = s ? [] : e.ticktext;
          if (u) {
            br.isArrayOrTypedArray(f) || (f = []);
            for (var v = 0; v < u.length; v++) {
              var h = l(u[v]);
              if (h > n && h < i) {
                var d = Ve.tickText(e, h, !1, String(f[v]));
                s && (d.minor = !0, d.text = ""), o.push(d);
              }
            }
          }
        }
        return o = _8(e, o), o;
      }
      var T0 = [2, 5, 10],
        p8 = [1, 2, 3, 6, 12],
        m8 = [1, 2, 5, 10, 15, 30],
        qG = [1, 2, 3, 7, 14],
        w8 = [-.046, 0, .301, .477, .602, .699, .778, .845, .903, .954, 1],
        T8 = [-.301, 0, .301, .699, 1],
        DG = [15, 30, 45, 90, 180];
      function wi(e, r, t) {
        return r * br.roundUp(e / r, t);
      }
      Ve.autoTicks = function (e, r, t) {
        var a;
        function n(v) {
          return Math.pow(v, Math.floor(Math.log(r) / Math.LN10));
        }
        if (e.type === "date") {
          e.tick0 = br.dateTick0(e.calendar, 0);
          var i = 2 * r;
          if (i > A0) r /= A0, a = n(10), e.dtick = "M" + 12 * wi(r, a, T0);else if (i > Fs) r /= Fs, e.dtick = "M" + wi(r, 1, p8);else if (i > Ea) {
            if (e.dtick = wi(r, Ea, e._hasDayOfWeekBreaks ? [1, 2, 7, 14] : qG), !t) {
              var l = Ve.getTickFormat(e),
                o = e.ticklabelmode === "period";
              o && (e._rawTick0 = e.tick0), /%[uVW]/.test(l) ? e.tick0 = br.dateTick0(e.calendar, 2) : e.tick0 = br.dateTick0(e.calendar, 1), o && (e._dowTick0 = e.tick0);
            }
          } else i > Ti ? e.dtick = wi(r, Ti, p8) : i > df ? e.dtick = wi(r, df, m8) : i > L0 ? e.dtick = wi(r, L0, m8) : (a = n(10), e.dtick = wi(r, a, T0));
        } else if (e.type === "log") {
          e.tick0 = 0;
          var s = br.simpleMap(e.range, e.r2l);
          if (e._isMinor && (r *= 1.5), r > .7) e.dtick = Math.ceil(r);else if (Math.abs(s[1] - s[0]) < 1) {
            var u = 1.5 * Math.abs((s[1] - s[0]) / r);
            r = Math.abs(Math.pow(10, s[1]) - Math.pow(10, s[0])) / u, a = n(10), e.dtick = "L" + wi(r, a, T0);
          } else e.dtick = r > .3 ? "D2" : "D1";
        } else e.type === "category" || e.type === "multicategory" ? (e.tick0 = 0, e.dtick = Math.ceil(Math.max(r, 1))) : Zm(e) ? (e.tick0 = 0, a = 1, e.dtick = wi(r, a, DG)) : (e.tick0 = 0, a = n(10), e.dtick = wi(r, a, T0));
        if (e.dtick === 0 && (e.dtick = 1), !zt(e.dtick) && typeof e.dtick != "string") {
          var f = e.dtick;
          throw e.dtick = 1, "ax.dtick error: " + String(f);
        }
      };
      function M8(e) {
        var r = e.dtick;
        if (e._tickexponent = 0, !zt(r) && typeof r != "string" && (r = 1), (e.type === "category" || e.type === "multicategory") && (e._tickround = null), e.type === "date") {
          var t = e.r2l(e.tick0),
            a = e.l2r(t).replace(/(^-|i)/g, ""),
            n = a.length;
          if (String(r).charAt(0) === "M") n > 10 || a.substr(5) !== "01-01" ? e._tickround = "d" : e._tickround = +r.substr(1) % 12 === 0 ? "y" : "m";else if (r >= Ea && n <= 10 || r >= Ea * 15) e._tickround = "d";else if (r >= df && n <= 16 || r >= Ti) e._tickround = "M";else if (r >= L0 && n <= 19 || r >= df) e._tickround = "S";else {
            var i = e.l2r(t + r).replace(/^-/, "").length;
            e._tickround = Math.max(n, i) - 20, e._tickround < 0 && (e._tickround = 4);
          }
        } else if (zt(r) || r.charAt(0) === "L") {
          var l = e.range.map(e.r2d || Number);
          zt(r) || (r = Number(r.substr(1))), e._tickround = 2 - Math.floor(Math.log(r) / Math.LN10 + .01);
          var o = Math.max(Math.abs(l[0]), Math.abs(l[1])),
            s = Math.floor(Math.log(o) / Math.LN10 + .01),
            u = e.minexponent === void 0 ? 3 : e.minexponent;
          Math.abs(s) > u && (D0(e.exponentformat) && !Vm(s) ? e._tickexponent = 3 * Math.round((s - 1) / 3) : e._tickexponent = s);
        } else e._tickround = null;
      }
      Ve.tickIncrement = function (e, r, t, a) {
        var n = t ? -1 : 1;
        if (zt(r)) return br.increment(e, n * r);
        var i = r.charAt(0),
          l = n * Number(r.substr(1));
        if (i === "M") return br.incrementMonth(e, l, a);
        if (i === "L") return Math.log(Math.pow(10, e) + l) / Math.LN10;
        if (i === "D") {
          var o = r === "D2" ? T8 : w8,
            s = e + n * .01,
            u = br.roundUp(br.mod(s, 1), o, t);
          return Math.floor(s) + Math.log(Mn.round(Math.pow(10, u), 1)) / Math.LN10;
        }
        throw "unrecognized dtick " + String(r);
      };
      Ve.tickFirst = function (e, r) {
        var t = e.r2l || Number,
          a = br.simpleMap(e.range, t, void 0, void 0, r),
          n = a[1] < a[0],
          i = n ? Math.floor : Math.ceil,
          l = Gm(a)[0],
          o = e.dtick,
          s = t(e.tick0);
        if (zt(o)) {
          var u = i((l - s) / o) * o + s;
          return (e.type === "category" || e.type === "multicategory") && (u = br.constrain(u, 0, e._categories.length - 1)), u;
        }
        var f = o.charAt(0),
          v = Number(o.substr(1));
        if (f === "M") {
          for (var h = 0, d = s, y, g, m; h < 10;) {
            if (y = Ve.tickIncrement(d, o, n, e.calendar), (y - l) * (d - l) <= 0) return n ? Math.min(d, y) : Math.max(d, y);
            g = (l - (d + y) / 2) / (y - d), m = f + (Math.abs(Math.round(g)) || 1) * v, d = Ve.tickIncrement(d, m, g < 0 ? !n : n, e.calendar), h++;
          }
          return br.error("tickFirst did not converge", e), d;
        } else {
          if (f === "L") return Math.log(i((Math.pow(10, l) - s) / v) * v + s) / Math.LN10;
          if (f === "D") {
            var _ = o === "D2" ? T8 : w8,
              w = br.roundUp(br.mod(l, 1), _, n);
            return Math.floor(l) + Math.log(Mn.round(Math.pow(10, w), 1)) / Math.LN10;
          } else throw "unrecognized dtick " + String(o);
        }
      };
      Ve.tickText = function (e, r, t, a) {
        var n = A8(e, r),
          i = e.tickmode === "array",
          l = t || i,
          o = e.type,
          s = o === "category" ? e.d2l_noadd : e.d2l,
          u,
          f = function (m) {
            var _ = e.l2p(m);
            return _ >= 0 && _ <= e._length ? m : null;
          };
        if (i && br.isArrayOrTypedArray(e.ticktext)) {
          var v = br.simpleMap(e.range, e.r2l),
            h = (Math.abs(v[1] - v[0]) - (e._lBreaks || 0)) / 1e4;
          for (u = 0; u < e.ticktext.length && !(Math.abs(r - s(e.tickvals[u])) < h); u++);
          if (u < e.ticktext.length) return n.text = String(e.ticktext[u]), n.xbnd = [f(n.x - .5), f(n.x + e.dtick - .5)], n;
        }
        function d(m) {
          if (m === void 0) return !0;
          if (t) return m === "none";
          var _ = {
            first: e._tmin,
            last: e._tmax
          }[m];
          return m !== "all" && r !== _;
        }
        var y = t ? "never" : e.exponentformat !== "none" && d(e.showexponent) ? "hide" : "";
        if (o === "date" ? EG(e, n, t, l) : o === "log" ? PG(e, n, t, l, y) : o === "category" ? RG(e, n) : o === "multicategory" ? zG(e, n, t) : Zm(e) ? FG(e, n, t, l, y) : NG(e, n, t, l, y), a || (e.tickprefix && !d(e.showtickprefix) && (n.text = e.tickprefix + n.text), e.ticksuffix && !d(e.showticksuffix) && (n.text += e.ticksuffix)), e.labelalias && e.labelalias.hasOwnProperty(n.text)) {
          var g = e.labelalias[n.text];
          typeof g == "string" && (n.text = g);
        }
        return (e.tickson === "boundaries" || e.showdividers) && (n.xbnd = [f(n.x - .5), f(n.x + e.dtick - .5)]), n;
      };
      Ve.hoverLabelText = function (e, r, t) {
        t && (e = br.extendFlat({}, e, {
          hoverformat: t
        }));
        var a = br.isArrayOrTypedArray(r) ? r[0] : r,
          n = br.isArrayOrTypedArray(r) ? r[1] : void 0;
        if (n !== void 0 && n !== a) return Ve.hoverLabelText(e, a, t) + " - " + Ve.hoverLabelText(e, n, t);
        var i = e.type === "log" && a <= 0,
          l = Ve.tickText(e, e.c2l(i ? -a : a), "hover").text;
        return i ? a === 0 ? "0" : bo + l : l;
      };
      function A8(e, r, t) {
        var a = e.tickfont || {};
        return {
          x: r,
          dx: 0,
          dy: 0,
          text: t || "",
          fontSize: a.size,
          font: a.family,
          fontWeight: a.weight,
          fontStyle: a.style,
          fontVariant: a.variant,
          fontTextcase: a.textcase,
          fontLineposition: a.lineposition,
          fontShadow: a.shadow,
          fontColor: a.color
        };
      }
      function EG(e, r, t, a) {
        var n = e._tickround,
          i = t && e.hoverformat || Ve.getTickFormat(e);
        a = !i && a, a && (zt(n) ? n = 4 : n = {
          y: "m",
          m: "d",
          d: "M",
          M: "S",
          S: 4
        }[n]);
        var l = br.formatDate(r.x, i, n, e._dateFormat, e.calendar, e._extraFormat),
          o,
          s = l.indexOf(`
`);
        if (s !== -1 && (o = l.substr(s + 1), l = l.substr(0, s)), a && (o !== void 0 && (l === "00:00:00" || l === "00:00") ? (l = o, o = "") : l.length === 8 && (l = l.replace(/:00$/, ""))), o) if (t) n === "d" ? l += ", " + o : l = o + (l ? ", " + l : "");else if (!e._inCalcTicks || e._prevDateHead !== o) e._prevDateHead = o, l += "<br>" + o;else {
          var u = yf(e),
            f = e._trueSide || e.side;
          (!u && f === "top" || u && f === "bottom") && (l += "<br> ");
        }
        r.text = l;
      }
      function PG(e, r, t, a, n) {
        var i = e.dtick,
          l = r.x,
          o = e.tickformat,
          s = typeof i == "string" && i.charAt(0);
        if (n === "never" && (n = ""), a && s !== "L" && (i = "L3", s = "L"), o || s === "L") r.text = mf(Math.pow(10, l), e, n, a);else if (zt(i) || s === "D" && br.mod(l + .01, 1) < .1) {
          var u = Math.round(l),
            f = Math.abs(u),
            v = e.exponentformat;
          v === "power" || D0(v) && Vm(u) ? (u === 0 ? r.text = 1 : u === 1 ? r.text = "10" : r.text = "10<sup>" + (u > 1 ? "" : bo) + f + "</sup>", r.fontSize *= 1.25) : (v === "e" || v === "E") && f > 2 ? r.text = "1" + v + (u > 0 ? "+" : bo) + f : (r.text = mf(Math.pow(10, l), e, "", "fakehover"), i === "D1" && e._id.charAt(0) === "y" && (r.dy -= r.fontSize / 6));
        } else if (s === "D") r.text = String(Math.round(Math.pow(10, br.mod(l, 1)))), r.fontSize *= .75;else throw "unrecognized dtick " + String(i);
        if (e.dtick === "D1") {
          var h = String(r.text).charAt(0);
          (h === "0" || h === "1") && (e._id.charAt(0) === "y" ? r.dx -= r.fontSize / 4 : (r.dy += r.fontSize / 2, r.dx += (e.range[1] > e.range[0] ? 1 : -1) * r.fontSize * (l < 0 ? .5 : .25)));
        }
      }
      function RG(e, r) {
        var t = e._categories[Math.round(r.x)];
        t === void 0 && (t = ""), r.text = String(t);
      }
      function zG(e, r, t) {
        var a = Math.round(r.x),
          n = e._categories[a] || [],
          i = n[1] === void 0 ? "" : String(n[1]),
          l = n[0] === void 0 ? "" : String(n[0]);
        t ? r.text = l + " - " + i : (r.text = i, r.text2 = l);
      }
      function NG(e, r, t, a, n) {
        n === "never" ? n = "" : e.showexponent === "all" && Math.abs(r.x / e.dtick) < 1e-6 && (n = "hide"), r.text = mf(r.x, e, n, a);
      }
      function FG(e, r, t, a, n) {
        if (e.thetaunit === "radians" && !t) {
          var i = r.x / 180;
          if (i === 0) r.text = "0";else {
            var l = IG(i);
            if (l[1] >= 100) r.text = mf(br.deg2rad(r.x), e, n, a);else {
              var o = r.x < 0;
              l[1] === 1 ? l[0] === 1 ? r.text = "\u03C0" : r.text = l[0] + "\u03C0" : r.text = ["<sup>", l[0], "</sup>", "\u2044", "<sub>", l[1], "</sub>", "\u03C0"].join(""), o && (r.text = bo + r.text);
            }
          }
        } else r.text = mf(r.x, e, n, a);
      }
      function IG(e) {
        function r(o, s) {
          return Math.abs(o - s) <= 1e-6;
        }
        function t(o, s) {
          return r(s, 0) ? o : t(s, o % s);
        }
        function a(o) {
          for (var s = 1; !r(Math.round(o * s) / s, o);) s *= 10;
          return s;
        }
        var n = a(e),
          i = e * n,
          l = Math.abs(t(i, n));
        return [Math.round(i / l), Math.round(n / l)];
      }
      var HG = ["f", "p", "n", "\u03BC", "m", "", "k", "M", "G", "T"];
      function D0(e) {
        return e === "SI" || e === "B";
      }
      function Vm(e) {
        return e > 14 || e < -15;
      }
      function mf(e, r, t, a) {
        var n = e < 0,
          i = r._tickround,
          l = t || r.exponentformat || "B",
          o = r._tickexponent,
          s = Ve.getTickFormat(r),
          u = r.separatethousands;
        if (a) {
          var f = {
            exponentformat: l,
            minexponent: r.minexponent,
            dtick: r.showexponent === "none" ? r.dtick : zt(e) && Math.abs(e) || 1,
            range: r.showexponent === "none" ? r.range.map(r.r2d) : [0, e || 1]
          };
          M8(f), i = (Number(f._tickround) || 0) + 4, o = f._tickexponent, r.hoverformat && (s = r.hoverformat);
        }
        if (s) return r._numFormat(s)(e).replace(/-/g, bo);
        var v = Math.pow(10, -i) / 2;
        if (l === "none" && (o = 0), e = Math.abs(e), e < v) e = "0", n = !1;else {
          if (e += v, o && (e *= Math.pow(10, -o), i += o), i === 0) e = String(Math.floor(e));else if (i < 0) {
            e = String(Math.round(e)), e = e.substr(0, e.length + i);
            for (var h = i; h < 0; h++) e += "0";
          } else {
            e = String(e);
            var d = e.indexOf(".") + 1;
            d && (e = e.substr(0, d + i).replace(/\.?0+$/, ""));
          }
          e = br.numSeparate(e, r._separators, u);
        }
        if (o && l !== "hide") {
          D0(l) && Vm(o) && (l = "power");
          var y;
          o < 0 ? y = bo + -o : l !== "power" ? y = "+" + o : y = String(o), l === "e" || l === "E" ? e += l + y : l === "power" ? e += "\xD710<sup>" + y + "</sup>" : l === "B" && o === 9 ? e += "B" : D0(l) && (e += HG[o / 3 + 5]);
        }
        return n ? bo + e : e;
      }
      Ve.getTickFormat = function (e) {
        var r;
        function t(s) {
          return typeof s != "string" ? s : Number(s.replace("M", "")) * Fs;
        }
        function a(s, u) {
          var f = ["L", "D"];
          if (typeof s == typeof u) {
            if (typeof s == "number") return s - u;
            var v = f.indexOf(s.charAt(0)),
              h = f.indexOf(u.charAt(0));
            return v === h ? Number(s.replace(/(L|D)/g, "")) - Number(u.replace(/(L|D)/g, "")) : v - h;
          } else return typeof s == "number" ? 1 : -1;
        }
        function n(s, u, f) {
          var v = f || function (y) {
              return y;
            },
            h = u[0],
            d = u[1];
          return (!h && typeof h != "number" || v(h) <= v(s)) && (!d && typeof d != "number" || v(d) >= v(s));
        }
        function i(s, u) {
          var f = u[0] === null,
            v = u[1] === null,
            h = a(s, u[0]) >= 0,
            d = a(s, u[1]) <= 0;
          return (f || h) && (v || d);
        }
        var l, o;
        if (e.tickformatstops && e.tickformatstops.length > 0) switch (e.type) {
          case "date":
          case "linear":
            {
              for (r = 0; r < e.tickformatstops.length; r++) if (o = e.tickformatstops[r], o.enabled && n(e.dtick, o.dtickrange, t)) {
                l = o;
                break;
              }
              break;
            }
          case "log":
            {
              for (r = 0; r < e.tickformatstops.length; r++) if (o = e.tickformatstops[r], o.enabled && i(e.dtick, o.dtickrange)) {
                l = o;
                break;
              }
              break;
            }
          default:
        }
        return l ? l.value : e.tickformat;
      };
      Ve.getSubplots = function (e, r) {
        var t = e._fullLayout._subplots,
          a = t.cartesian.concat(t.gl2d || []),
          n = r ? Ve.findSubplotsWithAxis(a, r) : a;
        return n.sort(function (i, l) {
          var o = i.substr(1).split("y"),
            s = l.substr(1).split("y");
          return o[0] === s[0] ? +o[1] - +s[1] : +o[0] - +s[0];
        }), n;
      };
      Ve.findSubplotsWithAxis = function (e, r) {
        for (var t = new RegExp(r._id.charAt(0) === "x" ? "^" + r._id + "y" : r._id + "$"), a = [], n = 0; n < e.length; n++) {
          var i = e[n];
          t.test(i) && a.push(i);
        }
        return a;
      };
      Ve.makeClipPaths = function (e) {
        var r = e._fullLayout;
        if (!r._hasOnlyLargeSploms) {
          var t = {
              _offset: 0,
              _length: r.width,
              _id: ""
            },
            a = {
              _offset: 0,
              _length: r.height,
              _id: ""
            },
            n = Ve.list(e, "x", !0),
            i = Ve.list(e, "y", !0),
            l = [],
            o,
            s;
          for (o = 0; o < n.length; o++) for (l.push({
            x: n[o],
            y: a
          }), s = 0; s < i.length; s++) o === 0 && l.push({
            x: t,
            y: i[s]
          }), l.push({
            x: n[o],
            y: i[s]
          });
          var u = r._clips.selectAll(".axesclip").data(l, function (f) {
            return f.x._id + f.y._id;
          });
          u.enter().append("clipPath").classed("axesclip", !0).attr("id", function (f) {
            return "clip" + r._uid + f.x._id + f.y._id;
          }).append("rect"), u.exit().remove(), u.each(function (f) {
            Mn.select(this).select("rect").attr({
              x: f.x._offset || 0,
              y: f.y._offset || 0,
              width: f.x._length || 1,
              height: f.y._length || 1
            });
          });
        }
      };
      Ve.draw = function (e, r, t) {
        var a = e._fullLayout;
        r === "redraw" && a._paper.selectAll("g.subplot").each(function (s) {
          var u = s[0],
            f = a._plots[u];
          if (f) {
            var v = f.xaxis,
              h = f.yaxis;
            f.xaxislayer.selectAll("." + v._id + "tick").remove(), f.yaxislayer.selectAll("." + h._id + "tick").remove(), f.xaxislayer.selectAll("." + v._id + "tick2").remove(), f.yaxislayer.selectAll("." + h._id + "tick2").remove(), f.xaxislayer.selectAll("." + v._id + "divider").remove(), f.yaxislayer.selectAll("." + h._id + "divider").remove(), f.minorGridlayer && f.minorGridlayer.selectAll("path").remove(), f.gridlayer && f.gridlayer.selectAll("path").remove(), f.zerolinelayer && f.zerolinelayer.selectAll("path").remove(), a._infolayer.select(".g-" + v._id + "title").remove(), a._infolayer.select(".g-" + h._id + "title").remove();
          }
        });
        var n = !r || r === "redraw" ? Ve.listIds(e) : r,
          i = Ve.list(e),
          l = i.filter(function (s) {
            return s.autoshift;
          }).map(function (s) {
            return s.overlaying;
          });
        n.map(function (s) {
          var u = Ve.getFromId(e, s);
          if (u.tickmode === "sync" && u.overlaying) {
            var f = n.findIndex(function (v) {
              return v === u.overlaying;
            });
            f >= 0 && n.unshift(n.splice(f, 1).shift());
          }
        });
        var o = {
          false: {
            left: 0,
            right: 0
          }
        };
        return br.syncOrAsync(n.map(function (s) {
          return function () {
            if (s) {
              var u = Ve.getFromId(e, s);
              t || (t = {}), t.axShifts = o, t.overlayingShiftedAx = l;
              var f = Ve.drawOne(e, u, t);
              return u._shiftPusher && Um(u, u._fullDepth || 0, o, !0), u._r = u.range.slice(), u._rl = br.simpleMap(u._r, u.r2l), f;
            }
          };
        }));
      };
      Ve.drawOne = function (e, r, t) {
        t = t || {};
        var a = t.axShifts || {},
          n = t.overlayingShiftedAx || [],
          i,
          l,
          o;
        r.setScale();
        var s = e._fullLayout,
          u = r._id,
          f = u.charAt(0),
          v = Ve.counterLetter(u),
          h = s._plots[r._mainSubplot];
        if (!h) return;
        if (r._shiftPusher = r.autoshift || n.indexOf(r._id) !== -1 || n.indexOf(r.overlaying) !== -1, r._shiftPusher & r.anchor === "free") {
          var d = r.linewidth / 2 || 0;
          r.ticks === "inside" && (d += r.ticklen), Um(r, d, a, !0), Um(r, r.shift || 0, a, !1);
        }
        (t.skipTitle !== !0 || r._shift === void 0) && (r._shift = $G(r, a));
        var y = h[f + "axislayer"],
          g = r._mainLinePosition,
          m = g += r._shift,
          _ = r._mainMirrorPosition,
          w = r._vals = Ve.calcTicks(r),
          T = [r.mirror, m, _].join("_");
        for (i = 0; i < w.length; i++) w[i].axInfo = T;
        r._selections = {}, r._tickAngles && (r._prevTickAngles = r._tickAngles), r._tickAngles = {}, r._depth = null;
        var b = {};
        function A(Re) {
          var Pe = u + (Re || "tick");
          return b[Pe] || (b[Pe] = UG(r, Pe, m)), b[Pe];
        }
        if (r.visible) {
          var S = Ve.makeTransTickFn(r),
            k = Ve.makeTransTickLabelFn(r),
            q,
            D,
            R = r.ticks === "inside",
            z = r.ticks === "outside";
          if (r.tickson === "boundaries") {
            var N = OG(r, w);
            D = Ve.clipEnds(r, N), q = R ? D : N;
          } else D = Ve.clipEnds(r, w), q = R && r.ticklabelmode !== "period" ? D : w;
          var H = r._gridVals = D,
            O = YG(r, w);
          if (!s._hasOnlyLargeSploms) {
            var J = r._subplotsWith,
              X = {};
            for (i = 0; i < J.length; i++) {
              l = J[i], o = s._plots[l];
              var B = o[v + "axis"],
                I = B._mainAxis._id;
              if (!X[I]) {
                X[I] = 1;
                var V = f === "x" ? "M0," + B._offset + "v" + B._length : "M" + B._offset + ",0h" + B._length;
                Ve.drawGrid(e, r, {
                  vals: H,
                  counterAxis: B,
                  layer: o.gridlayer.select("." + u),
                  minorLayer: o.minorGridlayer.select("." + u),
                  path: V,
                  transFn: S
                }), Ve.drawZeroLine(e, r, {
                  counterAxis: B,
                  layer: o.zerolinelayer,
                  path: V,
                  transFn: S
                });
              }
            }
          }
          var K,
            Q = Ve.getTickSigns(r),
            ie = Ve.getTickSigns(r, "minor");
          if (r.ticks || r.minor && r.minor.ticks) {
            var me = Ve.makeTickPath(r, m, Q[2]),
              pe = Ve.makeTickPath(r, m, ie[2], {
                minor: !0
              }),
              ge,
              j,
              _e,
              se;
            if (r._anchorAxis && r.mirror && r.mirror !== !0 ? (ge = Ve.makeTickPath(r, _, Q[3]), j = Ve.makeTickPath(r, _, ie[3], {
              minor: !0
            }), _e = me + ge, se = pe + j) : (ge = "", j = "", _e = me, se = pe), r.showdividers && z && r.tickson === "boundaries") {
              var Se = {};
              for (i = 0; i < O.length; i++) Se[O[i].x] = 1;
              K = function (Re) {
                return Se[Re.x] ? ge : _e;
              };
            } else K = function (Re) {
              return Re.minor ? se : _e;
            };
          }
          if (Ve.drawTicks(e, r, {
            vals: q,
            layer: y,
            path: K,
            transFn: S
          }), r.mirror === "allticks") {
            var ve = Object.keys(r._linepositions || {});
            for (i = 0; i < ve.length; i++) {
              l = ve[i], o = s._plots[l];
              var Ae = r._linepositions[l] || [],
                Y = Ae[0],
                re = Ae[1],
                U = Ae[2],
                de = Ve.makeTickPath(r, Y, U ? Q[0] : ie[0], {
                  minor: U
                }) + Ve.makeTickPath(r, re, U ? Q[1] : ie[1], {
                  minor: U
                });
              Ve.drawTicks(e, r, {
                vals: q,
                layer: o[f + "axislayer"],
                path: de,
                transFn: S
              });
            }
          }
          var be = [];
          if (be.push(function () {
            return Ve.drawLabels(e, r, {
              vals: w,
              layer: y,
              plotinfo: o,
              transFn: k,
              labelFns: Ve.makeLabelFns(r, m)
            });
          }), r.type === "multicategory") {
            var ye = {
              x: 2,
              y: 10
            }[f];
            be.push(function () {
              var Re = {
                  x: "height",
                  y: "width"
                }[f],
                Pe = A()[Re] + ye + (r._tickAngles[u + "tick"] ? r.tickfont.size * pf : 0);
              return Ve.drawLabels(e, r, {
                vals: BG(r, w),
                layer: y,
                cls: u + "tick2",
                repositionOnUpdate: !0,
                secondary: !0,
                transFn: S,
                labelFns: Ve.makeLabelFns(r, m + Pe * Q[4])
              });
            }), be.push(function () {
              return r._depth = Q[4] * (A("tick2")[r.side] - m), VG(e, r, {
                vals: O,
                layer: y,
                path: Ve.makeTickPath(r, m, Q[4], {
                  len: r._depth
                }),
                transFn: S
              });
            });
          } else r.title.hasOwnProperty("standoff") && be.push(function () {
            r._depth = Q[4] * (A()[r.side] - m);
          });
          var Fe = vf.getComponentMethod("rangeslider", "isVisible")(r);
          return !t.skipTitle && !(Fe && r.side === "bottom") && be.push(function () {
            return WG(e, r);
          }), be.push(function () {
            var Re = r.side.charAt(0),
              Pe = bG[r.side].charAt(0),
              Ie = Ve.getPxPosition(e, r),
              Be = z ? r.ticklen : 0,
              Ne,
              Ee,
              Je,
              We;
            (r.automargin || Fe || r._shiftPusher) && (r.type === "multicategory" ? Ne = A("tick2") : (Ne = A(), f === "x" && Re === "b" && (r._depth = Math.max(Ne.width > 0 ? Ne.bottom - Ie : 0, Be))));
            var ne = 0,
              Me = 0;
            if (r._shiftPusher && (ne = Math.max(Be, Ne.height > 0 ? Re === "l" ? Ie - Ne.left : Ne.right - Ie : 0), r.title.text !== s._dfltTitle[f] && (Me = (r._titleStandoff || 0) + (r._titleScoot || 0), Re === "l" && (Me += g8(r))), r._fullDepth = Math.max(ne, Me)), r.automargin) {
              Ee = {
                x: 0,
                y: 0,
                r: 0,
                l: 0,
                t: 0,
                b: 0
              };
              var Ce = [0, 1],
                cr = typeof r._shift == "number" ? r._shift : 0;
              if (f === "x") {
                if (Re === "b" ? Ee[Re] = r._depth : (Ee[Re] = r._depth = Math.max(Ne.width > 0 ? Ie - Ne.top : 0, Be), Ce.reverse()), Ne.width > 0) {
                  var tr = Ne.right - (r._offset + r._length);
                  tr > 0 && (Ee.xr = 1, Ee.r = tr);
                  var De = r._offset - Ne.left;
                  De > 0 && (Ee.xl = 0, Ee.l = De);
                }
              } else if (Re === "l" ? (r._depth = Math.max(Ne.height > 0 ? Ie - Ne.left : 0, Be), Ee[Re] = r._depth - cr) : (r._depth = Math.max(Ne.height > 0 ? Ne.right - Ie : 0, Be), Ee[Re] = r._depth + cr, Ce.reverse()), Ne.height > 0) {
                var Le = Ne.bottom - (r._offset + r._length);
                Le > 0 && (Ee.yb = 0, Ee.b = Le);
                var Ye = r._offset - Ne.top;
                Ye > 0 && (Ee.yt = 1, Ee.t = Ye);
              }
              Ee[v] = r.anchor === "free" ? r.position : r._anchorAxis.domain[Ce[0]], r.title.text !== s._dfltTitle[f] && (Ee[Re] += g8(r) + (r.title.standoff || 0)), r.mirror && r.anchor !== "free" && (Je = {
                x: 0,
                y: 0,
                r: 0,
                l: 0,
                t: 0,
                b: 0
              }, Je[Pe] = r.linewidth, r.mirror && r.mirror !== !0 && (Je[Pe] += Be), r.mirror === !0 || r.mirror === "ticks" ? Je[v] = r._anchorAxis.domain[Ce[1]] : (r.mirror === "all" || r.mirror === "allticks") && (Je[v] = [r._counterDomainMin, r._counterDomainMax][Ce[1]]));
            }
            Fe && (We = vf.getComponentMethod("rangeslider", "autoMarginOpts")(e, r)), typeof r.automargin == "string" && (y8(Ee, r.automargin), y8(Je, r.automargin)), zs.autoMargin(e, Wm(r), Ee), zs.autoMargin(e, C8(r), Je), zs.autoMargin(e, S8(r), We);
          }), br.syncOrAsync(be);
        }
      };
      function y8(e, r) {
        if (e) {
          var t = Object.keys(f8).reduce(function (a, n) {
            return r.indexOf(n) !== -1 && f8[n].forEach(function (i) {
              a[i] = 1;
            }), a;
          }, {});
          Object.keys(e).forEach(function (a) {
            t[a] || (a.length === 1 ? e[a] = 0 : delete e[a]);
          });
        }
      }
      function OG(e, r) {
        var t = [],
          a,
          n = function (i, l) {
            var o = i.xbnd[l];
            o !== null && t.push(br.extendFlat({}, i, {
              x: o
            }));
          };
        if (r.length) {
          for (a = 0; a < r.length; a++) n(r[a], 0);
          n(r[a - 1], 1);
        }
        return t;
      }
      function BG(e, r) {
        for (var t = [], a = {}, n = 0; n < r.length; n++) {
          var i = r[n];
          a[i.text2] ? a[i.text2].push(i.x) : a[i.text2] = [i.x];
        }
        for (var l in a) t.push(A8(e, br.interp(a[l], .5), l));
        return t;
      }
      function YG(e, r) {
        var t = [],
          a,
          n,
          i = r.length && r[r.length - 1].x < r[0].x,
          l = function (s, u) {
            var f = s.xbnd[u];
            f !== null && t.push(br.extendFlat({}, s, {
              x: f
            }));
          };
        if (e.showdividers && r.length) {
          for (a = 0; a < r.length; a++) {
            var o = r[a];
            o.text2 !== n && l(o, i ? 1 : 0), n = o.text2;
          }
          l(r[a - 1], i ? 0 : 1);
        }
        return t;
      }
      function UG(e, r, t) {
        var a, n, i, l;
        if (e._selections[r].size()) a = 1 / 0, n = -1 / 0, i = 1 / 0, l = -1 / 0, e._selections[r].each(function () {
          var s = Ym(this),
            u = sn.bBox(s.node().parentNode);
          a = Math.min(a, u.top), n = Math.max(n, u.bottom), i = Math.min(i, u.left), l = Math.max(l, u.right);
        });else {
          var o = Ve.makeLabelFns(e, t);
          a = n = o.yFn({
            dx: 0,
            dy: 0,
            fontSize: 0
          }), i = l = o.xFn({
            dx: 0,
            dy: 0,
            fontSize: 0
          });
        }
        return {
          top: a,
          bottom: n,
          left: i,
          right: l,
          height: n - a,
          width: l - i
        };
      }
      Ve.getTickSigns = function (e, r) {
        var t = e._id.charAt(0),
          a = {
            x: "top",
            y: "right"
          }[t],
          n = e.side === a ? 1 : -1,
          i = [-1, 1, n, -n],
          l = r ? (e.minor || {}).ticks : e.ticks;
        return l !== "inside" == (t === "x") && (i = i.map(function (o) {
          return -o;
        })), e.side && i.push({
          l: -1,
          t: -1,
          r: 1,
          b: 1
        }[e.side.charAt(0)]), i;
      };
      Ve.makeTransTickFn = function (e) {
        return e._id.charAt(0) === "x" ? function (r) {
          return Ns(e._offset + e.l2p(r.x), 0);
        } : function (r) {
          return Ns(0, e._offset + e.l2p(r.x));
        };
      };
      Ve.makeTransTickLabelFn = function (e) {
        var r = GG(e),
          t = e.ticklabelshift || 0,
          a = e.ticklabelstandoff || 0,
          n = r[0],
          i = r[1],
          l = e.range[0] > e.range[1],
          o = e.ticklabelposition && e.ticklabelposition.indexOf("inside") !== -1,
          s = !o;
        if (t) {
          var u = l ? -1 : 1;
          t = t * u;
        }
        if (a) {
          var f = e.side,
            v = o && (f === "top" || f === "left") || s && (f === "bottom" || f === "right") ? 1 : -1;
          a = a * v;
        }
        return e._id.charAt(0) === "x" ? function (h) {
          return Ns(n + e._offset + e.l2p(Bm(h)) + t, i + a);
        } : function (h) {
          return Ns(i + a, n + e._offset + e.l2p(Bm(h)) + t);
        };
      };
      function Bm(e) {
        return e.periodX !== void 0 ? e.periodX : e.x;
      }
      function GG(e) {
        var r = e.ticklabelposition || "",
          t = function (d) {
            return r.indexOf(d) !== -1;
          },
          a = t("top"),
          n = t("left"),
          i = t("right"),
          l = t("bottom"),
          o = t("inside"),
          s = l || n || a || i;
        if (!s && !o) return [0, 0];
        var u = e.side,
          f = s ? (e.tickwidth || 0) / 2 : 0,
          v = q0,
          h = e.tickfont ? e.tickfont.size : 12;
        return (l || a) && (f += h * xo, v += (e.linewidth || 0) / 2), (n || i) && (f += (e.linewidth || 0) / 2, v += q0), o && u === "top" && (v -= h * (1 - xo)), (n || a) && (f = -f), (u === "bottom" || u === "right") && (v = -v), [s ? f : 0, o ? v : 0];
      }
      Ve.makeTickPath = function (e, r, t, a) {
        a || (a = {});
        var n = a.minor;
        if (n && !e.minor) return "";
        var i = a.len !== void 0 ? a.len : n ? e.minor.ticklen : e.ticklen,
          l = e._id.charAt(0),
          o = (e.linewidth || 1) / 2;
        return l === "x" ? "M0," + (r + o * t) + "v" + i * t : "M" + (r + o * t) + ",0h" + i * t;
      };
      Ve.makeLabelFns = function (e, r, t) {
        var a = e.ticklabelposition || "",
          n = function (N) {
            return a.indexOf(N) !== -1;
          },
          i = n("top"),
          l = n("left"),
          o = n("right"),
          s = n("bottom"),
          u = s || l || i || o,
          f = n("inside"),
          v = a === "inside" && e.ticks === "inside" || !f && e.ticks === "outside" && e.tickson !== "boundaries",
          h = 0,
          d = 0,
          y = v ? e.ticklen : 0;
        if (f ? y *= -1 : u && (y = 0), v && (h += y, t)) {
          var g = br.deg2rad(t);
          h = y * Math.cos(g) + 1, d = y * Math.sin(g);
        }
        e.showticklabels && (v || e.showline) && (h += .2 * e.tickfont.size), h += (e.linewidth || 1) / 2 * (f ? -1 : 1);
        var m = {
            labelStandoff: h,
            labelShift: d
          },
          _,
          w,
          T,
          b,
          A = 0,
          S = e.side,
          k = e._id.charAt(0),
          q = e.tickangle,
          D;
        if (k === "x") D = !f && S === "bottom" || f && S === "top", b = D ? 1 : -1, f && (b *= -1), _ = d * b, w = r + h * b, T = D ? 1 : -.2, Math.abs(q) === 90 && (f ? T += cf : q === -90 && S === "bottom" ? T = xo : q === 90 && S === "top" ? T = cf : T = .5, A = cf / 2 * (q / 90)), m.xFn = function (N) {
          return N.dx + _ + A * N.fontSize;
        }, m.yFn = function (N) {
          return N.dy + w + N.fontSize * T;
        }, m.anchorFn = function (N, H) {
          if (u) {
            if (l) return "end";
            if (o) return "start";
          }
          return !zt(H) || H === 0 || H === 180 ? "middle" : H * b < 0 !== f ? "end" : "start";
        }, m.heightFn = function (N, H, O) {
          return H < -60 || H > 60 ? -.5 * O : e.side === "top" !== f ? -O : 0;
        };else if (k === "y") {
          if (D = !f && S === "left" || f && S === "right", b = D ? 1 : -1, f && (b *= -1), _ = h, w = d * b, T = 0, !f && Math.abs(q) === 90 && (q === -90 && S === "left" || q === 90 && S === "right" ? T = xo : T = .5), f) {
            var R = zt(q) ? +q : 0;
            if (R !== 0) {
              var z = br.deg2rad(R);
              A = Math.abs(Math.sin(z)) * xo * b, T = 0;
            }
          }
          m.xFn = function (N) {
            return N.dx + r - (_ + N.fontSize * T) * b + A * N.fontSize;
          }, m.yFn = function (N) {
            return N.dy + w + N.fontSize * cf;
          }, m.anchorFn = function (N, H) {
            return zt(H) && Math.abs(H) === 90 ? "middle" : D ? "end" : "start";
          }, m.heightFn = function (N, H, O) {
            return e.side === "right" && (H *= -1), H < -30 ? -O : H < 30 ? -.5 * O : 0;
          };
        }
        return m;
      };
      function R0(e) {
        return [e.text, e.x, e.axInfo, e.font, e.fontSize, e.fontColor].join("_");
      }
      Ve.drawTicks = function (e, r, t) {
        t = t || {};
        var a = r._id + "tick",
          n = [].concat(r.minor && r.minor.ticks ? t.vals.filter(function (l) {
            return l.minor && !l.noTick;
          }) : []).concat(r.ticks ? t.vals.filter(function (l) {
            return !l.minor && !l.noTick;
          }) : []),
          i = t.layer.selectAll("path." + a).data(n, R0);
        i.exit().remove(), i.enter().append("path").classed(a, 1).classed("ticks", 1).classed("crisp", t.crisp !== !1).each(function (l) {
          return hf.stroke(Mn.select(this), l.minor ? r.minor.tickcolor : r.tickcolor);
        }).style("stroke-width", function (l) {
          return sn.crispRound(e, l.minor ? r.minor.tickwidth : r.tickwidth, 1) + "px";
        }).attr("d", t.path).style("display", null), z0(r, [b8]), i.attr("transform", t.transFn);
      };
      Ve.drawGrid = function (e, r, t) {
        if (t = t || {}, r.tickmode !== "sync") {
          var a = r._id + "grid",
            n = r.minor && r.minor.showgrid,
            i = n ? t.vals.filter(function (_) {
              return _.minor;
            }) : [],
            l = r.showgrid ? t.vals.filter(function (_) {
              return !_.minor;
            }) : [],
            o = t.counterAxis;
          if (o && Ve.shouldShowZeroLine(e, r, o)) for (var s = r.tickmode === "array", u = 0; u < l.length; u++) {
            var f = l[u].x;
            if (s ? !f : Math.abs(f) < r.dtick / 100) if (l = l.slice(0, u).concat(l.slice(u + 1)), s) u--;else break;
          }
          r._gw = sn.crispRound(e, r.gridwidth, 1);
          for (var v = n ? sn.crispRound(e, r.minor.gridwidth, 1) : 0, h = t.layer, d = t.minorLayer, y = 1; y >= 0; y--) {
            var g = y ? h : d;
            if (g) {
              var m = g.selectAll("path." + a).data(y ? l : i, R0);
              m.exit().remove(), m.enter().append("path").classed(a, 1).classed("crisp", t.crisp !== !1), m.attr("transform", t.transFn).attr("d", t.path).each(function (_) {
                return hf.stroke(Mn.select(this), _.minor ? r.minor.gridcolor : r.gridcolor || "#ddd");
              }).style("stroke-dasharray", function (_) {
                return sn.dashStyle(_.minor ? r.minor.griddash : r.griddash, _.minor ? r.minor.gridwidth : r.gridwidth);
              }).style("stroke-width", function (_) {
                return (_.minor ? v : r._gw) + "px";
              }).style("display", null), typeof t.path == "function" && m.attr("d", t.path);
            }
          }
          z0(r, [Hm, Om]);
        }
      };
      Ve.drawZeroLine = function (e, r, t) {
        t = t || t;
        var a = r._id + "zl",
          n = Ve.shouldShowZeroLine(e, r, t.counterAxis),
          i = t.layer.selectAll("path." + a).data(n ? [{
            x: 0,
            id: r._id
          }] : []);
        i.exit().remove(), i.enter().append("path").classed(a, 1).classed("zl", 1).classed("crisp", t.crisp !== !1).each(function () {
          t.layer.selectAll("path").sort(function (l, o) {
            return _G(l.id, o.id);
          });
        }), i.attr("transform", t.transFn).attr("d", t.path).call(hf.stroke, r.zerolinecolor || hf.defaultLine).style("stroke-width", sn.crispRound(e, r.zerolinewidth, r._gw || 1) + "px").style("display", null), z0(r, [Im]);
      };
      Ve.drawLabels = function (e, r, t) {
        t = t || {};
        var a = e._fullLayout,
          n = r._id,
          i = t.cls || n + "tick",
          l = t.vals.filter(function (I) {
            return I.text;
          }),
          o = t.labelFns,
          s = t.secondary ? 0 : r.tickangle,
          u = (r._prevTickAngles || {})[i],
          f = t.layer.selectAll("g." + i).data(r.showticklabels ? l : [], R0),
          v = [];
        f.enter().append("g").classed(i, 1).append("text").attr("text-anchor", "middle").each(function (I) {
          var V = Mn.select(this),
            K = e._promises.length;
          V.call(go.positionText, o.xFn(I), o.yFn(I)).call(sn.font, {
            family: I.font,
            size: I.fontSize,
            color: I.fontColor,
            weight: I.fontWeight,
            style: I.fontStyle,
            variant: I.fontVariant,
            textcase: I.fontTextcase,
            lineposition: I.fontLineposition,
            shadow: I.fontShadow
          }).text(I.text).call(go.convertToTspans, e), e._promises[K] ? v.push(e._promises.pop().then(function () {
            h(V, s);
          })) : h(V, s);
        }), z0(r, [u8]), f.exit().remove(), t.repositionOnUpdate && f.each(function (I) {
          Mn.select(this).select("text").call(go.positionText, o.xFn(I), o.yFn(I));
        });
        function h(I, V) {
          I.each(function (K) {
            var Q = Mn.select(this),
              ie = Q.select(".text-math-group"),
              me = o.anchorFn(K, V),
              pe = t.transFn.call(Q.node(), K) + (zt(V) && +V != 0 ? " rotate(" + V + "," + o.xFn(K) + "," + (o.yFn(K) - K.fontSize / 2) + ")" : ""),
              ge = go.lineCount(Q),
              j = pf * K.fontSize,
              _e = o.heightFn(K, zt(V) ? +V : 0, (ge - 1) * j);
            if (_e && (pe += Ns(0, _e)), ie.empty()) {
              var se = Q.select("text");
              se.attr({
                transform: pe,
                "text-anchor": me
              }), se.style("opacity", 1), r._adjustTickLabelsOverflow && r._adjustTickLabelsOverflow();
            } else {
              var Se = sn.bBox(ie.node()).width,
                ve = Se * {
                  end: -.5,
                  start: .5
                }[me];
              ie.attr("transform", pe + Ns(ve, 0));
            }
          });
        }
        r._adjustTickLabelsOverflow = function () {
          var I = r.ticklabeloverflow;
          if (!(!I || I === "allow")) {
            var V = I.indexOf("hide") !== -1,
              K = r._id.charAt(0) === "x",
              Q = 0,
              ie = K ? e._fullLayout.width : e._fullLayout.height;
            if (I.indexOf("domain") !== -1) {
              var me = br.simpleMap(r.range, r.r2l);
              Q = r.l2p(me[0]) + r._offset, ie = r.l2p(me[1]) + r._offset;
            }
            var pe = Math.min(Q, ie),
              ge = Math.max(Q, ie),
              j = r.side,
              _e = 1 / 0,
              se = -1 / 0;
            f.each(function (Y) {
              var re = Mn.select(this),
                U = re.select(".text-math-group");
              if (U.empty()) {
                var de = sn.bBox(re.node()),
                  be = 0;
                K ? (de.right > ge || de.left < pe) && (be = 1) : (de.bottom > ge || de.top + (r.tickangle ? 0 : Y.fontSize / 4) < pe) && (be = 1);
                var ye = re.select("text");
                be ? V && ye.style("opacity", 0) : (ye.style("opacity", 1), j === "bottom" || j === "right" ? _e = Math.min(_e, K ? de.top : de.left) : _e = -1 / 0, j === "top" || j === "left" ? se = Math.max(se, K ? de.bottom : de.right) : se = 1 / 0);
              }
            });
            for (var Se in a._plots) {
              var ve = a._plots[Se];
              if (!(r._id !== ve.xaxis._id && r._id !== ve.yaxis._id)) {
                var Ae = K ? ve.yaxis : ve.xaxis;
                Ae && (Ae["_visibleLabelMin_" + r._id] = _e, Ae["_visibleLabelMax_" + r._id] = se);
              }
            }
          }
        }, r._hideCounterAxisInsideTickLabels = function (I) {
          var V = r._id.charAt(0) === "x",
            K = [];
          for (var Q in a._plots) {
            var ie = a._plots[Q];
            r._id !== ie.xaxis._id && r._id !== ie.yaxis._id || K.push(V ? ie.yaxis : ie.xaxis);
          }
          K.forEach(function (me, pe) {
            me && yf(me) && (I || [Im, Om, Hm, b8, u8]).forEach(function (ge) {
              var j = ge.K === "tick" && ge.L === "text" && r.ticklabelmode === "period",
                _e = a._plots[r._mainSubplot],
                se;
              ge.K === Im.K ? se = _e.zerolinelayer.selectAll("." + r._id + "zl") : ge.K === Om.K ? se = _e.minorGridlayer.selectAll("." + r._id) : ge.K === Hm.K ? se = _e.gridlayer.selectAll("." + r._id) : se = _e[r._id.charAt(0) + "axislayer"], se.each(function () {
                var Se = Mn.select(this);
                ge.L && (Se = Se.selectAll(ge.L)), Se.each(function (ve) {
                  var Ae = r.l2p(j ? Bm(ve) : ve.x) + r._offset,
                    Y = Mn.select(this);
                  Ae < r["_visibleLabelMax_" + me._id] && Ae > r["_visibleLabelMin_" + me._id] ? Y.style("display", "none") : ge.K === "tick" && !pe && Y.style("display", null);
                });
              });
            });
          });
        }, h(f, u + 1 ? u : s);
        function d() {
          return v.length && Promise.all(v);
        }
        var y = null;
        function g() {
          if (h(f, s), l.length && r.autotickangles && (r.type !== "log" || String(r.dtick).charAt(0) !== "D")) {
            y = r.autotickangles[0];
            var I = 0,
              V = [],
              K,
              Q = 1;
            f.each(function (Ne) {
              I = Math.max(I, Ne.fontSize);
              var Ee = r.l2p(Ne.x),
                Je = Ym(this),
                We = sn.bBox(Je.node());
              Q = Math.max(Q, go.lineCount(Je)), V.push({
                top: 0,
                bottom: 10,
                height: 10,
                left: Ee - We.width / 2,
                right: Ee + We.width / 2 + 2,
                width: We.width + 2
              });
            });
            var ie = (r.tickson === "boundaries" || r.showdividers) && !t.secondary,
              me = l.length,
              pe = Math.abs((l[me - 1].x - l[0].x) * r._m) / (me - 1),
              ge = ie ? pe / 2 : pe,
              j = ie ? r.ticklen : I * 1.25 * Q,
              _e = Math.sqrt(Math.pow(ge, 2) + Math.pow(j, 2)),
              se = ge / _e,
              Se = r.autotickangles.map(function (Ne) {
                return Ne * Math.PI / 180;
              }),
              ve = Se.find(function (Ne) {
                return Math.abs(Math.cos(Ne)) <= se;
              });
            ve === void 0 && (ve = Se.reduce(function (Ne, Ee) {
              return Math.abs(Math.cos(Ne)) < Math.abs(Math.cos(Ee)) ? Ne : Ee;
            }, Se[0]));
            var Ae = ve * (180 / Math.PI);
            if (ie) {
              var Y = 2;
              for (r.ticks && (Y += r.tickwidth / 2), K = 0; K < V.length; K++) {
                var re = l[K].xbnd,
                  U = V[K];
                if (re[0] !== null && U.left - r.l2p(re[0]) < Y || re[1] !== null && r.l2p(re[1]) - U.right < Y) {
                  y = Ae;
                  break;
                }
              }
            } else {
              var de = r.ticklabelposition || "",
                be = function (Ne) {
                  return de.indexOf(Ne) !== -1;
                },
                ye = be("top"),
                Fe = be("left"),
                Re = be("right"),
                Pe = be("bottom"),
                Ie = Pe || Fe || ye || Re,
                Be = Ie ? (r.tickwidth || 0) + 2 * q0 : 0;
              for (K = 0; K < V.length - 1; K++) if (br.bBoxIntersect(V[K], V[K + 1], Be)) {
                y = Ae;
                break;
              }
            }
            y && h(f, y);
          }
        }
        r._selections && (r._selections[i] = f);
        var m = [d];
        r.automargin && a._redrawFromAutoMarginCount && u === 90 ? (y = u, m.push(function () {
          h(f, u);
        })) : m.push(g), r._tickAngles && m.push(function () {
          r._tickAngles[i] = y === null ? zt(s) ? s : 0 : y;
        });
        var _ = function () {
            var I = 0,
              V = 0;
            return f.each(function (K, Q) {
              var ie = Ym(this),
                me = ie.select(".text-math-group");
              if (me.empty()) {
                var pe;
                r._vals[Q] && (pe = r._vals[Q].bb || sn.bBox(ie.node()), r._vals[Q].bb = pe), I = Math.max(I, pe.width), V = Math.max(V, pe.height);
              }
            }), {
              labelsMaxW: I,
              labelsMaxH: V
            };
          },
          w = r._anchorAxis;
        if (w && (w.autorange || w.insiderange) && yf(r) && !wG(a, r._id) && (a._insideTickLabelsUpdaterange || (a._insideTickLabelsUpdaterange = {}), w.autorange && (a._insideTickLabelsUpdaterange[w._name + ".autorange"] = w.autorange, m.push(_)), w.insiderange)) {
          var T = _(),
            b = r._id.charAt(0) === "y" ? T.labelsMaxW : T.labelsMaxH;
          b += 2 * q0, r.ticklabelposition === "inside" && (b += r.ticklen || 0);
          var A = r.side === "right" || r.side === "top" ? 1 : -1,
            S = A === 1 ? 1 : 0,
            k = A === 1 ? 0 : 1,
            q = [];
          q[k] = w.range[k];
          var D = w.range,
            R = w.r2p(D[S]),
            z = w.r2p(D[k]),
            N = a._insideTickLabelsUpdaterange[w._name + ".range"];
          if (N) {
            var H = w.r2p(N[S]),
              O = w.r2p(N[k]),
              J = A * (r._id.charAt(0) === "y" ? 1 : -1);
            J * R < J * H && (R = H, q[S] = D[S] = N[S]), J * z > J * O && (z = O, q[k] = D[k] = N[k]);
          }
          var X = Math.abs(z - R);
          X - b > 0 ? (X -= b, b *= 1 + b / X) : b = 0, r._id.charAt(0) !== "y" && (b = -b), q[S] = w.p2r(w.r2p(D[S]) + A * b), w.autorange === "min" || w.autorange === "max reversed" ? (q[0] = null, w._rangeInitial0 = void 0, w._rangeInitial1 = void 0) : (w.autorange === "max" || w.autorange === "min reversed") && (q[1] = null, w._rangeInitial0 = void 0, w._rangeInitial1 = void 0), a._insideTickLabelsUpdaterange[w._name + ".range"] = q;
        }
        var B = br.syncOrAsync(m);
        return B && B.then && e._promises.push(B), B;
      };
      function VG(e, r, t) {
        var a = r._id + "divider",
          n = t.vals,
          i = t.layer.selectAll("path." + a).data(n, R0);
        i.exit().remove(), i.enter().insert("path", ":first-child").classed(a, 1).classed("crisp", 1).call(hf.stroke, r.dividercolor).style("stroke-width", sn.crispRound(e, r.dividerwidth, 1) + "px"), i.attr("transform", t.transFn).attr("d", t.path);
      }
      Ve.getPxPosition = function (e, r) {
        var t = e._fullLayout._size,
          a = r._id.charAt(0),
          n = r.side,
          i;
        if (r.anchor !== "free" ? i = r._anchorAxis : a === "x" ? i = {
          _offset: t.t + (1 - (r.position || 0)) * t.h,
          _length: 0
        } : a === "y" && (i = {
          _offset: t.l + (r.position || 0) * t.w + r._shift,
          _length: 0
        }), n === "top" || n === "left") return i._offset;
        if (n === "bottom" || n === "right") return i._offset + i._length;
      };
      function g8(e) {
        var r = e.title.font.size,
          t = (e.title.text.match(go.BR_TAG_ALL) || []).length;
        return e.title.hasOwnProperty("standoff") ? r * (xo + t * pf) : t ? r * (t + 1) * pf : r;
      }
      function WG(e, r) {
        var t = e._fullLayout,
          a = r._id,
          n = a.charAt(0),
          i = r.title.font.size,
          l,
          o = (r.title.text.match(go.BR_TAG_ALL) || []).length;
        if (r.title.hasOwnProperty("standoff")) r.side === "bottom" || r.side === "right" ? l = r._depth + r.title.standoff + i * xo : (r.side === "top" || r.side === "left") && (l = r._depth + r.title.standoff + i * (cf + o * pf));else {
          var s = yf(r);
          if (r.type === "multicategory") l = r._depth;else {
            var u = 1.5 * i;
            s && (u = .5 * i, r.ticks === "outside" && (u += r.ticklen)), l = 10 + u + (r.linewidth ? r.linewidth - 1 : 0);
          }
          s || (n === "x" ? l += r.side === "top" ? i * (r.showticklabels ? 1 : 0) : i * (r.showticklabels ? 1.5 : .5) : l += r.side === "right" ? i * (r.showticklabels ? 1 : .5) : i * (r.showticklabels ? .5 : 0));
        }
        var f = Ve.getPxPosition(e, r),
          v,
          h,
          d;
        n === "x" ? (h = r._offset + r._length / 2, d = r.side === "top" ? f - l : f + l) : (d = r._offset + r._length / 2, h = r.side === "right" ? f + l : f - l, v = {
          rotate: "-90",
          offset: 0
        });
        var y;
        if (r.type !== "multicategory") {
          var g = r._selections[r._id + "tick"];
          if (y = {
            selection: g,
            side: r.side
          }, g && g.node() && g.node().parentNode) {
            var m = sn.getTranslate(g.node().parentNode);
            y.offsetLeft = m.x, y.offsetTop = m.y;
          }
          r.title.hasOwnProperty("standoff") && (y.pad = 0);
        }
        return r._titleStandoff = l, vG.draw(e, a + "title", {
          propContainer: r,
          propName: r._name + ".title.text",
          placeholder: t._dfltTitle[n],
          avoid: y,
          transform: v,
          attributes: {
            x: h,
            y: d,
            "text-anchor": "middle"
          }
        });
      }
      Ve.shouldShowZeroLine = function (e, r, t) {
        var a = br.simpleMap(r.range, r.r2l);
        return a[0] * a[1] <= 0 && r.zeroline && (r.type === "linear" || r.type === "-") && !(r.rangebreaks && r.maskBreaks(0) === E0) && (k8(r, 0) || !ZG(e, r, t, a) || XG(e, r));
      };
      Ve.clipEnds = function (e, r) {
        return r.filter(function (t) {
          return k8(e, t.x);
        });
      };
      function k8(e, r) {
        var t = e.l2p(r);
        return t > 1 && t < e._length - 1;
      }
      function ZG(e, r, t, a) {
        var n = t._mainAxis;
        if (!n) return;
        var i = e._fullLayout,
          l = r._id.charAt(0),
          o = Ve.counterLetter(r._id),
          s = r._offset + (Math.abs(a[0]) < Math.abs(a[1]) == (l === "x") ? 0 : r._length);
        function u(y) {
          if (!y.showline || !y.linewidth) return !1;
          var g = Math.max((y.linewidth + r.zerolinewidth) / 2, 1);
          function m(T) {
            return typeof T == "number" && Math.abs(T - s) < g;
          }
          if (m(y._mainLinePosition) || m(y._mainMirrorPosition)) return !0;
          var _ = y._linepositions || {};
          for (var w in _) if (m(_[w][0]) || m(_[w][1])) return !0;
        }
        var f = i._plots[t._mainSubplot];
        if (!(f.mainplotinfo || f).overlays.length) return u(t, s);
        for (var v = Ve.list(e, o), h = 0; h < v.length; h++) {
          var d = v[h];
          if (d._mainAxis === n && u(d, s)) return !0;
        }
      }
      function XG(e, r) {
        for (var t = e._fullData, a = r._mainSubplot, n = r._id.charAt(0), i = 0; i < t.length; i++) {
          var l = t[i];
          if (l.visible === !0 && l.xaxis + l.yaxis === a && (vf.traceIs(l, "bar-like") && l.orientation === {
            x: "h",
            y: "v"
          }[n] || l.fill && l.fill.charAt(l.fill.length - 1) === n)) return !0;
        }
        return !1;
      }
      function Ym(e) {
        var r = Mn.select(e),
          t = r.select(".text-math-group");
        return t.empty() ? r.select("text") : t;
      }
      Ve.allowAutoMargin = function (e) {
        for (var r = Ve.list(e, "", !0), t = 0; t < r.length; t++) {
          var a = r[t];
          a.automargin && (zs.allowAutoMargin(e, Wm(a)), a.mirror && zs.allowAutoMargin(e, C8(a))), vf.getComponentMethod("rangeslider", "isVisible")(a) && zs.allowAutoMargin(e, S8(a));
        }
      };
      function Wm(e) {
        return e._id + ".automargin";
      }
      function C8(e) {
        return Wm(e) + ".mirror";
      }
      function S8(e) {
        return e._id + ".rangeslider";
      }
      Ve.swap = function (e, r) {
        for (var t = JG(e, r), a = 0; a < t.length; a++) KG(e, t[a].x, t[a].y);
      };
      function JG(e, r) {
        var t = [],
          a,
          n;
        for (a = 0; a < r.length; a++) {
          var i = [],
            l = e._fullData[r[a]].xaxis,
            o = e._fullData[r[a]].yaxis;
          if (!(!l || !o)) {
            for (n = 0; n < t.length; n++) (t[n].x.indexOf(l) !== -1 || t[n].y.indexOf(o) !== -1) && i.push(n);
            if (!i.length) {
              t.push({
                x: [l],
                y: [o]
              });
              continue;
            }
            var s = t[i[0]],
              u;
            if (i.length > 1) for (n = 1; n < i.length; n++) u = t[i[n]], M0(s.x, u.x), M0(s.y, u.y);
            M0(s.x, [l]), M0(s.y, [o]);
          }
        }
        return t;
      }
      function M0(e, r) {
        for (var t = 0; t < r.length; t++) e.indexOf(r[t]) === -1 && e.push(r[t]);
      }
      function KG(e, r, t) {
        var a = [],
          n = [],
          i = e.layout,
          l,
          o;
        for (l = 0; l < r.length; l++) a.push(Ve.getFromId(e, r[l]));
        for (l = 0; l < t.length; l++) n.push(Ve.getFromId(e, t[l]));
        var s = Object.keys(hG),
          u = ["anchor", "domain", "overlaying", "position", "side", "tickangle", "editType"],
          f = ["linear", "log"];
        for (l = 0; l < s.length; l++) {
          var v = s[l],
            h = a[0][v],
            d = n[0][v],
            y = !0,
            g = !1,
            m = !1;
          if (!(v.charAt(0) === "_" || typeof h == "function" || u.indexOf(v) !== -1)) {
            for (o = 1; o < a.length && y; o++) {
              var _ = a[o][v];
              v === "type" && f.indexOf(h) !== -1 && f.indexOf(_) !== -1 && h !== _ ? g = !0 : _ !== h && (y = !1);
            }
            for (o = 1; o < n.length && y; o++) {
              var w = n[o][v];
              v === "type" && f.indexOf(d) !== -1 && f.indexOf(w) !== -1 && d !== w ? m = !0 : n[o][v] !== d && (y = !1);
            }
            y && (g && (i[a[0]._name].type = "linear"), m && (i[n[0]._name].type = "linear"), QG(i, v, a, n, e._fullLayout._dfltTitle));
          }
        }
        for (l = 0; l < e._fullLayout.annotations.length; l++) {
          var T = e._fullLayout.annotations[l];
          r.indexOf(T.xref) !== -1 && t.indexOf(T.yref) !== -1 && br.swapAttrs(i.annotations[l], ["?"]);
        }
      }
      function QG(e, r, t, a, n) {
        var i = br.nestedProperty,
          l = i(e[t[0]._name], r).get(),
          o = i(e[a[0]._name], r).get(),
          s;
        for (r === "title" && (l && l.text === n.x && (l.text = n.y), o && o.text === n.y && (o.text = n.x)), s = 0; s < t.length; s++) i(e, t[s]._name + "." + r).set(o);
        for (s = 0; s < a.length; s++) i(e, a[s]._name + "." + r).set(l);
      }
      function Zm(e) {
        return e._id === "angularaxis";
      }
      function Nm(e, r) {
        for (var t = r._rangebreaks.length, a = 0; a < t; a++) {
          var n = r._rangebreaks[a];
          if (e >= n.min && e < n.max) return n.max;
        }
        return e;
      }
      function yf(e) {
        return (e.ticklabelposition || "").indexOf("inside") !== -1;
      }
      function z0(e, r) {
        yf(e._anchorAxis || {}) && e._hideCounterAxisInsideTickLabels && e._hideCounterAxisInsideTickLabels(r);
      }
      function Um(e, r, t, a) {
        var n = e.anchor !== "free" && (e.overlaying === void 0 || e.overlaying === !1) ? e._id : e.overlaying,
          i;
        a ? i = e.side === "right" ? r : -r : i = r, n in t || (t[n] = {}), e.side in t[n] || (t[n][e.side] = 0), t[n][e.side] += i;
      }
      function $G(e, r) {
        return e.autoshift ? r[e.overlaying][e.side] : e.shift || 0;
      }
      function jG(e, r) {
        return /%f/.test(r) ? e >= gG : /%L/.test(r) ? e >= yG : /%[SX]/.test(r) ? e >= L0 : /%M/.test(r) ? e >= df : /%[HI]/.test(r) ? e >= Ti : /%p/.test(r) ? e >= _l : /%[Aadejuwx]/.test(r) ? e >= Ea : /%[UVW]/.test(r) ? e >= un : /%[Bbm]/.test(r) ? e >= S0 : /%[q]/.test(r) ? e >= C0 : /%[Yy]/.test(r) ? e >= k0 : !0;
      }
    });
    var D8 = Z((Joe, q8) => {
      "use strict";

      q8.exports = function (r, t, a) {
        var n, i;
        if (a) {
          var l = t === "reversed" || t === "min reversed" || t === "max reversed";
          n = a[l ? 1 : 0], i = a[l ? 0 : 1];
        }
        var o = r("autorangeoptions.minallowed", i === null ? n : void 0),
          s = r("autorangeoptions.maxallowed", n === null ? i : void 0);
        o === void 0 && r("autorangeoptions.clipmin"), s === void 0 && r("autorangeoptions.clipmax"), r("autorangeoptions.include");
      };
    });
    var Xm = Z((Koe, E8) => {
      "use strict";

      var eV = D8();
      E8.exports = function (r, t, a, n) {
        var i = t._template || {},
          l = t.type || i.type || "-";
        a("minallowed"), a("maxallowed");
        var o = a("range");
        if (!o) {
          var s;
          !n.noInsiderange && l !== "log" && (s = a("insiderange"), s && (s[0] === null || s[1] === null) && (t.insiderange = !1, s = void 0), s && (o = a("range", s)));
        }
        var u = t.getAutorangeDflt(o, n),
          f = a("autorange", u),
          v;
        o && (o[0] === null && o[1] === null || (o[0] === null || o[1] === null) && (f === "reversed" || f === !0) || o[0] !== null && (f === "min" || f === "max reversed") || o[1] !== null && (f === "max" || f === "min reversed")) && (o = void 0, delete t.range, t.autorange = !0, v = !0), v || (u = t.getAutorangeDflt(o, n), f = a("autorange", u)), f && (eV(a, f, o), (l === "linear" || l === "-") && a("rangemode")), t.cleanRange();
      };
    });
    var R8 = Z((Qoe, P8) => {
      var rV = {
        left: 0,
        top: 0
      };
      P8.exports = tV;
      function tV(e, r, t) {
        r = r || e.currentTarget || e.srcElement, Array.isArray(t) || (t = [0, 0]);
        var a = e.clientX || 0,
          n = e.clientY || 0,
          i = aV(r);
        return t[0] = a - i.left, t[1] = n - i.top, t;
      }
      function aV(e) {
        return e === window || e === document || e === document.body ? rV : e.getBoundingClientRect();
      }
    });
    var Jm = Z(($oe, z8) => {
      "use strict";

      var nV = Mp();
      function iV() {
        var e = !1;
        try {
          var r = Object.defineProperty({}, "passive", {
            get: function () {
              e = !0;
            }
          });
          window.addEventListener("test", null, r), window.removeEventListener("test", null, r);
        } catch (t) {
          e = !1;
        }
        return e;
      }
      z8.exports = nV && iV();
    });
    var F8 = Z((joe, N8) => {
      "use strict";

      N8.exports = function (r, t, a, n, i) {
        var l = (r - a) / (n - a),
          o = l + t / (n - a),
          s = (l + o) / 2;
        return i === "left" || i === "bottom" ? l : i === "center" || i === "middle" ? s : i === "right" || i === "top" ? o : l < 2 / 3 - s ? l : o > 4 / 3 - s ? o : s;
      };
    });
    var O8 = Z((ese, H8) => {
      "use strict";

      var I8 = He(),
        lV = [["sw-resize", "s-resize", "se-resize"], ["w-resize", "move", "e-resize"], ["nw-resize", "n-resize", "ne-resize"]];
      H8.exports = function (r, t, a, n) {
        return a === "left" ? r = 0 : a === "center" ? r = 1 : a === "right" ? r = 2 : r = I8.constrain(Math.floor(r * 3), 0, 2), n === "bottom" ? t = 0 : n === "middle" ? t = 1 : n === "top" ? t = 2 : t = I8.constrain(Math.floor(t * 3), 0, 2), lV[t][r];
      };
    });
    var Y8 = Z((rse, B8) => {
      "use strict";

      var oV = $u(),
        sV = zv(),
        uV = Gu().getGraphDiv,
        fV = Yu(),
        Km = B8.exports = {};
      Km.wrapped = function (e, r, t) {
        e = uV(e), e._fullLayout && sV.clear(e._fullLayout._uid + fV.HOVERID), Km.raw(e, r, t);
      };
      Km.raw = function (r, t) {
        var a = r._fullLayout,
          n = r._hoverdata;
        t || (t = {}), !(t.target && !r._dragged && oV.triggerHandler(r, "plotly_beforehover", t) === !1) && (a._hoverlayer.selectAll("g").remove(), a._hoverlayer.selectAll("line").remove(), a._hoverlayer.selectAll("circle").remove(), r._hoverdata = void 0, t.target && n && r.emit("plotly_unhover", {
          event: t,
          points: n
        }));
      };
    });
    var Qn = Z((tse, W8) => {
      "use strict";

      var cV = R8(),
        Qm = kp(),
        vV = Jm(),
        hV = He().removeElement,
        dV = da(),
        _o = W8.exports = {};
      _o.align = F8();
      _o.getCursor = O8();
      var G8 = Y8();
      _o.unhover = G8.wrapped;
      _o.unhoverRaw = G8.raw;
      _o.init = function (r) {
        var t = r.gd,
          a = 1,
          n = t._context.doubleClickDelay,
          i = r.element,
          l,
          o,
          s,
          u,
          f,
          v,
          h,
          d;
        t._mouseDownTime || (t._mouseDownTime = 0), i.style.pointerEvents = "all", i.onmousedown = m, vV ? (i._ontouchstart && i.removeEventListener("touchstart", i._ontouchstart), i._ontouchstart = m, i.addEventListener("touchstart", m, {
          passive: !1
        })) : i.ontouchstart = m;
        function y(T, b, A) {
          return Math.abs(T) < A && (T = 0), Math.abs(b) < A && (b = 0), [T, b];
        }
        var g = r.clampFn || y;
        function m(T) {
          t._dragged = !1, t._dragging = !0;
          var b = U8(T);
          l = b[0], o = b[1], h = T.target, v = T, d = T.buttons === 2 || T.ctrlKey, typeof T.clientX == "undefined" && typeof T.clientY == "undefined" && (T.clientX = l, T.clientY = o), s = new Date().getTime(), s - t._mouseDownTime < n ? a += 1 : (a = 1, t._mouseDownTime = s), r.prepFn && r.prepFn(T, l, o), Qm && !d ? (f = V8(), f.style.cursor = window.getComputedStyle(i).cursor) : Qm || (f = document, u = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(i).cursor), document.addEventListener("mouseup", w), document.addEventListener("touchend", w), r.dragmode !== !1 && (T.preventDefault(), document.addEventListener("mousemove", _), document.addEventListener("touchmove", _, {
            passive: !1
          }));
        }
        function _(T) {
          T.preventDefault();
          var b = U8(T),
            A = r.minDrag || dV.MINDRAG,
            S = g(b[0] - l, b[1] - o, A),
            k = S[0],
            q = S[1];
          (k || q) && (t._dragged = !0, _o.unhover(t, T)), t._dragged && r.moveFn && !d && (t._dragdata = {
            element: i,
            dx: k,
            dy: q
          }, r.moveFn(k, q));
        }
        function w(T) {
          if (delete t._dragdata, r.dragmode !== !1 && (T.preventDefault(), document.removeEventListener("mousemove", _), document.removeEventListener("touchmove", _)), document.removeEventListener("mouseup", w), document.removeEventListener("touchend", w), Qm ? hV(f) : u && (f.documentElement.style.cursor = u, u = null), !t._dragging) {
            t._dragged = !1;
            return;
          }
          if (t._dragging = !1, new Date().getTime() - t._mouseDownTime > n && (a = Math.max(a - 1, 1)), t._dragged) r.doneFn && r.doneFn();else {
            var b;
            v.target === h ? b = v : (b = {
              target: h,
              srcElement: h,
              toElement: h
            }, Object.keys(v).concat(Object.keys(v.__proto__)).forEach(A => {
              var S = v[A];
              !b[A] && typeof S != "function" && (b[A] = S);
            })), r.clickFn && r.clickFn(a, b), d || h.dispatchEvent(new MouseEvent("click", T));
          }
          t._dragging = !1, t._dragged = !1;
        }
      };
      function V8() {
        var e = document.createElement("div");
        e.className = "dragcover";
        var r = e.style;
        return r.position = "fixed", r.left = 0, r.right = 0, r.top = 0, r.bottom = 0, r.zIndex = 999999999, r.background = "none", document.body.appendChild(e), e;
      }
      _o.coverSlip = V8;
      function U8(e) {
        return cV(e.changedTouches ? e.changedTouches[0] : e, document.body);
      }
    });
    var wl = Z((ase, Z8) => {
      "use strict";

      Z8.exports = function (r, t) {
        (r.attr("class") || "").split(" ").forEach(function (a) {
          a.indexOf("cursor-") === 0 && r.classed(a, !1);
        }), t && r.classed("cursor-" + t, !0);
      };
    });
    var K8 = Z((nse, J8) => {
      "use strict";

      var $m = wl(),
        gf = "data-savedcursor",
        X8 = "!!";
      J8.exports = function (r, t) {
        var a = r.attr(gf);
        if (t) {
          if (!a) {
            for (var n = (r.attr("class") || "").split(" "), i = 0; i < n.length; i++) {
              var l = n[i];
              l.indexOf("cursor-") === 0 && r.attr(gf, l.substr(7)).classed(l, !1);
            }
            r.attr(gf) || r.attr(gf, X8);
          }
          $m(r, t);
        } else a && (r.attr(gf, null), a === X8 ? $m(r) : $m(r, a));
      };
    });
    var ey = Z((ise, Q8) => {
      "use strict";

      var jm = ha(),
        pV = hi();
      Q8.exports = {
        _isSubplotObj: !0,
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "legend"
        },
        bgcolor: {
          valType: "color",
          editType: "legend"
        },
        bordercolor: {
          valType: "color",
          dflt: pV.defaultLine,
          editType: "legend"
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "legend"
        },
        font: jm({
          editType: "legend"
        }),
        grouptitlefont: jm({
          editType: "legend"
        }),
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          dflt: "v",
          editType: "legend"
        },
        traceorder: {
          valType: "flaglist",
          flags: ["reversed", "grouped"],
          extras: ["normal"],
          editType: "legend"
        },
        tracegroupgap: {
          valType: "number",
          min: 0,
          dflt: 10,
          editType: "legend"
        },
        entrywidth: {
          valType: "number",
          min: 0,
          editType: "legend"
        },
        entrywidthmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "pixels",
          editType: "legend"
        },
        indentation: {
          valType: "number",
          min: -15,
          dflt: 0,
          editType: "legend"
        },
        itemsizing: {
          valType: "enumerated",
          values: ["trace", "constant"],
          dflt: "trace",
          editType: "legend"
        },
        itemwidth: {
          valType: "number",
          min: 30,
          dflt: 30,
          editType: "legend"
        },
        itemclick: {
          valType: "enumerated",
          values: ["toggle", "toggleothers", !1],
          dflt: "toggle",
          editType: "legend"
        },
        itemdoubleclick: {
          valType: "enumerated",
          values: ["toggle", "toggleothers", !1],
          dflt: "toggleothers",
          editType: "legend"
        },
        groupclick: {
          valType: "enumerated",
          values: ["toggleitem", "togglegroup"],
          dflt: "togglegroup",
          editType: "legend"
        },
        x: {
          valType: "number",
          editType: "legend"
        },
        xref: {
          valType: "enumerated",
          dflt: "paper",
          values: ["container", "paper"],
          editType: "layoutstyle"
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "left",
          editType: "legend"
        },
        y: {
          valType: "number",
          editType: "legend"
        },
        yref: {
          valType: "enumerated",
          dflt: "paper",
          values: ["container", "paper"],
          editType: "layoutstyle"
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          editType: "legend"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        valign: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "middle",
          editType: "legend"
        },
        title: {
          text: {
            valType: "string",
            dflt: "",
            editType: "legend"
          },
          font: jm({
            editType: "legend"
          }),
          side: {
            valType: "enumerated",
            values: ["top", "left", "top left", "top center", "top right"],
            editType: "legend"
          },
          editType: "legend"
        },
        editType: "legend"
      };
    });
    var F0 = Z(N0 => {
      "use strict";

      N0.isGrouped = function (r) {
        return (r.traceorder || "").indexOf("grouped") !== -1;
      };
      N0.isVertical = function (r) {
        return r.orientation !== "h";
      };
      N0.isReversed = function (r) {
        return (r.traceorder || "").indexOf("reversed") !== -1;
      };
    });
    var ay = Z((ose, $8) => {
      "use strict";

      var ry = gr(),
        fn = He(),
        mV = ct(),
        yV = Gn(),
        gV = ey(),
        bV = ds(),
        ty = F0();
      function xV(e, r, t, a) {
        var n = r[e] || {},
          i = mV.newContainer(t, e);
        function l(B, I) {
          return fn.coerce(n, i, gV, B, I);
        }
        var o = fn.coerceFont(l, "font", t.font);
        l("bgcolor", t.paper_bgcolor), l("bordercolor");
        var s = l("visible");
        if (s) {
          for (var u, f = function (B, I) {
              var V = u._input,
                K = u;
              return fn.coerce(V, K, yV, B, I);
            }, v = t.font || {}, h = fn.coerceFont(l, "grouptitlefont", v, {
              overrideDflt: {
                size: Math.round(v.size * 1.1)
              }
            }), d = 0, y = !1, g = "normal", m = (t.shapes || []).filter(function (B) {
              return B.showlegend;
            }), _ = a.concat(m).filter(function (B) {
              return e === (B.legend || "legend");
            }), w = 0; w < _.length; w++) if (u = _[w], !!u.visible) {
            var T = u._isShape;
            (u.showlegend || u._dfltShowLegend && !(u._module && u._module.attributes && u._module.attributes.showlegend && u._module.attributes.showlegend.dflt === !1)) && (d++, u.showlegend && (y = !0, (!T && ry.traceIs(u, "pie-like") || u._input.showlegend === !0) && d++), fn.coerceFont(f, "legendgrouptitle.font", h)), (!T && ry.traceIs(u, "bar") && t.barmode === "stack" || ["tonextx", "tonexty"].indexOf(u.fill) !== -1) && (g = ty.isGrouped({
              traceorder: g
            }) ? "grouped+reversed" : "reversed"), u.legendgroup !== void 0 && u.legendgroup !== "" && (g = ty.isReversed({
              traceorder: g
            }) ? "reversed+grouped" : "grouped");
          }
          var b = fn.coerce(r, t, bV, "showlegend", y && d > (e === "legend" ? 1 : 0));
          if (b === !1 && (t[e] = void 0), !(b === !1 && !n.uirevision) && (l("uirevision", t.uirevision), b !== !1)) {
            l("borderwidth");
            var A = l("orientation"),
              S = l("yref"),
              k = l("xref"),
              q = A === "h",
              D = S === "paper",
              R = k === "paper",
              z,
              N,
              H,
              O = "left";
            q ? (z = 0, ry.getComponentMethod("rangeslider", "isVisible")(r.xaxis) ? D ? (N = 1.1, H = "bottom") : (N = 1, H = "top") : D ? (N = -.1, H = "top") : (N = 0, H = "bottom")) : (N = 1, H = "auto", R ? z = 1.02 : (z = 1, O = "right")), fn.coerce(n, i, {
              x: {
                valType: "number",
                editType: "legend",
                min: R ? -2 : 0,
                max: R ? 3 : 1,
                dflt: z
              }
            }, "x"), fn.coerce(n, i, {
              y: {
                valType: "number",
                editType: "legend",
                min: D ? -2 : 0,
                max: D ? 3 : 1,
                dflt: N
              }
            }, "y"), l("traceorder", g), ty.isGrouped(t[e]) && l("tracegroupgap"), l("entrywidth"), l("entrywidthmode"), l("indentation"), l("itemsizing"), l("itemwidth"), l("itemclick"), l("itemdoubleclick"), l("groupclick"), l("xanchor", O), l("yanchor", H), l("valign"), fn.noneOrAll(n, i, ["x", "y"]);
            var J = l("title.text");
            if (J) {
              l("title.side", q ? "left" : "top");
              var X = fn.extendFlat({}, o, {
                size: fn.bigFont(o.size)
              });
              fn.coerceFont(l, "title.font", X);
            }
          }
        }
      }
      $8.exports = function (r, t, a) {
        var n,
          i = a.slice(),
          l = t.shapes;
        if (l) for (n = 0; n < l.length; n++) {
          var o = l[n];
          if (o.showlegend) {
            var s = {
              _input: o._input,
              visible: o.visible,
              showlegend: o.showlegend,
              legend: o.legend
            };
            i.push(s);
          }
        }
        var u = ["legend"];
        for (n = 0; n < i.length; n++) fn.pushUnique(u, i[n].legend);
        for (t._legends = [], n = 0; n < u.length; n++) {
          var f = u[n];
          xV(f, r, t, i), t[f] && t[f].visible && (t[f]._id = f), t._legends.push(f);
        }
      };
    });
    var ew = Z((sse, j8) => {
      "use strict";

      var Is = gr(),
        iy = He(),
        _V = iy.pushUnique,
        ny = !0;
      j8.exports = function (r, t, a) {
        var n = t._fullLayout;
        if (t._dragged || t._editing) return;
        var i = n.legend.itemclick,
          l = n.legend.itemdoubleclick,
          o = n.legend.groupclick;
        a === 1 && i === "toggle" && l === "toggleothers" && ny && t.data && t._context.showTips && iy.notifier(iy._(t, "Double-click on legend to isolate one trace"), "long"), ny = !1;
        var s;
        if (a === 1 ? s = i : a === 2 && (s = l), !s) return;
        var u = o === "togglegroup",
          f = n.hiddenlabels ? n.hiddenlabels.slice() : [],
          v = r.data()[0][0];
        if (v.groupTitle && v.noClick) return;
        var h = t._fullData,
          d = (n.shapes || []).filter(function (Ie) {
            return Ie.showlegend;
          }),
          y = h.concat(d),
          g = v.trace;
        g._isShape && (g = g._fullInput);
        var m = g.legendgroup,
          _,
          w,
          T,
          b,
          A,
          S,
          k = {},
          q = [],
          D = [],
          R = [];
        function z(Ie, Be) {
          var Ne = q.indexOf(Ie),
            Ee = k.visible;
          return Ee || (Ee = k.visible = []), q.indexOf(Ie) === -1 && (q.push(Ie), Ne = q.length - 1), Ee[Ne] = Be, Ne;
        }
        var N = (n.shapes || []).map(function (Ie) {
            return Ie._input;
          }),
          H = !1;
        function O(Ie, Be) {
          N[Ie].visible = Be, H = !0;
        }
        function J(Ie, Be) {
          if (!(v.groupTitle && !u)) {
            var Ne = Ie._fullInput || Ie,
              Ee = Ne._isShape,
              Je = Ne.index;
            Je === void 0 && (Je = Ne._index);
            var We = Ne.visible === !1 ? !1 : Be;
            Ee ? O(Je, We) : z(Je, We);
          }
        }
        var X = g.legend,
          B = g._fullInput,
          I = B && B._isShape;
        if (!I && Is.traceIs(g, "pie-like")) {
          var V = v.label,
            K = f.indexOf(V);
          if (s === "toggle") K === -1 ? f.push(V) : f.splice(K, 1);else if (s === "toggleothers") {
            var Q = K !== -1,
              ie = [];
            for (_ = 0; _ < t.calcdata.length; _++) {
              var me = t.calcdata[_];
              for (w = 0; w < me.length; w++) {
                var pe = me[w],
                  ge = pe.label;
                X === me[0].trace.legend && V !== ge && (f.indexOf(ge) === -1 && (Q = !0), _V(f, ge), ie.push(ge));
              }
            }
            if (!Q) for (var j = 0; j < ie.length; j++) {
              var _e = f.indexOf(ie[j]);
              _e !== -1 && f.splice(_e, 1);
            }
          }
          Is.call("_guiRelayout", t, "hiddenlabels", f);
        } else {
          var se = m && m.length,
            Se = [],
            ve;
          if (se) for (_ = 0; _ < y.length; _++) ve = y[_], ve.visible && ve.legendgroup === m && Se.push(_);
          if (s === "toggle") {
            var Ae;
            switch (g.visible) {
              case !0:
                Ae = "legendonly";
                break;
              case !1:
                Ae = !1;
                break;
              case "legendonly":
                Ae = !0;
                break;
            }
            if (se) {
              if (u) for (_ = 0; _ < y.length; _++) {
                var Y = y[_];
                Y.visible !== !1 && Y.legendgroup === m && J(Y, Ae);
              } else J(g, Ae);
            } else J(g, Ae);
          } else if (s === "toggleothers") {
            var re,
              U,
              de,
              be,
              ye,
              Fe = !0;
            for (_ = 0; _ < y.length; _++) if (ye = y[_], re = ye === g, de = ye.showlegend !== !0, !(re || de) && (U = se && ye.legendgroup === m, !U && ye.legend === X && ye.visible === !0 && !Is.traceIs(ye, "notLegendIsolatable"))) {
              Fe = !1;
              break;
            }
            for (_ = 0; _ < y.length; _++) if (ye = y[_], !(ye.visible === !1 || ye.legend !== X) && !Is.traceIs(ye, "notLegendIsolatable")) switch (g.visible) {
              case "legendonly":
                J(ye, !0);
                break;
              case !0:
                be = Fe ? !0 : "legendonly", re = ye === g, de = ye.showlegend !== !0 && !ye.legendgroup, U = re || se && ye.legendgroup === m, J(ye, U || de ? !0 : be);
                break;
            }
          }
          for (_ = 0; _ < D.length; _++) if (T = D[_], !!T) {
            var Re = T.constructUpdate(),
              Pe = Object.keys(Re);
            for (w = 0; w < Pe.length; w++) b = Pe[w], S = k[b] = k[b] || [], S[R[_]] = Re[b];
          }
          for (A = Object.keys(k), _ = 0; _ < A.length; _++) for (b = A[_], w = 0; w < q.length; w++) k[b].hasOwnProperty(w) || (k[b][w] = void 0);
          H ? Is.call("_guiUpdate", t, k, {
            shapes: N
          }, q) : Is.call("_guiRestyle", t, k, q);
        }
      };
    });
    var ly = Z((use, rw) => {
      "use strict";

      rw.exports = {
        scrollBarWidth: 6,
        scrollBarMinHeight: 20,
        scrollBarColor: "#808BA4",
        scrollBarMargin: 4,
        scrollBarEnterAttrs: {
          rx: 20,
          ry: 3,
          width: 0,
          height: 0
        },
        titlePad: 2,
        itemGap: 5
      };
    });
    var nw = Z((fse, aw) => {
      "use strict";

      var tw = gr(),
        oy = F0();
      aw.exports = function (r, t, a) {
        var n = t._inHover,
          i = oy.isGrouped(t),
          l = oy.isReversed(t),
          o = {},
          s = [],
          u = !1,
          f = {},
          v = 0,
          h = 0,
          d,
          y;
        function g(B, I, V) {
          if (t.visible !== !1 && !(a && B !== t._id)) if (I === "" || !oy.isGrouped(t)) {
            var K = "~~i" + v;
            s.push(K), o[K] = [V], v++;
          } else s.indexOf(I) === -1 ? (s.push(I), u = !0, o[I] = [V]) : o[I].push(V);
        }
        for (d = 0; d < r.length; d++) {
          var m = r[d],
            _ = m[0],
            w = _.trace,
            T = w.legend,
            b = w.legendgroup;
          if (!(!n && (!w.visible || !w.showlegend))) if (tw.traceIs(w, "pie-like")) for (f[b] || (f[b] = {}), y = 0; y < m.length; y++) {
            var A = m[y].label;
            f[b][A] || (g(T, b, {
              label: A,
              color: m[y].color,
              i: m[y].i,
              trace: w,
              pts: m[y].pts
            }), f[b][A] = !0, h = Math.max(h, (A || "").length));
          } else g(T, b, _), h = Math.max(h, (w.name || "").length);
        }
        if (!s.length) return [];
        var S = !u || !i,
          k = [];
        for (d = 0; d < s.length; d++) {
          var q = o[s[d]];
          S ? k.push(q[0]) : k.push(q);
        }
        for (S && (k = [k]), d = 0; d < k.length; d++) {
          var D = 1 / 0;
          for (y = 0; y < k[d].length; y++) {
            var R = k[d][y].trace.legendrank;
            D > R && (D = R);
          }
          k[d][0]._groupMinRank = D, k[d][0]._preGroupSort = d;
        }
        var z = function (B, I) {
            return B[0]._groupMinRank - I[0]._groupMinRank || B[0]._preGroupSort - I[0]._preGroupSort;
          },
          N = function (B, I) {
            return B.trace.legendrank - I.trace.legendrank || B._preSort - I._preSort;
          };
        for (k.forEach(function (B, I) {
          B[0]._preGroupSort = I;
        }), k.sort(z), d = 0; d < k.length; d++) {
          k[d].forEach(function (B, I) {
            B._preSort = I;
          }), k[d].sort(N);
          var H = k[d][0].trace,
            O = null;
          for (y = 0; y < k[d].length; y++) {
            var J = k[d][y].trace.legendgrouptitle;
            if (J && J.text) {
              O = J, n && (J.font = t._groupTitleFont);
              break;
            }
          }
          if (l && k[d].reverse(), O) {
            var X = !1;
            for (y = 0; y < k[d].length; y++) if (tw.traceIs(k[d][y].trace, "pie-like")) {
              X = !0;
              break;
            }
            k[d].unshift({
              i: -1,
              groupTitle: O,
              noClick: X,
              trace: {
                showlegend: H.showlegend,
                legendgroup: H.legendgroup,
                visible: t.groupclick === "toggleitem" ? !0 : H.visible
              }
            });
          }
          for (y = 0; y < k[d].length; y++) k[d][y] = [k[d][y]];
        }
        return t._lgroupsLength = k.length, t._maxNameLength = h, k;
      };
    });
    var H0 = Z(wo => {
      "use strict";

      var I0 = He();
      function iw(e) {
        return e.indexOf("e") !== -1 ? e.replace(/[.]?0+e/, "e") : e.indexOf(".") !== -1 ? e.replace(/[.]?0+$/, "") : e;
      }
      wo.formatPiePercent = function (r, t) {
        var a = iw((r * 100).toPrecision(3));
        return I0.numSeparate(a, t) + "%";
      };
      wo.formatPieValue = function (r, t) {
        var a = iw(r.toPrecision(10));
        return I0.numSeparate(a, t);
      };
      wo.getFirstFilled = function (r, t) {
        if (I0.isArrayOrTypedArray(r)) for (var a = 0; a < t.length; a++) {
          var n = r[t[a]];
          if (n || n === 0 || n === "") return n;
        }
      };
      wo.castOption = function (r, t) {
        if (I0.isArrayOrTypedArray(r)) return wo.getFirstFilled(r, t);
        if (r) return r;
      };
      wo.getRotationAngle = function (e) {
        return (e === "auto" ? 0 : e) * Math.PI / 180;
      };
    });
    var ow = Z((vse, lw) => {
      "use strict";

      var wV = tt(),
        TV = Er();
      lw.exports = function (r, t, a, n) {
        var i = a.marker.pattern;
        i && i.shape ? wV.pointStyle(r, a, n, t) : TV.fill(r, t.color);
      };
    });
    var O0 = Z((hse, fw) => {
      "use strict";

      var sw = Er(),
        uw = H0().castOption,
        MV = ow();
      fw.exports = function (r, t, a, n) {
        var i = a.marker.line,
          l = uw(i.color, t.pts) || sw.defaultLine,
          o = uw(i.width, t.pts) || 0;
        r.call(MV, t, a, n).style("stroke-width", o).call(sw.stroke, l);
      };
    });
    var cy = Z((dse, mw) => {
      "use strict";

      var Pa = Ir(),
        sy = gr(),
        wa = He(),
        cw = wa.strTranslate,
        Ba = tt(),
        An = Er(),
        uy = Tn().extractOpts,
        B0 = on(),
        AV = O0(),
        kV = H0().castOption,
        CV = ly(),
        vw = 12,
        hw = 5,
        To = 2,
        SV = 10,
        Hs = 5;
      mw.exports = function (r, t, a) {
        var n = t._fullLayout;
        a || (a = n.legend);
        var i = a.itemsizing === "constant",
          l = a.itemwidth,
          o = (l + CV.itemGap * 2) / 2,
          s = cw(o, 0),
          u = function (k, q, D, R) {
            var z;
            if (k + 1) z = k;else if (q && q.width > 0) z = q.width;else return 0;
            return i ? R : Math.min(z, D);
          };
        r.each(function (k) {
          var q = Pa.select(this),
            D = wa.ensureSingle(q, "g", "layers");
          D.style("opacity", k[0].trace.opacity);
          var R = a.indentation,
            z = a.valign,
            N = k[0].lineHeight,
            H = k[0].height;
          if (z === "middle" && R === 0 || !N || !H) D.attr("transform", null);else {
            var O = {
                top: 1,
                bottom: -1
              }[z],
              J = O * (.5 * (N - H + 3)) || 0,
              X = a.indentation;
            D.attr("transform", cw(X, J));
          }
          var B = D.selectAll("g.legendfill").data([k]);
          B.enter().append("g").classed("legendfill", !0);
          var I = D.selectAll("g.legendlines").data([k]);
          I.enter().append("g").classed("legendlines", !0);
          var V = D.selectAll("g.legendsymbols").data([k]);
          V.enter().append("g").classed("legendsymbols", !0), V.selectAll("g.legendpoints").data([k]).enter().append("g").classed("legendpoints", !0);
        }).each(S).each(h).each(y).each(d).each(m).each(b).each(T).each(f).each(v).each(_).each(w);
        function f(k) {
          var q = dw(k),
            D = q.showFill,
            R = q.showLine,
            z = q.showGradientLine,
            N = q.showGradientFill,
            H = q.anyFill,
            O = q.anyLine,
            J = k[0],
            X = J.trace,
            B,
            I,
            V = uy(X),
            K = V.colorscale,
            Q = V.reversescale,
            ie = function (Se) {
              if (Se.size()) if (D) Ba.fillGroupStyle(Se, t, !0);else {
                var ve = "legendfill-" + X.uid;
                Ba.gradient(Se, t, ve, fy(Q), K, "fill");
              }
            },
            me = function (Se) {
              if (Se.size()) {
                var ve = "legendline-" + X.uid;
                Ba.lineGroupStyle(Se), Ba.gradient(Se, t, ve, fy(Q), K, "stroke");
              }
            },
            pe = B0.hasMarkers(X) || !H ? "M5,0" : O ? "M5,-2" : "M5,-3",
            ge = Pa.select(this),
            j = ge.select(".legendfill").selectAll("path").data(D || N ? [k] : []);
          if (j.enter().append("path").classed("js-fill", !0), j.exit().remove(), j.attr("d", pe + "h" + l + "v6h-" + l + "z").call(ie), R || z) {
            var _e = u(void 0, X.line, SV, hw);
            I = wa.minExtend(X, {
              line: {
                width: _e
              }
            }), B = [wa.minExtend(J, {
              trace: I
            })];
          }
          var se = ge.select(".legendlines").selectAll("path").data(R || z ? [B] : []);
          se.enter().append("path").classed("js-line", !0), se.exit().remove(), se.attr("d", pe + (z ? "l" + l + ",0.0001" : "h" + l)).call(R ? Ba.lineGroupStyle : me);
        }
        function v(k) {
          var q = dw(k),
            D = q.anyFill,
            R = q.anyLine,
            z = q.showLine,
            N = q.showMarker,
            H = k[0],
            O = H.trace,
            J = !N && !R && !D && B0.hasText(O),
            X,
            B;
          function I(j, _e, se, Se) {
            var ve = wa.nestedProperty(O, j).get(),
              Ae = wa.isArrayOrTypedArray(ve) && _e ? _e(ve) : ve;
            if (i && Ae && Se !== void 0 && (Ae = Se), se) {
              if (Ae < se[0]) return se[0];
              if (Ae > se[1]) return se[1];
            }
            return Ae;
          }
          function V(j) {
            return H._distinct && H.index && j[H.index] ? j[H.index] : j[0];
          }
          if (N || J || z) {
            var K = {},
              Q = {};
            if (N) {
              K.mc = I("marker.color", V), K.mx = I("marker.symbol", V), K.mo = I("marker.opacity", wa.mean, [.2, 1]), K.mlc = I("marker.line.color", V), K.mlw = I("marker.line.width", wa.mean, [0, 5], To), Q.marker = {
                sizeref: 1,
                sizemin: 1,
                sizemode: "diameter"
              };
              var ie = I("marker.size", wa.mean, [2, 16], vw);
              K.ms = ie, Q.marker.size = ie;
            }
            z && (Q.line = {
              width: I("line.width", V, [0, 10], hw)
            }), J && (K.tx = "Aa", K.tp = I("textposition", V), K.ts = 10, K.tc = I("textfont.color", V), K.tf = I("textfont.family", V), K.tw = I("textfont.weight", V), K.ty = I("textfont.style", V), K.tv = I("textfont.variant", V), K.tC = I("textfont.textcase", V), K.tE = I("textfont.lineposition", V), K.tS = I("textfont.shadow", V)), X = [wa.minExtend(H, K)], B = wa.minExtend(O, Q), B.selectedpoints = null, B.texttemplate = null;
          }
          var me = Pa.select(this).select("g.legendpoints"),
            pe = me.selectAll("path.scatterpts").data(N ? X : []);
          pe.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", s), pe.exit().remove(), pe.call(Ba.pointStyle, B, t), N && (X[0].mrc = 3);
          var ge = me.selectAll("g.pointtext").data(J ? X : []);
          ge.enter().append("g").classed("pointtext", !0).append("text").attr("transform", s), ge.exit().remove(), ge.selectAll("text").call(Ba.textPointStyle, B, t);
        }
        function h(k) {
          var q = k[0].trace,
            D = q.type === "waterfall";
          if (k[0]._distinct && D) {
            var R = k[0].trace[k[0].dir].marker;
            return k[0].mc = R.color, k[0].mlw = R.line.width, k[0].mlc = R.line.color, g(k, this, "waterfall");
          }
          var z = [];
          q.visible && D && (z = k[0].hasTotals ? [["increasing", "M-6,-6V6H0Z"], ["totals", "M6,6H0L-6,-6H-0Z"], ["decreasing", "M6,6V-6H0Z"]] : [["increasing", "M-6,-6V6H6Z"], ["decreasing", "M6,6V-6H-6Z"]]);
          var N = Pa.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(z);
          N.enter().append("path").classed("legendwaterfall", !0).attr("transform", s).style("stroke-miterlimit", 1), N.exit().remove(), N.each(function (H) {
            var O = Pa.select(this),
              J = q[H[0]].marker,
              X = u(void 0, J.line, Hs, To);
            O.attr("d", H[1]).style("stroke-width", X + "px").call(An.fill, J.color), X && O.call(An.stroke, J.line.color);
          });
        }
        function d(k) {
          g(k, this);
        }
        function y(k) {
          g(k, this, "funnel");
        }
        function g(k, q, D) {
          var R = k[0].trace,
            z = R.marker || {},
            N = z.line || {},
            H = z.cornerradius ? "M6,3a3,3,0,0,1-3,3H-3a3,3,0,0,1-3-3V-3a3,3,0,0,1,3-3H3a3,3,0,0,1,3,3Z" : "M6,6H-6V-6H6Z",
            O = D ? R.visible && R.type === D : sy.traceIs(R, "bar"),
            J = Pa.select(q).select("g.legendpoints").selectAll("path.legend" + D).data(O ? [k] : []);
          J.enter().append("path").classed("legend" + D, !0).attr("d", H).attr("transform", s), J.exit().remove(), J.each(function (X) {
            var B = Pa.select(this),
              I = X[0],
              V = u(I.mlw, z.line, Hs, To);
            B.style("stroke-width", V + "px");
            var K = I.mcc;
            if (!a._inHover && "mc" in I) {
              var Q = uy(z),
                ie = Q.mid;
              ie === void 0 && (ie = (Q.max + Q.min) / 2), K = Ba.tryColorscale(z, "")(ie);
            }
            var me = K || I.mc || z.color,
              pe = z.pattern,
              ge = pe && Ba.getPatternAttr(pe.shape, 0, "");
            if (ge) {
              var j = Ba.getPatternAttr(pe.bgcolor, 0, null),
                _e = Ba.getPatternAttr(pe.fgcolor, 0, null),
                se = pe.fgopacity,
                Se = pw(pe.size, 8, 10),
                ve = pw(pe.solidity, .5, 1),
                Ae = "legend-" + R.uid;
              B.call(Ba.pattern, "legend", t, Ae, ge, Se, ve, K, pe.fillmode, j, _e, se);
            } else B.call(An.fill, me);
            V && An.stroke(B, I.mlc || N.color);
          });
        }
        function m(k) {
          var q = k[0].trace,
            D = Pa.select(this).select("g.legendpoints").selectAll("path.legendbox").data(q.visible && sy.traceIs(q, "box-violin") ? [k] : []);
          D.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", s), D.exit().remove(), D.each(function () {
            var R = Pa.select(this);
            if ((q.boxpoints === "all" || q.points === "all") && An.opacity(q.fillcolor) === 0 && An.opacity((q.line || {}).color) === 0) {
              var z = wa.minExtend(q, {
                marker: {
                  size: i ? vw : wa.constrain(q.marker.size, 2, 16),
                  sizeref: 1,
                  sizemin: 1,
                  sizemode: "diameter"
                }
              });
              D.call(Ba.pointStyle, z, t);
            } else {
              var N = u(void 0, q.line, Hs, To);
              R.style("stroke-width", N + "px").call(An.fill, q.fillcolor), N && An.stroke(R, q.line.color);
            }
          });
        }
        function _(k) {
          var q = k[0].trace,
            D = Pa.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(q.visible && q.type === "candlestick" ? [k, k] : []);
          D.enter().append("path").classed("legendcandle", !0).attr("d", function (R, z) {
            return z ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
          }).attr("transform", s).style("stroke-miterlimit", 1), D.exit().remove(), D.each(function (R, z) {
            var N = Pa.select(this),
              H = q[z ? "increasing" : "decreasing"],
              O = u(void 0, H.line, Hs, To);
            N.style("stroke-width", O + "px").call(An.fill, H.fillcolor), O && An.stroke(N, H.line.color);
          });
        }
        function w(k) {
          var q = k[0].trace,
            D = Pa.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(q.visible && q.type === "ohlc" ? [k, k] : []);
          D.enter().append("path").classed("legendohlc", !0).attr("d", function (R, z) {
            return z ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
          }).attr("transform", s).style("stroke-miterlimit", 1), D.exit().remove(), D.each(function (R, z) {
            var N = Pa.select(this),
              H = q[z ? "increasing" : "decreasing"],
              O = u(void 0, H.line, Hs, To);
            N.style("fill", "none").call(Ba.dashLine, H.line.dash, O), O && An.stroke(N, H.line.color);
          });
        }
        function T(k) {
          A(k, this, "pie");
        }
        function b(k) {
          A(k, this, "funnelarea");
        }
        function A(k, q, D) {
          var R = k[0],
            z = R.trace,
            N = D ? z.visible && z.type === D : sy.traceIs(z, D),
            H = Pa.select(q).select("g.legendpoints").selectAll("path.legend" + D).data(N ? [k] : []);
          if (H.enter().append("path").classed("legend" + D, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", s), H.exit().remove(), H.size()) {
            var O = z.marker || {},
              J = u(kV(O.line.width, R.pts), O.line, Hs, To),
              X = "pieLike",
              B = wa.minExtend(z, {
                marker: {
                  line: {
                    width: J
                  }
                }
              }, X),
              I = wa.minExtend(R, {
                trace: B
              }, X);
            AV(H, I, B, t);
          }
        }
        function S(k) {
          var q = k[0].trace,
            D,
            R = [];
          if (q.visible) switch (q.type) {
            case "histogram2d":
            case "heatmap":
              R = [["M-15,-2V4H15V-2Z"]], D = !0;
              break;
            case "choropleth":
            case "choroplethmapbox":
            case "choroplethmap":
              R = [["M-6,-6V6H6V-6Z"]], D = !0;
              break;
            case "densitymapbox":
            case "densitymap":
              R = [["M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"]], D = "radial";
              break;
            case "cone":
              R = [["M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"], ["M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"]], D = !1;
              break;
            case "streamtube":
              R = [["M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"], ["M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"]], D = !1;
              break;
            case "surface":
              R = [["M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"], ["M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"]], D = !0;
              break;
            case "mesh3d":
              R = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], D = !1;
              break;
            case "volume":
              R = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], D = !0;
              break;
            case "isosurface":
              R = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"]], D = !1;
              break;
          }
          var z = Pa.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(R);
          z.enter().append("path").classed("legend3dandfriends", !0).attr("transform", s).style("stroke-miterlimit", 1), z.exit().remove(), z.each(function (N, H) {
            var O = Pa.select(this),
              J = uy(q),
              X = J.colorscale,
              B = J.reversescale,
              I = function (ie) {
                if (ie.size()) {
                  var me = "legendfill-" + q.uid;
                  Ba.gradient(ie, t, me, fy(B, D === "radial"), X, "fill");
                }
              },
              V;
            if (X) {
              if (!D) {
                var Q = X.length;
                V = H === 0 ? X[B ? Q - 1 : 0][1] : H === 1 ? X[B ? 0 : Q - 1][1] : X[Math.floor((Q - 1) / 2)][1];
              }
            } else {
              var K = q.vertexcolor || q.facecolor || q.color;
              V = wa.isArrayOrTypedArray(K) ? K[H] || K[0] : K;
            }
            O.attr("d", N[0]), V ? O.call(An.fill, V) : O.call(I);
          });
        }
      };
      function fy(e, r) {
        var t = r ? "radial" : "horizontal";
        return t + (e ? "" : "reversed");
      }
      function dw(e) {
        var r = e[0].trace,
          t = r.contours,
          a = B0.hasLines(r),
          n = B0.hasMarkers(r),
          i = r.visible && r.fill && r.fill !== "none",
          l = !1,
          o = !1;
        if (t) {
          var s = t.coloring;
          s === "lines" ? l = !0 : a = s === "none" || s === "heatmap" || t.showlines, t.type === "constraint" ? i = t._operation !== "=" : (s === "fill" || s === "heatmap") && (o = !0);
        }
        return {
          showMarker: n,
          showLine: a,
          showFill: i,
          showGradientLine: l,
          showGradientFill: o,
          anyLine: a || l,
          anyFill: i || o
        };
      }
      function pw(e, r, t) {
        return e && wa.isArrayOrTypedArray(e) ? r : e > t ? t : e;
      }
    });
    var py = Z((pse, kw) => {
      "use strict";

      var Qa = Ir(),
        Nt = He(),
        hy = Pt(),
        Ys = gr(),
        yw = $u(),
        vy = Qn(),
        Ft = tt(),
        U0 = Er(),
        Mo = xa(),
        gw = ew(),
        Gt = ly(),
        dy = Da(),
        Mw = dy.LINE_SPACING,
        Bs = dy.FROM_TL,
        bw = dy.FROM_BR,
        xw = nw(),
        LV = cy(),
        _w = F0(),
        Os = 1,
        qV = /^legend[0-9]*$/;
      kw.exports = function (r, t) {
        if (t) ww(r, t);else {
          var a = r._fullLayout,
            n = a._legends,
            i = a._infolayer.selectAll('[class^="legend"]');
          i.each(function () {
            var u = Qa.select(this),
              f = u.attr("class"),
              v = f.split(" ")[0];
            v.match(qV) && n.indexOf(v) === -1 && u.remove();
          });
          for (var l = 0; l < n.length; l++) {
            var o = n[l],
              s = r._fullLayout[o];
            ww(r, s);
          }
        }
      };
      function DV(e, r, t) {
        if (!(r.title.side !== "top center" && r.title.side !== "top right")) {
          var a = r.title.font,
            n = a.size * Mw,
            i = 0,
            l = e.node(),
            o = Ft.bBox(l).width;
          r.title.side === "top center" ? i = .5 * (r._width - 2 * t - 2 * Gt.titlePad - o) : r.title.side === "top right" && (i = r._width - 2 * t - 2 * Gt.titlePad - o), Mo.positionText(e, t + Gt.titlePad + i, t + n);
        }
      }
      function ww(e, r) {
        var t = r || {},
          a = e._fullLayout,
          n = Z0(t),
          i,
          l,
          o = t._inHover;
        if (o ? (l = t.layer, i = "hover") : (l = a._infolayer, i = n), !!l) {
          i += a._uid, e._legendMouseDownTime || (e._legendMouseDownTime = 0);
          var s;
          if (o) {
            if (!t.entries) return;
            s = xw(t.entries, t);
          } else {
            for (var u = (e.calcdata || []).slice(), f = a.shapes, v = 0; v < f.length; v++) {
              var h = f[v];
              if (h.showlegend) {
                var d = {
                  _isShape: !0,
                  _fullInput: h,
                  index: h._index,
                  name: h.name || h.label.text || "shape " + h._index,
                  legend: h.legend,
                  legendgroup: h.legendgroup,
                  legendgrouptitle: h.legendgrouptitle,
                  legendrank: h.legendrank,
                  legendwidth: h.legendwidth,
                  showlegend: h.showlegend,
                  visible: h.visible,
                  opacity: h.opacity,
                  mode: h.type === "line" ? "lines" : "markers",
                  line: h.line,
                  marker: {
                    line: h.line,
                    color: h.fillcolor,
                    size: 12,
                    symbol: h.type === "rect" ? "square" : h.type === "circle" ? "circle" : "hexagon2"
                  }
                };
                u.push([{
                  trace: d
                }]);
              }
            }
            s = a.showlegend && xw(u, t, a._legends.length > 1);
          }
          var y = a.hiddenlabels || [];
          if (!o && (!a.showlegend || !s.length)) return l.selectAll("." + n).remove(), a._topdefs.select("#" + i).remove(), hy.autoMargin(e, n);
          var g = Nt.ensureSingle(l, "g", n, function (q) {
              o || q.attr("pointer-events", "all");
            }),
            m = Nt.ensureSingleById(a._topdefs, "clipPath", i, function (q) {
              q.append("rect");
            }),
            _ = Nt.ensureSingle(g, "rect", "bg", function (q) {
              q.attr("shape-rendering", "crispEdges");
            });
          _.call(U0.stroke, t.bordercolor).call(U0.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px");
          var w = Nt.ensureSingle(g, "g", "scrollbox"),
            T = t.title;
          t._titleWidth = 0, t._titleHeight = 0;
          var b;
          T.text ? (b = Nt.ensureSingle(w, "text", n + "titletext"), b.attr("text-anchor", "start").call(Ft.font, T.font).text(T.text), G0(b, w, e, t, Os)) : w.selectAll("." + n + "titletext").remove();
          var A = Nt.ensureSingle(g, "rect", "scrollbar", function (q) {
              q.attr(Gt.scrollBarEnterAttrs).call(U0.fill, Gt.scrollBarColor);
            }),
            S = w.selectAll("g.groups").data(s);
          S.enter().append("g").attr("class", "groups"), S.exit().remove();
          var k = S.selectAll("g.traces").data(Nt.identity);
          k.enter().append("g").attr("class", "traces"), k.exit().remove(), k.style("opacity", function (q) {
            var D = q[0].trace;
            return Ys.traceIs(D, "pie-like") ? y.indexOf(q[0].label) !== -1 ? .5 : 1 : D.visible === "legendonly" ? .5 : 1;
          }).each(function () {
            Qa.select(this).call(EV, e, t);
          }).call(LV, e, t).each(function () {
            o || Qa.select(this).call(PV, e, n);
          }), Nt.syncOrAsync([hy.previousPromises, function () {
            return NV(e, S, k, t);
          }, function () {
            var q = a._size,
              D = t.borderwidth,
              R = t.xref === "paper",
              z = t.yref === "paper";
            if (T.text && DV(b, t, D), !o) {
              var N, H;
              R ? N = q.l + q.w * t.x - Bs[V0(t)] * t._width : N = a.width * t.x - Bs[V0(t)] * t._width, z ? H = q.t + q.h * (1 - t.y) - Bs[W0(t)] * t._effHeight : H = a.height * (1 - t.y) - Bs[W0(t)] * t._effHeight;
              var O = FV(e, n, N, H);
              if (O) return;
              if (a.margin.autoexpand) {
                var J = N,
                  X = H;
                N = R ? Nt.constrain(N, 0, a.width - t._width) : J, H = z ? Nt.constrain(H, 0, a.height - t._effHeight) : X, N !== J && Nt.log("Constrain " + n + ".x to make legend fit inside graph"), H !== X && Nt.log("Constrain " + n + ".y to make legend fit inside graph");
              }
              Ft.setTranslate(g, N, H);
            }
            if (A.on(".drag", null), g.on("wheel", null), o || t._height <= t._maxHeight || e._context.staticPlot) {
              var B = t._effHeight;
              o && (B = t._height), _.attr({
                width: t._width - D,
                height: B - D,
                x: D / 2,
                y: D / 2
              }), Ft.setTranslate(w, 0, 0), m.select("rect").attr({
                width: t._width - 2 * D,
                height: B - 2 * D,
                x: D,
                y: D
              }), Ft.setClipUrl(w, i, e), Ft.setRect(A, 0, 0, 0, 0), delete t._scrollY;
            } else {
              var I = Math.max(Gt.scrollBarMinHeight, t._effHeight * t._effHeight / t._height),
                V = t._effHeight - I - 2 * Gt.scrollBarMargin,
                K = t._height - t._effHeight,
                Q = V / K,
                ie = Math.min(t._scrollY || 0, K);
              _.attr({
                width: t._width - 2 * D + Gt.scrollBarWidth + Gt.scrollBarMargin,
                height: t._effHeight - D,
                x: D / 2,
                y: D / 2
              }), m.select("rect").attr({
                width: t._width - 2 * D + Gt.scrollBarWidth + Gt.scrollBarMargin,
                height: t._effHeight - 2 * D,
                x: D,
                y: D + ie
              }), Ft.setClipUrl(w, i, e), ve(ie, I, Q), g.on("wheel", function () {
                ie = Nt.constrain(t._scrollY + Qa.event.deltaY / V * K, 0, K), ve(ie, I, Q), ie !== 0 && ie !== K && Qa.event.preventDefault();
              });
              var me,
                pe,
                ge,
                j = function (de, be, ye) {
                  var Fe = (ye - be) / Q + de;
                  return Nt.constrain(Fe, 0, K);
                },
                _e = function (de, be, ye) {
                  var Fe = (be - ye) / Q + de;
                  return Nt.constrain(Fe, 0, K);
                },
                se = Qa.behavior.drag().on("dragstart", function () {
                  var de = Qa.event.sourceEvent;
                  de.type === "touchstart" ? me = de.changedTouches[0].clientY : me = de.clientY, ge = ie;
                }).on("drag", function () {
                  var de = Qa.event.sourceEvent;
                  de.buttons === 2 || de.ctrlKey || (de.type === "touchmove" ? pe = de.changedTouches[0].clientY : pe = de.clientY, ie = j(ge, me, pe), ve(ie, I, Q));
                });
              A.call(se);
              var Se = Qa.behavior.drag().on("dragstart", function () {
                var de = Qa.event.sourceEvent;
                de.type === "touchstart" && (me = de.changedTouches[0].clientY, ge = ie);
              }).on("drag", function () {
                var de = Qa.event.sourceEvent;
                de.type === "touchmove" && (pe = de.changedTouches[0].clientY, ie = _e(ge, me, pe), ve(ie, I, Q));
              });
              w.call(Se);
            }
            function ve(de, be, ye) {
              t._scrollY = e._fullLayout[n]._scrollY = de, Ft.setTranslate(w, 0, -de), Ft.setRect(A, t._width, Gt.scrollBarMargin + de * ye, Gt.scrollBarWidth, be), m.select("rect").attr("y", D + de);
            }
            if (e._context.edits.legendPosition) {
              var Ae, Y, re, U;
              g.classed("cursor-move", !0), vy.init({
                element: g.node(),
                gd: e,
                prepFn: function (de) {
                  if (de.target !== A.node()) {
                    var be = Ft.getTranslate(g);
                    re = be.x, U = be.y;
                  }
                },
                moveFn: function (de, be) {
                  if (re !== void 0 && U !== void 0) {
                    var ye = re + de,
                      Fe = U + be;
                    Ft.setTranslate(g, ye, Fe), Ae = vy.align(ye, t._width, q.l, q.l + q.w, t.xanchor), Y = vy.align(Fe + t._height, -t._height, q.t + q.h, q.t, t.yanchor);
                  }
                },
                doneFn: function () {
                  if (Ae !== void 0 && Y !== void 0) {
                    var de = {};
                    de[n + ".x"] = Ae, de[n + ".y"] = Y, Ys.call("_guiRelayout", e, de);
                  }
                },
                clickFn: function (de, be) {
                  var ye = l.selectAll("g.traces").filter(function () {
                    var Fe = this.getBoundingClientRect();
                    return be.clientX >= Fe.left && be.clientX <= Fe.right && be.clientY >= Fe.top && be.clientY <= Fe.bottom;
                  });
                  ye.size() > 0 && Aw(e, g, ye, de, be);
                }
              });
            }
          }], e);
        }
      }
      function Y0(e, r, t) {
        var a = e[0],
          n = a.width,
          i = r.entrywidthmode,
          l = a.trace.legendwidth || r.entrywidth;
        return i === "fraction" ? r._maxWidth * l : t + (l || n);
      }
      function Aw(e, r, t, a, n) {
        var i = t.data()[0][0].trace,
          l = {
            event: n,
            node: t.node(),
            curveNumber: i.index,
            expandedIndex: i.index,
            data: e.data,
            layout: e.layout,
            frames: e._transitionData._frames,
            config: e._context,
            fullData: e._fullData,
            fullLayout: e._fullLayout
          };
        i._group && (l.group = i._group), Ys.traceIs(i, "pie-like") && (l.label = t.datum()[0].label);
        var o = yw.triggerHandler(e, "plotly_legendclick", l);
        if (a === 1) {
          if (o === !1) return;
          r._clickTimeout = setTimeout(function () {
            e._fullLayout && gw(t, e, a);
          }, e._context.doubleClickDelay);
        } else if (a === 2) {
          r._clickTimeout && clearTimeout(r._clickTimeout), e._legendMouseDownTime = 0;
          var s = yw.triggerHandler(e, "plotly_legenddoubleclick", l);
          s !== !1 && o !== !1 && gw(t, e, a);
        }
      }
      function EV(e, r, t) {
        var a = Z0(t),
          n = e.data()[0][0],
          i = n.trace,
          l = Ys.traceIs(i, "pie-like"),
          o = !t._inHover && r._context.edits.legendText && !l,
          s = t._maxNameLength,
          u,
          f;
        n.groupTitle ? (u = n.groupTitle.text, f = n.groupTitle.font) : (f = t.font, t.entries ? u = n.text : (u = l ? n.label : i.name, i._meta && (u = Nt.templateString(u, i._meta))));
        var v = Nt.ensureSingle(e, "text", a + "text");
        v.attr("text-anchor", "start").call(Ft.font, f).text(o ? Tw(u, s) : u);
        var h = t.indentation + t.itemwidth + Gt.itemGap * 2;
        Mo.positionText(v, h, 0), o ? v.call(Mo.makeEditable, {
          gd: r,
          text: u
        }).call(G0, e, r, t).on("edit", function (d) {
          this.text(Tw(d, s)).call(G0, e, r, t);
          var y = n.trace._fullInput || {},
            g = {};
          return g.name = d, y._isShape ? Ys.call("_guiRelayout", r, "shapes[" + i.index + "].name", g.name) : Ys.call("_guiRestyle", r, g, i.index);
        }) : G0(v, e, r, t);
      }
      function Tw(e, r) {
        var t = Math.max(4, r);
        if (e && e.trim().length >= t / 2) return e;
        e = e || "";
        for (var a = t - e.length; a > 0; a--) e += " ";
        return e;
      }
      function PV(e, r, t) {
        var a = r._context.doubleClickDelay,
          n,
          i = 1,
          l = Nt.ensureSingle(e, "rect", t + "toggle", function (o) {
            r._context.staticPlot || o.style("cursor", "pointer").attr("pointer-events", "all"), o.call(U0.fill, "rgba(0,0,0,0)");
          });
        r._context.staticPlot || (l.on("mousedown", function () {
          n = new Date().getTime(), n - r._legendMouseDownTime < a ? i += 1 : (i = 1, r._legendMouseDownTime = n);
        }), l.on("mouseup", function () {
          if (!(r._dragged || r._editing)) {
            var o = r._fullLayout[t];
            new Date().getTime() - r._legendMouseDownTime > a && (i = Math.max(i - 1, 1)), Aw(r, o, e, i, Qa.event);
          }
        }));
      }
      function G0(e, r, t, a, n) {
        a._inHover && e.attr("data-notex", !0), Mo.convertToTspans(e, t, function () {
          RV(r, t, a, n);
        });
      }
      function RV(e, r, t, a) {
        var n = e.data()[0][0];
        if (!t._inHover && n && !n.trace.showlegend) {
          e.remove();
          return;
        }
        var i = e.select("g[class*=math-group]"),
          l = i.node(),
          o = Z0(t);
        t || (t = r._fullLayout[o]);
        var s = t.borderwidth,
          u;
        a === Os ? u = t.title.font : n.groupTitle ? u = n.groupTitle.font : u = t.font;
        var f = u.size * Mw,
          v,
          h;
        if (l) {
          var d = Ft.bBox(l);
          v = d.height, h = d.width, a === Os ? Ft.setTranslate(i, s, s + v * .75) : Ft.setTranslate(i, 0, v * .25);
        } else {
          var y = "." + o + (a === Os ? "title" : "") + "text",
            g = e.select(y),
            m = Mo.lineCount(g),
            _ = g.node();
          if (v = f * m, h = _ ? Ft.bBox(_).width : 0, a === Os) t.title.side === "left" && (h += Gt.itemGap * 2), Mo.positionText(g, s + Gt.titlePad, s + f);else {
            var w = Gt.itemGap * 2 + t.indentation + t.itemwidth;
            n.groupTitle && (w = Gt.itemGap, h -= t.indentation + t.itemwidth), Mo.positionText(g, w, -f * ((m - 1) / 2 - .3));
          }
        }
        a === Os ? (t._titleWidth = h, t._titleHeight = v) : (n.lineHeight = f, n.height = Math.max(v, 16) + 3, n.width = h);
      }
      function zV(e) {
        var r = 0,
          t = 0,
          a = e.title.side;
        return a && (a.indexOf("left") !== -1 && (r = e._titleWidth), a.indexOf("top") !== -1 && (t = e._titleHeight)), [r, t];
      }
      function NV(e, r, t, a) {
        var n = e._fullLayout,
          i = Z0(a);
        a || (a = n[i]);
        var l = n._size,
          o = _w.isVertical(a),
          s = _w.isGrouped(a),
          u = a.entrywidthmode === "fraction",
          f = a.borderwidth,
          v = 2 * f,
          h = Gt.itemGap,
          d = a.indentation + a.itemwidth + h * 2,
          y = 2 * (f + h),
          g = W0(a),
          m = a.y < 0 || a.y === 0 && g === "top",
          _ = a.y > 1 || a.y === 1 && g === "bottom",
          w = a.tracegroupgap,
          T = {};
        a._maxHeight = Math.max(m || _ ? n.height / 2 : l.h, 30);
        var b = 0;
        a._width = 0, a._height = 0;
        var A = zV(a);
        if (o) t.each(function (ge) {
          var j = ge[0].height;
          Ft.setTranslate(this, f + A[0], f + A[1] + a._height + j / 2 + h), a._height += j, a._width = Math.max(a._width, ge[0].width);
        }), b = d + a._width, a._width += h + d + v, a._height += y, s && (r.each(function (ge, j) {
          Ft.setTranslate(this, 0, j * a.tracegroupgap);
        }), a._height += (a._lgroupsLength - 1) * a.tracegroupgap);else {
          var S = V0(a),
            k = a.x < 0 || a.x === 0 && S === "right",
            q = a.x > 1 || a.x === 1 && S === "left",
            D = _ || m,
            R = n.width / 2;
          a._maxWidth = Math.max(k ? D && S === "left" ? l.l + l.w : R : q ? D && S === "right" ? l.r + l.w : R : l.w, 2 * d);
          var z = 0,
            N = 0;
          t.each(function (ge) {
            var j = Y0(ge, a, d);
            z = Math.max(z, j), N += j;
          }), b = null;
          var H = 0;
          if (s) {
            var O = 0,
              J = 0,
              X = 0;
            r.each(function () {
              var ge = 0,
                j = 0;
              Qa.select(this).selectAll("g.traces").each(function (se) {
                var Se = Y0(se, a, d),
                  ve = se[0].height;
                Ft.setTranslate(this, A[0], A[1] + f + h + ve / 2 + j), j += ve, ge = Math.max(ge, Se), T[se[0].trace.legendgroup] = ge;
              });
              var _e = ge + h;
              J > 0 && _e + f + J > a._maxWidth ? (H = Math.max(H, J), J = 0, X += O + w, O = j) : O = Math.max(O, j), Ft.setTranslate(this, J, X), J += _e;
            }), a._width = Math.max(H, J) + f, a._height = X + O + y;
          } else {
            var B = t.size(),
              I = N + v + (B - 1) * h < a._maxWidth,
              V = 0,
              K = 0,
              Q = 0,
              ie = 0;
            t.each(function (ge) {
              var j = ge[0].height,
                _e = Y0(ge, a, d, s),
                se = I ? _e : z;
              u || (se += h), se + f + K - h >= a._maxWidth && (H = Math.max(H, ie), K = 0, Q += V, a._height += V, V = 0), Ft.setTranslate(this, A[0] + f + K, A[1] + f + Q + j / 2 + h), ie = K + _e + h, K += se, V = Math.max(V, j);
            }), I ? (a._width = K + v, a._height = V + y) : (a._width = Math.max(H, ie) + v, a._height += V + y);
          }
        }
        a._width = Math.ceil(Math.max(a._width + A[0], a._titleWidth + 2 * (f + Gt.titlePad))), a._height = Math.ceil(Math.max(a._height + A[1], a._titleHeight + 2 * (f + Gt.itemGap))), a._effHeight = Math.min(a._height, a._maxHeight);
        var me = e._context.edits,
          pe = me.legendText || me.legendPosition;
        t.each(function (ge) {
          var j = Qa.select(this).select("." + i + "toggle"),
            _e = ge[0].height,
            se = ge[0].trace.legendgroup,
            Se = Y0(ge, a, d);
          s && se !== "" && (Se = T[se]);
          var ve = pe ? d : b || Se;
          !o && !u && (ve += h / 2), Ft.setRect(j, 0, -_e / 2, ve, _e);
        });
      }
      function FV(e, r, t, a) {
        var n = e._fullLayout,
          i = n[r],
          l = V0(i),
          o = W0(i),
          s = i.xref === "paper",
          u = i.yref === "paper";
        e._fullLayout._reservedMargin[r] = {};
        var f = i.y < .5 ? "b" : "t",
          v = i.x < .5 ? "l" : "r",
          h = {
            r: n.width - t,
            l: t + i._width,
            b: n.height - a,
            t: a + i._effHeight
          };
        if (s && u) return hy.autoMargin(e, r, {
          x: i.x,
          y: i.y,
          l: i._width * Bs[l],
          r: i._width * bw[l],
          b: i._effHeight * bw[o],
          t: i._effHeight * Bs[o]
        });
        s ? e._fullLayout._reservedMargin[r][f] = h[f] : u || i.orientation === "v" ? e._fullLayout._reservedMargin[r][v] = h[v] : e._fullLayout._reservedMargin[r][f] = h[f];
      }
      function V0(e) {
        return Nt.isRightAnchor(e) ? "right" : Nt.isCenterAnchor(e) ? "center" : "left";
      }
      function W0(e) {
        return Nt.isBottomAnchor(e) ? "bottom" : Nt.isMiddleAnchor(e) ? "middle" : "top";
      }
      function Z0(e) {
        return e._id || "legend";
      }
    });
    var by = Z(gy => {
      "use strict";

      var Ao = Ir(),
        Gi = Hr(),
        Cw = bn(),
        Mt = He(),
        IV = Mt.pushUnique,
        my = Mt.strTranslate,
        HV = Mt.strRotate,
        OV = $u(),
        kn = xa(),
        BV = K8(),
        Mi = tt(),
        Kt = Er(),
        X0 = Qn(),
        Ai = dt(),
        YV = da().zindexSeparator,
        Gs = gr(),
        $n = bi(),
        ko = Yu(),
        UV = ay(),
        GV = py(),
        zw = ko.YANGLE,
        yy = Math.PI * zw / 180,
        VV = 1 / Math.sin(yy),
        WV = Math.cos(yy),
        ZV = Math.sin(yy),
        gt = ko.HOVERARROWSIZE,
        Or = ko.HOVERTEXTPAD,
        Sw = {
          box: !0,
          ohlc: !0,
          violin: !0,
          candlestick: !0
        },
        XV = {
          scatter: !0,
          scattergl: !0,
          splom: !0
        };
      function Lw(e, r) {
        return e.distance - r.distance;
      }
      gy.hover = function (r, t, a, n) {
        r = Mt.getGraphDiv(r);
        var i = t.target;
        Mt.throttle(r._fullLayout._uid + ko.HOVERID, ko.HOVERMINTIME, function () {
          JV(r, t, a, n, i);
        });
      };
      gy.loneHover = function (r, t) {
        var a = !0;
        Array.isArray(r) || (a = !1, r = [r]);
        var n = t.gd,
          i = Ow(n),
          l = Bw(n),
          o = r.map(function (m) {
            var _ = m._x0 || m.x0 || m.x || 0,
              w = m._x1 || m.x1 || m.x || 0,
              T = m._y0 || m.y0 || m.y || 0,
              b = m._y1 || m.y1 || m.y || 0,
              A = m.eventData;
            if (A) {
              var S = Math.min(_, w),
                k = Math.max(_, w),
                q = Math.min(T, b),
                D = Math.max(T, b),
                R = m.trace;
              if (Gs.traceIs(R, "gl3d")) {
                var z = n._fullLayout[R.scene]._scene.container,
                  N = z.offsetLeft,
                  H = z.offsetTop;
                S += N, k += N, q += H, D += H;
              }
              A.bbox = {
                x0: S + l,
                x1: k + l,
                y0: q + i,
                y1: D + i
              }, t.inOut_bbox && t.inOut_bbox.push(A.bbox);
            } else A = !1;
            return {
              color: m.color || Kt.defaultLine,
              x0: m.x0 || m.x || 0,
              x1: m.x1 || m.x || 0,
              y0: m.y0 || m.y || 0,
              y1: m.y1 || m.y || 0,
              xLabel: m.xLabel,
              yLabel: m.yLabel,
              zLabel: m.zLabel,
              text: m.text,
              name: m.name,
              idealAlign: m.idealAlign,
              borderColor: m.borderColor,
              fontFamily: m.fontFamily,
              fontSize: m.fontSize,
              fontColor: m.fontColor,
              fontWeight: m.fontWeight,
              fontStyle: m.fontStyle,
              fontVariant: m.fontVariant,
              nameLength: m.nameLength,
              textAlign: m.textAlign,
              trace: m.trace || {
                index: 0,
                hoverinfo: ""
              },
              xa: {
                _offset: 0
              },
              ya: {
                _offset: 0
              },
              index: 0,
              hovertemplate: m.hovertemplate || !1,
              hovertemplateLabels: m.hovertemplateLabels || !1,
              eventData: A
            };
          }),
          s = !1,
          u = Fw(o, {
            gd: n,
            hovermode: "closest",
            rotateLabels: s,
            bgColor: t.bgColor || Kt.background,
            container: Ao.select(t.container),
            outerContainer: t.outerContainer || t.container
          }),
          f = u.hoverLabels,
          v = 5,
          h = 0,
          d = 0;
        f.sort(function (m, _) {
          return m.y0 - _.y0;
        }).each(function (m, _) {
          var w = m.y0 - m.by / 2;
          w - v < h ? m.offset = h - w + v : m.offset = 0, h = w + m.by + m.offset, _ === t.anchorIndex && (d = m.offset);
        }).each(function (m) {
          m.offset -= d;
        });
        var y = n._fullLayout._invScaleX,
          g = n._fullLayout._invScaleY;
        return Hw(f, s, y, g), a ? f : f.node();
      };
      function JV(e, r, t, a, n) {
        t || (t = "xy"), typeof t == "string" && (t = t.split(YV)[0]);
        var i = Array.isArray(t) ? t : [t],
          l,
          o = e._fullLayout,
          s = o.hoversubplots,
          u = o._plots || [],
          f = u[t],
          v = o._has("cartesian"),
          h = r.hovermode || o.hovermode,
          d = (h || "").charAt(0) === "x",
          y = (h || "").charAt(0) === "y",
          g,
          m;
        if (v && (d || y) && s === "axis") {
          for (var _ = i.length, w = 0; w < _; w++) if (l = i[w], u[l]) {
            g = Ai.getFromId(e, l, "x"), m = Ai.getFromId(e, l, "y");
            var T = (d ? g : m)._subplotsWith;
            if (T && T.length) for (var b = 0; b < T.length; b++) IV(i, T[b]);
          }
        }
        if (f && s !== "single") {
          var A = f.overlays.map(function (yr) {
            return yr.id;
          });
          i = i.concat(A);
        }
        for (var S = i.length, k = new Array(S), q = new Array(S), D = !1, R = 0; R < S; R++) if (l = i[R], u[l]) D = !0, k[R] = u[l].xaxis, q[R] = u[l].yaxis;else if (o[l] && o[l]._subplot) {
          var z = o[l]._subplot;
          k[R] = z.xaxis, q[R] = z.yaxis;
        } else {
          Mt.warn("Unrecognized subplot: " + l);
          return;
        }
        if (h && !D && (h = "closest"), ["x", "y", "closest", "x unified", "y unified"].indexOf(h) === -1 || !e.calcdata || e.querySelector(".zoombox") || e._dragging) return X0.unhoverRaw(e, r);
        var N = o.hoverdistance;
        N === -1 && (N = 1 / 0);
        var H = o.spikedistance;
        H === -1 && (H = 1 / 0);
        var O = [],
          J = [],
          X,
          B,
          I,
          V,
          K,
          Q,
          ie,
          me,
          pe,
          ge,
          j,
          _e,
          se,
          Se = {
            hLinePoint: null,
            vLinePoint: null
          },
          ve = !1;
        if (Array.isArray(r)) for (h = "array", I = 0; I < r.length; I++) K = e.calcdata[r[I].curveNumber || 0], K && (Q = K[0].trace, K[0].trace.hoverinfo !== "skip" && (J.push(K), Q.orientation === "h" && (ve = !0)));else {
          var Ae = e.calcdata.slice();
          for (Ae.sort(function (yr, lt) {
            var Wr = yr[0].trace.zorder || 0,
              mt = lt[0].trace.zorder || 0;
            return Wr - mt;
          }), V = 0; V < Ae.length; V++) K = Ae[V], Q = K[0].trace, Q.hoverinfo !== "skip" && $n.isTraceInSubplots(Q, i) && (J.push(K), Q.orientation === "h" && (ve = !0));
          var Y = !n,
            re,
            U;
          if (Y) "xpx" in r ? re = r.xpx : re = k[0]._length / 2, "ypx" in r ? U = r.ypx : U = q[0]._length / 2;else {
            if (OV.triggerHandler(e, "plotly_beforehover", r) === !1) return;
            var de = n.getBoundingClientRect();
            re = r.clientX - de.left, U = r.clientY - de.top, o._calcInverseTransform(e);
            var be = Mt.apply3DTransform(o._invTransform)(re, U);
            if (re = be[0], U = be[1], re < 0 || re > k[0]._length || U < 0 || U > q[0]._length) return X0.unhoverRaw(e, r);
          }
          if (r.pointerX = re + k[0]._offset, r.pointerY = U + q[0]._offset, "xval" in r ? X = $n.flat(i, r.xval) : X = $n.p2c(k, re), "yval" in r ? B = $n.flat(i, r.yval) : B = $n.p2c(q, U), !Gi(X[0]) || !Gi(B[0])) return Mt.warn("Fx.hover failed", r, e), X0.unhoverRaw(e, r);
        }
        var ye = 1 / 0;
        function Fe(yr, lt) {
          for (V = 0; V < J.length; V++) if (K = J[V], !(!K || !K[0] || !K[0].trace) && (Q = K[0].trace, !(Q.visible !== !0 || Q._length === 0) && ["carpet", "contourcarpet"].indexOf(Q._module.name) === -1)) {
            if (pe = h, $n.isUnifiedHover(pe) && (pe = pe.charAt(0)), Q.type === "splom" ? (me = 0, ie = i[me]) : (ie = $n.getSubplot(Q), me = i.indexOf(ie)), _e = {
              cd: K,
              trace: Q,
              xa: k[me],
              ya: q[me],
              maxHoverDistance: N,
              maxSpikeDistance: H,
              index: !1,
              distance: Math.min(ye, N),
              spikeDistance: 1 / 0,
              xSpike: void 0,
              ySpike: void 0,
              color: Kt.defaultLine,
              name: Q.name,
              x0: void 0,
              x1: void 0,
              y0: void 0,
              y1: void 0,
              xLabelVal: void 0,
              yLabelVal: void 0,
              zLabelVal: void 0,
              text: void 0
            }, o[ie] && (_e.subplot = o[ie]._subplot), o._splomScenes && o._splomScenes[Q.uid] && (_e.scene = o._splomScenes[Q.uid]), pe === "array") {
              var Wr = r[V];
              "pointNumber" in Wr ? (_e.index = Wr.pointNumber, pe = "closest") : (pe = "", "xval" in Wr && (ge = Wr.xval, pe = "x"), "yval" in Wr && (j = Wr.yval, pe = pe ? "closest" : "y"));
            } else yr !== void 0 && lt !== void 0 ? (ge = yr, j = lt) : (ge = X[me], j = B[me]);
            if (se = O.length, N !== 0) if (Q._module && Q._module.hoverPoints) {
              var mt = Q._module.hoverPoints(_e, ge, j, pe, {
                finiteRange: !0,
                hoverLayer: o._hoverlayer,
                hoversubplots: s,
                gd: e
              });
              if (mt) for (var Tt, ot = 0; ot < mt.length; ot++) Tt = mt[ot], Gi(Tt.x0) && Gi(Tt.y0) && O.push(jV(Tt, h));
            } else Mt.log("Unrecognized trace type in hover:", Q);
            if (h === "closest" && O.length > se && (O.splice(0, se), ye = O[0].distance), v && H !== 0 && O.length === 0) {
              _e.distance = H, _e.index = !1;
              var yt = Q._module.hoverPoints(_e, ge, j, "closest", {
                hoverLayer: o._hoverlayer
              });
              if (yt && (yt = yt.filter(function (at) {
                return at.spikeDistance <= H;
              })), yt && yt.length) {
                var Ca,
                  aa = yt.filter(function (at) {
                    return at.xa.showspikes && at.xa.spikesnap !== "hovered data";
                  });
                if (aa.length) {
                  var In = aa[0];
                  Gi(In.x0) && Gi(In.y0) && (Ca = Pe(In), (!Se.vLinePoint || Se.vLinePoint.spikeDistance > Ca.spikeDistance) && (Se.vLinePoint = Ca));
                }
                var Hn = yt.filter(function (at) {
                  return at.ya.showspikes && at.ya.spikesnap !== "hovered data";
                });
                if (Hn.length) {
                  var Wt = Hn[0];
                  Gi(Wt.x0) && Gi(Wt.y0) && (Ca = Pe(Wt), (!Se.hLinePoint || Se.hLinePoint.spikeDistance > Ca.spikeDistance) && (Se.hLinePoint = Ca));
                }
              }
            }
          }
        }
        Fe();
        function Re(yr, lt, Wr) {
          for (var mt = null, Tt = 1 / 0, ot, yt = 0; yt < yr.length; yt++) g && g._id !== yr[yt].xa._id || m && m._id !== yr[yt].ya._id || (ot = yr[yt].spikeDistance, Wr && yt === 0 && (ot = -1 / 0), ot <= Tt && ot <= lt && (mt = yr[yt], Tt = ot));
          return mt;
        }
        function Pe(yr) {
          return yr ? {
            xa: yr.xa,
            ya: yr.ya,
            x: yr.xSpike !== void 0 ? yr.xSpike : (yr.x0 + yr.x1) / 2,
            y: yr.ySpike !== void 0 ? yr.ySpike : (yr.y0 + yr.y1) / 2,
            distance: yr.distance,
            spikeDistance: yr.spikeDistance,
            curveNumber: yr.trace.index,
            color: yr.color,
            pointNumber: yr.index
          } : null;
        }
        var Ie = {
            fullLayout: o,
            container: o._hoverlayer,
            event: r
          },
          Be = e._spikepoints,
          Ne = {
            vLinePoint: Se.vLinePoint,
            hLinePoint: Se.hLinePoint
          };
        e._spikepoints = Ne;
        var Ee = function () {
          var yr = O.filter(function (Wr) {
              return g && g._id === Wr.xa._id && m && m._id === Wr.ya._id;
            }),
            lt = O.filter(function (Wr) {
              return !(g && g._id === Wr.xa._id && m && m._id === Wr.ya._id);
            });
          yr.sort(Lw), lt.sort(Lw), O = yr.concat(lt), O = rW(O, h);
        };
        Ee();
        var Je = h.charAt(0),
          We = (Je === "x" || Je === "y") && O[0] && XV[O[0].trace.type];
        if (v && H !== 0 && O.length !== 0) {
          var ne = O.filter(function (yr) {
              return yr.ya.showspikes;
            }),
            Me = Re(ne, H, We);
          Se.hLinePoint = Pe(Me);
          var Ce = O.filter(function (yr) {
              return yr.xa.showspikes;
            }),
            cr = Re(Ce, H, We);
          Se.vLinePoint = Pe(cr);
        }
        if (O.length === 0) {
          var tr = X0.unhoverRaw(e, r);
          return v && (Se.hLinePoint !== null || Se.vLinePoint !== null) && Ew(Be) && Dw(e, Se, Ie), tr;
        }
        if (v && Ew(Be) && Dw(e, Se, Ie), $n.isXYhover(pe) && O[0].length !== 0 && O[0].trace.type !== "splom") {
          var De = O[0];
          Sw[De.trace.type] ? O = O.filter(function (yr) {
            return yr.trace.index === De.trace.index;
          }) : O = [De];
          var Le = O.length,
            Ye = Rw("x", De, o),
            Ze = Rw("y", De, o);
          Fe(Ye, Ze);
          var Ue = [],
            Oe = {},
            Ke = 0,
            fr = function (yr) {
              var lt = Sw[yr.trace.type] ? Nw(yr) : yr.trace.index;
              if (!Oe[lt]) Ke++, Oe[lt] = Ke, Ue.push(yr);else {
                var Wr = Oe[lt] - 1,
                  mt = Ue[Wr];
                Wr > 0 && Math.abs(yr.distance) < Math.abs(mt.distance) && (Ue[Wr] = yr);
              }
            },
            lr;
          for (lr = 0; lr < Le; lr++) fr(O[lr]);
          for (lr = O.length - 1; lr > Le - 1; lr--) fr(O[lr]);
          O = Ue, Ee();
        }
        var ze = e._hoverdata,
          ae = [],
          oe = Ow(e),
          qe = Bw(e);
        for (I = 0; I < O.length; I++) {
          var ke = O[I],
            ir = $n.makeEventData(ke, ke.trace, ke.cd);
          if (ke.hovertemplate !== !1) {
            var vr = !1;
            ke.cd[ke.index] && ke.cd[ke.index].ht && (vr = ke.cd[ke.index].ht), ke.hovertemplate = vr || ke.trace.hovertemplate || !1;
          }
          if (ke.xa && ke.ya) {
            var sr = ke.x0 + ke.xa._offset,
              Mr = ke.x1 + ke.xa._offset,
              Ur = ke.y0 + ke.ya._offset,
              $r = ke.y1 + ke.ya._offset,
              Vr = Math.min(sr, Mr),
              St = Math.max(sr, Mr),
              ea = Math.min(Ur, $r),
              ka = Math.max(Ur, $r);
            ir.bbox = {
              x0: Vr + qe,
              x1: St + qe,
              y0: ea + oe,
              y1: ka + oe
            };
          }
          ke.eventData = [ir], ae.push(ir);
        }
        e._hoverdata = ae;
        var ra = h === "y" && (J.length > 1 || O.length > 1) || h === "closest" && ve && O.length > 1,
          pn = Kt.combine(o.plot_bgcolor || Kt.background, o.paper_bgcolor),
          Ia = Fw(O, {
            gd: e,
            hovermode: h,
            rotateLabels: ra,
            bgColor: pn,
            container: o._hoverlayer,
            outerContainer: o._paper.node(),
            commonLabelOpts: o.hoverlabel,
            hoverdistance: o.hoverdistance
          }),
          ta = Ia.hoverLabels;
        if ($n.isUnifiedHover(h) || (QV(ta, ra, o, Ia.commonLabelBoundingBox), Hw(ta, ra, o._invScaleX, o._invScaleY)), n && n.tagName) {
          var Ha = Gs.getComponentMethod("annotations", "hasClickToShow")(e, ae);
          BV(Ao.select(n), Ha ? "pointer" : "");
        }
        !n || a || !eW(e, r, ze) || (ze && e.emit("plotly_unhover", {
          event: r,
          points: ze
        }), e.emit("plotly_hover", {
          event: r,
          points: e._hoverdata,
          xaxes: k,
          yaxes: q,
          xvals: X,
          yvals: B
        }));
      }
      function Nw(e) {
        return [e.trace.index, e.index, e.x0, e.y0, e.name, e.attr, e.xa ? e.xa._id : "", e.ya ? e.ya._id : ""].join(",");
      }
      var KV = /<extra>([\s\S]*)<\/extra>/;
      function Fw(e, r) {
        var t = r.gd,
          a = t._fullLayout,
          n = r.hovermode,
          i = r.rotateLabels,
          l = r.bgColor,
          o = r.container,
          s = r.outerContainer,
          u = r.commonLabelOpts || {};
        if (e.length === 0) return [[]];
        var f = r.fontFamily || ko.HOVERFONT,
          v = r.fontSize || ko.HOVERFONTSIZE,
          h = r.fontWeight || a.font.weight,
          d = r.fontStyle || a.font.style,
          y = r.fontVariant || a.font.variant,
          g = r.fontTextcase || a.font.textcase,
          m = r.fontLineposition || a.font.lineposition,
          _ = r.fontShadow || a.font.shadow,
          w = e[0],
          T = w.xa,
          b = w.ya,
          A = n.charAt(0),
          S = A + "Label",
          k = w[S];
        if (k === void 0 && T.type === "multicategory") for (var q = 0; q < e.length && (k = e[q][S], k === void 0); q++);
        var D = Us(t, s),
          R = D.top,
          z = D.width,
          N = D.height,
          H = k !== void 0 && w.distance <= r.hoverdistance && (n === "x" || n === "y");
        if (H) {
          var O = !0,
            J,
            X;
          for (J = 0; J < e.length; J++) if (O && e[J].zLabel === void 0 && (O = !1), X = e[J].hoverinfo || e[J].trace.hoverinfo, X) {
            var B = Array.isArray(X) ? X : X.split("+");
            if (B.indexOf("all") === -1 && B.indexOf(n) === -1) {
              H = !1;
              break;
            }
          }
          O && (H = !1);
        }
        var I = o.selectAll("g.axistext").data(H ? [0] : []);
        I.enter().append("g").classed("axistext", !0), I.exit().remove();
        var V = {
          minX: 0,
          maxX: 0,
          minY: 0,
          maxY: 0
        };
        if (I.each(function () {
          var Ce = Ao.select(this),
            cr = Mt.ensureSingle(Ce, "path", "", function (Vr) {
              Vr.style({
                "stroke-width": "1px"
              });
            }),
            tr = Mt.ensureSingle(Ce, "text", "", function (Vr) {
              Vr.attr("data-notex", 1);
            }),
            De = u.bgcolor || Kt.defaultLine,
            Le = u.bordercolor || Kt.contrast(De),
            Ye = Kt.contrast(De),
            Ze = u.font,
            Ue = {
              weight: Ze.weight || h,
              style: Ze.style || d,
              variant: Ze.variant || y,
              textcase: Ze.textcase || g,
              lineposition: Ze.lineposition || m,
              shadow: Ze.shadow || _,
              family: Ze.family || f,
              size: Ze.size || v,
              color: Ze.color || Ye
            };
          cr.style({
            fill: De,
            stroke: Le
          }), tr.text(k).call(Mi.font, Ue).call(kn.positionText, 0, 0).call(kn.convertToTspans, t), Ce.attr("transform", "");
          var Oe = Us(t, tr.node()),
            Ke,
            fr;
          if (n === "x") {
            var lr = T.side === "top" ? "-" : "";
            tr.attr("text-anchor", "middle").call(kn.positionText, 0, T.side === "top" ? R - Oe.bottom - gt - Or : R - Oe.top + gt + Or), Ke = T._offset + (w.x0 + w.x1) / 2, fr = b._offset + (T.side === "top" ? 0 : b._length);
            var ze = Oe.width / 2 + Or,
              ae = Ke;
            Ke < ze ? ae = ze : Ke > a.width - ze && (ae = a.width - ze), cr.attr("d", "M" + (Ke - ae) + ",0L" + (Ke - ae + gt) + "," + lr + gt + "H" + ze + "v" + lr + (Or * 2 + Oe.height) + "H" + -ze + "V" + lr + gt + "H" + (Ke - ae - gt) + "Z"), Ke = ae, V.minX = Ke - ze, V.maxX = Ke + ze, T.side === "top" ? (V.minY = fr - (Or * 2 + Oe.height), V.maxY = fr - Or) : (V.minY = fr + Or, V.maxY = fr + (Or * 2 + Oe.height));
          } else {
            var oe, qe, ke;
            b.side === "right" ? (oe = "start", qe = 1, ke = "", Ke = T._offset + T._length) : (oe = "end", qe = -1, ke = "-", Ke = T._offset), fr = b._offset + (w.y0 + w.y1) / 2, tr.attr("text-anchor", oe), cr.attr("d", "M0,0L" + ke + gt + "," + gt + "V" + (Or + Oe.height / 2) + "h" + ke + (Or * 2 + Oe.width) + "V-" + (Or + Oe.height / 2) + "H" + ke + gt + "V-" + gt + "Z"), V.minY = fr - (Or + Oe.height / 2), V.maxY = fr + (Or + Oe.height / 2), b.side === "right" ? (V.minX = Ke + gt, V.maxX = Ke + gt + (Or * 2 + Oe.width)) : (V.minX = Ke - gt - (Or * 2 + Oe.width), V.maxX = Ke - gt);
            var ir = Oe.height / 2,
              vr = R - Oe.top - ir,
              sr = "clip" + a._uid + "commonlabel" + b._id,
              Mr;
            if (Ke < Oe.width + 2 * Or + gt) {
              Mr = "M-" + (gt + Or) + "-" + ir + "h-" + (Oe.width - Or) + "V" + ir + "h" + (Oe.width - Or) + "Z";
              var Ur = Oe.width - Ke + Or;
              kn.positionText(tr, Ur, vr), oe === "end" && tr.selectAll("tspan").each(function () {
                var Vr = Ao.select(this),
                  St = Mi.tester.append("text").text(Vr.text()).call(Mi.font, Ue),
                  ea = Us(t, St.node());
                Math.round(ea.width) < Math.round(Oe.width) && Vr.attr("x", Ur - ea.width), St.remove();
              });
            } else kn.positionText(tr, qe * (Or + gt), vr), Mr = null;
            var $r = a._topclips.selectAll("#" + sr).data(Mr ? [0] : []);
            $r.enter().append("clipPath").attr("id", sr).append("path"), $r.exit().remove(), $r.select("path").attr("d", Mr), Mi.setClipUrl(tr, Mr ? sr : null, t);
          }
          Ce.attr("transform", my(Ke, fr));
        }), $n.isUnifiedHover(n)) {
          o.selectAll("g.hovertext").remove();
          var K = e.filter(function (Ce) {
            return Ce.hoverinfo !== "none";
          });
          if (K.length === 0) return [];
          var Q = a.hoverlabel,
            ie = Q.font,
            me = {
              showlegend: !0,
              legend: {
                title: {
                  text: k,
                  font: ie
                },
                font: ie,
                bgcolor: Q.bgcolor,
                bordercolor: Q.bordercolor,
                borderwidth: 1,
                tracegroupgap: 7,
                traceorder: a.legend ? a.legend.traceorder : void 0,
                orientation: "v"
              }
            },
            pe = {
              font: ie
            };
          UV(me, pe, t._fullData);
          var ge = pe.legend;
          ge.entries = [];
          for (var j = 0; j < K.length; j++) {
            var _e = K[j];
            if (_e.hoverinfo !== "none") {
              var se = qw(_e, !0, n, a, k),
                Se = se[0],
                ve = se[1];
              _e.name = ve, ve !== "" ? _e.text = ve + " : " + Se : _e.text = Se;
              var Ae = _e.cd[_e.index];
              Ae && (Ae.mc && (_e.mc = Ae.mc), Ae.mcc && (_e.mc = Ae.mcc), Ae.mlc && (_e.mlc = Ae.mlc), Ae.mlcc && (_e.mlc = Ae.mlcc), Ae.mlw && (_e.mlw = Ae.mlw), Ae.mrc && (_e.mrc = Ae.mrc), Ae.dir && (_e.dir = Ae.dir)), _e._distinct = !0, ge.entries.push([_e]);
            }
          }
          ge.entries.sort(function (Ce, cr) {
            return Ce[0].trace.index - cr[0].trace.index;
          }), ge.layer = o, ge._inHover = !0, ge._groupTitleFont = Q.grouptitlefont, GV(t, ge);
          var Y = o.select("g.legend"),
            re = Us(t, Y.node()),
            U = re.width + 2 * Or,
            de = re.height + 2 * Or,
            be = K[0],
            ye = (be.x0 + be.x1) / 2,
            Fe = (be.y0 + be.y1) / 2,
            Re = !(Gs.traceIs(be.trace, "bar-like") || Gs.traceIs(be.trace, "box-violin")),
            Pe,
            Ie;
          A === "y" ? Re ? (Ie = Fe - Or, Pe = Fe + Or) : (Ie = Math.min.apply(null, K.map(function (Ce) {
            return Math.min(Ce.y0, Ce.y1);
          })), Pe = Math.max.apply(null, K.map(function (Ce) {
            return Math.max(Ce.y0, Ce.y1);
          }))) : Ie = Pe = Mt.mean(K.map(function (Ce) {
            return (Ce.y0 + Ce.y1) / 2;
          })) - de / 2;
          var Be, Ne;
          A === "x" ? Re ? (Be = ye + Or, Ne = ye - Or) : (Be = Math.max.apply(null, K.map(function (Ce) {
            return Math.max(Ce.x0, Ce.x1);
          })), Ne = Math.min.apply(null, K.map(function (Ce) {
            return Math.min(Ce.x0, Ce.x1);
          }))) : Be = Ne = Mt.mean(K.map(function (Ce) {
            return (Ce.x0 + Ce.x1) / 2;
          })) - U / 2;
          var Ee = T._offset,
            Je = b._offset;
          Pe += Je, Be += Ee, Ne += Ee - U, Ie += Je - de;
          var We, ne;
          return Be + U < z && Be >= 0 ? We = Be : Ne + U < z && Ne >= 0 ? We = Ne : Ee + U < z ? We = Ee : Be - ye < ye - Ne + U ? We = z - U : We = 0, We += Or, Pe + de < N && Pe >= 0 ? ne = Pe : Ie + de < N && Ie >= 0 ? ne = Ie : Je + de < N ? ne = Je : Pe - Fe < Fe - Ie + de ? ne = N - de : ne = 0, ne += Or, Y.attr("transform", my(We - 1, ne - 1)), Y;
        }
        var Me = o.selectAll("g.hovertext").data(e, function (Ce) {
          return Nw(Ce);
        });
        return Me.enter().append("g").classed("hovertext", !0).each(function () {
          var Ce = Ao.select(this);
          Ce.append("rect").call(Kt.fill, Kt.addOpacity(l, .8)), Ce.append("text").classed("name", !0), Ce.append("path").style("stroke-width", "1px"), Ce.append("text").classed("nums", !0).call(Mi.font, {
            weight: h,
            style: d,
            variant: y,
            textcase: g,
            lineposition: m,
            shadow: _,
            family: f,
            size: v
          });
        }), Me.exit().remove(), Me.each(function (Ce) {
          var cr = Ao.select(this).attr("transform", ""),
            tr = Ce.color;
          Array.isArray(tr) && (tr = tr[Ce.eventData[0].pointNumber]);
          var De = Ce.bgcolor || tr,
            Le = Kt.combine(Kt.opacity(De) ? De : Kt.defaultLine, l),
            Ye = Kt.combine(Kt.opacity(tr) ? tr : Kt.defaultLine, l),
            Ze = Ce.borderColor || Kt.contrast(Le),
            Ue = qw(Ce, H, n, a, k, cr),
            Oe = Ue[0],
            Ke = Ue[1],
            fr = cr.select("text.nums").call(Mi.font, {
              family: Ce.fontFamily || f,
              size: Ce.fontSize || v,
              color: Ce.fontColor || Ze,
              weight: Ce.fontWeight || h,
              style: Ce.fontStyle || d,
              variant: Ce.fontVariant || y,
              textcase: Ce.fontTextcase || g,
              lineposition: Ce.fontLineposition || m,
              shadow: Ce.fontShadow || _
            }).text(Oe).attr("data-notex", 1).call(kn.positionText, 0, 0).call(kn.convertToTspans, t),
            lr = cr.select("text.name"),
            ze = 0,
            ae = 0;
          if (Ke && Ke !== Oe) {
            lr.call(Mi.font, {
              family: Ce.fontFamily || f,
              size: Ce.fontSize || v,
              color: Ye,
              weight: Ce.fontWeight || h,
              style: Ce.fontStyle || d,
              variant: Ce.fontVariant || y,
              textcase: Ce.fontTextcase || g,
              lineposition: Ce.fontLineposition || m,
              shadow: Ce.fontShadow || _
            }).text(Ke).attr("data-notex", 1).call(kn.positionText, 0, 0).call(kn.convertToTspans, t);
            var oe = Us(t, lr.node());
            ze = oe.width + 2 * Or, ae = oe.height + 2 * Or;
          } else lr.remove(), cr.select("rect").remove();
          cr.select("path").style({
            fill: Le,
            stroke: Ze
          });
          var qe = Ce.xa._offset + (Ce.x0 + Ce.x1) / 2,
            ke = Ce.ya._offset + (Ce.y0 + Ce.y1) / 2,
            ir = Math.abs(Ce.x1 - Ce.x0),
            vr = Math.abs(Ce.y1 - Ce.y0),
            sr = Us(t, fr.node()),
            Mr = sr.width / a._invScaleX,
            Ur = sr.height / a._invScaleY;
          Ce.ty0 = (R - sr.top) / a._invScaleY, Ce.bx = Mr + 2 * Or, Ce.by = Math.max(Ur + 2 * Or, ae), Ce.anchor = "start", Ce.txwidth = Mr, Ce.tx2width = ze, Ce.offset = 0;
          var $r = (Mr + gt + Or + ze) * a._invScaleX,
            Vr,
            St;
          if (i) Ce.pos = qe, Vr = ke + vr / 2 + $r <= N, St = ke - vr / 2 - $r >= 0, (Ce.idealAlign === "top" || !Vr) && St ? (ke -= vr / 2, Ce.anchor = "end") : Vr ? (ke += vr / 2, Ce.anchor = "start") : Ce.anchor = "middle", Ce.crossPos = ke;else {
            if (Ce.pos = ke, Vr = qe + ir / 2 + $r <= z, St = qe - ir / 2 - $r >= 0, (Ce.idealAlign === "left" || !Vr) && St) qe -= ir / 2, Ce.anchor = "end";else if (Vr) qe += ir / 2, Ce.anchor = "start";else {
              Ce.anchor = "middle";
              var ea = $r / 2,
                ka = qe + ea - z,
                ra = qe - ea;
              ka > 0 && (qe -= ka), ra < 0 && (qe += -ra);
            }
            Ce.crossPos = qe;
          }
          fr.attr("text-anchor", Ce.anchor), ze && lr.attr("text-anchor", Ce.anchor), cr.attr("transform", my(qe, ke) + (i ? HV(zw) : ""));
        }), {
          hoverLabels: Me,
          commonLabelBoundingBox: V
        };
      }
      function qw(e, r, t, a, n, i) {
        var l = "",
          o = "";
        e.nameOverride !== void 0 && (e.name = e.nameOverride), e.name && (e.trace._meta && (e.name = Mt.templateString(e.name, e.trace._meta)), l = Pw(e.name, e.nameLength));
        var s = t.charAt(0),
          u = s === "x" ? "y" : "x";
        e.zLabel !== void 0 ? (e.xLabel !== void 0 && (o += "x: " + e.xLabel + "<br>"), e.yLabel !== void 0 && (o += "y: " + e.yLabel + "<br>"), e.trace.type !== "choropleth" && e.trace.type !== "choroplethmapbox" && e.trace.type !== "choroplethmap" && (o += (o ? "z: " : "") + e.zLabel)) : r && e[s + "Label"] === n ? o = e[u + "Label"] || "" : e.xLabel === void 0 ? e.yLabel !== void 0 && e.trace.type !== "scattercarpet" && (o = e.yLabel) : e.yLabel === void 0 ? o = e.xLabel : o = "(" + e.xLabel + ", " + e.yLabel + ")", (e.text || e.text === 0) && !Array.isArray(e.text) && (o += (o ? "<br>" : "") + e.text), e.extraText !== void 0 && (o += (o ? "<br>" : "") + e.extraText), i && o === "" && !e.hovertemplate && (l === "" && i.remove(), o = l);
        var f = e.hovertemplate || !1;
        if (f) {
          var v = e.hovertemplateLabels || e;
          e[s + "Label"] !== n && (v[s + "other"] = v[s + "Val"], v[s + "otherLabel"] = v[s + "Label"]), o = Mt.hovertemplateString(f, v, a._d3locale, e.eventData[0] || {}, e.trace._meta), o = o.replace(KV, function (h, d) {
            return l = Pw(d, e.nameLength), "";
          });
        }
        return [o, l];
      }
      function QV(e, r, t, a) {
        var n = r ? "xa" : "ya",
          i = r ? "ya" : "xa",
          l = 0,
          o = 1,
          s = e.size(),
          u = new Array(s),
          f = 0,
          v = a.minX,
          h = a.maxX,
          d = a.minY,
          y = a.maxY,
          g = function (X) {
            return X * t._invScaleX;
          },
          m = function (X) {
            return X * t._invScaleY;
          };
        e.each(function (X) {
          var B = X[n],
            I = X[i],
            V = B._id.charAt(0) === "x",
            K = B.range;
          f === 0 && K && K[0] > K[1] !== V && (o = -1);
          var Q = 0,
            ie = V ? t.width : t.height;
          if (t.hovermode === "x" || t.hovermode === "y") {
            var me = Iw(X, r),
              pe = X.anchor,
              ge = pe === "end" ? -1 : 1,
              j,
              _e;
            if (pe === "middle") j = X.crossPos + (V ? m(me.y - X.by / 2) : g(X.bx / 2 + X.tx2width / 2)), _e = j + (V ? m(X.by) : g(X.bx));else if (V) j = X.crossPos + m(gt + me.y) - m(X.by / 2 - gt), _e = j + m(X.by);else {
              var se = g(ge * gt + me.x),
                Se = se + g(ge * X.bx);
              j = X.crossPos + Math.min(se, Se), _e = X.crossPos + Math.max(se, Se);
            }
            V ? d !== void 0 && y !== void 0 && Math.min(_e, y) - Math.max(j, d) > 1 && (I.side === "left" ? (Q = I._mainLinePosition, ie = t.width) : ie = I._mainLinePosition) : v !== void 0 && h !== void 0 && Math.min(_e, h) - Math.max(j, v) > 1 && (I.side === "top" ? (Q = I._mainLinePosition, ie = t.height) : ie = I._mainLinePosition);
          }
          u[f++] = [{
            datum: X,
            traceIndex: X.trace.index,
            dp: 0,
            pos: X.pos,
            posref: X.posref,
            size: X.by * (V ? VV : 1) / 2,
            pmin: Q,
            pmax: ie
          }];
        }), u.sort(function (X, B) {
          return X[0].posref - B[0].posref || o * (B[0].traceIndex - X[0].traceIndex);
        });
        var _, w, T, b, A, S, k;
        function q(X) {
          var B = X[0],
            I = X[X.length - 1];
          if (w = B.pmin - B.pos - B.dp + B.size, T = I.pos + I.dp + I.size - B.pmax, w > .01) {
            for (A = X.length - 1; A >= 0; A--) X[A].dp += w;
            _ = !1;
          }
          if (!(T < .01)) {
            if (w < -.01) {
              for (A = X.length - 1; A >= 0; A--) X[A].dp -= T;
              _ = !1;
            }
            if (_) {
              var V = 0;
              for (b = 0; b < X.length; b++) S = X[b], S.pos + S.dp + S.size > B.pmax && V++;
              for (b = X.length - 1; b >= 0 && !(V <= 0); b--) S = X[b], S.pos > B.pmax - 1 && (S.del = !0, V--);
              for (b = 0; b < X.length && !(V <= 0); b++) if (S = X[b], S.pos < B.pmin + 1) for (S.del = !0, V--, T = S.size * 2, A = X.length - 1; A >= 0; A--) X[A].dp -= T;
              for (b = X.length - 1; b >= 0 && !(V <= 0); b--) S = X[b], S.pos + S.dp + S.size > B.pmax && (S.del = !0, V--);
            }
          }
        }
        for (; !_ && l <= s;) {
          for (l++, _ = !0, b = 0; b < u.length - 1;) {
            var D = u[b],
              R = u[b + 1],
              z = D[D.length - 1],
              N = R[0];
            if (w = z.pos + z.dp + z.size - N.pos - N.dp + N.size, w > .01) {
              for (A = R.length - 1; A >= 0; A--) R[A].dp += w;
              for (D.push.apply(D, R), u.splice(b + 1, 1), k = 0, A = D.length - 1; A >= 0; A--) k += D[A].dp;
              for (T = k / D.length, A = D.length - 1; A >= 0; A--) D[A].dp -= T;
              _ = !1;
            } else b++;
          }
          u.forEach(q);
        }
        for (b = u.length - 1; b >= 0; b--) {
          var H = u[b];
          for (A = H.length - 1; A >= 0; A--) {
            var O = H[A],
              J = O.datum;
            J.offset = O.dp, J.del = O.del;
          }
        }
      }
      function Iw(e, r) {
        var t = 0,
          a = e.offset;
        return r && (a *= -ZV, t = e.offset * WV), {
          x: t,
          y: a
        };
      }
      function $V(e) {
        var r = {
            start: 1,
            end: -1,
            middle: 0
          }[e.anchor],
          t = r * (gt + Or),
          a = t + r * (e.txwidth + Or),
          n = e.anchor === "middle";
        return n && (t -= e.tx2width / 2, a += e.txwidth / 2 + Or), {
          alignShift: r,
          textShiftX: t,
          text2ShiftX: a
        };
      }
      function Hw(e, r, t, a) {
        var n = function (l) {
            return l * t;
          },
          i = function (l) {
            return l * a;
          };
        e.each(function (l) {
          var o = Ao.select(this);
          if (l.del) return o.remove();
          var s = o.select("text.nums"),
            u = l.anchor,
            f = u === "end" ? -1 : 1,
            v = $V(l),
            h = Iw(l, r),
            d = h.x,
            y = h.y,
            g = u === "middle";
          o.select("path").attr("d", g ? "M-" + n(l.bx / 2 + l.tx2width / 2) + "," + i(y - l.by / 2) + "h" + n(l.bx) + "v" + i(l.by) + "h-" + n(l.bx) + "Z" : "M0,0L" + n(f * gt + d) + "," + i(gt + y) + "v" + i(l.by / 2 - gt) + "h" + n(f * l.bx) + "v-" + i(l.by) + "H" + n(f * gt + d) + "V" + i(y - gt) + "Z");
          var m = d + v.textShiftX,
            _ = y + l.ty0 - l.by / 2 + Or,
            w = l.textAlign || "auto";
          w !== "auto" && (w === "left" && u !== "start" ? (s.attr("text-anchor", "start"), m = g ? -l.bx / 2 - l.tx2width / 2 + Or : -l.bx - Or) : w === "right" && u !== "end" && (s.attr("text-anchor", "end"), m = g ? l.bx / 2 - l.tx2width / 2 - Or : l.bx + Or)), s.call(kn.positionText, n(m), i(_)), l.tx2width && (o.select("text.name").call(kn.positionText, n(v.text2ShiftX + v.alignShift * Or + d), i(y + l.ty0 - l.by / 2 + Or)), o.select("rect").call(Mi.setRect, n(v.text2ShiftX + (v.alignShift - 1) * l.tx2width / 2 + d), i(y - l.by / 2 - 1), n(l.tx2width), i(l.by + 2)));
        });
      }
      function jV(e, r) {
        var t = e.index,
          a = e.trace || {},
          n = e.cd[0],
          i = e.cd[t] || {};
        function l(h) {
          return h || Gi(h) && h === 0;
        }
        var o = Array.isArray(t) ? function (h, d) {
          var y = Mt.castOption(n, t, h);
          return l(y) ? y : Mt.extractOption({}, a, "", d);
        } : function (h, d) {
          return Mt.extractOption(i, a, h, d);
        };
        function s(h, d, y) {
          var g = o(d, y);
          l(g) && (e[h] = g);
        }
        if (s("hoverinfo", "hi", "hoverinfo"), s("bgcolor", "hbg", "hoverlabel.bgcolor"), s("borderColor", "hbc", "hoverlabel.bordercolor"), s("fontFamily", "htf", "hoverlabel.font.family"), s("fontSize", "hts", "hoverlabel.font.size"), s("fontColor", "htc", "hoverlabel.font.color"), s("fontWeight", "htw", "hoverlabel.font.weight"), s("fontStyle", "hty", "hoverlabel.font.style"), s("fontVariant", "htv", "hoverlabel.font.variant"), s("nameLength", "hnl", "hoverlabel.namelength"), s("textAlign", "hta", "hoverlabel.align"), e.posref = r === "y" || r === "closest" && a.orientation === "h" ? e.xa._offset + (e.x0 + e.x1) / 2 : e.ya._offset + (e.y0 + e.y1) / 2, e.x0 = Mt.constrain(e.x0, 0, e.xa._length), e.x1 = Mt.constrain(e.x1, 0, e.xa._length), e.y0 = Mt.constrain(e.y0, 0, e.ya._length), e.y1 = Mt.constrain(e.y1, 0, e.ya._length), e.xLabelVal !== void 0 && (e.xLabel = "xLabel" in e ? e.xLabel : Ai.hoverLabelText(e.xa, e.xLabelVal, a.xhoverformat), e.xVal = e.xa.c2d(e.xLabelVal)), e.yLabelVal !== void 0 && (e.yLabel = "yLabel" in e ? e.yLabel : Ai.hoverLabelText(e.ya, e.yLabelVal, a.yhoverformat), e.yVal = e.ya.c2d(e.yLabelVal)), e.zLabelVal !== void 0 && e.zLabel === void 0 && (e.zLabel = String(e.zLabelVal)), !isNaN(e.xerr) && !(e.xa.type === "log" && e.xerr <= 0)) {
          var u = Ai.tickText(e.xa, e.xa.c2l(e.xerr), "hover").text;
          e.xerrneg !== void 0 ? e.xLabel += " +" + u + " / -" + Ai.tickText(e.xa, e.xa.c2l(e.xerrneg), "hover").text : e.xLabel += " \xB1 " + u, r === "x" && (e.distance += 1);
        }
        if (!isNaN(e.yerr) && !(e.ya.type === "log" && e.yerr <= 0)) {
          var f = Ai.tickText(e.ya, e.ya.c2l(e.yerr), "hover").text;
          e.yerrneg !== void 0 ? e.yLabel += " +" + f + " / -" + Ai.tickText(e.ya, e.ya.c2l(e.yerrneg), "hover").text : e.yLabel += " \xB1 " + f, r === "y" && (e.distance += 1);
        }
        var v = e.hoverinfo || e.trace.hoverinfo;
        return v && v !== "all" && (v = Array.isArray(v) ? v : v.split("+"), v.indexOf("x") === -1 && (e.xLabel = void 0), v.indexOf("y") === -1 && (e.yLabel = void 0), v.indexOf("z") === -1 && (e.zLabel = void 0), v.indexOf("text") === -1 && (e.text = void 0), v.indexOf("name") === -1 && (e.name = void 0)), e;
      }
      function Dw(e, r, t) {
        var a = t.container,
          n = t.fullLayout,
          i = n._size,
          l = t.event,
          o = !!r.hLinePoint,
          s = !!r.vLinePoint,
          u,
          f;
        if (a.selectAll(".spikeline").remove(), !!(s || o)) {
          var v = Kt.combine(n.plot_bgcolor, n.paper_bgcolor);
          if (o) {
            var h = r.hLinePoint,
              d,
              y;
            u = h && h.xa, f = h && h.ya;
            var g = f.spikesnap;
            g === "cursor" ? (d = l.pointerX, y = l.pointerY) : (d = u._offset + h.x, y = f._offset + h.y);
            var m = Cw.readability(h.color, v) < 1.5 ? Kt.contrast(v) : h.color,
              _ = f.spikemode,
              w = f.spikethickness,
              T = f.spikecolor || m,
              b = Ai.getPxPosition(e, f),
              A,
              S;
            if (_.indexOf("toaxis") !== -1 || _.indexOf("across") !== -1) {
              if (_.indexOf("toaxis") !== -1 && (A = b, S = d), _.indexOf("across") !== -1) {
                var k = f._counterDomainMin,
                  q = f._counterDomainMax;
                f.anchor === "free" && (k = Math.min(k, f.position), q = Math.max(q, f.position)), A = i.l + k * i.w, S = i.l + q * i.w;
              }
              a.insert("line", ":first-child").attr({
                x1: A,
                x2: S,
                y1: y,
                y2: y,
                "stroke-width": w,
                stroke: T,
                "stroke-dasharray": Mi.dashStyle(f.spikedash, w)
              }).classed("spikeline", !0).classed("crisp", !0), a.insert("line", ":first-child").attr({
                x1: A,
                x2: S,
                y1: y,
                y2: y,
                "stroke-width": w + 2,
                stroke: v
              }).classed("spikeline", !0).classed("crisp", !0);
            }
            _.indexOf("marker") !== -1 && a.insert("circle", ":first-child").attr({
              cx: b + (f.side !== "right" ? w : -w),
              cy: y,
              r: w,
              fill: T
            }).classed("spikeline", !0);
          }
          if (s) {
            var D = r.vLinePoint,
              R,
              z;
            u = D && D.xa, f = D && D.ya;
            var N = u.spikesnap;
            N === "cursor" ? (R = l.pointerX, z = l.pointerY) : (R = u._offset + D.x, z = f._offset + D.y);
            var H = Cw.readability(D.color, v) < 1.5 ? Kt.contrast(v) : D.color,
              O = u.spikemode,
              J = u.spikethickness,
              X = u.spikecolor || H,
              B = Ai.getPxPosition(e, u),
              I,
              V;
            if (O.indexOf("toaxis") !== -1 || O.indexOf("across") !== -1) {
              if (O.indexOf("toaxis") !== -1 && (I = B, V = z), O.indexOf("across") !== -1) {
                var K = u._counterDomainMin,
                  Q = u._counterDomainMax;
                u.anchor === "free" && (K = Math.min(K, u.position), Q = Math.max(Q, u.position)), I = i.t + (1 - Q) * i.h, V = i.t + (1 - K) * i.h;
              }
              a.insert("line", ":first-child").attr({
                x1: R,
                x2: R,
                y1: I,
                y2: V,
                "stroke-width": J,
                stroke: X,
                "stroke-dasharray": Mi.dashStyle(u.spikedash, J)
              }).classed("spikeline", !0).classed("crisp", !0), a.insert("line", ":first-child").attr({
                x1: R,
                x2: R,
                y1: I,
                y2: V,
                "stroke-width": J + 2,
                stroke: v
              }).classed("spikeline", !0).classed("crisp", !0);
            }
            O.indexOf("marker") !== -1 && a.insert("circle", ":first-child").attr({
              cx: R,
              cy: B - (u.side !== "top" ? J : -J),
              r: J,
              fill: X
            }).classed("spikeline", !0);
          }
        }
      }
      function eW(e, r, t) {
        if (!t || t.length !== e._hoverdata.length) return !0;
        for (var a = t.length - 1; a >= 0; a--) {
          var n = t[a],
            i = e._hoverdata[a];
          if (n.curveNumber !== i.curveNumber || String(n.pointNumber) !== String(i.pointNumber) || String(n.pointNumbers) !== String(i.pointNumbers)) return !0;
        }
        return !1;
      }
      function Ew(e, r) {
        return !r || r.vLinePoint !== e._spikepoints.vLinePoint || r.hLinePoint !== e._spikepoints.hLinePoint;
      }
      function Pw(e, r) {
        return kn.plainText(e || "", {
          len: r,
          allowedTags: ["br", "sub", "sup", "b", "i", "em", "s", "u"]
        });
      }
      function rW(e, r) {
        for (var t = r.charAt(0), a = [], n = [], i = [], l = 0; l < e.length; l++) {
          var o = e[l];
          Gs.traceIs(o.trace, "bar-like") || Gs.traceIs(o.trace, "box-violin") ? i.push(o) : o.trace[t + "period"] ? n.push(o) : a.push(o);
        }
        return a.concat(n).concat(i);
      }
      function Rw(e, r, t) {
        var a = r[e + "a"],
          n = r[e + "Val"],
          i = r.cd[0];
        if (a.type === "category" || a.type === "multicategory") n = a._categoriesMap[n];else if (a.type === "date") {
          var l = r.trace[e + "periodalignment"];
          if (l) {
            var o = r.cd[r.index],
              s = o[e + "Start"];
            s === void 0 && (s = o[e]);
            var u = o[e + "End"];
            u === void 0 && (u = o[e]);
            var f = u - s;
            l === "end" ? n += f : l === "middle" && (n += f / 2);
          }
          n = a.d2c(n);
        }
        return i && i.t && i.t.posLetter === a._id && (t.boxmode === "group" || t.violinmode === "group") && (n += i.t.dPos), n;
      }
      function Ow(e) {
        return e.offsetTop + e.clientTop;
      }
      function Bw(e) {
        return e.offsetLeft + e.clientLeft;
      }
      function Us(e, r) {
        var t = e._fullLayout,
          a = r.getBoundingClientRect(),
          n = a.left,
          i = a.top,
          l = n + a.width,
          o = i + a.height,
          s = Mt.apply3DTransform(t._invTransform)(n, i),
          u = Mt.apply3DTransform(t._invTransform)(l, o),
          f = s[0],
          v = s[1],
          h = u[0],
          d = u[1];
        return {
          x: f,
          y: v,
          width: h - f,
          height: d - v,
          top: Math.min(v, d),
          left: Math.min(f, h),
          right: Math.max(f, h),
          bottom: Math.max(v, d)
        };
      }
    });
    var J0 = Z((yse, Yw) => {
      "use strict";

      var tW = He(),
        aW = Er(),
        nW = bi().isUnifiedHover;
      Yw.exports = function (r, t, a, n) {
        n = n || {};
        var i = t.legend;
        function l(o) {
          n.font[o] || (n.font[o] = i ? t.legend.font[o] : t.font[o]);
        }
        t && nW(t.hovermode) && (n.font || (n.font = {}), l("size"), l("family"), l("color"), l("weight"), l("style"), l("variant"), i ? (n.bgcolor || (n.bgcolor = aW.combine(t.legend.bgcolor, t.paper_bgcolor)), n.bordercolor || (n.bordercolor = t.legend.bordercolor)) : n.bgcolor || (n.bgcolor = t.paper_bgcolor)), a("hoverlabel.bgcolor", n.bgcolor), a("hoverlabel.bordercolor", n.bordercolor), a("hoverlabel.namelength", n.namelength), tW.coerceFont(a, "hoverlabel.font", n.font), a("hoverlabel.align", n.align);
      };
    });
    var Gw = Z((gse, Uw) => {
      "use strict";

      var iW = He(),
        lW = J0(),
        oW = fs();
      Uw.exports = function (r, t) {
        function a(n, i) {
          return iW.coerce(r, t, oW, n, i);
        }
        lW(r, t, a);
      };
    });
    var Zw = Z((bse, Ww) => {
      "use strict";

      var Vw = He(),
        sW = mv(),
        uW = J0();
      Ww.exports = function (r, t, a, n) {
        function i(o, s) {
          return Vw.coerce(r, t, sW, o, s);
        }
        var l = Vw.extendFlat({}, n.hoverlabel);
        t.hovertemplate && (l.namelength = -1), uW(r, t, i, l);
      };
    });
    var xy = Z((xse, Xw) => {
      "use strict";

      var fW = He(),
        cW = fs();
      Xw.exports = function (r, t) {
        function a(n, i) {
          return t[n] !== void 0 ? t[n] : fW.coerce(r, t, cW, n, i);
        }
        return a("clickmode"), a("hoversubplots"), a("hovermode");
      };
    });
    var Qw = Z((_se, Kw) => {
      "use strict";

      var Jw = He(),
        vW = fs(),
        hW = xy(),
        dW = J0();
      Kw.exports = function (r, t) {
        function a(f, v) {
          return Jw.coerce(r, t, vW, f, v);
        }
        var n = hW(r, t);
        n && (a("hoverdistance"), a("spikedistance"));
        var i = a("dragmode");
        i === "select" && a("selectdirection");
        var l = t._has("mapbox"),
          o = t._has("map"),
          s = t._has("geo"),
          u = t._basePlotModules.length;
        t.dragmode === "zoom" && ((l || o || s) && u === 1 || (l || o) && s && u === 2) && (t.dragmode = "pan"), dW(r, t, a), Jw.coerceFont(a, "hoverlabel.grouptitlefont", t.hoverlabel.font);
      };
    });
    var eT = Z((wse, jw) => {
      "use strict";

      var _y = He(),
        $w = gr();
      jw.exports = function (r) {
        var t = r.calcdata,
          a = r._fullLayout;
        function n(u) {
          return function (f) {
            return _y.coerceHoverinfo({
              hoverinfo: f
            }, {
              _module: u._module
            }, a);
          };
        }
        for (var i = 0; i < t.length; i++) {
          var l = t[i],
            o = l[0].trace;
          if (!$w.traceIs(o, "pie-like")) {
            var s = $w.traceIs(o, "2dMap") ? pW : _y.fillArray;
            s(o.hoverinfo, l, "hi", n(o)), o.hovertemplate && s(o.hovertemplate, l, "ht"), o.hoverlabel && (s(o.hoverlabel.bgcolor, l, "hbg"), s(o.hoverlabel.bordercolor, l, "hbc"), s(o.hoverlabel.font.size, l, "hts"), s(o.hoverlabel.font.color, l, "htc"), s(o.hoverlabel.font.family, l, "htf"), s(o.hoverlabel.font.weight, l, "htw"), s(o.hoverlabel.font.style, l, "hty"), s(o.hoverlabel.font.variant, l, "htv"), s(o.hoverlabel.namelength, l, "hnl"), s(o.hoverlabel.align, l, "hta"));
          }
        }
      };
      function pW(e, r, t, a) {
        a = a || _y.identity, Array.isArray(e) && (r[0][t] = a(e));
      }
    });
    var tT = Z((Tse, rT) => {
      "use strict";

      var mW = gr(),
        yW = by().hover;
      rT.exports = function (r, t, a) {
        var n = mW.getComponentMethod("annotations", "onClick")(r, r._hoverdata);
        a !== void 0 && yW(r, t, a, !0);
        function i() {
          r.emit("plotly_click", {
            points: r._hoverdata,
            event: t
          });
        }
        r._hoverdata && t && t.target && (n && n.then ? n.then(i) : i(), t.stopImmediatePropagation && t.stopImmediatePropagation());
      };
    });
    var ki = Z((Mse, iT) => {
      "use strict";

      var gW = Ir(),
        K0 = He(),
        bW = Qn(),
        bf = bi(),
        aT = fs(),
        nT = by();
      iT.exports = {
        moduleType: "component",
        name: "fx",
        constants: Yu(),
        schema: {
          layout: aT
        },
        attributes: mv(),
        layoutAttributes: aT,
        supplyLayoutGlobalDefaults: Gw(),
        supplyDefaults: Zw(),
        supplyLayoutDefaults: Qw(),
        calc: eT(),
        getDistanceFunction: bf.getDistanceFunction,
        getClosest: bf.getClosest,
        inbox: bf.inbox,
        quadrature: bf.quadrature,
        appendArrayPointValue: bf.appendArrayPointValue,
        castHoverOption: _W,
        castHoverinfo: wW,
        hover: nT.hover,
        unhover: bW.unhover,
        loneHover: nT.loneHover,
        loneUnhover: xW,
        click: tT()
      };
      function xW(e) {
        var r = K0.isD3Selection(e) ? e : gW.select(e);
        r.selectAll("g.hovertext").remove(), r.selectAll(".spikeline").remove();
      }
      function _W(e, r, t) {
        return K0.castOption(e, r, "hoverlabel." + t);
      }
      function wW(e, r, t) {
        function a(n) {
          return K0.coerceHoverinfo({
            hoverinfo: n
          }, {
            _module: e._module
          }, r);
        }
        return K0.castOption(e, t, "hoverinfo", a);
      }
    });
    var Vs = Z(Vi => {
      "use strict";

      Vi.selectMode = function (e) {
        return e === "lasso" || e === "select";
      };
      Vi.drawMode = function (e) {
        return e === "drawclosedpath" || e === "drawopenpath" || e === "drawline" || e === "drawrect" || e === "drawcircle";
      };
      Vi.openMode = function (e) {
        return e === "drawline" || e === "drawopenpath";
      };
      Vi.rectMode = function (e) {
        return e === "select" || e === "drawline" || e === "drawrect" || e === "drawcircle";
      };
      Vi.freeMode = function (e) {
        return e === "lasso" || e === "drawclosedpath" || e === "drawopenpath";
      };
      Vi.selectingOrDrawing = function (e) {
        return Vi.freeMode(e) || Vi.rectMode(e);
      };
    });
    var Q0 = Z((kse, lT) => {
      "use strict";

      lT.exports = function (r) {
        var t = r._fullLayout;
        t._glcanvas && t._glcanvas.size() && t._glcanvas.each(function (a) {
          a.regl && a.regl.clear({
            color: !0,
            depth: !0
          });
        });
      };
    });
    var $0 = Z((Cse, oT) => {
      "use strict";

      oT.exports = {
        undo: {
          width: 857.1,
          height: 1e3,
          path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        home: {
          width: 928.6,
          height: 1e3,
          path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        "camera-retro": {
          width: 1e3,
          height: 1e3,
          path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        zoombox: {
          width: 1e3,
          height: 1e3,
          path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        pan: {
          width: 1e3,
          height: 1e3,
          path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        zoom_plus: {
          width: 875,
          height: 1e3,
          path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        zoom_minus: {
          width: 875,
          height: 1e3,
          path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        autoscale: {
          width: 1e3,
          height: 1e3,
          path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        tooltip_basic: {
          width: 1500,
          height: 1e3,
          path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        tooltip_compare: {
          width: 1125,
          height: 1e3,
          path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        plotlylogo: {
          width: 1542,
          height: 1e3,
          path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        "z-axis": {
          width: 1e3,
          height: 1e3,
          path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        "3d_rotate": {
          width: 1e3,
          height: 1e3,
          path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        camera: {
          width: 1e3,
          height: 1e3,
          path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        movie: {
          width: 1e3,
          height: 1e3,
          path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        question: {
          width: 857.1,
          height: 1e3,
          path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        disk: {
          width: 857.1,
          height: 1e3,
          path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        drawopenpath: {
          width: 70,
          height: 70,
          path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z",
          transform: "matrix(1 0 0 1 -15 -15)"
        },
        drawclosedpath: {
          width: 90,
          height: 90,
          path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z",
          transform: "matrix(1 0 0 1 -5 -5)"
        },
        lasso: {
          width: 1031,
          height: 1e3,
          path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        selectbox: {
          width: 1e3,
          height: 1e3,
          path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        drawline: {
          width: 70,
          height: 70,
          path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z",
          transform: "matrix(1 0 0 1 -15 -15)"
        },
        drawrect: {
          width: 80,
          height: 80,
          path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
          transform: "matrix(1 0 0 1 -10 -10)"
        },
        drawcircle: {
          width: 80,
          height: 80,
          path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z",
          transform: "matrix(1 0 0 1 -10 -10)"
        },
        eraseshape: {
          width: 80,
          height: 80,
          path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z",
          transform: "matrix(1 0 0 1 -10 -10)"
        },
        spikeline: {
          width: 1e3,
          height: 1e3,
          path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
          transform: "matrix(1.5 0 0 -1.5 0 850)"
        },
        pencil: {
          width: 1792,
          height: 1792,
          path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
          transform: "matrix(1 0 0 1 0 1)"
        },
        newplotlylogo: {
          name: "newplotlylogo",
          svg: ["<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'>", " <title>plotly-logomark</title>", " <g id='symbol'>", "  <rect fill='#000' x='0' y='0' width='132' height='132' rx='18' ry='18'/>", "  <circle fill='#9EF' cx='102' cy='30' r='6'/>", "  <circle fill='#BAC' cx='78' cy='30' r='6'/>", "  <circle fill='#BAC' cx='78' cy='54' r='6'/>", "  <circle fill='#D69' cx='54' cy='30' r='6'/>", "  <circle fill='#F26' cx='30' cy='30' r='6'/>", "  <circle fill='#F26' cx='30' cy='54' r='6'/>", "  <path fill='#FFF' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/>", "  <path fill='#FFF' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/>", "  <path fill='#FFF' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/>", "  <path fill='#FFF' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/>", " </g>", "</svg>"].join("")
        }
      };
    });
    var eh = Z((Sse, sT) => {
      "use strict";

      var j0 = 32;
      sT.exports = {
        CIRCLE_SIDES: j0,
        i000: 0,
        i090: j0 / 4,
        i180: j0 / 2,
        i270: j0 / 4 * 3,
        cos45: Math.cos(Math.PI / 4),
        sin45: Math.sin(Math.PI / 4),
        SQRT2: Math.sqrt(2)
      };
    });
    var rh = Z((Lse, fT) => {
      "use strict";

      var TW = He().strTranslate;
      function uT(e, r) {
        switch (e.type) {
          case "log":
            return e.p2d(r);
          case "date":
            return e.p2r(r, 0, e.calendar);
          default:
            return e.p2r(r);
        }
      }
      function MW(e, r) {
        switch (e.type) {
          case "log":
            return e.d2p(r);
          case "date":
            return e.r2p(r, 0, e.calendar);
          default:
            return e.r2p(r);
        }
      }
      function AW(e) {
        var r = e._id.charAt(0) === "y" ? 1 : 0;
        return function (t) {
          return uT(e, t[r]);
        };
      }
      function kW(e) {
        return TW(e.xaxis._offset, e.yaxis._offset);
      }
      fT.exports = {
        p2r: uT,
        r2p: MW,
        axValue: AW,
        getTransform: kW
      };
    });
    var Tl = Z(Wi => {
      "use strict";

      var CW = fm(),
        hT = eh(),
        Ws = hT.CIRCLE_SIDES,
        wy = hT.SQRT2,
        dT = rh(),
        cT = dT.p2r,
        vT = dT.r2p,
        SW = [0, 3, 4, 5, 6, 1, 2],
        LW = [0, 3, 4, 1, 2];
      Wi.writePaths = function (e) {
        var r = e.length;
        if (!r) return "M0,0Z";
        for (var t = "", a = 0; a < r; a++) for (var n = e[a].length, i = 0; i < n; i++) {
          var l = e[a][i][0];
          if (l === "Z") t += "Z";else for (var o = e[a][i].length, s = 0; s < o; s++) {
            var u = s;
            l === "Q" || l === "S" ? u = LW[s] : l === "C" && (u = SW[s]), t += e[a][i][u], s > 0 && s < o - 1 && (t += ",");
          }
        }
        return t;
      };
      Wi.readPaths = function (e, r, t, a) {
        var n = CW(e),
          i = [],
          l = -1,
          o = function () {
            l++, i[l] = [];
          },
          s,
          u = 0,
          f = 0,
          v,
          h,
          d = function () {
            v = u, h = f;
          };
        d();
        for (var y = 0; y < n.length; y++) {
          var g = [],
            m,
            _,
            w,
            T,
            b = n[y][0],
            A = b;
          switch (b) {
            case "M":
              o(), u = +n[y][1], f = +n[y][2], g.push([A, u, f]), d();
              break;
            case "Q":
            case "S":
              m = +n[y][1], w = +n[y][2], u = +n[y][3], f = +n[y][4], g.push([A, u, f, m, w]);
              break;
            case "C":
              m = +n[y][1], w = +n[y][2], _ = +n[y][3], T = +n[y][4], u = +n[y][5], f = +n[y][6], g.push([A, u, f, m, w, _, T]);
              break;
            case "T":
            case "L":
              u = +n[y][1], f = +n[y][2], g.push([A, u, f]);
              break;
            case "H":
              A = "L", u = +n[y][1], g.push([A, u, f]);
              break;
            case "V":
              A = "L", f = +n[y][1], g.push([A, u, f]);
              break;
            case "A":
              A = "L";
              var S = +n[y][1],
                k = +n[y][2];
              +n[y][4] || (S = -S, k = -k);
              var q = u - S,
                D = f;
              for (s = 1; s <= Ws / 2; s++) {
                var R = 2 * Math.PI * s / Ws;
                g.push([A, q + S * Math.cos(R), D + k * Math.sin(R)]);
              }
              break;
            case "Z":
              (u !== v || f !== h) && (u = v, f = h, g.push([A, u, f]));
              break;
          }
          for (var z = (t || {}).domain, N = r._fullLayout._size, H = t && t.xsizemode === "pixel", O = t && t.ysizemode === "pixel", J = a === !1, X = 0; X < g.length; X++) {
            for (s = 0; s + 2 < 7; s += 2) {
              var B = g[X][s + 1],
                I = g[X][s + 2];
              B === void 0 || I === void 0 || (u = B, f = I, t && (t.xaxis && t.xaxis.p2r ? (J && (B -= t.xaxis._offset), H ? B = vT(t.xaxis, t.xanchor) + B : B = cT(t.xaxis, B)) : (J && (B -= N.l), z ? B = z.x[0] + B / N.w : B = B / N.w), t.yaxis && t.yaxis.p2r ? (J && (I -= t.yaxis._offset), O ? I = vT(t.yaxis, t.yanchor) - I : I = cT(t.yaxis, I)) : (J && (I -= N.t), z ? I = z.y[1] - I / N.h : I = 1 - I / N.h)), g[X][s + 1] = B, g[X][s + 2] = I);
            }
            i[l].push(g[X].slice());
          }
        }
        return i;
      };
      function xf(e, r) {
        return Math.abs(e - r) <= 1e-6;
      }
      function th(e, r) {
        var t = r[1] - e[1],
          a = r[2] - e[2];
        return Math.sqrt(t * t + a * a);
      }
      Wi.pointsOnRectangle = function (e) {
        var r = e.length;
        if (r !== 5) return !1;
        for (var t = 1; t < 3; t++) {
          var a = e[0][t] - e[1][t],
            n = e[3][t] - e[2][t];
          if (!xf(a, n)) return !1;
          var i = e[0][t] - e[3][t],
            l = e[1][t] - e[2][t];
          if (!xf(i, l)) return !1;
        }
        return !xf(e[0][1], e[1][1]) && !xf(e[0][1], e[3][1]) ? !1 : !!(th(e[0], e[1]) * th(e[0], e[3]));
      };
      Wi.pointsOnEllipse = function (e) {
        var r = e.length;
        if (r !== Ws + 1) return !1;
        r = Ws;
        for (var t = 0; t < r; t++) {
          var a = (r * 2 - t) % r,
            n = (r / 2 + a) % r,
            i = (r / 2 + t) % r;
          if (!xf(th(e[t], e[i]), th(e[a], e[n]))) return !1;
        }
        return !0;
      };
      Wi.handleEllipse = function (e, r, t) {
        if (!e) return [r, t];
        var a = Wi.ellipseOver({
            x0: r[0],
            y0: r[1],
            x1: t[0],
            y1: t[1]
          }),
          n = (a.x1 + a.x0) / 2,
          i = (a.y1 + a.y0) / 2,
          l = (a.x1 - a.x0) / 2,
          o = (a.y1 - a.y0) / 2;
        l || (l = o = o / wy), o || (o = l = l / wy);
        for (var s = [], u = 0; u < Ws; u++) {
          var f = u * 2 * Math.PI / Ws;
          s.push([n + l * Math.cos(f), i + o * Math.sin(f)]);
        }
        return s;
      };
      Wi.ellipseOver = function (e) {
        var r = e.x0,
          t = e.y0,
          a = e.x1,
          n = e.y1,
          i = a - r,
          l = n - t;
        r -= i, t -= l;
        var o = (r + a) / 2,
          s = (t + n) / 2,
          u = wy;
        return i *= u, l *= u, {
          x0: o - i,
          y0: s - l,
          x1: o + i,
          y1: s + l
        };
      };
      Wi.fixDatesForPaths = function (e, r, t) {
        var a = r.type === "date",
          n = t.type === "date";
        if (!a && !n) return e;
        for (var i = 0; i < e.length; i++) for (var l = 0; l < e[i].length; l++) for (var o = 0; o + 2 < e[i][l].length; o += 2) a && (e[i][l][o + 1] = e[i][l][o + 1].replace(" ", "_")), n && (e[i][l][o + 2] = e[i][l][o + 2].replace(" ", "_"));
        return e;
      };
    });
    var ih = Z((Dse, wT) => {
      "use strict";

      var bT = Vs(),
        qW = bT.drawMode,
        DW = bT.openMode,
        Zs = eh(),
        pT = Zs.i000,
        mT = Zs.i090,
        yT = Zs.i180,
        gT = Zs.i270,
        EW = Zs.cos45,
        PW = Zs.sin45,
        xT = rh(),
        ah = xT.p2r,
        Ml = xT.r2p,
        RW = pl(),
        zW = RW.clearOutline,
        nh = Tl(),
        NW = nh.readPaths,
        FW = nh.writePaths,
        IW = nh.ellipseOver,
        HW = nh.fixDatesForPaths;
      function OW(e, r) {
        if (e.length) {
          var t = e[0][0];
          if (t) {
            var a = r.gd,
              n = r.isActiveShape,
              i = r.dragmode,
              l = (a.layout || {}).shapes || [];
            if (!qW(i) && n !== void 0) {
              var o = a._fullLayout._activeShapeIndex;
              if (o < l.length) switch (a._fullLayout.shapes[o].type) {
                case "rect":
                  i = "drawrect";
                  break;
                case "circle":
                  i = "drawcircle";
                  break;
                case "line":
                  i = "drawline";
                  break;
                case "path":
                  var s = l[o].path || "";
                  s[s.length - 1] === "Z" ? i = "drawclosedpath" : i = "drawopenpath";
                  break;
              }
            }
            var u = _T(e, r, i);
            zW(a);
            for (var f = r.editHelpers, v = (f || {}).modifyItem, h = [], d = 0; d < l.length; d++) {
              var y = a._fullLayout.shapes[d];
              if (h[d] = y._input, n !== void 0 && d === a._fullLayout._activeShapeIndex) {
                var g = u;
                switch (y.type) {
                  case "line":
                  case "rect":
                  case "circle":
                    v("x0", g.x0 - (y.x0shift || 0)), v("x1", g.x1 - (y.x1shift || 0)), v("y0", g.y0 - (y.y0shift || 0)), v("y1", g.y1 - (y.y1shift || 0));
                    break;
                  case "path":
                    v("path", g.path);
                    break;
                }
              }
            }
            return n === void 0 ? (h.push(u), h) : f ? f.getUpdateObj() : {};
          }
        }
      }
      function _T(e, r, t) {
        var a = e[0][0],
          n = r.gd,
          i = a.getAttribute("d"),
          l = n._fullLayout.newshape,
          o = r.plotinfo,
          s = r.isActiveShape,
          u = o.xaxis,
          f = o.yaxis,
          v = !!o.domain || !o.xaxis,
          h = !!o.domain || !o.yaxis,
          d = DW(t),
          y = NW(i, n, o, s),
          g = {
            editable: !0,
            visible: l.visible,
            name: l.name,
            showlegend: l.showlegend,
            legend: l.legend,
            legendwidth: l.legendwidth,
            legendgroup: l.legendgroup,
            legendgrouptitle: {
              text: l.legendgrouptitle.text,
              font: l.legendgrouptitle.font
            },
            legendrank: l.legendrank,
            label: l.label,
            xref: v ? "paper" : u._id,
            yref: h ? "paper" : f._id,
            layer: l.layer,
            opacity: l.opacity,
            line: {
              color: l.line.color,
              width: l.line.width,
              dash: l.line.dash
            }
          };
        d || (g.fillcolor = l.fillcolor, g.fillrule = l.fillrule);
        var m;
        if (y.length === 1 && (m = y[0]), m && m.length === 5 && t === "drawrect") g.type = "rect", g.x0 = m[0][1], g.y0 = m[0][2], g.x1 = m[2][1], g.y1 = m[2][2];else if (m && t === "drawline") g.type = "line", g.x0 = m[0][1], g.y0 = m[0][2], g.x1 = m[1][1], g.y1 = m[1][2];else if (m && t === "drawcircle") {
          g.type = "circle";
          var _ = m[pT][1],
            w = m[mT][1],
            T = m[yT][1],
            b = m[gT][1],
            A = m[pT][2],
            S = m[mT][2],
            k = m[yT][2],
            q = m[gT][2],
            D = o.xaxis && (o.xaxis.type === "date" || o.xaxis.type === "log"),
            R = o.yaxis && (o.yaxis.type === "date" || o.yaxis.type === "log");
          D && (_ = Ml(o.xaxis, _), w = Ml(o.xaxis, w), T = Ml(o.xaxis, T), b = Ml(o.xaxis, b)), R && (A = Ml(o.yaxis, A), S = Ml(o.yaxis, S), k = Ml(o.yaxis, k), q = Ml(o.yaxis, q));
          var z = (w + b) / 2,
            N = (A + k) / 2,
            H = (b - w + T - _) / 2,
            O = (q - S + k - A) / 2,
            J = IW({
              x0: z,
              y0: N,
              x1: z + H * EW,
              y1: N + O * PW
            });
          D && (J.x0 = ah(o.xaxis, J.x0), J.x1 = ah(o.xaxis, J.x1)), R && (J.y0 = ah(o.yaxis, J.y0), J.y1 = ah(o.yaxis, J.y1)), g.x0 = J.x0, g.y0 = J.y0, g.x1 = J.x1, g.y1 = J.y1;
        } else g.type = "path", u && f && HW(y, u, f), g.path = FW(y), m = null;
        return g;
      }
      wT.exports = {
        newShapes: OW,
        createShapeObj: _T
      };
    });
    var My = Z((Ese, TT) => {
      "use strict";

      var BW = Vs(),
        YW = BW.selectMode,
        UW = pl(),
        GW = UW.clearOutline,
        Ty = Tl(),
        VW = Ty.readPaths,
        WW = Ty.writePaths,
        ZW = Ty.fixDatesForPaths;
      TT.exports = function (r, t) {
        if (r.length) {
          var a = r[0][0];
          if (a) {
            var n = a.getAttribute("d"),
              i = t.gd,
              l = i._fullLayout.newselection,
              o = t.plotinfo,
              s = o.xaxis,
              u = o.yaxis,
              f = t.isActiveSelection,
              v = t.dragmode,
              h = (i.layout || {}).selections || [];
            if (!YW(v) && f !== void 0) {
              var d = i._fullLayout._activeSelectionIndex;
              if (d < h.length) switch (i._fullLayout.selections[d].type) {
                case "rect":
                  v = "select";
                  break;
                case "path":
                  v = "lasso";
                  break;
              }
            }
            var y = VW(n, i, o, f),
              g = {
                xref: s._id,
                yref: u._id,
                opacity: l.opacity,
                line: {
                  color: l.line.color,
                  width: l.line.width,
                  dash: l.line.dash
                }
              },
              m;
            y.length === 1 && (m = y[0]), m && m.length === 5 && v === "select" ? (g.type = "rect", g.x0 = m[0][1], g.y0 = m[0][2], g.x1 = m[2][1], g.y1 = m[2][2]) : (g.type = "path", s && u && ZW(y, s, u), g.path = WW(y), m = null), GW(i);
            for (var _ = t.editHelpers, w = (_ || {}).modifyItem, T = [], b = 0; b < h.length; b++) {
              var A = i._fullLayout.selections[b];
              if (!A) {
                T[b] = A;
                continue;
              }
              if (T[b] = A._input, f !== void 0 && b === i._fullLayout._activeSelectionIndex) {
                var S = g;
                switch (A.type) {
                  case "rect":
                    w("x0", S.x0), w("x1", S.x1), w("y0", S.y0), w("y1", S.y1);
                    break;
                  case "path":
                    w("path", S.path);
                    break;
                }
              }
            }
            return f === void 0 ? (T.push(g), T) : _ ? _.getUpdateObj() : {};
          }
        }
      };
    });
    var _f = Z((Pse, MT) => {
      "use strict";

      MT.exports = {
        segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
        paramRE: /[^\s,]+/g,
        paramIsX: {
          M: {
            0: !0,
            drawn: 0
          },
          L: {
            0: !0,
            drawn: 0
          },
          H: {
            0: !0,
            drawn: 0
          },
          V: {},
          Q: {
            0: !0,
            2: !0,
            drawn: 2
          },
          C: {
            0: !0,
            2: !0,
            4: !0,
            drawn: 4
          },
          T: {
            0: !0,
            drawn: 0
          },
          S: {
            0: !0,
            2: !0,
            drawn: 2
          },
          Z: {}
        },
        paramIsY: {
          M: {
            1: !0,
            drawn: 1
          },
          L: {
            1: !0,
            drawn: 1
          },
          H: {},
          V: {
            0: !0,
            drawn: 0
          },
          Q: {
            1: !0,
            3: !0,
            drawn: 3
          },
          C: {
            1: !0,
            3: !0,
            5: !0,
            drawn: 5
          },
          T: {
            1: !0,
            drawn: 1
          },
          S: {
            1: !0,
            3: !0,
            drawn: 5
          },
          Z: {}
        },
        numParams: {
          M: 2,
          L: 2,
          H: 1,
          V: 1,
          Q: 4,
          C: 6,
          T: 2,
          S: 4,
          Z: 0
        }
      };
    });
    var Al = Z(ia => {
      "use strict";

      var Co = _f(),
        AT = He(),
        lh = dt();
      ia.rangeToShapePosition = function (e) {
        return e.type === "log" ? e.r2d : function (r) {
          return r;
        };
      };
      ia.shapePositionToRange = function (e) {
        return e.type === "log" ? e.d2r : function (r) {
          return r;
        };
      };
      ia.decodeDate = function (e) {
        return function (r) {
          return r.replace && (r = r.replace("_", " ")), e(r);
        };
      };
      ia.encodeDate = function (e) {
        return function (r) {
          return e(r).replace(" ", "_");
        };
      };
      ia.extractPathCoords = function (e, r, t) {
        var a = [],
          n = e.match(Co.segmentRE);
        return n.forEach(function (i) {
          var l = r[i.charAt(0)].drawn;
          if (l !== void 0) {
            var o = i.substr(1).match(Co.paramRE);
            if (!(!o || o.length < l)) {
              var s = o[l],
                u = t ? s : AT.cleanNumber(s);
              a.push(u);
            }
          }
        }), a;
      };
      ia.getDataToPixel = function (e, r, t, a, n) {
        var i = e._fullLayout._size,
          l;
        if (r) {
          if (n === "domain") l = function (s) {
            return r._length * (a ? 1 - s : s) + r._offset;
          };else {
            var o = ia.shapePositionToRange(r);
            l = function (s) {
              var u = wf(r, t);
              return r._offset + r.r2p(o(s, !0)) + u;
            }, r.type === "date" && (l = ia.decodeDate(l));
          }
        } else a ? l = function (s) {
          return i.t + i.h * (1 - s);
        } : l = function (s) {
          return i.l + i.w * s;
        };
        return l;
      };
      ia.getPixelToData = function (e, r, t, a) {
        var n = e._fullLayout._size,
          i;
        if (r) {
          if (a === "domain") i = function (o) {
            var s = (o - r._offset) / r._length;
            return t ? 1 - s : s;
          };else {
            var l = ia.rangeToShapePosition(r);
            i = function (o) {
              return l(r.p2r(o - r._offset));
            };
          }
        } else t ? i = function (o) {
          return 1 - (o - n.t) / n.h;
        } : i = function (o) {
          return (o - n.l) / n.w;
        };
        return i;
      };
      ia.roundPositionForSharpStrokeRendering = function (e, r) {
        var t = Math.round(r % 2) === 1,
          a = Math.round(e);
        return t ? a + .5 : a;
      };
      ia.makeShapesOptionsAndPlotinfo = function (e, r) {
        var t = e._fullLayout.shapes[r] || {},
          a = e._fullLayout._plots[t.xref + t.yref],
          n = !!a;
        return n ? a._hadPlotinfo = !0 : (a = {}, t.xref && t.xref !== "paper" && (a.xaxis = e._fullLayout[t.xref + "axis"]), t.yref && t.yref !== "paper" && (a.yaxis = e._fullLayout[t.yref + "axis"])), a.xsizemode = t.xsizemode, a.ysizemode = t.ysizemode, a.xanchor = t.xanchor, a.yanchor = t.yanchor, {
          options: t,
          plotinfo: a
        };
      };
      ia.makeSelectionsOptionsAndPlotinfo = function (e, r) {
        var t = e._fullLayout.selections[r] || {},
          a = e._fullLayout._plots[t.xref + t.yref],
          n = !!a;
        return n ? a._hadPlotinfo = !0 : (a = {}, t.xref && (a.xaxis = e._fullLayout[t.xref + "axis"]), t.yref && (a.yaxis = e._fullLayout[t.yref + "axis"])), {
          options: t,
          plotinfo: a
        };
      };
      ia.getPathString = function (e, r) {
        var t = r.type,
          a = lh.getRefType(r.xref),
          n = lh.getRefType(r.yref),
          i = lh.getFromId(e, r.xref),
          l = lh.getFromId(e, r.yref),
          o = e._fullLayout._size,
          s,
          u,
          f,
          v,
          h = wf(i, r.x0shift),
          d = wf(i, r.x1shift),
          y = wf(l, r.y0shift),
          g = wf(l, r.y1shift),
          m,
          _,
          w,
          T;
        if (i ? a === "domain" ? u = function (H) {
          return i._offset + i._length * H;
        } : (s = ia.shapePositionToRange(i), u = function (H) {
          return i._offset + i.r2p(s(H, !0));
        }) : u = function (H) {
          return o.l + o.w * H;
        }, l ? n === "domain" ? v = function (H) {
          return l._offset + l._length * (1 - H);
        } : (f = ia.shapePositionToRange(l), v = function (H) {
          return l._offset + l.r2p(f(H, !0));
        }) : v = function (H) {
          return o.t + o.h * (1 - H);
        }, t === "path") return i && i.type === "date" && (u = ia.decodeDate(u)), l && l.type === "date" && (v = ia.decodeDate(v)), XW(r, u, v);
        if (r.xsizemode === "pixel") {
          var b = u(r.xanchor);
          m = b + r.x0 + h, _ = b + r.x1 + d;
        } else m = u(r.x0) + h, _ = u(r.x1) + d;
        if (r.ysizemode === "pixel") {
          var A = v(r.yanchor);
          w = A - r.y0 + y, T = A - r.y1 + g;
        } else w = v(r.y0) + y, T = v(r.y1) + g;
        if (t === "line") return "M" + m + "," + w + "L" + _ + "," + T;
        if (t === "rect") return "M" + m + "," + w + "H" + _ + "V" + T + "H" + m + "Z";
        var S = (m + _) / 2,
          k = (w + T) / 2,
          q = Math.abs(S - m),
          D = Math.abs(k - w),
          R = "A" + q + "," + D,
          z = S + q + "," + k,
          N = S + "," + (k - D);
        return "M" + z + R + " 0 1,1 " + N + R + " 0 0,1 " + z + "Z";
      };
      function XW(e, r, t) {
        var a = e.path,
          n = e.xsizemode,
          i = e.ysizemode,
          l = e.xanchor,
          o = e.yanchor;
        return a.replace(Co.segmentRE, function (s) {
          var u = 0,
            f = s.charAt(0),
            v = Co.paramIsX[f],
            h = Co.paramIsY[f],
            d = Co.numParams[f],
            y = s.substr(1).replace(Co.paramRE, function (g) {
              return v[u] ? n === "pixel" ? g = r(l) + Number(g) : g = r(g) : h[u] && (i === "pixel" ? g = t(o) - Number(g) : g = t(g)), u++, u > d && (g = "X"), g;
            });
          return u > d && (y = y.replace(/[\s,]*X.*/, ""), AT.log("Ignoring extra params in segment " + s)), f + y;
        });
      }
      function wf(e, r) {
        r = r || 0;
        var t = 0;
        return r && e && (e.type === "category" || e.type === "multicategory") && (t = (e.r2p(1) - e.r2p(0)) * r), t;
      }
    });
    var ky = Z((zse, LT) => {
      "use strict";

      var JW = He(),
        Xs = dt(),
        kT = xa(),
        CT = tt(),
        KW = Tl().readPaths,
        Ay = Al(),
        QW = Ay.getPathString,
        ST = kv(),
        $W = Da().FROM_TL;
      LT.exports = function (r, t, a, n) {
        if (n.selectAll(".shape-label").remove(), !!(a.label.text || a.label.texttemplate)) {
          var i;
          if (a.label.texttemplate) {
            var l = {};
            if (a.type !== "path") {
              var o = Xs.getFromId(r, a.xref),
                s = Xs.getFromId(r, a.yref);
              for (var u in ST) {
                var f = ST[u](a, o, s);
                f !== void 0 && (l[u] = f);
              }
            }
            i = JW.texttemplateStringForShapes(a.label.texttemplate, {}, r._fullLayout._d3locale, l);
          } else i = a.label.text;
          var v = {
              "data-index": t
            },
            h = a.label.font,
            d = {
              "data-notex": 1
            },
            y = n.append("g").attr(v).classed("shape-label", !0),
            g = y.append("text").attr(d).classed("shape-label-text", !0).text(i),
            m,
            _,
            w,
            T;
          if (a.path) {
            var b = QW(r, a),
              A = KW(b, r);
            m = 1 / 0, w = 1 / 0, _ = -1 / 0, T = -1 / 0;
            for (var S = 0; S < A.length; S++) for (var k = 0; k < A[S].length; k++) for (var q = A[S][k], D = 1; D < q.length; D += 2) {
              var R = q[D],
                z = q[D + 1];
              m = Math.min(m, R), _ = Math.max(_, R), w = Math.min(w, z), T = Math.max(T, z);
            }
          } else {
            var N = Xs.getFromId(r, a.xref),
              H = a.x0shift,
              O = a.x1shift,
              J = Xs.getRefType(a.xref),
              X = Xs.getFromId(r, a.yref),
              B = a.y0shift,
              I = a.y1shift,
              V = Xs.getRefType(a.yref),
              K = function (se, Se) {
                var ve = Ay.getDataToPixel(r, N, Se, !1, J);
                return ve(se);
              },
              Q = function (se, Se) {
                var ve = Ay.getDataToPixel(r, X, Se, !0, V);
                return ve(se);
              };
            m = K(a.x0, H), _ = K(a.x1, O), w = Q(a.y0, B), T = Q(a.y1, I);
          }
          var ie = a.label.textangle;
          ie === "auto" && (a.type === "line" ? ie = jW(m, w, _, T) : ie = 0), g.call(function (se) {
            return se.call(CT.font, h).attr({}), kT.convertToTspans(se, r), se;
          });
          var me = CT.bBox(g.node()),
            pe = eZ(m, w, _, T, a, ie, me),
            ge = pe.textx,
            j = pe.texty,
            _e = pe.xanchor;
          g.attr({
            "text-anchor": {
              left: "start",
              center: "middle",
              right: "end"
            }[_e],
            y: j,
            x: ge,
            transform: "rotate(" + ie + "," + ge + "," + j + ")"
          }).call(kT.positionText, ge, j);
        }
      };
      function jW(e, r, t, a) {
        var n, i;
        return i = Math.abs(t - e), t >= e ? n = r - a : n = a - r, -180 / Math.PI * Math.atan2(n, i);
      }
      function eZ(e, r, t, a, n, i, l) {
        var o = n.label.textposition,
          s = n.label.textangle,
          u = n.label.padding,
          f = n.type,
          v = Math.PI / 180 * i,
          h = Math.sin(v),
          d = Math.cos(v),
          y = n.label.xanchor,
          g = n.label.yanchor,
          m,
          _,
          w,
          T;
        if (f === "line") {
          o === "start" ? (m = e, _ = r) : o === "end" ? (m = t, _ = a) : (m = (e + t) / 2, _ = (r + a) / 2), y === "auto" && (o === "start" ? s === "auto" ? t > e ? y = "left" : t < e ? y = "right" : y = "center" : t > e ? y = "right" : t < e ? y = "left" : y = "center" : o === "end" ? s === "auto" ? t > e ? y = "right" : t < e ? y = "left" : y = "center" : t > e ? y = "left" : t < e ? y = "right" : y = "center" : y = "center");
          var b = {
              left: 1,
              center: 0,
              right: -1
            },
            A = {
              bottom: -1,
              middle: 0,
              top: 1
            };
          if (s === "auto") {
            var S = A[g];
            w = -u * h * S, T = u * d * S;
          } else {
            var k = b[y],
              q = A[g];
            w = u * k, T = u * q;
          }
          m = m + w, _ = _ + T;
        } else w = u + 3, o.indexOf("right") !== -1 ? (m = Math.max(e, t) - w, y === "auto" && (y = "right")) : o.indexOf("left") !== -1 ? (m = Math.min(e, t) + w, y === "auto" && (y = "left")) : (m = (e + t) / 2, y === "auto" && (y = "center")), o.indexOf("top") !== -1 ? _ = Math.min(r, a) : o.indexOf("bottom") !== -1 ? _ = Math.max(r, a) : _ = (r + a) / 2, T = u, g === "bottom" ? _ = _ - T : g === "top" && (_ = _ + T);
        var D = $W[g],
          R = n.label.font.size,
          z = l.height,
          N = (z * D - R) * h,
          H = -(z * D - R) * d;
        return {
          textx: m + N,
          texty: _ + H,
          xanchor: y
        };
      }
    });
    var uh = Z((Nse, FT) => {
      "use strict";

      var rZ = He(),
        tZ = rZ.strTranslate,
        qT = Qn(),
        PT = Vs(),
        aZ = PT.drawMode,
        RT = PT.selectMode,
        zT = gr(),
        DT = Er(),
        sh = eh(),
        nZ = sh.i000,
        iZ = sh.i090,
        lZ = sh.i180,
        oZ = sh.i270,
        sZ = pl(),
        NT = sZ.clearOutlineControllers,
        Sy = Tl(),
        oh = Sy.pointsOnRectangle,
        Cy = Sy.pointsOnEllipse,
        uZ = Sy.writePaths,
        fZ = ih().newShapes,
        cZ = ih().createShapeObj,
        vZ = My(),
        hZ = ky();
      FT.exports = function e(r, t, a, n) {
        n || (n = 0);
        var i = a.gd;
        function l() {
          e(r, t, a, n++), (Cy(r[0]) || a.hasText) && o({
            redrawing: !0
          });
        }
        function o(B) {
          var I = {};
          a.isActiveShape !== void 0 && (a.isActiveShape = !1, I = fZ(t, a)), a.isActiveSelection !== void 0 && (a.isActiveSelection = !1, I = vZ(t, a), i._fullLayout._reselect = !0), Object.keys(I).length && zT.call((B || {}).redrawing ? "relayout" : "_guiRelayout", i, I);
        }
        var s = i._fullLayout,
          u = s._zoomlayer,
          f = a.dragmode,
          v = aZ(f),
          h = RT(f);
        (v || h) && (i._fullLayout._outlining = !0), NT(i), t.attr("d", uZ(r));
        var d, y, g, m, _;
        if (!n && (a.isActiveShape || a.isActiveSelection)) {
          _ = dZ([], r);
          var w = u.append("g").attr("class", "outline-controllers");
          R(w), X();
        }
        if (v && a.hasText) {
          var T = u.select(".label-temp"),
            b = cZ(t, a, a.dragmode);
          hZ(i, "label-temp", b, T);
        }
        function A(B) {
          g = +B.srcElement.getAttribute("data-i"), m = +B.srcElement.getAttribute("data-j"), d[g][m].moveFn = S;
        }
        function S(B, I) {
          if (r.length) {
            var V = _[g][m][1],
              K = _[g][m][2],
              Q = r[g],
              ie = Q.length;
            if (oh(Q)) {
              var me = B,
                pe = I;
              if (a.isActiveSelection) {
                var ge = ET(Q, m);
                ge[1] === Q[m][1] ? pe = 0 : me = 0;
              }
              for (var j = 0; j < ie; j++) if (j !== m) {
                var _e = Q[j];
                _e[1] === Q[m][1] && (_e[1] = V + me), _e[2] === Q[m][2] && (_e[2] = K + pe);
              }
              if (Q[m][1] = V + me, Q[m][2] = K + pe, !oh(Q)) for (var se = 0; se < ie; se++) for (var Se = 0; Se < Q[se].length; Se++) Q[se][Se] = _[g][se][Se];
            } else Q[m][1] = V + B, Q[m][2] = K + I;
            l();
          }
        }
        function k() {
          o();
        }
        function q() {
          if (r.length && r[g] && r[g].length) {
            for (var B = [], I = 0; I < r[g].length; I++) I !== m && B.push(r[g][I]);
            B.length > 1 && !(B.length === 2 && B[1][0] === "Z") && (m === 0 && (B[0][0] = "M"), r[g] = B, l(), o());
          }
        }
        function D(B, I) {
          if (B === 2) {
            g = +I.srcElement.getAttribute("data-i"), m = +I.srcElement.getAttribute("data-j");
            var V = r[g];
            !oh(V) && !Cy(V) && q();
          }
        }
        function R(B) {
          d = [];
          for (var I = 0; I < r.length; I++) {
            var V = r[I],
              K = oh(V),
              Q = !K && Cy(V);
            d[I] = [];
            for (var ie = V.length, me = 0; me < ie; me++) if (V[me][0] !== "Z" && !(Q && me !== nZ && me !== iZ && me !== lZ && me !== oZ)) {
              var pe = K && a.isActiveSelection,
                ge;
              pe && (ge = ET(V, me));
              var j = V[me][1],
                _e = V[me][2],
                se = B.append(pe ? "rect" : "circle").attr("data-i", I).attr("data-j", me).style({
                  fill: DT.background,
                  stroke: DT.defaultLine,
                  "stroke-width": 1,
                  "shape-rendering": "crispEdges"
                });
              if (pe) {
                var Se = ge[1] - j,
                  ve = ge[2] - _e,
                  Ae = ve ? 5 : Math.max(Math.min(25, Math.abs(Se) - 5), 5),
                  Y = Se ? 5 : Math.max(Math.min(25, Math.abs(ve) - 5), 5);
                se.classed(ve ? "cursor-ew-resize" : "cursor-ns-resize", !0).attr("width", Ae).attr("height", Y).attr("x", j - Ae / 2).attr("y", _e - Y / 2).attr("transform", tZ(Se / 2, ve / 2));
              } else se.classed("cursor-grab", !0).attr("r", 5).attr("cx", j).attr("cy", _e);
              d[I][me] = {
                element: se.node(),
                gd: i,
                prepFn: A,
                doneFn: k,
                clickFn: D
              }, qT.init(d[I][me]);
            }
          }
        }
        function z(B, I) {
          if (r.length) for (var V = 0; V < r.length; V++) for (var K = 0; K < r[V].length; K++) for (var Q = 0; Q + 2 < r[V][K].length; Q += 2) r[V][K][Q + 1] = _[V][K][Q + 1] + B, r[V][K][Q + 2] = _[V][K][Q + 2] + I;
        }
        function N(B, I) {
          z(B, I), l();
        }
        function H(B) {
          g = +B.srcElement.getAttribute("data-i"), g || (g = 0), y[g].moveFn = N;
        }
        function O() {
          o();
        }
        function J(B) {
          B === 2 && pZ(i);
        }
        function X() {
          if (y = [], !!r.length) {
            var B = 0;
            y[B] = {
              element: t[0][0],
              gd: i,
              prepFn: H,
              doneFn: O,
              clickFn: J
            }, qT.init(y[B]);
          }
        }
      };
      function dZ(e, r) {
        for (var t = 0; t < r.length; t++) {
          var a = r[t];
          e[t] = [];
          for (var n = 0; n < a.length; n++) {
            e[t][n] = [];
            for (var i = 0; i < a[n].length; i++) e[t][n][i] = a[n][i];
          }
        }
        return e;
      }
      function ET(e, r) {
        var t = e[r][1],
          a = e[r][2],
          n = e.length,
          i,
          l,
          o;
        return i = (r + 1) % n, l = e[i][1], o = e[i][2], l === t && o === a && (i = (r + 2) % n, l = e[i][1], o = e[i][2]), [i, l, o];
      }
      function pZ(e) {
        if (RT(e._fullLayout.dragmode)) {
          NT(e);
          var r = e._fullLayout._activeSelectionIndex,
            t = (e.layout || {}).selections || [];
          if (r < t.length) {
            for (var a = [], n = 0; n < t.length; n++) n !== r && a.push(t[n]);
            delete e._fullLayout._activeSelectionIndex;
            var i = e._fullLayout.selections[r];
            e._fullLayout._deselect = {
              xref: i.xref,
              yref: i.yref
            }, zT.call("_guiRelayout", e, {
              selections: a
            });
          }
        }
      }
    });
    var hh = Z((Fse, ZT) => {
      "use strict";

      var mZ = Ir(),
        UT = gr(),
        IT = He(),
        Js = dt(),
        yZ = Tl().readPaths,
        gZ = uh(),
        ch = ky(),
        GT = pl().clearOutlineControllers,
        Ly = Er(),
        Dy = tt(),
        bZ = ct().arrayEditor,
        HT = Qn(),
        OT = wl(),
        So = _f(),
        $a = Al(),
        qy = $a.getPathString;
      ZT.exports = {
        draw: Ey,
        drawOne: VT,
        eraseActiveShape: wZ,
        drawLabel: ch
      };
      function Ey(e) {
        var r = e._fullLayout;
        r._shapeUpperLayer.selectAll("path").remove(), r._shapeLowerLayer.selectAll("path").remove(), r._shapeUpperLayer.selectAll("text").remove(), r._shapeLowerLayer.selectAll("text").remove();
        for (var t in r._plots) {
          var a = r._plots[t].shapelayer;
          a && (a.selectAll("path").remove(), a.selectAll("text").remove());
        }
        for (var n = 0; n < r.shapes.length; n++) r.shapes[n].visible === !0 && VT(e, n);
      }
      function fh(e) {
        return !!e._fullLayout._outlining;
      }
      function vh(e) {
        return !e._context.edits.shapePosition;
      }
      function VT(e, r) {
        e._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + r + '"]').remove();
        var t = $a.makeShapesOptionsAndPlotinfo(e, r),
          a = t.options,
          n = t.plotinfo;
        if (!a._input || a.visible !== !0) return;
        if (a.layer === "above") l(e._fullLayout._shapeUpperLayer);else if (a.xref === "paper" || a.yref === "paper") l(e._fullLayout._shapeLowerLayer);else if (a.layer === "between") l(n.shapelayerBetween);else if (n._hadPlotinfo) {
          var i = n.mainplotinfo || n;
          l(i.shapelayer);
        } else l(e._fullLayout._shapeLowerLayer);
        function l(o) {
          var s = qy(e, a),
            u = {
              "data-index": r,
              "fill-rule": a.fillrule,
              d: s
            },
            f = a.opacity,
            v = a.fillcolor,
            h = a.line.width ? a.line.color : "rgba(0,0,0,0)",
            d = a.line.width,
            y = a.line.dash;
          !d && a.editable === !0 && (d = 5, y = "solid");
          var g = s[s.length - 1] !== "Z",
            m = vh(e) && a.editable && e._fullLayout._activeShapeIndex === r;
          m && (v = g ? "rgba(0,0,0,0)" : e._fullLayout.activeshape.fillcolor, f = e._fullLayout.activeshape.opacity);
          var _ = o.append("g").classed("shape-group", !0).attr({
              "data-index": r
            }),
            w = _.append("path").attr(u).style("opacity", f).call(Ly.stroke, h).call(Ly.fill, v).call(Dy.dashLine, y, d);
          WT(_, e, a), ch(e, r, a, _);
          var T;
          if ((m || e._context.edits.shapePosition) && (T = bZ(e.layout, "shapes", a)), m) {
            w.style({
              cursor: "move"
            });
            var b = {
                element: w.node(),
                plotinfo: n,
                gd: e,
                editHelpers: T,
                hasText: a.label.text || a.label.texttemplate,
                isActiveShape: !0
              },
              A = yZ(s, e);
            gZ(A, w, b);
          } else e._context.edits.shapePosition ? xZ(e, w, a, r, o, T) : a.editable === !0 && w.style("pointer-events", g || Ly.opacity(v) * f <= .5 ? "stroke" : "all");
          w.node().addEventListener("click", function () {
            return _Z(e, w);
          });
        }
      }
      function WT(e, r, t) {
        var a = (t.xref + t.yref).replace(/paper/g, "").replace(/[xyz][1-9]* *domain/g, "");
        Dy.setClipUrl(e, a ? "clip" + r._fullLayout._uid + a : null, r);
      }
      function xZ(e, r, t, a, n, i) {
        var l = 10,
          o = 10,
          s = t.xsizemode === "pixel",
          u = t.ysizemode === "pixel",
          f = t.type === "line",
          v = t.type === "path",
          h = i.modifyItem,
          d,
          y,
          g,
          m,
          _,
          w,
          T,
          b,
          A,
          S,
          k,
          q,
          D,
          R,
          z,
          N = mZ.select(r.node().parentNode),
          H = Js.getFromId(e, t.xref),
          O = Js.getRefType(t.xref),
          J = Js.getFromId(e, t.yref),
          X = Js.getRefType(t.yref),
          B = t.x0shift,
          I = t.x1shift,
          V = t.y0shift,
          K = t.y1shift,
          Q = function (Re, Pe) {
            var Ie = $a.getDataToPixel(e, H, Pe, !1, O);
            return Ie(Re);
          },
          ie = function (Re, Pe) {
            var Ie = $a.getDataToPixel(e, J, Pe, !0, X);
            return Ie(Re);
          },
          me = $a.getPixelToData(e, H, !1, O),
          pe = $a.getPixelToData(e, J, !0, X),
          ge = se(),
          j = {
            element: ge.node(),
            gd: e,
            prepFn: Ae,
            doneFn: Y,
            clickFn: re
          },
          _e;
        HT.init(j), ge.node().onmousemove = ve;
        function se() {
          return f ? Se() : r;
        }
        function Se() {
          var Re = 10,
            Pe = Math.max(t.line.width, Re),
            Ie = n.append("g").attr("data-index", a).attr("drag-helper", !0);
          Ie.append("path").attr("d", r.attr("d")).style({
            cursor: "move",
            "stroke-width": Pe,
            "stroke-opacity": "0"
          });
          var Be = {
              "fill-opacity": "0"
            },
            Ne = Math.max(Pe / 2, Re);
          return Ie.append("circle").attr({
            "data-line-point": "start-point",
            cx: s ? Q(t.xanchor) + t.x0 : Q(t.x0, B),
            cy: u ? ie(t.yanchor) - t.y0 : ie(t.y0, V),
            r: Ne
          }).style(Be).classed("cursor-grab", !0), Ie.append("circle").attr({
            "data-line-point": "end-point",
            cx: s ? Q(t.xanchor) + t.x1 : Q(t.x1, I),
            cy: u ? ie(t.yanchor) - t.y1 : ie(t.y1, K),
            r: Ne
          }).style(Be).classed("cursor-grab", !0), Ie;
        }
        function ve(Re) {
          if (fh(e)) {
            _e = null;
            return;
          }
          if (f) Re.target.tagName === "path" ? _e = "move" : _e = Re.target.attributes["data-line-point"].value === "start-point" ? "resize-over-start-point" : "resize-over-end-point";else {
            var Pe = j.element.getBoundingClientRect(),
              Ie = Pe.right - Pe.left,
              Be = Pe.bottom - Pe.top,
              Ne = Re.clientX - Pe.left,
              Ee = Re.clientY - Pe.top,
              Je = !v && Ie > l && Be > o && !Re.shiftKey ? HT.getCursor(Ne / Ie, 1 - Ee / Be) : "move";
            OT(r, Je), _e = Je.split("-")[0];
          }
        }
        function Ae(Re) {
          fh(e) || (s && (_ = Q(t.xanchor)), u && (w = ie(t.yanchor)), t.type === "path" ? z = t.path : (d = s ? t.x0 : Q(t.x0), y = u ? t.y0 : ie(t.y0), g = s ? t.x1 : Q(t.x1), m = u ? t.y1 : ie(t.y1)), d < g ? (A = d, D = "x0", S = g, R = "x1") : (A = g, D = "x1", S = d, R = "x0"), !u && y < m || u && y > m ? (T = y, k = "y0", b = m, q = "y1") : (T = m, k = "y1", b = y, q = "y0"), ve(Re), be(n, t), Fe(r, t, e), j.moveFn = _e === "move" ? U : de, j.altKey = Re.altKey);
        }
        function Y() {
          fh(e) || (OT(r), ye(n), WT(r, e, t), UT.call("_guiRelayout", e, i.getUpdateObj()));
        }
        function re() {
          fh(e) || ye(n);
        }
        function U(Re, Pe) {
          if (t.type === "path") {
            var Ie = function (Ee) {
                return Ee;
              },
              Be = Ie,
              Ne = Ie;
            s ? h("xanchor", t.xanchor = me(_ + Re)) : (Be = function (Je) {
              return me(Q(Je) + Re);
            }, H && H.type === "date" && (Be = $a.encodeDate(Be))), u ? h("yanchor", t.yanchor = pe(w + Pe)) : (Ne = function (Je) {
              return pe(ie(Je) + Pe);
            }, J && J.type === "date" && (Ne = $a.encodeDate(Ne))), h("path", t.path = BT(z, Be, Ne));
          } else s ? h("xanchor", t.xanchor = me(_ + Re)) : (h("x0", t.x0 = me(d + Re)), h("x1", t.x1 = me(g + Re))), u ? h("yanchor", t.yanchor = pe(w + Pe)) : (h("y0", t.y0 = pe(y + Pe)), h("y1", t.y1 = pe(m + Pe)));
          r.attr("d", qy(e, t)), be(n, t), ch(e, a, t, N);
        }
        function de(Re, Pe) {
          if (v) {
            var Ie = function (Oe) {
                return Oe;
              },
              Be = Ie,
              Ne = Ie;
            s ? h("xanchor", t.xanchor = me(_ + Re)) : (Be = function (Ke) {
              return me(Q(Ke) + Re);
            }, H && H.type === "date" && (Be = $a.encodeDate(Be))), u ? h("yanchor", t.yanchor = pe(w + Pe)) : (Ne = function (Ke) {
              return pe(ie(Ke) + Pe);
            }, J && J.type === "date" && (Ne = $a.encodeDate(Ne))), h("path", t.path = BT(z, Be, Ne));
          } else if (f) {
            if (_e === "resize-over-start-point") {
              var Ee = d + Re,
                Je = u ? y - Pe : y + Pe;
              h("x0", t.x0 = s ? Ee : me(Ee)), h("y0", t.y0 = u ? Je : pe(Je));
            } else if (_e === "resize-over-end-point") {
              var We = g + Re,
                ne = u ? m - Pe : m + Pe;
              h("x1", t.x1 = s ? We : me(We)), h("y1", t.y1 = u ? ne : pe(ne));
            }
          } else {
            var Me = function (Oe) {
                return _e.indexOf(Oe) !== -1;
              },
              Ce = Me("n"),
              cr = Me("s"),
              tr = Me("w"),
              De = Me("e"),
              Le = Ce ? T + Pe : T,
              Ye = cr ? b + Pe : b,
              Ze = tr ? A + Re : A,
              Ue = De ? S + Re : S;
            u && (Ce && (Le = T - Pe), cr && (Ye = b - Pe)), (!u && Ye - Le > o || u && Le - Ye > o) && (h(k, t[k] = u ? Le : pe(Le)), h(q, t[q] = u ? Ye : pe(Ye))), Ue - Ze > l && (h(D, t[D] = s ? Ze : me(Ze)), h(R, t[R] = s ? Ue : me(Ue)));
          }
          r.attr("d", qy(e, t)), be(n, t), ch(e, a, t, N);
        }
        function be(Re, Pe) {
          (s || u) && Ie();
          function Ie() {
            var Be = Pe.type !== "path",
              Ne = Re.selectAll(".visual-cue").data([0]),
              Ee = 1;
            Ne.enter().append("path").attr({
              fill: "#fff",
              "fill-rule": "evenodd",
              stroke: "#000",
              "stroke-width": Ee
            }).classed("visual-cue", !0);
            var Je = Q(s ? Pe.xanchor : IT.midRange(Be ? [Pe.x0, Pe.x1] : $a.extractPathCoords(Pe.path, So.paramIsX))),
              We = ie(u ? Pe.yanchor : IT.midRange(Be ? [Pe.y0, Pe.y1] : $a.extractPathCoords(Pe.path, So.paramIsY)));
            if (Je = $a.roundPositionForSharpStrokeRendering(Je, Ee), We = $a.roundPositionForSharpStrokeRendering(We, Ee), s && u) {
              var ne = "M" + (Je - 1 - Ee) + "," + (We - 1 - Ee) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
              Ne.attr("d", ne);
            } else if (s) {
              var Me = "M" + (Je - 1 - Ee) + "," + (We - 9 - Ee) + "v18 h2 v-18 Z";
              Ne.attr("d", Me);
            } else {
              var Ce = "M" + (Je - 9 - Ee) + "," + (We - 1 - Ee) + "h18 v2 h-18 Z";
              Ne.attr("d", Ce);
            }
          }
        }
        function ye(Re) {
          Re.selectAll(".visual-cue").remove();
        }
        function Fe(Re, Pe, Ie) {
          var Be = Pe.xref,
            Ne = Pe.yref,
            Ee = Js.getFromId(Ie, Be),
            Je = Js.getFromId(Ie, Ne),
            We = "";
          Be !== "paper" && !Ee.autorange && (We += Be), Ne !== "paper" && !Je.autorange && (We += Ne), Dy.setClipUrl(Re, We ? "clip" + Ie._fullLayout._uid + We : null, Ie);
        }
      }
      function BT(e, r, t) {
        return e.replace(So.segmentRE, function (a) {
          var n = 0,
            i = a.charAt(0),
            l = So.paramIsX[i],
            o = So.paramIsY[i],
            s = So.numParams[i],
            u = a.substr(1).replace(So.paramRE, function (f) {
              return n >= s || (l[n] ? f = r(f) : o[n] && (f = t(f)), n++), f;
            });
          return i + u;
        });
      }
      function _Z(e, r) {
        if (vh(e)) {
          var t = r.node(),
            a = +t.getAttribute("data-index");
          if (a >= 0) {
            if (a === e._fullLayout._activeShapeIndex) {
              YT(e);
              return;
            }
            e._fullLayout._activeShapeIndex = a, e._fullLayout._deactivateShape = YT, Ey(e);
          }
        }
      }
      function YT(e) {
        if (vh(e)) {
          var r = e._fullLayout._activeShapeIndex;
          r >= 0 && (GT(e), delete e._fullLayout._activeShapeIndex, Ey(e));
        }
      }
      function wZ(e) {
        if (vh(e)) {
          GT(e);
          var r = e._fullLayout._activeShapeIndex,
            t = (e.layout || {}).shapes || [];
          if (r < t.length) {
            for (var a = [], n = 0; n < t.length; n++) n !== r && a.push(t[n]);
            return delete e._fullLayout._activeShapeIndex, UT.call("_guiRelayout", e, {
              shapes: a
            });
          }
        }
      }
    });
    var zy = Z((Ise, tM) => {
      "use strict";

      var Cn = gr(),
        XT = Pt(),
        JT = Xt(),
        Br = $0(),
        TZ = hh().eraseActiveShape,
        dh = He(),
        Nr = dh._,
        Yr = tM.exports = {};
      Yr.toImage = {
        name: "toImage",
        title: function (e) {
          var r = e._context.toImageButtonOptions || {},
            t = r.format || "png";
          return t === "png" ? Nr(e, "Download plot as a png") : Nr(e, "Download plot");
        },
        icon: Br.camera,
        click: function (e) {
          var r = e._context.toImageButtonOptions,
            t = {
              format: r.format || "png"
            };
          dh.notifier(Nr(e, "Taking snapshot - this may take a few seconds"), "long"), ["filename", "width", "height", "scale"].forEach(function (a) {
            a in r && (t[a] = r[a]);
          }), Cn.call("downloadImage", e, t).then(function (a) {
            dh.notifier(Nr(e, "Snapshot succeeded") + " - " + a, "long");
          }).catch(function () {
            dh.notifier(Nr(e, "Sorry, there was a problem downloading your snapshot!"), "long");
          });
        }
      };
      Yr.sendDataToCloud = {
        name: "sendDataToCloud",
        title: function (e) {
          return Nr(e, "Edit in Chart Studio");
        },
        icon: Br.disk,
        click: function (e) {
          XT.sendDataToCloud(e);
        }
      };
      Yr.editInChartStudio = {
        name: "editInChartStudio",
        title: function (e) {
          return Nr(e, "Edit in Chart Studio");
        },
        icon: Br.pencil,
        click: function (e) {
          XT.sendDataToCloud(e);
        }
      };
      Yr.zoom2d = {
        name: "zoom2d",
        _cat: "zoom",
        title: function (e) {
          return Nr(e, "Zoom");
        },
        attr: "dragmode",
        val: "zoom",
        icon: Br.zoombox,
        click: Ra
      };
      Yr.pan2d = {
        name: "pan2d",
        _cat: "pan",
        title: function (e) {
          return Nr(e, "Pan");
        },
        attr: "dragmode",
        val: "pan",
        icon: Br.pan,
        click: Ra
      };
      Yr.select2d = {
        name: "select2d",
        _cat: "select",
        title: function (e) {
          return Nr(e, "Box Select");
        },
        attr: "dragmode",
        val: "select",
        icon: Br.selectbox,
        click: Ra
      };
      Yr.lasso2d = {
        name: "lasso2d",
        _cat: "lasso",
        title: function (e) {
          return Nr(e, "Lasso Select");
        },
        attr: "dragmode",
        val: "lasso",
        icon: Br.lasso,
        click: Ra
      };
      Yr.drawclosedpath = {
        name: "drawclosedpath",
        title: function (e) {
          return Nr(e, "Draw closed freeform");
        },
        attr: "dragmode",
        val: "drawclosedpath",
        icon: Br.drawclosedpath,
        click: Ra
      };
      Yr.drawopenpath = {
        name: "drawopenpath",
        title: function (e) {
          return Nr(e, "Draw open freeform");
        },
        attr: "dragmode",
        val: "drawopenpath",
        icon: Br.drawopenpath,
        click: Ra
      };
      Yr.drawline = {
        name: "drawline",
        title: function (e) {
          return Nr(e, "Draw line");
        },
        attr: "dragmode",
        val: "drawline",
        icon: Br.drawline,
        click: Ra
      };
      Yr.drawrect = {
        name: "drawrect",
        title: function (e) {
          return Nr(e, "Draw rectangle");
        },
        attr: "dragmode",
        val: "drawrect",
        icon: Br.drawrect,
        click: Ra
      };
      Yr.drawcircle = {
        name: "drawcircle",
        title: function (e) {
          return Nr(e, "Draw circle");
        },
        attr: "dragmode",
        val: "drawcircle",
        icon: Br.drawcircle,
        click: Ra
      };
      Yr.eraseshape = {
        name: "eraseshape",
        title: function (e) {
          return Nr(e, "Erase active shape");
        },
        icon: Br.eraseshape,
        click: TZ
      };
      Yr.zoomIn2d = {
        name: "zoomIn2d",
        _cat: "zoomin",
        title: function (e) {
          return Nr(e, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: Br.zoom_plus,
        click: Ra
      };
      Yr.zoomOut2d = {
        name: "zoomOut2d",
        _cat: "zoomout",
        title: function (e) {
          return Nr(e, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: Br.zoom_minus,
        click: Ra
      };
      Yr.autoScale2d = {
        name: "autoScale2d",
        _cat: "autoscale",
        title: function (e) {
          return Nr(e, "Autoscale");
        },
        attr: "zoom",
        val: "auto",
        icon: Br.autoscale,
        click: Ra
      };
      Yr.resetScale2d = {
        name: "resetScale2d",
        _cat: "resetscale",
        title: function (e) {
          return Nr(e, "Reset axes");
        },
        attr: "zoom",
        val: "reset",
        icon: Br.home,
        click: Ra
      };
      Yr.hoverClosestCartesian = {
        name: "hoverClosestCartesian",
        _cat: "hoverclosest",
        title: function (e) {
          return Nr(e, "Show closest data on hover");
        },
        attr: "hovermode",
        val: "closest",
        icon: Br.tooltip_basic,
        gravity: "ne",
        click: Ra
      };
      Yr.hoverCompareCartesian = {
        name: "hoverCompareCartesian",
        _cat: "hoverCompare",
        title: function (e) {
          return Nr(e, "Compare data on hover");
        },
        attr: "hovermode",
        val: function (e) {
          return e._fullLayout._isHoriz ? "y" : "x";
        },
        icon: Br.tooltip_compare,
        gravity: "ne",
        click: Ra
      };
      function Ra(e, r) {
        var t = r.currentTarget,
          a = t.getAttribute("data-attr"),
          n = t.getAttribute("data-val") || !0,
          i = e._fullLayout,
          l = {},
          o = JT.list(e, null, !0),
          s = i._cartesianSpikesEnabled,
          u,
          f;
        if (a === "zoom") {
          var v = n === "in" ? .5 : 2,
            h = (1 + v) / 2,
            d = (1 - v) / 2,
            y;
          for (f = 0; f < o.length; f++) if (u = o[f], !u.fixedrange) if (y = u._name, n === "auto") l[y + ".autorange"] = !0;else if (n === "reset") u._rangeInitial0 === void 0 && u._rangeInitial1 === void 0 ? l[y + ".autorange"] = !0 : u._rangeInitial0 === void 0 ? (l[y + ".autorange"] = u._autorangeInitial, l[y + ".range"] = [null, u._rangeInitial1]) : u._rangeInitial1 === void 0 ? (l[y + ".range"] = [u._rangeInitial0, null], l[y + ".autorange"] = u._autorangeInitial) : l[y + ".range"] = [u._rangeInitial0, u._rangeInitial1], u._showSpikeInitial !== void 0 && (l[y + ".showspikes"] = u._showSpikeInitial, s === "on" && !u._showSpikeInitial && (s = "off"));else {
            var g = [u.r2l(u.range[0]), u.r2l(u.range[1])],
              m = [h * g[0] + d * g[1], h * g[1] + d * g[0]];
            l[y + ".range[0]"] = u.l2r(m[0]), l[y + ".range[1]"] = u.l2r(m[1]);
          }
        } else a === "hovermode" && (n === "x" || n === "y") && (n = i._isHoriz ? "y" : "x", t.setAttribute("data-val", n)), l[a] = n;
        i._cartesianSpikesEnabled = s, Cn.call("_guiRelayout", e, l);
      }
      Yr.zoom3d = {
        name: "zoom3d",
        _cat: "zoom",
        title: function (e) {
          return Nr(e, "Zoom");
        },
        attr: "scene.dragmode",
        val: "zoom",
        icon: Br.zoombox,
        click: ph
      };
      Yr.pan3d = {
        name: "pan3d",
        _cat: "pan",
        title: function (e) {
          return Nr(e, "Pan");
        },
        attr: "scene.dragmode",
        val: "pan",
        icon: Br.pan,
        click: ph
      };
      Yr.orbitRotation = {
        name: "orbitRotation",
        title: function (e) {
          return Nr(e, "Orbital rotation");
        },
        attr: "scene.dragmode",
        val: "orbit",
        icon: Br["3d_rotate"],
        click: ph
      };
      Yr.tableRotation = {
        name: "tableRotation",
        title: function (e) {
          return Nr(e, "Turntable rotation");
        },
        attr: "scene.dragmode",
        val: "turntable",
        icon: Br["z-axis"],
        click: ph
      };
      function ph(e, r) {
        for (var t = r.currentTarget, a = t.getAttribute("data-attr"), n = t.getAttribute("data-val") || !0, i = e._fullLayout._subplots.gl3d || [], l = {}, o = a.split("."), s = 0; s < i.length; s++) l[i[s] + "." + o[1]] = n;
        var u = n === "pan" ? n : "zoom";
        l.dragmode = u, Cn.call("_guiRelayout", e, l);
      }
      Yr.resetCameraDefault3d = {
        name: "resetCameraDefault3d",
        _cat: "resetCameraDefault",
        title: function (e) {
          return Nr(e, "Reset camera to default");
        },
        attr: "resetDefault",
        icon: Br.home,
        click: Py
      };
      Yr.resetCameraLastSave3d = {
        name: "resetCameraLastSave3d",
        _cat: "resetCameraLastSave",
        title: function (e) {
          return Nr(e, "Reset camera to last save");
        },
        attr: "resetLastSave",
        icon: Br.movie,
        click: Py
      };
      function Py(e, r) {
        for (var t = r.currentTarget, a = t.getAttribute("data-attr"), n = a === "resetLastSave", i = a === "resetDefault", l = e._fullLayout, o = l._subplots.gl3d || [], s = {}, u = 0; u < o.length; u++) {
          var f = o[u],
            v = f + ".camera",
            h = f + ".aspectratio",
            d = f + ".aspectmode",
            y = l[f]._scene,
            g;
          n ? (s[v + ".up"] = y.viewInitial.up, s[v + ".eye"] = y.viewInitial.eye, s[v + ".center"] = y.viewInitial.center, g = !0) : i && (s[v + ".up"] = null, s[v + ".eye"] = null, s[v + ".center"] = null, g = !0), g && (s[h + ".x"] = y.viewInitial.aspectratio.x, s[h + ".y"] = y.viewInitial.aspectratio.y, s[h + ".z"] = y.viewInitial.aspectratio.z, s[d] = y.viewInitial.aspectmode);
        }
        Cn.call("_guiRelayout", e, s);
      }
      Yr.hoverClosest3d = {
        name: "hoverClosest3d",
        _cat: "hoverclosest",
        title: function (e) {
          return Nr(e, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: Br.tooltip_basic,
        gravity: "ne",
        click: MZ
      };
      function KT(e, r) {
        var t = r.currentTarget,
          a = t._previousVal,
          n = e._fullLayout,
          i = n._subplots.gl3d || [],
          l = ["xaxis", "yaxis", "zaxis"],
          o = {},
          s = {};
        if (a) s = a, t._previousVal = null;else {
          for (var u = 0; u < i.length; u++) {
            var f = i[u],
              v = n[f],
              h = f + ".hovermode";
            o[h] = v.hovermode, s[h] = !1;
            for (var d = 0; d < 3; d++) {
              var y = l[d],
                g = f + "." + y + ".showspikes";
              s[g] = !1, o[g] = v[y].showspikes;
            }
          }
          t._previousVal = o;
        }
        return s;
      }
      function MZ(e, r) {
        var t = KT(e, r);
        Cn.call("_guiRelayout", e, t);
      }
      Yr.zoomInGeo = {
        name: "zoomInGeo",
        _cat: "zoomin",
        title: function (e) {
          return Nr(e, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: Br.zoom_plus,
        click: Ry
      };
      Yr.zoomOutGeo = {
        name: "zoomOutGeo",
        _cat: "zoomout",
        title: function (e) {
          return Nr(e, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: Br.zoom_minus,
        click: Ry
      };
      Yr.resetGeo = {
        name: "resetGeo",
        _cat: "reset",
        title: function (e) {
          return Nr(e, "Reset");
        },
        attr: "reset",
        val: null,
        icon: Br.autoscale,
        click: Ry
      };
      Yr.hoverClosestGeo = {
        name: "hoverClosestGeo",
        _cat: "hoverclosest",
        title: function (e) {
          return Nr(e, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: Br.tooltip_basic,
        gravity: "ne",
        click: $T
      };
      function Ry(e, r) {
        for (var t = r.currentTarget, a = t.getAttribute("data-attr"), n = t.getAttribute("data-val") || !0, i = e._fullLayout, l = i._subplots.geo || [], o = 0; o < l.length; o++) {
          var s = l[o],
            u = i[s];
          if (a === "zoom") {
            var f = u.projection.scale,
              v = n === "in" ? 2 * f : .5 * f;
            Cn.call("_guiRelayout", e, s + ".projection.scale", v);
          }
        }
        a === "reset" && Ks(e, "geo");
      }
      Yr.hoverClosestPie = {
        name: "hoverClosestPie",
        _cat: "hoverclosest",
        title: function (e) {
          return Nr(e, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: "closest",
        icon: Br.tooltip_basic,
        gravity: "ne",
        click: $T
      };
      function QT(e) {
        var r = e._fullLayout;
        return r.hovermode ? !1 : r._has("cartesian") ? r._isHoriz ? "y" : "x" : "closest";
      }
      function $T(e) {
        var r = QT(e);
        Cn.call("_guiRelayout", e, "hovermode", r);
      }
      Yr.resetViewSankey = {
        name: "resetSankeyGroup",
        title: function (e) {
          return Nr(e, "Reset view");
        },
        icon: Br.home,
        click: function (e) {
          for (var r = {
              "node.groups": [],
              "node.x": [],
              "node.y": []
            }, t = 0; t < e._fullData.length; t++) {
            var a = e._fullData[t]._viewInitial;
            r["node.groups"].push(a.node.groups.slice()), r["node.x"].push(a.node.x.slice()), r["node.y"].push(a.node.y.slice());
          }
          Cn.call("restyle", e, r);
        }
      };
      Yr.toggleHover = {
        name: "toggleHover",
        title: function (e) {
          return Nr(e, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: Br.tooltip_basic,
        gravity: "ne",
        click: function (e, r) {
          var t = KT(e, r);
          t.hovermode = QT(e), Cn.call("_guiRelayout", e, t);
        }
      };
      Yr.resetViews = {
        name: "resetViews",
        title: function (e) {
          return Nr(e, "Reset views");
        },
        icon: Br.home,
        click: function (e, r) {
          var t = r.currentTarget;
          t.setAttribute("data-attr", "zoom"), t.setAttribute("data-val", "reset"), Ra(e, r), t.setAttribute("data-attr", "resetLastSave"), Py(e, r), Ks(e, "geo"), Ks(e, "mapbox"), Ks(e, "map");
        }
      };
      Yr.toggleSpikelines = {
        name: "toggleSpikelines",
        title: function (e) {
          return Nr(e, "Toggle Spike Lines");
        },
        icon: Br.spikeline,
        attr: "_cartesianSpikesEnabled",
        val: "on",
        click: function (e) {
          var r = e._fullLayout,
            t = r._cartesianSpikesEnabled;
          r._cartesianSpikesEnabled = t === "on" ? "off" : "on", Cn.call("_guiRelayout", e, AZ(e));
        }
      };
      function AZ(e) {
        for (var r = e._fullLayout, t = r._cartesianSpikesEnabled === "on", a = JT.list(e, null, !0), n = {}, i = 0; i < a.length; i++) {
          var l = a[i];
          n[l._name + ".showspikes"] = t ? !0 : l._showSpikeInitial;
        }
        return n;
      }
      Yr.resetViewMapbox = {
        name: "resetViewMapbox",
        _cat: "resetView",
        title: function (e) {
          return Nr(e, "Reset view");
        },
        attr: "reset",
        icon: Br.home,
        click: function (e) {
          Ks(e, "mapbox");
        }
      };
      Yr.resetViewMap = {
        name: "resetViewMap",
        _cat: "resetView",
        title: function (e) {
          return Nr(e, "Reset view");
        },
        attr: "reset",
        icon: Br.home,
        click: function (e) {
          Ks(e, "map");
        }
      };
      Yr.zoomInMapbox = {
        name: "zoomInMapbox",
        _cat: "zoomin",
        title: function (e) {
          return Nr(e, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: Br.zoom_plus,
        click: jT
      };
      Yr.zoomInMap = {
        name: "zoomInMap",
        _cat: "zoomin",
        title: function (e) {
          return Nr(e, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: Br.zoom_plus,
        click: eM
      };
      Yr.zoomOutMapbox = {
        name: "zoomOutMapbox",
        _cat: "zoomout",
        title: function (e) {
          return Nr(e, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: Br.zoom_minus,
        click: jT
      };
      Yr.zoomOutMap = {
        name: "zoomOutMap",
        _cat: "zoomout",
        title: function (e) {
          return Nr(e, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: Br.zoom_minus,
        click: eM
      };
      function jT(e, r) {
        rM(e, r, "mapbox");
      }
      function eM(e, r) {
        rM(e, r, "map");
      }
      function rM(e, r, t) {
        for (var a = r.currentTarget, n = a.getAttribute("data-val"), i = e._fullLayout, l = i._subplots[t] || [], o = 1.05, s = {}, u = 0; u < l.length; u++) {
          var f = l[u],
            v = i[f].zoom,
            h = n === "in" ? o * v : v / o;
          s[f + ".zoom"] = h;
        }
        Cn.call("_guiRelayout", e, s);
      }
      function Ks(e, r) {
        for (var t = e._fullLayout, a = t._subplots[r] || [], n = {}, i = 0; i < a.length; i++) for (var l = a[i], o = t[l]._subplot, s = o.viewInitial, u = Object.keys(s), f = 0; f < u.length; f++) {
          var v = u[f];
          n[l + "." + v] = s[v];
        }
        Cn.call("_guiRelayout", e, n);
      }
    });
    var Ny = Z((Hse, lM) => {
      "use strict";

      var aM = zy(),
        kZ = Object.keys(aM),
        nM = ["drawline", "drawopenpath", "drawclosedpath", "drawcircle", "drawrect", "eraseshape"],
        iM = ["v1hovermode", "hoverclosest", "hovercompare", "togglehover", "togglespikelines"].concat(nM),
        Qs = [],
        CZ = function (e) {
          if (iM.indexOf(e._cat || e.name) === -1) {
            var r = e.name,
              t = (e._cat || e.name).toLowerCase();
            Qs.indexOf(r) === -1 && Qs.push(r), Qs.indexOf(t) === -1 && Qs.push(t);
          }
        };
      kZ.forEach(function (e) {
        CZ(aM[e]);
      });
      Qs.sort();
      lM.exports = {
        DRAW_MODES: nM,
        backButtons: iM,
        foreButtons: Qs
      };
    });
    var Fy = Z((Bse, oM) => {
      "use strict";

      var Ose = Ny();
      oM.exports = {
        editType: "modebar",
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          dflt: "h",
          editType: "modebar"
        },
        bgcolor: {
          valType: "color",
          editType: "modebar"
        },
        color: {
          valType: "color",
          editType: "modebar"
        },
        activecolor: {
          valType: "color",
          editType: "modebar"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        add: {
          valType: "string",
          arrayOk: !0,
          dflt: "",
          editType: "modebar"
        },
        remove: {
          valType: "string",
          arrayOk: !0,
          dflt: "",
          editType: "modebar"
        }
      };
    });
    var uM = Z((Yse, sM) => {
      "use strict";

      var SZ = He(),
        Tf = Er(),
        LZ = ct(),
        qZ = Fy();
      sM.exports = function (r, t) {
        var a = r.modebar || {},
          n = LZ.newContainer(t, "modebar");
        function i(o, s) {
          return SZ.coerce(a, n, qZ, o, s);
        }
        i("orientation"), i("bgcolor", Tf.addOpacity(t.paper_bgcolor, .5));
        var l = Tf.contrast(Tf.rgb(t.modebar.bgcolor));
        i("color", Tf.addOpacity(l, .3)), i("activecolor", Tf.addOpacity(l, .7)), i("uirevision", t.uirevision), i("add"), i("remove");
      };
    });
    var hM = Z((Use, vM) => {
      "use strict";

      var Iy = Ir(),
        DZ = Hr(),
        mh = He(),
        fM = $0(),
        EZ = tv().version,
        PZ = new DOMParser();
      function cM(e) {
        this.container = e.container, this.element = document.createElement("div"), this.update(e.graphInfo, e.buttons), this.container.appendChild(this.element);
      }
      var Ci = cM.prototype;
      Ci.update = function (e, r) {
        this.graphInfo = e;
        var t = this.graphInfo._context,
          a = this.graphInfo._fullLayout,
          n = "modebar-" + a._uid;
        this.element.setAttribute("id", n), this._uid = n, this.element.className = "modebar", t.displayModeBar === "hover" && (this.element.className += " modebar--hover ease-bg"), a.modebar.orientation === "v" && (this.element.className += " vertical", r = r.reverse());
        var i = a.modebar,
          l = "#" + n + " .modebar-group";
        document.querySelectorAll(l).forEach(function (v) {
          v.style.backgroundColor = i.bgcolor;
        });
        var o = !this.hasButtons(r),
          s = this.hasLogo !== t.displaylogo,
          u = this.locale !== t.locale;
        if (this.locale = t.locale, (o || s || u) && (this.removeAllButtons(), this.updateButtons(r), t.watermark || t.displaylogo)) {
          var f = this.getLogo();
          t.watermark && (f.className = f.className + " watermark"), a.modebar.orientation === "v" ? this.element.insertBefore(f, this.element.childNodes[0]) : this.element.appendChild(f), this.hasLogo = !0;
        }
        this.updateActiveButton(), mh.setStyleOnHover("#" + n + " .modebar-btn", ".active", ".icon path", "fill: " + i.activecolor, "fill: " + i.color, this.element);
      };
      Ci.updateButtons = function (e) {
        var r = this;
        this.buttons = e, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function (t) {
          var a = r.createGroup();
          t.forEach(function (n) {
            var i = n.name;
            if (!i) throw new Error("must provide button 'name' in button config");
            if (r.buttonsNames.indexOf(i) !== -1) throw new Error("button name '" + i + "' is taken");
            r.buttonsNames.push(i);
            var l = r.createButton(n);
            r.buttonElements.push(l), a.appendChild(l);
          }), r.element.appendChild(a);
        });
      };
      Ci.createGroup = function () {
        var e = document.createElement("div");
        e.className = "modebar-group";
        var r = this.graphInfo._fullLayout.modebar;
        return e.style.backgroundColor = r.bgcolor, e;
      };
      Ci.createButton = function (e) {
        var r = this,
          t = document.createElement("a");
        t.setAttribute("rel", "tooltip"), t.className = "modebar-btn";
        var a = e.title;
        a === void 0 ? a = e.name : typeof a == "function" && (a = a(this.graphInfo)), (a || a === 0) && t.setAttribute("data-title", a), e.attr !== void 0 && t.setAttribute("data-attr", e.attr);
        var n = e.val;
        n !== void 0 && (typeof n == "function" && (n = n(this.graphInfo)), t.setAttribute("data-val", n));
        var i = e.click;
        if (typeof i != "function") throw new Error("must provide button 'click' function in button config");
        t.addEventListener("click", function (o) {
          e.click(r.graphInfo, o), r.updateActiveButton(o.currentTarget);
        }), t.setAttribute("data-toggle", e.toggle || !1), e.toggle && Iy.select(t).classed("active", !0);
        var l = e.icon;
        return typeof l == "function" ? t.appendChild(l()) : t.appendChild(this.createIcon(l || fM.question)), t.setAttribute("data-gravity", e.gravity || "n"), t;
      };
      Ci.createIcon = function (e) {
        var r = DZ(e.height) ? Number(e.height) : e.ascent - e.descent,
          t = "http://www.w3.org/2000/svg",
          a;
        if (e.path) {
          a = document.createElementNS(t, "svg"), a.setAttribute("viewBox", [0, 0, e.width, r].join(" ")), a.setAttribute("class", "icon");
          var n = document.createElementNS(t, "path");
          n.setAttribute("d", e.path), e.transform ? n.setAttribute("transform", e.transform) : e.ascent !== void 0 && n.setAttribute("transform", "matrix(1 0 0 -1 0 " + e.ascent + ")"), a.appendChild(n);
        }
        if (e.svg) {
          var i = PZ.parseFromString(e.svg, "application/xml");
          a = i.childNodes[0];
        }
        return a.setAttribute("height", "1em"), a.setAttribute("width", "1em"), a;
      };
      Ci.updateActiveButton = function (e) {
        var r = this.graphInfo._fullLayout,
          t = e !== void 0 ? e.getAttribute("data-attr") : null;
        this.buttonElements.forEach(function (a) {
          var n = a.getAttribute("data-val") || !0,
            i = a.getAttribute("data-attr"),
            l = a.getAttribute("data-toggle") === "true",
            o = Iy.select(a),
            s = function (v, h) {
              var d = r.modebar,
                y = v.querySelector(".icon path");
              y && (h || v.matches(":hover") ? y.style.fill = d.activecolor : y.style.fill = d.color);
            };
          if (l) {
            if (i === t) {
              var u = !o.classed("active");
              o.classed("active", u), s(a, u);
            }
          } else {
            var f = i === null ? i : mh.nestedProperty(r, i).get();
            o.classed("active", f === n), s(a, f === n);
          }
        });
      };
      Ci.hasButtons = function (e) {
        var r = this.buttons;
        if (!r || e.length !== r.length) return !1;
        for (var t = 0; t < e.length; ++t) {
          if (e[t].length !== r[t].length) return !1;
          for (var a = 0; a < e[t].length; a++) if (e[t][a].name !== r[t][a].name) return !1;
        }
        return !0;
      };
      function RZ(e) {
        return e + " (v" + EZ + ")";
      }
      Ci.getLogo = function () {
        var e = this.createGroup(),
          r = document.createElement("a");
        return r.href = "https://plotly.com/", r.target = "_blank", r.setAttribute("data-title", RZ(mh._(this.graphInfo, "Produced with Plotly.js"))), r.className = "modebar-btn plotlyjsicon modebar-btn--logo", r.appendChild(this.createIcon(fM.newplotlylogo)), e.appendChild(r), e;
      };
      Ci.removeAllButtons = function () {
        for (; this.element.firstChild;) this.element.removeChild(this.element.firstChild);
        this.hasLogo = !1;
      };
      Ci.destroy = function () {
        mh.removeElement(this.container.querySelector(".modebar"));
      };
      function zZ(e, r) {
        var t = e._fullLayout,
          a = new cM({
            graphInfo: e,
            container: t._modebardiv.node(),
            buttons: r
          });
        return t._privateplot && Iy.select(a.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), a;
      }
      vM.exports = zZ;
    });
    var mM = Z((Gse, pM) => {
      "use strict";

      var NZ = Xt(),
        dM = on(),
        Hy = gr(),
        FZ = bi().isUnifiedHover,
        IZ = hM(),
        yh = zy(),
        HZ = Ny().DRAW_MODES,
        OZ = He().extendDeep;
      pM.exports = function (r) {
        var t = r._fullLayout,
          a = r._context,
          n = t._modeBar;
        if (!a.displayModeBar && !a.watermark) {
          n && (n.destroy(), delete t._modeBar);
          return;
        }
        if (!Array.isArray(a.modeBarButtonsToRemove)) throw new Error(["*modeBarButtonsToRemove* configuration options", "must be an array."].join(" "));
        if (!Array.isArray(a.modeBarButtonsToAdd)) throw new Error(["*modeBarButtonsToAdd* configuration options", "must be an array."].join(" "));
        var i = a.modeBarButtons,
          l;
        Array.isArray(i) && i.length ? l = WZ(i) : !a.displayModeBar && a.watermark ? l = [] : l = BZ(r), n ? n.update(r, l) : t._modeBar = IZ(r, l);
      };
      function BZ(e) {
        var r = e._fullLayout,
          t = e._fullData,
          a = e._context;
        function n(I, V) {
          if (typeof V == "string") {
            if (V.toLowerCase() === I.toLowerCase()) return !0;
          } else {
            var K = V.name,
              Q = V._cat || V.name;
            if (K === I || Q === I.toLowerCase()) return !0;
          }
          return !1;
        }
        var i = r.modebar.add;
        typeof i == "string" && (i = [i]);
        var l = r.modebar.remove;
        typeof l == "string" && (l = [l]);
        var o = a.modeBarButtonsToAdd.concat(i.filter(function (I) {
            for (var V = 0; V < a.modeBarButtonsToRemove.length; V++) if (n(I, a.modeBarButtonsToRemove[V])) return !1;
            return !0;
          })),
          s = a.modeBarButtonsToRemove.concat(l.filter(function (I) {
            for (var V = 0; V < a.modeBarButtonsToAdd.length; V++) if (n(I, a.modeBarButtonsToAdd[V])) return !1;
            return !0;
          })),
          u = r._has("cartesian"),
          f = r._has("gl3d"),
          v = r._has("geo"),
          h = r._has("pie"),
          d = r._has("funnelarea"),
          y = r._has("ternary"),
          g = r._has("mapbox"),
          m = r._has("map"),
          _ = r._has("polar"),
          w = r._has("smith"),
          T = r._has("sankey"),
          b = YZ(r),
          A = FZ(r.hovermode),
          S = [];
        function k(I) {
          if (I.length) {
            for (var V = [], K = 0; K < I.length; K++) {
              for (var Q = I[K], ie = yh[Q], me = ie.name.toLowerCase(), pe = (ie._cat || ie.name).toLowerCase(), ge = !1, j = 0; j < s.length; j++) {
                var _e = s[j].toLowerCase();
                if (_e === me || _e === pe) {
                  ge = !0;
                  break;
                }
              }
              ge || V.push(yh[Q]);
            }
            S.push(V);
          }
        }
        var q = ["toImage"];
        a.showEditInChartStudio ? q.push("editInChartStudio") : a.showSendToCloud && q.push("sendDataToCloud"), k(q);
        var D = [],
          R = [],
          z = [],
          N = [];
        (u || h || d || y) + v + f + g + m + _ + w > 1 ? (R = ["toggleHover"], z = ["resetViews"]) : v ? (D = ["zoomInGeo", "zoomOutGeo"], R = ["hoverClosestGeo"], z = ["resetGeo"]) : f ? (R = ["hoverClosest3d"], z = ["resetCameraDefault3d", "resetCameraLastSave3d"]) : g ? (D = ["zoomInMapbox", "zoomOutMapbox"], R = ["toggleHover"], z = ["resetViewMapbox"]) : m ? (D = ["zoomInMap", "zoomOutMap"], R = ["toggleHover"], z = ["resetViewMap"]) : h ? R = ["hoverClosestPie"] : T ? (R = ["hoverClosestCartesian", "hoverCompareCartesian"], z = ["resetViewSankey"]) : R = ["toggleHover"], u && R.push("toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian"), (GZ(t) || A) && (R = []), u && !b && (D = ["zoomIn2d", "zoomOut2d", "autoScale2d"], z[0] !== "resetViews" && (z = ["resetScale2d"])), f ? N = ["zoom3d", "pan3d", "orbitRotation", "tableRotation"] : u && !b || y ? N = ["zoom2d", "pan2d"] : g || m || v ? N = ["pan2d"] : _ && (N = ["zoom2d"]), UZ(t) && N.push("select2d", "lasso2d");
        var H = [],
          O = function (I) {
            H.indexOf(I) === -1 && R.indexOf(I) !== -1 && H.push(I);
          };
        if (Array.isArray(o)) {
          for (var J = [], X = 0; X < o.length; X++) {
            var B = o[X];
            typeof B == "string" ? (B = B.toLowerCase(), HZ.indexOf(B) !== -1 ? (r._has("mapbox") || r._has("map") || r._has("cartesian")) && N.push(B) : B === "togglespikelines" ? O("toggleSpikelines") : B === "togglehover" ? O("toggleHover") : B === "hovercompare" ? O("hoverCompareCartesian") : B === "hoverclosest" ? (O("hoverClosestCartesian"), O("hoverClosestGeo"), O("hoverClosest3d"), O("hoverClosestPie")) : B === "v1hovermode" && (O("hoverClosestCartesian"), O("hoverCompareCartesian"), O("hoverClosestGeo"), O("hoverClosest3d"), O("hoverClosestPie"))) : J.push(B);
          }
          o = J;
        }
        return k(N), k(D.concat(z)), k(H), VZ(S, o);
      }
      function YZ(e) {
        for (var r = NZ.list({
            _fullLayout: e
          }, null, !0), t = 0; t < r.length; t++) if (!r[t].fixedrange) return !1;
        return !0;
      }
      function UZ(e) {
        for (var r = !1, t = 0; t < e.length && !r; t++) {
          var a = e[t];
          !a._module || !a._module.selectPoints || (Hy.traceIs(a, "scatter-like") ? (dM.hasMarkers(a) || dM.hasText(a)) && (r = !0) : Hy.traceIs(a, "box-violin") ? (a.boxpoints === "all" || a.points === "all") && (r = !0) : r = !0);
        }
        return r;
      }
      function GZ(e) {
        for (var r = 0; r < e.length; r++) if (!Hy.traceIs(e[r], "noHover")) return !1;
        return !0;
      }
      function VZ(e, r) {
        if (r.length) if (Array.isArray(r[0])) for (var t = 0; t < r.length; t++) e.push(r[t]);else e.push(r);
        return e;
      }
      function WZ(e) {
        for (var r = OZ([], e), t = 0; t < r.length; t++) for (var a = r[t], n = 0; n < a.length; n++) {
          var i = a[n];
          if (typeof i == "string") if (yh[i] !== void 0) r[t][n] = yh[i];else throw new Error(["*modeBarButtons* configuration options", "invalid button name"].join(" "));
        }
        return r;
      }
    });
    var Oy = Z((Vse, yM) => {
      "use strict";

      yM.exports = {
        moduleType: "component",
        name: "modebar",
        layoutAttributes: Fy(),
        supplyLayoutDefaults: uM(),
        manage: mM()
      };
    });
    var By = Z((Wse, gM) => {
      "use strict";

      var ZZ = Da().FROM_BL;
      gM.exports = function (r, t, a) {
        a === void 0 && (a = ZZ[r.constraintoward || "center"]);
        var n = [r.r2l(r.range[0]), r.r2l(r.range[1])],
          i = n[0] + (n[1] - n[0]) * a;
        r.range = r._input.range = [r.l2r(i + (n[0] - i) * t), r.l2r(i + (n[1] - i) * t)], r.setScale();
      };
    });
    var Af = Z(Mf => {
      "use strict";

      var Lo = He(),
        Yy = ff(),
        jn = Xt().id2name,
        XZ = Xn(),
        bM = By(),
        JZ = b0(),
        KZ = Bt().ALMOST_EQUAL,
        QZ = Da().FROM_BL;
      Mf.handleDefaults = function (e, r, t) {
        var a = t.axIds,
          n = t.axHasImage,
          i = r._axisConstraintGroups = [],
          l = r._axisMatchGroups = [],
          o,
          s,
          u,
          f,
          v,
          h,
          d,
          y;
        for (o = 0; o < a.length; o++) f = jn(a[o]), v = e[f], h = r[f], $Z(v, h, {
          axIds: a,
          layoutOut: r,
          hasImage: n[f]
        });
        function g(q, D) {
          for (o = 0; o < q.length; o++) {
            s = q[o];
            for (u in s) r[jn(u)][D] = s;
          }
        }
        for (g(l, "_matchGroup"), o = 0; o < i.length; o++) {
          s = i[o];
          for (u in s) if (h = r[jn(u)], h.fixedrange) {
            for (var m in s) {
              var _ = jn(m);
              (e[_] || {}).fixedrange === !1 && Lo.warn("fixedrange was specified as false for axis " + _ + " but was overridden because another axis in its constraint group has fixedrange true"), r[_].fixedrange = !0;
            }
            break;
          }
        }
        for (o = 0; o < i.length;) {
          s = i[o];
          for (u in s) {
            h = r[jn(u)], h._matchGroup && Object.keys(h._matchGroup).length === Object.keys(s).length && (i.splice(o, 1), o--);
            break;
          }
          o++;
        }
        g(i, "_constraintGroup");
        var w = ["constrain", "range", "autorange", "rangemode", "rangebreaks", "categoryorder", "categoryarray"],
          T = !1,
          b = !1;
        function A() {
          y = h[d], d === "rangebreaks" && (b = h._hasDayOfWeekBreaks);
        }
        for (o = 0; o < l.length; o++) {
          s = l[o];
          for (var S = 0; S < w.length; S++) {
            d = w[S], y = null;
            var k;
            for (u in s) if (f = jn(u), v = e[f], h = r[f], d in h) {
              if (!h.matches && (k = h, d in v)) {
                A();
                break;
              }
              y === null && d in v && A();
            }
            if (d === "range" && y && v.range && v.range.length === 2 && v.range[0] !== null && v.range[1] !== null && (T = !0), d === "autorange" && y === null && T && (y = !1), y === null && d in k && (y = k[d]), y !== null) for (u in s) h = r[jn(u)], h[d] = d === "range" ? y.slice() : y, d === "rangebreaks" && (h._hasDayOfWeekBreaks = b, JZ(h, r));
          }
        }
      };
      function $Z(e, r, t) {
        var a = t.axIds,
          n = t.layoutOut,
          i = t.hasImage,
          l = n._axisConstraintGroups,
          o = n._axisMatchGroups,
          s = r._id,
          u = s.charAt(0),
          f = ((n._splomAxes || {})[u] || {})[s] || {},
          v = r._id,
          h = v.charAt(0) === "x";
        r._matchGroup = null, r._constraintGroup = null;
        function d(N, H) {
          return Lo.coerce(e, r, XZ, N, H);
        }
        d("constrain", i ? "domain" : "range"), Lo.coerce(e, r, {
          constraintoward: {
            valType: "enumerated",
            values: h ? ["left", "center", "right"] : ["bottom", "middle", "top"],
            dflt: h ? "center" : "middle"
          }
        }, "constraintoward");
        var y = r.type,
          g,
          m,
          _ = [];
        for (g = 0; g < a.length; g++) if (m = a[g], m !== v) {
          var w = n[jn(m)];
          w.type === y && _.push(m);
        }
        var T = wM(l, v);
        if (T) {
          var b = [];
          for (g = 0; g < _.length; g++) m = _[g], T[m] || b.push(m);
          _ = b;
        }
        var A = _.length,
          S,
          k;
        A && (e.matches || f.matches) && (S = Lo.coerce(e, r, {
          matches: {
            valType: "enumerated",
            values: _,
            dflt: _.indexOf(f.matches) !== -1 ? f.matches : void 0
          }
        }, "matches"));
        var q = i && !h ? r.anchor : void 0;
        if (A && !S && (e.scaleanchor || q) && (k = Lo.coerce(e, r, {
          scaleanchor: {
            valType: "enumerated",
            values: _.concat([!1])
          }
        }, "scaleanchor", q)), S) {
          r._matchGroup = Uy(o, v, S, 1);
          var D = n[jn(S)],
            R = xM(n, r) / xM(n, D);
          h !== (S.charAt(0) === "x") && (R = (h ? "x" : "y") + R), Uy(l, v, S, R);
        } else e.matches && a.indexOf(e.matches) !== -1 && Lo.warn("ignored " + r._name + '.matches: "' + e.matches + '" to avoid an infinite loop');
        if (k) {
          var z = d("scaleratio");
          z || (z = r.scaleratio = 1), Uy(l, v, k, z);
        } else e.scaleanchor && a.indexOf(e.scaleanchor) !== -1 && Lo.warn("ignored " + r._name + '.scaleanchor: "' + e.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
      }
      function xM(e, r) {
        var t = r.domain;
        return t || (t = e[jn(r.overlaying)].domain), t[1] - t[0];
      }
      function wM(e, r) {
        for (var t = 0; t < e.length; t++) if (e[t][r]) return e[t];
        return null;
      }
      function Uy(e, r, t, a) {
        var n,
          i,
          l,
          o,
          s,
          u = wM(e, r);
        u === null ? (u = {}, u[r] = 1, s = e.length, e.push(u)) : s = e.indexOf(u);
        var f = Object.keys(u);
        for (n = 0; n < e.length; n++) if (l = e[n], n !== s && l[t]) {
          var v = l[t];
          for (i = 0; i < f.length; i++) o = f[i], l[o] = Gy(v, Gy(a, u[o]));
          e.splice(s, 1);
          return;
        }
        if (a !== 1) for (i = 0; i < f.length; i++) {
          var h = f[i];
          u[h] = Gy(a, u[h]);
        }
        u[t] = 1;
      }
      function Gy(e, r) {
        var t = "",
          a = "",
          n,
          i;
        typeof e == "string" && (t = e.match(/^[xy]*/)[0], n = t.length, e = +e.substr(n)), typeof r == "string" && (a = r.match(/^[xy]*/)[0], i = a.length, r = +r.substr(i));
        var l = e * r;
        return !n && !i ? l : !n || !i || t.charAt(0) === a.charAt(0) ? t + a + e * r : n === i ? l : (n > i ? t.substr(i) : a.substr(n)) + l;
      }
      function jZ(e, r) {
        for (var t = r._size, a = t.h / t.w, n = {}, i = Object.keys(e), l = 0; l < i.length; l++) {
          var o = i[l],
            s = e[o];
          if (typeof s == "string") {
            var u = s.match(/^[xy]*/)[0],
              f = u.length;
            s = +s.substr(f);
            for (var v = u.charAt(0) === "y" ? a : 1 / a, h = 0; h < f; h++) s *= v;
          }
          n[o] = s;
        }
        return n;
      }
      Mf.enforce = function (r) {
        var t = r._fullLayout,
          a = t._axisConstraintGroups || [],
          n,
          i,
          l,
          o,
          s,
          u,
          f,
          v;
        for (n = 0; n < a.length; n++) {
          l = jZ(a[n], t);
          var h = Object.keys(l),
            d = 1 / 0,
            y = 0,
            g = 1 / 0,
            m = {},
            _ = {},
            w = !1;
          for (i = 0; i < h.length; i++) o = h[i], _[o] = s = t[jn(o)], s._inputDomain ? s.domain = s._inputDomain.slice() : s._inputDomain = s.domain.slice(), s._inputRange || (s._inputRange = s.range.slice()), s.setScale(), m[o] = u = Math.abs(s._m) / l[o], d = Math.min(d, u), (s.constrain === "domain" || !s._constraintShrinkable) && (g = Math.min(g, u)), delete s._constraintShrinkable, y = Math.max(y, u), s.constrain === "domain" && (w = !0);
          if (!(d > KZ * y && !w)) {
            for (i = 0; i < h.length; i++) if (o = h[i], u = m[o], s = _[o], f = s.constrain, u !== g || f === "domain") if (v = u / g, f === "range") bM(s, v);else {
              var T = s._inputDomain,
                b = (s.domain[1] - s.domain[0]) / (T[1] - T[0]),
                A = (s.r2l(s.range[1]) - s.r2l(s.range[0])) / (s.r2l(s._inputRange[1]) - s.r2l(s._inputRange[0]));
              if (v /= b, v * A < 1) {
                s.domain = s._input.domain = T.slice(), bM(s, v);
                continue;
              }
              if (A < 1 && (s.range = s._input.range = s._inputRange.slice(), v *= A), s.autorange) {
                var S = s.r2l(s.range[0]),
                  k = s.r2l(s.range[1]),
                  q = (S + k) / 2,
                  D = q,
                  R = q,
                  z = Math.abs(k - q),
                  N = q - z * v * 1.0001,
                  H = q + z * v * 1.0001,
                  O = Yy.makePadFn(t, s, 0),
                  J = Yy.makePadFn(t, s, 1);
                _M(s, v);
                var X = Math.abs(s._m),
                  B = Yy.concatExtremes(r, s),
                  I = B.min,
                  V = B.max,
                  K,
                  Q;
                for (Q = 0; Q < I.length; Q++) K = I[Q].val - O(I[Q]) / X, K > N && K < D && (D = K);
                for (Q = 0; Q < V.length; Q++) K = V[Q].val + J(V[Q]) / X, K < H && K > R && (R = K);
                var ie = (R - D) / (2 * z);
                v /= ie, D = s.l2r(D), R = s.l2r(R), s.range = s._input.range = S < k ? [D, R] : [R, D];
              }
              _M(s, v);
            }
          }
        }
      };
      Mf.getAxisGroup = function (r, t) {
        for (var a = r._axisMatchGroups, n = 0; n < a.length; n++) {
          var i = a[n];
          if (i[t]) return "g" + n;
        }
        return t;
      };
      Mf.clean = function (r, t) {
        if (t._inputDomain) {
          for (var a = !1, n = t._id, i = r._fullLayout._axisConstraintGroups, l = 0; l < i.length; l++) if (i[l][n]) {
            a = !0;
            break;
          }
          (!a || t.constrain !== "domain") && (t._input.domain = t.domain = t._inputDomain, delete t._inputDomain);
        }
      };
      function _M(e, r) {
        var t = e._inputDomain,
          a = QZ[e.constraintoward],
          n = t[0] + (t[1] - t[0]) * a;
        e.domain = e._input.domain = [n + (t[0] - n) / r, n + (t[1] - n) / r], e.setScale();
      }
    });
    var xh = Z(Qt => {
      "use strict";

      var bh = Ir(),
        za = gr(),
        cn = Pt(),
        Sn = He(),
        Vy = xa(),
        Wy = Q0(),
        kf = Er(),
        $s = tt(),
        TM = sf(),
        SM = Oy(),
        Cf = dt(),
        Zi = Da(),
        LM = Af(),
        eX = LM.enforce,
        rX = LM.clean,
        MM = ff().doAutoRange,
        qM = "start",
        tX = "middle",
        DM = "end",
        aX = da().zindexSeparator;
      Qt.layoutStyles = function (e) {
        return Sn.syncOrAsync([cn.doAutoMargin, iX], e);
      };
      function nX(e, r, t) {
        for (var a = 0; a < t.length; a++) {
          var n = t[a][0],
            i = t[a][1];
          if (!(n[0] >= e[1] || n[1] <= e[0]) && i[0] < r[1] && i[1] > r[0]) return !0;
        }
        return !1;
      }
      function iX(e) {
        var r = e._fullLayout,
          t = r._size,
          a = t.p,
          n = Cf.list(e, "", !0),
          i,
          l,
          o,
          s,
          u,
          f;
        if (r._paperdiv.style({
          width: e._context.responsive && r.autosize && !e._context._hasZeroWidth && !e.layout.width ? "100%" : r.width + "px",
          height: e._context.responsive && r.autosize && !e._context._hasZeroHeight && !e.layout.height ? "100%" : r.height + "px"
        }).selectAll(".main-svg").call($s.setSize, r.width, r.height), e._context.setBackground(e, r.paper_bgcolor), Qt.drawMainTitle(e), SM.manage(e), !r._has("cartesian")) return cn.previousPromises(e);
        function v(Ae, Y, re) {
          var U = Ae._lw / 2;
          if (Ae._id.charAt(0) === "x") {
            if (Y) {
              if (re === "top") return Y._offset - a - U;
            } else return t.t + t.h * (1 - (Ae.position || 0)) + U % 1;
            return Y._offset + Y._length + a + U;
          }
          if (Y) {
            if (re === "right") return Y._offset + Y._length + a + U;
          } else return t.l + t.w * (Ae.position || 0) + U % 1;
          return Y._offset - a - U;
        }
        for (i = 0; i < n.length; i++) {
          s = n[i];
          var h = s._anchorAxis;
          s._linepositions = {}, s._lw = $s.crispRound(e, s.linewidth, 1), s._mainLinePosition = v(s, h, s.side), s._mainMirrorPosition = s.mirror && h ? v(s, h, Zi.OPPOSITE_SIDE[s.side]) : null;
        }
        var d = [],
          y = [],
          g = [],
          m = kf.opacity(r.paper_bgcolor) === 1 && kf.opacity(r.plot_bgcolor) === 1 && r.paper_bgcolor === r.plot_bgcolor;
        for (l in r._plots) if (o = r._plots[l], o.mainplot) o.bg && o.bg.remove(), o.bg = void 0;else {
          var _ = o.xaxis.domain,
            w = o.yaxis.domain,
            T = o.plotgroup;
          if (nX(_, w, g) && l.indexOf(aX) === -1) {
            var b = T.node(),
              A = o.bg = Sn.ensureSingle(T, "rect", "bg");
            b.insertBefore(A.node(), b.childNodes[0]), y.push(l);
          } else T.select("rect.bg").remove(), g.push([_, w]), m || (d.push(l), y.push(l));
        }
        var S = r._bgLayer.selectAll(".bg").data(d);
        for (S.enter().append("rect").classed("bg", !0), S.exit().remove(), S.each(function (Ae) {
          r._plots[Ae].bg = bh.select(this);
        }), i = 0; i < y.length; i++) o = r._plots[y[i]], u = o.xaxis, f = o.yaxis, o.bg && u._offset !== void 0 && f._offset !== void 0 && o.bg.call($s.setRect, u._offset - a, f._offset - a, u._length + 2 * a, f._length + 2 * a).call(kf.fill, r.plot_bgcolor).style("stroke-width", 0);
        if (!r._hasOnlyLargeSploms) for (l in r._plots) {
          o = r._plots[l], u = o.xaxis, f = o.yaxis;
          var k = o.clipId = "clip" + r._uid + l + "plot",
            q = Sn.ensureSingleById(r._clips, "clipPath", k, function (Ae) {
              Ae.classed("plotclip", !0).append("rect");
            });
          o.clipRect = q.select("rect").attr({
            width: u._length,
            height: f._length
          }), $s.setTranslate(o.plot, u._offset, f._offset);
          var D, R;
          o._hasClipOnAxisFalse ? (D = null, R = k) : (D = k, R = null), $s.setClipUrl(o.plot, D, e), o.layerClipId = R;
        }
        var z, N, H, O, J, X, B, I, V, K, Q, ie, me;
        function pe(Ae) {
          return "M" + z + "," + Ae + "H" + N;
        }
        function ge(Ae) {
          return "M" + u._offset + "," + Ae + "h" + u._length;
        }
        function j(Ae) {
          return "M" + Ae + "," + I + "V" + B;
        }
        function _e(Ae) {
          return f._shift !== void 0 && (Ae += f._shift), "M" + Ae + "," + f._offset + "v" + f._length;
        }
        function se(Ae, Y, re) {
          if (!Ae.showline || l !== Ae._mainSubplot) return "";
          if (!Ae._anchorAxis) return re(Ae._mainLinePosition);
          var U = Y(Ae._mainLinePosition);
          return Ae.mirror && (U += Y(Ae._mainMirrorPosition)), U;
        }
        for (l in r._plots) {
          o = r._plots[l], u = o.xaxis, f = o.yaxis;
          var Se = "M0,0";
          AM(u, l) && (J = gh(u, "left", f, n), z = u._offset - (J ? a + J : 0), X = gh(u, "right", f, n), N = u._offset + u._length + (X ? a + X : 0), H = v(u, f, "bottom"), O = v(u, f, "top"), me = !u._anchorAxis || l !== u._mainSubplot, me && (u.mirror === "allticks" || u.mirror === "all") && (u._linepositions[l] = [H, O]), Se = se(u, pe, ge), me && u.showline && (u.mirror === "all" || u.mirror === "allticks") && (Se += pe(H) + pe(O)), o.xlines.style("stroke-width", u._lw + "px").call(kf.stroke, u.showline ? u.linecolor : "rgba(0,0,0,0)")), o.xlines.attr("d", Se);
          var ve = "M0,0";
          AM(f, l) && (Q = gh(f, "bottom", u, n), B = f._offset + f._length + (Q ? a : 0), ie = gh(f, "top", u, n), I = f._offset - (ie ? a : 0), V = v(f, u, "left"), K = v(f, u, "right"), me = !f._anchorAxis || l !== f._mainSubplot, me && (f.mirror === "allticks" || f.mirror === "all") && (f._linepositions[l] = [V, K]), ve = se(f, j, _e), me && f.showline && (f.mirror === "all" || f.mirror === "allticks") && (ve += j(V) + j(K)), o.ylines.style("stroke-width", f._lw + "px").call(kf.stroke, f.showline ? f.linecolor : "rgba(0,0,0,0)")), o.ylines.attr("d", ve);
        }
        return Cf.makeClipPaths(e), cn.previousPromises(e);
      }
      function AM(e, r) {
        return (e.ticks || e.showline) && (r === e._mainSubplot || e.mirror === "all" || e.mirror === "allticks");
      }
      function kM(e, r, t) {
        if (!t.showline || !t._lw) return !1;
        if (t.mirror === "all" || t.mirror === "allticks") return !0;
        var a = t._anchorAxis;
        if (!a) return !1;
        var n = Zi.FROM_BL[r];
        return t.side === r ? a.domain[n] === e.domain[n] : t.mirror && a.domain[1 - n] === e.domain[1 - n];
      }
      function gh(e, r, t, a) {
        if (kM(e, r, t)) return t._lw;
        for (var n = 0; n < a.length; n++) {
          var i = a[n];
          if (i._mainAxis === t._mainAxis && kM(e, r, i)) return i._lw;
        }
        return 0;
      }
      Qt.drawMainTitle = function (e) {
        var r = e._fullLayout.title,
          t = e._fullLayout,
          a = vX(t),
          n = hX(t),
          i = cX(t, n),
          l = fX(t, a);
        if (TM.draw(e, "gtitle", {
          propContainer: t,
          propName: "title.text",
          subtitlePropName: "title.subtitle.text",
          placeholder: t._dfltTitle.plot,
          subtitlePlaceholder: t._dfltTitle.subtitle,
          attributes: {
            x: l,
            y: i,
            "text-anchor": a,
            dy: n
          }
        }), r.text && r.automargin) {
          var o = bh.selectAll(".gtitle"),
            s = $s.bBox(bh.selectAll(".g-gtitle").node()).height,
            u = sX(e, r, s);
          if (u > 0) {
            uX(e, i, u, s), o.attr({
              x: l,
              y: i,
              "text-anchor": a,
              dy: CM(r.yanchor)
            }).call(Vy.positionText, l, i);
            var f = (r.text.match(Vy.BR_TAG_ALL) || []).length;
            if (f) {
              var v = Zi.LINE_SPACING * f + Zi.MID_SHIFT;
              r.y === 0 && (v = -v), o.selectAll(".line").each(function () {
                var m = +this.getAttribute("dy").slice(0, -2) - v + "em";
                this.setAttribute("dy", m);
              });
            }
            var h = bh.selectAll(".gtitle-subtitle");
            if (h.node()) {
              var d = o.node().getBBox(),
                y = d.y + d.height,
                g = y + TM.SUBTITLE_PADDING_EM * r.subtitle.font.size;
              h.attr({
                x: l,
                y: g,
                "text-anchor": a,
                dy: CM(r.yanchor)
              }).call(Vy.positionText, l, g);
            }
          }
        }
      };
      function lX(e, r, t, a, n) {
        var i = r.yref === "paper" ? e._fullLayout._size.h : e._fullLayout.height,
          l = Sn.isTopAnchor(r) ? a : a - n,
          o = t === "b" ? i - l : l;
        return Sn.isTopAnchor(r) && t === "t" || Sn.isBottomAnchor(r) && t === "b" ? !1 : o < n;
      }
      function oX(e, r, t, a, n) {
        var i = 0;
        return t === "middle" && (i += n / 2), e === "t" ? (t === "top" && (i += n), i += a - r * a) : (t === "bottom" && (i += n), i += r * a), i;
      }
      function sX(e, r, t) {
        var a = r.y,
          n = r.yanchor,
          i = a > .5 ? "t" : "b",
          l = e._fullLayout.margin[i],
          o = 0;
        return r.yref === "paper" ? o = t + r.pad.t + r.pad.b : r.yref === "container" && (o = oX(i, a, n, e._fullLayout.height, t) + r.pad.t + r.pad.b), o > l ? o : 0;
      }
      function uX(e, r, t, a) {
        var n = "title.automargin",
          i = e._fullLayout.title,
          l = i.y > .5 ? "t" : "b",
          o = {
            x: i.x,
            y: i.y,
            t: 0,
            b: 0
          },
          s = {};
        i.yref === "paper" && lX(e, i, l, r, a) ? o[l] = t : i.yref === "container" && (s[l] = t, e._fullLayout._reservedMargin[n] = s), cn.allowAutoMargin(e, n), cn.autoMargin(e, n, o);
      }
      function fX(e, r) {
        var t = e.title,
          a = e._size,
          n = 0;
        switch (r === qM ? n = t.pad.l : r === DM && (n = -t.pad.r), t.xref) {
          case "paper":
            return a.l + a.w * t.x + n;
          case "container":
          default:
            return e.width * t.x + n;
        }
      }
      function cX(e, r) {
        var t = e.title,
          a = e._size,
          n = 0;
        if (r === "0em" || !r ? n = -t.pad.b : r === Zi.CAP_SHIFT + "em" && (n = t.pad.t), t.y === "auto") return a.t / 2;
        switch (t.yref) {
          case "paper":
            return a.t + a.h - a.h * t.y + n;
          case "container":
          default:
            return e.height - e.height * t.y + n;
        }
      }
      function CM(e) {
        return e === "top" ? Zi.CAP_SHIFT + .3 + "em" : e === "bottom" ? "-0.3em" : Zi.MID_SHIFT + "em";
      }
      function vX(e) {
        var r = e.title,
          t = tX;
        return Sn.isRightAnchor(r) ? t = DM : Sn.isLeftAnchor(r) && (t = qM), t;
      }
      function hX(e) {
        var r = e.title,
          t = "0em";
        return Sn.isTopAnchor(r) ? t = Zi.CAP_SHIFT + "em" : Sn.isMiddleAnchor(r) && (t = Zi.MID_SHIFT + "em"), t;
      }
      Qt.doTraceStyle = function (e) {
        var r = e.calcdata,
          t = [],
          a;
        for (a = 0; a < r.length; a++) {
          var n = r[a],
            i = n[0] || {},
            l = i.trace || {},
            o = l._module || {},
            s = o.arraysToCalcdata;
          s && s(n, l);
          var u = o.editStyle;
          u && t.push({
            fn: u,
            cd0: i
          });
        }
        if (t.length) {
          for (a = 0; a < t.length; a++) {
            var f = t[a];
            f.fn(e, f.cd0);
          }
          Wy(e), Qt.redrawReglTraces(e);
        }
        return cn.style(e), za.getComponentMethod("legend", "draw")(e), cn.previousPromises(e);
      };
      Qt.doColorBars = function (e) {
        return za.getComponentMethod("colorbar", "draw")(e), cn.previousPromises(e);
      };
      Qt.layoutReplot = function (e) {
        var r = e.layout;
        return e.layout = void 0, za.call("_doPlot", e, "", r);
      };
      Qt.doLegend = function (e) {
        return za.getComponentMethod("legend", "draw")(e), cn.previousPromises(e);
      };
      Qt.doTicksRelayout = function (e) {
        return Cf.draw(e, "redraw"), e._fullLayout._hasOnlyLargeSploms && (za.subplotsRegistry.splom.updateGrid(e), Wy(e), Qt.redrawReglTraces(e)), Qt.drawMainTitle(e), cn.previousPromises(e);
      };
      Qt.doModeBar = function (e) {
        var r = e._fullLayout;
        SM.manage(e);
        for (var t = 0; t < r._basePlotModules.length; t++) {
          var a = r._basePlotModules[t].updateFx;
          a && a(e);
        }
        return cn.previousPromises(e);
      };
      Qt.doCamera = function (e) {
        for (var r = e._fullLayout, t = r._subplots.gl3d, a = 0; a < t.length; a++) {
          var n = r[t[a]],
            i = n._scene;
          i.setViewport(n);
        }
      };
      Qt.drawData = function (e) {
        var r = e._fullLayout;
        Wy(e);
        for (var t = r._basePlotModules, a = 0; a < t.length; a++) t[a].plot(e);
        return Qt.redrawReglTraces(e), cn.style(e), za.getComponentMethod("selections", "draw")(e), za.getComponentMethod("shapes", "draw")(e), za.getComponentMethod("annotations", "draw")(e), za.getComponentMethod("images", "draw")(e), r._replotting = !1, cn.previousPromises(e);
      };
      Qt.redrawReglTraces = function (e) {
        var r = e._fullLayout;
        if (r._has("regl")) {
          var t = e._fullData,
            a = [],
            n = [],
            i,
            l;
          for (r._hasOnlyLargeSploms && r._splomGrid.draw(), i = 0; i < t.length; i++) {
            var o = t[i];
            o.visible === !0 && o._length !== 0 && (o.type === "splom" ? r._splomScenes[o.uid].draw() : o.type === "scattergl" ? Sn.pushUnique(a, o.xaxis + o.yaxis) : o.type === "scatterpolargl" && Sn.pushUnique(n, o.subplot));
          }
          for (i = 0; i < a.length; i++) l = r._plots[a[i]], l._scene && l._scene.draw();
          for (i = 0; i < n.length; i++) l = r[n[i]]._subplot, l._scene && l._scene.draw();
        }
      };
      Qt.doAutoRangeAndConstraints = function (e) {
        for (var r = Cf.list(e, "", !0), t, a = {}, n = 0; n < r.length; n++) if (t = r[n], !a[t._id]) {
          a[t._id] = 1, rX(e, t), MM(e, t);
          var i = t._matchGroup;
          if (i) for (var l in i) {
            var o = Cf.getFromId(e, l);
            MM(e, o, t.range), a[l] = 1;
          }
        }
        eX(e);
      };
      Qt.finalDraw = function (e) {
        za.getComponentMethod("rangeslider", "draw")(e), za.getComponentMethod("rangeselector", "draw")(e);
      };
      Qt.drawMarginPushers = function (e) {
        za.getComponentMethod("legend", "draw")(e), za.getComponentMethod("rangeselector", "draw")(e), za.getComponentMethod("sliders", "draw")(e), za.getComponentMethod("updatemenus", "draw")(e), za.getComponentMethod("colorbar", "draw")(e);
      };
    });
    var Jy = Z((Jse, NM) => {
      "use strict";

      var dX = Tl().readPaths,
        pX = uh(),
        EM = pl().clearOutlineControllers,
        Zy = Er(),
        PM = tt(),
        mX = ct().arrayEditor,
        RM = Al(),
        yX = RM.getPathString;
      NM.exports = {
        draw: _h,
        drawOne: zM,
        activateLastSelection: xX
      };
      function _h(e) {
        var r = e._fullLayout;
        EM(e), r._selectionLayer.selectAll("path").remove();
        for (var t in r._plots) {
          var a = r._plots[t].selectionLayer;
          a && a.selectAll("path").remove();
        }
        for (var n = 0; n < r.selections.length; n++) zM(e, n);
      }
      function wh(e) {
        return e._context.editSelection;
      }
      function zM(e, r) {
        e._fullLayout._paperdiv.selectAll('.selectionlayer [data-index="' + r + '"]').remove();
        var t = RM.makeSelectionsOptionsAndPlotinfo(e, r),
          a = t.options,
          n = t.plotinfo;
        if (!a._input) return;
        i(e._fullLayout._selectionLayer);
        function i(l) {
          var o = yX(e, a),
            s = {
              "data-index": r,
              "fill-rule": "evenodd",
              d: o
            },
            u = a.opacity,
            f = "rgba(0,0,0,0)",
            v = a.line.color || Zy.contrast(e._fullLayout.plot_bgcolor),
            h = a.line.width,
            d = a.line.dash;
          h || (h = 5, d = "solid");
          var y = wh(e) && e._fullLayout._activeSelectionIndex === r;
          y && (f = e._fullLayout.activeselection.fillcolor, u = e._fullLayout.activeselection.opacity);
          for (var g = [], m = 1; m >= 0; m--) {
            var _ = l.append("path").attr(s).style("opacity", m ? .1 : u).call(Zy.stroke, v).call(Zy.fill, f).call(PM.dashLine, m ? "solid" : d, m ? 4 + h : h);
            if (gX(_, e, a), y) {
              var w = mX(e.layout, "selections", a);
              _.style({
                cursor: "move"
              });
              var T = {
                  element: _.node(),
                  plotinfo: n,
                  gd: e,
                  editHelpers: w,
                  isActiveSelection: !0
                },
                b = dX(o, e);
              pX(b, _, T);
            } else _.style("pointer-events", m ? "all" : "none");
            g[m] = _;
          }
          var A = g[0],
            S = g[1];
          S.node().addEventListener("click", function () {
            return bX(e, A);
          });
        }
      }
      function gX(e, r, t) {
        var a = t.xref + t.yref;
        PM.setClipUrl(e, "clip" + r._fullLayout._uid + a, r);
      }
      function bX(e, r) {
        if (wh(e)) {
          var t = r.node(),
            a = +t.getAttribute("data-index");
          if (a >= 0) {
            if (a === e._fullLayout._activeSelectionIndex) {
              Xy(e);
              return;
            }
            e._fullLayout._activeSelectionIndex = a, e._fullLayout._deactivateSelection = Xy, _h(e);
          }
        }
      }
      function xX(e) {
        if (wh(e)) {
          var r = e._fullLayout.selections.length - 1;
          e._fullLayout._activeSelectionIndex = r, e._fullLayout._deactivateSelection = Xy, _h(e);
        }
      }
      function Xy(e) {
        if (wh(e)) {
          var r = e._fullLayout._activeSelectionIndex;
          r >= 0 && (EM(e), delete e._fullLayout._activeSelectionIndex, _h(e));
        }
      }
    });
    var IM = Z((Kse, FM) => {
      function _X() {
        var e,
          r = 0,
          t = !1;
        function a(n, i) {
          return e.list.push({
            type: n,
            data: i ? JSON.parse(JSON.stringify(i)) : void 0
          }), e;
        }
        return e = {
          list: [],
          segmentId: function () {
            return r++;
          },
          checkIntersection: function (n, i) {
            return a("check", {
              seg1: n,
              seg2: i
            });
          },
          segmentChop: function (n, i) {
            return a("div_seg", {
              seg: n,
              pt: i
            }), a("chop", {
              seg: n,
              pt: i
            });
          },
          statusRemove: function (n) {
            return a("pop_seg", {
              seg: n
            });
          },
          segmentUpdate: function (n) {
            return a("seg_update", {
              seg: n
            });
          },
          segmentNew: function (n, i) {
            return a("new_seg", {
              seg: n,
              primary: i
            });
          },
          segmentRemove: function (n) {
            return a("rem_seg", {
              seg: n
            });
          },
          tempStatus: function (n, i, l) {
            return a("temp_status", {
              seg: n,
              above: i,
              below: l
            });
          },
          rewind: function (n) {
            return a("rewind", {
              seg: n
            });
          },
          status: function (n, i, l) {
            return a("status", {
              seg: n,
              above: i,
              below: l
            });
          },
          vert: function (n) {
            return n === t ? e : (t = n, a("vert", {
              x: n
            }));
          },
          log: function (n) {
            return typeof n != "string" && (n = JSON.stringify(n, !1, "  ")), a("log", {
              txt: n
            });
          },
          reset: function () {
            return a("reset");
          },
          selected: function (n) {
            return a("selected", {
              segs: n
            });
          },
          chainStart: function (n) {
            return a("chain_start", {
              seg: n
            });
          },
          chainRemoveHead: function (n, i) {
            return a("chain_rem_head", {
              index: n,
              pt: i
            });
          },
          chainRemoveTail: function (n, i) {
            return a("chain_rem_tail", {
              index: n,
              pt: i
            });
          },
          chainNew: function (n, i) {
            return a("chain_new", {
              pt1: n,
              pt2: i
            });
          },
          chainMatch: function (n) {
            return a("chain_match", {
              index: n
            });
          },
          chainClose: function (n) {
            return a("chain_close", {
              index: n
            });
          },
          chainAddHead: function (n, i) {
            return a("chain_add_head", {
              index: n,
              pt: i
            });
          },
          chainAddTail: function (n, i) {
            return a("chain_add_tail", {
              index: n,
              pt: i
            });
          },
          chainConnect: function (n, i) {
            return a("chain_con", {
              index1: n,
              index2: i
            });
          },
          chainReverse: function (n) {
            return a("chain_rev", {
              index: n
            });
          },
          chainJoin: function (n, i) {
            return a("chain_join", {
              index1: n,
              index2: i
            });
          },
          done: function () {
            return a("done");
          }
        }, e;
      }
      FM.exports = _X;
    });
    var OM = Z((Qse, HM) => {
      function wX(e) {
        typeof e != "number" && (e = 1e-10);
        var r = {
          epsilon: function (t) {
            return typeof t == "number" && (e = t), e;
          },
          pointAboveOrOnLine: function (t, a, n) {
            var i = a[0],
              l = a[1],
              o = n[0],
              s = n[1],
              u = t[0],
              f = t[1];
            return (o - i) * (f - l) - (s - l) * (u - i) >= -e;
          },
          pointBetween: function (t, a, n) {
            var i = t[1] - a[1],
              l = n[0] - a[0],
              o = t[0] - a[0],
              s = n[1] - a[1],
              u = o * l + i * s;
            if (u < e) return !1;
            var f = l * l + s * s;
            return !(u - f > -e);
          },
          pointsSameX: function (t, a) {
            return Math.abs(t[0] - a[0]) < e;
          },
          pointsSameY: function (t, a) {
            return Math.abs(t[1] - a[1]) < e;
          },
          pointsSame: function (t, a) {
            return r.pointsSameX(t, a) && r.pointsSameY(t, a);
          },
          pointsCompare: function (t, a) {
            return r.pointsSameX(t, a) ? r.pointsSameY(t, a) ? 0 : t[1] < a[1] ? -1 : 1 : t[0] < a[0] ? -1 : 1;
          },
          pointsCollinear: function (t, a, n) {
            var i = t[0] - a[0],
              l = t[1] - a[1],
              o = a[0] - n[0],
              s = a[1] - n[1];
            return Math.abs(i * s - o * l) < e;
          },
          linesIntersect: function (t, a, n, i) {
            var l = a[0] - t[0],
              o = a[1] - t[1],
              s = i[0] - n[0],
              u = i[1] - n[1],
              f = l * u - o * s;
            if (Math.abs(f) < e) return !1;
            var v = t[0] - n[0],
              h = t[1] - n[1],
              d = (s * h - u * v) / f,
              y = (l * h - o * v) / f,
              g = {
                alongA: 0,
                alongB: 0,
                pt: [t[0] + d * l, t[1] + d * o]
              };
            return d <= -e ? g.alongA = -2 : d < e ? g.alongA = -1 : d - 1 <= -e ? g.alongA = 0 : d - 1 < e ? g.alongA = 1 : g.alongA = 2, y <= -e ? g.alongB = -2 : y < e ? g.alongB = -1 : y - 1 <= -e ? g.alongB = 0 : y - 1 < e ? g.alongB = 1 : g.alongB = 2, g;
          },
          pointInsideRegion: function (t, a) {
            for (var n = t[0], i = t[1], l = a[a.length - 1][0], o = a[a.length - 1][1], s = !1, u = 0; u < a.length; u++) {
              var f = a[u][0],
                v = a[u][1];
              v - i > e != o - i > e && (l - f) * (i - v) / (o - v) + f - n > e && (s = !s), l = f, o = v;
            }
            return s;
          }
        };
        return r;
      }
      HM.exports = wX;
    });
    var YM = Z(($se, BM) => {
      var TX = {
        create: function () {
          var e = {
            root: {
              root: !0,
              next: null
            },
            exists: function (r) {
              return !(r === null || r === e.root);
            },
            isEmpty: function () {
              return e.root.next === null;
            },
            getHead: function () {
              return e.root.next;
            },
            insertBefore: function (r, t) {
              for (var a = e.root, n = e.root.next; n !== null;) {
                if (t(n)) {
                  r.prev = n.prev, r.next = n, n.prev.next = r, n.prev = r;
                  return;
                }
                a = n, n = n.next;
              }
              a.next = r, r.prev = a, r.next = null;
            },
            findTransition: function (r) {
              for (var t = e.root, a = e.root.next; a !== null && !r(a);) t = a, a = a.next;
              return {
                before: t === e.root ? null : t,
                after: a,
                insert: function (n) {
                  return n.prev = t, n.next = a, t.next = n, a !== null && (a.prev = n), n;
                }
              };
            }
          };
          return e;
        },
        node: function (e) {
          return e.prev = null, e.next = null, e.remove = function () {
            e.prev.next = e.next, e.next && (e.next.prev = e.prev), e.prev = null, e.next = null;
          }, e;
        }
      };
      BM.exports = TX;
    });
    var GM = Z((jse, UM) => {
      var Sf = YM();
      function MX(e, r, t) {
        function a(y, g) {
          return {
            id: t ? t.segmentId() : -1,
            start: y,
            end: g,
            myFill: {
              above: null,
              below: null
            },
            otherFill: null
          };
        }
        function n(y, g, m) {
          return {
            id: t ? t.segmentId() : -1,
            start: y,
            end: g,
            myFill: {
              above: m.myFill.above,
              below: m.myFill.below
            },
            otherFill: null
          };
        }
        var i = Sf.create();
        function l(y, g, m, _, w, T) {
          var b = r.pointsCompare(g, w);
          return b !== 0 ? b : r.pointsSame(m, T) ? 0 : y !== _ ? y ? 1 : -1 : r.pointAboveOrOnLine(m, _ ? w : T, _ ? T : w) ? 1 : -1;
        }
        function o(y, g) {
          i.insertBefore(y, function (m) {
            var _ = l(y.isStart, y.pt, g, m.isStart, m.pt, m.other.pt);
            return _ < 0;
          });
        }
        function s(y, g) {
          var m = Sf.node({
            isStart: !0,
            pt: y.start,
            seg: y,
            primary: g,
            other: null,
            status: null
          });
          return o(m, y.end), m;
        }
        function u(y, g, m) {
          var _ = Sf.node({
            isStart: !1,
            pt: g.end,
            seg: g,
            primary: m,
            other: y,
            status: null
          });
          y.other = _, o(_, y.pt);
        }
        function f(y, g) {
          var m = s(y, g);
          return u(m, y, g), m;
        }
        function v(y, g) {
          t && t.segmentChop(y.seg, g), y.other.remove(), y.seg.end = g, y.other.pt = g, o(y.other, y.pt);
        }
        function h(y, g) {
          var m = n(g, y.seg.end, y.seg);
          return v(y, g), f(m, y.primary);
        }
        function d(y, g) {
          var m = Sf.create();
          function _(J, X) {
            var B = J.seg.start,
              I = J.seg.end,
              V = X.seg.start,
              K = X.seg.end;
            return r.pointsCollinear(B, V, K) ? r.pointsCollinear(I, V, K) || r.pointAboveOrOnLine(I, V, K) ? 1 : -1 : r.pointAboveOrOnLine(B, V, K) ? 1 : -1;
          }
          function w(J) {
            return m.findTransition(function (X) {
              var B = _(J, X.ev);
              return B > 0;
            });
          }
          function T(J, X) {
            var B = J.seg,
              I = X.seg,
              V = B.start,
              K = B.end,
              Q = I.start,
              ie = I.end;
            t && t.checkIntersection(B, I);
            var me = r.linesIntersect(V, K, Q, ie);
            if (me === !1) {
              if (!r.pointsCollinear(V, K, Q) || r.pointsSame(V, ie) || r.pointsSame(K, Q)) return !1;
              var pe = r.pointsSame(V, Q),
                ge = r.pointsSame(K, ie);
              if (pe && ge) return X;
              var j = !pe && r.pointBetween(V, Q, ie),
                _e = !ge && r.pointBetween(K, Q, ie);
              if (pe) return _e ? h(X, K) : h(J, ie), X;
              j && (ge || (_e ? h(X, K) : h(J, ie)), h(X, V));
            } else me.alongA === 0 && (me.alongB === -1 ? h(J, Q) : me.alongB === 0 ? h(J, me.pt) : me.alongB === 1 && h(J, ie)), me.alongB === 0 && (me.alongA === -1 ? h(X, V) : me.alongA === 0 ? h(X, me.pt) : me.alongA === 1 && h(X, K));
            return !1;
          }
          for (var b = []; !i.isEmpty();) {
            var A = i.getHead();
            if (t && t.vert(A.pt[0]), A.isStart) {
              let J = function () {
                if (k) {
                  var X = T(A, k);
                  if (X) return X;
                }
                return q ? T(A, q) : !1;
              };
              var O = J;
              t && t.segmentNew(A.seg, A.primary);
              var S = w(A),
                k = S.before ? S.before.ev : null,
                q = S.after ? S.after.ev : null;
              t && t.tempStatus(A.seg, k ? k.seg : !1, q ? q.seg : !1);
              var D = J();
              if (D) {
                if (e) {
                  var R;
                  A.seg.myFill.below === null ? R = !0 : R = A.seg.myFill.above !== A.seg.myFill.below, R && (D.seg.myFill.above = !D.seg.myFill.above);
                } else D.seg.otherFill = A.seg.myFill;
                t && t.segmentUpdate(D.seg), A.other.remove(), A.remove();
              }
              if (i.getHead() !== A) {
                t && t.rewind(A.seg);
                continue;
              }
              if (e) {
                var R;
                A.seg.myFill.below === null ? R = !0 : R = A.seg.myFill.above !== A.seg.myFill.below, q ? A.seg.myFill.below = q.seg.myFill.above : A.seg.myFill.below = y, R ? A.seg.myFill.above = !A.seg.myFill.below : A.seg.myFill.above = A.seg.myFill.below;
              } else if (A.seg.otherFill === null) {
                var z;
                q ? A.primary === q.primary ? z = q.seg.otherFill.above : z = q.seg.myFill.above : z = A.primary ? g : y, A.seg.otherFill = {
                  above: z,
                  below: z
                };
              }
              t && t.status(A.seg, k ? k.seg : !1, q ? q.seg : !1), A.other.status = S.insert(Sf.node({
                ev: A
              }));
            } else {
              var N = A.status;
              if (N === null) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
              if (m.exists(N.prev) && m.exists(N.next) && T(N.prev.ev, N.next.ev), t && t.statusRemove(N.ev.seg), N.remove(), !A.primary) {
                var H = A.seg.myFill;
                A.seg.myFill = A.seg.otherFill, A.seg.otherFill = H;
              }
              b.push(A.seg);
            }
            i.getHead().remove();
          }
          return t && t.done(), b;
        }
        return e ? {
          addRegion: function (y) {
            for (var g, m = y[y.length - 1], _ = 0; _ < y.length; _++) {
              g = m, m = y[_];
              var w = r.pointsCompare(g, m);
              w !== 0 && f(a(w < 0 ? g : m, w < 0 ? m : g), !0);
            }
          },
          calculate: function (y) {
            return d(y, !1);
          }
        } : {
          calculate: function (y, g, m, _) {
            return y.forEach(function (w) {
              f(n(w.start, w.end, w), !0);
            }), m.forEach(function (w) {
              f(n(w.start, w.end, w), !1);
            }), d(g, _);
          }
        };
      }
      UM.exports = MX;
    });
    var WM = Z((eue, VM) => {
      function AX(e, r, t) {
        var a = [],
          n = [];
        return e.forEach(function (i) {
          var l = i.start,
            o = i.end;
          if (r.pointsSame(l, o)) {
            console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");
            return;
          }
          t && t.chainStart(i);
          var s = {
              index: 0,
              matches_head: !1,
              matches_pt1: !1
            },
            u = {
              index: 0,
              matches_head: !1,
              matches_pt1: !1
            },
            f = s;
          function v(O, J, X) {
            return f.index = O, f.matches_head = J, f.matches_pt1 = X, f === s ? (f = u, !1) : (f = null, !0);
          }
          for (var h = 0; h < a.length; h++) {
            var d = a[h],
              y = d[0],
              g = d[1],
              m = d[d.length - 1],
              _ = d[d.length - 2];
            if (r.pointsSame(y, l)) {
              if (v(h, !0, !0)) break;
            } else if (r.pointsSame(y, o)) {
              if (v(h, !0, !1)) break;
            } else if (r.pointsSame(m, l)) {
              if (v(h, !1, !0)) break;
            } else if (r.pointsSame(m, o) && v(h, !1, !1)) break;
          }
          if (f === s) {
            a.push([l, o]), t && t.chainNew(l, o);
            return;
          }
          if (f === u) {
            t && t.chainMatch(s.index);
            var w = s.index,
              T = s.matches_pt1 ? o : l,
              b = s.matches_head,
              d = a[w],
              A = b ? d[0] : d[d.length - 1],
              S = b ? d[1] : d[d.length - 2],
              k = b ? d[d.length - 1] : d[0],
              q = b ? d[d.length - 2] : d[1];
            if (r.pointsCollinear(S, A, T) && (b ? (t && t.chainRemoveHead(s.index, T), d.shift()) : (t && t.chainRemoveTail(s.index, T), d.pop()), A = S), r.pointsSame(k, T)) {
              a.splice(w, 1), r.pointsCollinear(q, k, A) && (b ? (t && t.chainRemoveTail(s.index, A), d.pop()) : (t && t.chainRemoveHead(s.index, A), d.shift())), t && t.chainClose(s.index), n.push(d);
              return;
            }
            b ? (t && t.chainAddHead(s.index, T), d.unshift(T)) : (t && t.chainAddTail(s.index, T), d.push(T));
            return;
          }
          function D(O) {
            t && t.chainReverse(O), a[O].reverse();
          }
          function R(O, J) {
            var X = a[O],
              B = a[J],
              I = X[X.length - 1],
              V = X[X.length - 2],
              K = B[0],
              Q = B[1];
            r.pointsCollinear(V, I, K) && (t && t.chainRemoveTail(O, I), X.pop(), I = V), r.pointsCollinear(I, K, Q) && (t && t.chainRemoveHead(J, K), B.shift()), t && t.chainJoin(O, J), a[O] = X.concat(B), a.splice(J, 1);
          }
          var z = s.index,
            N = u.index;
          t && t.chainConnect(z, N);
          var H = a[z].length < a[N].length;
          s.matches_head ? u.matches_head ? H ? (D(z), R(z, N)) : (D(N), R(N, z)) : R(N, z) : u.matches_head ? R(z, N) : H ? (D(z), R(N, z)) : (D(N), R(z, N));
        }), n;
      }
      VM.exports = AX;
    });
    var XM = Z((rue, ZM) => {
      function Lf(e, r, t) {
        var a = [];
        return e.forEach(function (n) {
          var i = (n.myFill.above ? 8 : 0) + (n.myFill.below ? 4 : 0) + (n.otherFill && n.otherFill.above ? 2 : 0) + (n.otherFill && n.otherFill.below ? 1 : 0);
          r[i] !== 0 && a.push({
            id: t ? t.segmentId() : -1,
            start: n.start,
            end: n.end,
            myFill: {
              above: r[i] === 1,
              below: r[i] === 2
            },
            otherFill: null
          });
        }), t && t.selected(a), a;
      }
      var kX = {
        union: function (e, r) {
          return Lf(e, [0, 2, 1, 0, 2, 2, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0], r);
        },
        intersect: function (e, r) {
          return Lf(e, [0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 1, 1, 0, 2, 1, 0], r);
        },
        difference: function (e, r) {
          return Lf(e, [0, 0, 0, 0, 2, 0, 2, 0, 1, 1, 0, 0, 0, 1, 2, 0], r);
        },
        differenceRev: function (e, r) {
          return Lf(e, [0, 2, 1, 0, 0, 0, 1, 1, 0, 2, 0, 2, 0, 0, 0, 0], r);
        },
        xor: function (e, r) {
          return Lf(e, [0, 2, 1, 0, 2, 0, 0, 1, 1, 0, 0, 2, 0, 1, 2, 0], r);
        }
      };
      ZM.exports = kX;
    });
    var KM = Z((tue, JM) => {
      var CX = {
        toPolygon: function (e, r) {
          function t(i) {
            if (i.length <= 0) return e.segments({
              inverted: !1,
              regions: []
            });
            function l(u) {
              var f = u.slice(0, u.length - 1);
              return e.segments({
                inverted: !1,
                regions: [f]
              });
            }
            for (var o = l(i[0]), s = 1; s < i.length; s++) o = e.selectDifference(e.combine(o, l(i[s])));
            return o;
          }
          if (r.type === "Polygon") return e.polygon(t(r.coordinates));
          if (r.type === "MultiPolygon") {
            for (var a = e.segments({
                inverted: !1,
                regions: []
              }), n = 0; n < r.coordinates.length; n++) a = e.selectUnion(e.combine(a, t(r.coordinates[n])));
            return e.polygon(a);
          }
          throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
        },
        fromPolygon: function (e, r, t) {
          t = e.polygon(e.segments(t));
          function a(d, y) {
            return r.pointInsideRegion([(d[0][0] + d[1][0]) * .5, (d[0][1] + d[1][1]) * .5], y);
          }
          function n(d) {
            return {
              region: d,
              children: []
            };
          }
          var i = n(null);
          function l(d, y) {
            for (var g = 0; g < d.children.length; g++) {
              var m = d.children[g];
              if (a(y, m.region)) {
                l(m, y);
                return;
              }
            }
            for (var _ = n(y), g = 0; g < d.children.length; g++) {
              var m = d.children[g];
              a(m.region, y) && (_.children.push(m), d.children.splice(g, 1), g--);
            }
            d.children.push(_);
          }
          for (var o = 0; o < t.regions.length; o++) {
            var s = t.regions[o];
            s.length < 3 || l(i, s);
          }
          function u(d, y) {
            for (var g = 0, m = d[d.length - 1][0], _ = d[d.length - 1][1], w = [], T = 0; T < d.length; T++) {
              var b = d[T][0],
                A = d[T][1];
              w.push([b, A]), g += A * m - b * _, m = b, _ = A;
            }
            var S = g < 0;
            return S !== y && w.reverse(), w.push([w[0][0], w[0][1]]), w;
          }
          var f = [];
          function v(d) {
            var y = [u(d.region, !1)];
            f.push(y);
            for (var g = 0; g < d.children.length; g++) y.push(h(d.children[g]));
          }
          function h(d) {
            for (var y = 0; y < d.children.length; y++) v(d.children[y]);
            return u(d.region, !0);
          }
          for (var o = 0; o < i.children.length; o++) v(i.children[o]);
          return f.length <= 0 ? {
            type: "Polygon",
            coordinates: []
          } : f.length == 1 ? {
            type: "Polygon",
            coordinates: f[0]
          } : {
            type: "MultiPolygon",
            coordinates: f
          };
        }
      };
      JM.exports = CX;
    });
    var eA = Z((aue, jM) => {
      var SX = IM(),
        LX = OM(),
        QM = GM(),
        qX = WM(),
        qf = XM(),
        $M = KM(),
        Ln = !1,
        Df = LX(),
        ja;
      ja = {
        buildLog: function (e) {
          return e === !0 ? Ln = SX() : e === !1 && (Ln = !1), Ln === !1 ? !1 : Ln.list;
        },
        epsilon: function (e) {
          return Df.epsilon(e);
        },
        segments: function (e) {
          var r = QM(!0, Df, Ln);
          return e.regions.forEach(r.addRegion), {
            segments: r.calculate(e.inverted),
            inverted: e.inverted
          };
        },
        combine: function (e, r) {
          var t = QM(!1, Df, Ln);
          return {
            combined: t.calculate(e.segments, e.inverted, r.segments, r.inverted),
            inverted1: e.inverted,
            inverted2: r.inverted
          };
        },
        selectUnion: function (e) {
          return {
            segments: qf.union(e.combined, Ln),
            inverted: e.inverted1 || e.inverted2
          };
        },
        selectIntersect: function (e) {
          return {
            segments: qf.intersect(e.combined, Ln),
            inverted: e.inverted1 && e.inverted2
          };
        },
        selectDifference: function (e) {
          return {
            segments: qf.difference(e.combined, Ln),
            inverted: e.inverted1 && !e.inverted2
          };
        },
        selectDifferenceRev: function (e) {
          return {
            segments: qf.differenceRev(e.combined, Ln),
            inverted: !e.inverted1 && e.inverted2
          };
        },
        selectXor: function (e) {
          return {
            segments: qf.xor(e.combined, Ln),
            inverted: e.inverted1 !== e.inverted2
          };
        },
        polygon: function (e) {
          return {
            regions: qX(e.segments, Df, Ln),
            inverted: e.inverted
          };
        },
        polygonFromGeoJSON: function (e) {
          return $M.toPolygon(ja, e);
        },
        polygonToGeoJSON: function (e) {
          return $M.fromPolygon(ja, Df, e);
        },
        union: function (e, r) {
          return Ef(e, r, ja.selectUnion);
        },
        intersect: function (e, r) {
          return Ef(e, r, ja.selectIntersect);
        },
        difference: function (e, r) {
          return Ef(e, r, ja.selectDifference);
        },
        differenceRev: function (e, r) {
          return Ef(e, r, ja.selectDifferenceRev);
        },
        xor: function (e, r) {
          return Ef(e, r, ja.selectXor);
        }
      };
      function Ef(e, r, t) {
        var a = ja.segments(e),
          n = ja.segments(r),
          i = ja.combine(a, n),
          l = t(i);
        return ja.polygon(l);
      }
      typeof window == "object" && (window.PolyBool = ja);
      jM.exports = ja;
    });
    var tA = Z((nue, rA) => {
      rA.exports = function (r, t, a, n) {
        var i = r[0],
          l = r[1],
          o = !1;
        a === void 0 && (a = 0), n === void 0 && (n = t.length);
        for (var s = n - a, u = 0, f = s - 1; u < s; f = u++) {
          var v = t[u + a][0],
            h = t[u + a][1],
            d = t[f + a][0],
            y = t[f + a][1],
            g = h > l != y > l && i < (d - v) * (l - h) / (y - h) + v;
          g && (o = !o);
        }
        return o;
      };
    });
    var Qy = Z((iue, aA) => {
      "use strict";

      var Ky = wv().dot,
        Th = Bt().BADNUM,
        Mh = aA.exports = {};
      Mh.tester = function (r) {
        var t = r.slice(),
          a = t[0][0],
          n = a,
          i = t[0][1],
          l = i,
          o;
        for ((t[t.length - 1][0] !== t[0][0] || t[t.length - 1][1] !== t[0][1]) && t.push(t[0]), o = 1; o < t.length; o++) a = Math.min(a, t[o][0]), n = Math.max(n, t[o][0]), i = Math.min(i, t[o][1]), l = Math.max(l, t[o][1]);
        var s = !1,
          u;
        t.length === 5 && (t[0][0] === t[1][0] ? t[2][0] === t[3][0] && t[0][1] === t[3][1] && t[1][1] === t[2][1] && (s = !0, u = function (y) {
          return y[0] === t[0][0];
        }) : t[0][1] === t[1][1] && t[2][1] === t[3][1] && t[0][0] === t[3][0] && t[1][0] === t[2][0] && (s = !0, u = function (y) {
          return y[1] === t[0][1];
        }));
        function f(y, g) {
          var m = y[0],
            _ = y[1];
          return !(m === Th || m < a || m > n || _ === Th || _ < i || _ > l || g && u(y));
        }
        function v(y, g) {
          var m = y[0],
            _ = y[1];
          if (m === Th || m < a || m > n || _ === Th || _ < i || _ > l) return !1;
          var w = t.length,
            T = t[0][0],
            b = t[0][1],
            A = 0,
            S,
            k,
            q,
            D,
            R;
          for (S = 1; S < w; S++) if (k = T, q = b, T = t[S][0], b = t[S][1], D = Math.min(k, T), !(m < D || m > Math.max(k, T) || _ > Math.max(q, b))) if (_ < Math.min(q, b)) m !== D && A++;else {
            if (T === k ? R = _ : R = q + (m - k) * (b - q) / (T - k), _ === R) return !(S === 1 && g);
            _ <= R && m !== D && A++;
          }
          return A % 2 === 1;
        }
        var h = !0,
          d = t[0];
        for (o = 1; o < t.length; o++) if (d[0] !== t[o][0] || d[1] !== t[o][1]) {
          h = !1;
          break;
        }
        return {
          xmin: a,
          xmax: n,
          ymin: i,
          ymax: l,
          pts: t,
          contains: s ? f : v,
          isRect: s,
          degenerate: h
        };
      };
      Mh.isSegmentBent = function (r, t, a, n) {
        var i = r[t],
          l = [r[a][0] - i[0], r[a][1] - i[1]],
          o = Ky(l, l),
          s = Math.sqrt(o),
          u = [-l[1] / s, l[0] / s],
          f,
          v,
          h;
        for (f = t + 1; f < a; f++) if (v = [r[f][0] - i[0], r[f][1] - i[1]], h = Ky(v, l), h < 0 || h > o || Math.abs(Ky(v, u)) > n) return !0;
        return !1;
      };
      Mh.filter = function (r, t) {
        var a = [r[0]],
          n = 0,
          i = 0;
        function l(s) {
          r.push(s);
          var u = a.length,
            f = n;
          a.splice(i + 1);
          for (var v = f + 1; v < r.length; v++) (v === r.length - 1 || Mh.isSegmentBent(r, f, v + 1, t)) && (a.push(r[v]), a.length < u - 2 && (n = v, i = a.length - 1), f = v);
        }
        if (r.length > 1) {
          var o = r.pop();
          l(o);
        }
        return {
          addPt: l,
          raw: r,
          filtered: a
        };
      };
    });
    var iA = Z((lue, nA) => {
      "use strict";

      nA.exports = {
        BENDPX: 1.5,
        MINSELECT: 12,
        SELECTDELAY: 100,
        SELECTID: "-select"
      };
    });
    var CA = Z((oue, kA) => {
      "use strict";

      var lA = eA(),
        DX = tA(),
        zf = gr(),
        EX = tt().dashStyle,
        Pf = Er(),
        PX = ki(),
        RX = bi().makeEventData,
        Of = Vs(),
        zX = Of.freeMode,
        NX = Of.rectMode,
        Nf = Of.drawMode,
        rg = Of.openMode,
        tg = Of.selectMode,
        oA = Al(),
        sA = _f(),
        hA = uh(),
        dA = pl().clearOutline,
        pA = Tl(),
        $y = pA.handleEllipse,
        FX = pA.readPaths,
        IX = ih().newShapes,
        HX = My(),
        OX = Jy().activateLastSelection,
        kh = He(),
        BX = kh.sorterAsc,
        mA = Qy(),
        Rf = zv(),
        qn = Xt().getFromId,
        YX = Q0(),
        UX = xh().redrawReglTraces,
        Ch = iA(),
        Si = Ch.MINSELECT,
        GX = mA.filter,
        ag = mA.tester,
        ng = rh(),
        uA = ng.p2r,
        VX = ng.axValue,
        WX = ng.getTransform;
      function ig(e) {
        return e.subplot !== void 0;
      }
      function ZX(e, r, t, a, n) {
        var i = !ig(a),
          l = zX(n),
          o = NX(n),
          s = rg(n),
          u = Nf(n),
          f = tg(n),
          v = n === "drawline",
          h = n === "drawcircle",
          d = v || h,
          y = a.gd,
          g = y._fullLayout,
          m = f && g.newselection.mode === "immediate" && i,
          _ = g._zoomlayer,
          w = a.element.getBoundingClientRect(),
          T = a.plotinfo,
          b = WX(T),
          A = r - w.left,
          S = t - w.top;
        g._calcInverseTransform(y);
        var k = kh.apply3DTransform(g._invTransform)(A, S);
        A = k[0], S = k[1];
        var q = g._invScaleX,
          D = g._invScaleY,
          R = A,
          z = S,
          N = "M" + A + "," + S,
          H = a.xaxes[0],
          O = a.yaxes[0],
          J = H._length,
          X = O._length,
          B = e.altKey && !(Nf(n) && s),
          I,
          V,
          K,
          Q,
          ie,
          me,
          pe;
        gA(e, y, a), l && (I = GX([[A, S]], Ch.BENDPX));
        var ge = _.selectAll("path.select-outline-" + T.id).data([1]),
          j = u ? g.newshape : g.newselection;
        u && (a.hasText = j.label.text || j.label.texttemplate);
        var _e = u && !s ? j.fillcolor : "rgba(0,0,0,0)",
          se = j.line.color || (i ? Pf.contrast(y._fullLayout.plot_bgcolor) : "#7f7f7f");
        ge.enter().append("path").attr("class", "select-outline select-outline-" + T.id).style({
          opacity: u ? j.opacity / 2 : 1,
          "stroke-dasharray": EX(j.line.dash, j.line.width),
          "stroke-width": j.line.width + "px",
          "shape-rendering": "crispEdges"
        }).call(Pf.stroke, se).call(Pf.fill, _e).attr("fill-rule", "evenodd").classed("cursor-move", !!u).attr("transform", b).attr("d", N + "Z");
        var Se = _.append("path").attr("class", "zoombox-corners").style({
          fill: Pf.background,
          stroke: Pf.defaultLine,
          "stroke-width": 1
        }).attr("transform", b).attr("d", "M0,0Z");
        if (u && a.hasText) {
          var ve = _.select(".label-temp");
          ve.empty() && (ve = _.append("g").classed("label-temp", !0).classed("select-outline", !0).style({
            opacity: .8
          }));
        }
        var Ae = g._uid + Ch.SELECTID,
          Y = [],
          re = Sh(y, a.xaxes, a.yaxes, a.subplot);
        m && !e.shiftKey && (a._clearSubplotSelections = function () {
          if (i) {
            var de = H._id,
              be = O._id;
            TA(y, de, be, re);
            for (var ye = (y.layout || {}).selections || [], Fe = [], Re = !1, Pe = 0; Pe < ye.length; Pe++) {
              var Ie = g.selections[Pe];
              !Ie || Ie.xref !== de || Ie.yref !== be ? Fe.push(ye[Pe]) : Re = !0;
            }
            Re && (y._fullLayout._noEmitSelectedAtStart = !0, zf.call("_guiRelayout", y, {
              selections: Fe
            }));
          }
        });
        var U = oJ(a);
        a.moveFn = function (de, be) {
          a._clearSubplotSelections && (a._clearSubplotSelections(), a._clearSubplotSelections = void 0), R = Math.max(0, Math.min(J, q * de + A)), z = Math.max(0, Math.min(X, D * be + S));
          var ye = Math.abs(R - A),
            Fe = Math.abs(z - S);
          if (o) {
            var Re, Pe, Ie;
            if (f) {
              var Be = g.selectdirection;
              switch (Be === "any" ? Fe < Math.min(ye * .6, Si) ? Re = "h" : ye < Math.min(Fe * .6, Si) ? Re = "v" : Re = "d" : Re = Be, Re) {
                case "h":
                  Pe = h ? X / 2 : 0, Ie = X;
                  break;
                case "v":
                  Pe = h ? J / 2 : 0, Ie = J;
                  break;
              }
            }
            if (u) switch (g.newshape.drawdirection) {
              case "vertical":
                Re = "h", Pe = h ? X / 2 : 0, Ie = X;
                break;
              case "horizontal":
                Re = "v", Pe = h ? J / 2 : 0, Ie = J;
                break;
              case "ortho":
                ye < Fe ? (Re = "h", Pe = S, Ie = z) : (Re = "v", Pe = A, Ie = R);
                break;
              default:
                Re = "d";
            }
            Re === "h" ? (Q = d ? $y(h, [R, Pe], [R, Ie]) : [[A, Pe], [A, Ie], [R, Ie], [R, Pe]], Q.xmin = d ? R : Math.min(A, R), Q.xmax = d ? R : Math.max(A, R), Q.ymin = Math.min(Pe, Ie), Q.ymax = Math.max(Pe, Ie), Se.attr("d", "M" + Q.xmin + "," + (S - Si) + "h-4v" + 2 * Si + "h4ZM" + (Q.xmax - 1) + "," + (S - Si) + "h4v" + 2 * Si + "h-4Z")) : Re === "v" ? (Q = d ? $y(h, [Pe, z], [Ie, z]) : [[Pe, S], [Pe, z], [Ie, z], [Ie, S]], Q.xmin = Math.min(Pe, Ie), Q.xmax = Math.max(Pe, Ie), Q.ymin = d ? z : Math.min(S, z), Q.ymax = d ? z : Math.max(S, z), Se.attr("d", "M" + (A - Si) + "," + Q.ymin + "v-4h" + 2 * Si + "v4ZM" + (A - Si) + "," + (Q.ymax - 1) + "v4h" + 2 * Si + "v-4Z")) : Re === "d" && (Q = d ? $y(h, [A, S], [R, z]) : [[A, S], [A, z], [R, z], [R, S]], Q.xmin = Math.min(A, R), Q.xmax = Math.max(A, R), Q.ymin = Math.min(S, z), Q.ymax = Math.max(S, z), Se.attr("d", "M0,0Z"));
          } else l && (I.addPt([R, z]), Q = I.filtered);
          if (a.selectionDefs && a.selectionDefs.length ? (K = bA(a.mergedPolygons, Q, B), Q.subtract = B, V = lg(a.selectionDefs.concat([Q]))) : (K = [Q], V = ag(Q)), hA(_A(K, s), ge, a), f) {
            var Ne = eg(y, !1),
              Ee = Ne.eventData ? Ne.eventData.points.slice() : [];
            Ne = eg(y, !1, V, re, a), V = Ne.selectionTesters, pe = Ne.eventData;
            var Je;
            I ? Je = I.filtered : Je = MA(K), Rf.throttle(Ae, Ch.SELECTDELAY, function () {
              Y = wA(V, re);
              for (var We = Y.slice(), ne = 0; ne < Ee.length; ne++) {
                for (var Me = Ee[ne], Ce = !1, cr = 0; cr < We.length; cr++) if (We[cr].curveNumber === Me.curveNumber && We[cr].pointNumber === Me.pointNumber) {
                  Ce = !0;
                  break;
                }
                Ce || We.push(Me);
              }
              We.length && (pe || (pe = {}), pe.points = We), U(pe, Je), sJ(y, pe);
            });
          }
        }, a.clickFn = function (de, be) {
          if (Se.remove(), y._fullLayout._activeShapeIndex >= 0) {
            y._fullLayout._deactivateShape(y);
            return;
          }
          if (!u) {
            var ye = g.clickmode;
            Rf.done(Ae).then(function () {
              if (Rf.clear(Ae), de === 2) {
                for (ge.remove(), ie = 0; ie < re.length; ie++) me = re[ie], me._module.selectPoints(me, !1);
                if (If(y, re), Ff(a), sg(y), re.length) {
                  var Fe = re[0].xaxis,
                    Re = re[0].yaxis;
                  if (Fe && Re) {
                    for (var Pe = [], Ie = y._fullLayout.selections, Be = 0; Be < Ie.length; Be++) {
                      var Ne = Ie[Be];
                      Ne && (Ne.xref !== Fe._id || Ne.yref !== Re._id) && Pe.push(Ne);
                    }
                    Pe.length < Ie.length && (y._fullLayout._noEmitSelectedAtStart = !0, zf.call("_guiRelayout", y, {
                      selections: Pe
                    }));
                  }
                }
              } else ye.indexOf("select") > -1 && yA(be, y, a.xaxes, a.yaxes, a.subplot, a, ge), ye === "event" && Hf(y, void 0);
              PX.click(y, be, T.id);
            }).catch(kh.error);
          }
        }, a.doneFn = function () {
          Se.remove(), Rf.done(Ae).then(function () {
            Rf.clear(Ae), !m && Q && a.selectionDefs && (Q.subtract = B, a.selectionDefs.push(Q), a.mergedPolygons.length = 0, [].push.apply(a.mergedPolygons, K)), (m || u) && Ff(a, m), a.doneFnCompleted && a.doneFnCompleted(Y), f && Hf(y, pe);
          }).catch(kh.error);
        };
      }
      function yA(e, r, t, a, n, i, l) {
        var o = r._hoverdata,
          s = r._fullLayout,
          u = s.clickmode,
          f = u.indexOf("event") > -1,
          v = [],
          h,
          d,
          y,
          g,
          m,
          _,
          w,
          T,
          b,
          A;
        if ($X(o)) {
          gA(e, r, i), h = Sh(r, t, a, n);
          var S = jX(o, h),
            k = S.pointNumbers.length > 0;
          if (k ? eJ(h, S) : rJ(h) && (w = cA(S))) {
            for (l && l.remove(), A = 0; A < h.length; A++) d = h[A], d._module.selectPoints(d, !1);
            If(r, h), Ff(i), f && sg(r);
          } else {
            T = e.shiftKey && (w !== void 0 ? w : cA(S)), y = XX(S.pointNumber, S.searchInfo, T);
            var q = i.selectionDefs.concat([y]);
            for (g = lg(q, g), A = 0; A < h.length; A++) if (m = h[A]._module.selectPoints(h[A], g), _ = xA(m, h[A]), v.length) for (var D = 0; D < _.length; D++) v.push(_[D]);else v = _;
            if (b = {
              points: v
            }, If(r, h, b), y && i && i.selectionDefs.push(y), l) {
              var R = i.mergedPolygons,
                z = rg(i.dragmode);
              hA(_A(R, z), l, i);
            }
            f && Hf(r, b);
          }
        }
      }
      function XX(e, r, t) {
        return {
          pointNumber: e,
          searchInfo: r,
          subtract: !!t
        };
      }
      function jy(e) {
        return "pointNumber" in e && "searchInfo" in e;
      }
      function JX(e) {
        return {
          xmin: 0,
          xmax: 0,
          ymin: 0,
          ymax: 0,
          pts: [],
          contains: function (r, t, a, n) {
            var i = e.searchInfo.cd[0].trace.index,
              l = n.cd[0].trace.index;
            return l === i && a === e.pointNumber;
          },
          isRect: !1,
          degenerate: !1,
          subtract: !!e.subtract
        };
      }
      function lg(e) {
        if (!e.length) return;
        for (var r = [], t = jy(e[0]) ? 0 : e[0][0][0], a = t, n = jy(e[0]) ? 0 : e[0][0][1], i = n, l = 0; l < e.length; l++) if (jy(e[l])) r.push(JX(e[l]));else {
          var o = ag(e[l]);
          o.subtract = !!e[l].subtract, r.push(o), t = Math.min(t, o.xmin), a = Math.max(a, o.xmax), n = Math.min(n, o.ymin), i = Math.max(i, o.ymax);
        }
        function s(u, f, v, h) {
          for (var d = !1, y = 0; y < r.length; y++) r[y].contains(u, f, v, h) && (d = !r[y].subtract);
          return d;
        }
        return {
          xmin: t,
          xmax: a,
          ymin: n,
          ymax: i,
          pts: [],
          contains: s,
          isRect: !1,
          degenerate: !1
        };
      }
      function gA(e, r, t) {
        var a = r._fullLayout,
          n = t.plotinfo,
          i = t.dragmode,
          l = a._lastSelectedSubplot && a._lastSelectedSubplot === n.id,
          o = (e.shiftKey || e.altKey) && !(Nf(i) && rg(i));
        l && o && n.selection && n.selection.selectionDefs && !t.selectionDefs ? (t.selectionDefs = n.selection.selectionDefs, t.mergedPolygons = n.selection.mergedPolygons) : (!o || !n.selection) && Ff(t), l || (dA(r), a._lastSelectedSubplot = n.id);
      }
      function KX(e) {
        return e._fullLayout._activeShapeIndex >= 0;
      }
      function QX(e) {
        return e._fullLayout._activeSelectionIndex >= 0;
      }
      function Ff(e, r) {
        var t = e.dragmode,
          a = e.plotinfo,
          n = e.gd;
        KX(n) && n._fullLayout._deactivateShape(n), QX(n) && n._fullLayout._deactivateSelection(n);
        var i = n._fullLayout,
          l = i._zoomlayer,
          o = Nf(t),
          s = tg(t);
        if (o || s) {
          var u = l.selectAll(".select-outline-" + a.id);
          if (u && n._fullLayout._outlining) {
            var f;
            o && (f = IX(u, e)), f && zf.call("_guiRelayout", n, {
              shapes: f
            });
            var v;
            s && !ig(e) && (v = HX(u, e)), v && (n._fullLayout._noEmitSelectedAtStart = !0, zf.call("_guiRelayout", n, {
              selections: v
            }).then(function () {
              r && OX(n);
            })), n._fullLayout._outlining = !1;
          }
        }
        a.selection = {}, a.selection.selectionDefs = e.selectionDefs = [], a.selection.mergedPolygons = e.mergedPolygons = [];
      }
      function fA(e) {
        return e._id;
      }
      function Sh(e, r, t, a) {
        if (!e.calcdata) return [];
        var n = [],
          i = r.map(fA),
          l = t.map(fA),
          o,
          s,
          u;
        for (u = 0; u < e.calcdata.length; u++) if (o = e.calcdata[u], s = o[0].trace, !(s.visible !== !0 || !s._module || !s._module.selectPoints)) if (ig({
          subplot: a
        }) && (s.subplot === a || s.geo === a)) n.push(Ah(s._module, o, r[0], t[0]));else if (s.type === "splom") {
          if (s._xaxes[i[0]] && s._yaxes[l[0]]) {
            var f = Ah(s._module, o, r[0], t[0]);
            f.scene = e._fullLayout._splomScenes[s.uid], n.push(f);
          }
        } else if (s.type === "sankey") {
          var v = Ah(s._module, o, r[0], t[0]);
          n.push(v);
        } else {
          if (i.indexOf(s.xaxis) === -1 && (!s._xA || !s._xA.overlaying) || l.indexOf(s.yaxis) === -1 && (!s._yA || !s._yA.overlaying)) continue;
          n.push(Ah(s._module, o, qn(e, s.xaxis), qn(e, s.yaxis)));
        }
        return n;
      }
      function Ah(e, r, t, a) {
        return {
          _module: e,
          cd: r,
          xaxis: t,
          yaxis: a
        };
      }
      function $X(e) {
        return e && Array.isArray(e) && e[0].hoverOnBox !== !0;
      }
      function jX(e, r) {
        var t = e[0],
          a = -1,
          n = [],
          i,
          l;
        for (l = 0; l < r.length; l++) if (i = r[l], t.fullData.index === i.cd[0].trace.index) {
          if (t.hoverOnBox === !0) break;
          t.pointNumber !== void 0 ? a = t.pointNumber : t.binNumber !== void 0 && (a = t.binNumber, n = t.pointNumbers);
          break;
        }
        return {
          pointNumber: a,
          pointNumbers: n,
          searchInfo: i
        };
      }
      function cA(e) {
        var r = e.searchInfo.cd[0].trace,
          t = e.pointNumber,
          a = e.pointNumbers,
          n = a.length > 0,
          i = n ? a[0] : t;
        return r.selectedpoints ? r.selectedpoints.indexOf(i) > -1 : !1;
      }
      function eJ(e, r) {
        var t = [],
          a,
          n,
          i,
          l;
        for (l = 0; l < e.length; l++) a = e[l], a.cd[0].trace.selectedpoints && a.cd[0].trace.selectedpoints.length > 0 && t.push(a);
        if (t.length === 1 && (i = t[0] === r.searchInfo, i && (n = r.searchInfo.cd[0].trace, n.selectedpoints.length === r.pointNumbers.length))) {
          for (l = 0; l < r.pointNumbers.length; l++) if (n.selectedpoints.indexOf(r.pointNumbers[l]) < 0) return !1;
          return !0;
        }
        return !1;
      }
      function rJ(e) {
        var r = 0,
          t,
          a,
          n;
        for (n = 0; n < e.length; n++) if (t = e[n], a = t.cd[0].trace, a.selectedpoints && (a.selectedpoints.length > 1 || (r += a.selectedpoints.length, r > 1))) return !1;
        return r === 1;
      }
      function If(e, r, t) {
        var a;
        for (a = 0; a < r.length; a++) {
          var n = r[a].cd[0].trace._fullInput,
            i = e._fullLayout._tracePreGUI[n.uid] || {};
          i.selectedpoints === void 0 && (i.selectedpoints = n._input.selectedpoints || null);
        }
        var l;
        if (t) {
          var o = t.points || [];
          for (a = 0; a < r.length; a++) l = r[a].cd[0].trace, l._input.selectedpoints = l._fullInput.selectedpoints = [], l._fullInput !== l && (l.selectedpoints = []);
          for (var s = 0; s < o.length; s++) {
            var u = o[s],
              f = u.data,
              v = u.fullData,
              h = u.pointIndex,
              d = u.pointIndices;
            d ? ([].push.apply(f.selectedpoints, d), l._fullInput !== l && [].push.apply(v.selectedpoints, d)) : (f.selectedpoints.push(h), l._fullInput !== l && v.selectedpoints.push(h));
          }
        } else for (a = 0; a < r.length; a++) l = r[a].cd[0].trace, delete l.selectedpoints, delete l._input.selectedpoints, l._fullInput !== l && delete l._fullInput.selectedpoints;
        tJ(e, r);
      }
      function tJ(e, r) {
        for (var t = !1, a = 0; a < r.length; a++) {
          var n = r[a],
            i = n.cd;
          zf.traceIs(i[0].trace, "regl") && (t = !0);
          var l = n._module,
            o = l.styleOnSelect || l.style;
          o && (o(e, i, i[0].node3), i[0].nodeRangePlot3 && o(e, i, i[0].nodeRangePlot3));
        }
        t && (YX(e), UX(e));
      }
      function bA(e, r, t) {
        for (var a = t ? lA.difference : lA.union, n = a({
            regions: e
          }, {
            regions: [r]
          }), i = n.regions.reverse(), l = 0; l < i.length; l++) {
          var o = i[l];
          o.subtract = og(o, i.slice(0, l));
        }
        return i;
      }
      function xA(e, r) {
        if (Array.isArray(e)) for (var t = r.cd, a = r.cd[0].trace, n = 0; n < e.length; n++) e[n] = RX(e[n], a, t);
        return e;
      }
      function _A(e, r) {
        for (var t = [], a = 0; a < e.length; a++) {
          t[a] = [];
          for (var n = 0; n < e[a].length; n++) {
            t[a][n] = [], t[a][n][0] = n ? "L" : "M";
            for (var i = 0; i < e[a][n].length; i++) t[a][n].push(e[a][n][i]);
          }
          r || t[a].push(["Z", t[a][0][1], t[a][0][2]]);
        }
        return t;
      }
      function wA(e, r) {
        for (var t = [], a, n = [], i, l = 0; l < r.length; l++) {
          var o = r[l];
          i = o._module.selectPoints(o, e), n.push(i), a = xA(i, o), t = t.concat(a);
        }
        return t;
      }
      function eg(e, r, t, a, n) {
        var i = !!a,
          l,
          o,
          s;
        n && (l = n.plotinfo, o = n.xaxes[0]._id, s = n.yaxes[0]._id);
        var u = [],
          f = [],
          v = vA(e),
          h = e._fullLayout;
        if (l) {
          var d = h._zoomlayer,
            y = h.dragmode,
            g = Nf(y),
            m = tg(y);
          if (g || m) {
            var _ = qn(e, o, "x"),
              w = qn(e, s, "y");
            if (_ && w) {
              var T = d.selectAll(".select-outline-" + l.id);
              if (T && e._fullLayout._outlining && T.length) {
                for (var b = T[0][0], A = b.getAttribute("d"), S = FX(A, e, l), k = [], q = 0; q < S.length; q++) {
                  for (var D = S[q], R = [], z = 0; z < D.length; z++) R.push([kl(_, D[z][1]), kl(w, D[z][2])]);
                  R.xref = o, R.yref = s, R.subtract = og(R, k), k.push(R);
                }
                v = v.concat(k);
              }
            }
          }
        }
        var N = o && s ? [o + s] : h._subplots.cartesian;
        aJ(e);
        for (var H = {}, O = 0; O < N.length; O++) {
          var J = N[O],
            X = J.indexOf("y"),
            B = J.slice(0, X),
            I = J.slice(X),
            V = o && s ? t : void 0;
          if (V = iJ(v, B, I, V), V) {
            var K = a;
            if (!i) {
              var Q = qn(e, B, "x"),
                ie = qn(e, I, "y");
              K = Sh(e, [Q], [ie], J);
              for (var me = 0; me < K.length; me++) {
                var pe = K[me],
                  ge = pe.cd[0],
                  j = ge.trace;
                if (pe._module.name === "scattergl" && !ge.t.xpx) {
                  var _e = j.x,
                    se = j.y,
                    Se = j._length;
                  ge.t.xpx = [], ge.t.ypx = [];
                  for (var ve = 0; ve < Se; ve++) ge.t.xpx[ve] = Q.c2p(_e[ve]), ge.t.ypx[ve] = ie.c2p(se[ve]);
                }
                pe._module.name === "splom" && (H[j.uid] || (H[j.uid] = !0));
              }
            }
            var Ae = wA(V, K);
            u = u.concat(Ae), f = f.concat(K);
          }
        }
        var Y = {
          points: u
        };
        If(e, f, Y);
        var re = h.clickmode,
          U = re.indexOf("event") > -1 && r;
        if (!l && r) {
          var de = vA(e, !0);
          if (de.length) {
            var be = de[0].xref,
              ye = de[0].yref;
            if (be && ye) {
              var Fe = MA(de),
                Re = AA([qn(e, be, "x"), qn(e, ye, "y")]);
              Re(Y, Fe);
            }
          }
          e._fullLayout._noEmitSelectedAtStart ? e._fullLayout._noEmitSelectedAtStart = !1 : U && Hf(e, Y), h._reselect = !1;
        }
        if (!l && h._deselect) {
          var Pe = h._deselect;
          o = Pe.xref, s = Pe.yref, nJ(o, s, f) || TA(e, o, s, a), U && (Y.points.length ? Hf(e, Y) : sg(e)), h._deselect = !1;
        }
        return {
          eventData: Y,
          selectionTesters: t
        };
      }
      function aJ(e) {
        var r = e.calcdata;
        if (r) for (var t = 0; t < r.length; t++) {
          var a = r[t][0],
            n = a.trace,
            i = e._fullLayout._splomScenes;
          if (i) {
            var l = i[n.uid];
            l && (l.selectBatch = []);
          }
        }
      }
      function nJ(e, r, t) {
        for (var a = 0; a < t.length; a++) {
          var n = t[a];
          if (n.xaxis && n.xaxis._id === e && n.yaxis && n.yaxis._id === r) return !0;
        }
        return !1;
      }
      function TA(e, r, t, a) {
        a = Sh(e, [qn(e, r, "x")], [qn(e, t, "y")], r + t);
        for (var n = 0; n < a.length; n++) {
          var i = a[n];
          i._module.selectPoints(i, !1);
        }
        If(e, a);
      }
      function iJ(e, r, t, a) {
        for (var n, i = 0; i < e.length; i++) {
          var l = e[i];
          if (!(r !== l.xref || t !== l.yref)) if (n) {
            var o = !!l.subtract;
            n = bA(n, l, o), a = lg(n);
          } else n = [l], a = ag(l);
        }
        return a;
      }
      function vA(e, r) {
        for (var t = [], a = e._fullLayout, n = a.selections, i = n.length, l = 0; l < i; l++) if (!(r && l !== a._activeSelectionIndex)) {
          var o = n[l];
          if (o) {
            var s = o.xref,
              u = o.yref,
              f = qn(e, s, "x"),
              v = qn(e, u, "y"),
              h,
              d,
              y,
              g,
              m;
            if (o.type === "rect") {
              m = [];
              var _ = kl(f, o.x0),
                w = kl(f, o.x1),
                T = kl(v, o.y0),
                b = kl(v, o.y1);
              m = [[_, T], [_, b], [w, b], [w, T]], h = Math.min(_, w), d = Math.max(_, w), y = Math.min(T, b), g = Math.max(T, b), m.xmin = h, m.xmax = d, m.ymin = y, m.ymax = g, m.xref = s, m.yref = u, m.subtract = !1, m.isRect = !0, t.push(m);
            } else if (o.type === "path") for (var A = o.path.split("Z"), S = [], k = 0; k < A.length; k++) {
              var q = A[k];
              if (q) {
                q += "Z";
                var D = oA.extractPathCoords(q, sA.paramIsX, "raw"),
                  R = oA.extractPathCoords(q, sA.paramIsY, "raw");
                h = 1 / 0, d = -1 / 0, y = 1 / 0, g = -1 / 0, m = [];
                for (var z = 0; z < D.length; z++) {
                  var N = kl(f, D[z]),
                    H = kl(v, R[z]);
                  m.push([N, H]), h = Math.min(N, h), d = Math.max(N, d), y = Math.min(H, y), g = Math.max(H, g);
                }
                m.xmin = h, m.xmax = d, m.ymin = y, m.ymax = g, m.xref = s, m.yref = u, m.subtract = og(m, S), S.push(m), t.push(m);
              }
            }
          }
        }
        return t;
      }
      function og(e, r) {
        for (var t = !1, a = 0; a < r.length; a++) for (var n = r[a], i = 0; i < e.length; i++) if (DX(e[i], n)) {
          t = !t;
          break;
        }
        return t;
      }
      function kl(e, r) {
        return e.type === "date" && (r = r.replace("_", " ")), e.type === "log" ? e.c2p(r) : e.r2p(r, null, e.calendar);
      }
      function MA(e) {
        for (var r = e.length, t = [], a = 0; a < r; a++) {
          var n = e[a];
          t = t.concat(n), t = t.concat([n[0]]);
        }
        return lJ(t);
      }
      function lJ(e) {
        return e.isRect = e.length === 5 && e[0][0] === e[4][0] && e[0][1] === e[4][1] && e[0][0] === e[1][0] && e[2][0] === e[3][0] && e[0][1] === e[3][1] && e[1][1] === e[2][1] || e[0][1] === e[1][1] && e[2][1] === e[3][1] && e[0][0] === e[3][0] && e[1][0] === e[2][0], e.isRect && (e.xmin = Math.min(e[0][0], e[2][0]), e.xmax = Math.max(e[0][0], e[2][0]), e.ymin = Math.min(e[0][1], e[2][1]), e.ymax = Math.max(e[0][1], e[2][1])), e;
      }
      function AA(e) {
        return function (r, t) {
          for (var a, n, i = 0; i < e.length; i++) {
            var l = e[i],
              o = l._id,
              s = o.charAt(0);
            if (t.isRect) {
              a || (a = {});
              var u = t[s + "min"],
                f = t[s + "max"];
              u !== void 0 && f !== void 0 && (a[o] = [uA(l, u), uA(l, f)].sort(BX));
            } else n || (n = {}), n[o] = t.map(VX(l));
          }
          a && (r.range = a), n && (r.lassoPoints = n);
        };
      }
      function oJ(e) {
        var r = e.plotinfo;
        return r.fillRangeItems || AA(e.xaxes.concat(e.yaxes));
      }
      function sJ(e, r) {
        e.emit("plotly_selecting", r);
      }
      function Hf(e, r) {
        r && (r.selections = (e.layout || {}).selections || []), e.emit("plotly_selected", r);
      }
      function sg(e) {
        e.emit("plotly_deselect", null);
      }
      kA.exports = {
        reselect: eg,
        prepSelect: ZX,
        clearOutline: dA,
        clearSelectionsCache: Ff,
        selectOnClick: yA
      };
    });
    var ug = Z((sue, SA) => {
      "use strict";

      SA.exports = [{
        path: "",
        backoff: 0
      }, {
        path: "M-2.4,-3V3L0.6,0Z",
        backoff: .6
      }, {
        path: "M-3.7,-2.5V2.5L1.3,0Z",
        backoff: 1.3
      }, {
        path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
        backoff: 1.55
      }, {
        path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
        backoff: 1.6
      }, {
        path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
        backoff: 2
      }, {
        path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
        backoff: 0,
        noRotate: !0
      }, {
        path: "M2,2V-2H-2V2Z",
        backoff: 0,
        noRotate: !0
      }];
    });
    var Bf = Z((uue, LA) => {
      "use strict";

      LA.exports = {
        axisRefDescription: function (e, r, t) {
          return ["If set to a", e, "axis id (e.g. *" + e + "* or", "*" + e + "2*), the `" + e + "` position refers to a", e, "coordinate. If set to *paper*, the `" + e + "`", "position refers to the distance from the", r, "of the plotting", "area in normalized coordinates where *0* (*1*) corresponds to the", r, "(" + t + "). If set to a", e, "axis ID followed by", "*domain* (separated by a space), the position behaves like for", "*paper*, but refers to the distance in fractions of the domain", "length from the", r, "of the domain of that axis: e.g.,", "*" + e + "2 domain* refers to the domain of the second", e, " axis and a", e, "position of 0.5 refers to the", "point between the", r, "and the", t, "of the domain of the", "second", e, "axis."].join(" ");
        }
      };
    });
    var js = Z((cue, EA) => {
      "use strict";

      var qA = ug(),
        DA = ha(),
        Lh = da(),
        uJ = ct().templatedArray,
        fue = Bf();
      EA.exports = uJ("annotation", {
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "calc+arraydraw"
        },
        text: {
          valType: "string",
          editType: "calc+arraydraw"
        },
        textangle: {
          valType: "angle",
          dflt: 0,
          editType: "calc+arraydraw"
        },
        font: DA({
          editType: "calc+arraydraw",
          colorEditType: "arraydraw"
        }),
        width: {
          valType: "number",
          min: 1,
          dflt: null,
          editType: "calc+arraydraw"
        },
        height: {
          valType: "number",
          min: 1,
          dflt: null,
          editType: "calc+arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "arraydraw"
        },
        align: {
          valType: "enumerated",
          values: ["left", "center", "right"],
          dflt: "center",
          editType: "arraydraw"
        },
        valign: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "middle",
          editType: "arraydraw"
        },
        bgcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "arraydraw"
        },
        bordercolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "arraydraw"
        },
        borderpad: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        showarrow: {
          valType: "boolean",
          dflt: !0,
          editType: "calc+arraydraw"
        },
        arrowcolor: {
          valType: "color",
          editType: "arraydraw"
        },
        arrowhead: {
          valType: "integer",
          min: 0,
          max: qA.length,
          dflt: 1,
          editType: "arraydraw"
        },
        startarrowhead: {
          valType: "integer",
          min: 0,
          max: qA.length,
          dflt: 1,
          editType: "arraydraw"
        },
        arrowside: {
          valType: "flaglist",
          flags: ["end", "start"],
          extras: ["none"],
          dflt: "end",
          editType: "arraydraw"
        },
        arrowsize: {
          valType: "number",
          min: .3,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        startarrowsize: {
          valType: "number",
          min: .3,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        arrowwidth: {
          valType: "number",
          min: .1,
          editType: "calc+arraydraw"
        },
        standoff: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "calc+arraydraw"
        },
        startstandoff: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "calc+arraydraw"
        },
        ax: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        ay: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        axref: {
          valType: "enumerated",
          dflt: "pixel",
          values: ["pixel", Lh.idRegex.x.toString()],
          editType: "calc"
        },
        ayref: {
          valType: "enumerated",
          dflt: "pixel",
          values: ["pixel", Lh.idRegex.y.toString()],
          editType: "calc"
        },
        xref: {
          valType: "enumerated",
          values: ["paper", Lh.idRegex.x.toString()],
          editType: "calc"
        },
        x: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "auto",
          editType: "calc+arraydraw"
        },
        xshift: {
          valType: "number",
          dflt: 0,
          editType: "calc+arraydraw"
        },
        yref: {
          valType: "enumerated",
          values: ["paper", Lh.idRegex.y.toString()],
          editType: "calc"
        },
        y: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "auto",
          editType: "calc+arraydraw"
        },
        yshift: {
          valType: "number",
          dflt: 0,
          editType: "calc+arraydraw"
        },
        clicktoshow: {
          valType: "enumerated",
          values: [!1, "onoff", "onout"],
          dflt: !1,
          editType: "arraydraw"
        },
        xclick: {
          valType: "any",
          editType: "arraydraw"
        },
        yclick: {
          valType: "any",
          editType: "arraydraw"
        },
        hovertext: {
          valType: "string",
          editType: "arraydraw"
        },
        hoverlabel: {
          bgcolor: {
            valType: "color",
            editType: "arraydraw"
          },
          bordercolor: {
            valType: "color",
            editType: "arraydraw"
          },
          font: DA({
            editType: "arraydraw"
          }),
          editType: "arraydraw"
        },
        captureevents: {
          valType: "boolean",
          editType: "arraydraw"
        },
        editType: "calc"
      });
    });
    var qh = Z((vue, PA) => {
      "use strict";

      PA.exports = {
        PTS_LINESONLY: 20,
        minTolerance: .2,
        toleranceGrowth: 10,
        maxScreensAway: 20,
        eventDataKeys: []
      };
    });
    var zA = Z((hue, RA) => {
      "use strict";

      RA.exports = function (r) {
        return {
          valType: "color",
          editType: "style",
          anim: !0
        };
      };
    });
    var qo = Z((due, BA) => {
      "use strict";

      var NA = r0().axisHoverFormat,
        fJ = zi().texttemplateAttrs,
        cJ = zi().hovertemplateAttrs,
        FA = nf(),
        vJ = ha(),
        hJ = mi().dash,
        dJ = mi().pattern,
        pJ = tt(),
        mJ = qh(),
        Dh = Yt().extendFlat,
        yJ = zA();
      function IA(e) {
        return {
          valType: "any",
          dflt: 0,
          editType: "calc"
        };
      }
      function HA(e) {
        return {
          valType: "any",
          editType: "calc"
        };
      }
      function OA(e) {
        return {
          valType: "enumerated",
          values: ["start", "middle", "end"],
          dflt: "middle",
          editType: "calc"
        };
      }
      BA.exports = {
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        x0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        dx: {
          valType: "number",
          dflt: 1,
          editType: "calc",
          anim: !0
        },
        y: {
          valType: "data_array",
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        y0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        dy: {
          valType: "number",
          dflt: 1,
          editType: "calc",
          anim: !0
        },
        xperiod: IA("x"),
        yperiod: IA("y"),
        xperiod0: HA("x0"),
        yperiod0: HA("y0"),
        xperiodalignment: OA("x"),
        yperiodalignment: OA("y"),
        xhoverformat: NA("x"),
        yhoverformat: NA("y"),
        offsetgroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        alignmentgroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        stackgroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          editType: "calc"
        },
        groupnorm: {
          valType: "enumerated",
          values: ["", "fraction", "percent"],
          dflt: "",
          editType: "calc"
        },
        stackgaps: {
          valType: "enumerated",
          values: ["infer zero", "interpolate"],
          dflt: "infer zero",
          editType: "calc"
        },
        text: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "calc"
        },
        texttemplate: fJ({}, {}),
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "style"
        },
        mode: {
          valType: "flaglist",
          flags: ["lines", "markers", "text"],
          extras: ["none"],
          editType: "calc"
        },
        hoveron: {
          valType: "flaglist",
          flags: ["points", "fills"],
          editType: "style"
        },
        hovertemplate: cJ({}, {
          keys: mJ.eventDataKeys
        }),
        line: {
          color: {
            valType: "color",
            editType: "style",
            anim: !0
          },
          width: {
            valType: "number",
            min: 0,
            dflt: 2,
            editType: "style",
            anim: !0
          },
          shape: {
            valType: "enumerated",
            values: ["linear", "spline", "hv", "vh", "hvh", "vhv"],
            dflt: "linear",
            editType: "plot"
          },
          smoothing: {
            valType: "number",
            min: 0,
            max: 1.3,
            dflt: 1,
            editType: "plot"
          },
          dash: Dh({}, hJ, {
            editType: "style"
          }),
          backoff: {
            valType: "number",
            min: 0,
            dflt: "auto",
            arrayOk: !0,
            editType: "plot"
          },
          simplify: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          editType: "plot"
        },
        connectgaps: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        cliponaxis: {
          valType: "boolean",
          dflt: !0,
          editType: "plot"
        },
        fill: {
          valType: "enumerated",
          values: ["none", "tozeroy", "tozerox", "tonexty", "tonextx", "toself", "tonext"],
          editType: "calc"
        },
        fillcolor: yJ(!0),
        fillgradient: Dh({
          type: {
            valType: "enumerated",
            values: ["radial", "horizontal", "vertical", "none"],
            dflt: "none",
            editType: "calc"
          },
          start: {
            valType: "number",
            editType: "calc"
          },
          stop: {
            valType: "number",
            editType: "calc"
          },
          colorscale: {
            valType: "colorscale",
            editType: "style"
          },
          editType: "calc"
        }),
        fillpattern: dJ,
        marker: Dh({
          symbol: {
            valType: "enumerated",
            values: pJ.symbolList,
            dflt: "circle",
            arrayOk: !0,
            editType: "style"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            arrayOk: !0,
            editType: "style",
            anim: !0
          },
          angle: {
            valType: "angle",
            dflt: 0,
            arrayOk: !0,
            editType: "plot",
            anim: !1
          },
          angleref: {
            valType: "enumerated",
            values: ["previous", "up"],
            dflt: "up",
            editType: "plot",
            anim: !1
          },
          standoff: {
            valType: "number",
            min: 0,
            dflt: 0,
            arrayOk: !0,
            editType: "plot",
            anim: !0
          },
          size: {
            valType: "number",
            min: 0,
            dflt: 6,
            arrayOk: !0,
            editType: "calc",
            anim: !0
          },
          maxdisplayed: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          sizeref: {
            valType: "number",
            dflt: 1,
            editType: "calc"
          },
          sizemin: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "calc"
          },
          sizemode: {
            valType: "enumerated",
            values: ["diameter", "area"],
            dflt: "diameter",
            editType: "calc"
          },
          line: Dh({
            width: {
              valType: "number",
              min: 0,
              arrayOk: !0,
              editType: "style",
              anim: !0
            },
            editType: "calc"
          }, FA("marker.line", {
            anim: !0
          })),
          gradient: {
            type: {
              valType: "enumerated",
              values: ["radial", "horizontal", "vertical", "none"],
              arrayOk: !0,
              dflt: "none",
              editType: "calc"
            },
            color: {
              valType: "color",
              arrayOk: !0,
              editType: "calc"
            },
            editType: "calc"
          },
          editType: "calc"
        }, FA("marker", {
          anim: !0
        })),
        selected: {
          marker: {
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              editType: "style"
            },
            color: {
              valType: "color",
              editType: "style"
            },
            size: {
              valType: "number",
              min: 0,
              editType: "style"
            },
            editType: "style"
          },
          textfont: {
            color: {
              valType: "color",
              editType: "style"
            },
            editType: "style"
          },
          editType: "style"
        },
        unselected: {
          marker: {
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              editType: "style"
            },
            color: {
              valType: "color",
              editType: "style"
            },
            size: {
              valType: "number",
              min: 0,
              editType: "style"
            },
            editType: "style"
          },
          textfont: {
            color: {
              valType: "color",
              editType: "style"
            },
            editType: "style"
          },
          editType: "style"
        },
        textposition: {
          valType: "enumerated",
          values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"],
          dflt: "middle center",
          arrayOk: !0,
          editType: "calc"
        },
        textfont: vJ({
          editType: "calc",
          colorEditType: "style",
          arrayOk: !0
        }),
        zorder: {
          valType: "integer",
          dflt: 0,
          editType: "plot"
        }
      };
    });
    var fg = Z((mue, GA) => {
      "use strict";

      var YA = js(),
        UA = qo().line,
        gJ = mi().dash,
        Eh = Yt().extendFlat,
        bJ = pi().overrideAll,
        xJ = ct().templatedArray,
        pue = Bf();
      GA.exports = bJ(xJ("selection", {
        type: {
          valType: "enumerated",
          values: ["rect", "path"]
        },
        xref: Eh({}, YA.xref, {}),
        yref: Eh({}, YA.yref, {}),
        x0: {
          valType: "any"
        },
        x1: {
          valType: "any"
        },
        y0: {
          valType: "any"
        },
        y1: {
          valType: "any"
        },
        path: {
          valType: "string",
          editType: "arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: .7,
          editType: "arraydraw"
        },
        line: {
          color: UA.color,
          width: Eh({}, UA.width, {
            min: 1,
            dflt: 1
          }),
          dash: Eh({}, gJ, {
            dflt: "dot"
          })
        }
      }), "arraydraw", "from-root");
    });
    var XA = Z((yue, ZA) => {
      "use strict";

      var VA = He(),
        Ph = dt(),
        _J = Jn(),
        wJ = fg(),
        WA = Al();
      ZA.exports = function (r, t) {
        _J(r, t, {
          name: "selections",
          handleItemDefaults: TJ
        });
        for (var a = t.selections, n = 0; n < a.length; n++) {
          var i = a[n];
          i && i.path === void 0 && (i.x0 === void 0 || i.x1 === void 0 || i.y0 === void 0 || i.y1 === void 0) && (t.selections[n] = null);
        }
      };
      function TJ(e, r, t) {
        function a(S, k) {
          return VA.coerce(e, r, wJ, S, k);
        }
        var n = a("path"),
          i = n ? "path" : "rect",
          l = a("type", i),
          o = l !== "path";
        o && delete r.path, a("opacity"), a("line.color"), a("line.width"), a("line.dash");
        for (var s = ["x", "y"], u = 0; u < 2; u++) {
          var f = s[u],
            v = {
              _fullLayout: t
            },
            h,
            d,
            y,
            g = Ph.coerceRef(e, r, v, f);
          if (h = Ph.getFromId(v, g), h._selectionIndices.push(r._index), y = WA.rangeToShapePosition(h), d = WA.shapePositionToRange(h), o) {
            var m = f + "0",
              _ = f + "1",
              w = e[m],
              T = e[_];
            e[m] = d(e[m], !0), e[_] = d(e[_], !0), Ph.coercePosition(r, v, a, g, m), Ph.coercePosition(r, v, a, g, _);
            var b = r[m],
              A = r[_];
            b !== void 0 && A !== void 0 && (r[m] = y(b), r[_] = y(A), e[m] = w, e[_] = T);
          }
        }
        o && VA.noneOrAll(e, r, ["x0", "x1", "y0", "y1"]);
      }
    });
    var KA = Z((gue, JA) => {
      "use strict";

      JA.exports = function (r, t, a) {
        a("newselection.mode");
        var n = a("newselection.line.width");
        n && (a("newselection.line.color"), a("newselection.line.dash")), a("activeselection.fillcolor"), a("activeselection.opacity");
      };
    });
    var Yf = Z((bue, jA) => {
      "use strict";

      var MJ = gr(),
        QA = He(),
        $A = Xt();
      jA.exports = function (r) {
        return function (a, n) {
          var i = a[r];
          if (Array.isArray(i)) for (var l = MJ.subplotsRegistry.cartesian, o = l.idRegex, s = n._subplots, u = s.xaxis, f = s.yaxis, v = s.cartesian, h = n._has("cartesian"), d = 0; d < i.length; d++) {
            var y = i[d];
            if (QA.isPlainObject(y)) {
              var g = $A.cleanId(y.xref, "x", !1),
                m = $A.cleanId(y.yref, "y", !1),
                _ = o.x.test(g),
                w = o.y.test(m);
              if (_ || w) {
                h || QA.pushUnique(n._basePlotModules, l);
                var T = !1;
                _ && u.indexOf(g) === -1 && (u.push(g), T = !0), w && f.indexOf(m) === -1 && (f.push(m), T = !0), T && _ && w && v.push(g + m);
              }
            }
          }
        };
      };
    });
    var eu = Z((xue, rk) => {
      "use strict";

      var ek = Jy(),
        Uf = CA();
      rk.exports = {
        moduleType: "component",
        name: "selections",
        layoutAttributes: fg(),
        supplyLayoutDefaults: XA(),
        supplyDrawNewSelectionDefaults: KA(),
        includeBasePlot: Yf()("selections"),
        draw: ek.draw,
        drawOne: ek.drawOne,
        reselect: Uf.reselect,
        prepSelect: Uf.prepSelect,
        clearOutline: Uf.clearOutline,
        clearSelectionsCache: Uf.clearSelectionsCache,
        selectOnClick: Uf.selectOnClick
      };
    });
    var wk = Z((_ue, _k) => {
      "use strict";

      var pg = Ir(),
        Dn = He(),
        tk = Dn.numberFormat,
        AJ = bn(),
        kJ = Jm(),
        Rh = gr(),
        ck = Dn.strTranslate,
        CJ = xa(),
        ak = Er(),
        Cl = tt(),
        SJ = ki(),
        nk = dt(),
        LJ = wl(),
        qJ = Qn(),
        vk = Vs(),
        zh = vk.selectingOrDrawing,
        DJ = vk.freeMode,
        EJ = Da().FROM_TL,
        PJ = Q0(),
        RJ = xh().redrawReglTraces,
        zJ = Pt(),
        vg = Xt().getFromId,
        NJ = eu().prepSelect,
        FJ = eu().clearOutline,
        IJ = eu().selectOnClick,
        cg = By(),
        mg = da(),
        ik = mg.MINDRAG,
        Ya = mg.MINZOOM,
        lk = !0;
      function HJ(e, r, t, a, n, i, l, o) {
        var s = e._fullLayout._zoomlayer,
          u = l + o === "nsew",
          f = (l + o).length === 1,
          v,
          h,
          d,
          y,
          g,
          m,
          _,
          w,
          T,
          b,
          A,
          S,
          k,
          q,
          D,
          R,
          z,
          N,
          H,
          O,
          J,
          X,
          B;
        t += r.yaxis._shift;
        function I() {
          if (v = r.xaxis, h = r.yaxis, T = v._length, b = h._length, _ = v._offset, w = h._offset, d = {}, d[v._id] = v, y = {}, y[h._id] = h, l && o) for (var De = r.overlays, Le = 0; Le < De.length; Le++) {
            var Ye = De[Le].xaxis;
            d[Ye._id] = Ye;
            var Ze = De[Le].yaxis;
            y[Ze._id] = Ze;
          }
          g = fk(d), m = fk(y), k = ok(g, o), q = ok(m, l), D = !q && !k, S = uk(e, e._fullLayout._axisMatchGroups, d, y), A = uk(e, e._fullLayout._axisConstraintGroups, d, y, S);
          var Ue = A.isSubplotConstrained || S.isSubplotConstrained;
          R = o || Ue, z = l || Ue;
          var Oe = e._fullLayout;
          N = Oe._has("scattergl"), H = Oe._has("splom"), O = Oe._has("svg");
        }
        I();
        var V = YJ(q + k, e._fullLayout.dragmode, u),
          K = dk(r, l + o + "drag", V, t, a, n, i);
        if (D && !u) return K.onmousedown = null, K.style.pointerEvents = "none", K;
        var Q = {
          element: K,
          gd: e,
          plotinfo: r
        };
        Q.prepFn = function (De, Le, Ye) {
          var Ze = Q.dragmode,
            Ue = e._fullLayout.dragmode;
          Ue !== Ze && (Q.dragmode = Ue), I(), X = e._fullLayout._invScaleX, B = e._fullLayout._invScaleY, D || (u ? De.shiftKey ? Ue === "pan" ? Ue = "zoom" : zh(Ue) || (Ue = "pan") : De.ctrlKey && (Ue = "pan") : Ue = "pan"), DJ(Ue) ? Q.minDrag = 1 : Q.minDrag = void 0, zh(Ue) ? (Q.xaxes = g, Q.yaxes = m, NJ(De, Le, Ye, Q, Ue)) : (Q.clickFn = me, zh(Ze) && ie(), D || (Ue === "zoom" ? (Q.moveFn = de, Q.doneFn = ye, Q.minDrag = 1, U(De, Le, Ye)) : Ue === "pan" && (Q.moveFn = Ne, Q.doneFn = ne))), e._fullLayout._redrag = function () {
            var Oe = e._dragdata;
            if (Oe && Oe.element === K) {
              var Ke = e._fullLayout.dragmode;
              zh(Ke) || (I(), Me([0, 0, T, b]), Q.moveFn(Oe.dx, Oe.dy));
            }
          };
        };
        function ie() {
          Q.plotinfo.selection = !1, FJ(e);
        }
        function me(De, Le) {
          var Ye = Q.gd;
          if (Ye._fullLayout._activeShapeIndex >= 0) {
            Ye._fullLayout._deactivateShape(Ye);
            return;
          }
          var Ze = Ye._fullLayout.clickmode;
          if (dg(Ye), De === 2 && !f && We(), u) Ze.indexOf("select") > -1 && IJ(Le, Ye, g, m, r.id, Q), Ze.indexOf("event") > -1 && SJ.click(Ye, Le, r.id);else if (De === 1 && f) {
            var Ue = l ? h : v,
              Oe = l === "s" || o === "w" ? 0 : 1,
              Ke = Ue._name + ".range[" + Oe + "]",
              fr = OJ(Ue, Oe),
              lr = "left",
              ze = "middle";
            if (Ue.fixedrange) return;
            l ? (ze = l === "n" ? "top" : "bottom", Ue.side === "right" && (lr = "right")) : o === "e" && (lr = "right"), Ye._context.showAxisRangeEntryBoxes && pg.select(K).call(CJ.makeEditable, {
              gd: Ye,
              immediate: !0,
              background: Ye._fullLayout.paper_bgcolor,
              text: String(fr),
              fill: Ue.tickfont ? Ue.tickfont.color : "#444",
              horizontalAlign: lr,
              verticalAlign: ze
            }).on("edit", function (ae) {
              var oe = Ue.d2r(ae);
              oe !== void 0 && Rh.call("_guiRelayout", Ye, Ke, oe);
            });
          }
        }
        qJ.init(Q);
        var pe, ge, j, _e, se, Se, ve, Ae, Y, re;
        function U(De, Le, Ye) {
          var Ze = K.getBoundingClientRect();
          pe = Le - Ze.left, ge = Ye - Ze.top, e._fullLayout._calcInverseTransform(e);
          var Ue = Dn.apply3DTransform(e._fullLayout._invTransform)(pe, ge);
          pe = Ue[0], ge = Ue[1], j = {
            l: pe,
            r: pe,
            w: 0,
            t: ge,
            b: ge,
            h: 0
          }, _e = e._hmpixcount ? e._hmlumcount / e._hmpixcount : AJ(e._fullLayout.plot_bgcolor).getLuminance(), se = "M0,0H" + T + "V" + b + "H0V0", Se = !1, ve = "xy", re = !1, Ae = pk(s, _e, _, w, se), Y = mk(s, _, w);
        }
        function de(De, Le) {
          if (e._transitioningWithDuration) return !1;
          var Ye = Math.max(0, Math.min(T, X * De + pe)),
            Ze = Math.max(0, Math.min(b, B * Le + ge)),
            Ue = Math.abs(Ye - pe),
            Oe = Math.abs(Ze - ge);
          j.l = Math.min(pe, Ye), j.r = Math.max(pe, Ye), j.t = Math.min(ge, Ze), j.b = Math.max(ge, Ze);
          function Ke() {
            ve = "", j.r = j.l, j.t = j.b, Y.attr("d", "M0,0Z");
          }
          if (A.isSubplotConstrained) Ue > Ya || Oe > Ya ? (ve = "xy", Ue / T > Oe / b ? (Oe = Ue * b / T, ge > Ze ? j.t = ge - Oe : j.b = ge + Oe) : (Ue = Oe * T / b, pe > Ye ? j.l = pe - Ue : j.r = pe + Ue), Y.attr("d", Nh(j))) : Ke();else if (S.isSubplotConstrained) {
            if (Ue > Ya || Oe > Ya) {
              ve = "xy";
              var fr = Math.min(j.l / T, (b - j.b) / b),
                lr = Math.max(j.r / T, (b - j.t) / b);
              j.l = fr * T, j.r = lr * T, j.b = (1 - fr) * b, j.t = (1 - lr) * b, Y.attr("d", Nh(j));
            } else Ke();
          } else !q || Oe < Math.min(Math.max(Ue * .6, ik), Ya) ? Ue < ik || !k ? Ke() : (j.t = 0, j.b = b, ve = "x", Y.attr("d", UJ(j, ge))) : !k || Ue < Math.min(Oe * .6, Ya) ? (j.l = 0, j.r = T, ve = "y", Y.attr("d", GJ(j, pe))) : (ve = "xy", Y.attr("d", Nh(j)));
          j.w = j.r - j.l, j.h = j.b - j.t, ve && (re = !0), e._dragged = re, yk(Ae, Y, j, se, Se, _e), be(), e.emit("plotly_relayouting", J), Se = !0;
        }
        function be() {
          J = {}, (ve === "xy" || ve === "x") && (hg(g, j.l / T, j.r / T, J, A.xaxes), Ee("x", J)), (ve === "xy" || ve === "y") && (hg(m, (b - j.b) / b, (b - j.t) / b, J, A.yaxes), Ee("y", J));
        }
        function ye() {
          be(), dg(e), ne(), bk(e);
        }
        var Fe = [0, 0, T, b],
          Re = null,
          Pe = mg.REDRAWDELAY,
          Ie = r.mainplot ? e._fullLayout._plots[r.mainplot] : r;
        function Be(De) {
          if (!e._context._scrollZoom.cartesian && !e._fullLayout._enablescrollzoom) return;
          if (ie(), e._transitioningWithDuration) {
            De.preventDefault(), De.stopPropagation();
            return;
          }
          I(), clearTimeout(Re);
          var Le = -De.deltaY;
          if (isFinite(Le) || (Le = De.wheelDelta / 10), !isFinite(Le)) {
            Dn.log("Did not find wheel motion attributes: ", De);
            return;
          }
          var Ye = Math.exp(-Math.min(Math.max(Le, -20), 20) / 200),
            Ze = Ie.draglayer.select(".nsewdrag").node().getBoundingClientRect(),
            Ue = (De.clientX - Ze.left) / Ze.width,
            Oe = (Ze.bottom - De.clientY) / Ze.height,
            Ke;
          function fr(lr, ze, ae) {
            if (lr.fixedrange) return;
            var oe = Dn.simpleMap(lr.range, lr.r2l),
              qe = oe[0] + (oe[1] - oe[0]) * ze;
            function ke(ir) {
              return lr.l2r(qe + (ir - qe) * ae);
            }
            lr.range = oe.map(ke);
          }
          if (R) {
            for (o || (Ue = .5), Ke = 0; Ke < g.length; Ke++) fr(g[Ke], Ue, Ye);
            Ee("x"), Fe[2] *= Ye, Fe[0] += Fe[2] * Ue * (1 / Ye - 1);
          }
          if (z) {
            for (l || (Oe = .5), Ke = 0; Ke < m.length; Ke++) fr(m[Ke], Oe, Ye);
            Ee("y"), Fe[3] *= Ye, Fe[1] += Fe[3] * (1 - Oe) * (1 / Ye - 1);
          }
          Me(Fe), Je(), e.emit("plotly_relayouting", J), Re = setTimeout(function () {
            e._fullLayout && (Fe = [0, 0, T, b], ne());
          }, Pe), De.preventDefault();
        }
        l.length * o.length !== 1 && xk(K, Be);
        function Ne(De, Le) {
          if (De = De * X, Le = Le * B, e._transitioningWithDuration) return;
          if (e._fullLayout._replotting = !0, k === "ew" || q === "ns") {
            var Ye = k ? -De : 0,
              Ze = q ? -Le : 0;
            if (S.isSubplotConstrained) {
              if (k && q) {
                var Ue = (De / T - Le / b) / 2;
                De = Ue * T, Le = -Ue * b, Ye = -De, Ze = -Le;
              }
              q ? Ye = -Ze * T / b : Ze = -Ye * b / T;
            }
            k && (sk(g, De), Ee("x")), q && (sk(m, Le), Ee("y")), Me([Ye, Ze, T, b]), Je(), e.emit("plotly_relayouting", J);
            return;
          }
          function Oe(ke, ir, vr) {
            for (var sr = 1 - ir, Mr, Ur, $r = 0; $r < ke.length; $r++) {
              var Vr = ke[$r];
              if (!Vr.fixedrange) {
                Mr = Vr, Ur = Vr._rl[sr] + (Vr._rl[ir] - Vr._rl[sr]) / BJ(vr / Vr._length);
                var St = Vr.l2r(Ur);
                St !== !1 && St !== void 0 && (Vr.range[ir] = St);
              }
            }
            return Mr._length * (Mr._rl[ir] - Ur) / (Mr._rl[ir] - Mr._rl[sr]);
          }
          var Ke = k === "w" == (q === "n") ? 1 : -1;
          if (k && q && (A.isSubplotConstrained || S.isSubplotConstrained)) {
            var fr = (De / T + Ke * Le / b) / 2;
            De = fr * T, Le = Ke * fr * b;
          }
          var lr, ze;
          if (k === "w" ? De = Oe(g, 0, De) : k === "e" ? De = Oe(g, 1, -De) : k || (De = 0), q === "n" ? Le = Oe(m, 1, Le) : q === "s" ? Le = Oe(m, 0, -Le) : q || (Le = 0), lr = k === "w" ? De : 0, ze = q === "n" ? Le : 0, A.isSubplotConstrained && !S.isSubplotConstrained || S.isSubplotConstrained && k && q && Ke > 0) {
            var ae;
            if (S.isSubplotConstrained || !k && q.length === 1) {
              for (ae = 0; ae < g.length; ae++) g[ae].range = g[ae]._r.slice(), cg(g[ae], 1 - Le / b);
              De = Le * T / b, lr = De / 2;
            }
            if (S.isSubplotConstrained || !q && k.length === 1) {
              for (ae = 0; ae < m.length; ae++) m[ae].range = m[ae]._r.slice(), cg(m[ae], 1 - De / T);
              Le = De * b / T, ze = Le / 2;
            }
          }
          (!S.isSubplotConstrained || !q) && Ee("x"), (!S.isSubplotConstrained || !k) && Ee("y");
          var oe = T - De,
            qe = b - Le;
          S.isSubplotConstrained && !(k && q) && (k ? (ze = lr ? 0 : De * b / T, qe = oe * b / T) : (lr = ze ? 0 : Le * T / b, oe = qe * T / b)), Me([lr, ze, oe, qe]), Je(), e.emit("plotly_relayouting", J);
        }
        function Ee(De, Le) {
          for (var Ye = S.isSubplotConstrained ? {
              x: m,
              y: g
            }[De] : S[De + "axes"], Ze = S.isSubplotConstrained ? {
              x: g,
              y: m
            }[De] : [], Ue = 0; Ue < Ye.length; Ue++) {
            var Oe = Ye[Ue],
              Ke = Oe._id,
              fr = S.xLinks[Ke] || S.yLinks[Ke],
              lr = Ze[0] || d[fr] || y[fr];
            lr && (Le ? (Le[Oe._name + ".range[0]"] = Le[lr._name + ".range[0]"], Le[Oe._name + ".range[1]"] = Le[lr._name + ".range[1]"]) : Oe.range = lr.range.slice());
          }
        }
        function Je() {
          var De = [],
            Le;
          function Ye(Ke) {
            for (Le = 0; Le < Ke.length; Le++) Ke[Le].fixedrange || De.push(Ke[Le]._id);
          }
          function Ze(Ke, fr) {
            for (Le = 0; Le < Ke.length; Le++) {
              var lr = Ke[Le],
                ze = lr[fr];
              !lr.fixedrange && ze.tickmode === "sync" && De.push(ze._id);
            }
          }
          for (R && (Ye(g), Ye(A.xaxes), Ye(S.xaxes), Ze(r.overlays, "xaxis")), z && (Ye(m), Ye(A.yaxes), Ye(S.yaxes), Ze(r.overlays, "yaxis")), J = {}, Le = 0; Le < De.length; Le++) {
            var Ue = De[Le],
              Oe = vg(e, Ue);
            nk.drawOne(e, Oe, {
              skipTitle: !0
            }), J[Oe._name + ".range[0]"] = Oe.range[0], J[Oe._name + ".range[1]"] = Oe.range[1];
          }
          nk.redrawComponents(e, De);
        }
        function We() {
          if (!e._transitioningWithDuration) {
            var De = e._context.doubleClick,
              Le = [];
            k && (Le = Le.concat(g)), q && (Le = Le.concat(m)), S.xaxes && (Le = Le.concat(S.xaxes)), S.yaxes && (Le = Le.concat(S.yaxes));
            var Ye = {},
              Ze,
              Ue;
            if (De === "reset+autosize") for (De = "autosize", Ue = 0; Ue < Le.length; Ue++) {
              Ze = Le[Ue];
              var Oe = Ze._rangeInitial0,
                Ke = Ze._rangeInitial1,
                fr = Oe !== void 0 || Ke !== void 0;
              if (fr && (Oe !== void 0 && Oe !== Ze.range[0] || Ke !== void 0 && Ke !== Ze.range[1]) || !fr && Ze.autorange !== !0) {
                De = "reset";
                break;
              }
            }
            if (De === "autosize") for (Ue = 0; Ue < Le.length; Ue++) Ze = Le[Ue], Ze.fixedrange || (Ye[Ze._name + ".autorange"] = !0);else if (De === "reset") {
              for ((k || A.isSubplotConstrained) && (Le = Le.concat(A.xaxes)), q && !A.isSubplotConstrained && (Le = Le.concat(A.yaxes)), A.isSubplotConstrained && (k ? q || (Le = Le.concat(m)) : Le = Le.concat(g)), Ue = 0; Ue < Le.length; Ue++) if (Ze = Le[Ue], !Ze.fixedrange) {
                var lr = Ze._name,
                  ze = Ze._autorangeInitial;
                Ze._rangeInitial0 === void 0 && Ze._rangeInitial1 === void 0 ? Ye[lr + ".autorange"] = !0 : Ze._rangeInitial0 === void 0 ? (Ye[lr + ".autorange"] = ze, Ye[lr + ".range"] = [null, Ze._rangeInitial1]) : Ze._rangeInitial1 === void 0 ? (Ye[lr + ".range"] = [Ze._rangeInitial0, null], Ye[lr + ".autorange"] = ze) : Ye[lr + ".range"] = [Ze._rangeInitial0, Ze._rangeInitial1];
              }
            }
            e.emit("plotly_doubleclick", null), Rh.call("_guiRelayout", e, Ye);
          }
        }
        function ne() {
          Me([0, 0, T, b]), Dn.syncOrAsync([zJ.previousPromises, function () {
            e._fullLayout._replotting = !1, Rh.call("_guiRelayout", e, J);
          }], e);
        }
        function Me(De) {
          var Le = e._fullLayout,
            Ye = Le._plots,
            Ze = Le._subplots.cartesian,
            Ue,
            Oe,
            Ke,
            fr;
          if (H && Rh.subplotsRegistry.splom.drag(e), N) {
            for (Ue = 0; Ue < Ze.length; Ue++) if (Oe = Ye[Ze[Ue]], Ke = Oe.xaxis, fr = Oe.yaxis, Oe._scene) {
              Ke.limitRange && Ke.limitRange(), fr.limitRange && fr.limitRange();
              var lr = Dn.simpleMap(Ke.range, Ke.r2l),
                ze = Dn.simpleMap(fr.range, fr.r2l);
              Oe._scene.update({
                range: [lr[0], ze[0], lr[1], ze[1]]
              });
            }
          }
          if ((H || N) && (PJ(e), RJ(e)), O) {
            var ae = De[2] / v._length,
              oe = De[3] / h._length;
            for (Ue = 0; Ue < Ze.length; Ue++) {
              Oe = Ye[Ze[Ue]], Ke = Oe.xaxis, fr = Oe.yaxis;
              var qe = (R || S.isSubplotConstrained) && !Ke.fixedrange && d[Ke._id],
                ke = (z || S.isSubplotConstrained) && !fr.fixedrange && y[fr._id],
                ir,
                vr,
                sr,
                Mr;
              if (qe ? (ir = ae, sr = o || S.isSubplotConstrained ? De[0] : tr(Ke, ir)) : S.xaHash[Ke._id] ? (ir = ae, sr = De[0] * Ke._length / v._length) : S.yaHash[Ke._id] ? (ir = oe, sr = q === "ns" ? -De[1] * Ke._length / h._length : tr(Ke, ir, {
                n: "top",
                s: "bottom"
              }[q])) : (ir = Ce(Ke, ae, oe), sr = cr(Ke, ir)), ir > 1 && (Ke.maxallowed !== void 0 && R === (Ke.range[0] < Ke.range[1] ? "e" : "w") || Ke.minallowed !== void 0 && R === (Ke.range[0] < Ke.range[1] ? "w" : "e")) && (ir = 1, sr = 0), ke ? (vr = oe, Mr = l || S.isSubplotConstrained ? De[1] : tr(fr, vr)) : S.yaHash[fr._id] ? (vr = oe, Mr = De[1] * fr._length / h._length) : S.xaHash[fr._id] ? (vr = ae, Mr = k === "ew" ? -De[0] * fr._length / v._length : tr(fr, vr, {
                e: "right",
                w: "left"
              }[k])) : (vr = Ce(fr, ae, oe), Mr = cr(fr, vr)), vr > 1 && (fr.maxallowed !== void 0 && z === (fr.range[0] < fr.range[1] ? "n" : "s") || fr.minallowed !== void 0 && z === (fr.range[0] < fr.range[1] ? "s" : "n")) && (vr = 1, Mr = 0), !(!ir && !vr)) {
                ir || (ir = 1), vr || (vr = 1);
                var Ur = Ke._offset - sr / ir,
                  $r = fr._offset - Mr / vr;
                Oe.clipRect.call(Cl.setTranslate, sr, Mr).call(Cl.setScale, ir, vr), Oe.plot.call(Cl.setTranslate, Ur, $r).call(Cl.setScale, 1 / ir, 1 / vr), (ir !== Oe.xScaleFactor || vr !== Oe.yScaleFactor) && (Cl.setPointGroupScale(Oe.zoomScalePts, ir, vr), Cl.setTextPointsScale(Oe.zoomScaleTxt, ir, vr)), Cl.hideOutsideRangePoints(Oe.clipOnAxisFalseTraces, Oe), Oe.xScaleFactor = ir, Oe.yScaleFactor = vr;
              }
            }
          }
        }
        function Ce(De, Le, Ye) {
          return De.fixedrange ? 0 : R && A.xaHash[De._id] ? Le : z && (A.isSubplotConstrained ? A.xaHash : A.yaHash)[De._id] ? Ye : 0;
        }
        function cr(De, Le) {
          return Le ? (De.range = De._r.slice(), cg(De, Le), tr(De, Le)) : 0;
        }
        function tr(De, Le, Ye) {
          return De._length * (1 - Le) * EJ[Ye || De.constraintoward || "middle"];
        }
        return K;
      }
      function hk(e, r, t, a) {
        var n = Dn.ensureSingle(e.draglayer, r, t, function (i) {
          i.classed("drag", !0).style({
            fill: "transparent",
            "stroke-width": 0
          }).attr("data-subplot", e.id);
        });
        return n.call(LJ, a), n.node();
      }
      function dk(e, r, t, a, n, i, l) {
        var o = hk(e, "rect", r, t);
        return pg.select(o).call(Cl.setRect, a, n, i, l), o;
      }
      function ok(e, r) {
        for (var t = 0; t < e.length; t++) if (!e[t].fixedrange) return r;
        return "";
      }
      function OJ(e, r) {
        var t = e.range[r],
          a = Math.abs(t - e.range[1 - r]),
          n;
        return e.type === "date" ? t : e.type === "log" ? (n = Math.ceil(Math.max(0, -Math.log(a) / Math.LN10)) + 3, tk("." + n + "g")(Math.pow(10, t))) : (n = Math.floor(Math.log(Math.abs(t)) / Math.LN10) - Math.floor(Math.log(a) / Math.LN10) + 4, tk("." + String(n) + "g")(t));
      }
      function hg(e, r, t, a, n) {
        for (var i = 0; i < e.length; i++) {
          var l = e[i];
          if (!l.fixedrange) if (l.rangebreaks) {
            var o = l._id.charAt(0) === "y",
              s = o ? 1 - r : r,
              u = o ? 1 - t : t;
            a[l._name + ".range[0]"] = l.l2r(l.p2l(s * l._length)), a[l._name + ".range[1]"] = l.l2r(l.p2l(u * l._length));
          } else {
            var f = l._rl[0],
              v = l._rl[1] - f;
            a[l._name + ".range[0]"] = l.l2r(f + v * r), a[l._name + ".range[1]"] = l.l2r(f + v * t);
          }
        }
        if (n && n.length) {
          var h = (r + (1 - t)) / 2;
          hg(n, h, 1 - h, a, []);
        }
      }
      function sk(e, r) {
        for (var t = 0; t < e.length; t++) {
          var a = e[t];
          if (!a.fixedrange) {
            if (a.rangebreaks) {
              var n = 0,
                i = a._length,
                l = a.p2l(n + r) - a.p2l(n),
                o = a.p2l(i + r) - a.p2l(i),
                s = (l + o) / 2;
              a.range = [a.l2r(a._rl[0] - s), a.l2r(a._rl[1] - s)];
            } else a.range = [a.l2r(a._rl[0] - r / a._m), a.l2r(a._rl[1] - r / a._m)];
            a.limitRange && a.limitRange();
          }
        }
      }
      function BJ(e) {
        return 1 - (e >= 0 ? Math.min(e, .9) : 1 / (1 / Math.max(e, -.3) + 3.222));
      }
      function YJ(e, r, t) {
        return e ? e === "nsew" ? t ? "" : r === "pan" ? "move" : "crosshair" : e.toLowerCase() + "-resize" : "pointer";
      }
      function pk(e, r, t, a, n) {
        return e.append("path").attr("class", "zoombox").style({
          fill: r > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
          "stroke-width": 0
        }).attr("transform", ck(t, a)).attr("d", n + "Z");
      }
      function mk(e, r, t) {
        return e.append("path").attr("class", "zoombox-corners").style({
          fill: ak.background,
          stroke: ak.defaultLine,
          "stroke-width": 1,
          opacity: 0
        }).attr("transform", ck(r, t)).attr("d", "M0,0Z");
      }
      function yk(e, r, t, a, n, i) {
        e.attr("d", a + "M" + t.l + "," + t.t + "v" + t.h + "h" + t.w + "v-" + t.h + "h-" + t.w + "Z"), gk(e, r, n, i);
      }
      function gk(e, r, t, a) {
        t || (e.transition().style("fill", a > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), r.transition().style("opacity", 1).duration(200));
      }
      function dg(e) {
        pg.select(e).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
      }
      function bk(e) {
        lk && e.data && e._context.showTips && (Dn.notifier(Dn._(e, "Double-click to zoom back out"), "long"), lk = !1);
      }
      function UJ(e, r) {
        return "M" + (e.l - .5) + "," + (r - Ya - .5) + "h-3v" + (2 * Ya + 1) + "h3ZM" + (e.r + .5) + "," + (r - Ya - .5) + "h3v" + (2 * Ya + 1) + "h-3Z";
      }
      function GJ(e, r) {
        return "M" + (r - Ya - .5) + "," + (e.t - .5) + "v-3h" + (2 * Ya + 1) + "v3ZM" + (r - Ya - .5) + "," + (e.b + .5) + "v3h" + (2 * Ya + 1) + "v-3Z";
      }
      function Nh(e) {
        var r = Math.floor(Math.min(e.b - e.t, e.r - e.l, Ya) / 2);
        return "M" + (e.l - 3.5) + "," + (e.t - .5 + r) + "h3v" + -r + "h" + r + "v-3h-" + (r + 3) + "ZM" + (e.r + 3.5) + "," + (e.t - .5 + r) + "h-3v" + -r + "h" + -r + "v-3h" + (r + 3) + "ZM" + (e.r + 3.5) + "," + (e.b + .5 - r) + "h-3v" + r + "h" + -r + "v3h" + (r + 3) + "ZM" + (e.l - 3.5) + "," + (e.b + .5 - r) + "h3v" + r + "h" + r + "v3h-" + (r + 3) + "Z";
      }
      function uk(e, r, t, a, n) {
        for (var i = !1, l = {}, o = {}, s, u, f, v, h = (n || {}).xaHash, d = (n || {}).yaHash, y = 0; y < r.length; y++) {
          var g = r[y];
          for (s in t) if (g[s]) {
            for (f in g) !(n && (h[f] || d[f])) && !(f.charAt(0) === "x" ? t : a)[f] && (l[f] = s);
            for (u in a) !(n && (h[u] || d[u])) && g[u] && (i = !0);
          }
          for (u in a) if (g[u]) for (v in g) !(n && (h[v] || d[v])) && !(v.charAt(0) === "x" ? t : a)[v] && (o[v] = u);
        }
        i && (Dn.extendFlat(l, o), o = {});
        var m = {},
          _ = [];
        for (f in l) {
          var w = vg(e, f);
          _.push(w), m[w._id] = w;
        }
        var T = {},
          b = [];
        for (v in o) {
          var A = vg(e, v);
          b.push(A), T[A._id] = A;
        }
        return {
          xaHash: m,
          yaHash: T,
          xaxes: _,
          yaxes: b,
          xLinks: l,
          yLinks: o,
          isSubplotConstrained: i
        };
      }
      function xk(e, r) {
        if (!kJ) e.onwheel !== void 0 ? e.onwheel = r : e.onmousewheel !== void 0 ? e.onmousewheel = r : e.isAddedWheelEvent || (e.isAddedWheelEvent = !0, e.addEventListener("wheel", r, {
          passive: !1
        }));else {
          var t = e.onwheel !== void 0 ? "wheel" : "mousewheel";
          e._onwheel && e.removeEventListener(t, e._onwheel), e._onwheel = r, e.addEventListener(t, r, {
            passive: !1
          });
        }
      }
      function fk(e) {
        var r = [];
        for (var t in e) r.push(e[t]);
        return r;
      }
      _k.exports = {
        makeDragBox: HJ,
        makeDragger: hk,
        makeRectDragger: dk,
        makeZoombox: pk,
        makeCorners: mk,
        updateZoombox: yk,
        xyCorners: Nh,
        transitionZoombox: gk,
        removeZoombox: dg,
        showDoubleClickNotifier: bk,
        attachWheelEventHandler: xk
      };
    });
    var yg = Z(Ih => {
      "use strict";

      var VJ = Ir(),
        Fh = ki(),
        WJ = Qn(),
        ZJ = wl(),
        ei = wk().makeDragBox,
        $t = da().DRAGGERSIZE;
      Ih.initInteractions = function (r) {
        var t = r._fullLayout;
        if (r._context.staticPlot) {
          VJ.select(r).selectAll(".drag").remove();
          return;
        }
        if (!(!t._has("cartesian") && !t._has("splom"))) {
          var a = Object.keys(t._plots || {}).sort(function (i, l) {
            if ((t._plots[i].mainplot && !0) === (t._plots[l].mainplot && !0)) {
              var o = i.split("y"),
                s = l.split("y");
              return o[0] === s[0] ? Number(o[1] || 1) - Number(s[1] || 1) : Number(o[0] || 1) - Number(s[0] || 1);
            }
            return t._plots[i].mainplot ? 1 : -1;
          });
          a.forEach(function (i) {
            var l = t._plots[i],
              o = l.xaxis,
              s = l.yaxis;
            if (!l.mainplot) {
              var u = ei(r, l, o._offset, s._offset, o._length, s._length, "ns", "ew");
              u.onmousemove = function (h) {
                r._fullLayout._rehover = function () {
                  r._fullLayout._hoversubplot === i && r._fullLayout._plots[i] && Fh.hover(r, h, i);
                }, Fh.hover(r, h, i), r._fullLayout._lasthover = u, r._fullLayout._hoversubplot = i;
              }, u.onmouseout = function (h) {
                r._dragging || (r._fullLayout._hoversubplot = null, WJ.unhover(r, h));
              }, r._context.showAxisDragHandles && (ei(r, l, o._offset - $t, s._offset - $t, $t, $t, "n", "w"), ei(r, l, o._offset + o._length, s._offset - $t, $t, $t, "n", "e"), ei(r, l, o._offset - $t, s._offset + s._length, $t, $t, "s", "w"), ei(r, l, o._offset + o._length, s._offset + s._length, $t, $t, "s", "e"));
            }
            if (r._context.showAxisDragHandles) {
              if (i === o._mainSubplot) {
                var f = o._mainLinePosition;
                o.side === "top" && (f -= $t), ei(r, l, o._offset + o._length * .1, f, o._length * .8, $t, "", "ew"), ei(r, l, o._offset, f, o._length * .1, $t, "", "w"), ei(r, l, o._offset + o._length * .9, f, o._length * .1, $t, "", "e");
              }
              if (i === s._mainSubplot) {
                var v = s._mainLinePosition;
                s.side !== "right" && (v -= $t), ei(r, l, v, s._offset + s._length * .1, $t, s._length * .8, "ns", ""), ei(r, l, v, s._offset + s._length * .9, $t, s._length * .1, "s", ""), ei(r, l, v, s._offset, $t, s._length * .1, "n", "");
              }
            }
          });
          var n = t._hoverlayer.node();
          n.onmousemove = function (i) {
            i.target = r._fullLayout._lasthover, Fh.hover(r, i, t._hoversubplot);
          }, n.onclick = function (i) {
            i.target = r._fullLayout._lasthover, Fh.click(r, i);
          }, n.onmousedown = function (i) {
            r._fullLayout._lasthover.onmousedown(i);
          }, Ih.updateFx(r);
        }
      };
      Ih.updateFx = function (e) {
        var r = e._fullLayout,
          t = r.dragmode === "pan" ? "move" : "crosshair";
        ZJ(r._draggers, t);
      };
    });
    var Ak = Z((Tue, Mk) => {
      "use strict";

      var Tk = gr();
      Mk.exports = function (r) {
        for (var t = Tk.layoutArrayContainers, a = Tk.layoutArrayRegexes, n = r.split("[")[0], i, l, o = 0; o < a.length; o++) if (l = r.match(a[o]), l && l.index === 0) {
          i = l[0];
          break;
        }
        if (i || (i = t[t.indexOf(n)]), !i) return !1;
        var s = r.substr(i.length);
        return s ? (l = s.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/), l ? {
          array: i,
          index: Number(l[1]),
          property: l[3] || ""
        } : !1) : {
          array: i,
          index: "",
          property: ""
        };
      };
    });
    var Ck = Z(Vf => {
      "use strict";

      var XJ = nl(),
        gg = _v(),
        Gf = ro(),
        JJ = vp().sorterAsc,
        bg = gr();
      Vf.containerArrayMatch = Ak();
      var KJ = Vf.isAddVal = function (r) {
          return r === "add" || XJ(r);
        },
        kk = Vf.isRemoveVal = function (r) {
          return r === null || r === "remove";
        };
      Vf.applyContainerArrayChanges = function (r, t, a, n, i) {
        var l = t.astr,
          o = bg.getComponentMethod(l, "supplyLayoutDefaults"),
          s = bg.getComponentMethod(l, "draw"),
          u = bg.getComponentMethod(l, "drawOne"),
          f = n.replot || n.recalc || o === gg || s === gg,
          v = r.layout,
          h = r._fullLayout;
        if (a[""]) {
          Object.keys(a).length > 1 && Gf.warn("Full array edits are incompatible with other edits", l);
          var d = a[""][""];
          if (kk(d)) t.set(null);else if (Array.isArray(d)) t.set(d);else return Gf.warn("Unrecognized full array edit value", l, d), !0;
          return f ? !1 : (o(v, h), s(r), !0);
        }
        var y = Object.keys(a).map(Number).sort(JJ),
          g = t.get(),
          m = g || [],
          _ = i(h, l).get(),
          w = [],
          T = -1,
          b = m.length,
          A,
          S,
          k,
          q,
          D,
          R,
          z,
          N;
        for (A = 0; A < y.length; A++) {
          if (k = y[A], q = a[k], D = Object.keys(q), R = q[""], z = KJ(R), k < 0 || k > m.length - (z ? 0 : 1)) {
            Gf.warn("index out of range", l, k);
            continue;
          }
          if (R !== void 0) D.length > 1 && Gf.warn("Insertion & removal are incompatible with edits to the same index.", l, k), kk(R) ? w.push(k) : z ? (R === "add" && (R = {}), m.splice(k, 0, R), _ && _.splice(k, 0, {})) : Gf.warn("Unrecognized full object edit value", l, k, R), T === -1 && (T = k);else for (S = 0; S < D.length; S++) N = l + "[" + k + "].", i(m[k], D[S], N).set(q[D[S]]);
        }
        for (A = w.length - 1; A >= 0; A--) m.splice(w[A], 1), _ && _.splice(w[A], 1);
        if (m.length ? g || t.set(m) : t.set(null), f) return !1;
        if (o(v, h), u !== gg) {
          var H;
          if (T === -1) H = y;else {
            for (b = Math.max(m.length, b), H = [], A = 0; A < y.length && (k = y[A], !(k >= T)); A++) H.push(k);
            for (A = T; A < b; A++) H.push(A);
          }
          for (A = 0; A < H.length; A++) u(r, H[A]);
        } else s(r);
        return !0;
      };
    });
    var zk = Z(ri => {
      "use strict";

      var Dk = Hr(),
        Aue = tp(),
        Ek = gr(),
        en = He(),
        Wf = Pt(),
        Pk = Xt(),
        Rk = Er(),
        Zf = Pk.cleanId,
        QJ = Pk.getFromTrace,
        xg = Ek.traceIs;
      ri.clearPromiseQueue = function (e) {
        Array.isArray(e._promises) && e._promises.length > 0 && en.log("Clearing previous rejected promises from queue."), e._promises = [];
      };
      ri.cleanLayout = function (e) {
        var r, t;
        e || (e = {}), e.xaxis1 && (e.xaxis || (e.xaxis = e.xaxis1), delete e.xaxis1), e.yaxis1 && (e.yaxis || (e.yaxis = e.yaxis1), delete e.yaxis1), e.scene1 && (e.scene || (e.scene = e.scene1), delete e.scene1);
        var a = (Wf.subplotsRegistry.cartesian || {}).attrRegex,
          n = (Wf.subplotsRegistry.polar || {}).attrRegex,
          i = (Wf.subplotsRegistry.ternary || {}).attrRegex,
          l = (Wf.subplotsRegistry.gl3d || {}).attrRegex,
          o = Object.keys(e);
        for (r = 0; r < o.length; r++) {
          var s = o[r];
          if (a && a.test(s)) {
            var u = e[s];
            u.anchor && u.anchor !== "free" && (u.anchor = Zf(u.anchor)), u.overlaying && (u.overlaying = Zf(u.overlaying)), u.type || (u.isdate ? u.type = "date" : u.islog ? u.type = "log" : u.isdate === !1 && u.islog === !1 && (u.type = "linear")), (u.autorange === "withzero" || u.autorange === "tozero") && (u.autorange = !0, u.rangemode = "tozero"), u.insiderange && delete u.range, delete u.islog, delete u.isdate, delete u.categories, Hh(u, "domain") && delete u.domain;
          }
        }
        var f = Array.isArray(e.annotations) ? e.annotations.length : 0;
        for (r = 0; r < f; r++) {
          var v = e.annotations[r];
          en.isPlainObject(v) && (ru(v, "xref"), ru(v, "yref"));
        }
        var h = Array.isArray(e.shapes) ? e.shapes.length : 0;
        for (r = 0; r < h; r++) {
          var d = e.shapes[r];
          en.isPlainObject(d) && (ru(d, "xref"), ru(d, "yref"));
        }
        var y = Array.isArray(e.images) ? e.images.length : 0;
        for (r = 0; r < y; r++) {
          var g = e.images[r];
          en.isPlainObject(g) && (ru(g, "xref"), ru(g, "yref"));
        }
        var m = e.legend;
        return m && (m.x > 3 ? (m.x = 1.02, m.xanchor = "left") : m.x < -2 && (m.x = -.02, m.xanchor = "right"), m.y > 3 ? (m.y = 1.02, m.yanchor = "bottom") : m.y < -2 && (m.y = -.02, m.yanchor = "top")), e.dragmode === "rotate" && (e.dragmode = "orbit"), Rk.clean(e), e.template && e.template.layout && ri.cleanLayout(e.template.layout), e;
      };
      function ru(e, r) {
        var t = e[r],
          a = r.charAt(0);
        t && t !== "paper" && (e[r] = Zf(t, a, !0));
      }
      ri.cleanData = function (e) {
        for (var r = 0; r < e.length; r++) {
          var t = e[r],
            a;
          if (t.type === "histogramy" && "xbins" in t && !("ybins" in t) && (t.ybins = t.xbins, delete t.xbins), t.type === "histogramy" && ri.swapXYData(t), (t.type === "histogramx" || t.type === "histogramy") && (t.type = "histogram"), "scl" in t && !("colorscale" in t) && (t.colorscale = t.scl, delete t.scl), "reversescl" in t && !("reversescale" in t) && (t.reversescale = t.reversescl, delete t.reversescl), t.xaxis && (t.xaxis = Zf(t.xaxis, "x")), t.yaxis && (t.yaxis = Zf(t.yaxis, "y")), xg(t, "gl3d") && t.scene && (t.scene = Wf.subplotsRegistry.gl3d.cleanId(t.scene)), !xg(t, "pie-like") && !xg(t, "bar-like")) if (Array.isArray(t.textposition)) for (a = 0; a < t.textposition.length; a++) t.textposition[a] = Lk(t.textposition[a]);else t.textposition && (t.textposition = Lk(t.textposition));
          var n = Ek.getModule(t);
          if (n && n.colorbar) {
            var i = n.colorbar.container,
              l = i ? t[i] : t;
            l && l.colorscale && (l.colorscale === "YIGnBu" && (l.colorscale = "YlGnBu"), l.colorscale === "YIOrRd" && (l.colorscale = "YlOrRd"));
          }
          if (t.type === "surface" && en.isPlainObject(t.contours)) {
            var o = ["x", "y", "z"];
            for (a = 0; a < o.length; a++) {
              var s = t.contours[o[a]];
              en.isPlainObject(s) && (s.highlightColor && (s.highlightcolor = s.highlightColor, delete s.highlightColor), s.highlightWidth && (s.highlightwidth = s.highlightWidth, delete s.highlightWidth));
            }
          }
          if (t.type === "candlestick" || t.type === "ohlc") {
            var u = (t.increasing || {}).showlegend !== !1,
              f = (t.decreasing || {}).showlegend !== !1,
              v = Sk(t.increasing),
              h = Sk(t.decreasing);
            if (v !== !1 && h !== !1) {
              var d = $J(v, h, u, f);
              d && (t.name = d);
            } else (v || h) && !t.name && (t.name = v || h);
          }
          Hh(t, "line") && delete t.line, "marker" in t && (Hh(t.marker, "line") && delete t.marker.line, Hh(t, "marker") && delete t.marker), Rk.clean(t), t.autobinx && (delete t.autobinx, delete t.xbins), t.autobiny && (delete t.autobiny, delete t.ybins);
        }
      };
      function Sk(e) {
        if (!en.isPlainObject(e)) return !1;
        var r = e.name;
        return delete e.name, delete e.showlegend, (typeof r == "string" || typeof r == "number") && String(r);
      }
      function $J(e, r, t, a) {
        if (t && !a) return e;
        if (a && !t || !e.trim()) return r;
        if (!r.trim()) return e;
        var n = Math.min(e.length, r.length),
          i;
        for (i = 0; i < n && e.charAt(i) === r.charAt(i); i++);
        var l = e.substr(0, i);
        return l.trim();
      }
      function Lk(e) {
        var r = "middle",
          t = "center";
        return typeof e == "string" && (e.indexOf("top") !== -1 ? r = "top" : e.indexOf("bottom") !== -1 && (r = "bottom"), e.indexOf("left") !== -1 ? t = "left" : e.indexOf("right") !== -1 && (t = "right")), r + " " + t;
      }
      function Hh(e, r) {
        return r in e && typeof e[r] == "object" && Object.keys(e[r]).length === 0;
      }
      ri.swapXYData = function (e) {
        var r;
        if (en.swapAttrs(e, ["?", "?0", "d?", "?bins", "nbins?", "autobin?", "?src", "error_?"]), Array.isArray(e.z) && Array.isArray(e.z[0]) && (e.transpose ? delete e.transpose : e.transpose = !0), e.error_x && e.error_y) {
          var t = e.error_y,
            a = "copy_ystyle" in t ? t.copy_ystyle : !(t.color || t.thickness || t.width);
          en.swapAttrs(e, ["error_?.copy_ystyle"]), a && en.swapAttrs(e, ["error_?.color", "error_?.thickness", "error_?.width"]);
        }
        if (typeof e.hoverinfo == "string") {
          var n = e.hoverinfo.split("+");
          for (r = 0; r < n.length; r++) n[r] === "x" ? n[r] = "y" : n[r] === "y" && (n[r] = "x");
          e.hoverinfo = n.join("+");
        }
      };
      ri.coerceTraceIndices = function (e, r) {
        if (Dk(r)) return [r];
        if (!Array.isArray(r) || !r.length) return e.data.map(function (n, i) {
          return i;
        });
        if (Array.isArray(r)) {
          for (var t = [], a = 0; a < r.length; a++) en.isIndex(r[a], e.data.length) ? t.push(r[a]) : en.warn("trace index (", r[a], ") is not a number or is out of bounds");
          return t;
        }
        return r;
      };
      ri.manageArrayContainers = function (e, r, t) {
        var a = e.obj,
          n = e.parts,
          i = n.length,
          l = n[i - 1],
          o = Dk(l);
        if (o && r === null) {
          var s = n.slice(0, i - 1).join("."),
            u = en.nestedProperty(a, s).get();
          u.splice(l, 1);
        } else o && e.get() === void 0 && e.get() === void 0 && (t[e.astr] = null), e.set(r);
      };
      var jJ = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
      function qk(e) {
        var r = e.search(jJ);
        if (r > 0) return e.substr(0, r);
      }
      ri.hasParent = function (e, r) {
        for (var t = qk(r); t;) {
          if (t in e) return !0;
          t = qk(t);
        }
        return !1;
      };
      var eK = ["x", "y", "z"];
      ri.clearAxisTypes = function (e, r, t) {
        for (var a = 0; a < r.length; a++) for (var n = e._fullData[a], i = 0; i < 3; i++) {
          var l = QJ(e, n, eK[i]);
          if (l && l.type !== "log") {
            var o = l._name,
              s = l._id.substr(1);
            if (s.substr(0, 5) === "scene") {
              if (t[s] !== void 0) continue;
              o = s + "." + o;
            }
            var u = o + ".type";
            t[o] === void 0 && t[u] === void 0 && en.nestedProperty(e.layout, u).set(null);
          }
        }
      };
    });
    var Cg = Z(Gr => {
      "use strict";

      var Yh = Ir(),
        rK = Hr(),
        tK = kp(),
        $e = He(),
        ut = $e.nestedProperty,
        Tg = $u(),
        Ua = d6(),
        En = gr(),
        Jh = As(),
        xr = Pt(),
        Na = dt(),
        aK = Xm(),
        nK = Xn(),
        _g = tt(),
        iK = Er(),
        lK = yg().initInteractions,
        oK = fo(),
        sK = eu().clearOutline,
        Ok = eo().dfltConfig,
        Oh = Ck(),
        It = zk(),
        et = xh(),
        Sl = pi(),
        uK = da().AX_NAME_PATTERN,
        wg = 0,
        Nk = 5;
      function fK(e, r, t, a) {
        var n;
        if (e = $e.getGraphDiv(e), Tg.init(e), $e.isPlainObject(r)) {
          var i = r;
          r = i.data, t = i.layout, a = i.config, n = i.frames;
        }
        var l = Tg.triggerHandler(e, "plotly_beforeplot", [r, t, a]);
        if (l === !1) return Promise.reject();
        !r && !t && !$e.isPlotDiv(e) && $e.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", e);
        function o() {
          if (n) return Gr.addFrames(e, n);
        }
        Yk(e, a), t || (t = {}), Yh.select(e).classed("js-plotly-plot", !0), _g.makeTester(), Array.isArray(e._promises) || (e._promises = []);
        var s = (e.data || []).length === 0 && Array.isArray(r);
        Array.isArray(r) && (It.cleanData(r), s ? e.data = r : e.data.push.apply(e.data, r), e.empty = !1), (!e.layout || s) && (e.layout = It.cleanLayout(t)), xr.supplyDefaults(e);
        var u = e._fullLayout,
          f = u._has("cartesian");
        u._replotting = !0, (s || u._shouldCreateBgLayer) && (PK(e), u._shouldCreateBgLayer && delete u._shouldCreateBgLayer), _g.initGradients(e), _g.initPatterns(e), s && Na.saveShowSpikeInitial(e);
        var v = !e.calcdata || e.calcdata.length !== (e._fullData || []).length;
        v && xr.doCalcdata(e);
        for (var h = 0; h < e.calcdata.length; h++) e.calcdata[h][0].trace = e._fullData[h];
        e._context.responsive ? e._responsiveChartHandler || (e._responsiveChartHandler = function () {
          $e.isHidden(e) || xr.resize(e);
        }, window.addEventListener("resize", e._responsiveChartHandler)) : $e.clearResponsive(e);
        var d = $e.extendFlat({}, u._size),
          y = 0;
        function g() {
          for (var k = u._basePlotModules, q = 0; q < k.length; q++) k[q].drawFramework && k[q].drawFramework(e);
          !u._glcanvas && u._has("gl") && (u._glcanvas = u._glcontainer.selectAll(".gl-canvas").data([{
            key: "contextLayer",
            context: !0,
            pick: !1
          }, {
            key: "focusLayer",
            context: !1,
            pick: !1
          }, {
            key: "pickLayer",
            context: !1,
            pick: !0
          }], function (N) {
            return N.key;
          }), u._glcanvas.enter().append("canvas").attr("class", function (N) {
            return "gl-canvas gl-canvas-" + N.key.replace("Layer", "");
          }).style({
            position: "absolute",
            top: 0,
            left: 0,
            overflow: "visible",
            "pointer-events": "none"
          }));
          var D = e._context.plotGlPixelRatio;
          if (u._glcanvas) {
            u._glcanvas.attr("width", u.width * D).attr("height", u.height * D).style("width", u.width + "px").style("height", u.height + "px");
            var R = u._glcanvas.data()[0].regl;
            if (R && (Math.floor(u.width * D) !== R._gl.drawingBufferWidth || Math.floor(u.height * D) !== R._gl.drawingBufferHeight)) {
              var z = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
              if (y) $e.error(z);else return $e.log(z + " Clearing graph and plotting again."), xr.cleanPlot([], {}, e._fullData, u), xr.supplyDefaults(e), u = e._fullLayout, xr.doCalcdata(e), y++, g();
            }
          }
          return u.modebar.orientation === "h" ? u._modebardiv.style("height", null).style("width", "100%") : u._modebardiv.style("width", null).style("height", u.height + "px"), xr.previousPromises(e);
        }
        function m() {
          if (xr.clearAutoMarginIds(e), et.drawMarginPushers(e), Na.allowAutoMargin(e), e._fullLayout.title.text && e._fullLayout.title.automargin && xr.allowAutoMargin(e, "title.automargin"), u._has("pie")) for (var k = e._fullData, q = 0; q < k.length; q++) {
            var D = k[q];
            D.type === "pie" && D.automargin && xr.allowAutoMargin(e, "pie." + D.uid + ".automargin");
          }
          return xr.doAutoMargin(e), xr.previousPromises(e);
        }
        function _() {
          if (xr.didMarginChange(d, u._size)) return $e.syncOrAsync([m, et.layoutStyles], e);
        }
        function w() {
          if (!v) {
            T();
            return;
          }
          return $e.syncOrAsync([En.getComponentMethod("shapes", "calcAutorange"), En.getComponentMethod("annotations", "calcAutorange"), T], e);
        }
        function T() {
          e._transitioning || (et.doAutoRangeAndConstraints(e), s && Na.saveRangeInitial(e), En.getComponentMethod("rangeslider", "calcAutorange")(e));
        }
        function b() {
          return Na.draw(e, s ? "" : "redraw");
        }
        var A = [xr.previousPromises, o, g, m, _];
        f && A.push(w), A.push(et.layoutStyles), f && A.push(b, function (q) {
          var D = q._fullLayout._insideTickLabelsUpdaterange;
          if (D) return q._fullLayout._insideTickLabelsUpdaterange = void 0, Xf(q, D).then(function () {
            Na.saveRangeInitial(q, !0);
          });
        }), A.push(et.drawData, et.finalDraw, lK, xr.addLinks, xr.rehover, xr.redrag, xr.reselect, xr.doAutoMargin, xr.previousPromises);
        var S = $e.syncOrAsync(A, e);
        return (!S || !S.then) && (S = Promise.resolve()), S.then(function () {
          return Jf(e), e;
        });
      }
      function Jf(e) {
        var r = e._fullLayout;
        r._redrawFromAutoMarginCount ? r._redrawFromAutoMarginCount-- : e.emit("plotly_afterplot");
      }
      function cK(e) {
        return $e.extendFlat(Ok, e);
      }
      function Bk(e, r) {
        try {
          e._fullLayout._paper.style("background", r);
        } catch (t) {
          $e.error(t);
        }
      }
      function vK(e, r) {
        var t = iK.combine(r, "white");
        Bk(e, t);
      }
      function Yk(e, r) {
        if (!e._context) {
          e._context = $e.extendDeep({}, Ok);
          var t = Yh.select("base");
          e._context._baseUrl = t.size() && t.attr("href") ? window.location.href.split("#")[0] : "";
        }
        var a = e._context,
          n,
          i,
          l;
        if (r) {
          for (i = Object.keys(r), n = 0; n < i.length; n++) l = i[n], !(l === "editable" || l === "edits") && l in a && (l === "setBackground" && r[l] === "opaque" ? a[l] = vK : a[l] = r[l]);
          var o = r.editable;
          if (o !== void 0) for (a.editable = o, i = Object.keys(a.edits), n = 0; n < i.length; n++) a.edits[i[n]] = o;
          if (r.edits) for (i = Object.keys(r.edits), n = 0; n < i.length; n++) l = i[n], l in a.edits && (a.edits[l] = r.edits[l]);
          a._exportedPlot = r._exportedPlot;
        }
        a.staticPlot && (a.editable = !1, a.edits = {}, a.autosizable = !1, a.scrollZoom = !1, a.doubleClick = !1, a.showTips = !1, a.showLink = !1, a.displayModeBar = !1), a.displayModeBar === "hover" && !tK && (a.displayModeBar = !0), (a.setBackground === "transparent" || typeof a.setBackground != "function") && (a.setBackground = Bk), a._hasZeroHeight = a._hasZeroHeight || e.clientHeight === 0, a._hasZeroWidth = a._hasZeroWidth || e.clientWidth === 0;
        var s = a.scrollZoom,
          u = a._scrollZoom = {};
        if (s === !0) u.cartesian = 1, u.gl3d = 1, u.geo = 1, u.mapbox = 1, u.map = 1;else if (typeof s == "string") {
          var f = s.split("+");
          for (n = 0; n < f.length; n++) u[f[n]] = 1;
        } else s !== !1 && (u.gl3d = 1, u.geo = 1, u.mapbox = 1, u.map = 1);
      }
      function hK(e) {
        if (e = $e.getGraphDiv(e), !$e.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
        return It.cleanData(e.data), It.cleanLayout(e.layout), e.calcdata = void 0, Gr._doPlot(e).then(function () {
          return e.emit("plotly_redraw"), e;
        });
      }
      function dK(e, r, t, a) {
        return e = $e.getGraphDiv(e), xr.cleanPlot([], {}, e._fullData || [], e._fullLayout || {}), xr.purge(e), Gr._doPlot(e, r, t, a);
      }
      function Uh(e, r) {
        var t = r + 1,
          a = [],
          n,
          i;
        for (n = 0; n < e.length; n++) i = e[n], i < 0 ? a.push(t + i) : a.push(i);
        return a;
      }
      function Gh(e, r, t) {
        var a, n;
        for (a = 0; a < r.length; a++) {
          if (n = r[a], n !== parseInt(n, 10)) throw new Error("all values in " + t + " must be integers");
          if (n >= e.data.length || n < -e.data.length) throw new Error(t + " must be valid indices for gd.data.");
          if (r.indexOf(n, a + 1) > -1 || n >= 0 && r.indexOf(-e.data.length + n) > -1 || n < 0 && r.indexOf(e.data.length + n) > -1) throw new Error("each index in " + t + " must be unique.");
        }
      }
      function Uk(e, r, t) {
        if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
        if (typeof r == "undefined") throw new Error("currentIndices is a required argument.");
        if (Array.isArray(r) || (r = [r]), Gh(e, r, "currentIndices"), typeof t != "undefined" && !Array.isArray(t) && (t = [t]), typeof t != "undefined" && Gh(e, t, "newIndices"), typeof t != "undefined" && r.length !== t.length) throw new Error("current and new indices must be of equal length.");
      }
      function pK(e, r, t) {
        var a, n;
        if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
        if (typeof r == "undefined") throw new Error("traces must be defined.");
        for (Array.isArray(r) || (r = [r]), a = 0; a < r.length; a++) if (n = r[a], typeof n != "object" || Array.isArray(n) || n === null) throw new Error("all values in traces array must be non-array objects");
        if (typeof t != "undefined" && !Array.isArray(t) && (t = [t]), typeof t != "undefined" && t.length !== r.length) throw new Error("if indices is specified, traces.length must equal indices.length");
      }
      function mK(e, r, t, a) {
        var n = $e.isPlainObject(a);
        if (!Array.isArray(e.data)) throw new Error("gd.data must be an array");
        if (!$e.isPlainObject(r)) throw new Error("update must be a key:value object");
        if (typeof t == "undefined") throw new Error("indices must be an integer or array of integers");
        Gh(e, t, "indices");
        for (var i in r) {
          if (!Array.isArray(r[i]) || r[i].length !== t.length) throw new Error("attribute " + i + " must be an array of length equal to indices array length");
          if (n && (!(i in a) || !Array.isArray(a[i]) || a[i].length !== r[i].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
        }
      }
      function yK(e, r, t, a) {
        var n = $e.isPlainObject(a),
          i = [],
          l,
          o,
          s,
          u,
          f;
        Array.isArray(t) || (t = [t]), t = Uh(t, e.data.length - 1);
        for (var v in r) for (var h = 0; h < t.length; h++) {
          if (l = e.data[t[h]], s = ut(l, v), o = s.get(), u = r[v][h], !$e.isArrayOrTypedArray(u)) throw new Error("attribute: " + v + " index: " + h + " must be an array");
          if (!$e.isArrayOrTypedArray(o)) throw new Error("cannot extend missing or non-array attribute: " + v);
          if (o.constructor !== u.constructor) throw new Error("cannot extend array with an array of a different type: " + v);
          f = n ? a[v][h] : a, rK(f) || (f = -1), i.push({
            prop: s,
            target: o,
            insert: u,
            maxp: Math.floor(f)
          });
        }
        return i;
      }
      function Gk(e, r, t, a, n) {
        mK(e, r, t, a);
        for (var i = yK(e, r, t, a), l = {}, o = {}, s = 0; s < i.length; s++) {
          var u = i[s].prop,
            f = i[s].maxp,
            v = n(i[s].target, i[s].insert, f);
          u.set(v[0]), Array.isArray(l[u.astr]) || (l[u.astr] = []), l[u.astr].push(v[1]), Array.isArray(o[u.astr]) || (o[u.astr] = []), o[u.astr].push(i[s].target.length);
        }
        return {
          update: l,
          maxPoints: o
        };
      }
      function Vk(e, r) {
        var t = new e.constructor(e.length + r.length);
        return t.set(e), t.set(r, e.length), t;
      }
      function Wk(e, r, t, a) {
        e = $e.getGraphDiv(e);
        function n(s, u, f) {
          var v, h;
          if ($e.isTypedArray(s)) {
            if (f < 0) {
              var d = new s.constructor(0),
                y = Vk(s, u);
              f < 0 ? (v = y, h = d) : (v = d, h = y);
            } else if (v = new s.constructor(f), h = new s.constructor(s.length + u.length - f), f === u.length) v.set(u), h.set(s);else if (f < u.length) {
              var g = u.length - f;
              v.set(u.subarray(g)), h.set(s), h.set(u.subarray(0, g), s.length);
            } else {
              var m = f - u.length,
                _ = s.length - m;
              v.set(s.subarray(_)), v.set(u, m), h.set(s.subarray(0, _));
            }
          } else v = s.concat(u), h = f >= 0 && f < v.length ? v.splice(0, v.length - f) : [];
          return [v, h];
        }
        var i = Gk(e, r, t, a, n),
          l = Gr.redraw(e),
          o = [e, i.update, t, i.maxPoints];
        return Ua.add(e, Gr.prependTraces, o, Wk, arguments), l;
      }
      function Zk(e, r, t, a) {
        e = $e.getGraphDiv(e);
        function n(s, u, f) {
          var v, h;
          if ($e.isTypedArray(s)) {
            if (f <= 0) {
              var d = new s.constructor(0),
                y = Vk(u, s);
              f < 0 ? (v = y, h = d) : (v = d, h = y);
            } else if (v = new s.constructor(f), h = new s.constructor(s.length + u.length - f), f === u.length) v.set(u), h.set(s);else if (f < u.length) {
              var g = u.length - f;
              v.set(u.subarray(0, g)), h.set(u.subarray(g)), h.set(s, g);
            } else {
              var m = f - u.length;
              v.set(u), v.set(s.subarray(0, m), u.length), h.set(s.subarray(m));
            }
          } else v = u.concat(s), h = f >= 0 && f < v.length ? v.splice(f, v.length) : [];
          return [v, h];
        }
        var i = Gk(e, r, t, a, n),
          l = Gr.redraw(e),
          o = [e, i.update, t, i.maxPoints];
        return Ua.add(e, Gr.extendTraces, o, Zk, arguments), l;
      }
      function Xk(e, r, t) {
        e = $e.getGraphDiv(e);
        var a = [],
          n = Gr.deleteTraces,
          i = Xk,
          l = [e, a],
          o = [e, r],
          s,
          u;
        for (pK(e, r, t), Array.isArray(r) || (r = [r]), r = r.map(function (f) {
          return $e.extendFlat({}, f);
        }), It.cleanData(r), s = 0; s < r.length; s++) e.data.push(r[s]);
        for (s = 0; s < r.length; s++) a.push(-r.length + s);
        if (typeof t == "undefined") return u = Gr.redraw(e), Ua.add(e, n, l, i, o), u;
        Array.isArray(t) || (t = [t]);
        try {
          Uk(e, a, t);
        } catch (f) {
          throw e.data.splice(e.data.length - r.length, r.length), f;
        }
        return Ua.startSequence(e), Ua.add(e, n, l, i, o), u = Gr.moveTraces(e, a, t), Ua.stopSequence(e), u;
      }
      function Jk(e, r) {
        e = $e.getGraphDiv(e);
        var t = [],
          a = Gr.addTraces,
          n = Jk,
          i = [e, t, r],
          l = [e, r],
          o,
          s;
        if (typeof r == "undefined") throw new Error("indices must be an integer or array of integers.");
        for (Array.isArray(r) || (r = [r]), Gh(e, r, "indices"), r = Uh(r, e.data.length - 1), r.sort($e.sorterDes), o = 0; o < r.length; o += 1) s = e.data.splice(r[o], 1)[0], t.push(s);
        var u = Gr.redraw(e);
        return Ua.add(e, a, i, n, l), u;
      }
      function Mg(e, r, t) {
        e = $e.getGraphDiv(e);
        var a = [],
          n = [],
          i = Mg,
          l = Mg,
          o = [e, t, r],
          s = [e, r, t],
          u;
        if (Uk(e, r, t), r = Array.isArray(r) ? r : [r], typeof t == "undefined") for (t = [], u = 0; u < r.length; u++) t.push(-r.length + u);
        for (t = Array.isArray(t) ? t : [t], r = Uh(r, e.data.length - 1), t = Uh(t, e.data.length - 1), u = 0; u < e.data.length; u++) r.indexOf(u) === -1 && a.push(e.data[u]);
        for (u = 0; u < r.length; u++) n.push({
          newIndex: t[u],
          trace: e.data[r[u]]
        });
        for (n.sort(function (v, h) {
          return v.newIndex - h.newIndex;
        }), u = 0; u < n.length; u += 1) a.splice(n[u].newIndex, 0, n[u].trace);
        e.data = a;
        var f = Gr.redraw(e);
        return Ua.add(e, i, o, l, s), f;
      }
      function Vh(e, r, t, a) {
        e = $e.getGraphDiv(e), It.clearPromiseQueue(e);
        var n = {};
        if (typeof r == "string") n[r] = t;else if ($e.isPlainObject(r)) n = $e.extendFlat({}, r), a === void 0 && (a = t);else return $e.warn("Restyle fail.", r, t, a), Promise.reject();
        Object.keys(n).length && (e.changed = !0);
        var i = It.coerceTraceIndices(e, a),
          l = Kk(e, n, i),
          o = l.flags;
        o.calc && (e.calcdata = void 0), o.clearAxisTypes && It.clearAxisTypes(e, i, {});
        var s = [];
        o.fullReplot ? s.push(Gr._doPlot) : (s.push(xr.previousPromises), xr.supplyDefaults(e), o.markerSize && (xr.doCalcdata(e), Kh(s)), o.style && s.push(et.doTraceStyle), o.colorbars && s.push(et.doColorBars), s.push(Jf)), s.push(xr.rehover, xr.redrag, xr.reselect), Ua.add(e, Vh, [e, l.undoit, l.traces], Vh, [e, l.redoit, l.traces]);
        var u = $e.syncOrAsync(s, e);
        return (!u || !u.then) && (u = Promise.resolve()), u.then(function () {
          return e.emit("plotly_restyle", l.eventData), e;
        });
      }
      function Xi(e) {
        return e === void 0 ? null : e;
      }
      function Bh(e, r) {
        return r ? function (t, a, n) {
          var i = ut(t, a),
            l = i.set;
          return i.set = function (o) {
            var s = (n || "") + a;
            Wh(s, i.get(), o, e), l(o);
          }, i;
        } : ut;
      }
      function Wh(e, r, t, a) {
        if (Array.isArray(r) || Array.isArray(t)) for (var n = Array.isArray(r) ? r : [], i = Array.isArray(t) ? t : [], l = Math.max(n.length, i.length), o = 0; o < l; o++) Wh(e + "[" + o + "]", n[o], i[o], a);else if ($e.isPlainObject(r) || $e.isPlainObject(t)) {
          var s = $e.isPlainObject(r) ? r : {},
            u = $e.isPlainObject(t) ? t : {},
            f = $e.extendFlat({}, s, u);
          for (var v in f) Wh(e + "." + v, s[v], u[v], a);
        } else a[e] === void 0 && (a[e] = Xi(r));
      }
      function gK(e, r, t) {
        for (var a in t) {
          var n = ut(e, a);
          Wh(a, n.get(), t[a], r);
        }
      }
      function Kk(e, r, t) {
        var a = e._fullLayout,
          n = e._fullData,
          i = e.data,
          l = a._guiEditing,
          o = Bh(a._preGUI, l),
          s = $e.extendDeepAll({}, r),
          u,
          f = Sl.traceFlags(),
          v = {},
          h = {},
          d;
        function y() {
          return t.map(function () {});
        }
        function g(Y) {
          var re = Na.id2name(Y);
          d.indexOf(re) === -1 && d.push(re);
        }
        function m(Y) {
          return "LAYOUT" + Y + ".autorange";
        }
        function _(Y) {
          return "LAYOUT" + Y + ".range";
        }
        function w(Y) {
          for (var re = Y; re < n.length; re++) if (n[re]._input === i[Y]) return n[re];
        }
        function T(Y, re, U) {
          if (Array.isArray(Y)) {
            Y.forEach(function (Fe) {
              T(Fe, re, U);
            });
            return;
          }
          if (!(Y in r || It.hasParent(r, Y))) {
            var de;
            if (Y.substr(0, 6) === "LAYOUT") de = o(e.layout, Y.replace("LAYOUT", ""));else {
              var be = t[U],
                ye = a._tracePreGUI[w(be)._fullInput.uid];
              de = Bh(ye, l)(i[be], Y);
            }
            Y in h || (h[Y] = y()), h[Y][U] === void 0 && (h[Y][U] = Xi(de.get())), re !== void 0 && de.set(re);
          }
        }
        function b(Y) {
          return function (re) {
            return n[re][Y];
          };
        }
        function A(Y) {
          return function (re, U) {
            return re === !1 ? n[t[U]][Y] : null;
          };
        }
        for (var S in r) {
          if (It.hasParent(r, S)) throw new Error("cannot set " + S + " and a parent attribute simultaneously");
          var k = r[S],
            q,
            D,
            R,
            z,
            N,
            H;
          if ((S === "autobinx" || S === "autobiny") && (S = S.charAt(S.length - 1) + "bins", Array.isArray(k) ? k = k.map(A(S)) : k === !1 ? k = t.map(b(S)) : k = null), v[S] = k, S.substr(0, 6) === "LAYOUT") {
            R = o(e.layout, S.replace("LAYOUT", "")), h[S] = [Xi(R.get())], R.set(Array.isArray(k) ? k[0] : k), f.calc = !0;
            continue;
          }
          for (h[S] = y(), u = 0; u < t.length; u++) {
            q = i[t[u]], D = w(t[u]);
            var O = a._tracePreGUI[D._fullInput.uid];
            if (R = Bh(O, l)(q, S), z = R.get(), N = Array.isArray(k) ? k[u % k.length] : k, N !== void 0) {
              var J = R.parts[R.parts.length - 1],
                X = S.substr(0, S.length - J.length - 1),
                B = X ? X + "." : "",
                I = X ? ut(D, X).get() : D;
              if (H = Jh.getTraceValObject(D, R.parts), H && H.impliedEdits && N !== null) for (var V in H.impliedEdits) T($e.relativeAttr(S, V), H.impliedEdits[V], u);else if ((J === "thicknessmode" || J === "lenmode") && z !== N && (N === "fraction" || N === "pixels") && I) {
                var K = a._size,
                  Q = I.orient,
                  ie = Q === "top" || Q === "bottom";
                if (J === "thicknessmode") {
                  var me = ie ? K.h : K.w;
                  T(B + "thickness", I.thickness * (N === "fraction" ? 1 / me : me), u);
                } else {
                  var pe = ie ? K.w : K.h;
                  T(B + "len", I.len * (N === "fraction" ? 1 / pe : pe), u);
                }
              } else if (S === "type" && (N === "pie" != (z === "pie") || N === "funnelarea" != (z === "funnelarea"))) {
                var ge = "x",
                  j = "y";
                (N === "bar" || z === "bar") && q.orientation === "h" && (ge = "y", j = "x"), $e.swapAttrs(q, ["?", "?src"], "labels", ge), $e.swapAttrs(q, ["d?", "?0"], "label", ge), $e.swapAttrs(q, ["?", "?src"], "values", j), z === "pie" || z === "funnelarea" ? (ut(q, "marker.color").set(ut(q, "marker.colors").get()), a._pielayer.selectAll("g.trace").remove()) : En.traceIs(q, "cartesian") && ut(q, "marker.colors").set(ut(q, "marker.color").get());
              }
              h[S][u] = Xi(z);
              var _e = ["swapxy", "swapxyaxes", "orientation", "orientationaxes"];
              if (_e.indexOf(S) !== -1) {
                if (S === "orientation") {
                  R.set(N);
                  var se = q.x && !q.y ? "h" : "v";
                  if ((R.get() || se) === D.orientation) continue;
                } else S === "orientationaxes" && (q.orientation = {
                  v: "h",
                  h: "v"
                }[D.orientation]);
                It.swapXYData(q), f.calc = f.clearAxisTypes = !0;
              } else xr.dataArrayContainers.indexOf(R.parts[0]) !== -1 ? (It.manageArrayContainers(R, N, h), f.calc = !0) : (H ? H.arrayOk && !En.traceIs(D, "regl") && ($e.isArrayOrTypedArray(N) || $e.isArrayOrTypedArray(z)) ? f.calc = !0 : Sl.update(f, H) : f.calc = !0, R.set(N));
            }
          }
          if (["swapxyaxes", "orientationaxes"].indexOf(S) !== -1 && Na.swap(e, t), S === "orientationaxes") {
            var Se = ut(e.layout, "hovermode"),
              ve = Se.get();
            ve === "x" ? Se.set("y") : ve === "y" ? Se.set("x") : ve === "x unified" ? Se.set("y unified") : ve === "y unified" && Se.set("x unified");
          }
          if (["orientation", "type"].indexOf(S) !== -1) {
            for (d = [], u = 0; u < t.length; u++) {
              var Ae = i[t[u]];
              En.traceIs(Ae, "cartesian") && (g(Ae.xaxis || "x"), g(Ae.yaxis || "y"));
            }
            T(d.map(m), !0, 0), T(d.map(_), [0, 1], 0);
          }
        }
        return (f.calc || f.plot) && (f.fullReplot = !0), {
          flags: f,
          undoit: h,
          redoit: v,
          traces: t,
          eventData: $e.extendDeepNoArrays([], [s, t])
        };
      }
      function Xf(e, r, t) {
        e = $e.getGraphDiv(e), It.clearPromiseQueue(e);
        var a = {};
        if (typeof r == "string") a[r] = t;else if ($e.isPlainObject(r)) a = $e.extendFlat({}, r);else return $e.warn("Relayout fail.", r, t), Promise.reject();
        Object.keys(a).length && (e.changed = !0);
        var n = eC(e, a),
          i = n.flags;
        i.calc && (e.calcdata = void 0);
        var l = [xr.previousPromises];
        i.layoutReplot ? l.push(et.layoutReplot) : Object.keys(a).length && (Qk(e, i, n) || xr.supplyDefaults(e), i.legend && l.push(et.doLegend), i.layoutstyle && l.push(et.layoutStyles), i.axrange && Kh(l, n.rangesAltered), i.ticks && l.push(et.doTicksRelayout), i.modebar && l.push(et.doModeBar), i.camera && l.push(et.doCamera), i.colorbars && l.push(et.doColorBars), l.push(Jf)), l.push(xr.rehover, xr.redrag, xr.reselect), Ua.add(e, Xf, [e, n.undoit], Xf, [e, n.redoit]);
        var o = $e.syncOrAsync(l, e);
        return (!o || !o.then) && (o = Promise.resolve(e)), o.then(function () {
          return e.emit("plotly_relayout", n.eventData), e;
        });
      }
      function Qk(e, r, t) {
        var a = e._fullLayout;
        if (!r.axrange) return !1;
        for (var n in r) if (n !== "axrange" && r[n]) return !1;
        var i,
          l,
          o = function (d, y) {
            return $e.coerce(i, l, nK, d, y);
          },
          s = {};
        for (var u in t.rangesAltered) {
          var f = Na.id2name(u);
          if (i = e.layout[f], l = a[f], aK(i, l, o, s), l._matchGroup) {
            for (var v in l._matchGroup) if (v !== u) {
              var h = a[Na.id2name(v)];
              h.autorange = l.autorange, h.range = l.range.slice(), h._input.range = l.range.slice();
            }
          }
        }
        return !0;
      }
      function Kh(e, r) {
        var t = r ? function (a) {
          var n = [],
            i = !0;
          for (var l in r) {
            var o = Na.getFromId(a, l);
            if (n.push(l), (o.ticklabelposition || "").indexOf("inside") !== -1 && o._anchorAxis && n.push(o._anchorAxis._id), o._matchGroup) for (var s in o._matchGroup) r[s] || n.push(s);
          }
          return Na.draw(a, n, {
            skipTitle: i
          });
        } : function (a) {
          return Na.draw(a, "redraw");
        };
        e.push(sK, et.doAutoRangeAndConstraints, t, et.drawData, et.finalDraw);
      }
      var $k = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/,
        jk = /^[xyz]axis[0-9]*\.autorange$/,
        bK = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
      function eC(e, r) {
        var t = e.layout,
          a = e._fullLayout,
          n = a._guiEditing,
          i = Bh(a._preGUI, n),
          l = Object.keys(r),
          o = Na.list(e),
          s = $e.extendDeepAll({}, r),
          u = {},
          f,
          v,
          h;
        for (l = Object.keys(r), v = 0; v < l.length; v++) if (l[v].indexOf("allaxes") === 0) {
          for (h = 0; h < o.length; h++) {
            var d = o[h]._id.substr(1),
              y = d.indexOf("scene") !== -1 ? d + "." : "",
              g = l[v].replace("allaxes", y + o[h]._name);
            r[g] || (r[g] = r[l[v]]);
          }
          delete r[l[v]];
        }
        var m = Sl.layoutFlags(),
          _ = {},
          w = {};
        function T(ye, Fe) {
          if (Array.isArray(ye)) {
            ye.forEach(function (Pe) {
              T(Pe, Fe);
            });
            return;
          }
          if (!(ye in r || It.hasParent(r, ye))) {
            var Re = i(t, ye);
            ye in w || (w[ye] = Xi(Re.get())), Fe !== void 0 && Re.set(Fe);
          }
        }
        var b = {},
          A;
        function S(ye) {
          var Fe = Na.name2id(ye.split(".")[0]);
          return b[Fe] = 1, Fe;
        }
        for (var k in r) {
          if (It.hasParent(r, k)) throw new Error("cannot set " + k + " and a parent attribute simultaneously");
          for (var q = i(t, k), D = r[k], R = q.parts.length, z = R - 1; z > 0 && typeof q.parts[z] != "string";) z--;
          var N = q.parts[z],
            H = q.parts[z - 1] + "." + N,
            O = q.parts.slice(0, z).join("."),
            J = ut(e.layout, O).get(),
            X = ut(a, O).get(),
            B = q.get();
          if (D !== void 0) {
            _[k] = D, w[k] = N === "reverse" ? D : Xi(B);
            var I = Jh.getLayoutValObject(a, q.parts);
            if (I && I.impliedEdits && D !== null) for (var V in I.impliedEdits) T($e.relativeAttr(k, V), I.impliedEdits[V]);
            if (["width", "height"].indexOf(k) !== -1) {
              if (D) {
                T("autosize", null);
                var K = k === "height" ? "width" : "height";
                T(K, a[K]);
              } else a[k] = e._initialAutoSize[k];
            } else if (k === "autosize") T("width", D ? null : a.width), T("height", D ? null : a.height);else if (H.match($k)) S(H), ut(a, O + "._inputRange").set(null);else if (H.match(jk)) {
              S(H), ut(a, O + "._inputRange").set(null);
              var Q = ut(a, O).get();
              Q._inputDomain && (Q._input.domain = Q._inputDomain.slice());
            } else H.match(bK) && ut(a, O + "._inputDomain").set(null);
            if (N === "type") {
              A = J;
              var ie = X.type === "linear" && D === "log",
                me = X.type === "log" && D === "linear";
              if (ie || me) {
                if (!A || !A.range) T(O + ".autorange", !0);else if (X.autorange) ie && (A.range = A.range[1] > A.range[0] ? [1, 2] : [2, 1]);else {
                  var pe = A.range[0],
                    ge = A.range[1];
                  ie ? (pe <= 0 && ge <= 0 && T(O + ".autorange", !0), pe <= 0 ? pe = ge / 1e6 : ge <= 0 && (ge = pe / 1e6), T(O + ".range[0]", Math.log(pe) / Math.LN10), T(O + ".range[1]", Math.log(ge) / Math.LN10)) : (T(O + ".range[0]", Math.pow(10, pe)), T(O + ".range[1]", Math.pow(10, ge)));
                }
                Array.isArray(a._subplots.polar) && a._subplots.polar.length && a[q.parts[0]] && q.parts[1] === "radialaxis" && delete a[q.parts[0]]._subplot.viewInitial["radialaxis.range"], En.getComponentMethod("annotations", "convertCoords")(e, X, D, T), En.getComponentMethod("images", "convertCoords")(e, X, D, T);
              } else T(O + ".autorange", !0), T(O + ".range", null);
              ut(a, O + "._inputRange").set(null);
            } else if (N.match(uK)) {
              var j = ut(a, k).get(),
                _e = (D || {}).type;
              (!_e || _e === "-") && (_e = "linear"), En.getComponentMethod("annotations", "convertCoords")(e, j, _e, T), En.getComponentMethod("images", "convertCoords")(e, j, _e, T);
            }
            var se = Oh.containerArrayMatch(k);
            if (se) {
              f = se.array, v = se.index;
              var Se = se.property,
                ve = I || {
                  editType: "calc"
                };
              v !== "" && Se === "" && (Oh.isAddVal(D) ? w[k] = null : Oh.isRemoveVal(D) ? w[k] = (ut(t, f).get() || [])[v] : $e.warn("unrecognized full object value", r)), Sl.update(m, ve), u[f] || (u[f] = {});
              var Ae = u[f][v];
              Ae || (Ae = u[f][v] = {}), Ae[Se] = D, delete r[k];
            } else N === "reverse" ? (J.range ? J.range.reverse() : (T(O + ".autorange", !0), J.range = [1, 0]), X.autorange ? m.calc = !0 : m.plot = !0) : (k === "dragmode" && (D === !1 && B !== !1 || D !== !1 && B === !1) || a._has("scatter-like") && a._has("regl") && k === "dragmode" && (D === "lasso" || D === "select") && !(B === "lasso" || B === "select") ? m.plot = !0 : I ? Sl.update(m, I) : m.calc = !0, q.set(D));
          }
        }
        for (f in u) {
          var Y = Oh.applyContainerArrayChanges(e, i(t, f), u[f], m, i);
          Y || (m.plot = !0);
        }
        for (var re in b) {
          A = Na.getFromId(e, re);
          var U = A && A._constraintGroup;
          if (U) {
            m.calc = !0;
            for (var de in U) b[de] || (Na.getFromId(e, de)._constraintShrinkable = !0);
          }
        }
        (rC(e) || r.height || r.width) && (m.plot = !0);
        var be = a.shapes;
        for (v = 0; v < be.length; v++) if (be[v].showlegend) {
          m.calc = !0;
          break;
        }
        return (m.plot || m.calc) && (m.layoutReplot = !0), {
          flags: m,
          rangesAltered: b,
          undoit: w,
          redoit: _,
          eventData: s
        };
      }
      function rC(e) {
        var r = e._fullLayout,
          t = r.width,
          a = r.height;
        return e.layout.autosize && xr.plotAutoSize(e, e.layout, r), r.width !== t || r.height !== a;
      }
      function Zh(e, r, t, a) {
        e = $e.getGraphDiv(e), It.clearPromiseQueue(e), $e.isPlainObject(r) || (r = {}), $e.isPlainObject(t) || (t = {}), Object.keys(r).length && (e.changed = !0), Object.keys(t).length && (e.changed = !0);
        var n = It.coerceTraceIndices(e, a),
          i = Kk(e, $e.extendFlat({}, r), n),
          l = i.flags,
          o = eC(e, $e.extendFlat({}, t)),
          s = o.flags;
        (l.calc || s.calc) && (e.calcdata = void 0), l.clearAxisTypes && It.clearAxisTypes(e, n, t);
        var u = [];
        s.layoutReplot ? u.push(et.layoutReplot) : l.fullReplot ? u.push(Gr._doPlot) : (u.push(xr.previousPromises), Qk(e, s, o) || xr.supplyDefaults(e), l.style && u.push(et.doTraceStyle), (l.colorbars || s.colorbars) && u.push(et.doColorBars), s.legend && u.push(et.doLegend), s.layoutstyle && u.push(et.layoutStyles), s.axrange && Kh(u, o.rangesAltered), s.ticks && u.push(et.doTicksRelayout), s.modebar && u.push(et.doModeBar), s.camera && u.push(et.doCamera), u.push(Jf)), u.push(xr.rehover, xr.redrag, xr.reselect), Ua.add(e, Zh, [e, i.undoit, o.undoit, i.traces], Zh, [e, i.redoit, o.redoit, i.traces]);
        var f = $e.syncOrAsync(u, e);
        return (!f || !f.then) && (f = Promise.resolve(e)), f.then(function () {
          return e.emit("plotly_update", {
            data: i.eventData,
            layout: o.eventData
          }), e;
        });
      }
      function kg(e) {
        return function (t) {
          t._fullLayout._guiEditing = !0;
          var a = e.apply(null, arguments);
          return t._fullLayout._guiEditing = !1, a;
        };
      }
      var xK = [{
          pattern: /^hiddenlabels/,
          attr: "legend.uirevision"
        }, {
          pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
        }, {
          pattern: /axis\d*\.showspikes$/,
          attr: "modebar.uirevision"
        }, {
          pattern: /(hover|drag)mode$/,
          attr: "modebar.uirevision"
        }, {
          pattern: /^(scene\d*)\.camera/
        }, {
          pattern: /^(geo\d*)\.(projection|center|fitbounds)/
        }, {
          pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
        }, {
          pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
        }, {
          pattern: /^(polar\d*\.angularaxis)\.rotation/
        }, {
          pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
        }, {
          pattern: /^(map\d*)\.(center|zoom|bearing|pitch)/
        }, {
          pattern: /^legend\.(x|y)$/,
          attr: "editrevision"
        }, {
          pattern: /^(shapes|annotations)/,
          attr: "editrevision"
        }, {
          pattern: /^title\.text$/,
          attr: "editrevision"
        }],
        _K = [{
          pattern: /^selectedpoints$/,
          attr: "selectionrevision"
        }, {
          pattern: /(^|value\.)visible$/,
          attr: "legend.uirevision"
        }, {
          pattern: /^dimensions\[\d+\]\.constraintrange/
        }, {
          pattern: /^node\.(x|y|groups)/
        }, {
          pattern: /^level$/
        }, {
          pattern: /(^|value\.)name$/
        }, {
          pattern: /colorbar\.title\.text$/
        }, {
          pattern: /colorbar\.(x|y)$/,
          attr: "editrevision"
        }];
      function Fk(e, r) {
        for (var t = 0; t < r.length; t++) {
          var a = r[t],
            n = e.match(a.pattern);
          if (n) {
            var i = n[1] || "";
            return {
              head: i,
              tail: e.substr(i.length + 1),
              attr: a.attr
            };
          }
        }
      }
      function Ik(e, r) {
        var t = ut(r, e).get();
        if (t !== void 0) return t;
        var a = e.split(".");
        for (a.pop(); a.length > 1;) if (a.pop(), t = ut(r, a.join(".") + ".uirevision").get(), t !== void 0) return t;
        return r.uirevision;
      }
      function wK(e, r) {
        for (var t = 0; t < r.length; t++) if (r[t]._fullInput.uid === e) return t;
        return -1;
      }
      function TK(e, r, t) {
        for (var a = 0; a < r.length; a++) if (r[a].uid === e) return a;
        return !r[t] || r[t].uid ? -1 : t;
      }
      function Hk(e, r) {
        var t = $e.isPlainObject(e),
          a = Array.isArray(e);
        return t || a ? (t && $e.isPlainObject(r) || a && Array.isArray(r)) && JSON.stringify(e) === JSON.stringify(r) : e === r;
      }
      function MK(e, r, t, a) {
        var n = a._preGUI,
          i,
          l,
          o,
          s,
          u,
          f,
          v,
          h,
          d,
          y,
          g = [],
          m = {},
          _ = {};
        for (i in n) {
          if (u = Fk(i, xK), u) {
            if (d = u.head, y = u.tail, l = u.attr || d + ".uirevision", o = ut(a, l).get(), s = o && Ik(l, r), s && s === o) {
              if (f = n[i], f === null && (f = void 0), v = ut(r, i), h = v.get(), Hk(h, f)) {
                h === void 0 && y === "autorange" && g.push(d), v.set(Xi(ut(a, i).get()));
                continue;
              } else if (y === "autorange" || y.substr(0, 6) === "range[") {
                var w = n[d + ".range[0]"],
                  T = n[d + ".range[1]"],
                  b = n[d + ".autorange"];
                if (b || b === null && w === null && T === null) {
                  if (!(d in m)) {
                    var A = ut(r, d).get();
                    m[d] = A && (A.autorange || A.autorange !== !1 && (!A.range || A.range.length !== 2));
                  }
                  if (m[d]) {
                    v.set(Xi(ut(a, i).get()));
                    continue;
                  }
                }
              }
            }
          } else $e.warn("unrecognized GUI edit: " + i);
          delete n[i], u && u.tail.substr(0, 6) === "range[" && (_[u.head] = 1);
        }
        for (var S = 0; S < g.length; S++) {
          var k = g[S];
          if (_[k]) {
            var q = ut(r, k).get();
            q && delete q.autorange;
          }
        }
        var D = a._tracePreGUI;
        for (var R in D) {
          var z = D[R],
            N = null,
            H;
          for (i in z) {
            if (!N) {
              var O = wK(R, t);
              if (O < 0) {
                delete D[R];
                break;
              }
              var J = t[O];
              H = J._fullInput;
              var X = TK(R, e, H.index);
              if (X < 0) {
                delete D[R];
                break;
              }
              N = e[X];
            }
            if (u = Fk(i, _K), u) {
              if (u.attr ? (o = ut(a, u.attr).get(), s = o && Ik(u.attr, r)) : (o = H.uirevision, s = N.uirevision, s === void 0 && (s = r.uirevision)), s && s === o && (f = z[i], f === null && (f = void 0), v = ut(N, i), h = v.get(), Hk(h, f))) {
                v.set(Xi(ut(H, i).get()));
                continue;
              }
            } else $e.warn("unrecognized GUI edit: " + i + " in trace uid " + R);
            delete z[i];
          }
        }
      }
      function AK(e, r, t, a) {
        var n, i;
        function l() {
          return Gr.addFrames(e, n);
        }
        e = $e.getGraphDiv(e), It.clearPromiseQueue(e);
        var o = e._fullData,
          s = e._fullLayout;
        if (!$e.isPlotDiv(e) || !o || !s) i = Gr.newPlot(e, r, t, a);else {
          if ($e.isPlainObject(r)) {
            var u = r;
            r = u.data, t = u.layout, a = u.config, n = u.frames;
          }
          var f = !1;
          if (a) {
            var v = $e.extendDeep({}, e._context);
            e._context = void 0, Yk(e, a), f = Ag(v, e._context);
          }
          e.data = r || [], It.cleanData(e.data), e.layout = t || {}, It.cleanLayout(e.layout), MK(e.data, e.layout, o, s), xr.supplyDefaults(e, {
            skipUpdateCalc: !0
          });
          var h = e._fullData,
            d = e._fullLayout,
            y = d.datarevision === void 0,
            g = d.transition,
            m = CK(e, s, d, y, g),
            _ = m.newDataRevision,
            w = kK(e, o, h, y, g, _);
          if (rC(e) && (m.layoutReplot = !0), w.calc || m.calc) {
            e.calcdata = void 0;
            for (var T = Object.getOwnPropertyNames(d), b = 0; b < T.length; b++) {
              var A = T[b],
                S = A.substring(0, 5);
              if (S === "xaxis" || S === "yaxis") {
                var k = d[A]._emptyCategories;
                k && k();
              }
            }
          } else xr.supplyDefaultsUpdateCalc(e.calcdata, h);
          var q = [];
          if (n && (e._transitionData = {}, xr.createTransitionData(e), q.push(l)), d.transition && !f && (w.anim || m.anim)) m.ticks && q.push(et.doTicksRelayout), xr.doCalcdata(e), et.doAutoRangeAndConstraints(e), q.push(function () {
            return xr.transitionFromReact(e, w, m, s);
          });else if (w.fullReplot || m.layoutReplot || f) e._fullLayout._skipDefaults = !0, q.push(Gr._doPlot);else {
            for (var D in m.arrays) {
              var R = m.arrays[D];
              if (R.length) {
                var z = En.getComponentMethod(D, "drawOne");
                if (z !== $e.noop) for (var N = 0; N < R.length; N++) z(e, R[N]);else {
                  var H = En.getComponentMethod(D, "draw");
                  if (H === $e.noop) throw new Error("cannot draw components: " + D);
                  H(e);
                }
              }
            }
            q.push(xr.previousPromises), w.style && q.push(et.doTraceStyle), (w.colorbars || m.colorbars) && q.push(et.doColorBars), m.legend && q.push(et.doLegend), m.layoutstyle && q.push(et.layoutStyles), m.axrange && Kh(q), m.ticks && q.push(et.doTicksRelayout), m.modebar && q.push(et.doModeBar), m.camera && q.push(et.doCamera), q.push(Jf);
          }
          q.push(xr.rehover, xr.redrag, xr.reselect), i = $e.syncOrAsync(q, e), (!i || !i.then) && (i = Promise.resolve(e));
        }
        return i.then(function () {
          return e.emit("plotly_react", {
            data: r,
            layout: t
          }), e;
        });
      }
      function kK(e, r, t, a, n, i) {
        var l = r.length === t.length;
        if (!n && !l) return {
          fullReplot: !0,
          calc: !0
        };
        var o = Sl.traceFlags();
        o.arrays = {}, o.nChanges = 0, o.nChangesAnim = 0;
        var s, u;
        function f(d) {
          var y = Jh.getTraceValObject(u, d);
          return !u._module.animatable && y.anim && (y.anim = !1), y;
        }
        var v = {
            getValObject: f,
            flags: o,
            immutable: a,
            transition: n,
            newDataRevision: i,
            gd: e
          },
          h = {};
        for (s = 0; s < r.length; s++) if (t[s]) {
          if (u = t[s]._fullInput, h[u.uid]) continue;
          h[u.uid] = 1, Xh(r[s]._fullInput, u, [], v);
        }
        return (o.calc || o.plot) && (o.fullReplot = !0), n && o.nChanges && o.nChangesAnim && (o.anim = o.nChanges === o.nChangesAnim && l ? "all" : "some"), o;
      }
      function CK(e, r, t, a, n) {
        var i = Sl.layoutFlags();
        i.arrays = {}, i.rangesAltered = {}, i.nChanges = 0, i.nChangesAnim = 0;
        function l(h) {
          return Jh.getLayoutValObject(t, h);
        }
        for (var o in t) if (!(!o.startsWith("xaxis") && !o.startsWith("yaxis")) && r[o]) {
          var s = t[o].domain,
            u = r[o].domain,
            f = r[o]._inputDomain;
          r[o]._inputDomain && (s[0] === f[0] && s[1] === f[1] ? t[o].domain = r[o].domain : (s[0] !== u[0] || s[1] !== u[1]) && (t[o]._inputDomain = null));
        }
        var v = {
          getValObject: l,
          flags: i,
          immutable: a,
          transition: n,
          gd: e
        };
        return Xh(r, t, [], v), (i.plot || i.calc) && (i.layoutReplot = !0), n && i.nChanges && i.nChangesAnim && (i.anim = i.nChanges === i.nChangesAnim ? "all" : "some"), i;
      }
      function Xh(e, r, t, a) {
        var n,
          i,
          l,
          o = a.getValObject,
          s = a.flags,
          u = a.immutable,
          f = a.inArray,
          v = a.arrayIndex;
        function h() {
          var O = n.editType;
          if (f && O.indexOf("arraydraw") !== -1) {
            $e.pushUnique(s.arrays[f], v);
            return;
          }
          Sl.update(s, n), O !== "none" && s.nChanges++, a.transition && n.anim && s.nChangesAnim++, ($k.test(l) || jk.test(l)) && (s.rangesAltered[t[0]] = 1), i === "datarevision" && (s.newDataRevision = 1);
        }
        function d(O) {
          return O.valType === "data_array" || O.arrayOk;
        }
        for (i in e) {
          if (s.calc && !a.transition) return;
          var y = e[i],
            g = r[i],
            m = t.concat(i);
          if (l = m.join("."), !(i.charAt(0) === "_" || typeof y == "function" || y === g)) {
            if ((i === "tick0" || i === "dtick") && t[0] !== "geo") {
              var _ = r.tickmode;
              if (_ === "auto" || _ === "array" || !_) continue;
            }
            if (!(i === "range" && r.autorange) && !((i === "zmin" || i === "zmax") && r.type === "contourcarpet") && (n = o(m), !!n && !(n._compareAsJSON && JSON.stringify(y) === JSON.stringify(g)))) {
              var w = n.valType,
                T,
                b = d(n),
                A = Array.isArray(y),
                S = Array.isArray(g);
              if (A && S) {
                var k = "_input_" + i,
                  q = e[k],
                  D = r[k];
                if (Array.isArray(q) && q === D) continue;
              }
              if (g === void 0) b && A ? s.calc = !0 : h();else if (n._isLinkedToArray) {
                var R = [],
                  z = !1;
                f || (s.arrays[i] = R);
                var N = Math.min(y.length, g.length),
                  H = Math.max(y.length, g.length);
                if (N !== H) if (n.editType === "arraydraw") z = !0;else {
                  h();
                  continue;
                }
                for (T = 0; T < N; T++) Xh(y[T], g[T], m.concat(T), $e.extendFlat({
                  inArray: i,
                  arrayIndex: T
                }, a));
                if (z) for (T = N; T < H; T++) R.push(T);
              } else !w && $e.isPlainObject(y) ? Xh(y, g, m, a) : b ? A && S ? (u && (s.calc = !0), (u || a.newDataRevision) && h()) : A !== S ? s.calc = !0 : h() : A && S ? (y.length !== g.length || String(y) !== String(g)) && h() : h();
            }
          }
        }
        for (i in r) if (!(i in e || i.charAt(0) === "_" || typeof r[i] == "function")) if (n = o(t.concat(i)), d(n) && Array.isArray(r[i])) {
          s.calc = !0;
          return;
        } else h();
      }
      function Ag(e, r) {
        var t;
        for (t in e) if (t.charAt(0) !== "_") {
          var a = e[t],
            n = r[t];
          if (a !== n) if ($e.isPlainObject(a) && $e.isPlainObject(n)) {
            if (Ag(a, n)) return !0;
          } else if (Array.isArray(a) && Array.isArray(n)) {
            if (a.length !== n.length) return !0;
            for (var i = 0; i < a.length; i++) if (a[i] !== n[i]) if ($e.isPlainObject(a[i]) && $e.isPlainObject(n[i])) {
              if (Ag(a[i], n[i])) return !0;
            } else return !0;
          } else return !0;
        }
      }
      function SK(e, r, t) {
        if (e = $e.getGraphDiv(e), !$e.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
        var a = e._transitionData;
        a._frameQueue || (a._frameQueue = []), t = xr.supplyAnimationDefaults(t);
        var n = t.transition,
          i = t.frame;
        a._frameWaitingCnt === void 0 && (a._frameWaitingCnt = 0);
        function l(u) {
          return Array.isArray(n) ? u >= n.length ? n[0] : n[u] : n;
        }
        function o(u) {
          return Array.isArray(i) ? u >= i.length ? i[0] : i[u] : i;
        }
        function s(u, f) {
          var v = 0;
          return function () {
            if (u && ++v === f) return u();
          };
        }
        return new Promise(function (u, f) {
          function v() {
            if (a._frameQueue.length !== 0) {
              for (; a._frameQueue.length;) {
                var N = a._frameQueue.pop();
                N.onInterrupt && N.onInterrupt();
              }
              e.emit("plotly_animationinterrupted", []);
            }
          }
          function h(N) {
            if (N.length !== 0) {
              for (var H = 0; H < N.length; H++) {
                var O;
                N[H].type === "byname" ? O = xr.computeFrame(e, N[H].name) : O = N[H].data;
                var J = o(H),
                  X = l(H);
                X.duration = Math.min(X.duration, J.duration);
                var B = {
                  frame: O,
                  name: N[H].name,
                  frameOpts: J,
                  transitionOpts: X
                };
                H === N.length - 1 && (B.onComplete = s(u, 2), B.onInterrupt = f), a._frameQueue.push(B);
              }
              t.mode === "immediate" && (a._lastFrameAt = -1 / 0), a._animationRaf || g();
            }
          }
          function d() {
            e.emit("plotly_animated"), window.cancelAnimationFrame(a._animationRaf), a._animationRaf = null;
          }
          function y() {
            a._currentFrame && a._currentFrame.onComplete && a._currentFrame.onComplete();
            var N = a._currentFrame = a._frameQueue.shift();
            if (N) {
              var H = N.name ? N.name.toString() : null;
              e._fullLayout._currentFrame = H, a._lastFrameAt = Date.now(), a._timeToNext = N.frameOpts.duration, xr.transition(e, N.frame.data, N.frame.layout, It.coerceTraceIndices(e, N.frame.traces), N.frameOpts, N.transitionOpts).then(function () {
                N.onComplete && N.onComplete();
              }), e.emit("plotly_animatingframe", {
                name: H,
                frame: N.frame,
                animation: {
                  frame: N.frameOpts,
                  transition: N.transitionOpts
                }
              });
            } else d();
          }
          function g() {
            e.emit("plotly_animating"), a._lastFrameAt = -1 / 0, a._timeToNext = 0, a._runningTransitions = 0, a._currentFrame = null;
            var N = function () {
              a._animationRaf = window.requestAnimationFrame(N), Date.now() - a._lastFrameAt > a._timeToNext && y();
            };
            N();
          }
          var m = 0;
          function _(N) {
            return Array.isArray(n) ? m >= n.length ? N.transitionOpts = n[m] : N.transitionOpts = n[0] : N.transitionOpts = n, m++, N;
          }
          var w,
            T,
            b = [],
            A = r == null,
            S = Array.isArray(r),
            k = !A && !S && $e.isPlainObject(r);
          if (k) b.push({
            type: "object",
            data: _($e.extendFlat({}, r))
          });else if (A || ["string", "number"].indexOf(typeof r) !== -1) for (w = 0; w < a._frames.length; w++) T = a._frames[w], T && (A || String(T.group) === String(r)) && b.push({
            type: "byname",
            name: String(T.name),
            data: _({
              name: T.name
            })
          });else if (S) for (w = 0; w < r.length; w++) {
            var q = r[w];
            ["number", "string"].indexOf(typeof q) !== -1 ? (q = String(q), b.push({
              type: "byname",
              name: q,
              data: _({
                name: q
              })
            })) : $e.isPlainObject(q) && b.push({
              type: "object",
              data: _($e.extendFlat({}, q))
            });
          }
          for (w = 0; w < b.length; w++) if (T = b[w], T.type === "byname" && !a._frameHash[T.data.name]) {
            $e.warn('animate failure: frame not found: "' + T.data.name + '"'), f();
            return;
          }
          ["next", "immediate"].indexOf(t.mode) !== -1 && v(), t.direction === "reverse" && b.reverse();
          var D = e._fullLayout._currentFrame;
          if (D && t.fromcurrent) {
            var R = -1;
            for (w = 0; w < b.length; w++) if (T = b[w], T.type === "byname" && T.name === D) {
              R = w;
              break;
            }
            if (R > 0 && R < b.length - 1) {
              var z = [];
              for (w = 0; w < b.length; w++) T = b[w], (b[w].type !== "byname" || w > R) && z.push(T);
              b = z;
            }
          }
          b.length > 0 ? h(b) : (e.emit("plotly_animated"), u());
        });
      }
      function LK(e, r, t) {
        if (e = $e.getGraphDiv(e), r == null) return Promise.resolve();
        if (!$e.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
        var a,
          n,
          i,
          l,
          o = e._transitionData._frames,
          s = e._transitionData._frameHash;
        if (!Array.isArray(r)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + r);
        var u = o.length + r.length * 2,
          f = [],
          v = {};
        for (a = r.length - 1; a >= 0; a--) if ($e.isPlainObject(r[a])) {
          var h = r[a].name,
            d = (s[h] || v[h] || {}).name,
            y = r[a].name,
            g = s[d] || v[d];
          d && y && typeof y == "number" && g && wg < Nk && (wg++, $e.warn('addFrames: overwriting frame "' + (s[d] || v[d]).name + '" with a frame whose name of type "number" also equates to "' + d + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), wg === Nk && $e.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), v[h] = {
            name: h
          }, f.push({
            frame: xr.supplyFrameDefaults(r[a]),
            index: t && t[a] !== void 0 && t[a] !== null ? t[a] : u + a
          });
        }
        f.sort(function (k, q) {
          return k.index > q.index ? -1 : k.index < q.index ? 1 : 0;
        });
        var m = [],
          _ = [],
          w = o.length;
        for (a = f.length - 1; a >= 0; a--) {
          if (n = f[a].frame, typeof n.name == "number" && $e.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !n.name) for (; s[n.name = "frame " + e._transitionData._counter++];);
          if (s[n.name]) {
            for (i = 0; i < o.length && (o[i] || {}).name !== n.name; i++);
            m.push({
              type: "replace",
              index: i,
              value: n
            }), _.unshift({
              type: "replace",
              index: i,
              value: o[i]
            });
          } else l = Math.max(0, Math.min(f[a].index, w)), m.push({
            type: "insert",
            index: l,
            value: n
          }), _.unshift({
            type: "delete",
            index: l
          }), w++;
        }
        var T = xr.modifyFrames,
          b = xr.modifyFrames,
          A = [e, _],
          S = [e, m];
        return Ua && Ua.add(e, T, A, b, S), xr.modifyFrames(e, m);
      }
      function qK(e, r) {
        if (e = $e.getGraphDiv(e), !$e.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
        var t,
          a,
          n = e._transitionData._frames,
          i = [],
          l = [];
        if (!r) for (r = [], t = 0; t < n.length; t++) r.push(t);
        for (r = r.slice(), r.sort(), t = r.length - 1; t >= 0; t--) a = r[t], i.push({
          type: "delete",
          index: a
        }), l.unshift({
          type: "insert",
          index: a,
          value: n[a]
        });
        var o = xr.modifyFrames,
          s = xr.modifyFrames,
          u = [e, l],
          f = [e, i];
        return Ua && Ua.add(e, o, u, s, f), xr.modifyFrames(e, i);
      }
      function DK(e) {
        e = $e.getGraphDiv(e);
        var r = e._fullLayout || {},
          t = e._fullData || [];
        return xr.cleanPlot([], {}, t, r), xr.purge(e), Tg.purge(e), r._container && r._container.remove(), delete e._context, e;
      }
      function EK(e) {
        var r = e._fullLayout,
          t = e.getBoundingClientRect();
        if (!$e.equalDomRects(t, r._lastBBox)) {
          var a = r._invTransform = $e.inverseTransformMatrix($e.getFullTransformMatrix(e));
          r._invScaleX = Math.sqrt(a[0][0] * a[0][0] + a[0][1] * a[0][1] + a[0][2] * a[0][2]), r._invScaleY = Math.sqrt(a[1][0] * a[1][0] + a[1][1] * a[1][1] + a[1][2] * a[1][2]), r._lastBBox = t;
        }
      }
      function PK(e) {
        var r = Yh.select(e),
          t = e._fullLayout;
        if (t._calcInverseTransform = EK, t._calcInverseTransform(e), t._container = r.selectAll(".plot-container").data([0]), t._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0).style({
          width: "100%",
          height: "100%"
        }), t._paperdiv = t._container.selectAll(".svg-container").data([0]), t._paperdiv.enter().append("div").classed("user-select-none", !0).classed("svg-container", !0).style("position", "relative"), t._glcontainer = t._paperdiv.selectAll(".gl-container").data([{}]), t._glcontainer.enter().append("div").classed("gl-container", !0), t._paperdiv.selectAll(".main-svg").remove(), t._paperdiv.select(".modebar-container").remove(), t._paper = t._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), t._toppaper = t._paperdiv.append("svg").classed("main-svg", !0), t._modebardiv = t._paperdiv.append("div"), delete t._modeBar, t._hoverpaper = t._paperdiv.append("svg").classed("main-svg", !0), !t._uid) {
          var a = {};
          Yh.selectAll("defs").each(function () {
            this.id && (a[this.id.split("-")[1]] = 1);
          }), t._uid = $e.randstr(a);
        }
        t._paperdiv.selectAll(".main-svg").attr(oK.svgAttrs), t._defs = t._paper.append("defs").attr("id", "defs-" + t._uid), t._clips = t._defs.append("g").classed("clips", !0), t._topdefs = t._toppaper.append("defs").attr("id", "topdefs-" + t._uid), t._topclips = t._topdefs.append("g").classed("clips", !0), t._bgLayer = t._paper.append("g").classed("bglayer", !0), t._draggers = t._paper.append("g").classed("draglayer", !0);
        var n = t._paper.append("g").classed("layer-below", !0);
        t._imageLowerLayer = n.append("g").classed("imagelayer", !0), t._shapeLowerLayer = n.append("g").classed("shapelayer", !0), t._cartesianlayer = t._paper.append("g").classed("cartesianlayer", !0), t._polarlayer = t._paper.append("g").classed("polarlayer", !0), t._smithlayer = t._paper.append("g").classed("smithlayer", !0), t._ternarylayer = t._paper.append("g").classed("ternarylayer", !0), t._geolayer = t._paper.append("g").classed("geolayer", !0), t._funnelarealayer = t._paper.append("g").classed("funnelarealayer", !0), t._pielayer = t._paper.append("g").classed("pielayer", !0), t._iciclelayer = t._paper.append("g").classed("iciclelayer", !0), t._treemaplayer = t._paper.append("g").classed("treemaplayer", !0), t._sunburstlayer = t._paper.append("g").classed("sunburstlayer", !0), t._indicatorlayer = t._toppaper.append("g").classed("indicatorlayer", !0), t._glimages = t._paper.append("g").classed("glimages", !0);
        var i = t._toppaper.append("g").classed("layer-above", !0);
        t._imageUpperLayer = i.append("g").classed("imagelayer", !0), t._shapeUpperLayer = i.append("g").classed("shapelayer", !0), t._selectionLayer = t._toppaper.append("g").classed("selectionlayer", !0), t._infolayer = t._toppaper.append("g").classed("infolayer", !0), t._menulayer = t._toppaper.append("g").classed("menulayer", !0), t._zoomlayer = t._toppaper.append("g").classed("zoomlayer", !0), t._hoverlayer = t._hoverpaper.append("g").classed("hoverlayer", !0), t._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), e.emit("plotly_framework");
      }
      Gr.animate = SK;
      Gr.addFrames = LK;
      Gr.deleteFrames = qK;
      Gr.addTraces = Xk;
      Gr.deleteTraces = Jk;
      Gr.extendTraces = Wk;
      Gr.moveTraces = Mg;
      Gr.prependTraces = Zk;
      Gr.newPlot = dK;
      Gr._doPlot = fK;
      Gr.purge = DK;
      Gr.react = AK;
      Gr.redraw = hK;
      Gr.relayout = Xf;
      Gr.restyle = Vh;
      Gr.setPlotConfig = cK;
      Gr.update = Zh;
      Gr._guiRelayout = kg(Xf);
      Gr._guiRestyle = kg(Vh);
      Gr._guiUpdate = kg(Zh);
      Gr._storeDirectGUIEdit = gK;
    });
    var Do = Z(Li => {
      "use strict";

      var RK = gr();
      Li.getDelay = function (e) {
        return e._has && (e._has("gl3d") || e._has("mapbox") || e._has("map")) ? 500 : 0;
      };
      Li.getRedrawFunc = function (e) {
        return function () {
          RK.getComponentMethod("colorbar", "draw")(e);
        };
      };
      Li.encodeSVG = function (e) {
        return "data:image/svg+xml," + encodeURIComponent(e);
      };
      Li.encodeJSON = function (e) {
        return "data:application/json," + encodeURIComponent(e);
      };
      var tC = window.URL || window.webkitURL;
      Li.createObjectURL = function (e) {
        return tC.createObjectURL(e);
      };
      Li.revokeObjectURL = function (e) {
        return tC.revokeObjectURL(e);
      };
      Li.createBlob = function (e, r) {
        if (r === "svg") return new window.Blob([e], {
          type: "image/svg+xml;charset=utf-8"
        });
        if (r === "full-json") return new window.Blob([e], {
          type: "application/json;charset=utf-8"
        });
        var t = zK(window.atob(e));
        return new window.Blob([t], {
          type: "image/" + r
        });
      };
      Li.octetStream = function (e) {
        document.location.href = "data:application/octet-stream" + e;
      };
      function zK(e) {
        for (var r = e.length, t = new ArrayBuffer(r), a = new Uint8Array(t), n = 0; n < r; n++) a[n] = e.charCodeAt(n);
        return t;
      }
      Li.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/;
    });
    var Qh = Z((Due, aC) => {
      "use strict";

      var Lg = Ir(),
        Lue = He(),
        NK = tt(),
        FK = Er(),
        que = fo(),
        Sg = /"/g,
        Kf = "TOBESTRIPPED",
        IK = new RegExp('("' + Kf + ")|(" + Kf + '")', "g");
      function HK(e) {
        var r = Lg.select("body").append("div").style({
            display: "none"
          }).html(""),
          t = e.replace(/(&[^;]*;)/gi, function (a) {
            return a === "&lt;" ? "&#60;" : a === "&rt;" ? "&#62;" : a.indexOf("<") !== -1 || a.indexOf(">") !== -1 ? "" : r.html(a).text();
          });
        return r.remove(), t;
      }
      function OK(e) {
        return e.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;");
      }
      aC.exports = function (r, t, a) {
        var n = r._fullLayout,
          i = n._paper,
          l = n._toppaper,
          o = n.width,
          s = n.height,
          u;
        i.insert("rect", ":first-child").call(NK.setRect, 0, 0, o, s).call(FK.fill, n.paper_bgcolor);
        var f = n._basePlotModules || [];
        for (u = 0; u < f.length; u++) {
          var v = f[u];
          v.toSVG && v.toSVG(r);
        }
        if (l) {
          var h = l.node().childNodes,
            d = Array.prototype.slice.call(h);
          for (u = 0; u < d.length; u++) {
            var y = d[u];
            y.childNodes.length && i.node().appendChild(y);
          }
        }
        n._draggers && n._draggers.remove(), i.node().style.background = "", i.selectAll("text").attr({
          "data-unformatted": null,
          "data-math": null
        }).each(function () {
          var m = Lg.select(this);
          if (this.style.visibility === "hidden" || this.style.display === "none") {
            m.remove();
            return;
          } else m.style({
            visibility: null,
            display: null
          });
          var _ = this.style.fontFamily;
          _ && _.indexOf('"') !== -1 && m.style("font-family", _.replace(Sg, Kf));
          var w = this.style.fontWeight;
          w && (w === "normal" || w === "400") && m.style("font-weight", void 0);
          var T = this.style.fontStyle;
          T && T === "normal" && m.style("font-style", void 0);
          var b = this.style.fontVariant;
          b && b === "normal" && m.style("font-variant", void 0);
        }), i.selectAll(".gradient_filled,.pattern_filled").each(function () {
          var m = Lg.select(this),
            _ = this.style.fill;
          _ && _.indexOf("url(") !== -1 && m.style("fill", _.replace(Sg, Kf));
          var w = this.style.stroke;
          w && w.indexOf("url(") !== -1 && m.style("stroke", w.replace(Sg, Kf));
        }), (t === "pdf" || t === "eps") && i.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), t === "svg" && a && (i.attr("width", a * o), i.attr("height", a * s), i.attr("viewBox", "0 0 " + o + " " + s));
        var g = new window.XMLSerializer().serializeToString(i.node());
        return g = HK(g), g = OK(g), g = g.replace(IK, "'"), g;
      };
    });
    var $h = Z((Eue, nC) => {
      "use strict";

      var BK = He(),
        YK = Yv().EventEmitter,
        Qf = Do();
      function UK(e) {
        var r = e.emitter || new YK(),
          t = new Promise(function (a, n) {
            var i = window.Image,
              l = e.svg,
              o = e.format || "png",
              s = e.canvas,
              u = e.scale || 1,
              f = e.width || 300,
              v = e.height || 150,
              h = u * f,
              d = u * v,
              y = s.getContext("2d", {
                willReadFrequently: !0
              }),
              g = new i(),
              m,
              _;
            o === "svg" || BK.isSafari() ? _ = Qf.encodeSVG(l) : (m = Qf.createBlob(l, "svg"), _ = Qf.createObjectURL(m)), s.width = h, s.height = d, g.onload = function () {
              var w;
              switch (m = null, Qf.revokeObjectURL(_), o !== "svg" && y.drawImage(g, 0, 0, h, d), o) {
                case "jpeg":
                  w = s.toDataURL("image/jpeg");
                  break;
                case "png":
                  w = s.toDataURL("image/png");
                  break;
                case "webp":
                  w = s.toDataURL("image/webp");
                  break;
                case "svg":
                  w = _;
                  break;
                default:
                  var T = "Image format is not jpeg, png, svg or webp.";
                  if (n(new Error(T)), !e.promise) return r.emit("error", T);
              }
              a(w), e.promise || r.emit("success", w);
            }, g.onerror = function (w) {
              if (m = null, Qf.revokeObjectURL(_), n(w), !e.promise) return r.emit("error", w);
            }, g.src = _;
          });
        return e.promise ? t : r;
      }
      nC.exports = UK;
    });
    var Dg = Z((Pue, oC) => {
      "use strict";

      var iC = Hr(),
        lC = Cg(),
        GK = Pt(),
        qi = He(),
        $f = Do(),
        VK = Qh(),
        WK = $h(),
        ZK = tv().version,
        qg = {
          format: {
            valType: "enumerated",
            values: ["png", "jpeg", "webp", "svg", "full-json"],
            dflt: "png"
          },
          width: {
            valType: "number",
            min: 1
          },
          height: {
            valType: "number",
            min: 1
          },
          scale: {
            valType: "number",
            min: 0,
            dflt: 1
          },
          setBackground: {
            valType: "any",
            dflt: !1
          },
          imageDataOnly: {
            valType: "boolean",
            dflt: !1
          }
        };
      function XK(e, r) {
        r = r || {};
        var t, a, n, i;
        qi.isPlainObject(e) ? (t = e.data || [], a = e.layout || {}, n = e.config || {}, i = {}) : (e = qi.getGraphDiv(e), t = qi.extendDeep([], e.data), a = qi.extendDeep({}, e.layout), n = e._context, i = e._fullLayout || {});
        function l(S) {
          return !(S in r) || qi.validate(r[S], qg[S]);
        }
        if (!l("width") && r.width !== null || !l("height") && r.height !== null) throw new Error("Height and width should be pixel values.");
        if (!l("format")) throw new Error("Export format is not " + qi.join2(qg.format.values, ", ", " or ") + ".");
        var o = {};
        function s(S, k) {
          return qi.coerce(r, o, qg, S, k);
        }
        var u = s("format"),
          f = s("width"),
          v = s("height"),
          h = s("scale"),
          d = s("setBackground"),
          y = s("imageDataOnly"),
          g = document.createElement("div");
        g.style.position = "absolute", g.style.left = "-5000px", document.body.appendChild(g);
        var m = qi.extendFlat({}, a);
        f ? m.width = f : r.width === null && iC(i.width) && (m.width = i.width), v ? m.height = v : r.height === null && iC(i.height) && (m.height = i.height);
        var _ = qi.extendFlat({}, n, {
            _exportedPlot: !0,
            staticPlot: !0,
            setBackground: d
          }),
          w = $f.getRedrawFunc(g);
        function T() {
          return new Promise(function (S) {
            setTimeout(S, $f.getDelay(g._fullLayout));
          });
        }
        function b() {
          return new Promise(function (S, k) {
            var q = VK(g, u, h),
              D = g._fullLayout.width,
              R = g._fullLayout.height;
            function z() {
              lC.purge(g), document.body.removeChild(g);
            }
            if (u === "full-json") {
              var N = GK.graphJson(g, !1, "keepdata", "object", !0, !0);
              return N.version = ZK, N = JSON.stringify(N), z(), S(y ? N : $f.encodeJSON(N));
            }
            if (z(), u === "svg") return S(y ? q : $f.encodeSVG(q));
            var H = document.createElement("canvas");
            H.id = qi.randstr(), WK({
              format: u,
              width: D,
              height: R,
              scale: h,
              canvas: H,
              svg: q,
              promise: !0
            }).then(S).catch(k);
          });
        }
        function A(S) {
          return y ? S.replace($f.IMAGE_URL_PREFIX, "") : S;
        }
        return new Promise(function (S, k) {
          lC.newPlot(g, t, m, _).then(w).then(T).then(b).then(function (q) {
            S(A(q));
          }).catch(function (q) {
            k(q);
          });
        });
      }
      oC.exports = XK;
    });
    var cC = Z((Rue, fC) => {
      "use strict";

      var Pn = He(),
        JK = Pt(),
        KK = As(),
        QK = eo().dfltConfig,
        ti = Pn.isPlainObject,
        Po = Array.isArray,
        sC = Pn.isArrayOrTypedArray;
      fC.exports = function (r, t) {
        r === void 0 && (r = []), t === void 0 && (t = {});
        var a = KK.get(),
          n = [],
          i = {
            _context: Pn.extendFlat({}, QK)
          },
          l,
          o;
        Po(r) ? (i.data = Pn.extendDeep([], r), l = r) : (i.data = [], l = [], n.push(jt("array", "data"))), ti(t) ? (i.layout = Pn.extendDeep({}, t), o = t) : (i.layout = {}, o = {}, arguments.length > 1 && n.push(jt("object", "layout"))), JK.supplyDefaults(i);
        for (var s = i._fullData, u = l.length, f = 0; f < u; f++) {
          var v = l[f],
            h = ["data", f];
          if (!ti(v)) {
            n.push(jt("object", h));
            continue;
          }
          var d = s[f],
            y = d.type,
            g = a.traces[y].attributes;
          g.type = {
            valType: "enumerated",
            values: [y]
          }, d.visible === !1 && v.visible !== !1 && n.push(jt("invisible", h)), jh(v, d, g, n, h);
        }
        var m = i._fullLayout,
          _ = $K(a, s);
        return jh(o, m, _, n, "layout"), n.length === 0 ? void 0 : n;
      };
      function jh(e, r, t, a, n, i) {
        i = i || [];
        for (var l = Object.keys(e), o = 0; o < l.length; o++) {
          var s = l[o],
            u = i.slice();
          u.push(s);
          var f = e[s],
            v = r[s],
            h = rQ(t, s),
            d = (h || {}).valType,
            y = d === "info_array",
            g = d === "colorscale",
            m = (h || {}).items;
          if (!eQ(t, s)) a.push(jt("schema", n, u));else if (ti(f) && ti(v) && d !== "any") jh(f, v, h, a, n, u);else if (y && Po(f)) {
            f.length > v.length && a.push(jt("unused", n, u.concat(v.length)));
            var _ = v.length,
              w = Array.isArray(m);
            w && (_ = Math.min(_, m.length));
            var T, b, A, S, k;
            if (h.dimensions === 2) {
              for (b = 0; b < _; b++) if (Po(f[b])) {
                f[b].length > v[b].length && a.push(jt("unused", n, u.concat(b, v[b].length)));
                var q = v[b].length;
                for (T = 0; T < (w ? Math.min(q, m[b].length) : q); T++) A = w ? m[b][T] : m, S = f[b][T], k = v[b][T], Pn.validate(S, A) ? k !== S && k !== +S && a.push(jt("dynamic", n, u.concat(b, T), S, k)) : a.push(jt("value", n, u.concat(b, T), S));
              } else a.push(jt("array", n, u.concat(b), f[b]));
            } else for (b = 0; b < _; b++) A = w ? m[b] : m, S = f[b], k = v[b], Pn.validate(S, A) ? k !== S && k !== +S && a.push(jt("dynamic", n, u.concat(b), S, k)) : a.push(jt("value", n, u.concat(b), S));
          } else if (h.items && !y && Po(f)) {
            var D = m[Object.keys(m)[0]],
              R = [],
              z,
              N;
            for (z = 0; z < v.length; z++) {
              var H = v[z]._index || z;
              if (N = u.slice(), N.push(H), ti(f[H]) && ti(v[z])) {
                R.push(H);
                var O = f[H],
                  J = v[z];
                ti(O) && O.visible !== !1 && J.visible === !1 ? a.push(jt("invisible", n, N)) : jh(O, J, D, a, n, N);
              }
            }
            for (z = 0; z < f.length; z++) N = u.slice(), N.push(z), ti(f[z]) ? R.indexOf(z) === -1 && a.push(jt("unused", n, N)) : a.push(jt("object", n, N, f[z]));
          } else !ti(f) && ti(v) ? a.push(jt("object", n, u, f)) : !sC(f) && sC(v) && !y && !g ? a.push(jt("array", n, u, f)) : s in r ? Pn.validate(f, h) ? h.valType === "enumerated" && (h.coerceNumber && f !== +v || f !== v) && a.push(jt("dynamic", n, u, f, v)) : a.push(jt("value", n, u, f)) : a.push(jt("unused", n, u, f));
        }
        return a;
      }
      function $K(e, r) {
        for (var t = e.layout.layoutAttributes, a = 0; a < r.length; a++) {
          var n = r[a],
            i = e.traces[n.type],
            l = i.layoutAttributes;
          l && (n.subplot ? Pn.extendFlat(t[i.attributes.subplot.dflt], l) : Pn.extendFlat(t, l));
        }
        return t;
      }
      var jK = {
        object: function (e, r) {
          var t;
          return e === "layout" && r === "" ? t = "The layout argument" : e[0] === "data" && r === "" ? t = "Trace " + e[1] + " in the data argument" : t = Eo(e) + "key " + r, t + " must be linked to an object container";
        },
        array: function (e, r) {
          var t;
          return e === "data" ? t = "The data argument" : t = Eo(e) + "key " + r, t + " must be linked to an array container";
        },
        schema: function (e, r) {
          return Eo(e) + "key " + r + " is not part of the schema";
        },
        unused: function (e, r, t) {
          var a = ti(t) ? "container" : "key";
          return Eo(e) + a + " " + r + " did not get coerced";
        },
        dynamic: function (e, r, t, a) {
          return [Eo(e) + "key", r, "(set to '" + t + "')", "got reset to", "'" + a + "'", "during defaults."].join(" ");
        },
        invisible: function (e, r) {
          return (r ? Eo(e) + "item " + r : "Trace " + e[1]) + " got defaulted to be not visible";
        },
        value: function (e, r, t) {
          return [Eo(e) + "key " + r, "is set to an invalid value (" + t + ")"].join(" ");
        }
      };
      function Eo(e) {
        return Po(e) ? "In data trace " + e[1] + ", " : "In " + e + ", ";
      }
      function jt(e, r, t, a, n) {
        t = t || "";
        var i, l;
        Po(r) ? (i = r[0], l = r[1]) : (i = r, l = null);
        var o = aQ(t),
          s = jK[e](r, o, a, n);
        return Pn.log(s), {
          code: e,
          container: i,
          trace: l,
          path: t,
          astr: o,
          msg: s
        };
      }
      function eQ(e, r) {
        var t = uC(r),
          a = t.keyMinusId,
          n = t.id;
        return a in e && e[a]._isSubplotObj && n ? !0 : r in e;
      }
      function rQ(e, r) {
        if (r in e) return e[r];
        var t = uC(r);
        return e[t.keyMinusId];
      }
      var tQ = Pn.counterRegex("([a-z]+)");
      function uC(e) {
        var r = e.match(tQ);
        return {
          keyMinusId: r && r[1],
          id: r && r[2]
        };
      }
      function aQ(e) {
        if (!Po(e)) return String(e);
        for (var r = "", t = 0; t < e.length; t++) {
          var a = e[t];
          typeof a == "number" ? r = r.substr(0, r.length - 1) + "[" + a + "]" : r += a, t < e.length - 1 && (r += ".");
        }
        return r;
      }
    });
    var hC = Z((zue, vC) => {
      "use strict";

      var nQ = He(),
        ed = Do();
      function iQ(e, r, t) {
        var a = document.createElement("a"),
          n = "download" in a,
          i = new Promise(function (l, o) {
            var s, u;
            if (n) return s = ed.createBlob(e, t), u = ed.createObjectURL(s), a.href = u, a.download = r, document.body.appendChild(a), a.click(), document.body.removeChild(a), ed.revokeObjectURL(u), s = null, l(r);
            if (nQ.isSafari()) {
              var f = t === "svg" ? "," : ";base64,";
              return ed.octetStream(f + encodeURIComponent(e)), l(r);
            }
            o(new Error("download error"));
          });
        return i;
      }
      vC.exports = iQ;
    });
    var Eg = Z((Fue, pC) => {
      "use strict";

      var dC = He(),
        lQ = Dg(),
        oQ = hC(),
        Nue = Do();
      function sQ(e, r) {
        var t;
        return dC.isPlainObject(e) || (t = dC.getGraphDiv(e)), r = r || {}, r.format = r.format || "png", r.width = r.width || null, r.height = r.height || null, r.imageDataOnly = !0, new Promise(function (a, n) {
          t && t._snapshotInProgress && n(new Error("Snapshotting already in progress.")), t && (t._snapshotInProgress = !0);
          var i = lQ(e, r),
            l = r.filename || e.fn || "newplot";
          l += "." + r.format.replace("-", "."), i.then(function (o) {
            return t && (t._snapshotInProgress = !1), oQ(o, l, r.format);
          }).then(function (o) {
            a(o);
          }).catch(function (o) {
            t && (t._snapshotInProgress = !1), n(o);
          });
        });
      }
      pC.exports = sQ;
    });
    var xC = Z(Pg => {
      "use strict";

      var rn = He(),
        tn = rn.isPlainObject,
        mC = As(),
        yC = Pt(),
        uQ = Gn(),
        gC = ct(),
        bC = eo().dfltConfig;
      Pg.makeTemplate = function (e) {
        e = rn.isPlainObject(e) ? e : rn.getGraphDiv(e), e = rn.extendDeep({
          _context: bC
        }, {
          data: e.data,
          layout: e.layout
        }), yC.supplyDefaults(e);
        var r = e.data || [],
          t = e.layout || {};
        t._basePlotModules = e._fullLayout._basePlotModules, t._modules = e._fullLayout._modules;
        var a = {
          data: {},
          layout: {}
        };
        r.forEach(function (d) {
          var y = {};
          jf(d, y, cQ.bind(null, d));
          var g = rn.coerce(d, {}, uQ, "type"),
            m = a.data[g];
          m || (m = a.data[g] = []), m.push(y);
        }), jf(t, a.layout, fQ.bind(null, t)), delete a.layout.template;
        var n = t.template;
        if (tn(n)) {
          var i = n.layout,
            l,
            o,
            s,
            u,
            f,
            v;
          tn(i) && rd(i, a.layout);
          var h = n.data;
          if (tn(h)) {
            for (o in a.data) if (s = h[o], Array.isArray(s)) {
              for (f = a.data[o], v = f.length, u = s.length, l = 0; l < v; l++) rd(s[l % u], f[l]);
              for (l = v; l < u; l++) f.push(rn.extendDeep({}, s[l]));
            }
            for (o in h) o in a.data || (a.data[o] = rn.extendDeep([], h[o]));
          }
        }
        return a;
      };
      function rd(e, r) {
        e = rn.extendDeep({}, e);
        var t = Object.keys(e).sort(),
          a,
          n;
        function i(f, v, h) {
          if (tn(v) && tn(f)) rd(f, v);else if (Array.isArray(v) && Array.isArray(f)) {
            var d = gC.arrayTemplater({
              _template: e
            }, h);
            for (n = 0; n < v.length; n++) {
              var y = v[n],
                g = d.newItem(y)._template;
              g && rd(g, y);
            }
            var m = d.defaultItems();
            for (n = 0; n < m.length; n++) v.push(m[n]._template);
            for (n = 0; n < v.length; n++) delete v[n].templateitemname;
          }
        }
        for (a = 0; a < t.length; a++) {
          var l = t[a],
            o = e[l];
          if (l in r ? i(o, r[l], l) : r[l] = o, td(l) === l) for (var s in r) {
            var u = td(s);
            s !== u && u === l && !(s in e) && i(o, r[s], l);
          }
        }
      }
      function td(e) {
        return e.replace(/[0-9]+$/, "");
      }
      function jf(e, r, t, a, n) {
        var i = n && t(n);
        for (var l in e) {
          var o = e[l],
            s = Rn(e, l, a),
            u = Rn(e, l, n),
            f = t(u);
          if (!f) {
            var v = td(l);
            v !== l && (u = Rn(e, v, n), f = t(u));
          }
          if (!(i && i === f) && !(!f || f._noTemplating || f.valType === "data_array" || f.arrayOk && Array.isArray(o))) if (!f.valType && tn(o)) jf(o, r, t, s, u);else if (f._isLinkedToArray && Array.isArray(o)) for (var h = !1, d = 0, y = {}, g = 0; g < o.length; g++) {
            var m = o[g];
            if (tn(m)) {
              var _ = m.name;
              if (_) y[_] || (jf(m, r, t, Rn(o, d, s), Rn(o, d, u)), d++, y[_] = 1);else if (!h) {
                var w = gC.arrayDefaultKey(l),
                  T = Rn(e, w, a),
                  b = Rn(o, d, s);
                jf(m, r, t, b, Rn(o, d, u));
                var A = rn.nestedProperty(r, b),
                  S = rn.nestedProperty(r, T);
                S.set(A.get()), A.set(null), h = !0;
              }
            }
          } else {
            var k = rn.nestedProperty(r, s);
            k.set(o);
          }
        }
      }
      function fQ(e, r) {
        return mC.getLayoutValObject(e, rn.nestedProperty({}, r).parts);
      }
      function cQ(e, r) {
        return mC.getTraceValObject(e, rn.nestedProperty({}, r).parts);
      }
      function Rn(e, r, t) {
        var a;
        return t ? Array.isArray(e) ? a = t + "[" + r + "]" : a = t + "." + r : a = r, a;
      }
      Pg.validateTemplate = function (e, r) {
        var t = rn.extendDeep({}, {
            _context: bC,
            data: e.data,
            layout: e.layout
          }),
          a = t.layout || {};
        tn(r) || (r = a.template || {});
        var n = r.layout,
          i = r.data,
          l = [];
        t.layout = a, t.layout.template = r, yC.supplyDefaults(t);
        var o = t._fullLayout,
          s = t._fullData,
          u = {};
        function f(T, b) {
          for (var A in T) if (A.charAt(0) !== "_" && tn(T[A])) {
            var S = td(A),
              k = [],
              q;
            for (q = 0; q < b.length; q++) k.push(Rn(T, A, b[q])), S !== A && k.push(Rn(T, S, b[q]));
            for (q = 0; q < k.length; q++) u[k[q]] = 1;
            f(T[A], k);
          }
        }
        function v(T, b) {
          for (var A in T) if (A.indexOf("defaults") === -1 && tn(T[A])) {
            var S = Rn(T, A, b);
            u[S] ? v(T[A], S) : l.push({
              code: "unused",
              path: S
            });
          }
        }
        if (tn(n) ? (f(o, ["layout"]), v(n, "layout")) : l.push({
          code: "layout"
        }), !tn(i)) l.push({
          code: "data"
        });else {
          for (var h = {}, d, y = 0; y < s.length; y++) {
            var g = s[y];
            d = g.type, h[d] = (h[d] || 0) + 1, g._fullInput._template || l.push({
              code: "missing",
              index: g.index,
              traceType: d
            });
          }
          for (d in i) {
            var m = i[d].length,
              _ = h[d] || 0;
            m > _ ? l.push({
              code: "unused",
              traceType: d,
              templateCount: m,
              dataCount: _
            }) : _ > m && l.push({
              code: "reused",
              traceType: d,
              templateCount: m,
              dataCount: _
            });
          }
        }
        function w(T, b) {
          for (var A in T) if (A.charAt(0) !== "_") {
            var S = T[A],
              k = Rn(T, A, b);
            tn(S) ? (Array.isArray(T) && S._template === !1 && S.templateitemname && l.push({
              code: "missing",
              path: k,
              templateitemname: S.templateitemname
            }), w(S, k)) : Array.isArray(S) && vQ(S) && w(S, k);
          }
        }
        if (w({
          data: s,
          layout: o
        }, ""), l.length) return l.map(hQ);
      };
      function vQ(e) {
        for (var r = 0; r < e.length; r++) if (tn(e[r])) return !0;
      }
      function hQ(e) {
        var r;
        switch (e.code) {
          case "data":
            r = "The template has no key data.";
            break;
          case "layout":
            r = "The template has no key layout.";
            break;
          case "missing":
            e.path ? r = "There are no templates for item " + e.path + " with name " + e.templateitemname : r = "There are no templates for trace " + e.index + ", of type " + e.traceType + ".";
            break;
          case "unused":
            e.path ? r = "The template item at " + e.path + " was not used in constructing the plot." : e.dataCount ? r = "Some of the templates of type " + e.traceType + " were not used. The template has " + e.templateCount + " traces, the data only has " + e.dataCount + " of this type." : r = "The template has " + e.templateCount + " traces of type " + e.traceType + " but there are none in the data.";
            break;
          case "reused":
            r = "Some of the templates of type " + e.traceType + " were used more than once. The template has " + e.templateCount + " traces, the data has " + e.dataCount + " of this type.";
            break;
        }
        return e.msg = r, e;
      }
    });
    var wC = Z(pt => {
      "use strict";

      var Vt = Cg();
      pt._doPlot = Vt._doPlot;
      pt.newPlot = Vt.newPlot;
      pt.restyle = Vt.restyle;
      pt.relayout = Vt.relayout;
      pt.redraw = Vt.redraw;
      pt.update = Vt.update;
      pt._guiRestyle = Vt._guiRestyle;
      pt._guiRelayout = Vt._guiRelayout;
      pt._guiUpdate = Vt._guiUpdate;
      pt._storeDirectGUIEdit = Vt._storeDirectGUIEdit;
      pt.react = Vt.react;
      pt.extendTraces = Vt.extendTraces;
      pt.prependTraces = Vt.prependTraces;
      pt.addTraces = Vt.addTraces;
      pt.deleteTraces = Vt.deleteTraces;
      pt.moveTraces = Vt.moveTraces;
      pt.purge = Vt.purge;
      pt.addFrames = Vt.addFrames;
      pt.deleteFrames = Vt.deleteFrames;
      pt.animate = Vt.animate;
      pt.setPlotConfig = Vt.setPlotConfig;
      var dQ = Gu().getGraphDiv,
        pQ = hh().eraseActiveShape;
      pt.deleteActiveShape = function (e) {
        return pQ(dQ(e));
      };
      pt.toImage = Dg();
      pt.validate = cC();
      pt.downloadImage = Eg();
      var _C = xC();
      pt.makeTemplate = _C.makeTemplate;
      pt.validateTemplate = _C.validateTemplate;
    });
    var zg = Z((Oue, TC) => {
      "use strict";

      var Rg = He(),
        mQ = gr();
      TC.exports = function (r, t, a, n) {
        var i = n("x"),
          l = n("y"),
          o,
          s = mQ.getComponentMethod("calendars", "handleTraceDefaults");
        if (s(r, t, ["x", "y"], a), i) {
          var u = Rg.minRowLength(i);
          l ? o = Math.min(u, Rg.minRowLength(l)) : (o = u, n("y0"), n("dy"));
        } else {
          if (!l) return 0;
          o = Rg.minRowLength(l), n("x0"), n("dx");
        }
        return t._length = o, o;
      };
    });
    var Ng = Z((Bue, kC) => {
      "use strict";

      var MC = He().dateTick0,
        yQ = Bt(),
        gQ = yQ.ONEWEEK;
      function AC(e, r) {
        return e % gQ === 0 ? MC(r, 1) : MC(r, 0);
      }
      kC.exports = function (r, t, a, n, i) {
        if (i || (i = {
          x: !0,
          y: !0
        }), i.x) {
          var l = n("xperiod");
          l && (n("xperiod0", AC(l, t.xcalendar)), n("xperiodalignment"));
        }
        if (i.y) {
          var o = n("yperiod");
          o && (n("yperiod0", AC(o, t.ycalendar)), n("yperiodalignment"));
        }
      };
    });
    var LC = Z((Yue, SC) => {
      "use strict";

      var CC = ["orientation", "groupnorm", "stackgaps"];
      SC.exports = function (r, t, a, n) {
        var i = a._scatterStackOpts,
          l = n("stackgroup");
        if (l) {
          var o = t.xaxis + t.yaxis,
            s = i[o];
          s || (s = i[o] = {});
          var u = s[l],
            f = !1;
          u ? u.traces.push(t) : (u = s[l] = {
            traceIndices: [],
            traces: [t]
          }, f = !0);
          for (var v = {
              orientation: t.x && !t.y ? "h" : "v"
            }, h = 0; h < CC.length; h++) {
            var d = CC[h],
              y = d + "Found";
            if (!u[y]) {
              var g = r[d] !== void 0,
                m = d === "orientation";
              if ((g || f) && (u[d] = n(d, v[d]), m && (u.fillDflt = u[d] === "h" ? "tonextx" : "tonexty"), g && (u[y] = !0, !f && (delete u.traces[0][d], m)))) for (var _ = 0; _ < u.traces.length - 1; _++) {
                var w = u.traces[_];
                w._input.fill !== w.fill && (w.fill = u.fillDflt);
              }
            }
          }
          return u;
        }
      };
    });
    var RC = Z((Uue, PC) => {
      "use strict";

      var qC = Er(),
        DC = Tn().hasColorscale,
        EC = Ls(),
        bQ = on();
      PC.exports = function (r, t, a, n, i, l) {
        var o = bQ.isBubble(r),
          s = (r.line || {}).color,
          u;
        if (l = l || {}, s && (a = s), i("marker.symbol"), i("marker.opacity", o ? .7 : 1), i("marker.size"), l.noAngle || (i("marker.angle"), l.noAngleRef || i("marker.angleref"), l.noStandOff || i("marker.standoff")), i("marker.color", a), DC(r, "marker") && EC(r, t, n, i, {
          prefix: "marker.",
          cLetter: "c"
        }), l.noSelect || (i("selected.marker.color"), i("unselected.marker.color"), i("selected.marker.size"), i("unselected.marker.size")), l.noLine || (s && !Array.isArray(s) && t.marker.color !== s ? u = s : o ? u = qC.background : u = qC.defaultLine, i("marker.line.color", u), DC(r, "marker.line") && EC(r, t, n, i, {
          prefix: "marker.line.",
          cLetter: "c"
        }), i("marker.line.width", o ? 1 : 0)), o && (i("marker.sizeref"), i("marker.sizemin"), i("marker.sizemode")), l.gradient) {
          var f = i("marker.gradient.type");
          f !== "none" && i("marker.gradient.color");
        }
      };
    });
    var NC = Z((Gue, zC) => {
      "use strict";

      var xQ = He().isArrayOrTypedArray,
        _Q = Tn().hasColorscale,
        wQ = Ls();
      zC.exports = function (r, t, a, n, i, l) {
        l || (l = {});
        var o = (r.marker || {}).color;
        if (o && o._inputArray && (o = o._inputArray), i("line.color", a), _Q(r, "line")) wQ(r, t, n, i, {
          prefix: "line.",
          cLetter: "c"
        });else {
          var s = (xQ(o) ? !1 : o) || a;
          i("line.color", s);
        }
        i("line.width"), l.noDash || i("line.dash"), l.backoff && i("line.backoff");
      };
    });
    var IC = Z((Vue, FC) => {
      "use strict";

      FC.exports = function (r, t, a) {
        var n = a("line.shape");
        n === "spline" && a("line.smoothing");
      };
    });
    var OC = Z((Wue, HC) => {
      "use strict";

      var TQ = He();
      HC.exports = function (e, r, t, a, n) {
        n = n || {}, a("textposition"), TQ.coerceFont(a, "textfont", n.font || t.font, n), n.noSelect || (a("selected.textfont.color"), a("unselected.textfont.color"));
      };
    });
    var UC = Z((Zue, YC) => {
      "use strict";

      var ad = Er(),
        BC = He().isArrayOrTypedArray;
      function MQ(e) {
        for (var r = ad.interpolate(e[0][1], e[1][1], .5), t = 2; t < e.length; t++) {
          var a = ad.interpolate(e[t - 1][1], e[t][1], .5);
          r = ad.interpolate(r, a, e[t - 1][0] / e[t][0]);
        }
        return r;
      }
      YC.exports = function (r, t, a, n, i) {
        i || (i = {});
        var l = !1;
        if (t.marker) {
          var o = t.marker.color,
            s = (t.marker.line || {}).color;
          o && !BC(o) ? l = o : s && !BC(s) && (l = s);
        }
        var u;
        if (i.moduleHasFillgradient) {
          var f = n("fillgradient.type");
          if (f !== "none") {
            n("fillgradient.start"), n("fillgradient.stop");
            var v = n("fillgradient.colorscale");
            v && (u = MQ(v));
          }
        }
        n("fillcolor", ad.addOpacity((t.line || {}).color || l || u || a, .5));
      };
    });
    var ZC = Z((Xue, WC) => {
      "use strict";

      var GC = He(),
        AQ = gr(),
        kQ = qo(),
        CQ = qh(),
        tu = on(),
        SQ = zg(),
        LQ = Ng(),
        qQ = LC(),
        DQ = RC(),
        EQ = NC(),
        VC = IC(),
        PQ = OC(),
        RQ = UC(),
        zQ = He().coercePattern;
      WC.exports = function (r, t, a, n) {
        function i(d, y) {
          return GC.coerce(r, t, kQ, d, y);
        }
        var l = SQ(r, t, n, i);
        if (l || (t.visible = !1), !!t.visible) {
          LQ(r, t, n, i), i("xhoverformat"), i("yhoverformat"), i("zorder");
          var o = qQ(r, t, n, i);
          n.scattermode === "group" && t.orientation === void 0 && i("orientation", "v");
          var s = !o && l < CQ.PTS_LINESONLY ? "lines+markers" : "lines";
          i("text"), i("hovertext"), i("mode", s), tu.hasMarkers(t) && DQ(r, t, a, n, i, {
            gradient: !0
          }), tu.hasLines(t) && (EQ(r, t, a, n, i, {
            backoff: !0
          }), VC(r, t, i), i("connectgaps"), i("line.simplify")), tu.hasText(t) && (i("texttemplate"), PQ(r, t, n, i));
          var u = [];
          (tu.hasMarkers(t) || tu.hasText(t)) && (i("cliponaxis"), i("marker.maxdisplayed"), u.push("points")), i("fill", o ? o.fillDflt : "none"), t.fill !== "none" && (RQ(r, t, a, i, {
            moduleHasFillgradient: !0
          }), tu.hasLines(t) || VC(r, t, i), zQ(i, "fillpattern", t.fillcolor, !1));
          var f = (t.line || {}).color,
            v = (t.marker || {}).color;
          (t.fill === "tonext" || t.fill === "toself") && u.push("fills"), i("hoveron", u.join("+") || "points"), t.hoveron !== "fills" && i("hovertemplate");
          var h = AQ.getComponentMethod("errorbars", "supplyDefaults");
          h(r, t, f || v || a, {
            axis: "y"
          }), h(r, t, f || v || a, {
            axis: "x",
            inherit: "y"
          }), GC.coerceSelectionMarkerOpacity(t, i);
        }
      };
    });
    var Fg = Z((Jue, XC) => {
      "use strict";

      var NQ = Af().getAxisGroup;
      XC.exports = function (r, t, a, n, i) {
        var l = t.orientation,
          o = t[{
            v: "x",
            h: "y"
          }[l] + "axis"],
          s = NQ(a, o) + l,
          u = a._alignmentOpts || {},
          f = n("alignmentgroup"),
          v = u[s];
        v || (v = u[s] = {});
        var h = v[f];
        h ? h.traces.push(t) : h = v[f] = {
          traces: [t],
          alignmentIndex: Object.keys(v).length,
          offsetGroups: {}
        };
        var d = n("offsetgroup") || "",
          y = h.offsetGroups,
          g = y[d];
        t._offsetIndex = 0, (i !== "group" || d) && (g || (g = y[d] = {
          offsetIndex: Object.keys(y).length
        }), t._offsetIndex = g.offsetIndex);
      };
    });
    var KC = Z((Kue, JC) => {
      "use strict";

      var FQ = He(),
        IQ = Fg(),
        HQ = qo();
      JC.exports = function (r, t) {
        var a,
          n,
          i,
          l = t.scattermode;
        function o(h) {
          return FQ.coerce(n._input, n, HQ, h);
        }
        if (t.scattermode === "group") for (i = 0; i < r.length; i++) n = r[i], n.type === "scatter" && (a = n._input, IQ(a, n, t, o, l));
        for (i = 0; i < r.length; i++) {
          var s = r[i];
          if (s.type === "scatter") {
            var u = s.fill;
            if (!(u === "none" || u === "toself") && (s.opacity = void 0, u === "tonexty" || u === "tonextx")) for (var f = i - 1; f >= 0; f--) {
              var v = r[f];
              if (v.type === "scatter" && v.xaxis === s.xaxis && v.yaxis === s.yaxis) {
                v.opacity = void 0;
                break;
              }
            }
          }
        }
      };
    });
    var $C = Z((Que, QC) => {
      "use strict";

      var OQ = He(),
        BQ = Zv();
      QC.exports = function (e, r) {
        function t(n, i) {
          return OQ.coerce(e, r, BQ, n, i);
        }
        var a = r.barmode === "group";
        r.scattermode === "group" && t("scattergap", a ? r.bargap : .2);
      };
    });
    var Ig = Z(($ue, eS) => {
      "use strict";

      var YQ = Hr(),
        jC = He(),
        UQ = jC.dateTime2ms,
        nd = jC.incrementMonth,
        GQ = Bt(),
        VQ = GQ.ONEAVGMONTH;
      eS.exports = function (r, t, a, n) {
        if (t.type !== "date") return {
          vals: n
        };
        var i = r[a + "periodalignment"];
        if (!i) return {
          vals: n
        };
        var l = r[a + "period"],
          o;
        if (YQ(l)) {
          if (l = +l, l <= 0) return {
            vals: n
          };
        } else if (typeof l == "string" && l.charAt(0) === "M") {
          var s = +l.substring(1);
          if (s > 0 && Math.round(s) === s) o = s;else return {
            vals: n
          };
        }
        for (var u = t.calendar, f = i === "start", v = i === "end", h = r[a + "period0"], d = UQ(h, u) || 0, y = [], g = [], m = [], _ = n.length, w = 0; w < _; w++) {
          var T = n[w],
            b,
            A,
            S;
          if (o) {
            for (b = Math.round((T - d) / (o * VQ)), S = nd(d, o * b, u); S > T;) S = nd(S, -o, u);
            for (; S <= T;) S = nd(S, o, u);
            A = nd(S, -o, u);
          } else {
            for (b = Math.round((T - d) / l), S = d + b * l; S > T;) S -= l;
            for (; S <= T;) S += l;
            A = S - l;
          }
          y[w] = f ? A : v ? S : (A + S) / 2, g[w] = A, m[w] = S;
        }
        return {
          vals: y,
          starts: g,
          ends: m
        };
      };
    });
    var aS = Z((jue, tS) => {
      "use strict";

      var Hg = Tn().hasColorscale,
        Og = i0(),
        rS = on();
      tS.exports = function (r, t) {
        rS.hasLines(t) && Hg(t, "line") && Og(r, t, {
          vals: t.line.color,
          containerStr: "line",
          cLetter: "c"
        }), rS.hasMarkers(t) && (Hg(t, "marker") && Og(r, t, {
          vals: t.marker.color,
          containerStr: "marker",
          cLetter: "c"
        }), Hg(t, "marker.line") && Og(r, t, {
          vals: t.marker.line.color,
          containerStr: "marker.line",
          cLetter: "c"
        }));
      };
    });
    var Bg = Z((efe, nS) => {
      "use strict";

      var At = He();
      nS.exports = function (r, t) {
        for (var a = 0; a < r.length; a++) r[a].i = a;
        At.mergeArray(t.text, r, "tx"), At.mergeArray(t.texttemplate, r, "txt"), At.mergeArray(t.hovertext, r, "htx"), At.mergeArray(t.customdata, r, "data"), At.mergeArray(t.textposition, r, "tp"), t.textfont && (At.mergeArrayCastPositive(t.textfont.size, r, "ts"), At.mergeArray(t.textfont.color, r, "tc"), At.mergeArray(t.textfont.family, r, "tf"), At.mergeArray(t.textfont.weight, r, "tw"), At.mergeArray(t.textfont.style, r, "ty"), At.mergeArray(t.textfont.variant, r, "tv"), At.mergeArray(t.textfont.textcase, r, "tC"), At.mergeArray(t.textfont.lineposition, r, "tE"), At.mergeArray(t.textfont.shadow, r, "tS"));
        var n = t.marker;
        if (n) {
          At.mergeArrayCastPositive(n.size, r, "ms"), At.mergeArrayCastPositive(n.opacity, r, "mo"), At.mergeArray(n.symbol, r, "mx"), At.mergeArray(n.angle, r, "ma"), At.mergeArray(n.standoff, r, "mf"), At.mergeArray(n.color, r, "mc");
          var i = n.line;
          n.line && (At.mergeArray(i.color, r, "mlc"), At.mergeArrayCastPositive(i.width, r, "mlw"));
          var l = n.gradient;
          l && l.type !== "none" && (At.mergeArray(l.type, r, "mgt"), At.mergeArray(l.color, r, "mgc"));
        }
      };
    });
    var Yg = Z((rfe, lS) => {
      "use strict";

      var iS = He();
      lS.exports = function (r, t) {
        iS.isArrayOrTypedArray(t.selectedpoints) && iS.tagSelected(r, t);
      };
    });
    var Zg = Z((tfe, hS) => {
      "use strict";

      var oS = Hr(),
        Gg = He(),
        ec = dt(),
        sS = Ig(),
        Ug = Bt().BADNUM,
        Vg = on(),
        WQ = aS(),
        ZQ = Bg(),
        XQ = Yg();
      function JQ(e, r) {
        var t = e._fullLayout,
          a = r._xA = ec.getFromId(e, r.xaxis || "x", "x"),
          n = r._yA = ec.getFromId(e, r.yaxis || "y", "y"),
          i = a.makeCalcdata(r, "x"),
          l = n.makeCalcdata(r, "y"),
          o = sS(r, a, "x", i),
          s = sS(r, n, "y", l),
          u = o.vals,
          f = s.vals,
          v = r._length,
          h = new Array(v),
          d = r.ids,
          y = Wg(r, t, a, n),
          g = !1,
          m,
          _,
          w,
          T,
          b,
          A;
        cS(t, r);
        var S = "x",
          k = "y",
          q;
        if (y) Gg.pushUnique(y.traceIndices, r.index), m = y.orientation === "v", m ? (k = "s", q = "x") : (S = "s", q = "y"), b = y.stackgaps === "interpolate";else {
          var D = fS(r, v);
          uS(e, r, a, n, u, f, D);
        }
        var R = !!r.xperiodalignment,
          z = !!r.yperiodalignment;
        for (_ = 0; _ < v; _++) {
          var N = h[_] = {},
            H = oS(u[_]),
            O = oS(f[_]);
          H && O ? (N[S] = u[_], N[k] = f[_], R && (N.orig_x = i[_], N.xEnd = o.ends[_], N.xStart = o.starts[_]), z && (N.orig_y = l[_], N.yEnd = s.ends[_], N.yStart = s.starts[_])) : y && (m ? H : O) ? (N[q] = m ? u[_] : f[_], N.gap = !0, b ? (N.s = Ug, g = !0) : N.s = 0) : N[S] = N[k] = Ug, d && (N.id = String(d[_]));
        }
        if (ZQ(h, r), WQ(e, r), XQ(h, r), y) {
          for (_ = 0; _ < h.length;) h[_][q] === Ug ? h.splice(_, 1) : _++;
          if (Gg.sort(h, function (I, V) {
            return I[q] - V[q] || I.i - V.i;
          }), g) {
            for (_ = 0; _ < h.length - 1 && h[_].gap;) _++;
            for (A = h[_].s, A || (A = h[_].s = 0), w = 0; w < _; w++) h[w].s = A;
            for (T = h.length - 1; T > _ && h[T].gap;) T--;
            for (A = h[T].s, w = h.length - 1; w > T; w--) h[w].s = A;
            for (; _ < T;) if (_++, h[_].gap) {
              for (w = _ + 1; h[w].gap;) w++;
              for (var J = h[_ - 1][q], X = h[_ - 1].s, B = (h[w].s - X) / (h[w][q] - J); _ < w;) h[_].s = X + (h[_][q] - J) * B, _++;
            }
          }
        }
        return h;
      }
      function uS(e, r, t, a, n, i, l) {
        var o = r._length,
          s = e._fullLayout,
          u = t._id,
          f = a._id,
          v = s._firstScatter[vS(r)] === r.uid,
          h = (Wg(r, s, t, a) || {}).orientation,
          d = r.fill;
        t._minDtick = 0, a._minDtick = 0;
        var y = {
            padded: !0
          },
          g = {
            padded: !0
          };
        l && (y.ppad = g.ppad = l);
        var m = o < 2 || n[0] !== n[o - 1] || i[0] !== i[o - 1];
        m && (d === "tozerox" || d === "tonextx" && (v || h === "h")) ? y.tozero = !0 : !(r.error_y || {}).visible && (d === "tonexty" || d === "tozeroy" || !Vg.hasMarkers(r) && !Vg.hasText(r)) && (y.padded = !1, y.ppad = 0), m && (d === "tozeroy" || d === "tonexty" && (v || h === "v")) ? g.tozero = !0 : (d === "tonextx" || d === "tozerox") && (g.padded = !1), u && (r._extremes[u] = ec.findExtremes(t, n, y)), f && (r._extremes[f] = ec.findExtremes(a, i, g));
      }
      function fS(e, r) {
        if (Vg.hasMarkers(e)) {
          var t = e.marker,
            a = 1.6 * (e.marker.sizeref || 1),
            n;
          if (e.marker.sizemode === "area" ? n = function (u) {
            return Math.max(Math.sqrt((u || 0) / a), 3);
          } : n = function (u) {
            return Math.max((u || 0) / a, 3);
          }, Gg.isArrayOrTypedArray(t.size)) {
            var i = {
              type: "linear"
            };
            ec.setConvert(i);
            for (var l = i.makeCalcdata(e.marker, "size"), o = new Array(r), s = 0; s < r; s++) o[s] = n(l[s]);
            return o;
          } else return n(t.size);
        }
      }
      function cS(e, r) {
        var t = vS(r),
          a = e._firstScatter;
        a[t] || (a[t] = r.uid);
      }
      function vS(e) {
        var r = e.stackgroup;
        return e.xaxis + e.yaxis + e.type + (r ? "-" + r : "");
      }
      function Wg(e, r, t, a) {
        var n = e.stackgroup;
        if (n) {
          var i = r._scatterStackOpts[t._id + a._id][n],
            l = i.orientation === "v" ? a : t;
          if (l.type === "linear" || l.type === "log") return i;
        }
      }
      hS.exports = {
        calc: JQ,
        calcMarkerSize: fS,
        calcAxisExpansion: uS,
        setFirstScatter: cS,
        getStackOpts: Wg
      };
    });
    var pS = Z((afe, dS) => {
      "use strict";

      dS.exports = id;
      var KQ = He().distinctVals;
      function id(e, r) {
        this.traces = e, this.sepNegVal = r.sepNegVal, this.overlapNoMerge = r.overlapNoMerge;
        for (var t = 1 / 0, a = r.posAxis._id.charAt(0), n = [], i = 0; i < e.length; i++) {
          for (var l = e[i], o = 0; o < l.length; o++) {
            var s = l[o],
              u = s.p;
            u === void 0 && (u = s[a]), u !== void 0 && n.push(u);
          }
          l[0] && l[0].width1 && (t = Math.min(l[0].width1, t));
        }
        this.positions = n;
        var f = KQ(n);
        this.distinctPositions = f.vals, f.vals.length === 1 && t !== 1 / 0 ? this.minDiff = t : this.minDiff = Math.min(f.minDiff, t);
        var v = (r.posAxis || {}).type;
        (v === "category" || v === "multicategory") && (this.minDiff = 1), this.binWidth = this.minDiff, this.bins = {};
      }
      id.prototype.put = function (r, t, a) {
        var n = this.getLabel(r, t, a),
          i = this.bins[n] || 0;
        return this.bins[n] = i + a, i;
      };
      id.prototype.get = function (r, t, a) {
        var n = this.getLabel(r, t, a);
        return this.bins[n] || 0;
      };
      id.prototype.getLabel = function (r, t, a) {
        var n = a < 0 && this.sepNegVal ? "v" : "^",
          i = this.overlapNoMerge ? r : Math.round(r / this.binWidth);
        return n + i + "g" + t;
      };
    });
    var $g = Z((nfe, bS) => {
      "use strict";

      var zn = Hr(),
        Ll = He().isArrayOrTypedArray,
        au = Bt().BADNUM,
        QQ = gr(),
        rc = dt(),
        $Q = Af().getAxisGroup,
        ld = pS();
      function jQ(e, r) {
        for (var t = r.xaxis, a = r.yaxis, n = e._fullLayout, i = e._fullData, l = e.calcdata, o = [], s = [], u = 0; u < i.length; u++) {
          var f = i[u];
          if (f.visible === !0 && QQ.traceIs(f, "bar") && f.xaxis === t._id && f.yaxis === a._id && (f.orientation === "h" ? o.push(l[u]) : s.push(l[u]), f._computePh)) for (var v = e.calcdata[u], h = 0; h < v.length; h++) typeof v[h].ph0 == "function" && (v[h].ph0 = v[h].ph0()), typeof v[h].ph1 == "function" && (v[h].ph1 = v[h].ph1());
        }
        var d = {
          xCat: t.type === "category" || t.type === "multicategory",
          yCat: a.type === "category" || a.type === "multicategory",
          mode: n.barmode,
          norm: n.barnorm,
          gap: n.bargap,
          groupgap: n.bargroupgap
        };
        Jg(e, t, a, s, d), Jg(e, a, t, o, d);
      }
      function Jg(e, r, t, a, n) {
        if (a.length) {
          var i, l, o, s, u;
          switch (t$(t, a), n.mode) {
            case "overlay":
              Xg(e, r, t, a, n);
              break;
            case "group":
              for (i = [], l = [], o = 0; o < a.length; o++) s = a[o], u = s[0].trace, u.offset === void 0 ? l.push(s) : i.push(s);
              l.length && a$(e, r, t, l, n), i.length && Xg(e, r, t, i, n);
              break;
            case "stack":
            case "relative":
              for (i = [], l = [], o = 0; o < a.length; o++) s = a[o], u = s[0].trace, u.base === void 0 ? l.push(s) : i.push(s);
              r$(l), l.length && n$(e, r, t, l, n), i.length && Xg(e, r, t, i, n);
              break;
          }
          e$(a), f$(a, r);
        }
      }
      function e$(e) {
        var r, t, a, n, i, l, o;
        for (r = 0; r < e.length; r++) t = e[r], a = t[0].trace, n = t[0].t, n.cornerradiusvalue === void 0 && (i = a.marker ? a.marker.cornerradius : void 0, i !== void 0 && (l = zn(i) ? +i : +i.slice(0, -1), o = zn(i) ? "px" : "%", n.cornerradiusvalue = l, n.cornerradiusform = o));
      }
      function r$(e) {
        if (!(e.length < 2)) {
          var r, t, a, n, i, l, o;
          for (r = 0; r < e.length && (t = e[r], a = t[0].trace, i = a.marker ? a.marker.cornerradius : void 0, i === void 0); r++);
          if (i !== void 0) for (l = zn(i) ? +i : +i.slice(0, -1), o = zn(i) ? "px" : "%", r = 0; r < e.length; r++) t = e[r], n = t[0].t, n.cornerradiusvalue = l, n.cornerradiusform = o;
        }
      }
      function t$(e, r) {
        var t, a;
        for (t = 0; t < r.length; t++) {
          var n = r[t],
            i = n[0].trace,
            l = i.type === "funnel" ? i._base : i.base,
            o,
            s = i.orientation === "h" ? i.xcalendar : i.ycalendar,
            u = e.type === "category" || e.type === "multicategory" ? function () {
              return null;
            } : e.d2c;
          if (Ll(l)) {
            for (a = 0; a < Math.min(l.length, n.length); a++) o = u(l[a], 0, s), zn(o) ? (n[a].b = +o, n[a].hasB = 1) : n[a].b = 0;
            for (; a < n.length; a++) n[a].b = 0;
          } else {
            o = u(l, 0, s);
            var f = zn(o);
            for (o = f ? o : 0, a = 0; a < n.length; a++) n[a].b = o, f && (n[a].hasB = 1);
          }
        }
      }
      function Xg(e, r, t, a, n) {
        for (var i = 0; i < a.length; i++) {
          var l = a[i],
            o = new ld([l], {
              posAxis: r,
              sepNegVal: !1,
              overlapNoMerge: !n.norm
            });
          Kg(e, r, o, n), n.norm ? (gS(o), Qg(t, o, n)) : yS(t, o);
        }
      }
      function a$(e, r, t, a, n) {
        var i = new ld(a, {
          posAxis: r,
          sepNegVal: !1,
          overlapNoMerge: !n.norm
        });
        Kg(e, r, i, n), s$(i, r), n.norm ? (gS(i), Qg(t, i, n)) : yS(t, i);
      }
      function n$(e, r, t, a, n) {
        var i = new ld(a, {
          posAxis: r,
          sepNegVal: n.mode === "relative",
          overlapNoMerge: !(n.norm || n.mode === "stack" || n.mode === "relative")
        });
        Kg(e, r, i, n), o$(t, i, n);
        for (var l = 0; l < a.length; l++) for (var o = a[l], s = o[0].t.offsetindex, u = 0; u < o.length; u++) {
          var f = o[u];
          if (f.s !== au) {
            var v = f.b + f.s === i.get(f.p, s, f.s);
            v && (f._outmost = !0);
          }
        }
        n.norm && Qg(t, i, n);
      }
      function Kg(e, r, t, a) {
        var n = e._fullLayout,
          i = t.positions,
          l = t.distinctPositions,
          o = t.minDiff,
          s = t.traces,
          u = s.length,
          f = i.length !== l.length,
          v = o * (1 - a.gap),
          h,
          d,
          y,
          g;
        if (r._id === "angularaxis") h = v, d = h * (1 - (a.groupgap || 0)), y = -d / 2;else {
          var m = $Q(n, r._id) + s[0][0].trace.orientation;
          g = n._alignmentOpts[m] || {};
        }
        for (var _ = 0; _ < u; _++) {
          var w = s[_],
            T = w[0].trace;
          if (r._id !== "angularaxis") {
            var b = g[T.alignmentgroup] || {},
              A = Object.keys(b.offsetGroups || {}).length;
            A ? h = v / A : h = f ? v / u : v, d = h * (1 - (a.groupgap || 0)), A ? y = ((2 * T._offsetIndex + 1 - A) * h - d) / 2 : y = f ? ((2 * _ + 1 - u) * h - d) / 2 : -d / 2;
          }
          var S = w[0].t;
          S.barwidth = d, S.offsetindex = T._offsetIndex || 0, S.poffset = y, S.bargroupwidth = v, S.bardelta = o;
        }
        t.binWidth = s[0][0].t.barwidth / 100, i$(t), l$(r, t), r._id === "angularaxis" ? mS(r, t) : mS(r, t, f);
      }
      function i$(e) {
        var r = e.traces,
          t,
          a;
        for (t = 0; t < r.length; t++) {
          var n = r[t],
            i = n[0],
            l = i.trace,
            o = i.t,
            s = l._offset || l.offset,
            u = o.poffset,
            f;
          if (Ll(s)) {
            for (f = Array.prototype.slice.call(s, 0, n.length), a = 0; a < f.length; a++) zn(f[a]) || (f[a] = u);
            for (a = f.length; a < n.length; a++) f.push(u);
            o.poffset = f;
          } else s !== void 0 && (o.poffset = s);
          var v = l._width || l.width,
            h = o.barwidth;
          if (Ll(v)) {
            var d = Array.prototype.slice.call(v, 0, n.length);
            for (a = 0; a < d.length; a++) zn(d[a]) || (d[a] = h);
            for (a = d.length; a < n.length; a++) d.push(h);
            if (o.barwidth = d, s === void 0) {
              for (f = [], a = 0; a < n.length; a++) f.push(u + (h - d[a]) / 2);
              o.poffset = f;
            }
          } else v !== void 0 && (o.barwidth = v, s === void 0 && (o.poffset = u + (h - v) / 2));
        }
      }
      function l$(e, r) {
        for (var t = r.traces, a = nu(e), n = 0; n < t.length; n++) for (var i = t[n], l = i[0].t, o = l.poffset, s = Ll(o), u = l.barwidth, f = Ll(u), v = 0; v < i.length; v++) {
          var h = i[v],
            d = h.w = f ? u[v] : u;
          h.p === void 0 && (h.p = h[a], h["orig_" + a] = h[a]);
          var y = (s ? o[v] : o) + d / 2;
          h[a] = h.p + y;
        }
      }
      function mS(e, r, t) {
        var a = r.traces,
          n = r.minDiff,
          i = n / 2;
        rc.minDtick(e, r.minDiff, r.distinctPositions[0], t);
        for (var l = 0; l < a.length; l++) {
          var o = a[l],
            s = o[0],
            u = s.trace,
            f = [],
            v,
            h,
            d,
            y;
          for (y = 0; y < o.length; y++) v = o[y], h = v.p - i, d = v.p + i, f.push(h, d);
          if (u.width || u.offset) {
            var g = s.t,
              m = g.poffset,
              _ = g.barwidth,
              w = Ll(m),
              T = Ll(_);
            for (y = 0; y < o.length; y++) {
              v = o[y];
              var b = w ? m[y] : m,
                A = T ? _[y] : _;
              h = v.p + b, d = h + A, f.push(h, d);
            }
          }
          u._extremes[e._id] = rc.findExtremes(e, f, {
            padded: !1
          });
        }
      }
      function yS(e, r) {
        for (var t = r.traces, a = nu(e), n = 0; n < t.length; n++) {
          for (var i = t[n], l = i[0].trace, o = l.type === "scatter", s = l.orientation === "v", u = [], f = !1, v = 0; v < i.length; v++) {
            var h = i[v],
              d = o ? 0 : h.b,
              y = o ? s ? h.y : h.x : d + h.s;
            h[a] = y, u.push(y), h.hasB && u.push(d), (!h.hasB || !h.b) && (f = !0);
          }
          l._extremes[e._id] = rc.findExtremes(e, u, {
            tozero: f,
            padded: !0
          });
        }
      }
      function o$(e, r, t) {
        var a = nu(e),
          n = r.traces,
          i,
          l,
          o,
          s,
          u,
          f,
          v;
        for (s = 0; s < n.length; s++) if (i = n[s], l = i[0].trace, l.type === "funnel") for (v = i[0].t.offsetindex, u = 0; u < i.length; u++) f = i[u], f.s !== au && r.put(f.p, v, -.5 * f.s);
        for (s = 0; s < n.length; s++) {
          i = n[s], l = i[0].trace, o = l.type === "funnel", v = l.type === "barpolar" ? 0 : i[0].t.offsetindex;
          var h = [];
          for (u = 0; u < i.length; u++) if (f = i[u], f.s !== au) {
            var d;
            o ? d = f.s : d = f.s + f.b;
            var y = r.put(f.p, v, d),
              g = y + d;
            f.b = y, f[a] = g, t.norm || (h.push(g), f.hasB && h.push(y));
          }
          t.norm || (l._extremes[e._id] = rc.findExtremes(e, h, {
            tozero: !0,
            padded: !0
          }));
        }
      }
      function gS(e) {
        for (var r = e.traces, t = 0; t < r.length; t++) for (var a = r[t], n = a[0].t.offsetindex, i = 0; i < a.length; i++) {
          var l = a[i];
          l.s !== au && e.put(l.p, n, l.b + l.s);
        }
      }
      function s$(e, r) {
        for (var t = e.traces, a = 0; a < t.length; a++) {
          var n = t[a],
            i = n[0].trace,
            l = n[0].t.offsetindex;
          if (i.base === void 0) for (var o = new ld([n], {
              posAxis: r,
              sepNegVal: !0,
              overlapNoMerge: !0
            }), s = 0; s < n.length; s++) {
            var u = n[s];
            if (u.p !== au) {
              var f = o.put(u.p, l, u.b + u.s);
              f && (u.b = f);
            }
          }
        }
      }
      function Qg(e, r, t) {
        var a = r.traces,
          n = nu(e),
          i = t.norm === "fraction" ? 1 : 100,
          l = i / 1e9,
          o = e.l2c(e.c2l(0)),
          s = t.mode === "stack" ? i : o;
        function u(S) {
          return zn(e.c2l(S)) && (S < o - l || S > s + l || !zn(o));
        }
        for (var f = 0; f < a.length; f++) {
          for (var v = a[f], h = v[0].t.offsetindex, d = v[0].trace, y = [], g = !1, m = !1, _ = 0; _ < v.length; _++) {
            var w = v[_];
            if (w.s !== au) {
              var T = Math.abs(i / r.get(w.p, h, w.s));
              w.b *= T, w.s *= T;
              var b = w.b,
                A = b + w.s;
              w[n] = A, y.push(A), m = m || u(A), w.hasB && (y.push(b), m = m || u(b)), (!w.hasB || !w.b) && (g = !0);
            }
          }
          d._extremes[e._id] = rc.findExtremes(e, y, {
            tozero: g,
            padded: m
          });
        }
      }
      function u$(e, r, t, a) {
        for (var n = nu(a), i = 0; i < e.length; i++) for (var l = e[i], o = 0; o < l.length; o++) {
          var s = l[o],
            u = s[n];
          s._sMin = r[u], s._sMax = t[u];
        }
      }
      function f$(e, r) {
        var t = nu(r),
          a = {},
          n,
          i,
          l,
          o = 1 / 0,
          s = -1 / 0;
        for (n = 0; n < e.length; n++) for (l = e[n], i = 0; i < l.length; i++) {
          var u = l[i].p;
          zn(u) && (o = Math.min(o, u), s = Math.max(s, u));
        }
        var f = 1e4 / (s - o),
          v = a.round = function (q) {
            return String(Math.round(f * (q - o)));
          },
          h = {},
          d = {},
          y = e.some(function (q) {
            var D = q[0].trace;
            return "marker" in D && D.marker.cornerradius;
          });
        for (n = 0; n < e.length; n++) {
          l = e[n], l[0].t.extents = a;
          var g = l[0].t.poffset,
            m = Ll(g);
          for (i = 0; i < l.length; i++) {
            var _ = l[i],
              w = _[t] - _.w / 2;
            if (zn(w)) {
              var T = _[t] + _.w / 2,
                b = v(_.p);
              a[b] ? a[b] = [Math.min(w, a[b][0]), Math.max(T, a[b][1])] : a[b] = [w, T];
            }
            if (_.p0 = _.p + (m ? g[i] : g), _.p1 = _.p0 + _.w, _.s0 = _.b, _.s1 = _.s0 + _.s, y) {
              var A = Math.min(_.s0, _.s1) || 0,
                S = Math.max(_.s0, _.s1) || 0,
                k = _[t];
              h[k] = k in h ? Math.min(h[k], A) : A, d[k] = k in d ? Math.max(d[k], S) : S;
            }
          }
        }
        y && u$(e, h, d, r);
      }
      function nu(e) {
        return e._id.charAt(0);
      }
      bS.exports = {
        crossTraceCalc: jQ,
        setGroupPositions: Jg
      };
    });
    var TS = Z((ife, wS) => {
      "use strict";

      var xS = Zg(),
        _S = $g().setGroupPositions;
      function c$(e, r) {
        for (var t = r.xaxis, a = r.yaxis, n = e._fullLayout, i = e._fullData, l = e.calcdata, o = [], s = [], u = 0; u < i.length; u++) {
          var f = i[u];
          f.visible === !0 && f.type === "scatter" && f.xaxis === t._id && f.yaxis === a._id && (f.orientation === "h" ? o.push(l[u]) : f.orientation === "v" && s.push(l[u]));
        }
        var v = {
          mode: n.scattermode,
          gap: n.scattergap
        };
        _S(e, t, a, s, v), _S(e, a, t, o, v);
      }
      wS.exports = function (r, t) {
        r._fullLayout.scattermode === "group" && c$(r, t);
        var a = t.xaxis,
          n = t.yaxis,
          i = a._id + n._id,
          l = r._fullLayout._scatterStackOpts[i];
        if (l) {
          var o = r.calcdata,
            s,
            u,
            f,
            v,
            h,
            d,
            y,
            g,
            m,
            _,
            w,
            T,
            b,
            A,
            S;
          for (var k in l) {
            _ = l[k];
            var q = _.traceIndices;
            if (q.length) {
              for (w = _.stackgaps === "interpolate", T = _.groupnorm, _.orientation === "v" ? (b = "x", A = "y") : (b = "y", A = "x"), S = new Array(q.length), s = 0; s < S.length; s++) S[s] = !1;
              d = o[q[0]];
              var D = new Array(d.length);
              for (s = 0; s < d.length; s++) D[s] = d[s][b];
              for (s = 1; s < q.length; s++) {
                for (h = o[q[s]], u = f = 0; u < h.length; u++) {
                  for (y = h[u][b]; y > D[f] && f < D.length; f++) jg(h, u, D[f], s, S, w, b), u++;
                  if (y !== D[f]) {
                    for (v = 0; v < s; v++) jg(o[q[v]], f, y, v, S, w, b);
                    D.splice(f, 0, y);
                  }
                  f++;
                }
                for (; f < D.length; f++) jg(h, u, D[f], s, S, w, b), u++;
              }
              var R = D.length;
              for (u = 0; u < d.length; u++) {
                for (g = d[u][A] = d[u].s, s = 1; s < q.length; s++) h = o[q[s]], h[0].trace._rawLength = h[0].trace._length, h[0].trace._length = R, g += h[u].s, h[u][A] = g;
                if (T) for (m = (T === "fraction" ? g : g / 100) || 1, s = 0; s < q.length; s++) {
                  var z = o[q[s]][u];
                  z[A] /= m, z.sNorm = z.s / m;
                }
              }
              for (s = 0; s < q.length; s++) {
                h = o[q[s]];
                var N = h[0].trace,
                  H = xS.calcMarkerSize(N, N._rawLength),
                  O = Array.isArray(H);
                if (H && S[s] || O) {
                  var J = H;
                  for (H = new Array(R), u = 0; u < R; u++) H[u] = h[u].gap ? 0 : O ? J[h[u].i] : J;
                }
                var X = new Array(R),
                  B = new Array(R);
                for (u = 0; u < R; u++) X[u] = h[u].x, B[u] = h[u].y;
                xS.calcAxisExpansion(r, N, a, n, X, B, H), h[0].t.orientation = _.orientation;
              }
            }
          }
        }
      };
      function jg(e, r, t, a, n, i, l) {
        n[a] = !0;
        var o = {
          i: null,
          gap: !0,
          s: 0
        };
        if (o[l] = t, e.splice(r, 0, o), r && t === e[r - 1][l]) {
          var s = e[r - 1];
          o.s = s.s, o.i = s.i, o.gap = s.gap;
        } else i && (o.s = v$(e, r, t, l));
        r || (e[0].t = e[1].t, e[0].trace = e[1].trace, delete e[1].t, delete e[1].trace);
      }
      function v$(e, r, t, a) {
        var n = e[r - 1],
          i = e[r + 1];
        return i ? n ? n.s + (i.s - n.s) * (t - n[a]) / (i[a] - n[a]) : i.s : n.s;
      }
    });
    var qS = Z((lfe, LS) => {
      "use strict";

      var h$ = tt(),
        CS = Bt(),
        tc = CS.BADNUM,
        SS = CS.LOG_CLIP,
        MS = SS + .5,
        AS = SS - .5,
        od = He(),
        d$ = od.segmentsIntersect,
        kS = od.constrain,
        e2 = qh();
      LS.exports = function (r, t) {
        var a = t.trace || {},
          n = t.xaxis,
          i = t.yaxis,
          l = n.type === "log",
          o = i.type === "log",
          s = n._length,
          u = i._length,
          f = t.backoff,
          v = a.marker,
          h = t.connectGaps,
          d = t.baseTolerance,
          y = t.shape,
          g = y === "linear",
          m = a.fill && a.fill !== "none",
          _ = [],
          w = e2.minTolerance,
          T = r.length,
          b = new Array(T),
          A = 0,
          S,
          k,
          q,
          D,
          R,
          z,
          N,
          H,
          O,
          J,
          X,
          B,
          I,
          V,
          K,
          Q;
        function ie(ze) {
          var ae = r[ze];
          if (!ae) return !1;
          var oe = t.linearized ? n.l2p(ae.x) : n.c2p(ae.x),
            qe = t.linearized ? i.l2p(ae.y) : i.c2p(ae.y);
          if (oe === tc) {
            if (l && (oe = n.c2p(ae.x, !0)), oe === tc) return !1;
            o && qe === tc && (oe *= Math.abs(n._m * u * (n._m > 0 ? MS : AS) / (i._m * s * (i._m > 0 ? MS : AS)))), oe *= 1e3;
          }
          if (qe === tc) {
            if (o && (qe = i.c2p(ae.y, !0)), qe === tc) return !1;
            qe *= 1e3;
          }
          return [oe, qe];
        }
        function me(ze, ae, oe, qe) {
          var ke = oe - ze,
            ir = qe - ae,
            vr = .5 - ze,
            sr = .5 - ae,
            Mr = ke * ke + ir * ir,
            Ur = ke * vr + ir * sr;
          if (Ur > 0 && Ur < Mr) {
            var $r = vr * ir - sr * ke;
            if ($r * $r < Mr) return !0;
          }
        }
        var pe, ge;
        function j(ze, ae) {
          var oe = ze[0] / s,
            qe = ze[1] / u,
            ke = Math.max(0, -oe, oe - 1, -qe, qe - 1);
          return ke && pe !== void 0 && me(oe, qe, pe, ge) && (ke = 0), ke && ae && me(oe, qe, ae[0] / s, ae[1] / u) && (ke = 0), (1 + e2.toleranceGrowth * ke) * d;
        }
        function _e(ze, ae) {
          var oe = ze[0] - ae[0],
            qe = ze[1] - ae[1];
          return Math.sqrt(oe * oe + qe * qe);
        }
        var se = e2.maxScreensAway,
          Se = -s * se,
          ve = s * (1 + se),
          Ae = -u * se,
          Y = u * (1 + se),
          re = [[Se, Ae, ve, Ae], [ve, Ae, ve, Y], [ve, Y, Se, Y], [Se, Y, Se, Ae]],
          U,
          de,
          be,
          ye,
          Fe,
          Re;
        function Pe(ze, ae) {
          for (var oe = [], qe = 0, ke = 0; ke < 4; ke++) {
            var ir = re[ke],
              vr = d$(ze[0], ze[1], ae[0], ae[1], ir[0], ir[1], ir[2], ir[3]);
            vr && (!qe || Math.abs(vr.x - oe[0][0]) > 1 || Math.abs(vr.y - oe[0][1]) > 1) && (vr = [vr.x, vr.y], qe && _e(vr, ze) < _e(oe[0], ze) ? oe.unshift(vr) : oe.push(vr), qe++);
          }
          return oe;
        }
        function Ie(ze) {
          if (ze[0] < Se || ze[0] > ve || ze[1] < Ae || ze[1] > Y) return [kS(ze[0], Se, ve), kS(ze[1], Ae, Y)];
        }
        function Be(ze, ae) {
          if (ze[0] === ae[0] && (ze[0] === Se || ze[0] === ve) || ze[1] === ae[1] && (ze[1] === Ae || ze[1] === Y)) return !0;
        }
        function Ne(ze, ae) {
          var oe = [],
            qe = Ie(ze),
            ke = Ie(ae);
          return qe && ke && Be(qe, ke) || (qe && oe.push(qe), ke && oe.push(ke)), oe;
        }
        function Ee(ze, ae, oe) {
          return function (qe, ke) {
            var ir = Ie(qe),
              vr = Ie(ke),
              sr = [];
            if (ir && vr && Be(ir, vr)) return sr;
            ir && sr.push(ir), vr && sr.push(vr);
            var Mr = 2 * od.constrain((qe[ze] + ke[ze]) / 2, ae, oe) - ((ir || qe)[ze] + (vr || ke)[ze]);
            if (Mr) {
              var Ur;
              ir && vr ? Ur = Mr > 0 == ir[ze] > vr[ze] ? ir : vr : Ur = ir || vr, Ur[ze] += Mr;
            }
            return sr;
          };
        }
        var Je;
        y === "linear" || y === "spline" ? Je = Pe : y === "hv" || y === "vh" ? Je = Ne : y === "hvh" ? Je = Ee(0, Se, ve) : y === "vhv" && (Je = Ee(1, Ae, Y));
        function We(ze, ae) {
          var oe = ae[0] - ze[0],
            qe = (ae[1] - ze[1]) / oe,
            ke = (ze[1] * ae[0] - ae[1] * ze[0]) / oe;
          return ke > 0 ? [qe > 0 ? Se : ve, Y] : [qe > 0 ? ve : Se, Ae];
        }
        function ne(ze) {
          var ae = ze[0],
            oe = ze[1],
            qe = ae === b[A - 1][0],
            ke = oe === b[A - 1][1];
          if (!(qe && ke)) if (A > 1) {
            var ir = ae === b[A - 2][0],
              vr = oe === b[A - 2][1];
            qe && (ae === Se || ae === ve) && ir ? vr ? A-- : b[A - 1] = ze : ke && (oe === Ae || oe === Y) && vr ? ir ? A-- : b[A - 1] = ze : b[A++] = ze;
          } else b[A++] = ze;
        }
        function Me(ze) {
          b[A - 1][0] !== ze[0] && b[A - 1][1] !== ze[1] && ne([be, ye]), ne(ze), Fe = null, be = ye = 0;
        }
        var Ce = od.isArrayOrTypedArray(v);
        function cr(ze) {
          if (ze && f && (ze.i = S, ze.d = r, ze.trace = a, ze.marker = Ce ? v[ze.i] : v, ze.backoff = f), pe = ze[0] / s, ge = ze[1] / u, U = ze[0] < Se ? Se : ze[0] > ve ? ve : 0, de = ze[1] < Ae ? Ae : ze[1] > Y ? Y : 0, U || de) {
            if (!A) b[A++] = [U || ze[0], de || ze[1]];else if (Fe) {
              var ae = Je(Fe, ze);
              ae.length > 1 && (Me(ae[0]), b[A++] = ae[1]);
            } else Re = Je(b[A - 1], ze)[0], b[A++] = Re;
            var oe = b[A - 1];
            U && de && (oe[0] !== U || oe[1] !== de) ? (Fe && (be !== U && ye !== de ? ne(be && ye ? We(Fe, ze) : [be || U, ye || de]) : be && ye && ne([be, ye])), ne([U, de])) : be - U && ye - de && ne([U || be, de || ye]), Fe = ze, be = U, ye = de;
          } else Fe && Me(Je(Fe, ze)[0]), b[A++] = ze;
        }
        for (S = 0; S < T; S++) if (k = ie(S), !!k) {
          for (A = 0, Fe = null, cr(k), S++; S < T; S++) {
            if (D = ie(S), !D) {
              if (h) continue;
              break;
            }
            if (!g || !t.simplify) {
              cr(D);
              continue;
            }
            var tr = ie(S + 1);
            if (J = _e(D, k), !(!(m && (A === 0 || A === T - 1)) && J < j(D, tr) * w)) {
              for (H = [(D[0] - k[0]) / J, (D[1] - k[1]) / J], R = k, X = J, B = V = K = 0, N = !1, q = D, S++; S < r.length; S++) {
                if (z = tr, tr = ie(S + 1), !z) {
                  if (h) continue;
                  break;
                }
                if (O = [z[0] - k[0], z[1] - k[1]], Q = O[0] * H[1] - O[1] * H[0], V = Math.min(V, Q), K = Math.max(K, Q), K - V > j(z, tr)) break;
                q = z, I = O[0] * H[0] + O[1] * H[1], I > X ? (X = I, D = z, N = !1) : I < B && (B = I, R = z, N = !0);
              }
              if (N ? (cr(D), q !== R && cr(R)) : (R !== k && cr(R), q !== D && cr(D)), cr(q), S >= r.length || !z) break;
              cr(z), k = z;
            }
          }
          Fe && ne([be || Fe[0], ye || Fe[1]]), _.push(b.slice(0, A));
        }
        var De = y.slice(y.length - 1);
        if (f && De !== "h" && De !== "v") {
          for (var Le = !1, Ye = -1, Ze = [], Ue = 0; Ue < _.length; Ue++) for (var Oe = 0; Oe < _[Ue].length - 1; Oe++) {
            var Ke = _[Ue][Oe],
              fr = _[Ue][Oe + 1],
              lr = h$.applyBackoff(fr, Ke);
            (lr[0] !== fr[0] || lr[1] !== fr[1]) && (Le = !0), Ze[Ye + 1] || (Ye++, Ze[Ye] = [Ke, [lr[0], lr[1]]]);
          }
          return Le ? Ze : _;
        }
        return _;
      };
    });
    var PS = Z((ofe, ES) => {
      "use strict";

      var DS = {
        tonextx: 1,
        tonexty: 1,
        tonext: 1
      };
      ES.exports = function (r, t, a) {
        var n,
          i,
          l,
          o,
          s,
          u = {},
          f = !1,
          v = -1,
          h = 0,
          d = -1;
        for (i = 0; i < a.length; i++) n = a[i][0].trace, l = n.stackgroup || "", l ? l in u ? s = u[l] : (s = u[l] = h, h++) : n.fill in DS && d >= 0 ? s = d : (s = d = h, h++), s < v && (f = !0), n._groupIndex = v = s;
        var y = a.slice();
        f && y.sort(function (m, _) {
          var w = m[0].trace,
            T = _[0].trace;
          return w._groupIndex - T._groupIndex || w.index - T.index;
        });
        var g = {};
        for (i = 0; i < y.length; i++) n = y[i][0].trace, l = n.stackgroup || "", n.visible === !0 ? (n._nexttrace = null, n.fill in DS && (o = g[l], n._prevtrace = o || null, o && (o._nexttrace = n)), n._ownfill = n.fill && (n.fill.substr(0, 6) === "tozero" || n.fill === "toself" || n.fill.substr(0, 2) === "to" && !n._prevtrace), g[l] = n) : n._prevtrace = n._nexttrace = n._ownfill = null;
        return y;
      };
    });
    var FS = Z((sfe, NS) => {
      "use strict";

      var ai = Ir(),
        p$ = gr(),
        ac = He(),
        iu = ac.ensureSingle,
        zS = ac.identity,
        kt = tt(),
        lu = on(),
        m$ = qS(),
        y$ = PS(),
        sd = Qy().tester;
      NS.exports = function (r, t, a, n, i, l) {
        var o,
          s,
          u = !i,
          f = !!i && i.duration > 0,
          v = y$(r, t, a);
        if (o = n.selectAll("g.trace").data(v, function (d) {
          return d[0].trace.uid;
        }), o.enter().append("g").attr("class", function (d) {
          return "trace scatter trace" + d[0].trace.uid;
        }).style("stroke-miterlimit", 2), o.order(), g$(r, o, t), f) {
          l && (s = l());
          var h = ai.transition().duration(i.duration).ease(i.easing).each("end", function () {
            s && s();
          }).each("interrupt", function () {
            s && s();
          });
          h.each(function () {
            n.selectAll("g.trace").each(function (d, y) {
              RS(r, y, t, d, v, this, i);
            });
          });
        } else o.each(function (d, y) {
          RS(r, y, t, d, v, this, i);
        });
        u && o.exit().remove(), n.selectAll("path:not([d])").remove();
      };
      function g$(e, r, t) {
        r.each(function (a) {
          var n = iu(ai.select(this), "g", "fills");
          kt.setClipUrl(n, t.layerClipId, e);
          var i = a[0].trace,
            l = [];
          i._ownfill && l.push("_ownFill"), i._nexttrace && l.push("_nextFill");
          var o = n.selectAll("g").data(l, zS);
          o.enter().append("g"), o.exit().each(function (s) {
            i[s] = null;
          }).remove(), o.order().each(function (s) {
            i[s] = iu(ai.select(this), "path", "js-fill");
          });
        });
      }
      function RS(e, r, t, a, n, i, l) {
        var o = e._context.staticPlot,
          s;
        b$(e, r, t, a, n);
        var u = !!l && l.duration > 0;
        function f(Ee) {
          return u ? Ee.transition() : Ee;
        }
        var v = t.xaxis,
          h = t.yaxis,
          d = a[0].trace,
          y = d.line,
          g = ai.select(i),
          m = iu(g, "g", "errorbars"),
          _ = iu(g, "g", "lines"),
          w = iu(g, "g", "points"),
          T = iu(g, "g", "text");
        if (p$.getComponentMethod("errorbars", "plot")(e, m, t, l), d.visible !== !0) return;
        f(g).style("opacity", d.opacity);
        var b,
          A,
          S = d.fill.charAt(d.fill.length - 1);
        S !== "x" && S !== "y" && (S = "");
        var k, q;
        S === "y" ? (k = 1, q = h.c2p(0, !0)) : S === "x" && (k = 0, q = v.c2p(0, !0)), a[0][t.isRangePlot ? "nodeRangePlot3" : "node3"] = g;
        var D = "",
          R = [],
          z = d._prevtrace,
          N = null,
          H = null;
        z && (D = z._prevRevpath || "", A = z._nextFill, R = z._ownPolygons, N = z._fillsegments, H = z._fillElement);
        var O,
          J,
          X = "",
          B = "",
          I,
          V,
          K,
          Q,
          ie,
          me,
          pe = [];
        d._polygons = [];
        var ge = [],
          j = [],
          _e = ac.noop;
        if (b = d._ownFill, lu.hasLines(d) || d.fill !== "none") {
          A && A.datum(a), ["hv", "vh", "hvh", "vhv"].indexOf(y.shape) !== -1 ? (I = kt.steps(y.shape), V = kt.steps(y.shape.split("").reverse().join(""))) : y.shape === "spline" ? I = V = function (Ee) {
            var Je = Ee[Ee.length - 1];
            return Ee.length > 1 && Ee[0][0] === Je[0] && Ee[0][1] === Je[1] ? kt.smoothclosed(Ee.slice(1), y.smoothing) : kt.smoothopen(Ee, y.smoothing);
          } : I = V = function (Ee) {
            return "M" + Ee.join("L");
          }, K = function (Ee) {
            return V(Ee.reverse());
          }, j = m$(a, {
            xaxis: v,
            yaxis: h,
            trace: d,
            connectGaps: d.connectgaps,
            baseTolerance: Math.max(y.width || 1, 3) / 4,
            shape: y.shape,
            backoff: y.backoff,
            simplify: y.simplify,
            fill: d.fill
          }), ge = new Array(j.length);
          var se = 0;
          for (s = 0; s < j.length; s++) {
            var Se,
              ve = j[s];
            !Se || !S ? (Se = ve.slice(), ge[se] = Se, se++) : Se.push.apply(Se, ve);
          }
          d._fillElement = null, d._fillExclusionElement = H, d._fillsegments = ge.slice(0, se), ge = d._fillsegments, j.length && (Q = j[0][0].slice(), ie = j[j.length - 1], me = ie[ie.length - 1].slice()), _e = function (Ee) {
            return function (Je) {
              if (O = I(Je), J = K(Je), X ? S ? (X += "L" + O.substr(1), B = J + ("L" + B.substr(1))) : (X += "Z" + O, B = J + "Z" + B) : (X = O, B = J), lu.hasLines(d)) {
                var We = ai.select(this);
                if (We.datum(a), Ee) f(We.style("opacity", 0).attr("d", O).call(kt.lineGroupStyle)).style("opacity", 1);else {
                  var ne = f(We);
                  ne.attr("d", O), kt.singleLineStyle(a, ne);
                }
              }
            };
          };
        }
        var Ae = _.selectAll(".js-line").data(j);
        f(Ae.exit()).style("opacity", 0).remove(), Ae.each(_e(!1)), Ae.enter().append("path").classed("js-line", !0).style("vector-effect", o ? "none" : "non-scaling-stroke").call(kt.lineGroupStyle).each(_e(!0)), kt.setClipUrl(Ae, t.layerClipId, e);
        function Y(Ee) {
          f(Ee).attr("d", "M0,0Z");
        }
        var re = function () {
            var Ee = new Array(ge.length);
            for (s = 0; s < ge.length; s++) Ee[s] = sd(ge[s]);
            return Ee;
          },
          U = function (Ee) {
            var Je, We;
            if (!Ee || Ee.length === 0) for (Je = new Array(ge.length), We = 0; We < ge.length; We++) {
              var ne = ge[We][0].slice(),
                Me = ge[We][ge[We].length - 1].slice();
              ne[k] = Me[k] = q;
              var Ce = [Me, ne],
                cr = Ce.concat(ge[We]);
              Je[We] = sd(cr);
            } else {
              for (Je = new Array(Ee.length - 1 + ge.length), We = 0; We < Ee.length - 1; We++) Je[We] = sd(Ee[We]);
              var tr = Ee[Ee.length - 1].slice();
              for (tr.reverse(), We = 0; We < ge.length; We++) Je[Ee.length - 1 + We] = sd(ge[We].concat(tr));
            }
            return Je;
          };
        j.length ? (b ? (b.datum(a), Q && me && (S ? (Q[k] = me[k] = q, f(b).attr("d", "M" + me + "L" + Q + "L" + X.substr(1)).call(kt.singleFillStyle, e), pe = U(null)) : (f(b).attr("d", X + "Z").call(kt.singleFillStyle, e), pe = re())), d._polygons = pe, d._fillElement = b) : A && (d.fill.substr(0, 6) === "tonext" && X && D ? (d.fill === "tonext" ? (f(A).attr("d", X + "Z" + D + "Z").call(kt.singleFillStyle, e), pe = re(), d._polygons = pe.concat(R)) : (f(A).attr("d", X + "L" + D.substr(1) + "Z").call(kt.singleFillStyle, e), pe = U(N), d._polygons = pe), d._fillElement = A) : Y(A)), d._prevRevpath = B) : (b ? Y(b) : A && Y(A), d._prevRevpath = null), d._ownPolygons = pe;
        function de(Ee) {
          return Ee.filter(function (Je) {
            return !Je.gap && Je.vis;
          });
        }
        function be(Ee) {
          return Ee.filter(function (Je) {
            return Je.vis;
          });
        }
        function ye(Ee) {
          return Ee.filter(function (Je) {
            return !Je.gap;
          });
        }
        function Fe(Ee) {
          return Ee.id;
        }
        function Re(Ee) {
          if (Ee.ids) return Fe;
        }
        function Pe() {
          return !1;
        }
        function Ie(Ee, Je, We) {
          var ne,
            Me,
            Ce,
            cr = We[0].trace,
            tr = lu.hasMarkers(cr),
            De = lu.hasText(cr),
            Le = Re(cr),
            Ye = Pe,
            Ze = Pe;
          if (tr || De) {
            var Ue = zS,
              Oe = cr.stackgroup,
              Ke = Oe && e._fullLayout._scatterStackOpts[v._id + h._id][Oe].stackgaps === "infer zero";
            cr.marker.maxdisplayed || cr._needsCull ? Ue = Ke ? be : de : Oe && !Ke && (Ue = ye), tr && (Ye = Ue), De && (Ze = Ue);
          }
          Me = Ee.selectAll("path.point"), ne = Me.data(Ye, Le);
          var fr = ne.enter().append("path").classed("point", !0);
          u && fr.call(kt.pointStyle, cr, e).call(kt.translatePoints, v, h).style("opacity", 0).transition().style("opacity", 1), ne.order();
          var lr;
          tr && (lr = kt.makePointStyleFns(cr)), ne.each(function (ze) {
            var ae = ai.select(this),
              oe = f(ae);
            Ce = kt.translatePoint(ze, oe, v, h), Ce ? (kt.singlePointStyle(ze, oe, cr, lr, e), t.layerClipId && kt.hideOutsideRangePoint(ze, oe, v, h, cr.xcalendar, cr.ycalendar), cr.customdata && ae.classed("plotly-customdata", ze.data !== null && ze.data !== void 0)) : oe.remove();
          }), u ? ne.exit().transition().style("opacity", 0).remove() : ne.exit().remove(), Me = Je.selectAll("g"), ne = Me.data(Ze, Le), ne.enter().append("g").classed("textpoint", !0).append("text"), ne.order(), ne.each(function (ze) {
            var ae = ai.select(this),
              oe = f(ae.select("text"));
            Ce = kt.translatePoint(ze, oe, v, h), Ce ? t.layerClipId && kt.hideOutsideRangePoint(ze, ae, v, h, cr.xcalendar, cr.ycalendar) : ae.remove();
          }), ne.selectAll("text").call(kt.textPointStyle, cr, e).each(function (ze) {
            var ae = v.c2p(ze.x),
              oe = h.c2p(ze.y);
            ai.select(this).selectAll("tspan.line").each(function () {
              f(ai.select(this)).attr({
                x: ae,
                y: oe
              });
            });
          }), ne.exit().remove();
        }
        w.datum(a), T.datum(a), Ie(w, T, a);
        var Be = d.cliponaxis === !1,
          Ne = Be ? null : t.layerClipId;
        kt.setClipUrl(w, Ne, e), kt.setClipUrl(T, Ne, e);
      }
      function b$(e, r, t, a, n) {
        var i = t.xaxis,
          l = t.yaxis,
          o = ai.extent(ac.simpleMap(i.range, i.r2c)),
          s = ai.extent(ac.simpleMap(l.range, l.r2c)),
          u = a[0].trace;
        if (lu.hasMarkers(u)) {
          var f = u.marker.maxdisplayed;
          if (f !== 0) {
            var v = a.filter(function (g) {
                return g.x >= o[0] && g.x <= o[1] && g.y >= s[0] && g.y <= s[1];
              }),
              h = Math.ceil(v.length / f),
              d = 0;
            n.forEach(function (g, m) {
              var _ = g[0].trace;
              lu.hasMarkers(_) && _.marker.maxdisplayed > 0 && m < r && d++;
            });
            var y = Math.round(d * h / 3 + Math.floor(d / 3) * h / 7.1);
            a.forEach(function (g) {
              delete g.vis;
            }), v.forEach(function (g, m) {
              Math.round((m + y) % h) === 0 && (g.vis = !0);
            });
          }
        }
      }
    });
    var r2 = Z((ufe, IS) => {
      "use strict";

      IS.exports = {
        container: "marker",
        min: "cmin",
        max: "cmax"
      };
    });
    var OS = Z((ffe, HS) => {
      "use strict";

      var ud = dt();
      HS.exports = function (r, t, a) {
        var n = {},
          i = {
            _fullLayout: a
          },
          l = ud.getFromTrace(i, t, "x"),
          o = ud.getFromTrace(i, t, "y"),
          s = r.orig_x;
        s === void 0 && (s = r.x);
        var u = r.orig_y;
        return u === void 0 && (u = r.y), n.xLabel = ud.tickText(l, l.c2l(s), !0).text, n.yLabel = ud.tickText(o, o.c2l(u), !0).text, n;
      };
    });
    var i2 = Z((cfe, BS) => {
      "use strict";

      var t2 = Ir(),
        ou = tt(),
        x$ = gr();
      function _$(e) {
        var r = t2.select(e).selectAll("g.trace.scatter");
        r.style("opacity", function (t) {
          return t[0].trace.opacity;
        }), r.selectAll("g.points").each(function (t) {
          var a = t2.select(this),
            n = t.trace || t[0].trace;
          a2(a, n, e);
        }), r.selectAll("g.text").each(function (t) {
          var a = t2.select(this),
            n = t.trace || t[0].trace;
          n2(a, n, e);
        }), r.selectAll("g.trace path.js-line").call(ou.lineGroupStyle), r.selectAll("g.trace path.js-fill").call(ou.fillGroupStyle, e, !1), x$.getComponentMethod("errorbars", "style")(r);
      }
      function a2(e, r, t) {
        ou.pointStyle(e.selectAll("path.point"), r, t);
      }
      function n2(e, r, t) {
        ou.textPointStyle(e.selectAll("text"), r, t);
      }
      function w$(e, r, t) {
        var a = r[0].trace;
        a.selectedpoints ? (ou.selectedPointStyle(t.selectAll("path.point"), a), ou.selectedTextStyle(t.selectAll("text"), a)) : (a2(t, a, e), n2(t, a, e));
      }
      BS.exports = {
        style: _$,
        stylePoints: a2,
        styleText: n2,
        styleOnSelect: w$
      };
    });
    var US = Z((vfe, YS) => {
      "use strict";

      var su = Er(),
        T$ = on();
      YS.exports = function (r, t) {
        var a, n;
        if (r.mode === "lines") return a = r.line.color, a && su.opacity(a) ? a : r.fillcolor;
        if (r.mode === "none") return r.fill ? r.fillcolor : "";
        var i = t.mcc || (r.marker || {}).color,
          l = t.mlcc || ((r.marker || {}).line || {}).color;
        return n = i && su.opacity(i) ? i : l && su.opacity(l) && (t.mlw || ((r.marker || {}).line || {}).width) ? l : "", n ? su.opacity(n) < .3 ? su.addOpacity(n, .3) : n : (a = (r.line || {}).color, a && su.opacity(a) && T$.hasLines(r) && r.line.width ? a : r.fillcolor);
      };
    });
    var WS = Z((hfe, VS) => {
      "use strict";

      var fd = He(),
        GS = ki(),
        M$ = gr(),
        A$ = US(),
        l2 = Er(),
        k$ = fd.fillText;
      VS.exports = function (r, t, a, n) {
        var i = r.cd,
          l = i[0].trace,
          o = r.xa,
          s = r.ya,
          u = o.c2p(t),
          f = s.c2p(a),
          v = [u, f],
          h = l.hoveron || "",
          d = l.mode.indexOf("markers") !== -1 ? 3 : .5,
          y = !!l.xperiodalignment,
          g = !!l.yperiodalignment;
        if (h.indexOf("points") !== -1) {
          var m = function (B) {
              if (y) {
                var I = o.c2p(B.xStart),
                  V = o.c2p(B.xEnd);
                return u >= Math.min(I, V) && u <= Math.max(I, V) ? 0 : 1 / 0;
              }
              var K = Math.max(3, B.mrc || 0),
                Q = 1 - 1 / K,
                ie = Math.abs(o.c2p(B.x) - u);
              return ie < K ? Q * ie / K : ie - K + Q;
            },
            _ = function (B) {
              if (g) {
                var I = s.c2p(B.yStart),
                  V = s.c2p(B.yEnd);
                return f >= Math.min(I, V) && f <= Math.max(I, V) ? 0 : 1 / 0;
              }
              var K = Math.max(3, B.mrc || 0),
                Q = 1 - 1 / K,
                ie = Math.abs(s.c2p(B.y) - f);
              return ie < K ? Q * ie / K : ie - K + Q;
            },
            w = function (B) {
              var I = Math.max(d, B.mrc || 0),
                V = o.c2p(B.x) - u,
                K = s.c2p(B.y) - f;
              return Math.max(Math.sqrt(V * V + K * K) - I, 1 - d / I);
            },
            T = GS.getDistanceFunction(n, m, _, w);
          if (GS.getClosest(i, T, r), r.index !== !1) {
            var b = i[r.index],
              A = o.c2p(b.x, !0),
              S = s.c2p(b.y, !0),
              k = b.mrc || 1;
            r.index = b.i;
            var q = i[0].t.orientation,
              D = q && (b.sNorm || b.s),
              R = q === "h" ? D : b.orig_x !== void 0 ? b.orig_x : b.x,
              z = q === "v" ? D : b.orig_y !== void 0 ? b.orig_y : b.y;
            return fd.extendFlat(r, {
              color: A$(l, b),
              x0: A - k,
              x1: A + k,
              xLabelVal: R,
              y0: S - k,
              y1: S + k,
              yLabelVal: z,
              spikeDistance: w(b),
              hovertemplate: l.hovertemplate
            }), k$(b, l, r), M$.getComponentMethod("errorbars", "hoverInfo")(b, l, r), [r];
          }
        }
        function N(B) {
          if (!B) return !1;
          var I = B.node();
          try {
            var V = new DOMPoint(v[0], v[1]);
            return I.isPointInFill(V);
          } catch (Q) {
            var K = I.ownerSVGElement.createSVGPoint();
            return K.x = v[0], K.y = v[1], I.isPointInFill(K);
          }
        }
        function H(B) {
          var I,
            V = [],
            K = 1 / 0,
            Q = -1 / 0,
            ie = 1 / 0,
            me = -1 / 0,
            pe;
          for (I = 0; I < B.length; I++) {
            var ge = B[I];
            ge.contains(v) && (V.push(ge), ie = Math.min(ie, ge.ymin), me = Math.max(me, ge.ymax));
          }
          if (V.length === 0) return null;
          ie = Math.max(ie, 0), me = Math.min(me, s._length), pe = (ie + me) / 2;
          var j, _e, se, Se, ve, Ae, Y;
          for (I = 0; I < V.length; I++) for (_e = V[I].pts, j = 1; j < _e.length; j++) Ae = _e[j - 1][1], Y = _e[j][1], Ae > pe != Y >= pe && (Se = _e[j - 1][0], ve = _e[j][0], Y - Ae && (se = Se + (ve - Se) * (pe - Ae) / (Y - Ae), K = Math.min(K, se), Q = Math.max(Q, se)));
          return K = Math.max(K, 0), Q = Math.min(Q, o._length), {
            x0: K,
            x1: Q,
            y0: pe,
            y1: pe
          };
        }
        if (h.indexOf("fills") !== -1 && l._fillElement) {
          var O = N(l._fillElement) && !N(l._fillExclusionElement);
          if (O) {
            var J = H(l._polygons);
            J === null && (J = {
              x0: v[0],
              x1: v[0],
              y0: v[1],
              y1: v[1]
            });
            var X = l2.defaultLine;
            return l2.opacity(l.fillcolor) ? X = l.fillcolor : l2.opacity((l.line || {}).color) && (X = l.line.color), fd.extendFlat(r, {
              distance: r.maxHoverDistance,
              x0: J.x0,
              x1: J.x1,
              y0: J.y0,
              y1: J.y1,
              color: X,
              hovertemplate: !1
            }), delete r.index, l.text && !fd.isArrayOrTypedArray(l.text) ? r.text = String(l.text) : r.text = l.name, [r];
          }
        }
      };
    });
    var JS = Z((dfe, XS) => {
      "use strict";

      var ZS = on();
      XS.exports = function (r, t) {
        var a = r.cd,
          n = r.xaxis,
          i = r.yaxis,
          l = [],
          o = a[0].trace,
          s,
          u,
          f,
          v,
          h = !ZS.hasMarkers(o) && !ZS.hasText(o);
        if (h) return [];
        if (t === !1) for (s = 0; s < a.length; s++) a[s].selected = 0;else for (s = 0; s < a.length; s++) u = a[s], f = n.c2p(u.x), v = i.c2p(u.y), u.i !== null && t.contains([f, v], !1, s, r) ? (l.push({
          pointNumber: u.i,
          x: n.c2d(u.x),
          y: i.c2d(u.y)
        }), u.selected = 1) : u.selected = 0;
        return l;
      };
    });
    var QS = Z((pfe, KS) => {
      "use strict";

      KS.exports = {
        xaxis: {
          valType: "subplotid",
          dflt: "x",
          editType: "calc+clearAxisTypes"
        },
        yaxis: {
          valType: "subplotid",
          dflt: "y",
          editType: "calc+clearAxisTypes"
        }
      };
    });
    var rL = Z((mfe, eL) => {
      "use strict";

      var nc = gr().traceIs,
        o2 = Sm();
      eL.exports = function (r, t, a, n) {
        a("autotypenumbers", n.autotypenumbersDflt);
        var i = a("type", (n.splomStash || {}).type);
        i === "-" && (C$(t, n.data), t.type === "-" ? t.type = "linear" : r.type = t.type);
      };
      function C$(e, r) {
        if (e.type === "-") {
          var t = e._id,
            a = t.charAt(0),
            n;
          t.indexOf("scene") !== -1 && (t = a);
          var i = S$(r, t, a);
          if (i) {
            if (i.type === "histogram" && a === {
              v: "y",
              h: "x"
            }[i.orientation || "v"]) {
              e.type = "linear";
              return;
            }
            var l = a + "calendar",
              o = i[l],
              s = {
                noMultiCategory: !nc(i, "cartesian") || nc(i, "noMultiCategory")
              };
            if (i.type === "box" && i._hasPreCompStats && a === {
              h: "x",
              v: "y"
            }[i.orientation || "v"] && (s.noMultiCategory = !0), s.autotypenumbers = e.autotypenumbers, jS(i, a)) {
              var u = $S(i),
                f = [];
              for (n = 0; n < r.length; n++) {
                var v = r[n];
                !nc(v, "box-violin") || (v[a + "axis"] || a) !== t || (v[u] !== void 0 ? f.push(v[u][0]) : v.name !== void 0 ? f.push(v.name) : f.push("text"), v[l] !== o && (o = void 0));
              }
              e.type = o2(f, o, s);
            } else if (i.type === "splom") {
              var h = i.dimensions,
                d = h[i._axesDim[t]];
              d.visible && (e.type = o2(d.values, o, s));
            } else e.type = o2(i[a] || [i[a + "0"]], o, s);
          }
        }
      }
      function S$(e, r, t) {
        for (var a = 0; a < e.length; a++) {
          var n = e[a];
          if (n.type === "splom" && n._length > 0 && (n["_" + t + "axes"] || {})[r]) return n;
          if ((n[t + "axis"] || t) === r) {
            if (jS(n, t)) return n;
            if ((n[t] || []).length || n[t + "0"]) return n;
          }
        }
      }
      function $S(e) {
        return {
          v: "x",
          h: "y"
        }[e.orientation || "v"];
      }
      function jS(e, r) {
        var t = $S(e),
          a = nc(e, "box-violin"),
          n = nc(e._fullInput || {}, "candlestick");
        return a && !n && r === t && e[t] === void 0 && e[t + "0"] === void 0;
      }
    });
    var aL = Z((yfe, tL) => {
      "use strict";

      var L$ = nn().isTypedArraySpec;
      function q$(e, r) {
        var t = r.dataAttr || e._id.charAt(0),
          a = {},
          n,
          i,
          l;
        if (r.axData) n = r.axData;else for (n = [], i = 0; i < r.data.length; i++) {
          var o = r.data[i];
          o[t + "axis"] === e._id && n.push(o);
        }
        for (i = 0; i < n.length; i++) {
          var s = n[i][t];
          for (l = 0; l < s.length; l++) {
            var u = s[l];
            u != null && (a[u] = 1);
          }
        }
        return Object.keys(a);
      }
      tL.exports = function (r, t, a, n) {
        if (t.type === "category") {
          var i = r.categoryarray,
            l = Array.isArray(i) && i.length > 0 || L$(i),
            o;
          l && (o = "array");
          var s = a("categoryorder", o),
            u;
          s === "array" && (u = a("categoryarray")), !l && s === "array" && (s = t.categoryorder = "trace"), s === "trace" ? t._initialCategories = [] : s === "array" ? t._initialCategories = u.slice() : (u = q$(t, n).sort(), s === "category ascending" ? t._initialCategories = u : s === "category descending" && (t._initialCategories = u.reverse()));
        }
      };
    });
    var lL = Z((gfe, iL) => {
      "use strict";

      var nL = bn().mix,
        D$ = hi(),
        E$ = He();
      iL.exports = function (r, t, a, n) {
        n = n || {};
        var i = n.dfltColor;
        function l(k, q) {
          return E$.coerce2(r, t, n.attributes, k, q);
        }
        var o = l("linecolor", i),
          s = l("linewidth"),
          u = a("showline", n.showLine || !!o || !!s);
        u || (delete t.linecolor, delete t.linewidth);
        var f = nL(i, n.bgColor, n.blend || D$.lightFraction).toRgbString(),
          v = l("gridcolor", f),
          h = l("gridwidth"),
          d = l("griddash"),
          y = a("showgrid", n.showGrid || !!v || !!h || !!d);
        if (y || (delete t.gridcolor, delete t.gridwidth, delete t.griddash), n.hasMinor) {
          var g = nL(t.gridcolor, n.bgColor, 67).toRgbString(),
            m = l("minor.gridcolor", g),
            _ = l("minor.gridwidth", t.gridwidth || 1),
            w = l("minor.griddash", t.griddash || "solid"),
            T = a("minor.showgrid", !!m || !!_ || !!w);
          T || (delete t.minor.gridcolor, delete t.minor.gridwidth, delete t.minor.griddash);
        }
        if (!n.noZeroLine) {
          var b = l("zerolinecolor", i),
            A = l("zerolinewidth"),
            S = a("zeroline", n.showGrid || !!b || !!A);
          S || (delete t.zerolinecolor, delete t.zerolinewidth);
        }
      };
    });
    var u2 = Z((bfe, vL) => {
      "use strict";

      var oL = Hr(),
        P$ = gr(),
        ic = He(),
        R$ = ct(),
        z$ = Jn(),
        s2 = Xn(),
        sL = Qp(),
        uL = jp(),
        N$ = tm(),
        F$ = am(),
        I$ = aL(),
        H$ = lL(),
        O$ = Xm(),
        fL = b0(),
        cd = da().WEEKDAY_PATTERN,
        B$ = da().HOUR_PATTERN;
      vL.exports = function (r, t, a, n, i) {
        var l = n.letter,
          o = n.font || {},
          s = n.splomStash || {},
          u = a("visible", !n.visibleDflt),
          f = t._template || {},
          v = t.type || f.type || "-",
          h;
        if (v === "date") {
          var d = P$.getComponentMethod("calendars", "handleDefaults");
          d(r, t, "calendar", n.calendar), n.noTicklabelmode || (h = a("ticklabelmode"));
        }
        !n.noTicklabelindex && (v === "date" || v === "linear") && a("ticklabelindex");
        var y = "";
        (!n.noTicklabelposition || v === "multicategory") && (y = ic.coerce(r, t, {
          ticklabelposition: {
            valType: "enumerated",
            dflt: "outside",
            values: h === "period" ? ["outside", "inside"] : l === "x" ? ["outside", "inside", "outside left", "inside left", "outside right", "inside right"] : ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"]
          }
        }, "ticklabelposition")), n.noTicklabeloverflow || a("ticklabeloverflow", y.indexOf("inside") !== -1 ? "hide past domain" : v === "category" || v === "multicategory" ? "allow" : "hide past div"), fL(t, i), O$(r, t, a, n), I$(r, t, a, n), v !== "category" && !n.noHover && a("hoverformat");
        var g = a("color"),
          m = g !== s2.color.dflt ? g : o.color,
          _ = s.label || i._dfltTitle[l];
        if (F$(r, t, a, v, n), !u) return t;
        a("title.text", _), ic.coerceFont(a, "title.font", o, {
          overrideDflt: {
            size: ic.bigFont(o.size),
            color: m
          }
        }), sL(r, t, a, v);
        var w = n.hasMinor;
        if (w && (R$.newContainer(t, "minor"), sL(r, t, a, v, {
          isMinor: !0
        })), N$(r, t, a, v, n), uL(r, t, a, n), w) {
          var T = n.isMinor;
          n.isMinor = !0, uL(r, t, a, n), n.isMinor = T;
        }
        H$(r, t, a, {
          dfltColor: g,
          bgColor: n.bgColor,
          showGrid: n.showGrid,
          hasMinor: w,
          attributes: s2
        }), w && !t.minor.ticks && !t.minor.showgrid && delete t.minor, (t.showline || t.ticks) && a("mirror");
        var b = v === "multicategory";
        if (!n.noTickson && (v === "category" || b) && (t.ticks || t.showgrid)) {
          var A;
          b && (A = "boundaries");
          var S = a("tickson", A);
          S === "boundaries" && delete t.ticklabelposition;
        }
        if (b) {
          var k = a("showdividers");
          k && (a("dividercolor"), a("dividerwidth"));
        }
        if (v === "date") if (z$(r, t, {
          name: "rangebreaks",
          inclusionAttr: "enabled",
          handleItemDefaults: Y$
        }), !t.rangebreaks.length) delete t.rangebreaks;else {
          for (var q = 0; q < t.rangebreaks.length; q++) if (t.rangebreaks[q].pattern === cd) {
            t._hasDayOfWeekBreaks = !0;
            break;
          }
          if (fL(t, i), i._has("scattergl") || i._has("splom")) for (var D = 0; D < n.data.length; D++) {
            var R = n.data[D];
            (R.type === "scattergl" || R.type === "splom") && (R.visible = !1, ic.warn(R.type + " traces do not work on axes with rangebreaks. Setting trace " + R.index + " to `visible: false`."));
          }
        }
        return t;
      };
      function Y$(e, r, t) {
        function a(h, d) {
          return ic.coerce(e, r, s2.rangebreaks, h, d);
        }
        var n = a("enabled");
        if (n) {
          var i = a("bounds");
          if (i && i.length >= 2) {
            var l = "",
              o,
              s;
            if (i.length === 2) {
              for (o = 0; o < 2; o++) if (s = cL(i[o]), s) {
                l = cd;
                break;
              }
            }
            var u = a("pattern", l);
            if (u === cd) for (o = 0; o < 2; o++) s = cL(i[o]), s && (r.bounds[o] = i[o] = s - 1);
            if (u) for (o = 0; o < 2; o++) switch (s = i[o], u) {
              case cd:
                if (!oL(s)) {
                  r.enabled = !1;
                  return;
                }
                if (s = +s, s !== Math.floor(s) || s < 0 || s >= 7) {
                  r.enabled = !1;
                  return;
                }
                r.bounds[o] = i[o] = s;
                break;
              case B$:
                if (!oL(s)) {
                  r.enabled = !1;
                  return;
                }
                if (s = +s, s < 0 || s > 24) {
                  r.enabled = !1;
                  return;
                }
                r.bounds[o] = i[o] = s;
                break;
            }
            if (t.autorange === !1) {
              var f = t.range;
              if (f[0] < f[1]) {
                if (i[0] < f[0] && i[1] > f[1]) {
                  r.enabled = !1;
                  return;
                }
              } else if (i[0] > f[0] && i[1] < f[1]) {
                r.enabled = !1;
                return;
              }
            }
          } else {
            var v = a("values");
            if (v && v.length) a("dvalue");else {
              r.enabled = !1;
              return;
            }
          }
        }
      }
      var U$ = {
        sun: 1,
        mon: 2,
        tue: 3,
        wed: 4,
        thu: 5,
        fri: 6,
        sat: 7
      };
      function cL(e) {
        if (typeof e == "string") return U$[e.substr(0, 3).toLowerCase()];
      }
    });
    var f2 = Z((xfe, hL) => {
      "use strict";

      var G$ = Hr(),
        vd = He();
      hL.exports = function (r, t, a, n) {
        var i = n.counterAxes || [],
          l = n.overlayableAxes || [],
          o = n.letter,
          s = n.grid,
          u = n.overlayingDomain,
          f,
          v,
          h,
          d,
          y,
          g;
        s && (v = s._domains[o][s._axisMap[t._id]], f = s._anchors[t._id], v && (h = s[o + "side"].split(" ")[0], d = s.domain[o][h === "right" || h === "top" ? 1 : 0])), v = v || [0, 1], f = f || (G$(r.position) ? "free" : i[0] || "free"), h = h || (o === "x" ? "bottom" : "left"), d = d || 0, y = 0, g = !1;
        var m = vd.coerce(r, t, {
            anchor: {
              valType: "enumerated",
              values: ["free"].concat(i),
              dflt: f
            }
          }, "anchor"),
          _ = vd.coerce(r, t, {
            side: {
              valType: "enumerated",
              values: o === "x" ? ["bottom", "top"] : ["left", "right"],
              dflt: h
            }
          }, "side");
        if (m === "free") {
          if (o === "y") {
            var w = a("autoshift");
            w && (d = _ === "left" ? u[0] : u[1], g = t.automargin ? t.automargin : !0, y = _ === "left" ? -3 : 3), a("shift", y);
          }
          a("position", d);
        }
        a("automargin", g);
        var T = !1;
        if (l.length && (T = vd.coerce(r, t, {
          overlaying: {
            valType: "enumerated",
            values: [!1].concat(l),
            dflt: !1
          }
        }, "overlaying")), !T) {
          var b = a("domain", v);
          b[0] > b[1] - 1 / 4096 && (t.domain = v), vd.noneOrAll(r.domain, t.domain, v), t.tickmode === "sync" && (t.tickmode = "auto");
        }
        return a("layer"), t;
      };
    });
    var wL = Z((_fe, _L) => {
      "use strict";

      var Ro = He(),
        dL = Er(),
        V$ = bi().isUnifiedHover,
        W$ = xy(),
        pL = ct(),
        Z$ = ds(),
        mL = Xn(),
        X$ = rL(),
        yL = u2(),
        J$ = Af(),
        gL = f2(),
        v2 = Xt(),
        Di = v2.id2name,
        bL = v2.name2id,
        K$ = da().AX_ID_PATTERN,
        xL = gr(),
        hd = xL.traceIs,
        c2 = xL.getComponentMethod;
      function dd(e, r, t) {
        Array.isArray(e[r]) ? e[r].push(t) : e[r] = [t];
      }
      _L.exports = function (r, t, a) {
        var n = t.autotypenumbers,
          i = {},
          l = {},
          o = {},
          s = {},
          u = {},
          f = {},
          v = {},
          h = {},
          d = {},
          y = {},
          g,
          m;
        for (g = 0; g < a.length; g++) {
          var _ = a[g];
          if (hd(_, "cartesian")) {
            var w;
            if (_.xaxis) w = Di(_.xaxis), dd(i, w, _);else if (_.xaxes) for (m = 0; m < _.xaxes.length; m++) dd(i, Di(_.xaxes[m]), _);
            var T;
            if (_.yaxis) T = Di(_.yaxis), dd(i, T, _);else if (_.yaxes) for (m = 0; m < _.yaxes.length; m++) dd(i, Di(_.yaxes[m]), _);
            if (_.type === "funnel" ? _.orientation === "h" ? (w && (l[w] = !0), T && (v[T] = !0)) : T && (o[T] = !0) : _.type === "image" ? (T && (h[T] = !0), w && (h[w] = !0)) : (T && (u[T] = !0, f[T] = !0), (!hd(_, "carpet") || _.type === "carpet" && !_._cheater) && w && (s[w] = !0)), _.type === "carpet" && _._cheater && w && (l[w] = !0), hd(_, "2dMap") && (d[w] = !0, d[T] = !0), hd(_, "oriented")) {
              var b = _.orientation === "h" ? T : w;
              y[b] = !0;
            }
          }
        }
        var A = t._subplots,
          S = A.xaxis,
          k = A.yaxis,
          q = Ro.simpleMap(S, Di),
          D = Ro.simpleMap(k, Di),
          R = q.concat(D),
          z = dL.background;
        S.length && k.length && (z = Ro.coerce(r, t, Z$, "plot_bgcolor"));
        var N = dL.combine(z, t.paper_bgcolor),
          H,
          O,
          J,
          X,
          B;
        function I() {
          var Me = i[H] || [];
          B._traceIndices = Me.map(function (Ce) {
            return Ce.index;
          }), B._annIndices = [], B._shapeIndices = [], B._selectionIndices = [], B._imgIndices = [], B._subplotsWith = [], B._counterAxes = [], B._name = B._attr = H, B._id = O;
        }
        function V(Me, Ce) {
          return Ro.coerce(X, B, mL, Me, Ce);
        }
        function K(Me, Ce) {
          return Ro.coerce2(X, B, mL, Me, Ce);
        }
        function Q(Me) {
          return Me === "x" ? k : S;
        }
        function ie(Me, Ce) {
          for (var cr = Me === "x" ? q : D, tr = [], De = 0; De < cr.length; De++) {
            var Le = cr[De];
            Le !== Ce && !(r[Le] || {}).overlaying && tr.push(bL(Le));
          }
          return tr;
        }
        var me = {
            x: Q("x"),
            y: Q("y")
          },
          pe = me.x.concat(me.y),
          ge = {},
          j = [];
        function _e() {
          var Me = X.matches;
          K$.test(Me) && pe.indexOf(Me) === -1 && (ge[Me] = X.type, j = Object.keys(ge));
        }
        var se = W$(r, t),
          Se = V$(se);
        for (g = 0; g < R.length; g++) {
          H = R[g], O = bL(H), J = H.charAt(0), Ro.isPlainObject(r[H]) || (r[H] = {}), X = r[H], B = pL.newContainer(t, H, J + "axis"), I();
          var ve = J === "x" && !s[H] && l[H] || J === "y" && !u[H] && o[H],
            Ae = J === "y" && (!f[H] && v[H] || h[H]),
            Y = {
              hasMinor: !0,
              letter: J,
              font: t.font,
              outerTicks: d[H],
              showGrid: !y[H],
              data: i[H] || [],
              bgColor: N,
              calendar: t.calendar,
              automargin: !0,
              visibleDflt: ve,
              reverseDflt: Ae,
              autotypenumbersDflt: n,
              splomStash: ((t._splomAxes || {})[J] || {})[O],
              noAutotickangles: J === "y"
            };
          V("uirevision", t.uirevision), X$(X, B, V, Y), yL(X, B, V, Y, t);
          var re = Se && J === se.charAt(0),
            U = K("spikecolor", Se ? B.color : void 0),
            de = K("spikethickness", Se ? 1.5 : void 0),
            be = K("spikedash", Se ? "dot" : void 0),
            ye = K("spikemode", Se ? "across" : void 0),
            Fe = K("spikesnap"),
            Re = V("showspikes", !!re || !!U || !!de || !!be || !!ye || !!Fe);
          Re || (delete B.spikecolor, delete B.spikethickness, delete B.spikedash, delete B.spikemode, delete B.spikesnap);
          var Pe = Di(X.overlaying),
            Ie = [0, 1];
          if (t[Pe] !== void 0) {
            var Be = Di(t[Pe].anchor);
            t[Be] !== void 0 && (Ie = t[Be].domain);
          }
          gL(X, B, V, {
            letter: J,
            counterAxes: me[J],
            overlayableAxes: ie(J, H),
            grid: t.grid,
            overlayingDomain: Ie
          }), V("title.standoff"), _e(), B._input = X;
        }
        for (g = 0; g < j.length;) {
          O = j[g++], H = Di(O), J = H.charAt(0), Ro.isPlainObject(r[H]) || (r[H] = {}), X = r[H], B = pL.newContainer(t, H, J + "axis"), I();
          var Ne = {
            letter: J,
            font: t.font,
            outerTicks: d[H],
            showGrid: !y[H],
            data: [],
            bgColor: N,
            calendar: t.calendar,
            automargin: !0,
            visibleDflt: !1,
            reverseDflt: !1,
            autotypenumbersDflt: n,
            splomStash: ((t._splomAxes || {})[J] || {})[O]
          };
          V("uirevision", t.uirevision), B.type = ge[O] || "linear", yL(X, B, V, Ne, t), gL(X, B, V, {
            letter: J,
            counterAxes: me[J],
            overlayableAxes: ie(J, H),
            grid: t.grid
          }), V("fixedrange"), _e(), B._input = X;
        }
        var Ee = c2("rangeslider", "handleDefaults"),
          Je = c2("rangeselector", "handleDefaults");
        for (g = 0; g < q.length; g++) H = q[g], X = r[H], B = t[H], Ee(r, t, H), B.type === "date" && Je(X, B, t, D, B.calendar), V("fixedrange");
        for (g = 0; g < D.length; g++) {
          H = D[g], X = r[H], B = t[H];
          var We = t[Di(B.anchor)],
            ne = c2("rangeslider", "isVisible")(We);
          V("fixedrange", ne);
        }
        J$.handleDefaults(r, t, {
          axIds: pe.concat(j).sort(v2.idSort),
          axHasImage: h
        });
      };
    });
    var AL = Z((wfe, ML) => {
      "use strict";

      var Q$ = Ir(),
        TL = gr(),
        pd = He(),
        vn = tt(),
        md = dt();
      ML.exports = function (r, t, a, n) {
        var i = r._fullLayout;
        if (t.length === 0) {
          md.redrawComponents(r);
          return;
        }
        function l(m) {
          var _ = m.xaxis,
            w = m.yaxis;
          i._defs.select("#" + m.clipId + "> rect").call(vn.setTranslate, 0, 0).call(vn.setScale, 1, 1), m.plot.call(vn.setTranslate, _._offset, w._offset).call(vn.setScale, 1, 1);
          var T = m.plot.selectAll(".scatterlayer .trace");
          T.selectAll(".point").call(vn.setPointGroupScale, 1, 1), T.selectAll(".textpoint").call(vn.setTextPointsScale, 1, 1), T.call(vn.hideOutsideRangePoints, m);
        }
        function o(m, _) {
          var w = m.plotinfo,
            T = w.xaxis,
            b = w.yaxis,
            A = T._length,
            S = b._length,
            k = !!m.xr1,
            q = !!m.yr1,
            D = [];
          if (k) {
            var R = pd.simpleMap(m.xr0, T.r2l),
              z = pd.simpleMap(m.xr1, T.r2l),
              N = R[1] - R[0],
              H = z[1] - z[0];
            D[0] = (R[0] * (1 - _) + _ * z[0] - R[0]) / (R[1] - R[0]) * A, D[2] = A * (1 - _ + _ * H / N), T.range[0] = T.l2r(R[0] * (1 - _) + _ * z[0]), T.range[1] = T.l2r(R[1] * (1 - _) + _ * z[1]);
          } else D[0] = 0, D[2] = A;
          if (q) {
            var O = pd.simpleMap(m.yr0, b.r2l),
              J = pd.simpleMap(m.yr1, b.r2l),
              X = O[1] - O[0],
              B = J[1] - J[0];
            D[1] = (O[1] * (1 - _) + _ * J[1] - O[1]) / (O[0] - O[1]) * S, D[3] = S * (1 - _ + _ * B / X), b.range[0] = T.l2r(O[0] * (1 - _) + _ * J[0]), b.range[1] = b.l2r(O[1] * (1 - _) + _ * J[1]);
          } else D[1] = 0, D[3] = S;
          md.drawOne(r, T, {
            skipTitle: !0
          }), md.drawOne(r, b, {
            skipTitle: !0
          }), md.redrawComponents(r, [T._id, b._id]);
          var I = k ? A / D[2] : 1,
            V = q ? S / D[3] : 1,
            K = k ? D[0] : 0,
            Q = q ? D[1] : 0,
            ie = k ? D[0] / D[2] * A : 0,
            me = q ? D[1] / D[3] * S : 0,
            pe = T._offset - ie,
            ge = b._offset - me;
          w.clipRect.call(vn.setTranslate, K, Q).call(vn.setScale, 1 / I, 1 / V), w.plot.call(vn.setTranslate, pe, ge).call(vn.setScale, I, V), vn.setPointGroupScale(w.zoomScalePts, 1 / I, 1 / V), vn.setTextPointsScale(w.zoomScaleTxt, 1 / I, 1 / V);
        }
        var s;
        n && (s = n());
        function u() {
          for (var m = {}, _ = 0; _ < t.length; _++) {
            var w = t[_],
              T = w.plotinfo.xaxis,
              b = w.plotinfo.yaxis;
            w.xr1 && (m[T._name + ".range"] = w.xr1.slice()), w.yr1 && (m[b._name + ".range"] = w.yr1.slice());
          }
          return s && s(), TL.call("relayout", r, m).then(function () {
            for (var A = 0; A < t.length; A++) l(t[A].plotinfo);
          });
        }
        function f() {
          for (var m = {}, _ = 0; _ < t.length; _++) {
            var w = t[_],
              T = w.plotinfo.xaxis,
              b = w.plotinfo.yaxis;
            w.xr0 && (m[T._name + ".range"] = w.xr0.slice()), w.yr0 && (m[b._name + ".range"] = w.yr0.slice());
          }
          return TL.call("relayout", r, m).then(function () {
            for (var A = 0; A < t.length; A++) l(t[A].plotinfo);
          });
        }
        var v,
          h,
          d,
          y = Q$.ease(a.easing);
        r._transitionData._interruptCallbacks.push(function () {
          return window.cancelAnimationFrame(d), d = null, f();
        });
        function g() {
          h = Date.now();
          for (var m = Math.min(1, (h - v) / a.duration), _ = y(m), w = 0; w < t.length; w++) o(t[w], _);
          h - v > a.duration ? (u(), d = window.cancelAnimationFrame(g)) : d = window.requestAnimationFrame(g);
        }
        return v = Date.now(), d = window.requestAnimationFrame(g), Promise.resolve();
      };
    });
    var bd = Z(Ta => {
      "use strict";

      var gd = Ir(),
        kL = gr(),
        zo = He(),
        $$ = Pt(),
        j$ = tt(),
        CL = zp().getModuleCalcData,
        ql = Xt(),
        ni = da(),
        ej = fo(),
        Qr = zo.ensureSingle;
      function yd(e, r, t) {
        return zo.ensureSingle(e, r, t, function (a) {
          a.datum(t);
        });
      }
      var No = ni.zindexSeparator;
      Ta.name = "cartesian";
      Ta.attr = ["xaxis", "yaxis"];
      Ta.idRoot = ["x", "y"];
      Ta.idRegex = ni.idRegex;
      Ta.attrRegex = ni.attrRegex;
      Ta.attributes = QS();
      Ta.layoutAttributes = Xn();
      Ta.supplyLayoutDefaults = wL();
      Ta.transitionAxes = AL();
      Ta.finalizeSubplots = function (e, r) {
        var t = r._subplots,
          a = t.xaxis,
          n = t.yaxis,
          i = t.cartesian,
          l = i,
          o = {},
          s = {},
          u,
          f,
          v;
        for (u = 0; u < l.length; u++) {
          var h = l[u].split("y");
          o[h[0]] = 1, s["y" + h[1]] = 1;
        }
        for (u = 0; u < a.length; u++) f = a[u], o[f] || (v = (e[ql.id2name(f)] || {}).anchor, ni.idRegex.y.test(v) || (v = "y"), i.push(f + v), l.push(f + v), s[v] || (s[v] = 1, zo.pushUnique(n, v)));
        for (u = 0; u < n.length; u++) v = n[u], s[v] || (f = (e[ql.id2name(v)] || {}).anchor, ni.idRegex.x.test(f) || (f = "x"), i.push(f + v), l.push(f + v), o[f] || (o[f] = 1, zo.pushUnique(a, f)));
        if (!l.length) {
          f = "", v = "";
          for (var d in e) if (ni.attrRegex.test(d)) {
            var y = d.charAt(0);
            y === "x" ? (!f || +d.substr(5) < +f.substr(5)) && (f = d) : (!v || +d.substr(5) < +v.substr(5)) && (v = d);
          }
          f = f ? ql.name2id(f) : "x", v = v ? ql.name2id(v) : "y", a.push(f), n.push(v), i.push(f + v);
        }
      };
      Ta.plot = function (e, r, t, a) {
        var n = e._fullLayout,
          i = n._subplots.cartesian,
          l = e.calcdata,
          o;
        if (!Array.isArray(r)) for (r = [], o = 0; o < l.length; o++) r.push(o);
        for (var s = n._zindices, u = 0; u < s.length; u++) {
          var f = s[u];
          for (o = 0; o < i.length; o++) {
            var v = i[o],
              h = n._plots[v];
            if (u > 0) {
              var d = h.id;
              if (d.indexOf(No) !== -1) continue;
              d += No + (u + 1), h = zo.extendFlat({}, h, {
                id: d,
                plot: n._cartesianlayer.selectAll(".subplot").select("." + d)
              });
            }
            for (var y = [], g, m = 0; m < l.length; m++) {
              var _ = l[m],
                w = _[0].trace;
              f === (w.zorder || 0) && w.xaxis + w.yaxis === v && ((r.indexOf(w.index) !== -1 || w.carpet) && (g && g[0].trace.xaxis + g[0].trace.yaxis === v && ["tonextx", "tonexty", "tonext"].indexOf(w.fill) !== -1 && y.indexOf(g) === -1 && y.push(g), y.push(_)), g = _);
            }
            SL(e, h, y, t, a);
          }
        }
      };
      function SL(e, r, t, a, n) {
        for (var i = ni.traceLayerClasses, l = e._fullLayout, o = l._zindices, s = l._modules, u, f, v, h = [], d = [], y = 0; y < o.length; y++) for (var g = o[y], m = 0; m < s.length; m++) {
          u = s[m];
          var _ = u.name,
            w = kL.modules[_].categories;
          if (w.svg) {
            var T = u.layerName || _ + "layer",
              b = T + (y ? Number(y) + 1 : ""),
              A = u.plot;
            f = CL(t, A, g), v = f[0], t = f[1], v.length && h.push({
              i: i.indexOf(T),
              zindex: y,
              className: b,
              plotMethod: A,
              cdModule: v
            }), w.zoomScale && d.push("." + b);
          }
        }
        h.sort(function (q, D) {
          return (q.zindex || 0) - (D.zindex || 0) || q.i - D.i;
        });
        var S = r.plot.selectAll("g.mlayer").data(h, function (q) {
          return q.className;
        });
        if (S.enter().append("g").attr("class", function (q) {
          return q.className;
        }).classed("mlayer", !0).classed("rangeplot", r.isRangePlot), S.exit().remove(), S.order(), S.each(function (q) {
          var D = gd.select(this),
            R = q.className;
          q.plotMethod(e, r, q.cdModule, D, a, n), ni.clipOnAxisFalseQuery.indexOf("." + R) === -1 && j$.setClipUrl(D, r.layerClipId, e);
        }), l._has("scattergl") && (u = kL.getModule("scattergl"), v = CL(t, u)[0], u.plot(e, r, v)), !e._context.staticPlot && (r._hasClipOnAxisFalse && (r.clipOnAxisFalseTraces = r.plot.selectAll(ni.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), d.length)) {
          var k = r.plot.selectAll(d.join(",")).selectAll(".trace");
          r.zoomScalePts = k.selectAll("path.point"), r.zoomScaleTxt = k.selectAll(".textpoint");
        }
      }
      Ta.clean = function (e, r, t, a) {
        var n = a._plots || {},
          i = r._plots || {},
          l = a._subplots || {},
          o,
          s,
          u;
        if (a._hasOnlyLargeSploms && !r._hasOnlyLargeSploms) for (u in n) o = n[u], o.plotgroup && o.plotgroup.remove();
        var f = a._has && a._has("gl"),
          v = r._has && r._has("gl");
        if (f && !v) for (u in n) o = n[u], o._scene && o._scene.destroy();
        if (l.xaxis && l.yaxis) {
          var h = ql.listIds({
            _fullLayout: a
          });
          for (s = 0; s < h.length; s++) {
            var d = h[s];
            r[ql.id2name(d)] || a._infolayer.selectAll(".g-" + d + "title").remove();
          }
        }
        var y = a._has && a._has("cartesian"),
          g = r._has && r._has("cartesian");
        if (y && !g) qL(a._cartesianlayer.selectAll(".subplot"), a), a._defs.selectAll(".axesclip").remove(), delete a._axisConstraintGroups, delete a._axisMatchGroups;else if (l.cartesian) for (s = 0; s < l.cartesian.length; s++) {
          var m = l.cartesian[s];
          if (m.indexOf(No) === -1 && !i[m]) {
            var _ = "." + m + ",." + m + "-x,." + m + "-y";
            a._cartesianlayer.selectAll(_).remove(), DL(m, a);
          }
        }
      };
      Ta.drawFramework = function (e) {
        var r = e._fullLayout,
          t = e.calcdata,
          a,
          n = {};
        for (a = 0; a < t.length; a++) {
          var i = t[a][0],
            l = i.trace,
            o = l.zorder || 0;
          n[o] || (n[o] = []), n[o].push(i);
        }
        var s = Object.keys(n).map(Number).sort(zo.sorterAsc);
        s.length || (s = [0]), r._zindices = s;
        var u = rj(e),
          f = u.length,
          v = [];
        for (a = 0; a < f; a++) v[a] = u[a].slice();
        for (var h = 1; h < s.length; h++) {
          var d = [];
          for (a = 0; a < f; a++) d[a] = u[a].slice(), d[a][0] += No + (h + 1);
          v = v.concat(d);
        }
        var y = r._cartesianlayer.selectAll(".subplot").data(v, String);
        y.enter().append("g").attr("class", function (g) {
          return "subplot " + g[0];
        }), y.order(), y.exit().call(qL, r), y.each(function (g) {
          var m = g[0],
            _ = m.indexOf(No),
            w = _ !== -1,
            T = w ? m.slice(0, _) : m,
            b = r._plots[m];
          b || (b = zo.extendFlat({}, r._plots[T]), b && (b.id = m, r._plots[m] = b, r._subplots.cartesian.push(m))), b && (b.plotgroup = gd.select(this), LL(e, b), w || (b.draglayer = Qr(r._draggers, "g", m)));
        });
      };
      Ta.rangePlot = function (e, r, t) {
        LL(e, r), SL(e, r, t), $$.style(e);
      };
      function rj(e) {
        var r = e._fullLayout,
          t = r._zindices.length,
          a = r._subplots.cartesian,
          n = a.length,
          i,
          l,
          o,
          s,
          u,
          f,
          v = [],
          h = [];
        for (i = 0; i < n; i++) {
          o = a[i], s = r._plots[o], u = s.xaxis, f = s.yaxis;
          var d = u._mainAxis,
            y = f._mainAxis,
            g = d._id + y._id,
            m = r._plots[g];
          s.overlays = [], g !== o && m ? (s.mainplot = g, s.mainplotinfo = m, h.push(o)) : (s.mainplot = void 0, s.mainplotinfo = void 0, v.push(o));
        }
        for (i = 0; i < h.length; i++) o = h[i], s = r._plots[o], s.mainplotinfo.overlays.push(s);
        var _ = v.concat(h),
          w = [];
        for (i = 0; i < n; i++) {
          o = _[i], s = r._plots[o], u = s.xaxis, f = s.yaxis;
          for (var T = [], b = 1; b <= t; b++) {
            var A = "";
            for (b > 1 && (A += No + b), T.push(o + A), l = 0; l < s.overlays.length; l++) T.push(s.overlays[l].id + A);
          }
          T = T.concat([u.layer, f.layer, u.overlaying || "", f.overlaying || ""]), w.push(T);
        }
        return w;
      }
      function LL(e, r) {
        var t = e._fullLayout,
          a = r.plotgroup,
          n = r.id,
          i = n.indexOf(No),
          l = i !== -1,
          o = ni.layerValue2layerClass[r.xaxis.layer],
          s = ni.layerValue2layerClass[r.yaxis.layer],
          u = t._hasOnlyLargeSploms,
          f = t._zindices.length > 1,
          v = r.mainplotinfo;
        if (!r.mainplot || f) {
          if (u) r.xlines = Qr(a, "path", "xlines-above"), r.ylines = Qr(a, "path", "ylines-above"), r.xaxislayer = Qr(a, "g", "xaxislayer-above"), r.yaxislayer = Qr(a, "g", "yaxislayer-above");else {
            if (!l) {
              var h = Qr(a, "g", "layer-subplot");
              r.shapelayer = Qr(h, "g", "shapelayer"), r.imagelayer = Qr(h, "g", "imagelayer"), v && f ? (r.minorGridlayer = v.minorGridlayer, r.gridlayer = v.gridlayer, r.zerolinelayer = v.zerolinelayer) : (r.minorGridlayer = Qr(a, "g", "minor-gridlayer"), r.gridlayer = Qr(a, "g", "gridlayer"), r.zerolinelayer = Qr(a, "g", "zerolinelayer"));
              var d = Qr(a, "g", "layer-between");
              r.shapelayerBetween = Qr(d, "g", "shapelayer"), r.imagelayerBetween = Qr(d, "g", "imagelayer"), Qr(a, "path", "xlines-below"), Qr(a, "path", "ylines-below"), r.overlinesBelow = Qr(a, "g", "overlines-below"), Qr(a, "g", "xaxislayer-below"), Qr(a, "g", "yaxislayer-below"), r.overaxesBelow = Qr(a, "g", "overaxes-below");
            }
            r.overplot = Qr(a, "g", "overplot"), r.plot = Qr(r.overplot, "g", n), l || (r.xlines = Qr(a, "path", "xlines-above"), r.ylines = Qr(a, "path", "ylines-above"), r.overlinesAbove = Qr(a, "g", "overlines-above"), Qr(a, "g", "xaxislayer-above"), Qr(a, "g", "yaxislayer-above"), r.overaxesAbove = Qr(a, "g", "overaxes-above"), r.xlines = a.select(".xlines-" + o), r.ylines = a.select(".ylines-" + s), r.xaxislayer = a.select(".xaxislayer-" + o), r.yaxislayer = a.select(".yaxislayer-" + s));
          }
        } else {
          var y = v.plotgroup,
            g = n + "-x",
            m = n + "-y";
          r.minorGridlayer = v.minorGridlayer, r.gridlayer = v.gridlayer, r.zerolinelayer = v.zerolinelayer, Qr(v.overlinesBelow, "path", g), Qr(v.overlinesBelow, "path", m), Qr(v.overaxesBelow, "g", g), Qr(v.overaxesBelow, "g", m), r.plot = Qr(v.overplot, "g", n), Qr(v.overlinesAbove, "path", g), Qr(v.overlinesAbove, "path", m), Qr(v.overaxesAbove, "g", g), Qr(v.overaxesAbove, "g", m), r.xlines = y.select(".overlines-" + o).select("." + g), r.ylines = y.select(".overlines-" + s).select("." + m), r.xaxislayer = y.select(".overaxes-" + o).select("." + g), r.yaxislayer = y.select(".overaxes-" + s).select("." + m);
        }
        l || (u || (yd(r.minorGridlayer, "g", r.xaxis._id), yd(r.minorGridlayer, "g", r.yaxis._id), r.minorGridlayer.selectAll("g").map(function (_) {
          return _[0];
        }).sort(ql.idSort), yd(r.gridlayer, "g", r.xaxis._id), yd(r.gridlayer, "g", r.yaxis._id), r.gridlayer.selectAll("g").map(function (_) {
          return _[0];
        }).sort(ql.idSort)), r.xlines.style("fill", "none").classed("crisp", !0), r.ylines.style("fill", "none").classed("crisp", !0));
      }
      function qL(e, r) {
        if (e) {
          var t = {};
          e.each(function (s) {
            var u = s[0],
              f = gd.select(this);
            f.remove(), DL(u, r), t[u] = !0;
          });
          for (var a in r._plots) for (var n = r._plots[a], i = n.overlays || [], l = 0; l < i.length; l++) {
            var o = i[l];
            t[o.id] && o.plot.selectAll(".trace").remove();
          }
        }
      }
      function DL(e, r) {
        r._draggers.selectAll("g." + e).remove(), r._defs.select("#clip" + r._uid + e + "plot").remove();
      }
      Ta.toSVG = function (e) {
        var r = e._fullLayout._glimages,
          t = gd.select(e).selectAll(".svg-container"),
          a = t.filter(function (i, l) {
            return l === t.size() - 1;
          }).selectAll(".gl-canvas-context, .gl-canvas-focus");
        function n() {
          var i = this,
            l = i.toDataURL("image/png"),
            o = r.append("svg:image");
          o.attr({
            xmlns: ej.svg,
            "xlink:href": l,
            preserveAspectRatio: "none",
            x: 0,
            y: 0,
            width: i.style.width,
            height: i.style.height
          });
        }
        a.each(n);
      };
      Ta.updateFx = yg().updateFx;
    });
    var PL = Z((Mfe, EL) => {
      "use strict";

      var xd = on();
      EL.exports = {
        hasLines: xd.hasLines,
        hasMarkers: xd.hasMarkers,
        hasText: xd.hasText,
        isBubble: xd.isBubble,
        attributes: qo(),
        layoutAttributes: Zv(),
        supplyDefaults: ZC(),
        crossTraceDefaults: KC(),
        supplyLayoutDefaults: $C(),
        calc: Zg().calc,
        crossTraceCalc: TS(),
        arraysToCalcdata: Bg(),
        plot: FS(),
        colorbar: r2(),
        formatLabels: OS(),
        style: i2().style,
        styleOnSelect: i2().styleOnSelect,
        hoverPoints: WS(),
        selectPoints: JS(),
        animatable: !0,
        moduleType: "trace",
        name: "scatter",
        basePlotModule: bd(),
        categories: ["cartesian", "svg", "symbols", "errorBarsOK", "showLegend", "scatter-like", "zoomScale"],
        meta: {}
      };
    });
    var NL = Z((Afe, zL) => {
      "use strict";

      var tj = Ir(),
        aj = Er(),
        RL = ug(),
        h2 = He(),
        nj = h2.strScale,
        ij = h2.strRotate,
        lj = h2.strTranslate;
      zL.exports = function (r, t, a) {
        var n = r.node(),
          i = RL[a.arrowhead || 0],
          l = RL[a.startarrowhead || 0],
          o = (a.arrowwidth || 1) * (a.arrowsize || 1),
          s = (a.arrowwidth || 1) * (a.startarrowsize || 1),
          u = t.indexOf("start") >= 0,
          f = t.indexOf("end") >= 0,
          v = i.backoff * o + a.standoff,
          h = l.backoff * s + a.startstandoff,
          d,
          y,
          g,
          m;
        if (n.nodeName === "line") {
          d = {
            x: +r.attr("x1"),
            y: +r.attr("y1")
          }, y = {
            x: +r.attr("x2"),
            y: +r.attr("y2")
          };
          var _ = d.x - y.x,
            w = d.y - y.y;
          if (g = Math.atan2(w, _), m = g + Math.PI, v && h && v + h > Math.sqrt(_ * _ + w * w)) {
            O();
            return;
          }
          if (v) {
            if (v * v > _ * _ + w * w) {
              O();
              return;
            }
            var T = v * Math.cos(g),
              b = v * Math.sin(g);
            y.x += T, y.y += b, r.attr({
              x2: y.x,
              y2: y.y
            });
          }
          if (h) {
            if (h * h > _ * _ + w * w) {
              O();
              return;
            }
            var A = h * Math.cos(g),
              S = h * Math.sin(g);
            d.x -= A, d.y -= S, r.attr({
              x1: d.x,
              y1: d.y
            });
          }
        } else if (n.nodeName === "path") {
          var k = n.getTotalLength(),
            q = "";
          if (k < v + h) {
            O();
            return;
          }
          var D = n.getPointAtLength(0),
            R = n.getPointAtLength(.1);
          g = Math.atan2(D.y - R.y, D.x - R.x), d = n.getPointAtLength(Math.min(h, k)), q = "0px," + h + "px,";
          var z = n.getPointAtLength(k),
            N = n.getPointAtLength(k - .1);
          m = Math.atan2(z.y - N.y, z.x - N.x), y = n.getPointAtLength(Math.max(0, k - v));
          var H = q ? h + v : v;
          q += k - H + "px," + k + "px", r.style("stroke-dasharray", q);
        }
        function O() {
          r.style("stroke-dasharray", "0px,100px");
        }
        function J(X, B, I, V) {
          X.path && (X.noRotate && (I = 0), tj.select(n.parentNode).append("path").attr({
            class: r.attr("class"),
            d: X.path,
            transform: lj(B.x, B.y) + ij(I * 180 / Math.PI) + nj(V)
          }).style({
            fill: aj.rgb(a.arrowcolor),
            "stroke-width": 0
          }));
        }
        u && J(l, d, g, s), f && J(i, y, m, o);
      };
    });
    var _d = Z((kfe, BL) => {
      "use strict";

      var FL = Ir(),
        d2 = gr(),
        oj = Pt(),
        El = He(),
        p2 = El.strTranslate,
        oc = dt(),
        Fo = Er(),
        Ji = tt(),
        IL = ki(),
        m2 = xa(),
        y2 = wl(),
        lc = Qn(),
        sj = ct().arrayEditor,
        uj = NL();
      BL.exports = {
        draw: fj,
        drawOne: HL,
        drawRaw: OL
      };
      function fj(e) {
        var r = e._fullLayout;
        r._infolayer.selectAll(".annotation").remove();
        for (var t = 0; t < r.annotations.length; t++) r.annotations[t].visible && HL(e, t);
        return oj.previousPromises(e);
      }
      function HL(e, r) {
        var t = e._fullLayout,
          a = t.annotations[r] || {},
          n = oc.getFromId(e, a.xref),
          i = oc.getFromId(e, a.yref);
        n && n.setScale(), i && i.setScale(), OL(e, a, r, !1, n, i);
      }
      function Dl(e, r, t, a, n) {
        var i = n[t],
          l = n[t + "ref"],
          o = t.indexOf("y") !== -1,
          s = oc.getRefType(l) === "domain",
          u = o ? a.h : a.w;
        return e ? s ? i + (o ? -r : r) / e._length : e.p2r(e.r2p(i) + r) : i + (o ? -r : r) / u;
      }
      function OL(e, r, t, a, n, i) {
        var l = e._fullLayout,
          o = e._fullLayout._size,
          s = e._context.edits,
          u,
          f;
        a ? (u = "annotation-" + a, f = a + ".annotations") : (u = "annotation", f = "annotations");
        var v = sj(e.layout, f, r),
          h = v.modifyBase,
          d = v.modifyItem,
          y = v.getUpdateObj;
        l._infolayer.selectAll("." + u + '[data-index="' + t + '"]').remove();
        var g = "clip" + l._uid + "_ann" + t;
        if (!r._input || r.visible === !1) {
          FL.selectAll("#" + g).remove();
          return;
        }
        var m = {
            x: {},
            y: {}
          },
          _ = +r.textangle || 0,
          w = l._infolayer.append("g").classed(u, !0).attr("data-index", String(t)).style("opacity", r.opacity),
          T = w.append("g").classed("annotation-text-g", !0),
          b = s[r.showarrow ? "annotationTail" : "annotationPosition"],
          A = r.captureevents || s.annotationText || b;
        function S(V) {
          var K = {
            index: t,
            annotation: r._input,
            fullAnnotation: r,
            event: V
          };
          return a && (K.subplotId = a), K;
        }
        var k = T.append("g").style("pointer-events", A ? "all" : null).call(y2, "pointer").on("click", function () {
          e._dragging = !1, e.emit("plotly_clickannotation", S(FL.event));
        });
        r.hovertext && k.on("mouseover", function () {
          var V = r.hoverlabel,
            K = V.font,
            Q = this.getBoundingClientRect(),
            ie = e.getBoundingClientRect();
          IL.loneHover({
            x0: Q.left - ie.left,
            x1: Q.right - ie.left,
            y: (Q.top + Q.bottom) / 2 - ie.top,
            text: r.hovertext,
            color: V.bgcolor,
            borderColor: V.bordercolor,
            fontFamily: K.family,
            fontSize: K.size,
            fontColor: K.color,
            fontWeight: K.weight,
            fontStyle: K.style,
            fontVariant: K.variant,
            fontShadow: K.fontShadow,
            fontLineposition: K.fontLineposition,
            fontTextcase: K.fontTextcase
          }, {
            container: l._hoverlayer.node(),
            outerContainer: l._paper.node(),
            gd: e
          });
        }).on("mouseout", function () {
          IL.loneUnhover(l._hoverlayer.node());
        });
        var q = r.borderwidth,
          D = r.borderpad,
          R = q + D,
          z = k.append("rect").attr("class", "bg").style("stroke-width", q + "px").call(Fo.stroke, r.bordercolor).call(Fo.fill, r.bgcolor),
          N = r.width || r.height,
          H = l._topclips.selectAll("#" + g).data(N ? [0] : []);
        H.enter().append("clipPath").classed("annclip", !0).attr("id", g).append("rect"), H.exit().remove();
        var O = r.font,
          J = l._meta ? El.templateString(r.text, l._meta) : r.text,
          X = k.append("text").classed("annotation-text", !0).text(J);
        function B(V) {
          return V.call(Ji.font, O).attr({
            "text-anchor": {
              left: "start",
              right: "end"
            }[r.align] || "middle"
          }), m2.convertToTspans(V, e, I), V;
        }
        function I() {
          var V = X.selectAll("a");
          if (V.size() === 1 && V.text() === X.text()) {
            var K = k.insert("a", ":first-child").attr({
              "xlink:xlink:href": V.attr("xlink:href"),
              "xlink:xlink:show": V.attr("xlink:show")
            }).style({
              cursor: "pointer"
            });
            K.node().appendChild(z.node());
          }
          var Q = k.select(".annotation-text-math-group"),
            ie = !Q.empty(),
            me = Ji.bBox((ie ? Q : X).node()),
            pe = me.width,
            ge = me.height,
            j = r.width || pe,
            _e = r.height || ge,
            se = Math.round(j + 2 * R),
            Se = Math.round(_e + 2 * R);
          function ve(qe, ke) {
            return ke === "auto" && (qe < 1 / 3 ? ke = "left" : qe > 2 / 3 ? ke = "right" : ke = "center"), {
              center: 0,
              middle: 0,
              left: .5,
              bottom: -.5,
              right: -.5,
              top: .5
            }[ke];
          }
          for (var Ae = !1, Y = ["x", "y"], re = 0; re < Y.length; re++) {
            var U = Y[re],
              de = r[U + "ref"] || U,
              be = r["a" + U + "ref"],
              ye = {
                x: n,
                y: i
              }[U],
              Fe = (_ + (U === "x" ? 0 : -90)) * Math.PI / 180,
              Re = se * Math.cos(Fe),
              Pe = Se * Math.sin(Fe),
              Ie = Math.abs(Re) + Math.abs(Pe),
              Be = r[U + "anchor"],
              Ne = r[U + "shift"] * (U === "x" ? 1 : -1),
              Ee = m[U],
              Je,
              We,
              ne,
              Me,
              Ce,
              cr = oc.getRefType(de);
            if (ye && cr !== "domain") {
              var tr = ye.r2fraction(r[U]);
              (tr < 0 || tr > 1) && (be === de ? (tr = ye.r2fraction(r["a" + U]), (tr < 0 || tr > 1) && (Ae = !0)) : Ae = !0), Je = ye._offset + ye.r2p(r[U]), Me = .5;
            } else {
              var De = cr === "domain";
              U === "x" ? (ne = r[U], Je = De ? ye._offset + ye._length * ne : Je = o.l + o.w * ne) : (ne = 1 - r[U], Je = De ? ye._offset + ye._length * ne : Je = o.t + o.h * ne), Me = r.showarrow ? .5 : ne;
            }
            if (r.showarrow) {
              Ee.head = Je;
              var Le = r["a" + U];
              if (Ce = Re * ve(.5, r.xanchor) - Pe * ve(.5, r.yanchor), be === de) {
                var Ye = oc.getRefType(be);
                Ye === "domain" ? (U === "y" && (Le = 1 - Le), Ee.tail = ye._offset + ye._length * Le) : Ye === "paper" ? U === "y" ? (Le = 1 - Le, Ee.tail = o.t + o.h * Le) : Ee.tail = o.l + o.w * Le : Ee.tail = ye._offset + ye.r2p(Le), We = Ce;
              } else Ee.tail = Je + Le, We = Ce + Le;
              Ee.text = Ee.tail + Ce;
              var Ze = l[U === "x" ? "width" : "height"];
              if (de === "paper" && (Ee.head = El.constrain(Ee.head, 1, Ze - 1)), be === "pixel") {
                var Ue = -Math.max(Ee.tail - 3, Ee.text),
                  Oe = Math.min(Ee.tail + 3, Ee.text) - Ze;
                Ue > 0 ? (Ee.tail += Ue, Ee.text += Ue) : Oe > 0 && (Ee.tail -= Oe, Ee.text -= Oe);
              }
              Ee.tail += Ne, Ee.head += Ne;
            } else Ce = Ie * ve(Me, Be), We = Ce, Ee.text = Je + Ce;
            Ee.text += Ne, Ce += Ne, We += Ne, r["_" + U + "padplus"] = Ie / 2 + We, r["_" + U + "padminus"] = Ie / 2 - We, r["_" + U + "size"] = Ie, r["_" + U + "shift"] = Ce;
          }
          if (Ae) {
            k.remove();
            return;
          }
          var Ke = 0,
            fr = 0;
          if (r.align !== "left" && (Ke = (j - pe) * (r.align === "center" ? .5 : 1)), r.valign !== "top" && (fr = (_e - ge) * (r.valign === "middle" ? .5 : 1)), ie) Q.select("svg").attr({
            x: R + Ke - 1,
            y: R + fr
          }).call(Ji.setClipUrl, N ? g : null, e);else {
            var lr = R + fr - me.top,
              ze = R + Ke - me.left;
            X.call(m2.positionText, ze, lr).call(Ji.setClipUrl, N ? g : null, e);
          }
          H.select("rect").call(Ji.setRect, R, R, j, _e), z.call(Ji.setRect, q / 2, q / 2, se - q, Se - q), k.call(Ji.setTranslate, Math.round(m.x.text - se / 2), Math.round(m.y.text - Se / 2)), T.attr({
            transform: "rotate(" + _ + "," + m.x.text + "," + m.y.text + ")"
          });
          var ae = function (qe, ke) {
            w.selectAll(".annotation-arrow-g").remove();
            var ir = m.x.head,
              vr = m.y.head,
              sr = m.x.tail + qe,
              Mr = m.y.tail + ke,
              Ur = m.x.text + qe,
              $r = m.y.text + ke,
              Vr = El.rotationXYMatrix(_, Ur, $r),
              St = El.apply2DTransform(Vr),
              ea = El.apply2DTransform2(Vr),
              ka = +z.attr("width"),
              ra = +z.attr("height"),
              pn = Ur - .5 * ka,
              Ia = pn + ka,
              ta = $r - .5 * ra,
              Ha = ta + ra,
              yr = [[pn, ta, pn, Ha], [pn, Ha, Ia, Ha], [Ia, Ha, Ia, ta], [Ia, ta, pn, ta]].map(ea);
            if (!yr.reduce(function (at, sa) {
              return at ^ !!El.segmentsIntersect(ir, vr, ir + 1e6, vr + 1e6, sa[0], sa[1], sa[2], sa[3]);
            }, !1)) {
              yr.forEach(function (at) {
                var sa = El.segmentsIntersect(sr, Mr, ir, vr, at[0], at[1], at[2], at[3]);
                sa && (sr = sa.x, Mr = sa.y);
              });
              var lt = r.arrowwidth,
                Wr = r.arrowcolor,
                mt = r.arrowside,
                Tt = w.append("g").style({
                  opacity: Fo.opacity(Wr)
                }).classed("annotation-arrow-g", !0),
                ot = Tt.append("path").attr("d", "M" + sr + "," + Mr + "L" + ir + "," + vr).style("stroke-width", lt + "px").call(Fo.stroke, Fo.rgb(Wr));
              if (uj(ot, mt, r), s.annotationPosition && ot.node().parentNode && !a) {
                var yt = ir,
                  Ca = vr;
                if (r.standoff) {
                  var aa = Math.sqrt(Math.pow(ir - sr, 2) + Math.pow(vr - Mr, 2));
                  yt += r.standoff * (sr - ir) / aa, Ca += r.standoff * (Mr - vr) / aa;
                }
                var In = Tt.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({
                    d: "M3,3H-3V-3H3ZM0,0L" + (sr - yt) + "," + (Mr - Ca),
                    transform: p2(yt, Ca)
                  }).style("stroke-width", lt + 6 + "px").call(Fo.stroke, "rgba(0,0,0,0)").call(Fo.fill, "rgba(0,0,0,0)"),
                  Hn,
                  Wt;
                lc.init({
                  element: In.node(),
                  gd: e,
                  prepFn: function () {
                    var at = Ji.getTranslate(k);
                    Hn = at.x, Wt = at.y, n && n.autorange && h(n._name + ".autorange", !0), i && i.autorange && h(i._name + ".autorange", !0);
                  },
                  moveFn: function (at, sa) {
                    var Ul = St(Hn, Wt),
                      Gl = Ul[0] + at,
                      rl = Ul[1] + sa;
                    k.call(Ji.setTranslate, Gl, rl), d("x", Dl(n, at, "x", o, r)), d("y", Dl(i, sa, "y", o, r)), r.axref === r.xref && d("ax", Dl(n, at, "ax", o, r)), r.ayref === r.yref && d("ay", Dl(i, sa, "ay", o, r)), Tt.attr("transform", p2(at, sa)), T.attr({
                      transform: "rotate(" + _ + "," + Gl + "," + rl + ")"
                    });
                  },
                  doneFn: function () {
                    d2.call("_guiRelayout", e, y());
                    var at = document.querySelector(".js-notes-box-panel");
                    at && at.redraw(at.selectedObj);
                  }
                });
              }
            }
          };
          if (r.showarrow && ae(0, 0), b) {
            var oe;
            lc.init({
              element: k.node(),
              gd: e,
              prepFn: function () {
                oe = T.attr("transform");
              },
              moveFn: function (qe, ke) {
                var ir = "pointer";
                if (r.showarrow) r.axref === r.xref ? d("ax", Dl(n, qe, "ax", o, r)) : d("ax", r.ax + qe), r.ayref === r.yref ? d("ay", Dl(i, ke, "ay", o.w, r)) : d("ay", r.ay + ke), ae(qe, ke);else {
                  if (a) return;
                  var vr, sr;
                  if (n) vr = Dl(n, qe, "x", o, r);else {
                    var Mr = r._xsize / o.w,
                      Ur = r.x + (r._xshift - r.xshift) / o.w - Mr / 2;
                    vr = lc.align(Ur + qe / o.w, Mr, 0, 1, r.xanchor);
                  }
                  if (i) sr = Dl(i, ke, "y", o, r);else {
                    var $r = r._ysize / o.h,
                      Vr = r.y - (r._yshift + r.yshift) / o.h - $r / 2;
                    sr = lc.align(Vr - ke / o.h, $r, 0, 1, r.yanchor);
                  }
                  d("x", vr), d("y", sr), (!n || !i) && (ir = lc.getCursor(n ? .5 : vr, i ? .5 : sr, r.xanchor, r.yanchor));
                }
                T.attr({
                  transform: p2(qe, ke) + oe
                }), y2(k, ir);
              },
              clickFn: function (qe, ke) {
                r.captureevents && e.emit("plotly_clickannotation", S(ke));
              },
              doneFn: function () {
                y2(k), d2.call("_guiRelayout", e, y());
                var qe = document.querySelector(".js-notes-box-panel");
                qe && qe.redraw(qe.selectedObj);
              }
            });
          }
        }
        s.annotationText ? X.call(m2.makeEditable, {
          delegate: k,
          gd: e
        }).call(B).on("edit", function (V) {
          r.text = V, this.call(B), d("text", V), n && n.autorange && h(n._name + ".autorange", !0), i && i.autorange && h(i._name + ".autorange", !0), d2.call("_guiRelayout", e, y());
        }) : X.call(B);
      }
    });
    var ZL = Z((Cfe, WL) => {
      "use strict";

      var YL = He(),
        cj = gr(),
        UL = ct().arrayEditor;
      WL.exports = {
        hasClickToShow: vj,
        onClick: hj
      };
      function vj(e, r) {
        var t = VL(e, r);
        return t.on.length > 0 || t.explicitOff.length > 0;
      }
      function hj(e, r) {
        var t = VL(e, r),
          a = t.on,
          n = t.off.concat(t.explicitOff),
          i = {},
          l = e._fullLayout.annotations,
          o,
          s;
        if (a.length || n.length) {
          for (o = 0; o < a.length; o++) s = UL(e.layout, "annotations", l[a[o]]), s.modifyItem("visible", !0), YL.extendFlat(i, s.getUpdateObj());
          for (o = 0; o < n.length; o++) s = UL(e.layout, "annotations", l[n[o]]), s.modifyItem("visible", !1), YL.extendFlat(i, s.getUpdateObj());
          return cj.call("update", e, {}, i);
        }
      }
      function VL(e, r) {
        var t = e._fullLayout.annotations,
          a = [],
          n = [],
          i = [],
          l = (r || []).length,
          o,
          s,
          u,
          f,
          v,
          h,
          d,
          y;
        for (o = 0; o < t.length; o++) if (u = t[o], f = u.clicktoshow, f) {
          for (s = 0; s < l; s++) if (v = r[s], h = v.xaxis, d = v.yaxis, h._id === u.xref && d._id === u.yref && h.d2r(v.x) === GL(u._xclick, h) && d.d2r(v.y) === GL(u._yclick, d)) {
            u.visible ? f === "onout" ? y = n : y = i : y = a, y.push(o);
            break;
          }
          s === l && u.visible && f === "onout" && n.push(o);
        }
        return {
          on: a,
          off: n,
          explicitOff: i
        };
      }
      function GL(e, r) {
        return r.type === "log" ? r.l2r(e) : r.d2r(e);
      }
    });
    var b2 = Z((Sfe, XL) => {
      "use strict";

      var g2 = He(),
        uu = Er();
      XL.exports = function (r, t, a, n) {
        n("opacity");
        var i = n("bgcolor"),
          l = n("bordercolor"),
          o = uu.opacity(l);
        n("borderpad");
        var s = n("borderwidth"),
          u = n("showarrow");
        n("text", u ? " " : a._dfltTitle.annotation), n("textangle"), g2.coerceFont(n, "font", a.font), n("width"), n("align");
        var f = n("height");
        if (f && n("valign"), u) {
          var v = n("arrowside"),
            h,
            d;
          v.indexOf("end") !== -1 && (h = n("arrowhead"), d = n("arrowsize")), v.indexOf("start") !== -1 && (n("startarrowhead", h), n("startarrowsize", d)), n("arrowcolor", o ? t.bordercolor : uu.defaultLine), n("arrowwidth", (o && s || 1) * 2), n("standoff"), n("startstandoff");
        }
        var y = n("hovertext"),
          g = a.hoverlabel || {};
        if (y) {
          var m = n("hoverlabel.bgcolor", g.bgcolor || (uu.opacity(i) ? uu.rgb(i) : uu.defaultLine)),
            _ = n("hoverlabel.bordercolor", g.bordercolor || uu.contrast(m)),
            w = g2.extendFlat({}, g.font);
          w.color || (w.color = _), g2.coerceFont(n, "hoverlabel.font", w);
        }
        n("captureevents", !!y);
      };
    });
    var KL = Z((Lfe, JL) => {
      "use strict";

      var x2 = He(),
        Io = dt(),
        dj = Jn(),
        pj = b2(),
        mj = js();
      JL.exports = function (r, t) {
        dj(r, t, {
          name: "annotations",
          handleItemDefaults: yj
        });
      };
      function yj(e, r, t) {
        function a(T, b) {
          return x2.coerce(e, r, mj, T, b);
        }
        var n = a("visible"),
          i = a("clicktoshow");
        if (n || i) {
          pj(e, r, t, a);
          for (var l = r.showarrow, o = ["x", "y"], s = [-10, -30], u = {
              _fullLayout: t
            }, f = 0; f < 2; f++) {
            var v = o[f],
              h = Io.coerceRef(e, r, u, v, "", "paper");
            if (h !== "paper") {
              var d = Io.getFromId(u, h);
              d._annIndices.push(r._index);
            }
            if (Io.coercePosition(r, u, a, h, v, .5), l) {
              var y = "a" + v,
                g = Io.coerceRef(e, r, u, y, "pixel", ["pixel", "paper"]);
              g !== "pixel" && g !== h && (g = r[y] = "pixel");
              var m = g === "pixel" ? s[f] : .4;
              Io.coercePosition(r, u, a, g, y, m);
            }
            a(v + "anchor"), a(v + "shift");
          }
          if (x2.noneOrAll(e, r, ["x", "y"]), l && x2.noneOrAll(e, r, ["ax", "ay"]), i) {
            var _ = a("xclick"),
              w = a("yclick");
            r._xclick = _ === void 0 ? r.x : Io.cleanPosition(_, u, r.xref), r._yclick = w === void 0 ? r.y : Io.cleanPosition(w, u, r.yref);
          }
        }
      }
    });
    var jL = Z((qfe, $L) => {
      "use strict";

      var _2 = He(),
        Ho = dt(),
        gj = _d().draw;
      $L.exports = function (r) {
        var t = r._fullLayout,
          a = _2.filterVisible(t.annotations);
        if (a.length && r._fullData.length) return _2.syncOrAsync([gj, bj], r);
      };
      function bj(e) {
        var r = e._fullLayout;
        _2.filterVisible(r.annotations).forEach(function (t) {
          var a = Ho.getFromId(e, t.xref),
            n = Ho.getFromId(e, t.yref),
            i = Ho.getRefType(t.xref),
            l = Ho.getRefType(t.yref);
          t._extremes = {}, i === "range" && QL(t, a), l === "range" && QL(t, n);
        });
      }
      function QL(e, r) {
        var t = r._id,
          a = t.charAt(0),
          n = e[a],
          i = e["a" + a],
          l = e[a + "ref"],
          o = e["a" + a + "ref"],
          s = e["_" + a + "padplus"],
          u = e["_" + a + "padminus"],
          f = {
            x: 1,
            y: -1
          }[a] * e[a + "shift"],
          v = 3 * e.arrowsize * e.arrowwidth || 0,
          h = v + f,
          d = v - f,
          y = 3 * e.startarrowsize * e.arrowwidth || 0,
          g = y + f,
          m = y - f,
          _;
        if (o === l) {
          var w = Ho.findExtremes(r, [r.r2c(n)], {
              ppadplus: h,
              ppadminus: d
            }),
            T = Ho.findExtremes(r, [r.r2c(i)], {
              ppadplus: Math.max(s, g),
              ppadminus: Math.max(u, m)
            });
          _ = {
            min: [w.min[0], T.min[0]],
            max: [w.max[0], T.max[0]]
          };
        } else g = i ? g + i : g, m = i ? m - i : m, _ = Ho.findExtremes(r, [r.r2c(n)], {
          ppadplus: Math.max(s, h, g),
          ppadminus: Math.max(u, d, m)
        });
        e._extremes[t] = _;
      }
    });
    var rq = Z((Dfe, eq) => {
      "use strict";

      var xj = Hr(),
        _j = vv();
      eq.exports = function (r, t, a, n) {
        t = t || {};
        var i = a === "log" && t.type === "linear",
          l = a === "linear" && t.type === "log";
        if (!(i || l)) return;
        var o = r._fullLayout.annotations,
          s = t._id.charAt(0),
          u,
          f;
        function v(d) {
          var y = u[d],
            g = null;
          i ? g = _j(y, t.range) : g = Math.pow(10, y), xj(g) || (g = null), n(f + d, g);
        }
        for (var h = 0; h < o.length; h++) u = o[h], f = "annotations[" + h + "].", u[s + "ref"] === t._id && v(s), u["a" + s + "ref"] === t._id && v("a" + s);
      };
    });
    var nq = Z((Efe, aq) => {
      "use strict";

      var w2 = _d(),
        tq = ZL();
      aq.exports = {
        moduleType: "component",
        name: "annotations",
        layoutAttributes: js(),
        supplyLayoutDefaults: KL(),
        includeBasePlot: Yf()("annotations"),
        calcAutorange: jL(),
        draw: w2.draw,
        drawOne: w2.drawOne,
        drawRaw: w2.drawRaw,
        hasClickToShow: tq.hasClickToShow,
        onClick: tq.onClick,
        convertCoords: rq()
      };
    });
    var wd = Z((Pfe, iq) => {
      "use strict";

      var ft = js(),
        wj = pi().overrideAll,
        Tj = ct().templatedArray;
      iq.exports = wj(Tj("annotation", {
        visible: ft.visible,
        x: {
          valType: "any"
        },
        y: {
          valType: "any"
        },
        z: {
          valType: "any"
        },
        ax: {
          valType: "number"
        },
        ay: {
          valType: "number"
        },
        xanchor: ft.xanchor,
        xshift: ft.xshift,
        yanchor: ft.yanchor,
        yshift: ft.yshift,
        text: ft.text,
        textangle: ft.textangle,
        font: ft.font,
        width: ft.width,
        height: ft.height,
        opacity: ft.opacity,
        align: ft.align,
        valign: ft.valign,
        bgcolor: ft.bgcolor,
        bordercolor: ft.bordercolor,
        borderpad: ft.borderpad,
        borderwidth: ft.borderwidth,
        showarrow: ft.showarrow,
        arrowcolor: ft.arrowcolor,
        arrowhead: ft.arrowhead,
        startarrowhead: ft.startarrowhead,
        arrowside: ft.arrowside,
        arrowsize: ft.arrowsize,
        startarrowsize: ft.startarrowsize,
        arrowwidth: ft.arrowwidth,
        standoff: ft.standoff,
        startstandoff: ft.startstandoff,
        hovertext: ft.hovertext,
        hoverlabel: ft.hoverlabel,
        captureevents: ft.captureevents
      }), "calc", "from-root");
    });
    var oq = Z((Rfe, lq) => {
      "use strict";

      var T2 = He(),
        Mj = dt(),
        Aj = Jn(),
        kj = b2(),
        Cj = wd();
      lq.exports = function (r, t, a) {
        Aj(r, t, {
          name: "annotations",
          handleItemDefaults: Sj,
          fullLayout: a.fullLayout
        });
      };
      function Sj(e, r, t, a) {
        function n(o, s) {
          return T2.coerce(e, r, Cj, o, s);
        }
        function i(o) {
          var s = o + "axis",
            u = {
              _fullLayout: {}
            };
          return u._fullLayout[s] = t[s], Mj.coercePosition(r, u, n, o, o, .5);
        }
        var l = n("visible");
        l && (kj(e, r, a.fullLayout, n), i("x"), i("y"), i("z"), T2.noneOrAll(e, r, ["x", "y", "z"]), r.xref = "x", r.yref = "y", r.zref = "z", n("xanchor"), n("yanchor"), n("xshift"), n("yshift"), r.showarrow && (r.axref = "pixel", r.ayref = "pixel", n("ax", -10), n("ay", -30), T2.noneOrAll(e, r, ["ax", "ay"])));
      }
    });
    var cq = Z((zfe, fq) => {
      "use strict";

      var sq = He(),
        uq = dt();
      fq.exports = function (r) {
        for (var t = r.fullSceneLayout, a = t.annotations, n = 0; n < a.length; n++) Lj(a[n], r);
        r.fullLayout._infolayer.selectAll(".annotation-" + r.id).remove();
      };
      function Lj(e, r) {
        var t = r.fullSceneLayout,
          a = t.domain,
          n = r.fullLayout._size,
          i = {
            pdata: null,
            type: "linear",
            autorange: !1,
            range: [-1 / 0, 1 / 0]
          };
        e._xa = {}, sq.extendFlat(e._xa, i), uq.setConvert(e._xa), e._xa._offset = n.l + a.x[0] * n.w, e._xa.l2p = function () {
          return .5 * (1 + e._pdata[0] / e._pdata[3]) * n.w * (a.x[1] - a.x[0]);
        }, e._ya = {}, sq.extendFlat(e._ya, i), uq.setConvert(e._ya), e._ya._offset = n.t + (1 - a.y[1]) * n.h, e._ya.l2p = function () {
          return .5 * (1 - e._pdata[1] / e._pdata[3]) * n.h * (a.y[1] - a.y[0]);
        };
      }
    });
    var hq = Z((Nfe, vq) => {
      "use strict";

      function M2(e, r) {
        var t = [0, 0, 0, 0],
          a,
          n;
        for (a = 0; a < 4; ++a) for (n = 0; n < 4; ++n) t[n] += e[4 * a + n] * r[a];
        return t;
      }
      function qj(e, r) {
        var t = M2(e.projection, M2(e.view, M2(e.model, [r[0], r[1], r[2], 1])));
        return t;
      }
      vq.exports = qj;
    });
    var pq = Z((Ffe, dq) => {
      "use strict";

      var Dj = _d().drawRaw,
        Ej = hq(),
        Pj = ["x", "y", "z"];
      dq.exports = function (r) {
        for (var t = r.fullSceneLayout, a = r.dataScale, n = t.annotations, i = 0; i < n.length; i++) {
          for (var l = n[i], o = !1, s = 0; s < 3; s++) {
            var u = Pj[s],
              f = l[u],
              v = t[u + "axis"],
              h = v.r2fraction(f);
            if (h < 0 || h > 1) {
              o = !0;
              break;
            }
          }
          o ? r.fullLayout._infolayer.select(".annotation-" + r.id + '[data-index="' + i + '"]').remove() : (l._pdata = Ej(r.glplot.cameraParams, [t.xaxis.r2l(l.x) * a[0], t.yaxis.r2l(l.y) * a[1], t.zaxis.r2l(l.z) * a[2]]), Dj(r.graphDiv, l, i, r.id, l._xa, l._ya));
        }
      };
    });
    var gq = Z((Ife, yq) => {
      "use strict";

      var Rj = gr(),
        mq = He();
      yq.exports = {
        moduleType: "component",
        name: "annotations3d",
        schema: {
          subplots: {
            scene: {
              annotations: wd()
            }
          }
        },
        layoutAttributes: wd(),
        handleDefaults: oq(),
        includeBasePlot: zj,
        convert: cq(),
        draw: pq()
      };
      function zj(e, r) {
        var t = Rj.subplotsRegistry.gl3d;
        if (t) for (var a = t.attrRegex, n = Object.keys(e), i = 0; i < n.length; i++) {
          var l = n[i];
          a.test(l) && (e[l].annotations || []).length && (mq.pushUnique(r._basePlotModules, t), mq.pushUnique(r._subplots.gl3d, l));
        }
      }
    });
    var A2 = Z((Ofe, wq) => {
      "use strict";

      var bq = js(),
        xq = ha(),
        _q = qo().line,
        Nj = mi().dash,
        ii = Yt().extendFlat,
        Fj = ct().templatedArray,
        Hfe = Bf(),
        fu = Gn(),
        Ij = zi().shapeTexttemplateAttrs,
        Hj = kv();
      wq.exports = Fj("shape", {
        visible: ii({}, fu.visible, {
          editType: "calc+arraydraw"
        }),
        showlegend: {
          valType: "boolean",
          dflt: !1,
          editType: "calc+arraydraw"
        },
        legend: ii({}, fu.legend, {
          editType: "calc+arraydraw"
        }),
        legendgroup: ii({}, fu.legendgroup, {
          editType: "calc+arraydraw"
        }),
        legendgrouptitle: {
          text: ii({}, fu.legendgrouptitle.text, {
            editType: "calc+arraydraw"
          }),
          font: xq({
            editType: "calc+arraydraw"
          }),
          editType: "calc+arraydraw"
        },
        legendrank: ii({}, fu.legendrank, {
          editType: "calc+arraydraw"
        }),
        legendwidth: ii({}, fu.legendwidth, {
          editType: "calc+arraydraw"
        }),
        type: {
          valType: "enumerated",
          values: ["circle", "rect", "path", "line"],
          editType: "calc+arraydraw"
        },
        layer: {
          valType: "enumerated",
          values: ["below", "above", "between"],
          dflt: "above",
          editType: "arraydraw"
        },
        xref: ii({}, bq.xref, {}),
        xsizemode: {
          valType: "enumerated",
          values: ["scaled", "pixel"],
          dflt: "scaled",
          editType: "calc+arraydraw"
        },
        xanchor: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        x0: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        x1: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        x0shift: {
          valType: "number",
          dflt: 0,
          min: -1,
          max: 1,
          editType: "calc"
        },
        x1shift: {
          valType: "number",
          dflt: 0,
          min: -1,
          max: 1,
          editType: "calc"
        },
        yref: ii({}, bq.yref, {}),
        ysizemode: {
          valType: "enumerated",
          values: ["scaled", "pixel"],
          dflt: "scaled",
          editType: "calc+arraydraw"
        },
        yanchor: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        y0: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        y1: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        y0shift: {
          valType: "number",
          dflt: 0,
          min: -1,
          max: 1,
          editType: "calc"
        },
        y1shift: {
          valType: "number",
          dflt: 0,
          min: -1,
          max: 1,
          editType: "calc"
        },
        path: {
          valType: "string",
          editType: "calc+arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "arraydraw"
        },
        line: {
          color: ii({}, _q.color, {
            editType: "arraydraw"
          }),
          width: ii({}, _q.width, {
            editType: "calc+arraydraw"
          }),
          dash: ii({}, Nj, {
            editType: "arraydraw"
          }),
          editType: "calc+arraydraw"
        },
        fillcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "arraydraw"
        },
        fillrule: {
          valType: "enumerated",
          values: ["evenodd", "nonzero"],
          dflt: "evenodd",
          editType: "arraydraw"
        },
        editable: {
          valType: "boolean",
          dflt: !1,
          editType: "calc+arraydraw"
        },
        label: {
          text: {
            valType: "string",
            dflt: "",
            editType: "arraydraw"
          },
          texttemplate: Ij({}, {
            keys: Object.keys(Hj)
          }),
          font: xq({
            editType: "calc+arraydraw",
            colorEditType: "arraydraw"
          }),
          textposition: {
            valType: "enumerated",
            values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right", "start", "middle", "end"],
            editType: "arraydraw"
          },
          textangle: {
            valType: "angle",
            dflt: "auto",
            editType: "calc+arraydraw"
          },
          xanchor: {
            valType: "enumerated",
            values: ["auto", "left", "center", "right"],
            dflt: "auto",
            editType: "calc+arraydraw"
          },
          yanchor: {
            valType: "enumerated",
            values: ["top", "middle", "bottom"],
            editType: "calc+arraydraw"
          },
          padding: {
            valType: "number",
            dflt: 3,
            min: 0,
            editType: "arraydraw"
          },
          editType: "arraydraw"
        },
        editType: "arraydraw"
      });
    });
    var Aq = Z((Bfe, Mq) => {
      "use strict";

      var sc = He(),
        cu = dt(),
        Oj = Jn(),
        Bj = A2(),
        Tq = Al();
      Mq.exports = function (r, t) {
        Oj(r, t, {
          name: "shapes",
          handleItemDefaults: Uj
        });
      };
      function Yj(e, r) {
        return e ? "bottom" : r.indexOf("top") !== -1 ? "top" : r.indexOf("bottom") !== -1 ? "bottom" : "middle";
      }
      function Uj(e, r, t) {
        function a(V, K) {
          return sc.coerce(e, r, Bj, V, K);
        }
        r._isShape = !0;
        var n = a("visible");
        if (n) {
          var i = a("showlegend");
          i && (a("legend"), a("legendwidth"), a("legendgroup"), a("legendgrouptitle.text"), sc.coerceFont(a, "legendgrouptitle.font"), a("legendrank"));
          var l = a("path"),
            o = l ? "path" : "rect",
            s = a("type", o),
            u = s !== "path";
          u && delete r.path, a("editable"), a("layer"), a("opacity"), a("fillcolor"), a("fillrule");
          var f = a("line.width");
          f && (a("line.color"), a("line.dash"));
          for (var v = a("xsizemode"), h = a("ysizemode"), d = ["x", "y"], y = 0; y < 2; y++) {
            var g = d[y],
              m = g + "anchor",
              _ = g === "x" ? v : h,
              w = {
                _fullLayout: t
              },
              T,
              b,
              A,
              S = cu.coerceRef(e, r, w, g, void 0, "paper"),
              k = cu.getRefType(S);
            if (k === "range" ? (T = cu.getFromId(w, S), T._shapeIndices.push(r._index), A = Tq.rangeToShapePosition(T), b = Tq.shapePositionToRange(T), (T.type === "category" || T.type === "multicategory") && (a(g + "0shift"), a(g + "1shift"))) : b = A = sc.identity, u) {
              var q = .25,
                D = .75,
                R = g + "0",
                z = g + "1",
                N = e[R],
                H = e[z];
              e[R] = b(e[R], !0), e[z] = b(e[z], !0), _ === "pixel" ? (a(R, 0), a(z, 10)) : (cu.coercePosition(r, w, a, S, R, q), cu.coercePosition(r, w, a, S, z, D)), r[R] = A(r[R]), r[z] = A(r[z]), e[R] = N, e[z] = H;
            }
            if (_ === "pixel") {
              var O = e[m];
              e[m] = b(e[m], !0), cu.coercePosition(r, w, a, S, m, .25), r[m] = A(r[m]), e[m] = O;
            }
          }
          u && sc.noneOrAll(e, r, ["x0", "x1", "y0", "y1"]);
          var J = s === "line",
            X,
            B;
          if (u && (X = a("label.texttemplate")), X || (B = a("label.text")), B || X) {
            a("label.textangle");
            var I = a("label.textposition", J ? "middle" : "middle center");
            a("label.xanchor"), a("label.yanchor", Yj(J, I)), a("label.padding"), sc.coerceFont(a, "label.font", t.font);
          }
        }
      }
    });
    var Sq = Z((Yfe, Cq) => {
      "use strict";

      var Gj = Er(),
        kq = He();
      function Vj(e, r) {
        return e ? "bottom" : r.indexOf("top") !== -1 ? "top" : r.indexOf("bottom") !== -1 ? "bottom" : "middle";
      }
      Cq.exports = function (r, t, a) {
        a("newshape.visible"), a("newshape.name"), a("newshape.showlegend"), a("newshape.legend"), a("newshape.legendwidth"), a("newshape.legendgroup"), a("newshape.legendgrouptitle.text"), kq.coerceFont(a, "newshape.legendgrouptitle.font"), a("newshape.legendrank"), a("newshape.drawdirection"), a("newshape.layer"), a("newshape.fillcolor"), a("newshape.fillrule"), a("newshape.opacity");
        var n = a("newshape.line.width");
        if (n) {
          var i = (r || {}).plot_bgcolor || "#FFF";
          a("newshape.line.color", Gj.contrast(i)), a("newshape.line.dash");
        }
        var l = r.dragmode === "drawline",
          o = a("newshape.label.text"),
          s = a("newshape.label.texttemplate");
        if (o || s) {
          a("newshape.label.textangle");
          var u = a("newshape.label.textposition", l ? "middle" : "middle center");
          a("newshape.label.xanchor"), a("newshape.label.yanchor", Vj(l, u)), a("newshape.label.padding"), kq.coerceFont(a, "newshape.label.font", t.font);
        }
        a("activeshape.fillcolor"), a("activeshape.opacity");
      };
    });
    var Pq = Z((Ufe, Eq) => {
      "use strict";

      var k2 = He(),
        vu = dt(),
        hu = _f(),
        qq = Al();
      Eq.exports = function (r) {
        var t = r._fullLayout,
          a = k2.filterVisible(t.shapes);
        if (!(!a.length || !r._fullData.length)) for (var n = 0; n < a.length; n++) {
          var i = a[n];
          i._extremes = {};
          var l,
            o,
            s = vu.getRefType(i.xref),
            u = vu.getRefType(i.yref);
          i.xref !== "paper" && s !== "domain" && (l = vu.getFromId(r, i.xref), o = Lq(l, i, hu.paramIsX), o && (i._extremes[l._id] = vu.findExtremes(l, o, Wj(i)))), i.yref !== "paper" && u !== "domain" && (l = vu.getFromId(r, i.yref), o = Lq(l, i, hu.paramIsY), o && (i._extremes[l._id] = vu.findExtremes(l, o, Zj(i))));
        }
      };
      function Wj(e) {
        return Dq(e.line.width, e.xsizemode, e.x0, e.x1, e.path, !1);
      }
      function Zj(e) {
        return Dq(e.line.width, e.ysizemode, e.y0, e.y1, e.path, !0);
      }
      function Dq(e, r, t, a, n, i) {
        var l = e / 2,
          o = i;
        if (r === "pixel") {
          var s = n ? qq.extractPathCoords(n, i ? hu.paramIsY : hu.paramIsX) : [t, a],
            u = k2.aggNums(Math.max, null, s),
            f = k2.aggNums(Math.min, null, s),
            v = f < 0 ? Math.abs(f) + l : l,
            h = u > 0 ? u + l : l;
          return {
            ppad: l,
            ppadplus: o ? v : h,
            ppadminus: o ? h : v
          };
        } else return {
          ppad: l
        };
      }
      function Lq(e, r, t) {
        var a = e._id.charAt(0) === "x" ? "x" : "y",
          n = e.type === "category" || e.type === "multicategory",
          i,
          l,
          o = 0,
          s = 0,
          u = n ? e.r2c : e.d2c,
          f = r[a + "sizemode"] === "scaled";
        if (f ? (i = r[a + "0"], l = r[a + "1"], n && (o = r[a + "0shift"], s = r[a + "1shift"])) : (i = r[a + "anchor"], l = r[a + "anchor"]), i !== void 0) return [u(i) + o, u(l) + s];
        if (r.path) {
          var v = 1 / 0,
            h = -1 / 0,
            d = r.path.match(hu.segmentRE),
            y,
            g,
            m,
            _,
            w;
          for (e.type === "date" && (u = qq.decodeDate(u)), y = 0; y < d.length; y++) g = d[y], m = t[g.charAt(0)].drawn, m !== void 0 && (_ = d[y].substr(1).match(hu.paramRE), !(!_ || _.length < m) && (w = u(_[m]), w < v && (v = w), w > h && (h = w)));
          if (h >= v) return [v, h];
        }
      }
    });
    var Nq = Z((Gfe, zq) => {
      "use strict";

      var Rq = hh();
      zq.exports = {
        moduleType: "component",
        name: "shapes",
        layoutAttributes: A2(),
        supplyLayoutDefaults: Aq(),
        supplyDrawNewShapeDefaults: Sq(),
        includeBasePlot: Yf()("shapes"),
        calcAutorange: Pq(),
        draw: Rq.draw,
        drawOne: Rq.drawOne
      };
    });
    var C2 = Z((Wfe, Iq) => {
      "use strict";

      var Fq = da(),
        Xj = ct().templatedArray,
        Vfe = Bf();
      Iq.exports = Xj("image", {
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "arraydraw"
        },
        source: {
          valType: "string",
          editType: "arraydraw"
        },
        layer: {
          valType: "enumerated",
          values: ["below", "above"],
          dflt: "above",
          editType: "arraydraw"
        },
        sizex: {
          valType: "number",
          dflt: 0,
          editType: "arraydraw"
        },
        sizey: {
          valType: "number",
          dflt: 0,
          editType: "arraydraw"
        },
        sizing: {
          valType: "enumerated",
          values: ["fill", "contain", "stretch"],
          dflt: "contain",
          editType: "arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "arraydraw"
        },
        x: {
          valType: "any",
          dflt: 0,
          editType: "arraydraw"
        },
        y: {
          valType: "any",
          dflt: 0,
          editType: "arraydraw"
        },
        xanchor: {
          valType: "enumerated",
          values: ["left", "center", "right"],
          dflt: "left",
          editType: "arraydraw"
        },
        yanchor: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "top",
          editType: "arraydraw"
        },
        xref: {
          valType: "enumerated",
          values: ["paper", Fq.idRegex.x.toString()],
          dflt: "paper",
          editType: "arraydraw"
        },
        yref: {
          valType: "enumerated",
          values: ["paper", Fq.idRegex.y.toString()],
          dflt: "paper",
          editType: "arraydraw"
        },
        editType: "arraydraw"
      });
    });
    var Oq = Z((Zfe, Hq) => {
      "use strict";

      var Jj = He(),
        S2 = dt(),
        Kj = Jn(),
        Qj = C2(),
        $j = "images";
      Hq.exports = function (r, t) {
        var a = {
          name: $j,
          handleItemDefaults: jj
        };
        Kj(r, t, a);
      };
      function jj(e, r, t) {
        function a(h, d) {
          return Jj.coerce(e, r, Qj, h, d);
        }
        var n = a("source"),
          i = a("visible", !!n);
        if (!i) return r;
        a("layer"), a("xanchor"), a("yanchor"), a("sizex"), a("sizey"), a("sizing"), a("opacity");
        for (var l = {
            _fullLayout: t
          }, o = ["x", "y"], s = 0; s < 2; s++) {
          var u = o[s],
            f = S2.coerceRef(e, r, l, u, "paper", void 0);
          if (f !== "paper") {
            var v = S2.getFromId(l, f);
            v._imgIndices.push(r._index);
          }
          S2.coercePosition(r, l, a, f, u, 0);
        }
        return r;
      }
    });
    var Gq = Z((Xfe, Uq) => {
      "use strict";

      var Bq = Ir(),
        eee = tt(),
        du = dt(),
        Yq = Xt(),
        ree = fo();
      Uq.exports = function (r) {
        var t = r._fullLayout,
          a = [],
          n = {},
          i = [],
          l,
          o;
        for (o = 0; o < t.images.length; o++) {
          var s = t.images[o];
          if (s.visible) if (s.layer === "below" && s.xref !== "paper" && s.yref !== "paper") {
            l = Yq.ref2id(s.xref) + Yq.ref2id(s.yref);
            var u = t._plots[l];
            if (!u) {
              i.push(s);
              continue;
            }
            u.mainplot && (l = u.mainplot.id), n[l] || (n[l] = []), n[l].push(s);
          } else s.layer === "above" ? a.push(s) : i.push(s);
        }
        var f = {
          x: {
            left: {
              sizing: "xMin",
              offset: 0
            },
            center: {
              sizing: "xMid",
              offset: -1 / 2
            },
            right: {
              sizing: "xMax",
              offset: -1
            }
          },
          y: {
            top: {
              sizing: "YMin",
              offset: 0
            },
            middle: {
              sizing: "YMid",
              offset: -1 / 2
            },
            bottom: {
              sizing: "YMax",
              offset: -1
            }
          }
        };
        function v(b) {
          var A = Bq.select(this);
          if (this._imgSrc !== b.source) if (A.attr("xmlns", ree.svg), !r._context.staticPlot || b.source && b.source.slice(0, 5) === "data:") A.attr("xlink:href", b.source), this._imgSrc = b.source;else {
            var S = new Promise(function (k) {
              var q = new Image();
              this.img = q, q.setAttribute("crossOrigin", "anonymous"), q.onerror = D, q.onload = function () {
                var R = document.createElement("canvas");
                R.width = this.width, R.height = this.height;
                var z = R.getContext("2d", {
                  willReadFrequently: !0
                });
                z.drawImage(this, 0, 0);
                var N = R.toDataURL("image/png");
                A.attr("xlink:href", N), k();
              }, A.on("error", D), q.src = b.source, this._imgSrc = b.source;
              function D() {
                A.remove(), k();
              }
            }.bind(this));
            r._promises.push(S);
          }
        }
        function h(b) {
          var A = Bq.select(this),
            S = du.getFromId(r, b.xref),
            k = du.getFromId(r, b.yref),
            q = du.getRefType(b.xref) === "domain",
            D = du.getRefType(b.yref) === "domain",
            R = t._size,
            z,
            N;
          S !== void 0 ? z = typeof b.xref == "string" && q ? S._length * b.sizex : Math.abs(S.l2p(b.sizex) - S.l2p(0)) : z = b.sizex * R.w, k !== void 0 ? N = typeof b.yref == "string" && D ? k._length * b.sizey : Math.abs(k.l2p(b.sizey) - k.l2p(0)) : N = b.sizey * R.h;
          var H = z * f.x[b.xanchor].offset,
            O = N * f.y[b.yanchor].offset,
            J = f.x[b.xanchor].sizing + f.y[b.yanchor].sizing,
            X,
            B;
          switch (S !== void 0 ? X = typeof b.xref == "string" && q ? S._length * b.x + S._offset : S.r2p(b.x) + S._offset : X = b.x * R.w + R.l, X += H, k !== void 0 ? B = typeof b.yref == "string" && D ? k._length * (1 - b.y) + k._offset : k.r2p(b.y) + k._offset : B = R.h - b.y * R.h + R.t, B += O, b.sizing) {
            case "fill":
              J += " slice";
              break;
            case "stretch":
              J = "none";
              break;
          }
          A.attr({
            x: X,
            y: B,
            width: z,
            height: N,
            preserveAspectRatio: J,
            opacity: b.opacity
          });
          var I = S && du.getRefType(b.xref) !== "domain" ? S._id : "",
            V = k && du.getRefType(b.yref) !== "domain" ? k._id : "",
            K = I + V;
          eee.setClipUrl(A, K ? "clip" + t._uid + K : null, r);
        }
        function d(b) {
          return [b.xref, b.x, b.sizex, b.yref, b.y, b.sizey].join("_");
        }
        function y(b, A) {
          return b._index - A._index;
        }
        var g = t._imageLowerLayer.selectAll("image").data(i, d),
          m = t._imageUpperLayer.selectAll("image").data(a, d);
        g.enter().append("image"), m.enter().append("image"), g.exit().remove(), m.exit().remove(), g.each(function (b) {
          v.bind(this)(b), h.bind(this)(b);
        }), m.each(function (b) {
          v.bind(this)(b), h.bind(this)(b);
        }), g.sort(y), m.sort(y);
        var _ = Object.keys(t._plots);
        for (o = 0; o < _.length; o++) {
          l = _[o];
          var w = t._plots[l];
          if (w.imagelayer) {
            var T = w.imagelayer.selectAll("image").data(n[l] || [], d);
            T.enter().append("image"), T.exit().remove(), T.each(function (b) {
              v.bind(this)(b), h.bind(this)(b);
            }), T.sort(y);
          }
        }
      };
    });
    var Zq = Z((Jfe, Wq) => {
      "use strict";

      var Vq = Hr(),
        tee = vv();
      Wq.exports = function (r, t, a, n) {
        t = t || {};
        var i = a === "log" && t.type === "linear",
          l = a === "linear" && t.type === "log";
        if (i || l) {
          for (var o = r._fullLayout.images, s = t._id.charAt(0), u, f, v = 0; v < o.length; v++) if (u = o[v], f = "images[" + v + "].", u[s + "ref"] === t._id) {
            var h = u[s],
              d = u["size" + s],
              y = null,
              g = null;
            if (i) {
              y = tee(h, t.range);
              var m = d / Math.pow(10, y) / 2;
              g = 2 * Math.log(m + Math.sqrt(1 + m * m)) / Math.LN10;
            } else y = Math.pow(10, h), g = y * (Math.pow(10, d / 2) - Math.pow(10, -d / 2));
            Vq(y) ? Vq(g) || (g = null) : (y = null, g = null), n(f + s, y), n(f + "size" + s, g);
          }
        }
      };
    });
    var Jq = Z((Kfe, Xq) => {
      "use strict";

      Xq.exports = {
        moduleType: "component",
        name: "images",
        layoutAttributes: C2(),
        supplyLayoutDefaults: Oq(),
        includeBasePlot: Yf()("images"),
        draw: Gq(),
        convertCoords: Zq()
      };
    });
    var Td = Z((Qfe, Kq) => {
      "use strict";

      Kq.exports = {
        name: "updatemenus",
        containerClassName: "updatemenu-container",
        headerGroupClassName: "updatemenu-header-group",
        headerClassName: "updatemenu-header",
        headerArrowClassName: "updatemenu-header-arrow",
        dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
        dropdownButtonClassName: "updatemenu-dropdown-button",
        buttonClassName: "updatemenu-button",
        itemRectClassName: "updatemenu-item-rect",
        itemTextClassName: "updatemenu-item-text",
        menuIndexAttrName: "updatemenu-active-index",
        autoMarginIdRoot: "updatemenu-",
        blankHeaderOpts: {
          label: "  "
        },
        minWidth: 30,
        minHeight: 30,
        textPadX: 24,
        arrowPadX: 16,
        rx: 2,
        ry: 2,
        textOffsetX: 12,
        textOffsetY: 3,
        arrowOffsetX: 4,
        gapButtonHeader: 5,
        gapButton: 2,
        activeColor: "#F4FAFF",
        hoverColor: "#F4FAFF",
        arrowSymbol: {
          left: "\u25C4",
          right: "\u25BA",
          up: "\u25B2",
          down: "\u25BC"
        }
      };
    });
    var L2 = Z(($fe, $q) => {
      "use strict";

      var aee = ha(),
        nee = hi(),
        iee = Yt().extendFlat,
        lee = pi().overrideAll,
        oee = Cv(),
        Qq = ct().templatedArray,
        see = Qq("button", {
          visible: {
            valType: "boolean"
          },
          method: {
            valType: "enumerated",
            values: ["restyle", "relayout", "animate", "update", "skip"],
            dflt: "restyle"
          },
          args: {
            valType: "info_array",
            freeLength: !0,
            items: [{
              valType: "any"
            }, {
              valType: "any"
            }, {
              valType: "any"
            }]
          },
          args2: {
            valType: "info_array",
            freeLength: !0,
            items: [{
              valType: "any"
            }, {
              valType: "any"
            }, {
              valType: "any"
            }]
          },
          label: {
            valType: "string",
            dflt: ""
          },
          execute: {
            valType: "boolean",
            dflt: !0
          }
        });
      $q.exports = lee(Qq("updatemenu", {
        _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/],
        visible: {
          valType: "boolean"
        },
        type: {
          valType: "enumerated",
          values: ["dropdown", "buttons"],
          dflt: "dropdown"
        },
        direction: {
          valType: "enumerated",
          values: ["left", "right", "up", "down"],
          dflt: "down"
        },
        active: {
          valType: "integer",
          min: -1,
          dflt: 0
        },
        showactive: {
          valType: "boolean",
          dflt: !0
        },
        buttons: see,
        x: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: -.05
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "right"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: 1
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "top"
        },
        pad: iee(oee({
          editType: "arraydraw"
        }), {}),
        font: aee({}),
        bgcolor: {
          valType: "color"
        },
        bordercolor: {
          valType: "color",
          dflt: nee.borderLine
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "arraydraw"
        }
      }), "arraydraw", "from-root");
    });
    var tD = Z((jfe, rD) => {
      "use strict";

      var Md = He(),
        jq = Jn(),
        eD = L2(),
        uee = Td(),
        fee = uee.name,
        cee = eD.buttons;
      rD.exports = function (r, t) {
        var a = {
          name: fee,
          handleItemDefaults: vee
        };
        jq(r, t, a);
      };
      function vee(e, r, t) {
        function a(l, o) {
          return Md.coerce(e, r, eD, l, o);
        }
        var n = jq(e, r, {
            name: "buttons",
            handleItemDefaults: hee
          }),
          i = a("visible", n.length > 0);
        i && (a("active"), a("direction"), a("type"), a("showactive"), a("x"), a("y"), Md.noneOrAll(e, r, ["x", "y"]), a("xanchor"), a("yanchor"), a("pad.t"), a("pad.r"), a("pad.b"), a("pad.l"), Md.coerceFont(a, "font", t.font), a("bgcolor", t.paper_bgcolor), a("bordercolor"), a("borderwidth"));
      }
      function hee(e, r) {
        function t(n, i) {
          return Md.coerce(e, r, cee, n, i);
        }
        var a = t("visible", e.method === "skip" || Array.isArray(e.args));
        a && (t("method"), t("args"), t("args2"), t("label"), t("execute"));
      }
    });
    var iD = Z((ece, nD) => {
      "use strict";

      nD.exports = xt;
      var li = Ir(),
        aD = Er(),
        pu = tt(),
        Ad = He();
      function xt(e, r, t) {
        this.gd = e, this.container = r, this.id = t, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([0]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({
          opacity: 0,
          x: 0,
          y: 0,
          width: 0,
          height: 0
        });
      }
      xt.barWidth = 2;
      xt.barLength = 20;
      xt.barRadius = 2;
      xt.barPad = 1;
      xt.barColor = "#808BA4";
      xt.prototype.enable = function (r, t, a) {
        var n = this.gd._fullLayout,
          i = n.width,
          l = n.height;
        this.position = r;
        var o = this.position.l,
          s = this.position.w,
          u = this.position.t,
          f = this.position.h,
          v = this.position.direction,
          h = v === "down",
          d = v === "left",
          y = v === "right",
          g = v === "up",
          m = s,
          _ = f,
          w,
          T,
          b,
          A;
        !h && !d && !y && !g && (this.position.direction = "down", h = !0);
        var S = h || g;
        S ? (w = o, T = w + m, h ? (b = u, A = Math.min(b + _, l), _ = A - b) : (A = u + _, b = Math.max(A - _, 0), _ = A - b)) : (b = u, A = b + _, d ? (T = o + m, w = Math.max(T - m, 0), m = T - w) : (w = o, T = Math.min(w + m, i), m = T - w)), this._box = {
          l: w,
          t: b,
          w: m,
          h: _
        };
        var k = s > m,
          q = xt.barLength + 2 * xt.barPad,
          D = xt.barWidth + 2 * xt.barPad,
          R = o,
          z = u + f;
        z + D > l && (z = l - D);
        var N = this.container.selectAll("rect.scrollbar-horizontal").data(k ? [0] : []);
        N.exit().on(".drag", null).remove(), N.enter().append("rect").classed("scrollbar-horizontal", !0).call(aD.fill, xt.barColor), k ? (this.hbar = N.attr({
          rx: xt.barRadius,
          ry: xt.barRadius,
          x: R,
          y: z,
          width: q,
          height: D
        }), this._hbarXMin = R + q / 2, this._hbarTranslateMax = m - q) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
        var H = f > _,
          O = xt.barWidth + 2 * xt.barPad,
          J = xt.barLength + 2 * xt.barPad,
          X = o + s,
          B = u;
        X + O > i && (X = i - O);
        var I = this.container.selectAll("rect.scrollbar-vertical").data(H ? [0] : []);
        I.exit().on(".drag", null).remove(), I.enter().append("rect").classed("scrollbar-vertical", !0).call(aD.fill, xt.barColor), H ? (this.vbar = I.attr({
          rx: xt.barRadius,
          ry: xt.barRadius,
          x: X,
          y: B,
          width: O,
          height: J
        }), this._vbarYMin = B + J / 2, this._vbarTranslateMax = _ - J) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
        var V = this.id,
          K = w - .5,
          Q = H ? T + O + .5 : T + .5,
          ie = b - .5,
          me = k ? A + D + .5 : A + .5,
          pe = n._topdefs.selectAll("#" + V).data(k || H ? [0] : []);
        if (pe.exit().remove(), pe.enter().append("clipPath").attr("id", V).append("rect"), k || H ? (this._clipRect = pe.select("rect").attr({
          x: Math.floor(K),
          y: Math.floor(ie),
          width: Math.ceil(Q) - Math.floor(K),
          height: Math.ceil(me) - Math.floor(ie)
        }), this.container.call(pu.setClipUrl, V, this.gd), this.bg.attr({
          x: o,
          y: u,
          width: s,
          height: f
        })) : (this.bg.attr({
          width: 0,
          height: 0
        }), this.container.on("wheel", null).on(".drag", null).call(pu.setClipUrl, null), delete this._clipRect), k || H) {
          var ge = li.behavior.drag().on("dragstart", function () {
            li.event.sourceEvent.preventDefault();
          }).on("drag", this._onBoxDrag.bind(this));
          this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(ge);
          var j = li.behavior.drag().on("dragstart", function () {
            li.event.sourceEvent.preventDefault(), li.event.sourceEvent.stopPropagation();
          }).on("drag", this._onBarDrag.bind(this));
          k && this.hbar.on(".drag", null).call(j), H && this.vbar.on(".drag", null).call(j);
        }
        this.setTranslate(t, a);
      };
      xt.prototype.disable = function () {
        (this.hbar || this.vbar) && (this.bg.attr({
          width: 0,
          height: 0
        }), this.container.on("wheel", null).on(".drag", null).call(pu.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
      };
      xt.prototype._onBoxDrag = function () {
        var r = this.translateX,
          t = this.translateY;
        this.hbar && (r -= li.event.dx), this.vbar && (t -= li.event.dy), this.setTranslate(r, t);
      };
      xt.prototype._onBoxWheel = function () {
        var r = this.translateX,
          t = this.translateY;
        this.hbar && (r += li.event.deltaY), this.vbar && (t += li.event.deltaY), this.setTranslate(r, t);
      };
      xt.prototype._onBarDrag = function () {
        var r = this.translateX,
          t = this.translateY;
        if (this.hbar) {
          var a = r + this._hbarXMin,
            n = a + this._hbarTranslateMax,
            i = Ad.constrain(li.event.x, a, n),
            l = (i - a) / (n - a),
            o = this.position.w - this._box.w;
          r = l * o;
        }
        if (this.vbar) {
          var s = t + this._vbarYMin,
            u = s + this._vbarTranslateMax,
            f = Ad.constrain(li.event.y, s, u),
            v = (f - s) / (u - s),
            h = this.position.h - this._box.h;
          t = v * h;
        }
        this.setTranslate(r, t);
      };
      xt.prototype.setTranslate = function (r, t) {
        var a = this.position.w - this._box.w,
          n = this.position.h - this._box.h;
        if (r = Ad.constrain(r || 0, 0, a), t = Ad.constrain(t || 0, 0, n), this.translateX = r, this.translateY = t, this.container.call(pu.setTranslate, this._box.l - this.position.l - r, this._box.t - this.position.t - t), this._clipRect && this._clipRect.attr({
          x: Math.floor(this.position.l + r - .5),
          y: Math.floor(this.position.t + t - .5)
        }), this.hbar) {
          var i = r / a;
          this.hbar.call(pu.setTranslate, r + i * this._hbarTranslateMax, t);
        }
        if (this.vbar) {
          var l = t / n;
          this.vbar.call(pu.setTranslate, r, t + l * this._vbarTranslateMax);
        }
      };
    });
    var pD = Z((rce, dD) => {
      "use strict";

      var mu = Ir(),
        uc = Pt(),
        fc = Er(),
        yu = tt(),
        hn = He(),
        kd = xa(),
        dee = ct().arrayEditor,
        oD = Da().LINE_SPACING,
        _r = Td(),
        pee = iD();
      dD.exports = function (r) {
        var t = r._fullLayout,
          a = hn.filterVisible(t[_r.name]);
        function n(h) {
          uc.autoMargin(r, vD(h));
        }
        var i = t._menulayer.selectAll("g." + _r.containerClassName).data(a.length > 0 ? [0] : []);
        if (i.enter().append("g").classed(_r.containerClassName, !0).style("cursor", "pointer"), i.exit().each(function () {
          mu.select(this).selectAll("g." + _r.headerGroupClassName).each(n);
        }).remove(), a.length !== 0) {
          var l = i.selectAll("g." + _r.headerGroupClassName).data(a, mee);
          l.enter().append("g").classed(_r.headerGroupClassName, !0);
          for (var o = hn.ensureSingle(i, "g", _r.dropdownButtonGroupClassName, function (h) {
              h.style("pointer-events", "all");
            }), s = 0; s < a.length; s++) {
            var u = a[s];
            wee(r, u);
          }
          var f = "updatemenus" + t._uid,
            v = new pee(r, o, f);
          l.enter().size() && (o.node().parentNode.appendChild(o.node()), o.call(D2)), l.exit().each(function (h) {
            o.call(D2), n(h);
          }).remove(), l.each(function (h) {
            var d = mu.select(this),
              y = h.type === "dropdown" ? o : null;
            uc.manageCommandObserver(r, h, h.buttons, function (g) {
              q2(r, h, h.buttons[g.index], d, y, v, g.index, !0);
            }), h.type === "dropdown" ? (uD(r, d, o, v, h), sD(o, h) && cc(r, d, o, v, h)) : cc(r, d, null, null, h);
          });
        }
      };
      function mee(e) {
        return e._index;
      }
      function yee(e) {
        return +e.attr(_r.menuIndexAttrName) == -1;
      }
      function sD(e, r) {
        return +e.attr(_r.menuIndexAttrName) === r._index;
      }
      function q2(e, r, t, a, n, i, l, o) {
        r.active = l, dee(e.layout, _r.name, r).applyUpdate("active", l), r.type === "buttons" ? cc(e, a, null, null, r) : r.type === "dropdown" && (n.attr(_r.menuIndexAttrName, "-1"), uD(e, a, n, i, r), o || cc(e, a, n, i, r));
      }
      function uD(e, r, t, a, n) {
        var i = hn.ensureSingle(r, "g", _r.headerClassName, function (h) {
            h.style("pointer-events", "all");
          }),
          l = n._dims,
          o = n.active,
          s = n.buttons[o] || _r.blankHeaderOpts,
          u = {
            y: n.pad.t,
            yPad: 0,
            x: n.pad.l,
            xPad: 0,
            index: 0
          },
          f = {
            width: l.headerWidth,
            height: l.headerHeight
          };
        i.call(E2, n, s, e).call(hD, n, u, f);
        var v = hn.ensureSingle(r, "text", _r.headerArrowClassName, function (h) {
          h.attr("text-anchor", "end").call(yu.font, n.font).text(_r.arrowSymbol[n.direction]);
        });
        v.attr({
          x: l.headerWidth - _r.arrowOffsetX + n.pad.l,
          y: l.headerHeight / 2 + _r.textOffsetY + n.pad.t
        }), i.on("click", function () {
          t.call(D2, String(sD(t, n) ? -1 : n._index)), cc(e, r, t, a, n);
        }), i.on("mouseover", function () {
          i.call(fD);
        }), i.on("mouseout", function () {
          i.call(cD, n);
        }), yu.setTranslate(r, l.lx, l.ly);
      }
      function cc(e, r, t, a, n) {
        t || (t = r, t.attr("pointer-events", "all"));
        var i = !yee(t) || n.type === "buttons" ? n.buttons : [],
          l = n.type === "dropdown" ? _r.dropdownButtonClassName : _r.buttonClassName,
          o = t.selectAll("g." + l).data(hn.filterVisible(i)),
          s = o.enter().append("g").classed(l, !0),
          u = o.exit();
        n.type === "dropdown" ? (s.attr("opacity", "0").transition().attr("opacity", "1"), u.transition().attr("opacity", "0").remove()) : u.remove();
        var f = 0,
          v = 0,
          h = n._dims,
          d = ["up", "down"].indexOf(n.direction) !== -1;
        n.type === "dropdown" && (d ? v = h.headerHeight + _r.gapButtonHeader : f = h.headerWidth + _r.gapButtonHeader), n.type === "dropdown" && n.direction === "up" && (v = -_r.gapButtonHeader + _r.gapButton - h.openHeight), n.type === "dropdown" && n.direction === "left" && (f = -_r.gapButtonHeader + _r.gapButton - h.openWidth);
        var y = {
            x: h.lx + f + n.pad.l,
            y: h.ly + v + n.pad.t,
            yPad: _r.gapButton,
            xPad: _r.gapButton,
            index: 0
          },
          g = {
            l: y.x + n.borderwidth,
            t: y.y + n.borderwidth
          };
        o.each(function (m, _) {
          var w = mu.select(this);
          w.call(E2, n, m, e).call(hD, n, y), w.on("click", function () {
            mu.event.defaultPrevented || (m.execute && (m.args2 && n.active === _ ? (q2(e, n, m, r, t, a, -1), uc.executeAPICommand(e, m.method, m.args2)) : (q2(e, n, m, r, t, a, _), uc.executeAPICommand(e, m.method, m.args))), e.emit("plotly_buttonclicked", {
              menu: n,
              button: m,
              active: n.active
            }));
          }), w.on("mouseover", function () {
            w.call(fD);
          }), w.on("mouseout", function () {
            w.call(cD, n), o.call(lD, n);
          });
        }), o.call(lD, n), d ? (g.w = Math.max(h.openWidth, h.headerWidth), g.h = y.y - g.t) : (g.w = y.x - g.l, g.h = Math.max(h.openHeight, h.headerHeight)), g.direction = n.direction, a && (o.size() ? gee(e, r, t, a, n, g) : bee(a));
      }
      function gee(e, r, t, a, n, i) {
        var l = n.direction,
          o = l === "up" || l === "down",
          s = n._dims,
          u = n.active,
          f,
          v,
          h;
        if (o) for (v = 0, h = 0; h < u; h++) v += s.heights[h] + _r.gapButton;else for (f = 0, h = 0; h < u; h++) f += s.widths[h] + _r.gapButton;
        a.enable(i, f, v), a.hbar && a.hbar.attr("opacity", "0").transition().attr("opacity", "1"), a.vbar && a.vbar.attr("opacity", "0").transition().attr("opacity", "1");
      }
      function bee(e) {
        var r = !!e.hbar,
          t = !!e.vbar;
        r && e.hbar.transition().attr("opacity", "0").each("end", function () {
          r = !1, t || e.disable();
        }), t && e.vbar.transition().attr("opacity", "0").each("end", function () {
          t = !1, r || e.disable();
        });
      }
      function E2(e, r, t, a) {
        e.call(xee, r).call(_ee, r, t, a);
      }
      function xee(e, r) {
        var t = hn.ensureSingle(e, "rect", _r.itemRectClassName, function (a) {
          a.attr({
            rx: _r.rx,
            ry: _r.ry,
            "shape-rendering": "crispEdges"
          });
        });
        t.call(fc.stroke, r.bordercolor).call(fc.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px");
      }
      function _ee(e, r, t, a) {
        var n = hn.ensureSingle(e, "text", _r.itemTextClassName, function (o) {
            o.attr({
              "text-anchor": "start",
              "data-notex": 1
            });
          }),
          i = t.label,
          l = a._fullLayout._meta;
        l && (i = hn.templateString(i, l)), n.call(yu.font, r.font).text(i).call(kd.convertToTspans, a);
      }
      function lD(e, r) {
        var t = r.active;
        e.each(function (a, n) {
          var i = mu.select(this);
          n === t && r.showactive && i.select("rect." + _r.itemRectClassName).call(fc.fill, _r.activeColor);
        });
      }
      function fD(e) {
        e.select("rect." + _r.itemRectClassName).call(fc.fill, _r.hoverColor);
      }
      function cD(e, r) {
        e.select("rect." + _r.itemRectClassName).call(fc.fill, r.bgcolor);
      }
      function wee(e, r) {
        var t = r._dims = {
            width1: 0,
            height1: 0,
            heights: [],
            widths: [],
            totalWidth: 0,
            totalHeight: 0,
            openWidth: 0,
            openHeight: 0,
            lx: 0,
            ly: 0
          },
          a = yu.tester.selectAll("g." + _r.dropdownButtonClassName).data(hn.filterVisible(r.buttons));
        a.enter().append("g").classed(_r.dropdownButtonClassName, !0);
        var n = ["up", "down"].indexOf(r.direction) !== -1;
        a.each(function (f, v) {
          var h = mu.select(this);
          h.call(E2, r, f, e);
          var d = h.select("." + _r.itemTextClassName),
            y = d.node() && yu.bBox(d.node()).width,
            g = Math.max(y + _r.textPadX, _r.minWidth),
            m = r.font.size * oD,
            _ = kd.lineCount(d),
            w = Math.max(m * _, _r.minHeight) + _r.textOffsetY;
          w = Math.ceil(w), g = Math.ceil(g), t.widths[v] = g, t.heights[v] = w, t.height1 = Math.max(t.height1, w), t.width1 = Math.max(t.width1, g), n ? (t.totalWidth = Math.max(t.totalWidth, g), t.openWidth = t.totalWidth, t.totalHeight += w + _r.gapButton, t.openHeight += w + _r.gapButton) : (t.totalWidth += g + _r.gapButton, t.openWidth += g + _r.gapButton, t.totalHeight = Math.max(t.totalHeight, w), t.openHeight = t.totalHeight);
        }), n ? t.totalHeight -= _r.gapButton : t.totalWidth -= _r.gapButton, t.headerWidth = t.width1 + _r.arrowPadX, t.headerHeight = t.height1, r.type === "dropdown" && (n ? (t.width1 += _r.arrowPadX, t.totalHeight = t.height1) : t.totalWidth = t.width1, t.totalWidth += _r.arrowPadX), a.remove();
        var i = t.totalWidth + r.pad.l + r.pad.r,
          l = t.totalHeight + r.pad.t + r.pad.b,
          o = e._fullLayout._size;
        t.lx = o.l + o.w * r.x, t.ly = o.t + o.h * (1 - r.y);
        var s = "left";
        hn.isRightAnchor(r) && (t.lx -= i, s = "right"), hn.isCenterAnchor(r) && (t.lx -= i / 2, s = "center");
        var u = "top";
        hn.isBottomAnchor(r) && (t.ly -= l, u = "bottom"), hn.isMiddleAnchor(r) && (t.ly -= l / 2, u = "middle"), t.totalWidth = Math.ceil(t.totalWidth), t.totalHeight = Math.ceil(t.totalHeight), t.lx = Math.round(t.lx), t.ly = Math.round(t.ly), uc.autoMargin(e, vD(r), {
          x: r.x,
          y: r.y,
          l: i * ({
            right: 1,
            center: .5
          }[s] || 0),
          r: i * ({
            left: 1,
            center: .5
          }[s] || 0),
          b: l * ({
            top: 1,
            middle: .5
          }[u] || 0),
          t: l * ({
            bottom: 1,
            middle: .5
          }[u] || 0)
        });
      }
      function vD(e) {
        return _r.autoMarginIdRoot + e._index;
      }
      function hD(e, r, t, a) {
        a = a || {};
        var n = e.select("." + _r.itemRectClassName),
          i = e.select("." + _r.itemTextClassName),
          l = r.borderwidth,
          o = t.index,
          s = r._dims;
        yu.setTranslate(e, l + t.x, l + t.y);
        var u = ["up", "down"].indexOf(r.direction) !== -1,
          f = a.height || (u ? s.heights[o] : s.height1);
        n.attr({
          x: 0,
          y: 0,
          width: a.width || (u ? s.width1 : s.widths[o]),
          height: f
        });
        var v = r.font.size * oD,
          h = kd.lineCount(i),
          d = (h - 1) * v / 2;
        kd.positionText(i, _r.textOffsetX, f / 2 - d + _r.textOffsetY), u ? t.y += s.heights[o] + t.yPad : t.x += s.widths[o] + t.xPad, t.index++;
      }
      function D2(e, r) {
        e.attr(_r.menuIndexAttrName, r || "-1").selectAll("g." + _r.dropdownButtonClassName).remove();
      }
    });
    var yD = Z((tce, mD) => {
      "use strict";

      var Tee = Td();
      mD.exports = {
        moduleType: "component",
        name: Tee.name,
        layoutAttributes: L2(),
        supplyLayoutDefaults: tD(),
        draw: pD()
      };
    });
    var vc = Z((ace, gD) => {
      "use strict";

      gD.exports = {
        name: "sliders",
        containerClassName: "slider-container",
        groupClassName: "slider-group",
        inputAreaClass: "slider-input-area",
        railRectClass: "slider-rail-rect",
        railTouchRectClass: "slider-rail-touch-rect",
        gripRectClass: "slider-grip-rect",
        tickRectClass: "slider-tick-rect",
        inputProxyClass: "slider-input-proxy",
        labelsClass: "slider-labels",
        labelGroupClass: "slider-label-group",
        labelClass: "slider-label",
        currentValueClass: "slider-current-value",
        railHeight: 5,
        menuIndexAttrName: "slider-active-index",
        autoMarginIdRoot: "slider-",
        minWidth: 30,
        minHeight: 30,
        textPadX: 40,
        arrowOffsetX: 4,
        railRadius: 2,
        railWidth: 5,
        railBorder: 4,
        railBorderWidth: 1,
        railBorderColor: "#bec8d9",
        railBgColor: "#f8fafc",
        railInset: 8,
        stepInset: 10,
        gripRadius: 10,
        gripWidth: 20,
        gripHeight: 20,
        gripBorder: 20,
        gripBorderWidth: 1,
        gripBorderColor: "#bec8d9",
        gripBgColor: "#f6f8fa",
        gripBgActiveColor: "#dbdde0",
        labelPadding: 8,
        labelOffset: 0,
        tickWidth: 1,
        tickColor: "#333",
        tickOffset: 25,
        tickLength: 7,
        minorTickOffset: 25,
        minorTickColor: "#333",
        minorTickLength: 4,
        currentValuePadding: 8,
        currentValueInset: 0
      };
    });
    var P2 = Z((nce, _D) => {
      "use strict";

      var bD = ha(),
        Mee = Cv(),
        Aee = Yt().extendDeepAll,
        kee = pi().overrideAll,
        Cee = Vu(),
        xD = ct().templatedArray,
        Oo = vc(),
        See = xD("step", {
          visible: {
            valType: "boolean",
            dflt: !0
          },
          method: {
            valType: "enumerated",
            values: ["restyle", "relayout", "animate", "update", "skip"],
            dflt: "restyle"
          },
          args: {
            valType: "info_array",
            freeLength: !0,
            items: [{
              valType: "any"
            }, {
              valType: "any"
            }, {
              valType: "any"
            }]
          },
          label: {
            valType: "string"
          },
          value: {
            valType: "string"
          },
          execute: {
            valType: "boolean",
            dflt: !0
          }
        });
      _D.exports = kee(xD("slider", {
        visible: {
          valType: "boolean",
          dflt: !0
        },
        active: {
          valType: "number",
          min: 0,
          dflt: 0
        },
        steps: See,
        lenmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "fraction"
        },
        len: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        x: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: 0
        },
        pad: Aee(Mee({
          editType: "arraydraw"
        }), {}, {
          t: {
            dflt: 20
          }
        }),
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "left"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: 0
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "top"
        },
        transition: {
          duration: {
            valType: "number",
            min: 0,
            dflt: 150
          },
          easing: {
            valType: "enumerated",
            values: Cee.transition.easing.values,
            dflt: "cubic-in-out"
          }
        },
        currentvalue: {
          visible: {
            valType: "boolean",
            dflt: !0
          },
          xanchor: {
            valType: "enumerated",
            values: ["left", "center", "right"],
            dflt: "left"
          },
          offset: {
            valType: "number",
            dflt: 10
          },
          prefix: {
            valType: "string"
          },
          suffix: {
            valType: "string"
          },
          font: bD({})
        },
        font: bD({}),
        activebgcolor: {
          valType: "color",
          dflt: Oo.gripBgActiveColor
        },
        bgcolor: {
          valType: "color",
          dflt: Oo.railBgColor
        },
        bordercolor: {
          valType: "color",
          dflt: Oo.railBorderColor
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: Oo.railBorderWidth
        },
        ticklen: {
          valType: "number",
          min: 0,
          dflt: Oo.tickLength
        },
        tickcolor: {
          valType: "color",
          dflt: Oo.tickColor
        },
        tickwidth: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        minorticklen: {
          valType: "number",
          min: 0,
          dflt: Oo.minorTickLength
        }
      }), "arraydraw", "from-root");
    });
    var AD = Z((ice, MD) => {
      "use strict";

      var gu = He(),
        wD = Jn(),
        TD = P2(),
        Lee = vc(),
        qee = Lee.name,
        Dee = TD.steps;
      MD.exports = function (r, t) {
        wD(r, t, {
          name: qee,
          handleItemDefaults: Eee
        });
      };
      function Eee(e, r, t) {
        function a(v, h) {
          return gu.coerce(e, r, TD, v, h);
        }
        for (var n = wD(e, r, {
            name: "steps",
            handleItemDefaults: Pee
          }), i = 0, l = 0; l < n.length; l++) n[l].visible && i++;
        var o;
        if (i < 2 ? o = r.visible = !1 : o = a("visible"), !!o) {
          r._stepCount = i;
          var s = r._visibleSteps = gu.filterVisible(n),
            u = a("active");
          (n[u] || {}).visible || (r.active = s[0]._index), a("x"), a("y"), gu.noneOrAll(e, r, ["x", "y"]), a("xanchor"), a("yanchor"), a("len"), a("lenmode"), a("pad.t"), a("pad.r"), a("pad.b"), a("pad.l"), gu.coerceFont(a, "font", t.font);
          var f = a("currentvalue.visible");
          f && (a("currentvalue.xanchor"), a("currentvalue.prefix"), a("currentvalue.suffix"), a("currentvalue.offset"), gu.coerceFont(a, "currentvalue.font", r.font)), a("transition.duration"), a("transition.easing"), a("bgcolor"), a("activebgcolor"), a("bordercolor"), a("borderwidth"), a("ticklen"), a("tickwidth"), a("tickcolor"), a("minorticklen");
        }
      }
      function Pee(e, r) {
        function t(i, l) {
          return gu.coerce(e, r, Dee, i, l);
        }
        var a;
        if (e.method !== "skip" && !Array.isArray(e.args) ? a = r.visible = !1 : a = t("visible"), a) {
          t("method"), t("args");
          var n = t("label", "step-" + r._index);
          t("value", n), t("execute");
        }
      }
    });
    var zD = Z((lce, RD) => {
      "use strict";

      var oi = Ir(),
        Cd = Pt(),
        Pl = Er(),
        si = tt(),
        dn = He(),
        Ree = dn.strTranslate,
        hc = xa(),
        zee = ct().arrayEditor,
        Dr = vc(),
        N2 = Da(),
        SD = N2.LINE_SPACING,
        R2 = N2.FROM_TL,
        z2 = N2.FROM_BR;
      RD.exports = function (r) {
        var t = r._context.staticPlot,
          a = r._fullLayout,
          n = Nee(a, r),
          i = a._infolayer.selectAll("g." + Dr.containerClassName).data(n.length > 0 ? [0] : []);
        i.enter().append("g").classed(Dr.containerClassName, !0).style("cursor", t ? null : "ew-resize");
        function l(f) {
          f._commandObserver && (f._commandObserver.remove(), delete f._commandObserver), Cd.autoMargin(r, LD(f));
        }
        if (i.exit().each(function () {
          oi.select(this).selectAll("g." + Dr.groupClassName).each(l);
        }).remove(), n.length !== 0) {
          var o = i.selectAll("g." + Dr.groupClassName).data(n, Fee);
          o.enter().append("g").classed(Dr.groupClassName, !0), o.exit().each(l).remove();
          for (var s = 0; s < n.length; s++) {
            var u = n[s];
            Iee(r, u);
          }
          o.each(function (f) {
            var v = oi.select(this);
            Uee(f), Cd.manageCommandObserver(r, f, f._visibleSteps, function (h) {
              var d = v.data()[0];
              d.active !== h.index && (d._dragging || DD(r, v, d, h.index, !1, !0));
            }), Hee(r, oi.select(this), f);
          });
        }
      };
      function LD(e) {
        return Dr.autoMarginIdRoot + e._index;
      }
      function Nee(e, r) {
        for (var t = e[Dr.name], a = [], n = 0; n < t.length; n++) {
          var i = t[n];
          i.visible && (i._gd = r, a.push(i));
        }
        return a;
      }
      function Fee(e) {
        return e._index;
      }
      function Iee(e, r) {
        var t = si.tester.selectAll("g." + Dr.labelGroupClass).data(r._visibleSteps);
        t.enter().append("g").classed(Dr.labelGroupClass, !0);
        var a = 0,
          n = 0;
        t.each(function (y) {
          var g = oi.select(this),
            m = qD(g, {
              step: y
            }, r),
            _ = m.node();
          if (_) {
            var w = si.bBox(_);
            n = Math.max(n, w.height), a = Math.max(a, w.width);
          }
        }), t.remove();
        var i = r._dims = {};
        i.inputAreaWidth = Math.max(Dr.railWidth, Dr.gripHeight);
        var l = e._fullLayout._size;
        i.lx = l.l + l.w * r.x, i.ly = l.t + l.h * (1 - r.y), r.lenmode === "fraction" ? i.outerLength = Math.round(l.w * r.len) : i.outerLength = r.len, i.inputAreaStart = 0, i.inputAreaLength = Math.round(i.outerLength - r.pad.l - r.pad.r);
        var o = i.inputAreaLength - 2 * Dr.stepInset,
          s = o / (r._stepCount - 1),
          u = a + Dr.labelPadding;
        if (i.labelStride = Math.max(1, Math.ceil(u / s)), i.labelHeight = n, i.currentValueMaxWidth = 0, i.currentValueHeight = 0, i.currentValueTotalHeight = 0, i.currentValueMaxLines = 1, r.currentvalue.visible) {
          var f = si.tester.append("g");
          t.each(function (y) {
            var g = Sd(f, r, y.label),
              m = g.node() && si.bBox(g.node()) || {
                width: 0,
                height: 0
              },
              _ = hc.lineCount(g);
            i.currentValueMaxWidth = Math.max(i.currentValueMaxWidth, Math.ceil(m.width)), i.currentValueHeight = Math.max(i.currentValueHeight, Math.ceil(m.height)), i.currentValueMaxLines = Math.max(i.currentValueMaxLines, _);
          }), i.currentValueTotalHeight = i.currentValueHeight + r.currentvalue.offset, f.remove();
        }
        i.height = i.currentValueTotalHeight + Dr.tickOffset + r.ticklen + Dr.labelOffset + i.labelHeight + r.pad.t + r.pad.b;
        var v = "left";
        dn.isRightAnchor(r) && (i.lx -= i.outerLength, v = "right"), dn.isCenterAnchor(r) && (i.lx -= i.outerLength / 2, v = "center");
        var h = "top";
        dn.isBottomAnchor(r) && (i.ly -= i.height, h = "bottom"), dn.isMiddleAnchor(r) && (i.ly -= i.height / 2, h = "middle"), i.outerLength = Math.ceil(i.outerLength), i.height = Math.ceil(i.height), i.lx = Math.round(i.lx), i.ly = Math.round(i.ly);
        var d = {
          y: r.y,
          b: i.height * z2[h],
          t: i.height * R2[h]
        };
        r.lenmode === "fraction" ? (d.l = 0, d.xl = r.x - r.len * R2[v], d.r = 0, d.xr = r.x + r.len * z2[v]) : (d.x = r.x, d.l = i.outerLength * R2[v], d.r = i.outerLength * z2[v]), Cd.autoMargin(e, LD(r), d);
      }
      function Hee(e, r, t) {
        (t.steps[t.active] || {}).visible || (t.active = t._visibleSteps[0]._index), r.call(Sd, t).call(Vee, t).call(Bee, t).call(Yee, t).call(Gee, e, t).call(Oee, e, t);
        var a = t._dims;
        si.setTranslate(r, a.lx + t.pad.l, a.ly + t.pad.t), r.call(PD, t, !1), r.call(Sd, t);
      }
      function Sd(e, r, t) {
        if (r.currentvalue.visible) {
          var a = r._dims,
            n,
            i;
          switch (r.currentvalue.xanchor) {
            case "right":
              n = a.inputAreaLength - Dr.currentValueInset - a.currentValueMaxWidth, i = "left";
              break;
            case "center":
              n = a.inputAreaLength * .5, i = "middle";
              break;
            default:
              n = Dr.currentValueInset, i = "left";
          }
          var l = dn.ensureSingle(e, "text", Dr.labelClass, function (h) {
              h.attr({
                "text-anchor": i,
                "data-notex": 1
              });
            }),
            o = r.currentvalue.prefix ? r.currentvalue.prefix : "";
          if (typeof t == "string") o += t;else {
            var s = r.steps[r.active].label,
              u = r._gd._fullLayout._meta;
            u && (s = dn.templateString(s, u)), o += s;
          }
          r.currentvalue.suffix && (o += r.currentvalue.suffix), l.call(si.font, r.currentvalue.font).text(o).call(hc.convertToTspans, r._gd);
          var f = hc.lineCount(l),
            v = (a.currentValueMaxLines + 1 - f) * r.currentvalue.font.size * SD;
          return hc.positionText(l, n, v), l;
        }
      }
      function Oee(e, r, t) {
        var a = dn.ensureSingle(e, "rect", Dr.gripRectClass, function (n) {
          n.call(ED, r, e, t).style("pointer-events", "all");
        });
        a.attr({
          width: Dr.gripWidth,
          height: Dr.gripHeight,
          rx: Dr.gripRadius,
          ry: Dr.gripRadius
        }).call(Pl.stroke, t.bordercolor).call(Pl.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px");
      }
      function qD(e, r, t) {
        var a = dn.ensureSingle(e, "text", Dr.labelClass, function (l) {
            l.attr({
              "text-anchor": "middle",
              "data-notex": 1
            });
          }),
          n = r.step.label,
          i = t._gd._fullLayout._meta;
        return i && (n = dn.templateString(n, i)), a.call(si.font, t.font).text(n).call(hc.convertToTspans, t._gd), a;
      }
      function Bee(e, r) {
        var t = dn.ensureSingle(e, "g", Dr.labelsClass),
          a = r._dims,
          n = t.selectAll("g." + Dr.labelGroupClass).data(a.labelSteps);
        n.enter().append("g").classed(Dr.labelGroupClass, !0), n.exit().remove(), n.each(function (i) {
          var l = oi.select(this);
          l.call(qD, i, r), si.setTranslate(l, F2(r, i.fraction), Dr.tickOffset + r.ticklen + r.font.size * SD + Dr.labelOffset + a.currentValueTotalHeight);
        });
      }
      function kD(e, r, t, a, n) {
        var i = Math.round(a * (t._stepCount - 1)),
          l = t._visibleSteps[i]._index;
        l !== t.active && DD(e, r, t, l, !0, n);
      }
      function DD(e, r, t, a, n, i) {
        var l = t.active;
        t.active = a, zee(e.layout, Dr.name, t).applyUpdate("active", a);
        var o = t.steps[t.active];
        r.call(PD, t, i), r.call(Sd, t), e.emit("plotly_sliderchange", {
          slider: t,
          step: t.steps[t.active],
          interaction: n,
          previousActive: l
        }), o && o.method && n && (r._nextMethod ? (r._nextMethod.step = o, r._nextMethod.doCallback = n, r._nextMethod.doTransition = i) : (r._nextMethod = {
          step: o,
          doCallback: n,
          doTransition: i
        }, r._nextMethodRaf = window.requestAnimationFrame(function () {
          var s = r._nextMethod.step;
          s.method && (s.execute && Cd.executeAPICommand(e, s.method, s.args), r._nextMethod = null, r._nextMethodRaf = null);
        })));
      }
      function ED(e, r, t) {
        if (r._context.staticPlot) return;
        var a = t.node(),
          n = oi.select(r);
        function i() {
          return t.data()[0];
        }
        function l() {
          var o = i();
          r.emit("plotly_sliderstart", {
            slider: o
          });
          var s = t.select("." + Dr.gripRectClass);
          oi.event.stopPropagation(), oi.event.preventDefault(), s.call(Pl.fill, o.activebgcolor);
          var u = CD(o, oi.mouse(a)[0]);
          kD(r, t, o, u, !0), o._dragging = !0;
          function f() {
            var h = i(),
              d = CD(h, oi.mouse(a)[0]);
            kD(r, t, h, d, !1);
          }
          n.on("mousemove", f), n.on("touchmove", f);
          function v() {
            var h = i();
            h._dragging = !1, s.call(Pl.fill, h.bgcolor), n.on("mouseup", null), n.on("mousemove", null), n.on("touchend", null), n.on("touchmove", null), r.emit("plotly_sliderend", {
              slider: h,
              step: h.steps[h.active]
            });
          }
          n.on("mouseup", v), n.on("touchend", v);
        }
        e.on("mousedown", l), e.on("touchstart", l);
      }
      function Yee(e, r) {
        var t = e.selectAll("rect." + Dr.tickRectClass).data(r._visibleSteps),
          a = r._dims;
        t.enter().append("rect").classed(Dr.tickRectClass, !0), t.exit().remove(), t.attr({
          width: r.tickwidth + "px",
          "shape-rendering": "crispEdges"
        }), t.each(function (n, i) {
          var l = i % a.labelStride === 0,
            o = oi.select(this);
          o.attr({
            height: l ? r.ticklen : r.minorticklen
          }).call(Pl.fill, r.tickcolor), si.setTranslate(o, F2(r, i / (r._stepCount - 1)) - .5 * r.tickwidth, (l ? Dr.tickOffset : Dr.minorTickOffset) + a.currentValueTotalHeight);
        });
      }
      function Uee(e) {
        var r = e._dims;
        r.labelSteps = [];
        for (var t = e._stepCount, a = 0; a < t; a += r.labelStride) r.labelSteps.push({
          fraction: a / (t - 1),
          step: e._visibleSteps[a]
        });
      }
      function PD(e, r, t) {
        for (var a = e.select("rect." + Dr.gripRectClass), n = 0, i = 0; i < r._stepCount; i++) if (r._visibleSteps[i]._index === r.active) {
          n = i;
          break;
        }
        var l = F2(r, n / (r._stepCount - 1));
        if (!r._invokingCommand) {
          var o = a;
          t && r.transition.duration > 0 && (o = o.transition().duration(r.transition.duration).ease(r.transition.easing)), o.attr("transform", Ree(l - Dr.gripWidth * .5, r._dims.currentValueTotalHeight));
        }
      }
      function F2(e, r) {
        var t = e._dims;
        return t.inputAreaStart + Dr.stepInset + (t.inputAreaLength - 2 * Dr.stepInset) * Math.min(1, Math.max(0, r));
      }
      function CD(e, r) {
        var t = e._dims;
        return Math.min(1, Math.max(0, (r - Dr.stepInset - t.inputAreaStart) / (t.inputAreaLength - 2 * Dr.stepInset - 2 * t.inputAreaStart)));
      }
      function Gee(e, r, t) {
        var a = t._dims,
          n = dn.ensureSingle(e, "rect", Dr.railTouchRectClass, function (i) {
            i.call(ED, r, e, t).style("pointer-events", "all");
          });
        n.attr({
          width: a.inputAreaLength,
          height: Math.max(a.inputAreaWidth, Dr.tickOffset + t.ticklen + a.labelHeight)
        }).call(Pl.fill, t.bgcolor).attr("opacity", 0), si.setTranslate(n, 0, a.currentValueTotalHeight);
      }
      function Vee(e, r) {
        var t = r._dims,
          a = t.inputAreaLength - Dr.railInset * 2,
          n = dn.ensureSingle(e, "rect", Dr.railRectClass);
        n.attr({
          width: a,
          height: Dr.railWidth,
          rx: Dr.railRadius,
          ry: Dr.railRadius,
          "shape-rendering": "crispEdges"
        }).call(Pl.stroke, r.bordercolor).call(Pl.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px"), si.setTranslate(n, Dr.railInset, (t.inputAreaWidth - Dr.railWidth) * .5 + t.currentValueTotalHeight);
      }
    });
    var FD = Z((oce, ND) => {
      "use strict";

      var Wee = vc();
      ND.exports = {
        moduleType: "component",
        name: Wee.name,
        layoutAttributes: P2(),
        supplyLayoutDefaults: AD(),
        draw: zD()
      };
    });
    var Ld = Z((sce, HD) => {
      "use strict";

      var ID = hi();
      HD.exports = {
        bgcolor: {
          valType: "color",
          dflt: ID.background,
          editType: "plot"
        },
        bordercolor: {
          valType: "color",
          dflt: ID.defaultLine,
          editType: "plot"
        },
        borderwidth: {
          valType: "integer",
          dflt: 0,
          min: 0,
          editType: "plot"
        },
        autorange: {
          valType: "boolean",
          dflt: !0,
          editType: "calc",
          impliedEdits: {
            "range[0]": void 0,
            "range[1]": void 0
          }
        },
        range: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "calc",
            impliedEdits: {
              "^autorange": !1
            }
          }, {
            valType: "any",
            editType: "calc",
            impliedEdits: {
              "^autorange": !1
            }
          }],
          editType: "calc",
          impliedEdits: {
            autorange: !1
          }
        },
        thickness: {
          valType: "number",
          dflt: .15,
          min: 0,
          max: 1,
          editType: "plot"
        },
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        editType: "calc"
      };
    });
    var I2 = Z((uce, OD) => {
      "use strict";

      OD.exports = {
        _isSubplotObj: !0,
        rangemode: {
          valType: "enumerated",
          values: ["auto", "fixed", "match"],
          dflt: "match",
          editType: "calc"
        },
        range: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "plot"
          }, {
            valType: "any",
            editType: "plot"
          }],
          editType: "plot"
        },
        editType: "calc"
      };
    });
    var qd = Z((fce, BD) => {
      "use strict";

      BD.exports = {
        name: "rangeslider",
        containerClassName: "rangeslider-container",
        bgClassName: "rangeslider-bg",
        rangePlotClassName: "rangeslider-rangeplot",
        maskMinClassName: "rangeslider-mask-min",
        maskMaxClassName: "rangeslider-mask-max",
        slideBoxClassName: "rangeslider-slidebox",
        grabberMinClassName: "rangeslider-grabber-min",
        grabAreaMinClassName: "rangeslider-grabarea-min",
        handleMinClassName: "rangeslider-handle-min",
        grabberMaxClassName: "rangeslider-grabber-max",
        grabAreaMaxClassName: "rangeslider-grabarea-max",
        handleMaxClassName: "rangeslider-handle-max",
        maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
        maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
        maskColor: "rgba(0,0,0,0.4)",
        maskOppAxisColor: "rgba(0,0,0,0.2)",
        slideBoxFill: "transparent",
        slideBoxCursor: "ew-resize",
        grabAreaFill: "transparent",
        grabAreaCursor: "col-resize",
        grabAreaWidth: 10,
        handleWidth: 4,
        handleRadius: 1,
        handleStrokeWidth: 1,
        extraPad: 15
      };
    });
    var GD = Z(Ed => {
      "use strict";

      var Zee = Xt(),
        Xee = xa(),
        YD = qd(),
        Jee = Da().LINE_SPACING,
        Dd = YD.name;
      function UD(e) {
        var r = e && e[Dd];
        return r && r.visible;
      }
      Ed.isVisible = UD;
      Ed.makeData = function (e) {
        for (var r = Zee.list({
            _fullLayout: e
          }, "x", !0), t = e.margin, a = [], n = 0; n < r.length; n++) {
          var i = r[n];
          if (UD(i)) {
            a.push(i);
            var l = i[Dd];
            l._id = Dd + i._id, l._height = (e.height - t.b - t.t) * l.thickness, l._offsetShift = Math.floor(l.borderwidth / 2);
          }
        }
        e._rangeSliderData = a;
      };
      Ed.autoMarginOpts = function (e, r) {
        var t = e._fullLayout,
          a = r[Dd],
          n = r._id.charAt(0),
          i = 0,
          l = 0;
        if (r.side === "bottom" && (i = r._depth, r.title.text !== t._dfltTitle[n])) {
          l = 1.5 * r.title.font.size + 10 + a._offsetShift;
          var o = (r.title.text.match(Xee.BR_TAG_ALL) || []).length;
          l += o * r.title.font.size * Jee;
        }
        return {
          x: 0,
          y: r._counterDomainMin,
          l: 0,
          r: 0,
          t: 0,
          b: a._height + i + Math.max(t.margin.b, l),
          pad: YD.extraPad + a._offsetShift * 2
        };
      };
    });
    var XD = Z((vce, ZD) => {
      "use strict";

      var Pd = He(),
        VD = ct(),
        WD = Xt(),
        Kee = Ld(),
        Qee = I2();
      ZD.exports = function (r, t, a) {
        var n = r[a],
          i = t[a];
        if (!(n.rangeslider || t._requestRangeslider[i._id])) return;
        Pd.isPlainObject(n.rangeslider) || (n.rangeslider = {});
        var l = n.rangeslider,
          o = VD.newContainer(i, "rangeslider");
        function s(A, S) {
          return Pd.coerce(l, o, Kee, A, S);
        }
        var u, f;
        function v(A, S) {
          return Pd.coerce(u, f, Qee, A, S);
        }
        var h = s("visible");
        if (h) {
          s("bgcolor", t.plot_bgcolor), s("bordercolor"), s("borderwidth"), s("thickness"), s("autorange", !i.isValidRange(l.range)), s("range");
          var d = t._subplots;
          if (d) for (var y = d.cartesian.filter(function (A) {
              return A.substr(0, A.indexOf("y")) === WD.name2id(a);
            }).map(function (A) {
              return A.substr(A.indexOf("y"), A.length);
            }), g = Pd.simpleMap(y, WD.id2name), m = 0; m < g.length; m++) {
            var _ = g[m];
            u = l[_] || {}, f = VD.newContainer(o, _, "yaxis");
            var w = t[_],
              T;
            u.range && w.isValidRange(u.range) && (T = "fixed");
            var b = v("rangemode", T);
            b !== "match" && v("range", w.range.slice());
          }
          o._input = l;
        }
      };
    });
    var KD = Z((hce, JD) => {
      "use strict";

      var $ee = Xt().list,
        jee = ff().getAutoRange,
        ere = qd();
      JD.exports = function (r) {
        for (var t = $ee(r, "x", !0), a = 0; a < t.length; a++) {
          var n = t[a],
            i = n[ere.name];
          i && i.visible && i.autorange && (i._input.autorange = !0, i._input.range = i.range = jee(r, n));
        }
      };
    });
    var eE = Z((dce, jD) => {
      "use strict";

      var Rd = Ir(),
        rre = gr(),
        tre = Pt(),
        Ct = He(),
        zd = Ct.strTranslate,
        $D = tt(),
        Rl = Er(),
        are = sf(),
        nre = bd(),
        H2 = Xt(),
        ire = Qn(),
        lre = wl(),
        Fr = qd();
      jD.exports = function (e) {
        for (var r = e._fullLayout, t = r._rangeSliderData, a = 0; a < t.length; a++) {
          var n = t[a][Fr.name];
          n._clipId = n._id + "-" + r._uid;
        }
        function i(o) {
          return o._name;
        }
        var l = r._infolayer.selectAll("g." + Fr.containerClassName).data(t, i);
        l.exit().each(function (o) {
          var s = o[Fr.name];
          r._topdefs.select("#" + s._clipId).remove();
        }).remove(), t.length !== 0 && (l.enter().append("g").classed(Fr.containerClassName, !0).attr("pointer-events", "all"), l.each(function (o) {
          var s = Rd.select(this),
            u = o[Fr.name],
            f = r[H2.id2name(o.anchor)],
            v = u[H2.id2name(o.anchor)];
          if (u.range) {
            var h = Ct.simpleMap(u.range, o.r2l),
              d = Ct.simpleMap(o.range, o.r2l),
              y;
            d[0] < d[1] ? y = [Math.min(h[0], d[0]), Math.max(h[1], d[1])] : y = [Math.max(h[0], d[0]), Math.min(h[1], d[1])], u.range = u._input.range = Ct.simpleMap(y, o.l2r);
          }
          o.cleanRange("rangeslider.range");
          var g = r._size,
            m = o.domain;
          u._width = g.w * (m[1] - m[0]);
          var _ = Math.round(g.l + g.w * m[0]),
            w = Math.round(g.t + g.h * (1 - o._counterDomainMin) + (o.side === "bottom" ? o._depth : 0) + u._offsetShift + Fr.extraPad);
          s.attr("transform", zd(_, w)), u._rl = Ct.simpleMap(u.range, o.r2l);
          var T = u._rl[0],
            b = u._rl[1],
            A = b - T;
          if (u.p2d = function (J) {
            return J / u._width * A + T;
          }, u.d2p = function (J) {
            return (J - T) / A * u._width;
          }, o.rangebreaks) {
            var S = o.locateBreaks(T, b);
            if (S.length) {
              var k,
                q,
                D = 0;
              for (k = 0; k < S.length; k++) q = S[k], D += q.max - q.min;
              var R = u._width / (b - T - D),
                z = [-R * T];
              for (k = 0; k < S.length; k++) q = S[k], z.push(z[z.length - 1] - R * (q.max - q.min));
              for (u.d2p = function (J) {
                for (var X = z[0], B = 0; B < S.length; B++) {
                  var I = S[B];
                  if (J >= I.max) X = z[B + 1];else if (J < I.min) break;
                }
                return X + R * J;
              }, k = 0; k < S.length; k++) q = S[k], q.pmin = u.d2p(q.min), q.pmax = u.d2p(q.max);
              u.p2d = function (J) {
                for (var X = z[0], B = 0; B < S.length; B++) {
                  var I = S[B];
                  if (J >= I.pmax) X = z[B + 1];else if (J < I.pmin) break;
                }
                return (J - X) / R;
              };
            }
          }
          if (v.rangemode !== "match") {
            var N = f.r2l(v.range[0]),
              H = f.r2l(v.range[1]),
              O = H - N;
            u.d2pOppAxis = function (J) {
              return (J - N) / O * u._height;
            };
          }
          s.call(fre, e, o, u).call(cre, e, o, u).call(vre, e, o, u).call(dre, e, o, u, v).call(pre, e, o, u).call(mre, e, o, u), ore(s, e, o, u), ure(s, e, o, u, f, v), o.side === "bottom" && are.draw(e, o._id + "title", {
            propContainer: o,
            propName: o._name + ".title",
            placeholder: r._dfltTitle.x,
            attributes: {
              x: o._offset + o._length / 2,
              y: w + u._height + u._offsetShift + 10 + 1.5 * o.title.font.size,
              "text-anchor": "middle"
            }
          });
        }));
      };
      function QD(e) {
        return typeof e.clientX == "number" ? e.clientX : e.touches && e.touches.length > 0 ? e.touches[0].clientX : 0;
      }
      function ore(e, r, t, a) {
        if (r._context.staticPlot) return;
        var n = e.select("rect." + Fr.slideBoxClassName).node(),
          i = e.select("rect." + Fr.grabAreaMinClassName).node(),
          l = e.select("rect." + Fr.grabAreaMaxClassName).node();
        function o() {
          var s = Rd.event,
            u = s.target,
            f = QD(s),
            v = f - e.node().getBoundingClientRect().left,
            h = a.d2p(t._rl[0]),
            d = a.d2p(t._rl[1]),
            y = ire.coverSlip();
          this.addEventListener("touchmove", g), this.addEventListener("touchend", m), y.addEventListener("mousemove", g), y.addEventListener("mouseup", m);
          function g(_) {
            var w = QD(_),
              T = +w - f,
              b,
              A,
              S;
            switch (u) {
              case n:
                if (S = "ew-resize", h + T > t._length || d + T < 0) return;
                b = h + T, A = d + T;
                break;
              case i:
                if (S = "col-resize", h + T > t._length) return;
                b = h + T, A = d;
                break;
              case l:
                if (S = "col-resize", d + T < 0) return;
                b = h, A = d + T;
                break;
              default:
                S = "ew-resize", b = v, A = v + T;
                break;
            }
            if (A < b) {
              var k = A;
              A = b, b = k;
            }
            a._pixelMin = b, a._pixelMax = A, lre(Rd.select(y), S), sre(e, r, t, a);
          }
          function m() {
            y.removeEventListener("mousemove", g), y.removeEventListener("mouseup", m), this.removeEventListener("touchmove", g), this.removeEventListener("touchend", m), Ct.removeElement(y);
          }
        }
        e.on("mousedown", o), e.on("touchstart", o);
      }
      function sre(e, r, t, a) {
        function n(o) {
          return t.l2r(Ct.constrain(o, a._rl[0], a._rl[1]));
        }
        var i = n(a.p2d(a._pixelMin)),
          l = n(a.p2d(a._pixelMax));
        window.requestAnimationFrame(function () {
          rre.call("_guiRelayout", r, t._name + ".range", [i, l]);
        });
      }
      function ure(e, r, t, a, n, i) {
        var l = Fr.handleWidth / 2;
        function o(_) {
          return Ct.constrain(_, 0, a._width);
        }
        function s(_) {
          return Ct.constrain(_, 0, a._height);
        }
        function u(_) {
          return Ct.constrain(_, -l, a._width + l);
        }
        var f = o(a.d2p(t._rl[0])),
          v = o(a.d2p(t._rl[1]));
        if (e.select("rect." + Fr.slideBoxClassName).attr("x", f).attr("width", v - f), e.select("rect." + Fr.maskMinClassName).attr("width", f), e.select("rect." + Fr.maskMaxClassName).attr("x", v).attr("width", a._width - v), i.rangemode !== "match") {
          var h = a._height - s(a.d2pOppAxis(n._rl[1])),
            d = a._height - s(a.d2pOppAxis(n._rl[0]));
          e.select("rect." + Fr.maskMinOppAxisClassName).attr("x", f).attr("height", h).attr("width", v - f), e.select("rect." + Fr.maskMaxOppAxisClassName).attr("x", f).attr("y", d).attr("height", a._height - d).attr("width", v - f), e.select("rect." + Fr.slideBoxClassName).attr("y", h).attr("height", d - h);
        }
        var y = .5,
          g = Math.round(u(f - l)) - y,
          m = Math.round(u(v - l)) + y;
        e.select("g." + Fr.grabberMinClassName).attr("transform", zd(g, y)), e.select("g." + Fr.grabberMaxClassName).attr("transform", zd(m, y));
      }
      function fre(e, r, t, a) {
        var n = Ct.ensureSingle(e, "rect", Fr.bgClassName, function (s) {
            s.attr({
              x: 0,
              y: 0,
              "shape-rendering": "crispEdges"
            });
          }),
          i = a.borderwidth % 2 === 0 ? a.borderwidth : a.borderwidth - 1,
          l = -a._offsetShift,
          o = $D.crispRound(r, a.borderwidth);
        n.attr({
          width: a._width + i,
          height: a._height + i,
          transform: zd(l, l),
          "stroke-width": o
        }).call(Rl.stroke, a.bordercolor).call(Rl.fill, a.bgcolor);
      }
      function cre(e, r, t, a) {
        var n = r._fullLayout,
          i = Ct.ensureSingleById(n._topdefs, "clipPath", a._clipId, function (l) {
            l.append("rect").attr({
              x: 0,
              y: 0
            });
          });
        i.select("rect").attr({
          width: a._width,
          height: a._height
        });
      }
      function vre(e, r, t, a) {
        var n = r.calcdata,
          i = e.selectAll("g." + Fr.rangePlotClassName).data(t._subplotsWith, Ct.identity);
        i.enter().append("g").attr("class", function (o) {
          return Fr.rangePlotClassName + " " + o;
        }).call($D.setClipUrl, a._clipId, r), i.order(), i.exit().remove();
        var l;
        i.each(function (o, s) {
          var u = Rd.select(this),
            f = s === 0,
            v = H2.getFromId(r, o, "y"),
            h = v._name,
            d = a[h],
            y = {
              data: [],
              layout: {
                xaxis: {
                  type: t.type,
                  domain: [0, 1],
                  range: a.range.slice(),
                  calendar: t.calendar
                },
                width: a._width,
                height: a._height,
                margin: {
                  t: 0,
                  b: 0,
                  l: 0,
                  r: 0
                }
              },
              _context: r._context
            };
          t.rangebreaks && (y.layout.xaxis.rangebreaks = t.rangebreaks), y.layout[h] = {
            type: v.type,
            domain: [0, 1],
            range: d.rangemode !== "match" ? d.range.slice() : v.range.slice(),
            calendar: v.calendar
          }, v.rangebreaks && (y.layout[h].rangebreaks = v.rangebreaks), tre.supplyDefaults(y);
          var g = y._fullLayout.xaxis,
            m = y._fullLayout[h];
          g.clearCalc(), g.setScale(), m.clearCalc(), m.setScale();
          var _ = {
            id: o,
            plotgroup: u,
            xaxis: g,
            yaxis: m,
            isRangePlot: !0
          };
          f ? l = _ : (_.mainplot = "xy", _.mainplotinfo = l), nre.rangePlot(r, _, hre(n, o));
        });
      }
      function hre(e, r) {
        for (var t = [], a = 0; a < e.length; a++) {
          var n = e[a],
            i = n[0].trace;
          i.xaxis + i.yaxis === r && t.push(n);
        }
        return t;
      }
      function dre(e, r, t, a, n) {
        var i = Ct.ensureSingle(e, "rect", Fr.maskMinClassName, function (u) {
          u.attr({
            x: 0,
            y: 0,
            "shape-rendering": "crispEdges"
          });
        });
        i.attr("height", a._height).call(Rl.fill, Fr.maskColor);
        var l = Ct.ensureSingle(e, "rect", Fr.maskMaxClassName, function (u) {
          u.attr({
            y: 0,
            "shape-rendering": "crispEdges"
          });
        });
        if (l.attr("height", a._height).call(Rl.fill, Fr.maskColor), n.rangemode !== "match") {
          var o = Ct.ensureSingle(e, "rect", Fr.maskMinOppAxisClassName, function (u) {
            u.attr({
              y: 0,
              "shape-rendering": "crispEdges"
            });
          });
          o.attr("width", a._width).call(Rl.fill, Fr.maskOppAxisColor);
          var s = Ct.ensureSingle(e, "rect", Fr.maskMaxOppAxisClassName, function (u) {
            u.attr({
              y: 0,
              "shape-rendering": "crispEdges"
            });
          });
          s.attr("width", a._width).style("border-top", Fr.maskOppBorder).call(Rl.fill, Fr.maskOppAxisColor);
        }
      }
      function pre(e, r, t, a) {
        if (!r._context.staticPlot) {
          var n = Ct.ensureSingle(e, "rect", Fr.slideBoxClassName, function (i) {
            i.attr({
              y: 0,
              cursor: Fr.slideBoxCursor,
              "shape-rendering": "crispEdges"
            });
          });
          n.attr({
            height: a._height,
            fill: Fr.slideBoxFill
          });
        }
      }
      function mre(e, r, t, a) {
        var n = Ct.ensureSingle(e, "g", Fr.grabberMinClassName),
          i = Ct.ensureSingle(e, "g", Fr.grabberMaxClassName),
          l = {
            x: 0,
            width: Fr.handleWidth,
            rx: Fr.handleRadius,
            fill: Rl.background,
            stroke: Rl.defaultLine,
            "stroke-width": Fr.handleStrokeWidth,
            "shape-rendering": "crispEdges"
          },
          o = {
            y: Math.round(a._height / 4),
            height: Math.round(a._height / 2)
          },
          s = Ct.ensureSingle(n, "rect", Fr.handleMinClassName, function (d) {
            d.attr(l);
          });
        s.attr(o);
        var u = Ct.ensureSingle(i, "rect", Fr.handleMaxClassName, function (d) {
          d.attr(l);
        });
        u.attr(o);
        var f = {
            width: Fr.grabAreaWidth,
            x: 0,
            y: 0,
            fill: Fr.grabAreaFill,
            cursor: r._context.staticPlot ? void 0 : Fr.grabAreaCursor
          },
          v = Ct.ensureSingle(n, "rect", Fr.grabAreaMinClassName, function (d) {
            d.attr(f);
          });
        v.attr("height", a._height);
        var h = Ct.ensureSingle(i, "rect", Fr.grabAreaMaxClassName, function (d) {
          d.attr(f);
        });
        h.attr("height", a._height);
      }
    });
    var tE = Z((pce, rE) => {
      "use strict";

      var yre = He(),
        gre = Ld(),
        bre = I2(),
        O2 = GD();
      rE.exports = {
        moduleType: "component",
        name: "rangeslider",
        schema: {
          subplots: {
            xaxis: {
              rangeslider: yre.extendFlat({}, gre, {
                yaxis: bre
              })
            }
          }
        },
        layoutAttributes: Ld(),
        handleDefaults: XD(),
        calcAutorange: KD(),
        draw: eE(),
        isVisible: O2.isVisible,
        makeData: O2.makeData,
        autoMarginOpts: O2.autoMarginOpts
      };
    });
    var Nd = Z((mce, nE) => {
      "use strict";

      var xre = ha(),
        aE = hi(),
        _re = ct().templatedArray,
        wre = _re("button", {
          visible: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          step: {
            valType: "enumerated",
            values: ["month", "year", "day", "hour", "minute", "second", "all"],
            dflt: "month",
            editType: "plot"
          },
          stepmode: {
            valType: "enumerated",
            values: ["backward", "todate"],
            dflt: "backward",
            editType: "plot"
          },
          count: {
            valType: "number",
            min: 0,
            dflt: 1,
            editType: "plot"
          },
          label: {
            valType: "string",
            editType: "plot"
          },
          editType: "plot"
        });
      nE.exports = {
        visible: {
          valType: "boolean",
          editType: "plot"
        },
        buttons: wre,
        x: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "plot"
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "left",
          editType: "plot"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "plot"
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "bottom",
          editType: "plot"
        },
        font: xre({
          editType: "plot"
        }),
        bgcolor: {
          valType: "color",
          dflt: aE.lightLine,
          editType: "plot"
        },
        activecolor: {
          valType: "color",
          editType: "plot"
        },
        bordercolor: {
          valType: "color",
          dflt: aE.defaultLine,
          editType: "plot"
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "plot"
        },
        editType: "plot"
      };
    });
    var B2 = Z((yce, iE) => {
      "use strict";

      iE.exports = {
        yPad: .02,
        minButtonWidth: 30,
        rx: 3,
        ry: 3,
        lightAmount: 25,
        darkAmount: 10
      };
    });
    var sE = Z((gce, oE) => {
      "use strict";

      var Fd = He(),
        Tre = Er(),
        Mre = ct(),
        Are = Jn(),
        lE = Nd(),
        Y2 = B2();
      oE.exports = function (r, t, a, n, i) {
        var l = r.rangeselector || {},
          o = Mre.newContainer(t, "rangeselector");
        function s(d, y) {
          return Fd.coerce(l, o, lE, d, y);
        }
        var u = Are(l, o, {
            name: "buttons",
            handleItemDefaults: kre,
            calendar: i
          }),
          f = s("visible", u.length > 0);
        if (f) {
          var v = Cre(t, a, n);
          s("x", v[0]), s("y", v[1]), Fd.noneOrAll(r, t, ["x", "y"]), s("xanchor"), s("yanchor"), Fd.coerceFont(s, "font", a.font);
          var h = s("bgcolor");
          s("activecolor", Tre.contrast(h, Y2.lightAmount, Y2.darkAmount)), s("bordercolor"), s("borderwidth");
        }
      };
      function kre(e, r, t, a) {
        var n = a.calendar;
        function i(s, u) {
          return Fd.coerce(e, r, lE.buttons, s, u);
        }
        var l = i("visible");
        if (l) {
          var o = i("step");
          o !== "all" && (n && n !== "gregorian" && (o === "month" || o === "year") ? r.stepmode = "backward" : i("stepmode"), i("count")), i("label");
        }
      }
      function Cre(e, r, t) {
        for (var a = t.filter(function (o) {
            return r[o].anchor === e._id;
          }), n = 0, i = 0; i < a.length; i++) {
          var l = r[a[i]].domain;
          l && (n = Math.max(l[1], n));
        }
        return [e.domain[0], n + Y2.yPad];
      }
    });
    var fE = Z((bce, uE) => {
      "use strict";

      var Sre = H1(),
        Lre = He().titleCase;
      uE.exports = function (r, t) {
        var a = r._name,
          n = {};
        if (t.step === "all") n[a + ".autorange"] = !0;else {
          var i = qre(r, t);
          n[a + ".range[0]"] = i[0], n[a + ".range[1]"] = i[1];
        }
        return n;
      };
      function qre(e, r) {
        var t = e.range,
          a = new Date(e.r2l(t[1])),
          n = r.step,
          i = Sre["utc" + Lre(n)],
          l = r.count,
          o;
        switch (r.stepmode) {
          case "backward":
            o = e.l2r(+i.offset(a, -l));
            break;
          case "todate":
            var s = i.offset(a, -l);
            o = e.l2r(+i.ceil(s));
            break;
        }
        var u = t[1];
        return [o, u];
      }
    });
    var gE = Z((xce, yE) => {
      "use strict";

      var Hd = Ir(),
        Dre = gr(),
        Ere = Pt(),
        cE = Er(),
        mE = tt(),
        Ki = He(),
        vE = Ki.strTranslate,
        Id = xa(),
        Pre = Xt(),
        V2 = Da(),
        hE = V2.LINE_SPACING,
        dE = V2.FROM_TL,
        pE = V2.FROM_BR,
        G2 = B2(),
        Rre = fE();
      yE.exports = function (r) {
        var t = r._fullLayout,
          a = t._infolayer.selectAll(".rangeselector").data(zre(r), Nre);
        a.enter().append("g").classed("rangeselector", !0), a.exit().remove(), a.style({
          cursor: "pointer",
          "pointer-events": "all"
        }), a.each(function (n) {
          var i = Hd.select(this),
            l = n,
            o = l.rangeselector,
            s = i.selectAll("g.button").data(Ki.filterVisible(o.buttons));
          s.enter().append("g").classed("button", !0), s.exit().remove(), s.each(function (u) {
            var f = Hd.select(this),
              v = Rre(l, u);
            u._isActive = Fre(l, u, v), f.call(U2, o, u), f.call(Hre, o, u, r), f.on("click", function () {
              r._dragged || Dre.call("_guiRelayout", r, v);
            }), f.on("mouseover", function () {
              u._isHovered = !0, f.call(U2, o, u);
            }), f.on("mouseout", function () {
              u._isHovered = !1, f.call(U2, o, u);
            });
          }), Bre(r, s, o, l._name, i);
        });
      };
      function zre(e) {
        for (var r = Pre.list(e, "x", !0), t = [], a = 0; a < r.length; a++) {
          var n = r[a];
          n.rangeselector && n.rangeselector.visible && t.push(n);
        }
        return t;
      }
      function Nre(e) {
        return e._id;
      }
      function Fre(e, r, t) {
        if (r.step === "all") return e.autorange === !0;
        var a = Object.keys(t);
        return e.range[0] === t[a[0]] && e.range[1] === t[a[1]];
      }
      function U2(e, r, t) {
        var a = Ki.ensureSingle(e, "rect", "selector-rect", function (n) {
          n.attr("shape-rendering", "crispEdges");
        });
        a.attr({
          rx: G2.rx,
          ry: G2.ry
        }), a.call(cE.stroke, r.bordercolor).call(cE.fill, Ire(r, t)).style("stroke-width", r.borderwidth + "px");
      }
      function Ire(e, r) {
        return r._isActive || r._isHovered ? e.activecolor : e.bgcolor;
      }
      function Hre(e, r, t, a) {
        function n(l) {
          Id.convertToTspans(l, a);
        }
        var i = Ki.ensureSingle(e, "text", "selector-text", function (l) {
          l.attr("text-anchor", "middle");
        });
        i.call(mE.font, r.font).text(Ore(t, a._fullLayout._meta)).call(n);
      }
      function Ore(e, r) {
        return e.label ? r ? Ki.templateString(e.label, r) : e.label : e.step === "all" ? "all" : e.count + e.step.charAt(0);
      }
      function Bre(e, r, t, a, n) {
        var i = 0,
          l = 0,
          o = t.borderwidth;
        r.each(function () {
          var d = Hd.select(this),
            y = d.select(".selector-text"),
            g = t.font.size * hE,
            m = Math.max(g * Id.lineCount(y), 16) + 3;
          l = Math.max(l, m);
        }), r.each(function () {
          var d = Hd.select(this),
            y = d.select(".selector-rect"),
            g = d.select(".selector-text"),
            m = g.node() && mE.bBox(g.node()).width,
            _ = t.font.size * hE,
            w = Id.lineCount(g),
            T = Math.max(m + 10, G2.minButtonWidth);
          d.attr("transform", vE(o + i, o)), y.attr({
            x: 0,
            y: 0,
            width: T,
            height: l
          }), Id.positionText(g, T / 2, l / 2 - (w - 1) * _ / 2 + 3), i += T + 5;
        });
        var s = e._fullLayout._size,
          u = s.l + s.w * t.x,
          f = s.t + s.h * (1 - t.y),
          v = "left";
        Ki.isRightAnchor(t) && (u -= i, v = "right"), Ki.isCenterAnchor(t) && (u -= i / 2, v = "center");
        var h = "top";
        Ki.isBottomAnchor(t) && (f -= l, h = "bottom"), Ki.isMiddleAnchor(t) && (f -= l / 2, h = "middle"), i = Math.ceil(i), l = Math.ceil(l), u = Math.round(u), f = Math.round(f), Ere.autoMargin(e, a + "-range-selector", {
          x: t.x,
          y: t.y,
          l: i * dE[v],
          r: i * pE[v],
          b: l * pE[h],
          t: l * dE[h]
        }), n.attr("transform", vE(u, f));
      }
    });
    var xE = Z((_ce, bE) => {
      "use strict";

      bE.exports = {
        moduleType: "component",
        name: "rangeselector",
        schema: {
          subplots: {
            xaxis: {
              rangeselector: Nd()
            }
          }
        },
        layoutAttributes: Nd(),
        handleDefaults: sE(),
        draw: gE()
      };
    });
    var Od = Z(W2 => {
      "use strict";

      var _E = Yt().extendFlat;
      W2.attributes = function (e, r) {
        e = e || {}, r = r || {};
        var t = {
            valType: "info_array",
            editType: e.editType,
            items: [{
              valType: "number",
              min: 0,
              max: 1,
              editType: e.editType
            }, {
              valType: "number",
              min: 0,
              max: 1,
              editType: e.editType
            }],
            dflt: [0, 1]
          },
          a = e.name ? e.name + " " : "",
          n = e.trace ? "trace " : "subplot ",
          i = r.description ? " " + r.description : "",
          l = {
            x: _E({}, t, {}),
            y: _E({}, t, {}),
            editType: e.editType
          };
        return e.noGridCell || (l.row = {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: e.editType
        }, l.column = {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: e.editType
        }), l;
      };
      W2.defaults = function (e, r, t, a) {
        var n = a && a.x || [0, 1],
          i = a && a.y || [0, 1],
          l = r.grid;
        if (l) {
          var o = t("domain.column");
          o !== void 0 && (o < l.columns ? n = l._domains.x[o] : delete e.domain.column);
          var s = t("domain.row");
          s !== void 0 && (s < l.rows ? i = l._domains.y[s] : delete e.domain.row);
        }
        var u = t("domain.x", n),
          f = t("domain.y", i);
        u[0] < u[1] || (e.domain.x = n.slice()), f[0] < f[1] || (e.domain.y = i.slice());
      };
    });
    var kE = Z((Tce, AE) => {
      "use strict";

      var Yre = He(),
        Ure = cs().counter,
        Gre = Od().attributes,
        wE = da().idRegex,
        Vre = ct(),
        Z2 = {
          rows: {
            valType: "integer",
            min: 1,
            editType: "plot"
          },
          roworder: {
            valType: "enumerated",
            values: ["top to bottom", "bottom to top"],
            dflt: "top to bottom",
            editType: "plot"
          },
          columns: {
            valType: "integer",
            min: 1,
            editType: "plot"
          },
          subplots: {
            valType: "info_array",
            freeLength: !0,
            dimensions: 2,
            items: {
              valType: "enumerated",
              values: [Ure("xy").toString(), ""],
              editType: "plot"
            },
            editType: "plot"
          },
          xaxes: {
            valType: "info_array",
            freeLength: !0,
            items: {
              valType: "enumerated",
              values: [wE.x.toString(), ""],
              editType: "plot"
            },
            editType: "plot"
          },
          yaxes: {
            valType: "info_array",
            freeLength: !0,
            items: {
              valType: "enumerated",
              values: [wE.y.toString(), ""],
              editType: "plot"
            },
            editType: "plot"
          },
          pattern: {
            valType: "enumerated",
            values: ["independent", "coupled"],
            dflt: "coupled",
            editType: "plot"
          },
          xgap: {
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          },
          ygap: {
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          },
          domain: Gre({
            name: "grid",
            editType: "plot",
            noGridCell: !0
          }, {}),
          xside: {
            valType: "enumerated",
            values: ["bottom", "bottom plot", "top plot", "top"],
            dflt: "bottom plot",
            editType: "plot"
          },
          yside: {
            valType: "enumerated",
            values: ["left", "left plot", "right plot", "right"],
            dflt: "left plot",
            editType: "plot"
          },
          editType: "plot"
        };
      function Bd(e, r, t) {
        var a = r[t + "axes"],
          n = Object.keys((e._splomAxes || {})[t] || {});
        if (Array.isArray(a)) return a;
        if (n.length) return n;
      }
      function Wre(e, r) {
        var t = e.grid || {},
          a = Bd(r, t, "x"),
          n = Bd(r, t, "y");
        if (!e.grid && !a && !n) return;
        var i = Array.isArray(t.subplots) && Array.isArray(t.subplots[0]),
          l = Array.isArray(a),
          o = Array.isArray(n),
          s = l && a !== t.xaxes && o && n !== t.yaxes,
          u,
          f;
        i ? (u = t.subplots.length, f = t.subplots[0].length) : (o && (u = n.length), l && (f = a.length));
        var v = Vre.newContainer(r, "grid");
        function h(S, k) {
          return Yre.coerce(t, v, Z2, S, k);
        }
        var d = h("rows", u),
          y = h("columns", f);
        if (!(d * y > 1)) {
          delete r.grid;
          return;
        }
        if (!i && !l && !o) {
          var g = h("pattern") === "independent";
          g && (i = !0);
        }
        v._hasSubplotGrid = i;
        var m = h("roworder"),
          _ = m === "top to bottom",
          w = i ? .2 : .1,
          T = i ? .3 : .1,
          b,
          A;
        s && r._splomGridDflt && (b = r._splomGridDflt.xside, A = r._splomGridDflt.yside), v._domains = {
          x: TE("x", h, w, b, y),
          y: TE("y", h, T, A, d, _)
        };
      }
      function TE(e, r, t, a, n, i) {
        var l = r(e + "gap", t),
          o = r("domain." + e);
        r(e + "side", a);
        for (var s = new Array(n), u = o[0], f = (o[1] - u) / (n - l), v = f * (1 - l), h = 0; h < n; h++) {
          var d = u + f * h;
          s[i ? n - 1 - h : h] = [d, d + v];
        }
        return s;
      }
      function Zre(e, r) {
        var t = r.grid;
        if (!(!t || !t._domains)) {
          var a = e.grid || {},
            n = r._subplots,
            i = t._hasSubplotGrid,
            l = t.rows,
            o = t.columns,
            s = t.pattern === "independent",
            u,
            f,
            v,
            h,
            d,
            y,
            g,
            m = t._axisMap = {};
          if (i) {
            var _ = a.subplots || [];
            y = t.subplots = new Array(l);
            var w = 1;
            for (u = 0; u < l; u++) {
              var T = y[u] = new Array(o),
                b = _[u] || [];
              for (f = 0; f < o; f++) if (s ? (d = w === 1 ? "xy" : "x" + w + "y" + w, w++) : d = b[f], T[f] = "", n.cartesian.indexOf(d) !== -1) {
                if (g = d.indexOf("y"), v = d.slice(0, g), h = d.slice(g), m[v] !== void 0 && m[v] !== f || m[h] !== void 0 && m[h] !== u) continue;
                T[f] = d, m[v] = f, m[h] = u;
              }
            }
          } else {
            var A = Bd(r, a, "x"),
              S = Bd(r, a, "y");
            t.xaxes = ME(A, n.xaxis, o, m, "x"), t.yaxes = ME(S, n.yaxis, l, m, "y");
          }
          var k = t._anchors = {},
            q = t.roworder === "top to bottom";
          for (var D in m) {
            var R = D.charAt(0),
              z = t[R + "side"],
              N,
              H,
              O;
            if (z.length < 8) k[D] = "free";else if (R === "x") {
              if (z.charAt(0) === "t" === q ? (N = 0, H = 1, O = l) : (N = l - 1, H = -1, O = -1), i) {
                var J = m[D];
                for (u = N; u !== O; u += H) if (d = y[u][J], !!d && (g = d.indexOf("y"), d.slice(0, g) === D)) {
                  k[D] = d.slice(g);
                  break;
                }
              } else for (u = N; u !== O; u += H) if (h = t.yaxes[u], n.cartesian.indexOf(D + h) !== -1) {
                k[D] = h;
                break;
              }
            } else if (z.charAt(0) === "l" ? (N = 0, H = 1, O = o) : (N = o - 1, H = -1, O = -1), i) {
              var X = m[D];
              for (u = N; u !== O; u += H) if (d = y[X][u], !!d && (g = d.indexOf("y"), d.slice(g) === D)) {
                k[D] = d.slice(0, g);
                break;
              }
            } else for (u = N; u !== O; u += H) if (v = t.xaxes[u], n.cartesian.indexOf(v + D) !== -1) {
              k[D] = v;
              break;
            }
          }
        }
      }
      function ME(e, r, t, a, n) {
        var i = new Array(t),
          l;
        function o(s, u) {
          r.indexOf(u) !== -1 && a[u] === void 0 ? (i[s] = u, a[u] = s) : i[s] = "";
        }
        if (Array.isArray(e)) for (l = 0; l < t; l++) o(l, e[l]);else for (o(0, n), l = 1; l < t; l++) o(l, n + (l + 1));
        return i;
      }
      AE.exports = {
        moduleType: "component",
        name: "grid",
        schema: {
          layout: {
            grid: Z2
          }
        },
        layoutAttributes: Z2,
        sizeDefaults: Wre,
        contentDefaults: Zre
      };
    });
    var X2 = Z((Mce, CE) => {
      "use strict";

      CE.exports = {
        visible: {
          valType: "boolean",
          editType: "calc"
        },
        type: {
          valType: "enumerated",
          values: ["percent", "constant", "sqrt", "data"],
          editType: "calc"
        },
        symmetric: {
          valType: "boolean",
          editType: "calc"
        },
        array: {
          valType: "data_array",
          editType: "calc"
        },
        arrayminus: {
          valType: "data_array",
          editType: "calc"
        },
        value: {
          valType: "number",
          min: 0,
          dflt: 10,
          editType: "calc"
        },
        valueminus: {
          valType: "number",
          min: 0,
          dflt: 10,
          editType: "calc"
        },
        traceref: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "style"
        },
        tracerefminus: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "style"
        },
        copy_ystyle: {
          valType: "boolean",
          editType: "plot"
        },
        copy_zstyle: {
          valType: "boolean",
          editType: "style"
        },
        color: {
          valType: "color",
          editType: "style"
        },
        thickness: {
          valType: "number",
          min: 0,
          dflt: 2,
          editType: "style"
        },
        width: {
          valType: "number",
          min: 0,
          editType: "plot"
        },
        editType: "calc"
      };
    });
    var qE = Z((Ace, LE) => {
      "use strict";

      var SE = Hr(),
        Xre = gr(),
        Jre = He(),
        Kre = ct(),
        Qre = X2();
      LE.exports = function (e, r, t, a) {
        var n = "error_" + a.axis,
          i = Kre.newContainer(r, n),
          l = e[n] || {};
        function o(y, g) {
          return Jre.coerce(l, i, Qre, y, g);
        }
        var s = l.array !== void 0 || l.value !== void 0 || l.type === "sqrt",
          u = o("visible", s);
        if (u !== !1) {
          var f = o("type", "array" in l ? "data" : "percent"),
            v = !0;
          f !== "sqrt" && (v = o("symmetric", !((f === "data" ? "arrayminus" : "valueminus") in l))), f === "data" ? (o("array"), o("traceref"), v || (o("arrayminus"), o("tracerefminus"))) : (f === "percent" || f === "constant") && (o("value"), v || o("valueminus"));
          var h = "copy_" + a.inherit + "style";
          if (a.inherit) {
            var d = r["error_" + a.inherit];
            (d || {}).visible && o(h, !(l.color || SE(l.thickness) || SE(l.width)));
          }
          (!a.inherit || !i[h]) && (o("color", t), o("thickness"), o("width", Xre.traceIs(r, "gl3d") ? 0 : 4));
        }
      };
    });
    var J2 = Z((kce, EE) => {
      "use strict";

      EE.exports = function (r) {
        var t = r.type,
          a = r.symmetric;
        if (t === "data") {
          var n = r.array || [];
          if (a) return function (u, f) {
            var v = +n[f];
            return [v, v];
          };
          var i = r.arrayminus || [];
          return function (u, f) {
            var v = +n[f],
              h = +i[f];
            return !isNaN(v) || !isNaN(h) ? [h || 0, v || 0] : [NaN, NaN];
          };
        } else {
          var l = DE(t, r.value),
            o = DE(t, r.valueminus);
          return a || r.valueminus === void 0 ? function (u) {
            var f = l(u);
            return [f, f];
          } : function (u) {
            return [o(u), l(u)];
          };
        }
      };
      function DE(e, r) {
        if (e === "percent") return function (t) {
          return Math.abs(t * r / 100);
        };
        if (e === "constant") return function () {
          return Math.abs(r);
        };
        if (e === "sqrt") return function (t) {
          return Math.sqrt(Math.abs(t));
        };
      }
    });
    var zE = Z((Cce, RE) => {
      "use strict";

      var K2 = Hr(),
        $re = gr(),
        Q2 = dt(),
        jre = He(),
        ete = J2();
      RE.exports = function (r) {
        for (var t = r.calcdata, a = 0; a < t.length; a++) {
          var n = t[a],
            i = n[0].trace;
          if (i.visible === !0 && $re.traceIs(i, "errorBarsOK")) {
            var l = Q2.getFromId(r, i.xaxis),
              o = Q2.getFromId(r, i.yaxis);
            PE(n, i, l, "x"), PE(n, i, o, "y");
          }
        }
      };
      function PE(e, r, t, a) {
        var n = r["error_" + a] || {},
          i = n.visible && ["linear", "log"].indexOf(t.type) !== -1,
          l = [];
        if (i) {
          for (var o = ete(n), s = 0; s < e.length; s++) {
            var u = e[s],
              f = u.i;
            if (f === void 0) f = s;else if (f === null) continue;
            var v = u[a];
            if (K2(t.c2l(v))) {
              var h = o(v, f);
              if (K2(h[0]) && K2(h[1])) {
                var d = u[a + "s"] = v - h[0],
                  y = u[a + "h"] = v + h[1];
                l.push(d, y);
              }
            }
          }
          var g = t._id,
            m = r._extremes[g],
            _ = Q2.findExtremes(t, l, jre.extendFlat({
              tozero: m.opts.tozero
            }, {
              padded: !0
            }));
          m.min = m.min.concat(_.min), m.max = m.max.concat(_.max);
        }
      }
    });
    var IE = Z((Sce, FE) => {
      "use strict";

      var NE = Ir(),
        zl = Hr(),
        rte = tt(),
        tte = on();
      FE.exports = function (r, t, a, n) {
        var i,
          l = a.xaxis,
          o = a.yaxis,
          s = n && n.duration > 0,
          u = r._context.staticPlot;
        t.each(function (f) {
          var v = f[0].trace,
            h = v.error_x || {},
            d = v.error_y || {},
            y;
          v.ids && (y = function (w) {
            return w.id;
          });
          var g = tte.hasMarkers(v) && v.marker.maxdisplayed > 0;
          !d.visible && !h.visible && (f = []);
          var m = NE.select(this).selectAll("g.errorbar").data(f, y);
          if (m.exit().remove(), !!f.length) {
            h.visible || m.selectAll("path.xerror").remove(), d.visible || m.selectAll("path.yerror").remove(), m.style("opacity", 1);
            var _ = m.enter().append("g").classed("errorbar", !0);
            s && _.style("opacity", 0).transition().duration(n.duration).style("opacity", 1), rte.setClipUrl(m, a.layerClipId, r), m.each(function (w) {
              var T = NE.select(this),
                b = ate(w, l, o);
              if (!(g && !w.vis)) {
                var A,
                  S = T.select("path.yerror");
                if (d.visible && zl(b.x) && zl(b.yh) && zl(b.ys)) {
                  var k = d.width;
                  A = "M" + (b.x - k) + "," + b.yh + "h" + 2 * k + "m-" + k + ",0V" + b.ys, b.noYS || (A += "m-" + k + ",0h" + 2 * k), i = !S.size(), i ? S = T.append("path").style("vector-effect", u ? "none" : "non-scaling-stroke").classed("yerror", !0) : s && (S = S.transition().duration(n.duration).ease(n.easing)), S.attr("d", A);
                } else S.remove();
                var q = T.select("path.xerror");
                if (h.visible && zl(b.y) && zl(b.xh) && zl(b.xs)) {
                  var D = (h.copy_ystyle ? d : h).width;
                  A = "M" + b.xh + "," + (b.y - D) + "v" + 2 * D + "m0,-" + D + "H" + b.xs, b.noXS || (A += "m0,-" + D + "v" + 2 * D), i = !q.size(), i ? q = T.append("path").style("vector-effect", u ? "none" : "non-scaling-stroke").classed("xerror", !0) : s && (q = q.transition().duration(n.duration).ease(n.easing)), q.attr("d", A);
                } else q.remove();
              }
            });
          }
        });
      };
      function ate(e, r, t) {
        var a = {
          x: r.c2p(e.x),
          y: t.c2p(e.y)
        };
        return e.yh !== void 0 && (a.yh = t.c2p(e.yh), a.ys = t.c2p(e.ys), zl(a.ys) || (a.noYS = !0, a.ys = t.c2p(e.ys, !0))), e.xh !== void 0 && (a.xh = r.c2p(e.xh), a.xs = r.c2p(e.xs), zl(a.xs) || (a.noXS = !0, a.xs = r.c2p(e.xs, !0))), a;
      }
    });
    var BE = Z((Lce, OE) => {
      "use strict";

      var nte = Ir(),
        HE = Er();
      OE.exports = function (r) {
        r.each(function (t) {
          var a = t[0].trace,
            n = a.error_y || {},
            i = a.error_x || {},
            l = nte.select(this);
          l.selectAll("path.yerror").style("stroke-width", n.thickness + "px").call(HE.stroke, n.color), i.copy_ystyle && (i = n), l.selectAll("path.xerror").style("stroke-width", i.thickness + "px").call(HE.stroke, i.color);
        });
      };
    });
    var GE = Z((qce, UE) => {
      "use strict";

      var dc = He(),
        YE = pi().overrideAll,
        pc = X2(),
        Bo = {
          error_x: dc.extendFlat({}, pc),
          error_y: dc.extendFlat({}, pc)
        };
      delete Bo.error_x.copy_zstyle;
      delete Bo.error_y.copy_zstyle;
      delete Bo.error_y.copy_ystyle;
      var mc = {
        error_x: dc.extendFlat({}, pc),
        error_y: dc.extendFlat({}, pc),
        error_z: dc.extendFlat({}, pc)
      };
      delete mc.error_x.copy_ystyle;
      delete mc.error_y.copy_ystyle;
      delete mc.error_z.copy_ystyle;
      delete mc.error_z.copy_zstyle;
      UE.exports = {
        moduleType: "component",
        name: "errorbars",
        schema: {
          traces: {
            scatter: Bo,
            bar: Bo,
            histogram: Bo,
            scatter3d: YE(mc, "calc", "nested"),
            scattergl: YE(Bo, "calc", "nested")
          }
        },
        supplyDefaults: qE(),
        calc: zE(),
        makeComputeError: J2(),
        plot: IE(),
        style: BE(),
        hoverInfo: ite
      };
      function ite(e, r, t) {
        (r.error_y || {}).visible && (t.yerr = e.yh - e.y, r.error_y.symmetric || (t.yerrneg = e.y - e.ys)), (r.error_x || {}).visible && (t.xerr = e.xh - e.x, r.error_x.symmetric || (t.xerrneg = e.x - e.xs));
      }
    });
    var WE = Z((Dce, VE) => {
      "use strict";

      VE.exports = {
        cn: {
          colorbar: "colorbar",
          cbbg: "cbbg",
          cbfill: "cbfill",
          cbfills: "cbfills",
          cbline: "cbline",
          cblines: "cblines",
          cbaxis: "cbaxis",
          cbtitleunshift: "cbtitleunshift",
          cbtitle: "cbtitle",
          cboutline: "cboutline",
          crisp: "crisp",
          jsPlaceholder: "js-placeholder"
        }
      };
    });
    var jE = Z((Ece, $E) => {
      "use strict";

      var Nl = Ir(),
        $2 = bn(),
        Ud = Pt(),
        ZE = gr(),
        Qi = dt(),
        Yd = Qn(),
        Nn = He(),
        fi = Nn.strTranslate,
        QE = Yt().extendFlat,
        j2 = wl(),
        ui = tt(),
        e3 = Er(),
        lte = sf(),
        ote = xa(),
        ste = Tn().flipScale,
        ute = u2(),
        fte = f2(),
        cte = Xn(),
        r3 = Da(),
        XE = r3.LINE_SPACING,
        JE = r3.FROM_TL,
        KE = r3.FROM_BR,
        bt = WE().cn;
      function vte(e) {
        var r = e._fullLayout,
          t = r._infolayer.selectAll("g." + bt.colorbar).data(hte(e), function (a) {
            return a._id;
          });
        t.enter().append("g").attr("class", function (a) {
          return a._id;
        }).classed(bt.colorbar, !0), t.each(function (a) {
          var n = Nl.select(this);
          Nn.ensureSingle(n, "rect", bt.cbbg), Nn.ensureSingle(n, "g", bt.cbfills), Nn.ensureSingle(n, "g", bt.cblines), Nn.ensureSingle(n, "g", bt.cbaxis, function (l) {
            l.classed(bt.crisp, !0);
          }), Nn.ensureSingle(n, "g", bt.cbtitleunshift, function (l) {
            l.append("g").classed(bt.cbtitle, !0);
          }), Nn.ensureSingle(n, "rect", bt.cboutline);
          var i = dte(n, a, e);
          i && i.then && (e._promises || []).push(i), e._context.edits.colorbarPosition && pte(n, a, e);
        }), t.exit().each(function (a) {
          Ud.autoMargin(e, a._id);
        }).remove(), t.order();
      }
      function hte(e) {
        var r = e._fullLayout,
          t = e.calcdata,
          a = [],
          n,
          i,
          l,
          o;
        function s(T) {
          return QE(T, {
            _fillcolor: null,
            _line: {
              color: null,
              width: null,
              dash: null
            },
            _levels: {
              start: null,
              end: null,
              size: null
            },
            _filllevels: null,
            _fillgradient: null,
            _zrange: null
          });
        }
        function u() {
          typeof o.calc == "function" ? o.calc(e, l, n) : (n._fillgradient = i.reversescale ? ste(i.colorscale) : i.colorscale, n._zrange = [i[o.min], i[o.max]]);
        }
        for (var f = 0; f < t.length; f++) {
          var v = t[f];
          if (l = v[0].trace, !!l._module) {
            var h = l._module.colorbar;
            if (l.visible === !0 && h) for (var d = Array.isArray(h), y = d ? h : [h], g = 0; g < y.length; g++) {
              o = y[g];
              var m = o.container;
              i = m ? l[m] : l, i && i.showscale && (n = s(i.colorbar), n._id = "cb" + l.uid + (d && m ? "-" + m : ""), n._traceIndex = l.index, n._propPrefix = (m ? m + "." : "") + "colorbar.", n._meta = l._meta, u(), a.push(n));
            }
          }
        }
        for (var _ in r._colorAxes) if (i = r[_], i.showscale) {
          var w = r._colorAxes[_];
          n = s(i.colorbar), n._id = "cb" + _, n._propPrefix = _ + ".colorbar.", n._meta = r._meta, o = {
            min: "cmin",
            max: "cmax"
          }, w[0] !== "heatmap" && (l = w[1], o.calc = l._module.colorbar.calc), u(), a.push(n);
        }
        return a;
      }
      function dte(e, r, t) {
        var a = r.orientation === "v",
          n = r.len,
          i = r.lenmode,
          l = r.thickness,
          o = r.thicknessmode,
          s = r.outlinewidth,
          u = r.borderwidth,
          f = r.bgcolor,
          v = r.xanchor,
          h = r.yanchor,
          d = r.xpad,
          y = r.ypad,
          g = r.x,
          m = a ? r.y : 1 - r.y,
          _ = r.yref === "paper",
          w = r.xref === "paper",
          T = t._fullLayout,
          b = T._size,
          A = r._fillcolor,
          S = r._line,
          k = r.title,
          q = k.side,
          D = r._zrange || Nl.extent((typeof A == "function" ? A : S.color).domain()),
          R = typeof S.color == "function" ? S.color : function () {
            return S.color;
          },
          z = typeof A == "function" ? A : function () {
            return A;
          },
          N = r._levels,
          H = mte(t, r, D),
          O = H.fill,
          J = H.line,
          X = Math.round(l * (o === "fraction" ? a ? b.w : b.h : 1)),
          B = X / (a ? b.w : b.h),
          I = Math.round(n * (i === "fraction" ? a ? b.h : b.w : 1)),
          V = I / (a ? b.h : b.w),
          K = w ? b.w : t._fullLayout.width,
          Q = _ ? b.h : t._fullLayout.height,
          ie = Math.round(a ? g * K + d : m * Q + y),
          me = {
            center: .5,
            right: 1
          }[v] || 0,
          pe = {
            top: 1,
            middle: .5
          }[h] || 0,
          ge = a ? g - me * B : m - pe * B,
          j = a ? m - pe * V : g - me * V,
          _e = Math.round(a ? Q * (1 - j) : K * j);
        r._lenFrac = V, r._thickFrac = B, r._uFrac = ge, r._vFrac = j;
        var se = r._axis = yte(t, r, D);
        se.position = B + (a ? g + d / b.w : m + y / b.h);
        var Se = ["top", "bottom"].indexOf(q) !== -1;
        if (a && Se && (se.title.side = q, se.titlex = g + d / b.w, se.titley = j + (k.side === "top" ? V - y / b.h : y / b.h)), !a && !Se && (se.title.side = q, se.titley = m + y / b.h, se.titlex = j + d / b.w), S.color && r.tickmode === "auto") {
          se.tickmode = "linear", se.tick0 = N.start;
          var ve = N.size,
            Ae = Nn.constrain(I / 50, 4, 15) + 1,
            Y = (D[1] - D[0]) / ((r.nticks || Ae) * ve);
          if (Y > 1) {
            var re = Math.pow(10, Math.floor(Math.log(Y) / Math.LN10));
            ve *= re * Nn.roundUp(Y / re, [2, 5, 10]), (Math.abs(N.start) / N.size + 1e-6) % 1 < 2e-6 && (se.tick0 = 0);
          }
          se.dtick = ve;
        }
        se.domain = a ? [j + y / b.h, j + V - y / b.h] : [j + d / b.w, j + V - d / b.w], se.setScale(), e.attr("transform", fi(Math.round(b.l), Math.round(b.t)));
        var U = e.select("." + bt.cbtitleunshift).attr("transform", fi(-Math.round(b.l), -Math.round(b.t))),
          de = se.ticklabelposition,
          be = se.title.font.size,
          ye = e.select("." + bt.cbaxis),
          Fe,
          Re = 0,
          Pe = 0;
        function Ie(We, ne) {
          var Me = {
              propContainer: se,
              propName: r._propPrefix + "title",
              traceIndex: r._traceIndex,
              _meta: r._meta,
              placeholder: T._dfltTitle.colorbar,
              containerGroup: e.select("." + bt.cbtitle)
            },
            Ce = We.charAt(0) === "h" ? We.substr(1) : "h" + We;
          e.selectAll("." + Ce + ",." + Ce + "-math-group").remove(), lte.draw(t, We, QE(Me, ne || {}));
        }
        function Be() {
          if (a && Se || !a && !Se) {
            var We, ne;
            q === "top" && (We = d + b.l + K * g, ne = y + b.t + Q * (1 - j - V) + 3 + be * .75), q === "bottom" && (We = d + b.l + K * g, ne = y + b.t + Q * (1 - j) - 3 - be * .25), q === "right" && (ne = y + b.t + Q * m + 3 + be * .75, We = d + b.l + K * j), Ie(se._id + "title", {
              attributes: {
                x: We,
                y: ne,
                "text-anchor": a ? "start" : "middle"
              }
            });
          }
        }
        function Ne() {
          if (a && !Se || !a && Se) {
            var We = se.position || 0,
              ne = se._offset + se._length / 2,
              Me,
              Ce;
            if (q === "right") Ce = ne, Me = b.l + K * We + 10 + be * (se.showticklabels ? 1 : .5);else if (Me = ne, q === "bottom" && (Ce = b.t + Q * We + 10 + (de.indexOf("inside") === -1 ? se.tickfont.size : 0) + (se.ticks !== "intside" && r.ticklen || 0)), q === "top") {
              var cr = k.text.split("<br>").length;
              Ce = b.t + Q * We + 10 - X - XE * be * cr;
            }
            Ie((a ? "h" : "v") + se._id + "title", {
              avoid: {
                selection: Nl.select(t).selectAll("g." + se._id + "tick"),
                side: q,
                offsetTop: a ? 0 : b.t,
                offsetLeft: a ? b.l : 0,
                maxShift: a ? T.width : T.height
              },
              attributes: {
                x: Me,
                y: Ce,
                "text-anchor": "middle"
              },
              transform: {
                rotate: a ? -90 : 0,
                offset: 0
              }
            });
          }
        }
        function Ee() {
          if (!a && !Se || a && Se) {
            var We = e.select("." + bt.cbtitle),
              ne = We.select("text"),
              Me = [-s / 2, s / 2],
              Ce = We.select(".h" + se._id + "title-math-group").node(),
              cr = 15.6;
            ne.node() && (cr = parseInt(ne.node().style.fontSize, 10) * XE);
            var tr;
            if (Ce ? (tr = ui.bBox(Ce), Pe = tr.width, Re = tr.height, Re > cr && (Me[1] -= (Re - cr) / 2)) : ne.node() && !ne.classed(bt.jsPlaceholder) && (tr = ui.bBox(ne.node()), Pe = tr.width, Re = tr.height), a) {
              if (Re) {
                if (Re += 5, q === "top") se.domain[1] -= Re / b.h, Me[1] *= -1;else {
                  se.domain[0] += Re / b.h;
                  var De = ote.lineCount(ne);
                  Me[1] += (1 - De) * cr;
                }
                We.attr("transform", fi(Me[0], Me[1])), se.setScale();
              }
            } else Pe && (q === "right" && (se.domain[0] += (Pe + be / 2) / b.w), We.attr("transform", fi(Me[0], Me[1])), se.setScale());
          }
          e.selectAll("." + bt.cbfills + ",." + bt.cblines).attr("transform", a ? fi(0, Math.round(b.h * (1 - se.domain[1]))) : fi(Math.round(b.w * se.domain[0]), 0)), ye.attr("transform", a ? fi(0, Math.round(-b.t)) : fi(Math.round(-b.l), 0));
          var Le = e.select("." + bt.cbfills).selectAll("rect." + bt.cbfill).attr("style", "").data(O);
          Le.enter().append("rect").classed(bt.cbfill, !0).attr("style", ""), Le.exit().remove();
          var Ye = D.map(se.c2p).map(Math.round).sort(function (fr, lr) {
            return fr - lr;
          });
          Le.each(function (fr, lr) {
            var ze = [lr === 0 ? D[0] : (O[lr] + O[lr - 1]) / 2, lr === O.length - 1 ? D[1] : (O[lr] + O[lr + 1]) / 2].map(se.c2p).map(Math.round);
            a && (ze[1] = Nn.constrain(ze[1] + (ze[1] > ze[0]) ? 1 : -1, Ye[0], Ye[1]));
            var ae = Nl.select(this).attr(a ? "x" : "y", ie).attr(a ? "y" : "x", Nl.min(ze)).attr(a ? "width" : "height", Math.max(X, 2)).attr(a ? "height" : "width", Math.max(Nl.max(ze) - Nl.min(ze), 2));
            if (r._fillgradient) ui.gradient(ae, t, r._id, a ? "vertical" : "horizontalreversed", r._fillgradient, "fill");else {
              var oe = z(fr).replace("e-", "");
              ae.attr("fill", $2(oe).toHexString());
            }
          });
          var Ze = e.select("." + bt.cblines).selectAll("path." + bt.cbline).data(S.color && S.width ? J : []);
          Ze.enter().append("path").classed(bt.cbline, !0), Ze.exit().remove(), Ze.each(function (fr) {
            var lr = ie,
              ze = Math.round(se.c2p(fr)) + S.width / 2 % 1;
            Nl.select(this).attr("d", "M" + (a ? lr + "," + ze : ze + "," + lr) + (a ? "h" : "v") + X).call(ui.lineGroupStyle, S.width, R(fr), S.dash);
          }), ye.selectAll("g." + se._id + "tick,path").remove();
          var Ue = ie + X + (s || 0) / 2 - (r.ticks === "outside" ? 1 : 0),
            Oe = Qi.calcTicks(se),
            Ke = Qi.getTickSigns(se)[2];
          return Qi.drawTicks(t, se, {
            vals: se.ticks === "inside" ? Qi.clipEnds(se, Oe) : Oe,
            layer: ye,
            path: Qi.makeTickPath(se, Ue, Ke),
            transFn: Qi.makeTransTickFn(se)
          }), Qi.drawLabels(t, se, {
            vals: Oe,
            layer: ye,
            transFn: Qi.makeTransTickLabelFn(se),
            labelFns: Qi.makeLabelFns(se, Ue)
          });
        }
        function Je() {
          var We,
            ne = X + s / 2;
          de.indexOf("inside") === -1 && (We = ui.bBox(ye.node()), ne += a ? We.width : We.height), Fe = U.select("text");
          var Me = 0,
            Ce = a && q === "top",
            cr = !a && q === "right",
            tr = 0;
          if (Fe.node() && !Fe.classed(bt.jsPlaceholder)) {
            var De,
              Le = U.select(".h" + se._id + "title-math-group").node();
            Le && (a && Se || !a && !Se) ? (We = ui.bBox(Le), Me = We.width, De = We.height) : (We = ui.bBox(U.node()), Me = We.right - b.l - (a ? ie : _e), De = We.bottom - b.t - (a ? _e : ie), !a && q === "top" && (ne += We.height, tr = We.height)), cr && (Fe.attr("transform", fi(Me / 2 + be / 2, 0)), Me *= 2), ne = Math.max(ne, a ? Me : De);
          }
          var Ye = (a ? d : y) * 2 + ne + u + s / 2,
            Ze = 0;
          !a && k.text && h === "bottom" && m <= 0 && (Ze = Ye / 2, Ye += Ze, tr += Ze), T._hColorbarMoveTitle = Ze, T._hColorbarMoveCBTitle = tr;
          var Ue = u + s,
            Oe = (a ? ie : _e) - Ue / 2 - (a ? d : 0),
            Ke = (a ? _e : ie) - (a ? I : y + tr - Ze);
          e.select("." + bt.cbbg).attr("x", Oe).attr("y", Ke).attr(a ? "width" : "height", Math.max(Ye - Ze, 2)).attr(a ? "height" : "width", Math.max(I + Ue, 2)).call(e3.fill, f).call(e3.stroke, r.bordercolor).style("stroke-width", u);
          var fr = cr ? Math.max(Me - 10, 0) : 0;
          e.selectAll("." + bt.cboutline).attr("x", (a ? ie : _e + d) + fr).attr("y", (a ? _e + y - I : ie) + (Ce ? Re : 0)).attr(a ? "width" : "height", Math.max(X, 2)).attr(a ? "height" : "width", Math.max(I - (a ? 2 * y + Re : 2 * d + fr), 2)).call(e3.stroke, r.outlinecolor).style({
            fill: "none",
            "stroke-width": s
          });
          var lr = a ? me * Ye : 0,
            ze = a ? 0 : (1 - pe) * Ye - tr;
          if (lr = w ? b.l - lr : -lr, ze = _ ? b.t - ze : -ze, e.attr("transform", fi(lr, ze)), !a && (u || $2(f).getAlpha() && !$2.equals(T.paper_bgcolor, f))) {
            var ae = ye.selectAll("text"),
              oe = ae[0].length,
              qe = e.select("." + bt.cbbg).node(),
              ke = ui.bBox(qe),
              ir = ui.getTranslate(e),
              vr = 2;
            ae.each(function (pn, Ia) {
              var ta = 0,
                Ha = oe - 1;
              if (Ia === ta || Ia === Ha) {
                var yr = ui.bBox(this),
                  lt = ui.getTranslate(this),
                  Wr;
                if (Ia === Ha) {
                  var mt = yr.right + lt.x,
                    Tt = ke.right + ir.x + _e - u - vr + g;
                  Wr = Tt - mt, Wr > 0 && (Wr = 0);
                } else if (Ia === ta) {
                  var ot = yr.left + lt.x,
                    yt = ke.left + ir.x + _e + u + vr;
                  Wr = yt - ot, Wr < 0 && (Wr = 0);
                }
                Wr && (oe < 3 ? this.setAttribute("transform", "translate(" + Wr + ",0) " + this.getAttribute("transform")) : this.setAttribute("visibility", "hidden"));
              }
            });
          }
          var sr = {},
            Mr = JE[v],
            Ur = KE[v],
            $r = JE[h],
            Vr = KE[h],
            St = Ye - X;
          a ? (i === "pixels" ? (sr.y = m, sr.t = I * $r, sr.b = I * Vr) : (sr.t = sr.b = 0, sr.yt = m + n * $r, sr.yb = m - n * Vr), o === "pixels" ? (sr.x = g, sr.l = Ye * Mr, sr.r = Ye * Ur) : (sr.l = St * Mr, sr.r = St * Ur, sr.xl = g - l * Mr, sr.xr = g + l * Ur)) : (i === "pixels" ? (sr.x = g, sr.l = I * Mr, sr.r = I * Ur) : (sr.l = sr.r = 0, sr.xl = g + n * Mr, sr.xr = g - n * Ur), o === "pixels" ? (sr.y = 1 - m, sr.t = Ye * $r, sr.b = Ye * Vr) : (sr.t = St * $r, sr.b = St * Vr, sr.yt = m - l * $r, sr.yb = m + l * Vr));
          var ea = r.y < .5 ? "b" : "t",
            ka = r.x < .5 ? "l" : "r";
          t._fullLayout._reservedMargin[r._id] = {};
          var ra = {
            r: T.width - Oe - lr,
            l: Oe + sr.r,
            b: T.height - Ke - ze,
            t: Ke + sr.b
          };
          w && _ ? Ud.autoMargin(t, r._id, sr) : w ? t._fullLayout._reservedMargin[r._id][ea] = ra[ea] : _ || a ? t._fullLayout._reservedMargin[r._id][ka] = ra[ka] : t._fullLayout._reservedMargin[r._id][ea] = ra[ea];
        }
        return Nn.syncOrAsync([Ud.previousPromises, Be, Ee, Ne, Ud.previousPromises, Je], t);
      }
      function pte(e, r, t) {
        var a = r.orientation === "v",
          n = t._fullLayout,
          i = n._size,
          l,
          o,
          s;
        Yd.init({
          element: e.node(),
          gd: t,
          prepFn: function () {
            l = e.attr("transform"), j2(e);
          },
          moveFn: function (u, f) {
            e.attr("transform", l + fi(u, f)), o = Yd.align((a ? r._uFrac : r._vFrac) + u / i.w, a ? r._thickFrac : r._lenFrac, 0, 1, r.xanchor), s = Yd.align((a ? r._vFrac : 1 - r._uFrac) - f / i.h, a ? r._lenFrac : r._thickFrac, 0, 1, r.yanchor);
            var v = Yd.getCursor(o, s, r.xanchor, r.yanchor);
            j2(e, v);
          },
          doneFn: function () {
            if (j2(e), o !== void 0 && s !== void 0) {
              var u = {};
              u[r._propPrefix + "x"] = o, u[r._propPrefix + "y"] = s, r._traceIndex !== void 0 ? ZE.call("_guiRestyle", t, u, r._traceIndex) : ZE.call("_guiRelayout", t, u);
            }
          }
        });
      }
      function mte(e, r, t) {
        var a = r._levels,
          n = [],
          i = [],
          l,
          o,
          s = a.end + a.size / 100,
          u = a.size,
          f = 1.001 * t[0] - .001 * t[1],
          v = 1.001 * t[1] - .001 * t[0];
        for (o = 0; o < 1e5 && (l = a.start + o * u, !(u > 0 ? l >= s : l <= s)); o++) l > f && l < v && n.push(l);
        if (r._fillgradient) i = [0];else if (typeof r._fillcolor == "function") {
          var h = r._filllevels;
          if (h) for (s = h.end + h.size / 100, u = h.size, o = 0; o < 1e5 && (l = h.start + o * u, !(u > 0 ? l >= s : l <= s)); o++) l > t[0] && l < t[1] && i.push(l);else i = n.map(function (d) {
            return d - a.size / 2;
          }), i.push(i[i.length - 1] + a.size);
        } else r._fillcolor && typeof r._fillcolor == "string" && (i = [0]);
        return a.size < 0 && (n.reverse(), i.reverse()), {
          line: n,
          fill: i
        };
      }
      function yte(e, r, t) {
        var a = e._fullLayout,
          n = r.orientation === "v",
          i = {
            type: "linear",
            range: t,
            tickmode: r.tickmode,
            nticks: r.nticks,
            tick0: r.tick0,
            dtick: r.dtick,
            tickvals: r.tickvals,
            ticktext: r.ticktext,
            ticks: r.ticks,
            ticklen: r.ticklen,
            tickwidth: r.tickwidth,
            tickcolor: r.tickcolor,
            showticklabels: r.showticklabels,
            labelalias: r.labelalias,
            ticklabelposition: r.ticklabelposition,
            ticklabeloverflow: r.ticklabeloverflow,
            ticklabelstep: r.ticklabelstep,
            tickfont: r.tickfont,
            tickangle: r.tickangle,
            tickformat: r.tickformat,
            exponentformat: r.exponentformat,
            minexponent: r.minexponent,
            separatethousands: r.separatethousands,
            showexponent: r.showexponent,
            showtickprefix: r.showtickprefix,
            tickprefix: r.tickprefix,
            showticksuffix: r.showticksuffix,
            ticksuffix: r.ticksuffix,
            title: r.title,
            showline: !0,
            anchor: "free",
            side: n ? "right" : "bottom",
            position: 1
          },
          l = n ? "y" : "x",
          o = {
            type: "linear",
            _id: l + r._id
          },
          s = {
            letter: l,
            font: a.font,
            noAutotickangles: l === "y",
            noHover: !0,
            noTickson: !0,
            noTicklabelmode: !0,
            noInsideRange: !0,
            calendar: a.calendar
          };
        function u(f, v) {
          return Nn.coerce(i, o, cte, f, v);
        }
        return ute(i, o, u, s, a), fte(i, o, u, s), o;
      }
      $E.exports = {
        draw: vte
      };
    });
    var rP = Z((Pce, eP) => {
      "use strict";

      eP.exports = {
        moduleType: "component",
        name: "colorbar",
        attributes: t0(),
        supplyDefaults: nm(),
        draw: jE().draw,
        hasColorbar: Zp()
      };
    });
    var aP = Z((Rce, tP) => {
      "use strict";

      tP.exports = {
        moduleType: "component",
        name: "legend",
        layoutAttributes: ey(),
        supplyLayoutDefaults: ay(),
        draw: py(),
        style: cy()
      };
    });
    var iP = Z((zce, nP) => {
      "use strict";

      nP.exports = {
        moduleType: "locale",
        name: "en",
        dictionary: {
          "Click to enter Colorscale title": "Click to enter Colourscale title"
        },
        format: {
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          periods: ["AM", "PM"],
          dateTime: "%a %b %e %X %Y",
          date: "%d/%m/%Y",
          time: "%H:%M:%S",
          decimal: ".",
          thousands: ",",
          grouping: [3],
          currency: ["$", ""],
          year: "%Y",
          month: "%b %Y",
          dayMonth: "%b %-d",
          dayMonthYear: "%b %-d, %Y"
        }
      };
    });
    var oP = Z((Nce, lP) => {
      "use strict";

      lP.exports = {
        moduleType: "locale",
        name: "en-US",
        dictionary: {
          "Click to enter Colorscale title": "Click to enter Colorscale title"
        },
        format: {
          date: "%m/%d/%Y"
        }
      };
    });
    var a3 = Z((Fce, cP) => {
      "use strict";

      var gte = gr(),
        fP = He(),
        t3 = fP.extendFlat,
        sP = fP.extendDeep;
      function uP(e) {
        var r;
        switch (e) {
          case "themes__thumb":
            r = {
              autosize: !0,
              width: 150,
              height: 150,
              title: {
                text: ""
              },
              showlegend: !1,
              margin: {
                l: 5,
                r: 5,
                t: 5,
                b: 5,
                pad: 0
              },
              annotations: []
            };
            break;
          case "thumbnail":
            r = {
              title: {
                text: ""
              },
              hidesources: !0,
              showlegend: !1,
              borderwidth: 0,
              bordercolor: "",
              margin: {
                l: 1,
                r: 1,
                t: 1,
                b: 1,
                pad: 0
              },
              annotations: []
            };
            break;
          default:
            r = {};
        }
        return r;
      }
      function bte(e) {
        var r = ["xaxis", "yaxis", "zaxis"];
        return r.indexOf(e.slice(0, 5)) > -1;
      }
      cP.exports = function (r, t) {
        var a,
          n = r.data,
          i = r.layout,
          l = sP([], n),
          o = sP({}, i, uP(t.tileClass)),
          s = r._context || {};
        if (t.width && (o.width = t.width), t.height && (o.height = t.height), t.tileClass === "thumbnail" || t.tileClass === "themes__thumb") {
          o.annotations = [];
          var u = Object.keys(o);
          for (a = 0; a < u.length; a++) bte(u[a]) && (o[u[a]].title = {
            text: ""
          });
          for (a = 0; a < l.length; a++) {
            var f = l[a];
            f.showscale = !1, f.marker && (f.marker.showscale = !1), gte.traceIs(f, "pie-like") && (f.textposition = "none");
          }
        }
        if (Array.isArray(t.annotations)) for (a = 0; a < t.annotations.length; a++) o.annotations.push(t.annotations[a]);
        var v = Object.keys(o).filter(function (m) {
          return m.match(/^scene\d*$/);
        });
        if (v.length) {
          var h = {};
          for (t.tileClass === "thumbnail" && (h = {
            title: {
              text: ""
            },
            showaxeslabels: !1,
            showticklabels: !1,
            linetickenable: !1
          }), a = 0; a < v.length; a++) {
            var d = o[v[a]];
            d.xaxis || (d.xaxis = {}), d.yaxis || (d.yaxis = {}), d.zaxis || (d.zaxis = {}), t3(d.xaxis, h), t3(d.yaxis, h), t3(d.zaxis, h), d._scene = null;
          }
        }
        var y = document.createElement("div");
        t.tileClass && (y.className = t.tileClass);
        var g = {
          gd: y,
          td: y,
          layout: o,
          data: l,
          config: {
            staticPlot: t.staticPlot === void 0 ? !0 : t.staticPlot,
            plotGlPixelRatio: t.plotGlPixelRatio === void 0 ? 2 : t.plotGlPixelRatio,
            displaylogo: t.displaylogo || !1,
            showLink: t.showLink || !1,
            showTips: t.showTips || !1,
            mapboxAccessToken: s.mapboxAccessToken
          }
        };
        return t.setBackground !== "transparent" && (g.config.setBackground = t.setBackground || "opaque"), g.gd.defaultLayout = uP(t.tileClass), g;
      };
    });
    var dP = Z((Ice, hP) => {
      "use strict";

      var xte = Yv().EventEmitter,
        _te = gr(),
        wte = He(),
        vP = Do(),
        Tte = a3(),
        Mte = Qh(),
        Ate = $h();
      function kte(e, r) {
        var t = new xte(),
          a = Tte(e, {
            format: "png"
          }),
          n = a.gd;
        n.style.position = "absolute", n.style.left = "-5000px", document.body.appendChild(n);
        function i() {
          var o = vP.getDelay(n._fullLayout);
          setTimeout(function () {
            var s = Mte(n),
              u = document.createElement("canvas");
            u.id = wte.randstr(), t = Ate({
              format: r.format,
              width: n._fullLayout.width,
              height: n._fullLayout.height,
              canvas: u,
              emitter: t,
              svg: s
            }), t.clean = function () {
              n && document.body.removeChild(n);
            };
          }, o);
        }
        var l = vP.getRedrawFunc(n);
        return _te.call("_doPlot", n, a.data, a.layout, a.config).then(l).then(i).catch(function (o) {
          t.emit("error", o);
        }), t;
      }
      hP.exports = kte;
    });
    var yP = Z((Hce, mP) => {
      "use strict";

      var pP = Do(),
        Cte = {
          getDelay: pP.getDelay,
          getRedrawFunc: pP.getRedrawFunc,
          clone: a3(),
          toSVG: Qh(),
          svgToImg: $h(),
          toImage: dP(),
          downloadImage: Eg()
        };
      mP.exports = Cte;
    });
    var bP = Z($i => {
      "use strict";

      $i.version = tv().version;
      sb();
      $4();
      var Ste = gr(),
        yc = $i.register = Ste.register,
        i3 = wC(),
        gP = Object.keys(i3);
      for (Gd = 0; Gd < gP.length; Gd++) bu = gP[Gd], bu.charAt(0) !== "_" && ($i[bu] = i3[bu]), yc({
        moduleType: "apiMethod",
        name: bu,
        fn: i3[bu]
      });
      var bu, Gd;
      yc(PL());
      yc([nq(), gq(), eu(), Nq(), Jq(), yD(), FD(), tE(), xE(), kE(), GE(), sm(), rP(), aP(), ki(), Oy()]);
      yc([iP(), oP()]);
      window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (yc(window.PlotlyLocales), delete window.PlotlyLocales);
      $i.Icons = $0();
      var Vd = ki(),
        n3 = Pt();
      $i.Plots = {
        resize: n3.resize,
        graphJson: n3.graphJson,
        sendDataToCloud: n3.sendDataToCloud
      };
      $i.Fx = {
        hover: Vd.hover,
        unhover: Vd.unhover,
        loneHover: Vd.loneHover,
        loneUnhover: Vd.loneUnhover
      };
      $i.Snapshot = yP();
      $i.PlotSchema = As();
    });
    var _P = Z((Bce, xP) => {
      "use strict";

      xP.exports = bP();
    });
    var Wd = Z((Yce, wP) => {
      "use strict";

      wP.exports = {
        TEXTPAD: 3,
        eventDataKeys: ["value", "label"]
      };
    });
    var gc = Z((Uce, kP) => {
      "use strict";

      var wt = qo(),
        TP = r0().axisHoverFormat,
        Lte = zi().hovertemplateAttrs,
        qte = zi().texttemplateAttrs,
        AP = nf(),
        Dte = ha(),
        MP = Wd(),
        Ete = mi().pattern,
        Yo = Yt().extendFlat,
        l3 = Dte({
          editType: "calc",
          arrayOk: !0,
          colorEditType: "style"
        }),
        Pte = wt.marker,
        Rte = Pte.line,
        zte = Yo({}, Rte.width, {
          dflt: 0
        }),
        Nte = Yo({
          width: zte,
          editType: "calc"
        }, AP("marker.line")),
        Fte = Yo({
          line: Nte,
          editType: "calc"
        }, AP("marker"), {
          opacity: {
            valType: "number",
            arrayOk: !0,
            dflt: 1,
            min: 0,
            max: 1,
            editType: "style"
          },
          pattern: Ete,
          cornerradius: {
            valType: "any",
            editType: "calc"
          }
        });
      kP.exports = {
        x: wt.x,
        x0: wt.x0,
        dx: wt.dx,
        y: wt.y,
        y0: wt.y0,
        dy: wt.dy,
        xperiod: wt.xperiod,
        yperiod: wt.yperiod,
        xperiod0: wt.xperiod0,
        yperiod0: wt.yperiod0,
        xperiodalignment: wt.xperiodalignment,
        yperiodalignment: wt.yperiodalignment,
        xhoverformat: TP("x"),
        yhoverformat: TP("y"),
        text: wt.text,
        texttemplate: qte({
          editType: "plot"
        }, {
          keys: MP.eventDataKeys
        }),
        hovertext: wt.hovertext,
        hovertemplate: Lte({}, {
          keys: MP.eventDataKeys
        }),
        textposition: {
          valType: "enumerated",
          values: ["inside", "outside", "auto", "none"],
          dflt: "auto",
          arrayOk: !0,
          editType: "calc"
        },
        insidetextanchor: {
          valType: "enumerated",
          values: ["end", "middle", "start"],
          dflt: "end",
          editType: "plot"
        },
        textangle: {
          valType: "angle",
          dflt: "auto",
          editType: "plot"
        },
        textfont: Yo({}, l3, {}),
        insidetextfont: Yo({}, l3, {}),
        outsidetextfont: Yo({}, l3, {}),
        constraintext: {
          valType: "enumerated",
          values: ["inside", "outside", "both", "none"],
          dflt: "both",
          editType: "calc"
        },
        cliponaxis: Yo({}, wt.cliponaxis, {}),
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          editType: "calc+clearAxisTypes"
        },
        base: {
          valType: "any",
          dflt: null,
          arrayOk: !0,
          editType: "calc"
        },
        offset: {
          valType: "number",
          dflt: null,
          arrayOk: !0,
          editType: "calc"
        },
        width: {
          valType: "number",
          dflt: null,
          min: 0,
          arrayOk: !0,
          editType: "calc"
        },
        marker: Fte,
        offsetgroup: wt.offsetgroup,
        alignmentgroup: wt.alignmentgroup,
        selected: {
          marker: {
            opacity: wt.selected.marker.opacity,
            color: wt.selected.marker.color,
            editType: "style"
          },
          textfont: wt.selected.textfont,
          editType: "style"
        },
        unselected: {
          marker: {
            opacity: wt.unselected.marker.opacity,
            color: wt.unselected.marker.color,
            editType: "style"
          },
          textfont: wt.unselected.textfont,
          editType: "style"
        },
        zorder: wt.zorder
      };
    });
    var o3 = Z((Gce, CP) => {
      "use strict";

      CP.exports = {
        barmode: {
          valType: "enumerated",
          values: ["stack", "group", "overlay", "relative"],
          dflt: "group",
          editType: "calc"
        },
        barnorm: {
          valType: "enumerated",
          values: ["", "fraction", "percent"],
          dflt: "",
          editType: "calc"
        },
        bargap: {
          valType: "number",
          min: 0,
          max: 1,
          editType: "calc"
        },
        bargroupgap: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "calc"
        },
        barcornerradius: {
          valType: "any",
          editType: "calc"
        }
      };
    });
    var DP = Z((Vce, qP) => {
      "use strict";

      var Ite = Er(),
        SP = Tn().hasColorscale,
        LP = Ls(),
        Hte = He().coercePattern;
      qP.exports = function (r, t, a, n, i) {
        var l = a("marker.color", n),
          o = SP(r, "marker");
        o && LP(r, t, i, a, {
          prefix: "marker.",
          cLetter: "c"
        }), a("marker.line.color", Ite.defaultLine), SP(r, "marker.line") && LP(r, t, i, a, {
          prefix: "marker.line.",
          cLetter: "c"
        }), a("marker.line.width"), a("marker.opacity"), Hte(a, "marker.pattern", l, o), a("selected.marker.color"), a("unselected.marker.color");
      };
    });
    var bc = Z((Wce, FP) => {
      "use strict";

      var EP = Hr(),
        xu = He(),
        PP = Er(),
        Ote = gr(),
        Bte = zg(),
        Yte = Ng(),
        Ute = DP(),
        Gte = Fg(),
        RP = gc(),
        Zd = xu.coerceFont;
      function Vte(e, r, t, a) {
        function n(u, f) {
          return xu.coerce(e, r, RP, u, f);
        }
        var i = Bte(e, r, a, n);
        if (!i) {
          r.visible = !1;
          return;
        }
        Yte(e, r, a, n), n("xhoverformat"), n("yhoverformat"), n("zorder"), n("orientation", r.x && !r.y ? "h" : "v"), n("base"), n("offset"), n("width"), n("text"), n("hovertext"), n("hovertemplate");
        var l = n("textposition");
        NP(e, r, a, n, l, {
          moduleHasSelected: !0,
          moduleHasUnselected: !0,
          moduleHasConstrain: !0,
          moduleHasCliponaxis: !0,
          moduleHasTextangle: !0,
          moduleHasInsideanchor: !0
        }), Ute(e, r, n, t, a);
        var o = (r.marker.line || {}).color,
          s = Ote.getComponentMethod("errorbars", "supplyDefaults");
        s(e, r, o || PP.defaultLine, {
          axis: "y"
        }), s(e, r, o || PP.defaultLine, {
          axis: "x",
          inherit: "y"
        }), xu.coerceSelectionMarkerOpacity(r, n);
      }
      function Wte(e, r) {
        var t, a;
        function n(o, s) {
          return xu.coerce(a._input, a, RP, o, s);
        }
        for (var i = 0; i < e.length; i++) if (a = e[i], a.type === "bar") {
          t = a._input;
          var l = n("marker.cornerradius", r.barcornerradius);
          a.marker && (a.marker.cornerradius = zP(l)), Gte(t, a, r, n, r.barmode);
        }
      }
      function zP(e) {
        if (EP(e)) {
          if (e = +e, e >= 0) return e;
        } else if (typeof e == "string" && (e = e.trim(), e.slice(-1) === "%" && EP(e.slice(0, -1)) && (e = +e.slice(0, -1), e >= 0))) return e + "%";
      }
      function NP(e, r, t, a, n, i) {
        i = i || {};
        var l = i.moduleHasSelected !== !1,
          o = i.moduleHasUnselected !== !1,
          s = i.moduleHasConstrain !== !1,
          u = i.moduleHasCliponaxis !== !1,
          f = i.moduleHasTextangle !== !1,
          v = i.moduleHasInsideanchor !== !1,
          h = !!i.hasPathbar,
          d = Array.isArray(n) || n === "auto",
          y = d || n === "inside",
          g = d || n === "outside";
        if (y || g) {
          var m = Zd(a, "textfont", t.font),
            _ = xu.extendFlat({}, m),
            w = e.textfont && e.textfont.color,
            T = !w;
          if (T && delete _.color, Zd(a, "insidetextfont", _), h) {
            var b = xu.extendFlat({}, m);
            T && delete b.color, Zd(a, "pathbar.textfont", b);
          }
          g && Zd(a, "outsidetextfont", m), l && a("selected.textfont.color"), o && a("unselected.textfont.color"), s && a("constraintext"), u && a("cliponaxis"), f && a("textangle"), a("texttemplate");
        }
        y && v && a("insidetextanchor");
      }
      FP.exports = {
        supplyDefaults: Vte,
        crossTraceDefaults: Wte,
        handleText: NP,
        validateCornerradius: zP
      };
    });
    var HP = Z((Zce, IP) => {
      "use strict";

      var Zte = gr(),
        Xte = dt(),
        Jte = He(),
        Kte = o3(),
        Qte = bc().validateCornerradius;
      IP.exports = function (e, r, t) {
        function a(g, m) {
          return Jte.coerce(e, r, Kte, g, m);
        }
        for (var n = !1, i = !1, l = !1, o = {}, s = a("barmode"), u = s === "group", f = 0; f < t.length; f++) {
          var v = t[f];
          if (Zte.traceIs(v, "bar") && v.visible) n = !0;else continue;
          var h = v.xaxis + v.yaxis;
          if (u ? (o[h] && (l = !0), o[h] = !0) : (h += v._input.offsetgroup, o.length > 0 && !o[h] && (l = !0), o[h] = !0), v.visible && v.type === "histogram") {
            var d = Xte.getFromId({
              _fullLayout: r
            }, v[v.orientation === "v" ? "xaxis" : "yaxis"]);
            d.type !== "category" && (i = !0);
          }
        }
        if (!n) {
          delete r.barmode;
          return;
        }
        s !== "overlay" && a("barnorm"), a("bargap", i && !l ? 0 : .2), a("bargroupgap");
        var y = a("barcornerradius");
        r.barcornerradius = Qte(y);
      };
    });
    var s3 = Z((Xce, OP) => {
      "use strict";

      var _u = He();
      OP.exports = function (r, t) {
        for (var a = 0; a < r.length; a++) r[a].i = a;
        _u.mergeArray(t.text, r, "tx"), _u.mergeArray(t.hovertext, r, "htx");
        var n = t.marker;
        if (n) {
          _u.mergeArray(n.opacity, r, "mo", !0), _u.mergeArray(n.color, r, "mc");
          var i = n.line;
          i && (_u.mergeArray(i.color, r, "mlc"), _u.mergeArrayCastPositive(i.width, r, "mlw"));
        }
      };
    });
    var WP = Z((Jce, VP) => {
      "use strict";

      var BP = dt(),
        YP = Ig(),
        UP = Tn().hasColorscale,
        GP = i0(),
        $te = s3(),
        jte = Yg();
      VP.exports = function (r, t) {
        var a = BP.getFromId(r, t.xaxis || "x"),
          n = BP.getFromId(r, t.yaxis || "y"),
          i,
          l,
          o,
          s,
          u,
          f,
          v = {
            msUTC: !!(t.base || t.base === 0)
          };
        t.orientation === "h" ? (i = a.makeCalcdata(t, "x", v), o = n.makeCalcdata(t, "y"), s = YP(t, n, "y", o), u = !!t.yperiodalignment, f = "y") : (i = n.makeCalcdata(t, "y", v), o = a.makeCalcdata(t, "x"), s = YP(t, a, "x", o), u = !!t.xperiodalignment, f = "x"), l = s.vals;
        for (var h = Math.min(l.length, i.length), d = new Array(h), y = 0; y < h; y++) d[y] = {
          p: l[y],
          s: i[y]
        }, u && (d[y].orig_p = o[y], d[y][f + "End"] = s.ends[y], d[y][f + "Start"] = s.starts[y]), t.ids && (d[y].id = String(t.ids[y]));
        return UP(t, "marker") && GP(r, t, {
          vals: t.marker.color,
          containerStr: "marker",
          cLetter: "c"
        }), UP(t, "marker.line") && GP(r, t, {
          vals: t.marker.line.color,
          containerStr: "marker.line",
          cLetter: "c"
        }), $te(d, t), jte(d, t), d;
      };
    });
    var xc = Z((Kce, XP) => {
      "use strict";

      var eae = Ir(),
        rae = He();
      function tae(e, r, t) {
        var a = e._fullLayout,
          n = a["_" + t + "Text_minsize"];
        if (n) {
          var i = a.uniformtext.mode === "hide",
            l;
          switch (t) {
            case "funnelarea":
            case "pie":
            case "sunburst":
              l = "g.slice";
              break;
            case "treemap":
            case "icicle":
              l = "g.slice, g.pathbar";
              break;
            default:
              l = "g.points > g.point";
          }
          r.selectAll(l).each(function (o) {
            var s = o.transform;
            if (s) {
              s.scale = i && s.hide ? 0 : n / s.fontSize;
              var u = eae.select(this).select("text");
              rae.setTransormAndDisplay(u, s);
            }
          });
        }
      }
      function aae(e, r, t) {
        if (t.uniformtext.mode) {
          var a = ZP(e),
            n = t.uniformtext.minsize,
            i = r.scale * r.fontSize;
          r.hide = i < n, t[a] = t[a] || 1 / 0, r.hide || (t[a] = Math.min(t[a], Math.max(i, n)));
        }
      }
      function nae(e, r) {
        var t = ZP(e);
        r[t] = void 0;
      }
      function ZP(e) {
        return "_" + e + "Text_minsize";
      }
      XP.exports = {
        recordMinTextSize: aae,
        clearMinTextSize: nae,
        resizeText: tae
      };
    });
    var Xd = Z(Uo => {
      "use strict";

      var iae = Hr(),
        lae = bn(),
        JP = He().isArrayOrTypedArray;
      Uo.coerceString = function (e, r, t) {
        if (typeof r == "string") {
          if (r || !e.noBlank) return r;
        } else if ((typeof r == "number" || r === !0) && !e.strict) return String(r);
        return t !== void 0 ? t : e.dflt;
      };
      Uo.coerceNumber = function (e, r, t) {
        if (iae(r)) {
          r = +r;
          var a = e.min,
            n = e.max,
            i = a !== void 0 && r < a || n !== void 0 && r > n;
          if (!i) return r;
        }
        return t !== void 0 ? t : e.dflt;
      };
      Uo.coerceColor = function (e, r, t) {
        return lae(r).isValid() ? r : t !== void 0 ? t : e.dflt;
      };
      Uo.coerceEnumerated = function (e, r, t) {
        return e.coerceNumber && (r = +r), e.values.indexOf(r) !== -1 ? r : t !== void 0 ? t : e.dflt;
      };
      Uo.getValue = function (e, r) {
        var t;
        return JP(e) ? r < e.length && (t = e[r]) : t = e, t;
      };
      Uo.getLineWidth = function (e, r) {
        var t = 0 < r.mlw ? r.mlw : JP(e.marker.line.width) ? 0 : e.marker.line.width;
        return t;
      };
    });
    var Jd = Z(($ce, lR) => {
      "use strict";

      var _c = Ir(),
        oae = Er(),
        wc = tt(),
        KP = He(),
        QP = gr(),
        $P = xc().resizeText,
        u3 = gc(),
        sae = u3.textfont,
        uae = u3.insidetextfont,
        fae = u3.outsidetextfont,
        ya = Xd();
      function cae(e) {
        var r = _c.select(e).selectAll('g[class^="barlayer"]').selectAll("g.trace");
        $P(e, r, "bar");
        var t = r.size(),
          a = e._fullLayout;
        r.style("opacity", function (n) {
          return n[0].trace.opacity;
        }).each(function (n) {
          (a.barmode === "stack" && t > 1 || a.bargap === 0 && a.bargroupgap === 0 && !n[0].trace.marker.line.width) && _c.select(this).attr("shape-rendering", "crispEdges");
        }), r.selectAll("g.points").each(function (n) {
          var i = _c.select(this),
            l = n[0].trace;
          jP(i, l, e);
        }), QP.getComponentMethod("errorbars", "style")(r);
      }
      function jP(e, r, t) {
        wc.pointStyle(e.selectAll("path"), r, t), eR(e, r, t);
      }
      function eR(e, r, t) {
        e.selectAll("text").each(function (a) {
          var n = _c.select(this),
            i = KP.ensureUniformFontSize(t, rR(n, a, r, t));
          wc.font(n, i);
        });
      }
      function vae(e, r, t) {
        var a = r[0].trace;
        a.selectedpoints ? hae(t, a, e) : (jP(t, a, e), QP.getComponentMethod("errorbars", "style")(t));
      }
      function hae(e, r, t) {
        wc.selectedPointStyle(e.selectAll("path"), r), dae(e.selectAll("text"), r, t);
      }
      function dae(e, r, t) {
        e.each(function (a) {
          var n = _c.select(this),
            i;
          if (a.selected) {
            i = KP.ensureUniformFontSize(t, rR(n, a, r, t));
            var l = r.selected.textfont && r.selected.textfont.color;
            l && (i.color = l), wc.font(n, i);
          } else wc.selectedTextStyle(n, r);
        });
      }
      function rR(e, r, t, a) {
        var n = a._fullLayout.font,
          i = t.textfont;
        if (e.classed("bartext-inside")) {
          var l = iR(r, t);
          i = aR(t, r.i, n, l);
        } else e.classed("bartext-outside") && (i = nR(t, r.i, n));
        return i;
      }
      function tR(e, r, t) {
        return f3(sae, e.textfont, r, t);
      }
      function aR(e, r, t, a) {
        var n = tR(e, r, t),
          i = e._input.textfont === void 0 || e._input.textfont.color === void 0 || Array.isArray(e.textfont.color) && e.textfont.color[r] === void 0;
        return i && (n = {
          color: oae.contrast(a),
          family: n.family,
          size: n.size,
          weight: n.weight,
          style: n.style,
          variant: n.variant,
          textcase: n.textcase,
          lineposition: n.lineposition,
          shadow: n.shadow
        }), f3(uae, e.insidetextfont, r, n);
      }
      function nR(e, r, t) {
        var a = tR(e, r, t);
        return f3(fae, e.outsidetextfont, r, a);
      }
      function f3(e, r, t, a) {
        r = r || {};
        var n = ya.getValue(r.family, t),
          i = ya.getValue(r.size, t),
          l = ya.getValue(r.color, t),
          o = ya.getValue(r.weight, t),
          s = ya.getValue(r.style, t),
          u = ya.getValue(r.variant, t),
          f = ya.getValue(r.textcase, t),
          v = ya.getValue(r.lineposition, t),
          h = ya.getValue(r.shadow, t);
        return {
          family: ya.coerceString(e.family, n, a.family),
          size: ya.coerceNumber(e.size, i, a.size),
          color: ya.coerceColor(e.color, l, a.color),
          weight: ya.coerceString(e.weight, o, a.weight),
          style: ya.coerceString(e.style, s, a.style),
          variant: ya.coerceString(e.variant, u, a.variant),
          textcase: ya.coerceString(e.variant, f, a.textcase),
          lineposition: ya.coerceString(e.variant, v, a.lineposition),
          shadow: ya.coerceString(e.variant, h, a.shadow)
        };
      }
      function iR(e, r) {
        return r.type === "waterfall" ? r[e.dir].marker.color : e.mcc || e.mc || r.marker.color;
      }
      lR.exports = {
        style: cae,
        styleTextPoints: eR,
        styleOnSelect: vae,
        getInsideTextFont: aR,
        getOutsideTextFont: nR,
        getBarColor: iR,
        resizeText: $P
      };
    });
    var pR = Z((jce, dR) => {
      "use strict";

      var Kd = Ir(),
        Qd = Hr(),
        la = He(),
        pae = xa(),
        mae = Er(),
        Fl = tt(),
        yae = gr(),
        $d = dt().tickText,
        oR = xc(),
        gae = oR.recordMinTextSize,
        bae = oR.clearMinTextSize,
        c3 = Jd(),
        wu = Xd(),
        xae = Wd(),
        sR = gc(),
        _ae = sR.text,
        wae = sR.textposition,
        Tae = bi().appendArrayPointValue,
        Fa = xae.TEXTPAD;
      function Mae(e) {
        return e.id;
      }
      function Aae(e) {
        if (e.ids) return Mae;
      }
      function v3(e) {
        return (e > 0) - (e < 0);
      }
      function Ei(e, r) {
        return e < r ? 1 : -1;
      }
      function kae(e, r, t, a) {
        var n = [],
          i = [],
          l = a ? r : t,
          o = a ? t : r;
        return n[0] = l.c2p(e.s0, !0), i[0] = o.c2p(e.p0, !0), n[1] = l.c2p(e.s1, !0), i[1] = o.c2p(e.p1, !0), a ? [n, i] : [i, n];
      }
      function uR(e, r, t, a) {
        if (!r.uniformtext.mode && fR(t)) {
          var n;
          return a && (n = a()), e.transition().duration(t.duration).ease(t.easing).each("end", function () {
            n && n();
          }).each("interrupt", function () {
            n && n();
          });
        } else return e;
      }
      function fR(e) {
        return e && e.duration > 0;
      }
      function Cae(e, r, t, a, n, i) {
        var l = r.xaxis,
          o = r.yaxis,
          s = e._fullLayout,
          u = e._context.staticPlot;
        n || (n = {
          mode: s.barmode,
          norm: s.barmode,
          gap: s.bargap,
          groupgap: s.bargroupgap
        }, bae("bar", s));
        var f = la.makeTraceGroups(a, t, "trace bars").each(function (v) {
          var h = Kd.select(this),
            d = v[0].trace,
            y = v[0].t,
            g = d.type === "waterfall",
            m = d.type === "funnel",
            _ = d.type === "histogram",
            w = d.type === "bar",
            T = w || m,
            b = 0;
          g && d.connector.visible && d.connector.mode === "between" && (b = d.connector.line.width / 2);
          var A = d.orientation === "h",
            S = fR(n),
            k = la.ensureSingle(h, "g", "points"),
            q = Aae(d),
            D = k.selectAll("g.point").data(la.identity, q);
          D.enter().append("g").classed("point", !0), D.exit().remove(), D.each(function (z, N) {
            var H = Kd.select(this),
              O = kae(z, l, o, A),
              J = O[0][0],
              X = O[0][1],
              B = O[1][0],
              I = O[1][1],
              V = (A ? X - J : I - B) === 0;
            V && T && wu.getLineWidth(d, z) && (V = !1), V || (V = !Qd(J) || !Qd(X) || !Qd(B) || !Qd(I)), z.isBlank = V, V && (A ? X = J : I = B), b && !V && (A ? (J -= Ei(J, X) * b, X += Ei(J, X) * b) : (B -= Ei(B, I) * b, I += Ei(B, I) * b));
            var K, Q;
            if (d.type === "waterfall") {
              if (!V) {
                var ie = d[z.dir].marker;
                K = ie.line.width, Q = ie.color;
              }
            } else K = wu.getLineWidth(d, z), Q = z.mc || d.marker.color;
            function me(ne) {
              var Me = Kd.round(K / 2 % 1, 2);
              return n.gap === 0 && n.groupgap === 0 ? Kd.round(Math.round(ne) - Me, 2) : ne;
            }
            function pe(ne, Me, Ce) {
              return Ce && ne === Me ? ne : Math.abs(ne - Me) >= 2 ? me(ne) : ne > Me ? Math.ceil(ne) : Math.floor(ne);
            }
            var ge = mae.opacity(Q),
              j = ge < 1 || K > .01 ? me : pe;
            e._context.staticPlot || (J = j(J, X, A), X = j(X, J, A), B = j(B, I, !A), I = j(I, B, !A));
            var _e = A ? l.c2p : o.c2p,
              se;
            z.s0 > 0 ? se = z._sMax : z.s0 < 0 ? se = z._sMin : se = z.s1 > 0 ? z._sMax : z._sMin;
            function Se(ne, Me) {
              if (!ne) return 0;
              var Ce = Math.abs(A ? I - B : X - J),
                cr = Math.abs(A ? X - J : I - B),
                tr = j(Math.abs(_e(se, !0) - _e(0, !0))),
                De = z.hasB ? Math.min(Ce / 2, cr / 2) : Math.min(Ce / 2, tr),
                Le;
              if (Me === "%") {
                var Ye = Math.min(50, ne);
                Le = Ce * (Ye / 100);
              } else Le = ne;
              return j(Math.max(Math.min(Le, De), 0));
            }
            var ve = w || _ ? Se(y.cornerradiusvalue, y.cornerradiusform) : 0,
              Ae,
              Y,
              re = "M" + J + "," + B + "V" + I + "H" + X + "V" + B + "Z",
              U = 0;
            if (ve && z.s) {
              var de = v3(z.s0) === 0 || v3(z.s) === v3(z.s0) ? z.s1 : z.s0;
              if (U = j(z.hasB ? 0 : Math.abs(_e(se, !0) - _e(de, !0))), U < ve) {
                var be = Ei(J, X),
                  ye = Ei(B, I),
                  Fe = be === -ye ? 1 : 0;
                if (A) {
                  if (z.hasB) Ae = "M" + (J + ve * be) + "," + B + "A " + ve + "," + ve + " 0 0 " + Fe + " " + J + "," + (B + ve * ye) + "V" + (I - ve * ye) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + (J + ve * be) + "," + I + "H" + (X - ve * be) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + X + "," + (I - ve * ye) + "V" + (B + ve * ye) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + (X - ve * be) + "," + B + "Z";else {
                    Y = Math.abs(X - J) + U;
                    var Re = Y < ve ? ve - Math.sqrt(Y * (2 * ve - Y)) : 0,
                      Pe = U > 0 ? Math.sqrt(U * (2 * ve - U)) : 0,
                      Ie = be > 0 ? Math.max : Math.min;
                    Ae = "M" + J + "," + B + "V" + (I - Re * ye) + "H" + Ie(X - (ve - U) * be, J) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + X + "," + (I - ve * ye - Pe) + "V" + (B + ve * ye + Pe) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + Ie(X - (ve - U) * be, J) + "," + (B + Re * ye) + "Z";
                  }
                } else if (z.hasB) Ae = "M" + (J + ve * be) + "," + B + "A " + ve + "," + ve + " 0 0 " + Fe + " " + J + "," + (B + ve * ye) + "V" + (I - ve * ye) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + (J + ve * be) + "," + I + "H" + (X - ve * be) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + X + "," + (I - ve * ye) + "V" + (B + ve * ye) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + (X - ve * be) + "," + B + "Z";else {
                  Y = Math.abs(I - B) + U;
                  var Be = Y < ve ? ve - Math.sqrt(Y * (2 * ve - Y)) : 0,
                    Ne = U > 0 ? Math.sqrt(U * (2 * ve - U)) : 0,
                    Ee = ye > 0 ? Math.max : Math.min;
                  Ae = "M" + (J + Be * be) + "," + B + "V" + Ee(I - (ve - U) * ye, B) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + (J + ve * be - Ne) + "," + I + "H" + (X - ve * be + Ne) + "A " + ve + "," + ve + " 0 0 " + Fe + " " + (X - Be * be) + "," + Ee(I - (ve - U) * ye, B) + "V" + B + "Z";
                }
              } else Ae = re;
            } else Ae = re;
            var Je = uR(la.ensureSingle(H, "path"), s, n, i);
            if (Je.style("vector-effect", u ? "none" : "non-scaling-stroke").attr("d", isNaN((X - J) * (I - B)) || V && e._context.staticPlot ? "M0,0Z" : Ae).call(Fl.setClipUrl, r.layerClipId, e), !s.uniformtext.mode && S) {
              var We = Fl.makePointStyleFns(d);
              Fl.singlePointStyle(z, Je, d, We, e);
            }
            Sae(e, r, H, v, N, J, X, B, I, ve, U, n, i), r.layerClipId && Fl.hideOutsideRangePoint(z, H.select("text"), l, o, d.xcalendar, d.ycalendar);
          });
          var R = d.cliponaxis === !1;
          Fl.setClipUrl(h, R ? null : r.layerClipId, e);
        });
        yae.getComponentMethod("errorbars", "plot")(e, f, r, n);
      }
      function Sae(e, r, t, a, n, i, l, o, s, u, f, v, h) {
        var d = r.xaxis,
          y = r.yaxis,
          g = e._fullLayout,
          m;
        function _(Y, re, U) {
          var de = la.ensureSingle(Y, "text").text(re).attr({
            class: "bartext bartext-" + m,
            "text-anchor": "middle",
            "data-notex": 1
          }).call(Fl.font, U).call(pae.convertToTspans, e);
          return de;
        }
        var w = a[0].trace,
          T = w.orientation === "h",
          b = Dae(g, a, n, d, y);
        m = Eae(w, n);
        var A = v.mode === "stack" || v.mode === "relative",
          S = a[n],
          k = !A || S._outmost,
          q = S.hasB,
          D = u && u - f > Fa;
        if (!b || m === "none" || (S.isBlank || i === l || o === s) && (m === "auto" || m === "inside")) {
          t.select("text").remove();
          return;
        }
        var R = g.font,
          z = c3.getBarColor(a[n], w),
          N = c3.getInsideTextFont(w, n, R, z),
          H = c3.getOutsideTextFont(w, n, R),
          O = w.insidetextanchor || "end",
          J = t.datum();
        T ? d.type === "log" && J.s0 <= 0 && (d.range[0] < d.range[1] ? i = 0 : i = d._length) : y.type === "log" && J.s0 <= 0 && (y.range[0] < y.range[1] ? o = y._length : o = 0);
        var X = Math.abs(l - i),
          B = Math.abs(s - o),
          I = X - 2 * Fa,
          V = B - 2 * Fa,
          K,
          Q,
          ie,
          me,
          pe;
        if (m === "outside" && !k && !S.hasB && (m = "inside"), m === "auto") if (k) {
          m = "inside", pe = la.ensureUniformFontSize(e, N), K = _(t, b, pe), Q = Fl.bBox(K.node()), ie = Q.width, me = Q.height;
          var ge = ie > 0 && me > 0,
            j;
          D ? q ? j = Go(I - 2 * u, V, ie, me, T) || Go(I, V - 2 * u, ie, me, T) : T ? j = Go(I - (u - f), V, ie, me, T) || Go(I, V - 2 * (u - f), ie, me, T) : j = Go(I, V - (u - f), ie, me, T) || Go(I - 2 * (u - f), V, ie, me, T) : j = Go(I, V, ie, me, T), ge && j ? m = "inside" : (m = "outside", K.remove(), K = null);
        } else m = "inside";
        if (!K) {
          pe = la.ensureUniformFontSize(e, m === "outside" ? H : N), K = _(t, b, pe);
          var _e = K.attr("transform");
          if (K.attr("transform", ""), Q = Fl.bBox(K.node()), ie = Q.width, me = Q.height, K.attr("transform", _e), ie <= 0 || me <= 0) {
            K.remove();
            return;
          }
        }
        var se = w.textangle,
          Se,
          ve;
        m === "outside" ? (ve = w.constraintext === "both" || w.constraintext === "outside", Se = qae(i, l, o, s, Q, {
          isHorizontal: T,
          constrained: ve,
          angle: se
        })) : (ve = w.constraintext === "both" || w.constraintext === "inside", Se = hR(i, l, o, s, Q, {
          isHorizontal: T,
          constrained: ve,
          angle: se,
          anchor: O,
          hasB: q,
          r: u,
          overhead: f
        })), Se.fontSize = pe.size, gae(w.type === "histogram" ? "bar" : w.type, Se, g), S.transform = Se;
        var Ae = uR(K, g, v, h);
        la.setTransormAndDisplay(Ae, Se);
      }
      function Go(e, r, t, a, n) {
        if (e < 0 || r < 0) return !1;
        var i = t <= e && a <= r,
          l = t <= r && a <= e,
          o = n ? e >= t * (r / a) : r >= a * (e / t);
        return i || l || o;
      }
      function cR(e) {
        return e === "auto" ? 0 : e;
      }
      function vR(e, r) {
        var t = Math.PI / 180 * r,
          a = Math.abs(Math.sin(t)),
          n = Math.abs(Math.cos(t));
        return {
          x: e.width * n + e.height * a,
          y: e.width * a + e.height * n
        };
      }
      function hR(e, r, t, a, n, i) {
        var l = !!i.isHorizontal,
          o = !!i.constrained,
          s = i.angle || 0,
          u = i.anchor,
          f = u === "end",
          v = u === "start",
          h = i.leftToRight || 0,
          d = (h + 1) / 2,
          y = 1 - d,
          g = i.hasB,
          m = i.r,
          _ = i.overhead,
          w = n.width,
          T = n.height,
          b = Math.abs(r - e),
          A = Math.abs(a - t),
          S = b > 2 * Fa && A > 2 * Fa ? Fa : 0;
        b -= 2 * S, A -= 2 * S;
        var k = cR(s);
        s === "auto" && !(w <= b && T <= A) && (w > b || T > A) && (!(w > A || T > b) || w < T != b < A) && (k += 90);
        var q = vR(n, k),
          D,
          R;
        if (m && m - _ > Fa) {
          var z = Lae(e, r, t, a, q, m, _, l, g);
          D = z.scale, R = z.pad;
        } else D = 1, o && (D = Math.min(1, b / q.x, A / q.y)), R = 0;
        var N = n.left * y + n.right * d,
          H = (n.top + n.bottom) / 2,
          O = (e + Fa) * y + (r - Fa) * d,
          J = (t + a) / 2,
          X = 0,
          B = 0;
        if (v || f) {
          var I = (l ? q.x : q.y) / 2;
          m && (f || g) && (S += R);
          var V = l ? Ei(e, r) : Ei(t, a);
          l ? v ? (O = e + V * S, X = -V * I) : (O = r - V * S, X = V * I) : v ? (J = t + V * S, B = -V * I) : (J = a - V * S, B = V * I);
        }
        return {
          textX: N,
          textY: H,
          targetX: O,
          targetY: J,
          anchorX: X,
          anchorY: B,
          scale: D,
          rotate: k
        };
      }
      function Lae(e, r, t, a, n, i, l, o, s) {
        var u = Math.max(0, Math.abs(r - e) - 2 * Fa),
          f = Math.max(0, Math.abs(a - t) - 2 * Fa),
          v = i - Fa,
          h = l ? v - Math.sqrt(v * v - (v - l) * (v - l)) : v,
          d = s ? v * 2 : o ? v - l : 2 * h,
          y = s ? v * 2 : o ? 2 * h : v - l,
          g,
          m,
          _,
          w,
          T;
        return n.y / n.x >= f / (u - d) ? w = f / n.y : n.y / n.x <= (f - y) / u ? w = u / n.x : !s && o ? (g = n.x * n.x + n.y * n.y / 4, m = -2 * n.x * (u - v) - n.y * (f / 2 - v), _ = (u - v) * (u - v) + (f / 2 - v) * (f / 2 - v) - v * v, w = (-m + Math.sqrt(m * m - 4 * g * _)) / (2 * g)) : s ? (g = (n.x * n.x + n.y * n.y) / 4, m = -n.x * (u / 2 - v) - n.y * (f / 2 - v), _ = (u / 2 - v) * (u / 2 - v) + (f / 2 - v) * (f / 2 - v) - v * v, w = (-m + Math.sqrt(m * m - 4 * g * _)) / (2 * g)) : (g = n.x * n.x / 4 + n.y * n.y, m = -n.x * (u / 2 - v) - 2 * n.y * (f - v), _ = (u / 2 - v) * (u / 2 - v) + (f - v) * (f - v) - v * v, w = (-m + Math.sqrt(m * m - 4 * g * _)) / (2 * g)), w = Math.min(1, w), o ? T = Math.max(0, v - Math.sqrt(Math.max(0, v * v - (v - (f - n.y * w) / 2) * (v - (f - n.y * w) / 2))) - l) : T = Math.max(0, v - Math.sqrt(Math.max(0, v * v - (v - (u - n.x * w) / 2) * (v - (u - n.x * w) / 2))) - l), {
          scale: w,
          pad: T
        };
      }
      function qae(e, r, t, a, n, i) {
        var l = !!i.isHorizontal,
          o = !!i.constrained,
          s = i.angle || 0,
          u = n.width,
          f = n.height,
          v = Math.abs(r - e),
          h = Math.abs(a - t),
          d;
        l ? d = h > 2 * Fa ? Fa : 0 : d = v > 2 * Fa ? Fa : 0;
        var y = 1;
        o && (y = l ? Math.min(1, h / f) : Math.min(1, v / u));
        var g = cR(s),
          m = vR(n, g),
          _ = (l ? m.x : m.y) / 2,
          w = (n.left + n.right) / 2,
          T = (n.top + n.bottom) / 2,
          b = (e + r) / 2,
          A = (t + a) / 2,
          S = 0,
          k = 0,
          q = l ? Ei(r, e) : Ei(t, a);
        return l ? (b = r - q * d, S = q * _) : (A = a + q * d, k = -q * _), {
          textX: w,
          textY: T,
          targetX: b,
          targetY: A,
          anchorX: S,
          anchorY: k,
          scale: y,
          rotate: g
        };
      }
      function Dae(e, r, t, a, n) {
        var i = r[0].trace,
          l = i.texttemplate,
          o;
        return l ? o = Pae(e, r, t, a, n) : i.textinfo ? o = Rae(r, t, a, n) : o = wu.getValue(i.text, t), wu.coerceString(_ae, o);
      }
      function Eae(e, r) {
        var t = wu.getValue(e.textposition, r);
        return wu.coerceEnumerated(wae, t);
      }
      function Pae(e, r, t, a, n) {
        var i = r[0].trace,
          l = la.castOption(i, t, "texttemplate");
        if (!l) return "";
        var o = i.type === "histogram",
          s = i.type === "waterfall",
          u = i.type === "funnel",
          f = i.orientation === "h",
          v,
          h,
          d,
          y;
        f ? (v = "y", h = n, d = "x", y = a) : (v = "x", h = a, d = "y", y = n);
        function g(S) {
          return $d(h, h.c2l(S), !0).text;
        }
        function m(S) {
          return $d(y, y.c2l(S), !0).text;
        }
        var _ = r[t],
          w = {};
        w.label = _.p, w.labelLabel = w[v + "Label"] = g(_.p);
        var T = la.castOption(i, _.i, "text");
        (T === 0 || T) && (w.text = T), w.value = _.s, w.valueLabel = w[d + "Label"] = m(_.s);
        var b = {};
        Tae(b, i, _.i), (o || b.x === void 0) && (b.x = f ? w.value : w.label), (o || b.y === void 0) && (b.y = f ? w.label : w.value), (o || b.xLabel === void 0) && (b.xLabel = f ? w.valueLabel : w.labelLabel), (o || b.yLabel === void 0) && (b.yLabel = f ? w.labelLabel : w.valueLabel), s && (w.delta = +_.rawS || _.s, w.deltaLabel = m(w.delta), w.final = _.v, w.finalLabel = m(w.final), w.initial = w.final - w.delta, w.initialLabel = m(w.initial)), u && (w.value = _.s, w.valueLabel = m(w.value), w.percentInitial = _.begR, w.percentInitialLabel = la.formatPercent(_.begR), w.percentPrevious = _.difR, w.percentPreviousLabel = la.formatPercent(_.difR), w.percentTotal = _.sumR, w.percenTotalLabel = la.formatPercent(_.sumR));
        var A = la.castOption(i, _.i, "customdata");
        return A && (w.customdata = A), la.texttemplateString(l, w, e._d3locale, b, w, i._meta || {});
      }
      function Rae(e, r, t, a) {
        var n = e[0].trace,
          i = n.orientation === "h",
          l = n.type === "waterfall",
          o = n.type === "funnel";
        function s(A) {
          var S = i ? a : t;
          return $d(S, A, !0).text;
        }
        function u(A) {
          var S = i ? t : a;
          return $d(S, +A, !0).text;
        }
        var f = n.textinfo,
          v = e[r],
          h = f.split("+"),
          d = [],
          y,
          g = function (A) {
            return h.indexOf(A) !== -1;
          };
        if (g("label") && d.push(s(e[r].p)), g("text") && (y = la.castOption(n, v.i, "text"), (y === 0 || y) && d.push(y)), l) {
          var m = +v.rawS || v.s,
            _ = v.v,
            w = _ - m;
          g("initial") && d.push(u(w)), g("delta") && d.push(u(m)), g("final") && d.push(u(_));
        }
        if (o) {
          g("value") && d.push(u(v.s));
          var T = 0;
          g("percent initial") && T++, g("percent previous") && T++, g("percent total") && T++;
          var b = T > 1;
          g("percent initial") && (y = la.formatPercent(v.begR), b && (y += " of initial"), d.push(y)), g("percent previous") && (y = la.formatPercent(v.difR), b && (y += " of previous"), d.push(y)), g("percent total") && (y = la.formatPercent(v.sumR), b && (y += " of total"), d.push(y));
        }
        return d.join("<br>");
      }
      dR.exports = {
        plot: Cae,
        toMoveInsideBar: hR
      };
    });
    var xR = Z((eve, bR) => {
      "use strict";

      var Tc = ki(),
        zae = gr(),
        mR = Er(),
        Nae = He().fillText,
        Fae = Xd().getLineWidth,
        h3 = dt().hoverLabelText,
        Iae = Bt().BADNUM;
      function Hae(e, r, t, a, n) {
        var i = yR(e, r, t, a, n);
        if (i) {
          var l = i.cd,
            o = l[0].trace,
            s = l[i.index];
          return i.color = gR(o, s), zae.getComponentMethod("errorbars", "hoverInfo")(s, o, i), [i];
        }
      }
      function yR(e, r, t, a, n) {
        var i = e.cd,
          l = i[0].trace,
          o = i[0].t,
          s = a === "closest",
          u = l.type === "waterfall",
          f = e.maxHoverDistance,
          v = e.maxSpikeDistance,
          h,
          d,
          y,
          g,
          m,
          _,
          w;
        l.orientation === "h" ? (h = t, d = r, y = "y", g = "x", m = J, _ = N) : (h = r, d = t, y = "x", g = "y", _ = J, m = N);
        var T = l[y + "period"],
          b = s || T;
        function A(j) {
          return k(j, -1);
        }
        function S(j) {
          return k(j, 1);
        }
        function k(j, _e) {
          var se = j.w;
          return j[y] + _e * se / 2;
        }
        function q(j) {
          return j[y + "End"] - j[y + "Start"];
        }
        var D = s ? A : T ? function (j) {
            return j.p - q(j) / 2;
          } : function (j) {
            return Math.min(A(j), j.p - o.bardelta / 2);
          },
          R = s ? S : T ? function (j) {
            return j.p + q(j) / 2;
          } : function (j) {
            return Math.max(S(j), j.p + o.bardelta / 2);
          };
        function z(j, _e, se) {
          return n.finiteRange && (se = 0), Tc.inbox(j - h, _e - h, se + Math.min(1, Math.abs(_e - j) / w) - 1);
        }
        function N(j) {
          return z(D(j), R(j), f);
        }
        function H(j) {
          return z(A(j), S(j), v);
        }
        function O(j) {
          var _e = j[g];
          if (u) {
            var se = Math.abs(j.rawS) || 0;
            d > 0 ? _e += se : d < 0 && (_e -= se);
          }
          return _e;
        }
        function J(j) {
          var _e = d,
            se = j.b,
            Se = O(j);
          return Tc.inbox(se - _e, Se - _e, f + (Se - _e) / (Se - se) - 1);
        }
        function X(j) {
          var _e = d,
            se = j.b,
            Se = O(j);
          return Tc.inbox(se - _e, Se - _e, v + (Se - _e) / (Se - se) - 1);
        }
        var B = e[y + "a"],
          I = e[g + "a"];
        w = Math.abs(B.r2c(B.range[1]) - B.r2c(B.range[0]));
        function V(j) {
          return (m(j) + _(j)) / 2;
        }
        var K = Tc.getDistanceFunction(a, m, _, V);
        if (Tc.getClosest(i, K, e), e.index !== !1 && i[e.index].p !== Iae) {
          b || (D = function (j) {
            return Math.min(A(j), j.p - o.bargroupwidth / 2);
          }, R = function (j) {
            return Math.max(S(j), j.p + o.bargroupwidth / 2);
          });
          var Q = e.index,
            ie = i[Q],
            me = l.base ? ie.b + ie.s : ie.s;
          e[g + "0"] = e[g + "1"] = I.c2p(ie[g], !0), e[g + "LabelVal"] = me;
          var pe = o.extents[o.extents.round(ie.p)];
          e[y + "0"] = B.c2p(s ? D(ie) : pe[0], !0), e[y + "1"] = B.c2p(s ? R(ie) : pe[1], !0);
          var ge = ie.orig_p !== void 0;
          return e[y + "LabelVal"] = ge ? ie.orig_p : ie.p, e.labelLabel = h3(B, e[y + "LabelVal"], l[y + "hoverformat"]), e.valueLabel = h3(I, e[g + "LabelVal"], l[g + "hoverformat"]), e.baseLabel = h3(I, ie.b, l[g + "hoverformat"]), e.spikeDistance = (X(ie) + H(ie)) / 2, e[y + "Spike"] = B.c2p(ie.p, !0), Nae(ie, l, e), e.hovertemplate = l.hovertemplate, e;
        }
      }
      function gR(e, r) {
        var t = r.mcc || e.marker.color,
          a = r.mlcc || e.marker.line.color,
          n = Fae(e, r);
        if (mR.opacity(t)) return t;
        if (mR.opacity(a) && n) return a;
      }
      bR.exports = {
        hoverPoints: Hae,
        hoverOnBars: yR,
        getTraceColor: gR
      };
    });
    var wR = Z((rve, _R) => {
      "use strict";

      _R.exports = function (r, t, a) {
        return r.x = "xVal" in t ? t.xVal : t.x, r.y = "yVal" in t ? t.yVal : t.y, t.xa && (r.xaxis = t.xa), t.ya && (r.yaxis = t.ya), a.orientation === "h" ? (r.label = r.y, r.value = r.x) : (r.label = r.x, r.value = r.y), r;
      };
    });
    var MR = Z((tve, TR) => {
      "use strict";

      TR.exports = function (r, t) {
        var a = r.cd,
          n = r.xaxis,
          i = r.yaxis,
          l = a[0].trace,
          o = l.type === "funnel",
          s = l.orientation === "h",
          u = [],
          f;
        if (t === !1) for (f = 0; f < a.length; f++) a[f].selected = 0;else for (f = 0; f < a.length; f++) {
          var v = a[f],
            h = "ct" in v ? v.ct : Oae(v, n, i, s, o);
          t.contains(h, !1, f, r) ? (u.push({
            pointNumber: f,
            x: n.c2d(v.x),
            y: i.c2d(v.y)
          }), v.selected = 1) : v.selected = 0;
        }
        return u;
      };
      function Oae(e, r, t, a, n) {
        var i = r.c2p(a ? e.s0 : e.p0, !0),
          l = r.c2p(a ? e.s1 : e.p1, !0),
          o = t.c2p(a ? e.p0 : e.s0, !0),
          s = t.c2p(a ? e.p1 : e.s1, !0);
        return n ? [(i + l) / 2, (o + s) / 2] : a ? [l, (o + s) / 2] : [(i + l) / 2, s];
      }
    });
    var kR = Z((ave, AR) => {
      "use strict";

      AR.exports = {
        attributes: gc(),
        layoutAttributes: o3(),
        supplyDefaults: bc().supplyDefaults,
        crossTraceDefaults: bc().crossTraceDefaults,
        supplyLayoutDefaults: HP(),
        calc: WP(),
        crossTraceCalc: $g().crossTraceCalc,
        colorbar: r2(),
        arraysToCalcdata: s3(),
        plot: pR().plot,
        style: Jd().style,
        styleOnSelect: Jd().styleOnSelect,
        hoverPoints: xR().hoverPoints,
        eventData: wR(),
        selectPoints: MR(),
        moduleType: "trace",
        name: "bar",
        basePlotModule: bd(),
        categories: ["bar-like", "cartesian", "svg", "bar", "oriented", "errorBarsOK", "showLegend", "zoomScale"],
        animatable: !0,
        meta: {}
      };
    });
    var SR = Z((nve, CR) => {
      "use strict";

      CR.exports = kR();
    });
    var d3 = Z((ive, LR) => {
      "use strict";

      var Bae = Gn(),
        Yae = Od().attributes,
        Uae = ha(),
        Gae = hi(),
        Vae = zi().hovertemplateAttrs,
        Wae = zi().texttemplateAttrs,
        Mc = Yt().extendFlat,
        Zae = mi().pattern,
        jd = Uae({
          editType: "plot",
          arrayOk: !0,
          colorEditType: "plot"
        });
      LR.exports = {
        labels: {
          valType: "data_array",
          editType: "calc"
        },
        label0: {
          valType: "number",
          dflt: 0,
          editType: "calc"
        },
        dlabel: {
          valType: "number",
          dflt: 1,
          editType: "calc"
        },
        values: {
          valType: "data_array",
          editType: "calc"
        },
        marker: {
          colors: {
            valType: "data_array",
            editType: "calc"
          },
          line: {
            color: {
              valType: "color",
              dflt: Gae.defaultLine,
              arrayOk: !0,
              editType: "style"
            },
            width: {
              valType: "number",
              min: 0,
              dflt: 0,
              arrayOk: !0,
              editType: "style"
            },
            editType: "calc"
          },
          pattern: Zae,
          editType: "calc"
        },
        text: {
          valType: "data_array",
          editType: "plot"
        },
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "style"
        },
        scalegroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        textinfo: {
          valType: "flaglist",
          flags: ["label", "text", "value", "percent"],
          extras: ["none"],
          editType: "calc"
        },
        hoverinfo: Mc({}, Bae.hoverinfo, {
          flags: ["label", "text", "value", "percent", "name"]
        }),
        hovertemplate: Vae({}, {
          keys: ["label", "color", "value", "percent", "text"]
        }),
        texttemplate: Wae({
          editType: "plot"
        }, {
          keys: ["label", "color", "value", "percent", "text"]
        }),
        textposition: {
          valType: "enumerated",
          values: ["inside", "outside", "auto", "none"],
          dflt: "auto",
          arrayOk: !0,
          editType: "plot"
        },
        textfont: Mc({}, jd, {}),
        insidetextorientation: {
          valType: "enumerated",
          values: ["horizontal", "radial", "tangential", "auto"],
          dflt: "auto",
          editType: "plot"
        },
        insidetextfont: Mc({}, jd, {}),
        outsidetextfont: Mc({}, jd, {}),
        automargin: {
          valType: "boolean",
          dflt: !1,
          editType: "plot"
        },
        title: {
          text: {
            valType: "string",
            dflt: "",
            editType: "plot"
          },
          font: Mc({}, jd, {}),
          position: {
            valType: "enumerated",
            values: ["top left", "top center", "top right", "middle center", "bottom left", "bottom center", "bottom right"],
            editType: "plot"
          },
          editType: "plot"
        },
        domain: Yae({
          name: "pie",
          trace: !0,
          editType: "calc"
        }),
        hole: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "calc"
        },
        sort: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        direction: {
          valType: "enumerated",
          values: ["clockwise", "counterclockwise"],
          dflt: "counterclockwise",
          editType: "calc"
        },
        rotation: {
          valType: "angle",
          dflt: 0,
          editType: "calc"
        },
        pull: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          arrayOk: !0,
          editType: "calc"
        }
      };
    });
    var PR = Z((lve, ER) => {
      "use strict";

      var Xae = Hr(),
        Ac = He(),
        Jae = d3(),
        Kae = Od().defaults,
        Qae = bc().handleText,
        $ae = He().coercePattern;
      function qR(e, r) {
        var t = Ac.isArrayOrTypedArray(e),
          a = Ac.isArrayOrTypedArray(r),
          n = Math.min(t ? e.length : 1 / 0, a ? r.length : 1 / 0);
        if (isFinite(n) || (n = 0), n && a) {
          for (var i, l = 0; l < n; l++) {
            var o = r[l];
            if (Xae(o) && o > 0) {
              i = !0;
              break;
            }
          }
          i || (n = 0);
        }
        return {
          hasLabels: t,
          hasValues: a,
          len: n
        };
      }
      function DR(e, r, t, a, n) {
        var i = a("marker.line.width");
        i && a("marker.line.color", n ? void 0 : t.paper_bgcolor);
        var l = a("marker.colors");
        $ae(a, "marker.pattern", l), e.marker && !r.marker.pattern.fgcolor && (r.marker.pattern.fgcolor = e.marker.colors), r.marker.pattern.bgcolor || (r.marker.pattern.bgcolor = t.paper_bgcolor);
      }
      function jae(e, r, t, a) {
        function n(w, T) {
          return Ac.coerce(e, r, Jae, w, T);
        }
        var i = n("labels"),
          l = n("values"),
          o = qR(i, l),
          s = o.len;
        if (r._hasLabels = o.hasLabels, r._hasValues = o.hasValues, !r._hasLabels && r._hasValues && (n("label0"), n("dlabel")), !s) {
          r.visible = !1;
          return;
        }
        r._length = s, DR(e, r, a, n, !0), n("scalegroup");
        var u = n("text"),
          f = n("texttemplate"),
          v;
        if (f || (v = n("textinfo", Ac.isArrayOrTypedArray(u) ? "text+percent" : "percent")), n("hovertext"), n("hovertemplate"), f || v && v !== "none") {
          var h = n("textposition");
          Qae(e, r, a, n, h, {
            moduleHasSelected: !1,
            moduleHasUnselected: !1,
            moduleHasConstrain: !1,
            moduleHasCliponaxis: !1,
            moduleHasTextangle: !1,
            moduleHasInsideanchor: !1
          });
          var d = Array.isArray(h) || h === "auto",
            y = d || h === "outside";
          y && n("automargin"), (h === "inside" || h === "auto" || Array.isArray(h)) && n("insidetextorientation");
        } else v === "none" && n("textposition", "none");
        Kae(r, a, n);
        var g = n("hole"),
          m = n("title.text");
        if (m) {
          var _ = n("title.position", g ? "middle center" : "top center");
          !g && _ === "middle center" && (r.title.position = "top center"), Ac.coerceFont(n, "title.font", a.font);
        }
        n("sort"), n("direction"), n("rotation"), n("pull");
      }
      ER.exports = {
        handleLabelsAndValues: qR,
        handleMarkerDefaults: DR,
        supplyDefaults: jae
      };
    });
    var p3 = Z((ove, RR) => {
      "use strict";

      RR.exports = {
        hiddenlabels: {
          valType: "data_array",
          editType: "calc"
        },
        piecolorway: {
          valType: "colorlist",
          editType: "calc"
        },
        extendpiecolors: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        }
      };
    });
    var NR = Z((sve, zR) => {
      "use strict";

      var ene = He(),
        rne = p3();
      zR.exports = function (r, t) {
        function a(n, i) {
          return ene.coerce(r, t, rne, n, i);
        }
        a("hiddenlabels"), a("piecolorway", t.colorway), a("extendpiecolors");
      };
    });
    var y3 = Z((uve, HR) => {
      "use strict";

      var tne = Hr(),
        m3 = bn(),
        ane = Er(),
        nne = {};
      function ine(e, r) {
        var t = [],
          a = e._fullLayout,
          n = a.hiddenlabels || [],
          i = r.labels,
          l = r.marker.colors || [],
          o = r.values,
          s = r._length,
          u = r._hasValues && s,
          f,
          v;
        if (r.dlabel) for (i = new Array(s), f = 0; f < s; f++) i[f] = String(r.label0 + f * r.dlabel);
        var h = {},
          d = FR(a["_" + r.type + "colormap"]),
          y = 0,
          g = !1;
        for (f = 0; f < s; f++) {
          var m, _, w;
          if (u) {
            if (m = o[f], !tne(m)) continue;
            m = +m;
          } else m = 1;
          _ = i[f], (_ === void 0 || _ === "") && (_ = f), _ = String(_);
          var T = h[_];
          T === void 0 ? (h[_] = t.length, w = n.indexOf(_) !== -1, w || (y += m), t.push({
            v: m,
            label: _,
            color: d(l[f], _),
            i: f,
            pts: [f],
            hidden: w
          })) : (g = !0, v = t[T], v.v += m, v.pts.push(f), v.hidden || (y += m), v.color === !1 && l[f] && (v.color = d(l[f], _)));
        }
        t = t.filter(function (A) {
          return A.v >= 0;
        });
        var b = r.type === "funnelarea" ? g : r.sort;
        return b && t.sort(function (A, S) {
          return S.v - A.v;
        }), t[0] && (t[0].vTotal = y), t;
      }
      function FR(e) {
        return function (t, a) {
          return !t || (t = m3(t), !t.isValid()) ? !1 : (t = ane.addOpacity(t, t.getAlpha()), e[a] || (e[a] = t), t);
        };
      }
      function lne(e, r) {
        var t = (r || {}).type;
        t || (t = "pie");
        var a = e._fullLayout,
          n = e.calcdata,
          i = a[t + "colorway"],
          l = a["_" + t + "colormap"];
        a["extend" + t + "colors"] && (i = IR(i, nne));
        for (var o = 0, s = 0; s < n.length; s++) {
          var u = n[s],
            f = u[0].trace.type;
          if (f === t) for (var v = 0; v < u.length; v++) {
            var h = u[v];
            h.color === !1 && (l[h.label] ? h.color = l[h.label] : (l[h.label] = h.color = i[o % i.length], o++));
          }
        }
      }
      function IR(e, r) {
        var t,
          a = JSON.stringify(e),
          n = r[a];
        if (!n) {
          for (n = e.slice(), t = 0; t < e.length; t++) n.push(m3(e[t]).lighten(20).toHexString());
          for (t = 0; t < e.length; t++) n.push(m3(e[t]).darken(20).toHexString());
          r[a] = n;
        }
        return n;
      }
      HR.exports = {
        calc: ine,
        crossTraceCalc: lne,
        makePullColorFn: FR,
        generateExtendedColors: IR
      };
    });
    var BR = Z((fve, OR) => {
      "use strict";

      var one = bi().appendArrayMultiPointValues;
      OR.exports = function (r, t) {
        var a = {
          curveNumber: t.index,
          pointNumbers: r.pts,
          data: t._input,
          fullData: t,
          label: r.label,
          color: r.color,
          value: r.v,
          percent: r.percent,
          text: r.text,
          bbox: r.bbox,
          v: r.v
        };
        return r.pts.length === 1 && (a.pointNumber = a.i = r.pts[0]), one(a, t, r.pts), t.type === "funnelarea" && (delete a.v, delete a.i), a;
      };
    });
    var uz = Z((cve, sz) => {
      "use strict";

      var an = Ir(),
        sne = Pt(),
        e1 = ki(),
        ZR = Er(),
        ji = tt(),
        ga = He(),
        une = ga.strScale,
        YR = ga.strTranslate,
        g3 = xa(),
        XR = xc(),
        fne = XR.recordMinTextSize,
        cne = XR.clearMinTextSize,
        JR = Wd().TEXTPAD,
        wr = H0(),
        r1 = BR(),
        UR = He().isValidTextValue;
      function vne(e, r) {
        var t = e._context.staticPlot,
          a = e._fullLayout,
          n = a._size;
        cne("pie", a), $R(r, e), iz(r, n);
        var i = ga.makeTraceGroups(a._pielayer, r, "trace").each(function (l) {
          var o = an.select(this),
            s = l[0],
            u = s.trace;
          _ne(l), o.attr("stroke-linejoin", "round"), o.each(function () {
            var f = an.select(this).selectAll("g.slice").data(l);
            f.enter().append("g").classed("slice", !0), f.exit().remove();
            var v = [[[], []], [[], []]],
              h = !1;
            f.each(function (b, A) {
              if (b.hidden) {
                an.select(this).selectAll("path,g").remove();
                return;
              }
              b.pointNumber = b.i, b.curveNumber = u.index, v[b.pxmid[1] < 0 ? 0 : 1][b.pxmid[0] < 0 ? 0 : 1].push(b);
              var S = s.cx,
                k = s.cy,
                q = an.select(this),
                D = q.selectAll("path.surface").data([b]);
              if (D.enter().append("path").classed("surface", !0).style({
                "pointer-events": t ? "none" : "all"
              }), q.call(KR, e, l), u.pull) {
                var R = +wr.castOption(u.pull, b.pts) || 0;
                R > 0 && (S += R * b.pxmid[0], k += R * b.pxmid[1]);
              }
              b.cxFinal = S, b.cyFinal = k;
              function z(I, V, K, Q) {
                var ie = Q * (V[0] - I[0]),
                  me = Q * (V[1] - I[1]);
                return "a" + Q * s.r + "," + Q * s.r + " 0 " + b.largeArc + (K ? " 1 " : " 0 ") + ie + "," + me;
              }
              var N = u.hole;
              if (b.v === s.vTotal) {
                var H = "M" + (S + b.px0[0]) + "," + (k + b.px0[1]) + z(b.px0, b.pxmid, !0, 1) + z(b.pxmid, b.px0, !0, 1) + "Z";
                N ? D.attr("d", "M" + (S + N * b.px0[0]) + "," + (k + N * b.px0[1]) + z(b.px0, b.pxmid, !1, N) + z(b.pxmid, b.px0, !1, N) + "Z" + H) : D.attr("d", H);
              } else {
                var O = z(b.px0, b.px1, !0, 1);
                if (N) {
                  var J = 1 - N;
                  D.attr("d", "M" + (S + N * b.px1[0]) + "," + (k + N * b.px1[1]) + z(b.px1, b.px0, !1, N) + "l" + J * b.px0[0] + "," + J * b.px0[1] + O + "Z");
                } else D.attr("d", "M" + S + "," + k + "l" + b.px0[0] + "," + b.px0[1] + O + "Z");
              }
              lz(e, b, s);
              var X = wr.castOption(u.textposition, b.pts),
                B = q.selectAll("g.slicetext").data(b.text && X !== "none" ? [0] : []);
              B.enter().append("g").classed("slicetext", !0), B.exit().remove(), B.each(function () {
                var I = ga.ensureSingle(an.select(this), "text", "", function (j) {
                    j.attr("data-notex", 1);
                  }),
                  V = ga.ensureUniformFontSize(e, X === "outside" ? dne(u, b, a.font) : QR(u, b, a.font));
                I.text(b.text).attr({
                  class: "slicetext",
                  transform: "",
                  "text-anchor": "middle"
                }).call(ji.font, V).call(g3.convertToTspans, e);
                var K = ji.bBox(I.node()),
                  Q;
                if (X === "outside") Q = WR(K, b);else if (Q = jR(K, b, s), X === "auto" && Q.scale < 1) {
                  var ie = ga.ensureUniformFontSize(e, u.outsidetextfont);
                  I.call(ji.font, ie), K = ji.bBox(I.node()), Q = WR(K, b);
                }
                var me = Q.textPosAngle,
                  pe = me === void 0 ? b.pxmid : t1(s.r, me);
                if (Q.targetX = S + pe[0] * Q.rCenter + (Q.x || 0), Q.targetY = k + pe[1] * Q.rCenter + (Q.y || 0), oz(Q, K), Q.outside) {
                  var ge = Q.targetY;
                  b.yLabelMin = ge - K.height / 2, b.yLabelMid = ge, b.yLabelMax = ge + K.height / 2, b.labelExtraX = 0, b.labelExtraY = 0, h = !0;
                }
                Q.fontSize = V.size, fne(u.type, Q, a), l[A].transform = Q, ga.setTransormAndDisplay(I, Q);
              });
            });
            var d = an.select(this).selectAll("g.titletext").data(u.title.text ? [0] : []);
            if (d.enter().append("g").classed("titletext", !0), d.exit().remove(), d.each(function () {
              var b = ga.ensureSingle(an.select(this), "text", "", function (k) {
                  k.attr("data-notex", 1);
                }),
                A = u.title.text;
              u._meta && (A = ga.templateString(A, u._meta)), b.text(A).attr({
                class: "titletext",
                transform: "",
                "text-anchor": "middle"
              }).call(ji.font, u.title.font).call(g3.convertToTspans, e);
              var S;
              u.title.position === "middle center" ? S = yne(s) : S = az(s, n), b.attr("transform", YR(S.x, S.y) + une(Math.min(1, S.scale)) + YR(S.tx, S.ty));
            }), h && bne(v, u), hne(f, u), h && u.automargin) {
              var y = ji.bBox(o.node()),
                g = u.domain,
                m = n.w * (g.x[1] - g.x[0]),
                _ = n.h * (g.y[1] - g.y[0]),
                w = (.5 * m - s.r) / n.w,
                T = (.5 * _ - s.r) / n.h;
              sne.autoMargin(e, "pie." + u.uid + ".automargin", {
                xl: g.x[0] - w,
                xr: g.x[1] + w,
                yb: g.y[0] - T,
                yt: g.y[1] + T,
                l: Math.max(s.cx - s.r - y.left, 0),
                r: Math.max(y.right - (s.cx + s.r), 0),
                b: Math.max(y.bottom - (s.cy + s.r), 0),
                t: Math.max(s.cy - s.r - y.top, 0),
                pad: 5
              });
            }
          });
        });
        setTimeout(function () {
          i.selectAll("tspan").each(function () {
            var l = an.select(this);
            l.attr("dy") && l.attr("dy", l.attr("dy"));
          });
        }, 0);
      }
      function hne(e, r) {
        e.each(function (t) {
          var a = an.select(this);
          if (!t.labelExtraX && !t.labelExtraY) {
            a.select("path.textline").remove();
            return;
          }
          var n = a.select("g.slicetext text");
          t.transform.targetX += t.labelExtraX, t.transform.targetY += t.labelExtraY, ga.setTransormAndDisplay(n, t.transform);
          var i = t.cxFinal + t.pxmid[0],
            l = t.cyFinal + t.pxmid[1],
            o = "M" + i + "," + l,
            s = (t.yLabelMax - t.yLabelMin) * (t.pxmid[0] < 0 ? -1 : 1) / 4;
          if (t.labelExtraX) {
            var u = t.labelExtraX * t.pxmid[1] / t.pxmid[0],
              f = t.yLabelMid + t.labelExtraY - (t.cyFinal + t.pxmid[1]);
            Math.abs(u) > Math.abs(f) ? o += "l" + f * t.pxmid[0] / t.pxmid[1] + "," + f + "H" + (i + t.labelExtraX + s) : o += "l" + t.labelExtraX + "," + u + "v" + (f - u) + "h" + s;
          } else o += "V" + (t.yLabelMid + t.labelExtraY) + "h" + s;
          ga.ensureSingle(a, "path", "textline").call(ZR.stroke, r.outsidetextfont.color).attr({
            "stroke-width": Math.min(2, r.outsidetextfont.size / 8),
            d: o,
            fill: "none"
          });
        });
      }
      function KR(e, r, t) {
        var a = t[0],
          n = a.cx,
          i = a.cy,
          l = a.trace,
          o = l.type === "funnelarea";
        "_hasHoverLabel" in l || (l._hasHoverLabel = !1), "_hasHoverEvent" in l || (l._hasHoverEvent = !1), e.on("mouseover", function (s) {
          var u = r._fullLayout,
            f = r._fullData[l.index];
          if (!(r._dragging || u.hovermode === !1)) {
            var v = f.hoverinfo;
            if (Array.isArray(v) && (v = e1.castHoverinfo({
              hoverinfo: [wr.castOption(v, s.pts)],
              _module: l._module
            }, u, 0)), v === "all" && (v = "label+text+value+percent+name"), f.hovertemplate || v !== "none" && v !== "skip" && v) {
              var h = s.rInscribed || 0,
                d = n + s.pxmid[0] * (1 - h),
                y = i + s.pxmid[1] * (1 - h),
                g = u.separators,
                m = [];
              if (v && v.indexOf("label") !== -1 && m.push(s.label), s.text = wr.castOption(f.hovertext || f.text, s.pts), v && v.indexOf("text") !== -1) {
                var _ = s.text;
                ga.isValidTextValue(_) && m.push(_);
              }
              s.value = s.v, s.valueLabel = wr.formatPieValue(s.v, g), v && v.indexOf("value") !== -1 && m.push(s.valueLabel), s.percent = s.v / a.vTotal, s.percentLabel = wr.formatPiePercent(s.percent, g), v && v.indexOf("percent") !== -1 && m.push(s.percentLabel);
              var w = f.hoverlabel,
                T = w.font,
                b = [];
              e1.loneHover({
                trace: l,
                x0: d - h * a.r,
                x1: d + h * a.r,
                y,
                _x0: o ? n + s.TL[0] : d - h * a.r,
                _x1: o ? n + s.TR[0] : d + h * a.r,
                _y0: o ? i + s.TL[1] : y - h * a.r,
                _y1: o ? i + s.BL[1] : y + h * a.r,
                text: m.join("<br>"),
                name: f.hovertemplate || v.indexOf("name") !== -1 ? f.name : void 0,
                idealAlign: s.pxmid[0] < 0 ? "left" : "right",
                color: wr.castOption(w.bgcolor, s.pts) || s.color,
                borderColor: wr.castOption(w.bordercolor, s.pts),
                fontFamily: wr.castOption(T.family, s.pts),
                fontSize: wr.castOption(T.size, s.pts),
                fontColor: wr.castOption(T.color, s.pts),
                nameLength: wr.castOption(w.namelength, s.pts),
                textAlign: wr.castOption(w.align, s.pts),
                hovertemplate: wr.castOption(f.hovertemplate, s.pts),
                hovertemplateLabels: s,
                eventData: [r1(s, f)]
              }, {
                container: u._hoverlayer.node(),
                outerContainer: u._paper.node(),
                gd: r,
                inOut_bbox: b
              }), s.bbox = b[0], l._hasHoverLabel = !0;
            }
            l._hasHoverEvent = !0, r.emit("plotly_hover", {
              points: [r1(s, f)],
              event: an.event
            });
          }
        }), e.on("mouseout", function (s) {
          var u = r._fullLayout,
            f = r._fullData[l.index],
            v = an.select(this).datum();
          l._hasHoverEvent && (s.originalEvent = an.event, r.emit("plotly_unhover", {
            points: [r1(v, f)],
            event: an.event
          }), l._hasHoverEvent = !1), l._hasHoverLabel && (e1.loneUnhover(u._hoverlayer.node()), l._hasHoverLabel = !1);
        }), e.on("click", function (s) {
          var u = r._fullLayout,
            f = r._fullData[l.index];
          r._dragging || u.hovermode === !1 || (r._hoverdata = [r1(s, f)], e1.click(r, an.event));
        });
      }
      function dne(e, r, t) {
        var a = wr.castOption(e.outsidetextfont.color, r.pts) || wr.castOption(e.textfont.color, r.pts) || t.color,
          n = wr.castOption(e.outsidetextfont.family, r.pts) || wr.castOption(e.textfont.family, r.pts) || t.family,
          i = wr.castOption(e.outsidetextfont.size, r.pts) || wr.castOption(e.textfont.size, r.pts) || t.size,
          l = wr.castOption(e.outsidetextfont.weight, r.pts) || wr.castOption(e.textfont.weight, r.pts) || t.weight,
          o = wr.castOption(e.outsidetextfont.style, r.pts) || wr.castOption(e.textfont.style, r.pts) || t.style,
          s = wr.castOption(e.outsidetextfont.variant, r.pts) || wr.castOption(e.textfont.variant, r.pts) || t.variant,
          u = wr.castOption(e.outsidetextfont.textcase, r.pts) || wr.castOption(e.textfont.textcase, r.pts) || t.textcase,
          f = wr.castOption(e.outsidetextfont.lineposition, r.pts) || wr.castOption(e.textfont.lineposition, r.pts) || t.lineposition,
          v = wr.castOption(e.outsidetextfont.shadow, r.pts) || wr.castOption(e.textfont.shadow, r.pts) || t.shadow;
        return {
          color: a,
          family: n,
          size: i,
          weight: l,
          style: o,
          variant: s,
          textcase: u,
          lineposition: f,
          shadow: v
        };
      }
      function QR(e, r, t) {
        var a = wr.castOption(e.insidetextfont.color, r.pts);
        !a && e._input.textfont && (a = wr.castOption(e._input.textfont.color, r.pts));
        var n = wr.castOption(e.insidetextfont.family, r.pts) || wr.castOption(e.textfont.family, r.pts) || t.family,
          i = wr.castOption(e.insidetextfont.size, r.pts) || wr.castOption(e.textfont.size, r.pts) || t.size,
          l = wr.castOption(e.insidetextfont.weight, r.pts) || wr.castOption(e.textfont.weight, r.pts) || t.weight,
          o = wr.castOption(e.insidetextfont.style, r.pts) || wr.castOption(e.textfont.style, r.pts) || t.style,
          s = wr.castOption(e.insidetextfont.variant, r.pts) || wr.castOption(e.textfont.variant, r.pts) || t.variant,
          u = wr.castOption(e.insidetextfont.textcase, r.pts) || wr.castOption(e.textfont.textcase, r.pts) || t.textcase,
          f = wr.castOption(e.insidetextfont.lineposition, r.pts) || wr.castOption(e.textfont.lineposition, r.pts) || t.lineposition,
          v = wr.castOption(e.insidetextfont.shadow, r.pts) || wr.castOption(e.textfont.shadow, r.pts) || t.shadow;
        return {
          color: a || ZR.contrast(r.color),
          family: n,
          size: i,
          weight: l,
          style: o,
          variant: s,
          textcase: u,
          lineposition: f,
          shadow: v
        };
      }
      function $R(e, r) {
        for (var t, a, n = 0; n < e.length; n++) if (t = e[n][0], a = t.trace, a.title.text) {
          var i = a.title.text;
          a._meta && (i = ga.templateString(i, a._meta));
          var l = ji.tester.append("text").attr("data-notex", 1).text(i).call(ji.font, a.title.font).call(g3.convertToTspans, r),
            o = ji.bBox(l.node(), !0);
          t.titleBox = {
            width: o.width,
            height: o.height
          }, l.remove();
        }
      }
      function jR(e, r, t) {
        var a = t.r || r.rpx1,
          n = r.rInscribed,
          i = r.startangle === r.stopangle;
        if (i) return {
          rCenter: 1 - n,
          scale: 0,
          rotate: 0,
          textPosAngle: 0
        };
        var l = r.ring,
          o = l === 1 && Math.abs(r.startangle - r.stopangle) === Math.PI * 2,
          s = r.halfangle,
          u = r.midangle,
          f = t.trace.insidetextorientation,
          v = f === "horizontal",
          h = f === "tangential",
          d = f === "radial",
          y = f === "auto",
          g = [],
          m;
        if (!y) {
          var _ = function (q, D) {
              if (pne(r, q)) {
                var R = Math.abs(q - r.startangle),
                  z = Math.abs(q - r.stopangle),
                  N = R < z ? R : z;
                D === "tan" ? m = VR(e, a, l, N, 0) : m = GR(e, a, l, N, Math.PI / 2), m.textPosAngle = q, g.push(m);
              }
            },
            w;
          if (v || h) {
            for (w = 4; w >= -4; w -= 2) _(Math.PI * w, "tan");
            for (w = 4; w >= -4; w -= 2) _(Math.PI * (w + 1), "tan");
          }
          if (v || d) {
            for (w = 4; w >= -4; w -= 2) _(Math.PI * (w + 1.5), "rad");
            for (w = 4; w >= -4; w -= 2) _(Math.PI * (w + .5), "rad");
          }
        }
        if (o || y || v) {
          var T = Math.sqrt(e.width * e.width + e.height * e.height);
          if (m = {
            scale: n * a * 2 / T,
            rCenter: 1 - n,
            rotate: 0
          }, m.textPosAngle = (r.startangle + r.stopangle) / 2, m.scale >= 1) return m;
          g.push(m);
        }
        (y || d) && (m = GR(e, a, l, s, u), m.textPosAngle = (r.startangle + r.stopangle) / 2, g.push(m)), (y || h) && (m = VR(e, a, l, s, u), m.textPosAngle = (r.startangle + r.stopangle) / 2, g.push(m));
        for (var b = 0, A = 0, S = 0; S < g.length; S++) {
          var k = g[S].scale;
          if (A < k && (A = k, b = S), !y && A >= 1) break;
        }
        return g[b];
      }
      function pne(e, r) {
        var t = e.startangle,
          a = e.stopangle;
        return t > r && r > a || t < r && r < a;
      }
      function GR(e, r, t, a, n) {
        r = Math.max(0, r - 2 * JR);
        var i = e.width / e.height,
          l = tz(i, a, r, t);
        return {
          scale: l * 2 / e.height,
          rCenter: ez(i, l / r),
          rotate: rz(n)
        };
      }
      function VR(e, r, t, a, n) {
        r = Math.max(0, r - 2 * JR);
        var i = e.height / e.width,
          l = tz(i, a, r, t);
        return {
          scale: l * 2 / e.width,
          rCenter: ez(i, l / r),
          rotate: rz(n + Math.PI / 2)
        };
      }
      function ez(e, r) {
        return Math.cos(r) - e * r;
      }
      function rz(e) {
        return (180 / Math.PI * e + 720) % 180 - 90;
      }
      function tz(e, r, t, a) {
        var n = e + 1 / (2 * Math.tan(r));
        return t * Math.min(1 / (Math.sqrt(n * n + .5) + n), a / (Math.sqrt(e * e + a / 2) + e));
      }
      function mne(e, r) {
        return e.v === r.vTotal && !r.trace.hole ? 1 : Math.min(1 / (1 + 1 / Math.sin(e.halfangle)), e.ring / 2);
      }
      function WR(e, r) {
        var t = r.pxmid[0],
          a = r.pxmid[1],
          n = e.width / 2,
          i = e.height / 2;
        return t < 0 && (n *= -1), a < 0 && (i *= -1), {
          scale: 1,
          rCenter: 1,
          rotate: 0,
          x: n + Math.abs(i) * (n > 0 ? 1 : -1) / 2,
          y: i / (1 + t * t / (a * a)),
          outside: !0
        };
      }
      function yne(e) {
        var r = Math.sqrt(e.titleBox.width * e.titleBox.width + e.titleBox.height * e.titleBox.height);
        return {
          x: e.cx,
          y: e.cy,
          scale: e.trace.hole * e.r * 2 / r,
          tx: 0,
          ty: -e.titleBox.height / 2 + e.trace.title.font.size
        };
      }
      function az(e, r) {
        var t = 1,
          a = 1,
          n,
          i = e.trace,
          l = {
            x: e.cx,
            y: e.cy
          },
          o = {
            tx: 0,
            ty: 0
          };
        o.ty += i.title.font.size, n = nz(i), i.title.position.indexOf("top") !== -1 ? (l.y -= (1 + n) * e.r, o.ty -= e.titleBox.height) : i.title.position.indexOf("bottom") !== -1 && (l.y += (1 + n) * e.r);
        var s = gne(e.r, e.trace.aspectratio),
          u = r.w * (i.domain.x[1] - i.domain.x[0]) / 2;
        return i.title.position.indexOf("left") !== -1 ? (u = u + s, l.x -= (1 + n) * s, o.tx += e.titleBox.width / 2) : i.title.position.indexOf("center") !== -1 ? u *= 2 : i.title.position.indexOf("right") !== -1 && (u = u + s, l.x += (1 + n) * s, o.tx -= e.titleBox.width / 2), t = u / e.titleBox.width, a = b3(e, r) / e.titleBox.height, {
          x: l.x,
          y: l.y,
          scale: Math.min(t, a),
          tx: o.tx,
          ty: o.ty
        };
      }
      function gne(e, r) {
        return e / (r === void 0 ? 1 : r);
      }
      function b3(e, r) {
        var t = e.trace,
          a = r.h * (t.domain.y[1] - t.domain.y[0]);
        return Math.min(e.titleBox.height, a / 2);
      }
      function nz(e) {
        var r = e.pull;
        if (!r) return 0;
        var t;
        if (ga.isArrayOrTypedArray(r)) for (r = 0, t = 0; t < e.pull.length; t++) e.pull[t] > r && (r = e.pull[t]);
        return r;
      }
      function bne(e, r) {
        var t, a, n, i, l, o, s, u, f, v, h, d, y;
        function g(T, b) {
          return T.pxmid[1] - b.pxmid[1];
        }
        function m(T, b) {
          return b.pxmid[1] - T.pxmid[1];
        }
        function _(T, b) {
          b || (b = {});
          var A = b.labelExtraY + (a ? b.yLabelMax : b.yLabelMin),
            S = a ? T.yLabelMin : T.yLabelMax,
            k = a ? T.yLabelMax : T.yLabelMin,
            q = T.cyFinal + l(T.px0[1], T.px1[1]),
            D = A - S,
            R,
            z,
            N,
            H,
            O,
            J;
          if (D * s > 0 && (T.labelExtraY = D), !!ga.isArrayOrTypedArray(r.pull)) for (z = 0; z < v.length; z++) N = v[z], !(N === T || (wr.castOption(r.pull, T.pts) || 0) >= (wr.castOption(r.pull, N.pts) || 0)) && ((T.pxmid[1] - N.pxmid[1]) * s > 0 ? (H = N.cyFinal + l(N.px0[1], N.px1[1]), D = H - S - T.labelExtraY, D * s > 0 && (T.labelExtraY += D)) : (k + T.labelExtraY - q) * s > 0 && (R = 3 * o * Math.abs(z - v.indexOf(T)), O = N.cxFinal + i(N.px0[0], N.px1[0]), J = O + R - (T.cxFinal + T.pxmid[0]) - T.labelExtraX, J * o > 0 && (T.labelExtraX += J)));
        }
        for (a = 0; a < 2; a++) for (n = a ? g : m, l = a ? Math.max : Math.min, s = a ? 1 : -1, t = 0; t < 2; t++) {
          for (i = t ? Math.max : Math.min, o = t ? 1 : -1, u = e[a][t], u.sort(n), f = e[1 - a][t], v = f.concat(u), d = [], h = 0; h < u.length; h++) u[h].yLabelMid !== void 0 && d.push(u[h]);
          for (y = !1, h = 0; a && h < f.length; h++) if (f[h].yLabelMid !== void 0) {
            y = f[h];
            break;
          }
          for (h = 0; h < d.length; h++) {
            var w = h && d[h - 1];
            y && !h && (w = y), _(d[h], w);
          }
        }
      }
      function iz(e, r) {
        for (var t = [], a = 0; a < e.length; a++) {
          var n = e[a][0],
            i = n.trace,
            l = i.domain,
            o = r.w * (l.x[1] - l.x[0]),
            s = r.h * (l.y[1] - l.y[0]);
          i.title.text && i.title.position !== "middle center" && (s -= b3(n, r));
          var u = o / 2,
            f = s / 2;
          i.type === "funnelarea" && !i.scalegroup && (f /= i.aspectratio), n.r = Math.min(u, f) / (1 + nz(i)), n.cx = r.l + r.w * (i.domain.x[1] + i.domain.x[0]) / 2, n.cy = r.t + r.h * (1 - i.domain.y[0]) - s / 2, i.title.text && i.title.position.indexOf("bottom") !== -1 && (n.cy -= b3(n, r)), i.scalegroup && t.indexOf(i.scalegroup) === -1 && t.push(i.scalegroup);
        }
        xne(e, t);
      }
      function xne(e, r) {
        for (var t, a, n, i = 0; i < r.length; i++) {
          var l = 1 / 0,
            o = r[i];
          for (a = 0; a < e.length; a++) if (t = e[a][0], n = t.trace, n.scalegroup === o) {
            var s;
            if (n.type === "pie") s = t.r * t.r;else if (n.type === "funnelarea") {
              var u, f;
              n.aspectratio > 1 ? (u = t.r, f = u / n.aspectratio) : (f = t.r, u = f * n.aspectratio), u *= (1 + n.baseratio) / 2, s = u * f;
            }
            l = Math.min(l, s / t.vTotal);
          }
          for (a = 0; a < e.length; a++) if (t = e[a][0], n = t.trace, n.scalegroup === o) {
            var v = l * t.vTotal;
            n.type === "funnelarea" && (v /= (1 + n.baseratio) / 2, v /= n.aspectratio), t.r = Math.sqrt(v);
          }
        }
      }
      function _ne(e) {
        var r = e[0],
          t = r.r,
          a = r.trace,
          n = wr.getRotationAngle(a.rotation),
          i = 2 * Math.PI / r.vTotal,
          l = "px0",
          o = "px1",
          s,
          u,
          f;
        if (a.direction === "counterclockwise") {
          for (s = 0; s < e.length && e[s].hidden; s++);
          if (s === e.length) return;
          n += i * e[s].v, i *= -1, l = "px1", o = "px0";
        }
        for (f = t1(t, n), s = 0; s < e.length; s++) u = e[s], !u.hidden && (u[l] = f, u.startangle = n, n += i * u.v / 2, u.pxmid = t1(t, n), u.midangle = n, n += i * u.v / 2, f = t1(t, n), u.stopangle = n, u[o] = f, u.largeArc = u.v > r.vTotal / 2 ? 1 : 0, u.halfangle = Math.PI * Math.min(u.v / r.vTotal, .5), u.ring = 1 - a.hole, u.rInscribed = mne(u, r));
      }
      function t1(e, r) {
        return [e * Math.sin(r), -e * Math.cos(r)];
      }
      function lz(e, r, t) {
        var a = e._fullLayout,
          n = t.trace,
          i = n.texttemplate,
          l = n.textinfo;
        if (!i && l && l !== "none") {
          var o = l.split("+"),
            s = function (b) {
              return o.indexOf(b) !== -1;
            },
            u = s("label"),
            f = s("text"),
            v = s("value"),
            h = s("percent"),
            d = a.separators,
            y;
          if (y = u ? [r.label] : [], f) {
            var g = wr.getFirstFilled(n.text, r.pts);
            UR(g) && y.push(g);
          }
          v && y.push(wr.formatPieValue(r.v, d)), h && y.push(wr.formatPiePercent(r.v / t.vTotal, d)), r.text = y.join("<br>");
        }
        function m(b) {
          return {
            label: b.label,
            value: b.v,
            valueLabel: wr.formatPieValue(b.v, a.separators),
            percent: b.v / t.vTotal,
            percentLabel: wr.formatPiePercent(b.v / t.vTotal, a.separators),
            color: b.color,
            text: b.text,
            customdata: ga.castOption(n, b.i, "customdata")
          };
        }
        if (i) {
          var _ = ga.castOption(n, r.i, "texttemplate");
          if (!_) r.text = "";else {
            var w = m(r),
              T = wr.getFirstFilled(n.text, r.pts);
            (UR(T) || T === "") && (w.text = T), r.text = ga.texttemplateString(_, w, e._fullLayout._d3locale, w, n._meta || {});
          }
        }
      }
      function oz(e, r) {
        var t = e.rotate * Math.PI / 180,
          a = Math.cos(t),
          n = Math.sin(t),
          i = (r.left + r.right) / 2,
          l = (r.top + r.bottom) / 2;
        e.textX = i * a - l * n, e.textY = i * n + l * a, e.noCenter = !0;
      }
      sz.exports = {
        plot: vne,
        formatSliceLabel: lz,
        transformInsideText: jR,
        determineInsideTextFont: QR,
        positionTitleOutside: az,
        prerenderTitles: $R,
        layoutAreas: iz,
        attachFxHandlers: KR,
        computeTransform: oz
      };
    });
    var vz = Z((vve, cz) => {
      "use strict";

      var fz = Ir(),
        wne = O0(),
        Tne = xc().resizeText;
      cz.exports = function (r) {
        var t = r._fullLayout._pielayer.selectAll(".trace");
        Tne(r, t, "pie"), t.each(function (a) {
          var n = a[0],
            i = n.trace,
            l = fz.select(this);
          l.style({
            opacity: i.opacity
          }), l.selectAll("path.surface").each(function (o) {
            fz.select(this).call(wne, o, i, r);
          });
        });
      };
    });
    var dz = Z(Tu => {
      "use strict";

      var hz = Pt();
      Tu.name = "pie";
      Tu.plot = function (e, r, t, a) {
        hz.plotBasePlot(Tu.name, e, r, t, a);
      };
      Tu.clean = function (e, r, t, a) {
        hz.cleanBasePlot(Tu.name, e, r, t, a);
      };
    });
    var mz = Z((dve, pz) => {
      "use strict";

      pz.exports = {
        attributes: d3(),
        supplyDefaults: PR().supplyDefaults,
        supplyLayoutDefaults: NR(),
        layoutAttributes: p3(),
        calc: y3().calc,
        crossTraceCalc: y3().crossTraceCalc,
        plot: uz().plot,
        style: vz(),
        styleOne: O0(),
        moduleType: "trace",
        name: "pie",
        basePlotModule: dz(),
        categories: ["pie-like", "pie", "showLegend"],
        meta: {}
      };
    });
    var gz = Z((pve, yz) => {
      "use strict";

      yz.exports = mz();
    });
    var Ma = Z((mve, xz) => {
      "use strict";

      var bz = Object.getOwnPropertySymbols,
        Mne = Object.prototype.hasOwnProperty,
        Ane = Object.prototype.propertyIsEnumerable;
      function kne(e) {
        if (e == null) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }
      function Cne() {
        try {
          if (!Object.assign) return !1;
          var e = new String("abc");
          if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
          for (var r = {}, t = 0; t < 10; t++) r["_" + String.fromCharCode(t)] = t;
          var a = Object.getOwnPropertyNames(r).map(function (i) {
            return r[i];
          });
          if (a.join("") !== "0123456789") return !1;
          var n = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (i) {
            n[i] = i;
          }), Object.keys(Object.assign({}, n)).join("") === "abcdefghijklmnopqrst";
        } catch (i) {
          return !1;
        }
      }
      xz.exports = Cne() ? Object.assign : function (e, r) {
        for (var t, a = kne(e), n, i = 1; i < arguments.length; i++) {
          t = Object(arguments[i]);
          for (var l in t) Mne.call(t, l) && (a[l] = t[l]);
          if (bz) {
            n = bz(t);
            for (var o = 0; o < n.length; o++) Ane.call(t, n[o]) && (a[n[o]] = t[n[o]]);
          }
        }
        return a;
      };
    });
    var Aa = Z((yve, wz) => {
      var n1 = Ma();
      function _z() {
        this.regionalOptions = [], this.regionalOptions[""] = {
          invalidCalendar: "Calendar {0} not found",
          invalidDate: "Invalid {0} date",
          invalidMonth: "Invalid {0} month",
          invalidYear: "Invalid {0} year",
          differentCalendars: "Cannot mix {0} and {1} dates"
        }, this.local = this.regionalOptions[""], this.calendars = {}, this._localCals = {};
      }
      n1(_z.prototype, {
        instance: function (e, r) {
          e = (e || "gregorian").toLowerCase(), r = r || "";
          var t = this._localCals[e + "-" + r];
          if (!t && this.calendars[e] && (t = new this.calendars[e](r), this._localCals[e + "-" + r] = t), !t) throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, e);
          return t;
        },
        newDate: function (e, r, t, a, n) {
          return a = (e != null && e.year ? e.calendar() : typeof a == "string" ? this.instance(a, n) : a) || this.instance(), a.newDate(e, r, t);
        },
        substituteDigits: function (e) {
          return function (r) {
            return (r + "").replace(/[0-9]/g, function (t) {
              return e[t];
            });
          };
        },
        substituteChineseDigits: function (e, r) {
          return function (t) {
            for (var a = "", n = 0; t > 0;) {
              var i = t % 10;
              a = (i === 0 ? "" : e[i] + r[n]) + a, n++, t = Math.floor(t / 10);
            }
            return a.indexOf(e[1] + r[1]) === 0 && (a = a.substr(1)), a || e[0];
          };
        }
      });
      function x3(e, r, t, a) {
        if (this._calendar = e, this._year = r, this._month = t, this._day = a, this._calendar._validateLevel === 0 && !this._calendar.isValid(this._year, this._month, this._day)) throw (Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
      }
      function a1(e, r) {
        return e = "" + e, "000000".substring(0, r - e.length) + e;
      }
      n1(x3.prototype, {
        newDate: function (e, r, t) {
          return this._calendar.newDate(e == null ? this : e, r, t);
        },
        year: function (e) {
          return arguments.length === 0 ? this._year : this.set(e, "y");
        },
        month: function (e) {
          return arguments.length === 0 ? this._month : this.set(e, "m");
        },
        day: function (e) {
          return arguments.length === 0 ? this._day : this.set(e, "d");
        },
        date: function (e, r, t) {
          if (!this._calendar.isValid(e, r, t)) throw (Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
          return this._year = e, this._month = r, this._day = t, this;
        },
        leapYear: function () {
          return this._calendar.leapYear(this);
        },
        epoch: function () {
          return this._calendar.epoch(this);
        },
        formatYear: function () {
          return this._calendar.formatYear(this);
        },
        monthOfYear: function () {
          return this._calendar.monthOfYear(this);
        },
        weekOfYear: function () {
          return this._calendar.weekOfYear(this);
        },
        daysInYear: function () {
          return this._calendar.daysInYear(this);
        },
        dayOfYear: function () {
          return this._calendar.dayOfYear(this);
        },
        daysInMonth: function () {
          return this._calendar.daysInMonth(this);
        },
        dayOfWeek: function () {
          return this._calendar.dayOfWeek(this);
        },
        weekDay: function () {
          return this._calendar.weekDay(this);
        },
        extraInfo: function () {
          return this._calendar.extraInfo(this);
        },
        add: function (e, r) {
          return this._calendar.add(this, e, r);
        },
        set: function (e, r) {
          return this._calendar.set(this, e, r);
        },
        compareTo: function (e) {
          if (this._calendar.name !== e._calendar.name) throw (Pr.local.differentCalendars || Pr.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, e._calendar.local.name);
          var r = this._year !== e._year ? this._year - e._year : this._month !== e._month ? this.monthOfYear() - e.monthOfYear() : this._day - e._day;
          return r === 0 ? 0 : r < 0 ? -1 : 1;
        },
        calendar: function () {
          return this._calendar;
        },
        toJD: function () {
          return this._calendar.toJD(this);
        },
        fromJD: function (e) {
          return this._calendar.fromJD(e);
        },
        toJSDate: function () {
          return this._calendar.toJSDate(this);
        },
        fromJSDate: function (e) {
          return this._calendar.fromJSDate(e);
        },
        toString: function () {
          return (this.year() < 0 ? "-" : "") + a1(Math.abs(this.year()), 4) + "-" + a1(this.month(), 2) + "-" + a1(this.day(), 2);
        }
      });
      function _3() {
        this.shortYearCutoff = "+10";
      }
      n1(_3.prototype, {
        _validateLevel: 0,
        newDate: function (e, r, t) {
          return e == null ? this.today() : (e.year && (this._validate(e, r, t, Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate), t = e.day(), r = e.month(), e = e.year()), new x3(this, e, r, t));
        },
        today: function () {
          return this.fromJSDate(new Date());
        },
        epoch: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Pr.local.invalidYear || Pr.regionalOptions[""].invalidYear);
          return r.year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
        },
        formatYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Pr.local.invalidYear || Pr.regionalOptions[""].invalidYear);
          return (r.year() < 0 ? "-" : "") + a1(Math.abs(r.year()), 4);
        },
        monthsInYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, Pr.local.invalidYear || Pr.regionalOptions[""].invalidYear), 12;
        },
        monthOfYear: function (e, r) {
          var t = this._validate(e, r, this.minDay, Pr.local.invalidMonth || Pr.regionalOptions[""].invalidMonth);
          return (t.month() + this.monthsInYear(t) - this.firstMonth) % this.monthsInYear(t) + this.minMonth;
        },
        fromMonthOfYear: function (e, r) {
          var t = (r + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(e) + this.minMonth;
          return this._validate(e, t, this.minDay, Pr.local.invalidMonth || Pr.regionalOptions[""].invalidMonth), t;
        },
        daysInYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Pr.local.invalidYear || Pr.regionalOptions[""].invalidYear);
          return this.leapYear(r) ? 366 : 365;
        },
        dayOfYear: function (e, r, t) {
          var a = this._validate(e, r, t, Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate);
          return a.toJD() - this.newDate(a.year(), this.fromMonthOfYear(a.year(), this.minMonth), this.minDay).toJD() + 1;
        },
        daysInWeek: function () {
          return 7;
        },
        dayOfWeek: function (e, r, t) {
          var a = this._validate(e, r, t, Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate);
          return (Math.floor(this.toJD(a)) + 2) % this.daysInWeek();
        },
        extraInfo: function (e, r, t) {
          return this._validate(e, r, t, Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate), {};
        },
        add: function (e, r, t) {
          return this._validate(e, this.minMonth, this.minDay, Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate), this._correctAdd(e, this._add(e, r, t), r, t);
        },
        _add: function (e, r, t) {
          if (this._validateLevel++, t === "d" || t === "w") {
            var a = e.toJD() + r * (t === "w" ? this.daysInWeek() : 1),
              n = e.calendar().fromJD(a);
            return this._validateLevel--, [n.year(), n.month(), n.day()];
          }
          try {
            var i = e.year() + (t === "y" ? r : 0),
              l = e.monthOfYear() + (t === "m" ? r : 0),
              n = e.day(),
              o = function (f) {
                for (; l < f.minMonth;) i--, l += f.monthsInYear(i);
                for (var v = f.monthsInYear(i); l > v - 1 + f.minMonth;) i++, l -= v, v = f.monthsInYear(i);
              };
            t === "y" ? (e.month() !== this.fromMonthOfYear(i, l) && (l = this.newDate(i, e.month(), this.minDay).monthOfYear()), l = Math.min(l, this.monthsInYear(i)), n = Math.min(n, this.daysInMonth(i, this.fromMonthOfYear(i, l)))) : t === "m" && (o(this), n = Math.min(n, this.daysInMonth(i, this.fromMonthOfYear(i, l))));
            var s = [i, this.fromMonthOfYear(i, l), n];
            return this._validateLevel--, s;
          } catch (u) {
            throw this._validateLevel--, u;
          }
        },
        _correctAdd: function (e, r, t, a) {
          if (!this.hasYearZero && (a === "y" || a === "m") && (r[0] === 0 || e.year() > 0 != r[0] > 0)) {
            var n = {
                y: [1, 1, "y"],
                m: [1, this.monthsInYear(-1), "m"],
                w: [this.daysInWeek(), this.daysInYear(-1), "d"],
                d: [1, this.daysInYear(-1), "d"]
              }[a],
              i = t < 0 ? -1 : 1;
            r = this._add(e, t * n[0] + i * n[1], n[2]);
          }
          return e.date(r[0], r[1], r[2]);
        },
        set: function (e, r, t) {
          this._validate(e, this.minMonth, this.minDay, Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate);
          var a = t === "y" ? r : e.year(),
            n = t === "m" ? r : e.month(),
            i = t === "d" ? r : e.day();
          return (t === "y" || t === "m") && (i = Math.min(i, this.daysInMonth(a, n))), e.date(a, n, i);
        },
        isValid: function (e, r, t) {
          this._validateLevel++;
          var a = this.hasYearZero || e !== 0;
          if (a) {
            var n = this.newDate(e, r, this.minDay);
            a = r >= this.minMonth && r - this.minMonth < this.monthsInYear(n) && t >= this.minDay && t - this.minDay < this.daysInMonth(n);
          }
          return this._validateLevel--, a;
        },
        toJSDate: function (e, r, t) {
          var a = this._validate(e, r, t, Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate);
          return Pr.instance().fromJD(this.toJD(a)).toJSDate();
        },
        fromJSDate: function (e) {
          return this.fromJD(Pr.instance().fromJSDate(e).toJD());
        },
        _validate: function (e, r, t, a) {
          if (e.year) {
            if (this._validateLevel === 0 && this.name !== e.calendar().name) throw (Pr.local.differentCalendars || Pr.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, e.calendar().local.name);
            return e;
          }
          try {
            if (this._validateLevel++, this._validateLevel === 1 && !this.isValid(e, r, t)) throw a.replace(/\{0\}/, this.local.name);
            var n = this.newDate(e, r, t);
            return this._validateLevel--, n;
          } catch (i) {
            throw this._validateLevel--, i;
          }
        }
      });
      function w3(e) {
        this.local = this.regionalOptions[e] || this.regionalOptions[""];
      }
      w3.prototype = new _3();
      n1(w3.prototype, {
        name: "Gregorian",
        jdEpoch: 17214255e-1,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Gregorian",
            epochs: ["BCE", "CE"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "mm/dd/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function (t) {
          var r = this._validate(t, this.minMonth, this.minDay, Pr.local.invalidYear || Pr.regionalOptions[""].invalidYear),
            t = r.year() + (r.year() < 0 ? 1 : 0);
          return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(4 - (a.dayOfWeek() || 7), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, Pr.local.invalidMonth || Pr.regionalOptions[""].invalidMonth);
          return this.daysPerMonth[t.month() - 1] + (t.month() === 2 && this.leapYear(t.year()) ? 1 : 0);
        },
        weekDay: function (e, r, t) {
          return (this.dayOfWeek(e, r, t) || 7) < 6;
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate);
          e = a.year(), r = a.month(), t = a.day(), e < 0 && e++, r < 3 && (r += 12, e--);
          var n = Math.floor(e / 100),
            i = 2 - n + Math.floor(n / 4);
          return Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (r + 1)) + t + i - 1524.5;
        },
        fromJD: function (e) {
          var r = Math.floor(e + .5),
            t = Math.floor((r - 186721625e-2) / 36524.25);
          t = r + 1 + t - Math.floor(t / 4);
          var a = t + 1524,
            n = Math.floor((a - 122.1) / 365.25),
            i = Math.floor(365.25 * n),
            l = Math.floor((a - i) / 30.6001),
            o = a - i - Math.floor(l * 30.6001),
            s = l - (l > 13.5 ? 13 : 1),
            u = n - (s > 2.5 ? 4716 : 4715);
          return u <= 0 && u--, this.newDate(u, s, o);
        },
        toJSDate: function (e, r, t) {
          var a = this._validate(e, r, t, Pr.local.invalidDate || Pr.regionalOptions[""].invalidDate),
            n = new Date(a.year(), a.month() - 1, a.day());
          return n.setHours(0), n.setMinutes(0), n.setSeconds(0), n.setMilliseconds(0), n.setHours(n.getHours() > 12 ? n.getHours() + 2 : 0), n;
        },
        fromJSDate: function (e) {
          return this.newDate(e.getFullYear(), e.getMonth() + 1, e.getDate());
        }
      });
      var Pr = wz.exports = new _z();
      Pr.cdate = x3;
      Pr.baseCalendar = _3;
      Pr.calendars.gregorian = w3;
    });
    var Tz = Z(() => {
      var T3 = Ma(),
        oa = Aa();
      T3(oa.regionalOptions[""], {
        invalidArguments: "Invalid arguments",
        invalidFormat: "Cannot format a date from another calendar",
        missingNumberAt: "Missing number at position {0}",
        unknownNameAt: "Unknown name at position {0}",
        unexpectedLiteralAt: "Unexpected literal at position {0}",
        unexpectedText: "Additional text found at end"
      });
      oa.local = oa.regionalOptions[""];
      T3(oa.cdate.prototype, {
        formatDate: function (e, r) {
          return typeof e != "string" && (r = e, e = ""), this._calendar.formatDate(e || "", this, r);
        }
      });
      T3(oa.baseCalendar.prototype, {
        UNIX_EPOCH: oa.instance().newDate(1970, 1, 1).toJD(),
        SECS_PER_DAY: 24 * 60 * 60,
        TICKS_EPOCH: oa.instance().jdEpoch,
        TICKS_PER_DAY: 24 * 60 * 60 * 1e7,
        ATOM: "yyyy-mm-dd",
        COOKIE: "D, dd M yyyy",
        FULL: "DD, MM d, yyyy",
        ISO_8601: "yyyy-mm-dd",
        JULIAN: "J",
        RFC_822: "D, d M yy",
        RFC_850: "DD, dd-M-yy",
        RFC_1036: "D, d M yy",
        RFC_1123: "D, d M yyyy",
        RFC_2822: "D, d M yyyy",
        RSS: "D, d M yy",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yyyy-mm-dd",
        formatDate: function (e, r, t) {
          if (typeof e != "string" && (t = r, r = e, e = ""), !r) return "";
          if (r.calendar() !== this) throw oa.local.invalidFormat || oa.regionalOptions[""].invalidFormat;
          e = e || this.local.dateFormat, t = t || {};
          for (var a = t.dayNamesShort || this.local.dayNamesShort, n = t.dayNames || this.local.dayNames, i = t.monthNumbers || this.local.monthNumbers, l = t.monthNamesShort || this.local.monthNamesShort, o = t.monthNames || this.local.monthNames, s = t.calculateWeek || this.local.calculateWeek, u = function (b, A) {
              for (var S = 1; T + S < e.length && e.charAt(T + S) === b;) S++;
              return T += S - 1, Math.floor(S / (A || 1)) > 1;
            }, f = function (b, A, S, k) {
              var q = "" + A;
              if (u(b, k)) for (; q.length < S;) q = "0" + q;
              return q;
            }, v = function (b, A, S, k) {
              return u(b) ? k[A] : S[A];
            }, h = this, d = function (b) {
              return typeof i == "function" ? i.call(h, b, u("m")) : m(f("m", b.month(), 2));
            }, y = function (b, A) {
              return A ? typeof o == "function" ? o.call(h, b) : o[b.month() - h.minMonth] : typeof l == "function" ? l.call(h, b) : l[b.month() - h.minMonth];
            }, g = this.local.digits, m = function (b) {
              return t.localNumbers && g ? g(b) : b;
            }, _ = "", w = !1, T = 0; T < e.length; T++) if (w) e.charAt(T) === "'" && !u("'") ? w = !1 : _ += e.charAt(T);else switch (e.charAt(T)) {
            case "d":
              _ += m(f("d", r.day(), 2));
              break;
            case "D":
              _ += v("D", r.dayOfWeek(), a, n);
              break;
            case "o":
              _ += f("o", r.dayOfYear(), 3);
              break;
            case "w":
              _ += f("w", r.weekOfYear(), 2);
              break;
            case "m":
              _ += d(r);
              break;
            case "M":
              _ += y(r, u("M"));
              break;
            case "y":
              _ += u("y", 2) ? r.year() : (r.year() % 100 < 10 ? "0" : "") + r.year() % 100;
              break;
            case "Y":
              u("Y", 2), _ += r.formatYear();
              break;
            case "J":
              _ += r.toJD();
              break;
            case "@":
              _ += (r.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
              break;
            case "!":
              _ += (r.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
              break;
            case "'":
              u("'") ? _ += "'" : w = !0;
              break;
            default:
              _ += e.charAt(T);
          }
          return _;
        },
        parseDate: function (e, r, t) {
          if (r == null) throw oa.local.invalidArguments || oa.regionalOptions[""].invalidArguments;
          if (r = typeof r == "object" ? r.toString() : r + "", r === "") return null;
          e = e || this.local.dateFormat, t = t || {};
          var a = t.shortYearCutoff || this.shortYearCutoff;
          a = typeof a != "string" ? a : this.today().year() % 100 + parseInt(a, 10);
          for (var n = t.dayNamesShort || this.local.dayNamesShort, i = t.dayNames || this.local.dayNames, l = t.parseMonth || this.local.parseMonth, o = t.monthNumbers || this.local.monthNumbers, s = t.monthNamesShort || this.local.monthNamesShort, u = t.monthNames || this.local.monthNames, f = -1, v = -1, h = -1, d = -1, y = -1, g = !1, m = !1, _ = function (N, H) {
              for (var O = 1; D + O < e.length && e.charAt(D + O) === N;) O++;
              return D += O - 1, Math.floor(O / (H || 1)) > 1;
            }, w = function (N, H) {
              var O = _(N, H),
                J = [2, 3, O ? 4 : 2, O ? 4 : 2, 10, 11, 20]["oyYJ@!".indexOf(N) + 1],
                X = new RegExp("^-?\\d{1," + J + "}"),
                B = r.substring(q).match(X);
              if (!B) throw (oa.local.missingNumberAt || oa.regionalOptions[""].missingNumberAt).replace(/\{0\}/, q);
              return q += B[0].length, parseInt(B[0], 10);
            }, T = this, b = function () {
              if (typeof o == "function") {
                _("m");
                var N = o.call(T, r.substring(q));
                return q += N.length, N;
              }
              return w("m");
            }, A = function (N, H, O, J) {
              for (var X = _(N, J) ? O : H, B = 0; B < X.length; B++) if (r.substr(q, X[B].length).toLowerCase() === X[B].toLowerCase()) return q += X[B].length, B + T.minMonth;
              throw (oa.local.unknownNameAt || oa.regionalOptions[""].unknownNameAt).replace(/\{0\}/, q);
            }, S = function () {
              if (typeof u == "function") {
                var N = _("M") ? u.call(T, r.substring(q)) : s.call(T, r.substring(q));
                return q += N.length, N;
              }
              return A("M", s, u);
            }, k = function () {
              if (r.charAt(q) !== e.charAt(D)) throw (oa.local.unexpectedLiteralAt || oa.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, q);
              q++;
            }, q = 0, D = 0; D < e.length; D++) if (m) e.charAt(D) === "'" && !_("'") ? m = !1 : k();else switch (e.charAt(D)) {
            case "d":
              d = w("d");
              break;
            case "D":
              A("D", n, i);
              break;
            case "o":
              y = w("o");
              break;
            case "w":
              w("w");
              break;
            case "m":
              h = b();
              break;
            case "M":
              h = S();
              break;
            case "y":
              var R = D;
              g = !_("y", 2), D = R, v = w("y", 2);
              break;
            case "Y":
              v = w("Y", 2);
              break;
            case "J":
              f = w("J") + .5, r.charAt(q) === "." && (q++, w("J"));
              break;
            case "@":
              f = w("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
              break;
            case "!":
              f = w("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
              break;
            case "*":
              q = r.length;
              break;
            case "'":
              _("'") ? k() : m = !0;
              break;
            default:
              k();
          }
          if (q < r.length) throw oa.local.unexpectedText || oa.regionalOptions[""].unexpectedText;
          if (v === -1 ? v = this.today().year() : v < 100 && g && (v += a === -1 ? 1900 : this.today().year() - this.today().year() % 100 - (v <= a ? 0 : 100)), typeof h == "string" && (h = l.call(this, v, h)), y > -1) {
            h = 1, d = y;
            for (var z = this.daysInMonth(v, h); d > z; z = this.daysInMonth(v, h)) h++, d -= z;
          }
          return f > -1 ? this.fromJD(f) : this.newDate(v, h, d);
        },
        determineDate: function (e, r, t, a, n) {
          t && typeof t != "object" && (n = a, a = t, t = null), typeof a != "string" && (n = a, a = "");
          var i = this,
            l = function (o) {
              try {
                return i.parseDate(a, o, n);
              } catch (v) {}
              o = o.toLowerCase();
              for (var s = (o.match(/^c/) && t ? t.newDate() : null) || i.today(), u = /([+-]?[0-9]+)\s*(d|w|m|y)?/g, f = u.exec(o); f;) s.add(parseInt(f[1], 10), f[2] || "d"), f = u.exec(o);
              return s;
            };
          return r = r ? r.newDate() : null, e = e == null ? r : typeof e == "string" ? l(e) : typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? r : i.today().add(e, "d") : i.newDate(e), e;
        }
      });
    });
    var Mz = Z(() => {
      var Il = Aa(),
        Sne = Ma(),
        M3 = Il.instance();
      function i1(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      i1.prototype = new Il.baseCalendar();
      Sne(i1.prototype, {
        name: "Chinese",
        jdEpoch: 17214255e-1,
        hasYearZero: !1,
        minMonth: 0,
        firstMonth: 0,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Chinese",
            epochs: ["BEC", "EC"],
            monthNumbers: function (e, r) {
              if (typeof e == "string") {
                var t = e.match(qne);
                return t ? t[0] : "";
              }
              var a = this._validateYear(e),
                n = e.month(),
                i = "" + this.toChineseMonth(a, n);
              return r && i.length < 2 && (i = "0" + i), this.isIntercalaryMonth(a, n) && (i += "i"), i;
            },
            monthNames: function (e) {
              if (typeof e == "string") {
                var r = e.match(Dne);
                return r ? r[0] : "";
              }
              var t = this._validateYear(e),
                a = e.month(),
                n = this.toChineseMonth(t, a),
                i = ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"][n - 1];
              return this.isIntercalaryMonth(t, a) && (i = "\u95F0" + i), i;
            },
            monthNamesShort: function (e) {
              if (typeof e == "string") {
                var r = e.match(Ene);
                return r ? r[0] : "";
              }
              var t = this._validateYear(e),
                a = e.month(),
                n = this.toChineseMonth(t, a),
                i = ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"][n - 1];
              return this.isIntercalaryMonth(t, a) && (i = "\u95F0" + i), i;
            },
            parseMonth: function (e, r) {
              e = this._validateYear(e);
              var t = parseInt(r),
                a;
              if (isNaN(t)) r[0] === "\u95F0" && (a = !0, r = r.substring(1)), r[r.length - 1] === "\u6708" && (r = r.substring(0, r.length - 1)), t = 1 + ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"].indexOf(r);else {
                var n = r[r.length - 1];
                a = n === "i" || n === "I";
              }
              var i = this.toMonthIndex(e, t, a);
              return i;
            },
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 1,
            isRTL: !1
          }
        },
        _validateYear: function (e, r) {
          if (e.year && (e = e.year()), typeof e != "number" || e < 1888 || e > 2111) throw r.replace(/\{0\}/, this.local.name);
          return e;
        },
        toMonthIndex: function (e, r, t) {
          var a = this.intercalaryMonth(e),
            n = t && r !== a;
          if (n || r < 1 || r > 12) throw Il.local.invalidMonth.replace(/\{0\}/, this.local.name);
          var i;
          return a ? !t && r <= a ? i = r - 1 : i = r : i = r - 1, i;
        },
        toChineseMonth: function (e, r) {
          e.year && (e = e.year(), r = e.month());
          var t = this.intercalaryMonth(e),
            a = t ? 12 : 11;
          if (r < 0 || r > a) throw Il.local.invalidMonth.replace(/\{0\}/, this.local.name);
          var n;
          return t ? r < t ? n = r + 1 : n = r : n = r + 1, n;
        },
        intercalaryMonth: function (e) {
          e = this._validateYear(e);
          var r = Hl[e - Hl[0]],
            t = r >> 13;
          return t;
        },
        isIntercalaryMonth: function (e, r) {
          e.year && (e = e.year(), r = e.month());
          var t = this.intercalaryMonth(e);
          return !!t && t === r;
        },
        leapYear: function (e) {
          return this.intercalaryMonth(e) !== 0;
        },
        weekOfYear: function (e, r, t) {
          var a = this._validateYear(e, Il.local.invalidyear),
            n = Ol[a - Ol[0]],
            i = n >> 9 & 4095,
            l = n >> 5 & 15,
            o = n & 31,
            s;
          s = M3.newDate(i, l, o), s.add(4 - (s.dayOfWeek() || 7), "d");
          var u = this.toJD(e, r, t) - s.toJD();
          return 1 + Math.floor(u / 7);
        },
        monthsInYear: function (e) {
          return this.leapYear(e) ? 13 : 12;
        },
        daysInMonth: function (e, r) {
          e.year && (r = e.month(), e = e.year()), e = this._validateYear(e);
          var t = Hl[e - Hl[0]],
            a = t >> 13,
            n = a ? 12 : 11;
          if (r > n) throw Il.local.invalidMonth.replace(/\{0\}/, this.local.name);
          var i = t & 1 << 12 - r ? 30 : 29;
          return i;
        },
        weekDay: function (e, r, t) {
          return (this.dayOfWeek(e, r, t) || 7) < 6;
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, i, t, Il.local.invalidDate);
          e = this._validateYear(a.year()), r = a.month(), t = a.day();
          var n = this.isIntercalaryMonth(e, r),
            i = this.toChineseMonth(e, r),
            l = Rne(e, i, t, n);
          return M3.toJD(l.year, l.month, l.day);
        },
        fromJD: function (e) {
          var r = M3.fromJD(e),
            t = Pne(r.year(), r.month(), r.day()),
            a = this.toMonthIndex(t.year, t.month, t.isIntercalary);
          return this.newDate(t.year, a, t.day);
        },
        fromString: function (e) {
          var r = e.match(Lne),
            t = this._validateYear(+r[1]),
            a = +r[2],
            n = !!r[3],
            i = this.toMonthIndex(t, a, n),
            l = +r[4];
          return this.newDate(t, i, l);
        },
        add: function (e, r, t) {
          var a = e.year(),
            n = e.month(),
            i = this.isIntercalaryMonth(a, n),
            l = this.toChineseMonth(a, n),
            o = Object.getPrototypeOf(i1.prototype).add.call(this, e, r, t);
          if (t === "y") {
            var s = o.year(),
              u = o.month(),
              f = this.isIntercalaryMonth(s, l),
              v = i && f ? this.toMonthIndex(s, l, !0) : this.toMonthIndex(s, l, !1);
            v !== u && o.month(v);
          }
          return o;
        }
      });
      var Lne = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m,
        qne = /^\d?\d[iI]?/m,
        Dne = /^闰?十?[一二三四五六七八九]?月/m,
        Ene = /^闰?十?[一二三四五六七八九]?/m;
      Il.calendars.chinese = i1;
      var Hl = [1887, 5780, 5802, 19157, 2742, 50359, 1198, 2646, 46378, 7466, 3412, 30122, 5482, 67949, 2396, 5294, 43597, 6732, 6954, 36181, 2772, 4954, 18781, 2396, 54427, 5274, 6730, 47781, 5800, 6868, 21210, 4790, 59703, 2350, 5270, 46667, 3402, 3496, 38325, 1388, 4782, 18735, 2350, 52374, 6804, 7498, 44457, 2906, 1388, 29294, 4700, 63789, 6442, 6804, 56138, 5802, 2772, 38235, 1210, 4698, 22827, 5418, 63125, 3476, 5802, 43701, 2484, 5302, 27223, 2646, 70954, 7466, 3412, 54698, 5482, 2412, 38062, 5294, 2636, 32038, 6954, 60245, 2772, 4826, 43357, 2394, 5274, 39501, 6730, 72357, 5800, 5844, 53978, 4790, 2358, 38039, 5270, 87627, 3402, 3496, 54708, 5484, 4782, 43311, 2350, 3222, 27978, 7498, 68965, 2904, 5484, 45677, 4700, 6444, 39573, 6804, 6986, 19285, 2772, 62811, 1210, 4698, 47403, 5418, 5780, 38570, 5546, 76469, 2420, 5302, 51799, 2646, 5414, 36501, 3412, 5546, 18869, 2412, 54446, 5276, 6732, 48422, 6822, 2900, 28010, 4826, 92509, 2394, 5274, 55883, 6730, 6820, 47956, 5812, 2778, 18779, 2358, 62615, 5270, 5450, 46757, 3492, 5556, 27318, 4718, 67887, 2350, 3222, 52554, 7498, 3428, 38252, 5468, 4700, 31022, 6444, 64149, 6804, 6986, 43861, 2772, 5338, 35421, 2650, 70955, 5418, 5780, 54954, 5546, 2740, 38074, 5302, 2646, 29991, 3366, 61011, 3412, 5546, 43445, 2412, 5294, 35406, 6732, 72998, 6820, 6996, 52586, 2778, 2396, 38045, 5274, 6698, 23333, 6820, 64338, 5812, 2746, 43355, 2358, 5270, 39499, 5450, 79525, 3492, 5548],
        Ol = [1887, 966732, 967231, 967733, 968265, 968766, 969297, 969798, 970298, 970829, 971330, 971830, 972362, 972863, 973395, 973896, 974397, 974928, 975428, 975929, 976461, 976962, 977462, 977994, 978494, 979026, 979526, 980026, 980558, 981059, 981559, 982091, 982593, 983124, 983624, 984124, 984656, 985157, 985656, 986189, 986690, 987191, 987722, 988222, 988753, 989254, 989754, 990286, 990788, 991288, 991819, 992319, 992851, 993352, 993851, 994383, 994885, 995385, 995917, 996418, 996918, 997450, 997949, 998481, 998982, 999483, 1000014, 1000515, 1001016, 1001548, 1002047, 1002578, 1003080, 1003580, 1004111, 1004613, 1005113, 1005645, 1006146, 1006645, 1007177, 1007678, 1008209, 1008710, 1009211, 1009743, 1010243, 1010743, 1011275, 1011775, 1012306, 1012807, 1013308, 1013840, 1014341, 1014841, 1015373, 1015874, 1016404, 1016905, 1017405, 1017937, 1018438, 1018939, 1019471, 1019972, 1020471, 1021002, 1021503, 1022035, 1022535, 1023036, 1023568, 1024069, 1024568, 1025100, 1025601, 1026102, 1026633, 1027133, 1027666, 1028167, 1028666, 1029198, 1029699, 1030199, 1030730, 1031231, 1031763, 1032264, 1032764, 1033296, 1033797, 1034297, 1034828, 1035329, 1035830, 1036362, 1036861, 1037393, 1037894, 1038394, 1038925, 1039427, 1039927, 1040459, 1040959, 1041491, 1041992, 1042492, 1043023, 1043524, 1044024, 1044556, 1045057, 1045558, 1046090, 1046590, 1047121, 1047622, 1048122, 1048654, 1049154, 1049655, 1050187, 1050689, 1051219, 1051720, 1052220, 1052751, 1053252, 1053752, 1054284, 1054786, 1055285, 1055817, 1056317, 1056849, 1057349, 1057850, 1058382, 1058883, 1059383, 1059915, 1060415, 1060947, 1061447, 1061947, 1062479, 1062981, 1063480, 1064012, 1064514, 1065014, 1065545, 1066045, 1066577, 1067078, 1067578, 1068110, 1068611, 1069112, 1069642, 1070142, 1070674, 1071175, 1071675, 1072207, 1072709, 1073209, 1073740, 1074241, 1074741, 1075273, 1075773, 1076305, 1076807, 1077308, 1077839, 1078340, 1078840, 1079372, 1079871, 1080403, 1080904];
      function Pne(e, r, t, a) {
        var n, i;
        if (typeof e == "object") n = e, i = r || {};else {
          var l = typeof e == "number" && e >= 1888 && e <= 2111;
          if (!l) throw new Error("Solar year outside range 1888-2111");
          var o = typeof r == "number" && r >= 1 && r <= 12;
          if (!o) throw new Error("Solar month outside range 1 - 12");
          var s = typeof t == "number" && t >= 1 && t <= 31;
          if (!s) throw new Error("Solar day outside range 1 - 31");
          n = {
            year: e,
            month: r,
            day: t
          }, i = a || {};
        }
        var u = Ol[n.year - Ol[0]],
          f = n.year << 9 | n.month << 5 | n.day;
        i.year = f >= u ? n.year : n.year - 1, u = Ol[i.year - Ol[0]];
        var v = u >> 9 & 4095,
          h = u >> 5 & 15,
          d = u & 31,
          y,
          g = new Date(v, h - 1, d),
          m = new Date(n.year, n.month - 1, n.day);
        y = Math.round((m - g) / (24 * 3600 * 1e3));
        var _ = Hl[i.year - Hl[0]],
          w;
        for (w = 0; w < 13; w++) {
          var T = _ & 1 << 12 - w ? 30 : 29;
          if (y < T) break;
          y -= T;
        }
        var b = _ >> 13;
        return !b || w < b ? (i.isIntercalary = !1, i.month = 1 + w) : w === b ? (i.isIntercalary = !0, i.month = w) : (i.isIntercalary = !1, i.month = w), i.day = 1 + y, i;
      }
      function Rne(e, r, t, a, n) {
        var i, l;
        if (typeof e == "object") l = e, i = r || {};else {
          var o = typeof e == "number" && e >= 1888 && e <= 2111;
          if (!o) throw new Error("Lunar year outside range 1888-2111");
          var s = typeof r == "number" && r >= 1 && r <= 12;
          if (!s) throw new Error("Lunar month outside range 1 - 12");
          var u = typeof t == "number" && t >= 1 && t <= 30;
          if (!u) throw new Error("Lunar day outside range 1 - 30");
          var f;
          typeof a == "object" ? (f = !1, i = a) : (f = !!a, i = n || {}), l = {
            year: e,
            month: r,
            day: t,
            isIntercalary: f
          };
        }
        var v;
        v = l.day - 1;
        var h = Hl[l.year - Hl[0]],
          d = h >> 13,
          y;
        d && (l.month > d || l.isIntercalary) ? y = l.month : y = l.month - 1;
        for (var g = 0; g < y; g++) {
          var m = h & 1 << 12 - g ? 30 : 29;
          v += m;
        }
        var _ = Ol[l.year - Ol[0]],
          w = _ >> 9 & 4095,
          T = _ >> 5 & 15,
          b = _ & 31,
          A = new Date(w, T - 1, b + v);
        return i.year = A.getFullYear(), i.month = 1 + A.getMonth(), i.day = A.getDate(), i;
      }
    });
    var Az = Z(() => {
      var Vo = Aa(),
        zne = Ma();
      function A3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      A3.prototype = new Vo.baseCalendar();
      zne(A3.prototype, {
        name: "Coptic",
        jdEpoch: 18250295e-1,
        daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Coptic",
            epochs: ["BAM", "AM"],
            monthNames: ["Thout", "Paopi", "Hathor", "Koiak", "Tobi", "Meshir", "Paremhat", "Paremoude", "Pashons", "Paoni", "Epip", "Mesori", "Pi Kogi Enavot"],
            monthNamesShort: ["Tho", "Pao", "Hath", "Koi", "Tob", "Mesh", "Pat", "Pad", "Pash", "Pao", "Epi", "Meso", "PiK"],
            dayNames: ["Tkyriaka", "Pesnau", "Pshoment", "Peftoou", "Ptiou", "Psoou", "Psabbaton"],
            dayNamesShort: ["Tky", "Pes", "Psh", "Pef", "Pti", "Pso", "Psa"],
            dayNamesMin: ["Tk", "Pes", "Psh", "Pef", "Pt", "Pso", "Psa"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function (t) {
          var r = this._validate(t, this.minMonth, this.minDay, Vo.local.invalidYear),
            t = r.year() + (r.year() < 0 ? 1 : 0);
          return t % 4 === 3 || t % 4 === -1;
        },
        monthsInYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, Vo.local.invalidYear || Vo.regionalOptions[""].invalidYear), 13;
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(-a.dayOfWeek(), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, Vo.local.invalidMonth);
          return this.daysPerMonth[t.month() - 1] + (t.month() === 13 && this.leapYear(t.year()) ? 1 : 0);
        },
        weekDay: function (e, r, t) {
          return (this.dayOfWeek(e, r, t) || 7) < 6;
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, Vo.local.invalidDate);
          return e = a.year(), e < 0 && e++, a.day() + (a.month() - 1) * 30 + (e - 1) * 365 + Math.floor(e / 4) + this.jdEpoch - 1;
        },
        fromJD: function (e) {
          var r = Math.floor(e) + .5 - this.jdEpoch,
            t = Math.floor((r - Math.floor((r + 366) / 1461)) / 365) + 1;
          t <= 0 && t--, r = Math.floor(e) + .5 - this.newDate(t, 1, 1).toJD();
          var a = Math.floor(r / 30) + 1,
            n = r - (a - 1) * 30 + 1;
          return this.newDate(t, a, n);
        }
      });
      Vo.calendars.coptic = A3;
    });
    var kz = Z(() => {
      var el = Aa(),
        Nne = Ma();
      function k3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      k3.prototype = new el.baseCalendar();
      Nne(k3.prototype, {
        name: "Discworld",
        jdEpoch: 17214255e-1,
        daysPerMonth: [16, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Discworld",
            epochs: ["BUC", "UC"],
            monthNames: ["Ick", "Offle", "February", "March", "April", "May", "June", "Grune", "August", "Spune", "Sektober", "Ember", "December"],
            monthNamesShort: ["Ick", "Off", "Feb", "Mar", "Apr", "May", "Jun", "Gru", "Aug", "Spu", "Sek", "Emb", "Dec"],
            dayNames: ["Sunday", "Octeday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Oct", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Oc", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 2,
            isRTL: !1
          }
        },
        leapYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, el.local.invalidYear), !1;
        },
        monthsInYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, el.local.invalidYear), 13;
        },
        daysInYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, el.local.invalidYear), 400;
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(-a.dayOfWeek(), "d"), Math.floor((a.dayOfYear() - 1) / 8) + 1;
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, el.local.invalidMonth);
          return this.daysPerMonth[t.month() - 1];
        },
        daysInWeek: function () {
          return 8;
        },
        dayOfWeek: function (e, r, t) {
          var a = this._validate(e, r, t, el.local.invalidDate);
          return (a.day() + 1) % 8;
        },
        weekDay: function (e, r, t) {
          var a = this.dayOfWeek(e, r, t);
          return a >= 2 && a <= 6;
        },
        extraInfo: function (e, r, t) {
          var a = this._validate(e, r, t, el.local.invalidDate);
          return {
            century: Fne[Math.floor((a.year() - 1) / 100) + 1] || ""
          };
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, el.local.invalidDate);
          return e = a.year() + (a.year() < 0 ? 1 : 0), r = a.month(), t = a.day(), t + (r > 1 ? 16 : 0) + (r > 2 ? (r - 2) * 32 : 0) + (e - 1) * 400 + this.jdEpoch - 1;
        },
        fromJD: function (e) {
          e = Math.floor(e + .5) - Math.floor(this.jdEpoch) - 1;
          var r = Math.floor(e / 400) + 1;
          e -= (r - 1) * 400, e += e > 15 ? 16 : 0;
          var t = Math.floor(e / 32) + 1,
            a = e - (t - 1) * 32 + 1;
          return this.newDate(r <= 0 ? r - 1 : r, t, a);
        }
      });
      var Fne = {
        20: "Fruitbat",
        21: "Anchovy"
      };
      el.calendars.discworld = k3;
    });
    var Cz = Z(() => {
      var Wo = Aa(),
        Ine = Ma();
      function C3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      C3.prototype = new Wo.baseCalendar();
      Ine(C3.prototype, {
        name: "Ethiopian",
        jdEpoch: 17242205e-1,
        daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Ethiopian",
            epochs: ["BEE", "EE"],
            monthNames: ["Meskerem", "Tikemet", "Hidar", "Tahesas", "Tir", "Yekatit", "Megabit", "Miazia", "Genbot", "Sene", "Hamle", "Nehase", "Pagume"],
            monthNamesShort: ["Mes", "Tik", "Hid", "Tah", "Tir", "Yek", "Meg", "Mia", "Gen", "Sen", "Ham", "Neh", "Pag"],
            dayNames: ["Ehud", "Segno", "Maksegno", "Irob", "Hamus", "Arb", "Kidame"],
            dayNamesShort: ["Ehu", "Seg", "Mak", "Iro", "Ham", "Arb", "Kid"],
            dayNamesMin: ["Eh", "Se", "Ma", "Ir", "Ha", "Ar", "Ki"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function (t) {
          var r = this._validate(t, this.minMonth, this.minDay, Wo.local.invalidYear),
            t = r.year() + (r.year() < 0 ? 1 : 0);
          return t % 4 === 3 || t % 4 === -1;
        },
        monthsInYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, Wo.local.invalidYear || Wo.regionalOptions[""].invalidYear), 13;
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(-a.dayOfWeek(), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, Wo.local.invalidMonth);
          return this.daysPerMonth[t.month() - 1] + (t.month() === 13 && this.leapYear(t.year()) ? 1 : 0);
        },
        weekDay: function (e, r, t) {
          return (this.dayOfWeek(e, r, t) || 7) < 6;
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, Wo.local.invalidDate);
          return e = a.year(), e < 0 && e++, a.day() + (a.month() - 1) * 30 + (e - 1) * 365 + Math.floor(e / 4) + this.jdEpoch - 1;
        },
        fromJD: function (e) {
          var r = Math.floor(e) + .5 - this.jdEpoch,
            t = Math.floor((r - Math.floor((r + 366) / 1461)) / 365) + 1;
          t <= 0 && t--, r = Math.floor(e) + .5 - this.newDate(t, 1, 1).toJD();
          var a = Math.floor(r / 30) + 1,
            n = r - (a - 1) * 30 + 1;
          return this.newDate(t, a, n);
        }
      });
      Wo.calendars.ethiopian = C3;
    });
    var Sz = Z(() => {
      var Bl = Aa(),
        Hne = Ma();
      function S3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      S3.prototype = new Bl.baseCalendar();
      Hne(S3.prototype, {
        name: "Hebrew",
        jdEpoch: 347995.5,
        daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 29],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 7,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Hebrew",
            epochs: ["BAM", "AM"],
            monthNames: ["Nisan", "Iyar", "Sivan", "Tammuz", "Av", "Elul", "Tishrei", "Cheshvan", "Kislev", "Tevet", "Shevat", "Adar", "Adar II"],
            monthNamesShort: ["Nis", "Iya", "Siv", "Tam", "Av", "Elu", "Tis", "Che", "Kis", "Tev", "She", "Ada", "Ad2"],
            dayNames: ["Yom Rishon", "Yom Sheni", "Yom Shlishi", "Yom Revi'i", "Yom Chamishi", "Yom Shishi", "Yom Shabbat"],
            dayNamesShort: ["Ris", "She", "Shl", "Rev", "Cha", "Shi", "Sha"],
            dayNamesMin: ["Ri", "She", "Shl", "Re", "Ch", "Shi", "Sha"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Bl.local.invalidYear);
          return this._leapYear(r.year());
        },
        _leapYear: function (e) {
          return e = e < 0 ? e + 1 : e, l1(e * 7 + 1, 19) < 7;
        },
        monthsInYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, Bl.local.invalidYear), this._leapYear(e.year ? e.year() : e) ? 13 : 12;
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(-a.dayOfWeek(), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Bl.local.invalidYear);
          return e = r.year(), this.toJD(e === -1 ? 1 : e + 1, 7, 1) - this.toJD(e, 7, 1);
        },
        daysInMonth: function (e, r) {
          return e.year && (r = e.month(), e = e.year()), this._validate(e, r, this.minDay, Bl.local.invalidMonth), r === 12 && this.leapYear(e) || r === 8 && l1(this.daysInYear(e), 10) === 5 ? 30 : r === 9 && l1(this.daysInYear(e), 10) === 3 ? 29 : this.daysPerMonth[r - 1];
        },
        weekDay: function (e, r, t) {
          return this.dayOfWeek(e, r, t) !== 6;
        },
        extraInfo: function (e, r, t) {
          var a = this._validate(e, r, t, Bl.local.invalidDate);
          return {
            yearType: (this.leapYear(a) ? "embolismic" : "common") + " " + ["deficient", "regular", "complete"][this.daysInYear(a) % 10 - 3]
          };
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, Bl.local.invalidDate);
          e = a.year(), r = a.month(), t = a.day();
          var n = e <= 0 ? e + 1 : e,
            i = this.jdEpoch + this._delay1(n) + this._delay2(n) + t + 1;
          if (r < 7) {
            for (var l = 7; l <= this.monthsInYear(e); l++) i += this.daysInMonth(e, l);
            for (var l = 1; l < r; l++) i += this.daysInMonth(e, l);
          } else for (var l = 7; l < r; l++) i += this.daysInMonth(e, l);
          return i;
        },
        _delay1: function (e) {
          var r = Math.floor((235 * e - 234) / 19),
            t = 12084 + 13753 * r,
            a = r * 29 + Math.floor(t / 25920);
          return l1(3 * (a + 1), 7) < 3 && a++, a;
        },
        _delay2: function (e) {
          var r = this._delay1(e - 1),
            t = this._delay1(e),
            a = this._delay1(e + 1);
          return a - t === 356 ? 2 : t - r === 382 ? 1 : 0;
        },
        fromJD: function (e) {
          e = Math.floor(e) + .5;
          for (var r = Math.floor((e - this.jdEpoch) * 98496 / 35975351) - 1; e >= this.toJD(r === -1 ? 1 : r + 1, 7, 1);) r++;
          for (var t = e < this.toJD(r, 1, 1) ? 7 : 1; e > this.toJD(r, t, this.daysInMonth(r, t));) t++;
          var a = e - this.toJD(r, t, 1) + 1;
          return this.newDate(r, t, a);
        }
      });
      function l1(e, r) {
        return e - r * Math.floor(e / r);
      }
      Bl.calendars.hebrew = S3;
    });
    var Lz = Z(() => {
      var kc = Aa(),
        One = Ma();
      function L3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      L3.prototype = new kc.baseCalendar();
      One(L3.prototype, {
        name: "Islamic",
        jdEpoch: 19484395e-1,
        daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Islamic",
            epochs: ["BH", "AH"],
            monthNames: ["Muharram", "Safar", "Rabi' al-awwal", "Rabi' al-thani", "Jumada al-awwal", "Jumada al-thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"],
            monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
            dayNames: ["Yawm al-ahad", "Yawm al-ithnayn", "Yawm ath-thulaathaa'", "Yawm al-arbi'aa'", "Yawm al-kham\u012Bs", "Yawm al-jum'a", "Yawm as-sabt"],
            dayNamesShort: ["Aha", "Ith", "Thu", "Arb", "Kha", "Jum", "Sab"],
            dayNamesMin: ["Ah", "It", "Th", "Ar", "Kh", "Ju", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 6,
            isRTL: !1
          }
        },
        leapYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, kc.local.invalidYear);
          return (r.year() * 11 + 14) % 30 < 11;
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(-a.dayOfWeek(), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function (e) {
          return this.leapYear(e) ? 355 : 354;
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, kc.local.invalidMonth);
          return this.daysPerMonth[t.month() - 1] + (t.month() === 12 && this.leapYear(t.year()) ? 1 : 0);
        },
        weekDay: function (e, r, t) {
          return this.dayOfWeek(e, r, t) !== 5;
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, kc.local.invalidDate);
          return e = a.year(), r = a.month(), t = a.day(), e = e <= 0 ? e + 1 : e, t + Math.ceil(29.5 * (r - 1)) + (e - 1) * 354 + Math.floor((3 + 11 * e) / 30) + this.jdEpoch - 1;
        },
        fromJD: function (e) {
          e = Math.floor(e) + .5;
          var r = Math.floor((30 * (e - this.jdEpoch) + 10646) / 10631);
          r = r <= 0 ? r - 1 : r;
          var t = Math.min(12, Math.ceil((e - 29 - this.toJD(r, 1, 1)) / 29.5) + 1),
            a = e - this.toJD(r, t, 1) + 1;
          return this.newDate(r, t, a);
        }
      });
      kc.calendars.islamic = L3;
    });
    var qz = Z(() => {
      var Cc = Aa(),
        Bne = Ma();
      function q3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      q3.prototype = new Cc.baseCalendar();
      Bne(q3.prototype, {
        name: "Julian",
        jdEpoch: 17214235e-1,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Julian",
            epochs: ["BC", "AD"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "mm/dd/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function (t) {
          var r = this._validate(t, this.minMonth, this.minDay, Cc.local.invalidYear),
            t = r.year() < 0 ? r.year() + 1 : r.year();
          return t % 4 === 0;
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(4 - (a.dayOfWeek() || 7), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, Cc.local.invalidMonth);
          return this.daysPerMonth[t.month() - 1] + (t.month() === 2 && this.leapYear(t.year()) ? 1 : 0);
        },
        weekDay: function (e, r, t) {
          return (this.dayOfWeek(e, r, t) || 7) < 6;
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, Cc.local.invalidDate);
          return e = a.year(), r = a.month(), t = a.day(), e < 0 && e++, r <= 2 && (e--, r += 12), Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (r + 1)) + t - 1524.5;
        },
        fromJD: function (e) {
          var r = Math.floor(e + .5),
            t = r + 1524,
            a = Math.floor((t - 122.1) / 365.25),
            n = Math.floor(365.25 * a),
            i = Math.floor((t - n) / 30.6001),
            l = i - Math.floor(i < 14 ? 1 : 13),
            o = a - Math.floor(l > 2 ? 4716 : 4715),
            s = t - n - Math.floor(30.6001 * i);
          return o <= 0 && o--, this.newDate(o, l, s);
        }
      });
      Cc.calendars.julian = q3;
    });
    var Ez = Z(() => {
      var Fn = Aa(),
        Yne = Ma();
      function E3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      E3.prototype = new Fn.baseCalendar();
      Yne(E3.prototype, {
        name: "Mayan",
        jdEpoch: 584282.5,
        hasYearZero: !0,
        minMonth: 0,
        firstMonth: 0,
        minDay: 0,
        regionalOptions: {
          "": {
            name: "Mayan",
            epochs: ["", ""],
            monthNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
            monthNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
            dayNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
            dayNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
            dayNamesMin: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
            digits: null,
            dateFormat: "YYYY.m.d",
            firstDay: 0,
            isRTL: !1,
            haabMonths: ["Pop", "Uo", "Zip", "Zotz", "Tzec", "Xul", "Yaxkin", "Mol", "Chen", "Yax", "Zac", "Ceh", "Mac", "Kankin", "Muan", "Pax", "Kayab", "Cumku", "Uayeb"],
            tzolkinMonths: ["Imix", "Ik", "Akbal", "Kan", "Chicchan", "Cimi", "Manik", "Lamat", "Muluc", "Oc", "Chuen", "Eb", "Ben", "Ix", "Men", "Cib", "Caban", "Etznab", "Cauac", "Ahau"]
          }
        },
        leapYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, Fn.local.invalidYear), !1;
        },
        formatYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Fn.local.invalidYear);
          e = r.year();
          var t = Math.floor(e / 400);
          e = e % 400, e += e < 0 ? 400 : 0;
          var a = Math.floor(e / 20);
          return t + "." + a + "." + e % 20;
        },
        forYear: function (e) {
          if (e = e.split("."), e.length < 3) throw "Invalid Mayan year";
          for (var r = 0, t = 0; t < e.length; t++) {
            var a = parseInt(e[t], 10);
            if (Math.abs(a) > 19 || t > 0 && a < 0) throw "Invalid Mayan year";
            r = r * 20 + a;
          }
          return r;
        },
        monthsInYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, Fn.local.invalidYear), 18;
        },
        weekOfYear: function (e, r, t) {
          return this._validate(e, r, t, Fn.local.invalidDate), 0;
        },
        daysInYear: function (e) {
          return this._validate(e, this.minMonth, this.minDay, Fn.local.invalidYear), 360;
        },
        daysInMonth: function (e, r) {
          return this._validate(e, r, this.minDay, Fn.local.invalidMonth), 20;
        },
        daysInWeek: function () {
          return 5;
        },
        dayOfWeek: function (e, r, t) {
          var a = this._validate(e, r, t, Fn.local.invalidDate);
          return a.day();
        },
        weekDay: function (e, r, t) {
          return this._validate(e, r, t, Fn.local.invalidDate), !0;
        },
        extraInfo: function (e, r, t) {
          var a = this._validate(e, r, t, Fn.local.invalidDate),
            n = a.toJD(),
            i = this._toHaab(n),
            l = this._toTzolkin(n);
          return {
            haabMonthName: this.local.haabMonths[i[0] - 1],
            haabMonth: i[0],
            haabDay: i[1],
            tzolkinDayName: this.local.tzolkinMonths[l[0] - 1],
            tzolkinDay: l[0],
            tzolkinTrecena: l[1]
          };
        },
        _toHaab: function (e) {
          e -= this.jdEpoch;
          var r = D3(e + 8 + 17 * 20, 365);
          return [Math.floor(r / 20) + 1, D3(r, 20)];
        },
        _toTzolkin: function (e) {
          return e -= this.jdEpoch, [Dz(e + 20, 20), Dz(e + 4, 13)];
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, Fn.local.invalidDate);
          return a.day() + a.month() * 20 + a.year() * 360 + this.jdEpoch;
        },
        fromJD: function (e) {
          e = Math.floor(e) + .5 - this.jdEpoch;
          var r = Math.floor(e / 360);
          e = e % 360, e += e < 0 ? 360 : 0;
          var t = Math.floor(e / 20),
            a = e % 20;
          return this.newDate(r, t, a);
        }
      });
      function D3(e, r) {
        return e - r * Math.floor(e / r);
      }
      function Dz(e, r) {
        return D3(e - 1, r) + 1;
      }
      Fn.calendars.mayan = E3;
    });
    var Rz = Z(() => {
      var Zo = Aa(),
        Une = Ma();
      function P3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      P3.prototype = new Zo.baseCalendar();
      var Pz = Zo.instance("gregorian");
      Une(P3.prototype, {
        name: "Nanakshahi",
        jdEpoch: 22576735e-1,
        daysPerMonth: [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Nanakshahi",
            epochs: ["BN", "AN"],
            monthNames: ["Chet", "Vaisakh", "Jeth", "Harh", "Sawan", "Bhadon", "Assu", "Katak", "Maghar", "Poh", "Magh", "Phagun"],
            monthNamesShort: ["Che", "Vai", "Jet", "Har", "Saw", "Bha", "Ass", "Kat", "Mgr", "Poh", "Mgh", "Pha"],
            dayNames: ["Somvaar", "Mangalvar", "Budhvaar", "Veervaar", "Shukarvaar", "Sanicharvaar", "Etvaar"],
            dayNamesShort: ["Som", "Mangal", "Budh", "Veer", "Shukar", "Sanichar", "Et"],
            dayNamesMin: ["So", "Ma", "Bu", "Ve", "Sh", "Sa", "Et"],
            digits: null,
            dateFormat: "dd-mm-yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Zo.local.invalidYear || Zo.regionalOptions[""].invalidYear);
          return Pz.leapYear(r.year() + (r.year() < 1 ? 1 : 0) + 1469);
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(1 - (a.dayOfWeek() || 7), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, Zo.local.invalidMonth);
          return this.daysPerMonth[t.month() - 1] + (t.month() === 12 && this.leapYear(t.year()) ? 1 : 0);
        },
        weekDay: function (e, r, t) {
          return (this.dayOfWeek(e, r, t) || 7) < 6;
        },
        toJD: function (n, r, t) {
          var a = this._validate(n, r, t, Zo.local.invalidMonth),
            n = a.year();
          n < 0 && n++;
          for (var i = a.day(), l = 1; l < a.month(); l++) i += this.daysPerMonth[l - 1];
          return i + Pz.toJD(n + 1468, 3, 13);
        },
        fromJD: function (e) {
          e = Math.floor(e + .5);
          for (var r = Math.floor((e - (this.jdEpoch - 1)) / 366); e >= this.toJD(r + 1, 1, 1);) r++;
          for (var t = e - Math.floor(this.toJD(r, 1, 1) + .5) + 1, a = 1; t > this.daysInMonth(r, a);) t -= this.daysInMonth(r, a), a++;
          return this.newDate(r, a, t);
        }
      });
      Zo.calendars.nanakshahi = P3;
    });
    var zz = Z(() => {
      var Xo = Aa(),
        Gne = Ma();
      function R3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      R3.prototype = new Xo.baseCalendar();
      Gne(R3.prototype, {
        name: "Nepali",
        jdEpoch: 17007095e-1,
        daysPerMonth: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        daysPerYear: 365,
        regionalOptions: {
          "": {
            name: "Nepali",
            epochs: ["BBS", "ABS"],
            monthNames: ["Baisakh", "Jestha", "Ashadh", "Shrawan", "Bhadra", "Ashwin", "Kartik", "Mangsir", "Paush", "Mangh", "Falgun", "Chaitra"],
            monthNamesShort: ["Bai", "Je", "As", "Shra", "Bha", "Ash", "Kar", "Mang", "Pau", "Ma", "Fal", "Chai"],
            dayNames: ["Aaitabaar", "Sombaar", "Manglbaar", "Budhabaar", "Bihibaar", "Shukrabaar", "Shanibaar"],
            dayNamesShort: ["Aaita", "Som", "Mangl", "Budha", "Bihi", "Shukra", "Shani"],
            dayNamesMin: ["Aai", "So", "Man", "Bu", "Bi", "Shu", "Sha"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 1,
            isRTL: !1
          }
        },
        leapYear: function (e) {
          return this.daysInYear(e) !== this.daysPerYear;
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(-a.dayOfWeek(), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Xo.local.invalidYear);
          if (e = r.year(), typeof this.NEPALI_CALENDAR_DATA[e] == "undefined") return this.daysPerYear;
          for (var t = 0, a = this.minMonth; a <= 12; a++) t += this.NEPALI_CALENDAR_DATA[e][a];
          return t;
        },
        daysInMonth: function (e, r) {
          return e.year && (r = e.month(), e = e.year()), this._validate(e, r, this.minDay, Xo.local.invalidMonth), typeof this.NEPALI_CALENDAR_DATA[e] == "undefined" ? this.daysPerMonth[r - 1] : this.NEPALI_CALENDAR_DATA[e][r];
        },
        weekDay: function (e, r, t) {
          return this.dayOfWeek(e, r, t) !== 6;
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, Xo.local.invalidDate);
          e = a.year(), r = a.month(), t = a.day();
          var n = Xo.instance(),
            i = 0,
            l = r,
            o = e;
          this._createMissingCalendarData(e);
          var s = e - (l > 9 || l === 9 && t >= this.NEPALI_CALENDAR_DATA[o][0] ? 56 : 57);
          for (r !== 9 && (i = t, l--); l !== 9;) l <= 0 && (l = 12, o--), i += this.NEPALI_CALENDAR_DATA[o][l], l--;
          return r === 9 ? (i += t - this.NEPALI_CALENDAR_DATA[o][0], i < 0 && (i += n.daysInYear(s))) : i += this.NEPALI_CALENDAR_DATA[o][9] - this.NEPALI_CALENDAR_DATA[o][0], n.newDate(s, 1, 1).add(i, "d").toJD();
        },
        fromJD: function (e) {
          var r = Xo.instance(),
            t = r.fromJD(e),
            a = t.year(),
            n = t.dayOfYear(),
            i = a + 56;
          this._createMissingCalendarData(i);
          for (var l = 9, o = this.NEPALI_CALENDAR_DATA[i][0], s = this.NEPALI_CALENDAR_DATA[i][l] - o + 1; n > s;) l++, l > 12 && (l = 1, i++), s += this.NEPALI_CALENDAR_DATA[i][l];
          var u = this.NEPALI_CALENDAR_DATA[i][l] - (s - n);
          return this.newDate(i, l, u);
        },
        _createMissingCalendarData: function (e) {
          var r = this.daysPerMonth.slice(0);
          r.unshift(17);
          for (var t = e - 1; t < e + 2; t++) typeof this.NEPALI_CALENDAR_DATA[t] == "undefined" && (this.NEPALI_CALENDAR_DATA[t] = r);
        },
        NEPALI_CALENDAR_DATA: {
          1970: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1971: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          1972: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          1973: [19, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1974: [19, 31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30],
          1975: [18, 31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30],
          1976: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1977: [18, 31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
          1978: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1979: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1980: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1981: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          1982: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1983: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1984: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1985: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          1986: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1987: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1988: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1989: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          1990: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1991: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1992: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1993: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          1994: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1995: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          1996: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1997: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1998: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1999: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2e3: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2001: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2002: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2003: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2004: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2005: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2006: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2007: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2008: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2009: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2010: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2011: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2012: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2013: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2014: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2015: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2016: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2017: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2018: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2019: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2020: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2021: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2022: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2023: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2024: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2025: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2026: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2027: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2028: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2029: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          2030: [17, 31, 32, 31, 32, 31, 30, 30, 30, 30, 30, 30, 31],
          2031: [17, 31, 32, 31, 32, 31, 31, 31, 31, 31, 31, 31, 31],
          2032: [17, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
          2033: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2034: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2035: [17, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2036: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2037: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2038: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2039: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2040: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2041: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2042: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2043: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2044: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2045: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2046: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2047: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2048: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2049: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2050: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2051: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2052: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2053: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2054: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2055: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 29, 30],
          2056: [17, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          2057: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2058: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2059: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2060: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2061: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2062: [17, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
          2063: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2064: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2065: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2066: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2067: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2068: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2069: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2070: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2071: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2072: [17, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2073: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2074: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2075: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2076: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2077: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2078: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2079: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2080: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2081: [17, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2082: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2083: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2084: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2085: [17, 31, 32, 31, 32, 31, 31, 30, 30, 29, 30, 30, 30],
          2086: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2087: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
          2088: [16, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
          2089: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2090: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2091: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
          2092: [16, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2093: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2094: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2095: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30],
          2096: [17, 30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2097: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2098: [17, 31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 30, 31],
          2099: [17, 31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30],
          2100: [17, 31, 32, 31, 32, 30, 31, 30, 29, 30, 29, 30, 30]
        }
      });
      Xo.calendars.nepali = R3;
    });
    var Nz = Z(() => {
      var Mu = Aa(),
        Vne = Ma();
      function o1(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      o1.prototype = new Mu.baseCalendar();
      Vne(o1.prototype, {
        name: "Persian",
        jdEpoch: 19483205e-1,
        daysPerMonth: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Persian",
            epochs: ["BP", "AP"],
            monthNames: ["Farvardin", "Ordibehesht", "Khordad", "Tir", "Mordad", "Shahrivar", "Mehr", "Aban", "Azar", "Day", "Bahman", "Esfand"],
            monthNamesShort: ["Far", "Ord", "Kho", "Tir", "Mor", "Sha", "Meh", "Aba", "Aza", "Day", "Bah", "Esf"],
            dayNames: ["Yekshambe", "Doshambe", "Seshambe", "Ch\xE6harshambe", "Panjshambe", "Jom'e", "Shambe"],
            dayNamesShort: ["Yek", "Do", "Se", "Ch\xE6", "Panj", "Jom", "Sha"],
            dayNamesMin: ["Ye", "Do", "Se", "Ch", "Pa", "Jo", "Sh"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 6,
            isRTL: !1
          }
        },
        leapYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Mu.local.invalidYear);
          return ((r.year() - (r.year() > 0 ? 474 : 473)) % 2820 + 474 + 38) * 682 % 2816 < 682;
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(-((a.dayOfWeek() + 1) % 7), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, Mu.local.invalidMonth);
          return this.daysPerMonth[t.month() - 1] + (t.month() === 12 && this.leapYear(t.year()) ? 1 : 0);
        },
        weekDay: function (e, r, t) {
          return this.dayOfWeek(e, r, t) !== 5;
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, Mu.local.invalidDate);
          e = a.year(), r = a.month(), t = a.day();
          var n = e - (e >= 0 ? 474 : 473),
            i = 474 + z3(n, 2820);
          return t + (r <= 7 ? (r - 1) * 31 : (r - 1) * 30 + 6) + Math.floor((i * 682 - 110) / 2816) + (i - 1) * 365 + Math.floor(n / 2820) * 1029983 + this.jdEpoch - 1;
        },
        fromJD: function (e) {
          e = Math.floor(e) + .5;
          var r = e - this.toJD(475, 1, 1),
            t = Math.floor(r / 1029983),
            a = z3(r, 1029983),
            n = 2820;
          if (a !== 1029982) {
            var i = Math.floor(a / 366),
              l = z3(a, 366);
            n = Math.floor((2134 * i + 2816 * l + 2815) / 1028522) + i + 1;
          }
          var o = n + 2820 * t + 474;
          o = o <= 0 ? o - 1 : o;
          var s = e - this.toJD(o, 1, 1) + 1,
            u = s <= 186 ? Math.ceil(s / 31) : Math.ceil((s - 6) / 30),
            f = e - this.toJD(o, u, 1) + 1;
          return this.newDate(o, u, f);
        }
      });
      function z3(e, r) {
        return e - r * Math.floor(e / r);
      }
      Mu.calendars.persian = o1;
      Mu.calendars.jalali = o1;
    });
    var Fz = Z(() => {
      var Jo = Aa(),
        Wne = Ma(),
        s1 = Jo.instance();
      function N3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      N3.prototype = new Jo.baseCalendar();
      Wne(N3.prototype, {
        name: "Taiwan",
        jdEpoch: 24194025e-1,
        yearsOffset: 1911,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Taiwan",
            epochs: ["BROC", "ROC"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 1,
            isRTL: !1
          }
        },
        leapYear: function (t) {
          var r = this._validate(t, this.minMonth, this.minDay, Jo.local.invalidYear),
            t = this._t2gYear(r.year());
          return s1.leapYear(t);
        },
        weekOfYear: function (n, r, t) {
          var a = this._validate(n, this.minMonth, this.minDay, Jo.local.invalidYear),
            n = this._t2gYear(a.year());
          return s1.weekOfYear(n, a.month(), a.day());
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, Jo.local.invalidMonth);
          return this.daysPerMonth[t.month() - 1] + (t.month() === 2 && this.leapYear(t.year()) ? 1 : 0);
        },
        weekDay: function (e, r, t) {
          return (this.dayOfWeek(e, r, t) || 7) < 6;
        },
        toJD: function (n, r, t) {
          var a = this._validate(n, r, t, Jo.local.invalidDate),
            n = this._t2gYear(a.year());
          return s1.toJD(n, a.month(), a.day());
        },
        fromJD: function (e) {
          var r = s1.fromJD(e),
            t = this._g2tYear(r.year());
          return this.newDate(t, r.month(), r.day());
        },
        _t2gYear: function (e) {
          return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
        },
        _g2tYear: function (e) {
          return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
        }
      });
      Jo.calendars.taiwan = N3;
    });
    var Iz = Z(() => {
      var Ko = Aa(),
        Zne = Ma(),
        u1 = Ko.instance();
      function F3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      F3.prototype = new Ko.baseCalendar();
      Zne(F3.prototype, {
        name: "Thai",
        jdEpoch: 15230985e-1,
        yearsOffset: 543,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Thai",
            epochs: ["BBE", "BE"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function (t) {
          var r = this._validate(t, this.minMonth, this.minDay, Ko.local.invalidYear),
            t = this._t2gYear(r.year());
          return u1.leapYear(t);
        },
        weekOfYear: function (n, r, t) {
          var a = this._validate(n, this.minMonth, this.minDay, Ko.local.invalidYear),
            n = this._t2gYear(a.year());
          return u1.weekOfYear(n, a.month(), a.day());
        },
        daysInMonth: function (e, r) {
          var t = this._validate(e, r, this.minDay, Ko.local.invalidMonth);
          return this.daysPerMonth[t.month() - 1] + (t.month() === 2 && this.leapYear(t.year()) ? 1 : 0);
        },
        weekDay: function (e, r, t) {
          return (this.dayOfWeek(e, r, t) || 7) < 6;
        },
        toJD: function (n, r, t) {
          var a = this._validate(n, r, t, Ko.local.invalidDate),
            n = this._t2gYear(a.year());
          return u1.toJD(n, a.month(), a.day());
        },
        fromJD: function (e) {
          var r = u1.fromJD(e),
            t = this._g2tYear(r.year());
          return this.newDate(t, r.month(), r.day());
        },
        _t2gYear: function (e) {
          return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
        },
        _g2tYear: function (e) {
          return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
        }
      });
      Ko.calendars.thai = F3;
    });
    var Hz = Z(() => {
      var Qo = Aa(),
        Xne = Ma();
      function I3(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      I3.prototype = new Qo.baseCalendar();
      Xne(I3.prototype, {
        name: "UmmAlQura",
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Umm al-Qura",
            epochs: ["BH", "AH"],
            monthNames: ["Al-Muharram", "Safar", "Rabi' al-awwal", "Rabi' Al-Thani", "Jumada Al-Awwal", "Jumada Al-Thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"],
            monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
            dayNames: ["Yawm al-Ahad", "Yawm al-Ithnain", "Yawm al-Thal\u0101th\u0101\u2019", "Yawm al-Arba\u2018\u0101\u2019", "Yawm al-Kham\u012Bs", "Yawm al-Jum\u2018a", "Yawm al-Sabt"],
            dayNamesMin: ["Ah", "Ith", "Th", "Ar", "Kh", "Ju", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 6,
            isRTL: !0
          }
        },
        leapYear: function (e) {
          var r = this._validate(e, this.minMonth, this.minDay, Qo.local.invalidYear);
          return this.daysInYear(r.year()) === 355;
        },
        weekOfYear: function (e, r, t) {
          var a = this.newDate(e, r, t);
          return a.add(-a.dayOfWeek(), "d"), Math.floor((a.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function (e) {
          for (var r = 0, t = 1; t <= 12; t++) r += this.daysInMonth(e, t);
          return r;
        },
        daysInMonth: function (e, r) {
          for (var t = this._validate(e, r, this.minDay, Qo.local.invalidMonth), a = t.toJD() - 24e5 + .5, n = 0, i = 0; i < Yl.length; i++) {
            if (Yl[i] > a) return Yl[n] - Yl[n - 1];
            n++;
          }
          return 30;
        },
        weekDay: function (e, r, t) {
          return this.dayOfWeek(e, r, t) !== 5;
        },
        toJD: function (e, r, t) {
          var a = this._validate(e, r, t, Qo.local.invalidDate),
            n = 12 * (a.year() - 1) + a.month() - 15292,
            i = a.day() + Yl[n - 1] - 1;
          return i + 24e5 - .5;
        },
        fromJD: function (e) {
          for (var r = e - 24e5 + .5, t = 0, a = 0; a < Yl.length && !(Yl[a] > r); a++) t++;
          var n = t + 15292,
            i = Math.floor((n - 1) / 12),
            l = i + 1,
            o = n - 12 * i,
            s = r - Yl[t - 1] + 1;
          return this.newDate(l, o, s);
        },
        isValid: function (e, r, t) {
          var a = Qo.baseCalendar.prototype.isValid.apply(this, arguments);
          return a && (e = e.year != null ? e.year : e, a = e >= 1276 && e <= 1500), a;
        },
        _validate: function (e, r, t, a) {
          var n = Qo.baseCalendar.prototype._validate.apply(this, arguments);
          if (n.year < 1276 || n.year > 1500) throw a.replace(/\{0\}/, this.local.name);
          return n;
        }
      });
      Qo.calendars.ummalqura = I3;
      var Yl = [20, 50, 79, 109, 138, 168, 197, 227, 256, 286, 315, 345, 374, 404, 433, 463, 492, 522, 551, 581, 611, 641, 670, 700, 729, 759, 788, 818, 847, 877, 906, 936, 965, 995, 1024, 1054, 1083, 1113, 1142, 1172, 1201, 1231, 1260, 1290, 1320, 1350, 1379, 1409, 1438, 1468, 1497, 1527, 1556, 1586, 1615, 1645, 1674, 1704, 1733, 1763, 1792, 1822, 1851, 1881, 1910, 1940, 1969, 1999, 2028, 2058, 2087, 2117, 2146, 2176, 2205, 2235, 2264, 2294, 2323, 2353, 2383, 2413, 2442, 2472, 2501, 2531, 2560, 2590, 2619, 2649, 2678, 2708, 2737, 2767, 2796, 2826, 2855, 2885, 2914, 2944, 2973, 3003, 3032, 3062, 3091, 3121, 3150, 3180, 3209, 3239, 3268, 3298, 3327, 3357, 3386, 3416, 3446, 3476, 3505, 3535, 3564, 3594, 3623, 3653, 3682, 3712, 3741, 3771, 3800, 3830, 3859, 3889, 3918, 3948, 3977, 4007, 4036, 4066, 4095, 4125, 4155, 4185, 4214, 4244, 4273, 4303, 4332, 4362, 4391, 4421, 4450, 4480, 4509, 4539, 4568, 4598, 4627, 4657, 4686, 4716, 4745, 4775, 4804, 4834, 4863, 4893, 4922, 4952, 4981, 5011, 5040, 5070, 5099, 5129, 5158, 5188, 5218, 5248, 5277, 5307, 5336, 5366, 5395, 5425, 5454, 5484, 5513, 5543, 5572, 5602, 5631, 5661, 5690, 5720, 5749, 5779, 5808, 5838, 5867, 5897, 5926, 5956, 5985, 6015, 6044, 6074, 6103, 6133, 6162, 6192, 6221, 6251, 6281, 6311, 6340, 6370, 6399, 6429, 6458, 6488, 6517, 6547, 6576, 6606, 6635, 6665, 6694, 6724, 6753, 6783, 6812, 6842, 6871, 6901, 6930, 6960, 6989, 7019, 7048, 7078, 7107, 7137, 7166, 7196, 7225, 7255, 7284, 7314, 7344, 7374, 7403, 7433, 7462, 7492, 7521, 7551, 7580, 7610, 7639, 7669, 7698, 7728, 7757, 7787, 7816, 7846, 7875, 7905, 7934, 7964, 7993, 8023, 8053, 8083, 8112, 8142, 8171, 8201, 8230, 8260, 8289, 8319, 8348, 8378, 8407, 8437, 8466, 8496, 8525, 8555, 8584, 8614, 8643, 8673, 8702, 8732, 8761, 8791, 8821, 8850, 8880, 8909, 8938, 8968, 8997, 9027, 9056, 9086, 9115, 9145, 9175, 9205, 9234, 9264, 9293, 9322, 9352, 9381, 9410, 9440, 9470, 9499, 9529, 9559, 9589, 9618, 9648, 9677, 9706, 9736, 9765, 9794, 9824, 9853, 9883, 9913, 9943, 9972, 10002, 10032, 10061, 10090, 10120, 10149, 10178, 10208, 10237, 10267, 10297, 10326, 10356, 10386, 10415, 10445, 10474, 10504, 10533, 10562, 10592, 10621, 10651, 10680, 10710, 10740, 10770, 10799, 10829, 10858, 10888, 10917, 10947, 10976, 11005, 11035, 11064, 11094, 11124, 11153, 11183, 11213, 11242, 11272, 11301, 11331, 11360, 11389, 11419, 11448, 11478, 11507, 11537, 11567, 11596, 11626, 11655, 11685, 11715, 11744, 11774, 11803, 11832, 11862, 11891, 11921, 11950, 11980, 12010, 12039, 12069, 12099, 12128, 12158, 12187, 12216, 12246, 12275, 12304, 12334, 12364, 12393, 12423, 12453, 12483, 12512, 12542, 12571, 12600, 12630, 12659, 12688, 12718, 12747, 12777, 12807, 12837, 12866, 12896, 12926, 12955, 12984, 13014, 13043, 13072, 13102, 13131, 13161, 13191, 13220, 13250, 13280, 13310, 13339, 13368, 13398, 13427, 13456, 13486, 13515, 13545, 13574, 13604, 13634, 13664, 13693, 13723, 13752, 13782, 13811, 13840, 13870, 13899, 13929, 13958, 13988, 14018, 14047, 14077, 14107, 14136, 14166, 14195, 14224, 14254, 14283, 14313, 14342, 14372, 14401, 14431, 14461, 14490, 14520, 14550, 14579, 14609, 14638, 14667, 14697, 14726, 14756, 14785, 14815, 14844, 14874, 14904, 14933, 14963, 14993, 15021, 15051, 15081, 15110, 15140, 15169, 15199, 15228, 15258, 15287, 15317, 15347, 15377, 15406, 15436, 15465, 15494, 15524, 15553, 15582, 15612, 15641, 15671, 15701, 15731, 15760, 15790, 15820, 15849, 15878, 15908, 15937, 15966, 15996, 16025, 16055, 16085, 16114, 16144, 16174, 16204, 16233, 16262, 16292, 16321, 16350, 16380, 16409, 16439, 16468, 16498, 16528, 16558, 16587, 16617, 16646, 16676, 16705, 16734, 16764, 16793, 16823, 16852, 16882, 16912, 16941, 16971, 17001, 17030, 17060, 17089, 17118, 17148, 17177, 17207, 17236, 17266, 17295, 17325, 17355, 17384, 17414, 17444, 17473, 17502, 17532, 17561, 17591, 17620, 17650, 17679, 17709, 17738, 17768, 17798, 17827, 17857, 17886, 17916, 17945, 17975, 18004, 18034, 18063, 18093, 18122, 18152, 18181, 18211, 18241, 18270, 18300, 18330, 18359, 18388, 18418, 18447, 18476, 18506, 18535, 18565, 18595, 18625, 18654, 18684, 18714, 18743, 18772, 18802, 18831, 18860, 18890, 18919, 18949, 18979, 19008, 19038, 19068, 19098, 19127, 19156, 19186, 19215, 19244, 19274, 19303, 19333, 19362, 19392, 19422, 19452, 19481, 19511, 19540, 19570, 19599, 19628, 19658, 19687, 19717, 19746, 19776, 19806, 19836, 19865, 19895, 19924, 19954, 19983, 20012, 20042, 20071, 20101, 20130, 20160, 20190, 20219, 20249, 20279, 20308, 20338, 20367, 20396, 20426, 20455, 20485, 20514, 20544, 20573, 20603, 20633, 20662, 20692, 20721, 20751, 20780, 20810, 20839, 20869, 20898, 20928, 20957, 20987, 21016, 21046, 21076, 21105, 21135, 21164, 21194, 21223, 21253, 21282, 21312, 21341, 21371, 21400, 21430, 21459, 21489, 21519, 21548, 21578, 21607, 21637, 21666, 21696, 21725, 21754, 21784, 21813, 21843, 21873, 21902, 21932, 21962, 21991, 22021, 22050, 22080, 22109, 22138, 22168, 22197, 22227, 22256, 22286, 22316, 22346, 22375, 22405, 22434, 22464, 22493, 22522, 22552, 22581, 22611, 22640, 22670, 22700, 22730, 22759, 22789, 22818, 22848, 22877, 22906, 22936, 22965, 22994, 23024, 23054, 23083, 23113, 23143, 23173, 23202, 23232, 23261, 23290, 23320, 23349, 23379, 23408, 23438, 23467, 23497, 23527, 23556, 23586, 23616, 23645, 23674, 23704, 23733, 23763, 23792, 23822, 23851, 23881, 23910, 23940, 23970, 23999, 24029, 24058, 24088, 24117, 24147, 24176, 24206, 24235, 24265, 24294, 24324, 24353, 24383, 24413, 24442, 24472, 24501, 24531, 24560, 24590, 24619, 24648, 24678, 24707, 24737, 24767, 24796, 24826, 24856, 24885, 24915, 24944, 24974, 25003, 25032, 25062, 25091, 25121, 25150, 25180, 25210, 25240, 25269, 25299, 25328, 25358, 25387, 25416, 25446, 25475, 25505, 25534, 25564, 25594, 25624, 25653, 25683, 25712, 25742, 25771, 25800, 25830, 25859, 25888, 25918, 25948, 25977, 26007, 26037, 26067, 26096, 26126, 26155, 26184, 26214, 26243, 26272, 26302, 26332, 26361, 26391, 26421, 26451, 26480, 26510, 26539, 26568, 26598, 26627, 26656, 26686, 26715, 26745, 26775, 26805, 26834, 26864, 26893, 26923, 26952, 26982, 27011, 27041, 27070, 27099, 27129, 27159, 27188, 27218, 27248, 27277, 27307, 27336, 27366, 27395, 27425, 27454, 27484, 27513, 27542, 27572, 27602, 27631, 27661, 27691, 27720, 27750, 27779, 27809, 27838, 27868, 27897, 27926, 27956, 27985, 28015, 28045, 28074, 28104, 28134, 28163, 28193, 28222, 28252, 28281, 28310, 28340, 28369, 28399, 28428, 28458, 28488, 28517, 28547, 28577, 28607, 28636, 28665, 28695, 28724, 28754, 28783, 28813, 28843, 28872, 28901, 28931, 28960, 28990, 29019, 29049, 29078, 29108, 29137, 29167, 29196, 29226, 29255, 29285, 29315, 29345, 29375, 29404, 29434, 29463, 29492, 29522, 29551, 29580, 29610, 29640, 29669, 29699, 29729, 29759, 29788, 29818, 29847, 29876, 29906, 29935, 29964, 29994, 30023, 30053, 30082, 30112, 30141, 30171, 30200, 30230, 30259, 30289, 30318, 30348, 30378, 30408, 30437, 30467, 30496, 30526, 30555, 30585, 30614, 30644, 30673, 30703, 30732, 30762, 30791, 30821, 30850, 30880, 30909, 30939, 30968, 30998, 31027, 31057, 31086, 31116, 31145, 31175, 31204, 31234, 31263, 31293, 31322, 31352, 31381, 31411, 31441, 31471, 31500, 31530, 31559, 31589, 31618, 31648, 31676, 31706, 31736, 31766, 31795, 31825, 31854, 31884, 31913, 31943, 31972, 32002, 32031, 32061, 32090, 32120, 32150, 32180, 32209, 32239, 32268, 32298, 32327, 32357, 32386, 32416, 32445, 32475, 32504, 32534, 32563, 32593, 32622, 32652, 32681, 32711, 32740, 32770, 32799, 32829, 32858, 32888, 32917, 32947, 32976, 33006, 33035, 33065, 33094, 33124, 33153, 33183, 33213, 33243, 33272, 33302, 33331, 33361, 33390, 33420, 33450, 33479, 33509, 33539, 33568, 33598, 33627, 33657, 33686, 33716, 33745, 33775, 33804, 33834, 33863, 33893, 33922, 33952, 33981, 34011, 34040, 34069, 34099, 34128, 34158, 34187, 34217, 34247, 34277, 34306, 34336, 34365, 34395, 34424, 34454, 34483, 34512, 34542, 34571, 34601, 34631, 34660, 34690, 34719, 34749, 34778, 34808, 34837, 34867, 34896, 34926, 34955, 34985, 35015, 35044, 35074, 35103, 35133, 35162, 35192, 35222, 35251, 35280, 35310, 35340, 35370, 35399, 35429, 35458, 35488, 35517, 35547, 35576, 35605, 35635, 35665, 35694, 35723, 35753, 35782, 35811, 35841, 35871, 35901, 35930, 35960, 35989, 36019, 36048, 36078, 36107, 36136, 36166, 36195, 36225, 36254, 36284, 36314, 36343, 36373, 36403, 36433, 36462, 36492, 36521, 36551, 36580, 36610, 36639, 36669, 36698, 36728, 36757, 36786, 36816, 36845, 36875, 36904, 36934, 36963, 36993, 37022, 37052, 37081, 37111, 37141, 37170, 37200, 37229, 37259, 37288, 37318, 37347, 37377, 37406, 37436, 37465, 37495, 37524, 37554, 37584, 37613, 37643, 37672, 37701, 37731, 37760, 37790, 37819, 37849, 37878, 37908, 37938, 37967, 37997, 38027, 38056, 38085, 38115, 38144, 38174, 38203, 38233, 38262, 38292, 38322, 38351, 38381, 38410, 38440, 38469, 38499, 38528, 38558, 38587, 38617, 38646, 38676, 38705, 38735, 38764, 38794, 38823, 38853, 38882, 38912, 38941, 38971, 39001, 39030, 39059, 39089, 39118, 39148, 39178, 39208, 39237, 39267, 39297, 39326, 39355, 39385, 39414, 39444, 39473, 39503, 39532, 39562, 39592, 39621, 39650, 39680, 39709, 39739, 39768, 39798, 39827, 39857, 39886, 39916, 39946, 39975, 40005, 40035, 40064, 40094, 40123, 40153, 40182, 40212, 40241, 40271, 40300, 40330, 40359, 40389, 40418, 40448, 40477, 40507, 40536, 40566, 40595, 40625, 40655, 40685, 40714, 40744, 40773, 40803, 40832, 40862, 40892, 40921, 40951, 40980, 41009, 41039, 41068, 41098, 41127, 41157, 41186, 41216, 41245, 41275, 41304, 41334, 41364, 41393, 41422, 41452, 41481, 41511, 41540, 41570, 41599, 41629, 41658, 41688, 41718, 41748, 41777, 41807, 41836, 41865, 41894, 41924, 41953, 41983, 42012, 42042, 42072, 42102, 42131, 42161, 42190, 42220, 42249, 42279, 42308, 42337, 42367, 42397, 42426, 42456, 42485, 42515, 42545, 42574, 42604, 42633, 42662, 42692, 42721, 42751, 42780, 42810, 42839, 42869, 42899, 42929, 42958, 42988, 43017, 43046, 43076, 43105, 43135, 43164, 43194, 43223, 43253, 43283, 43312, 43342, 43371, 43401, 43430, 43460, 43489, 43519, 43548, 43578, 43607, 43637, 43666, 43696, 43726, 43755, 43785, 43814, 43844, 43873, 43903, 43932, 43962, 43991, 44021, 44050, 44080, 44109, 44139, 44169, 44198, 44228, 44258, 44287, 44317, 44346, 44375, 44405, 44434, 44464, 44493, 44523, 44553, 44582, 44612, 44641, 44671, 44700, 44730, 44759, 44788, 44818, 44847, 44877, 44906, 44936, 44966, 44996, 45025, 45055, 45084, 45114, 45143, 45172, 45202, 45231, 45261, 45290, 45320, 45350, 45380, 45409, 45439, 45468, 45498, 45527, 45556, 45586, 45615, 45644, 45674, 45704, 45733, 45763, 45793, 45823, 45852, 45882, 45911, 45940, 45970, 45999, 46028, 46058, 46088, 46117, 46147, 46177, 46206, 46236, 46265, 46295, 46324, 46354, 46383, 46413, 46442, 46472, 46501, 46531, 46560, 46590, 46620, 46649, 46679, 46708, 46738, 46767, 46797, 46826, 46856, 46885, 46915, 46944, 46974, 47003, 47033, 47063, 47092, 47122, 47151, 47181, 47210, 47240, 47269, 47298, 47328, 47357, 47387, 47417, 47446, 47476, 47506, 47535, 47565, 47594, 47624, 47653, 47682, 47712, 47741, 47771, 47800, 47830, 47860, 47890, 47919, 47949, 47978, 48008, 48037, 48066, 48096, 48125, 48155, 48184, 48214, 48244, 48273, 48303, 48333, 48362, 48392, 48421, 48450, 48480, 48509, 48538, 48568, 48598, 48627, 48657, 48687, 48717, 48746, 48776, 48805, 48834, 48864, 48893, 48922, 48952, 48982, 49011, 49041, 49071, 49100, 49130, 49160, 49189, 49218, 49248, 49277, 49306, 49336, 49365, 49395, 49425, 49455, 49484, 49514, 49543, 49573, 49602, 49632, 49661, 49690, 49720, 49749, 49779, 49809, 49838, 49868, 49898, 49927, 49957, 49986, 50016, 50045, 50075, 50104, 50133, 50163, 50192, 50222, 50252, 50281, 50311, 50340, 50370, 50400, 50429, 50459, 50488, 50518, 50547, 50576, 50606, 50635, 50665, 50694, 50724, 50754, 50784, 50813, 50843, 50872, 50902, 50931, 50960, 50990, 51019, 51049, 51078, 51108, 51138, 51167, 51197, 51227, 51256, 51286, 51315, 51345, 51374, 51403, 51433, 51462, 51492, 51522, 51552, 51582, 51611, 51641, 51670, 51699, 51729, 51758, 51787, 51816, 51846, 51876, 51906, 51936, 51965, 51995, 52025, 52054, 52083, 52113, 52142, 52171, 52200, 52230, 52260, 52290, 52319, 52349, 52379, 52408, 52438, 52467, 52497, 52526, 52555, 52585, 52614, 52644, 52673, 52703, 52733, 52762, 52792, 52822, 52851, 52881, 52910, 52939, 52969, 52998, 53028, 53057, 53087, 53116, 53146, 53176, 53205, 53235, 53264, 53294, 53324, 53353, 53383, 53412, 53441, 53471, 53500, 53530, 53559, 53589, 53619, 53648, 53678, 53708, 53737, 53767, 53796, 53825, 53855, 53884, 53913, 53943, 53973, 54003, 54032, 54062, 54092, 54121, 54151, 54180, 54209, 54239, 54268, 54297, 54327, 54357, 54387, 54416, 54446, 54476, 54505, 54535, 54564, 54593, 54623, 54652, 54681, 54711, 54741, 54770, 54800, 54830, 54859, 54889, 54919, 54948, 54977, 55007, 55036, 55066, 55095, 55125, 55154, 55184, 55213, 55243, 55273, 55302, 55332, 55361, 55391, 55420, 55450, 55479, 55508, 55538, 55567, 55597, 55627, 55657, 55686, 55716, 55745, 55775, 55804, 55834, 55863, 55892, 55922, 55951, 55981, 56011, 56040, 56070, 56100, 56129, 56159, 56188, 56218, 56247, 56276, 56306, 56335, 56365, 56394, 56424, 56454, 56483, 56513, 56543, 56572, 56601, 56631, 56660, 56690, 56719, 56749, 56778, 56808, 56837, 56867, 56897, 56926, 56956, 56985, 57015, 57044, 57074, 57103, 57133, 57162, 57192, 57221, 57251, 57280, 57310, 57340, 57369, 57399, 57429, 57458, 57487, 57517, 57546, 57576, 57605, 57634, 57664, 57694, 57723, 57753, 57783, 57813, 57842, 57871, 57901, 57930, 57959, 57989, 58018, 58048, 58077, 58107, 58137, 58167, 58196, 58226, 58255, 58285, 58314, 58343, 58373, 58402, 58432, 58461, 58491, 58521, 58551, 58580, 58610, 58639, 58669, 58698, 58727, 58757, 58786, 58816, 58845, 58875, 58905, 58934, 58964, 58994, 59023, 59053, 59082, 59111, 59141, 59170, 59200, 59229, 59259, 59288, 59318, 59348, 59377, 59407, 59436, 59466, 59495, 59525, 59554, 59584, 59613, 59643, 59672, 59702, 59731, 59761, 59791, 59820, 59850, 59879, 59909, 59939, 59968, 59997, 60027, 60056, 60086, 60115, 60145, 60174, 60204, 60234, 60264, 60293, 60323, 60352, 60381, 60411, 60440, 60469, 60499, 60528, 60558, 60588, 60618, 60648, 60677, 60707, 60736, 60765, 60795, 60824, 60853, 60883, 60912, 60942, 60972, 61002, 61031, 61061, 61090, 61120, 61149, 61179, 61208, 61237, 61267, 61296, 61326, 61356, 61385, 61415, 61445, 61474, 61504, 61533, 61563, 61592, 61621, 61651, 61680, 61710, 61739, 61769, 61799, 61828, 61858, 61888, 61917, 61947, 61976, 62006, 62035, 62064, 62094, 62123, 62153, 62182, 62212, 62242, 62271, 62301, 62331, 62360, 62390, 62419, 62448, 62478, 62507, 62537, 62566, 62596, 62625, 62655, 62685, 62715, 62744, 62774, 62803, 62832, 62862, 62891, 62921, 62950, 62980, 63009, 63039, 63069, 63099, 63128, 63157, 63187, 63216, 63246, 63275, 63305, 63334, 63363, 63393, 63423, 63453, 63482, 63512, 63541, 63571, 63600, 63630, 63659, 63689, 63718, 63747, 63777, 63807, 63836, 63866, 63895, 63925, 63955, 63984, 64014, 64043, 64073, 64102, 64131, 64161, 64190, 64220, 64249, 64279, 64309, 64339, 64368, 64398, 64427, 64457, 64486, 64515, 64545, 64574, 64603, 64633, 64663, 64692, 64722, 64752, 64782, 64811, 64841, 64870, 64899, 64929, 64958, 64987, 65017, 65047, 65076, 65106, 65136, 65166, 65195, 65225, 65254, 65283, 65313, 65342, 65371, 65401, 65431, 65460, 65490, 65520, 65549, 65579, 65608, 65638, 65667, 65697, 65726, 65755, 65785, 65815, 65844, 65874, 65903, 65933, 65963, 65992, 66022, 66051, 66081, 66110, 66140, 66169, 66199, 66228, 66258, 66287, 66317, 66346, 66376, 66405, 66435, 66465, 66494, 66524, 66553, 66583, 66612, 66641, 66671, 66700, 66730, 66760, 66789, 66819, 66849, 66878, 66908, 66937, 66967, 66996, 67025, 67055, 67084, 67114, 67143, 67173, 67203, 67233, 67262, 67292, 67321, 67351, 67380, 67409, 67439, 67468, 67497, 67527, 67557, 67587, 67617, 67646, 67676, 67705, 67735, 67764, 67793, 67823, 67852, 67882, 67911, 67941, 67971, 68e3, 68030, 68060, 68089, 68119, 68148, 68177, 68207, 68236, 68266, 68295, 68325, 68354, 68384, 68414, 68443, 68473, 68502, 68532, 68561, 68591, 68620, 68650, 68679, 68708, 68738, 68768, 68797, 68827, 68857, 68886, 68916, 68946, 68975, 69004, 69034, 69063, 69092, 69122, 69152, 69181, 69211, 69240, 69270, 69300, 69330, 69359, 69388, 69418, 69447, 69476, 69506, 69535, 69565, 69595, 69624, 69654, 69684, 69713, 69743, 69772, 69802, 69831, 69861, 69890, 69919, 69949, 69978, 70008, 70038, 70067, 70097, 70126, 70156, 70186, 70215, 70245, 70274, 70303, 70333, 70362, 70392, 70421, 70451, 70481, 70510, 70540, 70570, 70599, 70629, 70658, 70687, 70717, 70746, 70776, 70805, 70835, 70864, 70894, 70924, 70954, 70983, 71013, 71042, 71071, 71101, 71130, 71159, 71189, 71218, 71248, 71278, 71308, 71337, 71367, 71397, 71426, 71455, 71485, 71514, 71543, 71573, 71602, 71632, 71662, 71691, 71721, 71751, 71781, 71810, 71839, 71869, 71898, 71927, 71957, 71986, 72016, 72046, 72075, 72105, 72135, 72164, 72194, 72223, 72253, 72282, 72311, 72341, 72370, 72400, 72429, 72459, 72489, 72518, 72548, 72577, 72607, 72637, 72666, 72695, 72725, 72754, 72784, 72813, 72843, 72872, 72902, 72931, 72961, 72991, 73020, 73050, 73080, 73109, 73139, 73168, 73197, 73227, 73256, 73286, 73315, 73345, 73375, 73404, 73434, 73464, 73493, 73523, 73552, 73581, 73611, 73640, 73669, 73699, 73729, 73758, 73788, 73818, 73848, 73877, 73907, 73936, 73965, 73995, 74024, 74053, 74083, 74113, 74142, 74172, 74202, 74231, 74261, 74291, 74320, 74349, 74379, 74408, 74437, 74467, 74497, 74526, 74556, 74586, 74615, 74645, 74675, 74704, 74733, 74763, 74792, 74822, 74851, 74881, 74910, 74940, 74969, 74999, 75029, 75058, 75088, 75117, 75147, 75176, 75206, 75235, 75264, 75294, 75323, 75353, 75383, 75412, 75442, 75472, 75501, 75531, 75560, 75590, 75619, 75648, 75678, 75707, 75737, 75766, 75796, 75826, 75856, 75885, 75915, 75944, 75974, 76003, 76032, 76062, 76091, 76121, 76150, 76180, 76210, 76239, 76269, 76299, 76328, 76358, 76387, 76416, 76446, 76475, 76505, 76534, 76564, 76593, 76623, 76653, 76682, 76712, 76741, 76771, 76801, 76830, 76859, 76889, 76918, 76948, 76977, 77007, 77036, 77066, 77096, 77125, 77155, 77185, 77214, 77243, 77273, 77302, 77332, 77361, 77390, 77420, 77450, 77479, 77509, 77539, 77569, 77598, 77627, 77657, 77686, 77715, 77745, 77774, 77804, 77833, 77863, 77893, 77923, 77952, 77982, 78011, 78041, 78070, 78099, 78129, 78158, 78188, 78217, 78247, 78277, 78307, 78336, 78366, 78395, 78425, 78454, 78483, 78513, 78542, 78572, 78601, 78631, 78661, 78690, 78720, 78750, 78779, 78808, 78838, 78867, 78897, 78926, 78956, 78985, 79015, 79044, 79074, 79104, 79133, 79163, 79192, 79222, 79251, 79281, 79310, 79340, 79369, 79399, 79428, 79458, 79487, 79517, 79546, 79576, 79606, 79635, 79665, 79695, 79724, 79753, 79783, 79812, 79841, 79871, 79900, 79930, 79960, 79990];
    });
    var Bz = Z((Xve, Oz) => {
      "use strict";

      Oz.exports = Aa();
      Tz();
      Mz();
      Az();
      kz();
      Cz();
      Sz();
      Lz();
      qz();
      Ez();
      Rz();
      zz();
      Nz();
      Fz();
      Iz();
      Hz();
    });
    var Xz = Z((Jve, Zz) => {
      "use strict";

      var Uz = Bz(),
        Sc = He(),
        Gz = Bt(),
        Jne = Gz.EPOCHJD,
        Kne = Gz.ONEDAY,
        B3 = {
          valType: "enumerated",
          values: Sc.sortObjectKeys(Uz.calendars),
          editType: "calc",
          dflt: "gregorian"
        },
        Vz = function (e, r, t, a) {
          var n = {};
          return n[t] = B3, Sc.coerce(e, r, n, t, a);
        },
        Qne = function (e, r, t, a) {
          for (var n = 0; n < t.length; n++) Vz(e, r, t[n] + "calendar", a.calendar);
        },
        $ne = {
          chinese: "2000-01-01",
          coptic: "2000-01-01",
          discworld: "2000-01-01",
          ethiopian: "2000-01-01",
          hebrew: "5000-01-01",
          islamic: "1000-01-01",
          julian: "2000-01-01",
          mayan: "5000-01-01",
          nanakshahi: "1000-01-01",
          nepali: "2000-01-01",
          persian: "1000-01-01",
          jalali: "1000-01-01",
          taiwan: "1000-01-01",
          thai: "2000-01-01",
          ummalqura: "1400-01-01"
        },
        jne = {
          chinese: "2000-01-02",
          coptic: "2000-01-03",
          discworld: "2000-01-03",
          ethiopian: "2000-01-05",
          hebrew: "5000-01-01",
          islamic: "1000-01-02",
          julian: "2000-01-03",
          mayan: "5000-01-01",
          nanakshahi: "1000-01-05",
          nepali: "2000-01-05",
          persian: "1000-01-01",
          jalali: "1000-01-01",
          taiwan: "1000-01-04",
          thai: "2000-01-04",
          ummalqura: "1400-01-06"
        },
        eie = {
          chinese: ["2000-01-01", "2001-01-01"],
          coptic: ["1700-01-01", "1701-01-01"],
          discworld: ["1800-01-01", "1801-01-01"],
          ethiopian: ["2000-01-01", "2001-01-01"],
          hebrew: ["5700-01-01", "5701-01-01"],
          islamic: ["1400-01-01", "1401-01-01"],
          julian: ["2000-01-01", "2001-01-01"],
          mayan: ["5200-01-01", "5201-01-01"],
          nanakshahi: ["0500-01-01", "0501-01-01"],
          nepali: ["2000-01-01", "2001-01-01"],
          persian: ["1400-01-01", "1401-01-01"],
          jalali: ["1400-01-01", "1401-01-01"],
          taiwan: ["0100-01-01", "0101-01-01"],
          thai: ["2500-01-01", "2501-01-01"],
          ummalqura: ["1400-01-01", "1401-01-01"]
        },
        f1 = "##",
        rie = {
          d: {
            0: "dd",
            "-": "d"
          },
          e: {
            0: "d",
            "-": "d"
          },
          a: {
            0: "D",
            "-": "D"
          },
          A: {
            0: "DD",
            "-": "DD"
          },
          j: {
            0: "oo",
            "-": "o"
          },
          W: {
            0: "ww",
            "-": "w"
          },
          m: {
            0: "mm",
            "-": "m"
          },
          b: {
            0: "M",
            "-": "M"
          },
          B: {
            0: "MM",
            "-": "MM"
          },
          y: {
            0: "yy",
            "-": "yy"
          },
          Y: {
            0: "yyyy",
            "-": "yyyy"
          },
          U: f1,
          w: f1,
          c: {
            0: "D M d %X yyyy",
            "-": "D M d %X yyyy"
          },
          x: {
            0: "mm/dd/yyyy",
            "-": "mm/dd/yyyy"
          }
        };
      function tie(e, r, t) {
        for (var a = Math.floor((r + .05) / Kne) + Jne, n = Wz(t).fromJD(a), i = 0, l, o, s, u, f; (i = e.indexOf("%", i)) !== -1;) l = e.charAt(i + 1), l === "0" || l === "-" || l === "_" ? (s = 3, o = e.charAt(i + 2), l === "_" && (l = "-")) : (o = l, l = "0", s = 2), u = rie[o], u ? (u === f1 ? f = f1 : f = n.formatDate(u[l]), e = e.substr(0, i) + f + e.substr(i + s), i += f.length) : i += s;
        return e;
      }
      var Yz = {};
      function Wz(e) {
        var r = Yz[e];
        return r || (r = Yz[e] = Uz.instance(e), r);
      }
      function Lc(e) {
        return Sc.extendFlat({}, B3, {
          description: e
        });
      }
      function Y3(e) {
        return "Sets the calendar system to use with `" + e + "` date data.";
      }
      var O3 = {
          xcalendar: Lc(Y3("x"))
        },
        Pi = Sc.extendFlat({}, O3, {
          ycalendar: Lc(Y3("y"))
        }),
        H3 = Sc.extendFlat({}, Pi, {
          zcalendar: Lc(Y3("z"))
        }),
        Au = Lc(["Sets the calendar system to use for `range` and `tick0`", "if this is a date axis. This does not set the calendar for", "interpreting data on this axis, that's specified in the trace", "or via the global `layout.calendar`"].join(" "));
      Zz.exports = {
        moduleType: "component",
        name: "calendars",
        schema: {
          traces: {
            scatter: Pi,
            bar: Pi,
            box: Pi,
            heatmap: Pi,
            contour: Pi,
            histogram: Pi,
            histogram2d: Pi,
            histogram2dcontour: Pi,
            scatter3d: H3,
            surface: H3,
            mesh3d: H3,
            scattergl: Pi,
            ohlc: O3,
            candlestick: O3
          },
          layout: {
            calendar: Lc(["Sets the default calendar system to use for interpreting and", "displaying dates throughout the plot."].join(" "))
          },
          subplots: {
            xaxis: {
              calendar: Au
            },
            yaxis: {
              calendar: Au
            },
            scene: {
              xaxis: {
                calendar: Au
              },
              yaxis: {
                calendar: Au
              },
              zaxis: {
                calendar: Au
              }
            },
            polar: {
              radialaxis: {
                calendar: Au
              }
            }
          }
        },
        layoutAttributes: B3,
        handleDefaults: Vz,
        handleTraceDefaults: Qne,
        CANONICAL_SUNDAY: jne,
        CANONICAL_TICK: $ne,
        DFLTRANGE: eie,
        getCal: Wz,
        worldCalFmt: tie
      };
    });
    var Kz = Z((Kve, Jz) => {
      "use strict";

      Jz.exports = Xz();
    });
    var aie = Z((Qve, $z) => {
      var Qz = _P();
      Qz.register([SR(), gz(), Kz()]);
      $z.exports = Qz;
    });
    return aie();
  })();
  /*! Bundled license information:
  
  native-promise-only/lib/npo.src.js:
    (*! Native Promise Only
        v0.8.1 (c) Kyle Simpson
        MIT License: http://getify.mit-license.org
    *)
  
  polybooljs/index.js:
    (*
     * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
     * @license MIT
     * @preserve Project Home: https://github.com/voidqk/polybooljs
     *)
  
  object-assign/index.js:
    (*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    *)
  */

  window.Plotly = Plotly;
  return Plotly;
});